import type { NamespaceCatalog } from './index';
const en = {
  '{value1} for {value2}': '{value1} for {value2}',
  'We could not load this item.': 'We could not load this item.',
  '{value1} canvas': '{value1} canvas',
  'Loading {value1}…': 'Loading {value1}…',
  '{value1} · Original retained': '{value1} · Original retained',
  '{value1} {value2}{value3} · Added {value4}': '{value1} {value2}{value3} · Added {value4}',
  '{value1} Use in chat': '{value1} Use in chat',
  '{value1} Download': '{value1} Download',
  Table: 'Table',
  Chart: 'Chart',
  Original: 'Original',
  'Text extracted from the PDF, marked by page. Download the original for its layout and images.':
    'Text extracted from the PDF, marked by page. Download the original for its layout and images.',
  'This preview shows the beginning of the file. Poneva reads the whole file; download the original to see all of it.':
    'This preview shows the beginning of the file. Poneva reads the whole file; download the original to see all of it.',
  'Preview of the first {value1} complete rows. Filtering and charts use only this preview. Download the original for the full file.':
    'Preview of the first {value1} complete rows. Filtering and charts use only this preview. Download the original for the full file.',
  'This source link cannot be opened.': 'This source link cannot be opened.',
  'Read-only chat': 'Read-only chat',
  'Only {value1} writes in this chat. Fork it to continue with your own connections. {value2}':
    'Only {value1} writes in this chat. Fork it to continue with your own connections. {value2}',
  '{value1} {value2} · {value3} will see it.': '{value1} {value2} · {value3} will see it.',
  Suggested: 'Suggested',
  'Suggest a follow-up…': 'Suggest a follow-up…',
  'Suggest a follow-up': 'Suggest a follow-up',
  'Sending…': 'Sending…',
  Send: 'Send',
  'We could not dismiss that suggestion. Please try again.':
    'We could not dismiss that suggestion. Please try again.',
  'Suggested follow-ups': 'Suggested follow-ups',
  '{value1} suggests': '{value1} suggests',
  Ask: 'Ask',
  'Dismiss {value1}’s suggestion': 'Dismiss {value1}’s suggestion',
  'Suggested by': 'Suggested by',
  '· edit it or send it': '· edit it or send it',
  'Remove the suggestion tag': 'Remove the suggestion tag',
  '{value1} {value2} is getting an answer': '{value1} {value2} is getting an answer',
  '{value1} {value2} stopped the answer': '{value1} {value2} stopped the answer',
  '{value1} Fork from here': '{value1} Fork from here',
  'Only {value1} can use this account': 'Only {value1} can use this account',
  '{value1} From {value2}’s {value3}': '{value1} From {value2}’s {value3}',
  '{value1} Suggested by {value2}': '{value1} Suggested by {value2}',
  'Fork this chat': 'Fork this chat',
  'Forking…': 'Forking…',
  Fork: 'Fork',
  'Could not make this private.': 'Could not make this private.',
  'Make this chat private?': 'Make this chat private?',
  Close: 'Close',
  '{value1} will see “{value2}”. Everyone else loses access right away {value3} .{value4}':
    '{value1} will see “{value2}”. Everyone else loses access right away {value3} .{value4}',
  Cancel: 'Cancel',
  'Saving…': 'Saving…',
  'Make private': 'Make private',
  'This chat is private again. Forks others made stay theirs.':
    'This chat is private again. Forks others made stay theirs.',
  'Who can read this chat: {value1}': 'Who can read this chat: {value1}',
  'Move this chat': 'Move this chat',
  'Only you write here. Others follow live and fork.':
    'Only you write here. Others follow live and fork.',
  'Made private. {value1} has been told in their Inbox.':
    'Made private. {value1} has been told in their Inbox.',
  'Chat access': 'Chat access',
  '{value1}’s chat. As an admin you can make it private.':
    '{value1}’s chat. As an admin you can make it private.',
  'Only {value1} will see it. {value2} is told.': 'Only {value1} will see it. {value2} is told.',
  '{value1} {value2} following': '{value1} {value2} following',
  'Forked from{value1} {value2} . The history is copied. From here, tools run with your own access.':
    'Forked from{value1} {value2} . The history is copied. From here, tools run with your own access.',
  '{value1}’s chat ·': '{value1}’s chat ·',
  '{value1} made this chat private': '{value1} made this chat private',
  'You can no longer open it. Any fork you made stays yours.':
    'You can no longer open it. Any fork you made stays yours.',
  'Start a new chat': 'Start a new chat',
  'Back to Recent chats': 'Back to Recent chats',
  'Opening your conversation…': 'Opening your conversation…',
  'This conversation isn’t available': 'This conversation isn’t available',
  'It may have been deleted, belong to another account, or be temporarily unavailable.':
    'It may have been deleted, belong to another account, or be temporarily unavailable.',
  'Try again': 'Try again',
  'More chat actions': 'More chat actions',
  'Close conversation sharing': 'Close conversation sharing',
  'Review the text before saving a private copy to Library. Then choose its audience. Your original conversation and future messages stay private.':
    'Review the text before saving a private copy to Library. Then choose its audience. Your original conversation and future messages stay private.',
  'Preparing the conversation…': 'Preparing the conversation…',
  'Refresh preview': 'Refresh preview',
  'The copy is saved in Library. Use Share to choose who can access it.':
    'The copy is saved in Library. Use Share to choose who can access it.',
  'Save this copy': 'Save this copy',
  'That Skill could not be opened.': 'That Skill could not be opened.',
  '{value1}{value2} · reviews and approvals': '{value1}{value2} · reviews and approvals',
  '{value1} {value2} you': '{value1} {value2} you',
  'Open Inbox': 'Open Inbox',
  'New at {value1} this week': 'New at {value1} this week',
  'Nothing new this week. Shared work, published Skills and approved knowledge show up here.':
    'Nothing new this week. Shared work, published Skills and approved knowledge show up here.',
  'New at {value1}': 'New at {value1}',
  'This Skill is unavailable. Try again.': 'This Skill is unavailable. Try again.',
  'You can attach up to {value1} files. Remove an attachment to add another.':
    'You can attach up to {value1} files. Remove an attachment to add another.',
  'Add company context': 'Add company context',
  'Add company context · @': 'Add company context · @',
  'Choose a Skill': 'Choose a Skill',
  'Choose a Skill · /': 'Choose a Skill · /',
  context: 'context',
  skills: 'skills',
  'Choose company context': 'Choose company context',
  'Skills for this conversation': 'Skills for this conversation',
  'Bring context into the conversation': 'Bring context into the conversation',
  'Close context picker': 'Close context picker',
  'Filter company context': 'Filter company context',
  'Find a Skill…': 'Find a Skill…',
  'Find a file…': 'Find a file…',
  'Available company context': 'Available company context',
  'No matching published Skills.': 'No matching published Skills.',
  'No matching files.': 'No matching files.',
  'Searching company work…': 'Searching company work…',
  'Try search again': 'Try search again',
  'Meaning search is temporarily limited. Showing available text matches.':
    'Meaning search is temporarily limited. Showing available text matches.',
  'Load more matches': 'Load more matches',
  '{value1} files attached. Remove an attachment to add another. Saved Skill references are included separately.':
    '{value1} files attached. Remove an attachment to add another. Saved Skill references are included separately.',
  'Create a Skill in chat': 'Create a Skill in chat',
  'Upload a company file': 'Upload a company file',
  'Company knowledge is always available to Poneva.':
    'Company knowledge is always available to Poneva.',
  '{value1} was not connected': '{value1} was not connected',
  Dismiss: 'Dismiss',
  'Try connecting again': 'Try connecting again',
  Waiting: 'Waiting',
  Connected: 'Connected',
  'Needs reconnecting': 'Needs reconnecting',
  Connect: 'Connect',
  '{value1}{value2} The provider’s account permissions still apply.':
    '{value1}{value2} The provider’s account permissions still apply.',
  'Last error: {value1}': 'Last error: {value1}',
  '{value1} {value2} ready.': '{value1} {value2} ready.',
  '{value1} ad {value2} available.': '{value1} ad {value2} available.',
  'Continue with my Meta app': 'Continue with my Meta app',
  Reconnect: 'Reconnect',
  Disconnect: 'Disconnect',
  'Remove attachment: {value1}': 'Remove attachment: {value1}',
  'Saved in this Skill. Edit the Skill to change its references.':
    'Saved in this Skill. Edit the Skill to change its references.',
  'Remove Skill context': 'Remove Skill context',
  Refining: 'Refining',
  Previewing: 'Previewing',
  Using: 'Using',
  'Skill revision {value1}': 'Skill revision {value1}',
  'a new Skill': 'a new Skill',
  'Stop making a new agent in this chat': 'Stop making a new agent in this chat',
  '{value1} Making a new agent {value2}': '{value1} Making a new agent {value2}',
  'Saved Skill references': 'Saved Skill references',
  'Included with Skill · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}':
    'Included with Skill · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}',
  'Selected Skill revision is unavailable. Select the Skill again to view its saved references.':
    'Selected Skill revision is unavailable. Select the Skill again to view its saved references.',
  'Conversation attachments': 'Conversation attachments',
  'Added for this conversation': 'Added for this conversation',
  'Selected passage {value1}': 'Selected passage {value1}',
  'We could not load your workspace.': 'We could not load your workspace.',
  'The selected Skill is unavailable. Check its access or choose it again.':
    'The selected Skill is unavailable. Check its access or choose it again.',
  'Source saved privately and included in your knowledge search.':
    'Source saved privately and included in your knowledge search.',
  'File saved privately to your library and attached to this message.':
    'File saved privately to your library and attached to this message.',
  'File saved privately to your library.': 'File saved privately to your library.',
  '{value1} {value2} earlier {value3} saved{value4}.':
    '{value1} {value2} earlier {value3} saved{value4}.',
  '{count} more line — shown in the complete revision':
    '{count} more line — shown in the complete revision',
  '{count} more lines — shown in the complete revision':
    '{count} more lines — shown in the complete revision',
  '{count} more line removed': '{count} more line removed',
  '{count} more lines removed': '{count} more lines removed',
  '{count} unchanged line': '{count} unchanged line',
  '{count} unchanged lines': '{count} unchanged lines',
  '{count} more lines not shown, {added} added and {removed} removed. Check them in the complete revision.':
    '{count} more lines not shown, {added} added and {removed} removed. Check them in the complete revision.',
  'Extracted text for Poneva to read. Download the original for its layout, charts and images. Spreadsheet formulas show their saved results and are not recalculated.':
    'Extracted text for Poneva to read. Download the original for its layout, charts and images. Spreadsheet formulas show their saved results and are not recalculated.',
  Esc: 'Esc',
  'Start something': 'Start something',
  'Choose a file to work with': 'Choose a file to work with',
  'Skills worth adding': 'Skills worth adding',
  'Picked for you': 'Picked for you',
  'Reusable work grounded in your company knowledge.':
    'Reusable work grounded in your company knowledge.',
  'Ideas from your company context and recent work. Pick one to start.':
    'Ideas from your company context and recent work. Pick one to start.',
  'Refresh suggested tasks': 'Refresh suggested tasks',
  'Check for new company context.': 'Check for new company context.',
  'Check for new context. Ideas also refresh daily.':
    'Check for new context. Ideas also refresh daily.',
  Refresh: 'Refresh',
  'Finding useful starting points…': 'Finding useful starting points…',
  'Suggestions aren’t available right now. Try Refresh, or describe the work you want to do.':
    'Suggestions aren’t available right now. Try Refresh, or describe the work you want to do.',
  'Loading the knowledge pages…': 'Loading the knowledge pages…',
  '{value1} All pages': '{value1} All pages',
  'The page is created.': 'The page is created.',
  'Your new page is suggested. A publisher decides whether it is added.':
    'Your new page is suggested. A publisher decides whether it is added.',
  'Company knowledge': 'Company knowledge',
  'What Poneva knows about your company, page by page. Every change is kept.':
    'What Poneva knows about your company, page by page. Every change is kept.',
  'Loading company knowledge…': 'Loading company knowledge…',
  'Knowledge pages are not enabled in this workspace.':
    'Knowledge pages are not enabled in this workspace.',
  'Ask your Poneva contact to switch them on for your company.':
    'Ask your Poneva contact to switch them on for your company.',
  '{value1} Change the agent': '{value1} Change the agent',
  '{value1} Continue in chat': '{value1} Continue in chat',
  Edit: 'Edit',
  '{value1} Edit with chat': '{value1} Edit with chat',
  'Duplicated to your Library. Only you can see the copy.':
    'Duplicated to your Library. Only you can see the copy.',
  'Could not duplicate this Result. Try again.': 'Could not duplicate this Result. Try again.',
  '{value1} Duplicate to my Library': '{value1} Duplicate to my Library',
  'Saved version {value1}.': 'Saved version {value1}.',
  'A newer version was saved. Reload the Result before saving.':
    'A newer version was saved. Reload the Result before saving.',
  'Could not save this version. Try again.': 'Could not save this version. Try again.',
  '{value1} saved a newer version. Review it before saving.':
    '{value1} saved a newer version. Review it before saving.',
  'Hide their version': 'Hide their version',
  'Show their version': 'Show their version',
  'Start from their version': 'Start from their version',
  Markdown: 'Markdown',
  'Result text': 'Result text',
  Preview: 'Preview',
  'What changed': 'What changed',
  'What changed? (optional)': 'What changed? (optional)',
  'Save version {value1}': 'Save version {value1}',
  'Open chat': 'Open chat',
  Current: 'Current',
  Restore: 'Restore',
  'Could not load the history.': 'Could not load the history.',
  'Restored version {value1} as version {value2}.':
    'Restored version {value1} as version {value2}.',
  'Someone saved a newer version. Review it before restoring.':
    'Someone saved a newer version. Review it before restoring.',
  'Could not restore that version.': 'Could not restore that version.',
  'Loading history…': 'Loading history…',
  'Restoring keeps what is there now as a version too, so nothing is lost.':
    'Restoring keeps what is there now as a version too, so nothing is lost.',
  'This Result was made with your own {value1}.': 'This Result was made with your own {value1}.',
  'It also used': 'It also used',
  'This Result was made with': 'This Result was made with',
  'Colleagues can read what came from them, but can never use them.':
    'Colleagues can read what came from them, but can never use them.',
  'Your personal agent {value1} keeps it up to date with your own access, so every refresh can carry your private data.':
    'Your personal agent {value1} keeps it up to date with your own access, so every refresh can carry your private data.',
  'A colleague’s personal agent keeps it up to date with their own access, so every refresh can carry their private data.':
    'A colleague’s personal agent keeps it up to date with their own access, so every refresh can carry their private data.',
  'Made private. Only you can see this meeting.': 'Made private. Only you can see this meeting.',
  'Could not make this meeting private.': 'Could not make this meeting private.',
  'Meeting · {value1} {value2} · Original retained':
    'Meeting · {value1} {value2} · Original retained',
  'The recording could not be opened.': 'The recording could not be opened.',
  'Ask about this suggestion': 'Ask about this suggestion',
  meeting_processing_failed: 'meeting_processing_failed',
  'Who can see this': 'Who can see this',
  'Everyone at {value1}': 'Everyone at {value1}',
  'Only me': 'Only me',
  'Everyone at {value1} can find it and ask about it.':
    'Everyone at {value1} can find it and ask about it.',
  'Only you can open and search this meeting. You can share it later.':
    'Only you can open and search this meeting. You can share it later.',
  'Added. Only you can see it. Transcription is running in the background.':
    'Added. Only you can see it. Transcription is running in the background.',
  'Visible to everyone at {value1}': 'Visible to everyone at {value1}',
  'Could not make it private.': 'Could not make it private.',
  'Show more meetings': 'Show more meetings',
  'Attached to this message': 'Attached to this message',
  'Connect securely, choose the tables to share, then decide whether Poneva can read or make changes.':
    'Connect securely, choose the tables to share, then decide whether Poneva can read or make changes.',
  'Review the tables this connection can access. Select at least one table.':
    'Review the tables this connection can access. Select at least one table.',
  'Select at least one table. Nothing is selected by default.':
    'Select at least one table. Nothing is selected by default.',
  'Choose who can use this connection and what Poneva can do.':
    'Choose who can use this connection and what Poneva can do.',
  'Your chosen access is enabled for the selected tables.':
    'Your chosen access is enabled for the selected tables.',
  'Your connection is saved with reading paused until permission is confirmed.':
    'Your connection is saved with reading paused until permission is confirmed.',
  'Confirm database disconnect': 'Confirm database disconnect',
  'Disconnect this database?': 'Disconnect this database?',
  'Access will stop for everyone using this connection.':
    'Access will stop for everyone using this connection.',
  'Keep connection': 'Keep connection',
  'What it can reach · {value1}{value2} {value3}': 'What it can reach · {value1}{value2} {value3}',
  Back: 'Back',
  Continue: 'Continue',
  'Uploading…': 'Uploading…',
  Library: 'Library',
  'Source material for your work. Available whenever you need it.':
    'Source material for your work. Available whenever you need it.',
  'The work you want to keep, with its sources and conversation attached.':
    'The work you want to keep, with its sources and conversation attached.',
  Results: 'Results',
  Files: 'Files',
  Artifacts: 'Artifacts',
  'Search library': 'Search library',
  'Find files by meaning…': 'Find files by meaning…',
  'Find saved work by meaning…': 'Find saved work by meaning…',
  'Search coverage is limited while indexing or meaning-based search is unavailable. You can retry or browse recent items.':
    'Search coverage is limited while indexing or meaning-based search is unavailable. You can retry or browse recent items.',
  'No matching work found.': 'No matching work found.',
  'A starting point for your next question.': 'A starting point for your next question.',
  'Good work is worth keeping.': 'Good work is worth keeping.',
  'Try a different description or clear the search to browse.':
    'Try a different description or clear the search to browse.',
  'Upload source material once and use it in conversations and Skills. Your original stays in the library.':
    'Upload source material once and use it in conversations and Skills. Your original stays in the library.',
  'Ask Poneva to save an answer, table or chart. Results stay connected to the conversation and their sources.':
    'Ask Poneva to save an answer, table or chart. Results stay connected to the conversation and their sources.',
  'Start in chat {value1}': 'Start in chat {value1}',
  'Open result: {value1}': 'Open result: {value1}',
  'Loading more library items…': 'Loading more library items…',
  'Load more': 'Load more',
  'Documents, transcripts, audio and video · Up to 500 MB per file. New files are private. Choose their audience with Share and which processable files become searchable company knowledge.':
    'Documents, transcripts, audio and video · Up to 500 MB per file. New files are private. Choose their audience with Share and which processable files become searchable company knowledge.',
  Skills: 'Skills',
  'Create in chat': 'Create in chat',
  'Search Skills': 'Search Skills',
  'Search finds published Skills. Clear the search to browse your drafts too.':
    'Search finds published Skills. Clear the search to browse your drafts too.',
  'Search coverage is limited while indexing or meaning-based search is unavailable.':
    'Search coverage is limited while indexing or meaning-based search is unavailable.',
  'Searching Skills…': 'Searching Skills…',
  'No matching published Skills found. Try a different description.':
    'No matching published Skills found. Try a different description.',
  'Load more Skills': 'Load more Skills',
  'View Skill: {value1}': 'View Skill: {value1}',
  'Company workspace': 'Company workspace',
  'View {value1}': 'View {value1}',
  'Loading Skills…': 'Loading Skills…',
  'Try again {value1}': 'Try again {value1}',
  'Nothing yet.': 'Nothing yet.',
  'Made from · Used by': 'Made from · Used by',
  'Could not load links': 'Could not load links',
  'Made from': 'Made from',
  'Used by': 'Used by',
  'About this chat {value1}': 'About this chat {value1}',
  'About this chat': 'About this chat',
  'Keep the work moving.': 'Keep the work moving.',
  'Ask a follow-up with this result in view, or turn a useful approach into a company Skill.':
    'Ask a follow-up with this result in view, or turn a useful approach into a company Skill.',
  'Save approach as a Skill': 'Save approach as a Skill',
  'Preview of': 'Preview of',
  'Made with': 'Made with',
  'Open the draft': 'Open the draft',
  'Open Skill': 'Open Skill',
  'Use in chat': 'Use in chat',
  'Finish the draft': 'Finish the draft',
  'Refine this Skill': 'Refine this Skill',
  'Made with a Skill.': 'Made with a Skill.',
  'This workspace could not be loaded just now, so that Skill cannot be opened yet. The result itself is unchanged.':
    'This workspace could not be loaded just now, so that Skill cannot be opened yet. The result itself is unchanged.',
  'That Skill is not available in this workspace, so it cannot be opened or used again. The result itself is unchanged.':
    'That Skill is not available in this workspace, so it cannot be opened or used again. The result itself is unchanged.',
  'Result · {value1} {value2}': 'Result · {value1} {value2}',
  '· Revised': '· Revised',
  '{value1} rows ·': '{value1} rows ·',
  'Result link copied.': 'Result link copied.',
  'Could not copy the link. Use your browser address bar.':
    'Could not copy the link. Use your browser address bar.',
  '{value1} Copy link': '{value1} Copy link',
  'No preview is available for this result.': 'No preview is available for this result.',
  '{value1} rows are retained in this snapshot. Open Table to inspect the values.':
    '{value1} rows are retained in this snapshot. Open Table to inspect the values.',
  'People can’t edit a Result an agent keeps up to date; the next refresh would replace their edit. Change the agent’s instructions instead.':
    'People can’t edit a Result an agent keeps up to date; the next refresh would replace their edit. Change the agent’s instructions instead.',
  'Linked sources': 'Linked sources',
  'Saved source': 'Saved source',
  'No source documents are linked to this result. Company knowledge and other references may be cited in the answer.':
    'No source documents are linked to this result. Company knowledge and other references may be cited in the answer.',
  'Run details': 'Run details',
  Created: 'Created',
  ', revised {value1}': ', revised {value1}',
  Conversation: 'Conversation',
  'Open conversation': 'Open conversation',
  'Not recorded': 'Not recorded',
  Run: 'Run',
  Updates: 'Updates',
  'Kept up to date by {value1}': 'Kept up to date by {value1}',
  'Version {value1}': 'Version {value1}',
  'Saved result': 'Saved result',
  'Made with a Skill': 'Made with a Skill',
  'Preview of {name}': 'Preview of {name}',
  'Made with {name}': 'Made with {name}',
  'Ad-hoc result': 'Ad-hoc result',
  'A Skill that is not available in this workspace':
    'A Skill that is not available in this workspace',
  '{name} · Revision {version}': '{name} · Revision {version}',
  '{name} · Version {version}': '{name} · Version {version}',
  'Could not open this request.': 'Could not open this request.',
  'Approved version published.': 'Approved version published.',
  'Request rejected. The item stays unchanged.': 'Request rejected. The item stays unchanged.',
  'Could not save the decision.': 'Could not save the decision.',
  'Proposed company change': 'Proposed company change',
  'Opening…': 'Opening…',
  'Approve this version': 'Approve this version',
  Decline: 'Decline',
  'Review the submitted version below. Changes made since submission will need a new request.':
    'Review the submitted version below. Changes made since submission will need a new request.',
  'The version submitted with this request.': 'The version submitted with this request.',
  'Version and proposed change': 'Version and proposed change',
  'Could not read the pinned content.': 'Could not read the pinned content.',
  'Showing a page of {value1} characters.': 'Showing a page of {value1} characters.',
  'Beginning of the submitted content. Open the full text to review every page.':
    'Beginning of the submitted content. Open the full text to review every page.',
  'Read full submitted text': 'Read full submitted text',
  'Previous page': 'Previous page',
  'Next page': 'Next page',
  'Made private. Its creator has been told in their Inbox.':
    'Made private. Its creator has been told in their Inbox.',
  'Made private. Its creator could not be notified.':
    'Made private. Its creator could not be notified.',
  'Make this {value1} private?': 'Make this {value1} private?',
  'Only the person who created it will see it. Everyone else loses access right away, and its creator gets an Inbox update if they are still a company member. If they have left, nobody in the company will be able to access this item.':
    'Only the person who created it will see it. Everyone else loses access right away, and its creator gets an Inbox update if they are still a company member. If they have left, nobody in the company will be able to access this item.',
  'Sent for review. The current audience stays unchanged until approval.':
    'Sent for review. The current audience stays unchanged until approval.',
  'Could not update sharing.': 'Could not update sharing.',
  'They can follow new answers live and fork it to continue with their own connections. Only you write here. You can make it private again at any time.':
    'They can follow new answers live and fork it to continue with their own connections. Only you write here. You can make it private again at any time.',
  'They see the project, its brief and the work in it they can already open. Nothing in it opens for anyone because of the project; each item keeps its own access.':
    'They see the project, its brief and the work in it they can already open. Nothing in it opens for anyone because of the project; each item keeps its own access.',
  'Check the content for private information before sharing. Sharing an item does not grant access to its original chat or private connections.':
    'Check the content for private information before sharing. Sharing an item does not grant access to its original chat or private connections.',
  '{value1} Everyone you share with can read it, including what the assistant or an App in it found in your {value2}. They can’t use your {value3}. Nothing changes for you: the chat keeps working with all your accounts.':
    '{value1} Everyone you share with can read it, including what the assistant or an App in it found in your {value2}. They can’t use your {value3}. Nothing changes for you: the chat keeps working with all your accounts.',
  'This chat used your {value1}.': 'This chat used your {value1}.',
  '{value1} Everyone you share with can read them, but nobody can use {value2} through this chat.':
    '{value1} Everyone you share with can read them, but nobody can use {value2} through this chat.',
  'This chat has results from {value1}.': 'This chat has results from {value1}.',
  'This controls access to the working draft. Any published company version stays available until you explicitly unpublish it. To publish a new version, complete its preview and use Save Skill. Run results stay private.':
    'This controls access to the working draft. Any published company version stays available until you explicitly unpublish it. To publish a new version, complete its preview and use Save Skill. Run results stay private.',
  'Return to conversation {value1}': 'Return to conversation {value1}',
  '{value1} Working with {value2}': '{value1} Working with {value2}',
  'View context {value1}': 'View context {value1}',
  'A way of working, made yours.': 'A way of working, made yours.',
  'Work that runs itself.': 'Work that runs itself.',
  'One place for one piece of work.': 'One place for one piece of work.',
  'Let’s move your work forward{value1}.': 'Let’s move your work forward{value1}.',
  'Describe the work. Your Skill takes shape beside the conversation.':
    'Describe the work. Your Skill takes shape beside the conversation.',
  'Describe what it should do and when. Your agent takes shape beside the conversation. The draft does not run automatically.':
    'Describe what it should do and when. Your agent takes shape beside the conversation. The draft does not run automatically.',
  'Say what the work is. Poneva drafts the project beside the conversation and brings in what you have already done. Nothing is created until you say so.':
    'Say what the work is. Poneva drafts the project beside the conversation and brings in what you have already done. Nothing is created until you say so.',
  'Start with an idea below. Poneva will take it from there.':
    'Start with an idea below. Poneva will take it from there.',
  'Skill deleted. You can restore it from the Skills archive for 30 days.':
    'Skill deleted. You can restore it from the Skills archive for 30 days.',
  'Could not delete this Skill.': 'Could not delete this Skill.',
  'More actions': 'More actions',
  'Delete “{value1}”? It will disappear from Skills and search, and cannot be used by agents. You can restore it for 30 days. Existing chats and results stay available.':
    'Delete “{value1}”? It will disappear from Skills and search, and cannot be used by agents. You can restore it for 30 days. Existing chats and results stay available.',
  'Deleting…': 'Deleting…',
  'Confirm delete': 'Confirm delete',
  'Delete Skill': 'Delete Skill',
  'Skill restored as an unpublished draft. Its author can review and publish it again.':
    'Skill restored as an unpublished draft. Its author can review and publish it again.',
  'Could not restore this Skill.': 'Could not restore this Skill.',
  'Archived Skills': 'Archived Skills',
  'Deleted Skills can be restored for 30 days. Restoring leaves them unpublished.':
    'Deleted Skills can be restored for 30 days. Restoring leaves them unpublished.',
  'Restore until {value1}': 'Restore until {value1}',
  'Loading…': 'Loading…',
  'No archived Skills.': 'No archived Skills.',
  'Load more archived Skills': 'Load more archived Skills',
  'Show more of the original': 'Show more of the original',
  'Filter result rows': 'Filter result rows',
  'Find a product or value…': 'Find a product or value…',
  '{value1} of {value2}': '{value1} of {value2}',
  'Result table': 'Result table',
  'No matching rows.': 'No matching rows.',
  'Showing the first 1,000 matching rows. Download the CSV for every row.':
    'Showing the first 1,000 matching rows. Download the CSV for every row.',
  'Agent ·': 'Agent ·',
  'Only you': 'Only you',
  'Stopped before it finished.': 'Stopped before it finished.',
  'Drafting the project…': 'Drafting the project…',
  'Checking where this chat belongs…': 'Checking where this chat belongs…',
  'Moving the chat…': 'Moving the chat…',
  'Taking it out of the project…': 'Taking it out of the project…',
  'Adding it to the project…': 'Adding it to the project…',
  'No matching connections are available right now.':
    'No matching connections are available right now.',
  'Company knowledge suggestion': 'Company knowledge suggestion',
  'Company knowledge now lives on pages. Open Knowledge to see them.':
    'Company knowledge now lives on pages. Open Knowledge to see them.',
  '{value1} · Open beside this conversation': '{value1} · Open beside this conversation',
  Agent: 'Agent',
  Triggers: 'Triggers',
  'Review the agent and its trigger. Approval applies exactly what is shown.':
    'Review the agent and its trigger. Approval applies exactly what is shown.',
  Authorization: 'Authorization',
  Owner: 'Owner',
  '{value1} · admins': '{value1} · admins',
  'Owner · always edits': 'Owner · always edits',
  'Admins manage it': 'Admins manage it',
  Editors: 'Editors',
  'A colleague': 'A colleague',
  'Can edit drafts and publish versions': 'Can edit drafts and publish versions',
  Remove: 'Remove',
  'No editors yet.': 'No editors yet.',
  'Admins can always edit company agents.': 'Admins can always edit company agents.',
  'Asking for edit access': 'Asking for edit access',
  'Asked {value1} · also in your Inbox': 'Asked {value1} · also in your Inbox',
  Grant: 'Grant',
  Admin: 'Admin',
  'Make personal': 'Make personal',
  'Switch off': 'Switch off',
  Archive: 'Archive',
  'Archive this agent': 'Archive this agent',
  'Loading agent…': 'Loading agent…',
  '{value1} Edit in chat': '{value1} Edit in chat',
  'This agent has not been created yet. It can run once its owner creates it.':
    'This agent has not been created yet. It can run once its owner creates it.',
  'New agent · Draft': 'New agent · Draft',
  'Untitled agent': 'Untitled agent',
  'Test run': 'Test run',
  'This draft does not run automatically.': 'This draft does not run automatically.',
  'Describe the agent in the chat. Its draft appears here.':
    'Describe the agent in the chat. Its draft appears here.',
  'Describe the agent in the chat first.': 'Describe the agent in the chat first.',
  '{value1} Test run': '{value1} Test run',
  'Create and turn on': 'Create and turn on',
  'Connection write setup': 'Connection write setup',
  'Account for connected changes': 'Account for connected changes',
  Connection: 'Connection',
  'Choose a connection': 'Choose a connection',
  'No published Skills available. You can add them later.':
    'No published Skills available. You can add them later.',
  '{value1} · not published. Review the changes. Testing is optional.':
    '{value1} · not published. Review the changes. Testing is optional.',
  'Draft · revision {value1}': 'Draft · revision {value1}',
  '{value1} Test draft': '{value1} Test draft',
  'Apply this draft as a new version': 'Apply this draft as a new version',
  'This draft cannot be applied.': 'This draft cannot be applied.',
  'Apply changes…': 'Apply changes…',
  'What changed?': 'What changed?',
  'Apply version {value1}': 'Apply version {value1}',
  Create: 'Create',
  'Edit access requested': 'Edit access requested',
  '{value1} Request edit access': '{value1} Request edit access',
  '{value1} Copy agent': '{value1} Copy agent',
  Pause: 'Pause',
  'Open agent: {value1}': 'Open agent: {value1}',
  '· you can edit': '· you can edit',
  '{value1} is switched off.': '{value1} is switched off.',
  '{value1} is archived.': '{value1} is archived.',
  'Loading agents…': 'Loading agents…',
  Agents: 'Agents',
  'Agents do work for you on a schedule or when you ask. They follow your company’s Skills.':
    'Agents do work for you on a schedule or when you ask. They follow your company’s Skills.',
  'No agent matches. Try a Skill name or what the agent should do.':
    'No agent matches. Try a Skill name or what the agent should do.',
  'Nothing of your own yet': 'Nothing of your own yet',
  'Tell Chat what an agent should do, or copy one of the company’s agents below.{value1}':
    'Tell Chat what an agent should do, or copy one of the company’s agents below.{value1}',
  'Your agents': 'Your agents',
  'Run on demand': 'Run on demand',
  'Run is always available. A schedule is optional and lives separately from the agent’s instructions.':
    'Run is always available. A schedule is optional and lives separately from the agent’s instructions.',
  'Enable this schedule when approved': 'Enable this schedule when approved',
  Schedule: 'Schedule',
  'Kept off until you create the agent from its canvas.':
    'Kept off until you create the agent from its canvas.',
  'Will be enabled when you approve.': 'Will be enabled when you approve.',
  'Will be saved paused. You can enable it later.':
    'Will be saved paused. You can enable it later.',
  'Only runs when you ask.': 'Only runs when you ask.',
  'Draft · approving saves it, and nothing runs. Test it and create it from its canvas.':
    'Draft · approving saves it, and nothing runs. Test it and create it from its canvas.',
  'Draft · nothing is scheduled until you approve. Connected actions require their own approval at run time.':
    'Draft · nothing is scheduled until you approve. Connected actions require their own approval at run time.',
  Name: 'Name',
  'Agent name': 'Agent name',
  'Who can use it': 'Who can use it',
  'Company agent · company resources only': 'Company agent · company resources only',
  'Personal agent · runs with your access': 'Personal agent · runs with your access',
  'Approving saves it as a draft. It does not run automatically.':
    'Approving saves it as a draft. It does not run automatically.',
  'Open the agent’s runs': 'Open the agent’s runs',
  'Run the published version once': 'Run the published version once',
  'Stopping…': 'Stopping…',
  'Stop run': 'Stop run',
  'Could not stop this run. Please try again.': 'Could not stop this run. Please try again.',
  'Run in progress': 'Run in progress',
  'This run is still answering. You can ask follow-ups when it finishes.':
    'This run is still answering. You can ask follow-ups when it finishes.',
  'Open run details': 'Open run details',
  Runs: 'Runs',
  'Open the run chat': 'Open the run chat',
  Watch: 'Watch',
  Save: 'Save',
  Goal: 'Goal',
  'Change the goal': 'Change the goal',
  'What it does': 'What it does',
  'What should this agent achieve?': 'What should this agent achieve?',
  'Not set yet.': 'Not set yet.',
  'When it runs': 'When it runs',
  'Change when it runs': 'Change when it runs',
  'Off means it runs only when someone runs it. Changing when it runs never changes its instructions.':
    'Off means it runs only when someone runs it. Changing when it runs never changes its instructions.',
  Instructions: 'Instructions',
  'Change the instructions': 'Change the instructions',
  'How the agent should approach the work and make decisions.':
    'How the agent should approach the work and make decisions.',
  Boundaries: 'Boundaries',
  'What to do or avoid. Every connected action still follows its approval.':
    'What to do or avoid. Every connected action still follows its approval.',
  'No instructions of its own. It follows its Skills.':
    'No instructions of its own. It follows its Skills.',
  'Pin a Skill': 'Pin a Skill',
  'Finds the Skills that fit each run, the same way a chat does.':
    'Finds the Skills that fit each run, the same way a chat does.',
  'Skills it always follows': 'Skills it always follows',
  'A Skill that is not published': 'A Skill that is not published',
  'Always follows · Version {value1}': 'Always follows · Version {value1}',
  'Not published': 'Not published',
  Uses: 'Uses',
  'Change in chat: Uses': 'Change in chat: Uses',
  'Change in chat': 'Change in chat',
  'Company knowledge and the tools each run is allowed to use.':
    'Company knowledge and the tools each run is allowed to use.',
  'People see the Result refresh; they change the agent, not the page.':
    'People see the Result refresh; they change the agent, not the page.',
  'The first run after it is created makes the Result; later runs add a version to it.':
    'The first run after it is created makes the Result; later runs add a version to it.',
  'It starts private. Sharing it wider shares every refresh, which can carry your private data.':
    'It starts private. Sharing it wider shares every refresh, which can carry your private data.',
  'Emails whoever the run is for': 'Emails whoever the run is for',
  'Email each run': 'Email each run',
  Delivers: 'Delivers',
  'Change what it delivers': 'Change what it delivers',
  'Expected result': 'Expected result',
  'What a successful run should deliver.': 'What a successful run should deliver.',
  'What each run delivers': 'What each run delivers',
  'Keeps one Result up to date {value1}': 'Keeps one Result up to date {value1}',
  'its Result': 'its Result',
  '· its first run makes it': '· its first run makes it',
  'Saves a new Result each run': 'Saves a new Result each run',
  'You can run this company agent as yourself.{value1} {value2}':
    'You can run this company agent as yourself.{value1} {value2}',
  'Changes since version': 'Changes since version',
  'are not live yet.': 'are not live yet.',
  'Review them in Versions': 'Review them in Versions',
  Skill: 'Skill',
  'The agent always uses the Skill’s published version.':
    'The agent always uses the Skill’s published version.',
  Day: 'Day',
  Time: 'Time',
  'Cron expression': 'Cron expression',
  'Editors and access': 'Editors and access',
  Company: 'Company',
  Personal: 'Personal',
  'No changes.': 'No changes.',
  'Instructions changes': 'Instructions changes',
  'Loading versions…': 'Loading versions…',
  'What the draft changes': 'What the draft changes',
  'No published version yet. Try the draft, then publish it.':
    'No published version yet. Try the draft, then publish it.',
  'Published versions': 'Published versions',
  'Former member': 'Former member',
  Live: 'Live',
  'What changed in version {value1}': 'What changed in version {value1}',
  'Every publish is a version you can restore.': 'Every publish is a version you can restore.',
  'We couldn’t load what happened in this App. Try again in a moment.':
    'We couldn’t load what happened in this App. Try again in a moment.',
  'Loading library…': 'Loading library…',
  Download: 'Download',
  CSV: 'CSV',
  Person: 'Person',
  Everyone: 'Everyone',
  'All connections': 'All connections',
  'App {value1}': 'App {value1}',
  'App reference': 'App reference',
  'From {value1}': 'From {value1}',
  'Until {value1}': 'Until {value1}',
  Result: 'Result',
  'All results': 'All results',
  Succeeded: 'Succeeded',
  Denied: 'Denied',
  Failed: 'Failed',
  Unknown: 'Unknown',
  Filter: 'Filter',
  'Loading activity…': 'Loading activity…',
  'Could not load activity. Try again.': 'Could not load activity. Try again.',
  'Removed connection': 'Removed connection',
  'App: {value1}': 'App: {value1}',
  'Older activity': 'Older activity',
  'Add a name and a web address.': 'Add a name and a web address.',
  'Enter a valid web address.': 'Enter a valid web address.',
  'Use a web address that starts with https://.': 'Use a web address that starts with https://.',
  'Add a custom connection': 'Add a custom connection',
  'Connect a tool server you trust. Poneva checks the address works and saves only the connection details needed to use it.':
    'Connect a tool server you trust. Poneva checks the address works and saves only the connection details needed to use it.',
  'Name {value1}': 'Name {value1}',
  'e.g. Product analytics': 'e.g. Product analytics',
  'Web address': 'Web address',
  'https://tools.example.com': 'https://tools.example.com',
  'Starts with https://, from your provider': 'Starts with https://, from your provider',
  'Sign-in': 'Sign-in',
  'Advanced sign-in': 'Advanced sign-in',
  'Access key {value1}': 'Access key {value1}',
  'Paste access key': 'Paste access key',
  'Request headers': 'Request headers',
  'Add header': 'Add header',
  'Header {value1} name': 'Header {value1} name',
  'Header name': 'Header name',
  'Header {value1} value': 'Header {value1} value',
  'Header value': 'Header value',
  'Remove header': 'Remove header',
  'Username {value1}': 'Username {value1}',
  'Password {value1}': 'Password {value1}',
  Advanced: 'Advanced',
  Transport: 'Transport',
  'Auto-detect': 'Auto-detect',
  'Streamable HTTP': 'Streamable HTTP',
  'Legacy SSE': 'Legacy SSE',
  "From your provider's app settings. Leave empty unless they gave you these.":
    "From your provider's app settings. Leave empty unless they gave you these.",
  "Authorization server issuer": "Authorization server issuer",
  "Enter the authorization server issuer when using a client ID.": "Enter the authorization server issuer when using a client ID.",
  'Client ID {value1}': 'Client ID {value1}',
  'Client secret {value1}': 'Client secret {value1}',
  'Connecting…': 'Connecting…',
  'Test and connect': 'Test and connect',
  'Add the store, the client ID and the client secret.':
    'Add the store, the client ID and the client secret.',
  'Connect your Shopify Developer App': 'Connect your Shopify Developer App',
  'Poneva can use exactly the access your store gave the app, and nothing more. It talks to Shopify directly and keeps the client secret encrypted.':
    'Poneva can use exactly the access your store gave the app, and nothing more. It talks to Shopify directly and keeps the client secret encrypted.',
  'How to create the app in Shopify': 'How to create the app in Shopify',
  'Open{value1} {value2}{value3} with the account that owns the store, and create an app.':
    'Open{value1} {value2}{value3} with the account that owns the store, and create an app.',
  'Shopify’s Dev Dashboard': 'Shopify’s Dev Dashboard',
  'Create a version and select the access scopes Poneva may use, for example read_products and read_orders. Add write_ scopes only for data Poneva may change. Then release the version.':
    'Create a version and select the access scopes Poneva may use, for example read_products and read_orders. Add write_ scopes only for data Poneva may change. Then release the version.',
  'For orders and customers, also select protected customer data in the app’s settings. Shopify allows this without review for an app made for your own store.':
    'For orders and customers, also select protected customer data in the app’s settings. Shopify allows this without review for an app made for your own store.',
  'Install the app on your store.': 'Install the app on your store.',
  'Copy the client ID and client secret from the app’s settings.':
    'Copy the client ID and client secret from the app’s settings.',
  'To change the access later, release a new version, approve it on the store and use Test connection here.':
    'To change the access later, release a new version, approve it on the store and use Test connection here.',
  Store: 'Store',
  'your-store.myshopify.com': 'your-store.myshopify.com',
  'Your store’s .myshopify.com address (Shopify admin → Settings → Domains), or paste the address of your Shopify admin page':
    'Your store’s .myshopify.com address (Shopify admin → Settings → Domains), or paste the address of your Shopify admin page',
  'Client ID {value1} {value2}': 'Client ID {value1} {value2}',
  'Client secret {value1} {value2}': 'Client secret {value1} {value2}',
  '{value1} chart of {value2} across {value3}': '{value1} chart of {value2} across {value3}',
  'We could not build the file.': 'We could not build the file.',
  '{value1} Present': '{value1} Present',
  'Building…': 'Building…',
  'Download PowerPoint': 'Download PowerPoint',
  'Slide {value1} of {value2}': 'Slide {value1} of {value2}',
  Slides: 'Slides',
  'Slide {value1}': 'Slide {value1}',
  'Speaker notes': 'Speaker notes',
  'Source: {value1}': 'Source: {value1}',
  px: 'px',
  'This suggested knowledge update could not be shown.':
    'This suggested knowledge update could not be shown.',
  'Suggested knowledge update': 'Suggested knowledge update',
  'This suggestion is no longer available to you.':
    'This suggestion is no longer available to you.',
  'We could not check where this suggestion stands.':
    'We could not check where this suggestion stands.',
  'Check again': 'Check again',
  'Show on page': 'Show on page',
  'The editor could not be loaded. Poneva may have been updated since you opened this page. Reload to get the latest version; nothing on this page has changed.':
    'The editor could not be loaded. Poneva may have been updated since you opened this page. Reload to get the latest version; nothing on this page has changed.',
  'Reload Poneva': 'Reload Poneva',
  Formatting: 'Formatting',
  'Text style': 'Text style',
  Text: 'Text',
  Heading: 'Heading',
  Subheading: 'Subheading',
  'Link a page': 'Link a page',
  'A page needs a title.': 'A page needs a title.',
  'Nothing has changed yet.': 'Nothing has changed yet.',
  'A page needs some text. To remove a page, archive it instead.':
    'A page needs some text. To remove a page, archive it instead.',
  'A suggested new page needs some text.': 'A suggested new page needs some text.',
  'This page is larger than 256 KB. Split it into smaller pages.':
    'This page is larger than 256 KB. Split it into smaller pages.',
  'Say in a few words why this change is right.': 'Say in a few words why this change is right.',
  'This page changed while you were editing. Your text is still here: copy it, then open the latest version and make your change again.':
    'This page changed while you were editing. Your text is still here: copy it, then open the latest version and make your change again.',
  'Your text is copied.': 'Your text is copied.',
  'Your text could not be copied. Select it in the editor and copy it.':
    'Your text could not be copied. Select it in the editor and copy it.',
  'The page “{value1}” is created.': 'The page “{value1}” is created.',
  'New page': 'New page',
  'Editing {value1}': 'Editing {value1}',
  Editing: 'Editing',
  'Creating publishes the page under {value1} for everyone':
    'Creating publishes the page under {value1} for everyone',
  'Saving publishes the new version for everyone': 'Saving publishes the new version for everyone',
  'Your changes are sent as a suggestion for a publisher':
    'Your changes are sent as a suggestion for a publisher',
  'Create page': 'Create page',
  'Send suggestion': 'Send suggestion',
  '{value1} Copy my text': '{value1} Copy my text',
  'Open the latest version': 'Open the latest version',
  'Page title': 'Page title',
  'Loading the editor…': 'Loading the editor…',
  'New page text': 'New page text',
  'Text of {value1}': 'Text of {value1}',
  'Write the page. Type [[ to link another page.': 'Write the page. Type [[ to link another page.',
  'Type [[ to link another page.': 'Type [[ to link another page.',
  'Link to a page': 'Link to a page',
  'What changed, in a few words': 'What changed, in a few words',
  'Where this comes from, in a few words': 'Where this comes from, in a few words',
  'Shown in the page history.': 'Shown in the page history.',
  'A publisher sees this next to your change.': 'A publisher sees this next to your change.',
  '1 suggestion is open on this page': '1 suggestion is open on this page',
  '{value1} suggestions are open on this page': '{value1} suggestions are open on this page',
  'They stay open while you edit. After you save, they show against your new text; one whose words you changed is marked outdated.':
    'They stay open while you edit. After you save, they show against your new text; one whose words you changed is marked outdated.',
  'Type [[ to link another page. Links keep working when a page is renamed or moved.':
    'Type [[ to link another page. Links keep working when a page is renamed or moved.',
  'Loading the history…': 'Loading the history…',
  'This page has no saved text yet.': 'This page has no saved text yet.',
  'Say in a few words why this revision should come back.':
    'Say in a few words why this revision should come back.',
  'Revision {value1} is suggested for a publisher to accept.':
    'Revision {value1} is suggested for a publisher to accept.',
  'The page already reads like this revision.': 'The page already reads like this revision.',
  'Revision {value1} is restored as revision {value2}.':
    'Revision {value1} is restored as revision {value2}.',
  'Revision history': 'Revision history',
  Revisions: 'Revisions',
  'Every saved revision is kept.': 'Every saved revision is kept.',
  'Revision {value1} {value2}': 'Revision {value1} {value2}',
  'Revision {value1} compared with revision {value2}':
    'Revision {value1} compared with revision {value2}',
  'Revision {value1}, the first text of this page':
    'Revision {value1}, the first text of this page',
  'Green was added, struck through was removed.': 'Green was added, struck through was removed.',
  '{value1} Export Markdown': '{value1} Export Markdown',
  'Restore this revision': 'Restore this revision',
  'Suggest restoring it': 'Suggest restoring it',
  'Why should this revision come back?': 'Why should this revision come back?',
  'Loading this revision…': 'Loading this revision…',
  'Only the title changed, from “{value1}” to “{value2}”.':
    'Only the title changed, from “{value1}” to “{value2}”.',
  'The text did not change in this revision.': 'The text did not change in this revision.',
  'Changes in revision {value1}': 'Changes in revision {value1}',
  'Loading page…': 'Loading page…',
  'Loading suggestion…': 'Loading suggestion…',
  'This suggestion is not available.': 'This suggestion is not available.',
  'It may have been decided, or it is not one you can see.':
    'It may have been decided, or it is not one you can see.',
  'Open Knowledge': 'Open Knowledge',
  'Opening the suggestion…': 'Opening the suggestion…',
  'Choose where the page goes.': 'Choose where the page goes.',
  'Say in a few words why.': 'Say in a few words why.',
  'Your suggestion is sent. A publisher decides.': 'Your suggestion is sent. A publisher decides.',
  'Moved under {value1}.': 'Moved under {value1}.',
  'Deleted “{value1}”.': 'Deleted “{value1}”.',
  'Archived. Its history is kept.': 'Archived. Its history is kept.',
  'Choose the page it goes under. Links to it keep working.':
    'Choose the page it goes under. Links to it keep working.',
  'Its text, its history and any open suggestions are removed for good, and links to it from other pages stop working. This cannot be undone.':
    'Its text, its history and any open suggestions are removed for good, and links to it from other pages stop working. This cannot be undone.',
  'An archived page no longer informs answers. Its history is kept, and a publisher can restore it or delete it permanently.':
    'An archived page no longer informs answers. Its history is kept, and a publisher can restore it or delete it permanently.',
  Under: 'Under',
  Change: 'Change',
  'Move under': 'Move under',
  'Search pages': 'Search pages',
  'Why?': 'Why?',
  'Delete permanently': 'Delete permanently',
  'Move page': 'Move page',
  'Archive page': 'Archive page',
  'Removed:': 'Removed:',
  'Added:': 'Added:',
  'Suggestion {value1}: show its card': 'Suggestion {value1}: show its card',
  'New page “{value1}”{value2}': 'New page “{value1}”{value2}',
  'No pages match “{value1}”.': 'No pages match “{value1}”.',
  'Where this page is': 'Where this page is',
  'Describe your company': 'Describe your company',
  'Empty page': 'Empty page',
  'Describe {value1}': 'Describe {value1}',
  'This page has no text yet.': 'This page has no text yet.',
  'Poneva reads this page before every answer. Start with who you are, what you sell and how you work; details go on the pages under it.':
    'Poneva reads this page before every answer. Start with who you are, what you sell and how you work; details go on the pages under it.',
  'Write it, or ask Poneva in chat to draft it for you.':
    'Write it, or ask Poneva in chat to draft it for you.',
  'Suggest a first version, and a publisher decides whether it becomes the page.':
    'Suggest a first version, and a publisher decides whether it becomes the page.',
  'Start writing': 'Start writing',
  'Suggest a first version': 'Suggest a first version',
  'Accepted. The page is archived.': 'Accepted. The page is archived.',
  'Accepted. The page is now revision {value1}.': 'Accepted. The page is now revision {value1}.',
  'Accepted.': 'Accepted.',
  'Suggestion rejected. The page stays as it is.': 'Suggestion rejected. The page stays as it is.',
  'Your suggestion is withdrawn.': 'Your suggestion is withdrawn.',
  'Restored. The page informs answers again.': 'Restored. The page informs answers again.',
  'Your suggestion is sent. A publisher decides whether it becomes the page.':
    'Your suggestion is sent. A publisher decides whether it becomes the page.',
  'Saved. The page is now revision {value1}.': 'Saved. The page is now revision {value1}.',
  'Nothing changed.': 'Nothing changed.',
  'This page is not available.': 'This page is not available.',
  'It may have been deleted, archived or moved out of reach, or you may no longer be in this company.':
    'It may have been deleted, archived or moved out of reach, or you may no longer be in this company.',
  'Page actions': 'Page actions',
  shown: 'shown',
  hidden: 'hidden',
  '{value1} History': '{value1} History',
  '{value1} Ask in chat': '{value1} Ask in chat',
  'Suggest edits': 'Suggest edits',
  'More actions for {value1}': 'More actions for {value1}',
  '{value1} Poneva reads this page in every chat': '{value1} Poneva reads this page in every chat',
  'This page is archived. It no longer informs answers; its history is kept. {value1}':
    'This page is archived. It no longer informs answers; its history is kept. {value1}',
  'Restore page': 'Restore page',
  'This link points to an earlier revision. You are reading the current text.':
    'This link points to an earlier revision. You are reading the current text.',
  'Show it in History': 'Show it in History',
  Pages: 'Pages',
  'Pages under {value1}': 'Pages under {value1}',
  'Linked from': 'Linked from',
  Suggestions: 'Suggestions',
  'Suggestions are hidden. You are reading the page as everyone else sees it.':
    'Suggestions are hidden. You are reading the page as everyone else sees it.',
  'Loading suggestions…': 'Loading suggestions…',
  'Nothing is waiting for review.': 'Nothing is waiting for review.',
  'When someone, Poneva in a chat or a connected agent suggests a change to a page, it shows here and on the page. Nothing changes until a publisher accepts it.':
    'When someone, Poneva in a chat or a connected agent suggests a change to a page, it shows here and on the page. Nothing changes until a publisher accepts it.',
  '{value1} Review knowledge in chat': '{value1} Review knowledge in chat',
  'Suggestions for review': 'Suggestions for review',
  'Suggested changes from chats, meetings, colleagues and connected agents. Nothing changes until a publisher accepts it on the page.':
    'Suggested changes from chats, meetings, colleagues and connected agents. Nothing changes until a publisher accepts it on the page.',
  'Your suggestions wait here until a publisher decides. The pages stay as they are until then.':
    'Your suggestions wait here until a publisher decides. The pages stay as they are until then.',
  'Review page': 'Review page',
  'Review on page': 'Review on page',
  'Open the meeting': 'Open the meeting',
  'Open the chat': 'Open the chat',
  'Accept and restore': 'Accept and restore',
  Accept: 'Accept',
  Reject: 'Reject',
  'Your suggestion · waiting for a publisher': 'Your suggestion · waiting for a publisher',
  Withdraw: 'Withdraw',
  'Waiting for a publisher': 'Waiting for a publisher',
  'Suggestion {value1}': 'Suggestion {value1}',
  'Suggestion {value1} from {value2}{value3}': 'Suggestion {value1} from {value2}{value3}',
  'Read the suggested page': 'Read the suggested page',
  'Outdated: the text it changes was edited after it was suggested. It can be rejected or withdrawn; a new suggestion can be made against the current text.':
    'Outdated: the text it changes was edited after it was suggested. It can be rejected or withdrawn; a new suggestion can be made against the current text.',
  'Restore this page first to accept this suggestion.':
    'Restore this page first to accept this suggestion.',
  'Previous suggestion': 'Previous suggestion',
  'Suggestion {value1} of {value2}': 'Suggestion {value1} of {value2}',
  'Next suggestion': 'Next suggestion',
  'Fold the suggestions away': 'Fold the suggestions away',
  'Show the suggestions': 'Show the suggestions',
  '1 suggestion': '1 suggestion',
  '{value1} suggestions': '{value1} suggestions',
  '{value1} the pages under {value2}': '{value1} the pages under {value2}',
  Ctrl: 'Ctrl',
  'Host {value1}': 'Host {value1}',
  'db.example.com': 'db.example.com',
  'Port {value1}': 'Port {value1}',
  'Database {value1}': 'Database {value1}',
  'Advanced TLS': 'Advanced TLS',
  '{value1} Poneva verifies the server certificate. Add a CA or server DNS name for IP hosts when your certificate requires it.':
    '{value1} Poneva verifies the server certificate. Add a CA or server DNS name for IP hosts when your certificate requires it.',
  'CA certificate {value1}': 'CA certificate {value1}',
  'Certificate server DNS name {value1}': 'Certificate server DNS name {value1}',
  '{value1} Your password is encrypted in secure storage. Poneva verifies the connection before saving it.':
    '{value1} Your password is encrypted in secure storage. Poneva verifies the connection before saving it.',
  'Testing…': 'Testing…',
  'Test connection': 'Test connection',
  'PostgreSQL is connected.': 'PostgreSQL is connected.',
  'PostgreSQL was saved safely.': 'PostgreSQL was saved safely.',
  'Poneva can read and change rows in the selected tables. Apps also follow their approved data scope.':
    'Poneva can read and change rows in the selected tables. Apps also follow their approved data scope.',
  'Poneva can read the selected tables. Apps also follow their approved data scope.':
    'Poneva can read the selected tables. Apps also follow their approved data scope.',
  'Reads are paused until permission is enabled.': 'Reads are paused until permission is enabled.',
  'Retrying…': 'Retrying…',
  'Retry permission': 'Retry permission',
  'Try it in Chat': 'Try it in Chat',
  Done: 'Done',
  'Disconnect database': 'Disconnect database',
  '{value1} TLS verified ·{value2} {value3}': '{value1} TLS verified ·{value2} {value3}',
  'Search schemas and tables': 'Search schemas and tables',
  'Search tables': 'Search tables',
  '{value1} of {value2} tables selected': '{value1} of {value2} tables selected',
  'Select matching tables': 'Select matching tables',
  'Select all tables': 'Select all tables',
  Clear: 'Clear',
  'Select a whole schema or individual tables. New tables need a fresh selection.':
    'Select a whole schema or individual tables. New tables need a fresh selection.',
  'No tables match this search.': 'No tables match this search.',
  'All tables in {value1}': 'All tables in {value1}',
  '{value1} / {value2} tables': '{value1} / {value2} tables',
  'Read & write available': 'Read & write available',
  'Read only': 'Read only',
  'This App could not be opened.': 'This App could not be opened.',
  'Opening App…': 'Opening App…',
  'Open the saved App to run this function.': 'Open the saved App to run this function.',
  'Save this App before running its function.': 'Save this App before running its function.',
  'Open saved App': 'Open saved App',
  'Open Apps': 'Open Apps',
  'The App could not be opened. Try again.': 'The App could not be opened. Try again.',
  'There are no numeric values available to chart. View the table for the original data.':
    'There are no numeric values available to chart. View the table for the original data.',
  'Chart value': 'Chart value',
  '{value1} of {value2} shown': '{value1} of {value2} shown',
  '{value1} by {value2}; {value3} rows. View Table for exact values.':
    '{value1} by {value2}; {value3} rows. View Table for exact values.',
  'Values come directly from the source data. Missing values are not estimates.':
    'Values come directly from the source data. Missing values are not estimates.',
  '{source} · read {date}': '{source} · read {date}',
  'Evidence is being recorded · read {date}': 'Evidence is being recorded · read {date}',
  'Evidence expired on {date} under the retention policy':
    'Evidence expired on {date} under the retention policy',
  'Entered by {person}': 'Entered by {person}',
  'No retained evidence for this value': 'No retained evidence for this value',
  'Evidence for {value1}': 'Evidence for {value1}',
  Measure: 'Measure',
  'Covers {shown} of {total} rows': 'Covers {shown} of {total} rows',
  'Show rows →': 'Show rows →',
  'Ask about this number': 'Ask about this number',
  'Search rows': 'Search rows',
  'Clear filters': 'Clear filters',
  Sort: 'Sort',
  'Sort: {column}': 'Sort: {column}',
  '{shown} of {total} rows': '{shown} of {total} rows',
  More: 'More',
  Density: 'Density',
  Comfortable: 'Comfortable',
  Compact: 'Compact',
  Columns: 'Columns',
  'No rows match. Clear the search or filters to see them again.':
    'No rows match. Clear the search or filters to see them again.',
  'Not available': 'Not available',
  'All rows': 'All rows',
  'Close row detail': 'Close row detail',
  'Ask about this row': 'Ask about this row',
  'Add note': 'Add note',
  Note: 'Note',
  Saved: 'Saved',
  Total: 'Total',
  ascending: 'ascending',
  descending: 'descending',
  'Scroll to see all columns': 'Scroll to see all columns',
  App: 'App',
  Artifact: 'Artifact',
  'New project': 'New project',
  'Review request': 'Review request',
  Activity: 'Activity',
  'Voice preview': 'Voice preview',
  Source: 'Source',
  File: 'File',
  Meeting: 'Meeting',
  'Knowledge page': 'Knowledge page',
  'Could not preview this CSV.': 'Could not preview this CSV.',
  'File content is unavailable.': 'File content is unavailable.',
  'You have five open suggestions here. {value1} will see them.':
    'You have five open suggestions here. {value1} will see them.',
  'We could not send your suggestion. Please try again.':
    'We could not send your suggestion. Please try again.',
  'The agent': 'The agent',
  'Selected colleagues': 'Selected colleagues',
  'The owner': 'The owner',
  'Forked. This copy is yours and runs with your own connections.':
    'Forked. This copy is yours and runs with your own connections.',
  'This chat is too long to fork.': 'This chat is too long to fork.',
  'We could not fork this chat. Please try again.':
    'We could not fork this chat. Please try again.',
  'Anyone who forked it keeps their copy: forks stay with the people who made them.':
    'Anyone who forked it keeps their copy: forks stay with the people who made them.',
  'Nobody has forked this chat.': 'Nobody has forked this chat.',
  '1 person forked this chat. Their copy stays theirs.':
    '1 person forked this chat. Their copy stays theirs.',
  '{value1} people forked this chat. Their copies stay theirs.':
    '{value1} people forked this chat. Their copies stay theirs.',
  'Personal. Nobody else sees it.': 'Personal. Nobody else sees it.',
  'People you pick. They get it in their Inbox.': 'People you pick. They get it in their Inbox.',
  'Everyone in the company can follow it and fork it.':
    'Everyone in the company can follow it and fork it.',
  'a chat you can no longer open': 'a chat you can no longer open',
  'shared the Result': 'shared the Result',
  'updated the Result': 'updated the Result',
  'published the Skill': 'published the Skill',
  'approved the fact': 'approved the fact',
  'added the fact': 'added the fact',
  'added the meeting': 'added the meeting',
  'published the page': 'published the page',
  'updated the page': 'updated the page',
  'shared the chat': 'shared the chat',
  'published a version of': 'published a version of',
  ran: 'ran',
  Knowledge: 'Knowledge',
  Meetings: 'Meetings',
  Chat: 'Chat',
  Use: 'Use',
  Open: 'Open',
  You: 'You',
  Someone: 'Someone',
  'published version {version} of': 'published version {version} of',
  'thing needs': 'thing needs',
  'things need': 'things need',
  'Published Skill': 'Published Skill',
  'Included with Skill': 'Included with Skill',
  'Already attached': 'Already attached',
  'Also available in company knowledge': 'Also available in company knowledge',
  'Company file': 'Company file',
  'Account identity unavailable': 'Account identity unavailable',
  'Access expired or was revoked. Reconnect to continue.':
    'Access expired or was revoked. Reconnect to continue.',
  'Account authorized · tools unavailable': 'Account authorized · tools unavailable',
  'Not available in this workspace yet.': 'Not available in this workspace yet.',
  'Everyone in the company': 'Everyone in the company',
  'Audience: only you.': 'Audience: only you.',
  'Audience: everyone in the company.': 'Audience: everyone in the company.',
  'tool is': 'tool is',
  'tools are': 'tools are',
  'account is': 'account is',
  'accounts are': 'accounts are',
  'We could not upload this file.': 'We could not upload this file.',
  'file was': 'file was',
  'files were': 'files were',
  'Your company': 'Your company',
  'Create an agent': 'Create an agent',
  'Give recurring work a helping hand': 'Give recurring work a helping hand',
  'Create a Skill': 'Create a Skill',
  'Save a reusable way of working': 'Save a reusable way of working',
  'Take meeting notes': 'Take meeting notes',
  'Capture decisions and next steps': 'Capture decisions and next steps',
  'Work with a file': 'Work with a file',
  'Start from a document or image': 'Start from a document or image',
  'Browse agents': 'Browse agents',
  'Open your agents and company agents': 'Open your agents and company agents',
  'Review results': 'Review results',
  'Return to work saved in your Library': 'Return to work saved in your Library',
  'For review': 'For review',
  'An agent': 'An agent',
  Assistant: 'Assistant',
  'Kept up to date by {value1}{value2}': 'Kept up to date by {value1}{value2}',
  ', {value1}': ', {value1}',
  'Version {value1}{value2}{value3}': 'Version {value1}{value2}{value3}',
  'Refreshed by its agent': 'Refreshed by its agent',
  'Saved from a chat': 'Saved from a chat',
  'Saved from {value1}': 'Saved from {value1}',
  Edited: 'Edited',
  'private account': 'private account',
  '{value1} ({value2})': '{value1} ({value2})',
  '{value1}’s {value2}': '{value1}’s {value2}',
  'Made private. The person who added it and the owner of its recording have been told in their Inbox.':
    'Made private. The person who added it and the owner of its recording have been told in their Inbox.',
  'Made private. The person who added it has been told in their Inbox.':
    'Made private. The person who added it has been told in their Inbox.',
  'Made private. The owner of its recording has been told in their Inbox.':
    'Made private. The owner of its recording has been told in their Inbox.',
  'Selected passage': 'Selected passage',
  '{value1} {value2}': '{value1} {value2}',
  'Upload a file': 'Upload a file',
  'Help me create a useful report from our company knowledge and available sources.':
    'Help me create a useful report from our company knowledge and available sources.',
  'This saved work couldn’t be opened. Open it again to retry.':
    'This saved work couldn’t be opened. Open it again to retry.',
  '{value1}’s': '{value1}’s',
  '{value1} chat “{value2}”': '{value1} chat “{value2}”',
  '{value1}{value2}': '{value1}{value2}',
  'Skill: {value1}{value2}': 'Skill: {value1}{value2}',
  'Result “{value1}”': 'Result “{value1}”',
  'Meeting “{value1}”': 'Meeting “{value1}”',
  'Used in {value1} {value2} this week': 'Used in {value1} {value2} this week',
  '{value1} {value2} · used in {value3} {value4}': '{value1} {value2} · used in {value3} {value4}',
  'The draft is not published yet, so no one else follows it.':
    'The draft is not published yet, so no one else follows it.',
  'Use it in a chat for current data, or refine the Skill first.':
    'Use it in a chat for current data, or refine the Skill first.',
  'An agent keeps this up to date. Continue the work in chat.':
    'An agent keeps this up to date. Continue the work in chat.',
  'Edit it here, or continue the work in chat.': 'Edit it here, or continue the work in chat.',
  'Duplicate it to your Library, or continue the work in chat.':
    'Duplicate it to your Library, or continue the work in chat.',
  'Download Markdown': 'Download Markdown',
  'Download CSV': 'Download CSV',
  'an agent': 'an agent',
  'Publish a Skill version': 'Publish a Skill version',
  'Share with {value1}': 'Share with {value1}',
  'Update company content': 'Update company content',
  Approved: 'Approved',
  Declined: 'Declined',
  Pending: 'Pending',
  'View decision': 'View decision',
  'No data': 'No data',
  'No change': 'No change',
  'Connection created': 'Connection created',
  'Sharing changed': 'Sharing changed',
  'Person added': 'Person added',
  'Person removed': 'Person removed',
  'Access changed': 'Access changed',
  'Access turned off': 'Access turned off',
  'Connection removed': 'Connection removed',
  'Query time limit changed': 'Query time limit changed',
  '{count} row': '{count} row',
  '{count} rows': '{count} rows',
  'This source is no longer available. Company knowledge now lives in Knowledge pages, and files stay in the Library.':
    'This source is no longer available. Company knowledge now lives in Knowledge pages, and files stay in the Library.',
  '· {value1} by {value2}': '· {value1} by {value2}',
  '· version {value1}': '· version {value1}',
  '{message} {count} earlier file was saved and attached.':
    '{message} {count} earlier file was saved and attached.',
  '{message} {count} earlier files were saved and attached.':
    '{message} {count} earlier files were saved and attached.',
  '{message} {count} earlier file was saved.': '{message} {count} earlier file was saved.',
  '{message} {count} earlier files were saved.': '{message} {count} earlier files were saved.',
  'refreshed {time}': 'refreshed {time}',
  'a colleague': 'a colleague',
  'Your chat “{title}”': 'Your chat “{title}”',
  '{name}’s chat “{title}”': '{name}’s chat “{title}”',
  'Kept up to date by {name}{version}': 'Kept up to date by {name}{version}',
  'Skill: {name}{version}': 'Skill: {name}{version}',
  'Result “{title}”': 'Result “{title}”',
  'Meeting “{title}”': 'Meeting “{title}”',
  'Used in {count} answer this week': 'Used in {count} answer this week',
  'Used in {count} answers this week': 'Used in {count} answers this week',
  '{count} source': '{count} source',
  '{count} sources': '{count} sources',
  'used in {count} place': 'used in {count} place',
  'used in {count} places': 'used in {count} places',
  '{company} workspace': '{company} workspace',
  '{count} page': '{count} page',
  '{count} pages': '{count} pages',
  '{needs} · reviews and approvals': '{needs} · reviews and approvals',
  '{count} thing needs you': '{count} thing needs you',
  '{count} things need you': '{count} things need you',
  'Included with Skill · {files} · {sources} {icon}':
    'Included with Skill · {files} · {sources} {icon}',
  '{count} file': '{count} file',
  '{count} files': '{count} files',
  Today: 'Today',
  'Earlier this week': 'Earlier this week',
  '{count} slide': '{count} slide',
  '{count} slides': '{count} slides',
  Early: 'Early',
  'TLS verified': 'TLS verified',
  'Made personal and switched off. Switch it on when you are ready.':
    'Made personal and switched off. Switch it on when you are ready.',
  'Made personal and switched off. Its owner is told which version is live.':
    'Made personal and switched off. Its owner is told which version is live.',
  'Switched off.': 'Switched off.',
  'Applied version {revision}.': 'Applied version {revision}.',
  'The draft is running in a chat only you can read.':
    'The draft is running in a chat only you can read.',
  'Publish a version first.': 'Publish a version first.',
  'Another Agent action is in progress.': 'Another Agent action is in progress.',
  'Knowledge & connections': 'Knowledge & connections',
  'Pinned Skills': 'Pinned Skills',
  None: 'None',
  'A new Result each run': 'A new Result each run',
  'One Result kept up to date': 'One Result kept up to date',
  Email: 'Email',
  On: 'On',
  Off: 'Off',
  'Waiting for review': 'Waiting for review',
  Outdated: 'Outdated',
  Accepted: 'Accepted',
  Rejected: 'Rejected',
  Withdrawn: 'Withdrawn',
  Replaced: 'Replaced',
  'Suggested edit': 'Suggested edit',
  'Suggested new page': 'Suggested new page',
  'Suggested move': 'Suggested move',
  'Suggested archive': 'Suggested archive',
  'Checking status…': 'Checking status…',
  'Status unavailable': 'Status unavailable',
  'Bulleted list': 'Bulleted list',
  'Numbered list': 'Numbered list',
  'Web link': 'Web link',
  Read: 'Read',
  Write: 'Write',
  'shared with you': 'shared with you',
  'Getting an answer': 'Getting an answer',
  '{name} is getting an answer': '{name} is getting an answer',
  'We could not save. Please try again.': 'We could not save. Please try again.',
  'The new page could not be created.': 'The new page could not be created.',
  'We could not load this revision.': 'We could not load this revision.',
  'We could not restore this revision. Please try again.':
    'We could not restore this revision. Please try again.',
  'We could not export this revision.': 'We could not export this revision.',
  'We could not open this suggestion.': 'We could not open this suggestion.',
  'We could not do that. Please try again.': 'We could not do that. Please try again.',
  'We could not save your decision. Please try again.':
    'We could not save your decision. Please try again.',
  'We could not restore this page. Please try again.':
    'We could not restore this page. Please try again.',
  'We could not export this page.': 'We could not export this page.',
  '{count} missed time merged.': '{count} missed time merged.',
  '{count} missed times merged.': '{count} missed times merged.',
  'About this project': 'About this project',
};
type Key = keyof typeof en;
const catalog = {
  en,
  bg: {
    'We could not load this item.': 'Не успяхме да заредим този елемент.',
    '{value1} canvas': 'Платно {value1}',
    'Loading {value1}…': 'Зареждане на {value1}…',
    '{value1} · Original retained': '{value1} · Оригиналът е запазен',
    '{value1} {value2}{value3} · Added {value4}': '{value1} {value2}{value3} · Добавено {value4}',
    '{value1} Use in chat': '{value1} Използвай в чата',
    '{value1} Download': '{value1} Изтегляне',
    Table: 'Таблица',
    Chart: 'Диаграма',
    Original: 'Оригинал',
    'Text extracted from the PDF, marked by page. Download the original for its layout and images.':
      'Текстът е извлечен от PDF файла и е обозначен по страници. Изтеглете оригинала, за да видите оформлението и изображенията му.',
    'This preview shows the beginning of the file. Poneva reads the whole file; download the original to see all of it.':
      'Този преглед показва началото на файла. Poneva прочита целия файл; изтеглете оригинала, за да видите всичко.',
    'Preview of the first {value1} complete rows. Filtering and charts use only this preview. Download the original for the full file.':
      'Преглед на първите {value1} пълни реда. Филтрирането и диаграмите използват само този преглед. Изтеглете оригинала за целия файл.',
    'This source link cannot be opened.': 'Тази връзка към източника не може да бъде отворена.',
    'Read-only chat': 'Чат само за четене',
    'Only {value1} writes in this chat. Fork it to continue with your own connections. {value2}':
      'Само {value1} може да пише в този чат. Разклонете го, за да продължите със собствените си връзки. {value2}',
    'Suggest a follow-up…': 'Предложете последващ въпрос…',
    'Suggest a follow-up': 'Предложете последващ въпрос',
    'Sending…': 'Изпращане…',
    Send: 'Изпрати',
    'We could not dismiss that suggestion. Please try again.':
      'Не успяхме да отхвърлим това предложение. Опитайте отново.',
    'Suggested follow-ups': 'Предложени последващи въпроси',
    '{value1} suggests': '{value1} предлага',
    Ask: 'Попитай',
    'Dismiss {value1}’s suggestion': 'Отхвърли предложението на {value1}',
    'Suggested by': 'Предложено от',
    '· edit it or send it': '· редактирайте го или го изпратете',
    'Remove the suggestion tag': 'Премахни етикета за предложение',
    '{value1} {value2} is getting an answer': '{value1} {value2} получава отговор',
    '{value1} {value2} stopped the answer': '{value1} {value2} спря отговора',
    '{value1} Fork from here': '{value1} Разклони оттук',
    '{value1} From {value2}’s {value3}': '{value1} От {value3} на {value2}',
    'Only {value1} can use this account': 'Само {value1} може да използва този акаунт',
    '{value1} Suggested by {value2}': '{value1} Предложено от {value2}',
    'Fork this chat': 'Разклони този чат',
    'Forking…': 'Разклоняване…',
    Fork: 'Разклони',
    'Could not make this private.': 'Не успяхме да го направим частен.',
    'Make this chat private?': 'Да направим ли този чат частен?',
    Close: 'Затвори',
    '{value1} will see “{value2}”. Everyone else loses access right away {value3} .{value4}':
      '{value1} ще вижда „{value2}“. Всички останали незабавно ще загубят достъп {value3} .{value4}',
    Cancel: 'Отказ',
    'Saving…': 'Запазване…',
    'Make private': 'Направи частен',
    'This chat is private again. Forks others made stay theirs.':
      'Този чат отново е частен. Създадените от други разклонения остават техни.',
    'Who can read this chat: {value1}': 'Кой може да чете този чат: {value1}',
    'Move this chat': 'Премести този чат',
    'Only you write here. Others follow live and fork.':
      'Само вие пишете тук. Другите следят на живо и могат да разклоняват.',
    'Made private. {value1} has been told in their Inbox.':
      'Направен е частен. {value1} е уведомен във „Входящи“.',
    'Chat access': 'Достъп до чата',
    '{value1}’s chat. As an admin you can make it private.':
      'Чатът на {value1}. Като администратор можете да го направите частен.',
    'Only {value1} will see it. {value2} is told.':
      'Само {value1} ще го вижда. {value2} е уведомен.',
    '{value1} {value2} following': '{value1} {value2} следят',
    'Forked from{value1} {value2} . The history is copied. From here, tools run with your own access.':
      'Разклонено от{value1} {value2} . Историята е копирана. Оттук нататък инструментите работят с вашия достъп.',
    '{value1} made this chat private': '{value1} направи този чат частен',
    'You can no longer open it. Any fork you made stays yours.':
      'Вече не можете да го отваряте. Всяко създадено от вас разклонение остава ваше.',
    'Start a new chat': 'Започни нов чат',
    'Back to Recent chats': 'Назад към последните чатове',
    'More chat actions': 'Още действия за чата',
    'Close conversation sharing': 'Затвори споделянето на разговора',
    'Review the text before saving a private copy to Library. Then choose its audience. Your original conversation and future messages stay private.':
      'Прегледайте текста, преди да запазите частно копие в Библиотека. След това изберете неговата аудитория. Оригиналният ви разговор и бъдещите съобщения остават частни.',
    'Preparing the conversation…': 'Подготовка на разговора…',
    'Refresh preview': 'Опресни прегледа',
    'The copy is saved in Library. Use Share to choose who can access it.':
      'Копието е запазено в Библиотека. Използвайте „Споделяне“, за да изберете кой има достъп до него.',
    'Save this copy': 'Запази това копие',
    'That Skill could not be opened.': 'Това умение не можа да бъде отворено.',
    '{value1}{value2} · reviews and approvals': '{value1}{value2} · прегледи и одобрения',
    'Open Inbox': 'Отвори „Входящи“',
    'New at {value1} this week': 'Ново в {value1} тази седмица',
    'Nothing new this week. Shared work, published Skills and approved knowledge show up here.':
      'Тази седмица няма нищо ново. Тук се показват споделената работа, публикуваните умения и одобрените знания.',
    'New at {value1}': 'Ново в {value1}',
    'This Skill is unavailable. Try again.': 'Това умение не е налично. Опитайте отново.',
    'You can attach up to {value1} files. Remove an attachment to add another.':
      'Можете да прикачите до {value1} файла. Премахнете прикачен файл, за да добавите друг.',
    'Add company context': 'Добави контекст за компанията',
    'Add company context · @': 'Добави контекст за компанията · @',
    'Choose a Skill': 'Избери умение',
    'Choose a Skill · /': 'Избери умение · /',
    context: 'контекст',
    skills: 'умения',
    'Choose company context': 'Изберете контекст на компанията',
    'Skills for this conversation': 'Умения за този разговор',
    'Bring context into the conversation': 'Добавете контекст към разговора',
    'Close context picker': 'Затворете избора на контекст',
    'Filter company context': 'Филтрирайте контекста на компанията',
    'Find a Skill…': 'Намерете умение…',
    'Find a file…': 'Намерете файл…',
    'Available company context': 'Наличен контекст на компанията',
    'No matching published Skills.': 'Няма съвпадащи публикувани умения.',
    'No matching files.': 'Няма съвпадащи файлове.',
    'Searching company work…': 'Търсене в работата на компанията…',
    'Try search again': 'Опитайте да потърсите отново',
    'Meaning search is temporarily limited. Showing available text matches.':
      'Търсенето по смисъл временно е ограничено. Показват се наличните съвпадения по текст.',
    'Load more matches': 'Заредете още съвпадения',
    '{value1} files attached. Remove an attachment to add another. Saved Skill references are included separately.':
      'Прикачени са {value1} файла. Премахнете прикачен файл, за да добавите друг. Запазените препратки към умения са включени отделно.',
    'Create a Skill in chat': 'Създайте умение в чата',
    'Upload a company file': 'Качете файл на компанията',
    'Company knowledge is always available to Poneva.':
      'Знанията на компанията са винаги достъпни за Poneva.',
    '{value1} was not connected': '{value1} не беше свързан',
    Dismiss: 'Затвори',
    'Try connecting again': 'Опитайте да се свържете отново',
    Waiting: 'Изчакване',
    Connected: 'Свързан',
    'Needs reconnecting': 'Необходимо е повторно свързване',
    Connect: 'Свързване',
    '{value1}{value2} The provider’s account permissions still apply.':
      '{value1}{value2} Разрешенията за акаунта при доставчика продължават да важат.',
    'Last error: {value1}': 'Последна грешка: {value1}',
    '{value1} {value2} ready.': '{value1} {value2} е готов.',
    'Continue with my Meta app': 'Продължете с моето приложение Meta',
    Reconnect: 'Свържете отново',
    Disconnect: 'Прекъснете връзката',
    'Remove attachment: {value1}': 'Премахнете прикачения файл: {value1}',
    'Saved in this Skill. Edit the Skill to change its references.':
      'Запазено в това умение. Редактирайте умението, за да промените препратките му.',
    'Remove Skill context': 'Премахнете контекста на умението',
    Refining: 'Прецизиране',
    Previewing: 'Преглед',
    Using: 'Използване',
    'Skill revision {value1}': 'Версия на умението {value1}',
    'a new Skill': 'ново умение',
    '{value1} Making a new agent {value2}': '{value1} Създаване на нов агент {value2}',
    'Stop making a new agent in this chat': 'Спрете създаването на нов агент в този чат',
    'Saved Skill references': 'Запазени препратки към умения',
    'Included with Skill · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}':
      'Включено с умението · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}',
    'Selected Skill revision is unavailable. Select the Skill again to view its saved references.':
      'Избраната версия на умението не е налична. Изберете умението отново, за да видите запазените му препратки.',
    'Conversation attachments': 'Прикачени файлове към разговора',
    'Added for this conversation': 'Добавено за този разговор',
    'Selected passage {value1}': 'Избран откъс {value1}',
    'We could not load your workspace.': 'Не успяхме да заредим работното ви пространство.',
    'The selected Skill is unavailable. Check its access or choose it again.':
      'Избраното умение не е налично. Проверете достъпа до него или го изберете отново.',
    'Source saved privately and included in your knowledge search.':
      'Източникът е запазен лично и е включен в търсенето на знания.',
    'File saved privately to your library and attached to this message.':
      'Файлът е запазен лично във вашата библиотека и е прикачен към това съобщение.',
    'File saved privately to your library.': 'Файлът е запазен лично във вашата библиотека.',
    '{value1} {value2} earlier {value3} saved{value4}.':
      '{value1} {value2} по-рано {value3} е запазен{value4}.',
    'Extracted text for Poneva to read. Download the original for its layout, charts and images. Spreadsheet formulas show their saved results and are not recalculated.':
      'Извлечен текст за прочитане от Poneva. Изтеглете оригинала за неговото оформление, диаграми и изображения. Формулите в електронната таблица показват запазените си резултати и не се преизчисляват.',
    Esc: 'Esc',
    'Start something': 'Започнете нещо',
    'Choose a file to work with': 'Изберете файл, с който да работите',
    'Skills worth adding': 'Умения, които си струва да добавите',
    'Picked for you': 'Подбрано за вас',
    'Reusable work grounded in your company knowledge.':
      'Работа за многократна употреба, основана на знанията на вашата компания.',
    'Ideas from your company context and recent work. Pick one to start.':
      'Идеи от контекста на компанията и скорошната ви работа. Изберете една, за да започнете.',
    'Refresh suggested tasks': 'Обновете предложените задачи',
    'Check for new company context.': 'Проверете за нов контекст на компанията.',
    'Check for new context. Ideas also refresh daily.':
      'Проверете за нов контекст. Идеите също се обновяват ежедневно.',
    Refresh: 'Обнови',
    'Finding useful starting points…': 'Търсене на полезни отправни точки…',
    'Suggestions aren’t available right now. Try Refresh, or describe the work you want to do.':
      'Предложенията не са налични в момента. Опитайте „Обнови“ или опишете работата, която искате да свършите.',
    'Loading the knowledge pages…': 'Зареждане на страниците със знания…',
    '{value1} All pages': '{value1} Всички страници',
    'The page is created.': 'Страницата е създадена.',
    'Your new page is suggested. A publisher decides whether it is added.':
      'Новата ви страница е предложена. Публикуващият решава дали да я добави.',
    'Company knowledge': 'Знания на компанията',
    'What Poneva knows about your company, page by page. Every change is kept.':
      'Какво знае Poneva за вашата компания, страница по страница. Всяка промяна се запазва.',
    'Loading company knowledge…': 'Зареждане на знанията на компанията…',
    'Knowledge pages are not enabled in this workspace.':
      'Страниците със знания не са активирани в това работно пространство.',
    'Ask your Poneva contact to switch them on for your company.':
      'Помолете вашия контакт в Poneva да ги активира за компанията ви.',
    '{value1} Change the agent': '{value1} Променете агента',
    '{value1} Continue in chat': '{value1} Продължете в чата',
    'Open result: {value1}': 'Отвори резултата: {value1}',
    'Loading more library items…': 'Зареждане на още елементи от библиотеката…',
    'Load more': 'Зареди още',
    'Documents, transcripts, audio and video · Up to 500 MB per file. New files are private. Choose their audience with Share and which processable files become searchable company knowledge.':
      'Документи, транскрипции, аудио и видео · До 500 MB на файл. Новите файлове са частни. Изберете тяхната аудитория чрез „Споделяне“ и кои файлове, подлежащи на обработка, да станат част от знанията на компанията, достъпни за търсене.',
    Skills: 'Умения',
    'Create in chat': 'Създай в чата',
    'Search Skills': 'Търсене на умения',
    'Search finds published Skills. Clear the search to browse your drafts too.':
      'Търсенето намира публикувани умения. Изчистете търсенето, за да преглеждате и черновите си.',
    'Search coverage is limited while indexing or meaning-based search is unavailable.':
      'Обхватът на търсенето е ограничен, докато индексирането или търсенето по смисъл не са достъпни.',
    'Searching Skills…': 'Търсене на умения…',
    'No matching published Skills found. Try a different description.':
      'Не са намерени съответстващи публикувани умения. Опитайте с друго описание.',
    'Load more Skills': 'Зареди още умения',
    'View Skill: {value1}': 'Преглед на умението: {value1}',
    'Company workspace': 'Работно пространство на компанията',
    'View {value1}': 'Преглед на {value1}',
    'Loading Skills…': 'Зареждане на умения…',
    'Try again {value1}': 'Опитайте отново {value1}',
    'Try again': 'Опитайте отново',
    'Nothing yet.': 'Все още няма нищо.',
    'Made from · Used by': 'Създадено от · Използвано от',
    'Could not load links': 'Връзките не можаха да бъдат заредени',
    'Made from': 'Създадено от',
    'Used by': 'Използвано от',
    'About this chat {value1}': 'За този чат {value1}',
    'About this chat': 'За този чат',
    'Keep the work moving.': 'Продължете работата.',
    'Ask a follow-up with this result in view, or turn a useful approach into a company Skill.':
      'Задайте допълнителен въпрос, докато този резултат е пред вас, или превърнете полезния подход в умение на компанията.',
    'Save approach as a Skill': 'Запази подхода като умение',
    'Preview of': 'Визуализация на',
    'Made with': 'Създадено с',
    'Open the draft': 'Отвори черновата',
    'Open Skill': 'Отвори умението',
    'Use in chat': 'Използвай в чата',
    'Finish the draft': 'Завърши черновата',
    'Refine this Skill': 'Прецизирай това умение',
    'Made with a Skill.': 'Създадено с умение.',
    'This workspace could not be loaded just now, so that Skill cannot be opened yet. The result itself is unchanged.':
      'Това работно пространство не можа да бъде заредено в момента, затова умението все още не може да бъде отворено. Самият резултат не е променен.',
    'That Skill is not available in this workspace, so it cannot be opened or used again. The result itself is unchanged.':
      'Това умение не е налично в това работно пространство, затова не може да бъде отворено или използвано отново. Самият резултат не е променен.',
    'Result · {value1} {value2}': 'Резултат · {value1} {value2}',
    '{value1} Copy link': '{value1} Копирай връзката',
    'Result link copied.': 'Връзката към резултата е копирана.',
    'Could not copy the link. Use your browser address bar.':
      'Връзката не можа да бъде копирана. Използвайте адресната лента на браузъра.',
    'No preview is available for this result.': 'Няма налична визуализация за този резултат.',
    '{value1} rows are retained in this snapshot. Open Table to inspect the values.':
      'В тази снимка са запазени {value1} реда. Отворете „Таблица“, за да прегледате стойностите.',
    'People can’t edit a Result an agent keeps up to date; the next refresh would replace their edit. Change the agent’s instructions instead.':
      'Хората не могат да редактират резултат, който агент поддържа актуален; при следващото обновяване редакцията им ще бъде заменена. Вместо това променете инструкциите на агента.',
    'Linked sources': 'Свързани източници',
    'Saved source': 'Запазен източник',
    'No source documents are linked to this result. Company knowledge and other references may be cited in the answer.':
      'Към този резултат няма свързани изходни документи. В отговора може да бъдат цитирани знания на компанията и други източници.',
    'Run details': 'Подробности за изпълнението',
    Created: 'Създадено',
    ', revised {value1}': ', редактирано {value1}',
    Conversation: 'Разговор',
    'Not recorded': 'Не е записано',
    'Open conversation': 'Отвори разговора',
    Run: 'Изпълнение',
    Updates: 'Актуализации',
    'Kept up to date by {value1}': 'Поддържано актуално от {value1}',
    'Version {value1}': 'Версия {value1}',
    'Could not open this request.': 'Тази заявка не можа да бъде отворена.',
    'Approved version published.': 'Одобрената версия е публикувана.',
    'Request rejected. The item stays unchanged.':
      'Заявката е отхвърлена. Елементът остава непроменен.',
    'Could not save the decision.': 'Решението не можа да бъде запазено.',
    'Proposed company change': 'Предложена промяна за компанията',
    'Opening…': 'Отваряне…',
    'Approve this version': 'Одобри тази версия',
    Decline: 'Отхвърли',
    'Review the submitted version below. Changes made since submission will need a new request.':
      'Прегледайте изпратената по-долу версия. За промените, направени след изпращането, ще е необходима нова заявка.',
    'The version submitted with this request.': 'Версията, изпратена с тази заявка.',
    'Version and proposed change': 'Версия и предложена промяна',
    'Could not read the pinned content.': 'Закаченото съдържание не можа да бъде прочетено.',
    'Showing a page of {value1} characters.': 'Показва се страница с {value1} знака.',
    'Beginning of the submitted content. Open the full text to review every page.':
      'Начало на изпратеното съдържание. Отворете пълния текст, за да прегледате всяка страница.',
    'Read full submitted text': 'Прочети целия изпратен текст',
    'Previous page': 'Предишна страница',
    'Next page': 'Следваща страница',
    'Made private. Its creator has been told in their Inbox.':
      'Направено е частно. Създателят му е уведомен във входящата си поща.',
    'Made private. Its creator could not be notified.':
      'Направено е частно. Създателят му не можа да бъде уведомен.',
    'Make this {value1} private?': 'Да направим ли {value1} частно?',
    'Only the person who created it will see it. Everyone else loses access right away, and its creator gets an Inbox update if they are still a company member. If they have left, nobody in the company will be able to access this item.':
      'Само човекът, който го е създал, ще го вижда. Всички останали незабавно ще загубят достъп, а създателят му ще получи актуализация във входящата си поща, ако все още е член на компанията. Ако е напуснал, никой в компанията няма да има достъп до този елемент.',
    'Sent for review. The current audience stays unchanged until approval.':
      'Изпратено за преглед. Текущата аудитория остава непроменена до одобрението.',
    Edit: 'Редактиране',
    '{value1} Edit with chat': '{value1} Редактиране с чат',
    '{value1} Duplicate to my Library': '{value1} Дублиране в моята библиотека',
    'Duplicated to your Library. Only you can see the copy.':
      'Дублирано във вашата библиотека. Само вие можете да виждате копието.',
    'Could not duplicate this Result. Try again.':
      'Този резултат не може да бъде дублиран. Опитайте отново.',
    'Saved version {value1}.': 'Версията {value1} е запазена.',
    'A newer version was saved. Reload the Result before saving.':
      'Запазена е по-нова версия. Презаредете резултата, преди да го запазите.',
    'Could not save this version. Try again.':
      'Тази версия не може да бъде запазена. Опитайте отново.',
    '{value1} saved a newer version. Review it before saving.':
      '{value1} запази по-нова версия. Прегледайте я, преди да я запазите.',
    'Hide their version': 'Скриване на тяхната версия',
    'Show their version': 'Показване на тяхната версия',
    'Start from their version': 'Започване от тяхната версия',
    Markdown: 'Markdown',
    'Result text': 'Текст на резултата',
    Preview: 'Преглед',
    'What changed': 'Какво се промени',
    'What changed? (optional)': 'Какво се промени? (по избор)',
    'Save version {value1}': 'Запазване на версия {value1}',
    'Open chat': 'Отваряне на чата',
    Current: 'Текуща',
    Restore: 'Възстановяване',
    'Could not load the history.': 'Историята не може да бъде заредена.',
    'Restored version {value1} as version {value2}.':
      'Версия {value1} е възстановена като версия {value2}.',
    'Someone saved a newer version. Review it before restoring.':
      'Някой е запазил по-нова версия. Прегледайте я, преди да възстановите.',
    'Could not restore that version.': 'Тази версия не може да бъде възстановена.',
    'Loading history…': 'Зареждане на историята…',
    'Restoring keeps what is there now as a version too, so nothing is lost.':
      'При възстановяване текущото съдържание също се запазва като версия, така че нищо не се губи.',
    'This Result was made with your own {value1}.':
      'Този резултат е създаден с вашия личен {value1}.',
    'It also used': 'Използва също',
    'This Result was made with': 'Този резултат е създаден с',
    'Colleagues can read what came from them, but can never use them.':
      'Колегите могат да прочетат съдържанието, получено от тях, но никога не могат да го използват.',
    'Your personal agent {value1} keeps it up to date with your own access, so every refresh can carry your private data.':
      'Вашият личен агент {value1} го поддържа актуален с вашия достъп, така че всяко обновяване може да съдържа личните ви данни.',
    'A colleague’s personal agent keeps it up to date with their own access, so every refresh can carry their private data.':
      'Личният агент на колега го поддържа актуален с неговия достъп, така че всяко обновяване може да съдържа личните му данни.',
    'Made private. Only you can see this meeting.':
      'Направено е лично. Само вие можете да виждате тази среща.',
    'Could not make this meeting private.': 'Тази среща не може да бъде направена лична.',
    'Meeting · {value1} {value2} · Original retained':
      'Среща · {value1} {value2} · Оригиналът е запазен',
    'The recording could not be opened.': 'Записът не може да бъде отворен.',
    'Ask about this suggestion': 'Попитайте за това предложение',
    meeting_processing_failed: 'обработката на срещата не бе успешна',
    'Who can see this': 'Кой може да вижда това',
    'Everyone at {value1}': 'Всички в {value1}',
    'Only me': 'Само аз',
    'Everyone at {value1} can find it and ask about it.':
      'Всеки в {value1} може да го намери и да задава въпроси за него.',
    'Only you can open and search this meeting. You can share it later.':
      'Само вие можете да отваряте и търсите в тази среща. Можете да я споделите по-късно.',
    'Added. Only you can see it. Transcription is running in the background.':
      'Добавено. Само вие можете да го виждате. Транскрипцията се извършва във фонов режим.',
    'Visible to everyone at {value1}': 'Видимо за всички в {value1}',
    'Could not make it private.': 'Не може да бъде направено лично.',
    'Show more meetings': 'Показване на още срещи',
    'Attached to this message': 'Прикачено към това съобщение',
    'Connect securely, choose the tables to share, then decide whether Poneva can read or make changes.':
      'Свържете се сигурно, изберете таблиците за споделяне и определете дали Poneva може да ги чете или променя.',
    'Review the tables this connection can access. Select at least one table.':
      'Прегледайте таблиците, до които тази връзка има достъп. Изберете поне една таблица.',
    'Select at least one table. Nothing is selected by default.':
      'Изберете поне една таблица. По подразбиране не е избрана нито една.',
    'Choose who can use this connection and what Poneva can do.':
      'Изберете кой може да използва тази връзка и какво може да прави Poneva.',
    'Your chosen access is enabled for the selected tables.':
      'Избраният от вас достъп е активиран за избраните таблици.',
    'Your connection is saved with reading paused until permission is confirmed.':
      'Връзката ви е запазена, като четенето е поставено на пауза до потвърждаване на разрешението.',
    'Confirm database disconnect': 'Потвърждаване на прекъсването на връзката с базата данни',
    'Disconnect this database?': 'Да се прекъсне ли връзката с тази база данни?',
    'Access will stop for everyone using this connection.':
      'Достъпът ще бъде спрян за всички, които използват тази връзка.',
    'Keep connection': 'Запазване на връзката',
    'What it can reach · {value1}{value2} {value3}':
      'До какво има достъп · {value1}{value2} {value3}',
    Back: 'Назад',
    Continue: 'Продължаване',
    'Uploading…': 'Качване…',
    Library: 'Библиотека',
    'Source material for your work. Available whenever you need it.':
      'Изходни материали за работата ви. Достъпни винаги, когато са ви нужни.',
    'The work you want to keep, with its sources and conversation attached.':
      'Работата, която искате да запазите, с прикачените източници и разговор.',
    Results: 'Резултати',
    Files: 'Файлове',
    Artifacts: 'Артефакти',
    'Search library': 'Търсене в библиотеката',
    'Find files by meaning…': 'Намиране на файлове по смисъл…',
    'Find saved work by meaning…': 'Намиране на запазена работа по смисъл…',
    'Search coverage is limited while indexing or meaning-based search is unavailable. You can retry or browse recent items.':
      'Обхватът на търсенето е ограничен, докато се извършва индексиране или търсенето по смисъл не е достъпно. Можете да опитате отново или да прегледате последните елементи.',
    'No matching work found.': 'Не е намерена съответстваща работа.',
    'A starting point for your next question.': 'Начална точка за следващия ви въпрос.',
    'Good work is worth keeping.': 'Добрата работа си заслужава да бъде запазена.',
    'Try a different description or clear the search to browse.':
      'Опитайте с друго описание или изчистете търсенето, за да прегледате съдържанието.',
    'Upload source material once and use it in conversations and Skills. Your original stays in the library.':
      'Качете изходния материал веднъж и го използвайте в разговори и умения. Оригиналът ви остава в библиотеката.',
    'Ask Poneva to save an answer, table or chart. Results stay connected to the conversation and their sources.':
      'Помолете Poneva да запази отговор, таблица или диаграма. Резултатите остават свързани с разговора и източниците си.',
    'Start in chat {value1}': 'Начало в чат {value1}',
    'This suggestion is no longer available to you.': 'Това предложение вече не е достъпно за вас.',
    'We could not check where this suggestion stands.':
      'Не успяхме да проверим състоянието на това предложение.',
    'Check again': 'Провери отново',
    'Show on page': 'Покажи на страницата',
    'The editor could not be loaded. Poneva may have been updated since you opened this page. Reload to get the latest version; nothing on this page has changed.':
      'Редакторът не можа да бъде зареден. Възможно е Poneva да е актуализирана, откакто сте отворили тази страница. Презаредете, за да получите най-новата версия; нищо на тази страница не се е променило.',
    'Reload Poneva': 'Презареди Poneva',
    Formatting: 'Форматиране',
    'Text style': 'Стил на текста',
    Text: 'Текст',
    Heading: 'Заглавие',
    Subheading: 'Подзаглавие',
    'Link a page': 'Връзка към страница',
    'A page needs a title.': 'Страницата трябва да има заглавие.',
    'Nothing has changed yet.': 'Все още няма промени.',
    'A page needs some text. To remove a page, archive it instead.':
      'Страницата трябва да съдържа текст. За да премахнете страница, архивирайте я.',
    'A suggested new page needs some text.': 'Предложената нова страница трябва да съдържа текст.',
    'This page is larger than 256 KB. Split it into smaller pages.':
      'Тази страница е по-голяма от 256 KB. Разделете я на по-малки страници.',
    'Say in a few words why this change is right.':
      'Обяснете накратко защо тази промяна е правилна.',
    'This page changed while you were editing. Your text is still here: copy it, then open the latest version and make your change again.':
      'Тази страница се промени, докато я редактирахте. Текстът ви все още е тук: копирайте го, след това отворете най-новата версия и направете промяната отново.',
    'Your text is copied.': 'Текстът ви е копиран.',
    'Your text could not be copied. Select it in the editor and copy it.':
      'Текстът ви не можа да бъде копиран. Изберете го в редактора и го копирайте.',
    'The page “{value1}” is created.': 'Страницата „{value1}“ е създадена.',
    'New page': 'Нова страница',
    'Editing {value1}': 'Редактиране на {value1}',
    Editing: 'Редактиране',
    'Creating publishes the page under {value1} for everyone':
      'Създаването публикува страницата под {value1} за всички',
    'Saving publishes the new version for everyone':
      'Запазването публикува новата версия за всички',
    'Your changes are sent as a suggestion for a publisher':
      'Промените ви са изпратени като предложение до издател',
    'Create page': 'Създай страница',
    Save: 'Запази',
    'Send suggestion': 'Изпрати предложение',
    '{value1} Copy my text': '{value1} Копирай текста ми',
    'Open the latest version': 'Отвори най-новата версия',
    'Page title': 'Заглавие на страницата',
    'Loading the editor…': 'Редакторът се зарежда…',
    'New page text': 'Текст на новата страница',
    'Text of {value1}': 'Текст на {value1}',
    'Write the page. Type [[ to link another page.':
      'Напишете текста на страницата. Въведете [[, за да добавите връзка към друга страница.',
    'Type [[ to link another page.': 'Въведете [[, за да добавите връзка към друга страница.',
    'Link to a page': 'Връзка към страница',
    'What changed, in a few words': 'Какво се промени, накратко',
    'Where this comes from, in a few words': 'Откъде идва това, накратко',
    'Shown in the page history.': 'Показва се в историята на страницата.',
    'A publisher sees this next to your change.': 'Издателят вижда това до промяната ви.',
    '1 suggestion is open on this page': '1 предложение е отворено на тази страница',
    '{value1} suggestions are open on this page':
      '{value1} предложения са отворени на тази страница',
    'They stay open while you edit. After you save, they show against your new text; one whose words you changed is marked outdated.':
      'Те остават отворени, докато редактирате. След като запазите, ще се показват спрямо новия ви текст; предложението, чиито думи сте променили, се маркира като остаряло.',
    'Type [[ to link another page. Links keep working when a page is renamed or moved.':
      'Въведете [[, за да добавите връзка към друга страница. Връзките продължават да работят, когато страницата бъде преименувана или преместена.',
    'Loading the history…': 'Историята се зарежда…',
    'This page has no saved text yet.': 'Тази страница все още няма запазен текст.',
    'Say in a few words why this revision should come back.':
      'Обяснете накратко защо тази редакция трябва да бъде възстановена.',
    'Revision {value1} is suggested for a publisher to accept.':
      'Редакция {value1} е предложена за приемане от издател.',
    'The page already reads like this revision.': 'Страницата вече изглежда като тази редакция.',
    'Revision {value1} is restored as revision {value2}.':
      'Редакция {value1} е възстановена като редакция {value2}.',
    'Revision history': 'История на редакциите',
    Revisions: 'Редакции',
    'Every saved revision is kept.': 'Всяка запазена редакция се съхранява.',
    'Revision {value1} {value2}': 'Редакция {value1} {value2}',
    'Revision {value1} compared with revision {value2}':
      'Редакция {value1} в сравнение с редакция {value2}',
    'Revision {value1}, the first text of this page':
      'Редакция {value1}, първият текст на тази страница',
    'Green was added, struck through was removed.':
      'Зеленото е добавено, а зачертаното е премахнато.',
    '{value1} Export Markdown': '{value1} Експортирай Markdown',
    'Restore this revision': 'Възстанови тази редакция',
    'Suggest restoring it': 'Предложи възстановяването ѝ',
    'Why should this revision come back?': 'Защо тази редакция трябва да бъде възстановена?',
    'Loading this revision…': 'Тази редакция се зарежда…',
    'Only the title changed, from “{value1}” to “{value2}”.':
      'Промени се само заглавието — от „{value1}“ на „{value2}“.',
    'The text did not change in this revision.': 'Текстът не се е променил в тази редакция.',
    'Changes in revision {value1}': 'Промени в редакция {value1}',
    'Loading page…': 'Страницата се зарежда…',
    'Loading suggestion…': 'Предложението се зарежда…',
    'This suggestion is not available.': 'Това предложение не е налично.',
    'It may have been decided, or it is not one you can see.':
      'Възможно е по него вече да е взето решение или да не е достъпно за вас.',
    'Open Knowledge': 'Отвори Knowledge',
    'Opening the suggestion…': 'Предложението се отваря…',
    'Choose where the page goes.': 'Изберете къде да бъде страницата.',
    'Say in a few words why.': 'Обяснете накратко защо.',
    'Your suggestion is sent. A publisher decides.':
      'Предложението ви е изпратено. Издателят взема решение.',
    'Moved under {value1}.': 'Преместено под {value1}.',
    'Deleted “{value1}”.': '„{value1}“ е изтрито.',
    'Archived. Its history is kept.': 'Архивирано. Историята му е запазена.',
    'Choose the page it goes under. Links to it keep working.':
      'Изберете страницата, под която да бъде. Връзките към нея ще продължат да работят.',
    'Its text, its history and any open suggestions are removed for good, and links to it from other pages stop working. This cannot be undone.':
      'Текстът, историята и всички отворени предложения се изтриват окончателно, а връзките към нея от други страници спират да работят. Това действие не може да бъде отменено.',
    'An archived page no longer informs answers. Its history is kept, and a publisher can restore it or delete it permanently.':
      'Архивираната страница вече не се използва за отговори. Историята ѝ е запазена и издател може да я възстанови или изтрие окончателно.',
    Under: 'Под',
    Change: 'Промяна',
    'Move under': 'Премести под',
    'Search pages': 'Търсене на страници',
    'Why?': 'Защо?',
    'Delete permanently': 'Изтрий окончателно',
    'Move page': 'Премести страницата',
    'Archive page': 'Архивирай страницата',
    'Suggestion {value1}: show its card': 'Предложение {value1}: покажи картата му',
    'Removed:': 'Премахнато:',
    'Added:': 'Добавено:',
    'New page “{value1}”{value2}': 'Нова страница „{value1}“{value2}',
    'No pages match “{value1}”.': 'Няма страници, съответстващи на „{value1}“.',
    'Where this page is': 'Къде се намира тази страница',
    'Describe your company': 'Опишете компанията си',
    'Empty page': 'Празна страница',
    'Describe {value1}': 'Опишете {value1}',
    'This page has no text yet.': 'Тази страница все още няма текст.',
    'Poneva reads this page before every answer. Start with who you are, what you sell and how you work; details go on the pages under it.':
      'Poneva прочита тази страница преди всеки отговор. Започнете с това кои сте, какво продавате и как работите; подробностите добавете на страниците под нея.',
    'Write it, or ask Poneva in chat to draft it for you.':
      'Напишете го или помолете Poneva в чата да го състави вместо вас.',
    'Suggest a first version, and a publisher decides whether it becomes the page.':
      'Предложете първа версия, а издател ще реши дали тя да стане страница.',
    'Start writing': 'Започнете да пишете',
    'Suggest a first version': 'Предложете първа версия',
    'Accepted. The page is archived.': 'Прието. Страницата е архивирана.',
    'Accepted. The page is now revision {value1}.': 'Прието. Страницата вече е редакция {value1}.',
    'Accepted.': 'Прието.',
    'Suggestion rejected. The page stays as it is.':
      'Предложението е отхвърлено. Страницата остава непроменена.',
    'Your suggestion is withdrawn.': 'Предложението ви е оттеглено.',
    'Restored. The page informs answers again.':
      'Възстановено. Страницата отново се използва за отговори.',
    'Your suggestion is sent. A publisher decides whether it becomes the page.':
      'Предложението ви е изпратено. Издател ще реши дали то да стане страница.',
    'Saved. The page is now revision {value1}.': 'Запазено. Страницата вече е редакция {value1}.',
    'Nothing changed.': 'Няма промяна.',
    'This page is not available.': 'Тази страница не е налична.',
    'It may have been deleted, archived or moved out of reach, or you may no longer be in this company.':
      'Възможно е да е изтрита, архивирана или преместена извън достъпа ви, или вече да не сте част от тази компания.',
    'Page actions': 'Действия за страницата',
    shown: 'показани',
    hidden: 'скрити',
    '{value1} History': 'История на {value1}',
    '{value1} Ask in chat': 'Попитай за {value1} в чата',
    'Suggest edits': 'Предложи редакции',
    'More actions for {value1}': 'Още действия за {value1}',
    '{value1} Poneva reads this page in every chat':
      '{value1} Poneva прочита тази страница във всеки чат',
    'This page is archived. It no longer informs answers; its history is kept. {value1}':
      'Тази страница е архивирана. Тя вече не се използва за отговори; историята ѝ е запазена. {value1}',
    'Restore page': 'Възстанови страницата',
    'This link points to an earlier revision. You are reading the current text.':
      'Тази връзка води към по-стара редакция. В момента четете актуалния текст.',
    'Show it in History': 'Покажи я в „История“',
    Pages: 'Страници',
    'Pages under {value1}': 'Страници под {value1}',
    'Linked from': 'Връзки от',
    Suggestions: 'Предложения',
    'Suggestions are hidden. You are reading the page as everyone else sees it.':
      'Предложенията са скрити. Четете страницата така, както я виждат всички останали.',
    'Loading suggestions…': 'Зареждане на предложения…',
    'Nothing is waiting for review.': 'Няма нищо, което да очаква преглед.',
    'When someone, Poneva in a chat or a connected agent suggests a change to a page, it shows here and on the page. Nothing changes until a publisher accepts it.':
      'Когато някой, Poneva в чат или свързан агент предложи промяна по страница, тя се показва тук и на самата страница. Нищо не се променя, докато издател не я приеме.',
    '{value1} Review knowledge in chat': '{value1} Прегледай знанията в чата',
    'Suggestions for review': 'Предложения за преглед',
    'Suggested changes from chats, meetings, colleagues and connected agents. Nothing changes until a publisher accepts it on the page.':
      'Предложени промени от чатове, срещи, колеги и свързани агенти. Нищо не се променя, докато издател не ги приеме на страницата.',
    'Your suggestions wait here until a publisher decides. The pages stay as they are until then.':
      'Предложенията ви ще изчакат тук, докато издател вземе решение. Дотогава страниците остават непроменени.',
    'Review page': 'Прегледай страницата',
    'Review on page': 'Прегледай на страницата',
    'Open the meeting': 'Отвори срещата',
    'Open the chat': 'Отвори чата',
    'Accept and restore': 'Приеми и възстанови',
    Accept: 'Приеми',
    Reject: 'Отхвърли',
    'Your suggestion · waiting for a publisher': 'Вашето предложение · изчаква издател',
    Withdraw: 'Оттегли',
    'Waiting for a publisher': 'Изчаква издател',
    'Suggestion {value1}': 'Предложение {value1}',
    'Suggestion {value1} from {value2}{value3}': 'Предложение {value1} от {value2}{value3}',
    'Read the suggested page': 'Прочети предложената страница',
    'Outdated: the text it changes was edited after it was suggested. It can be rejected or withdrawn; a new suggestion can be made against the current text.':
      'Неактуално: текстът, който променя, е редактиран след създаването на предложението. То може да бъде отхвърлено или оттеглено; за актуалния текст може да се направи ново предложение.',
    'Restore this page first to accept this suggestion.':
      'Първо възстановете тази страница, за да приемете предложението.',
    'Previous suggestion': 'Предишно предложение',
    'Could not update sharing.': 'Споделянето не може да бъде актуализирано.',
    'They can follow new answers live and fork it to continue with their own connections. Only you write here. You can make it private again at any time.':
      'Те могат да следят новите отговори на живо и да го разклонят, за да продължат със собствените си връзки. Само вие можете да пишете тук. Можете отново да го направите частно по всяко време.',
    'They see the project, its brief and the work in it they can already open. Nothing in it opens for anyone because of the project; each item keeps its own access.':
      'Те виждат проекта, краткото му описание и работата в него, до която вече имат достъп. Нищо в него не става достъпно за никого само заради проекта; всеки елемент запазва собствения си достъп.',
    'Check the content for private information before sharing. Sharing an item does not grant access to its original chat or private connections.':
      'Проверете съдържанието за лична информация, преди да го споделите. Споделянето на елемент не предоставя достъп до първоначалния му чат или до частните връзки.',
    '{value1} Everyone you share with can read it, including what the assistant or an App in it found in your {value2}. They can’t use your {value3}. Nothing changes for you: the chat keeps working with all your accounts.':
      '{value1} Всеки, с когото го споделите, може да го прочете, включително това, което асистентът или приложение в него е открило във вашия {value2}. Те не могат да използват вашия {value3}. За вас нищо не се променя: чатът продължава да работи с всичките ви акаунти.',
    '{value1} Everyone you share with can read them, but nobody can use {value2} through this chat.':
      '{value1} Всеки, с когото ги споделите, може да ги прочете, но никой не може да използва {value2} чрез този чат.',
    'This controls access to the working draft. Any published company version stays available until you explicitly unpublish it. To publish a new version, complete its preview and use Save Skill. Run results stay private.':
      'Това управлява достъпа до работната чернова. Всяка публикувана фирмена версия остава достъпна, докато изрично не я спрете от публикуване. За да публикувате нова версия, завършете визуализацията ѝ и изберете „Запазване на умението“. Резултатите от изпълненията остават частни.',
    'Skill deleted. You can restore it from the Skills archive for 30 days.':
      'Умението е изтрито. Можете да го възстановите от архива на уменията в продължение на 30 дни.',
    'Could not delete this Skill.': 'Това умение не може да бъде изтрито.',
    'More actions': 'Още действия',
    'Delete “{value1}”? It will disappear from Skills and search, and cannot be used by agents. You can restore it for 30 days. Existing chats and results stay available.':
      'Да се изтрие ли „{value1}“? То ще изчезне от уменията и търсенето и няма да може да се използва от агентите. Можете да го възстановите в продължение на 30 дни. Съществуващите чатове и резултати ще останат достъпни.',
    'Deleting…': 'Изтриване…',
    'Confirm delete': 'Потвърждаване на изтриването',
    'Delete Skill': 'Изтриване на умението',
    'Skill restored as an unpublished draft. Its author can review and publish it again.':
      'Умението е възстановено като непубликувана чернова. Авторът му може да го прегледа и публикува отново.',
    'Could not restore this Skill.': 'Това умение не може да бъде възстановено.',
    'Archived Skills': 'Архивирани умения',
    'Deleted Skills can be restored for 30 days. Restoring leaves them unpublished.':
      'Изтритите умения могат да бъдат възстановени в продължение на 30 дни. При възстановяване те остават непубликувани.',
    'Restore until {value1}': 'Възстановяване до {value1}',
    'Loading…': 'Зареждане…',
    'No archived Skills.': 'Няма архивирани умения.',
    'Load more archived Skills': 'Зареждане на още архивирани умения',
    'Show more of the original': 'Показване на още от оригинала',
    'Filter result rows': 'Филтриране на редовете с резултати',
    'Find a product or value…': 'Намиране на продукт или стойност…',
    '{value1} of {value2}': '{value1} от {value2}',
    'Result table': 'Таблица с резултати',
    'No matching rows.': 'Няма съвпадащи редове.',
    'Showing the first 1,000 matching rows. Download the CSV for every row.':
      'Показват се първите 1 000 съвпадащи реда. Изтеглете CSV файла за всички редове.',
    'Agent ·': 'Агент ·',
    'Only you': 'Само вие',
    'Stopped before it finished.': 'Спряно преди завършване.',
    'Drafting the project…': 'Създаване на чернова на проекта…',
    'Checking where this chat belongs…': 'Проверка къде принадлежи този чат…',
    'Moving the chat…': 'Преместване на чата…',
    'Taking it out of the project…': 'Премахване от проекта…',
    'Adding it to the project…': 'Добавяне към проекта…',
    'No matching connections are available right now.': 'В момента няма налични съвпадащи връзки.',
    'Company knowledge suggestion': 'Предложение за фирмени знания',
    'Company knowledge now lives on pages. Open Knowledge to see them.':
      'Фирмените знания вече се намират на страници. Отворете „Знания“, за да ги видите.',
    '{value1} · Open beside this conversation': '{value1} · Отваряне до този разговор',
    'Name {value1}': 'Име {value1}',
    'Host {value1}': 'Хост {value1}',
    'Port {value1}': 'Порт {value1}',
    'Database {value1}': 'База данни {value1}',
    'Username {value1}': 'Потребителско име {value1}',
    'Password {value1}': 'Парола {value1}',
    'Advanced TLS': 'Разширени настройки за TLS',
    '{value1} Poneva verifies the server certificate. Add a CA or server DNS name for IP hosts when your certificate requires it.':
      '{value1} Poneva проверява сертификата на сървъра. Добавете CA или DNS име на сървъра за IP хостове, когато сертификатът ви го изисква.',
    'CA certificate {value1}': 'CA сертификат {value1}',
    'Certificate server DNS name {value1}': 'DNS име на сървъра в сертификата {value1}',
    '{value1} Your password is encrypted in secure storage. Poneva verifies the connection before saving it.':
      '{value1} Паролата ви е шифрована в защитено хранилище. Poneva проверява връзката, преди да я запази.',
    'Testing…': 'Тестване…',
    'Test connection': 'Тестване на връзката',
    'PostgreSQL is connected.': 'Връзката с PostgreSQL е установена.',
    'PostgreSQL was saved safely.': 'PostgreSQL беше запазен безопасно.',
    'Poneva can read and change rows in the selected tables. Apps also follow their approved data scope.':
      'Poneva може да чете и променя редове в избраните таблици. Приложенията също спазват одобрения обхват на данните си.',
    'Poneva can read the selected tables. Apps also follow their approved data scope.':
      'Poneva може да чете избраните таблици. Приложенията също спазват одобрения обхват на данните си.',
    'Reads are paused until permission is enabled.':
      'Четенето е поставено на пауза, докато не бъде разрешено.',
    'Retrying…': 'Повторен опит…',
    'Retry permission': 'Повторен опит за разрешаване',
    'Try it in Chat': 'Изпробване в чата',
    Done: 'Готово',
    'Disconnect database': 'Прекъсване на връзката с базата данни',
    '{value1} TLS verified ·{value2} {value3}': '{value1} TLS е потвърден ·{value2} {value3}',
    'Search schemas and tables': 'Търсене в схеми и таблици',
    'Search tables': 'Търсене в таблици',
    '{value1} of {value2} tables selected': 'Избрани са {value1} от {value2} таблици',
    'Select matching tables': 'Избиране на съвпадащите таблици',
    'Select all tables': 'Избиране на всички таблици',
    Clear: 'Изчистване',
    'Select a whole schema or individual tables. New tables need a fresh selection.':
      'Изберете цяла схема или отделни таблици. За новите таблици е необходим нов избор.',
    'No tables match this search.': 'Няма таблици, съвпадащи с това търсене.',
    'All tables in {value1}': 'Всички таблици в {value1}',
    '{value1} / {value2} tables': '{value1} / {value2} таблици',
    'Read & write available': 'Налично четене и запис',
    'Read only': 'Само за четене',
    Ctrl: 'Ctrl',
    'This suggested knowledge update could not be shown.':
      'Това предложено обновяване на знанията не може да бъде показано.',
    'Suggested knowledge update': 'Предложено обновяване на знанията',
    'Enable this schedule when approved': 'Активирайте този график при одобрение',
    Schedule: 'График',
    'Kept off until you create the agent from its canvas.':
      'Остава изключен, докато не създадете агента от неговото платно.',
    'Will be enabled when you approve.': 'Ще бъде активиран, когато го одобрите.',
    'Will be saved paused. You can enable it later.':
      'Ще бъде запазен на пауза. Можете да го активирате по-късно.',
    'Only runs when you ask.': 'Изпълнява се само когато поискате.',
    'Draft · approving saves it, and nothing runs. Test it and create it from its canvas.':
      'Чернова · одобрението я запазва и нищо не се изпълнява. Тествайте я и я създайте от нейното платно.',
    'Draft · nothing is scheduled until you approve. Connected actions require their own approval at run time.':
      'Чернова · нищо не е планирано, докато не одобрите. Свързаните действия изискват собствено одобрение при изпълнение.',
    Name: 'Име',
    'Agent name': 'Име на агента',
    'Who can use it': 'Кой може да го използва',
    'Company agent · company resources only': 'Фирмен агент · само фирмени ресурси',
    'Personal agent · runs with your access': 'Личен агент · изпълнява се с вашия достъп',
    'Approving saves it as a draft. It does not run automatically.':
      'Одобрението го запазва като чернова. Той не се изпълнява автоматично.',
    'Open the agent’s runs': 'Отваряне на изпълненията на агента',
    'Run the published version once': 'Еднократно изпълнение на публикуваната версия',
    'Stopping…': 'Спиране…',
    'Stop run': 'Спиране на изпълнението',
    'Could not stop this run. Please try again.':
      'Това изпълнение не можа да бъде спряно. Опитайте отново.',
    'Run in progress': 'Изпълнението е в ход',
    'This run is still answering. You can ask follow-ups when it finishes.':
      'Това изпълнение все още отговаря. Можете да зададете допълнителни въпроси, когато приключи.',
    'Open run details': 'Отваряне на подробностите за изпълнението',
    Runs: 'Изпълнения',
    'Open the run chat': 'Отваряне на чата за изпълнението',
    Watch: 'Наблюдение',
    Goal: 'Цел',
    'Change the goal': 'Промяна на целта',
    'What it does': 'Какво прави',
    'What should this agent achieve?': 'Какво трябва да постигне този агент?',
    'Not set yet.': 'Все още не е зададено.',
    'When it runs': 'Кога се изпълнява',
    'Change when it runs': 'Промяна на времето за изпълнение',
    'Off means it runs only when someone runs it. Changing when it runs never changes its instructions.':
      'Изключено означава, че се изпълнява само когато някой го стартира. Промяната на времето за изпълнение никога не променя инструкциите му.',
    Instructions: 'Инструкции',
    'Change the instructions': 'Промяна на инструкциите',
    'How the agent should approach the work and make decisions.':
      'Как агентът трябва да подхожда към работата и да взема решения.',
    Boundaries: 'Ограничения',
    'What to do or avoid. Every connected action still follows its approval.':
      'Какво да прави или да избягва. Всяко свързано действие все още следва собственото си одобрение.',
    'No instructions of its own. It follows its Skills.':
      'Няма собствени инструкции. Следва своите умения.',
    'Pin a Skill': 'Закачане на умение',
    'Finds the Skills that fit each run, the same way a chat does.':
      'Намира уменията, подходящи за всяко изпълнение, по същия начин като чат.',
    'Skills it always follows': 'Умения, които винаги следва',
    'A Skill that is not published': 'Умение, което не е публикувано',
    'Always follows · Version {value1}': 'Винаги следва · Версия {value1}',
    'Not published': 'Непубликувано',
    Uses: 'Използва',
    'Change in chat': 'Промяна в чата',
    'Change in chat: Uses': 'Промяна в чата: Използва',
    'Company knowledge and the tools each run is allowed to use.':
      'Фирмените знания и инструментите, които всяко изпълнение има право да използва.',
    'People see the Result refresh; they change the agent, not the page.':
      'Хората виждат обновяването на резултата; те променят агента, а не страницата.',
    'The first run after it is created makes the Result; later runs add a version to it.':
      'Първото изпълнение след създаването му създава резултата; следващите изпълнения добавят версия към него.',
    'Emails whoever the run is for': 'Изпраща имейл до получателя на изпълнението',
    'Email each run': 'Изпращане на имейл при всяко изпълнение',
    Delivers: 'Предоставя',
    'Change what it delivers': 'Промяна на предоставяното съдържание',
    'Expected result': 'Очакван резултат',
    'What a successful run should deliver.': 'Какво трябва да предостави успешно изпълнение.',
    'What each run delivers': 'Какво предоставя всяко изпълнение',
    'Keeps one Result up to date {value1}': 'Поддържа един резултат актуален {value1}',
    'Saves a new Result each run': 'Запазва нов резултат при всяко изпълнение',
    'You can run this company agent as yourself.{value1} {value2}':
      'Можете да изпълнявате този фирмен агент като себе си.{value1} {value2}',
    'Changes since version': 'Промени след версията',
    'are not live yet.': 'все още не са активни.',
    'Review them in Versions': 'Прегледайте ги във „Версии“',
    Skill: 'Умение',
    'The agent always uses the Skill’s published version.':
      'Агентът винаги използва публикуваната версия на умението.',
    Day: 'Ден',
    Time: 'Час',
    'Cron expression': 'Cron израз',
    'Editors and access': 'Редактори и достъп',
    Company: 'Фирмен',
    Personal: 'Личен',
    'No changes.': 'Няма промени.',
    'Instructions changes': 'Промени в инструкциите',
    'Loading versions…': 'Зареждане на версии…',
    'What the draft changes': 'Какво променя черновата',
    'No published version yet. Try the draft, then publish it.':
      'Все още няма публикувана версия. Изпробвайте черновата, след което я публикувайте.',
    'Published versions': 'Публикувани версии',
    'Former member': 'Бивш член',
    Live: 'Активно',
    'Suggestion {value1} of {value2}': 'Предложение {value1} от {value2}',
    'Next suggestion': 'Следващо предложение',
    'Fold the suggestions away': 'Скрий предложенията',
    'Show the suggestions': 'Покажи предложенията',
    '1 suggestion': '1 предложение',
    '{value1} suggestions': '{value1} предложения',
    '{value1} the pages under {value2}': '{value1} страниците под {value2}',
    px: 'px',
    '{value1} chart of {value2} across {value3}': 'Диаграма на {value2} по {value3}: {value1}',
    'We could not build the file.': 'Не успяхме да създадем файла.',
    '{value1} Present': 'Представяне на {value1}',
    'Building…': 'Създаване…',
    'Download PowerPoint': 'Изтегляне на PowerPoint',
    'Slide {value1} of {value2}': 'Слайд {value1} от {value2}',
    Slides: 'Слайдове',
    'Slide {value1}': 'Слайд {value1}',
    'Speaker notes': 'Бележки на презентатора',
    'Source: {value1}': 'Източник: {value1}',
    'Add a name and a web address.': 'Добавете име и уеб адрес.',
    'Enter a valid web address.': 'Въведете валиден уеб адрес.',
    'Use a web address that starts with https://.':
      'Използвайте уеб адрес, който започва с https://.',
    'Add a custom connection': 'Добавяне на персонализирана връзка',
    'Connect a tool server you trust. Poneva checks the address works and saves only the connection details needed to use it.':
      'Свържете сървър с инструменти, на който имате доверие. Poneva проверява дали адресът работи и запазва само необходимите данни за връзката.',
    'Web address': 'Уеб адрес',
    'https://tools.example.com': 'https://tools.example.com',
    'Starts with https://, from your provider':
      'Започва с https://, предоставен от вашия доставчик',
    'Sign-in': 'Вход',
    'Advanced sign-in': 'Разширен вход',
    'Access key {value1}': 'Ключ за достъп {value1}',
    'Request headers': 'Заглавки на заявката',
    'Add header': 'Добавяне на заглавка',
    'Header {value1} name': 'Име на заглавка {value1}',
    'Header name': 'Име на заглавката',
    'Header {value1} value': 'Стойност на заглавка {value1}',
    'Header value': 'Стойност на заглавката',
    'Remove header': 'Премахване на заглавката',
    Advanced: 'Разширени',
    Transport: 'Транспорт',
    'Auto-detect': 'Автоматично откриване',
    'Streamable HTTP': 'Streamable HTTP',
    'Legacy SSE': 'Legacy SSE',
    "From your provider's app settings. Leave empty unless they gave you these.":
      'От настройките на приложението на вашия доставчик. Оставете празно, освен ако не са ви предоставили тези данни.',
    "Authorization server issuer": "Издател на сървъра за оторизация",
    "Enter the authorization server issuer when using a client ID.": "Въведете издателя на сървъра за оторизация, когато използвате идентификатор на клиента.",
    'Client ID {value1}': 'Идентификатор на клиента {value1}',
    'Client secret {value1}': 'Секретен ключ на клиента {value1}',
    'Connecting…': 'Свързване…',
    'Test and connect': 'Тестване и свързване',
    'Add the store, the client ID and the client secret.':
      'Добавете магазина, идентификатора на клиента и секретния ключ на клиента.',
    'Connect your Shopify Developer App': 'Свържете приложението си за разработчици на Shopify',
    'Poneva can use exactly the access your store gave the app, and nothing more. It talks to Shopify directly and keeps the client secret encrypted.':
      'Poneva може да използва точно достъпа, който магазинът ви е предоставил на приложението, и нищо повече. Тя комуникира директно с Shopify и съхранява секретния ключ на клиента шифрован.',
    'How to create the app in Shopify': 'Как да създадете приложението в Shopify',
    'Open{value1} {value2}{value3} with the account that owns the store, and create an app.':
      'Отворете{value1} {value2}{value3} с акаунта, който притежава магазина, и създайте приложение.',
    'Create a version and select the access scopes Poneva may use, for example read_products and read_orders. Add write_ scopes only for data Poneva may change. Then release the version.':
      'Създайте версия и изберете обхватите за достъп, които Poneva може да използва, например read_products и read_orders. Добавете обхвати write_ само за данни, които Poneva може да променя. След това публикувайте версията.',
    'For orders and customers, also select protected customer data in the app’s settings. Shopify allows this without review for an app made for your own store.':
      'За поръчките и клиентите изберете и защитени клиентски данни в настройките на приложението. Shopify позволява това без преглед за приложение, създадено за вашия собствен магазин.',
    'Install the app on your store.': 'Инсталирайте приложението в магазина си.',
    'Copy the client ID and client secret from the app’s settings.':
      'Копирайте идентификатора на клиента и секретния ключ на клиента от настройките на приложението.',
    'To change the access later, release a new version, approve it on the store and use Test connection here.':
      'За да промените достъпа по-късно, публикувайте нова версия, одобрете я в магазина и използвайте „Тестване на връзката“ тук.',
    Store: 'Магазин',
    'your-store.myshopify.com': 'your-store.myshopify.com',
    'Your store’s .myshopify.com address (Shopify admin → Settings → Domains), or paste the address of your Shopify admin page':
      'Адресът .myshopify.com на магазина ви (администраторът на Shopify → Settings → Domains) или адресът на административната ви страница в Shopify',
    'Client ID {value1} {value2}': 'Идентификатор на клиента {value1} {value2}',
    'Client secret {value1} {value2}': 'Секретен ключ на клиента {value1} {value2}',
    Person: 'Потребител',
    Everyone: 'Всички',
    Connection: 'Връзка',
    'All connections': 'Всички връзки',
    'App {value1}': 'Приложение {value1}',
    'From {value1}': 'От {value1}',
    'Until {value1}': 'До {value1}',
    Result: 'Резултат',
    'All results': 'Всички резултати',
    Succeeded: 'Успешно',
    Denied: 'Отказано',
    Failed: 'Неуспешно',
    Unknown: 'Неизвестно',
    Filter: 'Филтър',
    'Loading activity…': 'Зареждане на активността…',
    'Could not load activity. Try again.': 'Активността не можа да се зареди. Опитайте отново.',
    'Removed connection': 'Премахната връзка',
    'App: {value1}': 'Приложение: {value1}',
    'Older activity': 'По-стара активност',
    Download: 'Изтегляне',
    CSV: 'CSV',
    'Evidence for {value1}': 'Доказателства за {value1}',
    Measure: 'Мярка',
    'Show rows →': 'Показване на редовете →',
    'Ask about this number': 'Попитайте за това число',
    'There are no numeric values available to chart. View the table for the original data.':
      'Няма налични числови стойности за диаграмата. Вижте таблицата за първоначалните данни.',
    'Chart value': 'Стойност на диаграмата',
    '{value1} of {value2} shown': 'Показани са {value1} от {value2}',
    '{value1} by {value2}; {value3} rows. View Table for exact values.':
      '{value1} по {value2}; {value3} реда. Вижте таблицата за точните стойности.',
    'Values come directly from the source data. Missing values are not estimates.':
      'Стойностите идват директно от изходните данни. Липсващите стойности не са приблизителни.',
    'Loading library…': 'Зареждане на библиотеката…',
    'We couldn’t load what happened in this App. Try again in a moment.':
      'Не успяхме да заредим случилото се в това приложение. Опитайте отново след малко.',
    'This App could not be opened.': 'Това приложение не може да бъде отворено.',
    'Opening App…': 'Отваряне на приложението…',
    'Open the saved App to run this function.':
      'Отворете запазеното приложение, за да изпълните тази функция.',
    'Save this App before running its function.':
      'Запазете това приложение, преди да изпълните функцията му.',
    'Open saved App': 'Отваряне на запазеното приложение',
    'Open Apps': 'Отваряне на приложения',
    'The App could not be opened. Try again.':
      'Приложението не може да бъде отворено. Опитайте отново.',
    Owner: 'Собственик',
    '{value1} · admins': '{value1} · администратори',
    'Owner · always edits': 'Собственик · винаги редактира',
    'Admins manage it': 'Администраторите го управляват',
    Editors: 'Редактори',
    'A colleague': 'Колега',
    'Can edit drafts and publish versions': 'Може да редактира чернови и да публикува версии',
    Remove: 'Премахване',
    'No editors yet.': 'Все още няма редактори.',
    'Admins can always edit company agents.':
      'Администраторите винаги могат да редактират фирмените агенти.',
    'Asking for edit access': 'Заявяване на достъп за редактиране',
    'Asked {value1} · also in your Inbox': 'Поискано на {value1} · също е във входящата ви поща',
    Grant: 'Предоставяне',
    Admin: 'Администратор',
    'Make personal': 'Направи личен',
    'Switch off': 'Изключване',
    Archive: 'Архивиране',
    'Archive this agent': 'Архивирай този агент',
    'Loading agent…': 'Зареждане на агента…',
    '{value1} Edit in chat': '{value1} Редактиране в чата',
    Agent: 'Агент',
    'This agent has not been created yet. It can run once its owner creates it.':
      'Този агент все още не е създаден. Ще може да се изпълнява, след като собственикът му го създаде.',
    'New agent · Draft': 'Нов агент · Чернова',
    'Untitled agent': 'Агент без име',
    'Test run': 'Тестово изпълнение',
    'This draft does not run automatically.': 'Тази чернова не се изпълнява автоматично.',
    'Describe the agent in the chat. Its draft appears here.':
      'Опишете агента в чата. Черновата му ще се появи тук.',
    '{value1} Test run': '{value1} Тестово изпълнение',
    'Describe the agent in the chat first.': 'Първо опишете агента в чата.',
    'Create and turn on': 'Създаване и включване',
    'Connection write setup': 'Настройка за запис чрез връзка',
    'Account for connected changes': 'Акаунт за промени чрез връзката',
    'Choose a connection': 'Изберете връзка',
    'No published Skills available. You can add them later.':
      'Няма налични публикувани умения. Можете да ги добавите по-късно.',
    '{value1} · not published. Review the changes. Testing is optional.':
      '{value1} · не е публикувано. Прегледайте промените. Тестването не е задължително.',
    '{value1} Test draft': '{value1} Тестване на черновата',
    'Apply changes…': 'Прилагане на промените…',
    'Apply this draft as a new version': 'Прилагане на тази чернова като нова версия',
    'This draft cannot be applied.': 'Тази чернова не може да бъде приложена.',
    'What changed?': 'Какво се промени?',
    'Apply version {value1}': 'Прилагане на версия {value1}',
    Create: 'Създаване',
    'Edit access requested': 'Поискан е достъп за редактиране',
    '{value1} Request edit access': '{value1} Заявяване на достъп за редактиране',
    '{value1} Copy agent': '{value1} Копиране на агента',
    Pause: 'Пауза',
    'Open agent: {value1}': 'Отваряне на агент: {value1}',
    '· you can edit': '· можете да редактирате',
    '{value1} is switched off.': '{value1} е изключен.',
    '{value1} is archived.': '{value1} е архивиран.',
    'Loading agents…': 'Зареждане на агенти…',
    Agents: 'Агенти',
    'Agents do work for you on a schedule or when you ask. They follow your company’s Skills.':
      'Агентите работят за вас по график или когато ги помолите. Те следват уменията на вашата компания.',
    'No agent matches. Try a Skill name or what the agent should do.':
      'Няма съвпадащ агент. Опитайте с име на умение или описание на задачата на агента.',
    'Nothing of your own yet': 'Все още нямате нищо свое',
    'Tell Chat what an agent should do, or copy one of the company’s agents below.{value1}':
      'Кажете на Chat какво трябва да прави един агент или копирайте някой от фирмените агенти по-долу.{value1}',
    'Your agents': 'Вашите агенти',
    'Run on demand': 'Изпълнение при поискване',
    'Run is always available. A schedule is optional and lives separately from the agent’s instructions.':
      'Изпълнението винаги е достъпно. Графикът не е задължителен и се задава отделно от инструкциите на агента.',
    'What changed in version {value1}': 'Какво се промени във версия {value1}',
    'Every publish is a version you can restore.':
      'Всяко публикуване е версия, която можете да възстановите.',
    Authorization: 'Упълномощаване',
    '{value1} {value2} · {value3} will see it.': '{value1} {value2} · {value3} ще го вижда.',
    '{value1} {value2} you': '{value1} {value2} вие',
    '· Revised': '· Редактирано',
    'This chat used your {value1}.': 'Този чат използва вашия {value1}.',
    'This chat has results from {value1}.': 'Този чат съдържа резултати от {value1}.',
    'db.example.com': 'db.example.com',
    'e.g. Product analytics': 'напр. Анализ на продукти',
    'Paste access key': 'Поставете ключ за достъп',
    'Shopify’s Dev Dashboard': 'Dev Dashboard на Shopify',
    'App reference': 'Референция на приложението',
    'Draft · revision {value1}': 'Чернова · редакция {value1}',
    'its Result': 'неговия резултат',
    '· its first run makes it': '· първото му изпълнение го прави',
    '{value1}’s chat ·': 'Чатът на {value1} ·',
    '{value1} ad {value2} available.': '{value1} и {value2} са налични.',
    '{value1} rows ·': '{value1} реда ·',
    'It starts private. Sharing it wider shares every refresh, which can carry your private data.':
      'Първоначално е частно. Споделянето му с повече хора споделя всяко обновяване, което може да съдържа личните ви данни.',
    '{value1} for {value2}': '{value1} за {value2}',
    Suggested: 'Предложено',
    'Opening your conversation…': 'Отваряне на разговора ви…',
    'This conversation isn’t available': 'Този разговор не е наличен',
    'It may have been deleted, belong to another account, or be temporarily unavailable.':
      'Възможно е да е изтрит, да принадлежи на друг акаунт или временно да не е наличен.',
    '{count} more line — shown in the complete revision':
      'Още {count} ред — показан в пълната ревизия',
    '{count} more lines — shown in the complete revision':
      'Още {count} реда — показани в пълната ревизия',
    '{count} more line removed': 'Още {count} ред е премахнат',
    '{count} more lines removed': 'Още {count} реда са премахнати',
    '{count} unchanged line': '{count} непроменен ред',
    '{count} unchanged lines': '{count} непроменени реда',
    '{count} more lines not shown, {added} added and {removed} removed. Check them in the complete revision.':
      'Още {count} реда не са показани; добавени: {added}, премахнати: {removed}. Вижте ги в пълната ревизия.',
    'Saved result': 'Запазен резултат',
    'Made with a Skill': 'Създадено с умение',
    'Preview of {name}': 'Преглед на {name}',
    'Made with {name}': 'Създадено с {name}',
    'Ad-hoc result': 'Резултат по заявка',
    'A Skill that is not available in this workspace':
      'Умение, което не е налично в това работно пространство',
    '{name} · Revision {version}': '{name} · Ревизия {version}',
    '{name} · Version {version}': '{name} · Версия {version}',
    'Return to conversation {value1}': 'Връщане към разговора {value1}',
    '{value1} Working with {value2}': '{value1} Работи с {value2}',
    'View context {value1}': 'Преглед на контекста {value1}',
    'A way of working, made yours.': 'Начин на работа, съобразен с вас.',
    'Work that runs itself.': 'Работа, която се изпълнява сама.',
    'One place for one piece of work.': 'Едно място за всяка работа.',
    'Let’s move your work forward{value1}.': 'Нека придвижим работата ви напред{value1}.',
    'Describe the work. Your Skill takes shape beside the conversation.':
      'Опишете работата. Вашето умение ще се оформи до разговора.',
    'Describe what it should do and when. Your agent takes shape beside the conversation. The draft does not run automatically.':
      'Опишете какво трябва да прави и кога. Вашият агент ще се оформи до разговора. Черновата не се изпълнява автоматично.',
    'Say what the work is. Poneva drafts the project beside the conversation and brings in what you have already done. Nothing is created until you say so.':
      'Опишете каква е работата. Poneva създава чернова на проекта до разговора и включва вече свършеното от вас. Нищо не се създава, докато не потвърдите.',
    'Start with an idea below. Poneva will take it from there.':
      'Започнете с идея по-долу. Poneva ще се погрижи за останалото.',
    Triggers: 'Тригери',
    'Review the agent and its trigger. Approval applies exactly what is shown.':
      'Прегледайте агента и неговия тригер. Одобрението прилага точно показаното.',
    '{source} · read {date}': '{source} · прочетено на {date}',
    'Evidence is being recorded · read {date}': 'Доказателството се записва · прочетено на {date}',
    'Evidence expired on {date} under the retention policy':
      'Доказателството е изтекло на {date} съгласно политиката за съхранение',
    'Entered by {person}': 'Въведено от {person}',
    'No retained evidence for this value': 'Няма съхранено доказателство за тази стойност',
    'Covers {shown} of {total} rows': 'Обхваща {shown} от {total} реда',
    'Search rows': 'Търсене в редовете',
    'Clear filters': 'Изчистване на филтрите',
    Sort: 'Сортиране',
    'Sort: {column}': 'Сортиране: {column}',
    '{shown} of {total} rows': '{shown} от {total} реда',
    More: 'Още',
    Density: 'Плътност',
    Comfortable: 'Удобна',
    Compact: 'Компактна',
    Columns: 'Колони',
    'No rows match. Clear the search or filters to see them again.':
      'Няма съвпадащи редове. Изчистете търсенето или филтрите, за да ги видите отново.',
    'Not available': 'Недостъпно',
    'All rows': 'Всички редове',
    'Close row detail': 'Затваряне на подробностите за реда',
    'Ask about this row': 'Попитайте за този ред',
    'Add note': 'Добавяне на бележка',
    Note: 'Бележка',
    Saved: 'Запазено',
    Total: 'Общо',
    ascending: 'възходящо',
    descending: 'низходящо',
    'Scroll to see all columns': 'Превъртете, за да видите всички колони',
    App: 'Приложение',
    Artifact: 'Артефакт',
    'New project': 'Нов проект',
    'Review request': 'Заявка за преглед',
    Activity: 'Активност',
    'Voice preview': 'Преглед на гласа',
    Source: 'Източник',
    File: 'Файл',
    Meeting: 'Среща',
    'Knowledge page': 'Страница от базата знания',
    'Could not preview this CSV.': 'Този CSV файл не може да бъде прегледан.',
    'File content is unavailable.': 'Съдържанието на файла не е налично.',
    'You have five open suggestions here. {value1} will see them.':
      'Тук имате пет отворени предложения. {value1} ще ги види.',
    'We could not send your suggestion. Please try again.':
      'Предложението ви не можа да бъде изпратено. Опитайте отново.',
    'The agent': 'Агентът',
    'Selected colleagues': 'Избрани колеги',
    'The owner': 'Собственикът',
    'Forked. This copy is yours and runs with your own connections.':
      'Създадено е разклонение. Това копие е ваше и работи с вашите собствени връзки.',
    'This chat is too long to fork.': 'Този чат е твърде дълъг, за да бъде разклонен.',
    'We could not fork this chat. Please try again.':
      'Този чат не можа да бъде разклонен. Опитайте отново.',
    'Anyone who forked it keeps their copy: forks stay with the people who made them.':
      'Всеки, който е създал разклонение, запазва копието си: разклоненията остават при хората, които са ги създали.',
    'Nobody has forked this chat.': 'Никой не е създал разклонение на този чат.',
    '1 person forked this chat. Their copy stays theirs.':
      '1 човек е създал разклонение на този чат. Копието му остава негово.',
    '{value1} people forked this chat. Their copies stay theirs.':
      '{value1} души са създали разклонение на този чат. Копията им остават техни.',
    'Personal. Nobody else sees it.': 'Лично. Никой друг не го вижда.',
    'People you pick. They get it in their Inbox.':
      'Избрани от вас хора. Те го получават във „Входящи“.',
    'Everyone in the company can follow it and fork it.':
      'Всеки в компанията може да го следва и да създаде негово разклонение.',
    'a chat you can no longer open': 'чат, който вече не можете да отворите',
    'shared the Result': 'сподели резултата',
    'updated the Result': 'актуализира резултата',
    'published the Skill': 'публикува умението',
    'approved the fact': 'одобри факта',
    'added the fact': 'добави факта',
    'added the meeting': 'добави срещата',
    'published the page': 'публикува страницата',
    'updated the page': 'актуализира страницата',
    'shared the chat': 'сподели чата',
    'published a version of': 'публикува версия на',
    ran: 'изпълни',
    Knowledge: 'База знания',
    Meetings: 'Срещи',
    Chat: 'Чат',
    Use: 'Използване',
    Open: 'Отваряне',
    You: 'Вие',
    Someone: 'Някой',
    'published version {version} of': 'публикува версия {version} на',
    'thing needs': 'елемент изисква',
    'things need': 'елемента изискват',
    'Published Skill': 'Публикувано умение',
    'Included with Skill': 'Включено с умението',
    'Already attached': 'Вече е прикачено',
    'Also available in company knowledge': 'Също е налично в базата знания на компанията',
    'Company file': 'Файл на компанията',
    'Account identity unavailable': 'Самоличността на акаунта не е налична',
    'Access expired or was revoked. Reconnect to continue.':
      'Достъпът е изтекъл или е отнет. Свържете отново, за да продължите.',
    'Account authorized · tools unavailable':
      'Акаунтът е упълномощен · инструментите не са налични',
    'Not available in this workspace yet.': 'Все още не е налично в това работно пространство.',
    'Everyone in the company': 'Всеки в компанията',
    'Audience: only you.': 'Аудитория: само вие.',
    'Audience: everyone in the company.': 'Аудитория: всички в компанията.',
    'tool is': 'инструментът е',
    'tools are': 'инструментите са',
    'account is': 'акаунтът е',
    'accounts are': 'акаунтите са',
    'We could not upload this file.': 'Този файл не можа да бъде качен.',
    'file was': 'файлът беше',
    'files were': 'файловете бяха',
    'Your company': 'Вашата компания',
    'Create an agent': 'Създаване на агент',
    'Give recurring work a helping hand': 'Улеснете повтарящата се работа',
    'Create a Skill': 'Създаване на умение',
    'Save a reusable way of working': 'Запазете начин на работа за повторна употреба',
    'Take meeting notes': 'Водене на бележки от среща',
    'Capture decisions and next steps': 'Записване на решенията и следващите стъпки',
    'Work with a file': 'Работа с файл',
    'Start from a document or image': 'Започнете от документ или изображение',
    'Browse agents': 'Преглед на агентите',
    'Open your agents and company agents': 'Отворете вашите агенти и агентите на компанията',
    'Review results': 'Преглед на резултатите',
    'Return to work saved in your Library':
      'Върнете се към работата, запазена във вашата библиотека',
    'For review': 'За преглед',
    'An agent': 'Агент',
    Assistant: 'Асистент',
    'Kept up to date by {value1}{value2}': 'Поддържа се актуално от {value1}{value2}',
    ', {value1}': ', {value1}',
    'Version {value1}{value2}{value3}': 'Версия {value1}{value2}{value3}',
    'Refreshed by its agent': 'Обновено от неговия агент',
    'Saved from a chat': 'Запазено от чат',
    'Saved from {value1}': 'Запазено от {value1}',
    Edited: 'Редактирано',
    'private account': 'личен акаунт',
    '{value1} ({value2})': '{value1} ({value2})',
    '{value1}’s {value2}': '{value2} на {value1}',
    'Made private. The person who added it and the owner of its recording have been told in their Inbox.':
      'Направено е лично. Лицето, което го е добавило, и собственикът на записа са уведомени във входящата си кутия.',
    'Made private. The person who added it has been told in their Inbox.':
      'Направено е лично. Лицето, което го е добавило, е уведомено във входящата си кутия.',
    'Made private. The owner of its recording has been told in their Inbox.':
      'Направено е лично. Собственикът на записа е уведомен във входящата си кутия.',
    'Selected passage': 'Избран откъс',
    '{value1} {value2}': '{value1} {value2}',
    'Upload a file': 'Качване на файл',
    'Help me create a useful report from our company knowledge and available sources.':
      'Помогнете ми да създам полезен отчет от знанията на компанията и наличните източници.',
    'This saved work couldn’t be opened. Open it again to retry.':
      'Тази запазена работа не може да бъде отворена. Отворете я отново, за да опитате пак.',
    '{value1}’s': 'На {value1}',
    '{value1} chat “{value2}”': 'Чатът на {value1} „{value2}“',
    '{value1}{value2}': '{value1}{value2}',
    'Skill: {value1}{value2}': 'Умение: {value1}{value2}',
    'Result “{value1}”': 'Резултат „{value1}“',
    'Meeting “{value1}”': 'Среща „{value1}“',
    'Used in {value1} {value2} this week': 'Използвано в {value1} {value2} тази седмица',
    '{value1} {value2} · used in {value3} {value4}':
      '{value1} {value2} · използвано в {value3} {value4}',
    'The draft is not published yet, so no one else follows it.':
      'Черновата все още не е публикувана, затова никой друг не я следва.',
    'Use it in a chat for current data, or refine the Skill first.':
      'Използвайте го в чат за актуални данни или първо усъвършенствайте умението.',
    'An agent keeps this up to date. Continue the work in chat.':
      'Агент поддържа това актуално. Продължете работата в чата.',
    'Edit it here, or continue the work in chat.':
      'Редактирайте го тук или продължете работата в чата.',
    'Duplicate it to your Library, or continue the work in chat.':
      'Дублирайте го във вашата библиотека или продължете работата в чата.',
    'Download Markdown': 'Изтегляне на Markdown',
    'Download CSV': 'Изтегляне на CSV',
    'an agent': 'агент',
    'Publish a Skill version': 'Публикуване на версия на умение',
    'Share with {value1}': 'Споделяне с {value1}',
    'Update company content': 'Актуализиране на съдържанието на компанията',
    Approved: 'Одобрено',
    Declined: 'Отхвърлено',
    Pending: 'Изчакващо',
    'View decision': 'Преглед на решението',
    'No data': 'Няма данни',
    'No change': 'Няма промяна',
    'Connection created': 'Връзката е създадена',
    'Sharing changed': 'Споделянето е променено',
    'Person added': 'Лицето е добавено',
    'Person removed': 'Лицето е премахнато',
    'Access changed': 'Достъпът е променен',
    'Access turned off': 'Достъпът е изключен',
    'Connection removed': 'Връзката е премахната',
    'Query time limit changed': 'Ограничението за време на заявката е променено',
    '{count} row': '{count} ред',
    '{count} rows': '{count} реда',
    'This source is no longer available. Company knowledge now lives in Knowledge pages, and files stay in the Library.':
      'Този източник вече не е наличен. Знанията на компанията вече се намират в страниците „Знания“, а файловете остават в библиотеката.',
    '· {value1} by {value2}': '· {value1} от {value2}',
    '· version {value1}': '· версия {value1}',
    '{message} {count} earlier file was saved and attached.':
      '{message} {count} предишен файл беше запазен и прикачен.',
    '{message} {count} earlier files were saved and attached.':
      '{message} {count} предишни файла бяха запазени и прикачени.',
    '{message} {count} earlier file was saved.': '{message} {count} предишен файл беше запазен.',
    '{message} {count} earlier files were saved.':
      '{message} {count} предишни файла бяха запазени.',
    'refreshed {time}': 'обновено {time}',
    'a colleague': 'колега',
    'Your chat “{title}”': 'Вашият чат „{title}“',
    '{name}’s chat “{title}”': 'Чатът на {name} „{title}“',
    'Kept up to date by {name}{version}': 'Поддържа се актуално от {name}{version}',
    'Skill: {name}{version}': 'Умение: {name}{version}',
    'Result “{title}”': 'Резултат „{title}“',
    'Meeting “{title}”': 'Среща „{title}“',
    'Used in {count} answer this week': 'Използвано в {count} отговора тази седмица',
    'Used in {count} answers this week': 'Използвано в {count} отговора тази седмица',
    '{count} source': '{count} източник',
    '{count} sources': '{count} източника',
    'used in {count} place': 'използвано на {count} място',
    'used in {count} places': 'използвано на {count} места',
    '{company} workspace': '{company} работно пространство',
    '{count} page': '{count} страница',
    '{count} pages': '{count} страници',
    '{needs} · reviews and approvals': '{needs} · прегледа и одобрения',
    '{count} thing needs you': '{count} елемент изисква вашето внимание',
    '{count} things need you': '{count} елемента изискват вашето внимание',
    'Included with Skill · {files} · {sources} {icon}':
      'Включено с умение · {files} · {sources} {icon}',
    '{count} file': '{count} файл',
    '{count} files': '{count} файла',
    Today: 'Днес',
    'Earlier this week': 'По-рано тази седмица',
    '{count} slide': '{count} слайд',
    '{count} slides': '{count} слайда',
    Early: 'Ранен',
    'TLS verified': 'TLS е потвърден',
    'Made personal and switched off. Switch it on when you are ready.':
      'Направено лично и изключено. Включете го, когато сте готови.',
    'Made personal and switched off. Its owner is told which version is live.':
      'Направено лично и изключено. Собственикът му е уведомен коя версия е активна.',
    'Switched off.': 'Изключено.',
    'Applied version {revision}.': 'Приложена е версия {revision}.',
    'The draft is running in a chat only you can read.':
      'Черновата се изпълнява в чат, който само вие можете да четете.',
    'Publish a version first.': 'Първо публикувайте версия.',
    'Another Agent action is in progress.': 'Друго действие на Агент се изпълнява.',
    'Knowledge & connections': 'Знания и връзки',
    'Pinned Skills': 'Закачени умения',
    None: 'Няма',
    'A new Result each run': 'Нов резултат при всяко изпълнение',
    'One Result kept up to date': 'Един резултат, който се поддържа актуален',
    Email: 'Имейл',
    On: 'Включено',
    Off: 'Изключено',
    'Waiting for review': 'В очакване на преглед',
    Outdated: 'Остаряло',
    Accepted: 'Прието',
    Rejected: 'Отхвърлено',
    Withdrawn: 'Оттеглено',
    Replaced: 'Заменено',
    'Suggested edit': 'Предложена редакция',
    'Suggested new page': 'Предложена нова страница',
    'Suggested move': 'Предложено преместване',
    'Suggested archive': 'Предложено архивиране',
    'Checking status…': 'Проверка на състоянието…',
    'Status unavailable': 'Състоянието не е налично',
    'Bulleted list': 'Списък с водещи символи',
    'Numbered list': 'Номериран списък',
    'Web link': 'Уеб връзка',
    Read: 'Четене',
    Write: 'Запис',
    'shared with you': 'споделено с вас',
    'Getting an answer': 'Получаване на отговор',
    '{name} is getting an answer': '{name} получава отговор',
    'We could not save. Please try again.': 'Не успяхме да запазим. Моля, опитайте отново.',
    'The new page could not be created.': 'Новата страница не можа да бъде създадена.',
    'We could not load this revision.': 'Не успяхме да заредим тази версия.',
    'We could not restore this revision. Please try again.':
      'Не успяхме да възстановим тази версия. Моля, опитайте отново.',
    'We could not export this revision.': 'Не успяхме да експортираме тази версия.',
    'We could not open this suggestion.': 'Не успяхме да отворим това предложение.',
    'We could not do that. Please try again.':
      'Не успяхме да извършим това. Моля, опитайте отново.',
    'We could not save your decision. Please try again.':
      'Не успяхме да запазим решението ви. Моля, опитайте отново.',
    'We could not restore this page. Please try again.':
      'Не успяхме да възстановим тази страница. Моля, опитайте отново.',
    'We could not export this page.': 'Не успяхме да експортираме тази страница.',
    '{count} missed time merged.': 'Обединен е {count} пропуснат интервал.',
    '{count} missed times merged.': 'Обединени са {count} пропуснати интервала.',
    'About this project': 'За този проект',
  },
  hr: {
    'We could not load this item.': 'Nije moguće učitati ovu stavku.',
    '{value1} canvas': '{value1} platno',
    'Loading {value1}…': 'Učitavanje stavke {value1}…',
    '{value1} · Original retained': '{value1} · Izvornik zadržan',
    '{value1} {value2}{value3} · Added {value4}': '{value1} {value2}{value3} · Dodano {value4}',
    '{value1} Use in chat': '{value1} Upotrijebi u chatu',
    '{value1} Download': '{value1} Preuzmi',
    Table: 'Tablica',
    Chart: 'Grafikon',
    Original: 'Izvornik',
    'Text extracted from the PDF, marked by page. Download the original for its layout and images.':
      'Tekst je izdvojen iz PDF-a i označen po stranicama. Preuzmite izvornik da biste vidjeli njegov raspored i slike.',
    'This preview shows the beginning of the file. Poneva reads the whole file; download the original to see all of it.':
      'Ovaj pretpregled prikazuje početak datoteke. Poneva čita cijelu datoteku; preuzmite izvornik da biste vidjeli cijeli sadržaj.',
    'Preview of the first {value1} complete rows. Filtering and charts use only this preview. Download the original for the full file.':
      'Pretpregled prvih {value1} potpunih redaka. Filtriranje i grafikoni koriste samo ovaj pretpregled. Preuzmite izvornik za cijelu datoteku.',
    'This source link cannot be opened.': 'Ovu izvornu poveznicu nije moguće otvoriti.',
    'Read-only chat': 'Chat samo za čitanje',
    'Only {value1} writes in this chat. Fork it to continue with your own connections. {value2}':
      'Samo {value1} šalje poruke u ovom chatu. Izradite njegovu kopiju da biste nastavili s vlastitim vezama. {value2}',
    'Suggest a follow-up…': 'Predložite dodatno pitanje…',
    'Suggest a follow-up': 'Predloži dodatno pitanje',
    'Sending…': 'Slanje…',
    Send: 'Pošalji',
    'We could not dismiss that suggestion. Please try again.':
      'Nije moguće odbaciti taj prijedlog. Pokušajte ponovno.',
    'Suggested follow-ups': 'Predložena dodatna pitanja',
    '{value1} suggests': '{value1} predlaže',
    Ask: 'Pitaj',
    'Dismiss {value1}’s suggestion': 'Odbaci prijedlog korisnika {value1}',
    'Suggested by': 'Predložio/la',
    '· edit it or send it': '· uredite ga ili pošaljite',
    'Remove the suggestion tag': 'Ukloni oznaku prijedloga',
    '{value1} {value2} is getting an answer': '{value1} {value2} dobiva odgovor',
    '{value1} {value2} stopped the answer': '{value1} {value2} zaustavio/la je odgovor',
    '{value1} Fork from here': '{value1} Izradi kopiju odavde',
    '{value1} From {value2}’s {value3}': '{value1} Od korisnika {value2}, {value3}',
    'Only {value1} can use this account': 'Samo {value1} može upotrebljavati ovaj račun',
    '{value1} Suggested by {value2}': '{value1} Predložio/la {value2}',
    'Fork this chat': 'Izradi kopiju ovog chata',
    'Forking…': 'Izrada kopije…',
    Fork: 'Izradi kopiju',
    'Could not make this private.': 'Nije moguće postaviti kao privatno.',
    'Make this chat private?': 'Želite li ovaj chat postaviti kao privatan?',
    Close: 'Zatvori',
    '{value1} will see “{value2}”. Everyone else loses access right away {value3} .{value4}':
      '{value1} će vidjeti „{value2}”. Svi ostali odmah gube pristup {value3} .{value4}',
    Cancel: 'Odustani',
    'Saving…': 'Spremanje…',
    'Make private': 'Postavi kao privatno',
    'This chat is private again. Forks others made stay theirs.':
      'Ovaj je chat ponovno privatan. Kopije koje su izradili drugi ostaju njima.',
    'Who can read this chat: {value1}': 'Tko može čitati ovaj chat: {value1}',
    'Move this chat': 'Premjesti ovaj chat',
    'Only you write here. Others follow live and fork.':
      'Samo vi ovdje šaljete poruke. Ostali prate uživo i mogu izraditi kopiju.',
    'Made private. {value1} has been told in their Inbox.':
      'Postavljeno kao privatno. {value1} je obaviješten/a u ulaznoj pošti.',
    'Chat access': 'Pristup chatu',
    '{value1}’s chat. As an admin you can make it private.':
      'Chat korisnika {value1}. Kao administrator možete ga postaviti kao privatan.',
    'Only {value1} will see it. {value2} is told.':
      'Samo će {value1} to vidjeti. {value2} je obaviješten/a.',
    '{value1} {value2} following': '{value1} {value2} prati',
    'Forked from{value1} {value2} . The history is copied. From here, tools run with your own access.':
      'Kopija izrađena iz{value1} {value2} . Povijest je kopirana. Odavde alati rade s vašim vlastitim pristupom.',
    '{value1} made this chat private': '{value1} je ovaj chat postavio/la kao privatan',
    'You can no longer open it. Any fork you made stays yours.':
      'Više ga ne možete otvoriti. Svaka kopija koju ste izradili ostaje vama.',
    'Start a new chat': 'Započni novi chat',
    'Back to Recent chats': 'Natrag na nedavne chatove',
    'More chat actions': 'Više radnji chata',
    'Close conversation sharing': 'Zatvori dijeljenje razgovora',
    'Review the text before saving a private copy to Library. Then choose its audience. Your original conversation and future messages stay private.':
      'Pregledajte tekst prije spremanja privatne kopije u Biblioteku. Zatim odaberite njezinu publiku. Vaš izvorni razgovor i buduće poruke ostaju privatni.',
    'Preparing the conversation…': 'Priprema razgovora…',
    'Refresh preview': 'Osvježi pretpregled',
    'The copy is saved in Library. Use Share to choose who can access it.':
      'Kopija je spremljena u Biblioteku. Upotrijebite Dijeli da biste odabrali tko joj može pristupiti.',
    'Save this copy': 'Spremi ovu kopiju',
    'That Skill could not be opened.': 'Nije moguće otvoriti tu vještinu.',
    '{value1}{value2} · reviews and approvals': '{value1}{value2} · pregledi i odobrenja',
    'Open Inbox': 'Otvori ulaznu poštu',
    'New at {value1} this week': 'Novo u odjeljku {value1} ovog tjedna',
    'Nothing new this week. Shared work, published Skills and approved knowledge show up here.':
      'Ovaj tjedan nema ničeg novog. Ovdje se prikazuju dijeljeni radovi, objavljene vještine i odobreno znanje.',
    'New at {value1}': 'Novo u odjeljku {value1}',
    'This Skill is unavailable. Try again.': 'Ova vještina nije dostupna. Pokušajte ponovno.',
    'You can attach up to {value1} files. Remove an attachment to add another.':
      'Možete priložiti najviše {value1} datoteka. Uklonite privitak da biste dodali drugi.',
    'Add company context': 'Dodaj kontekst tvrtke',
    'Add company context · @': 'Dodaj kontekst tvrtke · @',
    'Choose a Skill': 'Odaberite vještinu',
    'Choose a Skill · /': 'Odaberite vještinu · /',
    context: 'kontekst',
    skills: 'vještine',
    'Choose company context': 'Odaberi kontekst tvrtke',
    'Skills for this conversation': 'Vještine za ovaj razgovor',
    'Bring context into the conversation': 'Dodaj kontekst u razgovor',
    'Close context picker': 'Zatvori odabir konteksta',
    'Filter company context': 'Filtriraj kontekst tvrtke',
    'Find a Skill…': 'Pronađi vještinu…',
    'Find a file…': 'Pronađi datoteku…',
    'Available company context': 'Dostupni kontekst tvrtke',
    'No matching published Skills.': 'Nema odgovarajućih objavljenih vještina.',
    'No matching files.': 'Nema odgovarajućih datoteka.',
    'Searching company work…': 'Pretraživanje rada tvrtke…',
    'Try search again': 'Pokušaj ponovno pretražiti',
    'Meaning search is temporarily limited. Showing available text matches.':
      'Pretraživanje po značenju trenutačno je ograničeno. Prikazuju se dostupna podudaranja teksta.',
    'Load more matches': 'Učitaj još podudaranja',
    '{value1} files attached. Remove an attachment to add another. Saved Skill references are included separately.':
      'Priloženo je datoteka: {value1}. Ukloni privitak da bi dodao drugi. Spremljene reference vještine uključene su zasebno.',
    'Create a Skill in chat': 'Izradi vještinu u chatu',
    'Upload a company file': 'Prenesi datoteku tvrtke',
    'Company knowledge is always available to Poneva.': 'Znanje tvrtke uvijek je dostupno Ponevi.',
    '{value1} was not connected': '{value1} nije povezan',
    Dismiss: 'Zatvori',
    'Try connecting again': 'Pokušaj se ponovno povezati',
    Waiting: 'Čekanje',
    Connected: 'Povezano',
    'Needs reconnecting': 'Potrebno je ponovno povezivanje',
    Connect: 'Poveži',
    '{value1}{value2} The provider’s account permissions still apply.':
      '{value1}{value2} Dozvole računa pružatelja i dalje vrijede.',
    'Last error: {value1}': 'Posljednja pogreška: {value1}',
    '{value1} {value2} ready.': '{value1} {value2} spremno.',
    'Continue with my Meta app': 'Nastavi s mojom aplikacijom Meta',
    Reconnect: 'Ponovno poveži',
    Disconnect: 'Prekini vezu',
    'Remove attachment: {value1}': 'Ukloni privitak: {value1}',
    'Saved in this Skill. Edit the Skill to change its references.':
      'Spremljeno u ovoj vještini. Uredi vještinu da bi promijenio njezine reference.',
    'Remove Skill context': 'Ukloni kontekst vještine',
    Refining: 'Dorađivanje',
    Previewing: 'Pregled',
    Using: 'Upotreba',
    'Skill revision {value1}': 'Revizija vještine {value1}',
    'a new Skill': 'novu vještinu',
    '{value1} Making a new agent {value2}': '{value1} Izrada novog agenta {value2}',
    'Stop making a new agent in this chat': 'Zaustavi izradu novog agenta u ovom chatu',
    'Saved Skill references': 'Spremljene reference vještine',
    'Included with Skill · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}':
      'Uključeno s vještinom · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}',
    'Selected Skill revision is unavailable. Select the Skill again to view its saved references.':
      'Odabrana revizija vještine nije dostupna. Ponovno odaberi vještinu da bi vidio njezine spremljene reference.',
    'Conversation attachments': 'Privici razgovora',
    'Added for this conversation': 'Dodano za ovaj razgovor',
    'Selected passage {value1}': 'Odabrani odlomak {value1}',
    'We could not load your workspace.': 'Nismo mogli učitati tvoj radni prostor.',
    'The selected Skill is unavailable. Check its access or choose it again.':
      'Odabrana vještina nije dostupna. Provjeri pristup ili je ponovno odaberi.',
    'Source saved privately and included in your knowledge search.':
      'Izvor je privatno spremljen i uključen u tvoje pretraživanje znanja.',
    'File saved privately to your library and attached to this message.':
      'Datoteka je privatno spremljena u tvoju biblioteku i priložena ovoj poruci.',
    'File saved privately to your library.': 'Datoteka je privatno spremljena u tvoju biblioteku.',
    '{value1} {value2} earlier {value3} saved{value4}.':
      '{value1} {value2} ranije {value3} spremljeno{value4}.',
    'Extracted text for Poneva to read. Download the original for its layout, charts and images. Spreadsheet formulas show their saved results and are not recalculated.':
      'Izdvojeni tekst za čitanje u Ponevi. Preuzmi izvornik za njegov raspored, grafikone i slike. Formule u proračunskoj tablici prikazuju spremljene rezultate i ne izračunavaju se ponovno.',
    Esc: 'Esc',
    'Start something': 'Započni nešto',
    'Choose a file to work with': 'Odaberi datoteku za rad',
    'Skills worth adding': 'Vještine koje vrijedi dodati',
    'Picked for you': 'Odabrano za tebe',
    'Reusable work grounded in your company knowledge.':
      'Ponovno upotrebljiv rad utemeljen na znanju tvoje tvrtke.',
    'Ideas from your company context and recent work. Pick one to start.':
      'Ideje iz konteksta tvoje tvrtke i nedavnog rada. Odaberi jednu za početak.',
    'Refresh suggested tasks': 'Osvježi predložene zadatke',
    'Check for new company context.': 'Provjeri novi kontekst tvrtke.',
    'Check for new context. Ideas also refresh daily.':
      'Provjeri novi kontekst. Ideje se također osvježavaju svakodnevno.',
    Refresh: 'Osvježi',
    'Finding useful starting points…': 'Traženje korisnih početnih točaka…',
    'Suggestions aren’t available right now. Try Refresh, or describe the work you want to do.':
      'Prijedlozi trenutačno nisu dostupni. Pokušaj s opcijom Osvježi ili opiši posao koji želiš obaviti.',
    'Loading the knowledge pages…': 'Učitavanje stranica znanja…',
    '{value1} All pages': '{value1} Sve stranice',
    'The page is created.': 'Stranica je izrađena.',
    'Your new page is suggested. A publisher decides whether it is added.':
      'Tvoja nova stranica predložena je. Izdavač odlučuje hoće li biti dodana.',
    'Company knowledge': 'Znanje tvrtke',
    'What Poneva knows about your company, page by page. Every change is kept.':
      'Što Poneva zna o tvojoj tvrtki, stranicu po stranicu. Svaka se promjena čuva.',
    'Loading company knowledge…': 'Učitavanje znanja tvrtke…',
    'Knowledge pages are not enabled in this workspace.':
      'Stranice znanja nisu omogućene u ovom radnom prostoru.',
    'Ask your Poneva contact to switch them on for your company.':
      'Zamoli svoj kontakt u Ponevi da ih uključi za tvoju tvrtku.',
    '{value1} Change the agent': '{value1} Promijeni agenta',
    '{value1} Continue in chat': '{value1} Nastavi u chatu',
    Edit: 'Uredi',
    '{value1} Edit with chat': '{value1} Uredi uz chat',
    '{value1} Duplicate to my Library': '{value1} Dupliciraj u moju biblioteku',
    'Duplicated to your Library. Only you can see the copy.':
      'Duplicirano u vašu biblioteku. Samo vi možete vidjeti kopiju.',
    'Could not duplicate this Result. Try again.':
      'Nije moguće duplicirati ovaj rezultat. Pokušajte ponovno.',
    'Saved version {value1}.': 'Spremljena je verzija {value1}.',
    'A newer version was saved. Reload the Result before saving.':
      'Spremljena je novija verzija. Ponovno učitajte rezultat prije spremanja.',
    'Could not save this version. Try again.':
      'Nije moguće spremiti ovu verziju. Pokušajte ponovno.',
    '{value1} saved a newer version. Review it before saving.':
      '{value1} je spremio noviju verziju. Pregledajte je prije spremanja.',
    'Hide their version': 'Sakrij njihovu verziju',
    'Show their version': 'Prikaži njihovu verziju',
    'Start from their version': 'Započni s njihovom verzijom',
    Markdown: 'Markdown',
    'Result text': 'Tekst rezultata',
    Preview: 'Pretpregled',
    'What changed': 'Što se promijenilo',
    'What changed? (optional)': 'Što se promijenilo? (neobavezno)',
    'Save version {value1}': 'Spremi verziju {value1}',
    'Open chat': 'Otvori chat',
    Current: 'Trenutna',
    Restore: 'Vrati',
    'Could not load the history.': 'Nije moguće učitati povijest.',
    'Restored version {value1} as version {value2}.':
      'Verzija {value1} vraćena je kao verzija {value2}.',
    'Someone saved a newer version. Review it before restoring.':
      'Netko je spremio noviju verziju. Pregledajte je prije vraćanja.',
    'Could not restore that version.': 'Nije moguće vratiti tu verziju.',
    'Loading history…': 'Učitavanje povijesti…',
    'Restoring keeps what is there now as a version too, so nothing is lost.':
      'Vraćanjem se i trenutačno stanje sprema kao verzija, tako da se ništa ne gubi.',
    'This Result was made with your own {value1}.':
      'Ovaj rezultat izrađen je pomoću vašeg {value1}.',
    'It also used': 'Također je korišteno',
    'This Result was made with': 'Ovaj rezultat izrađen je pomoću',
    'Colleagues can read what came from them, but can never use them.':
      'Kolege mogu pročitati ono što je došlo od njih, ali to nikada ne mogu koristiti.',
    'Your personal agent {value1} keeps it up to date with your own access, so every refresh can carry your private data.':
      'Vaš osobni agent {value1} ažurira ga pomoću vašeg pristupa, pa svako osvježavanje može sadržavati vaše privatne podatke.',
    'A colleague’s personal agent keeps it up to date with their own access, so every refresh can carry their private data.':
      'Osobni agent kolege ažurira ga pomoću njihova pristupa, pa svako osvježavanje može sadržavati njihove privatne podatke.',
    'Made private. Only you can see this meeting.':
      'Postavljeno kao privatno. Samo vi možete vidjeti ovaj sastanak.',
    'Could not make this meeting private.': 'Nije moguće postaviti ovaj sastanak kao privatan.',
    'Meeting · {value1} {value2} · Original retained':
      'Sastanak · {value1} {value2} · Izvornik je zadržan',
    'The recording could not be opened.': 'Nije moguće otvoriti snimku.',
    'Ask about this suggestion': 'Pitajte o ovom prijedlogu',
    meeting_processing_failed: 'obrada_sastanka_nije_uspjela',
    'Who can see this': 'Tko ovo može vidjeti',
    'Everyone at {value1}': 'Svi u {value1}',
    'Only me': 'Samo ja',
    'Everyone at {value1} can find it and ask about it.':
      'Svi u {value1} mogu ga pronaći i postavljati pitanja o njemu.',
    'Only you can open and search this meeting. You can share it later.':
      'Samo vi možete otvoriti i pretraživati ovaj sastanak. Možete ga podijeliti kasnije.',
    'Added. Only you can see it. Transcription is running in the background.':
      'Dodano. Samo vi to možete vidjeti. Transkripcija se obrađuje u pozadini.',
    'Visible to everyone at {value1}': 'Vidljivo svima u {value1}',
    'Could not make it private.': 'Nije moguće postaviti kao privatno.',
    'Show more meetings': 'Prikaži još sastanaka',
    'Attached to this message': 'Priloženo ovoj poruci',
    'Connect securely, choose the tables to share, then decide whether Poneva can read or make changes.':
      'Sigurno se povežite, odaberite tablice za dijeljenje i odlučite može li Poneva čitati podatke ili ih mijenjati.',
    'Review the tables this connection can access. Select at least one table.':
      'Pregledajte tablice kojima ova veza može pristupiti. Odaberite barem jednu tablicu.',
    'Select at least one table. Nothing is selected by default.':
      'Odaberite barem jednu tablicu. Prema zadanim postavkama ništa nije odabrano.',
    'Choose who can use this connection and what Poneva can do.':
      'Odaberite tko može koristiti ovu vezu i što Poneva može raditi.',
    'Your chosen access is enabled for the selected tables.':
      'Odabrani pristup omogućen je za odabrane tablice.',
    'Your connection is saved with reading paused until permission is confirmed.':
      'Vaša je veza spremljena, a čitanje je pauzirano dok se ne potvrdi dozvola.',
    'Confirm database disconnect': 'Potvrdi prekid veze s bazom podataka',
    'Disconnect this database?': 'Prekinuti vezu s ovom bazom podataka?',
    'Access will stop for everyone using this connection.':
      'Pristup će se prekinuti za sve koji koriste ovu vezu.',
    'Keep connection': 'Zadrži vezu',
    'What it can reach · {value1}{value2} {value3}':
      'Čemu može pristupiti · {value1}{value2} {value3}',
    Back: 'Natrag',
    Continue: 'Nastavi',
    'Uploading…': 'Prijenos…',
    Library: 'Biblioteka',
    'Source material for your work. Available whenever you need it.':
      'Izvorni materijali za vaš rad. Dostupni kad god vam zatrebaju.',
    'The work you want to keep, with its sources and conversation attached.':
      'Rad koji želite zadržati, s priloženim izvorima i razgovorom.',
    Results: 'Rezultati',
    Files: 'Datoteke',
    Artifacts: 'Artefakti',
    'Search library': 'Pretraži biblioteku',
    'Find files by meaning…': 'Pronađite datoteke prema značenju…',
    'Find saved work by meaning…': 'Pronađite spremljeni rad prema značenju…',
    'Search coverage is limited while indexing or meaning-based search is unavailable. You can retry or browse recent items.':
      'Pretraživanje je ograničeno dok je indeksiranje u tijeku ili pretraživanje prema značenju nije dostupno. Možete pokušati ponovno ili pregledati nedavne stavke.',
    'No matching work found.': 'Nije pronađen odgovarajući rad.',
    'A starting point for your next question.': 'Polazišna točka za vaše sljedeće pitanje.',
    'Good work is worth keeping.': 'Dobar rad vrijedi sačuvati.',
    'Try a different description or clear the search to browse.':
      'Pokušajte s drukčijim opisom ili izbrišite pretraživanje za pregled sadržaja.',
    'Upload source material once and use it in conversations and Skills. Your original stays in the library.':
      'Prenesite izvorni materijal jednom i koristite ga u razgovorima i vještinama. Izvornik ostaje u biblioteci.',
    'Ask Poneva to save an answer, table or chart. Results stay connected to the conversation and their sources.':
      'Zatražite od Poneve da spremi odgovor, tablicu ili grafikon. Rezultati ostaju povezani s razgovorom i svojim izvorima.',
    'Start in chat {value1}': 'Započni u chatu {value1}',
    'Open result: {value1}': 'Otvori rezultat: {value1}',
    'Loading more library items…': 'Učitavanje dodatnih stavki biblioteke…',
    'Load more': 'Učitaj još',
    'Documents, transcripts, audio and video · Up to 500 MB per file. New files are private. Choose their audience with Share and which processable files become searchable company knowledge.':
      'Dokumenti, transkripti, audiozapisi i videozapisi · Do 500 MB po datoteci. Nove su datoteke privatne. Odaberite njihovu publiku opcijom Dijeli i odredite koje datoteke koje je moguće obraditi postaju pretraživo znanje tvrtke.',
    Skills: 'Vještine',
    'Create in chat': 'Izradi u chatu',
    'Search Skills': 'Pretraži vještine',
    'Search finds published Skills. Clear the search to browse your drafts too.':
      'Pretraživanje pronalazi objavljene vještine. Izbrišite pretraživanje da biste pregledali i svoje skice.',
    'Search coverage is limited while indexing or meaning-based search is unavailable.':
      'Pokrivenost pretraživanja ograničena je dok indeksiranje ili pretraživanje prema značenju nije dostupno.',
    'Searching Skills…': 'Pretraživanje vještina…',
    'No matching published Skills found. Try a different description.':
      'Nije pronađena nijedna odgovarajuća objavljena vještina. Isprobajte drugačiji opis.',
    'Load more Skills': 'Učitaj još vještina',
    'View Skill: {value1}': 'Prikaži vještinu: {value1}',
    'Company workspace': 'Radni prostor tvrtke',
    'View {value1}': 'Prikaži {value1}',
    'Loading Skills…': 'Učitavanje vještina…',
    'Try again {value1}': 'Pokušaj ponovno {value1}',
    'Try again': 'Pokušaj ponovno',
    'Nothing yet.': 'Još nema ničega.',
    'Made from · Used by': 'Izrađeno od · Upotrebljavaju',
    'Could not load links': 'Nije moguće učitati poveznice',
    'Made from': 'Izrađeno od',
    'Used by': 'Upotrebljavaju',
    'About this chat {value1}': 'O ovom chatu {value1}',
    'About this chat': 'O ovom chatu',
    'Keep the work moving.': 'Nastavite s radom.',
    'Ask a follow-up with this result in view, or turn a useful approach into a company Skill.':
      'Postavite dodatno pitanje dok je ovaj rezultat prikazan ili pretvorite koristan pristup u vještinu tvrtke.',
    'Save approach as a Skill': 'Spremi pristup kao vještinu',
    'Preview of': 'Pretpregled:',
    'Made with': 'Izrađeno pomoću',
    'Open the draft': 'Otvori skicu',
    'Open Skill': 'Otvori vještinu',
    'Use in chat': 'Upotrijebi u chatu',
    'Finish the draft': 'Dovrši skicu',
    'Refine this Skill': 'Doradi ovu vještinu',
    'Made with a Skill.': 'Izrađeno pomoću vještine.',
    'This workspace could not be loaded just now, so that Skill cannot be opened yet. The result itself is unchanged.':
      'Ovaj se radni prostor trenutačno nije mogao učitati pa se ta vještina još ne može otvoriti. Sam rezultat nije promijenjen.',
    'That Skill is not available in this workspace, so it cannot be opened or used again. The result itself is unchanged.':
      'Ta vještina nije dostupna u ovom radnom prostoru pa se ne može otvoriti ni ponovno upotrijebiti. Sam rezultat nije promijenjen.',
    'Result · {value1} {value2}': 'Rezultat · {value1} {value2}',
    '{value1} Copy link': '{value1} Kopiraj poveznicu',
    'Result link copied.': 'Poveznica rezultata kopirana je.',
    'Could not copy the link. Use your browser address bar.':
      'Poveznicu nije moguće kopirati. Upotrijebite adresnu traku preglednika.',
    'No preview is available for this result.': 'Pretpregled ovog rezultata nije dostupan.',
    '{value1} rows are retained in this snapshot. Open Table to inspect the values.':
      'U ovoj je snimci zadržano redaka: {value1}. Otvorite Tablicu da biste pregledali vrijednosti.',
    'People can’t edit a Result an agent keeps up to date; the next refresh would replace their edit. Change the agent’s instructions instead.':
      'Korisnici ne mogu uređivati rezultat koji agent održava ažurnim; sljedeće bi osvježavanje zamijenilo njihove izmjene. Umjesto toga promijenite upute agenta.',
    'Linked sources': 'Povezani izvori',
    'Saved source': 'Spremljeni izvor',
    'No source documents are linked to this result. Company knowledge and other references may be cited in the answer.':
      'S ovim rezultatom nisu povezani izvorni dokumenti. U odgovoru se mogu navesti znanje tvrtke i drugi izvori.',
    'Run details': 'Pojedinosti izvođenja',
    Created: 'Izrađeno',
    ', revised {value1}': ', revidirano {value1}',
    Conversation: 'Razgovor',
    'Not recorded': 'Nije zabilježeno',
    'Open conversation': 'Otvori razgovor',
    Run: 'Pokreni',
    Updates: 'Ažuriranja',
    'Kept up to date by {value1}': 'Ažurira {value1}',
    'Version {value1}': 'Verzija {value1}',
    'Could not open this request.': 'Ovaj zahtjev nije moguće otvoriti.',
    'Approved version published.': 'Odobrena verzija objavljena je.',
    'Request rejected. The item stays unchanged.':
      'Zahtjev je odbijen. Stavka ostaje nepromijenjena.',
    'Could not save the decision.': 'Odluku nije moguće spremiti.',
    'Proposed company change': 'Predložena promjena tvrtke',
    'Opening…': 'Otvaranje…',
    'Approve this version': 'Odobri ovu verziju',
    Decline: 'Odbij',
    'Review the submitted version below. Changes made since submission will need a new request.':
      'U nastavku pregledajte poslanu verziju. Za promjene napravljene nakon slanja bit će potreban novi zahtjev.',
    'The version submitted with this request.': 'Verzija poslana s ovim zahtjevom.',
    'Version and proposed change': 'Verzija i predložena promjena',
    'Could not read the pinned content.': 'Prikvačeni sadržaj nije moguće pročitati.',
    'Showing a page of {value1} characters.': 'Prikazuje se stranica s {value1} znakova.',
    'Beginning of the submitted content. Open the full text to review every page.':
      'Početak poslanog sadržaja. Otvorite cijeli tekst da biste pregledali svaku stranicu.',
    'Read full submitted text': 'Pročitaj cijeli poslani tekst',
    'Previous page': 'Prethodna stranica',
    'Next page': 'Sljedeća stranica',
    'Made private. Its creator has been told in their Inbox.':
      'Postavljeno je kao privatno. Autor je obaviješten u svom ulaznom sandučiću.',
    'Made private. Its creator could not be notified.':
      'Postavljeno je kao privatno. Autor nije mogao biti obaviješten.',
    'Make this {value1} private?': 'Želite li ovo učiniti privatnim: {value1}?',
    'Only the person who created it will see it. Everyone else loses access right away, and its creator gets an Inbox update if they are still a company member. If they have left, nobody in the company will be able to access this item.':
      'Vidjet će ga samo osoba koja ga je izradila. Svi ostali odmah gube pristup, a autor će dobiti ažuriranje u ulaznom sandučiću ako je još član tvrtke. Ako je napustio tvrtku, nitko u tvrtki neće moći pristupiti ovoj stavci.',
    'Sent for review. The current audience stays unchanged until approval.':
      'Poslano na pregled. Trenutačna publika ostaje nepromijenjena do odobrenja.',
    'This suggestion is no longer available to you.': 'Ovaj vam prijedlog više nije dostupan.',
    'We could not check where this suggestion stands.':
      'Nismo mogli provjeriti status ovog prijedloga.',
    'Check again': 'Provjeri ponovno',
    'Show on page': 'Prikaži na stranici',
    'The editor could not be loaded. Poneva may have been updated since you opened this page. Reload to get the latest version; nothing on this page has changed.':
      'Uređivač se nije mogao učitati. Poneva je možda ažurirana otkad ste otvorili ovu stranicu. Ponovno učitajte najnoviju verziju; ništa na ovoj stranici nije promijenjeno.',
    'Reload Poneva': 'Ponovno učitaj Ponevu',
    Formatting: 'Oblikovanje',
    'Text style': 'Stil teksta',
    Text: 'Tekst',
    Heading: 'Naslov',
    Subheading: 'Podnaslov',
    'Link a page': 'Poveži stranicu',
    'A page needs a title.': 'Stranica treba imati naslov.',
    'Nothing has changed yet.': 'Još se ništa nije promijenilo.',
    'A page needs some text. To remove a page, archive it instead.':
      'Stranica treba sadržavati tekst. Da biste uklonili stranicu, arhivirajte je.',
    'A suggested new page needs some text.': 'Predložena nova stranica treba sadržavati tekst.',
    'This page is larger than 256 KB. Split it into smaller pages.':
      'Ova je stranica veća od 256 KB. Podijelite je na manje stranice.',
    'Say in a few words why this change is right.':
      'U nekoliko riječi objasnite zašto je ova promjena ispravna.',
    'This page changed while you were editing. Your text is still here: copy it, then open the latest version and make your change again.':
      'Ova se stranica promijenila dok ste je uređivali. Vaš je tekst i dalje ovdje: kopirajte ga, zatim otvorite najnoviju verziju i ponovno unesite promjenu.',
    'Your text is copied.': 'Vaš je tekst kopiran.',
    'Your text could not be copied. Select it in the editor and copy it.':
      'Vaš se tekst nije mogao kopirati. Odaberite ga u uređivaču i kopirajte.',
    'The page “{value1}” is created.': 'Stranica „{value1}” je stvorena.',
    'New page': 'Nova stranica',
    'Editing {value1}': 'Uređivanje stranice {value1}',
    Editing: 'Uređivanje',
    'Creating publishes the page under {value1} for everyone':
      'Stvaranjem se stranica objavljuje pod {value1} za sve',
    'Saving publishes the new version for everyone': 'Spremanjem se nova verzija objavljuje za sve',
    'Your changes are sent as a suggestion for a publisher':
      'Vaše se promjene šalju kao prijedlog izdavaču',
    'Create page': 'Stvori stranicu',
    Save: 'Spremi',
    'Send suggestion': 'Pošalji prijedlog',
    '{value1} Copy my text': '{value1} Kopiraj moj tekst',
    'Open the latest version': 'Otvori najnoviju verziju',
    'Page title': 'Naslov stranice',
    'Loading the editor…': 'Učitavanje uređivača…',
    'New page text': 'Tekst nove stranice',
    'Text of {value1}': 'Tekst stranice {value1}',
    'Write the page. Type [[ to link another page.':
      'Napišite sadržaj stranice. Upišite [[ da biste povezali drugu stranicu.',
    'Type [[ to link another page.': 'Upišite [[ da biste povezali drugu stranicu.',
    'Link to a page': 'Poveži sa stranicom',
    'What changed, in a few words': 'Što se promijenilo, ukratko',
    'Where this comes from, in a few words': 'Odakle ovo dolazi, ukratko',
    'Shown in the page history.': 'Prikazuje se u povijesti stranice.',
    'A publisher sees this next to your change.': 'Izdavač ovo vidi pokraj vaše promjene.',
    '1 suggestion is open on this page': '1 prijedlog otvoren je na ovoj stranici',
    '{value1} suggestions are open on this page':
      '{value1} prijedloga otvoreno je na ovoj stranici',
    'They stay open while you edit. After you save, they show against your new text; one whose words you changed is marked outdated.':
      'Ostaju otvoreni dok uređujete. Nakon spremanja prikazuju se uz vaš novi tekst; prijedlog čije ste riječi promijenili označava se kao zastario.',
    'Type [[ to link another page. Links keep working when a page is renamed or moved.':
      'Upišite [[ da biste povezali drugu stranicu. Veze nastavljaju funkcionirati kada se stranica preimenuje ili premjesti.',
    'Loading the history…': 'Učitavanje povijesti…',
    'This page has no saved text yet.': 'Ova stranica još nema spremljen tekst.',
    'Say in a few words why this revision should come back.':
      'U nekoliko riječi objasnite zašto bi se ova revizija trebala vratiti.',
    'Revision {value1} is suggested for a publisher to accept.':
      'Revizija {value1} predlaže se izdavaču na prihvaćanje.',
    'The page already reads like this revision.': 'Stranica već izgleda kao ova revizija.',
    'Revision {value1} is restored as revision {value2}.':
      'Revizija {value1} vraćena je kao revizija {value2}.',
    'Revision history': 'Povijest revizija',
    Revisions: 'Revizije',
    'Every saved revision is kept.': 'Svaka spremljena revizija se čuva.',
    'Revision {value1} {value2}': 'Revizija {value1} {value2}',
    'Revision {value1} compared with revision {value2}':
      'Revizija {value1} u usporedbi s revizijom {value2}',
    'Revision {value1}, the first text of this page': 'Revizija {value1}, prvi tekst ove stranice',
    'Green was added, struck through was removed.': 'Zeleno je dodano, a precrtano uklonjeno.',
    '{value1} Export Markdown': '{value1} Izvezi Markdown',
    'Restore this revision': 'Vrati ovu reviziju',
    'Suggest restoring it': 'Predloži vraćanje',
    'Why should this revision come back?': 'Zašto bi se ova revizija trebala vratiti?',
    'Loading this revision…': 'Učitavanje ove revizije…',
    'Only the title changed, from “{value1}” to “{value2}”.':
      'Promijenio se samo naslov, s „{value1}” na „{value2}”.',
    'The text did not change in this revision.': 'Tekst se u ovoj reviziji nije promijenio.',
    'Changes in revision {value1}': 'Promjene u reviziji {value1}',
    'Loading page…': 'Učitavanje stranice…',
    'Loading suggestion…': 'Učitavanje prijedloga…',
    'This suggestion is not available.': 'Ovaj prijedlog nije dostupan.',
    'It may have been decided, or it is not one you can see.':
      'Možda je o njemu već odlučeno ili ga ne možete vidjeti.',
    'Open Knowledge': 'Otvori Knowledge',
    'Opening the suggestion…': 'Otvaranje prijedloga…',
    'Choose where the page goes.': 'Odaberite kamo stranica ide.',
    'Say in a few words why.': 'U nekoliko riječi objasnite zašto.',
    'Your suggestion is sent. A publisher decides.': 'Vaš je prijedlog poslan. Izdavač odlučuje.',
    'Moved under {value1}.': 'Premješteno pod {value1}.',
    'Deleted “{value1}”.': 'Izbrisano: „{value1}”.',
    'Could not update sharing.': 'Dijeljenje nije moguće ažurirati.',
    'They can follow new answers live and fork it to continue with their own connections. Only you write here. You can make it private again at any time.':
      'Mogu uživo pratiti nove odgovore i izraditi vlastitu kopiju kako bi nastavili s vlastitim vezama. Ovdje pišete samo vi. U bilo kojem trenutku možete ponovno postaviti privatnost.',
    'They see the project, its brief and the work in it they can already open. Nothing in it opens for anyone because of the project; each item keeps its own access.':
      'Vide projekt, njegov sažetak i radove u njemu koje već mogu otvoriti. Ništa se u projektu ne otvara drugima samo zbog projekta; svaka stavka zadržava vlastiti pristup.',
    'Check the content for private information before sharing. Sharing an item does not grant access to its original chat or private connections.':
      'Prije dijeljenja provjerite sadrži li sadržaj privatne informacije. Dijeljenje stavke ne daje pristup izvornom razgovoru ni privatnim vezama.',
    '{value1} Everyone you share with can read it, including what the assistant or an App in it found in your {value2}. They can’t use your {value3}. Nothing changes for you: the chat keeps working with all your accounts.':
      '{value1} Svi s kojima podijelite mogu to pročitati, uključujući ono što su pomoćnik ili aplikacija u tome pronašli u vašem {value2}. Ne mogu upotrebljavati vaš {value3}. Za vas se ništa ne mijenja: razgovor i dalje radi sa svim vašim računima.',
    '{value1} Everyone you share with can read them, but nobody can use {value2} through this chat.':
      '{value1} Svi s kojima ih podijelite mogu ih pročitati, ali nitko ne može upotrebljavati {value2} putem ovog razgovora.',
    'This controls access to the working draft. Any published company version stays available until you explicitly unpublish it. To publish a new version, complete its preview and use Save Skill. Run results stay private.':
      'Ovim se upravlja pristupom radnoj skici. Svaka objavljena verzija tvrtke ostaje dostupna dok je izričito ne povučete iz objave. Da biste objavili novu verziju, dovršite njezin pregled i upotrijebite Spremi vještinu. Rezultati pokretanja ostaju privatni.',
    'Skill deleted. You can restore it from the Skills archive for 30 days.':
      'Vještina je izbrisana. Možete je vratiti iz arhive vještina u roku od 30 dana.',
    'Could not delete this Skill.': 'Ovu vještinu nije moguće izbrisati.',
    'More actions': 'Više radnji',
    'Delete “{value1}”? It will disappear from Skills and search, and cannot be used by agents. You can restore it for 30 days. Existing chats and results stay available.':
      'Izbrisati „{value1}”? Nestat će iz vještina i pretraživanja te je agenti neće moći upotrebljavati. Možete je vratiti u roku od 30 dana. Postojeći razgovori i rezultati ostaju dostupni.',
    'Deleting…': 'Brisanje…',
    'Confirm delete': 'Potvrdi brisanje',
    'Delete Skill': 'Izbriši vještinu',
    'Skill restored as an unpublished draft. Its author can review and publish it again.':
      'Vještina je vraćena kao neobjavljena skica. Njezin autor može je pregledati i ponovno objaviti.',
    'Could not restore this Skill.': 'Ovu vještinu nije moguće vratiti.',
    'Archived Skills': 'Arhivirane vještine',
    'Deleted Skills can be restored for 30 days. Restoring leaves them unpublished.':
      'Izbrisane vještine mogu se vratiti u roku od 30 dana. Vraćanjem ostaju neobjavljene.',
    'Restore until {value1}': 'Vrati do {value1}',
    'Loading…': 'Učitavanje…',
    'No archived Skills.': 'Nema arhiviranih vještina.',
    'Load more archived Skills': 'Učitaj još arhiviranih vještina',
    'Show more of the original': 'Prikaži više izvornika',
    'Filter result rows': 'Filtriraj retke rezultata',
    'Find a product or value…': 'Pronađite proizvod ili vrijednost…',
    '{value1} of {value2}': '{value1} od {value2}',
    'Result table': 'Tablica rezultata',
    'No matching rows.': 'Nema podudarajućih redaka.',
    'Showing the first 1,000 matching rows. Download the CSV for every row.':
      'Prikazano je prvih 1.000 podudarajućih redaka. Preuzmite CSV za sve retke.',
    'Agent ·': 'Agent ·',
    'Only you': 'Samo vi',
    'Stopped before it finished.': 'Zaustavljeno prije dovršetka.',
    'Drafting the project…': 'Izrada skice projekta…',
    'Checking where this chat belongs…': 'Provjera kamo ovaj razgovor pripada…',
    'Moving the chat…': 'Premještanje razgovora…',
    'Taking it out of the project…': 'Uklanjanje iz projekta…',
    'Adding it to the project…': 'Dodavanje u projekt…',
    'No matching connections are available right now.':
      'Trenutačno nema dostupnih podudarajućih veza.',
    'Company knowledge suggestion': 'Prijedlog znanja tvrtke',
    'Company knowledge now lives on pages. Open Knowledge to see them.':
      'Znanje tvrtke sada se nalazi na stranicama. Otvorite Znanje da biste ih vidjeli.',
    '{value1} · Open beside this conversation': '{value1} · Otvori pokraj ovog razgovora',
    'Name {value1}': 'Naziv {value1}',
    'Host {value1}': 'Poslužitelj {value1}',
    'Port {value1}': 'Priključak {value1}',
    'Database {value1}': 'Baza podataka {value1}',
    'Username {value1}': 'Korisničko ime {value1}',
    'Password {value1}': 'Lozinka {value1}',
    'Advanced TLS': 'Napredni TLS',
    '{value1} Poneva verifies the server certificate. Add a CA or server DNS name for IP hosts when your certificate requires it.':
      '{value1} Poneva provjerava certifikat poslužitelja. Dodajte CA ili DNS naziv poslužitelja za IP poslužitelje kada to vaš certifikat zahtijeva.',
    'CA certificate {value1}': 'CA certifikat {value1}',
    'Certificate server DNS name {value1}': 'DNS naziv poslužitelja certifikata {value1}',
    '{value1} Your password is encrypted in secure storage. Poneva verifies the connection before saving it.':
      '{value1} Vaša je lozinka šifrirana i pohranjena na sigurnom mjestu. Poneva provjerava vezu prije spremanja.',
    'Testing…': 'Testiranje…',
    'Test connection': 'Testiraj vezu',
    'PostgreSQL is connected.': 'PostgreSQL je povezan.',
    'PostgreSQL was saved safely.': 'PostgreSQL je sigurno spremljen.',
    'Poneva can read and change rows in the selected tables. Apps also follow their approved data scope.':
      'Poneva može čitati i mijenjati retke u odabranim tablicama. Aplikacije također slijede svoj odobreni opseg podataka.',
    'Poneva can read the selected tables. Apps also follow their approved data scope.':
      'Poneva može čitati odabrane tablice. Aplikacije također slijede svoj odobreni opseg podataka.',
    'Reads are paused until permission is enabled.':
      'Čitanje je pauzirano dok se ne omogući dozvola.',
    'Retrying…': 'Ponovni pokušaj…',
    'Retry permission': 'Ponovi dozvolu',
    'Try it in Chat': 'Isprobaj u razgovoru',
    Done: 'Gotovo',
    'Disconnect database': 'Odspoji bazu podataka',
    '{value1} TLS verified ·{value2} {value3}': '{value1} TLS potvrđen ·{value2} {value3}',
    'Search schemas and tables': 'Pretraži sheme i tablice',
    'Search tables': 'Pretraži tablice',
    '{value1} of {value2} tables selected': 'Odabrano je {value1} od {value2} tablica',
    'Select matching tables': 'Odaberi podudarajuće tablice',
    'Select all tables': 'Odaberi sve tablice',
    Clear: 'Očisti',
    'Select a whole schema or individual tables. New tables need a fresh selection.':
      'Odaberite cijelu shemu ili pojedinačne tablice. Za nove tablice potreban je novi odabir.',
    'No tables match this search.': 'Nijedna tablica ne odgovara ovom pretraživanju.',
    'All tables in {value1}': 'Sve tablice u {value1}',
    '{value1} / {value2} tables': '{value1} / {value2} tablica',
    'Read & write available': 'Dostupno čitanje i pisanje',
    'Read only': 'Samo za čitanje',
    Ctrl: 'Ctrl',
    'This suggested knowledge update could not be shown.':
      'Ovaj predloženi dodatak znanju nije moguće prikazati.',
    'Suggested knowledge update': 'Predloženi dodatak znanju',
    'Suggestion {value1} of {value2}': 'Prijedlog {value1} od {value2}',
    'Next suggestion': 'Sljedeći prijedlog',
    'Fold the suggestions away': 'Sakrij prijedloge',
    'Show the suggestions': 'Prikaži prijedloge',
    '1 suggestion': '1 prijedlog',
    '{value1} suggestions': '{value1} prijedloga',
    '{value1} the pages under {value2}': '{value1} stranica pod {value2}',
    px: 'px',
    '{value1} chart of {value2} across {value3}': '{value1} grafikon za {value2} kroz {value3}',
    'We could not build the file.': 'Nismo mogli izraditi datoteku.',
    '{value1} Present': '{value1} prezentacija',
    'Building…': 'Izrada…',
    'Download PowerPoint': 'Preuzmi PowerPoint',
    'Slide {value1} of {value2}': 'Slajd {value1} od {value2}',
    Slides: 'Slajdovi',
    'Slide {value1}': 'Slajd {value1}',
    'Speaker notes': 'Bilješke govornika',
    'Source: {value1}': 'Izvor: {value1}',
    'Add a name and a web address.': 'Dodajte naziv i web-adresu.',
    'Enter a valid web address.': 'Unesite valjanu web-adresu.',
    'Use a web address that starts with https://.':
      'Upotrijebite web-adresu koja počinje s https://.',
    'Add a custom connection': 'Dodaj prilagođenu vezu',
    'Connect a tool server you trust. Poneva checks the address works and saves only the connection details needed to use it.':
      'Povežite poslužitelj alata kojem vjerujete. Poneva provjerava funkcionira li adresa i sprema samo podatke o vezi potrebne za njegovo korištenje.',
    'Web address': 'Web-adresa',
    'https://tools.example.com': 'https://tools.example.com',
    'Starts with https://, from your provider': 'Počinje s https://, od vašeg pružatelja usluge',
    'Sign-in': 'Prijava',
    'Advanced sign-in': 'Napredna prijava',
    'Access key {value1}': 'Pristupni ključ {value1}',
    'Request headers': 'Zaglavlja zahtjeva',
    'Add header': 'Dodaj zaglavlje',
    'Header {value1} name': 'Naziv zaglavlja {value1}',
    'Header name': 'Naziv zaglavlja',
    'Header {value1} value': 'Vrijednost zaglavlja {value1}',
    'Header value': 'Vrijednost zaglavlja',
    'Remove header': 'Ukloni zaglavlje',
    Advanced: 'Napredno',
    Transport: 'Prijenos',
    'Auto-detect': 'Automatski prepoznaj',
    'Streamable HTTP': 'HTTP koji podržava strujanje',
    'Legacy SSE': 'Naslijeđeni SSE',
    "From your provider's app settings. Leave empty unless they gave you these.":
      'U postavkama aplikacije vašeg pružatelja usluge. Ostavite prazno osim ako vam ih je pružatelj dao.',
    "Authorization server issuer": "Izdavatelj autorizacijskog poslužitelja",
    "Enter the authorization server issuer when using a client ID.": "Unesite izdavatelja autorizacijskog poslužitelja kada koristite ID klijenta.",
    'Client ID {value1}': 'ID klijenta {value1}',
    'Client secret {value1}': 'Tajna klijenta {value1}',
    'Connecting…': 'Povezivanje…',
    'Test and connect': 'Testiraj i poveži',
    'Add the store, the client ID and the client secret.':
      'Dodajte trgovinu, ID klijenta i tajnu klijenta.',
    'Connect your Shopify Developer App': 'Povežite svoju razvojnu aplikaciju za Shopify',
    'Poneva can use exactly the access your store gave the app, and nothing more. It talks to Shopify directly and keeps the client secret encrypted.':
      'Poneva može koristiti točno one dozvole koje je vaša trgovina dodijelila aplikaciji i ništa više. Izravno komunicira sa Shopifyjem i čuva tajnu klijenta šifriranom.',
    'How to create the app in Shopify': 'Kako izraditi aplikaciju u Shopifyju',
    'Open{value1} {value2}{value3} with the account that owns the store, and create an app.':
      'Otvorite{value1} {value2}{value3} računom koji je vlasnik trgovine i izradite aplikaciju.',
    'Create a version and select the access scopes Poneva may use, for example read_products and read_orders. Add write_ scopes only for data Poneva may change. Then release the version.':
      'Izradite verziju i odaberite opsege pristupa koje Poneva smije koristiti, primjerice read_products i read_orders. Opsege write_ dodajte samo za podatke koje Poneva smije mijenjati. Zatim objavite verziju.',
    'For orders and customers, also select protected customer data in the app’s settings. Shopify allows this without review for an app made for your own store.':
      'Za narudžbe i kupce u postavkama aplikacije odaberite i zaštićene podatke o kupcima. Shopify to dopušta bez provjere za aplikaciju izrađenu za vašu vlastitu trgovinu.',
    'Install the app on your store.': 'Instalirajte aplikaciju u svoju trgovinu.',
    'Copy the client ID and client secret from the app’s settings.':
      'Kopirajte ID klijenta i tajnu klijenta iz postavki aplikacije.',
    'To change the access later, release a new version, approve it on the store and use Test connection here.':
      'Da biste poslije promijenili dozvole, objavite novu verziju, odobrite je u trgovini i ovdje upotrijebite opciju Testiraj vezu.',
    Store: 'Trgovina',
    'your-store.myshopify.com': 'your-store.myshopify.com',
    'Your store’s .myshopify.com address (Shopify admin → Settings → Domains), or paste the address of your Shopify admin page':
      'Adresa vaše trgovine .myshopify.com (Shopify administrator → Postavke → Domene) ili zalijepite adresu stranice Shopify administratora',
    'Client ID {value1} {value2}': 'ID klijenta {value1} {value2}',
    'Client secret {value1} {value2}': 'Tajna klijenta {value1} {value2}',
    Person: 'Osoba',
    Everyone: 'Svi',
    Connection: 'Veza',
    'All connections': 'Sve veze',
    'App {value1}': 'Aplikacija {value1}',
    'From {value1}': 'Od {value1}',
    'Until {value1}': 'Do {value1}',
    Result: 'Rezultat',
    'All results': 'Svi rezultati',
    Succeeded: 'Uspješno',
    Denied: 'Odbijeno',
    Failed: 'Neuspješno',
    Unknown: 'Nepoznato',
    Filter: 'Filtar',
    'Loading activity…': 'Učitavanje aktivnosti…',
    'Could not load activity. Try again.': 'Aktivnost se nije mogla učitati. Pokušajte ponovno.',
    'Removed connection': 'Uklonjena veza',
    'App: {value1}': 'Aplikacija: {value1}',
    'Older activity': 'Starija aktivnost',
    'Archived. Its history is kept.': 'Arhivirano. Povijest je sačuvana.',
    'Choose the page it goes under. Links to it keep working.':
      'Odaberite stranicu ispod koje ide. Poveznice na nju i dalje rade.',
    'Its text, its history and any open suggestions are removed for good, and links to it from other pages stop working. This cannot be undone.':
      'Njezin tekst, povijest i svi otvoreni prijedlozi trajno se uklanjaju, a poveznice na nju s drugih stranica prestaju raditi. Ovo se ne može poništiti.',
    'An archived page no longer informs answers. Its history is kept, and a publisher can restore it or delete it permanently.':
      'Arhivirana stranica više ne utječe na odgovore. Povijest je sačuvana, a izdavač je može vratiti ili trajno izbrisati.',
    Under: 'Ispod',
    Change: 'Promijeni',
    'Move under': 'Premjesti ispod',
    'Search pages': 'Pretraži stranice',
    'Why?': 'Zašto?',
    'Delete permanently': 'Trajno izbriši',
    'Move page': 'Premjesti stranicu',
    'Archive page': 'Arhiviraj stranicu',
    'Suggestion {value1}: show its card': 'Prijedlog {value1}: prikaži njegovu karticu',
    'Removed:': 'Uklonjeno:',
    'Added:': 'Dodano:',
    'New page “{value1}”{value2}': 'Nova stranica „{value1}”{value2}',
    'No pages match “{value1}”.': 'Nema stranica koje odgovaraju „{value1}“.',
    'Where this page is': 'Gdje se ova stranica nalazi',
    'Describe your company': 'Opišite svoju tvrtku',
    'Empty page': 'Prazna stranica',
    'Describe {value1}': 'Opišite {value1}',
    'This page has no text yet.': 'Ova stranica još nema teksta.',
    'Poneva reads this page before every answer. Start with who you are, what you sell and how you work; details go on the pages under it.':
      'Poneva čita ovu stranicu prije svakog odgovora. Započnite s time tko ste, što prodajete i kako radite; pojedinosti dodajte na stranice ispod nje.',
    'Write it, or ask Poneva in chat to draft it for you.':
      'Napišite ga ili zamolite Ponevu u chatu da ga napiše umjesto vas.',
    'Suggest a first version, and a publisher decides whether it becomes the page.':
      'Predložite prvu verziju, a izdavač odlučuje hoće li ona postati stranica.',
    'Start writing': 'Započni pisanje',
    'Suggest a first version': 'Predloži prvu verziju',
    'Accepted. The page is archived.': 'Prihvaćeno. Stranica je arhivirana.',
    'Accepted. The page is now revision {value1}.':
      'Prihvaćeno. Stranica je sada revizija {value1}.',
    'Accepted.': 'Prihvaćeno.',
    'Suggestion rejected. The page stays as it is.':
      'Prijedlog je odbijen. Stranica ostaje nepromijenjena.',
    'Your suggestion is withdrawn.': 'Vaš je prijedlog povučen.',
    'Restored. The page informs answers again.': 'Vraćeno. Stranica ponovno utječe na odgovore.',
    'Your suggestion is sent. A publisher decides whether it becomes the page.':
      'Vaš je prijedlog poslan. Izdavač odlučuje hoće li on postati stranica.',
    'Saved. The page is now revision {value1}.': 'Spremljeno. Stranica je sada revizija {value1}.',
    'Nothing changed.': 'Ništa se nije promijenilo.',
    'This page is not available.': 'Ova stranica nije dostupna.',
    'It may have been deleted, archived or moved out of reach, or you may no longer be in this company.':
      'Možda je izbrisana, arhivirana ili premještena izvan vašeg dosega, ili više niste u ovoj tvrtki.',
    'Page actions': 'Radnje na stranici',
    shown: 'prikazano',
    hidden: 'skriveno',
    '{value1} History': '{value1} Povijest',
    '{value1} Ask in chat': '{value1} Pitaj u chatu',
    'Suggest edits': 'Predloži izmjene',
    'More actions for {value1}': 'Više radnji za {value1}',
    '{value1} Poneva reads this page in every chat':
      '{value1} Poneva čita ovu stranicu u svakom chatu',
    'This page is archived. It no longer informs answers; its history is kept. {value1}':
      'Ova je stranica arhivirana. Više ne utječe na odgovore; njezina je povijest sačuvana. {value1}',
    'Restore page': 'Vrati stranicu',
    'This link points to an earlier revision. You are reading the current text.':
      'Ova poveznica vodi na raniju reviziju. Čitate trenutačni tekst.',
    'Show it in History': 'Prikaži u Povijesti',
    Pages: 'Stranice',
    'Pages under {value1}': 'Stranice ispod {value1}',
    'Linked from': 'Povezano s',
    Suggestions: 'Prijedlozi',
    'Suggestions are hidden. You are reading the page as everyone else sees it.':
      'Prijedlozi su skriveni. Stranicu čitate onako kako je vide svi ostali.',
    'Loading suggestions…': 'Učitavanje prijedloga…',
    'Nothing is waiting for review.': 'Ništa ne čeka na pregled.',
    'When someone, Poneva in a chat or a connected agent suggests a change to a page, it shows here and on the page. Nothing changes until a publisher accepts it.':
      'Kada netko, Poneva u chatu ili povezani agent predloži izmjenu stranice, ona se prikazuje ovdje i na stranici. Ništa se ne mijenja dok je izdavač ne prihvati.',
    '{value1} Review knowledge in chat': '{value1} Pregledaj znanje u chatu',
    'Suggestions for review': 'Prijedlozi za pregled',
    'Suggested changes from chats, meetings, colleagues and connected agents. Nothing changes until a publisher accepts it on the page.':
      'Predložene izmjene iz chatova, sastanaka, od kolega i povezanih agenata. Ništa se ne mijenja dok ih izdavač ne prihvati na stranici.',
    'Your suggestions wait here until a publisher decides. The pages stay as they are until then.':
      'Vaši prijedlozi ovdje čekaju odluku izdavača. Stranice do tada ostaju nepromijenjene.',
    'Review page': 'Pregledaj stranicu',
    'Review on page': 'Pregledaj na stranici',
    'Open the meeting': 'Otvori sastanak',
    'Open the chat': 'Otvori chat',
    'Accept and restore': 'Prihvati i vrati',
    Accept: 'Prihvati',
    Reject: 'Odbij',
    'Your suggestion · waiting for a publisher': 'Vaš prijedlog · čeka izdavača',
    Withdraw: 'Povuci',
    'Waiting for a publisher': 'Čeka izdavača',
    'Suggestion {value1}': 'Prijedlog {value1}',
    'Suggestion {value1} from {value2}{value3}': 'Prijedlog {value1} od {value2}{value3}',
    'Read the suggested page': 'Pročitaj predloženu stranicu',
    'Outdated: the text it changes was edited after it was suggested. It can be rejected or withdrawn; a new suggestion can be made against the current text.':
      'Zastarjelo: tekst koji mijenja uređen je nakon slanja prijedloga. Prijedlog se može odbiti ili povući; novi se prijedlog može izraditi na temelju trenutačnog teksta.',
    'Restore this page first to accept this suggestion.':
      'Najprije vratite ovu stranicu da biste prihvatili ovaj prijedlog.',
    'Previous suggestion': 'Prethodni prijedlog',
    Download: 'Preuzmi',
    CSV: 'CSV',
    'Evidence for {value1}': 'Dokaz za {value1}',
    Measure: 'Mjera',
    'Show rows →': 'Prikaži retke →',
    'Ask about this number': 'Pitajte o ovom broju',
    'There are no numeric values available to chart. View the table for the original data.':
      'Nema dostupnih numeričkih vrijednosti za grafikon. Pogledajte tablicu s izvornim podacima.',
    'Chart value': 'Vrijednost grafikona',
    '{value1} of {value2} shown': 'Prikazano: {value1} od {value2}',
    '{value1} by {value2}; {value3} rows. View Table for exact values.':
      '{value1} prema {value2}; {value3} redaka. Za točne vrijednosti pogledajte tablicu.',
    'Values come directly from the source data. Missing values are not estimates.':
      'Vrijednosti dolaze izravno iz izvornih podataka. Vrijednosti koje nedostaju nisu procjene.',
    'Loading library…': 'Učitavanje biblioteke…',
    'We couldn’t load what happened in this App. Try again in a moment.':
      'Nismo mogli učitati što se dogodilo u ovoj aplikaciji. Pokušajte ponovno za trenutak.',
    'This App could not be opened.': 'Ovu aplikaciju nije moguće otvoriti.',
    'Opening App…': 'Otvaranje aplikacije…',
    'Open the saved App to run this function.':
      'Otvorite spremljenu aplikaciju da biste pokrenuli ovu funkciju.',
    'Save this App before running its function.':
      'Spremite ovu aplikaciju prije pokretanja njezine funkcije.',
    'Open saved App': 'Otvori spremljenu aplikaciju',
    'Open Apps': 'Otvori aplikacije',
    'The App could not be opened. Try again.':
      'Aplikaciju nije moguće otvoriti. Pokušajte ponovno.',
    Owner: 'Vlasnik',
    '{value1} · admins': '{value1} · administratori',
    'Owner · always edits': 'Vlasnik · uvijek može uređivati',
    'Admins manage it': 'Njime upravljaju administratori',
    Editors: 'Urednici',
    'A colleague': 'Kolega',
    'Can edit drafts and publish versions': 'Može uređivati skice i objavljivati verzije',
    Remove: 'Ukloni',
    'No editors yet.': 'Još nema urednika.',
    'Admins can always edit company agents.': 'Administratori uvijek mogu uređivati agente tvrtke.',
    'Asking for edit access': 'Traženje pristupa uređivanju',
    'Asked {value1} · also in your Inbox': 'Zatraženo {value1} · također u vašoj ulaznoj pošti',
    Grant: 'Odobri',
    Admin: 'Administrator',
    'Make personal': 'Učini osobnim',
    'Switch off': 'Isključi',
    Archive: 'Arhiviraj',
    'Archive this agent': 'Arhiviraj ovog agenta',
    'Loading agent…': 'Učitavanje agenta…',
    '{value1} Edit in chat': '{value1} Uredi u chatu',
    Agent: 'Agent',
    'This agent has not been created yet. It can run once its owner creates it.':
      'Ovaj agent još nije izrađen. Može se pokrenuti kada ga njegov vlasnik izradi.',
    'New agent · Draft': 'Novi agent · Skica',
    'Untitled agent': 'Agent bez naziva',
    'Test run': 'Probno pokretanje',
    'This draft does not run automatically.': 'Ova se skica ne pokreće automatski.',
    'Describe the agent in the chat. Its draft appears here.':
      'Opišite agenta u chatu. Njegova će se skica prikazati ovdje.',
    '{value1} Test run': '{value1} Probno pokretanje',
    'Describe the agent in the chat first.': 'Najprije opišite agenta u chatu.',
    'Create and turn on': 'Izradi i uključi',
    'Connection write setup': 'Postavljanje upisa putem veze',
    'Account for connected changes': 'Račun za promjene putem veze',
    'Choose a connection': 'Odaberite vezu',
    'No published Skills available. You can add them later.':
      'Nema dostupnih objavljenih vještina. Možete ih dodati kasnije.',
    '{value1} · not published. Review the changes. Testing is optional.':
      '{value1} · nije objavljeno. Pregledajte promjene. Testiranje nije obavezno.',
    '{value1} Test draft': '{value1} Testiraj skicu',
    'Apply changes…': 'Primjena promjena…',
    'Apply this draft as a new version': 'Primijeni ovu skicu kao novu verziju',
    'This draft cannot be applied.': 'Ovu skicu nije moguće primijeniti.',
    'What changed?': 'Što se promijenilo?',
    'Apply version {value1}': 'Primijeni verziju {value1}',
    Create: 'Izradi',
    'Edit access requested': 'Zatražen je pristup uređivanju',
    '{value1} Request edit access': '{value1} Zatraži pristup uređivanju',
    '{value1} Copy agent': '{value1} Kopiraj agenta',
    Pause: 'Pauziraj',
    'Open agent: {value1}': 'Otvori agenta: {value1}',
    '· you can edit': '· možete uređivati',
    '{value1} is switched off.': '{value1} je isključen.',
    '{value1} is archived.': '{value1} je arhiviran.',
    'Loading agents…': 'Učitavanje agenata…',
    Agents: 'Agenti',
    'Agents do work for you on a schedule or when you ask. They follow your company’s Skills.':
      'Agenti rade za vas prema rasporedu ili kada to zatražite. Slijede vještine vaše tvrtke.',
    'No agent matches. Try a Skill name or what the agent should do.':
      'Nijedan agent ne odgovara. Pokušajte s nazivom vještine ili opišite što agent treba raditi.',
    'Nothing of your own yet': 'Još nemate vlastitih agenata',
    'Tell Chat what an agent should do, or copy one of the company’s agents below.{value1}':
      'Recite Chatu što agent treba raditi ili kopirajte jednog od agenata tvrtke u nastavku.{value1}',
    'Your agents': 'Vaši agenti',
    'Run on demand': 'Pokreni na zahtjev',
    'Run is always available. A schedule is optional and lives separately from the agent’s instructions.':
      'Pokretanje je uvijek dostupno. Raspored nije obavezan i postoji odvojeno od uputa agenta.',
    'Enable this schedule when approved': 'Omogući ovaj raspored nakon odobrenja',
    Schedule: 'Raspored',
    'Kept off until you create the agent from its canvas.':
      'Ostaje isključen dok ne izradite agenta iz njegova platna.',
    'Will be enabled when you approve.': 'Bit će omogućen nakon vašeg odobrenja.',
    'Will be saved paused. You can enable it later.':
      'Bit će spremljen pauziran. Možete ga omogućiti kasnije.',
    'Only runs when you ask.': 'Pokreće se samo kada to zatražite.',
    'Draft · approving saves it, and nothing runs. Test it and create it from its canvas.':
      'Nacrt · odobrenjem ga spremate i ništa se ne pokreće. Testirajte ga i izradite iz njegova platna.',
    'Draft · nothing is scheduled until you approve. Connected actions require their own approval at run time.':
      'Nacrt · ništa se ne raspoređuje dok ne odobrite. Povezane radnje zahtijevaju zasebno odobrenje pri pokretanju.',
    Name: 'Naziv',
    'Agent name': 'Naziv agenta',
    'Who can use it': 'Tko ga može upotrebljavati',
    'Company agent · company resources only': 'Agent tvrtke · samo resursi tvrtke',
    'Personal agent · runs with your access': 'Osobni agent · pokreće se s vašim pristupom',
    'Approving saves it as a draft. It does not run automatically.':
      'Odobrenjem ga spremate kao nacrt. Ne pokreće se automatski.',
    'Open the agent’s runs': 'Otvori pokretanja agenta',
    'Run the published version once': 'Pokreni objavljenu verziju jednom',
    'Stopping…': 'Zaustavljanje…',
    'Stop run': 'Zaustavi pokretanje',
    'Could not stop this run. Please try again.':
      'Nije moguće zaustaviti ovo pokretanje. Pokušajte ponovno.',
    'Run in progress': 'Pokretanje je u tijeku',
    'This run is still answering. You can ask follow-ups when it finishes.':
      'Ovo pokretanje još odgovara. Možete postaviti dodatna pitanja kada završi.',
    'Open run details': 'Otvori pojedinosti pokretanja',
    Runs: 'Pokretanja',
    'Open the run chat': 'Otvori razgovor pokretanja',
    Watch: 'Prati',
    Goal: 'Cilj',
    'Change the goal': 'Promijeni cilj',
    'What it does': 'Što radi',
    'What should this agent achieve?': 'Što bi ovaj agent trebao postići?',
    'Not set yet.': 'Još nije postavljeno.',
    'When it runs': 'Kada se pokreće',
    'Change when it runs': 'Promijeni vrijeme pokretanja',
    'Off means it runs only when someone runs it. Changing when it runs never changes its instructions.':
      'Isključeno znači da se pokreće samo kada ga netko pokrene. Promjena vremena pokretanja nikada ne mijenja njegove upute.',
    Instructions: 'Upute',
    'Change the instructions': 'Promijeni upute',
    'How the agent should approach the work and make decisions.':
      'Kako agent treba pristupiti radu i donositi odluke.',
    Boundaries: 'Ograničenja',
    'What to do or avoid. Every connected action still follows its approval.':
      'Što treba raditi ili izbjegavati. Svaka povezana radnja i dalje podliježe odobrenju.',
    'No instructions of its own. It follows its Skills.':
      'Nema vlastite upute. Slijedi svoje vještine.',
    'Pin a Skill': 'Prikvači vještinu',
    'Finds the Skills that fit each run, the same way a chat does.':
      'Pronalski vještine prikladne za svako pokretanje, na isti način kao razgovor.',
    'Skills it always follows': 'Vještine koje uvijek slijedi',
    'A Skill that is not published': 'Vještina koja nije objavljena',
    'Always follows · Version {value1}': 'Uvijek slijedi · Verzija {value1}',
    'Not published': 'Nije objavljeno',
    Uses: 'Upotrebljava',
    'Change in chat': 'Promijeni u razgovoru',
    'Change in chat: Uses': 'Promijeni u razgovoru: upotrebljava',
    'Company knowledge and the tools each run is allowed to use.':
      'Znanje tvrtke i alati koje svako pokretanje smije upotrebljavati.',
    'People see the Result refresh; they change the agent, not the page.':
      'Korisnici vide osvježeni rezultat; mijenjaju agenta, a ne stranicu.',
    'The first run after it is created makes the Result; later runs add a version to it.':
      'Prvo pokretanje nakon izrade stvara rezultat; kasnija pokretanja dodaju njegovu verziju.',
    'Emails whoever the run is for': 'Šalje e-poštu osobi kojoj je pokretanje namijenjeno',
    'Email each run': 'Pošalji e-poštom svako pokretanje',
    Delivers: 'Isporučuje',
    'Change what it delivers': 'Promijeni što isporučuje',
    'Expected result': 'Očekivani rezultat',
    'What a successful run should deliver.': 'Što bi uspješno pokretanje trebalo isporučiti.',
    'What each run delivers': 'Što svako pokretanje isporučuje',
    'Keeps one Result up to date {value1}': 'Održava jedan rezultat ažurnim {value1}',
    'Saves a new Result each run': 'Sprema novi rezultat pri svakom pokretanju',
    'You can run this company agent as yourself.{value1} {value2}':
      'Ovaj agent tvrtke možete pokrenuti kao vi.{value1} {value2}',
    'Changes since version': 'Promjene od verzije',
    'are not live yet.': 'još nisu aktivne.',
    'Review them in Versions': 'Pregledajte ih u odjeljku Verzije',
    Skill: 'Vještina',
    'The agent always uses the Skill’s published version.':
      'Agent uvijek upotrebljava objavljenu verziju vještine.',
    Day: 'Dan',
    Time: 'Vrijeme',
    'Cron expression': 'Cron izraz',
    'Editors and access': 'Urednici i pristup',
    Company: 'Tvrtka',
    Personal: 'Osobno',
    'No changes.': 'Nema promjena.',
    'Instructions changes': 'Promjene uputa',
    'Loading versions…': 'Učitavanje verzija…',
    'What the draft changes': 'Što nacrt mijenja',
    'No published version yet. Try the draft, then publish it.':
      'Još nema objavljene verzije. Isprobajte nacrt, a zatim ga objavite.',
    'Published versions': 'Objavljene verzije',
    'Former member': 'Bivši član',
    Live: 'Aktivno',
    'What changed in version {value1}': 'Što se promijenilo u verziji {value1}',
    'Every publish is a version you can restore.': 'Svaka objava je verzija koju možete vratiti.',
    Authorization: 'Autorizacija',
    '{value1} {value2} · {value3} will see it.': '{value1} {value2} · {value3} će to vidjeti.',
    '{value1} {value2} you': '{value1} {value2} vi',
    '· Revised': '· Izmijenjeno',
    'This chat used your {value1}.': 'Ovaj je razgovor upotrijebio vaš {value1}.',
    'This chat has results from {value1}.': 'Ovaj razgovor sadrži rezultate iz {value1}.',
    'db.example.com': 'db.example.com',
    'e.g. Product analytics': 'npr. Analitika proizvoda',
    'Paste access key': 'Zalijepite pristupni ključ',
    'Shopify’s Dev Dashboard': 'Shopifyjeva razvojna nadzorna ploča',
    'App reference': 'Referenca aplikacije',
    'Draft · revision {value1}': 'Skica · revizija {value1}',
    'its Result': 'njegov rezultat',
    '· its first run makes it': '· njegovo prvo pokretanje čini ga',
    '{value1}’s chat ·': 'Razgovor korisnika {value1} ·',
    '{value1} ad {value2} available.': '{value1} i {value2} dostupni.',
    '{value1} rows ·': '{value1} redaka ·',
    'It starts private. Sharing it wider shares every refresh, which can carry your private data.':
      'Isprva je privatno. Šire dijeljenje dijeli svako osvježavanje, koje može sadržavati vaše privatne podatke.',
    '{value1} for {value2}': '{value1} za {value2}',
    Suggested: 'Predloženo',
    'Opening your conversation…': 'Otvaranje razgovora…',
    'This conversation isn’t available': 'Ovaj razgovor nije dostupan',
    'It may have been deleted, belong to another account, or be temporarily unavailable.':
      'Možda je izbrisan, pripada drugom računu ili je privremeno nedostupan.',
    '{count} more line — shown in the complete revision':
      'Još {count} redak — prikazan u potpunoj reviziji',
    '{count} more lines — shown in the complete revision':
      'Još {count} redaka — prikazano u potpunoj reviziji',
    '{count} more line removed': 'Uklonjen je još {count} redak',
    '{count} more lines removed': 'Uklonjeno je još {count} redaka',
    '{count} unchanged line': '{count} nepromijenjen redak',
    '{count} unchanged lines': '{count} nepromijenjenih redaka',
    '{count} more lines not shown, {added} added and {removed} removed. Check them in the complete revision.':
      'Još {count} redaka nije prikazano; dodano: {added}, uklonjeno: {removed}. Provjerite ih u potpunoj reviziji.',
    'Saved result': 'Spremljeni rezultat',
    'Made with a Skill': 'Izrađeno uz vještinu',
    'Preview of {name}': 'Pretpregled stavke {name}',
    'Made with {name}': 'Izrađeno uz {name}',
    'Ad-hoc result': 'Rezultat po narudžbi',
    'A Skill that is not available in this workspace':
      'Vještina koja nije dostupna u ovom radnom prostoru',
    '{name} · Revision {version}': '{name} · Revizija {version}',
    '{name} · Version {version}': '{name} · Verzija {version}',
    'Return to conversation {value1}': 'Povratak na razgovor {value1}',
    '{value1} Working with {value2}': '{value1} radi s {value2}',
    'View context {value1}': 'Prikaži kontekst {value1}',
    'A way of working, made yours.': 'Način rada prilagođen vama.',
    'Work that runs itself.': 'Posao koji se izvršava sam.',
    'One place for one piece of work.': 'Jedno mjesto za jedan dio posla.',
    'Let’s move your work forward{value1}.': 'Pogurajmo vaš posao naprijed{value1}.',
    'Describe the work. Your Skill takes shape beside the conversation.':
      'Opišite posao. Vaša vještina oblikuje se uz razgovor.',
    'Describe what it should do and when. Your agent takes shape beside the conversation. The draft does not run automatically.':
      'Opišite što bi agent trebao raditi i kada. Vaš agent oblikuje se uz razgovor. Nacrt se ne pokreće automatski.',
    'Say what the work is. Poneva drafts the project beside the conversation and brings in what you have already done. Nothing is created until you say so.':
      'Opišite o kojem je poslu riječ. Poneva izrađuje nacrt projekta uz razgovor i dodaje ono što ste već napravili. Ništa se ne stvara dok to ne potvrdite.',
    'Start with an idea below. Poneva will take it from there.':
      'Započnite idejom u nastavku. Poneva će odatle preuzeti dalje.',
    Triggers: 'Okidači',
    'Review the agent and its trigger. Approval applies exactly what is shown.':
      'Pregledajte agenta i njegov okidač. Odobrenjem se primjenjuje točno ono što je prikazano.',
    '{source} · read {date}': '{source} · pročitano {date}',
    'Evidence is being recorded · read {date}': 'Dokazi se bilježe · pročitano {date}',
    'Evidence expired on {date} under the retention policy':
      'Dokazi su istekli {date} u skladu s pravilima zadržavanja',
    'Entered by {person}': 'Unio/la {person}',
    'No retained evidence for this value': 'Za ovu vrijednost nema zadržanih dokaza',
    'Covers {shown} of {total} rows': 'Obuhvaća {shown} od {total} redaka',
    'Search rows': 'Pretraži retke',
    'Clear filters': 'Izbriši filtre',
    Sort: 'Sortiraj',
    'Sort: {column}': 'Sortiraj: {column}',
    '{shown} of {total} rows': '{shown} od {total} redaka',
    More: 'Više',
    Density: 'Gustoća',
    Comfortable: 'Prostrano',
    Compact: 'Zbijeno',
    Columns: 'Stupci',
    'No rows match. Clear the search or filters to see them again.':
      'Nijedan redak ne odgovara. Izbrišite pretraživanje ili filtre da biste ih ponovno vidjeli.',
    'Not available': 'Nije dostupno',
    'All rows': 'Svi retci',
    'Close row detail': 'Zatvori pojedinosti retka',
    'Ask about this row': 'Pitaj o ovom retku',
    'Add note': 'Dodaj bilješku',
    Note: 'Bilješka',
    Saved: 'Spremljeno',
    Total: 'Ukupno',
    ascending: 'uzlazno',
    descending: 'silazno',
    'Scroll to see all columns': 'Pomaknite se za prikaz svih stupaca',
    App: 'Aplikacija',
    Artifact: 'Artefakt',
    'New project': 'Novi projekt',
    'Review request': 'Zahtjev za pregled',
    Activity: 'Aktivnost',
    'Voice preview': 'Glasovni pregled',
    Source: 'Izvor',
    File: 'Datoteka',
    Meeting: 'Sastanak',
    'Knowledge page': 'Stranica znanja',
    'Could not preview this CSV.': 'Nije moguće pregledati ovaj CSV.',
    'File content is unavailable.': 'Sadržaj datoteke nije dostupan.',
    'You have five open suggestions here. {value1} will see them.':
      'Ovdje imate pet otvorenih prijedloga. {value1} će ih vidjeti.',
    'We could not send your suggestion. Please try again.':
      'Nismo mogli poslati vaš prijedlog. Pokušajte ponovno.',
    'The agent': 'Agent',
    'Selected colleagues': 'Odabrani kolege',
    'The owner': 'Vlasnik',
    'Forked. This copy is yours and runs with your own connections.':
      'Izvedena kopija. Ova je kopija vaša i radi s vašim vezama.',
    'This chat is too long to fork.': 'Ovaj je chat predug za izradu izvedene kopije.',
    'We could not fork this chat. Please try again.':
      'Nismo mogli izraditi izvedenu kopiju ovog chata. Pokušajte ponovno.',
    'Anyone who forked it keeps their copy: forks stay with the people who made them.':
      'Svatko tko je izradio izvedenu kopiju zadržava je: izvedene kopije ostaju kod osoba koje su ih izradile.',
    'Nobody has forked this chat.': 'Nitko nije izradio izvedenu kopiju ovog chata.',
    '1 person forked this chat. Their copy stays theirs.':
      '1 osoba izradila je izvedenu kopiju ovog chata. Njihova kopija ostaje njihova.',
    '{value1} people forked this chat. Their copies stay theirs.':
      '{value1} osoba izradilo je izvedenu kopiju ovog chata. Njihove kopije ostaju njihove.',
    'Personal. Nobody else sees it.': 'Osobno. Nitko drugi to ne vidi.',
    'People you pick. They get it in their Inbox.':
      'Osobe koje odaberete. Dobit će to u svojoj ulaznoj pošti.',
    'Everyone in the company can follow it and fork it.':
      'Svi u tvrtki mogu to pratiti i izraditi izvedenu kopiju.',
    'a chat you can no longer open': 'chat koji više ne možete otvoriti',
    'shared the Result': 'podijelio je Rezultat',
    'updated the Result': 'ažurirao je Rezultat',
    'published the Skill': 'objavio je Vještinu',
    'approved the fact': 'odobrio je činjenicu',
    'added the fact': 'dodao je činjenicu',
    'added the meeting': 'dodao je sastanak',
    'published the page': 'objavio je stranicu',
    'updated the page': 'ažurirao je stranicu',
    'shared the chat': 'podijelio je chat',
    'published a version of': 'objavio je verziju od',
    ran: 'pokrenuo je',
    Knowledge: 'Znanje',
    Meetings: 'Sastanci',
    Chat: 'Razgovor',
    Use: 'Upotrijebi',
    Open: 'Otvori',
    You: 'Vi',
    Someone: 'Netko',
    'published version {version} of': 'objavio je verziju {version} od',
    'thing needs': 'stavka treba',
    'things need': 'stavke trebaju',
    'Published Skill': 'Objavljena vještina',
    'Included with Skill': 'Uključeno s vještinom',
    'Already attached': 'Već priloženo',
    'Also available in company knowledge': 'Dostupno i u znanju tvrtke',
    'Company file': 'Datoteka tvrtke',
    'Account identity unavailable': 'Identitet računa nije dostupan',
    'Access expired or was revoked. Reconnect to continue.':
      'Pristup je istekao ili je opozvan. Ponovno se povežite za nastavak.',
    'Account authorized · tools unavailable': 'Račun je autoriziran · alati nisu dostupni',
    'Not available in this workspace yet.': 'Još nije dostupno u ovom radnom prostoru.',
    'Everyone in the company': 'Svi u tvrtki',
    'Audience: only you.': 'Publika: samo vi.',
    'Audience: everyone in the company.': 'Publika: svi u tvrtki.',
    'tool is': 'alat je',
    'tools are': 'alati su',
    'account is': 'račun je',
    'accounts are': 'računi su',
    'We could not upload this file.': 'Nismo mogli prenijeti ovu datoteku.',
    'file was': 'datoteka je bila',
    'files were': 'datoteke su bile',
    'Your company': 'Vaša tvrtka',
    'Create an agent': 'Izradi agenta',
    'Give recurring work a helping hand': 'Olakšajte ponavljajuće zadatke',
    'Create a Skill': 'Izradi vještinu',
    'Save a reusable way of working': 'Spremite način rada za ponovnu upotrebu',
    'Take meeting notes': 'Vodite bilješke sa sastanka',
    'Capture decisions and next steps': 'Zabilježite odluke i sljedeće korake',
    'Work with a file': 'Radite s datotekom',
    'Start from a document or image': 'Započnite s dokumentom ili slikom',
    'Browse agents': 'Pregledaj agente',
    'Open your agents and company agents': 'Otvorite svoje agente i agente tvrtke',
    'Review results': 'Pregledaj rezultate',
    'Return to work saved in your Library': 'Vratite se radu spremljenom u svojoj Biblioteci',
    'For review': 'Za pregled',
    'An agent': 'Agent',
    Assistant: 'Asistent',
    'Kept up to date by {value1}{value2}': 'Ažurira {value1}{value2}',
    ', {value1}': ', {value1}',
    'Version {value1}{value2}{value3}': 'Verzija {value1}{value2}{value3}',
    'Refreshed by its agent': 'Ažurira ga njegov agent',
    'Saved from a chat': 'Spremljeno iz razgovora',
    'Saved from {value1}': 'Spremljeno iz aplikacije {value1}',
    Edited: 'Uređeno',
    'private account': 'privatni račun',
    '{value1} ({value2})': '{value1} ({value2})',
    '{value1}’s {value2}': '{value2} korisnika {value1}',
    'Made private. The person who added it and the owner of its recording have been told in their Inbox.':
      'Postavljeno kao privatno. Osoba koja ga je dodala i vlasnik njegove snimke obaviješteni su u svojoj ulaznoj pošti.',
    'Made private. The person who added it has been told in their Inbox.':
      'Postavljeno kao privatno. Osoba koja ga je dodala obaviještena je u svojoj ulaznoj pošti.',
    'Made private. The owner of its recording has been told in their Inbox.':
      'Postavljeno kao privatno. Vlasnik njegove snimke obaviješten je u svojoj ulaznoj pošti.',
    'Selected passage': 'Odabrani odlomak',
    '{value1} {value2}': '{value1} {value2}',
    'Upload a file': 'Prenesite datoteku',
    'Help me create a useful report from our company knowledge and available sources.':
      'Pomozite mi izraditi koristan izvještaj na temelju znanja tvrtke i dostupnih izvora.',
    'This saved work couldn’t be opened. Open it again to retry.':
      'Ovaj spremljeni rad nije moguće otvoriti. Otvorite ga ponovno i pokušajte opet.',
    '{value1}’s': 'korisnika {value1}',
    '{value1} chat “{value2}”': 'razgovor korisnika {value1} „{value2}“',
    '{value1}{value2}': '{value1}{value2}',
    'Skill: {value1}{value2}': 'Vještina: {value1}{value2}',
    'Result “{value1}”': 'Rezultat „{value1}“',
    'Meeting “{value1}”': 'Sastanak „{value1}“',
    'Used in {value1} {value2} this week': 'Ovaj tjedan upotrijebljeno u: {value1} {value2}',
    '{value1} {value2} · used in {value3} {value4}':
      '{value1} {value2} · upotrijebljeno u: {value3} {value4}',
    'The draft is not published yet, so no one else follows it.':
      'Nacrt još nije objavljen pa ga nitko drugi ne prati.',
    'Use it in a chat for current data, or refine the Skill first.':
      'Upotrijebite je u razgovoru za aktualne podatke ili najprije doradite vještinu.',
    'An agent keeps this up to date. Continue the work in chat.':
      'Agent ovo održava ažurnim. Nastavite rad u razgovoru.',
    'Edit it here, or continue the work in chat.': 'Uredite ovdje ili nastavite rad u razgovoru.',
    'Duplicate it to your Library, or continue the work in chat.':
      'Duplicirajte je u svoju Biblioteku ili nastavite rad u razgovoru.',
    'Download Markdown': 'Preuzmi Markdown',
    'Download CSV': 'Preuzmi CSV',
    'an agent': 'agent',
    'Publish a Skill version': 'Objavi verziju vještine',
    'Share with {value1}': 'Podijeli s korisnikom {value1}',
    'Update company content': 'Ažuriraj sadržaj tvrtke',
    Approved: 'Odobreno',
    Declined: 'Odbijeno',
    Pending: 'Na čekanju',
    'View decision': 'Prikaži odluku',
    'No data': 'Nema podataka',
    'No change': 'Nema promjene',
    'Connection created': 'Veza je stvorena',
    'Sharing changed': 'Postavke dijeljenja promijenjene',
    'Person added': 'Osoba je dodana',
    'Person removed': 'Osoba je uklonjena',
    'Access changed': 'Pristup je promijenjen',
    'Access turned off': 'Pristup je isključen',
    'Connection removed': 'Veza je uklonjena',
    'Query time limit changed': 'Vremensko ograničenje upita promijenjeno',
    '{count} row': '{count} redak',
    '{count} rows': '{count} redaka',
    'This source is no longer available. Company knowledge now lives in Knowledge pages, and files stay in the Library.':
      'Ovaj izvor više nije dostupan. Znanje tvrtke sada se nalazi na stranicama Znanja, a datoteke ostaju u Biblioteci.',
    '· {value1} by {value2}': '· {value1} autor: {value2}',
    '· version {value1}': '· verzija {value1}',
    '{message} {count} earlier file was saved and attached.':
      '{message} {count} ranija datoteka spremljena je i priložena.',
    '{message} {count} earlier files were saved and attached.':
      '{message} {count} ranije datoteke spremljene su i priložene.',
    '{message} {count} earlier file was saved.': '{message} {count} ranija datoteka spremljena je.',
    '{message} {count} earlier files were saved.':
      '{message} {count} ranije datoteke spremljene su.',
    'refreshed {time}': 'osvježeno {time}',
    'a colleague': 'suradnik',
    'Your chat “{title}”': 'Vaš razgovor „{title}“',
    '{name}’s chat “{title}”': 'Razgovor korisnika {name} „{title}“',
    'Kept up to date by {name}{version}': 'Ažurira {name}{version}',
    'Skill: {name}{version}': 'Vještina: {name}{version}',
    'Result “{title}”': 'Rezultat „{title}“',
    'Meeting “{title}”': 'Sastanak „{title}“',
    'Used in {count} answer this week': 'Upotrijebljeno u {count} odgovoru ovaj tjedan',
    'Used in {count} answers this week': 'Upotrijebljeno u {count} odgovorima ovaj tjedan',
    '{count} source': '{count} izvor',
    '{count} sources': '{count} izvora',
    'used in {count} place': 'upotrijebljeno na {count} mjestu',
    'used in {count} places': 'upotrijebljeno na {count} mjesta',
    '{company} workspace': 'radni prostor tvrtke {company}',
    '{count} page': '{count} stranica',
    '{count} pages': '{count} stranica',
    '{needs} · reviews and approvals': '{needs} · pregledi i odobrenja',
    '{count} thing needs you': '{count} stavka treba vašu pažnju',
    '{count} things need you': '{count} stavki treba vašu pažnju',
    'Included with Skill · {files} · {sources} {icon}':
      'Uključeno uz vještinu · {files} · {sources} {icon}',
    '{count} file': '{count} datoteka',
    '{count} files': '{count} datoteka',
    Today: 'Danas',
    'Earlier this week': 'Ranije ovog tjedna',
    '{count} slide': '{count} slajd',
    '{count} slides': '{count} slajdova',
    Early: 'Rano',
    'TLS verified': 'TLS potvrđen',
    'Made personal and switched off. Switch it on when you are ready.':
      'Postavljeno kao osobno i isključeno. Uključite kada budete spremni.',
    'Made personal and switched off. Its owner is told which version is live.':
      'Postavljeno kao osobno i isključeno. Vlasnik je obaviješten koja je verzija aktivna.',
    'Switched off.': 'Isključeno.',
    'Applied version {revision}.': 'Primijenjena verzija {revision}.',
    'The draft is running in a chat only you can read.':
      'Skica se izvršava u chatu koji samo vi možete čitati.',
    'Publish a version first.': 'Najprije objavite verziju.',
    'Another Agent action is in progress.': 'Druga radnja agenta je u tijeku.',
    'Knowledge & connections': 'Znanje i povezivanja',
    'Pinned Skills': 'Prikvačene vještine',
    None: 'Ništa',
    'A new Result each run': 'Novi rezultat pri svakom pokretanju',
    'One Result kept up to date': 'Jedan rezultat koji se ažurira',
    Email: 'E-pošta',
    On: 'Uključeno',
    Off: 'Isključeno',
    'Waiting for review': 'Čeka pregled',
    Outdated: 'Zastarjelo',
    Accepted: 'Prihvaćeno',
    Rejected: 'Odbijeno',
    Withdrawn: 'Povučeno',
    Replaced: 'Zamijenjeno',
    'Suggested edit': 'Predložena izmjena',
    'Suggested new page': 'Predložena nova stranica',
    'Suggested move': 'Predloženo premještanje',
    'Suggested archive': 'Predloženo arhiviranje',
    'Checking status…': 'Provjera statusa…',
    'Status unavailable': 'Status nije dostupan',
    'Bulleted list': 'Popis s grafičkim oznakama',
    'Numbered list': 'Numerirani popis',
    'Web link': 'Web-poveznica',
    Read: 'Čitanje',
    Write: 'Pisanje',
    'shared with you': 'podijeljeno s vama',
    'Getting an answer': 'Priprema odgovora',
    '{name} is getting an answer': '{name} priprema odgovor',
    'We could not save. Please try again.': 'Spremanje nije uspjelo. Pokušajte ponovno.',
    'The new page could not be created.': 'Nije moguće izraditi novu stranicu.',
    'We could not load this revision.': 'Nije moguće učitati ovu reviziju.',
    'We could not restore this revision. Please try again.':
      'Nije moguće vratiti ovu reviziju. Pokušajte ponovno.',
    'We could not export this revision.': 'Nije moguće izvesti ovu reviziju.',
    'We could not open this suggestion.': 'Nije moguće otvoriti ovaj prijedlog.',
    'We could not do that. Please try again.': 'To nije moguće. Pokušajte ponovno.',
    'We could not save your decision. Please try again.':
      'Nije moguće spremiti vašu odluku. Pokušajte ponovno.',
    'We could not restore this page. Please try again.':
      'Nije moguće vratiti ovu stranicu. Pokušajte ponovno.',
    'We could not export this page.': 'Nije moguće izvesti ovu stranicu.',
    '{count} missed time merged.': 'Spojen je {count} propušteni termin.',
    '{count} missed times merged.': 'Spojeno je {count} propuštenih termina.',
    'About this project': 'O ovom projektu',
  },
  cs: {
    'We could not load this item.': 'Tuto položku se nepodařilo načíst.',
    '{value1} canvas': 'Plátno {value1}',
    'Loading {value1}…': 'Načítání {value1}…',
    '{value1} · Original retained': '{value1} · Původní verze zachována',
    '{value1} {value2}{value3} · Added {value4}': '{value1} {value2}{value3} · Přidáno {value4}',
    '{value1} Use in chat': '{value1} Použít v chatu',
    '{value1} Download': '{value1} Stáhnout',
    Table: 'Tabulka',
    Chart: 'Graf',
    Original: 'Originál',
    'Text extracted from the PDF, marked by page. Download the original for its layout and images.':
      'Text extrahovaný z PDF, označený podle stránek. Stáhněte si originál, abyste zachovali jeho rozvržení a obrázky.',
    'This preview shows the beginning of the file. Poneva reads the whole file; download the original to see all of it.':
      'Tento náhled zobrazuje začátek souboru. Poneva čte celý soubor; stáhněte si originál, abyste viděli celý obsah.',
    'Preview of the first {value1} complete rows. Filtering and charts use only this preview. Download the original for the full file.':
      'Náhled prvních {value1} úplných řádků. Filtrování a grafy používají pouze tento náhled. Stáhněte si originál pro celý soubor.',
    'This source link cannot be opened.': 'Tento odkaz na zdroj nelze otevřít.',
    'Read-only chat': 'Chat pouze pro čtení',
    'Only {value1} writes in this chat. Fork it to continue with your own connections. {value2}':
      'V tomto chatu píše pouze {value1}. Vytvořte jeho kopii a pokračujte s vlastními připojeními. {value2}',
    'Suggest a follow-up…': 'Navrhnout další otázku…',
    'Suggest a follow-up': 'Navrhnout další otázku',
    'Sending…': 'Odesílání…',
    Send: 'Odeslat',
    'We could not dismiss that suggestion. Please try again.':
      'Tento návrh se nepodařilo skrýt. Zkuste to znovu.',
    'Suggested follow-ups': 'Navržené další otázky',
    '{value1} suggests': '{value1} navrhuje',
    Ask: 'Zeptat se',
    'Dismiss {value1}’s suggestion': 'Skrýt návrh od {value1}',
    'Suggested by': 'Navrhl(a)',
    '· edit it or send it': '· upravte ho nebo odešlete',
    'Remove the suggestion tag': 'Odstranit štítek návrhu',
    '{value1} {value2} is getting an answer': '{value1} {value2} dostává odpověď',
    '{value1} {value2} stopped the answer': '{value1} {value2} zastavil(a) odpověď',
    '{value1} Fork from here': '{value1} Vytvořit kopii od tohoto místa',
    '{value1} From {value2}’s {value3}': '{value1} Od {value2} – {value3}',
    'Only {value1} can use this account': 'Tento účet může používat pouze {value1}',
    '{value1} Suggested by {value2}': '{value1} Navrhl(a) {value2}',
    'Fork this chat': 'Vytvořit kopii tohoto chatu',
    'Forking…': 'Vytváření kopie…',
    Fork: 'Vytvořit kopii',
    'Could not make this private.': 'Nepodařilo se nastavit soukromí.',
    'Make this chat private?': 'Nastavit tento chat jako soukromý?',
    Close: 'Zavřít',
    '{value1} will see “{value2}”. Everyone else loses access right away {value3} .{value4}':
      'Uvidí to {value1}: „{value2}“. Všem ostatním bude přístup okamžitě odebrán {value3} .{value4}',
    Cancel: 'Zrušit',
    'Saving…': 'Ukládání…',
    'Make private': 'Nastavit jako soukromé',
    'This chat is private again. Forks others made stay theirs.':
      'Tento chat je znovu soukromý. Kopie vytvořené ostatními zůstávají jejich.',
    'Who can read this chat: {value1}': 'Kdo může tento chat číst: {value1}',
    'Move this chat': 'Přesunout tento chat',
    'Only you write here. Others follow live and fork.':
      'Zde píšete pouze vy. Ostatní sledují chat v reálném čase a mohou vytvořit kopii.',
    'Made private. {value1} has been told in their Inbox.':
      'Nastaveno jako soukromé. {value1} byl(a) informován(a) ve své doručené poště.',
    'Chat access': 'Přístup k chatu',
    '{value1}’s chat. As an admin you can make it private.':
      'Chat uživatele {value1}. Jako správce ho můžete nastavit jako soukromý.',
    'Only {value1} will see it. {value2} is told.':
      'Uvidí ho pouze {value1}. {value2} bude informován(a).',
    '{value1} {value2} following': '{value1} {value2} sleduje',
    'Forked from{value1} {value2} . The history is copied. From here, tools run with your own access.':
      'Vytvořena kopie z{value1} {value2} . Historie byla zkopírována. Od tohoto místa nástroje používají váš vlastní přístup.',
    '{value1} made this chat private': '{value1} nastavil(a) tento chat jako soukromý',
    'You can no longer open it. Any fork you made stays yours.':
      'Už ho nemůžete otevřít. Každá kopie, kterou jste vytvořili, zůstává vaše.',
    'Start a new chat': 'Začít nový chat',
    'Back to Recent chats': 'Zpět na poslední chaty',
    'More chat actions': 'Další akce chatu',
    'Close conversation sharing': 'Zavřít sdílení konverzace',
    'Review the text before saving a private copy to Library. Then choose its audience. Your original conversation and future messages stay private.':
      'Před uložením soukromé kopie do Knihovny zkontrolujte text. Poté vyberte její publikum. Vaše původní konverzace i budoucí zprávy zůstanou soukromé.',
    'Preparing the conversation…': 'Příprava konverzace…',
    'Refresh preview': 'Obnovit náhled',
    'The copy is saved in Library. Use Share to choose who can access it.':
      'Kopie je uložena v Knihovně. Pomocí možnosti Sdílet vyberte, kdo k ní bude mít přístup.',
    'Save this copy': 'Uložit tuto kopii',
    'That Skill could not be opened.': 'Tuto dovednost se nepodařilo otevřít.',
    '{value1}{value2} · reviews and approvals': '{value1}{value2} · kontroly a schvalování',
    'Open Inbox': 'Otevřít doručenou poštu',
    'New at {value1} this week': 'Tento týden nové v {value1}',
    'Nothing new this week. Shared work, published Skills and approved knowledge show up here.':
      'Tento týden nic nového. Zde se zobrazí sdílená práce, publikované dovednosti a schválené znalosti.',
    'New at {value1}': 'Nové v {value1}',
    'This Skill is unavailable. Try again.': 'Tato dovednost není k dispozici. Zkuste to znovu.',
    'You can attach up to {value1} files. Remove an attachment to add another.':
      'Můžete připojit až {value1} souborů. Odeberte přílohu a přidejte další.',
    'Add company context': 'Přidat kontext společnosti',
    'Add company context · @': 'Přidat kontext společnosti · @',
    'Choose a Skill': 'Vybrat dovednost',
    'Choose a Skill · /': 'Vybrat dovednost · /',
    context: 'kontext',
    skills: 'dovednosti',
    'Choose company context': 'Vyberte firemní kontext',
    'Skills for this conversation': 'Dovednosti pro tuto konverzaci',
    'Bring context into the conversation': 'Přidat kontext do konverzace',
    'Close context picker': 'Zavřít výběr kontextu',
    'Filter company context': 'Filtrovat firemní kontext',
    'Find a Skill…': 'Najít dovednost…',
    'Find a file…': 'Najít soubor…',
    'Available company context': 'Dostupný firemní kontext',
    'No matching published Skills.': 'Žádné odpovídající publikované dovednosti.',
    'No matching files.': 'Žádné odpovídající soubory.',
    'Searching company work…': 'Vyhledávání ve firemní práci…',
    'Try search again': 'Zkuste vyhledávání znovu',
    'Meaning search is temporarily limited. Showing available text matches.':
      'Sémantické vyhledávání je dočasně omezené. Zobrazují se dostupné textové shody.',
    'Load more matches': 'Načíst další shody',
    '{value1} files attached. Remove an attachment to add another. Saved Skill references are included separately.':
      'Připojeno souborů: {value1}. Odeberte přílohu a přidejte další. Odkazy na uložené dovednosti jsou zahrnuty samostatně.',
    'Create a Skill in chat': 'Vytvořit dovednost v chatu',
    'Upload a company file': 'Nahrát firemní soubor',
    'Company knowledge is always available to Poneva.':
      'Firemní znalosti jsou pro Ponevu vždy dostupné.',
    '{value1} was not connected': '{value1} nebyl připojen',
    Dismiss: 'Zavřít',
    'Try connecting again': 'Zkusit připojení znovu',
    Waiting: 'Čeká se',
    Connected: 'Připojeno',
    'Needs reconnecting': 'Vyžaduje opětovné připojení',
    Connect: 'Připojit',
    '{value1}{value2} The provider’s account permissions still apply.':
      '{value1}{value2} Oprávnění účtu poskytovatele se stále uplatňují.',
    'Last error: {value1}': 'Poslední chyba: {value1}',
    '{value1} {value2} ready.': '{value1} {value2} je připraveno.',
    'Continue with my Meta app': 'Pokračovat s mou aplikací Meta',
    Reconnect: 'Připojit znovu',
    Disconnect: 'Odpojit',
    'Remove attachment: {value1}': 'Odebrat přílohu: {value1}',
    'Saved in this Skill. Edit the Skill to change its references.':
      'Uloženo v této dovednosti. Chcete-li změnit její odkazy, upravte dovednost.',
    'Remove Skill context': 'Odebrat kontext dovednosti',
    Refining: 'Upřesňování',
    Previewing: 'Náhled',
    Using: 'Používání',
    'Skill revision {value1}': 'Revize dovednosti {value1}',
    'a new Skill': 'novou dovednost',
    '{value1} Making a new agent {value2}': '{value1} Vytváření nového agenta {value2}',
    'Stop making a new agent in this chat': 'Zastavit vytváření nového agenta v tomto chatu',
    'Saved Skill references': 'Odkazy na uložené dovednosti',
    'Included with Skill · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}':
      'Součást dovednosti · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}',
    'Selected Skill revision is unavailable. Select the Skill again to view its saved references.':
      'Vybraná revize dovednosti není dostupná. Vyberte dovednost znovu a zobrazte její uložené odkazy.',
    'Conversation attachments': 'Přílohy konverzace',
    'Added for this conversation': 'Přidáno pro tuto konverzaci',
    'Selected passage {value1}': 'Vybraná pasáž {value1}',
    'We could not load your workspace.': 'Pracovní prostor se nepodařilo načíst.',
    'The selected Skill is unavailable. Check its access or choose it again.':
      'Vybraná dovednost není dostupná. Zkontrolujte k ní přístup nebo ji vyberte znovu.',
    'Source saved privately and included in your knowledge search.':
      'Zdroj byl uložen soukromě a zahrnut do vyhledávání ve vašich znalostech.',
    'File saved privately to your library and attached to this message.':
      'Soubor byl uložen soukromě do vaší knihovny a připojen k této zprávě.',
    'File saved privately to your library.': 'Soubor byl uložen soukromě do vaší knihovny.',
    '{value1} {value2} earlier {value3} saved{value4}.':
      '{value1} {value2} předtím {value3} uloženo{value4}.',
    'Extracted text for Poneva to read. Download the original for its layout, charts and images. Spreadsheet formulas show their saved results and are not recalculated.':
      'Extrahovaný text ke čtení pro Ponevu. Stáhněte si originál, pokud potřebujete jeho rozvržení, grafy a obrázky. Vzorce v tabulce zobrazují uložené výsledky a nejsou přepočítávány.',
    Esc: 'Esc',
    'Start something': 'Začněte s něčím',
    'Choose a file to work with': 'Vyberte soubor, se kterým chcete pracovat',
    'Skills worth adding': 'Dovednosti, které stojí za přidání',
    'Picked for you': 'Vybrané pro vás',
    'Reusable work grounded in your company knowledge.':
      'Opakovaně využitelná práce založená na znalostech vaší společnosti.',
    'Ideas from your company context and recent work. Pick one to start.':
      'Nápady vycházející z kontextu vaší společnosti a nedávné práce. Vyberte jeden a začněte.',
    'Refresh suggested tasks': 'Obnovit navrhované úkoly',
    'Check for new company context.': 'Zkontrolovat nový firemní kontext.',
    'Check for new context. Ideas also refresh daily.':
      'Zkontrolovat nový kontext. Nápady se také denně obnovují.',
    Refresh: 'Obnovit',
    'Finding useful starting points…': 'Hledání užitečných výchozích bodů…',
    'Suggestions aren’t available right now. Try Refresh, or describe the work you want to do.':
      'Návrhy teď nejsou dostupné. Zkuste Obnovit nebo popište práci, kterou chcete provést.',
    'Loading the knowledge pages…': 'Načítání stránek znalostí…',
    '{value1} All pages': '{value1} Všechny stránky',
    'The page is created.': 'Stránka je vytvořena.',
    'Your new page is suggested. A publisher decides whether it is added.':
      'Vaše nová stránka byla navržena. Vydavatel rozhodne, zda bude přidána.',
    'Company knowledge': 'Firemní znalosti',
    'What Poneva knows about your company, page by page. Every change is kept.':
      'Co Poneva ví o vaší společnosti, stránku po stránce. Každá změna se zachovává.',
    'Loading company knowledge…': 'Načítání firemních znalostí…',
    'Knowledge pages are not enabled in this workspace.':
      'Stránky znalostí nejsou v tomto pracovním prostoru povoleny.',
    'Ask your Poneva contact to switch them on for your company.':
      'Požádejte svého kontaktu ve společnosti Poneva, aby je pro vaši společnost aktivoval.',
    '{value1} Change the agent': '{value1} Změnit agenta',
    '{value1} Continue in chat': '{value1} Pokračovat v chatu',
    'Open result: {value1}': 'Otevřít výsledek: {value1}',
    'Loading more library items…': 'Načítání dalších položek knihovny…',
    'Load more': 'Načíst další',
    'Documents, transcripts, audio and video · Up to 500 MB per file. New files are private. Choose their audience with Share and which processable files become searchable company knowledge.':
      'Dokumenty, přepisy, zvukové a video soubory · Až 500 MB na soubor. Nové soubory jsou soukromé. Pomocí možnosti Sdílet určete jejich publikum a vyberte, které zpracovatelné soubory se stanou prohledávatelnými firemními znalostmi.',
    Skills: 'Dovednosti',
    'Create in chat': 'Vytvořit v chatu',
    'Search Skills': 'Hledat dovednosti',
    'Search finds published Skills. Clear the search to browse your drafts too.':
      'Vyhledávání najde publikované dovednosti. Vymažte vyhledávání a procházejte také své koncepty.',
    'Search coverage is limited while indexing or meaning-based search is unavailable.':
      'Rozsah vyhledávání je omezený, dokud není k dispozici indexování nebo vyhledávání podle významu.',
    'Searching Skills…': 'Vyhledávání dovedností…',
    'No matching published Skills found. Try a different description.':
      'Nebyly nalezeny žádné odpovídající publikované dovednosti. Zkuste jiný popis.',
    'Load more Skills': 'Načíst další dovednosti',
    'View Skill: {value1}': 'Zobrazit dovednost: {value1}',
    'Company workspace': 'Firemní pracovní prostor',
    'View {value1}': 'Zobrazit {value1}',
    'Loading Skills…': 'Načítání dovedností…',
    'Try again {value1}': 'Zkusit znovu {value1}',
    'Try again': 'Zkusit znovu',
    'Nothing yet.': 'Zatím nic.',
    'Made from · Used by': 'Vytvořeno z · Používáno',
    'Could not load links': 'Odkazy se nepodařilo načíst',
    'Made from': 'Vytvořeno z',
    'Used by': 'Používáno',
    'About this chat {value1}': 'O tomto chatu {value1}',
    'About this chat': 'O tomto chatu',
    'Keep the work moving.': 'Udržujte práci v pohybu.',
    'Ask a follow-up with this result in view, or turn a useful approach into a company Skill.':
      'Položte doplňující otázku s tímto výsledkem na očích nebo převeďte užitečný postup na firemní dovednost.',
    'Save approach as a Skill': 'Uložit postup jako dovednost',
    'Preview of': 'Náhled',
    'Made with': 'Vytvořeno pomocí',
    'Open the draft': 'Otevřít koncept',
    'Open Skill': 'Otevřít dovednost',
    'Use in chat': 'Použít v chatu',
    'Finish the draft': 'Dokončit koncept',
    'Refine this Skill': 'Vylepšit tuto dovednost',
    'Made with a Skill.': 'Vytvořeno pomocí dovednosti.',
    'This workspace could not be loaded just now, so that Skill cannot be opened yet. The result itself is unchanged.':
      'Tento pracovní prostor se nyní nepodařilo načíst, takže tuto dovednost zatím nelze otevřít. Samotný výsledek se nezměnil.',
    'That Skill is not available in this workspace, so it cannot be opened or used again. The result itself is unchanged.':
      'Tato dovednost není v tomto pracovním prostoru dostupná, takže ji nelze znovu otevřít ani použít. Samotný výsledek se nezměnil.',
    'Result · {value1} {value2}': 'Výsledek · {value1} {value2}',
    '{value1} Copy link': '{value1} Kopírovat odkaz',
    'Result link copied.': 'Odkaz na výsledek byl zkopírován.',
    'Could not copy the link. Use your browser address bar.':
      'Odkaz se nepodařilo zkopírovat. Použijte adresní řádek prohlížeče.',
    'No preview is available for this result.': 'Pro tento výsledek není k dispozici náhled.',
    '{value1} rows are retained in this snapshot. Open Table to inspect the values.':
      'V tomto snímku je zachováno {value1} řádků. Otevřete tabulku a prohlédněte si hodnoty.',
    'People can’t edit a Result an agent keeps up to date; the next refresh would replace their edit. Change the agent’s instructions instead.':
      'Výsledek, který agent udržuje aktuální, nelze upravovat; při příští aktualizaci by se vaše změny přepsaly. Místo toho změňte pokyny agenta.',
    'Linked sources': 'Propojené zdroje',
    'Saved source': 'Uložený zdroj',
    'No source documents are linked to this result. Company knowledge and other references may be cited in the answer.':
      'K tomuto výsledku nejsou propojeny žádné zdrojové dokumenty. V odpovědi mohou být citovány firemní znalosti a další reference.',
    'Run details': 'Podrobnosti spuštění',
    Created: 'Vytvořeno',
    ', revised {value1}': ', upraveno {value1}',
    Conversation: 'Konverzace',
    'Not recorded': 'Nezaznamenáno',
    'Open conversation': 'Otevřít konverzaci',
    Run: 'Spustit',
    Updates: 'Aktualizace',
    'Kept up to date by {value1}': 'Aktualizuje {value1}',
    'Version {value1}': 'Verze {value1}',
    'Could not open this request.': 'Tento požadavek se nepodařilo otevřít.',
    'Approved version published.': 'Schválená verze byla publikována.',
    'Request rejected. The item stays unchanged.':
      'Požadavek byl zamítnut. Položka zůstává beze změny.',
    'Could not save the decision.': 'Rozhodnutí se nepodařilo uložit.',
    'Proposed company change': 'Navrhovaná firemní změna',
    'Opening…': 'Otevírání…',
    'Approve this version': 'Schválit tuto verzi',
    Decline: 'Zamítnout',
    'Review the submitted version below. Changes made since submission will need a new request.':
      'Níže zkontrolujte odeslanou verzi. Změny provedené po odeslání budou vyžadovat nový požadavek.',
    'The version submitted with this request.': 'Verze odeslaná s tímto požadavkem.',
    'Version and proposed change': 'Verze a navrhovaná změna',
    'Could not read the pinned content.': 'Připnutý obsah se nepodařilo načíst.',
    'Showing a page of {value1} characters.': 'Zobrazuje se stránka s {value1} znaky.',
    'Beginning of the submitted content. Open the full text to review every page.':
      'Začátek odeslaného obsahu. Otevřete celý text a zkontrolujte každou stránku.',
    'Read full submitted text': 'Přečíst celý odeslaný text',
    'Previous page': 'Předchozí stránka',
    'Next page': 'Další stránka',
    'Made private. Its creator has been told in their Inbox.':
      'Nastaveno jako soukromé. Autor byl informován ve své doručené poště.',
    'Made private. Its creator could not be notified.':
      'Nastaveno jako soukromé. Autor nemohl být informován.',
    'Make this {value1} private?': 'Nastavit {value1} jako soukromé?',
    'Only the person who created it will see it. Everyone else loses access right away, and its creator gets an Inbox update if they are still a company member. If they have left, nobody in the company will be able to access this item.':
      'Uvidí ho pouze osoba, která ho vytvořila. Všichni ostatní okamžitě ztratí přístup a autor obdrží aktualizaci v doručené poště, pokud je stále členem společnosti. Pokud společnost opustil, k této položce už nebude mít přístup nikdo z firmy.',
    'Sent for review. The current audience stays unchanged until approval.':
      'Odesláno ke kontrole. Stávající publikum zůstane beze změny až do schválení.',
    Edit: 'Upravit',
    '{value1} Edit with chat': '{value1} Upravit v chatu',
    '{value1} Duplicate to my Library': '{value1} Duplikovat do mé Knihovny',
    'Duplicated to your Library. Only you can see the copy.':
      'Zduplikováno do vaší Knihovny. Kopii vidíte pouze vy.',
    'Could not duplicate this Result. Try again.':
      'Tento výsledek se nepodařilo zduplikovat. Zkuste to znovu.',
    'Saved version {value1}.': 'Verze {value1} byla uložena.',
    'A newer version was saved. Reload the Result before saving.':
      'Byla uložena novější verze. Před uložením znovu načtěte výsledek.',
    'Could not save this version. Try again.': 'Tuto verzi se nepodařilo uložit. Zkuste to znovu.',
    '{value1} saved a newer version. Review it before saving.':
      '{value1} uložil(a) novější verzi. Před uložením ji zkontrolujte.',
    'Hide their version': 'Skrýt jejich verzi',
    'Show their version': 'Zobrazit jejich verzi',
    'Start from their version': 'Začít od jejich verze',
    Markdown: 'Markdown',
    'Result text': 'Text výsledku',
    Preview: 'Náhled',
    'What changed': 'Co se změnilo',
    'What changed? (optional)': 'Co se změnilo? (volitelné)',
    'Save version {value1}': 'Uložit verzi {value1}',
    'Open chat': 'Otevřít chat',
    Current: 'Aktuální',
    Restore: 'Obnovit',
    'Could not load the history.': 'Historii se nepodařilo načíst.',
    'Restored version {value1} as version {value2}.':
      'Verze {value1} byla obnovena jako verze {value2}.',
    'Someone saved a newer version. Review it before restoring.':
      'Někdo uložil novější verzi. Před obnovením ji zkontrolujte.',
    'Could not restore that version.': 'Tuto verzi se nepodařilo obnovit.',
    'Loading history…': 'Načítání historie…',
    'Restoring keeps what is there now as a version too, so nothing is lost.':
      'Obnovením se současný stav také uloží jako verze, takže se nic neztratí.',
    'This Result was made with your own {value1}.':
      'Tento výsledek byl vytvořen pomocí vašeho vlastního {value1}.',
    'It also used': 'Použil také',
    'This Result was made with': 'Tento výsledek byl vytvořen pomocí',
    'Colleagues can read what came from them, but can never use them.':
      'Kolegové mohou číst, co od nich pochází, ale nikdy to nemohou použít.',
    'Your personal agent {value1} keeps it up to date with your own access, so every refresh can carry your private data.':
      'Váš osobní agent {value1} ho udržuje aktuální pomocí vašeho přístupu, takže při každé aktualizaci může obsahovat vaše soukromá data.',
    'A colleague’s personal agent keeps it up to date with their own access, so every refresh can carry their private data.':
      'Osobní agent kolegy ho udržuje aktuální pomocí jeho přístupu, takže při každé aktualizaci může obsahovat jeho soukromá data.',
    'Made private. Only you can see this meeting.':
      'Nastaveno jako soukromé. Tuto schůzku vidíte pouze vy.',
    'Could not make this meeting private.': 'Tuto schůzku se nepodařilo nastavit jako soukromou.',
    'Meeting · {value1} {value2} · Original retained':
      'Schůzka · {value1} {value2} · Originál zachován',
    'The recording could not be opened.': 'Nahrávku se nepodařilo otevřít.',
    'Ask about this suggestion': 'Zeptat se na tento návrh',
    meeting_processing_failed: 'Zpracování schůzky se nezdařilo',
    'Who can see this': 'Kdo to může vidět',
    'Everyone at {value1}': 'Všichni v {value1}',
    'Only me': 'Pouze já',
    'Everyone at {value1} can find it and ask about it.':
      'Všichni v {value1} to mohou najít a ptát se na to.',
    'Only you can open and search this meeting. You can share it later.':
      'Tuto schůzku můžete otevřít a vyhledávat v ní pouze vy. Později ji můžete sdílet.',
    'Added. Only you can see it. Transcription is running in the background.':
      'Přidáno. Vidíte to pouze vy. Přepis probíhá na pozadí.',
    'Visible to everyone at {value1}': 'Viditelné pro všechny v {value1}',
    'Could not make it private.': 'Nepodařilo se to nastavit jako soukromé.',
    'Show more meetings': 'Zobrazit více schůzek',
    'Attached to this message': 'Připojeno k této zprávě',
    'Connect securely, choose the tables to share, then decide whether Poneva can read or make changes.':
      'Bezpečně se připojte, vyberte tabulky ke sdílení a poté rozhodněte, zda z nich Poneva může číst nebo v nich provádět změny.',
    'Review the tables this connection can access. Select at least one table.':
      'Zkontrolujte tabulky, ke kterým má toto připojení přístup. Vyberte alespoň jednu tabulku.',
    'Select at least one table. Nothing is selected by default.':
      'Vyberte alespoň jednu tabulku. Ve výchozím nastavení není vybráno nic.',
    'Choose who can use this connection and what Poneva can do.':
      'Vyberte, kdo může toto připojení používat a co může Poneva dělat.',
    'Your chosen access is enabled for the selected tables.':
      'Zvolený přístup je pro vybrané tabulky povolen.',
    'Your connection is saved with reading paused until permission is confirmed.':
      'Vaše připojení je uloženo a čtení je pozastaveno do potvrzení oprávnění.',
    'Confirm database disconnect': 'Potvrdit odpojení databáze',
    'Disconnect this database?': 'Odpojit tuto databázi?',
    'Access will stop for everyone using this connection.':
      'Přístup bude ukončen všem, kdo toto připojení používají.',
    'Keep connection': 'Ponechat připojení',
    'What it can reach · {value1}{value2} {value3}':
      'K čemu má přístup · {value1}{value2} {value3}',
    Back: 'Zpět',
    Continue: 'Pokračovat',
    'Uploading…': 'Nahrávání…',
    Library: 'Knihovna',
    'Source material for your work. Available whenever you need it.':
      'Podklady pro vaši práci. K dispozici, kdykoli je potřebujete.',
    'The work you want to keep, with its sources and conversation attached.':
      'Práce, kterou si chcete ponechat, včetně připojených zdrojů a konverzace.',
    Results: 'Výsledky',
    Files: 'Soubory',
    Artifacts: 'Artefakty',
    'Search library': 'Prohledat Knihovnu',
    'Find files by meaning…': 'Najít soubory podle významu…',
    'Find saved work by meaning…': 'Najít uloženou práci podle významu…',
    'Search coverage is limited while indexing or meaning-based search is unavailable. You can retry or browse recent items.':
      'Rozsah vyhledávání je omezený, dokud probíhá indexování nebo není dostupné vyhledávání podle významu. Můžete to zkusit znovu nebo procházet nedávné položky.',
    'No matching work found.': 'Nebyla nalezena žádná odpovídající práce.',
    'A starting point for your next question.': 'Výchozí bod pro vaši další otázku.',
    'Good work is worth keeping.': 'Dobrou práci stojí za to si ponechat.',
    'Try a different description or clear the search to browse.':
      'Zkuste jiný popis nebo vymažte vyhledávání a procházejte položky.',
    'Upload source material once and use it in conversations and Skills. Your original stays in the library.':
      'Nahrajte podklady jednou a používejte je v konverzacích a Dovednostech. Originál zůstane v Knihovně.',
    'Ask Poneva to save an answer, table or chart. Results stay connected to the conversation and their sources.':
      'Požádejte Ponevu o uložení odpovědi, tabulky nebo grafu. Výsledky zůstanou propojené s konverzací a jejich zdroji.',
    'Start in chat {value1}': 'Začít v chatu {value1}',
    'Could not update sharing.': 'Sdílení se nepodařilo aktualizovat.',
    'They can follow new answers live and fork it to continue with their own connections. Only you write here. You can make it private again at any time.':
      'Mohou v reálném čase sledovat nové odpovědi a vytvořit kopii pro pokračování s vlastními připojeními. Zde píšete pouze vy. Kdykoli jej můžete znovu nastavit jako soukromý.',
    'They see the project, its brief and the work in it they can already open. Nothing in it opens for anyone because of the project; each item keeps its own access.':
      'Uvidí projekt, jeho zadání a práci v něm, ke které už mají přístup. Nic se jim nezpřístupní jen díky projektu; každá položka si zachovává vlastní přístupová práva.',
    'Check the content for private information before sharing. Sharing an item does not grant access to its original chat or private connections.':
      'Před sdílením zkontrolujte obsah, zda neobsahuje soukromé informace. Sdílení položky neposkytuje přístup k původnímu chatu ani k soukromým připojením.',
    '{value1} Everyone you share with can read it, including what the assistant or an App in it found in your {value2}. They can’t use your {value3}. Nothing changes for you: the chat keeps working with all your accounts.':
      '{value1} Každý, s kým položku sdílíte, si ji může přečíst, včetně toho, co v ní asistent nebo aplikace našli ve vašem {value2}. Nemohou používat váš {value3}. Pro vás se nic nemění: chat dál funguje se všemi vašimi účty.',
    '{value1} Everyone you share with can read them, but nobody can use {value2} through this chat.':
      '{value1} Každý, s kým je sdílíte, si je může přečíst, ale nikdo nemůže prostřednictvím tohoto chatu používat {value2}.',
    'This controls access to the working draft. Any published company version stays available until you explicitly unpublish it. To publish a new version, complete its preview and use Save Skill. Run results stay private.':
      'Toto nastavení řídí přístup k pracovnímu konceptu. Každá publikovaná firemní verze zůstane dostupná, dokud ji výslovně nezrušíte. Chcete-li publikovat novou verzi, dokončete její náhled a použijte Uložit dovednost. Výsledky spuštění zůstávají soukromé.',
    'Skill deleted. You can restore it from the Skills archive for 30 days.':
      'Dovednost byla smazána. Z archivu dovedností ji můžete obnovit po dobu 30 dnů.',
    'Could not delete this Skill.': 'Tuto dovednost se nepodařilo smazat.',
    'More actions': 'Další akce',
    'Delete “{value1}”? It will disappear from Skills and search, and cannot be used by agents. You can restore it for 30 days. Existing chats and results stay available.':
      'Smazat „{value1}“? Zmizí z dovedností a vyhledávání a agenti ji nebudou moci používat. Po dobu 30 dnů ji můžete obnovit. Stávající chaty a výsledky zůstanou dostupné.',
    'Deleting…': 'Mazání…',
    'Confirm delete': 'Potvrdit smazání',
    'Delete Skill': 'Smazat dovednost',
    'Skill restored as an unpublished draft. Its author can review and publish it again.':
      'Dovednost byla obnovena jako nepublikovaný koncept. Její autor ji může zkontrolovat a znovu publikovat.',
    'Could not restore this Skill.': 'Tuto dovednost se nepodařilo obnovit.',
    'Archived Skills': 'Archivované dovednosti',
    'Deleted Skills can be restored for 30 days. Restoring leaves them unpublished.':
      'Smazané dovednosti lze po dobu 30 dnů obnovit. Po obnovení zůstanou nepublikované.',
    'Restore until {value1}': 'Obnovit do {value1}',
    'Loading…': 'Načítání…',
    'No archived Skills.': 'Žádné archivované dovednosti.',
    'Load more archived Skills': 'Načíst další archivované dovednosti',
    'Show more of the original': 'Zobrazit více původního obsahu',
    'Filter result rows': 'Filtrovat řádky výsledků',
    'Find a product or value…': 'Najít produkt nebo hodnotu…',
    '{value1} of {value2}': '{value1} z {value2}',
    'Result table': 'Tabulka výsledků',
    'No matching rows.': 'Žádné odpovídající řádky.',
    'Showing the first 1,000 matching rows. Download the CSV for every row.':
      'Zobrazuje se prvních 1 000 odpovídajících řádků. Stáhněte si CSV se všemi řádky.',
    'Agent ·': 'Agent ·',
    'Only you': 'Pouze vy',
    'Stopped before it finished.': 'Zastaveno před dokončením.',
    'Drafting the project…': 'Vytváření konceptu projektu…',
    'Checking where this chat belongs…': 'Kontrola, kam tento chat patří…',
    'Moving the chat…': 'Přesouvání chatu…',
    'Taking it out of the project…': 'Odebírání z projektu…',
    'Adding it to the project…': 'Přidávání do projektu…',
    'No matching connections are available right now.':
      'Momentálně nejsou k dispozici žádná odpovídající připojení.',
    'Company knowledge suggestion': 'Návrh firemních znalostí',
    'Company knowledge now lives on pages. Open Knowledge to see them.':
      'Firemní znalosti jsou nyní na stránkách. Otevřete Znalosti a zobrazte je.',
    '{value1} · Open beside this conversation': '{value1} · Otevřít vedle této konverzace',
    'Name {value1}': 'Název {value1}',
    'Host {value1}': 'Hostitel {value1}',
    'Port {value1}': 'Port {value1}',
    'Database {value1}': 'Databáze {value1}',
    'Username {value1}': 'Uživatelské jméno {value1}',
    'Password {value1}': 'Heslo {value1}',
    'Advanced TLS': 'Pokročilé TLS',
    '{value1} Poneva verifies the server certificate. Add a CA or server DNS name for IP hosts when your certificate requires it.':
      '{value1} Poneva ověřuje certifikát serveru. Pokud to váš certifikát vyžaduje, přidejte certifikační autoritu nebo DNS název serveru pro hostitele s IP adresou.',
    'CA certificate {value1}': 'Certifikát CA {value1}',
    'Certificate server DNS name {value1}': 'DNS název serveru certifikátu {value1}',
    '{value1} Your password is encrypted in secure storage. Poneva verifies the connection before saving it.':
      '{value1} Vaše heslo je zašifrováno v zabezpečeném úložišti. Poneva před uložením ověří připojení.',
    'Testing…': 'Testování…',
    'Test connection': 'Otestovat připojení',
    'PostgreSQL is connected.': 'PostgreSQL je připojen.',
    'PostgreSQL was saved safely.': 'PostgreSQL byl bezpečně uložen.',
    'Poneva can read and change rows in the selected tables. Apps also follow their approved data scope.':
      'Poneva může číst a měnit řádky ve vybraných tabulkách. Aplikace se také řídí schváleným rozsahem dat.',
    'Poneva can read the selected tables. Apps also follow their approved data scope.':
      'Poneva může číst vybrané tabulky. Aplikace se také řídí schváleným rozsahem dat.',
    'Reads are paused until permission is enabled.':
      'Čtení je pozastaveno, dokud nebude povoleno oprávnění.',
    'Retrying…': 'Opakování…',
    'Retry permission': 'Zkusit oprávnění znovu',
    'Try it in Chat': 'Vyzkoušet v chatu',
    Done: 'Hotovo',
    'Disconnect database': 'Odpojit databázi',
    '{value1} TLS verified ·{value2} {value3}': '{value1} TLS ověřeno ·{value2} {value3}',
    'Search schemas and tables': 'Prohledat schémata a tabulky',
    'Search tables': 'Prohledat tabulky',
    '{value1} of {value2} tables selected': 'Vybráno tabulek: {value1} z {value2}',
    'Select matching tables': 'Vybrat odpovídající tabulky',
    'Select all tables': 'Vybrat všechny tabulky',
    Clear: 'Vymazat',
    'Select a whole schema or individual tables. New tables need a fresh selection.':
      'Vyberte celé schéma nebo jednotlivé tabulky. Nové tabulky je třeba vybrat znovu.',
    'No tables match this search.': 'Tomuto vyhledávání neodpovídají žádné tabulky.',
    'All tables in {value1}': 'Všechny tabulky v {value1}',
    '{value1} / {value2} tables': '{value1} / {value2} tabulek',
    'Read & write available': 'K dispozici čtení i zápis',
    'Read only': 'Pouze pro čtení',
    Ctrl: 'Ctrl',
    'This suggested knowledge update could not be shown.':
      'Navrhovanou aktualizaci znalostí se nepodařilo zobrazit.',
    'Suggested knowledge update': 'Navrhovaná aktualizace znalostí',
    'This suggestion is no longer available to you.': 'Tento návrh už pro vás není k dispozici.',
    'We could not check where this suggestion stands.': 'Nepodařilo se ověřit stav tohoto návrhu.',
    'Check again': 'Zkontrolovat znovu',
    'Show on page': 'Zobrazit na stránce',
    'The editor could not be loaded. Poneva may have been updated since you opened this page. Reload to get the latest version; nothing on this page has changed.':
      'Editor se nepodařilo načíst. Poneva mohl být od otevření této stránky aktualizován. Načtěte nejnovější verzi; na této stránce se nic nezměnilo.',
    'Reload Poneva': 'Načíst Poneva znovu',
    Formatting: 'Formátování',
    'Text style': 'Styl textu',
    Text: 'Text',
    Heading: 'Nadpis',
    Subheading: 'Podnadpis',
    'Link a page': 'Propojit stránku',
    'A page needs a title.': 'Stránka musí mít název.',
    'Nothing has changed yet.': 'Zatím se nic nezměnilo.',
    'A page needs some text. To remove a page, archive it instead.':
      'Stránka musí obsahovat text. Chcete-li ji odstranit, místo toho ji archivujte.',
    'A suggested new page needs some text.': 'Navrhovaná nová stránka musí obsahovat text.',
    'This page is larger than 256 KB. Split it into smaller pages.':
      'Tato stránka je větší než 256 KB. Rozdělte ji na menší stránky.',
    'Say in a few words why this change is right.':
      'Stručně vysvětlete, proč je tato změna správná.',
    'This page changed while you were editing. Your text is still here: copy it, then open the latest version and make your change again.':
      'Tato stránka se během úprav změnila. Váš text je stále zde: zkopírujte ho, otevřete nejnovější verzi a proveďte změnu znovu.',
    'Your text is copied.': 'Text byl zkopírován.',
    'Your text could not be copied. Select it in the editor and copy it.':
      'Text se nepodařilo zkopírovat. Vyberte ho v editoru a zkopírujte.',
    'The page “{value1}” is created.': 'Stránka „{value1}“ byla vytvořena.',
    'New page': 'Nová stránka',
    'Editing {value1}': 'Úprava stránky {value1}',
    Editing: 'Úpravy',
    'Creating publishes the page under {value1} for everyone':
      'Vytvořením stránku zveřejníte pod {value1} pro všechny',
    'Saving publishes the new version for everyone': 'Uložením zveřejníte novou verzi pro všechny',
    'Your changes are sent as a suggestion for a publisher':
      'Vaše změny budou odeslány jako návrh ke schválení',
    'Create page': 'Vytvořit stránku',
    Save: 'Uložit',
    'Send suggestion': 'Odeslat návrh',
    '{value1} Copy my text': '{value1} Zkopírovat můj text',
    'Open the latest version': 'Otevřít nejnovější verzi',
    'Page title': 'Název stránky',
    'Loading the editor…': 'Načítání editoru…',
    'New page text': 'Text nové stránky',
    'Text of {value1}': 'Text stránky {value1}',
    'Write the page. Type [[ to link another page.':
      'Napište stránku. Pro propojení s jinou stránkou zadejte [[.',
    'Type [[ to link another page.': 'Pro propojení s jinou stránkou zadejte [[.',
    'Link to a page': 'Propojit se stránkou',
    'What changed, in a few words': 'Co se změnilo, stručně',
    'Where this comes from, in a few words': 'Odkud to pochází, stručně',
    'Shown in the page history.': 'Zobrazuje se v historii stránky.',
    'A publisher sees this next to your change.': 'Schvalovatel to uvidí vedle vaší změny.',
    '1 suggestion is open on this page': 'Na této stránce je otevřen 1 návrh',
    '{value1} suggestions are open on this page': 'Na této stránce je otevřeno {value1} návrhů',
    'They stay open while you edit. After you save, they show against your new text; one whose words you changed is marked outdated.':
      'Během úprav zůstávají otevřené. Po uložení se zobrazí u vašeho nového textu; návrh, jehož slova jste změnili, bude označen jako zastaralý.',
    'Type [[ to link another page. Links keep working when a page is renamed or moved.':
      'Pro propojení s jinou stránkou zadejte [[. Odkazy fungují i po přejmenování nebo přesunutí stránky.',
    'Loading the history…': 'Načítání historie…',
    'This page has no saved text yet.': 'Tato stránka zatím nemá uložený text.',
    'Say in a few words why this revision should come back.':
      'Stručně vysvětlete, proč by se tato revize měla obnovit.',
    'Revision {value1} is suggested for a publisher to accept.':
      'Revize {value1} byla navržena ke schválení.',
    'The page already reads like this revision.': 'Stránka už odpovídá této revizi.',
    'Revision {value1} is restored as revision {value2}.':
      'Revize {value1} byla obnovena jako revize {value2}.',
    'Revision history': 'Historie revizí',
    Revisions: 'Revize',
    'Every saved revision is kept.': 'Každá uložená revize se uchovává.',
    'Revision {value1} {value2}': 'Revize {value1} {value2}',
    'Revision {value1} compared with revision {value2}':
      'Porovnání revize {value1} s revizí {value2}',
    'Revision {value1}, the first text of this page': 'Revize {value1}, první text této stránky',
    'Green was added, struck through was removed.':
      'Zeleně je označen přidaný text, přeškrtnutý text byl odstraněn.',
    '{value1} Export Markdown': '{value1} Exportovat Markdown',
    'Restore this revision': 'Obnovit tuto revizi',
    'Suggest restoring it': 'Navrhnout obnovení',
    'Why should this revision come back?': 'Proč by se tato revize měla obnovit?',
    'Loading this revision…': 'Načítání této revize…',
    'Only the title changed, from “{value1}” to “{value2}”.':
      'Změnil se pouze název z „{value1}“ na „{value2}“.',
    'The text did not change in this revision.': 'Text se v této revizi nezměnil.',
    'Changes in revision {value1}': 'Změny v revizi {value1}',
    'Loading page…': 'Načítání stránky…',
    'Loading suggestion…': 'Načítání návrhu…',
    'This suggestion is not available.': 'Tento návrh není k dispozici.',
    'It may have been decided, or it is not one you can see.':
      'Možná už o něm bylo rozhodnuto nebo ho nemáte oprávnění zobrazit.',
    'Open Knowledge': 'Otevřít znalosti',
    'Opening the suggestion…': 'Otevírání návrhu…',
    'Choose where the page goes.': 'Vyberte, kam stránka patří.',
    'Say in a few words why.': 'Stručně vysvětlete proč.',
    'Your suggestion is sent. A publisher decides.':
      'Váš návrh byl odeslán. Rozhodne schvalovatel.',
    'Moved under {value1}.': 'Přesunuto pod {value1}.',
    'Deleted “{value1}”.': '„{value1}“ bylo odstraněno.',
    'Archived. Its history is kept.': 'Archivováno. Historie je zachována.',
    'Choose the page it goes under. Links to it keep working.':
      'Vyberte stránku, pod kterou bude. Odkazy na ni budou dál fungovat.',
    'Its text, its history and any open suggestions are removed for good, and links to it from other pages stop working. This cannot be undone.':
      'Její text, historie i všechny otevřené návrhy budou trvale odstraněny a odkazy na ni z ostatních stránek přestanou fungovat. Tuto akci nelze vrátit zpět.',
    'An archived page no longer informs answers. Its history is kept, and a publisher can restore it or delete it permanently.':
      'Archivovaná stránka už neovlivňuje odpovědi. Její historie je zachována a vydavatel ji může obnovit nebo trvale odstranit.',
    Under: 'Pod',
    Change: 'Změnit',
    'Move under': 'Přesunout pod',
    'Search pages': 'Hledat stránky',
    'Why?': 'Proč?',
    'Delete permanently': 'Trvale odstranit',
    'Move page': 'Přesunout stránku',
    'Archive page': 'Archivovat stránku',
    'Suggestion {value1}: show its card': 'Návrh {value1}: zobrazit jeho kartu',
    'Removed:': 'Odstraněno:',
    'Added:': 'Přidáno:',
    'New page “{value1}”{value2}': 'Nová stránka „{value1}“{value2}',
    'No pages match “{value1}”.': 'Žádné stránky neodpovídají „{value1}“.',
    'Where this page is': 'Umístění této stránky',
    'Describe your company': 'Popište svou společnost',
    'Empty page': 'Prázdná stránka',
    'Describe {value1}': 'Popište {value1}',
    'This page has no text yet.': 'Tato stránka zatím nemá žádný text.',
    'Poneva reads this page before every answer. Start with who you are, what you sell and how you work; details go on the pages under it.':
      'Poneva si tuto stránku přečte před každou odpovědí. Začněte tím, kdo jste, co prodáváte a jak pracujete; podrobnosti patří na stránky pod ní.',
    'Write it, or ask Poneva in chat to draft it for you.':
      'Napište ho sami, nebo požádejte Ponevu v chatu, aby ho připravila za vás.',
    'Suggest a first version, and a publisher decides whether it becomes the page.':
      'Navrhněte první verzi a vydavatel rozhodne, zda se z ní stane stránka.',
    'Start writing': 'Začít psát',
    'Suggest a first version': 'Navrhnout první verzi',
    'Accepted. The page is archived.': 'Přijato. Stránka je archivována.',
    'Accepted. The page is now revision {value1}.': 'Přijato. Stránka je nyní ve verzi {value1}.',
    'Accepted.': 'Přijato.',
    'Suggestion rejected. The page stays as it is.': 'Návrh zamítnut. Stránka zůstává beze změny.',
    'Your suggestion is withdrawn.': 'Váš návrh byl stažen.',
    'Restored. The page informs answers again.': 'Obnoveno. Stránka znovu ovlivňuje odpovědi.',
    'Your suggestion is sent. A publisher decides whether it becomes the page.':
      'Váš návrh byl odeslán. Vydavatel rozhodne, zda se z něj stane stránka.',
    'Saved. The page is now revision {value1}.': 'Uloženo. Stránka je nyní ve verzi {value1}.',
    'Nothing changed.': 'Nic se nezměnilo.',
    'This page is not available.': 'Tato stránka není dostupná.',
    'It may have been deleted, archived or moved out of reach, or you may no longer be in this company.':
      'Mohla být odstraněna, archivována nebo přesunuta mimo váš dosah, případně už nemusíte být v této společnosti.',
    'Page actions': 'Akce stránky',
    shown: 'zobrazeno',
    hidden: 'skryto',
    '{value1} History': 'Historie {value1}',
    '{value1} Ask in chat': '{value1} Zeptat se v chatu',
    'Suggest edits': 'Navrhnout úpravy',
    'More actions for {value1}': 'Další akce pro {value1}',
    '{value1} Poneva reads this page in every chat':
      '{value1} Poneva tuto stránku čte v každém chatu',
    'This page is archived. It no longer informs answers; its history is kept. {value1}':
      'Tato stránka je archivována. Už neovlivňuje odpovědi, její historie je zachována. {value1}',
    'Restore page': 'Obnovit stránku',
    'This link points to an earlier revision. You are reading the current text.':
      'Tento odkaz vede na starší verzi. Čtete aktuální text.',
    'Show it in History': 'Zobrazit v historii',
    Pages: 'Stránky',
    'Pages under {value1}': 'Stránky pod {value1}',
    'Linked from': 'Odkazy z',
    Suggestions: 'Návrhy',
    'Suggestions are hidden. You are reading the page as everyone else sees it.':
      'Návrhy jsou skryté. Čtete stránku tak, jak ji vidí ostatní.',
    'Loading suggestions…': 'Načítání návrhů…',
    'Nothing is waiting for review.': 'Nic nečeká na kontrolu.',
    'When someone, Poneva in a chat or a connected agent suggests a change to a page, it shows here and on the page. Nothing changes until a publisher accepts it.':
      'Když někdo, Poneva v chatu nebo připojený agent navrhne změnu stránky, zobrazí se zde i na stránce. Nic se nezmění, dokud ji vydavatel nepřijme.',
    '{value1} Review knowledge in chat': '{value1} Zkontrolovat znalosti v chatu',
    'Suggestions for review': 'Návrhy ke kontrole',
    'Suggested changes from chats, meetings, colleagues and connected agents. Nothing changes until a publisher accepts it on the page.':
      'Navrhované změny z chatů, schůzek, od kolegů a připojených agentů. Nic se nezmění, dokud je vydavatel nepřijme na stránce.',
    'Your suggestions wait here until a publisher decides. The pages stay as they are until then.':
      'Vaše návrhy zde čekají, dokud vydavatel nerozhodne. Do té doby zůstávají stránky beze změny.',
    'Review page': 'Zkontrolovat stránku',
    'Review on page': 'Zkontrolovat na stránce',
    'Open the meeting': 'Otevřít schůzku',
    'Open the chat': 'Otevřít chat',
    'Accept and restore': 'Přijmout a obnovit',
    Accept: 'Přijmout',
    Reject: 'Zamítnout',
    'Your suggestion · waiting for a publisher': 'Váš návrh · čeká na vydavatele',
    Withdraw: 'Stáhnout',
    'Waiting for a publisher': 'Čeká na vydavatele',
    'Suggestion {value1}': 'Návrh {value1}',
    'Suggestion {value1} from {value2}{value3}': 'Návrh {value1} od {value2}{value3}',
    'Read the suggested page': 'Přečíst navrhovanou stránku',
    'Outdated: the text it changes was edited after it was suggested. It can be rejected or withdrawn; a new suggestion can be made against the current text.':
      'Zastaralé: text, který návrh mění, byl po jeho vytvoření upraven. Návrh lze zamítnout nebo stáhnout; na aktuální text lze vytvořit nový návrh.',
    'Restore this page first to accept this suggestion.':
      'Nejprve tuto stránku obnovte, abyste mohli návrh přijmout.',
    'Previous suggestion': 'Předchozí návrh',
    'Suggestion {value1} of {value2}': 'Návrh {value1} z {value2}',
    'Next suggestion': 'Další návrh',
    'Fold the suggestions away': 'Sbalit návrhy',
    'Show the suggestions': 'Zobrazit návrhy',
    '1 suggestion': '1 návrh',
    '{value1} suggestions': '{value1} návrhů',
    '{value1} the pages under {value2}': '{value1} stránky pod {value2}',
    px: 'px',
    '{value1} chart of {value2} across {value3}': '{value1} grafu {value2} napříč {value3}',
    'We could not build the file.': 'Soubor se nepodařilo vytvořit.',
    '{value1} Present': '{value1} Přítomno',
    'Building…': 'Vytváření…',
    'Download PowerPoint': 'Stáhnout PowerPoint',
    'Slide {value1} of {value2}': 'Snímek {value1} z {value2}',
    Slides: 'Snímky',
    'Slide {value1}': 'Snímek {value1}',
    'Speaker notes': 'Poznámky pro řečníka',
    'Source: {value1}': 'Zdroj: {value1}',
    'Add a name and a web address.': 'Přidejte název a webovou adresu.',
    'Enter a valid web address.': 'Zadejte platnou webovou adresu.',
    'Use a web address that starts with https://.':
      'Použijte webovou adresu začínající na https://.',
    'Add a custom connection': 'Přidat vlastní připojení',
    'Connect a tool server you trust. Poneva checks the address works and saves only the connection details needed to use it.':
      'Připojte server nástrojů, kterému důvěřujete. Poneva ověří, že adresa funguje, a uloží pouze údaje o připojení potřebné k jeho používání.',
    'Web address': 'Webová adresa',
    'https://tools.example.com': 'https://tools.example.com',
    'Starts with https://, from your provider': 'Začíná na https://, od vašeho poskytovatele',
    'Sign-in': 'Přihlášení',
    'Advanced sign-in': 'Pokročilé přihlášení',
    'Access key {value1}': 'Přístupový klíč {value1}',
    'Request headers': 'Hlavičky požadavku',
    'Add header': 'Přidat hlavičku',
    'Header {value1} name': 'Název hlavičky {value1}',
    'Header name': 'Název hlavičky',
    'Header {value1} value': 'Hodnota hlavičky {value1}',
    'Header value': 'Hodnota hlavičky',
    'Remove header': 'Odebrat hlavičku',
    Advanced: 'Pokročilé',
    Transport: 'Přenos',
    'Auto-detect': 'Automaticky rozpoznat',
    'Streamable HTTP': 'Streamable HTTP',
    'Legacy SSE': 'Starší SSE',
    "From your provider's app settings. Leave empty unless they gave you these.":
      'Z nastavení aplikace vašeho poskytovatele. Ponechte prázdné, pokud vám tyto údaje neposkytl.',
    "Authorization server issuer": "Vydavatel autorizačního serveru",
    "Enter the authorization server issuer when using a client ID.": "Při použití ID klienta zadejte vydavatele autorizačního serveru.",
    'Client ID {value1}': 'ID klienta {value1}',
    'Client secret {value1}': 'Tajný klíč klienta {value1}',
    'Connecting…': 'Připojování…',
    'Test and connect': 'Otestovat a připojit',
    'Add the store, the client ID and the client secret.':
      'Přidejte obchod, ID klienta a tajný klíč klienta.',
    'Connect your Shopify Developer App': 'Připojte svou vývojářskou aplikaci Shopify',
    'Poneva can use exactly the access your store gave the app, and nothing more. It talks to Shopify directly and keeps the client secret encrypted.':
      'Poneva může využívat přesně ta oprávnění, která váš obchod aplikaci udělil, a žádná další. Komunikuje přímo se Shopify a tajný klíč klienta uchovává zašifrovaný.',
    'How to create the app in Shopify': 'Jak vytvořit aplikaci v Shopify',
    'Open{value1} {value2}{value3} with the account that owns the store, and create an app.':
      'Otevřete{value1} {value2}{value3} účtem vlastníka obchodu a vytvořte aplikaci.',
    'Create a version and select the access scopes Poneva may use, for example read_products and read_orders. Add write_ scopes only for data Poneva may change. Then release the version.':
      'Vytvořte verzi a vyberte rozsahy přístupu, které může Poneva používat, například read_products a read_orders. Rozsahy write_ přidejte pouze pro data, která může Poneva měnit. Poté verzi zveřejněte.',
    'For orders and customers, also select protected customer data in the app’s settings. Shopify allows this without review for an app made for your own store.':
      'U objednávek a zákazníků také v nastavení aplikace vyberte chráněná zákaznická data. Shopify to u aplikace vytvořené pro váš vlastní obchod umožňuje bez kontroly.',
    'Install the app on your store.': 'Nainstalujte aplikaci do svého obchodu.',
    'Copy the client ID and client secret from the app’s settings.':
      'Zkopírujte ID klienta a tajný klíč klienta z nastavení aplikace.',
    'To change the access later, release a new version, approve it on the store and use Test connection here.':
      'Chcete-li později změnit přístup, zveřejněte novou verzi, schvalte ji v obchodě a zde použijte možnost Otestovat připojení.',
    Store: 'Obchod',
    'your-store.myshopify.com': 'your-store.myshopify.com',
    'Your store’s .myshopify.com address (Shopify admin → Settings → Domains), or paste the address of your Shopify admin page':
      'Adresa vašeho obchodu .myshopify.com (správa Shopify → Settings → Domains) nebo vložte adresu stránky správy Shopify',
    'Client ID {value1} {value2}': 'ID klienta {value1} {value2}',
    'Client secret {value1} {value2}': 'Tajný klíč klienta {value1} {value2}',
    Person: 'Osoba',
    Everyone: 'Všichni',
    Connection: 'Připojení',
    'All connections': 'Všechna připojení',
    'App {value1}': 'Aplikace {value1}',
    'From {value1}': 'Od {value1}',
    'Until {value1}': 'Do {value1}',
    Result: 'Výsledek',
    'All results': 'Všechny výsledky',
    Succeeded: 'Úspěšné',
    Denied: 'Zamítnuté',
    Failed: 'Neúspěšné',
    Unknown: 'Neznámé',
    Filter: 'Filtrovat',
    'Loading activity…': 'Načítání aktivity…',
    'Could not load activity. Try again.': 'Aktivitu se nepodařilo načíst. Zkuste to znovu.',
    'Removed connection': 'Odebrané připojení',
    'App: {value1}': 'Aplikace: {value1}',
    'Older activity': 'Starší aktivita',
    'Enable this schedule when approved': 'Po schválení tento plán povolit',
    Schedule: 'Plán',
    'Kept off until you create the agent from its canvas.':
      'Zůstane vypnutý, dokud agenta nevytvoříte z jeho plátna.',
    'Will be enabled when you approve.': 'Po schválení bude povolen.',
    'Will be saved paused. You can enable it later.':
      'Uloží se pozastavený. Později ho můžete povolit.',
    'Only runs when you ask.': 'Spustí se jen na vyžádání.',
    'Draft · approving saves it, and nothing runs. Test it and create it from its canvas.':
      'Návrh · schválením ho uložíte a nic se nespustí. Otestujte ho a vytvořte z jeho plátna.',
    'Draft · nothing is scheduled until you approve. Connected actions require their own approval at run time.':
      'Návrh · dokud ho neschválíte, nic není naplánováno. Připojené akce vyžadují vlastní schválení při spuštění.',
    Name: 'Název',
    'Agent name': 'Název agenta',
    'Who can use it': 'Kdo ho může používat',
    'Company agent · company resources only': 'Firemní agent · pouze firemní zdroje',
    'Personal agent · runs with your access': 'Osobní agent · spouští se s vaším přístupem',
    'Approving saves it as a draft. It does not run automatically.':
      'Schválením ho uložíte jako návrh. Nespouští se automaticky.',
    'Open the agent’s runs': 'Otevřít spuštění agenta',
    'Run the published version once': 'Jednou spustit publikovanou verzi',
    'Stopping…': 'Zastavování…',
    'Stop run': 'Zastavit spuštění',
    'Could not stop this run. Please try again.':
      'Toto spuštění se nepodařilo zastavit. Zkuste to znovu.',
    'Run in progress': 'Spuštění probíhá',
    'This run is still answering. You can ask follow-ups when it finishes.':
      'Toto spuštění stále odpovídá. Po jeho dokončení můžete položit doplňující otázky.',
    'Open run details': 'Otevřít podrobnosti spuštění',
    Runs: 'Spuštění',
    'Open the run chat': 'Otevřít chat spuštění',
    Watch: 'Sledovat',
    Goal: 'Cíl',
    'Change the goal': 'Změnit cíl',
    'What it does': 'Co dělá',
    'What should this agent achieve?': 'Čeho má tento agent dosáhnout?',
    'Not set yet.': 'Zatím není nastaveno.',
    'When it runs': 'Kdy se spouští',
    'Change when it runs': 'Změnit, kdy se spouští',
    'Off means it runs only when someone runs it. Changing when it runs never changes its instructions.':
      'Vypnuto znamená, že se spustí jen tehdy, když ho někdo spustí. Změna času spuštění nikdy nemění jeho pokyny.',
    Instructions: 'Pokyny',
    'Change the instructions': 'Změnit pokyny',
    'How the agent should approach the work and make decisions.':
      'Jak má agent přistupovat k práci a rozhodovat se.',
    Boundaries: 'Omezení',
    'What to do or avoid. Every connected action still follows its approval.':
      'Co dělat nebo čemu se vyhnout. Každá připojená akce se stále řídí svým schválením.',
    'No instructions of its own. It follows its Skills.':
      'Nemá vlastní pokyny. Řídí se svými dovednostmi.',
    'Pin a Skill': 'Připnout dovednost',
    'Finds the Skills that fit each run, the same way a chat does.':
      'Pro každé spuštění vyhledá vhodné dovednosti stejně jako chat.',
    'Skills it always follows': 'Dovednosti, kterými se vždy řídí',
    'A Skill that is not published': 'Dovednost, která není publikovaná',
    'Always follows · Version {value1}': 'Vždy se řídí · Verze {value1}',
    'Not published': 'Není publikováno',
    Uses: 'Používá',
    'Change in chat': 'Změnit v chatu',
    'Change in chat: Uses': 'Změnit v chatu: Používá',
    'Company knowledge and the tools each run is allowed to use.':
      'Firemní znalosti a nástroje, které může každé spuštění používat.',
    'People see the Result refresh; they change the agent, not the page.':
      'Lidé uvidí aktualizovaný výsledek; mění agenta, nikoli stránku.',
    'The first run after it is created makes the Result; later runs add a version to it.':
      'První spuštění po vytvoření vytvoří výsledek; další spuštění do něj přidají verzi.',
    'Emails whoever the run is for': 'Pošle e-mail osobě, pro kterou je spuštění určeno',
    'Email each run': 'Poslat e-mailem každé spuštění',
    Delivers: 'Dodává',
    'Change what it delivers': 'Změnit, co dodává',
    'Expected result': 'Očekávaný výsledek',
    'What a successful run should deliver.': 'Co má úspěšné spuštění dodat.',
    'What each run delivers': 'Co dodává každé spuštění',
    'Keeps one Result up to date {value1}': 'Udržuje jeden výsledek aktuální {value1}',
    'Saves a new Result each run': 'Při každém spuštění uloží nový výsledek',
    'You can run this company agent as yourself.{value1} {value2}':
      'Tohoto firemního agenta můžete spustit jako sebe.{value1} {value2}',
    'Changes since version': 'Změny od verze',
    'are not live yet.': 'zatím nejsou aktivní.',
    'Review them in Versions': 'Prohlédnout ve verzích',
    Skill: 'Dovednost',
    'The agent always uses the Skill’s published version.':
      'Agent vždy používá publikovanou verzi dovednosti.',
    Day: 'Den',
    Time: 'Čas',
    'Cron expression': 'Výraz cron',
    'Editors and access': 'Editoři a přístup',
    Company: 'Firemní',
    Personal: 'Osobní',
    'No changes.': 'Žádné změny.',
    'Instructions changes': 'Změny pokynů',
    'Loading versions…': 'Načítání verzí…',
    'What the draft changes': 'Co návrh mění',
    'No published version yet. Try the draft, then publish it.':
      'Zatím není k dispozici žádná publikovaná verze. Vyzkoušejte návrh a poté ho publikujte.',
    'Published versions': 'Publikované verze',
    'Former member': 'Bývalý člen',
    Live: 'Aktivní',
    Download: 'Stáhnout',
    CSV: 'CSV',
    'Evidence for {value1}': 'Důkazy pro {value1}',
    Measure: 'Metrika',
    'Show rows →': 'Zobrazit řádky →',
    'Ask about this number': 'Zeptat se na toto číslo',
    'There are no numeric values available to chart. View the table for the original data.':
      'Nejsou k dispozici žádné číselné hodnoty pro graf. Původní data zobrazíte v tabulce.',
    'Chart value': 'Hodnota grafu',
    '{value1} of {value2} shown': 'Zobrazeno {value1} z {value2}',
    '{value1} by {value2}; {value3} rows. View Table for exact values.':
      '{value1} podle {value2}; {value3} řádků. Přesné hodnoty zobrazíte v tabulce.',
    'Values come directly from the source data. Missing values are not estimates.':
      'Hodnoty pocházejí přímo ze zdrojových dat. Chybějící hodnoty nejsou odhady.',
    'Loading library…': 'Načítání knihovny…',
    'We couldn’t load what happened in this App. Try again in a moment.':
      'Nepodařilo se načíst, co se v této aplikaci stalo. Zkuste to za chvíli znovu.',
    'This App could not be opened.': 'Tuto aplikaci se nepodařilo otevřít.',
    'Opening App…': 'Otevírání aplikace…',
    'Open the saved App to run this function.': 'Tuto funkci spustíte otevřením uložené aplikace.',
    'Save this App before running its function.': 'Před spuštěním funkce tuto aplikaci uložte.',
    'Open saved App': 'Otevřít uloženou aplikaci',
    'Open Apps': 'Otevřít aplikace',
    'The App could not be opened. Try again.': 'Aplikaci se nepodařilo otevřít. Zkuste to znovu.',
    Owner: 'Vlastník',
    '{value1} · admins': '{value1} · administrátoři',
    'Owner · always edits': 'Vlastník · může vždy upravovat',
    'Admins manage it': 'Spravují ho administrátoři',
    Editors: 'Upravující',
    'A colleague': 'Kolega',
    'Can edit drafts and publish versions': 'Může upravovat návrhy a zveřejňovat verze',
    Remove: 'Odebrat',
    'No editors yet.': 'Zatím žádní upravující.',
    'Admins can always edit company agents.': 'Administrátoři mohou vždy upravovat firemní agenty.',
    'Asking for edit access': 'Žádost o přístup k úpravám',
    'Asked {value1} · also in your Inbox': 'Požádáno {value1} · také ve vaší doručené poště',
    Grant: 'Udělit',
    Admin: 'Administrátor',
    'Make personal': 'Nastavit jako osobní',
    'Switch off': 'Vypnout',
    Archive: 'Archivovat',
    'Archive this agent': 'Archivovat tohoto agenta',
    'Loading agent…': 'Načítání agenta…',
    '{value1} Edit in chat': '{value1} Upravit v chatu',
    Agent: 'Agent',
    'This agent has not been created yet. It can run once its owner creates it.':
      'Tento agent ještě nebyl vytvořen. Spustit ho lze, jakmile ho vytvoří jeho vlastník.',
    'New agent · Draft': 'Nový agent · Návrh',
    'Untitled agent': 'Agent bez názvu',
    'Test run': 'Testovací spuštění',
    'This draft does not run automatically.': 'Tento návrh se nespouští automaticky.',
    'Describe the agent in the chat. Its draft appears here.':
      'Popište agenta v chatu. Jeho návrh se zobrazí zde.',
    '{value1} Test run': '{value1} Testovací spuštění',
    'Describe the agent in the chat first.': 'Nejprve popište agenta v chatu.',
    'Create and turn on': 'Vytvořit a zapnout',
    'Connection write setup': 'Nastavení zápisu do připojení',
    'Account for connected changes': 'Účet pro změny v připojených službách',
    'Choose a connection': 'Vyberte připojení',
    'No published Skills available. You can add them later.':
      'Nejsou k dispozici žádné zveřejněné dovednosti. Můžete je přidat později.',
    '{value1} · not published. Review the changes. Testing is optional.':
      '{value1} · nezveřejněno. Zkontrolujte změny. Testování je volitelné.',
    '{value1} Test draft': '{value1} Otestovat návrh',
    'Apply changes…': 'Použít změny…',
    'Apply this draft as a new version': 'Použít tento návrh jako novou verzi',
    'This draft cannot be applied.': 'Tento návrh nelze použít.',
    'What changed?': 'Co se změnilo?',
    'Apply version {value1}': 'Použít verzi {value1}',
    Create: 'Vytvořit',
    'Edit access requested': 'Požadavek na přístup k úpravám',
    '{value1} Request edit access': '{value1} Požádat o přístup k úpravám',
    '{value1} Copy agent': '{value1} Kopírovat agenta',
    Pause: 'Pozastavit',
    'Open agent: {value1}': 'Otevřít agenta: {value1}',
    '· you can edit': '· můžete upravovat',
    '{value1} is switched off.': '{value1} je vypnutý.',
    '{value1} is archived.': '{value1} je archivovaný.',
    'Loading agents…': 'Načítání agentů…',
    Agents: 'Agenti',
    'Agents do work for you on a schedule or when you ask. They follow your company’s Skills.':
      'Agenti pro vás pracují podle plánu nebo na vyžádání. Řídí se dovednostmi vaší společnosti.',
    'No agent matches. Try a Skill name or what the agent should do.':
      'Žádný agent neodpovídá. Zkuste název dovednosti nebo popis toho, co má agent dělat.',
    'Nothing of your own yet': 'Zatím nic vlastního',
    'Tell Chat what an agent should do, or copy one of the company’s agents below.{value1}':
      'Řekněte Chatu, co má agent dělat, nebo níže zkopírujte některého z firemních agentů.{value1}',
    'Your agents': 'Vaši agenti',
    'Run on demand': 'Spouštět na vyžádání',
    'Run is always available. A schedule is optional and lives separately from the agent’s instructions.':
      'Spuštění je vždy k dispozici. Plán je volitelný a existuje samostatně od pokynů agenta.',
    'What changed in version {value1}': 'Co se změnilo ve verzi {value1}',
    'Every publish is a version you can restore.':
      'Každé publikování je verze, kterou můžete obnovit.',
    Authorization: 'Autorizace',
    '{value1} {value2} · {value3} will see it.': '{value1} {value2} · {value3} ho uvidí.',
    '{value1} {value2} you': '{value1} {value2} vám',
    '· Revised': '· Upraveno',
    'This chat used your {value1}.': 'Tento chat použil váš {value1}.',
    'This chat has results from {value1}.': 'Tento chat obsahuje výsledky z {value1}.',
    'db.example.com': 'db.example.com',
    'e.g. Product analytics': 'např. Analýza produktů',
    'Paste access key': 'Vložte přístupový klíč',
    'Shopify’s Dev Dashboard': 'Vývojářský panel Shopify',
    'App reference': 'Reference aplikace',
    'Draft · revision {value1}': 'Koncept · revize {value1}',
    'its Result': 'jeho výsledek',
    '· its first run makes it': '· jeho první spuštění ho vytvoří',
    '{value1}’s chat ·': 'Chat uživatele {value1} ·',
    '{value1} ad {value2} available.': '{value1} a {value2} jsou k dispozici.',
    '{value1} rows ·': '{value1} řádků ·',
    'It starts private. Sharing it wider shares every refresh, which can carry your private data.':
      'Na začátku je soukromé. Sdílením s více lidmi zpřístupníte každou aktualizaci, která může obsahovat vaše soukromá data.',
    '{value1} for {value2}': '{value1} pro {value2}',
    Suggested: 'Navrhované',
    'Opening your conversation…': 'Otevírání konverzace…',
    'This conversation isn’t available': 'Tato konverzace není dostupná',
    'It may have been deleted, belong to another account, or be temporarily unavailable.':
      'Mohla být smazána, patřit k jinému účtu nebo být dočasně nedostupná.',
    '{count} more line — shown in the complete revision':
      '{count} další řádek — zobrazen v úplné revizi',
    '{count} more lines — shown in the complete revision':
      '{count} dalších řádků — zobrazeno v úplné revizi',
    '{count} more line removed': '{count} další řádek odstraněn',
    '{count} more lines removed': '{count} dalších řádků odstraněno',
    '{count} unchanged line': '{count} nezměněný řádek',
    '{count} unchanged lines': '{count} nezměněných řádků',
    '{count} more lines not shown, {added} added and {removed} removed. Check them in the complete revision.':
      '{count} dalších řádků není zobrazeno, {added} přidáno a {removed} odstraněno. Zkontrolujte je v úplné revizi.',
    'Saved result': 'Uložený výsledek',
    'Made with a Skill': 'Vytvořeno pomocí dovednosti',
    'Preview of {name}': 'Náhled {name}',
    'Made with {name}': 'Vytvořeno pomocí {name}',
    'Ad-hoc result': 'Výsledek na vyžádání',
    'A Skill that is not available in this workspace':
      'Dovednost, která není v tomto pracovním prostoru dostupná',
    '{name} · Revision {version}': '{name} · Revize {version}',
    '{name} · Version {version}': '{name} · Verze {version}',
    'Return to conversation {value1}': 'Návrat do konverzace {value1}',
    '{value1} Working with {value2}': '{value1} pracuje s {value2}',
    'View context {value1}': 'Zobrazit kontext {value1}',
    'A way of working, made yours.': 'Způsob práce, který si přizpůsobíte.',
    'Work that runs itself.': 'Práce, která se provádí sama.',
    'One place for one piece of work.': 'Jedno místo pro jednu práci.',
    'Let’s move your work forward{value1}.': 'Posuňme vaši práci dál{value1}.',
    'Describe the work. Your Skill takes shape beside the conversation.':
      'Popište práci. Vaše dovednost se začne formovat vedle konverzace.',
    'Describe what it should do and when. Your agent takes shape beside the conversation. The draft does not run automatically.':
      'Popište, co má dělat a kdy. Váš agent se začne formovat vedle konverzace. Návrh se nespouští automaticky.',
    'Say what the work is. Poneva drafts the project beside the conversation and brings in what you have already done. Nothing is created until you say so.':
      'Řekněte, o jakou práci jde. Poneva připraví návrh projektu vedle konverzace a doplní, co jste už udělali. Nic se nevytvoří, dokud to neschválíte.',
    'Start with an idea below. Poneva will take it from there.':
      'Začněte níže nápadem. Poneva se postará o zbytek.',
    Triggers: 'Spouštěče',
    'Review the agent and its trigger. Approval applies exactly what is shown.':
      'Zkontrolujte agenta a jeho spouštěč. Schválení přesně použije to, co je zobrazeno.',
    '{source} · read {date}': '{source} · načteno {date}',
    'Evidence is being recorded · read {date}': 'Záznam se pořizuje · načteno {date}',
    'Evidence expired on {date} under the retention policy':
      'Záznam vypršel {date} podle zásad uchovávání',
    'Entered by {person}': 'Zadal(a) {person}',
    'No retained evidence for this value': 'Pro tuto hodnotu nejsou uchovávány žádné záznamy',
    'Covers {shown} of {total} rows': 'Pokrývá {shown} z {total} řádků',
    'Search rows': 'Hledat v řádcích',
    'Clear filters': 'Zrušit filtry',
    Sort: 'Seřadit',
    'Sort: {column}': 'Řadit: {column}',
    '{shown} of {total} rows': '{shown} z {total} řádků',
    More: 'Více',
    Density: 'Hustota',
    Comfortable: 'Prostorné',
    Compact: 'Kompaktní',
    Columns: 'Sloupce',
    'No rows match. Clear the search or filters to see them again.':
      'Žádné řádky neodpovídají. Zrušte hledání nebo filtry a znovu je zobrazte.',
    'Not available': 'Není k dispozici',
    'All rows': 'Všechny řádky',
    'Close row detail': 'Zavřít podrobnosti řádku',
    'Ask about this row': 'Zeptat se na tento řádek',
    'Add note': 'Přidat poznámku',
    Note: 'Poznámka',
    Saved: 'Uloženo',
    Total: 'Celkem',
    ascending: 'vzestupně',
    descending: 'sestupně',
    'Scroll to see all columns': 'Posunutím zobrazíte všechny sloupce',
    App: 'Aplikace',
    Artifact: 'Artefakt',
    'New project': 'Nový projekt',
    'Review request': 'Žádost o kontrolu',
    Activity: 'Aktivita',
    'Voice preview': 'Náhled hlasu',
    Source: 'Zdroj',
    File: 'Soubor',
    Meeting: 'Schůzka',
    'Knowledge page': 'Stránka znalostí',
    'Could not preview this CSV.': 'Náhled tohoto CSV se nepodařilo zobrazit.',
    'File content is unavailable.': 'Obsah souboru není k dispozici.',
    'You have five open suggestions here. {value1} will see them.':
      'Máte zde pět otevřených návrhů. Uvidí je {value1}.',
    'We could not send your suggestion. Please try again.':
      'Návrh se nepodařilo odeslat. Zkuste to znovu.',
    'The agent': 'Agent',
    'Selected colleagues': 'Vybraní kolegové',
    'The owner': 'Vlastník',
    'Forked. This copy is yours and runs with your own connections.':
      'Vytvořena kopie. Tato kopie je vaše a používá vaše vlastní připojení.',
    'This chat is too long to fork.': 'Tento chat je příliš dlouhý na vytvoření kopie.',
    'We could not fork this chat. Please try again.':
      'Kopii tohoto chatu se nepodařilo vytvořit. Zkuste to znovu.',
    'Anyone who forked it keeps their copy: forks stay with the people who made them.':
      'Každý, kdo vytvořil kopii, si ji ponechá: kopie zůstávají u lidí, kteří je vytvořili.',
    'Nobody has forked this chat.': 'Nikdo nevytvořil kopii tohoto chatu.',
    '1 person forked this chat. Their copy stays theirs.':
      'Kopii tohoto chatu vytvořil 1 člověk. Jeho kopie zůstává jeho.',
    '{value1} people forked this chat. Their copies stay theirs.':
      'Kopii tohoto chatu vytvořilo {value1} lidí. Jejich kopie zůstávají jejich.',
    'Personal. Nobody else sees it.': 'Osobní. Nikdo další ji neuvidí.',
    'People you pick. They get it in their Inbox.':
      'Lidé, které vyberete. Dostanou ji do doručené pošty.',
    'Everyone in the company can follow it and fork it.':
      'Kdokoli ve společnosti ji může sledovat a vytvořit její kopii.',
    'a chat you can no longer open': 'chat, který už nemůžete otevřít',
    'shared the Result': 'sdílel(a) výsledek',
    'updated the Result': 'aktualizoval(a) výsledek',
    'published the Skill': 'zveřejnil(a) dovednost',
    'approved the fact': 'schválil(a) fakt',
    'added the fact': 'přidal(a) fakt',
    'added the meeting': 'přidal(a) schůzku',
    'published the page': 'zveřejnil(a) stránku',
    'updated the page': 'aktualizoval(a) stránku',
    'shared the chat': 'sdílel(a) chat',
    'published a version of': 'zveřejnil(a) verzi',
    ran: 'spustil(a)',
    Knowledge: 'Znalosti',
    Meetings: 'Schůzky',
    Chat: 'Chat',
    Use: 'Použít',
    Open: 'Otevřít',
    You: 'Vy',
    Someone: 'Někdo',
    'published version {version} of': 'zveřejnil(a) verzi {version}',
    'thing needs': 'položka vyžaduje',
    'things need': 'položky vyžadují',
    'Published Skill': 'Zveřejněná dovednost',
    'Included with Skill': 'Součást dovednosti',
    'Already attached': 'Již připojeno',
    'Also available in company knowledge': 'K dispozici také ve znalostech společnosti',
    'Company file': 'Soubor společnosti',
    'Account identity unavailable': 'Identita účtu není k dispozici',
    'Access expired or was revoked. Reconnect to continue.':
      'Přístup vypršel nebo byl odvolán. Pro pokračování se znovu připojte.',
    'Account authorized · tools unavailable': 'Účet autorizován · nástroje nejsou k dispozici',
    'Not available in this workspace yet.': 'V tomto pracovním prostoru zatím není k dispozici.',
    'Everyone in the company': 'Všichni ve společnosti',
    'Audience: only you.': 'Publikum: pouze vy.',
    'Audience: everyone in the company.': 'Publikum: všichni ve společnosti.',
    'tool is': 'nástroj je',
    'tools are': 'nástroje jsou',
    'account is': 'účet je',
    'accounts are': 'účty jsou',
    'We could not upload this file.': 'Tento soubor se nepodařilo nahrát.',
    'file was': 'soubor byl',
    'files were': 'soubory byly',
    'Your company': 'Vaše společnost',
    'Create an agent': 'Vytvořit agenta',
    'Give recurring work a helping hand': 'Usnadněte si opakovanou práci',
    'Create a Skill': 'Vytvořit dovednost',
    'Save a reusable way of working': 'Uložte si opakovatelný způsob práce',
    'Take meeting notes': 'Pořizovat zápisy z porad',
    'Capture decisions and next steps': 'Zachytit rozhodnutí a další kroky',
    'Work with a file': 'Pracovat se souborem',
    'Start from a document or image': 'Začít dokumentem nebo obrázkem',
    'Browse agents': 'Procházet agenty',
    'Open your agents and company agents': 'Otevřít vlastní agenty a agenty společnosti',
    'Review results': 'Prohlédnout výsledky',
    'Return to work saved in your Library': 'Vrátit se k práci uložené v Knihovně',
    'For review': 'Ke kontrole',
    'An agent': 'Agent',
    Assistant: 'Asistent',
    'Kept up to date by {value1}{value2}': 'Aktualizuje {value1}{value2}',
    ', {value1}': ', {value1}',
    'Version {value1}{value2}{value3}': 'Verze {value1}{value2}{value3}',
    'Refreshed by its agent': 'Aktualizuje ji její agent',
    'Saved from a chat': 'Uloženo z chatu',
    'Saved from {value1}': 'Uloženo z aplikace {value1}',
    Edited: 'Upraveno',
    'private account': 'soukromý účet',
    '{value1} ({value2})': '{value1} ({value2})',
    '{value1}’s {value2}': '{value2} uživatele {value1}',
    'Made private. The person who added it and the owner of its recording have been told in their Inbox.':
      'Nastaveno jako soukromé. Osoba, která jej přidala, a vlastník jeho záznamu byli informováni ve své doručené poště.',
    'Made private. The person who added it has been told in their Inbox.':
      'Nastaveno jako soukromé. Osoba, která jej přidala, byla informována ve své doručené poště.',
    'Made private. The owner of its recording has been told in their Inbox.':
      'Nastaveno jako soukromé. Vlastník jeho záznamu byl informován ve své doručené poště.',
    'Selected passage': 'Vybraná pasáž',
    '{value1} {value2}': '{value1} {value2}',
    'Upload a file': 'Nahrát soubor',
    'Help me create a useful report from our company knowledge and available sources.':
      'Pomozte mi vytvořit užitečný report ze znalostí naší společnosti a dostupných zdrojů.',
    'This saved work couldn’t be opened. Open it again to retry.':
      'Tuto uloženou práci se nepodařilo otevřít. Otevřete ji znovu a zkuste to znovu.',
    '{value1}’s': 'uživatele {value1}',
    '{value1} chat “{value2}”': 'Chat uživatele {value1} „{value2}“',
    '{value1}{value2}': '{value1}{value2}',
    'Skill: {value1}{value2}': 'Dovednost: {value1}{value2}',
    'Result “{value1}”': 'Výsledek „{value1}“',
    'Meeting “{value1}”': 'Porada „{value1}“',
    'Used in {value1} {value2} this week': 'Tento týden použito v {value1} {value2}',
    '{value1} {value2} · used in {value3} {value4}':
      '{value1} {value2} · použito v {value3} {value4}',
    'The draft is not published yet, so no one else follows it.':
      'Koncept zatím není publikován, takže jej nikdo další nesleduje.',
    'Use it in a chat for current data, or refine the Skill first.':
      'Použijte ji v chatu s aktuálními daty nebo nejprve dovednost upravte.',
    'An agent keeps this up to date. Continue the work in chat.':
      'Agent toto udržuje aktuální. Pokračujte v práci v chatu.',
    'Edit it here, or continue the work in chat.':
      'Upravte ji zde nebo pokračujte v práci v chatu.',
    'Duplicate it to your Library, or continue the work in chat.':
      'Vytvořte její kopii ve své Knihovně nebo pokračujte v práci v chatu.',
    'Download Markdown': 'Stáhnout Markdown',
    'Download CSV': 'Stáhnout CSV',
    'an agent': 'agent',
    'Publish a Skill version': 'Publikovat verzi dovednosti',
    'Share with {value1}': 'Sdílet s {value1}',
    'Update company content': 'Aktualizovat obsah společnosti',
    Approved: 'Schváleno',
    Declined: 'Zamítnuto',
    Pending: 'Čeká na vyřízení',
    'View decision': 'Zobrazit rozhodnutí',
    'No data': 'Žádná data',
    'No change': 'Beze změny',
    'Connection created': 'Připojení vytvořeno',
    'Sharing changed': 'Sdílení změněno',
    'Person added': 'Osoba přidána',
    'Person removed': 'Osoba odebrána',
    'Access changed': 'Přístup změněn',
    'Access turned off': 'Přístup vypnut',
    'Connection removed': 'Připojení odebráno',
    'Query time limit changed': 'Časový limit dotazu změněn',
    '{count} row': '{count} řádek',
    '{count} rows': '{count} řádků',
    'This source is no longer available. Company knowledge now lives in Knowledge pages, and files stay in the Library.':
      'Tento zdroj již není k dispozici. Znalosti společnosti jsou nyní na stránkách znalostí a soubory zůstávají v Knihovně.',
    '· {value1} by {value2}': '· {value1} od {value2}',
    '· version {value1}': '· verze {value1}',
    '{message} {count} earlier file was saved and attached.':
      '{message} {count} starší soubor byl uložen a připojen.',
    '{message} {count} earlier files were saved and attached.':
      '{message} {count} starší soubory byly uloženy a připojeny.',
    '{message} {count} earlier file was saved.': '{message} {count} starší soubor byl uložen.',
    '{message} {count} earlier files were saved.': '{message} {count} starší soubory byly uloženy.',
    'refreshed {time}': 'aktualizováno {time}',
    'a colleague': 'kolega',
    'Your chat “{title}”': 'Váš chat „{title}“',
    '{name}’s chat “{title}”': 'Chat uživatele {name} „{title}“',
    'Kept up to date by {name}{version}': 'Průběžně aktualizuje {name}{version}',
    'Skill: {name}{version}': 'Dovednost: {name}{version}',
    'Result “{title}”': 'Výsledek „{title}“',
    'Meeting “{title}”': 'Schůzka „{title}“',
    'Used in {count} answer this week': 'Tento týden použito v {count} odpovědi',
    'Used in {count} answers this week': 'Tento týden použito v {count} odpovědích',
    '{count} source': '{count} zdroj',
    '{count} sources': '{count} zdrojů',
    'used in {count} place': 'použito na {count} místě',
    'used in {count} places': 'použito na {count} místech',
    '{company} workspace': '{company} pracovní prostor',
    '{count} page': '{count} stránka',
    '{count} pages': '{count} stránek',
    '{needs} · reviews and approvals': '{needs} · kontroly a schválení',
    '{count} thing needs you': '{count} položka čeká na vás',
    '{count} things need you': '{count} položek čeká na vás',
    'Included with Skill · {files} · {sources} {icon}':
      'Součást dovednosti · {files} · {sources} {icon}',
    '{count} file': '{count} soubor',
    '{count} files': '{count} souborů',
    Today: 'Dnes',
    'Earlier this week': 'Dříve tento týden',
    '{count} slide': '{count} snímek',
    '{count} slides': '{count} snímků',
    Early: 'Předběžně',
    'TLS verified': 'TLS ověřeno',
    'Made personal and switched off. Switch it on when you are ready.':
      'Nastaveno jako osobní a vypnuto. Až budete připraveni, zapněte to.',
    'Made personal and switched off. Its owner is told which version is live.':
      'Nastaveno jako osobní a vypnuto. Jeho vlastník je informován, která verze je aktivní.',
    'Switched off.': 'Vypnuto.',
    'Applied version {revision}.': 'Použita verze {revision}.',
    'The draft is running in a chat only you can read.':
      'Koncept běží v chatu, který můžete číst jen vy.',
    'Publish a version first.': 'Nejprve publikujte verzi.',
    'Another Agent action is in progress.': 'Probíhá jiná akce agenta.',
    'Knowledge & connections': 'Znalosti a připojení',
    'Pinned Skills': 'Připnuté dovednosti',
    None: 'Žádné',
    'A new Result each run': 'Při každém spuštění nový výsledek',
    'One Result kept up to date': 'Jeden výsledek průběžně aktualizovaný',
    Email: 'E-mail',
    On: 'Zapnuto',
    Off: 'Vypnuto',
    'Waiting for review': 'Čeká na kontrolu',
    Outdated: 'Zastaralé',
    Accepted: 'Přijato',
    Rejected: 'Zamítnuto',
    Withdrawn: 'Staženo',
    Replaced: 'Nahrazeno',
    'Suggested edit': 'Navrhovaná úprava',
    'Suggested new page': 'Navrhovaná nová stránka',
    'Suggested move': 'Navrhované přesunutí',
    'Suggested archive': 'Navrhovaná archivace',
    'Checking status…': 'Kontroluje se stav…',
    'Status unavailable': 'Stav není k dispozici',
    'Bulleted list': 'Odrážkový seznam',
    'Numbered list': 'Číslovaný seznam',
    'Web link': 'Webový odkaz',
    Read: 'Číst',
    Write: 'Zapisovat',
    'shared with you': 'sdíleno s vámi',
    'Getting an answer': 'Získávání odpovědi',
    '{name} is getting an answer': '{name} získává odpověď',
    'We could not save. Please try again.': 'Nepodařilo se uložit. Zkuste to znovu.',
    'The new page could not be created.': 'Novou stránku se nepodařilo vytvořit.',
    'We could not load this revision.': 'Tuto verzi se nepodařilo načíst.',
    'We could not restore this revision. Please try again.':
      'Tuto verzi se nepodařilo obnovit. Zkuste to znovu.',
    'We could not export this revision.': 'Tuto verzi se nepodařilo exportovat.',
    'We could not open this suggestion.': 'Tento návrh se nepodařilo otevřít.',
    'We could not do that. Please try again.': 'Tuto akci se nepodařilo provést. Zkuste to znovu.',
    'We could not save your decision. Please try again.':
      'Vaše rozhodnutí se nepodařilo uložit. Zkuste to znovu.',
    'We could not restore this page. Please try again.':
      'Tuto stránku se nepodařilo obnovit. Zkuste to znovu.',
    'We could not export this page.': 'Tuto stránku se nepodařilo exportovat.',
    '{count} missed time merged.': '{count} zmeškaný čas byl sloučen.',
    '{count} missed times merged.': '{count} zmeškaných časů bylo sloučeno.',
    'About this project': 'O tomto projektu',
  },
  da: {
    'We could not load this item.': 'Vi kunne ikke indlæse dette element.',
    '{value1} canvas': '{value1} lærred',
    'Loading {value1}…': 'Indlæser {value1}…',
    '{value1} · Original retained': '{value1} · Original bevaret',
    '{value1} {value2}{value3} · Added {value4}': '{value1} {value2}{value3} · Tilføjet {value4}',
    '{value1} Use in chat': '{value1} Brug i chat',
    '{value1} Download': 'Hent {value1}',
    Table: 'Tabel',
    Chart: 'Diagram',
    Original: 'Oprindelig',
    'Text extracted from the PDF, marked by page. Download the original for its layout and images.':
      'Tekst udtrukket fra PDF-filen og markeret efter side. Download originalen for at se layout og billeder.',
    'This preview shows the beginning of the file. Poneva reads the whole file; download the original to see all of it.':
      'Denne forhåndsvisning viser begyndelsen af filen. Poneva læser hele filen; download originalen for at se det hele.',
    'Preview of the first {value1} complete rows. Filtering and charts use only this preview. Download the original for the full file.':
      'Forhåndsvisning af de første {value1} komplette rækker. Filtrering og diagrammer bruger kun denne forhåndsvisning. Download originalen for at se hele filen.',
    'This source link cannot be opened.': 'Dette kildelink kan ikke åbnes.',
    'Read-only chat': 'Skrivebeskyttet chat',
    'Only {value1} writes in this chat. Fork it to continue with your own connections. {value2}':
      'Det er kun {value1}, der skriver i denne chat. Opret en forgrening for at fortsætte med dine egne forbindelser. {value2}',
    'Suggest a follow-up…': 'Foreslå en opfølgning…',
    'Suggest a follow-up': 'Foreslå en opfølgning',
    'Sending…': 'Sender…',
    Send: 'Send',
    'We could not dismiss that suggestion. Please try again.':
      'Vi kunne ikke afvise forslaget. Prøv igen.',
    'Suggested follow-ups': 'Foreslåede opfølgninger',
    '{value1} suggests': '{value1} foreslår',
    Ask: 'Spørg',
    'Dismiss {value1}’s suggestion': 'Afvis {value1}s forslag',
    'Suggested by': 'Foreslået af',
    '· edit it or send it': '· rediger det eller send det',
    'Remove the suggestion tag': 'Fjern forslagsmærket',
    '{value1} {value2} is getting an answer': '{value1} {value2} er ved at få et svar',
    '{value1} {value2} stopped the answer': '{value1} {value2} stoppede svaret',
    '{value1} Fork from here': '{value1} Opret forgrening herfra',
    '{value1} From {value2}’s {value3}': '{value1} Fra {value2}s {value3}',
    'Only {value1} can use this account': 'Det er kun {value1}, der kan bruge denne konto',
    '{value1} Suggested by {value2}': '{value1} Foreslået af {value2}',
    'Fork this chat': 'Opret en forgrening af denne chat',
    'Forking…': 'Opretter forgrening…',
    Fork: 'Opret forgrening',
    'Could not make this private.': 'Kunne ikke gøre dette privat.',
    'Make this chat private?': 'Vil du gøre denne chat privat?',
    Close: 'Luk',
    '{value1} will see “{value2}”. Everyone else loses access right away {value3} .{value4}':
      '{value1} kan se “{value2}”. Alle andre mister adgangen med det samme {value3} .{value4}',
    Cancel: 'Annuller',
    'Saving…': 'Gemmer…',
    'Make private': 'Gør privat',
    'This chat is private again. Forks others made stay theirs.':
      'Denne chat er privat igen. Forgreninger, som andre har oprettet, forbliver deres.',
    'Who can read this chat: {value1}': 'Hvem kan læse denne chat: {value1}',
    'Move this chat': 'Flyt denne chat',
    'Only you write here. Others follow live and fork.':
      'Det er kun dig, der skriver her. Andre følger med live og kan oprette en forgrening.',
    'Made private. {value1} has been told in their Inbox.':
      'Gjort privat. {value1} er blevet underrettet i sin indbakke.',
    'Chat access': 'Chatadgang',
    '{value1}’s chat. As an admin you can make it private.':
      '{value1}s chat. Som administrator kan du gøre den privat.',
    'Only {value1} will see it. {value2} is told.':
      'Det er kun {value1}, der kan se den. {value2} er blevet underrettet.',
    '{value1} {value2} following': '{value1} {value2} følger med',
    'Forked from{value1} {value2} . The history is copied. From here, tools run with your own access.':
      'Forgrenet fra{value1} {value2} . Historikken er kopieret. Herfra kører værktøjer med din egen adgang.',
    '{value1} made this chat private': '{value1} gjorde denne chat privat',
    'You can no longer open it. Any fork you made stays yours.':
      'Du kan ikke længere åbne den. Alle forgreninger, du har oprettet, forbliver dine.',
    'Start a new chat': 'Start en ny chat',
    'Back to Recent chats': 'Tilbage til Seneste chats',
    'More chat actions': 'Flere chat-handlinger',
    'Close conversation sharing': 'Luk samtaledeling',
    'Review the text before saving a private copy to Library. Then choose its audience. Your original conversation and future messages stay private.':
      'Gennemgå teksten, før du gemmer en privat kopi i Bibliotek. Vælg derefter målgruppe. Din oprindelige samtale og fremtidige beskeder forbliver private.',
    'Preparing the conversation…': 'Forbereder samtalen…',
    'Refresh preview': 'Opdater forhåndsvisning',
    'The copy is saved in Library. Use Share to choose who can access it.':
      'Kopien er gemt i Bibliotek. Brug Del for at vælge, hvem der kan få adgang til den.',
    'Save this copy': 'Gem denne kopi',
    'That Skill could not be opened.': 'Den pågældende færdighed kunne ikke åbnes.',
    '{value1}{value2} · reviews and approvals': '{value1}{value2} · gennemgange og godkendelser',
    'Open Inbox': 'Åbn indbakke',
    'New at {value1} this week': 'Nyt hos {value1} i denne uge',
    'Nothing new this week. Shared work, published Skills and approved knowledge show up here.':
      'Intet nyt i denne uge. Delt arbejde, publicerede færdigheder og godkendt viden vises her.',
    'New at {value1}': 'Nyt hos {value1}',
    'This Skill is unavailable. Try again.': 'Denne færdighed er ikke tilgængelig. Prøv igen.',
    'You can attach up to {value1} files. Remove an attachment to add another.':
      'Du kan vedhæfte op til {value1} filer. Fjern en vedhæftning for at tilføje en ny.',
    'Add company context': 'Tilføj virksomhedskontekst',
    'Add company context · @': 'Tilføj virksomhedskontekst · @',
    'Choose a Skill': 'Vælg en færdighed',
    'Choose a Skill · /': 'Vælg en færdighed · /',
    context: 'kontekst',
    skills: 'færdigheder',
    'Choose company context': 'Vælg virksomhedskontekst',
    'Skills for this conversation': 'Færdigheder til denne samtale',
    'Bring context into the conversation': 'Føj kontekst til samtalen',
    'Close context picker': 'Luk kontekstvælger',
    'Filter company context': 'Filtrér virksomhedskontekst',
    'Find a Skill…': 'Find en færdighed…',
    'Find a file…': 'Find en fil…',
    'Available company context': 'Tilgængelig virksomhedskontekst',
    'No matching published Skills.': 'Ingen matchende udgivne færdigheder.',
    'No matching files.': 'Ingen matchende filer.',
    'Searching company work…': 'Søger i virksomhedens arbejde…',
    'Try search again': 'Prøv at søge igen',
    'Meaning search is temporarily limited. Showing available text matches.':
      'Betydningssøgning er midlertidigt begrænset. Viser tilgængelige tekstmatch.',
    'Load more matches': 'Indlæs flere match',
    '{value1} files attached. Remove an attachment to add another. Saved Skill references are included separately.':
      '{value1} filer vedhæftet. Fjern en vedhæftet fil for at tilføje en mere. Gemte færdighedsreferencer medtages separat.',
    'Create a Skill in chat': 'Opret en færdighed i chatten',
    'Upload a company file': 'Upload en virksomhedsfil',
    'Company knowledge is always available to Poneva.':
      'Virksomhedsviden er altid tilgængelig for Poneva.',
    '{value1} was not connected': '{value1} blev ikke forbundet',
    Dismiss: 'Luk',
    'Try connecting again': 'Prøv at oprette forbindelse igen',
    Waiting: 'Venter',
    Connected: 'Forbundet',
    'Needs reconnecting': 'Skal forbindes igen',
    Connect: 'Forbind',
    '{value1}{value2} The provider’s account permissions still apply.':
      '{value1}{value2} Udbyderens kontotilladelser gælder stadig.',
    'Last error: {value1}': 'Seneste fejl: {value1}',
    '{value1} {value2} ready.': '{value1} {value2} er klar.',
    'Continue with my Meta app': 'Fortsæt med min Meta-app',
    Reconnect: 'Forbind igen',
    Disconnect: 'Afbryd forbindelsen',
    'Remove attachment: {value1}': 'Fjern vedhæftet fil: {value1}',
    'Saved in this Skill. Edit the Skill to change its references.':
      'Gemt i denne færdighed. Rediger færdigheden for at ændre dens referencer.',
    'Remove Skill context': 'Fjern færdighedskontekst',
    Refining: 'Forfiner',
    Previewing: 'Forhåndsviser',
    Using: 'Bruger',
    'Skill revision {value1}': 'Færdighedsversion {value1}',
    'a new Skill': 'en ny færdighed',
    '{value1} Making a new agent {value2}': '{value1} Opretter en ny agent {value2}',
    'Stop making a new agent in this chat': 'Stop med at oprette en ny agent i denne chat',
    'Saved Skill references': 'Gemte færdighedsreferencer',
    'Included with Skill · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}':
      'Inkluderet med færdigheden · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}',
    'Selected Skill revision is unavailable. Select the Skill again to view its saved references.':
      'Den valgte færdighedsversion er ikke tilgængelig. Vælg færdigheden igen for at se dens gemte referencer.',
    'Conversation attachments': 'Vedhæftede filer i samtalen',
    'Added for this conversation': 'Tilføjet til denne samtale',
    'Selected passage {value1}': 'Valgt tekstudsnit {value1}',
    'We could not load your workspace.': 'Vi kunne ikke indlæse dit arbejdsområde.',
    'The selected Skill is unavailable. Check its access or choose it again.':
      'Den valgte færdighed er ikke tilgængelig. Kontrollér adgangen, eller vælg den igen.',
    'Source saved privately and included in your knowledge search.':
      'Kilden er gemt privat og medtaget i din videnssøgning.',
    'File saved privately to your library and attached to this message.':
      'Filen er gemt privat i dit bibliotek og vedhæftet denne besked.',
    'File saved privately to your library.': 'Filen er gemt privat i dit bibliotek.',
    '{value1} {value2} earlier {value3} saved{value4}.':
      '{value1} {value2} tidligere {value3} gemt{value4}.',
    'Extracted text for Poneva to read. Download the original for its layout, charts and images. Spreadsheet formulas show their saved results and are not recalculated.':
      'Udpakket tekst, som Poneva kan læse. Download originalen for at bevare layout, diagrammer og billeder. Regnearksformler viser deres gemte resultater og genberegnes ikke.',
    Esc: 'Esc',
    'Start something': 'Start noget',
    'Choose a file to work with': 'Vælg en fil at arbejde med',
    'Skills worth adding': 'Færdigheder, der er værd at tilføje',
    'Picked for you': 'Udvalgt til dig',
    'Reusable work grounded in your company knowledge.':
      'Genanvendeligt arbejde baseret på din virksomhedsviden.',
    'Ideas from your company context and recent work. Pick one to start.':
      'Idéer fra din virksomhedskontekst og dit seneste arbejde. Vælg en for at komme i gang.',
    'Refresh suggested tasks': 'Opdatér foreslåede opgaver',
    'Check for new company context.': 'Søg efter ny virksomhedskontekst.',
    'Check for new context. Ideas also refresh daily.':
      'Søg efter ny kontekst. Idéer opdateres også dagligt.',
    Refresh: 'Opdatér',
    'Finding useful starting points…': 'Finder nyttige udgangspunkter…',
    'Suggestions aren’t available right now. Try Refresh, or describe the work you want to do.':
      'Forslag er ikke tilgængelige lige nu. Prøv Opdatér, eller beskriv det arbejde, du vil udføre.',
    'Loading the knowledge pages…': 'Indlæser videnssiderne…',
    '{value1} All pages': '{value1} Alle sider',
    'The page is created.': 'Siden er oprettet.',
    'Your new page is suggested. A publisher decides whether it is added.':
      'Din nye side er foreslået. En udgiver afgør, om den skal tilføjes.',
    'Company knowledge': 'Virksomhedsviden',
    'What Poneva knows about your company, page by page. Every change is kept.':
      'Det, Poneva ved om din virksomhed, side for side. Alle ændringer bevares.',
    'Loading company knowledge…': 'Indlæser virksomhedsviden…',
    'Knowledge pages are not enabled in this workspace.':
      'Videnssider er ikke aktiveret i dette arbejdsområde.',
    'Ask your Poneva contact to switch them on for your company.':
      'Bed din Poneva-kontakt om at slå dem til for din virksomhed.',
    '{value1} Change the agent': '{value1} Skift agent',
    '{value1} Continue in chat': '{value1} Fortsæt i chatten',
    Edit: 'Rediger',
    '{value1} Edit with chat': '{value1} Rediger med chat',
    '{value1} Duplicate to my Library': '{value1} Kopiér til mit bibliotek',
    'Duplicated to your Library. Only you can see the copy.':
      'Kopieret til dit bibliotek. Kun du kan se kopien.',
    'Could not duplicate this Result. Try again.': 'Resultatet kunne ikke kopieres. Prøv igen.',
    'Saved version {value1}.': 'Version {value1} er gemt.',
    'A newer version was saved. Reload the Result before saving.':
      'En nyere version er gemt. Genindlæs resultatet, før du gemmer.',
    'Could not save this version. Try again.': 'Versionen kunne ikke gemmes. Prøv igen.',
    '{value1} saved a newer version. Review it before saving.':
      '{value1} har gemt en nyere version. Gennemgå den, før du gemmer.',
    'Hide their version': 'Skjul deres version',
    'Show their version': 'Vis deres version',
    'Start from their version': 'Start fra deres version',
    Markdown: 'Markdown',
    'Result text': 'Resultattekst',
    Preview: 'Forhåndsvisning',
    'What changed': 'Hvad er ændret',
    'What changed? (optional)': 'Hvad er ændret? (valgfrit)',
    'Save version {value1}': 'Gem version {value1}',
    'Open chat': 'Åbn chat',
    Current: 'Nuværende',
    Restore: 'Gendan',
    'Could not load the history.': 'Historikken kunne ikke indlæses.',
    'Restored version {value1} as version {value2}.':
      'Version {value1} er gendannet som version {value2}.',
    'Someone saved a newer version. Review it before restoring.':
      'Nogen har gemt en nyere version. Gennemgå den, før du gendanner.',
    'Could not restore that version.': 'Den version kunne ikke gendannes.',
    'Loading history…': 'Indlæser historik…',
    'Restoring keeps what is there now as a version too, so nothing is lost.':
      'Ved gendannelse gemmes det nuværende også som en version, så intet går tabt.',
    'This Result was made with your own {value1}.':
      'Dette resultat blev lavet med din egen {value1}.',
    'It also used': 'Det brugte også',
    'This Result was made with': 'Dette resultat blev lavet med',
    'Colleagues can read what came from them, but can never use them.':
      'Kollegaer kan læse det, der kom fra dem, men kan aldrig bruge dem.',
    'Your personal agent {value1} keeps it up to date with your own access, so every refresh can carry your private data.':
      'Din personlige agent {value1} holder det opdateret med din egen adgang, så hver opdatering kan indeholde dine private data.',
    'A colleague’s personal agent keeps it up to date with their own access, so every refresh can carry their private data.':
      'En kollegas personlige agent holder det opdateret med deres egen adgang, så hver opdatering kan indeholde deres private data.',
    'Made private. Only you can see this meeting.': 'Gjort privat. Kun du kan se dette møde.',
    'Could not make this meeting private.': 'Mødet kunne ikke gøres privat.',
    'Meeting · {value1} {value2} · Original retained':
      'Møde · {value1} {value2} · Originalen er bevaret',
    'The recording could not be opened.': 'Optagelsen kunne ikke åbnes.',
    'Ask about this suggestion': 'Spørg om dette forslag',
    meeting_processing_failed: 'mødebehandling_mislykkedes',
    'Who can see this': 'Hvem kan se dette',
    'Everyone at {value1}': 'Alle i {value1}',
    'Only me': 'Kun mig',
    'Everyone at {value1} can find it and ask about it.':
      'Alle i {value1} kan finde det og spørge om det.',
    'Only you can open and search this meeting. You can share it later.':
      'Kun du kan åbne og søge i dette møde. Du kan dele det senere.',
    'Added. Only you can see it. Transcription is running in the background.':
      'Tilføjet. Kun du kan se det. Transskriberingen kører i baggrunden.',
    'Visible to everyone at {value1}': 'Synligt for alle i {value1}',
    'Could not make it private.': 'Det kunne ikke gøres privat.',
    'Show more meetings': 'Vis flere møder',
    'Attached to this message': 'Vedhæftet denne besked',
    'Connect securely, choose the tables to share, then decide whether Poneva can read or make changes.':
      'Opret forbindelse sikkert, vælg de tabeller, der skal deles, og beslut derefter, om Poneva må læse eller foretage ændringer.',
    'Review the tables this connection can access. Select at least one table.':
      'Gennemgå de tabeller, som denne forbindelse har adgang til. Vælg mindst én tabel.',
    'Select at least one table. Nothing is selected by default.':
      'Vælg mindst én tabel. Intet er valgt som standard.',
    'Choose who can use this connection and what Poneva can do.':
      'Vælg, hvem der må bruge denne forbindelse, og hvad Poneva må gøre.',
    'Your chosen access is enabled for the selected tables.':
      'Den valgte adgang er aktiveret for de valgte tabeller.',
    'Your connection is saved with reading paused until permission is confirmed.':
      'Din forbindelse er gemt, og læsning er sat på pause, indtil tilladelsen er bekræftet.',
    'Confirm database disconnect': 'Bekræft afbrydelse af databaseforbindelse',
    'Disconnect this database?': 'Afbryd forbindelsen til denne database?',
    'Access will stop for everyone using this connection.':
      'Adgangen ophører for alle, der bruger denne forbindelse.',
    'Keep connection': 'Behold forbindelse',
    'What it can reach · {value1}{value2} {value3}':
      'Hvad den har adgang til · {value1}{value2} {value3}',
    Back: 'Tilbage',
    Continue: 'Fortsæt',
    'Uploading…': 'Uploader…',
    Library: 'Bibliotek',
    'Source material for your work. Available whenever you need it.':
      'Kildemateriale til dit arbejde. Tilgængeligt, når du har brug for det.',
    'The work you want to keep, with its sources and conversation attached.':
      'Det arbejde, du vil gemme, med tilhørende kilder og samtale.',
    Results: 'Resultater',
    Files: 'Filer',
    Artifacts: 'Artefakter',
    'Search library': 'Søg i bibliotek',
    'Find files by meaning…': 'Find filer efter betydning…',
    'Find saved work by meaning…': 'Find gemt arbejde efter betydning…',
    'Search coverage is limited while indexing or meaning-based search is unavailable. You can retry or browse recent items.':
      'Søgedækningen er begrænset, mens indeksering eller betydningsbaseret søgning ikke er tilgængelig. Du kan prøve igen eller gennemse de seneste elementer.',
    'No matching work found.': 'Intet matchende arbejde fundet.',
    'A starting point for your next question.': 'Et udgangspunkt for dit næste spørgsmål.',
    'Good work is worth keeping.': 'Godt arbejde er værd at gemme.',
    'Try a different description or clear the search to browse.':
      'Prøv en anden beskrivelse, eller ryd søgningen for at gennemse indholdet.',
    'Upload source material once and use it in conversations and Skills. Your original stays in the library.':
      'Upload kildemateriale én gang, og brug det i samtaler og Kompetencer. Originalen bliver i biblioteket.',
    'Ask Poneva to save an answer, table or chart. Results stay connected to the conversation and their sources.':
      'Bed Poneva om at gemme et svar, en tabel eller et diagram. Resultaterne forbliver knyttet til samtalen og dens kilder.',
    'Start in chat {value1}': 'Start i chat {value1}',
    'Open result: {value1}': 'Åbn resultat: {value1}',
    'Loading more library items…': 'Indlæser flere elementer fra biblioteket…',
    'Load more': 'Indlæs flere',
    'Documents, transcripts, audio and video · Up to 500 MB per file. New files are private. Choose their audience with Share and which processable files become searchable company knowledge.':
      'Dokumenter, transskripter, lyd og video · Op til 500 MB pr. fil. Nye filer er private. Vælg deres målgruppe med Del, og hvilke filer der kan behandles, som skal blive søgbar virksomhedsviden.',
    Skills: 'Kompetencer',
    'Create in chat': 'Opret i chat',
    'Search Skills': 'Søg i kompetencer',
    'Search finds published Skills. Clear the search to browse your drafts too.':
      'Søgningen finder publicerede kompetencer. Ryd søgningen for også at gennemse dine kladder.',
    'Search coverage is limited while indexing or meaning-based search is unavailable.':
      'Søgedækningen er begrænset, mens indeksering eller betydningsbaseret søgning ikke er tilgængelig.',
    'Searching Skills…': 'Søger i kompetencer…',
    'No matching published Skills found. Try a different description.':
      'Fandt ingen matchende publicerede kompetencer. Prøv en anden beskrivelse.',
    'Load more Skills': 'Indlæs flere kompetencer',
    'View Skill: {value1}': 'Se kompetence: {value1}',
    'Company workspace': 'Virksomhedsarbejdsområde',
    'View {value1}': 'Se {value1}',
    'Loading Skills…': 'Indlæser kompetencer…',
    'Try again {value1}': 'Prøv igen {value1}',
    'Try again': 'Prøv igen',
    'Nothing yet.': 'Intet endnu.',
    'Made from · Used by': 'Baseret på · Bruges af',
    'Could not load links': 'Kunne ikke indlæse links',
    'Made from': 'Baseret på',
    'Used by': 'Bruges af',
    'About this chat {value1}': 'Om denne chat {value1}',
    'About this chat': 'Om denne chat',
    'Keep the work moving.': 'Hold arbejdet i gang.',
    'Ask a follow-up with this result in view, or turn a useful approach into a company Skill.':
      'Stil et opfølgende spørgsmål med dette resultat synligt, eller omdan en nyttig fremgangsmåde til en virksomhedskompetence.',
    'Save approach as a Skill': 'Gem fremgangsmåde som kompetence',
    'Preview of': 'Forhåndsvisning af',
    'Made with': 'Oprettet med',
    'Open the draft': 'Åbn kladden',
    'Open Skill': 'Åbn kompetence',
    'Use in chat': 'Brug i chat',
    'Finish the draft': 'Færdiggør kladden',
    'Refine this Skill': 'Forfin denne kompetence',
    'Made with a Skill.': 'Oprettet med en kompetence.',
    'This workspace could not be loaded just now, so that Skill cannot be opened yet. The result itself is unchanged.':
      'Dette arbejdsområde kunne ikke indlæses lige nu, så kompetencen kan ikke åbnes endnu. Selve resultatet er uændret.',
    'That Skill is not available in this workspace, so it cannot be opened or used again. The result itself is unchanged.':
      'Den kompetence er ikke tilgængelig i dette arbejdsområde, så den kan ikke åbnes eller bruges igen. Selve resultatet er uændret.',
    'Result · {value1} {value2}': 'Resultat · {value1} {value2}',
    '{value1} Copy link': '{value1} Kopiér link',
    'Result link copied.': 'Resultatlink kopieret.',
    'Could not copy the link. Use your browser address bar.':
      'Kunne ikke kopiere linket. Brug browserens adresselinje.',
    'No preview is available for this result.':
      'Der er ingen forhåndsvisning tilgængelig for dette resultat.',
    '{value1} rows are retained in this snapshot. Open Table to inspect the values.':
      '{value1} rækker er bevaret i dette øjebliksbillede. Åbn Tabel for at se værdierne.',
    'People can’t edit a Result an agent keeps up to date; the next refresh would replace their edit. Change the agent’s instructions instead.':
      'Man kan ikke redigere et resultat, som en agent holder opdateret; den næste opdatering vil erstatte ændringen. Redigér i stedet agentens instruktioner.',
    'Linked sources': 'Tilknyttede kilder',
    'Saved source': 'Gemt kilde',
    'No source documents are linked to this result. Company knowledge and other references may be cited in the answer.':
      'Ingen kildedokumenter er knyttet til dette resultat. Virksomhedsviden og andre referencer kan blive citeret i svaret.',
    'Run details': 'Kørselsdetaljer',
    Created: 'Oprettet',
    ', revised {value1}': ', revideret {value1}',
    Conversation: 'Samtale',
    'Not recorded': 'Ikke registreret',
    'Open conversation': 'Åbn samtale',
    Run: 'Kørsel',
    Updates: 'Opdateringer',
    'Kept up to date by {value1}': 'Holdes opdateret af {value1}',
    'Version {value1}': 'Version {value1}',
    'Could not open this request.': 'Kunne ikke åbne denne anmodning.',
    'Approved version published.': 'Den godkendte version er publiceret.',
    'Request rejected. The item stays unchanged.':
      'Anmodningen blev afvist. Elementet forbliver uændret.',
    'Could not save the decision.': 'Kunne ikke gemme beslutningen.',
    'Proposed company change': 'Foreslået virksomhedsændring',
    'Opening…': 'Åbner…',
    'Approve this version': 'Godkend denne version',
    Decline: 'Afvis',
    'Review the submitted version below. Changes made since submission will need a new request.':
      'Gennemgå den indsendte version nedenfor. Ændringer, der er foretaget siden indsendelsen, kræver en ny anmodning.',
    'The version submitted with this request.':
      'Den version, der blev indsendt med denne anmodning.',
    'Version and proposed change': 'Version og foreslået ændring',
    'Could not read the pinned content.': 'Kunne ikke læse det fastgjorte indhold.',
    'Showing a page of {value1} characters.': 'Viser en side med {value1} tegn.',
    'Beginning of the submitted content. Open the full text to review every page.':
      'Begyndelsen af det indsendte indhold. Åbn hele teksten for at gennemgå alle sider.',
    'Read full submitted text': 'Læs hele den indsendte tekst',
    'Previous page': 'Forrige side',
    'Next page': 'Næste side',
    'Made private. Its creator has been told in their Inbox.':
      'Gjort privat. Opretteren har fået besked i sin indbakke.',
    'Made private. Its creator could not be notified.':
      'Gjort privat. Opretteren kunne ikke få besked.',
    'Make this {value1} private?': 'Gør {value1} privat?',
    'Only the person who created it will see it. Everyone else loses access right away, and its creator gets an Inbox update if they are still a company member. If they have left, nobody in the company will be able to access this item.':
      'Det er kun den person, der oprettede det, der kan se det. Alle andre mister adgangen med det samme, og opretteren får en opdatering i indbakken, hvis vedkommende stadig er medlem af virksomheden. Hvis vedkommende har forladt virksomheden, kan ingen i virksomheden få adgang til dette element.',
    'Sent for review. The current audience stays unchanged until approval.':
      'Sendt til gennemgang. Den nuværende målgruppe forbliver uændret, indtil det er godkendt.',
    'This suggestion is no longer available to you.':
      'Dette forslag er ikke længere tilgængeligt for dig.',
    'We could not check where this suggestion stands.':
      'Vi kunne ikke kontrollere status for dette forslag.',
    'Check again': 'Prøv igen',
    'Show on page': 'Vis på siden',
    'The editor could not be loaded. Poneva may have been updated since you opened this page. Reload to get the latest version; nothing on this page has changed.':
      'Editoren kunne ikke indlæses. Poneva kan være blevet opdateret, siden du åbnede denne side. Genindlæs for at få den nyeste version; intet på denne side er blevet ændret.',
    'Reload Poneva': 'Genindlæs Poneva',
    Formatting: 'Formatering',
    'Text style': 'Teksttypografi',
    Text: 'Tekst',
    Heading: 'Overskrift',
    Subheading: 'Underoverskrift',
    'Link a page': 'Link til en side',
    'A page needs a title.': 'En side skal have en titel.',
    'Nothing has changed yet.': 'Intet er ændret endnu.',
    'A page needs some text. To remove a page, archive it instead.':
      'En side skal indeholde tekst. Arkivér siden i stedet for at fjerne den.',
    'A suggested new page needs some text.': 'En foreslået ny side skal indeholde tekst.',
    'This page is larger than 256 KB. Split it into smaller pages.':
      'Denne side er større end 256 KB. Opdel den i mindre sider.',
    'Say in a few words why this change is right.':
      'Skriv med få ord, hvorfor denne ændring er rigtig.',
    'This page changed while you were editing. Your text is still here: copy it, then open the latest version and make your change again.':
      'Denne side blev ændret, mens du redigerede. Din tekst er stadig her: Kopiér den, åbn derefter den nyeste version, og foretag din ændring igen.',
    'Your text is copied.': 'Din tekst er kopieret.',
    'Your text could not be copied. Select it in the editor and copy it.':
      'Din tekst kunne ikke kopieres. Markér den i editoren, og kopiér den.',
    'The page “{value1}” is created.': 'Siden “{value1}” er oprettet.',
    'New page': 'Ny side',
    'Editing {value1}': 'Redigerer {value1}',
    Editing: 'Redigerer',
    'Creating publishes the page under {value1} for everyone':
      'Når du opretter siden, udgives den under {value1} for alle',
    'Saving publishes the new version for everyone':
      'Når du gemmer, udgives den nye version for alle',
    'Your changes are sent as a suggestion for a publisher':
      'Dine ændringer sendes som et forslag til en udgiver',
    'Create page': 'Opret side',
    Save: 'Gem',
    'Send suggestion': 'Send forslag',
    '{value1} Copy my text': '{value1} Kopiér min tekst',
    'Open the latest version': 'Åbn den nyeste version',
    'Page title': 'Sidetitel',
    'Loading the editor…': 'Indlæser editoren…',
    'New page text': 'Tekst til ny side',
    'Text of {value1}': 'Tekst for {value1}',
    'Write the page. Type [[ to link another page.':
      'Skriv siden. Skriv [[ for at linke til en anden side.',
    'Type [[ to link another page.': 'Skriv [[ for at linke til en anden side.',
    'Link to a page': 'Link til en side',
    'What changed, in a few words': 'Hvad blev ændret, med få ord',
    'Where this comes from, in a few words': 'Hvor dette kommer fra, med få ord',
    'Shown in the page history.': 'Vises i sidens historik.',
    'A publisher sees this next to your change.': 'En udgiver ser dette ved siden af din ændring.',
    '1 suggestion is open on this page': '1 forslag er åbent på denne side',
    '{value1} suggestions are open on this page': '{value1} forslag er åbne på denne side',
    'They stay open while you edit. After you save, they show against your new text; one whose words you changed is marked outdated.':
      'De forbliver åbne, mens du redigerer. Når du har gemt, vises de i forhold til din nye tekst; et forslag, hvis ord du har ændret, markeres som forældet.',
    'Type [[ to link another page. Links keep working when a page is renamed or moved.':
      'Skriv [[ for at linke til en anden side. Links fungerer stadig, når en side omdøbes eller flyttes.',
    'Loading the history…': 'Indlæser historikken…',
    'This page has no saved text yet.': 'Denne side har ingen gemt tekst endnu.',
    'Say in a few words why this revision should come back.':
      'Skriv med få ord, hvorfor denne revision skal gendannes.',
    'Revision {value1} is suggested for a publisher to accept.':
      'Revision {value1} foreslås til godkendelse af en udgiver.',
    'The page already reads like this revision.': 'Siden har allerede denne revisions indhold.',
    'Revision {value1} is restored as revision {value2}.':
      'Revision {value1} er gendannet som revision {value2}.',
    'Revision history': 'Revisionshistorik',
    Revisions: 'Revisioner',
    'Every saved revision is kept.': 'Alle gemte revisioner opbevares.',
    'Revision {value1} {value2}': 'Revision {value1} {value2}',
    'Revision {value1} compared with revision {value2}':
      'Revision {value1} sammenlignet med revision {value2}',
    'Revision {value1}, the first text of this page':
      'Revision {value1}, den første tekst på denne side',
    'Green was added, struck through was removed.':
      'Grøn tekst blev tilføjet, gennemstreget tekst blev fjernet.',
    '{value1} Export Markdown': '{value1} Eksportér Markdown',
    'Restore this revision': 'Gendan denne revision',
    'Suggest restoring it': 'Foreslå at gendanne den',
    'Why should this revision come back?': 'Hvorfor skal denne revision gendannes?',
    'Loading this revision…': 'Indlæser denne revision…',
    'Only the title changed, from “{value1}” to “{value2}”.':
      'Kun titlen blev ændret fra “{value1}” til “{value2}”.',
    'The text did not change in this revision.': 'Teksten blev ikke ændret i denne revision.',
    'Changes in revision {value1}': 'Ændringer i revision {value1}',
    'Loading page…': 'Indlæser siden…',
    'Loading suggestion…': 'Indlæser forslaget…',
    'This suggestion is not available.': 'Dette forslag er ikke tilgængeligt.',
    'It may have been decided, or it is not one you can see.':
      'Det kan være blevet afgjort, eller det er et forslag, du ikke kan se.',
    'Open Knowledge': 'Åbn Viden',
    'Opening the suggestion…': 'Åbner forslaget…',
    'Choose where the page goes.': 'Vælg, hvor siden skal placeres.',
    'Say in a few words why.': 'Skriv med få ord hvorfor.',
    'Your suggestion is sent. A publisher decides.':
      'Dit forslag er sendt. En udgiver træffer afgørelsen.',
    'Moved under {value1}.': 'Flyttet ind under {value1}.',
    'Deleted “{value1}”.': '“{value1}” er slettet.',
    'Could not update sharing.': 'Deling kunne ikke opdateres.',
    'They can follow new answers live and fork it to continue with their own connections. Only you write here. You can make it private again at any time.':
      'De kan følge nye svar live og forgrene det for at fortsætte med deres egne forbindelser. Det er kun dig, der kan skrive her. Du kan gøre det privat igen når som helst.',
    'They see the project, its brief and the work in it they can already open. Nothing in it opens for anyone because of the project; each item keeps its own access.':
      'De kan se projektet, dets brief og det arbejde i det, som de allerede kan åbne. Intet i det bliver åbnet for nogen på grund af projektet; hvert element bevarer sin egen adgang.',
    'Check the content for private information before sharing. Sharing an item does not grant access to its original chat or private connections.':
      'Tjek indholdet for private oplysninger, før du deler det. Deling af et element giver ikke adgang til dets oprindelige chat eller private forbindelser.',
    '{value1} Everyone you share with can read it, including what the assistant or an App in it found in your {value2}. They can’t use your {value3}. Nothing changes for you: the chat keeps working with all your accounts.':
      '{value1} Alle, du deler med, kan læse det, herunder det, som assistenten eller en app i det fandt i din {value2}. De kan ikke bruge din {value3}. Intet ændrer sig for dig: Chat fortsætter med at fungere med alle dine konti.',
    '{value1} Everyone you share with can read them, but nobody can use {value2} through this chat.':
      '{value1} Alle, du deler med, kan læse dem, men ingen kan bruge {value2} gennem denne chat.',
    'This controls access to the working draft. Any published company version stays available until you explicitly unpublish it. To publish a new version, complete its preview and use Save Skill. Run results stay private.':
      'Dette styrer adgangen til arbejdsudkastet. Alle offentliggjorte virksomhedsudgaver forbliver tilgængelige, indtil du specifikt fjerner offentliggørelsen. Hvis du vil offentliggøre en ny version, skal du færdiggøre dens forhåndsvisning og vælge Gem færdighed. Kørselsresultater forbliver private.',
    'Skill deleted. You can restore it from the Skills archive for 30 days.':
      'Færdigheden er slettet. Du kan gendanne den fra færdighedsarkivet i 30 dage.',
    'Could not delete this Skill.': 'Denne færdighed kunne ikke slettes.',
    'More actions': 'Flere handlinger',
    'Delete “{value1}”? It will disappear from Skills and search, and cannot be used by agents. You can restore it for 30 days. Existing chats and results stay available.':
      'Slet “{value1}”? Den forsvinder fra færdigheder og søgning og kan ikke bruges af agenter. Du kan gendanne den i 30 dage. Eksisterende chats og resultater forbliver tilgængelige.',
    'Deleting…': 'Sletter…',
    'Confirm delete': 'Bekræft sletning',
    'Delete Skill': 'Slet færdighed',
    'Skill restored as an unpublished draft. Its author can review and publish it again.':
      'Færdigheden er gendannet som et ikke-offentliggjort udkast. Forfatteren kan gennemgå og offentliggøre den igen.',
    'Could not restore this Skill.': 'Denne færdighed kunne ikke gendannes.',
    'Archived Skills': 'Arkiverede færdigheder',
    'Deleted Skills can be restored for 30 days. Restoring leaves them unpublished.':
      'Slettede færdigheder kan gendannes i 30 dage. Gendannelse efterlader dem ikke-offentliggjorte.',
    'Restore until {value1}': 'Gendan indtil {value1}',
    'Loading…': 'Indlæser…',
    'No archived Skills.': 'Ingen arkiverede færdigheder.',
    'Load more archived Skills': 'Indlæs flere arkiverede færdigheder',
    'Show more of the original': 'Vis mere af originalen',
    'Filter result rows': 'Filtrer resultatrækker',
    'Find a product or value…': 'Find et produkt eller en værdi…',
    '{value1} of {value2}': '{value1} af {value2}',
    'Result table': 'Resultattabel',
    'No matching rows.': 'Ingen matchende rækker.',
    'Showing the first 1,000 matching rows. Download the CSV for every row.':
      'Viser de første 1.000 matchende rækker. Download CSV-filen for at se alle rækker.',
    'Agent ·': 'Agent ·',
    'Only you': 'Kun dig',
    'Stopped before it finished.': 'Stoppet, før det blev færdigt.',
    'Drafting the project…': 'Udarbejder projektet…',
    'Checking where this chat belongs…': 'Tjekker, hvor denne chat hører til…',
    'Moving the chat…': 'Flytter chatten…',
    'Taking it out of the project…': 'Fjerner den fra projektet…',
    'Adding it to the project…': 'Føjer den til projektet…',
    'No matching connections are available right now.':
      'Ingen matchende forbindelser er tilgængelige lige nu.',
    'Company knowledge suggestion': 'Forslag til virksomhedsviden',
    'Company knowledge now lives on pages. Open Knowledge to see them.':
      'Virksomhedsviden findes nu på sider. Åbn Viden for at se dem.',
    '{value1} · Open beside this conversation': '{value1} · Åbn ved siden af denne samtale',
    'Name {value1}': 'Navn {value1}',
    'Host {value1}': 'Vært {value1}',
    'Port {value1}': 'Port {value1}',
    'Database {value1}': 'Database {value1}',
    'Username {value1}': 'Brugernavn {value1}',
    'Password {value1}': 'Adgangskode {value1}',
    'Advanced TLS': 'Avanceret TLS',
    '{value1} Poneva verifies the server certificate. Add a CA or server DNS name for IP hosts when your certificate requires it.':
      '{value1} Poneva verificerer servercertifikatet. Tilføj et CA-certifikat eller et server-DNS-navn for IP-værter, når dit certifikat kræver det.',
    'CA certificate {value1}': 'CA-certifikat {value1}',
    'Certificate server DNS name {value1}': 'Serverens DNS-navn til certifikatet {value1}',
    '{value1} Your password is encrypted in secure storage. Poneva verifies the connection before saving it.':
      '{value1} Din adgangskode er krypteret i sikker lagring. Poneva verificerer forbindelsen, før den gemmes.',
    'Testing…': 'Tester…',
    'Test connection': 'Test forbindelse',
    'PostgreSQL is connected.': 'PostgreSQL er tilsluttet.',
    'PostgreSQL was saved safely.': 'PostgreSQL blev gemt sikkert.',
    'Poneva can read and change rows in the selected tables. Apps also follow their approved data scope.':
      'Poneva kan læse og ændre rækker i de valgte tabeller. Apps følger også deres godkendte dataomfang.',
    'Poneva can read the selected tables. Apps also follow their approved data scope.':
      'Poneva kan læse de valgte tabeller. Apps følger også deres godkendte dataomfang.',
    'Reads are paused until permission is enabled.':
      'Læsning er sat på pause, indtil tilladelsen aktiveres.',
    'Retrying…': 'Prøver igen…',
    'Retry permission': 'Prøv tilladelse igen',
    'Try it in Chat': 'Prøv det i Chat',
    Done: 'Færdig',
    'Disconnect database': 'Afbryd databaseforbindelse',
    '{value1} TLS verified ·{value2} {value3}': '{value1} TLS verificeret ·{value2} {value3}',
    'Search schemas and tables': 'Søg i skemaer og tabeller',
    'Search tables': 'Søg i tabeller',
    '{value1} of {value2} tables selected': '{value1} af {value2} tabeller valgt',
    'Select matching tables': 'Vælg matchende tabeller',
    'Select all tables': 'Vælg alle tabeller',
    Clear: 'Ryd',
    'Select a whole schema or individual tables. New tables need a fresh selection.':
      'Vælg et helt skema eller enkelte tabeller. Nye tabeller kræver et nyt valg.',
    'No tables match this search.': 'Ingen tabeller matcher denne søgning.',
    'All tables in {value1}': 'Alle tabeller i {value1}',
    '{value1} / {value2} tables': '{value1} / {value2} tabeller',
    'Read & write available': 'Læsning og skrivning tilgængelig',
    'Read only': 'Kun læsning',
    Ctrl: 'Ctrl',
    'This suggested knowledge update could not be shown.':
      'Dette foreslåede videnopdatering kunne ikke vises.',
    'Suggested knowledge update': 'Foreslået videnopdatering',
    'Archived. Its history is kept.': 'Arkiveret. Historikken er bevaret.',
    'Choose the page it goes under. Links to it keep working.':
      'Vælg, hvilken side den skal ligge under. Links til den fortsætter med at virke.',
    'Its text, its history and any open suggestions are removed for good, and links to it from other pages stop working. This cannot be undone.':
      'Dens tekst, historik og eventuelle åbne forslag fjernes permanent, og links til den fra andre sider holder op med at virke. Dette kan ikke fortrydes.',
    'An archived page no longer informs answers. Its history is kept, and a publisher can restore it or delete it permanently.':
      'En arkiveret side indgår ikke længere i svar. Historikken er bevaret, og en udgiver kan gendanne siden eller slette den permanent.',
    Under: 'Under',
    Change: 'Skift',
    'Move under': 'Flyt under',
    'Search pages': 'Søg på sider',
    'Why?': 'Hvorfor?',
    'Delete permanently': 'Slet permanent',
    'Move page': 'Flyt side',
    'Archive page': 'Arkiver side',
    'Suggestion {value1}: show its card': 'Forslag {value1}: vis kortet',
    'Removed:': 'Fjernet:',
    'Added:': 'Tilføjet:',
    'New page “{value1}”{value2}': 'Ny side “{value1}”{value2}',
    'No pages match “{value1}”.': 'Ingen sider matcher “{value1}”.',
    'Where this page is': 'Hvor denne side er',
    'Describe your company': 'Beskriv din virksomhed',
    'Empty page': 'Tom side',
    'Describe {value1}': 'Beskriv {value1}',
    'This page has no text yet.': 'Denne side har ingen tekst endnu.',
    'Poneva reads this page before every answer. Start with who you are, what you sell and how you work; details go on the pages under it.':
      'Poneva læser denne side før hvert svar. Start med, hvem I er, hvad I sælger, og hvordan I arbejder; detaljer hører til på siderne under den.',
    'Write it, or ask Poneva in chat to draft it for you.':
      'Skriv det, eller bed Poneva om at skrive et udkast til dig i chatten.',
    'Suggest a first version, and a publisher decides whether it becomes the page.':
      'Foreslå en første version, så beslutter en udgiver, om den skal blive til siden.',
    'Start writing': 'Begynd at skrive',
    'Suggest a first version': 'Foreslå en første version',
    'Accepted. The page is archived.': 'Accepteret. Siden er arkiveret.',
    'Accepted. The page is now revision {value1}.': 'Accepteret. Siden er nu version {value1}.',
    'Accepted.': 'Accepteret.',
    'Suggestion rejected. The page stays as it is.':
      'Forslaget blev afvist. Siden forbliver, som den er.',
    'Your suggestion is withdrawn.': 'Dit forslag er trukket tilbage.',
    'Restored. The page informs answers again.': 'Gendannet. Siden indgår igen i svar.',
    'Your suggestion is sent. A publisher decides whether it becomes the page.':
      'Dit forslag er sendt. En udgiver beslutter, om det skal blive til siden.',
    'Saved. The page is now revision {value1}.': 'Gemt. Siden er nu version {value1}.',
    'Nothing changed.': 'Intet blev ændret.',
    'This page is not available.': 'Denne side er ikke tilgængelig.',
    'It may have been deleted, archived or moved out of reach, or you may no longer be in this company.':
      'Den kan være blevet slettet, arkiveret eller flyttet uden for din adgang, eller du er måske ikke længere i denne virksomhed.',
    'Page actions': 'Sidehandlinger',
    shown: 'vist',
    hidden: 'skjult',
    '{value1} History': '{value1} Historik',
    '{value1} Ask in chat': '{value1} Spørg i chatten',
    'Suggest edits': 'Foreslå ændringer',
    'More actions for {value1}': 'Flere handlinger for {value1}',
    '{value1} Poneva reads this page in every chat': '{value1} Poneva læser denne side i hver chat',
    'This page is archived. It no longer informs answers; its history is kept. {value1}':
      'Denne side er arkiveret. Den indgår ikke længere i svar, men historikken er bevaret. {value1}',
    'Restore page': 'Gendan side',
    'This link points to an earlier revision. You are reading the current text.':
      'Dette link peger på en tidligere version. Du læser den aktuelle tekst.',
    'Show it in History': 'Vis den i Historik',
    Pages: 'Sider',
    'Pages under {value1}': 'Sider under {value1}',
    'Linked from': 'Linket fra',
    Suggestions: 'Forslag',
    'Suggestions are hidden. You are reading the page as everyone else sees it.':
      'Forslag er skjult. Du læser siden, som alle andre ser den.',
    'Loading suggestions…': 'Indlæser forslag…',
    'Nothing is waiting for review.': 'Der er ikke noget, der venter på gennemgang.',
    'When someone, Poneva in a chat or a connected agent suggests a change to a page, it shows here and on the page. Nothing changes until a publisher accepts it.':
      'Når nogen, Poneva i en chat eller en forbundet agent foreslår en ændring af en side, vises den her og på siden. Intet ændres, før en udgiver accepterer den.',
    '{value1} Review knowledge in chat': '{value1} Gennemgå viden i chatten',
    'Suggestions for review': 'Forslag til gennemgang',
    'Suggested changes from chats, meetings, colleagues and connected agents. Nothing changes until a publisher accepts it on the page.':
      'Foreslåede ændringer fra chats, møder, kolleger og forbundne agenter. Intet ændres, før en udgiver accepterer dem på siden.',
    'Your suggestions wait here until a publisher decides. The pages stay as they are until then.':
      'Dine forslag venter her, indtil en udgiver beslutter sig. Siderne forbliver, som de er, indtil da.',
    'Review page': 'Gennemgå side',
    'Review on page': 'Gennemgå på siden',
    'Open the meeting': 'Åbn mødet',
    'Open the chat': 'Åbn chatten',
    'Accept and restore': 'Accepter og gendan',
    Accept: 'Accepter',
    Reject: 'Afvis',
    'Your suggestion · waiting for a publisher': 'Dit forslag · venter på en udgiver',
    Withdraw: 'Træk tilbage',
    'Waiting for a publisher': 'Venter på en udgiver',
    'Suggestion {value1}': 'Forslag {value1}',
    'Suggestion {value1} from {value2}{value3}': 'Forslag {value1} fra {value2}{value3}',
    'Read the suggested page': 'Læs den foreslåede side',
    'Outdated: the text it changes was edited after it was suggested. It can be rejected or withdrawn; a new suggestion can be made against the current text.':
      'Forældet: Den tekst, som forslaget ændrer, blev redigeret, efter at det blev foreslået. Det kan afvises eller trækkes tilbage; der kan oprettes et nyt forslag til den aktuelle tekst.',
    'Restore this page first to accept this suggestion.':
      'Gendan denne side først for at acceptere forslaget.',
    'Previous suggestion': 'Forrige forslag',
    'Suggestion {value1} of {value2}': 'Forslag {value1} af {value2}',
    'Next suggestion': 'Næste forslag',
    'Fold the suggestions away': 'Skjul forslagene',
    'Show the suggestions': 'Vis forslagene',
    '1 suggestion': '1 forslag',
    '{value1} suggestions': '{value1} forslag',
    '{value1} the pages under {value2}': '{value1} siderne under {value2}',
    px: 'px',
    '{value1} chart of {value2} across {value3}':
      '{value1}-diagram over {value2} på tværs af {value3}',
    'We could not build the file.': 'Vi kunne ikke oprette filen.',
    '{value1} Present': '{value1} til stede',
    'Building…': 'Opretter…',
    'Download PowerPoint': 'Hent PowerPoint',
    'Slide {value1} of {value2}': 'Dias {value1} af {value2}',
    Slides: 'Dias',
    'Slide {value1}': 'Dias {value1}',
    'Speaker notes': 'Talernoter',
    'Source: {value1}': 'Kilde: {value1}',
    'Add a name and a web address.': 'Tilføj et navn og en webadresse.',
    'Enter a valid web address.': 'Indtast en gyldig webadresse.',
    'Use a web address that starts with https://.':
      'Brug en webadresse, der begynder med https://.',
    'Add a custom connection': 'Tilføj en brugerdefineret forbindelse',
    'Connect a tool server you trust. Poneva checks the address works and saves only the connection details needed to use it.':
      'Opret forbindelse til en værktøjsserver, du har tillid til. Poneva kontrollerer, at adressen fungerer, og gemmer kun de forbindelsesoplysninger, der er nødvendige for at bruge den.',
    'Web address': 'Webadresse',
    'https://tools.example.com': 'https://tools.example.com',
    'Starts with https://, from your provider': 'Begynder med https://, fra din udbyder',
    'Sign-in': 'Log ind',
    'Advanced sign-in': 'Avanceret login',
    'Access key {value1}': 'Adgangsnøgle {value1}',
    'Request headers': 'Anmodningsheadere',
    'Add header': 'Tilføj header',
    'Header {value1} name': 'Navn på header {value1}',
    'Header name': 'Headernavn',
    'Header {value1} value': 'Værdi for header {value1}',
    'Header value': 'Headerværdi',
    'Remove header': 'Fjern header',
    Advanced: 'Avanceret',
    Transport: 'Transport',
    'Auto-detect': 'Registrer automatisk',
    'Streamable HTTP': 'Streamable HTTP',
    'Legacy SSE': 'Ældre SSE',
    "From your provider's app settings. Leave empty unless they gave you these.":
      'Fra din udbyders appindstillinger. Lad felterne være tomme, medmindre du har fået disse oplysninger.',
    "Authorization server issuer": "Autorisationsserverens udsteder",
    "Enter the authorization server issuer when using a client ID.": "Angiv autorisationsserverens udsteder, når du bruger et klient-id.",
    'Client ID {value1}': 'Klient-ID {value1}',
    'Client secret {value1}': 'Klienthemmelighed {value1}',
    'Connecting…': 'Opretter forbindelse…',
    'Test and connect': 'Test, og opret forbindelse',
    'Add the store, the client ID and the client secret.':
      "Tilføj butikken, klient-ID'et og klienthemmeligheden.",
    'Connect your Shopify Developer App': 'Opret forbindelse til din Shopify Developer App',
    'Poneva can use exactly the access your store gave the app, and nothing more. It talks to Shopify directly and keeps the client secret encrypted.':
      'Poneva kan kun bruge de adgangstilladelser, din butik har givet appen, og ikke mere. Den kommunikerer direkte med Shopify og opbevarer klienthemmeligheden krypteret.',
    'How to create the app in Shopify': 'Sådan opretter du appen i Shopify',
    'Open{value1} {value2}{value3} with the account that owns the store, and create an app.':
      'Åbn{value1} {value2}{value3} med den konto, der ejer butikken, og opret en app.',
    'Create a version and select the access scopes Poneva may use, for example read_products and read_orders. Add write_ scopes only for data Poneva may change. Then release the version.':
      'Opret en version, og vælg de adgangsområder, Poneva må bruge, f.eks. read_products og read_orders. Tilføj kun write_-områder for data, Poneva må ændre. Udgiv derefter versionen.',
    'For orders and customers, also select protected customer data in the app’s settings. Shopify allows this without review for an app made for your own store.':
      'For ordrer og kunder skal du også vælge beskyttede kundedata i appens indstillinger. Shopify tillader dette uden gennemgang for en app, der er oprettet til din egen butik.',
    'Install the app on your store.': 'Installer appen i din butik.',
    'Copy the client ID and client secret from the app’s settings.':
      "Kopiér klient-ID'et og klienthemmeligheden fra appens indstillinger.",
    'To change the access later, release a new version, approve it on the store and use Test connection here.':
      'Hvis du senere vil ændre adgangen, skal du udgive en ny version, godkende den i butikken og bruge Test forbindelse her.',
    Store: 'Butik',
    'your-store.myshopify.com': 'your-store.myshopify.com',
    'Your store’s .myshopify.com address (Shopify admin → Settings → Domains), or paste the address of your Shopify admin page':
      'Din butiks .myshopify.com-adresse (Shopify-administrator → Indstillinger → Domæner), eller indsæt adressen til din Shopify-administratorside',
    'Client ID {value1} {value2}': 'Klient-ID {value1} {value2}',
    'Client secret {value1} {value2}': 'Klienthemmelighed {value1} {value2}',
    Person: 'Person',
    Everyone: 'Alle',
    Connection: 'Forbindelse',
    'All connections': 'Alle forbindelser',
    'App {value1}': 'App {value1}',
    'From {value1}': 'Fra {value1}',
    'Until {value1}': 'Til {value1}',
    Result: 'Resultat',
    'All results': 'Alle resultater',
    Succeeded: 'Gennemført',
    Denied: 'Afvist',
    Failed: 'Mislykkedes',
    Unknown: 'Ukendt',
    Filter: 'Filtrer',
    'Loading activity…': 'Indlæser aktivitet…',
    'Could not load activity. Try again.': 'Aktiviteten kunne ikke indlæses. Prøv igen.',
    'Removed connection': 'Forbindelse fjernet',
    'App: {value1}': 'App: {value1}',
    'Older activity': 'Ældre aktivitet',
    Download: 'Hent',
    CSV: 'CSV',
    'Evidence for {value1}': 'Dokumentation for {value1}',
    Measure: 'Mål',
    'Show rows →': 'Vis rækker →',
    'Ask about this number': 'Spørg om dette tal',
    'There are no numeric values available to chart. View the table for the original data.':
      'Der er ingen numeriske værdier tilgængelige til diagrammet. Se tabellen for de oprindelige data.',
    'Chart value': 'Diagramværdi',
    '{value1} of {value2} shown': '{value1} af {value2} vist',
    '{value1} by {value2}; {value3} rows. View Table for exact values.':
      '{value1} gange {value2}; {value3} rækker. Se tabellen for de nøjagtige værdier.',
    'Values come directly from the source data. Missing values are not estimates.':
      'Værdierne kommer direkte fra kildedataene. Manglende værdier er ikke estimater.',
    'Loading library…': 'Indlæser bibliotek…',
    'We couldn’t load what happened in this App. Try again in a moment.':
      'Vi kunne ikke indlæse, hvad der skete i denne app. Prøv igen om et øjeblik.',
    'This App could not be opened.': 'Denne app kunne ikke åbnes.',
    'Opening App…': 'Åbner app…',
    'Open the saved App to run this function.': 'Åbn den gemte app for at køre denne funktion.',
    'Save this App before running its function.': 'Gem denne app, før du kører dens funktion.',
    'Open saved App': 'Åbn gemt app',
    'Open Apps': 'Åbn apps',
    'The App could not be opened. Try again.': 'Appen kunne ikke åbnes. Prøv igen.',
    Owner: 'Ejer',
    '{value1} · admins': '{value1} · administratorer',
    'Owner · always edits': 'Ejer · kan altid redigere',
    'Admins manage it': 'Administratorer administrerer den',
    Editors: 'Redaktører',
    'A colleague': 'En kollega',
    'Can edit drafts and publish versions': 'Kan redigere kladder og publicere versioner',
    Remove: 'Fjern',
    'No editors yet.': 'Ingen redaktører endnu.',
    'Admins can always edit company agents.':
      'Administratorer kan altid redigere virksomhedens agenter.',
    'Asking for edit access': 'Anmoder om redigeringsadgang',
    'Asked {value1} · also in your Inbox': 'Anmodet {value1} · også i din indbakke',
    Grant: 'Giv adgang',
    Admin: 'Administrator',
    'Make personal': 'Gør personlig',
    'Switch off': 'Deaktivér',
    Archive: 'Arkivér',
    'Archive this agent': 'Arkivér denne agent',
    'Loading agent…': 'Indlæser agent…',
    '{value1} Edit in chat': '{value1} Rediger i chat',
    Agent: 'Agent',
    'This agent has not been created yet. It can run once its owner creates it.':
      'Denne agent er ikke oprettet endnu. Den kan køre, når ejeren har oprettet den.',
    'New agent · Draft': 'Ny agent · Kladde',
    'Untitled agent': 'Agent uden navn',
    'Test run': 'Testkørsel',
    'This draft does not run automatically.': 'Denne kladde kører ikke automatisk.',
    'Describe the agent in the chat. Its draft appears here.':
      'Beskriv agenten i chatten. Dens kladde vises her.',
    '{value1} Test run': '{value1} Testkørsel',
    'Describe the agent in the chat first.': 'Beskriv først agenten i chatten.',
    'Create and turn on': 'Opret og aktivér',
    'Connection write setup': 'Opsætning af skriveadgang til forbindelse',
    'Account for connected changes': 'Konto til ændringer i forbindelse',
    'Choose a connection': 'Vælg en forbindelse',
    'No published Skills available. You can add them later.':
      'Ingen publicerede kompetencer tilgængelige. Du kan tilføje dem senere.',
    '{value1} · not published. Review the changes. Testing is optional.':
      '{value1} · ikke publiceret. Gennemgå ændringerne. Test er valgfri.',
    '{value1} Test draft': '{value1} Testkladde',
    'Apply changes…': 'Anvend ændringer…',
    'Apply this draft as a new version': 'Anvend denne kladde som en ny version',
    'This draft cannot be applied.': 'Denne kladde kan ikke anvendes.',
    'What changed?': 'Hvad blev ændret?',
    'Apply version {value1}': 'Anvend version {value1}',
    Create: 'Opret',
    'Edit access requested': 'Der er anmodet om redigeringsadgang',
    '{value1} Request edit access': '{value1} Anmod om redigeringsadgang',
    '{value1} Copy agent': '{value1} Kopiér agent',
    Pause: 'Sæt på pause',
    'Open agent: {value1}': 'Åbn agent: {value1}',
    '· you can edit': '· du kan redigere',
    '{value1} is switched off.': '{value1} er deaktiveret.',
    '{value1} is archived.': '{value1} er arkiveret.',
    'Loading agents…': 'Indlæser agenter…',
    Agents: 'Agenter',
    'Agents do work for you on a schedule or when you ask. They follow your company’s Skills.':
      'Agenter udfører arbejde for dig efter en tidsplan eller på din anmodning. De følger din virksomheds kompetencer.',
    'No agent matches. Try a Skill name or what the agent should do.':
      'Ingen agenter matcher. Prøv et kompetencenavn eller beskriv, hvad agenten skal gøre.',
    'Nothing of your own yet': 'Intet af dit eget endnu',
    'Tell Chat what an agent should do, or copy one of the company’s agents below.{value1}':
      'Fortæl Chat, hvad en agent skal gøre, eller kopiér en af virksomhedens agenter nedenfor.{value1}',
    'Your agents': 'Dine agenter',
    'Run on demand': 'Kør efter behov',
    'Run is always available. A schedule is optional and lives separately from the agent’s instructions.':
      'Kørsel er altid tilgængelig. En tidsplan er valgfri og findes separat fra agentens instruktioner.',
    'Enable this schedule when approved': 'Aktivér denne tidsplan, når den er godkendt',
    Schedule: 'Tidsplan',
    'Kept off until you create the agent from its canvas.':
      'Forbliver deaktiveret, indtil du opretter agenten fra dens canvas.',
    'Will be enabled when you approve.': 'Aktiveres, når du godkender.',
    'Will be saved paused. You can enable it later.':
      'Gemmes sat på pause. Du kan aktivere den senere.',
    'Only runs when you ask.': 'Kører kun, når du beder den om det.',
    'Draft · approving saves it, and nothing runs. Test it and create it from its canvas.':
      'Kladde · godkendelse gemmer den, og intet kører. Test den, og opret den fra dens canvas.',
    'Draft · nothing is scheduled until you approve. Connected actions require their own approval at run time.':
      'Kladde · intet planlægges, før du godkender. Forbundne handlinger kræver deres egen godkendelse ved kørsel.',
    Name: 'Navn',
    'Agent name': 'Agentnavn',
    'Who can use it': 'Hvem kan bruge den',
    'Company agent · company resources only': 'Virksomhedsagent · kun virksomhedsressourcer',
    'Personal agent · runs with your access': 'Personlig agent · kører med din adgang',
    'Approving saves it as a draft. It does not run automatically.':
      'Godkendelse gemmer den som en kladde. Den kører ikke automatisk.',
    'Open the agent’s runs': 'Åbn agentens kørsler',
    'Run the published version once': 'Kør den publicerede version én gang',
    'Stopping…': 'Stopper…',
    'Stop run': 'Stop kørsel',
    'Could not stop this run. Please try again.': 'Denne kørsel kunne ikke stoppes. Prøv igen.',
    'Run in progress': 'Kørsel i gang',
    'This run is still answering. You can ask follow-ups when it finishes.':
      'Denne kørsel svarer stadig. Du kan stille opfølgende spørgsmål, når den er færdig.',
    'Open run details': 'Åbn kørselsdetaljer',
    Runs: 'Kørsler',
    'Open the run chat': 'Åbn kørselschaten',
    Watch: 'Se',
    Goal: 'Mål',
    'Change the goal': 'Rediger målet',
    'What it does': 'Hvad den gør',
    'What should this agent achieve?': 'Hvad skal denne agent opnå?',
    'Not set yet.': 'Ikke angivet endnu.',
    'When it runs': 'Hvornår den kører',
    'Change when it runs': 'Rediger, hvornår den kører',
    'Off means it runs only when someone runs it. Changing when it runs never changes its instructions.':
      'Deaktiveret betyder, at den kun kører, når nogen kører den. Ændring af, hvornår den kører, ændrer aldrig dens instruktioner.',
    Instructions: 'Instruktioner',
    'Change the instructions': 'Rediger instruktionerne',
    'How the agent should approach the work and make decisions.':
      'Hvordan agenten skal gribe arbejdet an og træffe beslutninger.',
    Boundaries: 'Grænser',
    'What to do or avoid. Every connected action still follows its approval.':
      'Hvad den skal gøre eller undgå. Hver forbundet handling følger stadig sin godkendelse.',
    'No instructions of its own. It follows its Skills.':
      'Ingen egne instruktioner. Den følger sine færdigheder.',
    'Pin a Skill': 'Fastgør en færdighed',
    'Finds the Skills that fit each run, the same way a chat does.':
      'Finder de færdigheder, der passer til hver kørsel, på samme måde som en chat.',
    'Skills it always follows': 'Færdigheder, den altid følger',
    'A Skill that is not published': 'En færdighed, der ikke er publiceret',
    'Always follows · Version {value1}': 'Følger altid · Version {value1}',
    'Not published': 'Ikke publiceret',
    Uses: 'Bruger',
    'Change in chat': 'Rediger i chat',
    'Change in chat: Uses': 'Rediger i chat: Bruger',
    'Company knowledge and the tools each run is allowed to use.':
      'Virksomhedsviden og de værktøjer, hver kørsel må bruge.',
    'People see the Result refresh; they change the agent, not the page.':
      'Brugerne kan se, at resultatet opdateres; de ændrer agenten, ikke siden.',
    'The first run after it is created makes the Result; later runs add a version to it.':
      'Den første kørsel efter oprettelsen genererer resultatet; senere kørsler tilføjer en version til det.',
    'Emails whoever the run is for': 'Sender en e-mail til den, kørslen er for',
    'Email each run': 'Send en e-mail ved hver kørsel',
    Delivers: 'Leverer',
    'Change what it delivers': 'Rediger, hvad den leverer',
    'Expected result': 'Forventet resultat',
    'What a successful run should deliver.': 'Hvad en vellykket kørsel skal levere.',
    'What each run delivers': 'Hvad hver kørsel leverer',
    'Keeps one Result up to date {value1}': 'Holder ét resultat opdateret {value1}',
    'Saves a new Result each run': 'Gemmer et nyt resultat ved hver kørsel',
    'You can run this company agent as yourself.{value1} {value2}':
      'Du kan køre denne virksomhedsagent som dig selv.{value1} {value2}',
    'Changes since version': 'Ændringer siden version',
    'are not live yet.': 'er ikke aktive endnu.',
    'Review them in Versions': 'Gennemgå dem i versioner',
    Skill: 'Færdighed',
    'The agent always uses the Skill’s published version.':
      'Agenten bruger altid færdighedens publicerede version.',
    Day: 'Dag',
    Time: 'Tid',
    'Cron expression': 'Cron-udtryk',
    'Editors and access': 'Redaktører og adgang',
    Company: 'Virksomhed',
    Personal: 'Personlig',
    'No changes.': 'Ingen ændringer.',
    'Instructions changes': 'Ændringer i instruktioner',
    'Loading versions…': 'Indlæser versioner…',
    'What the draft changes': 'Hvad kladden ændrer',
    'No published version yet. Try the draft, then publish it.':
      'Ingen publiceret version endnu. Prøv kladden, og publicér den derefter.',
    'Published versions': 'Publicerede versioner',
    'Former member': 'Tidligere medlem',
    Live: 'Aktiv',
    'What changed in version {value1}': 'Hvad er ændret i version {value1}',
    'Every publish is a version you can restore.': 'Hver udgivelse er en version, du kan gendanne.',
    Authorization: 'Godkendelse',
    '{value1} {value2} · {value3} will see it.': '{value1} {value2} · {value3} kan se det.',
    '{value1} {value2} you': '{value1} {value2} dig',
    '· Revised': '· Revideret',
    'This chat used your {value1}.': 'Denne chat brugte din {value1}.',
    'This chat has results from {value1}.': 'Denne chat har resultater fra {value1}.',
    'db.example.com': 'db.example.com',
    'e.g. Product analytics': 'f.eks. Produktanalyse',
    'Paste access key': 'Indsæt adgangsnøgle',
    'Shopify’s Dev Dashboard': 'Shopifys udviklerdashboard',
    'App reference': 'Appreference',
    'Draft · revision {value1}': 'Kladde · revision {value1}',
    'its Result': 'dens resultat',
    '· its first run makes it': '· dens første kørsel gør den',
    '{value1}’s chat ·': '{value1}s chat ·',
    '{value1} ad {value2} available.': '{value1} og {value2} er tilgængelige.',
    '{value1} rows ·': '{value1} rækker ·',
    'It starts private. Sharing it wider shares every refresh, which can carry your private data.':
      'Den er privat fra start. Hvis du deler den med flere, deles alle opdateringer også, hvilket kan medføre, at dine private data deles.',
    'Close row detail': 'Luk rækkedetalje',
    'Ask about this row': 'Spørg om denne række',
    'Add note': 'Tilføj note',
    Note: 'Bemærkning',
    Saved: 'Gemt',
    Total: 'I alt',
    ascending: 'stigende',
    descending: 'faldende',
    'Scroll to see all columns': 'Rul for at se alle kolonner',
    '{value1} for {value2}': '{value1} for {value2}',
    Suggested: 'Foreslået',
    'Opening your conversation…': 'Åbner din samtale…',
    'This conversation isn’t available': 'Denne samtale er ikke tilgængelig',
    'It may have been deleted, belong to another account, or be temporarily unavailable.':
      'Den kan være blevet slettet, tilhøre en anden konto eller være midlertidigt utilgængelig.',
    '{count} more line — shown in the complete revision':
      '{count} linje mere — vises i den komplette revision',
    '{count} more lines — shown in the complete revision':
      '{count} linjer mere — vises i den komplette revision',
    '{count} more line removed': '{count} linje mere fjernet',
    '{count} more lines removed': '{count} linjer mere fjernet',
    '{count} unchanged line': '{count} uændret linje',
    '{count} unchanged lines': '{count} uændrede linjer',
    '{count} more lines not shown, {added} added and {removed} removed. Check them in the complete revision.':
      '{count} linjer mere vises ikke, {added} tilføjet og {removed} fjernet. Se dem i den komplette revision.',
    'Saved result': 'Gemt resultat',
    'Made with a Skill': 'Lavet med en færdighed',
    'Preview of {name}': 'Forhåndsvisning af {name}',
    'Made with {name}': 'Lavet med {name}',
    'Ad-hoc result': 'Ad hoc-resultat',
    'A Skill that is not available in this workspace':
      'En færdighed, der ikke er tilgængelig i dette arbejdsområde',
    '{name} · Revision {version}': '{name} · Revision {version}',
    '{name} · Version {version}': '{name} · Version {version}',
    'Return to conversation {value1}': 'Vend tilbage til samtalen {value1}',
    '{value1} Working with {value2}': '{value1} arbejder med {value2}',
    'View context {value1}': 'Se kontekst {value1}',
    'A way of working, made yours.': 'En arbejdsmetode, gjort til din egen.',
    'Work that runs itself.': 'Arbejde, der kører af sig selv.',
    'One place for one piece of work.': 'Ét sted til ét stykke arbejde.',
    'Let’s move your work forward{value1}.': 'Lad os føre dit arbejde videre{value1}.',
    'Describe the work. Your Skill takes shape beside the conversation.':
      'Beskriv arbejdet. Din færdighed tager form ved siden af samtalen.',
    'Describe what it should do and when. Your agent takes shape beside the conversation. The draft does not run automatically.':
      'Beskriv, hvad den skal gøre og hvornår. Din agent tager form ved siden af samtalen. Udkastet kører ikke automatisk.',
    'Say what the work is. Poneva drafts the project beside the conversation and brings in what you have already done. Nothing is created until you say so.':
      'Fortæl, hvad arbejdet går ud på. Poneva udarbejder projektet ved siden af samtalen og medtager det, du allerede har gjort. Intet oprettes, før du siger til.',
    'Start with an idea below. Poneva will take it from there.':
      'Start med en idé nedenfor. Poneva tager over derfra.',
    Triggers: 'Udløsere',
    'Review the agent and its trigger. Approval applies exactly what is shown.':
      'Gennemgå agenten og dens udløser. Godkendelsen anvender præcis det, der vises.',
    '{source} · read {date}': '{source} · læst {date}',
    'Evidence is being recorded · read {date}': 'Dokumentation registreres · læst {date}',
    'Evidence expired on {date} under the retention policy':
      'Dokumentationen udløb {date} i henhold til opbevaringspolitikken',
    'Entered by {person}': 'Indtastet af {person}',
    'No retained evidence for this value': 'Ingen gemt dokumentation for denne værdi',
    'Covers {shown} of {total} rows': 'Dækker {shown} af {total} rækker',
    'Search rows': 'Søg i rækker',
    'Clear filters': 'Ryd filtre',
    Sort: 'Sortér',
    'Sort: {column}': 'Sortér: {column}',
    '{shown} of {total} rows': '{shown} af {total} rækker',
    More: 'Mere',
    Density: 'Tæthed',
    Comfortable: 'Komfortabel',
    Compact: 'Kompakt',
    Columns: 'Kolonner',
    'No rows match. Clear the search or filters to see them again.':
      'Ingen rækker matcher. Ryd søgningen eller filtrene for at se dem igen.',
    'Not available': 'Ikke tilgængelig',
    'All rows': 'Alle rækker',
    App: 'App',
    Artifact: 'Artefakt',
    'New project': 'Nyt projekt',
    'Review request': 'Anmodning om gennemgang',
    Activity: 'Aktivitet',
    'Voice preview': 'Stemmeeksempel',
    Source: 'Kilde',
    File: 'Fil',
    Meeting: 'Møde',
    'Knowledge page': 'Vidensside',
    'Could not preview this CSV.': 'Denne CSV-fil kunne ikke forhåndsvises.',
    'File content is unavailable.': 'Filindholdet er ikke tilgængeligt.',
    'You have five open suggestions here. {value1} will see them.':
      'Du har fem åbne forslag her. {value1} kan se dem.',
    'We could not send your suggestion. Please try again.':
      'Vi kunne ikke sende dit forslag. Prøv igen.',
    'The agent': 'Agenten',
    'Selected colleagues': 'Valgte kolleger',
    'The owner': 'Ejeren',
    'Forked. This copy is yours and runs with your own connections.':
      'Oprettet som en forgrening. Denne kopi er din og kører med dine egne forbindelser.',
    'This chat is too long to fork.': 'Denne chat er for lang til at oprette en forgrening af.',
    'We could not fork this chat. Please try again.':
      'Vi kunne ikke oprette en forgrening af denne chat. Prøv igen.',
    'Anyone who forked it keeps their copy: forks stay with the people who made them.':
      'Alle, der oprettede en forgrening, beholder deres kopi: Forgreninger bliver hos de personer, der oprettede dem.',
    'Nobody has forked this chat.': 'Ingen har oprettet en forgrening af denne chat.',
    '1 person forked this chat. Their copy stays theirs.':
      '1 person oprettede en forgrening af denne chat. Kopien forbliver deres.',
    '{value1} people forked this chat. Their copies stay theirs.':
      '{value1} personer oprettede forgreninger af denne chat. Kopierne forbliver deres.',
    'Personal. Nobody else sees it.': 'Personlig. Ingen andre kan se den.',
    'People you pick. They get it in their Inbox.':
      'De personer, du vælger. De får den i deres indbakke.',
    'Everyone in the company can follow it and fork it.':
      'Alle i virksomheden kan følge den og oprette en forgrening af den.',
    'a chat you can no longer open': 'en chat, du ikke længere kan åbne',
    'shared the Result': 'delte resultatet',
    'updated the Result': 'opdaterede resultatet',
    'published the Skill': 'udgav færdigheden',
    'approved the fact': 'godkendte faktummet',
    'added the fact': 'tilføjede faktummet',
    'added the meeting': 'tilføjede mødet',
    'published the page': 'udgav siden',
    'updated the page': 'opdaterede siden',
    'shared the chat': 'delte chatten',
    'published a version of': 'udgav en version af',
    ran: 'kørte',
    Knowledge: 'Viden',
    Meetings: 'Møder',
    Chat: 'Chat',
    Use: 'Brug',
    Open: 'Åbn',
    You: 'Dig',
    Someone: 'Nogen',
    'published version {version} of': 'udgav version {version} af',
    'thing needs': 'element kræver',
    'things need': 'elementer kræver',
    'Published Skill': 'Udgivet færdighed',
    'Included with Skill': 'Inkluderet i færdigheden',
    'Already attached': 'Allerede vedhæftet',
    'Also available in company knowledge': 'Også tilgængelig i virksomhedens viden',
    'Access changed': 'Adgang ændret',
    'Access turned off': 'Adgang slået fra',
    'Connection removed': 'Forbindelse fjernet',
    'Query time limit changed': 'Forespørgslens tidsgrænse ændret',
    '{count} row': '{count} række',
    '{count} rows': '{count} rækker',
    'This source is no longer available. Company knowledge now lives in Knowledge pages, and files stay in the Library.':
      'Denne kilde er ikke længere tilgængelig. Virksomhedens viden findes nu på videnssider, og filer bliver i biblioteket.',
    'Company file': 'Virksomhedsfil',
    'Account identity unavailable': 'Kontoidentitet ikke tilgængelig',
    'Access expired or was revoked. Reconnect to continue.':
      'Adgangen er udløbet eller blev tilbagekaldt. Opret forbindelse igen for at fortsætte.',
    'Account authorized · tools unavailable': 'Konto godkendt · værktøjer utilgængelige',
    'Not available in this workspace yet.': 'Ikke tilgængelig i dette arbejdsområde endnu.',
    'Everyone in the company': 'Alle i virksomheden',
    'Audience: only you.': 'Målgruppe: kun dig.',
    'Audience: everyone in the company.': 'Målgruppe: alle i virksomheden.',
    'tool is': 'værktøj er',
    'tools are': 'værktøjer er',
    'account is': 'konto er',
    'accounts are': 'konti er',
    'We could not upload this file.': 'Vi kunne ikke uploade denne fil.',
    'file was': 'fil blev',
    'files were': 'filer blev',
    'Your company': 'Din virksomhed',
    'Create an agent': 'Opret en agent',
    'Give recurring work a helping hand': 'Få hjælp til tilbagevendende arbejde',
    'Create a Skill': 'Opret en færdighed',
    'Save a reusable way of working': 'Gem en genanvendelig arbejdsmetode',
    'Take meeting notes': 'Tag mødenoter',
    'Capture decisions and next steps': 'Notér beslutninger og næste skridt',
    'Work with a file': 'Arbejd med en fil',
    'Start from a document or image': 'Start med et dokument eller et billede',
    'Browse agents': 'Gennemse agenter',
    'Open your agents and company agents': 'Åbn dine agenter og virksomhedens agenter',
    'Review results': 'Gennemgå resultater',
    'Return to work saved in your Library': 'Gå tilbage til arbejde, der er gemt i dit Bibliotek',
    'For review': 'Til gennemsyn',
    'An agent': 'En agent',
    Assistant: 'Assistent',
    'Kept up to date by {value1}{value2}': 'Holdes opdateret af {value1}{value2}',
    ', {value1}': ', {value1}',
    'Version {value1}{value2}{value3}': 'Version {value1}{value2}{value3}',
    'Refreshed by its agent': 'Opdateret af sin agent',
    'Saved from a chat': 'Gemt fra en chat',
    'Saved from {value1}': 'Gemt fra {value1}',
    Edited: 'Redigeret',
    'private account': 'privat konto',
    '{value1} ({value2})': '{value1} ({value2})',
    '{value1}’s {value2}': '{value2} tilhørende {value1}',
    'Made private. The person who added it and the owner of its recording have been told in their Inbox.':
      'Gjort privat. Den person, der tilføjede det, og ejeren af dets optagelse er blevet underrettet i deres indbakke.',
    'Made private. The person who added it has been told in their Inbox.':
      'Gjort privat. Den person, der tilføjede det, er blevet underrettet i deres indbakke.',
    'Made private. The owner of its recording has been told in their Inbox.':
      'Gjort privat. Ejeren af dets optagelse er blevet underrettet i deres indbakke.',
    'Selected passage': 'Valgt passage',
    '{value1} {value2}': '{value1} {value2}',
    'Upload a file': 'Upload en fil',
    'Help me create a useful report from our company knowledge and available sources.':
      'Hjælp mig med at oprette en nyttig rapport ud fra virksomhedens viden og tilgængelige kilder.',
    'This saved work couldn’t be opened. Open it again to retry.':
      'Dette gemte arbejde kunne ikke åbnes. Åbn det igen for at prøve igen.',
    '{value1}’s': '{value1}s',
    '{value1} chat “{value2}”': '{value1}s chat “{value2}”',
    '{value1}{value2}': '{value1}{value2}',
    'Skill: {value1}{value2}': 'Færdighed: {value1}{value2}',
    'Result “{value1}”': 'Resultat “{value1}”',
    'Meeting “{value1}”': 'Møde “{value1}”',
    'Used in {value1} {value2} this week': 'Brugt i {value1} {value2} denne uge',
    '{value1} {value2} · used in {value3} {value4}':
      '{value1} {value2} · brugt i {value3} {value4}',
    'The draft is not published yet, so no one else follows it.':
      'Udkastet er ikke udgivet endnu, så ingen andre følger det.',
    'Use it in a chat for current data, or refine the Skill first.':
      'Brug den i en chat for at få aktuelle data, eller finpuds færdigheden først.',
    'An agent keeps this up to date. Continue the work in chat.':
      'En agent holder dette opdateret. Fortsæt arbejdet i chatten.',
    'Edit it here, or continue the work in chat.':
      'Rediger det her, eller fortsæt arbejdet i chatten.',
    'Duplicate it to your Library, or continue the work in chat.':
      'Duplikér det til dit Bibliotek, eller fortsæt arbejdet i chatten.',
    'Download Markdown': 'Hent Markdown',
    'Download CSV': 'Hent CSV',
    'an agent': 'en agent',
    'Publish a Skill version': 'Udgiv en færdighedsversion',
    'Share with {value1}': 'Del med {value1}',
    'Update company content': 'Opdater virksomhedsindhold',
    Approved: 'Godkendt',
    Declined: 'Afvist',
    Pending: 'Afventer',
    'View decision': 'Se beslutning',
    'No data': 'Ingen data',
    'No change': 'Ingen ændring',
    'Connection created': 'Forbindelse oprettet',
    'Sharing changed': 'Deling ændret',
    'Person added': 'Person tilføjet',
    'Person removed': 'Person fjernet',
    '· {value1} by {value2}': '· {value1} af {value2}',
    '· version {value1}': '· version {value1}',
    '{message} {count} earlier file was saved and attached.':
      '{message} {count} tidligere fil blev gemt og vedhæftet.',
    '{message} {count} earlier files were saved and attached.':
      '{message} {count} tidligere filer blev gemt og vedhæftet.',
    '{message} {count} earlier file was saved.': '{message} {count} tidligere fil blev gemt.',
    '{message} {count} earlier files were saved.': '{message} {count} tidligere filer blev gemt.',
    'refreshed {time}': 'opdateret {time}',
    'a colleague': 'en kollega',
    'Your chat “{title}”': 'Din chat “{title}”',
    '{name}’s chat “{title}”': '{name}s chat “{title}”',
    'Kept up to date by {name}{version}': 'Holdes opdateret af {name}{version}',
    'Skill: {name}{version}': 'Færdighed: {name}{version}',
    'Result “{title}”': 'Resultat “{title}”',
    'Meeting “{title}”': 'Møde “{title}”',
    'Used in {count} answer this week': 'Brugt i {count} svar denne uge',
    'Used in {count} answers this week': 'Brugt i {count} svar denne uge',
    '{count} source': '{count} kilde',
    '{count} sources': '{count} kilder',
    'used in {count} place': 'brugt {count} sted',
    'used in {count} places': 'brugt {count} steder',
    '{company} workspace': '{company} arbejdsområde',
    '{count} page': '{count} side',
    '{count} pages': '{count} sider',
    '{needs} · reviews and approvals': '{needs} · gennemgange og godkendelser',
    '{count} thing needs you': '{count} ting kræver din handling',
    '{count} things need you': '{count} ting kræver din handling',
    'Included with Skill · {files} · {sources} {icon}':
      'Inkluderet i færdigheden · {files} · {sources} {icon}',
    '{count} file': '{count} fil',
    '{count} files': '{count} filer',
    Today: 'I dag',
    'Earlier this week': 'Tidligere på ugen',
    '{count} slide': '{count} dias',
    '{count} slides': '{count} dias',
    Early: 'Tidligt',
    'TLS verified': 'TLS verificeret',
    'Made personal and switched off. Switch it on when you are ready.':
      'Gjort personlig og deaktiveret. Slå den til, når du er klar.',
    'Made personal and switched off. Its owner is told which version is live.':
      'Gjort personlig og deaktiveret. Ejeren får at vide, hvilken version der er aktiv.',
    'Switched off.': 'Deaktiveret.',
    'Applied version {revision}.': 'Version {revision} anvendt.',
    'The draft is running in a chat only you can read.':
      'Kladdeversionen kører i en chat, som kun du kan læse.',
    'Publish a version first.': 'Udgiv en version først.',
    'Another Agent action is in progress.': 'En anden Agent-handling er i gang.',
    'Knowledge & connections': 'Viden og forbindelser',
    'Pinned Skills': 'Fastgjorte færdigheder',
    None: 'Ingen',
    'A new Result each run': 'Et nyt resultat ved hver kørsel',
    'One Result kept up to date': 'Ét resultat holdes opdateret',
    Email: 'E-mail',
    On: 'Til',
    Off: 'Fra',
    'Waiting for review': 'Afventer gennemgang',
    Outdated: 'Forældet',
    Accepted: 'Accepteret',
    Rejected: 'Afvist',
    Withdrawn: 'Trukket tilbage',
    Replaced: 'Erstattet',
    'Suggested edit': 'Foreslået redigering',
    'Suggested new page': 'Foreslået ny side',
    'Suggested move': 'Foreslået flytning',
    'Suggested archive': 'Foreslået arkivering',
    'Checking status…': 'Tjekker status…',
    'Status unavailable': 'Status ikke tilgængelig',
    'Bulleted list': 'Punktopstilling',
    'Numbered list': 'Nummereret liste',
    'Web link': 'Weblink',
    Read: 'Læs',
    Write: 'Skriv',
    'shared with you': 'delt med dig',
    'Getting an answer': 'Henter et svar',
    '{name} is getting an answer': '{name} er ved at finde et svar',
    'We could not save. Please try again.': 'Vi kunne ikke gemme. Prøv igen.',
    'The new page could not be created.': 'Den nye side kunne ikke oprettes.',
    'We could not load this revision.': 'Vi kunne ikke indlæse denne revision.',
    'We could not restore this revision. Please try again.':
      'Vi kunne ikke gendanne denne revision. Prøv igen.',
    'We could not export this revision.': 'Vi kunne ikke eksportere denne revision.',
    'We could not open this suggestion.': 'Vi kunne ikke åbne dette forslag.',
    'We could not do that. Please try again.': 'Det kunne vi ikke gøre. Prøv igen.',
    'We could not save your decision. Please try again.':
      'Vi kunne ikke gemme din beslutning. Prøv igen.',
    'We could not restore this page. Please try again.':
      'Vi kunne ikke gendanne denne side. Prøv igen.',
    'We could not export this page.': 'Vi kunne ikke eksportere denne side.',
    '{count} missed time merged.': '{count} overset tidspunkt flettet.',
    '{count} missed times merged.': '{count} oversete tidspunkter flettet.',
    'About this project': 'Om dette projekt',
  },
  nl: {
    context: 'Context',
    skills: 'vaardigheden',
    'Choose company context': 'Kies bedrijfscontext',
    'Skills for this conversation': 'Vaardigheden voor dit gesprek',
    'Bring context into the conversation': 'Voeg context toe aan het gesprek',
    'Close context picker': 'Contextkiezer sluiten',
    'Filter company context': 'Bedrijfscontext filteren',
    'Find a Skill…': 'Een vaardigheid zoeken…',
    'Find a file…': 'Een bestand zoeken…',
    'Available company context': 'Beschikbare bedrijfscontext',
    'No matching published Skills.': 'Geen overeenkomende gepubliceerde vaardigheden.',
    'No matching files.': 'Geen overeenkomende bestanden.',
    'Searching company work…': 'Bedrijfswerk doorzoeken…',
    'Try search again': 'Opnieuw zoeken',
    'Meaning search is temporarily limited. Showing available text matches.':
      'Zoeken op betekenis is tijdelijk beperkt. Beschikbare tekstovereenkomsten worden weergegeven.',
    'Load more matches': 'Meer overeenkomsten laden',
    '{value1} files attached. Remove an attachment to add another. Saved Skill references are included separately.':
      '{value1} bestanden bijgevoegd. Verwijder een bijlage om een andere toe te voegen. Opgeslagen verwijzingen naar vaardigheden zijn afzonderlijk opgenomen.',
    'Create a Skill in chat': 'Een vaardigheid maken in de chat',
    'Upload a company file': 'Een bedrijfsbestand uploaden',
    'Company knowledge is always available to Poneva.':
      'Bedrijfskennis is altijd beschikbaar voor Poneva.',
    '{value1} was not connected': '{value1} is niet verbonden',
    Dismiss: 'Negeren',
    'Try connecting again': 'Opnieuw proberen te verbinden',
    Waiting: 'Wachten',
    Connected: 'Verbonden',
    'Needs reconnecting': 'Opnieuw verbinden vereist',
    Connect: 'Verbinden',
    '{value1}{value2} The provider’s account permissions still apply.':
      '{value1}{value2} De accountmachtigingen van de provider blijven van toepassing.',
    'Last error: {value1}': 'Laatste fout: {value1}',
    '{value1} {value2} ready.': '{value1} {value2} is klaar.',
    'Continue with my Meta app': 'Doorgaan met mijn Meta-app',
    Reconnect: 'Opnieuw verbinden',
    Disconnect: 'Verbinding verbreken',
    'Remove attachment: {value1}': 'Bijlage verwijderen: {value1}',
    'Saved in this Skill. Edit the Skill to change its references.':
      'Opgeslagen in deze vaardigheid. Bewerk de vaardigheid om de verwijzingen te wijzigen.',
    'Remove Skill context': 'Vaardigheidscontext verwijderen',
    Refining: 'Verfijnen',
    Previewing: 'Voorbeeld bekijken',
    Using: 'Gebruiken',
    'Skill revision {value1}': 'Versie van vaardigheid {value1}',
    'a new Skill': 'een nieuwe vaardigheid',
    '{value1} Making a new agent {value2}': '{value1} Nieuwe agent {value2} maken',
    'Stop making a new agent in this chat': 'Stop met het maken van een nieuwe agent in deze chat',
    'Saved Skill references': 'Opgeslagen verwijzingen naar vaardigheden',
    'Included with Skill · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}':
      'Opgenomen met vaardigheid · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}',
    'Selected Skill revision is unavailable. Select the Skill again to view its saved references.':
      'De geselecteerde versie van de vaardigheid is niet beschikbaar. Selecteer de vaardigheid opnieuw om de opgeslagen verwijzingen te bekijken.',
    'Conversation attachments': 'Bijlagen bij gesprek',
    'Added for this conversation': 'Toegevoegd voor dit gesprek',
    'Selected passage {value1}': 'Geselecteerde passage {value1}',
    'We could not load your workspace.': 'We konden je werkruimte niet laden.',
    'The selected Skill is unavailable. Check its access or choose it again.':
      'De geselecteerde vaardigheid is niet beschikbaar. Controleer de toegang of kies de vaardigheid opnieuw.',
    'Source saved privately and included in your knowledge search.':
      'Bron privé opgeslagen en opgenomen in je kenniszoekopdracht.',
    'File saved privately to your library and attached to this message.':
      'Bestand privé opgeslagen in je bibliotheek en aan dit bericht toegevoegd.',
    'File saved privately to your library.': 'Bestand privé opgeslagen in je bibliotheek.',
    '{value1} {value2} earlier {value3} saved{value4}.':
      '{value1} {value2} eerder {value3} opgeslagen{value4}.',
    'Extracted text for Poneva to read. Download the original for its layout, charts and images. Spreadsheet formulas show their saved results and are not recalculated.':
      'Geëxtraheerde tekst die Poneva kan lezen. Download het origineel voor de opmaak, grafieken en afbeeldingen. Spreadsheetformules tonen hun opgeslagen resultaten en worden niet opnieuw berekend.',
    Esc: 'Esc',
    'Start something': 'Begin iets',
    'Choose a file to work with': 'Kies een bestand om mee te werken',
    'Skills worth adding': 'Vaardigheden die de moeite waard zijn om toe te voegen',
    'Picked for you': 'Voor jou geselecteerd',
    'Reusable work grounded in your company knowledge.':
      'Herbruikbaar werk op basis van je bedrijfskennis.',
    'Ideas from your company context and recent work. Pick one to start.':
      'Ideeën uit je bedrijfscontext en recente werk. Kies er een om te beginnen.',
    'Refresh suggested tasks': 'Voorgestelde taken vernieuwen',
    'Check for new company context.': 'Controleren op nieuwe bedrijfscontext.',
    'Check for new context. Ideas also refresh daily.':
      'Controleren op nieuwe context. Ideeën worden ook dagelijks vernieuwd.',
    Refresh: 'Vernieuwen',
    'Finding useful starting points…': 'Nuttige startpunten zoeken…',
    'Suggestions aren’t available right now. Try Refresh, or describe the work you want to do.':
      'Suggesties zijn momenteel niet beschikbaar. Probeer Vernieuwen of beschrijf het werk dat je wilt doen.',
    'Loading the knowledge pages…': 'Kennispagina’s laden…',
    '{value1} All pages': '{value1} Alle pagina’s',
    'The page is created.': 'De pagina is gemaakt.',
    'Your new page is suggested. A publisher decides whether it is added.':
      'Je nieuwe pagina is voorgesteld. Een uitgever bepaalt of deze wordt toegevoegd.',
    'Company knowledge': 'Bedrijfskennis',
    'What Poneva knows about your company, page by page. Every change is kept.':
      'Wat Poneva over je bedrijf weet, pagina voor pagina. Elke wijziging wordt bewaard.',
    'Loading company knowledge…': 'Bedrijfskennis laden…',
    'Knowledge pages are not enabled in this workspace.':
      'Kennispagina’s zijn niet ingeschakeld in deze werkruimte.',
    'Ask your Poneva contact to switch them on for your company.':
      'Vraag je Poneva-contactpersoon om ze voor je bedrijf in te schakelen.',
    '{value1} Change the agent': '{value1} De agent wijzigen',
    '{value1} Continue in chat': '{value1} Doorgaan in de chat',
    'We could not load this item.': 'Dit item kon niet worden geladen.',
    '{value1} canvas': '{value1}-canvas',
    'Loading {value1}…': '{value1} wordt geladen…',
    '{value1} · Original retained': '{value1} · Origineel behouden',
    '{value1} {value2}{value3} · Added {value4}':
      '{value1} {value2}{value3} · Toegevoegd op {value4}',
    '{value1} Use in chat': '{value1} Gebruiken in chat',
    '{value1} Download': '{value1} Downloaden',
    Table: 'Tabel',
    Chart: 'Grafiek',
    Original: 'Origineel',
    'Text extracted from the PDF, marked by page. Download the original for its layout and images.':
      'Tekst geëxtraheerd uit de pdf, gemarkeerd per pagina. Download het origineel voor de opmaak en afbeeldingen.',
    'This preview shows the beginning of the file. Poneva reads the whole file; download the original to see all of it.':
      'Deze preview toont het begin van het bestand. Poneva leest het hele bestand; download het origineel om alles te zien.',
    'Preview of the first {value1} complete rows. Filtering and charts use only this preview. Download the original for the full file.':
      'Preview van de eerste {value1} volledige rijen. Filters en grafieken gebruiken alleen deze preview. Download het origineel voor het volledige bestand.',
    'This source link cannot be opened.': 'Deze bronlink kan niet worden geopend.',
    'Read-only chat': 'Chat alleen-lezen',
    'Only {value1} writes in this chat. Fork it to continue with your own connections. {value2}':
      'Alleen {value1} kan in deze chat schrijven. Fork de chat om verder te gaan met je eigen verbindingen. {value2}',
    'Suggest a follow-up…': 'Een vervolgvraag voorstellen…',
    'Suggest a follow-up': 'Een vervolgvraag voorstellen',
    'Sending…': 'Wordt verzonden…',
    Send: 'Verzenden',
    'We could not dismiss that suggestion. Please try again.':
      'We konden die suggestie niet sluiten. Probeer het opnieuw.',
    'Suggested follow-ups': 'Voorgestelde vervolgstappen',
    '{value1} suggests': '{value1} stelt voor',
    Ask: 'Vragen',
    'Dismiss {value1}’s suggestion': 'De suggestie van {value1} sluiten',
    'Suggested by': 'Voorgesteld door',
    '· edit it or send it': '· bewerken of verzenden',
    'Remove the suggestion tag': 'Suggestielabel verwijderen',
    '{value1} {value2} is getting an answer': '{value1} {value2} krijgt antwoord',
    '{value1} {value2} stopped the answer': '{value1} {value2} heeft het antwoord gestopt',
    '{value1} Fork from here': '{value1} Vanaf hier forken',
    '{value1} From {value2}’s {value3}': '{value1} Uit de {value3} van {value2}',
    'Only {value1} can use this account': 'Alleen {value1} kan dit account gebruiken',
    '{value1} Suggested by {value2}': '{value1} Voorgesteld door {value2}',
    'Fork this chat': 'Deze chat forken',
    'Forking…': 'Bezig met forken…',
    Fork: 'Forken',
    'Could not make this private.': 'Kon niet privé worden gemaakt.',
    'Make this chat private?': 'Deze chat privé maken?',
    Close: 'Sluiten',
    '{value1} will see “{value2}”. Everyone else loses access right away {value3} .{value4}':
      '{value1} kan “{value2}” zien. Alle anderen verliezen onmiddellijk toegang {value3} .{value4}',
    Cancel: 'Annuleren',
    'Saving…': 'Wordt opgeslagen…',
    'Make private': 'Privé maken',
    'This chat is private again. Forks others made stay theirs.':
      'Deze chat is weer privé. Forks die anderen hebben gemaakt, blijven van hen.',
    'Who can read this chat: {value1}': 'Wie deze chat kan lezen: {value1}',
    'Move this chat': 'Deze chat verplaatsen',
    'Only you write here. Others follow live and fork.':
      'Alleen jij schrijft hier. Anderen volgen live en kunnen forken.',
    'Made private. {value1} has been told in their Inbox.':
      'Privé gemaakt. {value1} is hiervan op de hoogte gebracht in de Inbox.',
    'Chat access': 'Chattoegang',
    '{value1}’s chat. As an admin you can make it private.':
      'Chat van {value1}. Als beheerder kun je deze privé maken.',
    'Only {value1} will see it. {value2} is told.':
      'Alleen {value1} kan dit zien. {value2} is hiervan op de hoogte gebracht.',
    '{value1} {value2} following': '{value1} {value2} volgen',
    'Forked from{value1} {value2} . The history is copied. From here, tools run with your own access.':
      'Geforkt uit{value1} {value2} . De geschiedenis is gekopieerd. Vanaf hier werken tools met jouw eigen toegang.',
    '{value1} made this chat private': '{value1} heeft deze chat privé gemaakt',
    'You can no longer open it. Any fork you made stays yours.':
      'Je kunt deze chat niet meer openen. Elke fork die je hebt gemaakt, blijft van jou.',
    'Start a new chat': 'Een nieuwe chat starten',
    'Back to Recent chats': 'Terug naar Recente chats',
    'More chat actions': 'Meer chatacties',
    'Close conversation sharing': 'Delen van gesprek sluiten',
    'Review the text before saving a private copy to Library. Then choose its audience. Your original conversation and future messages stay private.':
      'Controleer de tekst voordat je een privé-kopie opslaat in de Bibliotheek. Kies daarna het publiek. Je oorspronkelijke gesprek en toekomstige berichten blijven privé.',
    'Preparing the conversation…': 'Gesprek voorbereiden…',
    'Refresh preview': 'Preview vernieuwen',
    'The copy is saved in Library. Use Share to choose who can access it.':
      'De kopie is opgeslagen in de Bibliotheek. Gebruik Delen om te kiezen wie toegang heeft.',
    'Save this copy': 'Deze kopie opslaan',
    'That Skill could not be opened.': 'Die vaardigheid kon niet worden geopend.',
    '{value1}{value2} · reviews and approvals': '{value1}{value2} · beoordelingen en goedkeuringen',
    'Open Inbox': 'Inbox openen',
    'New at {value1} this week': 'Nieuw bij {value1} deze week',
    'Nothing new this week. Shared work, published Skills and approved knowledge show up here.':
      'Deze week niets nieuws. Gedeeld werk, gepubliceerde vaardigheden en goedgekeurde kennis verschijnen hier.',
    'New at {value1}': 'Nieuw bij {value1}',
    'This Skill is unavailable. Try again.':
      'Deze vaardigheid is niet beschikbaar. Probeer het opnieuw.',
    'You can attach up to {value1} files. Remove an attachment to add another.':
      'Je kunt maximaal {value1} bestanden toevoegen. Verwijder een bijlage om een andere toe te voegen.',
    'Add company context': 'Bedrijfscontext toevoegen',
    'Add company context · @': 'Bedrijfscontext toevoegen · @',
    'Choose a Skill': 'Een vaardigheid kiezen',
    'Choose a Skill · /': 'Een vaardigheid kiezen · /',
    Edit: 'Bewerken',
    '{value1} Edit with chat': '{value1} Bewerken met chat',
    '{value1} Duplicate to my Library': '{value1} Dupliceren naar mijn bibliotheek',
    'Duplicated to your Library. Only you can see the copy.':
      'Gekopieerd naar je bibliotheek. Alleen jij kunt de kopie zien.',
    'Could not duplicate this Result. Try again.':
      'Dit resultaat kon niet worden gedupliceerd. Probeer het opnieuw.',
    'Saved version {value1}.': 'Versie {value1} opgeslagen.',
    'A newer version was saved. Reload the Result before saving.':
      'Er is een nieuwere versie opgeslagen. Laad het resultaat opnieuw voordat je opslaat.',
    'Could not save this version. Try again.':
      'Deze versie kon niet worden opgeslagen. Probeer het opnieuw.',
    '{value1} saved a newer version. Review it before saving.':
      '{value1} heeft een nieuwere versie opgeslagen. Bekijk deze voordat je opslaat.',
    'Hide their version': 'Hun versie verbergen',
    'Show their version': 'Hun versie tonen',
    'Start from their version': 'Begin met hun versie',
    Markdown: 'Markdown',
    'Result text': 'Resultaattekst',
    Preview: 'Voorbeeld',
    'What changed': 'Wat is er gewijzigd',
    'What changed? (optional)': 'Wat is er gewijzigd? (optioneel)',
    'Save version {value1}': 'Versie {value1} opslaan',
    'Open chat': 'Chat openen',
    Current: 'Huidig',
    Restore: 'Herstellen',
    'Could not load the history.': 'De geschiedenis kon niet worden geladen.',
    'Restored version {value1} as version {value2}.':
      'Versie {value1} hersteld als versie {value2}.',
    'Someone saved a newer version. Review it before restoring.':
      'Iemand heeft een nieuwere versie opgeslagen. Bekijk deze voordat je herstelt.',
    'Could not restore that version.': 'Die versie kon niet worden hersteld.',
    'Loading history…': 'Geschiedenis laden…',
    'Restoring keeps what is there now as a version too, so nothing is lost.':
      'Bij herstellen wordt ook wat er nu staat als versie bewaard, zodat er niets verloren gaat.',
    'This Result was made with your own {value1}.':
      'Dit resultaat is gemaakt met je eigen {value1}.',
    'It also used': 'Het gebruikte ook',
    'This Result was made with': 'Dit resultaat is gemaakt met',
    'Colleagues can read what came from them, but can never use them.':
      "Collega's kunnen lezen wat van hen afkomstig is, maar kunnen deze nooit gebruiken.",
    'Your personal agent {value1} keeps it up to date with your own access, so every refresh can carry your private data.':
      'Je persoonlijke agent {value1} houdt het actueel met jouw eigen toegangsrechten, zodat elke vernieuwing je privégegevens kan bevatten.',
    'A colleague’s personal agent keeps it up to date with their own access, so every refresh can carry their private data.':
      'De persoonlijke agent van een collega houdt het actueel met diens eigen toegangsrechten, zodat elke vernieuwing diens privégegevens kan bevatten.',
    'Made private. Only you can see this meeting.':
      'Privé gemaakt. Alleen jij kunt deze vergadering zien.',
    'Could not make this meeting private.': 'Deze vergadering kon niet privé worden gemaakt.',
    'Meeting · {value1} {value2} · Original retained':
      'Vergadering · {value1} {value2} · Origineel behouden',
    'The recording could not be opened.': 'De opname kon niet worden geopend.',
    'Ask about this suggestion': 'Vraag iets over deze suggestie',
    meeting_processing_failed: 'verwerking_van_vergadering_mislukt',
    'Who can see this': 'Wie kan dit zien',
    'Everyone at {value1}': 'Iedereen bij {value1}',
    'Only me': 'Alleen ik',
    'Everyone at {value1} can find it and ask about it.':
      'Iedereen bij {value1} kan dit vinden en er vragen over stellen.',
    'Only you can open and search this meeting. You can share it later.':
      'Alleen jij kunt deze vergadering openen en doorzoeken. Je kunt deze later delen.',
    'Added. Only you can see it. Transcription is running in the background.':
      'Toegevoegd. Alleen jij kunt dit zien. De transcriptie wordt op de achtergrond uitgevoerd.',
    'Visible to everyone at {value1}': 'Zichtbaar voor iedereen bij {value1}',
    'Could not make it private.': 'Kon niet privé worden gemaakt.',
    'Show more meetings': 'Meer vergaderingen tonen',
    'Attached to this message': 'Bijgevoegd bij dit bericht',
    'Connect securely, choose the tables to share, then decide whether Poneva can read or make changes.':
      'Maak veilig verbinding, kies de tabellen die je wilt delen en bepaal vervolgens of Poneva deze mag lezen of wijzigen.',
    'Review the tables this connection can access. Select at least one table.':
      'Bekijk de tabellen waartoe deze verbinding toegang heeft. Selecteer minstens één tabel.',
    'Select at least one table. Nothing is selected by default.':
      'Selecteer minstens één tabel. Standaard is niets geselecteerd.',
    'Choose who can use this connection and what Poneva can do.':
      'Kies wie deze verbinding mag gebruiken en wat Poneva mag doen.',
    'Your chosen access is enabled for the selected tables.':
      'De door jou gekozen toegang is ingeschakeld voor de geselecteerde tabellen.',
    'Your connection is saved with reading paused until permission is confirmed.':
      'Je verbinding is opgeslagen. Lezen is gepauzeerd totdat de toestemming is bevestigd.',
    'Confirm database disconnect': 'Verbinding met database verbreken bevestigen',
    'Disconnect this database?': 'Verbinding met deze database verbreken?',
    'Access will stop for everyone using this connection.':
      'De toegang wordt beëindigd voor iedereen die deze verbinding gebruikt.',
    'Keep connection': 'Verbinding behouden',
    'What it can reach · {value1}{value2} {value3}':
      'Waar het toegang toe heeft · {value1}{value2} {value3}',
    Back: 'Terug',
    Continue: 'Doorgaan',
    'Uploading…': 'Uploaden…',
    Library: 'Bibliotheek',
    'Source material for your work. Available whenever you need it.':
      'Bronmateriaal voor je werk. Beschikbaar wanneer je het nodig hebt.',
    'The work you want to keep, with its sources and conversation attached.':
      'Het werk dat je wilt bewaren, met de bijbehorende bronnen en conversatie.',
    Results: 'Resultaten',
    Files: 'Bestanden',
    Artifacts: 'Artefacten',
    'Search library': 'Bibliotheek doorzoeken',
    'Find files by meaning…': 'Bestanden zoeken op betekenis…',
    'Find saved work by meaning…': 'Opgeslagen werk zoeken op betekenis…',
    'Search coverage is limited while indexing or meaning-based search is unavailable. You can retry or browse recent items.':
      'De zoekdekking is beperkt zolang indexering of zoeken op betekenis niet beschikbaar is. Je kunt het opnieuw proberen of recente items bekijken.',
    'No matching work found.': 'Geen overeenkomend werk gevonden.',
    'A starting point for your next question.': 'Een beginpunt voor je volgende vraag.',
    'Good work is worth keeping.': 'Goed werk is het bewaren waard.',
    'Try a different description or clear the search to browse.':
      'Probeer een andere beschrijving of wis de zoekopdracht om te bladeren.',
    'Upload source material once and use it in conversations and Skills. Your original stays in the library.':
      'Upload bronmateriaal één keer en gebruik het in conversaties en Vaardigheden. Het origineel blijft in de bibliotheek.',
    'Ask Poneva to save an answer, table or chart. Results stay connected to the conversation and their sources.':
      'Vraag Poneva een antwoord, tabel of grafiek op te slaan. Resultaten blijven gekoppeld aan de conversatie en de bronnen.',
    'Start in chat {value1}': 'Starten in chat {value1}',
    'Open result: {value1}': 'Resultaat openen: {value1}',
    'Loading more library items…': 'Meer bibliotheekitems laden…',
    'Load more': 'Meer laden',
    'Documents, transcripts, audio and video · Up to 500 MB per file. New files are private. Choose their audience with Share and which processable files become searchable company knowledge.':
      'Documenten, transcripties, audio en video · Tot 500 MB per bestand. Nieuwe bestanden zijn privé. Kies hun doelgroep via Delen en bepaal welke verwerkbare bestanden doorzoekbare bedrijfskennis worden.',
    Skills: 'Vaardigheden',
    'Create in chat': 'In chat maken',
    'Search Skills': 'Vaardigheden zoeken',
    'Search finds published Skills. Clear the search to browse your drafts too.':
      'Met zoeken vind je gepubliceerde vaardigheden. Wis de zoekopdracht om ook je concepten te bekijken.',
    'Search coverage is limited while indexing or meaning-based search is unavailable.':
      'De zoekdekking is beperkt zolang indexering of zoeken op betekenis niet beschikbaar is.',
    'Searching Skills…': 'Vaardigheden zoeken…',
    'No matching published Skills found. Try a different description.':
      'Geen overeenkomende gepubliceerde vaardigheden gevonden. Probeer een andere beschrijving.',
    'Load more Skills': 'Meer vaardigheden laden',
    'View Skill: {value1}': 'Vaardigheid bekijken: {value1}',
    'Company workspace': 'Bedrijfswerkruimte',
    'View {value1}': '{value1} bekijken',
    'Loading Skills…': 'Vaardigheden laden…',
    'Try again {value1}': 'Opnieuw proberen {value1}',
    'Try again': 'Opnieuw proberen',
    'Nothing yet.': 'Nog niets.',
    'Made from · Used by': 'Gemaakt van · Gebruikt door',
    'Could not load links': 'Kan koppelingen niet laden',
    'Made from': 'Gemaakt van',
    'Used by': 'Gebruikt door',
    'About this chat {value1}': 'Over deze chat {value1}',
    'About this chat': 'Over deze chat',
    'Keep the work moving.': 'Houd het werk gaande.',
    'Ask a follow-up with this result in view, or turn a useful approach into a company Skill.':
      'Stel een vervolgvraag terwijl je dit resultaat bekijkt, of maak van een nuttige aanpak een bedrijfsvaardigheid.',
    'Save approach as a Skill': 'Aanpak opslaan als vaardigheid',
    'Preview of': 'Voorbeeld van',
    'Made with': 'Gemaakt met',
    'Open the draft': 'Concept openen',
    'Open Skill': 'Vaardigheid openen',
    'Use in chat': 'In chat gebruiken',
    'Finish the draft': 'Concept voltooien',
    'Refine this Skill': 'Deze vaardigheid verfijnen',
    'Made with a Skill.': 'Gemaakt met een vaardigheid.',
    'This workspace could not be loaded just now, so that Skill cannot be opened yet. The result itself is unchanged.':
      'Deze werkruimte kon zojuist niet worden geladen, dus die vaardigheid kan nog niet worden geopend. Het resultaat zelf is ongewijzigd.',
    'That Skill is not available in this workspace, so it cannot be opened or used again. The result itself is unchanged.':
      'Die vaardigheid is niet beschikbaar in deze werkruimte en kan daarom niet worden geopend of opnieuw worden gebruikt. Het resultaat zelf is ongewijzigd.',
    'Result · {value1} {value2}': 'Resultaat · {value1} {value2}',
    '{value1} Copy link': '{value1} Koppeling kopiëren',
    'Result link copied.': 'Koppeling naar resultaat gekopieerd.',
    'Could not copy the link. Use your browser address bar.':
      'Kan de koppeling niet kopiëren. Gebruik de adresbalk van je browser.',
    'No preview is available for this result.':
      'Er is geen voorbeeld beschikbaar voor dit resultaat.',
    '{value1} rows are retained in this snapshot. Open Table to inspect the values.':
      '{value1} rijen zijn in deze momentopname bewaard. Open Tabel om de waarden te bekijken.',
    'People can’t edit a Result an agent keeps up to date; the next refresh would replace their edit. Change the agent’s instructions instead.':
      'Je kunt een resultaat dat door een agent wordt bijgewerkt niet bewerken; bij de volgende vernieuwing zou je bewerking worden overschreven. Wijzig in plaats daarvan de instructies van de agent.',
    'Linked sources': 'Gekoppelde bronnen',
    'Saved source': 'Opgeslagen bron',
    'No source documents are linked to this result. Company knowledge and other references may be cited in the answer.':
      'Aan dit resultaat zijn geen brondocumenten gekoppeld. In het antwoord kunnen bedrijfskennis en andere referenties worden aangehaald.',
    'Run details': 'Uitvoeringsdetails',
    Created: 'Gemaakt',
    ', revised {value1}': ', herzien op {value1}',
    Conversation: 'Gesprek',
    'Not recorded': 'Niet opgenomen',
    'Open conversation': 'Gesprek openen',
    Run: 'Uitvoering',
    Updates: 'Updates',
    'Kept up to date by {value1}': 'Bijgewerkt door {value1}',
    'Version {value1}': 'Versie {value1}',
    'Could not open this request.': 'Kan dit verzoek niet openen.',
    'Approved version published.': 'Goedgekeurde versie gepubliceerd.',
    'Request rejected. The item stays unchanged.':
      'Verzoek afgewezen. Het item blijft ongewijzigd.',
    'Could not save the decision.': 'Kan de beslissing niet opslaan.',
    'Proposed company change': 'Voorgestelde bedrijfswijziging',
    'Opening…': 'Openen…',
    'Approve this version': 'Deze versie goedkeuren',
    Decline: 'Afwijzen',
    'Review the submitted version below. Changes made since submission will need a new request.':
      'Bekijk hieronder de ingediende versie. Voor wijzigingen die na indiening zijn aangebracht, is een nieuw verzoek nodig.',
    'The version submitted with this request.': 'De versie die met dit verzoek is ingediend.',
    'Version and proposed change': 'Versie en voorgestelde wijziging',
    'Could not read the pinned content.': 'Kan de vastgezette inhoud niet lezen.',
    'Showing a page of {value1} characters.':
      'Er wordt een pagina met {value1} tekens weergegeven.',
    'Beginning of the submitted content. Open the full text to review every page.':
      'Begin van de ingediende inhoud. Open de volledige tekst om elke pagina te bekijken.',
    'Read full submitted text': 'Volledige ingediende tekst lezen',
    'Previous page': 'Vorige pagina',
    'Next page': 'Volgende pagina',
    'Made private. Its creator has been told in their Inbox.':
      'Privé gemaakt. De maker is hierover geïnformeerd in diens Inbox.',
    'Made private. Its creator could not be notified.':
      'Privé gemaakt. De maker kon niet worden geïnformeerd.',
    'Make this {value1} private?': '{value1} privé maken?',
    'Only the person who created it will see it. Everyone else loses access right away, and its creator gets an Inbox update if they are still a company member. If they have left, nobody in the company will be able to access this item.':
      'Alleen de persoon die het heeft gemaakt, kan het zien. Alle anderen verliezen direct de toegang en de maker krijgt een update in de Inbox als die nog lid is van het bedrijf. Als de maker is vertrokken, kan niemand binnen het bedrijf dit item openen.',
    'Sent for review. The current audience stays unchanged until approval.':
      'Ter beoordeling verzonden. De huidige doelgroep blijft ongewijzigd totdat het is goedgekeurd.',
    'Could not update sharing.': 'Delen kon niet worden bijgewerkt.',
    'They can follow new answers live and fork it to continue with their own connections. Only you write here. You can make it private again at any time.':
      'Zij kunnen nieuwe antwoorden live volgen en het kopiëren om verder te gaan met hun eigen verbindingen. Alleen jij kunt hier schrijven. Je kunt het op elk moment weer privé maken.',
    'They see the project, its brief and the work in it they can already open. Nothing in it opens for anyone because of the project; each item keeps its own access.':
      'Zij zien het project, de projectbeschrijving en het werk dat ze al kunnen openen. Door het project krijgt niemand toegang tot andere inhoud; elk item behoudt zijn eigen toegangsrechten.',
    'Check the content for private information before sharing. Sharing an item does not grant access to its original chat or private connections.':
      'Controleer de inhoud op privégegevens voordat je deze deelt. Door een item te delen krijgt niemand toegang tot de oorspronkelijke chat of privéverbindingen.',
    '{value1} Everyone you share with can read it, including what the assistant or an App in it found in your {value2}. They can’t use your {value3}. Nothing changes for you: the chat keeps working with all your accounts.':
      '{value1} Iedereen met wie je dit deelt kan het lezen, inclusief wat de assistent of een app erin heeft gevonden in jouw {value2}. Zij kunnen jouw {value3} niet gebruiken. Voor jou verandert er niets: de chat blijft werken met al je accounts.',
    '{value1} Everyone you share with can read them, but nobody can use {value2} through this chat.':
      '{value1} Iedereen met wie je dit deelt kan ze lezen, maar niemand kan {value2} via deze chat gebruiken.',
    'This controls access to the working draft. Any published company version stays available until you explicitly unpublish it. To publish a new version, complete its preview and use Save Skill. Run results stay private.':
      'Dit bepaalt de toegang tot het werkconcept. Elke gepubliceerde bedrijfsversie blijft beschikbaar totdat je deze expliciet intrekt. Voltooi de preview en gebruik Vaardigheid opslaan om een nieuwe versie te publiceren. Uitvoerresultaten blijven privé.',
    'Skill deleted. You can restore it from the Skills archive for 30 days.':
      'Vaardigheid verwijderd. Je kunt deze 30 dagen terugzetten vanuit het vaardighedenarchief.',
    'Could not delete this Skill.': 'Deze vaardigheid kon niet worden verwijderd.',
    'More actions': 'Meer acties',
    'Delete “{value1}”? It will disappear from Skills and search, and cannot be used by agents. You can restore it for 30 days. Existing chats and results stay available.':
      '“{value1}” verwijderen? Deze verdwijnt uit Vaardigheden en zoekresultaten en kan niet door agents worden gebruikt. Je kunt deze 30 dagen terugzetten. Bestaande chats en resultaten blijven beschikbaar.',
    'Deleting…': 'Verwijderen…',
    'Confirm delete': 'Verwijdering bevestigen',
    'Delete Skill': 'Vaardigheid verwijderen',
    'Skill restored as an unpublished draft. Its author can review and publish it again.':
      'Vaardigheid teruggezet als ongepubliceerd concept. De auteur kan deze opnieuw beoordelen en publiceren.',
    'Could not restore this Skill.': 'Deze vaardigheid kon niet worden teruggezet.',
    'Archived Skills': 'Gearchiveerde vaardigheden',
    'Deleted Skills can be restored for 30 days. Restoring leaves them unpublished.':
      'Verwijderde vaardigheden kunnen 30 dagen worden teruggezet. Na het terugzetten blijven ze ongepubliceerd.',
    'Restore until {value1}': 'Terugzetten tot {value1}',
    'Loading…': 'Laden…',
    'No archived Skills.': 'Geen gearchiveerde vaardigheden.',
    'Load more archived Skills': 'Meer gearchiveerde vaardigheden laden',
    'Show more of the original': 'Meer van het origineel tonen',
    'Filter result rows': 'Resultaatrijen filteren',
    'Find a product or value…': 'Een product of waarde vinden…',
    '{value1} of {value2}': '{value1} van {value2}',
    'Result table': 'Resultatentabel',
    'No matching rows.': 'Geen overeenkomende rijen.',
    'Showing the first 1,000 matching rows. Download the CSV for every row.':
      'De eerste 1.000 overeenkomende rijen worden weergegeven. Download de CSV voor alle rijen.',
    'Agent ·': 'Agent ·',
    'Only you': 'Alleen jij',
    'Stopped before it finished.': 'Gestopt voordat het klaar was.',
    'Drafting the project…': 'Project opstellen…',
    'Checking where this chat belongs…': 'Controleren waar deze chat thuishoort…',
    'Moving the chat…': 'Chat verplaatsen…',
    'Taking it out of the project…': 'Uit het project halen…',
    'Adding it to the project…': 'Aan het project toevoegen…',
    'No matching connections are available right now.':
      'Er zijn momenteel geen overeenkomende verbindingen beschikbaar.',
    'Company knowledge suggestion': 'Suggestie voor bedrijfskennis',
    'Company knowledge now lives on pages. Open Knowledge to see them.':
      "Bedrijfskennis staat nu op pagina's. Open Kennis om deze te bekijken.",
    '{value1} · Open beside this conversation': '{value1} · Naast dit gesprek openen',
    'Name {value1}': 'Naam {value1}',
    'Host {value1}': 'Host {value1}',
    'Port {value1}': 'Poort {value1}',
    'Database {value1}': 'Database {value1}',
    'Username {value1}': 'Gebruikersnaam {value1}',
    'Password {value1}': 'Wachtwoord {value1}',
    'Advanced TLS': 'Geavanceerde TLS',
    '{value1} Poneva verifies the server certificate. Add a CA or server DNS name for IP hosts when your certificate requires it.':
      '{value1} Poneva controleert het servercertificaat. Voeg een CA- of server-DNS-naam toe voor IP-hosts als je certificaat dit vereist.',
    'CA certificate {value1}': 'CA-certificaat {value1}',
    'Certificate server DNS name {value1}': 'Server-DNS-naam van certificaat {value1}',
    '{value1} Your password is encrypted in secure storage. Poneva verifies the connection before saving it.':
      '{value1} Je wachtwoord wordt versleuteld opgeslagen in beveiligde opslag. Poneva controleert de verbinding voordat deze wordt opgeslagen.',
    'Testing…': 'Testen…',
    'Test connection': 'Verbinding testen',
    'PostgreSQL is connected.': 'PostgreSQL is verbonden.',
    'PostgreSQL was saved safely.': 'PostgreSQL is veilig opgeslagen.',
    'Poneva can read and change rows in the selected tables. Apps also follow their approved data scope.':
      'Poneva kan rijen in de geselecteerde tabellen lezen en wijzigen. Apps houden zich ook aan hun goedgekeurde gegevensbereik.',
    'Poneva can read the selected tables. Apps also follow their approved data scope.':
      'Poneva kan de geselecteerde tabellen lezen. Apps houden zich ook aan hun goedgekeurde gegevensbereik.',
    'Reads are paused until permission is enabled.':
      'Leesbewerkingen zijn gepauzeerd totdat de toestemming is ingeschakeld.',
    'Retrying…': 'Opnieuw proberen…',
    'Retry permission': 'Toestemming opnieuw proberen',
    'Try it in Chat': 'Probeer het in Chat',
    Done: 'Gereed',
    'Disconnect database': 'Databaseverbinding verbreken',
    '{value1} TLS verified ·{value2} {value3}': '{value1} TLS geverifieerd ·{value2} {value3}',
    'Search schemas and tables': "Schema's en tabellen zoeken",
    'Search tables': 'Tabellen zoeken',
    '{value1} of {value2} tables selected': '{value1} van {value2} tabellen geselecteerd',
    'Select matching tables': 'Overeenkomende tabellen selecteren',
    'Select all tables': 'Alle tabellen selecteren',
    Clear: 'Wissen',
    'Select a whole schema or individual tables. New tables need a fresh selection.':
      'Selecteer een volledig schema of afzonderlijke tabellen. Voor nieuwe tabellen moet je opnieuw selecteren.',
    'No tables match this search.': 'Geen tabellen komen overeen met deze zoekopdracht.',
    'All tables in {value1}': 'Alle tabellen in {value1}',
    '{value1} / {value2} tables': '{value1} / {value2} tabellen',
    'Read & write available': 'Lezen en schrijven beschikbaar',
    'Read only': 'Alleen-lezen',
    Ctrl: 'Ctrl',
    'This suggested knowledge update could not be shown.':
      'Deze voorgestelde kennisupdate kon niet worden weergegeven.',
    'Suggested knowledge update': 'Voorgestelde kennisupdate',
    'This suggestion is no longer available to you.':
      'Deze suggestie is niet langer voor jou beschikbaar.',
    'We could not check where this suggestion stands.':
      'We konden niet controleren wat de status van deze suggestie is.',
    'Check again': 'Opnieuw controleren',
    'Show on page': 'Op pagina weergeven',
    'The editor could not be loaded. Poneva may have been updated since you opened this page. Reload to get the latest version; nothing on this page has changed.':
      'De editor kon niet worden geladen. Poneva is mogelijk bijgewerkt sinds je deze pagina hebt geopend. Laad de pagina opnieuw voor de nieuwste versie; er is niets op deze pagina gewijzigd.',
    'Reload Poneva': 'Poneva opnieuw laden',
    Formatting: 'Opmaak',
    'Text style': 'Tekststijl',
    Text: 'Tekst',
    Heading: 'Kop',
    Subheading: 'Subkop',
    'Link a page': 'Een pagina koppelen',
    'A page needs a title.': 'Een pagina heeft een titel nodig.',
    'Nothing has changed yet.': 'Er is nog niets gewijzigd.',
    'A page needs some text. To remove a page, archive it instead.':
      'Een pagina heeft tekst nodig. Archiveer een pagina in plaats daarvan om deze te verwijderen.',
    'A suggested new page needs some text.': 'Een voorgestelde nieuwe pagina heeft tekst nodig.',
    'This page is larger than 256 KB. Split it into smaller pages.':
      "Deze pagina is groter dan 256 KB. Splits de pagina op in kleinere pagina's.",
    'Say in a few words why this change is right.':
      'Leg in een paar woorden uit waarom deze wijziging juist is.',
    'This page changed while you were editing. Your text is still here: copy it, then open the latest version and make your change again.':
      'Deze pagina is gewijzigd terwijl je deze bewerkte. Je tekst staat er nog: kopieer deze, open daarna de nieuwste versie en voer je wijziging opnieuw uit.',
    'Your text is copied.': 'Je tekst is gekopieerd.',
    'Your text could not be copied. Select it in the editor and copy it.':
      'Je tekst kon niet worden gekopieerd. Selecteer de tekst in de editor en kopieer deze.',
    'The page “{value1}” is created.': 'De pagina “{value1}” is gemaakt.',
    'New page': 'Nieuwe pagina',
    'Editing {value1}': '{value1} bewerken',
    Editing: 'Bewerken',
    'Creating publishes the page under {value1} for everyone':
      'Als je de pagina maakt, wordt deze onder {value1} voor iedereen gepubliceerd',
    'Saving publishes the new version for everyone':
      'Als je opslaat, wordt de nieuwe versie voor iedereen gepubliceerd',
    'Your changes are sent as a suggestion for a publisher':
      'Je wijzigingen worden als suggestie naar een publiceerder gestuurd',
    'Create page': 'Pagina maken',
    Save: 'Opslaan',
    'Send suggestion': 'Suggestie verzenden',
    '{value1} Copy my text': '{value1} Mijn tekst kopiëren',
    'Open the latest version': 'Nieuwste versie openen',
    'Page title': 'Paginatitel',
    'Loading the editor…': 'Editor wordt geladen…',
    'New page text': 'Tekst van nieuwe pagina',
    'Text of {value1}': 'Tekst van {value1}',
    'Write the page. Type [[ to link another page.':
      'Schrijf de pagina. Typ [[ om een andere pagina te koppelen.',
    'Type [[ to link another page.': 'Typ [[ om een andere pagina te koppelen.',
    'Link to a page': 'Aan een pagina koppelen',
    'What changed, in a few words': 'Wat is er gewijzigd, in een paar woorden',
    'Where this comes from, in a few words': 'Waar dit vandaan komt, in een paar woorden',
    'Shown in the page history.': 'Wordt in de paginageschiedenis weergegeven.',
    'A publisher sees this next to your change.': 'Een publiceerder ziet dit naast je wijziging.',
    '1 suggestion is open on this page': 'Er staat 1 suggestie open op deze pagina',
    '{value1} suggestions are open on this page':
      'Er staan {value1} suggesties open op deze pagina',
    'They stay open while you edit. After you save, they show against your new text; one whose words you changed is marked outdated.':
      'Ze blijven open terwijl je bewerkt. Nadat je opslaat, worden ze bij je nieuwe tekst weergegeven; een suggestie waarvan je de woorden hebt gewijzigd, wordt als verouderd gemarkeerd.',
    'Type [[ to link another page. Links keep working when a page is renamed or moved.':
      'Typ [[ om een andere pagina te koppelen. Koppelingen blijven werken wanneer een pagina een andere naam krijgt of wordt verplaatst.',
    'Loading the history…': 'Geschiedenis wordt geladen…',
    'This page has no saved text yet.': 'Deze pagina heeft nog geen opgeslagen tekst.',
    'Say in a few words why this revision should come back.':
      'Leg in een paar woorden uit waarom deze revisie moet worden teruggezet.',
    'Revision {value1} is suggested for a publisher to accept.':
      'Revisie {value1} wordt ter acceptatie aan een publiceerder voorgesteld.',
    'The page already reads like this revision.': 'De pagina bevat al de tekst van deze revisie.',
    'Revision {value1} is restored as revision {value2}.':
      'Revisie {value1} is teruggezet als revisie {value2}.',
    'Revision history': 'Revisiegeschiedenis',
    Revisions: 'Revisies',
    'Every saved revision is kept.': 'Elke opgeslagen revisie wordt bewaard.',
    'Revision {value1} {value2}': 'Revisie {value1} {value2}',
    'Revision {value1} compared with revision {value2}':
      'Revisie {value1} vergeleken met revisie {value2}',
    'Revision {value1}, the first text of this page':
      'Revisie {value1}, de eerste tekst van deze pagina',
    'Green was added, struck through was removed.':
      'Groen is toegevoegd, doorgestreepte tekst is verwijderd.',
    '{value1} Export Markdown': '{value1} Markdown exporteren',
    'Restore this revision': 'Deze revisie terugzetten',
    'Suggest restoring it': 'Voorstellen om deze terug te zetten',
    'Why should this revision come back?': 'Waarom moet deze revisie worden teruggezet?',
    'Loading this revision…': 'Deze revisie wordt geladen…',
    'Only the title changed, from “{value1}” to “{value2}”.':
      'Alleen de titel is gewijzigd, van “{value1}” naar “{value2}”.',
    'The text did not change in this revision.': 'De tekst is in deze revisie niet gewijzigd.',
    'Changes in revision {value1}': 'Wijzigingen in revisie {value1}',
    'Loading page…': 'Pagina wordt geladen…',
    'Loading suggestion…': 'Suggestie wordt geladen…',
    'This suggestion is not available.': 'Deze suggestie is niet beschikbaar.',
    'It may have been decided, or it is not one you can see.':
      'Er is mogelijk al over beslist, of je hebt geen toegang om deze te bekijken.',
    'Open Knowledge': 'Kennis openen',
    'Opening the suggestion…': 'Suggestie wordt geopend…',
    'Choose where the page goes.': 'Kies waar de pagina komt te staan.',
    'Say in a few words why.': 'Leg in een paar woorden uit waarom.',
    'Your suggestion is sent. A publisher decides.':
      'Je suggestie is verzonden. Een publiceerder neemt de beslissing.',
    'Moved under {value1}.': 'Verplaatst onder {value1}.',
    'Deleted “{value1}”.': '“{value1}” verwijderd.',
    'Archived. Its history is kept.': 'Gearchiveerd. De geschiedenis blijft bewaard.',
    'Choose the page it goes under. Links to it keep working.':
      'Kies onder welke pagina deze valt. Links ernaartoe blijven werken.',
    'Its text, its history and any open suggestions are removed for good, and links to it from other pages stop working. This cannot be undone.':
      'De tekst, geschiedenis en openstaande suggesties worden definitief verwijderd en links ernaartoe vanaf andere pagina’s werken niet meer. Dit kan niet ongedaan worden gemaakt.',
    'An archived page no longer informs answers. Its history is kept, and a publisher can restore it or delete it permanently.':
      'Een gearchiveerde pagina wordt niet meer gebruikt voor antwoorden. De geschiedenis blijft bewaard en een uitgever kan de pagina herstellen of definitief verwijderen.',
    Under: 'Onder',
    Change: 'Wijzigen',
    'Move under': 'Verplaatsen onder',
    'Search pages': 'Pagina’s zoeken',
    'Why?': 'Waarom?',
    'Delete permanently': 'Definitief verwijderen',
    'Move page': 'Pagina verplaatsen',
    'Archive page': 'Pagina archiveren',
    'Suggestion {value1}: show its card': 'Suggestie {value1}: kaart tonen',
    'Removed:': 'Verwijderd:',
    'Added:': 'Toegevoegd:',
    'New page “{value1}”{value2}': 'Nieuwe pagina “{value1}”{value2}',
    'No pages match “{value1}”.': 'Geen pagina’s gevonden voor “{value1}”.',
    'Where this page is': 'Waar deze pagina staat',
    'Describe your company': 'Beschrijf je bedrijf',
    'Empty page': 'Lege pagina',
    'Describe {value1}': 'Beschrijf {value1}',
    'This page has no text yet.': 'Deze pagina bevat nog geen tekst.',
    'Poneva reads this page before every answer. Start with who you are, what you sell and how you work; details go on the pages under it.':
      'Poneva leest deze pagina vóór elk antwoord. Begin met wie je bent, wat je verkoopt en hoe je werkt; details komen op de onderliggende pagina’s.',
    'Write it, or ask Poneva in chat to draft it for you.':
      'Schrijf het zelf of vraag Poneva in de chat om een concept voor je te maken.',
    'Suggest a first version, and a publisher decides whether it becomes the page.':
      'Stel een eerste versie voor; een uitgever beslist of die de pagina wordt.',
    'Start writing': 'Begin met schrijven',
    'Suggest a first version': 'Eerste versie voorstellen',
    'Accepted. The page is archived.': 'Geaccepteerd. De pagina is gearchiveerd.',
    'Accepted. The page is now revision {value1}.':
      'Geaccepteerd. De pagina is nu revisie {value1}.',
    'Accepted.': 'Geaccepteerd.',
    'Suggestion rejected. The page stays as it is.':
      'Suggestie afgewezen. De pagina blijft ongewijzigd.',
    'Your suggestion is withdrawn.': 'Je suggestie is ingetrokken.',
    'Restored. The page informs answers again.':
      'Hersteld. De pagina wordt weer gebruikt voor antwoorden.',
    'Your suggestion is sent. A publisher decides whether it becomes the page.':
      'Je suggestie is verzonden. Een uitgever beslist of die de pagina wordt.',
    'Saved. The page is now revision {value1}.': 'Opgeslagen. De pagina is nu revisie {value1}.',
    'Nothing changed.': 'Er is niets gewijzigd.',
    'This page is not available.': 'Deze pagina is niet beschikbaar.',
    'It may have been deleted, archived or moved out of reach, or you may no longer be in this company.':
      'De pagina is mogelijk verwijderd, gearchiveerd of verplaatst naar een plek waar je geen toegang toe hebt, of je werkt niet meer bij dit bedrijf.',
    'Page actions': 'Pagina-acties',
    shown: 'getoond',
    hidden: 'verborgen',
    '{value1} History': 'Geschiedenis van {value1}',
    '{value1} Ask in chat': '{value1} In chat vragen',
    'Suggest edits': 'Wijzigingen voorstellen',
    'More actions for {value1}': 'Meer acties voor {value1}',
    '{value1} Poneva reads this page in every chat':
      '{value1} Poneva leest deze pagina in elke chat',
    'This page is archived. It no longer informs answers; its history is kept. {value1}':
      'Deze pagina is gearchiveerd. De pagina wordt niet meer gebruikt voor antwoorden; de geschiedenis blijft bewaard. {value1}',
    'Restore page': 'Pagina herstellen',
    'This link points to an earlier revision. You are reading the current text.':
      'Deze link verwijst naar een eerdere revisie. Je leest de huidige tekst.',
    'Show it in History': 'In Geschiedenis tonen',
    Pages: 'Pagina’s',
    'Pages under {value1}': 'Pagina’s onder {value1}',
    'Linked from': 'Gelinkt vanaf',
    Suggestions: 'Suggesties',
    'Suggestions are hidden. You are reading the page as everyone else sees it.':
      'Suggesties zijn verborgen. Je leest de pagina zoals iedereen die ziet.',
    'Loading suggestions…': 'Suggesties worden geladen…',
    'Nothing is waiting for review.': 'Er wacht niets op beoordeling.',
    'When someone, Poneva in a chat or a connected agent suggests a change to a page, it shows here and on the page. Nothing changes until a publisher accepts it.':
      'Wanneer iemand, Poneva in een chat of een verbonden agent een wijziging aan een pagina voorstelt, verschijnt die hier en op de pagina. Er verandert niets totdat een uitgever de wijziging accepteert.',
    '{value1} Review knowledge in chat': '{value1} Kennis beoordelen in chat',
    'Suggestions for review': 'Suggesties ter beoordeling',
    'Suggested changes from chats, meetings, colleagues and connected agents. Nothing changes until a publisher accepts it on the page.':
      'Voorgestelde wijzigingen uit chats, vergaderingen, van collega’s en verbonden agents. Er verandert niets totdat een uitgever ze op de pagina accepteert.',
    'Your suggestions wait here until a publisher decides. The pages stay as they are until then.':
      'Je suggesties blijven hier staan totdat een uitgever beslist. De pagina’s blijven tot die tijd ongewijzigd.',
    'Review page': 'Pagina beoordelen',
    'Review on page': 'Op pagina beoordelen',
    'Open the meeting': 'Vergadering openen',
    'Open the chat': 'Chat openen',
    'Accept and restore': 'Accepteren en herstellen',
    Accept: 'Accepteren',
    Reject: 'Afwijzen',
    'Your suggestion · waiting for a publisher': 'Je suggestie · wacht op een uitgever',
    Withdraw: 'Intrekken',
    'Waiting for a publisher': 'Wacht op een uitgever',
    'Suggestion {value1}': 'Suggestie {value1}',
    'Suggestion {value1} from {value2}{value3}': 'Suggestie {value1} van {value2}{value3}',
    'Read the suggested page': 'Voorgestelde pagina lezen',
    'Outdated: the text it changes was edited after it was suggested. It can be rejected or withdrawn; a new suggestion can be made against the current text.':
      'Verouderd: de tekst die wordt gewijzigd, is bewerkt nadat de suggestie was gedaan. De suggestie kan worden afgewezen of ingetrokken; er kan een nieuwe suggestie voor de huidige tekst worden gedaan.',
    'Restore this page first to accept this suggestion.':
      'Herstel deze pagina eerst om deze suggestie te accepteren.',
    'Previous suggestion': 'Vorige suggestie',
    'Suggestion {value1} of {value2}': 'Suggestie {value1} van {value2}',
    'Next suggestion': 'Volgende suggestie',
    'Fold the suggestions away': 'Suggesties inklappen',
    'Show the suggestions': 'Suggesties tonen',
    '1 suggestion': '1 suggestie',
    '{value1} suggestions': '{value1} suggesties',
    '{value1} the pages under {value2}': "{value1} de pagina's onder {value2}",
    px: 'px',
    '{value1} chart of {value2} across {value3}': '{value1}-grafiek van {value2} over {value3}',
    'We could not build the file.': 'We konden het bestand niet maken.',
    '{value1} Present': '{value1} presenteren',
    'Building…': 'Bezig met maken…',
    'Download PowerPoint': 'PowerPoint downloaden',
    'Slide {value1} of {value2}': 'Dia {value1} van {value2}',
    Slides: "Dia's",
    'Slide {value1}': 'Dia {value1}',
    'Speaker notes': 'Sprekersnotities',
    'Source: {value1}': 'Bron: {value1}',
    'Add a name and a web address.': 'Voeg een naam en webadres toe.',
    'Enter a valid web address.': 'Voer een geldig webadres in.',
    'Use a web address that starts with https://.': 'Gebruik een webadres dat begint met https://.',
    'Add a custom connection': 'Aangepaste verbinding toevoegen',
    'Connect a tool server you trust. Poneva checks the address works and saves only the connection details needed to use it.':
      'Verbind een toolserver die je vertrouwt. Poneva controleert of het adres werkt en slaat alleen de verbindingsgegevens op die nodig zijn om deze te gebruiken.',
    'Web address': 'Webadres',
    'https://tools.example.com': 'https://tools.example.com',
    'Starts with https://, from your provider': 'Begint met https://, van je provider',
    'Sign-in': 'Aanmelden',
    'Advanced sign-in': 'Geavanceerd aanmelden',
    'Access key {value1}': 'Toegangssleutel {value1}',
    'Request headers': 'Requestheaders',
    'Add header': 'Header toevoegen',
    'Header {value1} name': 'Naam van header {value1}',
    'Header name': 'Naam van header',
    'Header {value1} value': 'Waarde van header {value1}',
    'Header value': 'Waarde van header',
    'Remove header': 'Header verwijderen',
    Advanced: 'Geavanceerd',
    Transport: 'Transport',
    'Auto-detect': 'Automatisch detecteren',
    'Streamable HTTP': 'Streamable HTTP',
    'Legacy SSE': 'Verouderde SSE',
    "From your provider's app settings. Leave empty unless they gave you these.":
      'Uit de app-instellingen van je provider. Laat dit leeg tenzij je deze gegevens hebt gekregen.',
    "Authorization server issuer": "Uitgever van de autorisatieserver",
    "Enter the authorization server issuer when using a client ID.": "Voer de uitgever van de autorisatieserver in als u een client-ID gebruikt.",
    'Client ID {value1}': 'Client-ID {value1}',
    'Client secret {value1}': 'Clientgeheim {value1}',
    'Connecting…': 'Bezig met verbinden…',
    'Test and connect': 'Testen en verbinden',
    'Add the store, the client ID and the client secret.':
      'Voeg de winkel, het client-ID en het clientgeheim toe.',
    'Connect your Shopify Developer App': 'Je Shopify Developer App verbinden',
    'Poneva can use exactly the access your store gave the app, and nothing more. It talks to Shopify directly and keeps the client secret encrypted.':
      'Poneva kan precies de toegang gebruiken die je winkel aan de app heeft gegeven, en niets meer. Poneva communiceert rechtstreeks met Shopify en bewaart het clientgeheim versleuteld.',
    'How to create the app in Shopify': 'Een app maken in Shopify',
    'Open{value1} {value2}{value3} with the account that owns the store, and create an app.':
      'Open{value1} {value2}{value3} met het account van de winkeleigenaar en maak een app.',
    'Create a version and select the access scopes Poneva may use, for example read_products and read_orders. Add write_ scopes only for data Poneva may change. Then release the version.':
      'Maak een versie en selecteer de toegangsbereiken die Poneva mag gebruiken, bijvoorbeeld read_products en read_orders. Voeg write_-bereiken alleen toe voor gegevens die Poneva mag wijzigen. Publiceer vervolgens de versie.',
    'For orders and customers, also select protected customer data in the app’s settings. Shopify allows this without review for an app made for your own store.':
      'Selecteer voor bestellingen en klanten ook beschermde klantgegevens in de instellingen van de app. Shopify staat dit zonder beoordeling toe voor een app die voor je eigen winkel is gemaakt.',
    'Install the app on your store.': 'Installeer de app in je winkel.',
    'Copy the client ID and client secret from the app’s settings.':
      'Kopieer het client-ID en clientgeheim uit de instellingen van de app.',
    'To change the access later, release a new version, approve it on the store and use Test connection here.':
      'Als je de toegang later wilt wijzigen, publiceer dan een nieuwe versie, keur deze goed in de winkel en gebruik hier Verbinding testen.',
    Store: 'Winkel',
    'your-store.myshopify.com': 'your-store.myshopify.com',
    'Your store’s .myshopify.com address (Shopify admin → Settings → Domains), or paste the address of your Shopify admin page':
      'Het .myshopify.com-adres van je winkel (Shopify-beheercentrum → Settings → Domains), of plak het adres van je Shopify-beheerpagina',
    'Client ID {value1} {value2}': 'Client-ID {value1} {value2}',
    'Client secret {value1} {value2}': 'Clientgeheim {value1} {value2}',
    Person: 'Persoon',
    Everyone: 'Iedereen',
    Connection: 'Verbinding',
    'All connections': 'Alle verbindingen',
    'App {value1}': 'App {value1}',
    'From {value1}': 'Vanaf {value1}',
    'Until {value1}': 'Tot {value1}',
    Result: 'Resultaat',
    'All results': 'Alle resultaten',
    Succeeded: 'Geslaagd',
    Denied: 'Geweigerd',
    Failed: 'Mislukt',
    Unknown: 'Onbekend',
    Filter: 'Filter',
    'Loading activity…': 'Activiteit laden…',
    'Could not load activity. Try again.': 'Kan de activiteit niet laden. Probeer het opnieuw.',
    'Removed connection': 'Verbinding verwijderd',
    'App: {value1}': 'App: {value1}',
    'Older activity': 'Oudere activiteit',
    Download: 'Downloaden',
    CSV: 'CSV',
    'Evidence for {value1}': 'Onderbouwing voor {value1}',
    Measure: 'Maatstaf',
    'Show rows →': 'Rijen weergeven →',
    'Ask about this number': 'Vraag naar dit getal',
    'There are no numeric values available to chart. View the table for the original data.':
      'Er zijn geen numerieke waarden beschikbaar voor een grafiek. Bekijk de tabel voor de oorspronkelijke gegevens.',
    'Chart value': 'Grafiekwaarde',
    '{value1} of {value2} shown': '{value1} van {value2} weergegeven',
    '{value1} by {value2}; {value3} rows. View Table for exact values.':
      '{value1} bij {value2}; {value3} rijen. Bekijk de tabel voor exacte waarden.',
    'Values come directly from the source data. Missing values are not estimates.':
      'Waarden komen rechtstreeks uit de brongegevens. Ontbrekende waarden zijn geen schattingen.',
    'Loading library…': 'Bibliotheek wordt geladen…',
    'We couldn’t load what happened in this App. Try again in a moment.':
      'We konden niet laden wat er in deze App is gebeurd. Probeer het zo opnieuw.',
    'This App could not be opened.': 'Deze App kon niet worden geopend.',
    'Opening App…': 'App wordt geopend…',
    'Open the saved App to run this function.':
      'Open de opgeslagen App om deze functie uit te voeren.',
    'Save this App before running its function.': 'Sla deze App op voordat je de functie uitvoert.',
    'Open saved App': 'Opgeslagen App openen',
    'Open Apps': 'Apps openen',
    'The App could not be opened. Try again.':
      'De App kon niet worden geopend. Probeer het opnieuw.',
    Owner: 'Eigenaar',
    '{value1} · admins': '{value1} · beheerders',
    'Owner · always edits': 'Eigenaar · kan altijd bewerken',
    'Admins manage it': 'Beheerders beheren dit',
    Editors: 'Bewerkers',
    'A colleague': 'Een collega',
    'Can edit drafts and publish versions': 'Kan concepten bewerken en versies publiceren',
    Remove: 'Verwijderen',
    'No editors yet.': 'Nog geen bewerkers.',
    'Admins can always edit company agents.': 'Beheerders kunnen bedrijfsagenten altijd bewerken.',
    'Asking for edit access': 'Bewerkingsrechten aanvragen',
    'Asked {value1} · also in your Inbox': 'Aangevraagd op {value1} · ook in je Inbox',
    Grant: 'Toestaan',
    Admin: 'Beheerder',
    'Make personal': 'Persoonlijk maken',
    'Switch off': 'Uitschakelen',
    Archive: 'Archiveren',
    'Archive this agent': 'Deze agent archiveren',
    'Loading agent…': 'Agent wordt geladen…',
    '{value1} Edit in chat': '{value1} Bewerken in chat',
    Agent: 'Agent',
    'This agent has not been created yet. It can run once its owner creates it.':
      'Deze agent is nog niet gemaakt. De agent kan worden uitgevoerd zodra de eigenaar deze maakt.',
    'New agent · Draft': 'Nieuwe agent · Concept',
    'Untitled agent': 'Naamloze agent',
    'Test run': 'Testuitvoering',
    'This draft does not run automatically.': 'Dit concept wordt niet automatisch uitgevoerd.',
    'Describe the agent in the chat. Its draft appears here.':
      'Beschrijf de agent in de chat. Het concept verschijnt hier.',
    '{value1} Test run': '{value1} Testuitvoering',
    'Describe the agent in the chat first.': 'Beschrijf de agent eerst in de chat.',
    'Create and turn on': 'Maken en inschakelen',
    'Connection write setup': 'Instellingen voor schrijven via verbinding',
    'Account for connected changes': 'Account voor wijzigingen via de verbinding',
    'Choose a connection': 'Kies een verbinding',
    'No published Skills available. You can add them later.':
      'Er zijn geen gepubliceerde vaardigheden beschikbaar. Je kunt ze later toevoegen.',
    '{value1} · not published. Review the changes. Testing is optional.':
      '{value1} · niet gepubliceerd. Controleer de wijzigingen. Testen is optioneel.',
    '{value1} Test draft': '{value1} Concept testen',
    'Apply changes…': 'Wijzigingen toepassen…',
    'Apply this draft as a new version': 'Dit concept als nieuwe versie toepassen',
    'This draft cannot be applied.': 'Dit concept kan niet worden toegepast.',
    'What changed?': 'Wat is er gewijzigd?',
    'Apply version {value1}': 'Versie {value1} toepassen',
    Create: 'Maken',
    'Edit access requested': 'Bewerkingsrechten aangevraagd',
    '{value1} Request edit access': '{value1} Bewerkingsrechten aanvragen',
    '{value1} Copy agent': '{value1} Agent kopiëren',
    Pause: 'Pauzeren',
    'Open agent: {value1}': 'Agent openen: {value1}',
    '· you can edit': '· je kunt bewerken',
    '{value1} is switched off.': '{value1} is uitgeschakeld.',
    '{value1} is archived.': '{value1} is gearchiveerd.',
    'Loading agents…': 'Agenten worden geladen…',
    Agents: 'Agenten',
    'Agents do work for you on a schedule or when you ask. They follow your company’s Skills.':
      'Agenten doen werk voor je volgens een schema of wanneer je erom vraagt. Ze volgen de vaardigheden van je bedrijf.',
    'No agent matches. Try a Skill name or what the agent should do.':
      'Geen overeenkomende agent. Probeer de naam van een vaardigheid of beschrijf wat de agent moet doen.',
    'Nothing of your own yet': 'Je hebt nog niets van jezelf',
    'Tell Chat what an agent should do, or copy one of the company’s agents below.{value1}':
      'Vertel Chat wat een agent moet doen of kopieer hieronder een van de bedrijfsagenten.{value1}',
    'Your agents': 'Je agenten',
    'Run on demand': 'Op aanvraag uitvoeren',
    'Run is always available. A schedule is optional and lives separately from the agent’s instructions.':
      'Uitvoeren is altijd beschikbaar. Een schema is optioneel en staat los van de instructies van de agent.',
    'What changed in version {value1}': 'Wat is er gewijzigd in versie {value1}',
    'Every publish is a version you can restore.':
      'Elke publicatie is een versie die je kunt herstellen.',
    Authorization: 'Autorisatie',
    '{value1} {value2} · {value3} will see it.': '{value1} {value2} · {value3} zullen het zien.',
    '{value1} {value2} you': '{value1} {value2} jou',
    '· Revised': '· Herzien',
    'This chat used your {value1}.': 'Deze chat heeft je {value1} gebruikt.',
    'This chat has results from {value1}.': 'Deze chat bevat resultaten van {value1}.',
    'db.example.com': 'db.example.com',
    'e.g. Product analytics': 'bijv. Productanalyse',
    'Paste access key': 'Plak de toegangssleutel',
    'Shopify’s Dev Dashboard': 'Shopify’s Dev Dashboard',
    'App reference': 'Appreferentie',
    'Draft · revision {value1}': 'Concept · revisie {value1}',
    'its Result': 'het resultaat ervan',
    '· its first run makes it': '· de eerste uitvoering ervan maakt het',
    '{value1}’s chat ·': 'Chat van {value1} ·',
    '{value1} ad {value2} available.': '{value1} en {value2} beschikbaar.',
    '{value1} rows ·': '{value1} rijen ·',
    'It starts private. Sharing it wider shares every refresh, which can carry your private data.':
      'Het begint privé. Als je het breder deelt, wordt elke vernieuwing gedeeld, waarbij je privégegevens kunnen worden meegenomen.',
    'Enable this schedule when approved': 'Schakel deze planning in zodra deze is goedgekeurd.',
    Schedule: 'Planning',
    'Kept off until you create the agent from its canvas.':
      'Uitgeschakeld totdat je de agent vanuit het canvas maakt.',
    'Will be enabled when you approve.': 'Wordt ingeschakeld zodra je goedkeurt.',
    'Will be saved paused. You can enable it later.':
      'Wordt gepauzeerd opgeslagen. Je kunt deze later inschakelen.',
    'Only runs when you ask.': 'Wordt alleen uitgevoerd wanneer je erom vraagt.',
    'Draft · approving saves it, and nothing runs. Test it and create it from its canvas.':
      'Concept · goedkeuren slaat het op en er wordt niets uitgevoerd. Test het en maak het vanuit het canvas.',
    'Draft · nothing is scheduled until you approve. Connected actions require their own approval at run time.':
      'Concept · er wordt niets gepland totdat je goedkeurt. Voor verbonden acties is tijdens de uitvoering afzonderlijke goedkeuring vereist.',
    Name: 'Naam',
    'Agent name': 'Naam van de agent',
    'Who can use it': 'Wie dit kan gebruiken',
    'Company agent · company resources only': 'Bedrijfsagent · alleen bedrijfsresources',
    'Personal agent · runs with your access':
      'Persoonlijke agent · wordt uitgevoerd met jouw toegang',
    'Approving saves it as a draft. It does not run automatically.':
      'Goedkeuren slaat het op als concept. Het wordt niet automatisch uitgevoerd.',
    'Open the agent’s runs': 'Uitvoeringen van de agent openen',
    'Run the published version once': 'De gepubliceerde versie één keer uitvoeren',
    'Stopping…': 'Wordt gestopt…',
    'Stop run': 'Uitvoering stoppen',
    'Could not stop this run. Please try again.':
      'Deze uitvoering kon niet worden gestopt. Probeer het opnieuw.',
    'Run in progress': 'Uitvoering bezig',
    'This run is still answering. You can ask follow-ups when it finishes.':
      'Deze uitvoering geeft nog antwoord. Je kunt vervolgvragen stellen zodra deze klaar is.',
    'Open run details': 'Details van uitvoering openen',
    Runs: 'Uitvoeringen',
    'Open the run chat': 'Chat van uitvoering openen',
    Watch: 'Bekijken',
    Goal: 'Doel',
    'Change the goal': 'Doel wijzigen',
    'What it does': 'Wat het doet',
    'What should this agent achieve?': 'Wat moet deze agent bereiken?',
    'Not set yet.': 'Nog niet ingesteld.',
    'When it runs': 'Wanneer deze wordt uitgevoerd',
    'Change when it runs': 'Uitvoeringsmoment wijzigen',
    'Off means it runs only when someone runs it. Changing when it runs never changes its instructions.':
      'Uit betekent dat deze alleen wordt uitgevoerd wanneer iemand dit doet. Het wijzigen van het uitvoeringsmoment verandert nooit de instructies.',
    Instructions: 'Instructies',
    'Change the instructions': 'Instructies wijzigen',
    'How the agent should approach the work and make decisions.':
      'Hoe de agent het werk moet aanpakken en beslissingen moet nemen.',
    Boundaries: 'Grenzen',
    'What to do or avoid. Every connected action still follows its approval.':
      'Wat de agent wel of niet moet doen. Voor elke verbonden actie is nog steeds goedkeuring vereist.',
    'No instructions of its own. It follows its Skills.':
      'Heeft geen eigen instructies. Volgt de Vaardigheden.',
    'Pin a Skill': 'Een vaardigheid vastmaken',
    'Finds the Skills that fit each run, the same way a chat does.':
      'Zoekt voor elke uitvoering passende Vaardigheden, net als een chat.',
    'Skills it always follows': 'Vaardigheden die altijd worden gevolgd',
    'A Skill that is not published': 'Een niet-gepubliceerde vaardigheid',
    'Always follows · Version {value1}': 'Volgt altijd · versie {value1}',
    'Not published': 'Niet gepubliceerd',
    Uses: 'Gebruikt',
    'Change in chat': 'Wijzigen in chat',
    'Change in chat: Uses': 'Wijzigen in chat: Gebruikt',
    'Company knowledge and the tools each run is allowed to use.':
      'Bedrijfskennis en de tools die elke uitvoering mag gebruiken.',
    'People see the Result refresh; they change the agent, not the page.':
      'Gebruikers zien dat het Resultaat wordt vernieuwd; ze wijzigen de agent, niet de pagina.',
    'The first run after it is created makes the Result; later runs add a version to it.':
      'De eerste uitvoering nadat deze is gemaakt, maakt het Resultaat; latere uitvoeringen voegen er een versie aan toe.',
    'Emails whoever the run is for': 'Stuurt een e-mail naar degene voor wie de uitvoering is',
    'Email each run': 'Elke uitvoering e-mailen',
    Delivers: 'Levert',
    'Change what it delivers': 'Wijzigen wat deze oplevert',
    'Expected result': 'Verwacht resultaat',
    'What a successful run should deliver.': 'Wat een geslaagde uitvoering moet opleveren.',
    'What each run delivers': 'Wat elke uitvoering oplevert',
    'Keeps one Result up to date {value1}': 'Houdt één Resultaat actueel {value1}',
    'Saves a new Result each run': 'Slaat bij elke uitvoering een nieuw Resultaat op',
    'You can run this company agent as yourself.{value1} {value2}':
      'Je kunt deze bedrijfsagent namens jezelf uitvoeren.{value1} {value2}',
    'Changes since version': 'Wijzigingen sinds versie',
    'are not live yet.': 'zijn nog niet actief.',
    'Review them in Versions': 'Bekijk ze in Versies',
    Skill: 'Vaardigheid',
    'The agent always uses the Skill’s published version.':
      'De agent gebruikt altijd de gepubliceerde versie van de vaardigheid.',
    Day: 'Dag',
    Time: 'Tijd',
    'Cron expression': 'Cron-expressie',
    'Editors and access': 'Editors en toegang',
    Company: 'Bedrijf',
    Personal: 'Persoonlijk',
    'No changes.': 'Geen wijzigingen.',
    'Instructions changes': 'Wijzigingen in instructies',
    'Loading versions…': 'Versies worden geladen…',
    'What the draft changes': 'Wat het concept wijzigt',
    'No published version yet. Try the draft, then publish it.':
      'Er is nog geen gepubliceerde versie. Probeer het concept en publiceer het daarna.',
    'Published versions': 'Gepubliceerde versies',
    'Former member': 'Voormalig lid',
    Live: 'Actief',
    Note: 'Notitie',
    Saved: 'Opgeslagen',
    Total: 'Totaal',
    ascending: 'oplopend',
    descending: 'aflopend',
    'Scroll to see all columns': 'Scroll om alle kolommen te zien',
    '{value1} for {value2}': '{value1} voor {value2}',
    Suggested: 'Voorgesteld',
    'Opening your conversation…': 'Je gesprek wordt geopend…',
    'This conversation isn’t available': 'Dit gesprek is niet beschikbaar',
    'It may have been deleted, belong to another account, or be temporarily unavailable.':
      'Het is mogelijk verwijderd, behoort tot een ander account of is tijdelijk niet beschikbaar.',
    '{count} more line — shown in the complete revision':
      '{count} extra regel — weergegeven in de volledige revisie',
    '{count} more lines — shown in the complete revision':
      '{count} extra regels — weergegeven in de volledige revisie',
    '{count} more line removed': '{count} extra regel verwijderd',
    '{count} more lines removed': '{count} extra regels verwijderd',
    '{count} unchanged line': '{count} ongewijzigde regel',
    '{count} unchanged lines': '{count} ongewijzigde regels',
    '{count} more lines not shown, {added} added and {removed} removed. Check them in the complete revision.':
      '{count} extra regels niet weergegeven, {added} toegevoegd en {removed} verwijderd. Bekijk ze in de volledige revisie.',
    'Saved result': 'Opgeslagen resultaat',
    'Made with a Skill': 'Gemaakt met een vaardigheid',
    'Preview of {name}': 'Voorbeeld van {name}',
    'Made with {name}': 'Gemaakt met {name}',
    'Ad-hoc result': 'Ad-hocresultaat',
    'A Skill that is not available in this workspace':
      'Een vaardigheid die niet beschikbaar is in deze werkruimte',
    '{name} · Revision {version}': '{name} · Revisie {version}',
    '{name} · Version {version}': '{name} · Versie {version}',
    'Return to conversation {value1}': 'Terug naar gesprek {value1}',
    '{value1} Working with {value2}': '{value1} werkt met {value2}',
    'View context {value1}': 'Context bekijken {value1}',
    'A way of working, made yours.': 'Een manier van werken, helemaal van jou.',
    'Work that runs itself.': 'Werk dat zichzelf uitvoert.',
    'One place for one piece of work.': 'Eén plek voor één stuk werk.',
    'Let’s move your work forward{value1}.': 'Laten we je werk vooruithelpen{value1}.',
    'Describe the work. Your Skill takes shape beside the conversation.':
      'Beschrijf het werk. Je vaardigheid krijgt vorm naast het gesprek.',
    'Describe what it should do and when. Your agent takes shape beside the conversation. The draft does not run automatically.':
      'Beschrijf wat het moet doen en wanneer. Je agent krijgt vorm naast het gesprek. Het concept wordt niet automatisch uitgevoerd.',
    'Say what the work is. Poneva drafts the project beside the conversation and brings in what you have already done. Nothing is created until you say so.':
      'Beschrijf waar het werk over gaat. Poneva maakt naast het gesprek een concept van het project en voegt toe wat je al hebt gedaan. Er wordt niets gemaakt totdat je dat aangeeft.',
    'Start with an idea below. Poneva will take it from there.':
      'Begin hieronder met een idee. Poneva doet de rest.',
    Triggers: 'Triggers',
    'Review the agent and its trigger. Approval applies exactly what is shown.':
      'Controleer de agent en de trigger. Goedkeuring past precies toe wat wordt weergegeven.',
    '{source} · read {date}': '{source} · gelezen op {date}',
    'Evidence is being recorded · read {date}': 'Bewijs wordt vastgelegd · gelezen op {date}',
    'Evidence expired on {date} under the retention policy':
      'Bewijs is op {date} verlopen volgens het bewaarbeleid',
    'Entered by {person}': 'Ingevoerd door {person}',
    'No retained evidence for this value': 'Geen bewaard bewijs voor deze waarde',
    'Covers {shown} of {total} rows': 'Omvat {shown} van {total} rijen',
    'Search rows': 'Rijen zoeken',
    'Clear filters': 'Filters wissen',
    Sort: 'Sorteren',
    'Sort: {column}': 'Sorteren: {column}',
    '{shown} of {total} rows': '{shown} van {total} rijen',
    More: 'Meer',
    Density: 'Dichtheid',
    Comfortable: 'Ruim',
    Compact: 'Compact',
    Columns: 'Kolommen',
    'No rows match. Clear the search or filters to see them again.':
      'Geen rijen gevonden. Wis de zoekopdracht of filters om ze opnieuw te bekijken.',
    'Not available': 'Niet beschikbaar',
    'All rows': 'Alle rijen',
    'Close row detail': 'Rijdetails sluiten',
    'Ask about this row': 'Vraag over deze rij stellen',
    'Add note': 'Notitie toevoegen',
    'Connection removed': 'Verbinding verwijderd',
    'Query time limit changed': 'Limiet voor querytijd gewijzigd',
    '{count} row': '{count} rij',
    '{count} rows': '{count} rijen',
    'This source is no longer available. Company knowledge now lives in Knowledge pages, and files stay in the Library.':
      "Deze bron is niet langer beschikbaar. Bedrijfskennis staat nu op kennispagina's en bestanden blijven in de Bibliotheek.",
    App: 'App',
    Artifact: 'Artefact',
    'New project': 'Nieuw project',
    'Review request': 'Beoordelingsverzoek',
    Activity: 'Activiteit',
    'Voice preview': 'Spraakvoorbeeld',
    Source: 'Bron',
    File: 'Bestand',
    Meeting: 'Vergadering',
    'Knowledge page': 'Kennispagina',
    'Could not preview this CSV.': 'Er kon geen voorbeeld van dit CSV-bestand worden weergegeven.',
    'File content is unavailable.': 'De bestandsinhoud is niet beschikbaar.',
    'You have five open suggestions here. {value1} will see them.':
      'Je hebt hier vijf open suggesties. {value1} kan ze zien.',
    'We could not send your suggestion. Please try again.':
      'We konden je suggestie niet verzenden. Probeer het opnieuw.',
    'The agent': 'De agent',
    'Selected colleagues': "Geselecteerde collega's",
    'The owner': 'De eigenaar',
    'Forked. This copy is yours and runs with your own connections.':
      'Kopie gemaakt. Deze is van jou en gebruikt je eigen verbindingen.',
    'This chat is too long to fork.': 'Deze chat is te lang om te kopiëren.',
    'We could not fork this chat. Please try again.':
      'We konden geen kopie van deze chat maken. Probeer het opnieuw.',
    'Anyone who forked it keeps their copy: forks stay with the people who made them.':
      'Iedereen die een kopie heeft gemaakt, houdt die kopie: kopieën blijven bij de mensen die ze hebben gemaakt.',
    'Nobody has forked this chat.': 'Niemand heeft een kopie van deze chat gemaakt.',
    '1 person forked this chat. Their copy stays theirs.':
      '1 persoon heeft een kopie van deze chat gemaakt. Hun kopie blijft van hen.',
    '{value1} people forked this chat. Their copies stay theirs.':
      '{value1} mensen hebben een kopie van deze chat gemaakt. Hun kopieën blijven van hen.',
    'Personal. Nobody else sees it.': 'Persoonlijk. Niemand anders kan dit zien.',
    'People you pick. They get it in their Inbox.':
      'De mensen die je kiest. Zij krijgen dit in hun Inbox.',
    'Everyone in the company can follow it and fork it.':
      'Iedereen in het bedrijf kan dit volgen en er een kopie van maken.',
    'a chat you can no longer open': 'een chat die je niet meer kunt openen',
    'shared the Result': 'deelde het resultaat',
    'updated the Result': 'werkte het resultaat bij',
    'published the Skill': 'publiceerde de vaardigheid',
    'approved the fact': 'keurde het feit goed',
    'added the fact': 'voegde het feit toe',
    'added the meeting': 'voegde de vergadering toe',
    'published the page': 'publiceerde de pagina',
    'updated the page': 'werkte de pagina bij',
    'shared the chat': 'deelde de chat',
    'published a version of': 'publiceerde een versie van',
    ran: 'voerde uit',
    Knowledge: 'Kennis',
    Meetings: 'Vergaderingen',
    Chat: 'Chat',
    Use: 'Gebruiken',
    Open: 'Openen',
    You: 'Jij',
    Someone: 'Iemand',
    'published version {version} of': 'publiceerde versie {version} van',
    'thing needs': 'item vereist',
    'things need': 'items vereisen',
    'Published Skill': 'Gepubliceerde vaardigheid',
    'Included with Skill': 'Inbegrepen bij vaardigheid',
    'Already attached': 'Al toegevoegd',
    'Also available in company knowledge': 'Ook beschikbaar in bedrijfskennis',
    'Company file': 'Bedrijfsbestand',
    'Account identity unavailable': 'Accountidentiteit niet beschikbaar',
    'Access expired or was revoked. Reconnect to continue.':
      'Toegang verlopen of ingetrokken. Maak opnieuw verbinding om door te gaan.',
    'Account authorized · tools unavailable': 'Account geautoriseerd · tools niet beschikbaar',
    'Not available in this workspace yet.': 'Nog niet beschikbaar in deze werkruimte.',
    'Everyone in the company': 'Iedereen in het bedrijf',
    'Audience: only you.': 'Doelgroep: alleen jij.',
    'Audience: everyone in the company.': 'Doelgroep: iedereen in het bedrijf.',
    'tool is': 'tool is',
    'tools are': 'tools zijn',
    'account is': 'account is',
    'accounts are': 'accounts zijn',
    'We could not upload this file.': 'We konden dit bestand niet uploaden.',
    'file was': 'bestand is',
    'files were': 'bestanden zijn',
    'Your company': 'Je bedrijf',
    'Create an agent': 'Agent maken',
    'Give recurring work a helping hand': 'Geef terugkerend werk een handje',
    'Create a Skill': 'Vaardigheid maken',
    'Save a reusable way of working': 'Een herbruikbare werkwijze opslaan',
    'Take meeting notes': 'Notulen maken',
    'Capture decisions and next steps': 'Besluiten en vervolgstappen vastleggen',
    'Work with a file': 'Met een bestand werken',
    'Start from a document or image': 'Begin met een document of afbeelding',
    'Browse agents': 'Agents bekijken',
    'Open your agents and company agents': 'Je agents en bedrijfsagents openen',
    'Review results': 'Resultaten bekijken',
    'Return to work saved in your Library': 'Terug naar werk dat in je bibliotheek is opgeslagen',
    'For review': 'Ter beoordeling',
    'An agent': 'Een agent',
    Assistant: 'Assistent',
    'Kept up to date by {value1}{value2}': 'Bijgewerkt door {value1}{value2}',
    ', {value1}': ', {value1}',
    'Version {value1}{value2}{value3}': 'Versie {value1}{value2}{value3}',
    'Refreshed by its agent': 'Bijgewerkt door de bijbehorende agent',
    'Saved from a chat': 'Opgeslagen vanuit een chat',
    'Saved from {value1}': 'Opgeslagen vanuit {value1}',
    Edited: 'Bewerkt',
    'private account': 'privéaccount',
    '{value1} ({value2})': '{value1} ({value2})',
    '{value1}’s {value2}': '{value2} van {value1}',
    'Made private. The person who added it and the owner of its recording have been told in their Inbox.':
      'Privé gemaakt. De persoon die het heeft toegevoegd en de eigenaar van de opname zijn hierover geïnformeerd in hun Inbox.',
    'Made private. The person who added it has been told in their Inbox.':
      'Privé gemaakt. De persoon die het heeft toegevoegd, is hierover geïnformeerd in diens Inbox.',
    'Made private. The owner of its recording has been told in their Inbox.':
      'Privé gemaakt. De eigenaar van de opname is hierover geïnformeerd in diens Inbox.',
    'Selected passage': 'Geselecteerde passage',
    '{value1} {value2}': '{value1} {value2}',
    'Upload a file': 'Een bestand uploaden',
    'Help me create a useful report from our company knowledge and available sources.':
      'Help me een nuttig rapport te maken op basis van onze bedrijfskennis en beschikbare bronnen.',
    'This saved work couldn’t be opened. Open it again to retry.':
      'Dit opgeslagen werk kon niet worden geopend. Open het opnieuw om het nogmaals te proberen.',
    '{value1}’s': 'Van {value1}',
    '{value1} chat “{value2}”': 'Chat van {value1}: “{value2}”',
    '{value1}{value2}': '{value1}{value2}',
    'Skill: {value1}{value2}': 'Vaardigheid: {value1}{value2}',
    'Result “{value1}”': 'Resultaat “{value1}”',
    'Meeting “{value1}”': 'Vergadering “{value1}”',
    'Used in {value1} {value2} this week': 'Deze week gebruikt in {value1} {value2}',
    '{value1} {value2} · used in {value3} {value4}':
      '{value1} {value2} · gebruikt in {value3} {value4}',
    'The draft is not published yet, so no one else follows it.':
      'Het concept is nog niet gepubliceerd, dus niemand anders volgt het.',
    'Use it in a chat for current data, or refine the Skill first.':
      'Gebruik het in een chat voor actuele gegevens of verfijn de vaardigheid eerst.',
    'An agent keeps this up to date. Continue the work in chat.':
      'Een agent houdt dit up-to-date. Ga verder in de chat.',
    'Edit it here, or continue the work in chat.': 'Bewerk het hier of ga verder in de chat.',
    'Duplicate it to your Library, or continue the work in chat.':
      'Dupliceer het naar je bibliotheek of ga verder in de chat.',
    'Download Markdown': 'Markdown downloaden',
    'Download CSV': 'CSV downloaden',
    'an agent': 'een agent',
    'Publish a Skill version': 'Een versie van een vaardigheid publiceren',
    'Share with {value1}': 'Delen met {value1}',
    'Update company content': 'Bedrijfsinhoud bijwerken',
    Approved: 'Goedgekeurd',
    Declined: 'Afgewezen',
    Pending: 'In behandeling',
    'View decision': 'Besluit bekijken',
    'No data': 'Geen gegevens',
    'No change': 'Geen wijziging',
    'Connection created': 'Verbinding gemaakt',
    'Sharing changed': 'Deelinstellingen gewijzigd',
    'Person added': 'Persoon toegevoegd',
    'Person removed': 'Persoon verwijderd',
    'Access changed': 'Toegang gewijzigd',
    'Access turned off': 'Toegang uitgeschakeld',
    '· {value1} by {value2}': '· {value1} door {value2}',
    '· version {value1}': '· versie {value1}',
    '{message} {count} earlier file was saved and attached.':
      '{message} {count} eerder bestand is opgeslagen en bijgevoegd.',
    '{message} {count} earlier files were saved and attached.':
      '{message} {count} eerdere bestanden zijn opgeslagen en bijgevoegd.',
    '{message} {count} earlier file was saved.': '{message} {count} eerder bestand is opgeslagen.',
    '{message} {count} earlier files were saved.':
      '{message} {count} eerdere bestanden zijn opgeslagen.',
    'refreshed {time}': 'bijgewerkt {time}',
    'a colleague': 'een collega',
    'Your chat “{title}”': 'Je chat “{title}”',
    '{name}’s chat “{title}”': 'De chat van {name} “{title}”',
    'Kept up to date by {name}{version}': 'Bijgehouden door {name}{version}',
    'Skill: {name}{version}': 'Vaardigheid: {name}{version}',
    'Result “{title}”': 'Resultaat “{title}”',
    'Meeting “{title}”': 'Vergadering “{title}”',
    'Used in {count} answer this week': 'Deze week gebruikt in {count} antwoord',
    'Used in {count} answers this week': 'Deze week gebruikt in {count} antwoorden',
    '{count} source': '{count} bron',
    '{count} sources': '{count} bronnen',
    'used in {count} place': 'gebruikt op {count} plek',
    'used in {count} places': 'gebruikt op {count} plekken',
    '{company} workspace': '{company}-werkruimte',
    '{count} page': '{count} pagina',
    '{count} pages': "{count} pagina's",
    '{needs} · reviews and approvals': '{needs} · beoordelingen en goedkeuringen',
    '{count} thing needs you': '{count} item heeft je aandacht nodig',
    '{count} things need you': '{count} items hebben je aandacht nodig',
    'Included with Skill · {files} · {sources} {icon}':
      'Inbegrepen bij vaardigheid · {files} · {sources} {icon}',
    '{count} file': '{count} bestand',
    '{count} files': '{count} bestanden',
    Today: 'Vandaag',
    'Earlier this week': 'Eerder deze week',
    '{count} slide': '{count} dia',
    '{count} slides': "{count} dia's",
    Early: 'Vroeg',
    'TLS verified': 'TLS geverifieerd',
    'Made personal and switched off. Switch it on when you are ready.':
      'Persoonlijk gemaakt en uitgeschakeld. Schakel het in wanneer je klaar bent.',
    'Made personal and switched off. Its owner is told which version is live.':
      'Persoonlijk gemaakt en uitgeschakeld. De eigenaar krijgt te horen welke versie live is.',
    'Switched off.': 'Uitgeschakeld.',
    'Applied version {revision}.': 'Versie {revision} toegepast.',
    'The draft is running in a chat only you can read.':
      'Het concept draait in een chat die alleen jij kunt lezen.',
    'Publish a version first.': 'Publiceer eerst een versie.',
    'Another Agent action is in progress.': 'Er is al een andere Agent-actie bezig.',
    'Knowledge & connections': 'Kennis en verbindingen',
    'Pinned Skills': 'Vastgezette vaardigheden',
    None: 'Geen',
    'A new Result each run': 'Een nieuw resultaat bij elke uitvoering',
    'One Result kept up to date': 'Eén resultaat dat up-to-date wordt gehouden',
    Email: 'E-mail',
    On: 'Aan',
    Off: 'Uit',
    'Waiting for review': 'Wacht op beoordeling',
    Outdated: 'Verouderd',
    Accepted: 'Geaccepteerd',
    Rejected: 'Afgewezen',
    Withdrawn: 'Ingetrokken',
    Replaced: 'Vervangen',
    'Suggested edit': 'Voorgestelde bewerking',
    'Suggested new page': 'Voorgestelde nieuwe pagina',
    'Suggested move': 'Voorgestelde verplaatsing',
    'Suggested archive': 'Voorgestelde archivering',
    'Checking status…': 'Status wordt gecontroleerd…',
    'Status unavailable': 'Status niet beschikbaar',
    'Bulleted list': 'Lijst met opsommingstekens',
    'Numbered list': 'Genummerde lijst',
    'Web link': 'Weblink',
    Read: 'Lezen',
    Write: 'Schrijven',
    'shared with you': 'met je gedeeld',
    'Getting an answer': 'Een antwoord ophalen',
    '{name} is getting an answer': '{name} haalt een antwoord op',
    'We could not save. Please try again.': 'We konden dit niet opslaan. Probeer het opnieuw.',
    'The new page could not be created.': 'De nieuwe pagina kon niet worden gemaakt.',
    'We could not load this revision.': 'We konden deze revisie niet laden.',
    'We could not restore this revision. Please try again.':
      'We konden deze revisie niet herstellen. Probeer het opnieuw.',
    'We could not export this revision.': 'We konden deze revisie niet exporteren.',
    'We could not open this suggestion.': 'We konden deze suggestie niet openen.',
    'We could not do that. Please try again.': 'Dat konden we niet doen. Probeer het opnieuw.',
    'We could not save your decision. Please try again.':
      'We konden je beslissing niet opslaan. Probeer het opnieuw.',
    'We could not restore this page. Please try again.':
      'We konden deze pagina niet herstellen. Probeer het opnieuw.',
    'We could not export this page.': 'We konden deze pagina niet exporteren.',
    '{count} missed time merged.': '{count} gemiste tijd samengevoegd.',
    '{count} missed times merged.': '{count} gemiste tijden samengevoegd.',
    'About this project': 'Over dit project',
  },
  et: {
    context: 'kontekst',
    skills: 'oskused',
    'Choose company context': 'Vali ettevõtte kontekst',
    'Skills for this conversation': 'Selle vestluse oskused',
    'Bring context into the conversation': 'Too kontekst vestlusse',
    'Close context picker': 'Sulge konteksti valija',
    'Filter company context': 'Filtreeri ettevõtte konteksti',
    'Find a Skill…': 'Leia oskus…',
    'Find a file…': 'Leia fail…',
    'Available company context': 'Saadaolev ettevõtte kontekst',
    'No matching published Skills.': 'Sobivaid avaldatud oskusi ei leitud.',
    'No matching files.': 'Sobivaid faile ei leitud.',
    'Searching company work…': 'Ettevõtte töö otsimine…',
    'Try search again': 'Proovi uuesti otsida',
    'Meaning search is temporarily limited. Showing available text matches.':
      'Tähenduspõhine otsing on ajutiselt piiratud. Kuvatakse saadaolevad tekstivasted.',
    'Load more matches': 'Laadi rohkem vasteid',
    '{value1} files attached. Remove an attachment to add another. Saved Skill references are included separately.':
      'Manustatud on {value1} faili. Teise lisamiseks eemalda mõni manus. Salvestatud oskuste viited lisatakse eraldi.',
    'Create a Skill in chat': 'Loo vestluses oskus',
    'Upload a company file': 'Laadi üles ettevõtte fail',
    'Company knowledge is always available to Poneva.':
      'Ettevõtte teadmised on Ponevale alati kättesaadavad.',
    '{value1} was not connected': '{value1} ei ühendatud',
    Dismiss: 'Loobu',
    'Try connecting again': 'Proovi uuesti ühendada',
    Waiting: 'Ootamine',
    Connected: 'Ühendatud',
    'Needs reconnecting': 'Vajab uuesti ühendamist',
    Connect: 'Ühenda',
    '{value1}{value2} The provider’s account permissions still apply.':
      '{value1}{value2} Teenusepakkuja kontoõigused kehtivad endiselt.',
    'Last error: {value1}': 'Viimane tõrge: {value1}',
    '{value1} {value2} ready.': '{value1} {value2} on valmis.',
    'Continue with my Meta app': 'Jätka minu Meta rakendusega',
    Reconnect: 'Ühenda uuesti',
    Disconnect: 'Katkesta ühendus',
    'Remove attachment: {value1}': 'Eemalda manus: {value1}',
    'Saved in this Skill. Edit the Skill to change its references.':
      'Salvestatud sellesse oskusse. Viidete muutmiseks muuda oskust.',
    'Remove Skill context': 'Eemalda oskuse kontekst',
    Refining: 'Täiustamine',
    Previewing: 'Eelvaade',
    Using: 'Kasutamine',
    'Skill revision {value1}': 'Oskuse versioon {value1}',
    'a new Skill': 'uus oskus',
    '{value1} Making a new agent {value2}': '{value1} Uue agendi {value2} loomine',
    'Stop making a new agent in this chat': 'Lõpeta selles vestluses uue agendi loomine',
    'Saved Skill references': 'Salvestatud oskuste viited',
    'Included with Skill · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}':
      'Oskusega kaasas · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}',
    'Selected Skill revision is unavailable. Select the Skill again to view its saved references.':
      'Valitud oskuse versioon pole saadaval. Salvestatud viidete vaatamiseks vali oskus uuesti.',
    'Conversation attachments': 'Vestluse manused',
    'Added for this conversation': 'Selle vestluse jaoks lisatud',
    'Selected passage {value1}': 'Valitud lõik {value1}',
    'We could not load your workspace.': 'Me ei saanud sinu tööruumi laadida.',
    'The selected Skill is unavailable. Check its access or choose it again.':
      'Valitud oskus pole saadaval. Kontrolli selle juurdepääsu või vali see uuesti.',
    'Source saved privately and included in your knowledge search.':
      'Allikas salvestati privaatselt ja lisati sinu teadmiste otsingusse.',
    'File saved privately to your library and attached to this message.':
      'Fail salvestati privaatselt sinu teeki ja manustati sellele sõnumile.',
    'File saved privately to your library.': 'Fail salvestati privaatselt sinu teeki.',
    '{value1} {value2} earlier {value3} saved{value4}.':
      '{value1} {value2} varem {value3} salvestatud{value4}.',
    'Extracted text for Poneva to read. Download the original for its layout, charts and images. Spreadsheet formulas show their saved results and are not recalculated.':
      'Poneva jaoks lugemiseks eraldatud tekst. Paigutuse, diagrammide ja piltide säilitamiseks laadi alla originaal. Arvutustabeli valemid näitavad salvestatud tulemusi ja neid ei arvutata uuesti.',
    Esc: 'Esc',
    'Start something': 'Alusta millegagi',
    'Choose a file to work with': 'Vali fail, millega töötada',
    'Skills worth adding': 'Lisamist väärivad oskused',
    'Picked for you': 'Sulle valitud',
    'Reusable work grounded in your company knowledge.':
      'Taaskasutatav töö, mis põhineb sinu ettevõtte teadmistel.',
    'Ideas from your company context and recent work. Pick one to start.':
      'Ideed sinu ettevõtte konteksti ja hiljutise töö põhjal. Alustamiseks vali üks.',
    'Refresh suggested tasks': 'Värskenda soovitatud ülesandeid',
    'Check for new company context.': 'Kontrolli uut ettevõtte konteksti.',
    'Check for new context. Ideas also refresh daily.':
      'Kontrolli uut konteksti. Ideed värskenduvad samuti iga päev.',
    Refresh: 'Värskenda',
    'Finding useful starting points…': 'Kasulike lähtekohtade otsimine…',
    'Suggestions aren’t available right now. Try Refresh, or describe the work you want to do.':
      'Soovitused pole praegu saadaval. Proovi värskendada või kirjelda tööd, mida soovid teha.',
    'Loading the knowledge pages…': 'Teadmiste lehtede laadimine…',
    '{value1} All pages': '{value1} Kõik lehed',
    'The page is created.': 'Leht on loodud.',
    'Your new page is suggested. A publisher decides whether it is added.':
      'Sinu uus leht on esitatud soovitusena. Avaldaja otsustab, kas see lisatakse.',
    'Company knowledge': 'Ettevõtte teadmised',
    'What Poneva knows about your company, page by page. Every change is kept.':
      'Mida Poneva sinu ettevõtte kohta teab, lehekülg lehekülje haaval. Kõik muudatused säilitatakse.',
    'Loading company knowledge…': 'Ettevõtte teadmiste laadimine…',
    'Knowledge pages are not enabled in this workspace.':
      'Teadmiste lehed pole selles tööruumis lubatud.',
    'Ask your Poneva contact to switch them on for your company.':
      'Palu oma Poneva kontaktisikul need oma ettevõtte jaoks sisse lülitada.',
    '{value1} Change the agent': '{value1} Muuda agenti',
    '{value1} Continue in chat': '{value1} Jätka vestluses',
    'We could not load this item.': 'Seda üksust ei saanud laadida.',
    '{value1} canvas': '{value1} lõuend',
    'Loading {value1}…': '{value1} laadimine…',
    '{value1} · Original retained': '{value1} · Algne säilitati',
    '{value1} {value2}{value3} · Added {value4}': '{value1} {value2}{value3} · Lisatud {value4}',
    '{value1} Use in chat': '{value1} Kasuta vestluses',
    '{value1} Download': '{value1} Laadi alla',
    Table: 'Tabel',
    Chart: 'Diagramm',
    Original: 'Algne',
    'Text extracted from the PDF, marked by page. Download the original for its layout and images.':
      'PDF-ist eraldatud tekst on lehekülgede kaupa märgistatud. Paigutuse ja piltide nägemiseks laadi alla algne fail.',
    'This preview shows the beginning of the file. Poneva reads the whole file; download the original to see all of it.':
      'See eelvaade näitab faili algust. Poneva loeb kogu faili; kõige nägemiseks laadi alla algne fail.',
    'Preview of the first {value1} complete rows. Filtering and charts use only this preview. Download the original for the full file.':
      'Esimese {value1} täieliku rea eelvaade. Filtreerimine ja diagrammid kasutavad ainult seda eelvaadet. Täieliku faili saamiseks laadi alla algne fail.',
    'This source link cannot be opened.': 'Seda allikalinki ei saa avada.',
    'Read-only chat': 'Kirjutuskaitstud vestlus',
    'Only {value1} writes in this chat. Fork it to continue with your own connections. {value2}':
      'Ainult {value1} saab selles vestluses kirjutada. Oma ühendustega jätkamiseks loo sellest haru. {value2}',
    'Suggest a follow-up…': 'Paku jätkuküsimus…',
    'Suggest a follow-up': 'Paku jätkuküsimus',
    'Sending…': 'Saatmine…',
    Send: 'Saada',
    'We could not dismiss that suggestion. Please try again.':
      'Seda soovitust ei saanud peita. Proovi uuesti.',
    'Suggested follow-ups': 'Soovitatud jätkuküsimused',
    '{value1} suggests': '{value1} soovitab',
    Ask: 'Küsi',
    'Dismiss {value1}’s suggestion': 'Peida kasutaja {value1} soovitus',
    'Suggested by': 'Soovitas',
    '· edit it or send it': '· muuda seda või saada',
    'Remove the suggestion tag': 'Eemalda soovituse silt',
    '{value1} {value2} is getting an answer': '{value1} {value2} saab vastust',
    '{value1} {value2} stopped the answer': '{value1} {value2} peatas vastuse',
    '{value1} Fork from here': '{value1} Loo siit haru',
    '{value1} From {value2}’s {value3}': '{value1} Kasutaja {value2} {value3}',
    'Only {value1} can use this account': 'Ainult {value1} saab seda kontot kasutada',
    '{value1} Suggested by {value2}': '{value1} Soovitas {value2}',
    'Fork this chat': 'Loo sellest vestlusest haru',
    'Forking…': 'Haru loomine…',
    Fork: 'Loo haru',
    'Could not make this private.': 'Privaatseks muutmine ei õnnestunud.',
    'Make this chat private?': 'Kas muuta see vestlus privaatseks?',
    Close: 'Sulge',
    '{value1} will see “{value2}”. Everyone else loses access right away {value3} .{value4}':
      '{value1} näeb „{value2}”. Kõik teised kaotavad kohe juurdepääsu {value3} .{value4}',
    Cancel: 'Loobu',
    'Saving…': 'Salvestamine…',
    'Make private': 'Muuda privaatseks',
    'This chat is private again. Forks others made stay theirs.':
      'See vestlus on taas privaatne. Teiste loodud harud jäävad neile.',
    'Who can read this chat: {value1}': 'Kes saavad seda vestlust lugeda: {value1}',
    'Move this chat': 'Teisalda see vestlus',
    'Only you write here. Others follow live and fork.':
      'Ainult sina kirjutad siin. Teised jälgivad otse ja loovad harusid.',
    'Made private. {value1} has been told in their Inbox.':
      'Muudeti privaatseks. {value1} sai sellest oma sisendkaustas teada.',
    'Chat access': 'Vestluse juurdepääs',
    '{value1}’s chat. As an admin you can make it private.':
      'Kasutaja {value1} vestlus. Administraatorina saad selle privaatseks muuta.',
    'Only {value1} will see it. {value2} is told.':
      'Seda näeb ainult {value1}. {value2} saab sellest teada.',
    '{value1} {value2} following': '{value1} {value2} jälgivad',
    'Forked from{value1} {value2} . The history is copied. From here, tools run with your own access.':
      'Hargnetud allikast{value1} {value2} . Vestluse ajalugu kopeeriti. Siit edasi töötavad tööriistad sinu juurdepääsuga.',
    '{value1} made this chat private': '{value1} muutis selle vestluse privaatseks',
    'You can no longer open it. Any fork you made stays yours.':
      'Sa ei saa seda enam avada. Kõik sinu loodud harud jäävad sulle.',
    'Start a new chat': 'Alusta uut vestlust',
    'Back to Recent chats': 'Tagasi hiljutiste vestluste juurde',
    'More chat actions': 'Veel vestluse toiminguid',
    'Close conversation sharing': 'Sulge vestluse jagamine',
    'Review the text before saving a private copy to Library. Then choose its audience. Your original conversation and future messages stay private.':
      'Vaata tekst enne privaatse koopia Teeki salvestamist üle. Seejärel vali selle sihtrühm. Sinu algne vestlus ja tulevased sõnumid jäävad privaatseks.',
    'Preparing the conversation…': 'Vestluse ettevalmistamine…',
    'Refresh preview': 'Värskenda eelvaadet',
    'The copy is saved in Library. Use Share to choose who can access it.':
      'Koopia on Teeki salvestatud. Kasuta jagamist, et valida, kellel on sellele juurdepääs.',
    'Save this copy': 'Salvesta see koopia',
    'That Skill could not be opened.': 'Seda oskust ei saanud avada.',
    '{value1}{value2} · reviews and approvals': '{value1}{value2} · ülevaatused ja kinnitamised',
    'Open Inbox': 'Ava sisendkaust',
    'New at {value1} this week': 'Sel nädalal on jaotises {value1} uut',
    'Nothing new this week. Shared work, published Skills and approved knowledge show up here.':
      'Sel nädalal pole midagi uut. Jagatud töö, avaldatud oskused ja kinnitatud teadmised kuvatakse siin.',
    'New at {value1}': 'Uut jaotises {value1}',
    'This Skill is unavailable. Try again.': 'See oskus pole saadaval. Proovi uuesti.',
    'You can attach up to {value1} files. Remove an attachment to add another.':
      'Saad manustada kuni {value1} faili. Uue lisamiseks eemalda mõni manus.',
    'Add company context': 'Lisa ettevõtte kontekst',
    'Add company context · @': 'Lisa ettevõtte kontekst · @',
    'Choose a Skill': 'Vali oskus',
    'Choose a Skill · /': 'Vali oskus · /',
    Edit: 'Muuda',
    '{value1} Edit with chat': '{value1} Muuda vestluses',
    '{value1} Duplicate to my Library': '{value1} Kopeeri minu teeki',
    'Duplicated to your Library. Only you can see the copy.':
      'Kopeeritud sinu teeki. Ainult sina näed koopiat.',
    'Could not duplicate this Result. Try again.':
      'Seda tulemust ei saanud kopeerida. Proovi uuesti.',
    'Saved version {value1}.': 'Versioon {value1} on salvestatud.',
    'A newer version was saved. Reload the Result before saving.':
      'Salvestati uuem versioon. Laadi tulemus enne salvestamist uuesti.',
    'Could not save this version. Try again.':
      'Seda versiooni ei saanud salvestada. Proovi uuesti.',
    '{value1} saved a newer version. Review it before saving.':
      '{value1} salvestas uuema versiooni. Vaata see enne salvestamist üle.',
    'Hide their version': 'Peida nende versioon',
    'Show their version': 'Näita nende versiooni',
    'Start from their version': 'Alusta nende versioonist',
    Markdown: 'Markdown',
    'Result text': 'Tulemuse tekst',
    Preview: 'Eelvaade',
    'What changed': 'Mis muutus',
    'What changed? (optional)': 'Mis muutus? (valikuline)',
    'Save version {value1}': 'Salvesta versioon {value1}',
    'Open chat': 'Ava vestlus',
    Current: 'Praegune',
    Restore: 'Taasta',
    'Could not load the history.': 'Ajalugu ei saanud laadida.',
    'Restored version {value1} as version {value2}.':
      'Versioon {value1} taastati versioonina {value2}.',
    'Someone saved a newer version. Review it before restoring.':
      'Keegi salvestas uuema versiooni. Vaata see enne taastamist üle.',
    'Could not restore that version.': 'Seda versiooni ei saanud taastada.',
    'Loading history…': 'Ajaloo laadimine…',
    'Restoring keeps what is there now as a version too, so nothing is lost.':
      'Taastamisel salvestatakse praegune sisu samuti versioonina, nii et midagi ei lähe kaotsi.',
    'This Result was made with your own {value1}.': 'See tulemus loodi sinu enda {value1} abil.',
    'It also used': 'See kasutas ka',
    'This Result was made with': 'See tulemus loodi järgmise abil:',
    'Colleagues can read what came from them, but can never use them.':
      'Kolleegid saavad lugeda neilt pärinevat sisu, kuid ei saa seda kunagi kasutada.',
    'Your personal agent {value1} keeps it up to date with your own access, so every refresh can carry your private data.':
      'Sinu isiklik agent {value1} hoiab seda sinu juurdepääsu abil ajakohasena, nii et iga värskendus võib sisaldada sinu privaatseid andmeid.',
    'A colleague’s personal agent keeps it up to date with their own access, so every refresh can carry their private data.':
      'Kolleegi isiklik agent hoiab seda tema juurdepääsu abil ajakohasena, nii et iga värskendus võib sisaldada tema privaatseid andmeid.',
    'Made private. Only you can see this meeting.':
      'Muudetud privaatseks. Ainult sina näed seda koosolekut.',
    'Could not make this meeting private.': 'Seda koosolekut ei saanud privaatseks muuta.',
    'Meeting · {value1} {value2} · Original retained':
      'Koosolek · {value1} {value2} · Algne säilitati',
    'The recording could not be opened.': 'Salvestist ei saanud avada.',
    'Ask about this suggestion': 'Küsi selle soovituse kohta',
    meeting_processing_failed: 'koosoleku töötlemine nurjus',
    'Who can see this': 'Kes seda näevad',
    'Everyone at {value1}': 'Kõik organisatsioonis {value1}',
    'Only me': 'Ainult mina',
    'Everyone at {value1} can find it and ask about it.':
      'Kõik organisatsioonis {value1} saavad selle üles leida ja selle kohta küsida.',
    'Only you can open and search this meeting. You can share it later.':
      'Ainult sina saad seda koosolekut avada ja otsida. Saad seda hiljem jagada.',
    'Added. Only you can see it. Transcription is running in the background.':
      'Lisatud. Ainult sina näed seda. Transkriptsioon töötab taustal.',
    'Visible to everyone at {value1}': 'Nähtav kõigile organisatsioonis {value1}',
    'Could not make it private.': 'Seda ei saanud privaatseks muuta.',
    'Show more meetings': 'Näita rohkem koosolekuid',
    'Attached to this message': 'Lisatud sellele sõnumile',
    'Connect securely, choose the tables to share, then decide whether Poneva can read or make changes.':
      'Loo turvaline ühendus, vali jagatavad tabelid ja otsusta, kas Poneva võib neid lugeda või muuta.',
    'Review the tables this connection can access. Select at least one table.':
      'Vaata üle tabelid, millele sellel ühendusel on juurdepääs. Vali vähemalt üks tabel.',
    'Select at least one table. Nothing is selected by default.':
      'Vali vähemalt üks tabel. Vaikimisi pole midagi valitud.',
    'Choose who can use this connection and what Poneva can do.':
      'Vali, kes saavad seda ühendust kasutada ja mida Poneva teha võib.',
    'Your chosen access is enabled for the selected tables.':
      'Sinu valitud juurdepääs on valitud tabelite jaoks lubatud.',
    'Your connection is saved with reading paused until permission is confirmed.':
      'Sinu ühendus on salvestatud ja lugemine on peatatud, kuni luba kinnitatakse.',
    'Confirm database disconnect': 'Kinnita andmebaasi ühenduse katkestamine',
    'Disconnect this database?': 'Kas katkestada selle andmebaasi ühendus?',
    'Access will stop for everyone using this connection.':
      'Juurdepääs katkeb kõigil, kes seda ühendust kasutavad.',
    'Keep connection': 'Säilita ühendus',
    'What it can reach · {value1}{value2} {value3}':
      'Millele sellel on juurdepääs · {value1}{value2} {value3}',
    Back: 'Tagasi',
    Continue: 'Jätka',
    'Uploading…': 'Üleslaadimine…',
    Library: 'Teek',
    'Source material for your work. Available whenever you need it.':
      'Sinu töö lähtematerjalid. Saadaval alati, kui neid vajad.',
    'The work you want to keep, with its sources and conversation attached.':
      'Töö, mida soovid alles hoida koos lisatud allikate ja vestlusega.',
    Results: 'Tulemused',
    Files: 'Failid',
    Artifacts: 'Artefaktid',
    'Search library': 'Otsi teegist',
    'Find files by meaning…': 'Leia faile tähenduse järgi…',
    'Find saved work by meaning…': 'Leia salvestatud tööd tähenduse järgi…',
    'Search coverage is limited while indexing or meaning-based search is unavailable. You can retry or browse recent items.':
      'Otsing on indekseerimise ajal või tähenduspõhise otsingu puudumisel piiratud. Võid uuesti proovida või sirvida hiljutisi üksusi.',
    'No matching work found.': 'Sobivat tööd ei leitud.',
    'A starting point for your next question.': 'Lähtekoht sinu järgmisele küsimusele.',
    'Good work is worth keeping.': 'Hea töö tasub alles hoida.',
    'Try a different description or clear the search to browse.':
      'Proovi teistsugust kirjeldust või sirvimiseks tühjenda otsing.',
    'Upload source material once and use it in conversations and Skills. Your original stays in the library.':
      'Laadi lähtematerjal üks kord üles ja kasuta seda vestlustes ning oskustes. Algne fail jääb teeki alles.',
    'Ask Poneva to save an answer, table or chart. Results stay connected to the conversation and their sources.':
      'Palu Poneval salvestada vastus, tabel või diagramm. Tulemused jäävad vestluse ja selle allikatega seotuks.',
    'Start in chat {value1}': 'Alusta vestluses {value1}',
    'Open result: {value1}': 'Ava tulemus: {value1}',
    'Loading more library items…': 'Teegiüksuste laadimine…',
    'Load more': 'Laadi rohkem',
    'Documents, transcripts, audio and video · Up to 500 MB per file. New files are private. Choose their audience with Share and which processable files become searchable company knowledge.':
      'Dokumendid, transkriptsioonid, heli ja video · Faili suurus kuni 500 MB. Uued failid on privaatsed. Vali jagamise kaudu nende sihtrühm ning see, millised töödeldavad failid muutuvad otsitavaks ettevõtte teadmiseks.',
    Skills: 'Oskused',
    'Create in chat': 'Loo vestluses',
    'Search Skills': 'Otsi oskusi',
    'Search finds published Skills. Clear the search to browse your drafts too.':
      'Otsing leiab avaldatud oskused. Kustuta otsing, et sirvida ka mustandeid.',
    'Search coverage is limited while indexing or meaning-based search is unavailable.':
      'Otsingu katvus on piiratud, kuni indekseerimine või tähenduspõhine otsing pole saadaval.',
    'Searching Skills…': 'Oskuste otsimine…',
    'No matching published Skills found. Try a different description.':
      'Sobivaid avaldatud oskusi ei leitud. Proovi teistsugust kirjeldust.',
    'Load more Skills': 'Laadi rohkem oskusi',
    'View Skill: {value1}': 'Vaata oskust: {value1}',
    'Company workspace': 'Ettevõtte tööruum',
    'View {value1}': 'Vaata {value1}',
    'Loading Skills…': 'Oskuste laadimine…',
    'Try again {value1}': 'Proovi uuesti {value1}',
    'Try again': 'Proovi uuesti',
    'Nothing yet.': 'Veel mitte midagi.',
    'Made from · Used by': 'Alus · Kasutajad',
    'Could not load links': 'Linke ei saanud laadida',
    'Made from': 'Alus',
    'Used by': 'Kasutajad',
    'About this chat {value1}': 'Teave selle vestluse kohta {value1}',
    'About this chat': 'Teave selle vestluse kohta',
    'Keep the work moving.': 'Hoia töö edenemas.',
    'Ask a follow-up with this result in view, or turn a useful approach into a company Skill.':
      'Esita täpsustav küsimus, hoides seda tulemust vaates, või muuda kasulik lähenemine ettevõtte oskuseks.',
    'Save approach as a Skill': 'Salvesta lähenemine oskusena',
    'Preview of': 'Eelvaade:',
    'Made with': 'Loodud koos',
    'Open the draft': 'Ava mustand',
    'Open Skill': 'Ava oskus',
    'Use in chat': 'Kasuta vestluses',
    'Finish the draft': 'Lõpeta mustand',
    'Refine this Skill': 'Täienda seda oskust',
    'Made with a Skill.': 'Loodud oskuse abil.',
    'This workspace could not be loaded just now, so that Skill cannot be opened yet. The result itself is unchanged.':
      'Seda tööruumi ei saanud praegu laadida, seega ei saa seda oskust veel avada. Tulemus ise on muutmata.',
    'That Skill is not available in this workspace, so it cannot be opened or used again. The result itself is unchanged.':
      'See oskus pole selles tööruumis saadaval, seega ei saa seda avada ega uuesti kasutada. Tulemus ise on muutmata.',
    'Result · {value1} {value2}': 'Tulemus · {value1} {value2}',
    '{value1} Copy link': '{value1} Kopeeri link',
    'Result link copied.': 'Tulemuse link on kopeeritud.',
    'Could not copy the link. Use your browser address bar.':
      'Linki ei saanud kopeerida. Kasuta brauseri aadressiriba.',
    'No preview is available for this result.': 'Selle tulemuse eelvaade pole saadaval.',
    '{value1} rows are retained in this snapshot. Open Table to inspect the values.':
      'Selles hetktõmmises on alles {value1} rida. Ava tabel väärtuste vaatamiseks.',
    'People can’t edit a Result an agent keeps up to date; the next refresh would replace their edit. Change the agent’s instructions instead.':
      'Inimesed ei saa muuta tulemust, mida agent ajakohasena hoiab, sest järgmine värskendus kirjutaks nende muudatuse üle. Muuda hoopis agendi juhiseid.',
    'Linked sources': 'Lingitud allikad',
    'Saved source': 'Salvestatud allikas',
    'No source documents are linked to this result. Company knowledge and other references may be cited in the answer.':
      'Selle tulemusega pole lingitud ühtegi lähtedokumenti. Vastuses võidakse viidata ettevõtte teadmistele ja muudele allikatele.',
    'Run details': 'Käivitamise üksikasjad',
    Created: 'Loodud',
    ', revised {value1}': ', muudetud {value1}',
    Conversation: 'Vestlus',
    'Not recorded': 'Ei salvestatud',
    'Open conversation': 'Ava vestlus',
    Run: 'Käivitus',
    Updates: 'Värskendused',
    'Kept up to date by {value1}': 'Ajakohasena hoiab {value1}',
    'Version {value1}': 'Versioon {value1}',
    'Could not open this request.': 'Seda taotlust ei saanud avada.',
    'Approved version published.': 'Kinnitatud versioon on avaldatud.',
    'Request rejected. The item stays unchanged.': 'Taotlus lükati tagasi. Üksus jääb muutmata.',
    'Could not save the decision.': 'Otsust ei saanud salvestada.',
    'Proposed company change': 'Ettevõtte muudatuse ettepanek',
    'Opening…': 'Avamine…',
    'Approve this version': 'Kinnita see versioon',
    Decline: 'Lükka tagasi',
    'Review the submitted version below. Changes made since submission will need a new request.':
      'Vaata allpool esitatud versioon üle. Pärast esitamist tehtud muudatuste jaoks tuleb esitada uus taotlus.',
    'The version submitted with this request.': 'Selle taotlusega esitatud versioon.',
    'Version and proposed change': 'Versioon ja muudatuse ettepanek',
    'Could not read the pinned content.': 'Kinnitatud sisu ei saanud lugeda.',
    'Showing a page of {value1} characters.': 'Kuvatakse {value1} märgi pikkune lehekülg.',
    'Beginning of the submitted content. Open the full text to review every page.':
      'Esitatud sisu algus. Ava täistekst, et kõik leheküljed üle vaadata.',
    'Read full submitted text': 'Loe esitatud täisteksti',
    'Previous page': 'Eelmine lehekülg',
    'Next page': 'Järgmine lehekülg',
    'Made private. Its creator has been told in their Inbox.':
      'Muudeti privaatseks. Selle loojat teavitati tema postkastis.',
    'Made private. Its creator could not be notified.':
      'Muudeti privaatseks. Selle loojat ei saanud teavitada.',
    'Make this {value1} private?': 'Kas muuta {value1} privaatseks?',
    'Only the person who created it will see it. Everyone else loses access right away, and its creator gets an Inbox update if they are still a company member. If they have left, nobody in the company will be able to access this item.':
      'Seda näeb ainult selle looja. Kõik teised kaotavad kohe juurdepääsu ning looja saab postkasti teavituse, kui ta on endiselt ettevõtte liige. Kui ta on lahkunud, ei pääse sellele üksusele ettevõttes keegi ligi.',
    'Sent for review. The current audience stays unchanged until approval.':
      'Saadetud ülevaatamiseks. Praegune sihtrühm jääb kinnitamiseni muutmata.',
    'This suggestion is no longer available to you.': 'See ettepanek pole sulle enam saadaval.',
    'We could not check where this suggestion stands.':
      'Me ei saanud kontrollida, milline on selle ettepaneku olek.',
    'Check again': 'Kontrolli uuesti',
    'Show on page': 'Kuva lehel',
    'The editor could not be loaded. Poneva may have been updated since you opened this page. Reload to get the latest version; nothing on this page has changed.':
      'Redaktorit ei saanud laadida. Ponevat võidi pärast selle lehe avamist värskendada. Uusima versiooni saamiseks laadi leht uuesti; sellel lehel pole midagi muutunud.',
    'Reload Poneva': 'Laadi Poneva uuesti',
    Formatting: 'Vormindus',
    'Text style': 'Teksti laad',
    Text: 'Tekst',
    Heading: 'Pealkiri',
    Subheading: 'Alampealkiri',
    'Link a page': 'Lingi leht',
    'A page needs a title.': 'Lehel peab olema pealkiri.',
    'Nothing has changed yet.': 'Midagi pole veel muutunud.',
    'A page needs some text. To remove a page, archive it instead.':
      'Lehel peab olema teksti. Lehe eemaldamiseks arhiveeri see.',
    'A suggested new page needs some text.': 'Soovitatud uuel lehel peab olema teksti.',
    'This page is larger than 256 KB. Split it into smaller pages.':
      'See leht on suurem kui 256 KB. Jaga see väiksemateks lehtedeks.',
    'Say in a few words why this change is right.': 'Ütle mõne sõnaga, miks see muudatus on õige.',
    'This page changed while you were editing. Your text is still here: copy it, then open the latest version and make your change again.':
      'See leht muutus redigeerimise ajal. Sinu tekst on endiselt alles: kopeeri see, ava uusim versioon ja tee muudatus uuesti.',
    'Your text is copied.': 'Sinu tekst on kopeeritud.',
    'Your text could not be copied. Select it in the editor and copy it.':
      'Sinu teksti ei saanud kopeerida. Vali see redaktoris ja kopeeri.',
    'The page “{value1}” is created.': 'Leht „{value1}” on loodud.',
    'New page': 'Uus leht',
    'Editing {value1}': '{value1} redigeerimine',
    Editing: 'Redigeerimine',
    'Creating publishes the page under {value1} for everyone':
      'Loomisel avaldatakse leht jaotises {value1} kõigile',
    'Saving publishes the new version for everyone':
      'Salvestamisel avaldatakse uus versioon kõigile',
    'Your changes are sent as a suggestion for a publisher':
      'Sinu muudatused saadetakse avaldajale ettepanekuna',
    'Create page': 'Loo leht',
    Save: 'Salvesta',
    'Send suggestion': 'Saada ettepanek',
    '{value1} Copy my text': '{value1} Kopeeri mu tekst',
    'Open the latest version': 'Ava uusim versioon',
    'Page title': 'Lehe pealkiri',
    'Loading the editor…': 'Redaktori laadimine…',
    'New page text': 'Uue lehe tekst',
    'Text of {value1}': '{value1} tekst',
    'Write the page. Type [[ to link another page.':
      'Kirjuta leht. Teise lehe linkimiseks sisesta [[.',
    'Type [[ to link another page.': 'Teise lehe linkimiseks sisesta [[.',
    'Link to a page': 'Lingi lehele',
    'What changed, in a few words': 'Mis muutus, mõne sõnaga',
    'Where this comes from, in a few words': 'Kust see pärineb, mõne sõnaga',
    'Shown in the page history.': 'Kuvatakse lehe ajaloos.',
    'A publisher sees this next to your change.': 'Avaldaja näeb seda sinu muudatuse kõrval.',
    '1 suggestion is open on this page': 'Sellel lehel on 1 avatud ettepanek',
    '{value1} suggestions are open on this page': 'Sellel lehel on avatud {value1} ettepanekut',
    'They stay open while you edit. After you save, they show against your new text; one whose words you changed is marked outdated.':
      'Need jäävad redigeerimise ajal avatuks. Pärast salvestamist kuvatakse need sinu uue teksti juures; ettepanek, mille sõnastust muutsid, märgitakse aegunuks.',
    'Type [[ to link another page. Links keep working when a page is renamed or moved.':
      'Teise lehe linkimiseks sisesta [[. Lingid toimivad ka siis, kui leht ümber nimetatakse või teisaldatakse.',
    'Loading the history…': 'Ajaloo laadimine…',
    'This page has no saved text yet.': 'Sellel lehel pole veel salvestatud teksti.',
    'Say in a few words why this revision should come back.':
      'Ütle mõne sõnaga, miks see redaktsioon tuleks taastada.',
    'Revision {value1} is suggested for a publisher to accept.':
      'Redaktsioon {value1} on soovitatud avaldajale kinnitamiseks.',
    'The page already reads like this revision.': 'Leht on juba selle redaktsiooniga samasugune.',
    'Revision {value1} is restored as revision {value2}.':
      'Redaktsioon {value1} taastati redaktsioonina {value2}.',
    'Revision history': 'Redaktsioonide ajalugu',
    Revisions: 'Redaktsioonid',
    'Every saved revision is kept.': 'Iga salvestatud redaktsioon säilitatakse.',
    'Revision {value1} {value2}': 'Redaktsioon {value1} {value2}',
    'Revision {value1} compared with revision {value2}':
      'Redaktsiooni {value1} võrdlus redaktsiooniga {value2}',
    'Revision {value1}, the first text of this page':
      'Redaktsioon {value1}, selle lehe esimene tekst',
    'Green was added, struck through was removed.':
      'Rohelisega on lisatud, läbikriipsutatult eemaldatud.',
    '{value1} Export Markdown': '{value1} Ekspordi Markdownina',
    'Restore this revision': 'Taasta see redaktsioon',
    'Suggest restoring it': 'Soovita selle taastamist',
    'Why should this revision come back?': 'Miks tuleks see redaktsioon taastada?',
    'Loading this revision…': 'Selle redaktsiooni laadimine…',
    'Only the title changed, from “{value1}” to “{value2}”.':
      'Muutus ainult pealkiri: „{value1}” asemel „{value2}”.',
    'The text did not change in this revision.': 'Selles redaktsioonis tekst ei muutunud.',
    'Changes in revision {value1}': 'Redaktsiooni {value1} muudatused',
    'Loading page…': 'Lehe laadimine…',
    'Loading suggestion…': 'Ettepaneku laadimine…',
    'This suggestion is not available.': 'See ettepanek pole saadaval.',
    'It may have been decided, or it is not one you can see.':
      'See võidi juba otsustada või pole see sulle nähtav.',
    'Open Knowledge': 'Ava Knowledge',
    'Opening the suggestion…': 'Ettepaneku avamine…',
    'Choose where the page goes.': 'Vali, kuhu leht paigutatakse.',
    'Say in a few words why.': 'Ütle mõne sõnaga, miks.',
    'Your suggestion is sent. A publisher decides.':
      'Sinu ettepanek on saadetud. Otsuse teeb avaldaja.',
    'Moved under {value1}.': 'Teisaldatud jaotise {value1} alla.',
    'Deleted “{value1}”.': '„{value1}” on kustutatud.',
    'Could not update sharing.': 'Jagamise värskendamine ebaõnnestus.',
    'They can follow new answers live and fork it to continue with their own connections. Only you write here. You can make it private again at any time.':
      'Nad saavad uusi vastuseid reaalajas jälgida ja selle oma ühendustega jätkamiseks harundada. Ainult sina saad siin kirjutada. Saad selle igal ajal taas privaatseks muuta.',
    'They see the project, its brief and the work in it they can already open. Nothing in it opens for anyone because of the project; each item keeps its own access.':
      'Nad näevad projekti, selle ülevaadet ja selles olevat tööd, mida nad saavad juba avada. Projekt ei ava kellelegi selles midagi; iga üksus säilitab oma juurdepääsu.',
    'Check the content for private information before sharing. Sharing an item does not grant access to its original chat or private connections.':
      'Enne jagamist kontrolli sisu privaatse teabe suhtes. Üksuse jagamine ei anna juurdepääsu selle algsele vestlusele ega privaatsetele ühendustele.',
    '{value1} Everyone you share with can read it, including what the assistant or an App in it found in your {value2}. They can’t use your {value3}. Nothing changes for you: the chat keeps working with all your accounts.':
      '{value1} Kõik, kellega seda jagad, saavad seda lugeda, sealhulgas seda, mida selles olev assistent või rakendus sinu {value2} leidis. Nad ei saa sinu {value3} kasutada. Sinu jaoks ei muutu midagi: vestlus töötab edasi kõigi sinu kontodega.',
    '{value1} Everyone you share with can read them, but nobody can use {value2} through this chat.':
      '{value1} Kõik, kellega neid jagad, saavad neid lugeda, kuid keegi ei saa selle vestluse kaudu kasutada {value2}.',
    'This controls access to the working draft. Any published company version stays available until you explicitly unpublish it. To publish a new version, complete its preview and use Save Skill. Run results stay private.':
      'See määrab juurdepääsu tööversioonile. Kõik avaldatud ettevõtte versioonid jäävad kättesaadavaks, kuni sa nende avaldamise selgesõnaliselt tühistad. Uue versiooni avaldamiseks lõpeta selle eelvaade ja vali „Salvesta oskus“. Käivitustulemused jäävad privaatseks.',
    'Skill deleted. You can restore it from the Skills archive for 30 days.':
      'Oskus kustutati. Saad selle 30 päeva jooksul Oskuste arhiivist taastada.',
    'Could not delete this Skill.': 'Seda oskust ei saanud kustutada.',
    'More actions': 'Veel toiminguid',
    'Delete “{value1}”? It will disappear from Skills and search, and cannot be used by agents. You can restore it for 30 days. Existing chats and results stay available.':
      'Kas kustutada „{value1}“? See kaob Oskustest ja otsingust ning agendid ei saa seda kasutada. Saad selle 30 päeva jooksul taastada. Olemasolevad vestlused ja tulemused jäävad kättesaadavaks.',
    'Deleting…': 'Kustutamine…',
    'Confirm delete': 'Kinnita kustutamine',
    'Delete Skill': 'Kustuta oskus',
    'Skill restored as an unpublished draft. Its author can review and publish it again.':
      'Oskus taastati avaldamata tööversioonina. Selle autor saab selle üle vaadata ja uuesti avaldada.',
    'Could not restore this Skill.': 'Seda oskust ei saanud taastada.',
    'Archived Skills': 'Arhiveeritud oskused',
    'Deleted Skills can be restored for 30 days. Restoring leaves them unpublished.':
      'Kustutatud oskusi saab 30 päeva jooksul taastada. Taastamisel jäävad need avaldamata.',
    'Restore until {value1}': 'Taasta kuni {value1}',
    'Loading…': 'Laadimine…',
    'No archived Skills.': 'Arhiveeritud oskusi pole.',
    'Load more archived Skills': 'Laadi rohkem arhiveeritud oskusi',
    'Show more of the original': 'Kuva rohkem algsest',
    'Filter result rows': 'Filtreeri tulemuseridu',
    'Find a product or value…': 'Leia toode või väärtus…',
    '{value1} of {value2}': '{value1} / {value2}',
    'Result table': 'Tabeli tulemused',
    'No matching rows.': 'Sobivaid ridu pole.',
    'Showing the first 1,000 matching rows. Download the CSV for every row.':
      'Kuvatakse esimesed 1000 sobivat rida. Kõigi ridade saamiseks laadi alla CSV.',
    'Agent ·': 'Agent ·',
    'Only you': 'Ainult sina',
    'Stopped before it finished.': 'Peatati enne lõpetamist.',
    'Drafting the project…': 'Projekti koostamine…',
    'Checking where this chat belongs…': 'Kontrollimine, kuhu see vestlus kuulub…',
    'Moving the chat…': 'Vestluse teisaldamine…',
    'Taking it out of the project…': 'Projektist eemaldamine…',
    'Adding it to the project…': 'Projekti lisamine…',
    'No matching connections are available right now.': 'Sobivaid ühendusi pole praegu saadaval.',
    'Company knowledge suggestion': 'Ettevõtte teadmiste soovitus',
    'Company knowledge now lives on pages. Open Knowledge to see them.':
      'Ettevõtte teadmised asuvad nüüd lehtedel. Nende vaatamiseks ava Teadmised.',
    '{value1} · Open beside this conversation': '{value1} · Ava selle vestluse kõrval',
    'Name {value1}': 'Nimi {value1}',
    'Host {value1}': 'Host {value1}',
    'Port {value1}': 'Port {value1}',
    'Database {value1}': 'Andmebaas {value1}',
    'Username {value1}': 'Kasutajanimi {value1}',
    'Password {value1}': 'Parool {value1}',
    'Advanced TLS': 'TLS-i täpsemad seaded',
    '{value1} Poneva verifies the server certificate. Add a CA or server DNS name for IP hosts when your certificate requires it.':
      '{value1} Poneva kontrollib serveri sertifikaati. IP-hostide puhul lisa CA või serveri DNS-nimi, kui sertifikaat seda nõuab.',
    'CA certificate {value1}': 'CA-sertifikaat {value1}',
    'Certificate server DNS name {value1}': 'Sertifikaadi serveri DNS-nimi {value1}',
    '{value1} Your password is encrypted in secure storage. Poneva verifies the connection before saving it.':
      '{value1} Sinu parool on turvalises hoidlas krüptitud. Poneva kontrollib ühendust enne selle salvestamist.',
    'Testing…': 'Testimine…',
    'Test connection': 'Testi ühendust',
    'PostgreSQL is connected.': 'PostgreSQL on ühendatud.',
    'PostgreSQL was saved safely.': 'PostgreSQL salvestati turvaliselt.',
    'Poneva can read and change rows in the selected tables. Apps also follow their approved data scope.':
      'Poneva saab valitud tabelitest ridu lugeda ja neid muuta. Rakendused järgivad samuti neile kinnitatud andmeulatust.',
    'Poneva can read the selected tables. Apps also follow their approved data scope.':
      'Poneva saab valitud tabelitest lugeda. Rakendused järgivad samuti neile kinnitatud andmeulatust.',
    'Reads are paused until permission is enabled.': 'Lugemine on peatatud, kuni luba lubatakse.',
    'Retrying…': 'Uuesti proovimine…',
    'Retry permission': 'Proovi luba uuesti',
    'Try it in Chat': 'Proovi vestluses',
    Done: 'Valmis',
    'Disconnect database': 'Katkesta andmebaasi ühendus',
    '{value1} TLS verified ·{value2} {value3}': '{value1} TLS kinnitatud ·{value2} {value3}',
    'Search schemas and tables': 'Otsi skeeme ja tabeleid',
    'Search tables': 'Otsi tabeleid',
    '{value1} of {value2} tables selected': 'Valitud on {value1} tabelit {value2}-st',
    'Select matching tables': 'Vali sobivad tabelid',
    'Select all tables': 'Vali kõik tabelid',
    Clear: 'Tühjenda',
    'Select a whole schema or individual tables. New tables need a fresh selection.':
      'Vali terve skeem või üksikud tabelid. Uued tabelid tuleb uuesti valida.',
    'No tables match this search.': 'Ükski tabel ei vasta sellele otsingule.',
    'All tables in {value1}': 'Kõik skeemi {value1} tabelid',
    '{value1} / {value2} tables': '{value1} / {value2} tabelit',
    'Read & write available': 'Lugemine ja kirjutamine on saadaval',
    'Read only': 'Ainult lugemine',
    Ctrl: 'Ctrl',
    'This suggested knowledge update could not be shown.':
      'Seda soovitatud teadmiste värskendust ei saanud kuvada.',
    'Suggested knowledge update': 'Soovitatud teadmiste värskendus',
    'Archived. Its history is kept.': 'Arhiveeritud. Selle ajalugu säilitatakse.',
    'Choose the page it goes under. Links to it keep working.':
      'Vali leht, mille alla see kuulub. Lingid sellele toimivad edasi.',
    'Its text, its history and any open suggestions are removed for good, and links to it from other pages stop working. This cannot be undone.':
      'Selle tekst, ajalugu ja kõik lahtised ettepanekud kustutatakse jäädavalt ning teiste lehtede lingid sellele lakkavad töötamast. Seda ei saa tagasi võtta.',
    'An archived page no longer informs answers. Its history is kept, and a publisher can restore it or delete it permanently.':
      'Arhiveeritud leht ei mõjuta enam vastuseid. Selle ajalugu säilitatakse ning avaldaja saab selle taastada või jäädavalt kustutada.',
    Under: 'Ülemleht',
    Change: 'Muuda',
    'Move under': 'Teisalda lehe alla',
    'Search pages': 'Otsi lehtedest',
    'Why?': 'Miks?',
    'Delete permanently': 'Kustuta jäädavalt',
    'Move page': 'Teisalda leht',
    'Archive page': 'Arhiveeri leht',
    'Suggestion {value1}: show its card': 'Ettepanek {value1}: kuva selle kaart',
    'Removed:': 'Eemaldatud:',
    'Added:': 'Lisatud:',
    'New page “{value1}”{value2}': 'Uus leht „{value1}”{value2}',
    'No pages match “{value1}”.': 'Ükski leht ei vasta otsingule „{value1}”.',
    'Where this page is': 'Selle lehe asukoht',
    'Describe your company': 'Kirjelda oma ettevõtet',
    'Empty page': 'Tühi leht',
    'Describe {value1}': 'Kirjelda: {value1}',
    'This page has no text yet.': 'Sellel lehel pole veel teksti.',
    'Poneva reads this page before every answer. Start with who you are, what you sell and how you work; details go on the pages under it.':
      'Poneva loeb seda lehte enne iga vastust. Alusta sellest, kes te olete, mida müüte ja kuidas töötate; üksikasjad lisa selle alla kuuluvatele lehtedele.',
    'Write it, or ask Poneva in chat to draft it for you.':
      'Kirjuta see ise või palu Poneval vestluses esimene mustand koostada.',
    'Suggest a first version, and a publisher decides whether it becomes the page.':
      'Paku esimest versiooni ja avaldaja otsustab, kas sellest saab leht.',
    'Start writing': 'Alusta kirjutamist',
    'Suggest a first version': 'Paku esimest versiooni',
    'Accepted. The page is archived.': 'Kinnitatud. Leht on arhiveeritud.',
    'Accepted. The page is now revision {value1}.':
      'Kinnitatud. Leht on nüüd redaktsioon {value1}.',
    'Accepted.': 'Kinnitatud.',
    'Suggestion rejected. The page stays as it is.': 'Ettepanek lükati tagasi. Leht jääb muutmata.',
    'Your suggestion is withdrawn.': 'Sinu ettepanek on tagasi võetud.',
    'Restored. The page informs answers again.': 'Taastatud. Leht mõjutab taas vastuseid.',
    'Your suggestion is sent. A publisher decides whether it becomes the page.':
      'Sinu ettepanek on saadetud. Avaldaja otsustab, kas sellest saab leht.',
    'Saved. The page is now revision {value1}.': 'Salvestatud. Leht on nüüd redaktsioon {value1}.',
    'Nothing changed.': 'Midagi ei muutunud.',
    'This page is not available.': 'See leht pole saadaval.',
    'It may have been deleted, archived or moved out of reach, or you may no longer be in this company.':
      'See võidi kustutada, arhiveerida või kättesaamatust kohast välja teisaldada või ei pruugi sa enam selles ettevõttes olla.',
    'Page actions': 'Lehe toimingud',
    shown: 'kuvatud',
    hidden: 'peidetud',
    '{value1} History': '{value1} ajalugu',
    '{value1} Ask in chat': '{value1} Küsi vestluses',
    'Suggest edits': 'Paku muudatusi',
    'More actions for {value1}': 'Veel toiminguid: {value1}',
    '{value1} Poneva reads this page in every chat':
      '{value1} Poneva loeb seda lehte igas vestluses',
    'This page is archived. It no longer informs answers; its history is kept. {value1}':
      'See leht on arhiveeritud. See ei mõjuta enam vastuseid, kuid selle ajalugu säilitatakse. {value1}',
    'Restore page': 'Taasta leht',
    'This link points to an earlier revision. You are reading the current text.':
      'See link viib varasema redaktsiooni juurde. Loed praegust teksti.',
    'Show it in History': 'Kuva ajaloos',
    Pages: 'Lehed',
    'Pages under {value1}': 'Lehed jaotises {value1}',
    'Linked from': 'Lingid siit',
    Suggestions: 'Ettepanekud',
    'Suggestions are hidden. You are reading the page as everyone else sees it.':
      'Ettepanekud on peidetud. Loed lehte nii, nagu kõik teised seda näevad.',
    'Loading suggestions…': 'Ettepanekute laadimine…',
    'Nothing is waiting for review.': 'Ükski ettepanek ei oota ülevaatamist.',
    'When someone, Poneva in a chat or a connected agent suggests a change to a page, it shows here and on the page. Nothing changes until a publisher accepts it.':
      'Kui keegi, Poneva vestluses või ühendatud agent teeb lehele muudatusettepaneku, kuvatakse see siin ja lehel. Midagi ei muutu enne, kui avaldaja selle kinnitab.',
    '{value1} Review knowledge in chat': '{value1} Vaata teadmised vestluses üle',
    'Suggestions for review': 'Ülevaatamist ootavad ettepanekud',
    'Suggested changes from chats, meetings, colleagues and connected agents. Nothing changes until a publisher accepts it on the page.':
      'Vestlustest, koosolekutelt, kolleegidelt ja ühendatud agentidelt pärinevad muudatusettepanekud. Midagi ei muutu enne, kui avaldaja need lehel kinnitab.',
    'Your suggestions wait here until a publisher decides. The pages stay as they are until then.':
      'Sinu ettepanekud ootavad siin, kuni avaldaja otsuse teeb. Seni jäävad lehed muutmata.',
    'Review page': 'Vaata leht üle',
    'Review on page': 'Vaata lehel üle',
    'Open the meeting': 'Ava koosolek',
    'Open the chat': 'Ava vestlus',
    'Accept and restore': 'Kinnita ja taasta',
    Accept: 'Kinnita',
    Reject: 'Lükka tagasi',
    'Your suggestion · waiting for a publisher': 'Sinu ettepanek · ootab avaldaja otsust',
    Withdraw: 'Võta tagasi',
    'Waiting for a publisher': 'Ootab avaldaja otsust',
    'Suggestion {value1}': 'Ettepanek {value1}',
    'Suggestion {value1} from {value2}{value3}': 'Ettepanek {value1}, autor {value2}{value3}',
    'Read the suggested page': 'Loe pakutud lehte',
    'Outdated: the text it changes was edited after it was suggested. It can be rejected or withdrawn; a new suggestion can be made against the current text.':
      'Aegunud: muudetavat teksti redigeeriti pärast ettepaneku tegemist. Ettepaneku võib tagasi lükata või tagasi võtta; praeguse teksti põhjal saab teha uue ettepaneku.',
    'Restore this page first to accept this suggestion.':
      'Selle ettepaneku kinnitamiseks taasta esmalt see leht.',
    'Previous suggestion': 'Eelmine ettepanek',
    'Suggestion {value1} of {value2}': 'Soovitus {value1} / {value2}',
    'Next suggestion': 'Järgmine soovitus',
    'Fold the suggestions away': 'Ahenda soovitused',
    'Show the suggestions': 'Kuva soovitused',
    '1 suggestion': '1 soovitus',
    '{value1} suggestions': '{value1} soovitust',
    '{value1} the pages under {value2}': '{value1} lehte jaotises {value2}',
    px: 'px',
    '{value1} chart of {value2} across {value3}':
      '{value1} diagramm: {value2} jaotus {value3} lõikes',
    'We could not build the file.': 'Faili loomine ebaõnnestus.',
    '{value1} Present': '{value1} Esitlus',
    'Building…': 'Koostamine…',
    'Download PowerPoint': 'Laadi PowerPoint alla',
    'Slide {value1} of {value2}': 'Slaid {value1}/{value2}',
    Slides: 'Slaidid',
    'Slide {value1}': 'Slaid {value1}',
    'Speaker notes': 'Esineja märkmed',
    'Source: {value1}': 'Allikas: {value1}',
    'Add a name and a web address.': 'Lisage nimi ja veebiaadress.',
    'Enter a valid web address.': 'Sisestage kehtiv veebiaadress.',
    'Use a web address that starts with https://.':
      'Kasutage veebiaadressi, mis algab tekstiga https://.',
    'Add a custom connection': 'Lisa kohandatud ühendus',
    'Connect a tool server you trust. Poneva checks the address works and saves only the connection details needed to use it.':
      'Ühendage usaldusväärne tööriistaserver. Poneva kontrollib aadressi toimivust ja salvestab ainult ühenduse kasutamiseks vajalikud andmed.',
    'Web address': 'Veebiaadress',
    'https://tools.example.com': 'https://tools.example.com',
    'Starts with https://, from your provider': 'Algab teie teenusepakkuja antud tekstiga https://',
    'Sign-in': 'Sisselogimine',
    'Advanced sign-in': 'Täpsem sisselogimine',
    'Access key {value1}': 'Juurdepääsuvõti {value1}',
    'Request headers': 'Päringu päised',
    'Add header': 'Lisa päis',
    'Header {value1} name': 'Päise {value1} nimi',
    'Header name': 'Päise nimi',
    'Header {value1} value': 'Päise {value1} väärtus',
    'Header value': 'Päise väärtus',
    'Remove header': 'Eemalda päis',
    Advanced: 'Täpsemad seaded',
    Transport: 'Transport',
    'Auto-detect': 'Tuvasta automaatselt',
    'Streamable HTTP': 'Streamable HTTP',
    'Legacy SSE': 'Legacy SSE',
    "From your provider's app settings. Leave empty unless they gave you these.":
      'Leiate need teenusepakkuja rakenduse seadetest. Jätke tühjaks, kui teenusepakkuja pole neid teile andnud.',
    "Authorization server issuer": "Autoriseerimisserveri väljastaja",
    "Enter the authorization server issuer when using a client ID.": "Kliendi ID kasutamisel sisestage autoriseerimisserveri väljastaja.",
    'Client ID {value1}': 'Kliendi ID {value1}',
    'Client secret {value1}': 'Kliendisaladus {value1}',
    'Connecting…': 'Ühendamine…',
    'Test and connect': 'Testi ja ühenda',
    'Add the store, the client ID and the client secret.':
      'Lisage pood, kliendi ID ja kliendisaladus.',
    'Connect your Shopify Developer App': 'Ühendage oma Shopify Developer App',
    'Poneva can use exactly the access your store gave the app, and nothing more. It talks to Shopify directly and keeps the client secret encrypted.':
      'Poneva saab kasutada täpselt seda juurdepääsu, mille teie pood rakendusele andis, ega midagi enamat. Poneva suhtleb otse Shopifyga ja hoiab kliendisaladuse krüptituna.',
    'How to create the app in Shopify': 'Kuidas Shopify rakendus luua',
    'Open{value1} {value2}{value3} with the account that owns the store, and create an app.':
      'Avage{value1} {value2}{value3} poe omaniku kontoga ja looge rakendus.',
    'Create a version and select the access scopes Poneva may use, for example read_products and read_orders. Add write_ scopes only for data Poneva may change. Then release the version.':
      'Looge versioon ja valige juurdepääsuulatused, mida Poneva võib kasutada, näiteks read_products ja read_orders. Lisage write_ ulatused ainult andmete jaoks, mida Poneva võib muuta. Seejärel avaldage versioon.',
    'For orders and customers, also select protected customer data in the app’s settings. Shopify allows this without review for an app made for your own store.':
      'Tellimuste ja klientide puhul valige rakenduse seadetes ka kaitstud kliendiandmed. Shopify lubab seda teie enda poe jaoks loodud rakenduse puhul ilma ülevaatuseta.',
    'Install the app on your store.': 'Installige rakendus oma poodi.',
    'Copy the client ID and client secret from the app’s settings.':
      'Kopeerige rakenduse seadetest kliendi ID ja kliendisaladus.',
    'To change the access later, release a new version, approve it on the store and use Test connection here.':
      'Juurdepääsu hilisemaks muutmiseks avaldage uus versioon, kinnitage see poes ja kasutage siin valikut Testi ühendust.',
    Store: 'Pood',
    'your-store.myshopify.com': 'your-store.myshopify.com',
    'Your store’s .myshopify.com address (Shopify admin → Settings → Domains), or paste the address of your Shopify admin page':
      'Teie poe .myshopify.com-aadress (Shopify admin → Settings → Domains) või kleepige oma Shopify administraatori lehe aadress',
    'Client ID {value1} {value2}': 'Kliendi ID {value1} {value2}',
    'Client secret {value1} {value2}': 'Kliendisaladus {value1} {value2}',
    Person: 'Isik',
    Everyone: 'Kõik',
    Connection: 'Ühendus',
    'All connections': 'Kõik ühendused',
    'App {value1}': 'Rakendus {value1}',
    'From {value1}': 'Alates {value1}',
    'Until {value1}': 'Kuni {value1}',
    Result: 'Tulemus',
    'All results': 'Kõik tulemused',
    Succeeded: 'Õnnestus',
    Denied: 'Keelatud',
    Failed: 'Ebaõnnestus',
    Unknown: 'Teadmata',
    Filter: 'Filtreeri',
    'Loading activity…': 'Tegevuse laadimine…',
    'Could not load activity. Try again.': 'Tegevuse laadimine ebaõnnestus. Proovige uuesti.',
    'Removed connection': 'Ühendus eemaldatud',
    'App: {value1}': 'Rakendus: {value1}',
    'Older activity': 'Vanem tegevus',
    Download: 'Laadi alla',
    CSV: 'CSV',
    'Evidence for {value1}': 'Tõendid väärtuse {value1} kohta',
    Measure: 'Mõõdik',
    'Show rows →': 'Kuva read →',
    'Ask about this number': 'Küsi selle numbri kohta',
    'There are no numeric values available to chart. View the table for the original data.':
      'Diagrammi jaoks pole arvulisi väärtusi. Algandmete vaatamiseks ava tabel.',
    'Chart value': 'Diagrammi väärtus',
    '{value1} of {value2} shown': 'Kuvatud {value1} {value2}-st',
    '{value1} by {value2}; {value3} rows. View Table for exact values.':
      '{value1} × {value2}; {value3} rida. Täpsete väärtuste vaatamiseks ava tabel.',
    'Values come directly from the source data. Missing values are not estimates.':
      'Väärtused pärinevad otse lähteandmetest. Puuduvad väärtused ei ole hinnangulised.',
    'Loading library…': 'Teegi laadimine…',
    'We couldn’t load what happened in this App. Try again in a moment.':
      'Selles rakenduses toimunu laadimine ebaõnnestus. Proovi hetke pärast uuesti.',
    'This App could not be opened.': 'Seda rakendust ei saanud avada.',
    'Opening App…': 'Rakenduse avamine…',
    'Open the saved App to run this function.':
      'Selle funktsiooni käivitamiseks ava salvestatud rakendus.',
    'Save this App before running its function.':
      'Salvesta see rakendus enne selle funktsiooni käivitamist.',
    'Open saved App': 'Ava salvestatud rakendus',
    'Open Apps': 'Ava rakendused',
    'The App could not be opened. Try again.': 'Rakendust ei saanud avada. Proovi uuesti.',
    Owner: 'Omanik',
    '{value1} · admins': '{value1} · administraatorit',
    'Owner · always edits': 'Omanik · saab alati muuta',
    'Admins manage it': 'Administraatorid haldavad seda',
    Editors: 'Muutjad',
    'A colleague': 'Kolleeg',
    'Can edit drafts and publish versions': 'Saab muuta mustandeid ja avaldada versioone',
    Remove: 'Eemalda',
    'No editors yet.': 'Muutjaid veel pole.',
    'Admins can always edit company agents.':
      'Administraatorid saavad ettevõtte agente alati muuta.',
    'Asking for edit access': 'Muutmisõiguse taotlemine',
    'Asked {value1} · also in your Inbox': 'Taotletud {value1} · samuti sinu postkastis',
    Grant: 'Luba',
    Admin: 'Administraator',
    'Make personal': 'Muuda isiklikuks',
    'Switch off': 'Lülita välja',
    Archive: 'Arhiveeri',
    'Archive this agent': 'Arhiveeri see agent',
    'Loading agent…': 'Agendi laadimine…',
    '{value1} Edit in chat': '{value1} Muuda vestluses',
    Agent: 'Agent',
    'This agent has not been created yet. It can run once its owner creates it.':
      'Seda agenti pole veel loodud. Seda saab käivitada, kui omanik on selle loonud.',
    'New agent · Draft': 'Uus agent · Mustand',
    'Untitled agent': 'Pealkirjata agent',
    'Test run': 'Proovikäivitus',
    'This draft does not run automatically.': 'See mustand ei käivitu automaatselt.',
    'Describe the agent in the chat. Its draft appears here.':
      'Kirjelda agenti vestluses. Selle mustand kuvatakse siin.',
    '{value1} Test run': '{value1} Proovikäivitus',
    'Describe the agent in the chat first.': 'Kirjelda agenti esmalt vestluses.',
    'Create and turn on': 'Loo ja lülita sisse',
    'Connection write setup': 'Ühenduse kirjutamisõiguse seadistamine',
    'Account for connected changes': 'Konto ühendatud muudatuste jaoks',
    'Choose a connection': 'Vali ühendus',
    'No published Skills available. You can add them later.':
      'Avaldatud oskusi pole saadaval. Saad need hiljem lisada.',
    '{value1} · not published. Review the changes. Testing is optional.':
      '{value1} · avaldamata. Vaata muudatused üle. Testimine on valikuline.',
    '{value1} Test draft': '{value1} Testi mustandit',
    'Apply changes…': 'Rakenda muudatused…',
    'Apply this draft as a new version': 'Rakenda see mustand uue versioonina',
    'This draft cannot be applied.': 'Seda mustandit ei saa rakendada.',
    'What changed?': 'Mis muutus?',
    'Apply version {value1}': 'Rakenda versioon {value1}',
    Create: 'Loo',
    'Edit access requested': 'Muutmisõigus taotletud',
    '{value1} Request edit access': '{value1} Taotle muutmisõigust',
    '{value1} Copy agent': '{value1} Kopeeri agent',
    Pause: 'Peata',
    'Open agent: {value1}': 'Ava agent: {value1}',
    '· you can edit': '· saad muuta',
    '{value1} is switched off.': '{value1} on välja lülitatud.',
    '{value1} is archived.': '{value1} on arhiveeritud.',
    'Loading agents…': 'Agentide laadimine…',
    Agents: 'Agendid',
    'Agents do work for you on a schedule or when you ask. They follow your company’s Skills.':
      'Agendid teevad sinu eest tööd graafiku alusel või sinu palvel. Nad järgivad sinu ettevõtte oskusi.',
    'No agent matches. Try a Skill name or what the agent should do.':
      'Ühtegi sobivat agenti pole. Proovi oskuse nime või kirjelda, mida agent peaks tegema.',
    'Nothing of your own yet': 'Sul pole veel midagi enda oma',
    'Tell Chat what an agent should do, or copy one of the company’s agents below.{value1}':
      'Ütle Chatile, mida agent peaks tegema, või kopeeri allolevatest ettevõtte agentidest üks.{value1}',
    'Your agents': 'Sinu agendid',
    'Run on demand': 'Käivita nõudmisel',
    'Run is always available. A schedule is optional and lives separately from the agent’s instructions.':
      'Käivitamine on alati saadaval. Graafik on valikuline ja paikneb agendi juhistest eraldi.',
    'What changed in version {value1}': 'Mis muutus versioonis {value1}',
    'Every publish is a version you can restore.':
      'Iga avaldamine on versioon, mille saad taastada.',
    Authorization: 'Autoriseerimine',
    '{value1} {value2} · {value3} will see it.': '{value1} {value2} · {value3} näevad seda.',
    '{value1} {value2} you': '{value1} {value2} sind',
    '· Revised': '· Muudetud',
    'This chat used your {value1}.': 'See vestlus kasutas sinu {value1}.',
    'This chat has results from {value1}.': 'Selles vestluses on tulemused allikast {value1}.',
    'db.example.com': 'db.example.com',
    'e.g. Product analytics': 'nt tooteanalüüs',
    'Paste access key': 'Kleebi juurdepääsuvõti',
    'Shopify’s Dev Dashboard': 'Shopify Dev Dashboard',
    'App reference': 'Rakenduse viide',
    'Draft · revision {value1}': 'Mustand · redaktsioon {value1}',
    'its Result': 'selle tulemus',
    '· its first run makes it': '· selle esimene käivitamine muudab selle',
    '{value1}’s chat ·': '{value1} vestlus ·',
    '{value1} ad {value2} available.': '{value1} ja {value2} on saadaval.',
    '{value1} rows ·': '{value1} rida ·',
    'It starts private. Sharing it wider shares every refresh, which can carry your private data.':
      'Algselt on see privaatne. Laiemalt jagamisel jagatakse iga värskendust, mis võib sisaldada sinu privaatseid andmeid.',
    'Enable this schedule when approved': 'Luba see ajastus pärast kinnitamist',
    Schedule: 'Ajastus',
    'Kept off until you create the agent from its canvas.':
      'See jääb välja lülitatuks, kuni loote agendi selle lõuendilt.',
    'Will be enabled when you approve.': 'See lubatakse pärast teie kinnitust.',
    'Will be saved paused. You can enable it later.':
      'See salvestatakse peatatud olekus. Saate selle hiljem lubada.',
    'Only runs when you ask.': 'Käivitub ainult teie palvel.',
    'Draft · approving saves it, and nothing runs. Test it and create it from its canvas.':
      'Mustand · kinnitamine salvestab selle ja midagi ei käivitata. Testige seda ning looge agent selle lõuendilt.',
    'Draft · nothing is scheduled until you approve. Connected actions require their own approval at run time.':
      'Mustand · midagi ei ajastata enne teie kinnitust. Ühendatud toimingud nõuavad käivitamise ajal eraldi kinnitust.',
    Name: 'Nimi',
    'Agent name': 'Agendi nimi',
    'Who can use it': 'Kes saavad seda kasutada',
    'Company agent · company resources only': 'Ettevõtte agent · ainult ettevõtte ressursid',
    'Personal agent · runs with your access': 'Isiklik agent · käivitub teie juurdepääsuga',
    'Approving saves it as a draft. It does not run automatically.':
      'Kinnitamine salvestab selle mustandina. See ei käivitu automaatselt.',
    'Open the agent’s runs': 'Ava agendi käivitused',
    'Run the published version once': 'Käivita avaldatud versioon üks kord',
    'Stopping…': 'Peatamine…',
    'Stop run': 'Peata käivitus',
    'Could not stop this run. Please try again.':
      'Seda käivitust ei saanud peatada. Proovige uuesti.',
    'Run in progress': 'Käivitus on pooleli',
    'This run is still answering. You can ask follow-ups when it finishes.':
      'See käivitus alles vastab. Kui see lõpetab, saate esitada täpsustavaid küsimusi.',
    'Open run details': 'Ava käivituse üksikasjad',
    Runs: 'Käivitused',
    'Open the run chat': 'Ava käivituse vestlus',
    Watch: 'Vaata',
    Goal: 'Eesmärk',
    'Change the goal': 'Muuda eesmärki',
    'What it does': 'Mida see teeb',
    'What should this agent achieve?': 'Mida peaks see agent saavutama?',
    'Not set yet.': 'Pole veel määratud.',
    'When it runs': 'Millal see käivitub',
    'Change when it runs': 'Muuda käivitusaega',
    'Off means it runs only when someone runs it. Changing when it runs never changes its instructions.':
      'Väljas tähendab, et see käivitub ainult siis, kui keegi selle käivitab. Käivitusaja muutmine ei muuda kunagi selle juhiseid.',
    Instructions: 'Juhised',
    'Change the instructions': 'Muuda juhiseid',
    'How the agent should approach the work and make decisions.':
      'Kuidas agent peaks tööle lähenema ja otsuseid tegema.',
    Boundaries: 'Piirangud',
    'What to do or avoid. Every connected action still follows its approval.':
      'Mida teha või vältida. Iga ühendatud toiming järgib endiselt oma kinnitust.',
    'No instructions of its own. It follows its Skills.':
      'Oma juhised puuduvad. See järgib oma oskusi.',
    'Pin a Skill': 'Kinnita oskus',
    'Finds the Skills that fit each run, the same way a chat does.':
      'Leiab igaks käivituseks sobivad oskused samamoodi nagu vestlus.',
    'Skills it always follows': 'Oskused, mida see alati järgib',
    'A Skill that is not published': 'Oskus, mida pole avaldatud',
    'Always follows · Version {value1}': 'Järgib alati · versioon {value1}',
    'Not published': 'Avaldamata',
    Uses: 'Kasutab',
    'Change in chat': 'Muuda vestluses',
    'Change in chat: Uses': 'Muuda vestluses: kasutab',
    'Company knowledge and the tools each run is allowed to use.':
      'Ettevõtte teadmised ja tööriistad, mida iga käivitus võib kasutada.',
    'People see the Result refresh; they change the agent, not the page.':
      'Inimesed näevad tulemuse värskendust; nad muudavad agenti, mitte lehte.',
    'The first run after it is created makes the Result; later runs add a version to it.':
      'Esimene käivitus pärast selle loomist loob tulemuse; hilisemad käivitused lisavad sellele versiooni.',
    'Emails whoever the run is for': 'Saadab e-kirja käivituse adressaadile',
    'Email each run': 'Saada iga käivituse kohta e-kiri',
    Delivers: 'Edastab',
    'Change what it delivers': 'Muuda edastatavat sisu',
    'Expected result': 'Oodatav tulemus',
    'What a successful run should deliver.': 'Mida edukas käivitus peaks edastama.',
    'What each run delivers': 'Mida iga käivitus edastab',
    'Keeps one Result up to date {value1}': 'Hoiab ühe tulemuse ajakohasena {value1}',
    'Saves a new Result each run': 'Salvestab iga käivituse kohta uue tulemuse',
    'You can run this company agent as yourself.{value1} {value2}':
      'Saate seda ettevõtte agenti käivitada iseendana.{value1} {value2}',
    'Changes since version': 'Muudatused alates versioonist',
    'are not live yet.': 'ei ole veel aktiivsed.',
    'Review them in Versions': 'Vaadake need üle jaotises „Versioonid“',
    Skill: 'Oskus',
    'The agent always uses the Skill’s published version.':
      'Agent kasutab alati oskuse avaldatud versiooni.',
    Day: 'Päev',
    Time: 'Kellaaeg',
    'Cron expression': 'Cron-avaldise',
    'Editors and access': 'Muutjad ja juurdepääs',
    Company: 'Ettevõte',
    Personal: 'Isiklik',
    'No changes.': 'Muudatusi pole.',
    'Instructions changes': 'Juhiste muudatused',
    'Loading versions…': 'Versioonide laadimine…',
    'What the draft changes': 'Mida mustand muudab',
    'No published version yet. Try the draft, then publish it.':
      'Avaldatud versiooni veel pole. Proovige mustandit ja avaldage see seejärel.',
    'Published versions': 'Avaldatud versioonid',
    'Former member': 'Endine liige',
    Live: 'Aktiivne',
    'Scroll to see all columns': 'Keri, et näha kõiki veerge',
    '{value1} for {value2}': '{value1} – {value2} jaoks',
    Suggested: 'Soovitatud',
    'Opening your conversation…': 'Vestluse avamine…',
    'This conversation isn’t available': 'See vestlus pole saadaval',
    'It may have been deleted, belong to another account, or be temporarily unavailable.':
      'See võidi kustutada, see võib kuuluda teisele kontole või olla ajutiselt kättesaamatu.',
    '{count} more line — shown in the complete revision':
      'Veel {count} rida — kuvatakse täielikus versioonis',
    '{count} more lines — shown in the complete revision':
      'Veel {count} rida — kuvatakse täielikus versioonis',
    '{count} more line removed': 'Veel {count} rida eemaldatud',
    '{count} more lines removed': 'Veel {count} rida eemaldatud',
    '{count} unchanged line': '{count} muutmata rida',
    '{count} unchanged lines': '{count} muutmata rida',
    '{count} more lines not shown, {added} added and {removed} removed. Check them in the complete revision.':
      'Veel {count} rida ei kuvata, lisatud on {added} ja eemaldatud {removed}. Vaata neid täielikus versioonis.',
    'Saved result': 'Salvestatud tulemus',
    'Made with a Skill': 'Loodud oskusega',
    'Preview of {name}': '{name} eelvaade',
    'Made with {name}': 'Loodud: {name}',
    'Ad-hoc result': 'Ühekordse päringu tulemus',
    'A Skill that is not available in this workspace': 'Selles tööruumis kättesaamatu oskus',
    '{name} · Revision {version}': '{name} · versioon {version}',
    '{name} · Version {version}': '{name} · versioon {version}',
    'Return to conversation {value1}': 'Naase vestlusesse {value1}',
    '{value1} Working with {value2}': '{value1} töötab koos {value2}-ga',
    'View context {value1}': 'Vaata konteksti {value1}',
    'A way of working, made yours.': 'Tööviis, mis on sinu nägu.',
    'Work that runs itself.': 'Töö, mis teeb end ise.',
    'One place for one piece of work.': 'Üks koht ühe töö jaoks.',
    'Let’s move your work forward{value1}.': 'Viime su töö edasi{value1}.',
    'Describe the work. Your Skill takes shape beside the conversation.':
      'Kirjelda tööd. Sinu oskus kujuneb vestluse kõrval.',
    'Describe what it should do and when. Your agent takes shape beside the conversation. The draft does not run automatically.':
      'Kirjelda, mida see peaks tegema ja millal. Sinu agent kujuneb vestluse kõrval. Kavand ei käivitu automaatselt.',
    'Say what the work is. Poneva drafts the project beside the conversation and brings in what you have already done. Nothing is created until you say so.':
      'Kirjelda, mis tööga on tegu. Poneva koostab projekti kavandi vestluse kõrvale ja toob sisse juba tehtu. Midagi ei looda enne, kui sa seda ütled.',
    'Start with an idea below. Poneva will take it from there.':
      'Alusta allolevast ideest. Poneva hoolitseb ülejäänu eest.',
    Triggers: 'Käivitajad',
    'Review the agent and its trigger. Approval applies exactly what is shown.':
      'Vaata agent ja selle käivitaja üle. Kinnitamine rakendab täpselt kuvatut.',
    '{source} · read {date}': '{source} · loetud {date}',
    'Evidence is being recorded · read {date}': 'Tõend salvestatakse · loetud {date}',
    'Evidence expired on {date} under the retention policy':
      'Tõend aegus {date} säilituseeskirja alusel',
    'Entered by {person}': 'Sisestaja: {person}',
    'No retained evidence for this value': 'Selle väärtuse kohta säilitatud tõendeid pole',
    'Covers {shown} of {total} rows': 'Hõlmab {shown} rida {total} reast',
    'Search rows': 'Otsi ridadest',
    'Clear filters': 'Tühjenda filtrid',
    Sort: 'Sordi',
    'Sort: {column}': 'Sordi: {column}',
    '{shown} of {total} rows': '{shown} rida {total} reast',
    More: 'Veel',
    Density: 'Tihedus',
    Comfortable: 'Mugav',
    Compact: 'Kompaktne',
    Columns: 'Veerud',
    'No rows match. Clear the search or filters to see them again.':
      'Ükski rida ei vasta tingimustele. Nende uuesti nägemiseks tühjenda otsing või filtrid.',
    'Not available': 'Pole saadaval',
    'All rows': 'Kõik read',
    'Close row detail': 'Sulge rea üksikasjad',
    'Ask about this row': 'Küsi selle rea kohta',
    'Add note': 'Lisa märkus',
    Note: 'Märkus',
    Saved: 'Salvestatud',
    Total: 'Kokku',
    ascending: 'kasvavalt',
    descending: 'kahanevalt',
    App: 'Rakendus',
    Artifact: 'Artefakt',
    'New project': 'Uus projekt',
    'Review request': 'Ülevaatamise taotlus',
    Activity: 'Tegevus',
    'Voice preview': 'Hääle eelvaade',
    Source: 'Allikas',
    File: 'Fail',
    Meeting: 'Koosolek',
    'Knowledge page': 'Teadmiste leht',
    'Could not preview this CSV.': 'Selle CSV eelvaadet ei saanud kuvada.',
    'File content is unavailable.': 'Faili sisu pole saadaval.',
    'You have five open suggestions here. {value1} will see them.':
      'Sul on siin viis avatud soovitust. {value1} näeb neid.',
    'We could not send your suggestion. Please try again.':
      'Soovitust ei saanud saata. Proovi uuesti.',
    'The agent': 'Agent',
    'Selected colleagues': 'Valitud kolleegid',
    'The owner': 'Omanik',
    'Forked. This copy is yours and runs with your own connections.':
      'Haru on loodud. See koopia on sinu ja töötab sinu enda ühendustega.',
    'This chat is too long to fork.': 'See vestlus on harundamiseks liiga pikk.',
    'We could not fork this chat. Please try again.':
      'Seda vestlust ei saanud harundada. Proovi uuesti.',
    'Anyone who forked it keeps their copy: forks stay with the people who made them.':
      'Kõik, kes selle harundasid, säilitavad oma koopia: harud jäävad nende loojatele.',
    'Nobody has forked this chat.': 'Keegi pole seda vestlust harundanud.',
    '1 person forked this chat. Their copy stays theirs.':
      '1 inimene harundas seda vestlust. Tema koopia jääb talle.',
    '{value1} people forked this chat. Their copies stay theirs.':
      '{value1} inimest harundasid seda vestlust. Nende koopiad jäävad neile.',
    'Personal. Nobody else sees it.': 'Isiklik. Keegi teine seda ei näe.',
    'People you pick. They get it in their Inbox.':
      'Sinu valitud inimesed. Nad saavad selle oma postkasti.',
    'Everyone in the company can follow it and fork it.':
      'Kõik ettevõtte töötajad saavad seda jälgida ja harundada.',
    'a chat you can no longer open': 'vestlus, mida sa enam avada ei saa',
    'shared the Result': 'jagas Tulemust',
    'updated the Result': 'uuendas Tulemust',
    'published the Skill': 'avaldas Oskuse',
    'approved the fact': 'kiitis fakti heaks',
    'added the fact': 'lisas fakti',
    'added the meeting': 'lisas koosoleku',
    'published the page': 'avaldas lehe',
    'updated the page': 'uuendas lehte',
    'shared the chat': 'jagas vestlust',
    'published a version of': 'avaldas versiooni üksusest',
    ran: 'käivitas',
    Knowledge: 'Teadmised',
    Meetings: 'Koosolekud',
    Chat: 'Vestlus',
    Use: 'Kasuta',
    Open: 'Ava',
    You: 'Sina',
    Someone: 'Keegi',
    'published version {version} of': 'avaldas üksuse versiooni {version}',
    'thing needs': 'asi vajab',
    'things need': 'asjad vajavad',
    'Published Skill': 'Avaldatud oskus',
    'Included with Skill': 'Oskusega kaasas',
    'Already attached': 'Juba lisatud',
    'Also available in company knowledge': 'Saadaval ka ettevõtte teadmistes',
    'Company file': 'Ettevõtte fail',
    'Account identity unavailable': 'Konto identiteet pole saadaval',
    'Access expired or was revoked. Reconnect to continue.':
      'Juurdepääs aegus või tühistati. Jätkamiseks loo ühendus uuesti.',
    'Account authorized · tools unavailable': 'Konto on volitatud · tööriistad pole saadaval',
    'Not available in this workspace yet.': 'Pole selles tööruumis veel saadaval.',
    'Everyone in the company': 'Kõik ettevõtte töötajad',
    'Audience: only you.': 'Vaatajaskond: ainult sina.',
    'Audience: everyone in the company.': 'Vaatajaskond: kõik ettevõtte töötajad.',
    'tool is': 'tööriist on',
    'tools are': 'tööriistad on',
    'account is': 'konto on',
    'accounts are': 'kontod on',
    'We could not upload this file.': 'Seda faili ei õnnestunud üles laadida.',
    'file was': 'fail oli',
    'files were': 'failid olid',
    'Your company': 'Sinu ettevõte',
    'Create an agent': 'Loo agent',
    'Give recurring work a helping hand': 'Anna korduvatele töödele hoogu',
    'Create a Skill': 'Loo oskus',
    'Save a reusable way of working': 'Salvesta korduvkasutatav tööviis',
    'Take meeting notes': 'Koosta koosolekumärkmeid',
    'Capture decisions and next steps': 'Pane kirja otsused ja järgmised sammud',
    'Work with a file': 'Tööta failiga',
    'Start from a document or image': 'Alusta dokumendist või pildist',
    'Browse agents': 'Sirvi agente',
    'Open your agents and company agents': 'Ava oma agendid ja ettevõtte agendid',
    'Review results': 'Vaata tulemused üle',
    'Return to work saved in your Library': 'Naase oma teeki salvestatud töö juurde',
    'For review': 'Ülevaatamiseks',
    'An agent': 'Agent',
    Assistant: 'Abiline',
    'Kept up to date by {value1}{value2}': 'Ajakohasena hoiab {value1}{value2}',
    ', {value1}': ', {value1}',
    'Version {value1}{value2}{value3}': 'Versioon {value1}{value2}{value3}',
    'Refreshed by its agent': 'Agendi värskendatud',
    'Saved from a chat': 'Vestlusest salvestatud',
    'Saved from {value1}': 'Salvestatud rakendusest {value1}',
    Edited: 'Muudetud',
    'private account': 'privaatne konto',
    '{value1} ({value2})': '{value1} ({value2})',
    '{value1}’s {value2}': '{value1} {value2}',
    'Made private. The person who added it and the owner of its recording have been told in their Inbox.':
      'Muudeti privaatseks. Selle lisajat ja salvestise omanikku teavitati nende postkastis.',
    'Made private. The person who added it has been told in their Inbox.':
      'Muudeti privaatseks. Selle lisajat teavitati tema postkastis.',
    'Made private. The owner of its recording has been told in their Inbox.':
      'Muudeti privaatseks. Salvestise omanikku teavitati tema postkastis.',
    'Selected passage': 'Valitud lõik',
    '{value1} {value2}': '{value1} {value2}',
    'Upload a file': 'Laadi fail üles',
    'Help me create a useful report from our company knowledge and available sources.':
      'Aita mul koostada meie ettevõtte teadmiste ja saadaolevate allikate põhjal kasulik aruanne.',
    'This saved work couldn’t be opened. Open it again to retry.':
      'Seda salvestatud tööd ei saanud avada. Proovi selle uuesti avamiseks uuesti.',
    '{value1}’s': '{value1}',
    '{value1} chat “{value2}”': '{value1} vestlus „{value2}“',
    '{value1}{value2}': '{value1}{value2}',
    'Skill: {value1}{value2}': 'Oskus: {value1}{value2}',
    'Result “{value1}”': 'Tulemus „{value1}“',
    'Meeting “{value1}”': 'Koosolek „{value1}“',
    'Used in {value1} {value2} this week': 'Sel nädalal kasutatud {value1} {value2}',
    '{value1} {value2} · used in {value3} {value4}':
      '{value1} {value2} · kasutatud {value3} {value4}',
    'The draft is not published yet, so no one else follows it.':
      'Mustand pole veel avaldatud, seega ei jälgi seda keegi teine.',
    'Use it in a chat for current data, or refine the Skill first.':
      'Kasuta seda vestluses värskete andmete saamiseks või täienda esmalt oskust.',
    'An agent keeps this up to date. Continue the work in chat.':
      'Agent hoiab seda ajakohasena. Jätka tööd vestluses.',
    'Edit it here, or continue the work in chat.': 'Muuda seda siin või jätka tööd vestluses.',
    'Duplicate it to your Library, or continue the work in chat.':
      'Tee sellest oma teeki koopia või jätka tööd vestluses.',
    'Download Markdown': 'Laadi alla Markdown',
    'Download CSV': 'Laadi alla CSV',
    'an agent': 'agent',
    'Publish a Skill version': 'Avalda oskuse versioon',
    'Share with {value1}': 'Jaga kasutajaga {value1}',
    'Update company content': 'Värskenda ettevõtte sisu',
    Approved: 'Heaks kiidetud',
    Declined: 'Tagasi lükatud',
    Pending: 'Ootel',
    'View decision': 'Vaata otsust',
    'No data': 'Andmed puuduvad',
    'No change': 'Muudatusi pole',
    'Connection created': 'Ühendus loodud',
    'Sharing changed': 'Jagamise seade muudetud',
    'Person added': 'Isik lisatud',
    'Person removed': 'Isik eemaldatud',
    'Access changed': 'Juurdepääsu muudetud',
    'Access turned off': 'Juurdepääs välja lülitatud',
    'Connection removed': 'Ühendus eemaldatud',
    'Query time limit changed': 'Päringu ajalimiiti muudetud',
    '{count} row': '{count} rida',
    '{count} rows': '{count} rida',
    'This source is no longer available. Company knowledge now lives in Knowledge pages, and files stay in the Library.':
      'See allikas pole enam saadaval. Ettevõtte teadmised asuvad nüüd teadmiste lehtedel ja failid jäävad teeki.',
    '· {value1} by {value2}': '· {value1} kasutajalt {value2}',
    '· version {value1}': '· versioon {value1}',
    '{message} {count} earlier file was saved and attached.':
      '{message} {count} varasem fail salvestati ja lisati.',
    '{message} {count} earlier files were saved and attached.':
      '{message} {count} varasemat faili salvestati ja lisati.',
    '{message} {count} earlier file was saved.': '{message} {count} varasem fail salvestati.',
    '{message} {count} earlier files were saved.': '{message} {count} varasemat faili salvestati.',
    'refreshed {time}': 'värskendatud {time}',
    'a colleague': 'kolleeg',
    'Your chat “{title}”': 'Sinu vestlus „{title}“',
    '{name}’s chat “{title}”': 'Kasutaja {name} vestlus „{title}“',
    'Kept up to date by {name}{version}': 'Ajakohasena hoiab {name}{version}',
    'Skill: {name}{version}': 'Oskus: {name}{version}',
    'Result “{title}”': 'Tulemus „{title}“',
    'Meeting “{title}”': 'Koosolek „{title}“',
    'Used in {count} answer this week': 'Kasutatud sel nädalal {count} vastuses',
    'Used in {count} answers this week': 'Kasutatud sel nädalal {count} vastuses',
    '{count} source': '{count} allikas',
    '{count} sources': '{count} allikat',
    'used in {count} place': 'kasutatud {count} kohas',
    'used in {count} places': 'kasutatud {count} kohtades',
    '{company} workspace': '{company} tööruum',
    '{count} page': '{count} leht',
    '{count} pages': '{count} lehte',
    '{needs} · reviews and approvals': '{needs} · ülevaatamist ja kinnitamist',
    '{count} thing needs you': '{count} asi vajab sinu tähelepanu',
    '{count} things need you': '{count} asja vajavad sinu tähelepanu',
    'Included with Skill · {files} · {sources} {icon}':
      'Oskusega kaasas · {files} · {sources} {icon}',
    '{count} file': '{count} fail',
    '{count} files': '{count} faili',
    Today: 'Täna',
    'Earlier this week': 'Selle nädala jooksul varem',
    '{count} slide': '{count} slaid',
    '{count} slides': '{count} slaidi',
    Early: 'Varakult',
    'TLS verified': 'TLS kinnitatud',
    'Made personal and switched off. Switch it on when you are ready.':
      'Muudetud isiklikuks ja välja lülitatud. Lülita see sisse, kui oled valmis.',
    'Made personal and switched off. Its owner is told which version is live.':
      'Muudetud isiklikuks ja välja lülitatud. Selle omanikule antakse teada, milline versioon on aktiivne.',
    'Switched off.': 'Välja lülitatud.',
    'Applied version {revision}.': 'Rakendatud versioon {revision}.',
    'The draft is running in a chat only you can read.':
      'Mustand töötab vestluses, mida saad lugeda ainult sina.',
    'Publish a version first.': 'Avalda esmalt versioon.',
    'Another Agent action is in progress.': 'Teine Agendi toiming on pooleli.',
    'Knowledge & connections': 'Teadmised ja ühendused',
    'Pinned Skills': 'Kinnitatud oskused',
    None: 'Puudub',
    'A new Result each run': 'Iga käivitusega uus tulemus',
    'One Result kept up to date': 'Üks ajakohasena hoitav tulemus',
    Email: 'E-post',
    On: 'Sees',
    Off: 'Väljas',
    'Waiting for review': 'Ülevaatamisel',
    Outdated: 'Aegunud',
    Accepted: 'Heaks kiidetud',
    Rejected: 'Tagasi lükatud',
    Withdrawn: 'Tagasi võetud',
    Replaced: 'Asendatud',
    'Suggested edit': 'Soovitatud muudatus',
    'Suggested new page': 'Soovitatud uus leht',
    'Suggested move': 'Soovitatud teisaldamine',
    'Suggested archive': 'Soovitatud arhiveerimine',
    'Checking status…': 'Oleku kontrollimine…',
    'Status unavailable': 'Olek pole saadaval',
    'Bulleted list': 'Täpploend',
    'Numbered list': 'Nummerdatud loend',
    'Web link': 'Veebilink',
    Read: 'Lugemine',
    Write: 'Kirjutamine',
    'shared with you': 'teiega jagatud',
    'Getting an answer': 'Vastuse otsimine',
    '{name} is getting an answer': '{name} otsib vastust',
    'We could not save. Please try again.': 'Salvestamine ebaõnnestus. Proovige uuesti.',
    'The new page could not be created.': 'Uue lehe loomine ebaõnnestus.',
    'We could not load this revision.': 'Selle versiooni laadimine ebaõnnestus.',
    'We could not restore this revision. Please try again.':
      'Selle versiooni taastamine ebaõnnestus. Proovige uuesti.',
    'We could not export this revision.': 'Selle versiooni eksportimine ebaõnnestus.',
    'We could not open this suggestion.': 'Selle soovituse avamine ebaõnnestus.',
    'We could not do that. Please try again.': 'Seda ei saanud teha. Proovige uuesti.',
    'We could not save your decision. Please try again.':
      'Teie otsuse salvestamine ebaõnnestus. Proovige uuesti.',
    'We could not restore this page. Please try again.':
      'Selle lehe taastamine ebaõnnestus. Proovige uuesti.',
    'We could not export this page.': 'Selle lehe eksportimine ebaõnnestus.',
    '{count} missed time merged.': '{count} vahelejäänud kord liideti.',
    '{count} missed times merged.': '{count} vahelejäänud korda liideti.',
    'About this project': 'Selle projekti kohta',
  },
  fi: {
    'We could not load this item.': 'Tätä kohdetta ei voitu ladata.',
    '{value1} canvas': '{value1} piirtoalue',
    'Loading {value1}…': 'Ladataan kohdetta {value1}…',
    '{value1} · Original retained': '{value1} · Alkuperäinen säilytetty',
    '{value1} {value2}{value3} · Added {value4}': '{value1} {value2}{value3} · Lisätty {value4}',
    '{value1} Use in chat': '{value1} Käytä chatissa',
    '{value1} Download': '{value1} Lataa',
    Table: 'Taulukko',
    Chart: 'Kaavio',
    Original: 'Alkuperäinen',
    'Text extracted from the PDF, marked by page. Download the original for its layout and images.':
      'PDF-tiedostosta poimittu teksti sivuittain merkittynä. Lataa alkuperäinen tiedosto nähdäksesi sen asettelun ja kuvat.',
    'This preview shows the beginning of the file. Poneva reads the whole file; download the original to see all of it.':
      'Tämä esikatselu näyttää tiedoston alun. Poneva lukee koko tiedoston; lataa alkuperäinen nähdäksesi kaiken.',
    'Preview of the first {value1} complete rows. Filtering and charts use only this preview. Download the original for the full file.':
      'Esikatselu ensimmäisestä {value1} täydestä rivistä. Suodatus ja kaaviot käyttävät vain tätä esikatselua. Lataa alkuperäinen tiedosto nähdäksesi sen kokonaan.',
    'This source link cannot be opened.': 'Tätä lähdelinkkiä ei voi avata.',
    'Read-only chat': 'Vain luku -chat',
    'Only {value1} writes in this chat. Fork it to continue with your own connections. {value2}':
      'Vain {value1} voi kirjoittaa tähän chattiin. Haarauta se jatkaaksesi omilla yhteyksilläsi. {value2}',
    'Suggest a follow-up…': 'Ehdota jatkokysymystä…',
    'Suggest a follow-up': 'Ehdota jatkokysymystä',
    'Sending…': 'Lähetetään…',
    Send: 'Lähetä',
    'We could not dismiss that suggestion. Please try again.':
      'Ehdotusta ei voitu hylätä. Yritä uudelleen.',
    'Suggested follow-ups': 'Ehdotetut jatkokysymykset',
    '{value1} suggests': '{value1} ehdottaa',
    Ask: 'Kysy',
    'Dismiss {value1}’s suggestion': 'Hylkää käyttäjän {value1} ehdotus',
    'Suggested by': 'Ehdottaja',
    '· edit it or send it': '· muokkaa tai lähetä se',
    'Remove the suggestion tag': 'Poista ehdotustunniste',
    '{value1} {value2} is getting an answer': '{value1} {value2} saa vastausta',
    '{value1} {value2} stopped the answer': '{value1} {value2} keskeytti vastauksen',
    '{value1} Fork from here': '{value1} Haarauta tästä',
    '{value1} From {value2}’s {value3}': '{value1} Käyttäjän {value2} {value3}',
    'Only {value1} can use this account': 'Vain {value1} voi käyttää tätä tiliä',
    '{value1} Suggested by {value2}': '{value1} Ehdottaja: {value2}',
    'Fork this chat': 'Haarauta tämä chat',
    'Forking…': 'Haarautetaan…',
    Fork: 'Haarauta',
    'Could not make this private.': 'Tästä ei voitu tehdä yksityistä.',
    'Make this chat private?': 'Tehdäänkö tästä chatista yksityinen?',
    Close: 'Sulje',
    '{value1} will see “{value2}”. Everyone else loses access right away {value3} .{value4}':
      '{value1} näkee kohteen ”{value2}”. Kaikki muut menettävät käyttöoikeuden heti {value3} .{value4}',
    Cancel: 'Peruuta',
    'Saving…': 'Tallennetaan…',
    'Make private': 'Tee yksityiseksi',
    'This chat is private again. Forks others made stay theirs.':
      'Tämä chat on jälleen yksityinen. Muiden tekemät haarat säilyvät heidän omina kopioinaan.',
    'Who can read this chat: {value1}': 'Ketkä voivat lukea tämän chatin: {value1}',
    'Move this chat': 'Siirrä tämä chat',
    'Only you write here. Others follow live and fork.':
      'Vain sinä kirjoitat täällä. Muut seuraavat reaaliajassa ja haarauttavat chatin.',
    'Made private. {value1} has been told in their Inbox.':
      'Tehty yksityiseksi. Käyttäjälle {value1} on ilmoitettu asiasta Saapuneet-kansiossa.',
    'Chat access': 'Chatin käyttöoikeus',
    '{value1}’s chat. As an admin you can make it private.':
      'Käyttäjän {value1} chat. Järjestelmänvalvojana voit tehdä siitä yksityisen.',
    'Only {value1} will see it. {value2} is told.':
      'Vain {value1} näkee sen. Käyttäjälle {value2} ilmoitetaan asiasta.',
    '{value1} {value2} following': '{value1} {value2} seuraa',
    'Forked from{value1} {value2} . The history is copied. From here, tools run with your own access.':
      'Haarautettu kohteesta{value1} {value2} . Historia kopioidaan. Tästä eteenpäin työkalut toimivat omilla käyttöoikeuksillasi.',
    '{value1} made this chat private': 'Käyttäjä {value1} teki tästä chatista yksityisen',
    'You can no longer open it. Any fork you made stays yours.':
      'Et voi enää avata sitä. Kaikki tekemäsi haarat säilyvät sinulla.',
    'Start a new chat': 'Aloita uusi chat',
    'Back to Recent chats': 'Takaisin viimeisimpiin chatteihin',
    'More chat actions': 'Lisää chat-toimintoja',
    'Close conversation sharing': 'Sulje keskustelun jakaminen',
    'Review the text before saving a private copy to Library. Then choose its audience. Your original conversation and future messages stay private.':
      'Tarkista teksti ennen yksityisen kopion tallentamista Kirjastoon. Valitse sen jälkeen kohderyhmä. Alkuperäinen keskustelusi ja tulevat viestit pysyvät yksityisinä.',
    'Preparing the conversation…': 'Valmistellaan keskustelua…',
    'Refresh preview': 'Päivitä esikatselu',
    'The copy is saved in Library. Use Share to choose who can access it.':
      'Kopio on tallennettu Kirjastoon. Valitse Jaa-toiminnolla, kenellä on siihen käyttöoikeus.',
    'Save this copy': 'Tallenna tämä kopio',
    'That Skill could not be opened.': 'Taitoa ei voitu avata.',
    '{value1}{value2} · reviews and approvals': '{value1}{value2} · tarkistukset ja hyväksynnät',
    'Open Inbox': 'Avaa Saapuneet',
    'New at {value1} this week': 'Uutta kohteessa {value1} tällä viikolla',
    'Nothing new this week. Shared work, published Skills and approved knowledge show up here.':
      'Tällä viikolla ei ole uutta. Jaettu työ, julkaistut taidot ja hyväksytty tieto näkyvät täällä.',
    'New at {value1}': 'Uutta kohteessa {value1}',
    'This Skill is unavailable. Try again.': 'Tämä taito ei ole käytettävissä. Yritä uudelleen.',
    'You can attach up to {value1} files. Remove an attachment to add another.':
      'Voit liittää enintään {value1} tiedostoa. Poista liite, jotta voit lisätä toisen.',
    'Add company context': 'Lisää yrityksen konteksti',
    'Add company context · @': 'Lisää yrityksen konteksti · @',
    'Choose a Skill': 'Valitse taito',
    'Choose a Skill · /': 'Valitse taito · /',
    context: 'konteksti',
    skills: 'taidot',
    'Choose company context': 'Valitse yrityksen konteksti',
    'Skills for this conversation': 'Taidot tätä keskustelua varten',
    'Bring context into the conversation': 'Tuo konteksti keskusteluun',
    'Close context picker': 'Sulje kontekstinvalitsin',
    'Filter company context': 'Suodata yrityksen kontekstia',
    'Find a Skill…': 'Etsi taitoa…',
    'Find a file…': 'Etsi tiedostoa…',
    'Available company context': 'Saatavilla oleva yrityksen konteksti',
    'No matching published Skills.': 'Vastaavia julkaistuja taitoja ei löytynyt.',
    'No matching files.': 'Vastaavia tiedostoja ei löytynyt.',
    'Searching company work…': 'Haetaan yrityksen työstä…',
    'Try search again': 'Yritä hakea uudelleen',
    'Meaning search is temporarily limited. Showing available text matches.':
      'Merkityshaku on tilapäisesti rajoitettu. Näytetään saatavilla olevat tekstiosumat.',
    'Load more matches': 'Lataa lisää osumia',
    '{value1} files attached. Remove an attachment to add another. Saved Skill references are included separately.':
      '{value1} tiedostoa liitetty. Poista liite, jos haluat lisätä uuden. Tallennettujen taitojen viitteet sisällytetään erikseen.',
    'Create a Skill in chat': 'Luo taito keskustelussa',
    'Upload a company file': 'Lataa yrityksen tiedosto',
    'Company knowledge is always available to Poneva.':
      'Yrityksen tietämys on aina Ponevan käytettävissä.',
    '{value1} was not connected': 'Kohdetta {value1} ei yhdistetty',
    Dismiss: 'Ohita',
    'Try connecting again': 'Yritä yhdistää uudelleen',
    Waiting: 'Odotetaan',
    Connected: 'Yhdistetty',
    'Needs reconnecting': 'Yhdistäminen uudelleen tarvitaan',
    Connect: 'Yhdistä',
    '{value1}{value2} The provider’s account permissions still apply.':
      '{value1}{value2} Palveluntarjoajan tilin käyttöoikeudet ovat edelleen voimassa.',
    'Last error: {value1}': 'Viimeisin virhe: {value1}',
    '{value1} {value2} ready.': '{value1} {value2} on valmis.',
    'Continue with my Meta app': 'Jatka Meta-sovelluksellani',
    Reconnect: 'Yhdistä uudelleen',
    Disconnect: 'Katkaise yhteys',
    'Remove attachment: {value1}': 'Poista liite: {value1}',
    'Saved in this Skill. Edit the Skill to change its references.':
      'Tallennettu tähän taitoon. Muokkaa taitoa muuttaaksesi sen viitteitä.',
    'Remove Skill context': 'Poista taidon konteksti',
    Refining: 'Viimeistellään',
    Previewing: 'Esikatsellaan',
    Using: 'Käytetään',
    'Skill revision {value1}': 'Taidón versio {value1}',
    'a new Skill': 'uusi taito',
    '{value1} Making a new agent {value2}': '{value1} Luodaan uusi agentti {value2}',
    'Stop making a new agent in this chat': 'Lopeta uuden agentin luominen tässä keskustelussa',
    'Saved Skill references': 'Tallennetut taitojen viitteet',
    'Included with Skill · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}':
      'Sisältyy taitoon · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}',
    'Selected Skill revision is unavailable. Select the Skill again to view its saved references.':
      'Valittu taidon versio ei ole saatavilla. Valitse taito uudelleen nähdäksesi sen tallennetut viitteet.',
    'Conversation attachments': 'Keskustelun liitteet',
    'Added for this conversation': 'Lisätty tätä keskustelua varten',
    'Selected passage {value1}': 'Valittu kohta {value1}',
    'We could not load your workspace.': 'Työtilaasi ei voitu ladata.',
    'The selected Skill is unavailable. Check its access or choose it again.':
      'Valittu taito ei ole saatavilla. Tarkista sen käyttöoikeus tai valitse se uudelleen.',
    'Source saved privately and included in your knowledge search.':
      'Lähde tallennettiin yksityisesti ja sisällytettiin tietämystä koskevaan hakuusi.',
    'File saved privately to your library and attached to this message.':
      'Tiedosto tallennettiin yksityisesti kirjastoosi ja liitettiin tähän viestiin.',
    'File saved privately to your library.': 'Tiedosto tallennettiin yksityisesti kirjastoosi.',
    '{value1} {value2} earlier {value3} saved{value4}.':
      '{value1} {value2} aiemmin {value3} tallennettu{value4}.',
    'Extracted text for Poneva to read. Download the original for its layout, charts and images. Spreadsheet formulas show their saved results and are not recalculated.':
      'Ponevan luettavaksi poimittu teksti. Lataa alkuperäinen tiedosto nähdäksesi sen asettelun, kaaviot ja kuvat. Laskentataulukon kaavat näyttävät tallennetut tuloksensa, eikä niitä lasketa uudelleen.',
    Esc: 'Esc',
    'Start something': 'Aloita jotain',
    'Choose a file to work with': 'Valitse tiedosto, jonka parissa haluat työskennellä',
    'Skills worth adding': 'Lisäämisen arvoiset taidot',
    'Picked for you': 'Valittu sinulle',
    'Reusable work grounded in your company knowledge.':
      'Uudelleenkäytettävää työtä yrityksesi tietämyksen pohjalta.',
    'Ideas from your company context and recent work. Pick one to start.':
      'Ideoita yrityksesi kontekstista ja viimeaikaisesta työstä. Valitse yksi aloittaaksesi.',
    'Refresh suggested tasks': 'Päivitä ehdotetut tehtävät',
    'Check for new company context.': 'Tarkista uusi yrityksen konteksti.',
    'Check for new context. Ideas also refresh daily.':
      'Tarkista uusi konteksti. Ideat päivittyvät myös päivittäin.',
    Refresh: 'Päivitä',
    'Finding useful starting points…': 'Etsitään hyödyllisiä lähtökohtia…',
    'Suggestions aren’t available right now. Try Refresh, or describe the work you want to do.':
      'Ehdotukset eivät ole juuri nyt saatavilla. Kokeile Päivitä-toimintoa tai kuvaile, mitä haluat tehdä.',
    'Loading the knowledge pages…': 'Ladataan tietämysivuja…',
    '{value1} All pages': '{value1} Kaikki sivut',
    'The page is created.': 'Sivu on luotu.',
    'Your new page is suggested. A publisher decides whether it is added.':
      'Uutta sivuasi ehdotetaan. Julkaisija päättää, lisätäänkö se.',
    'Company knowledge': 'Yrityksen tietämys',
    'What Poneva knows about your company, page by page. Every change is kept.':
      'Mitä Poneva tietää yrityksestäsi sivu sivulta. Jokainen muutos säilytetään.',
    'Loading company knowledge…': 'Ladataan yrityksen tietämystä…',
    'Knowledge pages are not enabled in this workspace.':
      'Tietämysivuja ei ole otettu käyttöön tässä työtilassa.',
    'Ask your Poneva contact to switch them on for your company.':
      'Pyydä Poneva-yhteyshenkilöäsi ottamaan ne käyttöön yrityksessäsi.',
    '{value1} Change the agent': '{value1} Vaihda agenttia',
    '{value1} Continue in chat': '{value1} Jatka keskustelussa',
    Edit: 'Muokkaa',
    '{value1} Edit with chat': '{value1} Muokkaa chatissa',
    '{value1} Duplicate to my Library': '{value1} Kopioi kirjastooni',
    'Duplicated to your Library. Only you can see the copy.':
      'Kopioitu kirjastoosi. Vain sinä näet kopion.',
    'Could not duplicate this Result. Try again.':
      'Tätä tulosta ei voitu kopioida. Yritä uudelleen.',
    'Saved version {value1}.': 'Versio {value1} tallennettu.',
    'A newer version was saved. Reload the Result before saving.':
      'Uudempi versio on tallennettu. Lataa tulos uudelleen ennen tallentamista.',
    'Could not save this version. Try again.': 'Tätä versiota ei voitu tallentaa. Yritä uudelleen.',
    '{value1} saved a newer version. Review it before saving.':
      '{value1} tallensi uudemman version. Tarkista se ennen tallentamista.',
    'Hide their version': 'Piilota heidän versionsa',
    'Show their version': 'Näytä heidän versionsa',
    'Start from their version': 'Aloita heidän versiostaan',
    Markdown: 'Markdown',
    'Result text': 'Tuloksen teksti',
    Preview: 'Esikatselu',
    'What changed': 'Mitä muuttui',
    'What changed? (optional)': 'Mitä muuttui? (valinnainen)',
    'Save version {value1}': 'Tallenna versio {value1}',
    'Open chat': 'Avaa chat',
    Current: 'Nykyinen',
    Restore: 'Palauta',
    'Could not load the history.': 'Historiaa ei voitu ladata.',
    'Restored version {value1} as version {value2}.':
      'Versio {value1} palautettiin versioksi {value2}.',
    'Someone saved a newer version. Review it before restoring.':
      'Joku tallensi uudemman version. Tarkista se ennen palauttamista.',
    'Could not restore that version.': 'Tätä versiota ei voitu palauttaa.',
    'Loading history…': 'Ladataan historiaa…',
    'Restoring keeps what is there now as a version too, so nothing is lost.':
      'Palauttaminen säilyttää nykyisen sisällön myös versiona, joten mitään ei menetetä.',
    'This Result was made with your own {value1}.':
      'Tämä tulos luotiin omalla kohteellasi {value1}.',
    'It also used': 'Se käytti myös',
    'This Result was made with': 'Tämä tulos luotiin käyttäen',
    'Colleagues can read what came from them, but can never use them.':
      'Työkaverit voivat lukea heidän lähteistään peräisin olevan sisällön, mutta eivät voi koskaan käyttää niitä.',
    'Your personal agent {value1} keeps it up to date with your own access, so every refresh can carry your private data.':
      'Henkilökohtainen agenttisi {value1} pitää sen ajan tasalla omilla käyttöoikeuksillasi, joten jokainen päivitys voi sisältää yksityisiä tietojasi.',
    'A colleague’s personal agent keeps it up to date with their own access, so every refresh can carry their private data.':
      'Työkaverin henkilökohtainen agentti pitää sen ajan tasalla omilla käyttöoikeuksillaan, joten jokainen päivitys voi sisältää hänen yksityisiä tietojaan.',
    'Made private. Only you can see this meeting.':
      'Muutettu yksityiseksi. Vain sinä näet tämän kokouksen.',
    'Could not make this meeting private.': 'Tätä kokousta ei voitu muuttaa yksityiseksi.',
    'Meeting · {value1} {value2} · Original retained':
      'Kokous · {value1} {value2} · Alkuperäinen säilytetty',
    'The recording could not be opened.': 'Tallennetta ei voitu avata.',
    'Ask about this suggestion': 'Kysy tästä ehdotuksesta',
    meeting_processing_failed: 'kokouksen käsittely epäonnistui',
    'Who can see this': 'Kuka näkee tämän',
    'Everyone at {value1}': 'Kaikki organisaatiossa {value1}',
    'Only me': 'Vain minä',
    'Everyone at {value1} can find it and ask about it.':
      'Kaikki organisaatiossa {value1} voivat löytää sen ja kysyä siitä.',
    'Only you can open and search this meeting. You can share it later.':
      'Vain sinä voit avata tämän kokouksen ja hakea siitä. Voit jakaa sen myöhemmin.',
    'Added. Only you can see it. Transcription is running in the background.':
      'Lisätty. Vain sinä näet sen. Litterointi on käynnissä taustalla.',
    'Visible to everyone at {value1}': 'Näkyy kaikille organisaatiossa {value1}',
    'Could not make it private.': 'Sitä ei voitu muuttaa yksityiseksi.',
    'Show more meetings': 'Näytä lisää kokouksia',
    'Attached to this message': 'Liitetty tähän viestiin',
    'Connect securely, choose the tables to share, then decide whether Poneva can read or make changes.':
      'Muodosta suojattu yhteys, valitse jaettavat taulut ja päätä sitten, voiko Poneva lukea tai tehdä muutoksia.',
    'Review the tables this connection can access. Select at least one table.':
      'Tarkista taulut, joita tämä yhteys voi käyttää. Valitse vähintään yksi taulu.',
    'Select at least one table. Nothing is selected by default.':
      'Valitse vähintään yksi taulu. Mitään ei ole valittu oletuksena.',
    'Choose who can use this connection and what Poneva can do.':
      'Valitse, kuka voi käyttää tätä yhteyttä ja mitä Poneva voi tehdä.',
    'Your chosen access is enabled for the selected tables.':
      'Valitsemasi käyttöoikeudet on otettu käyttöön valituille tauluille.',
    'Your connection is saved with reading paused until permission is confirmed.':
      'Yhteytesi on tallennettu, mutta lukeminen on keskeytetty, kunnes käyttöoikeus vahvistetaan.',
    'Confirm database disconnect': 'Vahvista tietokannan yhteyden katkaiseminen',
    'Disconnect this database?': 'Katkaistaanko tämän tietokannan yhteys?',
    'Access will stop for everyone using this connection.':
      'Käyttö estetään kaikilta, jotka käyttävät tätä yhteyttä.',
    'Keep connection': 'Säilytä yhteys',
    'What it can reach · {value1}{value2} {value3}':
      'Mihin sillä on pääsy · {value1}{value2} {value3}',
    Back: 'Takaisin',
    Continue: 'Jatka',
    'Uploading…': 'Lähetetään…',
    Library: 'Kirjasto',
    'Source material for your work. Available whenever you need it.':
      'Työsi lähdemateriaali. Käytettävissä aina tarvittaessa.',
    'The work you want to keep, with its sources and conversation attached.':
      'Säilytettävä työ sekä siihen liitetyt lähteet ja keskustelu.',
    Results: 'Tulokset',
    Files: 'Tiedostot',
    Artifacts: 'Tuotokset',
    'Search library': 'Hae kirjastosta',
    'Find files by meaning…': 'Etsi tiedostoja merkityksen perusteella…',
    'Find saved work by meaning…': 'Etsi tallennettua työtä merkityksen perusteella…',
    'Search coverage is limited while indexing or meaning-based search is unavailable. You can retry or browse recent items.':
      'Haku kattaa vähemmän sisältöä indeksoinnin aikana tai kun merkitykseen perustuva haku ei ole käytettävissä. Voit yrittää uudelleen tai selata viimeisimpiä kohteita.',
    'No matching work found.': 'Vastaavaa työtä ei löytynyt.',
    'A starting point for your next question.': 'Lähtökohta seuraavalle kysymyksellesi.',
    'Good work is worth keeping.': 'Hyvä työ kannattaa säilyttää.',
    'Try a different description or clear the search to browse.':
      'Kokeile erilaista kuvausta tai tyhjennä haku selataksesi sisältöä.',
    'Upload source material once and use it in conversations and Skills. Your original stays in the library.':
      'Lataa lähdemateriaali kerran ja käytä sitä keskusteluissa ja taidoissa. Alkuperäinen säilyy kirjastossa.',
    'Ask Poneva to save an answer, table or chart. Results stay connected to the conversation and their sources.':
      'Pyydä Ponevaa tallentamaan vastaus, taulukko tai kaavio. Tulokset pysyvät yhteydessä keskusteluun ja niiden lähteisiin.',
    'Start in chat {value1}': 'Aloita chatissa {value1}',
    'Open result: {value1}': 'Avaa tulos: {value1}',
    'Loading more library items…': 'Ladataan lisää kirjaston kohteita…',
    'Load more': 'Lataa lisää',
    'Documents, transcripts, audio and video · Up to 500 MB per file. New files are private. Choose their audience with Share and which processable files become searchable company knowledge.':
      'Asiakirjat, tekstitykset, ääni ja video · Enintään 500 Mt tiedostoa kohden. Uudet tiedostot ovat yksityisiä. Valitse niiden yleisö kohdasta Jaa sekä ne käsiteltävissä olevat tiedostot, joista tulee haettavaa yrityksen tietämystä.',
    Skills: 'Taidot',
    'Create in chat': 'Luo keskustelussa',
    'Search Skills': 'Hae taitoja',
    'Search finds published Skills. Clear the search to browse your drafts too.':
      'Haku löytää julkaistut taidot. Tyhjennä haku selataksesi myös luonnoksiasi.',
    'Search coverage is limited while indexing or meaning-based search is unavailable.':
      'Haun kattavuus on rajallinen indeksoinnin aikana tai kun merkityspohjainen haku ei ole käytettävissä.',
    'Searching Skills…': 'Haetaan taitoja…',
    'No matching published Skills found. Try a different description.':
      'Sopivia julkaistuja taitoja ei löytynyt. Kokeile toisenlaista kuvausta.',
    'Load more Skills': 'Lataa lisää taitoja',
    'View Skill: {value1}': 'Näytä taito: {value1}',
    'Company workspace': 'Yrityksen työtila',
    'View {value1}': 'Näytä {value1}',
    'Loading Skills…': 'Ladataan taitoja…',
    'Try again {value1}': 'Yritä uudelleen {value1}',
    'Try again': 'Yritä uudelleen',
    'Nothing yet.': 'Ei vielä mitään.',
    'Made from · Used by': 'Perustuu · Käyttävät',
    'Could not load links': 'Linkkejä ei voitu ladata',
    'Made from': 'Perustuu',
    'Used by': 'Käyttävät',
    'About this chat {value1}': 'Tietoja tästä keskustelusta {value1}',
    'About this chat': 'Tietoja tästä keskustelusta',
    'Keep the work moving.': 'Pidä työ liikkeessä.',
    'Ask a follow-up with this result in view, or turn a useful approach into a company Skill.':
      'Esitä jatkokysymys tämän tuloksen pohjalta tai muunna hyödyllinen lähestymistapa yrityksen taidoksi.',
    'Save approach as a Skill': 'Tallenna lähestymistapa taidoksi',
    'Preview of': 'Esikatselu kohteesta',
    'Made with': 'Luotu käyttäen',
    'Open the draft': 'Avaa luonnos',
    'Open Skill': 'Avaa taito',
    'Use in chat': 'Käytä keskustelussa',
    'Finish the draft': 'Viimeistele luonnos',
    'Refine this Skill': 'Viimeistele tätä taitoa',
    'Made with a Skill.': 'Luotu taidon avulla.',
    'This workspace could not be loaded just now, so that Skill cannot be opened yet. The result itself is unchanged.':
      'Tätä työtilaa ei voitu juuri nyt ladata, joten kyseistä taitoa ei voi vielä avata. Tulos itsessään ei ole muuttunut.',
    'That Skill is not available in this workspace, so it cannot be opened or used again. The result itself is unchanged.':
      'Kyseinen taito ei ole käytettävissä tässä työtilassa, joten sitä ei voi avata tai käyttää uudelleen. Tulos itsessään ei ole muuttunut.',
    'Result · {value1} {value2}': 'Tulos · {value1} {value2}',
    '{value1} Copy link': '{value1} Kopioi linkki',
    'Result link copied.': 'Tuloksen linkki kopioitu.',
    'Could not copy the link. Use your browser address bar.':
      'Linkkiä ei voitu kopioida. Käytä selaimen osoiteriviä.',
    'No preview is available for this result.': 'Tästä tuloksesta ei ole saatavilla esikatselua.',
    '{value1} rows are retained in this snapshot. Open Table to inspect the values.':
      'Tässä tilannevedoksessa on säilytetty {value1} riviä. Avaa Taulukko tarkastellaksesi arvoja.',
    'People can’t edit a Result an agent keeps up to date; the next refresh would replace their edit. Change the agent’s instructions instead.':
      'Käyttäjät eivät voi muokata tulosta, jonka agentti pitää ajan tasalla; seuraava päivitys korvaisi heidän muokkauksensa. Muuta sen sijaan agentin ohjeita.',
    'Linked sources': 'Linkitetyt lähteet',
    'Saved source': 'Tallennettu lähde',
    'No source documents are linked to this result. Company knowledge and other references may be cited in the answer.':
      'Tähän tulokseen ei liity lähdeasiakirjoja. Vastauksessa voidaan viitata yrityksen tietämykseen ja muihin lähteisiin.',
    'Run details': 'Suorituksen tiedot',
    Created: 'Luotu',
    ', revised {value1}': ', muokattu {value1}',
    Conversation: 'Keskustelu',
    'Not recorded': 'Ei tallennettu',
    'Open conversation': 'Avaa keskustelu',
    Run: 'Suorita',
    Updates: 'Päivitykset',
    'Kept up to date by {value1}': '{value1} pitää ajan tasalla',
    'Version {value1}': 'Versio {value1}',
    'Could not open this request.': 'Pyyntöä ei voitu avata.',
    'Approved version published.': 'Hyväksytty versio julkaistu.',
    'Request rejected. The item stays unchanged.': 'Pyyntö hylättiin. Kohde säilyy ennallaan.',
    'Could not save the decision.': 'Päätöstä ei voitu tallentaa.',
    'Proposed company change': 'Ehdotettu yritysmuutos',
    'Opening…': 'Avataan…',
    'Approve this version': 'Hyväksy tämä versio',
    Decline: 'Hylkää',
    'Review the submitted version below. Changes made since submission will need a new request.':
      'Tarkista lähetetty versio alta. Lähettämisen jälkeen tehdyt muutokset edellyttävät uutta pyyntöä.',
    'The version submitted with this request.': 'Tämän pyynnön yhteydessä lähetetty versio.',
    'Version and proposed change': 'Versio ja ehdotettu muutos',
    'Could not read the pinned content.': 'Kiinnitettyä sisältöä ei voitu lukea.',
    'Showing a page of {value1} characters.': 'Näytetään sivu, jolla on {value1} merkkiä.',
    'Beginning of the submitted content. Open the full text to review every page.':
      'Lähetetyn sisällön alku. Avaa koko teksti tarkistaaksesi jokaisen sivun.',
    'Read full submitted text': 'Lue lähetetty teksti kokonaan',
    'Previous page': 'Edellinen sivu',
    'Next page': 'Seuraava sivu',
    'Made private. Its creator has been told in their Inbox.':
      'Muutettu yksityiseksi. Sen luojalle on ilmoitettu Saapuneet-kansiossa.',
    'Made private. Its creator could not be notified.':
      'Muutettu yksityiseksi. Sen luojalle ei voitu ilmoittaa.',
    'Make this {value1} private?': 'Muutetaanko tämä yksityiseksi: {value1}?',
    'Only the person who created it will see it. Everyone else loses access right away, and its creator gets an Inbox update if they are still a company member. If they have left, nobody in the company will be able to access this item.':
      'Vain sen luonut henkilö näkee sen. Kaikki muut menettävät käyttöoikeuden heti, ja luoja saa päivityksen Saapuneet-kansioon, jos hän on edelleen yrityksen jäsen. Jos hän on lähtenyt, kukaan yrityksessä ei voi käyttää tätä kohdetta.',
    'Sent for review. The current audience stays unchanged until approval.':
      'Lähetetty tarkistettavaksi. Nykyinen yleisö säilyy muuttumattomana hyväksyntään asti.',
    'Could not update sharing.': 'Jakamisen päivitys epäonnistui.',
    'They can follow new answers live and fork it to continue with their own connections. Only you write here. You can make it private again at any time.':
      'He voivat seurata uusia vastauksia reaaliajassa ja haarauttaa tämän jatkaakseen omilla yhteyksillään. Vain sinä voit kirjoittaa tänne. Voit muuttaa tämän jälleen yksityiseksi milloin tahansa.',
    'They see the project, its brief and the work in it they can already open. Nothing in it opens for anyone because of the project; each item keeps its own access.':
      'He näkevät projektin, sen tiivistelmän ja siinä olevan työn, jonka he voivat jo avata. Projekti ei anna kenellekään pääsyä mihinkään uuteen; jokaisella kohteella on omat käyttöoikeutensa.',
    'Check the content for private information before sharing. Sharing an item does not grant access to its original chat or private connections.':
      'Tarkista sisältö yksityisten tietojen varalta ennen jakamista. Kohteen jakaminen ei anna pääsyä sen alkuperäiseen keskusteluun tai yksityisiin yhteyksiin.',
    '{value1} Everyone you share with can read it, including what the assistant or an App in it found in your {value2}. They can’t use your {value3}. Nothing changes for you: the chat keeps working with all your accounts.':
      '{value1} Kaikki, joiden kanssa jaat tämän, voivat lukea sen, mukaan lukien sen, mitä siinä oleva avustaja tai sovellus löysi kohteesta {value2}. He eivät voi käyttää kohdetta {value3}. Sinulle mikään ei muutu: keskustelu toimii edelleen kaikilla tileilläsi.',
    '{value1} Everyone you share with can read them, but nobody can use {value2} through this chat.':
      '{value1} Kaikki, joiden kanssa jaat nämä, voivat lukea ne, mutta kukaan ei voi käyttää kohdetta {value2} tämän keskustelun kautta.',
    'This controls access to the working draft. Any published company version stays available until you explicitly unpublish it. To publish a new version, complete its preview and use Save Skill. Run results stay private.':
      'Tämä hallitsee työn alla olevan luonnoksen käyttöoikeuksia. Julkaistu yritysversio pysyy saatavilla, kunnes poistat sen julkaisusta erikseen. Julkaise uusi versio viimeistelemällä sen esikatselu ja valitsemalla Tallenna taito. Suoritusten tulokset pysyvät yksityisinä.',
    'Skill deleted. You can restore it from the Skills archive for 30 days.':
      'Taito poistettu. Voit palauttaa sen Taitojen arkistosta 30 päivän ajan.',
    'Could not delete this Skill.': 'Taidon poistaminen epäonnistui.',
    'More actions': 'Lisää toimintoja',
    'Delete “{value1}”? It will disappear from Skills and search, and cannot be used by agents. You can restore it for 30 days. Existing chats and results stay available.':
      'Poistetaanko ”{value1}”? Se poistuu Taidoista ja hausta, eivätkä agentit voi käyttää sitä. Voit palauttaa sen 30 päivän ajan. Olemassa olevat keskustelut ja tulokset säilyvät saatavilla.',
    'Deleting…': 'Poistetaan…',
    'Confirm delete': 'Vahvista poisto',
    'Delete Skill': 'Poista taito',
    'Skill restored as an unpublished draft. Its author can review and publish it again.':
      'Taito palautettiin julkaisemattomana luonnoksena. Sen tekijä voi tarkistaa sen ja julkaista sen uudelleen.',
    'Could not restore this Skill.': 'Taidon palauttaminen epäonnistui.',
    'Archived Skills': 'Arkistoidut taidot',
    'Deleted Skills can be restored for 30 days. Restoring leaves them unpublished.':
      'Poistetut taidot voi palauttaa 30 päivän ajan. Palautetut taidot pysyvät julkaisemattomina.',
    'Restore until {value1}': 'Palauta viimeistään {value1}',
    'Loading…': 'Ladataan…',
    'No archived Skills.': 'Ei arkistoituja taitoja.',
    'Load more archived Skills': 'Lataa lisää arkistoituja taitoja',
    'Show more of the original': 'Näytä lisää alkuperäisestä',
    'Filter result rows': 'Suodata tulosrivejä',
    'Find a product or value…': 'Etsi tuotetta tai arvoa…',
    '{value1} of {value2}': '{value1} / {value2}',
    'Result table': 'Tulostaulukko',
    'No matching rows.': 'Vastaavia rivejä ei löytynyt.',
    'Showing the first 1,000 matching rows. Download the CSV for every row.':
      'Näytetään ensimmäiset 1 000 vastaavaa riviä. Lataa CSV nähdäksesi kaikki rivit.',
    'Agent ·': 'Agentti ·',
    'Only you': 'Vain sinä',
    'Stopped before it finished.': 'Pysäytetty ennen valmistumista.',
    'Drafting the project…': 'Laaditaan projektin luonnosta…',
    'Checking where this chat belongs…': 'Tarkistetaan, mihin tämä keskustelu kuuluu…',
    'Moving the chat…': 'Siirretään keskustelua…',
    'Taking it out of the project…': 'Poistetaan keskustelu projektista…',
    'Adding it to the project…': 'Lisätään keskustelu projektiin…',
    'No matching connections are available right now.':
      'Vastaavia yhteyksiä ei ole tällä hetkellä saatavilla.',
    'Company knowledge suggestion': 'Yrityksen tietopohjaehdotus',
    'Company knowledge now lives on pages. Open Knowledge to see them.':
      'Yrityksen tietopohja on nyt sivuilla. Avaa Tietopohja nähdäksesi ne.',
    '{value1} · Open beside this conversation': '{value1} · Avaa tämän keskustelun viereen',
    'Name {value1}': 'Nimi {value1}',
    'Host {value1}': 'Isäntä {value1}',
    'Port {value1}': 'Portti {value1}',
    'Database {value1}': 'Tietokanta {value1}',
    'Username {value1}': 'Käyttäjänimi {value1}',
    'Password {value1}': 'Salasana {value1}',
    'Advanced TLS': 'TLS-lisäasetukset',
    '{value1} Poneva verifies the server certificate. Add a CA or server DNS name for IP hosts when your certificate requires it.':
      '{value1} Poneva vahvistaa palvelimen varmenteen. Lisää varmenteen myöntäjä tai palvelimen DNS-nimi IP-isännille, jos varmenteesi sitä edellyttää.',
    'CA certificate {value1}': 'Varmenteen myöntäjän varmenne {value1}',
    'Certificate server DNS name {value1}': 'Varmenteen palvelimen DNS-nimi {value1}',
    '{value1} Your password is encrypted in secure storage. Poneva verifies the connection before saving it.':
      '{value1} Salasanasi salataan suojatussa tallennustilassa. Poneva vahvistaa yhteyden ennen sen tallentamista.',
    'Testing…': 'Testataan…',
    'Test connection': 'Testaa yhteys',
    'PostgreSQL is connected.': 'PostgreSQL on yhdistetty.',
    'PostgreSQL was saved safely.': 'PostgreSQL tallennettiin turvallisesti.',
    'Poneva can read and change rows in the selected tables. Apps also follow their approved data scope.':
      'Poneva voi lukea valittujen taulujen rivejä ja muuttaa niitä. Sovellukset noudattavat myös niille hyväksyttyä tietojen käyttöaluetta.',
    'Poneva can read the selected tables. Apps also follow their approved data scope.':
      'Poneva voi lukea valittuja tauluja. Sovellukset noudattavat myös niille hyväksyttyä tietojen käyttöaluetta.',
    'Reads are paused until permission is enabled.':
      'Lukeminen on keskeytetty, kunnes käyttöoikeus otetaan käyttöön.',
    'Retrying…': 'Yritetään uudelleen…',
    'Retry permission': 'Yritä käyttöoikeutta uudelleen',
    'Try it in Chat': 'Kokeile keskustelussa',
    Done: 'Valmis',
    'Disconnect database': 'Katkaise tietokantayhteys',
    '{value1} TLS verified ·{value2} {value3}': '{value1} TLS vahvistettu ·{value2} {value3}',
    'Search schemas and tables': 'Hae skeemoista ja tauluista',
    'Search tables': 'Hae tauluista',
    '{value1} of {value2} tables selected': '{value1} / {value2} taulua valittu',
    'Select matching tables': 'Valitse vastaavat taulut',
    'Select all tables': 'Valitse kaikki taulut',
    Clear: 'Tyhjennä',
    'Select a whole schema or individual tables. New tables need a fresh selection.':
      'Valitse koko skeema tai yksittäisiä tauluja. Uudet taulut on valittava uudelleen.',
    'No tables match this search.': 'Haku ei vastaa yhtään taulua.',
    'All tables in {value1}': 'Kaikki kohteen {value1} taulut',
    '{value1} / {value2} tables': '{value1} / {value2} taulua',
    'Read & write available': 'Luku ja kirjoitus käytettävissä',
    'Read only': 'Vain luku',
    Ctrl: 'Ctrl',
    'This suggested knowledge update could not be shown.':
      'Ehdotettua tietopohjan päivitystä ei voitu näyttää.',
    'Suggested knowledge update': 'Ehdotettu tietopohjan päivitys',
    'This suggestion is no longer available to you.': 'Tämä ehdotus ei ole enää käytettävissäsi.',
    'We could not check where this suggestion stands.':
      'Emme voineet tarkistaa tämän ehdotuksen tilaa.',
    'Check again': 'Tarkista uudelleen',
    'Show on page': 'Näytä sivulla',
    'The editor could not be loaded. Poneva may have been updated since you opened this page. Reload to get the latest version; nothing on this page has changed.':
      'Muokkausta ei voitu ladata. Poneva on ehkä päivitetty sen jälkeen, kun avasit tämän sivun. Lataa uusin versio uudelleen. Mikään tällä sivulla ei ole muuttunut.',
    'Reload Poneva': 'Lataa Poneva uudelleen',
    Formatting: 'Muotoilu',
    'Text style': 'Tekstin tyyli',
    Text: 'Teksti',
    Heading: 'Otsikko',
    Subheading: 'Alaotsikko',
    'Link a page': 'Linkitä sivu',
    'A page needs a title.': 'Sivulla täytyy olla otsikko.',
    'Nothing has changed yet.': 'Mikään ei ole vielä muuttunut.',
    'A page needs some text. To remove a page, archive it instead.':
      'Sivulla täytyy olla tekstiä. Jos haluat poistaa sivun, arkistoi se.',
    'A suggested new page needs some text.': 'Ehdotetulla uudella sivulla täytyy olla tekstiä.',
    'This page is larger than 256 KB. Split it into smaller pages.':
      'Tämä sivu on suurempi kuin 256 kt. Jaa se pienemmiksi sivuiksi.',
    'Say in a few words why this change is right.':
      'Kerro muutamalla sanalla, miksi tämä muutos on oikea.',
    'This page changed while you were editing. Your text is still here: copy it, then open the latest version and make your change again.':
      'Tämä sivu muuttui muokkauksen aikana. Tekstisi on yhä tässä: kopioi se, avaa uusin versio ja tee muutoksesi uudelleen.',
    'Your text is copied.': 'Tekstisi on kopioitu.',
    'Your text could not be copied. Select it in the editor and copy it.':
      'Tekstiäsi ei voitu kopioida. Valitse se muokkausnäkymässä ja kopioi se.',
    'The page “{value1}” is created.': 'Sivu ”{value1}” on luotu.',
    'New page': 'Uusi sivu',
    'Editing {value1}': 'Muokataan: {value1}',
    Editing: 'Muokataan',
    'Creating publishes the page under {value1} for everyone':
      'Luominen julkaisee sivun kohdan {value1} alle kaikkien nähtäväksi',
    'Saving publishes the new version for everyone':
      'Tallentaminen julkaisee uuden version kaikkien nähtäväksi',
    'Your changes are sent as a suggestion for a publisher':
      'Muutoksesi lähetetään ehdotuksena julkaisijalle',
    'Create page': 'Luo sivu',
    Save: 'Tallenna',
    'Send suggestion': 'Lähetä ehdotus',
    '{value1} Copy my text': '{value1} Kopioi tekstini',
    'Open the latest version': 'Avaa uusin versio',
    'Page title': 'Sivun otsikko',
    'Loading the editor…': 'Ladataan muokkausnäkymää…',
    'New page text': 'Uuden sivun teksti',
    'Text of {value1}': 'Kohteen {value1} teksti',
    'Write the page. Type [[ to link another page.':
      'Kirjoita sivu. Linkitä toinen sivu kirjoittamalla [[.',
    'Type [[ to link another page.': 'Linkitä toinen sivu kirjoittamalla [[.',
    'Link to a page': 'Linkki sivulle',
    'What changed, in a few words': 'Mikä muuttui, muutamalla sanalla',
    'Where this comes from, in a few words': 'Mistä tämä on peräisin, muutamalla sanalla',
    'Shown in the page history.': 'Näytetään sivun historiassa.',
    'A publisher sees this next to your change.': 'Julkaisija näkee tämän muutoksesi vieressä.',
    '1 suggestion is open on this page': 'Sivulla on 1 avoin ehdotus',
    '{value1} suggestions are open on this page': 'Sivulla on avoinna {value1} ehdotusta',
    'They stay open while you edit. After you save, they show against your new text; one whose words you changed is marked outdated.':
      'Ne pysyvät avoimina muokkauksen aikana. Tallennuksen jälkeen ne näkyvät uuden tekstisi yhteydessä; ehdotus, jonka sanoja muutit, merkitään vanhentuneeksi.',
    'Type [[ to link another page. Links keep working when a page is renamed or moved.':
      'Linkitä toinen sivu kirjoittamalla [[. Linkit toimivat edelleen, vaikka sivu nimetään uudelleen tai siirretään.',
    'Loading the history…': 'Ladataan historiaa…',
    'This page has no saved text yet.': 'Tälle sivulle ei ole vielä tallennettu tekstiä.',
    'Say in a few words why this revision should come back.':
      'Kerro muutamalla sanalla, miksi tämä versio pitäisi palauttaa.',
    'Revision {value1} is suggested for a publisher to accept.':
      'Versiota {value1} ehdotetaan julkaisijan hyväksyttäväksi.',
    'The page already reads like this revision.': 'Sivu vastaa jo tätä versiota.',
    'Revision {value1} is restored as revision {value2}.':
      'Versio {value1} palautetaan versioksi {value2}.',
    'Revision history': 'Versiohistoria',
    Revisions: 'Versiot',
    'Every saved revision is kept.': 'Jokainen tallennettu versio säilytetään.',
    'Revision {value1} {value2}': 'Versio {value1} {value2}',
    'Revision {value1} compared with revision {value2}':
      'Versio {value1} verrattuna versioon {value2}',
    'Revision {value1}, the first text of this page':
      'Versio {value1}, tämän sivun ensimmäinen teksti',
    'Green was added, struck through was removed.': 'Vihreä lisättiin, yliviivattu poistettiin.',
    '{value1} Export Markdown': '{value1} Vie Markdownina',
    'Restore this revision': 'Palauta tämä versio',
    'Suggest restoring it': 'Ehdota sen palauttamista',
    'Why should this revision come back?': 'Miksi tämä versio pitäisi palauttaa?',
    'Loading this revision…': 'Ladataan tätä versiota…',
    'Only the title changed, from “{value1}” to “{value2}”.':
      'Vain otsikko muuttui: ”{value1}” → ”{value2}”.',
    'The text did not change in this revision.': 'Teksti ei muuttunut tässä versiossa.',
    'Changes in revision {value1}': 'Version {value1} muutokset',
    'Loading page…': 'Ladataan sivua…',
    'Loading suggestion…': 'Ladataan ehdotusta…',
    'This suggestion is not available.': 'Tämä ehdotus ei ole käytettävissä.',
    'It may have been decided, or it is not one you can see.':
      'Se on ehkä jo käsitelty, tai sinulla ei ole oikeutta nähdä sitä.',
    'Open Knowledge': 'Avaa tietämys',
    'Opening the suggestion…': 'Avataan ehdotusta…',
    'Choose where the page goes.': 'Valitse, mihin sivu sijoitetaan.',
    'Say in a few words why.': 'Kerro muutamalla sanalla miksi.',
    'Your suggestion is sent. A publisher decides.':
      'Ehdotuksesi on lähetetty. Julkaisija päättää.',
    'Moved under {value1}.': 'Siirretty kohdan {value1} alle.',
    'Deleted “{value1}”.': 'Poistettu: ”{value1}”.',
    'Suggestion {value1} of {value2}': 'Ehdotus {value1}/{value2}',
    'Next suggestion': 'Seuraava ehdotus',
    'Fold the suggestions away': 'Piilota ehdotukset',
    'Show the suggestions': 'Näytä ehdotukset',
    '1 suggestion': '1 ehdotus',
    '{value1} suggestions': '{value1} ehdotusta',
    '{value1} the pages under {value2}': '{value1} sivua kohteessa {value2}',
    px: 'px',
    '{value1} chart of {value2} across {value3}': '{value1} kaavio: {value2} kohteessa {value3}',
    'We could not build the file.': 'Tiedostoa ei voitu luoda.',
    '{value1} Present': '{value1} läsnä',
    'Building…': 'Luodaan…',
    'Download PowerPoint': 'Lataa PowerPoint',
    'Slide {value1} of {value2}': 'Dia {value1}/{value2}',
    Slides: 'Diat',
    'Slide {value1}': 'Dia {value1}',
    'Speaker notes': 'Esittäjän muistiinpanot',
    'Source: {value1}': 'Lähde: {value1}',
    'Add a name and a web address.': 'Lisää nimi ja verkko-osoite.',
    'Enter a valid web address.': 'Anna kelvollinen verkko-osoite.',
    'Use a web address that starts with https://.':
      'Käytä verkko-osoitetta, joka alkaa merkkijonolla https://.',
    'Add a custom connection': 'Lisää mukautettu yhteys',
    'Connect a tool server you trust. Poneva checks the address works and saves only the connection details needed to use it.':
      'Yhdistä luotettavaan työkalupalvelimeen. Poneva tarkistaa, että osoite toimii, ja tallentaa vain sen käyttämiseen tarvittavat yhteystiedot.',
    'Web address': 'Verkko-osoite',
    'https://tools.example.com': 'https://tools.example.com',
    'Starts with https://, from your provider':
      'Alkaa merkkijonolla https://, palveluntarjoajaltasi',
    'Sign-in': 'Kirjautuminen',
    'Advanced sign-in': 'Kehittynyt kirjautuminen',
    'Access key {value1}': 'Käyttöavain {value1}',
    'Request headers': 'Pyyntöotsakkeet',
    'Add header': 'Lisää otsake',
    'Header {value1} name': 'Otsakkeen {value1} nimi',
    'Header name': 'Otsakkeen nimi',
    'Header {value1} value': 'Otsakkeen {value1} arvo',
    'Header value': 'Otsakkeen arvo',
    'Remove header': 'Poista otsake',
    Advanced: 'Lisäasetukset',
    Transport: 'Siirtoprotokolla',
    'Auto-detect': 'Tunnista automaattisesti',
    'Streamable HTTP': 'Streamable HTTP',
    'Legacy SSE': 'Vanha SSE',
    "From your provider's app settings. Leave empty unless they gave you these.":
      'Palveluntarjoajasi sovelluksen asetuksista. Jätä tyhjäksi, ellei palveluntarjoaja ole antanut näitä tietoja.',
    "Authorization server issuer": "Valtuutuspalvelimen myöntäjä",
    "Enter the authorization server issuer when using a client ID.": "Anna valtuutuspalvelimen myöntäjä, kun käytät asiakastunnusta.",
    'Client ID {value1}': 'Asiakastunnus {value1}',
    'Client secret {value1}': 'Asiakassalaisuus {value1}',
    'Connecting…': 'Yhdistetään…',
    'Test and connect': 'Testaa ja yhdistä',
    'Add the store, the client ID and the client secret.':
      'Lisää kauppa, asiakastunnus ja asiakassalaisuus.',
    'Connect your Shopify Developer App': 'Yhdistä Shopify-kehittäjäsovellus',
    'Poneva can use exactly the access your store gave the app, and nothing more. It talks to Shopify directly and keeps the client secret encrypted.':
      'Poneva voi käyttää täsmälleen niitä käyttöoikeuksia, jotka kauppasi myönsi sovellukselle, ei mitään enempää. Se keskustelee suoraan Shopifyn kanssa ja säilyttää asiakassalaisuuden salattuna.',
    'How to create the app in Shopify': 'Sovelluksen luominen Shopifyn avulla',
    'Open{value1} {value2}{value3} with the account that owns the store, and create an app.':
      'Avaa{value1} {value2}{value3} kaupan omistavan tilin avulla ja luo sovellus.',
    'Create a version and select the access scopes Poneva may use, for example read_products and read_orders. Add write_ scopes only for data Poneva may change. Then release the version.':
      'Luo versio ja valitse käyttöoikeusalueet, joita Poneva saa käyttää, esimerkiksi read_products ja read_orders. Lisää write_-alkuisia alueita vain tiedoille, joita Poneva saa muuttaa. Julkaise sitten versio.',
    'For orders and customers, also select protected customer data in the app’s settings. Shopify allows this without review for an app made for your own store.':
      'Valitse tilausten ja asiakkaiden osalta myös suojatut asiakastiedot sovelluksen asetuksista. Shopify sallii tämän ilman tarkistusta sovellukselle, joka on tehty omaa kauppaasi varten.',
    'Install the app on your store.': 'Asenna sovellus kauppaasi.',
    'Copy the client ID and client secret from the app’s settings.':
      'Kopioi asiakastunnus ja asiakassalaisuus sovelluksen asetuksista.',
    'To change the access later, release a new version, approve it on the store and use Test connection here.':
      'Jos haluat muuttaa käyttöoikeuksia myöhemmin, julkaise uusi versio, hyväksy se kaupassa ja valitse tästä Testaa yhteys.',
    Store: 'Kauppa',
    'your-store.myshopify.com': 'your-store.myshopify.com',
    'Your store’s .myshopify.com address (Shopify admin → Settings → Domains), or paste the address of your Shopify admin page':
      'Kauppasi .myshopify.com-osoite (Shopify-hallinta → Settings → Domains) tai Shopify-hallintasivusi osoite',
    'Client ID {value1} {value2}': 'Asiakastunnus {value1} {value2}',
    'Client secret {value1} {value2}': 'Asiakassalaisuus {value1} {value2}',
    Person: 'Henkilö',
    Everyone: 'Kaikki',
    Connection: 'Yhteys',
    'All connections': 'Kaikki yhteydet',
    'App {value1}': 'Sovellus {value1}',
    'From {value1}': 'Alkaen {value1}',
    'Until {value1}': 'Päättyen {value1}',
    Result: 'Tulos',
    'All results': 'Kaikki tulokset',
    Succeeded: 'Onnistui',
    Denied: 'Estetty',
    Failed: 'Epäonnistui',
    Unknown: 'Tuntematon',
    Filter: 'Suodatin',
    'Loading activity…': 'Ladataan toimintaa…',
    'Could not load activity. Try again.': 'Toimintaa ei voitu ladata. Yritä uudelleen.',
    'Removed connection': 'Yhteys poistettu',
    'App: {value1}': 'Sovellus: {value1}',
    'Older activity': 'Vanhempi toiminta',
    'Archived. Its history is kept.': 'Arkistoitu. Historia säilytetään.',
    'Choose the page it goes under. Links to it keep working.':
      'Valitse sivu, jonka alle se sijoitetaan. Sen linkit toimivat edelleen.',
    'Its text, its history and any open suggestions are removed for good, and links to it from other pages stop working. This cannot be undone.':
      'Sen teksti, historia ja avoimet ehdotukset poistetaan pysyvästi, ja muilta sivuilta siihen johtavat linkit lakkaavat toimimasta. Tätä ei voi kumota.',
    'An archived page no longer informs answers. Its history is kept, and a publisher can restore it or delete it permanently.':
      'Arkistoitu sivu ei enää vaikuta vastauksiin. Sen historia säilytetään, ja julkaisija voi palauttaa sivun tai poistaa sen pysyvästi.',
    Under: 'Alla',
    Change: 'Muuta',
    'Move under': 'Siirrä alle',
    'Search pages': 'Hae sivuista',
    'Why?': 'Miksi?',
    'Delete permanently': 'Poista pysyvästi',
    'Move page': 'Siirrä sivu',
    'Archive page': 'Arkistoi sivu',
    'Suggestion {value1}: show its card': 'Ehdotus {value1}: näytä sen kortti',
    'Removed:': 'Poistettu:',
    'Added:': 'Lisätty:',
    'New page “{value1}”{value2}': 'Uusi sivu ”{value1}”{value2}',
    'No pages match “{value1}”.': 'Yksikään sivu ei vastaa hakua ”{value1}”.',
    'Where this page is': 'Tämän sivun sijainti',
    'Describe your company': 'Kuvaile yritystäsi',
    'Empty page': 'Tyhjä sivu',
    'Describe {value1}': 'Kuvaile: {value1}',
    'This page has no text yet.': 'Tällä sivulla ei ole vielä tekstiä.',
    'Poneva reads this page before every answer. Start with who you are, what you sell and how you work; details go on the pages under it.':
      'Poneva lukee tämän sivun ennen jokaista vastausta. Aloita kertomalla, kuka olet, mitä myyt ja miten työskentelet. Yksityiskohdat kuuluvat sen alla oleville sivuille.',
    'Write it, or ask Poneva in chat to draft it for you.':
      'Kirjoita se itse tai pyydä Ponevaa laatimaan luonnos chatissa.',
    'Suggest a first version, and a publisher decides whether it becomes the page.':
      'Ehdota ensimmäistä versiota, niin julkaisija päättää, tuleeko siitä sivu.',
    'Start writing': 'Aloita kirjoittaminen',
    'Suggest a first version': 'Ehdota ensimmäistä versiota',
    'Accepted. The page is archived.': 'Hyväksytty. Sivu on arkistoitu.',
    'Accepted. The page is now revision {value1}.': 'Hyväksytty. Sivu on nyt versio {value1}.',
    'Accepted.': 'Hyväksytty.',
    'Suggestion rejected. The page stays as it is.': 'Ehdotus hylätty. Sivu säilyy ennallaan.',
    'Your suggestion is withdrawn.': 'Ehdotuksesi on peruttu.',
    'Restored. The page informs answers again.': 'Palautettu. Sivu vaikuttaa jälleen vastauksiin.',
    'Your suggestion is sent. A publisher decides whether it becomes the page.':
      'Ehdotuksesi on lähetetty. Julkaisija päättää, tuleeko siitä sivu.',
    'Saved. The page is now revision {value1}.': 'Tallennettu. Sivu on nyt versio {value1}.',
    'Nothing changed.': 'Mitään ei muutettu.',
    'This page is not available.': 'Tämä sivu ei ole saatavilla.',
    'It may have been deleted, archived or moved out of reach, or you may no longer be in this company.':
      'Se on ehkä poistettu, arkistoitu tai siirretty käyttöoikeuksiesi ulottumattomiin, tai et ehkä enää kuulu tähän yritykseen.',
    'Page actions': 'Sivun toiminnot',
    shown: 'näytetään',
    hidden: 'piilotettu',
    '{value1} History': '{value1} Historia',
    '{value1} Ask in chat': '{value1} Kysy chatissa',
    'Suggest edits': 'Ehdota muokkauksia',
    'More actions for {value1}': 'Lisää toimintoja: {value1}',
    '{value1} Poneva reads this page in every chat':
      '{value1} Poneva lukee tämän sivun jokaisessa chatissa',
    'This page is archived. It no longer informs answers; its history is kept. {value1}':
      'Tämä sivu on arkistoitu. Se ei enää vaikuta vastauksiin, mutta sen historia säilytetään. {value1}',
    'Restore page': 'Palauta sivu',
    'This link points to an earlier revision. You are reading the current text.':
      'Tämä linkki johtaa aiempaan versioon. Luet nykyistä tekstiä.',
    'Show it in History': 'Näytä historiassa',
    Pages: 'Sivut',
    'Pages under {value1}': 'Sivun {value1} alla olevat sivut',
    'Linked from': 'Linkitetty sivuilta',
    Suggestions: 'Ehdotukset',
    'Suggestions are hidden. You are reading the page as everyone else sees it.':
      'Ehdotukset on piilotettu. Luet sivua sellaisena kuin kaikki muut näkevät sen.',
    'Loading suggestions…': 'Ladataan ehdotuksia…',
    'Nothing is waiting for review.': 'Tarkistettavia kohteita ei ole.',
    'When someone, Poneva in a chat or a connected agent suggests a change to a page, it shows here and on the page. Nothing changes until a publisher accepts it.':
      'Kun joku, Poneva chatissa tai yhdistetty agentti ehdottaa muutosta sivulle, se näkyy täällä ja sivulla. Mikään ei muutu, ennen kuin julkaisija hyväksyy ehdotuksen.',
    '{value1} Review knowledge in chat': '{value1} Tarkista tietämys chatissa',
    'Suggestions for review': 'Tarkistettavat ehdotukset',
    'Suggested changes from chats, meetings, colleagues and connected agents. Nothing changes until a publisher accepts it on the page.':
      'Chateissa, kokouksissa, kollegoilta ja yhdistetyiltä agenteilta saadut muutosehdotukset. Mikään ei muutu, ennen kuin julkaisija hyväksyy ehdotuksen sivulla.',
    'Your suggestions wait here until a publisher decides. The pages stay as they are until then.':
      'Ehdotuksesi odottavat täällä julkaisijan päätöstä. Sivut säilyvät ennallaan siihen asti.',
    'Review page': 'Tarkista sivu',
    'Review on page': 'Tarkista sivulla',
    'Open the meeting': 'Avaa kokous',
    'Open the chat': 'Avaa chat',
    'Accept and restore': 'Hyväksy ja palauta',
    Accept: 'Hyväksy',
    Reject: 'Hylkää',
    'Your suggestion · waiting for a publisher': 'Ehdotuksesi · odottaa julkaisijaa',
    Withdraw: 'Peru',
    'Waiting for a publisher': 'Odottaa julkaisijaa',
    'Suggestion {value1}': 'Ehdotus {value1}',
    'Suggestion {value1} from {value2}{value3}': 'Ehdotus {value1}, lähettäjä {value2}{value3}',
    'Read the suggested page': 'Lue ehdotettu sivu',
    'Outdated: the text it changes was edited after it was suggested. It can be rejected or withdrawn; a new suggestion can be made against the current text.':
      'Vanhentunut: ehdotuksen kohteena ollutta tekstiä muokattiin ehdotuksen tekemisen jälkeen. Ehdotuksen voi hylätä tai perua, ja nykyistä tekstiä varten voi tehdä uuden ehdotuksen.',
    'Restore this page first to accept this suggestion.':
      'Palauta tämä sivu ensin, jotta voit hyväksyä ehdotuksen.',
    'Previous suggestion': 'Edellinen ehdotus',
    Download: 'Lataa',
    CSV: 'CSV',
    'Evidence for {value1}': 'Perustiedot: {value1}',
    Measure: 'Mitta',
    'Show rows →': 'Näytä rivit →',
    'Ask about this number': 'Kysy tästä luvusta',
    'There are no numeric values available to chart. View the table for the original data.':
      'Kaaviossa ei ole käytettävissä numeerisia arvoja. Näytä alkuperäiset tiedot taulukossa.',
    'Chart value': 'Kaavion arvo',
    '{value1} of {value2} shown': 'Näytetään {value1}/{value2}',
    '{value1} by {value2}; {value3} rows. View Table for exact values.':
      '{value1} / {value2}; {value3} riviä. Näytä tarkat arvot taulukossa.',
    'Values come directly from the source data. Missing values are not estimates.':
      'Arvot tulevat suoraan lähdetiedoista. Puuttuvia arvoja ei ole arvioitu.',
    'Loading library…': 'Ladataan kirjastoa…',
    'We couldn’t load what happened in this App. Try again in a moment.':
      'Tämän sovelluksen tapahtumia ei voitu ladata. Yritä hetken kuluttua uudelleen.',
    'This App could not be opened.': 'Tätä sovellusta ei voitu avata.',
    'Opening App…': 'Avataan sovellusta…',
    'Open the saved App to run this function.':
      'Avaa tallennettu sovellus käyttääksesi tätä toimintoa.',
    'Save this App before running its function.':
      'Tallenna tämä sovellus ennen sen toiminnon suorittamista.',
    'Open saved App': 'Avaa tallennettu sovellus',
    'Open Apps': 'Avaa sovellukset',
    'The App could not be opened. Try again.': 'Sovellusta ei voitu avata. Yritä uudelleen.',
    Owner: 'Omistaja',
    '{value1} · admins': '{value1} · ylläpitäjää',
    'Owner · always edits': 'Omistaja · voi aina muokata',
    'Admins manage it': 'Ylläpitäjät hallinnoivat sitä',
    Editors: 'Muokkaajat',
    'A colleague': 'Työtoveri',
    'Can edit drafts and publish versions': 'Voi muokata luonnoksia ja julkaista versioita',
    Remove: 'Poista',
    'No editors yet.': 'Muokkaajia ei vielä ole.',
    'Admins can always edit company agents.':
      'Ylläpitäjät voivat aina muokata yrityksen agentteja.',
    'Asking for edit access': 'Pyydetään muokkausoikeutta',
    'Asked {value1} · also in your Inbox': 'Pyydetty {value1} · myös Saapuneet-kansiossasi',
    Grant: 'Myönnä',
    Admin: 'Ylläpitäjä',
    'Make personal': 'Tee henkilökohtaiseksi',
    'Switch off': 'Poista käytöstä',
    Archive: 'Arkistoi',
    'Archive this agent': 'Arkistoi tämä agentti',
    'Loading agent…': 'Ladataan agenttia…',
    '{value1} Edit in chat': '{value1} Muokkaa keskustelussa',
    Agent: 'Agentti',
    'This agent has not been created yet. It can run once its owner creates it.':
      'Tätä agenttia ei ole vielä luotu. Se voi suorittaa tehtäviä, kun sen omistaja luo sen.',
    'New agent · Draft': 'Uusi agentti · Luonnos',
    'Untitled agent': 'Nimeämätön agentti',
    'Test run': 'Testiajo',
    'This draft does not run automatically.': 'Tämä luonnos ei käynnisty automaattisesti.',
    'Describe the agent in the chat. Its draft appears here.':
      'Kuvaile agenttia keskustelussa. Sen luonnos näkyy täällä.',
    '{value1} Test run': '{value1} Testiajo',
    'Describe the agent in the chat first.': 'Kuvaile agenttia ensin keskustelussa.',
    'Create and turn on': 'Luo ja ota käyttöön',
    'Connection write setup': 'Yhteyden kirjoitusasetukset',
    'Account for connected changes': 'Yhdistettyjen muutosten tili',
    'Choose a connection': 'Valitse yhteys',
    'No published Skills available. You can add them later.':
      'Julkaistuja taitoja ei ole saatavilla. Voit lisätä niitä myöhemmin.',
    '{value1} · not published. Review the changes. Testing is optional.':
      '{value1} · ei julkaistu. Tarkista muutokset. Testaus on valinnainen.',
    '{value1} Test draft': '{value1} Testaa luonnosta',
    'Apply changes…': 'Ota muutokset käyttöön…',
    'Apply this draft as a new version': 'Ota tämä luonnos käyttöön uutena versiona',
    'This draft cannot be applied.': 'Tätä luonnosta ei voi ottaa käyttöön.',
    'What changed?': 'Mitä muuttui?',
    'Apply version {value1}': 'Ota versio {value1} käyttöön',
    Create: 'Luo',
    'Edit access requested': 'Muokkausoikeutta pyydetty',
    '{value1} Request edit access': '{value1} Pyydä muokkausoikeutta',
    '{value1} Copy agent': '{value1} Kopioi agentti',
    Pause: 'Keskeytä',
    'Open agent: {value1}': 'Avaa agentti: {value1}',
    '· you can edit': '· voit muokata',
    '{value1} is switched off.': '{value1} on poistettu käytöstä.',
    '{value1} is archived.': '{value1} on arkistoitu.',
    'Loading agents…': 'Ladataan agentteja…',
    Agents: 'Agentit',
    'Agents do work for you on a schedule or when you ask. They follow your company’s Skills.':
      'Agentit tekevät työtä puolestasi aikataulun mukaan tai pyynnöstäsi. Ne noudattavat yrityksesi taitoja.',
    'No agent matches. Try a Skill name or what the agent should do.':
      'Yksikään agentti ei vastaa hakua. Kokeile taidon nimeä tai kuvausta siitä, mitä agentin pitäisi tehdä.',
    'Nothing of your own yet': 'Sinulla ei ole vielä omia kohteita',
    'Tell Chat what an agent should do, or copy one of the company’s agents below.{value1}':
      'Kerro Chatille, mitä agentin pitäisi tehdä, tai kopioi jokin alla olevista yrityksen agenteista.{value1}',
    'Your agents': 'Omat agenttisi',
    'Run on demand': 'Suorita pyynnöstä',
    'Run is always available. A schedule is optional and lives separately from the agent’s instructions.':
      'Suoritus on aina käytettävissä. Aikataulu on valinnainen, ja se määritetään erikseen agentin ohjeista.',
    'What changed in version {value1}': 'Mitä versiosta {value1} muuttui',
    'Every publish is a version you can restore.':
      'Jokainen julkaisu on versio, jonka voit palauttaa.',
    Authorization: 'Valtuutus',
    '{value1} {value2} · {value3} will see it.': '{value1} {value2} · {value3} näkee sen.',
    '{value1} {value2} you': '{value1} {value2} sinä',
    '· Revised': '· Muokattu',
    'This chat used your {value1}.': 'Tämä keskustelu käytti kohdetta {value1}.',
    'This chat has results from {value1}.': 'Tässä keskustelussa on tuloksia kohteesta {value1}.',
    'db.example.com': 'db.example.com',
    'e.g. Product analytics': 'esim. Tuoteanalytiikka',
    'Paste access key': 'Liitä käyttöavain',
    'Shopify’s Dev Dashboard': 'Shopifyn kehittäjien hallintapaneeli',
    'App reference': 'Sovelluksen viite',
    'Draft · revision {value1}': 'Luonnos · versio {value1}',
    'its Result': 'sen tulos',
    '· its first run makes it': '· sen ensimmäinen suoritus tekee siitä',
    '{value1}’s chat ·': 'Kohteen {value1} keskustelu ·',
    '{value1} ad {value2} available.': '{value1} ja {value2} saatavilla.',
    '{value1} rows ·': '{value1} riviä ·',
    'It starts private. Sharing it wider shares every refresh, which can carry your private data.':
      'Se on aluksi yksityinen. Laajempi jakaminen jakaa jokaisen päivityksen, joka voi sisältää yksityisiä tietojasi.',
    'Enable this schedule when approved': 'Ota tämä ajoitus käyttöön hyväksymisen jälkeen',
    Schedule: 'Ajoitus',
    'Kept off until you create the agent from its canvas.':
      'Pidetään poissa käytöstä, kunnes luot agentin sen työalustalta.',
    'Will be enabled when you approve.': 'Otetaan käyttöön, kun hyväksyt.',
    'Will be saved paused. You can enable it later.':
      'Tallennetaan keskeytettynä. Voit ottaa sen käyttöön myöhemmin.',
    'Only runs when you ask.': 'Suoritetaan vain pyynnöstäsi.',
    'Draft · approving saves it, and nothing runs. Test it and create it from its canvas.':
      'Luonnos · hyväksyminen tallentaa sen, eikä mitään suoriteta. Testaa se ja luo se työalustalta.',
    'Draft · nothing is scheduled until you approve. Connected actions require their own approval at run time.':
      'Luonnos · mitään ei ajoiteta ennen hyväksyntääsi. Yhdistetyt toiminnot edellyttävät oman hyväksyntänsä suoritushetkellä.',
    Name: 'Nimi',
    'Agent name': 'Agentin nimi',
    'Who can use it': 'Kuka voi käyttää sitä',
    'Company agent · company resources only': 'Yritysagentti · vain yrityksen resurssit',
    'Personal agent · runs with your access':
      'Henkilökohtainen agentti · suoritetaan käyttöoikeuksillasi',
    'Approving saves it as a draft. It does not run automatically.':
      'Hyväksyminen tallentaa sen luonnoksena. Sitä ei suoriteta automaattisesti.',
    'Open the agent’s runs': 'Avaa agentin suoritukset',
    'Run the published version once': 'Suorita julkaistu versio kerran',
    'Stopping…': 'Pysäytetään…',
    'Stop run': 'Pysäytä suoritus',
    'Could not stop this run. Please try again.': 'Suoritusta ei voitu pysäyttää. Yritä uudelleen.',
    'Run in progress': 'Suoritus käynnissä',
    'This run is still answering. You can ask follow-ups when it finishes.':
      'Tämä suoritus vastaa vielä. Voit esittää jatkokysymyksiä, kun se valmistuu.',
    'Open run details': 'Avaa suorituksen tiedot',
    Runs: 'Suoritukset',
    'Open the run chat': 'Avaa suorituksen keskustelu',
    Watch: 'Katso',
    Goal: 'Tavoite',
    'Change the goal': 'Muuta tavoitetta',
    'What it does': 'Mitä se tekee',
    'What should this agent achieve?': 'Mitä tämän agentin pitäisi saavuttaa?',
    'Not set yet.': 'Ei vielä määritetty.',
    'When it runs': 'Milloin se suoritetaan',
    'Change when it runs': 'Muuta suoritusajankohtaa',
    'Off means it runs only when someone runs it. Changing when it runs never changes its instructions.':
      'Pois käytöstä tarkoittaa, että se suoritetaan vain jonkun käynnistäessä sen. Suoritusajankohdan muuttaminen ei koskaan muuta sen ohjeita.',
    Instructions: 'Ohjeet',
    'Change the instructions': 'Muuta ohjeita',
    'How the agent should approach the work and make decisions.':
      'Miten agentin tulee lähestyä työtä ja tehdä päätöksiä.',
    Boundaries: 'Rajaukset',
    'What to do or avoid. Every connected action still follows its approval.':
      'Mitä tulee tehdä tai välttää. Jokainen yhdistetty toiminto noudattaa edelleen hyväksyntäänsä.',
    'No instructions of its own. It follows its Skills.':
      'Sillä ei ole omia ohjeita. Se noudattaa taitojaan.',
    'Pin a Skill': 'Kiinnitä taito',
    'Finds the Skills that fit each run, the same way a chat does.':
      'Etsii kuhunkin suoritukseen sopivat taidot samalla tavalla kuin keskustelu.',
    'Skills it always follows': 'Taidot, joita se noudattaa aina',
    'A Skill that is not published': 'Taito, jota ei ole julkaistu',
    'Always follows · Version {value1}': 'Noudattaa aina · Versio {value1}',
    'Not published': 'Ei julkaistu',
    Uses: 'Käyttää',
    'Change in chat': 'Muuta keskustelussa',
    'Change in chat: Uses': 'Muuta keskustelussa: Käyttää',
    'Company knowledge and the tools each run is allowed to use.':
      'Yrityksen tietämys ja työkalut, joita kukin suoritus saa käyttää.',
    'People see the Result refresh; they change the agent, not the page.':
      'Käyttäjät näkevät Tuloksen päivittyvän; he muuttavat agenttia, eivät sivua.',
    'The first run after it is created makes the Result; later runs add a version to it.':
      'Ensimmäinen suoritus sen luomisen jälkeen luo Tuloksen; myöhemmät suoritukset lisäävät siihen version.',
    'Emails whoever the run is for': 'Lähettää sähköpostin suorituksen vastaanottajalle',
    'Email each run': 'Lähetä sähköpostia jokaisesta suorituksesta',
    Delivers: 'Tuottaa',
    'Change what it delivers': 'Muuta sen tuottamaa sisältöä',
    'Expected result': 'Odotettu tulos',
    'What a successful run should deliver.': 'Mitä onnistuneen suorituksen tulee tuottaa.',
    'What each run delivers': 'Mitä kukin suoritus tuottaa',
    'Keeps one Result up to date {value1}': 'Pitää yhden Tuloksen ajan tasalla {value1}',
    'Saves a new Result each run': 'Tallentaa uuden Tuloksen jokaisella suorituksella',
    'You can run this company agent as yourself.{value1} {value2}':
      'Voit suorittaa tämän yritysagentin omana itsenäsi.{value1} {value2}',
    'Changes since version': 'Muutokset versiosta',
    'are not live yet.': 'eivät ole vielä käytössä.',
    'Review them in Versions': 'Tarkista ne kohdassa Versiot',
    Skill: 'Taito',
    'The agent always uses the Skill’s published version.':
      'Agentti käyttää aina taidon julkaistua versiota.',
    Day: 'Päivä',
    Time: 'Aika',
    'Cron expression': 'Cron-lauseke',
    'Editors and access': 'Muokkaajat ja käyttöoikeudet',
    Company: 'Yritys',
    Personal: 'Henkilökohtainen',
    'No changes.': 'Ei muutoksia.',
    'Instructions changes': 'Ohjemuutokset',
    'Loading versions…': 'Ladataan versioita…',
    'What the draft changes': 'Mitä luonnos muuttaa',
    'No published version yet. Try the draft, then publish it.':
      'Julkaistua versiota ei vielä ole. Kokeile luonnosta ja julkaise se sitten.',
    'Published versions': 'Julkaistut versiot',
    'Former member': 'Entinen jäsen',
    Live: 'Käytössä',
    '{value1} for {value2}': '{value1} kohteelle {value2}',
    Suggested: 'Ehdotetut',
    'Opening your conversation…': 'Avataan keskusteluasi…',
    'This conversation isn’t available': 'Tämä keskustelu ei ole saatavilla',
    'It may have been deleted, belong to another account, or be temporarily unavailable.':
      'Se on saatettu poistaa, se voi kuulua toiselle tilille tai olla tilapäisesti poissa käytöstä.',
    '{count} more line — shown in the complete revision':
      '{count} rivi lisää — näkyy täydellisessä versiossa',
    '{count} more lines — shown in the complete revision':
      '{count} riviä lisää — näkyy täydellisessä versiossa',
    '{count} more line removed': '{count} rivi lisää poistettu',
    '{count} more lines removed': '{count} riviä lisää poistettu',
    '{count} unchanged line': '{count} muuttumaton rivi',
    '{count} unchanged lines': '{count} muuttumatonta riviä',
    '{count} more lines not shown, {added} added and {removed} removed. Check them in the complete revision.':
      '{count} riviä lisää ei näytetä, {added} lisätty ja {removed} poistettu. Tarkista ne täydellisestä versiosta.',
    'Saved result': 'Tallennettu tulos',
    'Made with a Skill': 'Luotu Skill-taidolla',
    'Preview of {name}': 'Esikatselu: {name}',
    'Made with {name}': 'Luotu käyttäen: {name}',
    'Ad-hoc result': 'Kertaluonteinen tulos',
    'A Skill that is not available in this workspace':
      'Skill, joka ei ole käytettävissä tässä työtilassa',
    '{name} · Revision {version}': '{name} · Versio {version}',
    '{name} · Version {version}': '{name} · Versio {version}',
    'Return to conversation {value1}': 'Palaa keskusteluun {value1}',
    '{value1} Working with {value2}': '{value1} työskentelee kohteen {value2} kanssa',
    'View context {value1}': 'Näytä konteksti {value1}',
    'A way of working, made yours.': 'Työskentelytapa, joka on sinun näköisesi.',
    'Work that runs itself.': 'Työ, joka hoituu itsestään.',
    'One place for one piece of work.': 'Yksi paikka yhdelle työlle.',
    'Let’s move your work forward{value1}.': 'Viedään työtäsi eteenpäin{value1}.',
    'Describe the work. Your Skill takes shape beside the conversation.':
      'Kuvaile työ. Skillisi muotoutuu keskustelun vierelle.',
    'Describe what it should do and when. Your agent takes shape beside the conversation. The draft does not run automatically.':
      'Kuvaile, mitä sen pitäisi tehdä ja milloin. Agenttisi muotoutuu keskustelun vierelle. Luonnos ei käynnisty automaattisesti.',
    'Say what the work is. Poneva drafts the project beside the conversation and brings in what you have already done. Nothing is created until you say so.':
      'Kerro, mistä työssä on kyse. Poneva luonnostelee projektin keskustelun vierelle ja tuo mukaan sen, mitä olet jo tehnyt. Mitään ei luoda ennen kuin annat siihen luvan.',
    'Start with an idea below. Poneva will take it from there.':
      'Aloita alla olevasta ideasta. Poneva hoitaa loput.',
    Triggers: 'Käynnistimet',
    'Review the agent and its trigger. Approval applies exactly what is shown.':
      'Tarkista agentti ja sen käynnistin. Hyväksyntä ottaa käyttöön täsmälleen näytetyn sisällön.',
    '{source} · read {date}': '{source} · luettu {date}',
    'Evidence is being recorded · read {date}': 'Näyttöä tallennetaan · luettu {date}',
    'Evidence expired on {date} under the retention policy':
      'Näyttö vanheni {date} säilytyskäytännön mukaisesti',
    'Entered by {person}': 'Syöttäjä: {person}',
    'No retained evidence for this value': 'Tästä arvosta ei ole säilytettyä näyttöä',
    'Covers {shown} of {total} rows': 'Kattaa {shown}/{total} riviä',
    'Search rows': 'Hae riveistä',
    'Clear filters': 'Tyhjennä suodattimet',
    Sort: 'Lajittele',
    'Sort: {column}': 'Lajittele: {column}',
    '{shown} of {total} rows': '{shown}/{total} riviä',
    More: 'Lisää',
    Density: 'Tiheys',
    Comfortable: 'Väljä',
    Compact: 'Tiivis',
    Columns: 'Sarakkeet',
    'No rows match. Clear the search or filters to see them again.':
      'Yksikään rivi ei vastaa hakua. Tyhjennä haku tai suodattimet nähdäksesi rivit uudelleen.',
    'Not available': 'Ei saatavilla',
    'All rows': 'Kaikki rivit',
    'Close row detail': 'Sulje rivin tiedot',
    'Ask about this row': 'Kysy tästä rivistä',
    'Add note': 'Lisää muistiinpano',
    Note: 'Muistiinpano',
    Saved: 'Tallennettu',
    Total: 'Yhteensä',
    ascending: 'nouseva',
    descending: 'laskeva',
    'Scroll to see all columns': 'Vieritä nähdäksesi kaikki sarakkeet',
    App: 'Sovellus',
    Artifact: 'Artefakti',
    'New project': 'Uusi projekti',
    'Review request': 'Tarkistuspyyntö',
    Activity: 'Toiminta',
    'Voice preview': 'Äänen esikuuntelu',
    Source: 'Lähde',
    File: 'Tiedosto',
    Meeting: 'Kokous',
    'Knowledge page': 'Tietosivu',
    'Could not preview this CSV.': 'CSV-tiedoston esikatselu ei onnistunut.',
    'File content is unavailable.': 'Tiedoston sisältö ei ole saatavilla.',
    'You have five open suggestions here. {value1} will see them.':
      'Täällä on viisi avointa ehdotusta. {value1} näkee ne.',
    'We could not send your suggestion. Please try again.':
      'Ehdotuksen lähettäminen ei onnistunut. Yritä uudelleen.',
    'The agent': 'Agentti',
    'Selected colleagues': 'Valitut työtoverit',
    'The owner': 'Omistaja',
    'Forked. This copy is yours and runs with your own connections.':
      'Haarautettu. Tämä kopio on sinun, ja se käyttää omia yhteyksiäsi.',
    'This chat is too long to fork.': 'Tämä keskustelu on liian pitkä haarautettavaksi.',
    'We could not fork this chat. Please try again.':
      'Keskustelun haarauttaminen ei onnistunut. Yritä uudelleen.',
    'Anyone who forked it keeps their copy: forks stay with the people who made them.':
      'Kaikki haarauttaneet säilyttävät oman kopionsa: haarautumat pysyvät niiden tekijöillä.',
    'Nobody has forked this chat.': 'Kukaan ei ole haarauttanut tätä keskustelua.',
    '1 person forked this chat. Their copy stays theirs.':
      '1 henkilö haarautti tämän keskustelun. Hänen kopionsa pysyy hänellä.',
    '{value1} people forked this chat. Their copies stay theirs.':
      '{value1} henkilöä haarautti tämän keskustelun. Heidän kopionsa pysyvät heillä.',
    'Personal. Nobody else sees it.': 'Henkilökohtainen. Kukaan muu ei näe sitä.',
    'People you pick. They get it in their Inbox.':
      'Valitsemasi henkilöt. He saavat sen Saapuneet-kansioonsa.',
    'Everyone in the company can follow it and fork it.':
      'Kaikki yrityksen jäsenet voivat seurata ja haarauttaa sen.',
    'a chat you can no longer open': 'keskustelu, jota et voi enää avata',
    'shared the Result': 'jakoi tuloksen',
    'updated the Result': 'päivitti tuloksen',
    'published the Skill': 'julkaisi taidon',
    'approved the fact': 'hyväksyi faktan',
    'added the fact': 'lisäsi faktan',
    'added the meeting': 'lisäsi kokouksen',
    'published the page': 'julkaisi sivun',
    'updated the page': 'päivitti sivun',
    'shared the chat': 'jakoi keskustelun',
    'published a version of': 'julkaisi version kohteesta',
    ran: 'suoritti',
    Knowledge: 'Tietämys',
    Meetings: 'Kokoukset',
    Chat: 'Keskustelu',
    Use: 'Käytä',
    Open: 'Avaa',
    You: 'Sinä',
    Someone: 'Joku',
    'published version {version} of': 'julkaisi version {version} kohteesta',
    'thing needs': 'asia tarvitsee',
    'things need': 'asiat tarvitsevat',
    'Published Skill': 'Julkaistu taito',
    'Included with Skill': 'Sisältyy taitoon',
    'Already attached': 'Jo liitetty',
    'Also available in company knowledge': 'Saatavilla myös yrityksen tietämyksessä',
    'Company file': 'Yrityksen tiedosto',
    'Account identity unavailable': 'Tilin henkilöllisyys ei ole saatavilla',
    'Access expired or was revoked. Reconnect to continue.':
      'Käyttöoikeus vanheni tai peruutettiin. Yhdistä uudelleen jatkaaksesi.',
    'Account authorized · tools unavailable': 'Tili valtuutettu · työkalut eivät ole saatavilla',
    'Not available in this workspace yet.': 'Ei vielä saatavilla tässä työtilassa.',
    'Everyone in the company': 'Kaikki yrityksen jäsenet',
    'Audience: only you.': 'Yleisö: vain sinä.',
    'Audience: everyone in the company.': 'Yleisö: kaikki yrityksen jäsenet.',
    'tool is': 'työkalu on',
    'tools are': 'työkalut ovat',
    'account is': 'tili on',
    'accounts are': 'tilit ovat',
    'We could not upload this file.': 'Tiedoston lataaminen ei onnistunut.',
    'file was': 'tiedosto oli',
    'files were': 'tiedostot olivat',
    'Your company': 'Yrityksesi',
    'Create an agent': 'Luo agentti',
    'Give recurring work a helping hand': 'Helpota toistuvaa työtä',
    'Create a Skill': 'Luo taito',
    'Save a reusable way of working': 'Tallenna uudelleenkäytettävä työskentelytapa',
    'Take meeting notes': 'Tee kokousmuistiinpanoja',
    'Capture decisions and next steps': 'Kirjaa päätökset ja seuraavat vaiheet',
    'Work with a file': 'Työskentele tiedoston kanssa',
    'Start from a document or image': 'Aloita asiakirjasta tai kuvasta',
    'Browse agents': 'Selaa agentteja',
    'Open your agents and company agents': 'Avaa omat agenttisi ja yrityksen agentit',
    'Review results': 'Tarkista tulokset',
    'Return to work saved in your Library': 'Palaa Kirjastoon tallennettuun työhön',
    'For review': 'Tarkistettavana',
    'An agent': 'Agentti',
    Assistant: 'Avustaja',
    'Kept up to date by {value1}{value2}': 'Ajan tasalla pitäjänä {value1}{value2}',
    ', {value1}': ', {value1}',
    'Version {value1}{value2}{value3}': 'Versio {value1}{value2}{value3}',
    'Refreshed by its agent': 'Sen agentti on päivittänyt',
    'Saved from a chat': 'Tallennettu keskustelusta',
    'Saved from {value1}': 'Tallennettu sovelluksesta {value1}',
    Edited: 'Muokattu',
    'private account': 'yksityinen tili',
    '{value1} ({value2})': '{value1} ({value2})',
    '{value1}’s {value2}': '{value1}:n {value2}',
    'Made private. The person who added it and the owner of its recording have been told in their Inbox.':
      'Muutettu yksityiseksi. Sen lisänneelle henkilölle ja tallenteen omistajalle on ilmoitettu heidän Saapuneet-kansiossaan.',
    'Made private. The person who added it has been told in their Inbox.':
      'Muutettu yksityiseksi. Sen lisänneelle henkilölle on ilmoitettu hänen Saapuneet-kansiossaan.',
    'Made private. The owner of its recording has been told in their Inbox.':
      'Muutettu yksityiseksi. Tallenteen omistajalle on ilmoitettu hänen Saapuneet-kansiossaan.',
    'Selected passage': 'Valittu kohta',
    '{value1} {value2}': '{value1} {value2}',
    'Upload a file': 'Lataa tiedosto',
    'Help me create a useful report from our company knowledge and available sources.':
      'Auta minua luomaan hyödyllinen raportti yrityksemme tiedoista ja käytettävissä olevista lähteistä.',
    'This saved work couldn’t be opened. Open it again to retry.':
      'Tätä tallennettua työtä ei voitu avata. Yritä uudelleen avaamalla se.',
    '{value1}’s': '{value1}:n',
    '{value1} chat “{value2}”': '{value1}:n keskustelu ”{value2}”',
    '{value1}{value2}': '{value1}{value2}',
    'Skill: {value1}{value2}': 'Taito: {value1}{value2}',
    'Result “{value1}”': 'Tulos ”{value1}”',
    'Meeting “{value1}”': 'Kokous ”{value1}”',
    'Used in {value1} {value2} this week': 'Käytetty tällä viikolla: {value1} {value2}',
    '{value1} {value2} · used in {value3} {value4}':
      '{value1} {value2} · käytetty: {value3} {value4}',
    'The draft is not published yet, so no one else follows it.':
      'Luonnosta ei ole vielä julkaistu, joten kukaan muu ei seuraa sitä.',
    'Use it in a chat for current data, or refine the Skill first.':
      'Käytä sitä keskustelussa ajantasaisten tietojen saamiseen tai viimeistele taito ensin.',
    'An agent keeps this up to date. Continue the work in chat.':
      'Agentti pitää tämän ajan tasalla. Jatka työtä keskustelussa.',
    'Edit it here, or continue the work in chat.':
      'Muokkaa sitä täällä tai jatka työtä keskustelussa.',
    'Duplicate it to your Library, or continue the work in chat.':
      'Monista se Kirjastoosi tai jatka työtä keskustelussa.',
    'Download Markdown': 'Lataa Markdown',
    'Download CSV': 'Lataa CSV',
    'an agent': 'agentti',
    'Publish a Skill version': 'Julkaise taidon versio',
    'Share with {value1}': 'Jaa käyttäjän {value1} kanssa',
    'Update company content': 'Päivitä yrityksen sisältöä',
    Approved: 'Hyväksytty',
    Declined: 'Hylätty',
    Pending: 'Odottaa käsittelyä',
    'View decision': 'Näytä päätös',
    'No data': 'Ei tietoja',
    'No change': 'Ei muutosta',
    'Connection created': 'Yhteys luotu',
    'Sharing changed': 'Jakamisasetusta muutettu',
    'Person added': 'Henkilö lisätty',
    'Person removed': 'Henkilö poistettu',
    'Access changed': 'Käyttöoikeutta muutettu',
    'Access turned off': 'Käyttöoikeus poistettu käytöstä',
    'Connection removed': 'Yhteys poistettu',
    'Query time limit changed': 'Kyselyn aikarajaa muutettu',
    '{count} row': '{count} rivi',
    '{count} rows': '{count} riviä',
    'This source is no longer available. Company knowledge now lives in Knowledge pages, and files stay in the Library.':
      'Tämä lähde ei ole enää käytettävissä. Yrityksen tiedot ovat nyt tietosivuilla, ja tiedostot säilyvät Kirjastossa.',
    '· {value1} by {value2}': '· {value1}, tekijä {value2}',
    '· version {value1}': '· versio {value1}',
    '{message} {count} earlier file was saved and attached.':
      '{message} {count} aiempi tiedosto tallennettiin ja liitettiin.',
    '{message} {count} earlier files were saved and attached.':
      '{message} {count} aiempaa tiedostoa tallennettiin ja liitettiin.',
    '{message} {count} earlier file was saved.': '{message} {count} aiempi tiedosto tallennettiin.',
    '{message} {count} earlier files were saved.':
      '{message} {count} aiempaa tiedostoa tallennettiin.',
    'refreshed {time}': 'päivitetty {time}',
    'a colleague': 'kollega',
    'Your chat “{title}”': 'Keskustelusi “{title}”',
    '{name}’s chat “{title}”': 'Käyttäjän {name} keskustelu “{title}”',
    'Kept up to date by {name}{version}': 'Ajan tasalla pitäjänä {name}{version}',
    'Skill: {name}{version}': 'Taito: {name}{version}',
    'Result “{title}”': 'Tulos “{title}”',
    'Meeting “{title}”': 'Kokous “{title}”',
    'Used in {count} answer this week': 'Käytetty tällä viikolla {count} vastauksessa',
    'Used in {count} answers this week': 'Käytetty tällä viikolla {count} vastauksessa',
    '{count} source': '{count} lähde',
    '{count} sources': '{count} lähdettä',
    'used in {count} place': 'käytetty {count} paikassa',
    'used in {count} places': 'käytetty {count} paikassa',
    '{company} workspace': '{company} työtila',
    '{count} page': '{count} sivu',
    '{count} pages': '{count} sivua',
    '{needs} · reviews and approvals': '{needs} · tarkistusta ja hyväksyntää',
    '{count} thing needs you': '{count} asia tarvitsee sinua',
    '{count} things need you': '{count} asiaa tarvitsee sinua',
    'Included with Skill · {files} · {sources} {icon}':
      'Sisältyy taitoon · {files} · {sources} {icon}',
    '{count} file': '{count} tiedosto',
    '{count} files': '{count} tiedostoa',
    Today: 'Tänään',
    'Earlier this week': 'Aiemmin tällä viikolla',
    '{count} slide': '{count} dia',
    '{count} slides': '{count} diaa',
    Early: 'Aikaisin',
    'TLS verified': 'TLS vahvistettu',
    'Made personal and switched off. Switch it on when you are ready.':
      'Muutettu henkilökohtaiseksi ja poistettu käytöstä. Ota se käyttöön, kun olet valmis.',
    'Made personal and switched off. Its owner is told which version is live.':
      'Muutettu henkilökohtaiseksi ja poistettu käytöstä. Sen omistajalle ilmoitetaan, mikä versio on käytössä.',
    'Switched off.': 'Poistettu käytöstä.',
    'Applied version {revision}.': 'Versio {revision} otettu käyttöön.',
    'The draft is running in a chat only you can read.':
      'Luonnos on käynnissä keskustelussa, jonka vain sinä voit lukea.',
    'Publish a version first.': 'Julkaise versio ensin.',
    'Another Agent action is in progress.': 'Toinen Agentti-toiminto on käynnissä.',
    'Knowledge & connections': 'Tietämys ja yhteydet',
    'Pinned Skills': 'Kiinnitetyt taidot',
    None: 'Ei mitään',
    'A new Result each run': 'Uusi tulos jokaisella suorituskerralla',
    'One Result kept up to date': 'Yksi tulos ajan tasalla',
    Email: 'Sähköposti',
    On: 'Käytössä',
    Off: 'Poissa käytöstä',
    'Waiting for review': 'Odottaa tarkistusta',
    Outdated: 'Vanhentunut',
    Accepted: 'Hyväksytty',
    Rejected: 'Hylätty',
    Withdrawn: 'Peruttu',
    Replaced: 'Korvattu',
    'Suggested edit': 'Ehdotettu muokkaus',
    'Suggested new page': 'Ehdotettu uusi sivu',
    'Suggested move': 'Ehdotettu siirto',
    'Suggested archive': 'Ehdotettu arkistointi',
    'Checking status…': 'Tarkistetaan tilaa…',
    'Status unavailable': 'Tila ei ole saatavilla',
    'Bulleted list': 'Luettelomerkit',
    'Numbered list': 'Numeroitu luettelo',
    'Web link': 'Verkkolinkki',
    Read: 'Lue',
    Write: 'Kirjoita',
    'shared with you': 'jaettu kanssasi',
    'Getting an answer': 'Haetaan vastausta',
    '{name} is getting an answer': '{name} hakee vastausta',
    'We could not save. Please try again.': 'Tallennus epäonnistui. Yritä uudelleen.',
    'The new page could not be created.': 'Uutta sivua ei voitu luoda.',
    'We could not load this revision.': 'Tätä versiota ei voitu ladata.',
    'We could not restore this revision. Please try again.':
      'Tätä versiota ei voitu palauttaa. Yritä uudelleen.',
    'We could not export this revision.': 'Tätä versiota ei voitu viedä.',
    'We could not open this suggestion.': 'Tätä ehdotusta ei voitu avata.',
    'We could not do that. Please try again.': 'Toiminto epäonnistui. Yritä uudelleen.',
    'We could not save your decision. Please try again.':
      'Päätöstäsi ei voitu tallentaa. Yritä uudelleen.',
    'We could not restore this page. Please try again.':
      'Tätä sivua ei voitu palauttaa. Yritä uudelleen.',
    'We could not export this page.': 'Tätä sivua ei voitu viedä.',
    '{count} missed time merged.': '{count} väliin jäänyt aika yhdistetty.',
    '{count} missed times merged.': '{count} väliin jäänyttä aikaa yhdistetty.',
    'About this project': 'Tietoja projektista',
  },
  fr: {
    context: 'contexte',
    skills: 'compétences',
    'Choose company context': 'Choisir le contexte de l’entreprise',
    'Skills for this conversation': 'Compétences pour cette conversation',
    'Bring context into the conversation': 'Ajouter le contexte à la conversation',
    'Close context picker': 'Fermer le sélecteur de contexte',
    'Filter company context': 'Filtrer le contexte de l’entreprise',
    'Find a Skill…': 'Rechercher une compétence…',
    'Find a file…': 'Rechercher un fichier…',
    'Available company context': 'Contexte disponible de l’entreprise',
    'No matching published Skills.': 'Aucune compétence publiée correspondante.',
    'No matching files.': 'Aucun fichier correspondant.',
    'Searching company work…': 'Recherche dans le travail de l’entreprise…',
    'Try search again': 'Réessayer la recherche',
    'Meaning search is temporarily limited. Showing available text matches.':
      'La recherche sémantique est temporairement limitée. Affichage des correspondances textuelles disponibles.',
    'Load more matches': 'Charger davantage de résultats',
    '{value1} files attached. Remove an attachment to add another. Saved Skill references are included separately.':
      '{value1} fichiers joints. Supprimez une pièce jointe pour en ajouter une autre. Les références de compétences enregistrées sont incluses séparément.',
    'Create a Skill in chat': 'Créer une compétence dans le chat',
    'Upload a company file': 'Importer un fichier de l’entreprise',
    'Company knowledge is always available to Poneva.':
      'Les connaissances de l’entreprise sont toujours disponibles pour Poneva.',
    '{value1} was not connected': '{value1} n’a pas été connecté',
    Dismiss: 'Ignorer',
    'Try connecting again': 'Réessayer la connexion',
    Waiting: 'En attente',
    Connected: 'Connecté',
    'Needs reconnecting': 'Reconnexion nécessaire',
    Connect: 'Connecter',
    '{value1}{value2} The provider’s account permissions still apply.':
      '{value1}{value2} Les autorisations du compte du fournisseur continuent de s’appliquer.',
    'Last error: {value1}': 'Dernière erreur : {value1}',
    '{value1} {value2} ready.': '{value1} {value2} est prêt.',
    'Continue with my Meta app': 'Continuer avec mon application Meta',
    Reconnect: 'Reconnecter',
    Disconnect: 'Déconnecter',
    'Remove attachment: {value1}': 'Supprimer la pièce jointe : {value1}',
    'Saved in this Skill. Edit the Skill to change its references.':
      'Enregistré dans cette compétence. Modifiez la compétence pour changer ses références.',
    'Remove Skill context': 'Supprimer le contexte de la compétence',
    Refining: 'Affinement',
    Previewing: 'Aperçu',
    Using: 'Utilisation',
    'Skill revision {value1}': 'Révision de la compétence {value1}',
    'a new Skill': 'une nouvelle compétence',
    '{value1} Making a new agent {value2}': '{value1} Création d’un nouvel agent {value2}',
    'Stop making a new agent in this chat': 'Arrêter la création d’un nouvel agent dans ce chat',
    'Saved Skill references': 'Références de compétences enregistrées',
    'Included with Skill · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}':
      'Inclus avec la compétence · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}',
    'Selected Skill revision is unavailable. Select the Skill again to view its saved references.':
      'La révision de compétence sélectionnée n’est pas disponible. Sélectionnez à nouveau la compétence pour afficher ses références enregistrées.',
    'Conversation attachments': 'Pièces jointes de la conversation',
    'Added for this conversation': 'Ajouté pour cette conversation',
    'Selected passage {value1}': 'Passage sélectionné {value1}',
    'We could not load your workspace.': 'Nous n’avons pas pu charger votre espace de travail.',
    'The selected Skill is unavailable. Check its access or choose it again.':
      'La compétence sélectionnée n’est pas disponible. Vérifiez vos droits d’accès ou sélectionnez-la à nouveau.',
    'Source saved privately and included in your knowledge search.':
      'Source enregistrée en privé et incluse dans votre recherche de connaissances.',
    'File saved privately to your library and attached to this message.':
      'Fichier enregistré en privé dans votre bibliothèque et joint à ce message.',
    'File saved privately to your library.': 'Fichier enregistré en privé dans votre bibliothèque.',
    '{value1} {value2} earlier {value3} saved{value4}.':
      '{value1} {value2} {value3} enregistré{value4} précédemment.',
    'Extracted text for Poneva to read. Download the original for its layout, charts and images. Spreadsheet formulas show their saved results and are not recalculated.':
      'Texte extrait pour que Poneva puisse le lire. Téléchargez l’original pour conserver sa mise en page, ses graphiques et ses images. Les formules du tableur affichent leurs résultats enregistrés et ne sont pas recalculées.',
    Esc: 'Échap',
    'Start something': 'Commencer quelque chose',
    'Choose a file to work with': 'Choisir un fichier avec lequel travailler',
    'Skills worth adding': 'Compétences à ajouter',
    'Picked for you': 'Sélectionné pour vous',
    'Reusable work grounded in your company knowledge.':
      'Du travail réutilisable fondé sur les connaissances de votre entreprise.',
    'Ideas from your company context and recent work. Pick one to start.':
      'Idées tirées du contexte de votre entreprise et de votre activité récente. Choisissez-en une pour commencer.',
    'Refresh suggested tasks': 'Actualiser les tâches suggérées',
    'Check for new company context.': 'Rechercher du nouveau contexte d’entreprise.',
    'Check for new context. Ideas also refresh daily.':
      'Rechercher du nouveau contexte. Les idées sont également actualisées chaque jour.',
    Refresh: 'Actualiser',
    'Finding useful starting points…': 'Recherche de points de départ utiles…',
    'Suggestions aren’t available right now. Try Refresh, or describe the work you want to do.':
      'Les suggestions ne sont pas disponibles pour le moment. Essayez Actualiser ou décrivez le travail que vous souhaitez effectuer.',
    'Loading the knowledge pages…': 'Chargement des pages de connaissances…',
    '{value1} All pages': '{value1} Toutes les pages',
    'The page is created.': 'La page est créée.',
    'Your new page is suggested. A publisher decides whether it is added.':
      'Votre nouvelle page est suggérée. Un éditeur décide de son ajout.',
    'Company knowledge': 'Connaissances de l’entreprise',
    'What Poneva knows about your company, page by page. Every change is kept.':
      'Ce que Poneva sait de votre entreprise, page par page. Chaque modification est conservée.',
    'Loading company knowledge…': 'Chargement des connaissances de l’entreprise…',
    'Knowledge pages are not enabled in this workspace.':
      'Les pages de connaissances ne sont pas activées dans cet espace de travail.',
    'Ask your Poneva contact to switch them on for your company.':
      'Demandez à votre contact Poneva de les activer pour votre entreprise.',
    '{value1} Change the agent': '{value1} Changer d’agent',
    '{value1} Continue in chat': '{value1} Continuer dans le chat',
    'We could not load this item.': 'Impossible de charger cet élément.',
    '{value1} canvas': '{value1} canevas',
    'Loading {value1}…': 'Chargement de {value1}…',
    '{value1} · Original retained': '{value1} · Original conservé',
    '{value1} {value2}{value3} · Added {value4}': '{value1} {value2}{value3} · Ajouté le {value4}',
    '{value1} Use in chat': '{value1} Utiliser dans la conversation',
    '{value1} Download': '{value1} Télécharger',
    Table: 'Tableau',
    Chart: 'Graphique',
    Original: 'Original',
    'Text extracted from the PDF, marked by page. Download the original for its layout and images.':
      'Texte extrait du PDF, repéré par page. Téléchargez l’original pour conserver sa mise en page et ses images.',
    'This preview shows the beginning of the file. Poneva reads the whole file; download the original to see all of it.':
      'Cet aperçu affiche le début du fichier. Poneva lit l’intégralité du fichier ; téléchargez l’original pour tout voir.',
    'Preview of the first {value1} complete rows. Filtering and charts use only this preview. Download the original for the full file.':
      'Aperçu des {value1} premières lignes complètes. Les filtres et les graphiques utilisent uniquement cet aperçu. Téléchargez l’original pour accéder à l’intégralité du fichier.',
    'This source link cannot be opened.': 'Ce lien source ne peut pas être ouvert.',
    'Read-only chat': 'Conversation en lecture seule',
    'Only {value1} writes in this chat. Fork it to continue with your own connections. {value2}':
      'Seul {value1} peut écrire dans cette conversation. Créez-en une copie pour continuer avec vos propres connexions. {value2}',
    'Suggest a follow-up…': 'Suggérer un suivi…',
    'Suggest a follow-up': 'Suggérer un suivi',
    'Sending…': 'Envoi…',
    Send: 'Envoyer',
    'We could not dismiss that suggestion. Please try again.':
      'Impossible d’ignorer cette suggestion. Veuillez réessayer.',
    'Suggested follow-ups': 'Suggestions de suivi',
    '{value1} suggests': '{value1} suggère',
    Ask: 'Demander',
    'Dismiss {value1}’s suggestion': 'Ignorer la suggestion de {value1}',
    'Suggested by': 'Suggéré par',
    '· edit it or send it': '· modifiez-la ou envoyez-la',
    'Remove the suggestion tag': 'Supprimer le tag de suggestion',
    '{value1} {value2} is getting an answer': '{value1} {value2} reçoit une réponse',
    '{value1} {value2} stopped the answer': '{value1} {value2} a interrompu la réponse',
    '{value1} Fork from here': '{value1} Créer une copie à partir d’ici',
    '{value1} From {value2}’s {value3}': '{value1} Depuis le {value3} de {value2}',
    'Only {value1} can use this account': 'Seul {value1} peut utiliser ce compte',
    '{value1} Suggested by {value2}': '{value1} Suggéré par {value2}',
    'Fork this chat': 'Créer une copie de cette conversation',
    'Forking…': 'Création de la copie…',
    Fork: 'Créer une copie',
    'Could not make this private.': 'Impossible de rendre cette conversation privée.',
    'Make this chat private?': 'Rendre cette conversation privée ?',
    Close: 'Fermer',
    '{value1} will see “{value2}”. Everyone else loses access right away {value3} .{value4}':
      '{value1} verra « {value2} ». Tous les autres perdront immédiatement l’accès {value3} .{value4}',
    Cancel: 'Annuler',
    'Saving…': 'Enregistrement…',
    'Make private': 'Rendre privée',
    'This chat is private again. Forks others made stay theirs.':
      'Cette conversation est de nouveau privée. Les copies créées par d’autres restent les leurs.',
    'Who can read this chat: {value1}': 'Qui peut lire cette conversation : {value1}',
    'Move this chat': 'Déplacer cette conversation',
    'Only you write here. Others follow live and fork.':
      'Vous êtes la seule personne à écrire ici. Les autres suivent en direct et peuvent créer une copie.',
    'Made private. {value1} has been told in their Inbox.':
      'Conversation rendue privée. {value1} en a été informé dans sa boîte de réception.',
    'Chat access': 'Accès à la conversation',
    '{value1}’s chat. As an admin you can make it private.':
      'Conversation de {value1}. En tant qu’administrateur, vous pouvez la rendre privée.',
    'Only {value1} will see it. {value2} is told.':
      'Seul {value1} la verra. {value2} en est informé.',
    '{value1} {value2} following': '{value1} {value2} suivent',
    'Forked from{value1} {value2} . The history is copied. From here, tools run with your own access.':
      'Copie créée depuis{value1} {value2} . L’historique est copié. À partir d’ici, les outils utilisent vos propres accès.',
    '{value1} made this chat private': '{value1} a rendu cette conversation privée',
    'You can no longer open it. Any fork you made stays yours.':
      'Vous ne pouvez plus l’ouvrir. Toute copie que vous avez créée reste la vôtre.',
    'Start a new chat': 'Démarrer une nouvelle conversation',
    'Back to Recent chats': 'Retour aux conversations récentes',
    'More chat actions': 'Plus d’actions sur la conversation',
    'Close conversation sharing': 'Fermer le partage de la conversation',
    'Review the text before saving a private copy to Library. Then choose its audience. Your original conversation and future messages stay private.':
      'Relisez le texte avant d’enregistrer une copie privée dans la Bibliothèque. Choisissez ensuite son audience. Votre conversation d’origine et vos futurs messages restent privés.',
    'Preparing the conversation…': 'Préparation de la conversation…',
    'Refresh preview': 'Actualiser l’aperçu',
    'The copy is saved in Library. Use Share to choose who can access it.':
      'La copie est enregistrée dans la Bibliothèque. Utilisez Partager pour choisir qui peut y accéder.',
    'Save this copy': 'Enregistrer cette copie',
    'That Skill could not be opened.': 'Impossible d’ouvrir cette compétence.',
    '{value1}{value2} · reviews and approvals': '{value1}{value2} · évaluations et approbations',
    'Open Inbox': 'Ouvrir la boîte de réception',
    'New at {value1} this week': 'Nouveautés chez {value1} cette semaine',
    'Nothing new this week. Shared work, published Skills and approved knowledge show up here.':
      'Rien de nouveau cette semaine. Les travaux partagés, les compétences publiées et les connaissances approuvées apparaissent ici.',
    'New at {value1}': 'Nouveautés chez {value1}',
    'This Skill is unavailable. Try again.': 'Cette compétence est indisponible. Réessayez.',
    'You can attach up to {value1} files. Remove an attachment to add another.':
      'Vous pouvez joindre jusqu’à {value1} fichiers. Supprimez une pièce jointe pour en ajouter une autre.',
    'Add company context': 'Ajouter le contexte de l’entreprise',
    'Add company context · @': 'Ajouter le contexte de l’entreprise · @',
    'Choose a Skill': 'Choisir une compétence',
    'Choose a Skill · /': 'Choisir une compétence · /',
    Edit: 'Modifier',
    '{value1} Edit with chat': '{value1} Modifier avec le chat',
    '{value1} Duplicate to my Library': '{value1} Dupliquer dans ma bibliothèque',
    'Duplicated to your Library. Only you can see the copy.':
      'Dupliqué dans votre bibliothèque. Vous seul pouvez voir la copie.',
    'Could not duplicate this Result. Try again.':
      'Impossible de dupliquer ce résultat. Réessayez.',
    'Saved version {value1}.': 'Version {value1} enregistrée.',
    'A newer version was saved. Reload the Result before saving.':
      'Une version plus récente a été enregistrée. Rechargez le résultat avant de l’enregistrer.',
    'Could not save this version. Try again.': 'Impossible d’enregistrer cette version. Réessayez.',
    '{value1} saved a newer version. Review it before saving.':
      '{value1} a enregistré une version plus récente. Consultez-la avant d’enregistrer.',
    'Hide their version': 'Masquer leur version',
    'Show their version': 'Afficher leur version',
    'Start from their version': 'Commencer à partir de leur version',
    Markdown: 'Markdown',
    'Result text': 'Texte du résultat',
    Preview: 'Aperçu',
    'What changed': 'Modifications',
    'What changed? (optional)': 'Qu’est-ce qui a changé ? (facultatif)',
    'Save version {value1}': 'Enregistrer la version {value1}',
    'Open chat': 'Ouvrir le chat',
    Current: 'Actuelle',
    Restore: 'Restaurer',
    'Could not load the history.': 'Impossible de charger l’historique.',
    'Restored version {value1} as version {value2}.':
      'La version {value1} a été restaurée en tant que version {value2}.',
    'Someone saved a newer version. Review it before restoring.':
      'Une personne a enregistré une version plus récente. Consultez-la avant de restaurer.',
    'Could not restore that version.': 'Impossible de restaurer cette version.',
    'Loading history…': 'Chargement de l’historique…',
    'Restoring keeps what is there now as a version too, so nothing is lost.':
      'La restauration conserve également le contenu actuel en tant que version, afin que rien ne soit perdu.',
    'This Result was made with your own {value1}.':
      'Ce résultat a été créé avec votre propre {value1}.',
    'It also used': 'Il a également utilisé',
    'This Result was made with': 'Ce résultat a été créé avec',
    'Colleagues can read what came from them, but can never use them.':
      'Les collègues peuvent lire ce qui en provient, mais ne peuvent jamais les utiliser.',
    'Your personal agent {value1} keeps it up to date with your own access, so every refresh can carry your private data.':
      'Votre agent personnel {value1} le tient à jour avec vos propres accès, de sorte que chaque actualisation peut inclure vos données privées.',
    'A colleague’s personal agent keeps it up to date with their own access, so every refresh can carry their private data.':
      'L’agent personnel d’un collègue le tient à jour avec ses propres accès, de sorte que chaque actualisation peut inclure ses données privées.',
    'Made private. Only you can see this meeting.':
      'Rendue privée. Vous seul pouvez voir cette réunion.',
    'Could not make this meeting private.': 'Impossible de rendre cette réunion privée.',
    'Meeting · {value1} {value2} · Original retained':
      'Réunion · {value1} {value2} · Original conservé',
    'The recording could not be opened.': 'Impossible d’ouvrir l’enregistrement.',
    'Ask about this suggestion': 'Poser une question sur cette suggestion',
    meeting_processing_failed: 'Échec du traitement de la réunion',
    'Who can see this': 'Qui peut voir ceci',
    'Everyone at {value1}': 'Tout le monde chez {value1}',
    'Only me': 'Moi uniquement',
    'Everyone at {value1} can find it and ask about it.':
      'Tout le monde chez {value1} peut le trouver et poser des questions à son sujet.',
    'Only you can open and search this meeting. You can share it later.':
      'Vous seul pouvez ouvrir et rechercher cette réunion. Vous pourrez la partager ultérieurement.',
    'Added. Only you can see it. Transcription is running in the background.':
      'Ajoutée. Vous seul pouvez la voir. La transcription s’exécute en arrière-plan.',
    'Visible to everyone at {value1}': 'Visible par tout le monde chez {value1}',
    'Could not make it private.': 'Impossible de la rendre privée.',
    'Show more meetings': 'Afficher davantage de réunions',
    'Attached to this message': 'Joint à ce message',
    'Connect securely, choose the tables to share, then decide whether Poneva can read or make changes.':
      'Connectez-vous en toute sécurité, choisissez les tables à partager, puis décidez si Poneva peut les lire ou les modifier.',
    'Review the tables this connection can access. Select at least one table.':
      'Vérifiez les tables auxquelles cette connexion peut accéder. Sélectionnez au moins une table.',
    'Select at least one table. Nothing is selected by default.':
      'Sélectionnez au moins une table. Aucune table n’est sélectionnée par défaut.',
    'Choose who can use this connection and what Poneva can do.':
      'Choisissez qui peut utiliser cette connexion et ce que Poneva peut faire.',
    'Your chosen access is enabled for the selected tables.':
      'L’accès que vous avez choisi est activé pour les tables sélectionnées.',
    'Your connection is saved with reading paused until permission is confirmed.':
      'Votre connexion est enregistrée, avec la lecture suspendue jusqu’à confirmation de l’autorisation.',
    'Confirm database disconnect': 'Confirmer la déconnexion de la base de données',
    'Disconnect this database?': 'Déconnecter cette base de données ?',
    'Access will stop for everyone using this connection.':
      'L’accès sera interrompu pour toutes les personnes utilisant cette connexion.',
    'Keep connection': 'Conserver la connexion',
    'What it can reach · {value1}{value2} {value3}':
      'Ce à quoi elle peut accéder · {value1}{value2} {value3}',
    Back: 'Retour',
    Continue: 'Continuer',
    'Uploading…': 'Importation…',
    Library: 'Bibliothèque',
    'Source material for your work. Available whenever you need it.':
      'Les documents sources de votre travail, disponibles quand vous en avez besoin.',
    'The work you want to keep, with its sources and conversation attached.':
      'Le travail que vous souhaitez conserver, avec ses sources et sa conversation associées.',
    Results: 'Résultats',
    Files: 'Fichiers',
    Artifacts: 'Éléments',
    'Search library': 'Rechercher dans la bibliothèque',
    'Find files by meaning…': 'Rechercher des fichiers par sens…',
    'Find saved work by meaning…': 'Rechercher du travail enregistré par sens…',
    'Search coverage is limited while indexing or meaning-based search is unavailable. You can retry or browse recent items.':
      'La couverture de la recherche est limitée pendant l’indexation ou lorsque la recherche par sens est indisponible. Vous pouvez réessayer ou parcourir les éléments récents.',
    'No matching work found.': 'Aucun travail correspondant trouvé.',
    'A starting point for your next question.': 'Un point de départ pour votre prochaine question.',
    'Good work is worth keeping.': 'Un travail de qualité mérite d’être conservé.',
    'Try a different description or clear the search to browse.':
      'Essayez une autre description ou effacez la recherche pour parcourir les éléments.',
    'Upload source material once and use it in conversations and Skills. Your original stays in the library.':
      'Importez vos documents sources une seule fois et utilisez-les dans les conversations et les compétences. L’original reste dans la bibliothèque.',
    'Ask Poneva to save an answer, table or chart. Results stay connected to the conversation and their sources.':
      'Demandez à Poneva d’enregistrer une réponse, un tableau ou un graphique. Les résultats restent associés à la conversation et à leurs sources.',
    'Start in chat {value1}': 'Commencer dans le chat {value1}',
    'Open result: {value1}': 'Ouvrir le résultat : {value1}',
    'Loading more library items…': 'Chargement d’autres éléments de la bibliothèque…',
    'Load more': 'Charger davantage',
    'Documents, transcripts, audio and video · Up to 500 MB per file. New files are private. Choose their audience with Share and which processable files become searchable company knowledge.':
      'Documents, transcriptions, fichiers audio et vidéos · Jusqu’à 500 Mo par fichier. Les nouveaux fichiers sont privés. Choisissez leur audience avec Partager et les fichiers traitables qui deviennent consultables dans les connaissances de l’entreprise.',
    Skills: 'Compétences',
    'Create in chat': 'Créer dans le chat',
    'Search Skills': 'Rechercher des compétences',
    'Search finds published Skills. Clear the search to browse your drafts too.':
      'La recherche trouve les compétences publiées. Effacez la recherche pour parcourir aussi vos brouillons.',
    'Search coverage is limited while indexing or meaning-based search is unavailable.':
      'La couverture de recherche est limitée pendant l’indexation ou lorsque la recherche sémantique est indisponible.',
    'Searching Skills…': 'Recherche de compétences…',
    'No matching published Skills found. Try a different description.':
      'Aucune compétence publiée correspondante trouvée. Essayez une autre description.',
    'Load more Skills': 'Charger davantage de compétences',
    'View Skill: {value1}': 'Afficher la compétence : {value1}',
    'Company workspace': 'Espace de travail de l’entreprise',
    'View {value1}': 'Afficher {value1}',
    'Loading Skills…': 'Chargement des compétences…',
    'Try again {value1}': 'Réessayer {value1}',
    'Try again': 'Réessayer',
    'Nothing yet.': 'Rien pour le moment.',
    'Made from · Used by': 'Créé à partir de · Utilisé par',
    'Could not load links': 'Impossible de charger les liens',
    'Made from': 'Créé à partir de',
    'Used by': 'Utilisé par',
    'About this chat {value1}': 'À propos de ce chat {value1}',
    'About this chat': 'À propos de ce chat',
    'Keep the work moving.': 'Faites avancer le travail.',
    'Ask a follow-up with this result in view, or turn a useful approach into a company Skill.':
      'Posez une question complémentaire avec ce résultat sous les yeux, ou transformez une approche utile en compétence d’entreprise.',
    'Save approach as a Skill': 'Enregistrer l’approche comme compétence',
    'Preview of': 'Aperçu de',
    'Made with': 'Créé avec',
    'Open the draft': 'Ouvrir le brouillon',
    'Open Skill': 'Ouvrir la compétence',
    'Use in chat': 'Utiliser dans le chat',
    'Finish the draft': 'Terminer le brouillon',
    'Refine this Skill': 'Affiner cette compétence',
    'Made with a Skill.': 'Créé avec une compétence.',
    'This workspace could not be loaded just now, so that Skill cannot be opened yet. The result itself is unchanged.':
      'Cet espace de travail n’a pas pu être chargé pour le moment, cette compétence ne peut donc pas encore être ouverte. Le résultat lui-même reste inchangé.',
    'That Skill is not available in this workspace, so it cannot be opened or used again. The result itself is unchanged.':
      'Cette compétence n’est pas disponible dans cet espace de travail : elle ne peut donc pas être ouverte ni réutilisée. Le résultat lui-même reste inchangé.',
    'Result · {value1} {value2}': 'Résultat · {value1} {value2}',
    '{value1} Copy link': '{value1} Copier le lien',
    'Result link copied.': 'Lien du résultat copié.',
    'Could not copy the link. Use your browser address bar.':
      'Impossible de copier le lien. Utilisez la barre d’adresse de votre navigateur.',
    'No preview is available for this result.': 'Aucun aperçu n’est disponible pour ce résultat.',
    '{value1} rows are retained in this snapshot. Open Table to inspect the values.':
      '{value1} lignes sont conservées dans cet instantané. Ouvrez le tableau pour examiner les valeurs.',
    'People can’t edit a Result an agent keeps up to date; the next refresh would replace their edit. Change the agent’s instructions instead.':
      'Les utilisateurs ne peuvent pas modifier un résultat qu’un agent tient à jour ; la prochaine actualisation remplacerait leur modification. Modifiez plutôt les instructions de l’agent.',
    'Linked sources': 'Sources liées',
    'Saved source': 'Source enregistrée',
    'No source documents are linked to this result. Company knowledge and other references may be cited in the answer.':
      'Aucun document source n’est lié à ce résultat. Les connaissances de l’entreprise et d’autres références peuvent être citées dans la réponse.',
    'Run details': 'Détails de l’exécution',
    Created: 'Créé',
    ', revised {value1}': ', révisé le {value1}',
    Conversation: 'Conversation',
    'Not recorded': 'Non enregistrée',
    'Open conversation': 'Ouvrir la conversation',
    Run: 'Exécution',
    Updates: 'Mises à jour',
    'Kept up to date by {value1}': 'Tenu à jour par {value1}',
    'Version {value1}': 'Version {value1}',
    'Could not open this request.': 'Impossible d’ouvrir cette demande.',
    'Approved version published.': 'La version approuvée a été publiée.',
    'Request rejected. The item stays unchanged.': 'Demande refusée. L’élément reste inchangé.',
    'Could not save the decision.': 'Impossible d’enregistrer la décision.',
    'Proposed company change': 'Modification proposée pour l’entreprise',
    'Opening…': 'Ouverture…',
    'Approve this version': 'Approuver cette version',
    Decline: 'Refuser',
    'Review the submitted version below. Changes made since submission will need a new request.':
      'Examinez ci-dessous la version soumise. Les modifications apportées depuis la soumission nécessiteront une nouvelle demande.',
    'The version submitted with this request.': 'La version soumise avec cette demande.',
    'Version and proposed change': 'Version et modification proposée',
    'Could not read the pinned content.': 'Impossible de lire le contenu épinglé.',
    'Showing a page of {value1} characters.': 'Affichage d’une page de {value1} caractères.',
    'Beginning of the submitted content. Open the full text to review every page.':
      'Début du contenu soumis. Ouvrez le texte intégral pour examiner chaque page.',
    'Read full submitted text': 'Lire l’intégralité du texte soumis',
    'Previous page': 'Page précédente',
    'Next page': 'Page suivante',
    'Made private. Its creator has been told in their Inbox.':
      'Rendu privé. Son créateur en a été informé dans sa boîte de réception.',
    'Made private. Its creator could not be notified.':
      'Rendu privé. Impossible d’en informer son créateur.',
    'Make this {value1} private?': 'Rendre {value1} privé ?',
    'Only the person who created it will see it. Everyone else loses access right away, and its creator gets an Inbox update if they are still a company member. If they have left, nobody in the company will be able to access this item.':
      'Seule la personne qui l’a créé le verra. Tous les autres perdront immédiatement l’accès, et son créateur recevra une mise à jour dans sa boîte de réception s’il est toujours membre de l’entreprise. S’il l’a quittée, personne dans l’entreprise ne pourra accéder à cet élément.',
    'Sent for review. The current audience stays unchanged until approval.':
      'Envoyé pour examen. L’audience actuelle reste inchangée jusqu’à l’approbation.',
    'Could not update sharing.': 'Impossible de mettre à jour le partage.',
    'They can follow new answers live and fork it to continue with their own connections. Only you write here. You can make it private again at any time.':
      'Ils peuvent suivre les nouvelles réponses en direct et le dupliquer pour continuer avec leurs propres connexions. Vous seul pouvez écrire ici. Vous pouvez le rendre privé à nouveau à tout moment.',
    'They see the project, its brief and the work in it they can already open. Nothing in it opens for anyone because of the project; each item keeps its own access.':
      'Ils voient le projet, son brief et les éléments qu’ils peuvent déjà ouvrir. Le projet ne donne accès à rien d’autre ; chaque élément conserve ses propres droits d’accès.',
    'Check the content for private information before sharing. Sharing an item does not grant access to its original chat or private connections.':
      'Vérifiez que le contenu ne contient pas d’informations privées avant de le partager. Le partage d’un élément ne donne pas accès à sa conversation d’origine ni à ses connexions privées.',
    '{value1} Everyone you share with can read it, including what the assistant or an App in it found in your {value2}. They can’t use your {value3}. Nothing changes for you: the chat keeps working with all your accounts.':
      '{value1} Toutes les personnes avec qui vous le partagez peuvent le lire, y compris ce que l’assistant ou une application y a trouvé dans votre {value2}. Elles ne peuvent pas utiliser votre {value3}. Rien ne change pour vous : la conversation continue de fonctionner avec tous vos comptes.',
    '{value1} Everyone you share with can read them, but nobody can use {value2} through this chat.':
      '{value1} Toutes les personnes avec qui vous les partagez peuvent les lire, mais personne ne peut utiliser {value2} via cette conversation.',
    'This controls access to the working draft. Any published company version stays available until you explicitly unpublish it. To publish a new version, complete its preview and use Save Skill. Run results stay private.':
      'Cela contrôle l’accès au brouillon de travail. Toute version publiée par l’entreprise reste disponible jusqu’à ce que vous la dépubliiez explicitement. Pour publier une nouvelle version, terminez son aperçu et utilisez Enregistrer la compétence. Les résultats d’exécution restent privés.',
    'Skill deleted. You can restore it from the Skills archive for 30 days.':
      'Compétence supprimée. Vous pouvez la restaurer depuis les archives des compétences pendant 30 jours.',
    'Could not delete this Skill.': 'Impossible de supprimer cette compétence.',
    'More actions': 'Plus d’actions',
    'Delete “{value1}”? It will disappear from Skills and search, and cannot be used by agents. You can restore it for 30 days. Existing chats and results stay available.':
      'Supprimer « {value1} » ? Elle disparaîtra des compétences et des résultats de recherche et ne pourra plus être utilisée par les agents. Vous pouvez la restaurer pendant 30 jours. Les conversations et résultats existants resteront disponibles.',
    'Deleting…': 'Suppression…',
    'Confirm delete': 'Confirmer la suppression',
    'Delete Skill': 'Supprimer la compétence',
    'Skill restored as an unpublished draft. Its author can review and publish it again.':
      'Compétence restaurée en tant que brouillon non publié. Son auteur peut la vérifier et la publier à nouveau.',
    'Could not restore this Skill.': 'Impossible de restaurer cette compétence.',
    'Archived Skills': 'Compétences archivées',
    'Deleted Skills can be restored for 30 days. Restoring leaves them unpublished.':
      'Les compétences supprimées peuvent être restaurées pendant 30 jours. Leur restauration ne les publie pas.',
    'Restore until {value1}': 'Restaurer jusqu’au {value1}',
    'Loading…': 'Chargement…',
    'No archived Skills.': 'Aucune compétence archivée.',
    'Load more archived Skills': 'Charger davantage de compétences archivées',
    'Show more of the original': 'Afficher davantage du contenu d’origine',
    'Filter result rows': 'Filtrer les lignes de résultats',
    'Find a product or value…': 'Rechercher un produit ou une valeur…',
    '{value1} of {value2}': '{value1} sur {value2}',
    'Result table': 'Tableau de résultats',
    'No matching rows.': 'Aucune ligne correspondante.',
    'Showing the first 1,000 matching rows. Download the CSV for every row.':
      'Affichage des 1 000 premières lignes correspondantes. Téléchargez le fichier CSV pour obtenir toutes les lignes.',
    'Agent ·': 'Agent ·',
    'Only you': 'Vous seul',
    'Stopped before it finished.': 'Arrêté avant la fin.',
    'Drafting the project…': 'Création du brouillon du projet…',
    'Checking where this chat belongs…': 'Vérification de l’emplacement de cette conversation…',
    'Moving the chat…': 'Déplacement de la conversation…',
    'Taking it out of the project…': 'Retrait du projet…',
    'Adding it to the project…': 'Ajout au projet…',
    'No matching connections are available right now.':
      'Aucune connexion correspondante n’est disponible pour le moment.',
    'Company knowledge suggestion': 'Suggestion de connaissances de l’entreprise',
    'Company knowledge now lives on pages. Open Knowledge to see them.':
      'Les connaissances de l’entreprise se trouvent désormais sur des pages. Ouvrez Connaissances pour les consulter.',
    '{value1} · Open beside this conversation': '{value1} · Ouvrir à côté de cette conversation',
    'Name {value1}': 'Nom {value1}',
    'Host {value1}': 'Hôte {value1}',
    'Port {value1}': 'Port {value1}',
    'Database {value1}': 'Base de données {value1}',
    'Username {value1}': 'Nom d’utilisateur {value1}',
    'Password {value1}': 'Mot de passe {value1}',
    'Advanced TLS': 'TLS avancé',
    '{value1} Poneva verifies the server certificate. Add a CA or server DNS name for IP hosts when your certificate requires it.':
      '{value1} Poneva vérifie le certificat du serveur. Ajoutez une autorité de certification ou un nom DNS de serveur pour les hôtes IP si votre certificat l’exige.',
    'CA certificate {value1}': 'Certificat de l’autorité de certification {value1}',
    'Certificate server DNS name {value1}':
      'Nom DNS du serveur indiqué dans le certificat {value1}',
    '{value1} Your password is encrypted in secure storage. Poneva verifies the connection before saving it.':
      '{value1} Votre mot de passe est chiffré dans un espace de stockage sécurisé. Poneva vérifie la connexion avant de l’enregistrer.',
    'Testing…': 'Test en cours…',
    'Test connection': 'Tester la connexion',
    'PostgreSQL is connected.': 'PostgreSQL est connecté.',
    'PostgreSQL was saved safely.': 'PostgreSQL a été enregistré en toute sécurité.',
    'Poneva can read and change rows in the selected tables. Apps also follow their approved data scope.':
      'Poneva peut lire et modifier les lignes des tables sélectionnées. Les applications respectent également leur périmètre de données approuvé.',
    'Poneva can read the selected tables. Apps also follow their approved data scope.':
      'Poneva peut lire les tables sélectionnées. Les applications respectent également leur périmètre de données approuvé.',
    'Reads are paused until permission is enabled.':
      'Les lectures sont suspendues jusqu’à l’activation de l’autorisation.',
    'Retrying…': 'Nouvelle tentative…',
    'Retry permission': 'Réessayer d’autoriser',
    'Try it in Chat': 'Essayer dans Chat',
    Done: 'Terminé',
    'Disconnect database': 'Déconnecter la base de données',
    '{value1} TLS verified ·{value2} {value3}': '{value1} TLS vérifié ·{value2} {value3}',
    'Search schemas and tables': 'Rechercher des schémas et des tables',
    'Search tables': 'Rechercher des tables',
    '{value1} of {value2} tables selected': '{value1} table(s) sélectionnée(s) sur {value2}',
    'Select matching tables': 'Sélectionner les tables correspondantes',
    'Select all tables': 'Sélectionner toutes les tables',
    Clear: 'Effacer',
    'Select a whole schema or individual tables. New tables need a fresh selection.':
      'Sélectionnez un schéma entier ou des tables individuelles. Les nouvelles tables nécessitent une nouvelle sélection.',
    'No tables match this search.': 'Aucune table ne correspond à cette recherche.',
    'All tables in {value1}': 'Toutes les tables de {value1}',
    '{value1} / {value2} tables': '{value1} / {value2} tables',
    'Read & write available': 'Lecture et écriture disponibles',
    'Read only': 'Lecture seule',
    Ctrl: 'Ctrl',
    'This suggested knowledge update could not be shown.':
      'Impossible d’afficher cette mise à jour suggérée des connaissances.',
    'Suggested knowledge update': 'Mise à jour suggérée des connaissances',
    'This suggestion is no longer available to you.':
      'Cette suggestion ne vous est plus accessible.',
    'We could not check where this suggestion stands.':
      'Nous n’avons pas pu vérifier l’état de cette suggestion.',
    'Check again': 'Réessayer',
    'Show on page': 'Afficher sur la page',
    'The editor could not be loaded. Poneva may have been updated since you opened this page. Reload to get the latest version; nothing on this page has changed.':
      'L’éditeur n’a pas pu être chargé. Poneva a peut-être été mis à jour depuis l’ouverture de cette page. Rechargez-la pour obtenir la dernière version ; rien sur cette page n’a changé.',
    'Reload Poneva': 'Recharger Poneva',
    Formatting: 'Mise en forme',
    'Text style': 'Style du texte',
    Text: 'Texte',
    Heading: 'Titre',
    Subheading: 'Sous-titre',
    'Link a page': 'Lier une page',
    'A page needs a title.': 'Une page doit avoir un titre.',
    'Nothing has changed yet.': 'Rien n’a encore changé.',
    'A page needs some text. To remove a page, archive it instead.':
      'Une page doit contenir du texte. Pour supprimer une page, archivez-la.',
    'A suggested new page needs some text.': 'Une nouvelle page suggérée doit contenir du texte.',
    'This page is larger than 256 KB. Split it into smaller pages.':
      'Cette page dépasse 256 Ko. Divisez-la en pages plus petites.',
    'Say in a few words why this change is right.':
      'Expliquez en quelques mots pourquoi cette modification est pertinente.',
    'This page changed while you were editing. Your text is still here: copy it, then open the latest version and make your change again.':
      'Cette page a été modifiée pendant que vous la modifiiez. Votre texte est toujours là : copiez-le, puis ouvrez la dernière version et effectuez à nouveau votre modification.',
    'Your text is copied.': 'Votre texte a été copié.',
    'Your text could not be copied. Select it in the editor and copy it.':
      'Votre texte n’a pas pu être copié. Sélectionnez-le dans l’éditeur, puis copiez-le.',
    'The page “{value1}” is created.': 'La page « {value1} » a été créée.',
    'New page': 'Nouvelle page',
    'Editing {value1}': 'Modification de {value1}',
    Editing: 'Modification',
    'Creating publishes the page under {value1} for everyone':
      'La création publie la page sous {value1} pour tout le monde',
    'Saving publishes the new version for everyone':
      'L’enregistrement publie la nouvelle version pour tout le monde',
    'Your changes are sent as a suggestion for a publisher':
      'Vos modifications sont envoyées comme suggestion à un éditeur',
    'Create page': 'Créer la page',
    Save: 'Enregistrer',
    'Send suggestion': 'Envoyer la suggestion',
    '{value1} Copy my text': '{value1} Copier mon texte',
    'Open the latest version': 'Ouvrir la dernière version',
    'Page title': 'Titre de la page',
    'Loading the editor…': 'Chargement de l’éditeur…',
    'New page text': 'Texte de la nouvelle page',
    'Text of {value1}': 'Texte de {value1}',
    'Write the page. Type [[ to link another page.':
      'Rédigez la page. Saisissez [[ pour créer un lien vers une autre page.',
    'Type [[ to link another page.': 'Saisissez [[ pour créer un lien vers une autre page.',
    'Link to a page': 'Lien vers une page',
    'What changed, in a few words': 'Ce qui a changé, en quelques mots',
    'Where this comes from, in a few words': 'Origine, en quelques mots',
    'Shown in the page history.': 'Affiché dans l’historique de la page.',
    'A publisher sees this next to your change.':
      'Un éditeur voit ceci à côté de votre modification.',
    '1 suggestion is open on this page': '1 suggestion est ouverte sur cette page',
    '{value1} suggestions are open on this page':
      '{value1} suggestions sont ouvertes sur cette page',
    'They stay open while you edit. After you save, they show against your new text; one whose words you changed is marked outdated.':
      'Elles restent ouvertes pendant vos modifications. Après l’enregistrement, elles s’affichent par rapport à votre nouveau texte ; celles dont vous avez modifié les termes sont marquées comme obsolètes.',
    'Type [[ to link another page. Links keep working when a page is renamed or moved.':
      'Saisissez [[ pour créer un lien vers une autre page. Les liens continuent de fonctionner lorsqu’une page est renommée ou déplacée.',
    'Loading the history…': 'Chargement de l’historique…',
    'This page has no saved text yet.': 'Cette page ne contient pas encore de texte enregistré.',
    'Say in a few words why this revision should come back.':
      'Expliquez en quelques mots pourquoi cette révision devrait être restaurée.',
    'Revision {value1} is suggested for a publisher to accept.':
      'La révision {value1} est proposée à l’acceptation d’un éditeur.',
    'The page already reads like this revision.': 'La page correspond déjà à cette révision.',
    'Revision {value1} is restored as revision {value2}.':
      'La révision {value1} est restaurée en tant que révision {value2}.',
    'Revision history': 'Historique des révisions',
    Revisions: 'Révisions',
    'Every saved revision is kept.': 'Toutes les révisions enregistrées sont conservées.',
    'Revision {value1} {value2}': 'Révision {value1} {value2}',
    'Revision {value1} compared with revision {value2}':
      'Comparaison de la révision {value1} avec la révision {value2}',
    'Revision {value1}, the first text of this page':
      'Révision {value1}, premier texte de cette page',
    'Green was added, struck through was removed.':
      'Le vert a été ajouté ; le texte barré a été supprimé.',
    '{value1} Export Markdown': '{value1} Exporter en Markdown',
    'Restore this revision': 'Restaurer cette révision',
    'Suggest restoring it': 'Suggérer de la restaurer',
    'Why should this revision come back?': 'Pourquoi cette révision devrait-elle être restaurée ?',
    'Loading this revision…': 'Chargement de cette révision…',
    'Only the title changed, from “{value1}” to “{value2}”.':
      'Seul le titre a changé, de « {value1} » à « {value2} ».',
    'The text did not change in this revision.': 'Le texte n’a pas changé dans cette révision.',
    'Changes in revision {value1}': 'Modifications de la révision {value1}',
    'Loading page…': 'Chargement de la page…',
    'Loading suggestion…': 'Chargement de la suggestion…',
    'This suggestion is not available.': 'Cette suggestion n’est pas disponible.',
    'It may have been decided, or it is not one you can see.':
      'Elle a peut-être déjà été traitée, ou vous n’êtes pas autorisé à la voir.',
    'Open Knowledge': 'Ouvrir la base de connaissances',
    'Opening the suggestion…': 'Ouverture de la suggestion…',
    'Choose where the page goes.': 'Choisissez où placer la page.',
    'Say in a few words why.': 'Expliquez pourquoi en quelques mots.',
    'Your suggestion is sent. A publisher decides.':
      'Votre suggestion a été envoyée. Un éditeur prendra la décision.',
    'Moved under {value1}.': 'Déplacée sous {value1}.',
    'Deleted “{value1}”.': '« {value1} » a été supprimée.',
    'Archived. Its history is kept.': 'Archivée. Son historique est conservé.',
    'Choose the page it goes under. Links to it keep working.':
      'Choisissez la page sous laquelle elle sera placée. Les liens vers celle-ci continueront de fonctionner.',
    'Its text, its history and any open suggestions are removed for good, and links to it from other pages stop working. This cannot be undone.':
      'Son texte, son historique et les suggestions en cours sont définitivement supprimés, et les liens vers celle-ci depuis d’autres pages cessent de fonctionner. Cette action est irréversible.',
    'An archived page no longer informs answers. Its history is kept, and a publisher can restore it or delete it permanently.':
      'Une page archivée n’est plus prise en compte dans les réponses. Son historique est conservé, et un éditeur peut la restaurer ou la supprimer définitivement.',
    Under: 'Sous',
    Change: 'Modifier',
    'Move under': 'Déplacer sous',
    'Search pages': 'Rechercher des pages',
    'Why?': 'Pourquoi ?',
    'Delete permanently': 'Supprimer définitivement',
    'Move page': 'Déplacer la page',
    'Archive page': 'Archiver la page',
    'Suggestion {value1}: show its card': 'Suggestion {value1} : afficher sa fiche',
    'Removed:': 'Supprimé :',
    'Added:': 'Ajouté :',
    'New page “{value1}”{value2}': 'Nouvelle page « {value1} »{value2}',
    'No pages match “{value1}”.': 'Aucune page ne correspond à « {value1} ».',
    'Where this page is': 'Emplacement de cette page',
    'Describe your company': 'Décrivez votre entreprise',
    'Empty page': 'Page vide',
    'Describe {value1}': 'Décrire {value1}',
    'This page has no text yet.': 'Cette page ne contient encore aucun texte.',
    'Poneva reads this page before every answer. Start with who you are, what you sell and how you work; details go on the pages under it.':
      'Poneva lit cette page avant chaque réponse. Commencez par présenter votre entreprise, ce que vous vendez et votre façon de travailler ; ajoutez les détails sur les pages placées dessous.',
    'Write it, or ask Poneva in chat to draft it for you.':
      'Rédigez-la ou demandez à Poneva de vous en proposer une version dans le chat.',
    'Suggest a first version, and a publisher decides whether it becomes the page.':
      'Proposez une première version ; un éditeur décidera si elle devient la page.',
    'Start writing': 'Commencer à écrire',
    'Suggest a first version': 'Proposer une première version',
    'Accepted. The page is archived.': 'Acceptée. La page est archivée.',
    'Accepted. The page is now revision {value1}.':
      'Acceptée. La page est maintenant à la révision {value1}.',
    'Accepted.': 'Acceptée.',
    'Suggestion rejected. The page stays as it is.': 'Suggestion refusée. La page reste inchangée.',
    'Your suggestion is withdrawn.': 'Votre suggestion est retirée.',
    'Restored. The page informs answers again.':
      'Restaurée. La page est de nouveau prise en compte dans les réponses.',
    'Your suggestion is sent. A publisher decides whether it becomes the page.':
      'Votre suggestion est envoyée. Un éditeur décidera si elle devient la page.',
    'Saved. The page is now revision {value1}.':
      'Enregistrée. La page est maintenant à la révision {value1}.',
    'Nothing changed.': 'Aucun changement.',
    'This page is not available.': 'Cette page n’est pas disponible.',
    'It may have been deleted, archived or moved out of reach, or you may no longer be in this company.':
      'Elle a peut-être été supprimée, archivée ou déplacée hors de votre accès, ou vous ne faites peut-être plus partie de cette entreprise.',
    'Page actions': 'Actions sur la page',
    shown: 'affichées',
    hidden: 'masquées',
    '{value1} History': 'Historique de {value1}',
    '{value1} Ask in chat': 'Demander à {value1} dans le chat',
    'Suggest edits': 'Suggérer des modifications',
    'More actions for {value1}': 'Plus d’actions pour {value1}',
    '{value1} Poneva reads this page in every chat':
      '{value1} Poneva lit cette page dans chaque chat',
    'This page is archived. It no longer informs answers; its history is kept. {value1}':
      'Cette page est archivée. Elle n’est plus prise en compte dans les réponses ; son historique est conservé. {value1}',
    'Restore page': 'Restaurer la page',
    'This link points to an earlier revision. You are reading the current text.':
      'Ce lien renvoie vers une révision antérieure. Vous consultez le texte actuel.',
    'Show it in History': 'L’afficher dans l’historique',
    Pages: 'Pages',
    'Pages under {value1}': 'Pages sous {value1}',
    'Linked from': 'Liens depuis',
    Suggestions: 'Suggestions',
    'Suggestions are hidden. You are reading the page as everyone else sees it.':
      'Les suggestions sont masquées. Vous consultez la page telle que les autres la voient.',
    'Loading suggestions…': 'Chargement des suggestions…',
    'Nothing is waiting for review.': 'Aucun élément n’est en attente de révision.',
    'When someone, Poneva in a chat or a connected agent suggests a change to a page, it shows here and on the page. Nothing changes until a publisher accepts it.':
      'Lorsqu’une personne, Poneva dans un chat ou un agent connecté suggère une modification d’une page, celle-ci s’affiche ici et sur la page. Rien ne change tant qu’un éditeur ne l’a pas acceptée.',
    '{value1} Review knowledge in chat': '{value1} Réviser les connaissances dans le chat',
    'Suggestions for review': 'Suggestions à examiner',
    'Suggested changes from chats, meetings, colleagues and connected agents. Nothing changes until a publisher accepts it on the page.':
      'Modifications suggérées depuis des chats, des réunions, des collègues et des agents connectés. Rien ne change tant qu’un éditeur ne les a pas acceptées sur la page.',
    'Your suggestions wait here until a publisher decides. The pages stay as they are until then.':
      'Vos suggestions restent ici jusqu’à la décision d’un éditeur. Les pages restent inchangées d’ici là.',
    'Review page': 'Réviser la page',
    'Review on page': 'Réviser sur la page',
    'Open the meeting': 'Ouvrir la réunion',
    'Open the chat': 'Ouvrir le chat',
    'Accept and restore': 'Accepter et restaurer',
    Accept: 'Accepter',
    Reject: 'Refuser',
    'Your suggestion · waiting for a publisher': 'Votre suggestion · en attente d’un éditeur',
    Withdraw: 'Retirer',
    'Waiting for a publisher': 'En attente d’un éditeur',
    'Suggestion {value1}': 'Suggestion {value1}',
    'Suggestion {value1} from {value2}{value3}': 'Suggestion {value1} de {value2}{value3}',
    'Read the suggested page': 'Lire la page suggérée',
    'Outdated: the text it changes was edited after it was suggested. It can be rejected or withdrawn; a new suggestion can be made against the current text.':
      'Obsolète : le texte qu’elle modifie a été édité après la suggestion. Celle-ci peut être refusée ou retirée ; une nouvelle suggestion peut être faite à partir du texte actuel.',
    'Restore this page first to accept this suggestion.':
      'Restaurez d’abord cette page pour accepter cette suggestion.',
    'Previous suggestion': 'Suggestion précédente',
    'Suggestion {value1} of {value2}': 'Suggestion {value1} sur {value2}',
    'Next suggestion': 'Suggestion suivante',
    'Fold the suggestions away': 'Masquer les suggestions',
    'Show the suggestions': 'Afficher les suggestions',
    '1 suggestion': '1 suggestion',
    '{value1} suggestions': '{value1} suggestions',
    '{value1} the pages under {value2}': '{value1} les pages sous {value2}',
    px: 'px',
    '{value1} chart of {value2} across {value3}': 'Graphique {value1} de {value2} sur {value3}',
    'We could not build the file.': 'Nous n’avons pas pu créer le fichier.',
    '{value1} Present': '{value1} présent',
    'Building…': 'Création…',
    'Download PowerPoint': 'Télécharger PowerPoint',
    'Slide {value1} of {value2}': 'Diapositive {value1} sur {value2}',
    Slides: 'Diapositives',
    'Slide {value1}': 'Diapositive {value1}',
    'Speaker notes': 'Notes du présentateur',
    'Source: {value1}': 'Source : {value1}',
    'Add a name and a web address.': 'Ajoutez un nom et une adresse web.',
    'Enter a valid web address.': 'Saisissez une adresse web valide.',
    'Use a web address that starts with https://.':
      'Utilisez une adresse web commençant par https://.',
    'Add a custom connection': 'Ajouter une connexion personnalisée',
    'Connect a tool server you trust. Poneva checks the address works and saves only the connection details needed to use it.':
      'Connectez un serveur d’outils de confiance. Poneva vérifie que l’adresse fonctionne et enregistre uniquement les informations de connexion nécessaires à son utilisation.',
    'Web address': 'Adresse web',
    'https://tools.example.com': 'https://tools.example.com',
    'Starts with https://, from your provider':
      'Commence par https://, fourni par votre fournisseur',
    'Sign-in': 'Authentification',
    'Advanced sign-in': 'Authentification avancée',
    'Access key {value1}': 'Clé d’accès {value1}',
    'Request headers': 'En-têtes de requête',
    'Add header': 'Ajouter un en-tête',
    'Header {value1} name': 'Nom de l’en-tête {value1}',
    'Header name': 'Nom de l’en-tête',
    'Header {value1} value': 'Valeur de l’en-tête {value1}',
    'Header value': 'Valeur de l’en-tête',
    'Remove header': 'Supprimer l’en-tête',
    Advanced: 'Avancé',
    Transport: 'Transport',
    'Auto-detect': 'Détection automatique',
    'Streamable HTTP': 'HTTP diffusé en continu',
    'Legacy SSE': 'SSE classique',
    "From your provider's app settings. Leave empty unless they gave you these.":
      'Dans les paramètres de l’application de votre fournisseur. Laissez vide sauf si ces informations vous ont été fournies.',
    "Authorization server issuer": "Émetteur du serveur d’autorisation",
    "Enter the authorization server issuer when using a client ID.": "Indiquez l’émetteur du serveur d’autorisation si vous utilisez un identifiant client.",
    'Client ID {value1}': 'ID client {value1}',
    'Client secret {value1}': 'Secret client {value1}',
    'Connecting…': 'Connexion…',
    'Test and connect': 'Tester et connecter',
    'Add the store, the client ID and the client secret.':
      'Ajoutez la boutique, l’ID client et le secret client.',
    'Connect your Shopify Developer App': 'Connecter votre application Shopify pour développeurs',
    'Poneva can use exactly the access your store gave the app, and nothing more. It talks to Shopify directly and keeps the client secret encrypted.':
      'Poneva peut utiliser exactement les accès que votre boutique a accordés à l’application, et rien de plus. Elle communique directement avec Shopify et conserve le secret client chiffré.',
    'How to create the app in Shopify': 'Comment créer l’application dans Shopify',
    'Open{value1} {value2}{value3} with the account that owns the store, and create an app.':
      'Ouvrez{value1} {value2}{value3} avec le compte propriétaire de la boutique, puis créez une application.',
    'Create a version and select the access scopes Poneva may use, for example read_products and read_orders. Add write_ scopes only for data Poneva may change. Then release the version.':
      'Créez une version et sélectionnez les autorisations que Poneva peut utiliser, par exemple read_products et read_orders. Ajoutez des autorisations write_ uniquement pour les données que Poneva peut modifier. Publiez ensuite la version.',
    'For orders and customers, also select protected customer data in the app’s settings. Shopify allows this without review for an app made for your own store.':
      'Pour les commandes et les clients, sélectionnez également les données client protégées dans les paramètres de l’application. Shopify l’autorise sans examen pour une application créée pour votre propre boutique.',
    'Install the app on your store.': 'Installez l’application sur votre boutique.',
    'Copy the client ID and client secret from the app’s settings.':
      'Copiez l’ID client et le secret client depuis les paramètres de l’application.',
    'To change the access later, release a new version, approve it on the store and use Test connection here.':
      'Pour modifier les accès ultérieurement, publiez une nouvelle version, approuvez-la dans la boutique, puis utilisez Tester la connexion ici.',
    Store: 'Boutique',
    'your-store.myshopify.com': 'your-store.myshopify.com',
    'Your store’s .myshopify.com address (Shopify admin → Settings → Domains), or paste the address of your Shopify admin page':
      'Adresse .myshopify.com de votre boutique (interface d’administration Shopify → Settings → Domains), ou collez l’adresse de votre page d’administration Shopify',
    'Client ID {value1} {value2}': 'ID client {value1} {value2}',
    'Client secret {value1} {value2}': 'Secret client {value1} {value2}',
    Person: 'Personne',
    Everyone: 'Tout le monde',
    Connection: 'Connexion',
    'All connections': 'Toutes les connexions',
    'App {value1}': 'Application {value1}',
    'From {value1}': 'Du {value1}',
    'Until {value1}': 'Jusqu’au {value1}',
    Result: 'Résultat',
    'All results': 'Tous les résultats',
    Succeeded: 'Réussi',
    Denied: 'Refusé',
    Failed: 'Échoué',
    Unknown: 'Inconnu',
    Filter: 'Filtrer',
    'Loading activity…': 'Chargement de l’activité…',
    'Could not load activity. Try again.': 'Impossible de charger l’activité. Réessayez.',
    'Removed connection': 'Connexion supprimée',
    'App: {value1}': 'Application : {value1}',
    'Older activity': 'Activité plus ancienne',
    'What changed in version {value1}': 'Qu’est-ce qui a changé dans la version {value1}',
    'Every publish is a version you can restore.':
      'Chaque publication est une version que vous pouvez restaurer.',
    Authorization: 'Autorisation',
    '{value1} {value2} · {value3} will see it.': '{value1} {value2} · {value3} le verront.',
    '{value1} {value2} you': '{value1} {value2} vous',
    '· Revised': '· Révisé',
    'This chat used your {value1}.': 'Cette conversation a utilisé votre {value1}.',
    'This chat has results from {value1}.':
      'Cette conversation contient des résultats de {value1}.',
    'db.example.com': 'db.example.com',
    'e.g. Product analytics': 'p. ex. analyse produit',
    'Paste access key': 'Collez la clé d’accès',
    'Shopify’s Dev Dashboard': 'Tableau de bord développeur de Shopify',
    'App reference': 'Référence de l’application',
    'Draft · revision {value1}': 'Brouillon · révision {value1}',
    'its Result': 'son résultat',
    '· its first run makes it': '· sa première exécution le rend',
    '{value1}’s chat ·': 'Conversation de {value1} ·',
    '{value1} ad {value2} available.': '{value1} et {value2} disponibles.',
    '{value1} rows ·': '{value1} lignes ·',
    'It starts private. Sharing it wider shares every refresh, which can carry your private data.':
      'Elle est privée au départ. La partager plus largement partage chaque actualisation, qui peut contenir vos données privées.',
    Download: 'Télécharger',
    CSV: 'CSV',
    'Evidence for {value1}': 'Éléments justificatifs pour {value1}',
    Measure: 'Mesure',
    'Show rows →': 'Afficher les lignes →',
    'Ask about this number': 'Poser une question sur ce nombre',
    'There are no numeric values available to chart. View the table for the original data.':
      "Aucune valeur numérique n'est disponible pour créer un graphique. Consultez le tableau pour voir les données d'origine.",
    'Chart value': 'Valeur du graphique',
    '{value1} of {value2} shown': '{value1} sur {value2} affichées',
    '{value1} by {value2}; {value3} rows. View Table for exact values.':
      '{value1} par {value2} ; {value3} lignes. Consultez le tableau pour connaître les valeurs exactes.',
    'Values come directly from the source data. Missing values are not estimates.':
      'Les valeurs proviennent directement des données sources. Les valeurs manquantes ne sont pas des estimations.',
    'Loading library…': 'Chargement de la bibliothèque…',
    'We couldn’t load what happened in this App. Try again in a moment.':
      "Nous n'avons pas pu charger ce qui s'est passé dans cette application. Réessayez dans un instant.",
    'This App could not be opened.': "Cette application n'a pas pu être ouverte.",
    'Opening App…': "Ouverture de l'application…",
    'Open the saved App to run this function.':
      "Ouvrez l'application enregistrée pour exécuter cette fonction.",
    'Save this App before running its function.':
      "Enregistrez cette application avant d'exécuter sa fonction.",
    'Open saved App': "Ouvrir l'application enregistrée",
    'Open Apps': 'Ouvrir les applications',
    'The App could not be opened. Try again.': "L'application n'a pas pu être ouverte. Réessayez.",
    Owner: 'Propriétaire',
    '{value1} · admins': '{value1} · administrateurs',
    'Owner · always edits': 'Propriétaire · peut toujours modifier',
    'Admins manage it': 'Les administrateurs la gèrent',
    Editors: 'Éditeurs',
    'A colleague': 'Un collègue',
    'Can edit drafts and publish versions': 'Peut modifier les brouillons et publier des versions',
    Remove: 'Supprimer',
    'No editors yet.': 'Aucun éditeur pour le moment.',
    'Admins can always edit company agents.':
      "Les administrateurs peuvent toujours modifier les agents de l'entreprise.",
    'Asking for edit access': "Demande d'accès en modification",
    'Asked {value1} · also in your Inbox':
      'Demandé {value1} · également dans votre boîte de réception',
    Grant: 'Accorder',
    Admin: 'Administrateur',
    'Make personal': 'Rendre personnel',
    'Switch off': 'Désactiver',
    Archive: 'Archiver',
    'Archive this agent': 'Archiver cet agent',
    'Loading agent…': "Chargement de l'agent…",
    '{value1} Edit in chat': '{value1} Modifier dans le chat',
    Agent: 'Agent',
    'This agent has not been created yet. It can run once its owner creates it.':
      "Cet agent n'a pas encore été créé. Il pourra être exécuté une fois créé par son propriétaire.",
    'New agent · Draft': 'Nouvel agent · Brouillon',
    'Untitled agent': 'Agent sans titre',
    'Test run': 'Exécution de test',
    'This draft does not run automatically.': "Ce brouillon ne s'exécute pas automatiquement.",
    'Describe the agent in the chat. Its draft appears here.':
      "Décrivez l'agent dans le chat. Son brouillon apparaîtra ici.",
    '{value1} Test run': '{value1} Exécution de test',
    'Describe the agent in the chat first.': "Décrivez d'abord l'agent dans le chat.",
    'Create and turn on': 'Créer et activer',
    'Connection write setup': "Configuration de l'écriture de la connexion",
    'Account for connected changes': 'Compte pour les modifications connectées',
    'Choose a connection': 'Choisir une connexion',
    'No published Skills available. You can add them later.':
      "Aucune compétence publiée n'est disponible. Vous pourrez en ajouter ultérieurement.",
    '{value1} · not published. Review the changes. Testing is optional.':
      '{value1} · non publié. Examinez les modifications. Les tests sont facultatifs.',
    '{value1} Test draft': '{value1} Tester le brouillon',
    'Apply changes…': 'Appliquer les modifications…',
    'Apply this draft as a new version': 'Appliquer ce brouillon comme nouvelle version',
    'This draft cannot be applied.': 'Ce brouillon ne peut pas être appliqué.',
    'What changed?': "Qu'est-ce qui a changé ?",
    'Apply version {value1}': 'Appliquer la version {value1}',
    Create: 'Créer',
    'Edit access requested': 'Accès en modification demandé',
    '{value1} Request edit access': '{value1} Demander un accès en modification',
    '{value1} Copy agent': "{value1} Copier l'agent",
    Pause: 'Mettre en pause',
    'Open agent: {value1}': "Ouvrir l'agent : {value1}",
    '· you can edit': '· vous pouvez modifier',
    '{value1} is switched off.': '{value1} est désactivé.',
    '{value1} is archived.': '{value1} est archivé.',
    'Loading agents…': 'Chargement des agents…',
    Agents: 'Agents',
    'Agents do work for you on a schedule or when you ask. They follow your company’s Skills.':
      'Les agents travaillent pour vous selon un calendrier ou à votre demande. Ils suivent les compétences de votre entreprise.',
    'No agent matches. Try a Skill name or what the agent should do.':
      "Aucun agent ne correspond. Essayez le nom d'une compétence ou décrivez ce que l'agent doit faire.",
    'Nothing of your own yet': "Vous n'avez encore rien à vous",
    'Tell Chat what an agent should do, or copy one of the company’s agents below.{value1}':
      "Dites à Chat ce qu'un agent doit faire ou copiez l'un des agents de l'entreprise ci-dessous.{value1}",
    'Your agents': 'Vos agents',
    'Run on demand': 'Exécuter à la demande',
    'Run is always available. A schedule is optional and lives separately from the agent’s instructions.':
      "L'exécution est toujours disponible. Un calendrier est facultatif et est géré séparément des instructions de l'agent.",
    'Enable this schedule when approved': 'Activer cette planification après approbation',
    Schedule: 'Planification',
    'Kept off until you create the agent from its canvas.':
      'Désactivée jusqu’à ce que vous créiez l’agent depuis son canevas.',
    'Will be enabled when you approve.': 'Sera activée après votre approbation.',
    'Will be saved paused. You can enable it later.':
      'Sera enregistrée en pause. Vous pourrez l’activer plus tard.',
    'Only runs when you ask.': 'S’exécute uniquement lorsque vous le demandez.',
    'Draft · approving saves it, and nothing runs. Test it and create it from its canvas.':
      'Brouillon · l’approbation l’enregistre et rien ne s’exécute. Testez-le et créez-le depuis son canevas.',
    'Draft · nothing is scheduled until you approve. Connected actions require their own approval at run time.':
      'Brouillon · rien n’est planifié avant votre approbation. Les actions connectées nécessitent leur propre approbation au moment de l’exécution.',
    Name: 'Nom',
    'Agent name': 'Nom de l’agent',
    'Who can use it': 'Qui peut l’utiliser',
    'Company agent · company resources only':
      'Agent d’entreprise · ressources de l’entreprise uniquement',
    'Personal agent · runs with your access': 'Agent personnel · s’exécute avec vos accès',
    'Approving saves it as a draft. It does not run automatically.':
      'L’approbation l’enregistre comme brouillon. Il ne s’exécute pas automatiquement.',
    'Open the agent’s runs': 'Ouvrir les exécutions de l’agent',
    'Run the published version once': 'Exécuter une fois la version publiée',
    'Stopping…': 'Arrêt…',
    'Stop run': 'Arrêter l’exécution',
    'Could not stop this run. Please try again.':
      'Impossible d’arrêter cette exécution. Veuillez réessayer.',
    'Run in progress': 'Exécution en cours',
    'This run is still answering. You can ask follow-ups when it finishes.':
      'Cette exécution est toujours en train de répondre. Vous pourrez poser des questions complémentaires lorsqu’elle sera terminée.',
    'Open run details': 'Ouvrir les détails de l’exécution',
    Runs: 'Exécutions',
    'Open the run chat': 'Ouvrir le chat de l’exécution',
    Watch: 'Suivre',
    Goal: 'Objectif',
    'Change the goal': 'Modifier l’objectif',
    'What it does': 'Ce qu’il fait',
    'What should this agent achieve?': 'Que doit accomplir cet agent ?',
    'Not set yet.': 'Pas encore défini.',
    'When it runs': 'Quand il s’exécute',
    'Change when it runs': 'Modifier son déclenchement',
    'Off means it runs only when someone runs it. Changing when it runs never changes its instructions.':
      'Désactivé signifie qu’il s’exécute uniquement lorsqu’une personne le lance. Modifier son déclenchement ne change jamais ses instructions.',
    Instructions: 'Instructions',
    'Change the instructions': 'Modifier les instructions',
    'How the agent should approach the work and make decisions.':
      'Comment l’agent doit aborder le travail et prendre des décisions.',
    Boundaries: 'Limites',
    'What to do or avoid. Every connected action still follows its approval.':
      'Ce qu’il doit faire ou éviter. Chaque action connectée reste soumise à son approbation.',
    'No instructions of its own. It follows its Skills.':
      'Aucune instruction propre. Il suit ses Compétences.',
    'Pin a Skill': 'Épingler une compétence',
    'Finds the Skills that fit each run, the same way a chat does.':
      'Trouve les compétences adaptées à chaque exécution, comme le fait un chat.',
    'Skills it always follows': 'Compétences qu’il suit toujours',
    'A Skill that is not published': 'Une compétence qui n’est pas publiée',
    'Always follows · Version {value1}': 'Suit toujours · Version {value1}',
    'Not published': 'Non publiée',
    Uses: 'Utilise',
    'Change in chat': 'Modifier dans le chat',
    'Change in chat: Uses': 'Modifier dans le chat : utilise',
    'Company knowledge and the tools each run is allowed to use.':
      'Connaissances de l’entreprise et outils que chaque exécution est autorisée à utiliser.',
    'People see the Result refresh; they change the agent, not the page.':
      'Les utilisateurs voient le Résultat s’actualiser ; ils modifient l’agent, pas la page.',
    'The first run after it is created makes the Result; later runs add a version to it.':
      'La première exécution après sa création génère le Résultat ; les suivantes lui ajoutent une version.',
    'Emails whoever the run is for': 'Envoie un e-mail à la personne concernée par l’exécution',
    'Email each run': 'Envoyer un e-mail pour chaque exécution',
    Delivers: 'Produit',
    'Change what it delivers': 'Modifier ce qu’il produit',
    'Expected result': 'Résultat attendu',
    'What a successful run should deliver.': 'Ce qu’une exécution réussie doit produire.',
    'What each run delivers': 'Ce que produit chaque exécution',
    'Keeps one Result up to date {value1}': 'Maintient un Résultat à jour {value1}',
    'Saves a new Result each run': 'Enregistre un nouveau Résultat à chaque exécution',
    'You can run this company agent as yourself.{value1} {value2}':
      'Vous pouvez exécuter cet agent d’entreprise en votre nom.{value1} {value2}',
    'Changes since version': 'Modifications depuis la version',
    'are not live yet.': 'ne sont pas encore actives.',
    'Review them in Versions': 'Consultez-les dans Versions',
    Skill: 'Compétence',
    'The agent always uses the Skill’s published version.':
      'L’agent utilise toujours la version publiée de la compétence.',
    Day: 'Jour',
    Time: 'Heure',
    'Cron expression': 'Expression Cron',
    'Editors and access': 'Éditeurs et accès',
    Company: 'Entreprise',
    Personal: 'Personnel',
    'No changes.': 'Aucune modification.',
    'Instructions changes': 'Modifications des instructions',
    'Loading versions…': 'Chargement des versions…',
    'What the draft changes': 'Modifications apportées par le brouillon',
    'No published version yet. Try the draft, then publish it.':
      'Aucune version publiée pour le moment. Testez le brouillon, puis publiez-le.',
    'Published versions': 'Versions publiées',
    'Former member': 'Ancien membre',
    Live: 'Actif',
    Note: 'Remarque',
    Saved: 'Enregistré',
    Total: 'Total',
    ascending: 'croissant',
    descending: 'décroissant',
    'Scroll to see all columns': 'Faites défiler pour voir toutes les colonnes',
    '{value1} for {value2}': '{value1} pour {value2}',
    Suggested: 'Suggestion',
    'Opening your conversation…': 'Ouverture de votre conversation…',
    'This conversation isn’t available': 'Cette conversation n’est pas disponible',
    'It may have been deleted, belong to another account, or be temporarily unavailable.':
      'Elle a peut-être été supprimée, appartenir à un autre compte ou être temporairement indisponible.',
    '{count} more line — shown in the complete revision':
      '{count} ligne supplémentaire — affichée dans la révision complète',
    '{count} more lines — shown in the complete revision':
      '{count} lignes supplémentaires — affichées dans la révision complète',
    '{count} more line removed': '{count} ligne supplémentaire supprimée',
    '{count} more lines removed': '{count} lignes supplémentaires supprimées',
    '{count} unchanged line': '{count} ligne inchangée',
    '{count} unchanged lines': '{count} lignes inchangées',
    '{count} more lines not shown, {added} added and {removed} removed. Check them in the complete revision.':
      '{count} lignes supplémentaires non affichées, dont {added} ajoutées et {removed} supprimées. Consultez-les dans la révision complète.',
    'Saved result': 'Résultat enregistré',
    'Made with a Skill': 'Créé avec une compétence',
    'Preview of {name}': 'Aperçu de {name}',
    'Made with {name}': 'Créé avec {name}',
    'Ad-hoc result': 'Résultat ponctuel',
    'A Skill that is not available in this workspace':
      'Une compétence qui n’est pas disponible dans cet espace de travail',
    '{name} · Revision {version}': '{name} · Révision {version}',
    '{name} · Version {version}': '{name} · Version {version}',
    'Return to conversation {value1}': 'Retourner à la conversation {value1}',
    '{value1} Working with {value2}': '{value1} travaille avec {value2}',
    'View context {value1}': 'Voir le contexte {value1}',
    'A way of working, made yours.': 'Une façon de travailler, à votre image.',
    'Work that runs itself.': 'Un travail qui s’exécute tout seul.',
    'One place for one piece of work.': 'Un espace pour chaque projet.',
    'Let’s move your work forward{value1}.': 'Faisons avancer votre travail{value1}.',
    'Describe the work. Your Skill takes shape beside the conversation.':
      'Décrivez le travail. Votre compétence prend forme à côté de la conversation.',
    'Describe what it should do and when. Your agent takes shape beside the conversation. The draft does not run automatically.':
      'Décrivez ce qu’il doit faire et quand. Votre agent prend forme à côté de la conversation. Le brouillon ne s’exécute pas automatiquement.',
    'Say what the work is. Poneva drafts the project beside the conversation and brings in what you have already done. Nothing is created until you say so.':
      'Décrivez le travail. Poneva prépare le projet à côté de la conversation et y ajoute ce que vous avez déjà fait. Rien n’est créé tant que vous ne le demandez pas.',
    'Start with an idea below. Poneva will take it from there.':
      'Commencez par une idée ci-dessous. Poneva s’occupe du reste.',
    Triggers: 'Déclencheurs',
    'Review the agent and its trigger. Approval applies exactly what is shown.':
      'Vérifiez l’agent et son déclencheur. L’approbation applique exactement ce qui est affiché.',
    '{source} · read {date}': '{source} · lu le {date}',
    'Evidence is being recorded · read {date}':
      'Les éléments justificatifs sont enregistrés · lu le {date}',
    'Evidence expired on {date} under the retention policy':
      'Les éléments justificatifs ont expiré le {date} conformément à la politique de conservation',
    'Entered by {person}': 'Saisi par {person}',
    'No retained evidence for this value': 'Aucun élément justificatif conservé pour cette valeur',
    'Covers {shown} of {total} rows': 'Couvre {shown} lignes sur {total}',
    'Search rows': 'Rechercher dans les lignes',
    'Clear filters': 'Effacer les filtres',
    Sort: 'Trier',
    'Sort: {column}': 'Trier : {column}',
    '{shown} of {total} rows': '{shown} lignes sur {total}',
    More: 'Plus',
    Density: 'Densité',
    Comfortable: 'Confortable',
    Compact: 'Compact',
    Columns: 'Colonnes',
    'No rows match. Clear the search or filters to see them again.':
      'Aucune ligne ne correspond. Effacez la recherche ou les filtres pour les afficher à nouveau.',
    'Not available': 'Non disponible',
    'All rows': 'Toutes les lignes',
    'Close row detail': 'Fermer le détail de la ligne',
    'Ask about this row': 'Poser une question sur cette ligne',
    'Add note': 'Ajouter une note',
    'Access turned off': 'Accès désactivé',
    'Connection removed': 'Connexion supprimée',
    'Query time limit changed': 'Limite de temps de requête modifiée',
    '{count} row': '{count} ligne',
    '{count} rows': '{count} lignes',
    'This source is no longer available. Company knowledge now lives in Knowledge pages, and files stay in the Library.':
      'Cette source n’est plus disponible. Les connaissances de l’entreprise se trouvent désormais dans les pages de connaissances, et les fichiers restent dans la Bibliothèque.',
    App: 'Application',
    Artifact: 'Artefact',
    'New project': 'Nouveau projet',
    'Review request': 'Demande de révision',
    Activity: 'Activité',
    'Voice preview': 'Aperçu vocal',
    Source: 'Source',
    File: 'Fichier',
    Meeting: 'Réunion',
    'Knowledge page': 'Page de connaissances',
    'Could not preview this CSV.': 'Impossible d’afficher un aperçu de ce fichier CSV.',
    'File content is unavailable.': 'Le contenu du fichier n’est pas disponible.',
    'You have five open suggestions here. {value1} will see them.':
      'Cinq suggestions sont ouvertes ici. {value1} les verra.',
    'We could not send your suggestion. Please try again.':
      'Impossible d’envoyer votre suggestion. Veuillez réessayer.',
    'The agent': 'L’agent',
    'Selected colleagues': 'Collègues sélectionnés',
    'The owner': 'Le propriétaire',
    'Forked. This copy is yours and runs with your own connections.':
      'Copié. Cette copie vous appartient et fonctionne avec vos propres connexions.',
    'This chat is too long to fork.': 'Cette conversation est trop longue pour être copiée.',
    'We could not fork this chat. Please try again.':
      'Impossible de copier cette conversation. Veuillez réessayer.',
    'Anyone who forked it keeps their copy: forks stay with the people who made them.':
      'Toute personne qui l’a copiée conserve sa copie : les copies restent avec les personnes qui les ont créées.',
    'Nobody has forked this chat.': 'Personne n’a copié cette conversation.',
    '1 person forked this chat. Their copy stays theirs.':
      '1 personne a copié cette conversation. Sa copie lui appartient.',
    '{value1} people forked this chat. Their copies stay theirs.':
      '{value1} personnes ont copié cette conversation. Leurs copies leur appartiennent.',
    'Personal. Nobody else sees it.': 'Personnel. Personne d’autre ne peut le voir.',
    'People you pick. They get it in their Inbox.':
      'Les personnes que vous choisissez. Elles le reçoivent dans leur boîte de réception.',
    'Everyone in the company can follow it and fork it.':
      'Tout le monde dans l’entreprise peut le suivre et le copier.',
    'a chat you can no longer open': 'une conversation que vous ne pouvez plus ouvrir',
    'shared the Result': 'a partagé le résultat',
    'updated the Result': 'a mis à jour le résultat',
    'published the Skill': 'a publié la compétence',
    'approved the fact': 'a approuvé le fait',
    'added the fact': 'a ajouté le fait',
    'added the meeting': 'a ajouté la réunion',
    'published the page': 'a publié la page',
    'updated the page': 'a mis à jour la page',
    'shared the chat': 'a partagé la conversation',
    'published a version of': 'a publié une version de',
    ran: 'a exécuté',
    Knowledge: 'Connaissances',
    Meetings: 'Réunions',
    Chat: 'Conversation',
    Use: 'Utiliser',
    Open: 'Ouvrir',
    You: 'Vous',
    Someone: 'Quelqu’un',
    'published version {version} of': 'a publié la version {version} de',
    'thing needs': 'élément nécessite',
    'things need': 'éléments nécessitent',
    'Published Skill': 'Compétence publiée',
    'Included with Skill': 'Inclus avec la compétence',
    'Already attached': 'Déjà joint',
    'Also available in company knowledge':
      'Également disponible dans les connaissances de l’entreprise',
    'Company file': 'Fichier de l’entreprise',
    'Account identity unavailable': 'Identité du compte indisponible',
    'Access expired or was revoked. Reconnect to continue.':
      'L’accès a expiré ou a été révoqué. Reconnectez-vous pour continuer.',
    'Account authorized · tools unavailable': 'Compte autorisé · outils indisponibles',
    'Not available in this workspace yet.': 'Pas encore disponible dans cet espace de travail.',
    'Everyone in the company': 'Tout le monde dans l’entreprise',
    'Audience: only you.': 'Audience : vous uniquement.',
    'Audience: everyone in the company.': 'Audience : tout le monde dans l’entreprise.',
    'tool is': 'outil est',
    'tools are': 'outils sont',
    'account is': 'compte est',
    'accounts are': 'comptes sont',
    'We could not upload this file.': 'Nous n’avons pas pu importer ce fichier.',
    'file was': 'fichier a été',
    'files were': 'fichiers ont été',
    'Your company': 'Votre entreprise',
    'Create an agent': 'Créer un agent',
    'Give recurring work a helping hand': 'Simplifiez les tâches récurrentes',
    'Create a Skill': 'Créer une compétence',
    'Save a reusable way of working': 'Enregistrez une méthode de travail réutilisable',
    'Take meeting notes': 'Prendre des notes de réunion',
    'Capture decisions and next steps': 'Capturer les décisions et les prochaines étapes',
    'Work with a file': 'Travailler avec un fichier',
    'Start from a document or image': 'Commencer à partir d’un document ou d’une image',
    'Browse agents': 'Parcourir les agents',
    'Open your agents and company agents': 'Ouvrir vos agents et ceux de l’entreprise',
    'Review results': 'Examiner les résultats',
    'Return to work saved in your Library': 'Revenir au travail enregistré dans votre Bibliothèque',
    'For review': 'À examiner',
    'An agent': 'Un agent',
    Assistant: 'Assistant',
    'Kept up to date by {value1}{value2}': 'Mis à jour par {value1}{value2}',
    ', {value1}': ', {value1}',
    'Version {value1}{value2}{value3}': 'Version {value1}{value2}{value3}',
    'Refreshed by its agent': 'Actualisé par son agent',
    'Saved from a chat': 'Enregistré depuis une conversation',
    'Saved from {value1}': 'Enregistré depuis {value1}',
    Edited: 'Modifié',
    'private account': 'compte privé',
    '{value1} ({value2})': '{value1} ({value2})',
    '{value1}’s {value2}': '{value2} de {value1}',
    'Made private. The person who added it and the owner of its recording have been told in their Inbox.':
      'Rendu privé. La personne qui l’a ajouté et le propriétaire de son enregistrement en ont été informés dans leur boîte de réception.',
    'Made private. The person who added it has been told in their Inbox.':
      'Rendu privé. La personne qui l’a ajouté en a été informée dans sa boîte de réception.',
    'Made private. The owner of its recording has been told in their Inbox.':
      'Rendu privé. Le propriétaire de son enregistrement en a été informé dans sa boîte de réception.',
    'Selected passage': 'Passage sélectionné',
    '{value1} {value2}': '{value1} {value2}',
    'Upload a file': 'Importer un fichier',
    'Help me create a useful report from our company knowledge and available sources.':
      'Aidez-moi à créer un rapport utile à partir des connaissances de notre entreprise et des sources disponibles.',
    'This saved work couldn’t be opened. Open it again to retry.':
      'Impossible d’ouvrir ce travail enregistré. Ouvrez-le à nouveau pour réessayer.',
    '{value1}’s': 'De {value1}',
    '{value1} chat “{value2}”': 'Conversation « {value2} » de {value1}',
    '{value1}{value2}': '{value1}{value2}',
    'Skill: {value1}{value2}': 'Compétence : {value1}{value2}',
    'Result “{value1}”': 'Résultat « {value1} »',
    'Meeting “{value1}”': 'Réunion « {value1} »',
    'Used in {value1} {value2} this week': 'Utilisé dans {value1} {value2} cette semaine',
    '{value1} {value2} · used in {value3} {value4}':
      '{value1} {value2} · utilisé dans {value3} {value4}',
    'The draft is not published yet, so no one else follows it.':
      'Le brouillon n’est pas encore publié, personne d’autre ne le suit donc.',
    'Use it in a chat for current data, or refine the Skill first.':
      'Utilisez-la dans une conversation pour obtenir des données à jour, ou affinez d’abord la compétence.',
    'An agent keeps this up to date. Continue the work in chat.':
      'Un agent la tient à jour. Poursuivez le travail dans une conversation.',
    'Edit it here, or continue the work in chat.':
      'Modifiez-la ici ou poursuivez le travail dans une conversation.',
    'Duplicate it to your Library, or continue the work in chat.':
      'Dupliquez-la dans votre Bibliothèque ou poursuivez le travail dans une conversation.',
    'Download Markdown': 'Télécharger le fichier Markdown',
    'Download CSV': 'Télécharger le fichier CSV',
    'an agent': 'un agent',
    'Publish a Skill version': 'Publier une version de la compétence',
    'Share with {value1}': 'Partager avec {value1}',
    'Update company content': 'Mettre à jour le contenu de l’entreprise',
    Approved: 'Approuvé',
    Declined: 'Refusé',
    Pending: 'En attente',
    'View decision': 'Voir la décision',
    'No data': 'Aucune donnée',
    'No change': 'Aucun changement',
    'Connection created': 'Connexion créée',
    'Sharing changed': 'Partage modifié',
    'Person added': 'Personne ajoutée',
    'Person removed': 'Personne supprimée',
    'Access changed': 'Accès modifié',
    '· {value1} by {value2}': '· {value1} par {value2}',
    '· version {value1}': '· version {value1}',
    '{message} {count} earlier file was saved and attached.':
      '{message} {count} fichier précédent a été enregistré et joint.',
    '{message} {count} earlier files were saved and attached.':
      '{message} {count} fichiers précédents ont été enregistrés et joints.',
    '{message} {count} earlier file was saved.':
      '{message} {count} fichier précédent a été enregistré.',
    '{message} {count} earlier files were saved.':
      '{message} {count} fichiers précédents ont été enregistrés.',
    'refreshed {time}': 'actualisé {time}',
    'a colleague': 'un collègue',
    'Your chat “{title}”': 'Votre conversation « {title} »',
    '{name}’s chat “{title}”': 'Conversation de {name} : « {title} »',
    'Kept up to date by {name}{version}': 'Mis à jour par {name}{version}',
    'Skill: {name}{version}': 'Compétence : {name}{version}',
    'Result “{title}”': 'Résultat « {title} »',
    'Meeting “{title}”': 'Réunion « {title} »',
    'Used in {count} answer this week': 'Utilisé dans {count} réponse cette semaine',
    'Used in {count} answers this week': 'Utilisé dans {count} réponses cette semaine',
    '{count} source': '{count} source',
    '{count} sources': '{count} sources',
    'used in {count} place': 'utilisé à {count} endroit',
    'used in {count} places': 'utilisé à {count} endroits',
    '{company} workspace': 'espace de travail {company}',
    '{count} page': '{count} page',
    '{count} pages': '{count} pages',
    '{needs} · reviews and approvals': '{needs} · révisions et approbations',
    '{count} thing needs you': '{count} élément nécessite votre attention',
    '{count} things need you': '{count} éléments nécessitent votre attention',
    'Included with Skill · {files} · {sources} {icon}':
      'Inclus avec la compétence · {files} · {sources} {icon}',
    '{count} file': '{count} fichier',
    '{count} files': '{count} fichiers',
    Today: 'Aujourd’hui',
    'Earlier this week': 'Plus tôt cette semaine',
    '{count} slide': '{count} diapositive',
    '{count} slides': '{count} diapositives',
    Early: 'Tôt',
    'TLS verified': 'TLS vérifié',
    'Made personal and switched off. Switch it on when you are ready.':
      'Rendu personnel et désactivé. Activez-le lorsque vous êtes prêt.',
    'Made personal and switched off. Its owner is told which version is live.':
      'Rendu personnel et désactivé. Son propriétaire est informé de la version en ligne.',
    'Switched off.': 'Désactivé.',
    'Applied version {revision}.': 'Version {revision} appliquée.',
    'The draft is running in a chat only you can read.':
      'Le brouillon s’exécute dans une conversation que vous seul pouvez lire.',
    'Publish a version first.': 'Publiez d’abord une version.',
    'Another Agent action is in progress.': 'Une autre action de l’agent est en cours.',
    'Knowledge & connections': 'Connaissances et connexions',
    'Pinned Skills': 'Compétences épinglées',
    None: 'Aucun',
    'A new Result each run': 'Un nouveau résultat à chaque exécution',
    'One Result kept up to date': 'Un résultat maintenu à jour',
    Email: 'E-mail',
    On: 'Activé',
    Off: 'Désactivé',
    'Waiting for review': 'En attente d’examen',
    Outdated: 'Obsolète',
    Accepted: 'Accepté',
    Rejected: 'Refusé',
    Withdrawn: 'Retiré',
    Replaced: 'Remplacé',
    'Suggested edit': 'Modification suggérée',
    'Suggested new page': 'Nouvelle page suggérée',
    'Suggested move': 'Déplacement suggéré',
    'Suggested archive': 'Archivage suggéré',
    'Checking status…': 'Vérification de l’état…',
    'Status unavailable': 'État indisponible',
    'Bulleted list': 'Liste à puces',
    'Numbered list': 'Liste numérotée',
    'Web link': 'Lien web',
    Read: 'Lire',
    Write: 'Écrire',
    'shared with you': 'partagé avec vous',
    'Getting an answer': "Recherche d'une réponse",
    '{name} is getting an answer': '{name} recherche une réponse',
    'We could not save. Please try again.': 'Nous n’avons pas pu enregistrer. Veuillez réessayer.',
    'The new page could not be created.': 'La nouvelle page n’a pas pu être créée.',
    'We could not load this revision.': 'Nous n’avons pas pu charger cette révision.',
    'We could not restore this revision. Please try again.':
      'Nous n’avons pas pu restaurer cette révision. Veuillez réessayer.',
    'We could not export this revision.': 'Nous n’avons pas pu exporter cette révision.',
    'We could not open this suggestion.': 'Nous n’avons pas pu ouvrir cette suggestion.',
    'We could not do that. Please try again.':
      'Nous n’avons pas pu effectuer cette action. Veuillez réessayer.',
    'We could not save your decision. Please try again.':
      'Nous n’avons pas pu enregistrer votre décision. Veuillez réessayer.',
    'We could not restore this page. Please try again.':
      'Nous n’avons pas pu restaurer cette page. Veuillez réessayer.',
    'We could not export this page.': 'Nous n’avons pas pu exporter cette page.',
    '{count} missed time merged.': '{count} période manquée fusionnée.',
    '{count} missed times merged.': '{count} périodes manquées fusionnées.',
    'About this project': 'À propos de ce projet',
  },
  de: {
    'We could not load this item.': 'Dieses Element konnte nicht geladen werden.',
    '{value1} canvas': '{value1} Canvas',
    'Loading {value1}…': '{value1} wird geladen…',
    '{value1} · Original retained': '{value1} · Original beibehalten',
    '{value1} {value2}{value3} · Added {value4}':
      '{value1} {value2}{value3} · Hinzugefügt am {value4}',
    '{value1} Use in chat': '{value1} Im Chat verwenden',
    '{value1} Download': '{value1} Herunterladen',
    Table: 'Tabelle',
    Chart: 'Diagramm',
    Original: 'Original',
    'Text extracted from the PDF, marked by page. Download the original for its layout and images.':
      'Aus dem PDF extrahierter Text, nach Seiten gekennzeichnet. Laden Sie das Original für das Layout und die Bilder herunter.',
    'This preview shows the beginning of the file. Poneva reads the whole file; download the original to see all of it.':
      'Diese Vorschau zeigt den Anfang der Datei. Poneva liest die gesamte Datei. Laden Sie das Original herunter, um alles zu sehen.',
    'Preview of the first {value1} complete rows. Filtering and charts use only this preview. Download the original for the full file.':
      'Vorschau der ersten {value1} vollständigen Zeilen. Filter und Diagramme verwenden nur diese Vorschau. Laden Sie das Original für die vollständige Datei herunter.',
    'This source link cannot be opened.': 'Dieser Quelllink kann nicht geöffnet werden.',
    'Read-only chat': 'Chat mit Leseberechtigung',
    'Only {value1} writes in this chat. Fork it to continue with your own connections. {value2}':
      'Nur {value1} kann in diesem Chat schreiben. Erstellen Sie einen Fork, um mit Ihren eigenen Verbindungen fortzufahren. {value2}',
    'Suggest a follow-up…': 'Nachfassfrage vorschlagen…',
    'Suggest a follow-up': 'Nachfassfrage vorschlagen',
    'Sending…': 'Wird gesendet…',
    Send: 'Senden',
    'We could not dismiss that suggestion. Please try again.':
      'Dieser Vorschlag konnte nicht verworfen werden. Bitte versuchen Sie es erneut.',
    'Suggested follow-ups': 'Vorgeschlagene Nachfassfragen',
    '{value1} suggests': '{value1} schlägt vor',
    Ask: 'Fragen',
    'Dismiss {value1}’s suggestion': 'Vorschlag von {value1} verwerfen',
    'Suggested by': 'Vorgeschlagen von',
    '· edit it or send it': '· bearbeiten oder senden',
    'Remove the suggestion tag': 'Vorschlagstag entfernen',
    '{value1} {value2} is getting an answer': '{value1} {value2} erhält eine Antwort',
    '{value1} {value2} stopped the answer': '{value1} {value2} hat die Antwort angehalten',
    '{value1} Fork from here': '{value1} Ab hier einen Fork erstellen',
    '{value1} From {value2}’s {value3}': '{value1} Aus {value3} von {value2}',
    'Only {value1} can use this account': 'Nur {value1} kann dieses Konto verwenden',
    '{value1} Suggested by {value2}': '{value1} Vorgeschlagen von {value2}',
    'Fork this chat': 'Fork für diesen Chat erstellen',
    'Forking…': 'Fork wird erstellt…',
    Fork: 'Fork erstellen',
    'Could not make this private.': 'Konnte nicht privat gestellt werden.',
    'Make this chat private?': 'Diesen Chat privat stellen?',
    Close: 'Schließen',
    '{value1} will see “{value2}”. Everyone else loses access right away {value3} .{value4}':
      '{value1} kann „{value2}“ sehen. Alle anderen verlieren sofort den Zugriff {value3} .{value4}',
    Cancel: 'Abbrechen',
    'Saving…': 'Wird gespeichert…',
    'Make private': 'Privat stellen',
    'This chat is private again. Forks others made stay theirs.':
      'Dieser Chat ist wieder privat. Von anderen erstellte Forks bleiben in deren Besitz.',
    'Who can read this chat: {value1}': 'Wer diesen Chat lesen kann: {value1}',
    'Move this chat': 'Diesen Chat verschieben',
    'Only you write here. Others follow live and fork.':
      'Nur Sie schreiben hier. Andere können live folgen und einen Fork erstellen.',
    'Made private. {value1} has been told in their Inbox.':
      'Privat gestellt. {value1} wurde im Posteingang benachrichtigt.',
    'Chat access': 'Chat-Zugriff',
    '{value1}’s chat. As an admin you can make it private.':
      'Chat von {value1}. Als Admin können Sie ihn privat stellen.',
    'Only {value1} will see it. {value2} is told.':
      'Nur {value1} kann ihn sehen. {value2} wurde benachrichtigt.',
    '{value1} {value2} following': '{value1} {value2} folgen',
    'Forked from{value1} {value2} . The history is copied. From here, tools run with your own access.':
      'Fork erstellt aus{value1} {value2} . Der Verlauf wurde kopiert. Ab hier werden Tools mit Ihrem eigenen Zugriff ausgeführt.',
    '{value1} made this chat private': '{value1} hat diesen Chat privat gestellt',
    'You can no longer open it. Any fork you made stays yours.':
      'Sie können ihn nicht mehr öffnen. Jeder von Ihnen erstellte Fork bleibt in Ihrem Besitz.',
    'Start a new chat': 'Neuen Chat starten',
    'Back to Recent chats': 'Zurück zu den letzten Chats',
    'More chat actions': 'Weitere Chat-Aktionen',
    'Close conversation sharing': 'Freigabe der Unterhaltung schließen',
    'Review the text before saving a private copy to Library. Then choose its audience. Your original conversation and future messages stay private.':
      'Prüfen Sie den Text, bevor Sie eine private Kopie in der Bibliothek speichern. Wählen Sie anschließend die Zielgruppe aus. Ihre ursprüngliche Unterhaltung und zukünftige Nachrichten bleiben privat.',
    'Preparing the conversation…': 'Unterhaltung wird vorbereitet…',
    'Refresh preview': 'Vorschau aktualisieren',
    'The copy is saved in Library. Use Share to choose who can access it.':
      'Die Kopie wurde in der Bibliothek gespeichert. Wählen Sie über „Teilen“ aus, wer darauf zugreifen kann.',
    'Save this copy': 'Diese Kopie speichern',
    'That Skill could not be opened.': 'Dieser Skill konnte nicht geöffnet werden.',
    '{value1}{value2} · reviews and approvals':
      '{value1}{value2} · Überprüfungen und Genehmigungen',
    'Open Inbox': 'Posteingang öffnen',
    'New at {value1} this week': 'Diese Woche neu bei {value1}',
    'Nothing new this week. Shared work, published Skills and approved knowledge show up here.':
      'Diese Woche gibt es nichts Neues. Hier werden geteilte Arbeiten, veröffentlichte Skills und genehmigtes Wissen angezeigt.',
    'New at {value1}': 'Neu bei {value1}',
    'This Skill is unavailable. Try again.':
      'Dieser Skill ist nicht verfügbar. Bitte versuchen Sie es erneut.',
    'You can attach up to {value1} files. Remove an attachment to add another.':
      'Sie können bis zu {value1} Dateien anhängen. Entfernen Sie einen Anhang, um einen weiteren hinzuzufügen.',
    'Add company context': 'Unternehmenskontext hinzufügen',
    'Add company context · @': 'Unternehmenskontext hinzufügen · @',
    'Choose a Skill': 'Skill auswählen',
    'Choose a Skill · /': 'Skill auswählen · /',
    context: 'Kontext',
    skills: 'Fähigkeiten',
    'Choose company context': 'Unternehmenskontext auswählen',
    'Skills for this conversation': 'Fähigkeiten für diese Unterhaltung',
    'Bring context into the conversation': 'Kontext in die Unterhaltung einbeziehen',
    'Close context picker': 'Kontextauswahl schließen',
    'Filter company context': 'Unternehmenskontext filtern',
    'Find a Skill…': 'Fähigkeit suchen…',
    'Find a file…': 'Datei suchen…',
    'Available company context': 'Verfügbarer Unternehmenskontext',
    'No matching published Skills.': 'Keine passenden veröffentlichten Fähigkeiten.',
    'No matching files.': 'Keine passenden Dateien.',
    'Searching company work…': 'Unternehmensarbeit wird durchsucht…',
    'Try search again': 'Erneut suchen',
    'Meaning search is temporarily limited. Showing available text matches.':
      'Die semantische Suche ist vorübergehend eingeschränkt. Verfügbare Texttreffer werden angezeigt.',
    'Load more matches': 'Weitere Treffer laden',
    '{value1} files attached. Remove an attachment to add another. Saved Skill references are included separately.':
      '{value1} Dateien angehängt. Entfernen Sie einen Anhang, um einen weiteren hinzuzufügen. Gespeicherte Verweise auf Fähigkeiten werden separat einbezogen.',
    'Create a Skill in chat': 'Eine Fähigkeit im Chat erstellen',
    'Upload a company file': 'Unternehmensdatei hochladen',
    'Company knowledge is always available to Poneva.':
      'Das Unternehmenswissen ist für Poneva immer verfügbar.',
    '{value1} was not connected': '{value1} wurde nicht verbunden',
    Dismiss: 'Schließen',
    'Try connecting again': 'Erneut verbinden',
    Waiting: 'Warten',
    Connected: 'Verbunden',
    'Needs reconnecting': 'Erneute Verbindung erforderlich',
    Connect: 'Verbinden',
    '{value1}{value2} The provider’s account permissions still apply.':
      '{value1}{value2} Die Berechtigungen des Providerkontos gelten weiterhin.',
    'Last error: {value1}': 'Letzter Fehler: {value1}',
    '{value1} {value2} ready.': '{value1} {value2} ist bereit.',
    'Continue with my Meta app': 'Mit meiner Meta-App fortfahren',
    Reconnect: 'Erneut verbinden',
    Disconnect: 'Verbindung trennen',
    'Remove attachment: {value1}': 'Anhang entfernen: {value1}',
    'Saved in this Skill. Edit the Skill to change its references.':
      'In dieser Fähigkeit gespeichert. Bearbeiten Sie die Fähigkeit, um ihre Verweise zu ändern.',
    'Remove Skill context': 'Fähigkeitskontext entfernen',
    Refining: 'Wird verfeinert',
    Previewing: 'Vorschau wird angezeigt',
    Using: 'Wird verwendet',
    'Skill revision {value1}': 'Fähigkeitsversion {value1}',
    'a new Skill': 'eine neue Fähigkeit',
    '{value1} Making a new agent {value2}': '{value1} Neuer Agent wird erstellt {value2}',
    'Stop making a new agent in this chat': 'Erstellung eines neuen Agenten in diesem Chat beenden',
    'Saved Skill references': 'Gespeicherte Verweise auf Fähigkeiten',
    'Included with Skill · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}':
      'Mit der Fähigkeit einbezogen · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}',
    'Selected Skill revision is unavailable. Select the Skill again to view its saved references.':
      'Die ausgewählte Fähigkeitsversion ist nicht verfügbar. Wählen Sie die Fähigkeit erneut aus, um ihre gespeicherten Verweise anzuzeigen.',
    'Conversation attachments': 'Anhänge der Unterhaltung',
    'Added for this conversation': 'Für diese Unterhaltung hinzugefügt',
    'Selected passage {value1}': 'Ausgewählte Passage {value1}',
    'We could not load your workspace.': 'Ihr Workspace konnte nicht geladen werden.',
    'The selected Skill is unavailable. Check its access or choose it again.':
      'Die ausgewählte Fähigkeit ist nicht verfügbar. Überprüfen Sie den Zugriff oder wählen Sie sie erneut aus.',
    'Source saved privately and included in your knowledge search.':
      'Quelle privat gespeichert und in Ihre Wissenssuche einbezogen.',
    'File saved privately to your library and attached to this message.':
      'Datei privat in Ihrer Bibliothek gespeichert und an diese Nachricht angehängt.',
    'File saved privately to your library.': 'Datei privat in Ihrer Bibliothek gespeichert.',
    '{value1} {value2} earlier {value3} saved{value4}.':
      '{value1} {value2} zuvor {value3} gespeichert{value4}.',
    'Extracted text for Poneva to read. Download the original for its layout, charts and images. Spreadsheet formulas show their saved results and are not recalculated.':
      'Extrahierter Text zum Lesen für Poneva. Laden Sie das Original für Layout, Diagramme und Bilder herunter. Tabellenkalkulationsformeln zeigen ihre gespeicherten Ergebnisse und werden nicht neu berechnet.',
    Esc: 'Esc',
    'Start something': 'Etwas starten',
    'Choose a file to work with': 'Datei auswählen, mit der Sie arbeiten möchten',
    'Skills worth adding': 'Empfehlenswerte Fähigkeiten',
    'Picked for you': 'Für Sie ausgewählt',
    'Reusable work grounded in your company knowledge.':
      'Wiederverwendbare Arbeit auf Grundlage Ihres Unternehmenswissens.',
    'Ideas from your company context and recent work. Pick one to start.':
      'Ideen aus Ihrem Unternehmenskontext und Ihrer letzten Arbeit. Wählen Sie eine aus, um zu beginnen.',
    'Refresh suggested tasks': 'Vorgeschlagene Aufgaben aktualisieren',
    'Check for new company context.': 'Auf neuen Unternehmenskontext prüfen.',
    'Check for new context. Ideas also refresh daily.':
      'Auf neuen Kontext prüfen. Ideen werden außerdem täglich aktualisiert.',
    Refresh: 'Aktualisieren',
    'Finding useful starting points…': 'Nützliche Ausgangspunkte werden gesucht…',
    'Suggestions aren’t available right now. Try Refresh, or describe the work you want to do.':
      'Vorschläge sind derzeit nicht verfügbar. Versuchen Sie es mit „Aktualisieren“ oder beschreiben Sie die gewünschte Arbeit.',
    'Loading the knowledge pages…': 'Wissensseiten werden geladen…',
    '{value1} All pages': '{value1} Alle Seiten',
    'The page is created.': 'Die Seite wurde erstellt.',
    'Your new page is suggested. A publisher decides whether it is added.':
      'Ihre neue Seite wurde vorgeschlagen. Ein Herausgeber entscheidet, ob sie hinzugefügt wird.',
    'Company knowledge': 'Unternehmenswissen',
    'What Poneva knows about your company, page by page. Every change is kept.':
      'Was Poneva über Ihr Unternehmen weiß – Seite für Seite. Jede Änderung bleibt erhalten.',
    'Loading company knowledge…': 'Unternehmenswissen wird geladen…',
    'Knowledge pages are not enabled in this workspace.':
      'Wissensseiten sind in diesem Workspace nicht aktiviert.',
    'Ask your Poneva contact to switch them on for your company.':
      'Bitten Sie Ihre Poneva-Kontaktperson, sie für Ihr Unternehmen zu aktivieren.',
    '{value1} Change the agent': '{value1} Agenten ändern',
    '{value1} Continue in chat': '{value1} Im Chat fortfahren',
    Edit: 'Bearbeiten',
    '{value1} Edit with chat': '{value1} Mit Chat bearbeiten',
    '{value1} Duplicate to my Library': '{value1} in meine Bibliothek duplizieren',
    'Duplicated to your Library. Only you can see the copy.':
      'In Ihre Bibliothek dupliziert. Nur Sie können die Kopie sehen.',
    'Could not duplicate this Result. Try again.':
      'Dieses Ergebnis konnte nicht dupliziert werden. Versuchen Sie es erneut.',
    'Saved version {value1}.': 'Version {value1} gespeichert.',
    'A newer version was saved. Reload the Result before saving.':
      'Eine neuere Version wurde gespeichert. Laden Sie das Ergebnis vor dem Speichern neu.',
    'Could not save this version. Try again.':
      'Diese Version konnte nicht gespeichert werden. Versuchen Sie es erneut.',
    '{value1} saved a newer version. Review it before saving.':
      '{value1} hat eine neuere Version gespeichert. Prüfen Sie sie vor dem Speichern.',
    'Hide their version': 'Ihre Version ausblenden',
    'Show their version': 'Ihre Version anzeigen',
    'Start from their version': 'Mit ihrer Version beginnen',
    Markdown: 'Markdown',
    'Result text': 'Ergebnistext',
    Preview: 'Vorschau',
    'What changed': 'Was wurde geändert',
    'What changed? (optional)': 'Was wurde geändert? (optional)',
    'Save version {value1}': 'Version {value1} speichern',
    'Open chat': 'Chat öffnen',
    Current: 'Aktuell',
    Restore: 'Wiederherstellen',
    'Could not load the history.': 'Der Verlauf konnte nicht geladen werden.',
    'Restored version {value1} as version {value2}.':
      'Version {value1} als Version {value2} wiederhergestellt.',
    'Someone saved a newer version. Review it before restoring.':
      'Jemand hat eine neuere Version gespeichert. Prüfen Sie sie vor dem Wiederherstellen.',
    'Could not restore that version.': 'Diese Version konnte nicht wiederhergestellt werden.',
    'Loading history…': 'Verlauf wird geladen…',
    'Restoring keeps what is there now as a version too, so nothing is lost.':
      'Beim Wiederherstellen wird der aktuelle Stand ebenfalls als Version gespeichert, damit nichts verloren geht.',
    'This Result was made with your own {value1}.':
      'Dieses Ergebnis wurde mit Ihrem eigenen {value1} erstellt.',
    'It also used': 'Außerdem verwendet wurden',
    'This Result was made with': 'Dieses Ergebnis wurde erstellt mit',
    'Colleagues can read what came from them, but can never use them.':
      'Kolleginnen und Kollegen können lesen, was von ihnen stammt, aber es niemals verwenden.',
    'Your personal agent {value1} keeps it up to date with your own access, so every refresh can carry your private data.':
      'Ihr persönlicher Agent {value1} hält es mit Ihren eigenen Zugriffsrechten aktuell, sodass jede Aktualisierung Ihre privaten Daten enthalten kann.',
    'A colleague’s personal agent keeps it up to date with their own access, so every refresh can carry their private data.':
      'Der persönliche Agent einer Kollegin oder eines Kollegen hält es mit den eigenen Zugriffsrechten aktuell, sodass jede Aktualisierung private Daten enthalten kann.',
    'Made private. Only you can see this meeting.':
      'Privat gemacht. Nur Sie können dieses Meeting sehen.',
    'Could not make this meeting private.': 'Dieses Meeting konnte nicht privat gemacht werden.',
    'Meeting · {value1} {value2} · Original retained':
      'Meeting · {value1} {value2} · Original beibehalten',
    'The recording could not be opened.': 'Die Aufzeichnung konnte nicht geöffnet werden.',
    'Ask about this suggestion': 'Zu diesem Vorschlag fragen',
    meeting_processing_failed: 'Verarbeitung des Meetings fehlgeschlagen',
    'Who can see this': 'Wer kann dies sehen?',
    'Everyone at {value1}': 'Alle bei {value1}',
    'Only me': 'Nur ich',
    'Everyone at {value1} can find it and ask about it.':
      'Alle bei {value1} können es finden und dazu Fragen stellen.',
    'Only you can open and search this meeting. You can share it later.':
      'Nur Sie können dieses Meeting öffnen und durchsuchen. Sie können es später teilen.',
    'Added. Only you can see it. Transcription is running in the background.':
      'Hinzugefügt. Nur Sie können es sehen. Die Transkription läuft im Hintergrund.',
    'Visible to everyone at {value1}': 'Für alle bei {value1} sichtbar',
    'Could not make it private.': 'Es konnte nicht privat gemacht werden.',
    'Show more meetings': 'Mehr Meetings anzeigen',
    'Attached to this message': 'An diese Nachricht angehängt',
    'Connect securely, choose the tables to share, then decide whether Poneva can read or make changes.':
      'Stellen Sie eine sichere Verbindung her, wählen Sie die zu teilenden Tabellen aus und entscheiden Sie dann, ob Poneva sie lesen oder Änderungen vornehmen darf.',
    'Review the tables this connection can access. Select at least one table.':
      'Prüfen Sie die Tabellen, auf die diese Verbindung zugreifen kann. Wählen Sie mindestens eine Tabelle aus.',
    'Select at least one table. Nothing is selected by default.':
      'Wählen Sie mindestens eine Tabelle aus. Standardmäßig ist nichts ausgewählt.',
    'Choose who can use this connection and what Poneva can do.':
      'Legen Sie fest, wer diese Verbindung verwenden darf und was Poneva tun kann.',
    'Your chosen access is enabled for the selected tables.':
      'Der von Ihnen gewählte Zugriff ist für die ausgewählten Tabellen aktiviert.',
    'Your connection is saved with reading paused until permission is confirmed.':
      'Ihre Verbindung wurde gespeichert. Das Lesen ist pausiert, bis die Berechtigung bestätigt wurde.',
    'Confirm database disconnect': 'Trennung der Datenbank bestätigen',
    'Disconnect this database?': 'Diese Datenbank trennen?',
    'Access will stop for everyone using this connection.':
      'Der Zugriff wird für alle beendet, die diese Verbindung verwenden.',
    'Keep connection': 'Verbindung beibehalten',
    'What it can reach · {value1}{value2} {value3}':
      'Worauf sie zugreifen kann · {value1}{value2} {value3}',
    Back: 'Zurück',
    Continue: 'Weiter',
    'Uploading…': 'Wird hochgeladen…',
    Library: 'Bibliothek',
    'Source material for your work. Available whenever you need it.':
      'Quellenmaterial für Ihre Arbeit. Verfügbar, wann immer Sie es brauchen.',
    'The work you want to keep, with its sources and conversation attached.':
      'Die Arbeit, die Sie behalten möchten, mit den zugehörigen Quellen und dem Gespräch.',
    Results: 'Ergebnisse',
    Files: 'Dateien',
    Artifacts: 'Artefakte',
    'Search library': 'Bibliothek durchsuchen',
    'Find files by meaning…': 'Dateien nach Bedeutung finden…',
    'Find saved work by meaning…': 'Gespeicherte Arbeit nach Bedeutung finden…',
    'Search coverage is limited while indexing or meaning-based search is unavailable. You can retry or browse recent items.':
      'Die Suchabdeckung ist während der Indizierung oder bei nicht verfügbarer bedeutungsbasierter Suche eingeschränkt. Sie können es erneut versuchen oder die zuletzt verwendeten Elemente durchsuchen.',
    'No matching work found.': 'Keine passende Arbeit gefunden.',
    'A starting point for your next question.': 'Ein Ausgangspunkt für Ihre nächste Frage.',
    'Good work is worth keeping.': 'Gute Arbeit ist es wert, aufbewahrt zu werden.',
    'Try a different description or clear the search to browse.':
      'Versuchen Sie es mit einer anderen Beschreibung oder löschen Sie die Suche, um zu stöbern.',
    'Upload source material once and use it in conversations and Skills. Your original stays in the library.':
      'Laden Sie Quellenmaterial einmal hoch und verwenden Sie es in Gesprächen und Skills. Das Original bleibt in der Bibliothek.',
    'Ask Poneva to save an answer, table or chart. Results stay connected to the conversation and their sources.':
      'Bitte Poneva, eine Antwort, Tabelle oder ein Diagramm zu speichern. Ergebnisse bleiben mit dem Gespräch und ihren Quellen verknüpft.',
    'Start in chat {value1}': 'In Chat {value1} beginnen',
    'Open result: {value1}': 'Ergebnis öffnen: {value1}',
    'Loading more library items…': 'Weitere Bibliothekselemente werden geladen …',
    'Load more': 'Mehr laden',
    'Documents, transcripts, audio and video · Up to 500 MB per file. New files are private. Choose their audience with Share and which processable files become searchable company knowledge.':
      'Dokumente, Transkripte, Audio und Video · Bis zu 500 MB pro Datei. Neue Dateien sind privat. Wählen Sie mit „Teilen“ die Zielgruppe und welche verarbeitbaren Dateien als durchsuchbares Unternehmenswissen verfügbar werden.',
    Skills: 'Fähigkeiten',
    'Create in chat': 'Im Chat erstellen',
    'Search Skills': 'Fähigkeiten durchsuchen',
    'Search finds published Skills. Clear the search to browse your drafts too.':
      'Die Suche findet veröffentlichte Fähigkeiten. Löschen Sie die Suche, um auch Ihre Entwürfe zu durchsuchen.',
    'Search coverage is limited while indexing or meaning-based search is unavailable.':
      'Der Suchumfang ist eingeschränkt, solange die Indizierung oder die bedeutungsbasierte Suche nicht verfügbar ist.',
    'Searching Skills…': 'Fähigkeiten werden durchsucht …',
    'No matching published Skills found. Try a different description.':
      'Keine passenden veröffentlichten Fähigkeiten gefunden. Versuchen Sie es mit einer anderen Beschreibung.',
    'Load more Skills': 'Weitere Fähigkeiten laden',
    'View Skill: {value1}': 'Fähigkeit anzeigen: {value1}',
    'Company workspace': 'Unternehmensarbeitsbereich',
    'View {value1}': '{value1} anzeigen',
    'Loading Skills…': 'Fähigkeiten werden geladen …',
    'Try again {value1}': 'Erneut versuchen {value1}',
    'Try again': 'Erneut versuchen',
    'Nothing yet.': 'Noch nichts.',
    'Made from · Used by': 'Erstellt aus · Verwendet von',
    'Could not load links': 'Links konnten nicht geladen werden',
    'Made from': 'Erstellt aus',
    'Used by': 'Verwendet von',
    'About this chat {value1}': 'Über diesen Chat {value1}',
    'About this chat': 'Über diesen Chat',
    'Keep the work moving.': 'Halten Sie die Arbeit in Gang.',
    'Ask a follow-up with this result in view, or turn a useful approach into a company Skill.':
      'Stellen Sie eine Anschlussfrage, während dieses Ergebnis angezeigt wird, oder machen Sie aus einem hilfreichen Ansatz eine Unternehmensfähigkeit.',
    'Save approach as a Skill': 'Ansatz als Fähigkeit speichern',
    'Preview of': 'Vorschau von',
    'Made with': 'Erstellt mit',
    'Open the draft': 'Entwurf öffnen',
    'Open Skill': 'Fähigkeit öffnen',
    'Use in chat': 'Im Chat verwenden',
    'Finish the draft': 'Entwurf fertigstellen',
    'Refine this Skill': 'Diese Fähigkeit verfeinern',
    'Made with a Skill.': 'Mit einer Fähigkeit erstellt.',
    'This workspace could not be loaded just now, so that Skill cannot be opened yet. The result itself is unchanged.':
      'Dieser Arbeitsbereich konnte gerade nicht geladen werden, daher kann diese Fähigkeit noch nicht geöffnet werden. Das Ergebnis selbst bleibt unverändert.',
    'That Skill is not available in this workspace, so it cannot be opened or used again. The result itself is unchanged.':
      'Diese Fähigkeit ist in diesem Arbeitsbereich nicht verfügbar und kann daher nicht erneut geöffnet oder verwendet werden. Das Ergebnis selbst bleibt unverändert.',
    'Result · {value1} {value2}': 'Ergebnis · {value1} {value2}',
    '{value1} Copy link': '{value1} Link kopieren',
    'Result link copied.': 'Link zum Ergebnis kopiert.',
    'Could not copy the link. Use your browser address bar.':
      'Der Link konnte nicht kopiert werden. Verwenden Sie die Adressleiste Ihres Browsers.',
    'No preview is available for this result.': 'Für dieses Ergebnis ist keine Vorschau verfügbar.',
    '{value1} rows are retained in this snapshot. Open Table to inspect the values.':
      '{value1} Zeilen sind in diesem Schnappschuss enthalten. Öffnen Sie die Tabelle, um die Werte zu prüfen.',
    'People can’t edit a Result an agent keeps up to date; the next refresh would replace their edit. Change the agent’s instructions instead.':
      'Ein Ergebnis, das von einem Agenten aktuell gehalten wird, kann nicht bearbeitet werden. Bei der nächsten Aktualisierung würden die Änderungen überschrieben. Ändern Sie stattdessen die Anweisungen des Agenten.',
    'Linked sources': 'Verknüpfte Quellen',
    'Saved source': 'Gespeicherte Quelle',
    'No source documents are linked to this result. Company knowledge and other references may be cited in the answer.':
      'Mit diesem Ergebnis sind keine Quelldokumente verknüpft. In der Antwort können Unternehmenswissen und andere Referenzen zitiert werden.',
    'Run details': 'Ausführungsdetails',
    Created: 'Erstellt',
    ', revised {value1}': ', überarbeitet {value1}',
    Conversation: 'Unterhaltung',
    'Not recorded': 'Nicht aufgezeichnet',
    'Open conversation': 'Unterhaltung öffnen',
    Run: 'Ausführung',
    Updates: 'Aktualisierungen',
    'Kept up to date by {value1}': 'Aktuell gehalten von {value1}',
    'Version {value1}': 'Version {value1}',
    'Could not open this request.': 'Diese Anfrage konnte nicht geöffnet werden.',
    'Approved version published.': 'Genehmigte Version veröffentlicht.',
    'Request rejected. The item stays unchanged.':
      'Anfrage abgelehnt. Das Element bleibt unverändert.',
    'Could not save the decision.': 'Die Entscheidung konnte nicht gespeichert werden.',
    'Proposed company change': 'Vorgeschlagene Unternehmensänderung',
    'Opening…': 'Wird geöffnet …',
    'Approve this version': 'Diese Version genehmigen',
    Decline: 'Ablehnen',
    'Review the submitted version below. Changes made since submission will need a new request.':
      'Prüfen Sie die unten eingereichte Version. Änderungen seit der Einreichung erfordern eine neue Anfrage.',
    'The version submitted with this request.': 'Die mit dieser Anfrage eingereichte Version.',
    'Version and proposed change': 'Version und vorgeschlagene Änderung',
    'Could not read the pinned content.': 'Der angeheftete Inhalt konnte nicht gelesen werden.',
    'Showing a page of {value1} characters.': 'Eine Seite mit {value1} Zeichen wird angezeigt.',
    'Beginning of the submitted content. Open the full text to review every page.':
      'Anfang des eingereichten Inhalts. Öffnen Sie den vollständigen Text, um jede Seite zu prüfen.',
    'Read full submitted text': 'Vollständigen eingereichten Text lesen',
    'Previous page': 'Vorherige Seite',
    'Next page': 'Nächste Seite',
    'Made private. Its creator has been told in their Inbox.':
      'Privat gemacht. Die erstellende Person wurde in ihrem Posteingang benachrichtigt.',
    'Made private. Its creator could not be notified.':
      'Privat gemacht. Die erstellende Person konnte nicht benachrichtigt werden.',
    'Make this {value1} private?': '{value1} privat machen?',
    'Only the person who created it will see it. Everyone else loses access right away, and its creator gets an Inbox update if they are still a company member. If they have left, nobody in the company will be able to access this item.':
      'Nur die erstellende Person kann es sehen. Alle anderen verlieren sofort den Zugriff, und die erstellende Person erhält eine Aktualisierung im Posteingang, sofern sie noch Mitglied des Unternehmens ist. Falls sie das Unternehmen verlassen hat, kann niemand im Unternehmen auf dieses Element zugreifen.',
    'Sent for review. The current audience stays unchanged until approval.':
      'Zur Prüfung gesendet. Die aktuelle Zielgruppe bleibt bis zur Genehmigung unverändert.',
    'This suggestion is no longer available to you.':
      'Dieser Vorschlag ist für Sie nicht mehr verfügbar.',
    'We could not check where this suggestion stands.':
      'Der Status dieses Vorschlags konnte nicht geprüft werden.',
    'Check again': 'Erneut prüfen',
    'Show on page': 'Auf der Seite anzeigen',
    'The editor could not be loaded. Poneva may have been updated since you opened this page. Reload to get the latest version; nothing on this page has changed.':
      'Der Editor konnte nicht geladen werden. Poneva wurde möglicherweise aktualisiert, seit Sie diese Seite geöffnet haben. Laden Sie die Seite neu, um die aktuelle Version zu erhalten. Auf dieser Seite hat sich nichts geändert.',
    'Reload Poneva': 'Poneva neu laden',
    Formatting: 'Formatierung',
    'Text style': 'Textstil',
    Text: 'Text',
    Heading: 'Überschrift',
    Subheading: 'Unterüberschrift',
    'Link a page': 'Seite verknüpfen',
    'A page needs a title.': 'Eine Seite benötigt einen Titel.',
    'Nothing has changed yet.': 'Bisher wurde nichts geändert.',
    'A page needs some text. To remove a page, archive it instead.':
      'Eine Seite benötigt Text. Um eine Seite zu entfernen, archiviere sie stattdessen.',
    'A suggested new page needs some text.': 'Eine vorgeschlagene neue Seite benötigt Text.',
    'This page is larger than 256 KB. Split it into smaller pages.':
      'Diese Seite ist größer als 256 KB. Teilen Sie sie in kleinere Seiten auf.',
    'Say in a few words why this change is right.':
      'Erklären Sie in wenigen Worten, warum diese Änderung richtig ist.',
    'This page changed while you were editing. Your text is still here: copy it, then open the latest version and make your change again.':
      'Diese Seite wurde während Ihrer Bearbeitung geändert. Ihr Text ist noch vorhanden: Kopieren Sie ihn, öffnen Sie dann die aktuelle Version und nehmen Sie Ihre Änderung erneut vor.',
    'Your text is copied.': 'Ihr Text wurde kopiert.',
    'Your text could not be copied. Select it in the editor and copy it.':
      'Ihr Text konnte nicht kopiert werden. Wählen Sie ihn im Editor aus und kopieren Sie ihn.',
    'The page “{value1}” is created.': 'Die Seite „{value1}“ wurde erstellt.',
    'New page': 'Neue Seite',
    'Editing {value1}': '{value1} wird bearbeitet',
    Editing: 'Bearbeiten',
    'Creating publishes the page under {value1} for everyone':
      'Beim Erstellen wird die Seite unter {value1} für alle veröffentlicht',
    'Saving publishes the new version for everyone':
      'Beim Speichern wird die neue Version für alle veröffentlicht',
    'Your changes are sent as a suggestion for a publisher':
      'Ihre Änderungen werden als Vorschlag an eine freigebende Person gesendet',
    'Create page': 'Seite erstellen',
    Save: 'Speichern',
    'Send suggestion': 'Vorschlag senden',
    '{value1} Copy my text': '{value1} Meinen Text kopieren',
    'Open the latest version': 'Aktuelle Version öffnen',
    'Page title': 'Seitentitel',
    'Loading the editor…': 'Editor wird geladen…',
    'New page text': 'Text der neuen Seite',
    'Text of {value1}': 'Text von {value1}',
    'Write the page. Type [[ to link another page.':
      'Schreiben Sie die Seite. Geben Sie [[ ein, um eine andere Seite zu verknüpfen.',
    'Type [[ to link another page.': 'Geben Sie [[ ein, um eine andere Seite zu verknüpfen.',
    'Link to a page': 'Mit einer Seite verknüpfen',
    'What changed, in a few words': 'Was wurde geändert? In wenigen Worten',
    'Where this comes from, in a few words': 'Quelle, in wenigen Worten',
    'Shown in the page history.': 'Wird im Seitenverlauf angezeigt.',
    'A publisher sees this next to your change.':
      'Eine freigebende Person sieht dies neben Ihrer Änderung.',
    '1 suggestion is open on this page': '1 Vorschlag ist für diese Seite offen',
    '{value1} suggestions are open on this page': '{value1} Vorschläge sind für diese Seite offen',
    'They stay open while you edit. After you save, they show against your new text; one whose words you changed is marked outdated.':
      'Sie bleiben während Ihrer Bearbeitung offen. Nach dem Speichern werden sie Ihrem neuen Text gegenübergestellt. Ein Vorschlag, dessen Formulierung Sie geändert haben, wird als veraltet markiert.',
    'Type [[ to link another page. Links keep working when a page is renamed or moved.':
      'Geben Sie [[ ein, um eine andere Seite zu verknüpfen. Verknüpfungen funktionieren auch weiter, wenn eine Seite umbenannt oder verschoben wird.',
    'Loading the history…': 'Verlauf wird geladen…',
    'This page has no saved text yet.': 'Für diese Seite wurde noch kein Text gespeichert.',
    'Say in a few words why this revision should come back.':
      'Erklären Sie in wenigen Worten, warum diese Revision wiederhergestellt werden sollte.',
    'Revision {value1} is suggested for a publisher to accept.':
      'Revision {value1} wird einer freigebenden Person zur Annahme vorgeschlagen.',
    'The page already reads like this revision.': 'Die Seite entspricht bereits dieser Revision.',
    'Revision {value1} is restored as revision {value2}.':
      'Revision {value1} wurde als Revision {value2} wiederhergestellt.',
    'Revision history': 'Revisionsverlauf',
    Revisions: 'Revisionen',
    'Every saved revision is kept.': 'Jede gespeicherte Revision bleibt erhalten.',
    'Revision {value1} {value2}': 'Revision {value1} {value2}',
    'Revision {value1} compared with revision {value2}':
      'Revision {value1} im Vergleich zu Revision {value2}',
    'Revision {value1}, the first text of this page':
      'Revision {value1}, der erste Text dieser Seite',
    'Green was added, struck through was removed.':
      'Grün wurde hinzugefügt, Durchgestrichenes wurde entfernt.',
    '{value1} Export Markdown': '{value1} Markdown exportieren',
    'Restore this revision': 'Diese Revision wiederherstellen',
    'Suggest restoring it': 'Wiederherstellung vorschlagen',
    'Why should this revision come back?': 'Warum sollte diese Revision wiederhergestellt werden?',
    'Loading this revision…': 'Diese Revision wird geladen…',
    'Only the title changed, from “{value1}” to “{value2}”.':
      'Nur der Titel wurde von „{value1}“ in „{value2}“ geändert.',
    'The text did not change in this revision.':
      'Der Text wurde in dieser Revision nicht geändert.',
    'Changes in revision {value1}': 'Änderungen in Revision {value1}',
    'Loading page…': 'Seite wird geladen…',
    'Loading suggestion…': 'Vorschlag wird geladen…',
    'This suggestion is not available.': 'Dieser Vorschlag ist nicht verfügbar.',
    'It may have been decided, or it is not one you can see.':
      'Möglicherweise wurde bereits darüber entschieden, oder Sie können ihn nicht sehen.',
    'Open Knowledge': 'Knowledge öffnen',
    'Opening the suggestion…': 'Vorschlag wird geöffnet…',
    'Choose where the page goes.': 'Wählen Sie aus, wohin die Seite verschoben wird.',
    'Say in a few words why.': 'Erklären Sie in wenigen Worten, warum.',
    'Your suggestion is sent. A publisher decides.':
      'Ihr Vorschlag wurde gesendet. Eine freigebende Person entscheidet.',
    'Moved under {value1}.': 'Unter {value1} verschoben.',
    'Deleted “{value1}”.': '„{value1}“ gelöscht.',
    'Could not update sharing.': 'Freigabe konnte nicht aktualisiert werden.',
    'They can follow new answers live and fork it to continue with their own connections. Only you write here. You can make it private again at any time.':
      'Sie können neue Antworten live verfolgen und es kopieren, um mit ihren eigenen Verbindungen weiterzuarbeiten. Nur Sie können hier schreiben. Sie können es jederzeit wieder privat machen.',
    'They see the project, its brief and the work in it they can already open. Nothing in it opens for anyone because of the project; each item keeps its own access.':
      'Sie sehen das Projekt, seine Beschreibung und die darin enthaltenen Arbeiten, auf die sie bereits zugreifen können. Durch das Projekt wird nichts für andere freigegeben; jedes Element behält seinen eigenen Zugriff.',
    'Check the content for private information before sharing. Sharing an item does not grant access to its original chat or private connections.':
      'Prüfen Sie den Inhalt vor der Freigabe auf vertrauliche Informationen. Die Freigabe eines Elements gewährt keinen Zugriff auf den ursprünglichen Chat oder private Verbindungen.',
    '{value1} Everyone you share with can read it, including what the assistant or an App in it found in your {value2}. They can’t use your {value3}. Nothing changes for you: the chat keeps working with all your accounts.':
      '{value1} Alle Personen, mit denen Sie es teilen, können es lesen, einschließlich der Inhalte, die der Assistent oder eine darin enthaltene App in Ihrem {value2} gefunden hat. Sie können Ihr {value3} nicht verwenden. Für Sie ändert sich nichts: Der Chat funktioniert weiterhin mit all Ihren Konten.',
    '{value1} Everyone you share with can read them, but nobody can use {value2} through this chat.':
      '{value1} Alle Personen, mit denen Sie sie teilen, können sie lesen, aber niemand kann {value2} über diesen Chat verwenden.',
    'This controls access to the working draft. Any published company version stays available until you explicitly unpublish it. To publish a new version, complete its preview and use Save Skill. Run results stay private.':
      'Hiermit steuern Sie den Zugriff auf den Arbeitsentwurf. Jede veröffentlichte Unternehmensversion bleibt verfügbar, bis Sie ihre Veröffentlichung ausdrücklich aufheben. Um eine neue Version zu veröffentlichen, schließen Sie die Vorschau ab und wählen Sie „Skill speichern“. Ausführungsergebnisse bleiben privat.',
    'Skill deleted. You can restore it from the Skills archive for 30 days.':
      'Skill gelöscht. Sie können ihn 30 Tage lang aus dem Skills-Archiv wiederherstellen.',
    'Could not delete this Skill.': 'Dieser Skill konnte nicht gelöscht werden.',
    'More actions': 'Weitere Aktionen',
    'Delete “{value1}”? It will disappear from Skills and search, and cannot be used by agents. You can restore it for 30 days. Existing chats and results stay available.':
      '„{value1}“ löschen? Der Skill wird aus den Skills und der Suche entfernt und kann nicht von Agenten verwendet werden. Sie können ihn 30 Tage lang wiederherstellen. Vorhandene Chats und Ergebnisse bleiben verfügbar.',
    'Deleting…': 'Wird gelöscht…',
    'Confirm delete': 'Löschen bestätigen',
    'Delete Skill': 'Skill löschen',
    'Skill restored as an unpublished draft. Its author can review and publish it again.':
      'Skill als unveröffentlichten Entwurf wiederhergestellt. Der Autor kann ihn überprüfen und erneut veröffentlichen.',
    'Could not restore this Skill.': 'Dieser Skill konnte nicht wiederhergestellt werden.',
    'Archived Skills': 'Archivierte Skills',
    'Deleted Skills can be restored for 30 days. Restoring leaves them unpublished.':
      'Gelöschte Skills können 30 Tage lang wiederhergestellt werden. Nach der Wiederherstellung bleiben sie unveröffentlicht.',
    'Restore until {value1}': 'Bis {value1} wiederherstellen',
    'Loading…': 'Wird geladen…',
    'No archived Skills.': 'Keine archivierten Skills.',
    'Load more archived Skills': 'Weitere archivierte Skills laden',
    'Show more of the original': 'Mehr vom Original anzeigen',
    'Filter result rows': 'Ergebniszeilen filtern',
    'Find a product or value…': 'Produkt oder Wert suchen…',
    '{value1} of {value2}': '{value1} von {value2}',
    'Result table': 'Ergebnistabelle',
    'No matching rows.': 'Keine passenden Zeilen.',
    'Showing the first 1,000 matching rows. Download the CSV for every row.':
      'Die ersten 1.000 passenden Zeilen werden angezeigt. Laden Sie die CSV-Datei mit allen Zeilen herunter.',
    'Agent ·': 'Agent ·',
    'Only you': 'Nur Sie',
    'Stopped before it finished.': 'Vor Abschluss angehalten.',
    'Drafting the project…': 'Projekt wird entworfen…',
    'Checking where this chat belongs…': 'Zugehörigkeit dieses Chats wird geprüft…',
    'Moving the chat…': 'Chat wird verschoben…',
    'Taking it out of the project…': 'Wird aus dem Projekt entfernt…',
    'Adding it to the project…': 'Wird zum Projekt hinzugefügt…',
    'No matching connections are available right now.':
      'Derzeit sind keine passenden Verbindungen verfügbar.',
    'Company knowledge suggestion': 'Vorschlag für Unternehmenswissen',
    'Company knowledge now lives on pages. Open Knowledge to see them.':
      'Unternehmenswissen befindet sich jetzt auf Seiten. Öffnen Sie „Wissen“, um es anzuzeigen.',
    '{value1} · Open beside this conversation': '{value1} · Neben dieser Unterhaltung öffnen',
    'Name {value1}': 'Name {value1}',
    'Host {value1}': 'Host {value1}',
    'Port {value1}': 'Port {value1}',
    'Database {value1}': 'Datenbank {value1}',
    'Username {value1}': 'Benutzername {value1}',
    'Password {value1}': 'Passwort {value1}',
    'Advanced TLS': 'Erweitertes TLS',
    '{value1} Poneva verifies the server certificate. Add a CA or server DNS name for IP hosts when your certificate requires it.':
      '{value1} Poneva überprüft das Serverzertifikat. Fügen Sie eine CA oder einen Server-DNS-Namen für IP-Hosts hinzu, wenn Ihr Zertifikat dies erfordert.',
    'CA certificate {value1}': 'CA-Zertifikat {value1}',
    'Certificate server DNS name {value1}': 'DNS-Name des Zertifikatsservers {value1}',
    '{value1} Your password is encrypted in secure storage. Poneva verifies the connection before saving it.':
      '{value1} Ihr Passwort wird verschlüsselt in einem sicheren Speicher abgelegt. Poneva überprüft die Verbindung vor dem Speichern.',
    'Testing…': 'Wird getestet…',
    'Test connection': 'Verbindung testen',
    'PostgreSQL is connected.': 'PostgreSQL ist verbunden.',
    'PostgreSQL was saved safely.': 'PostgreSQL wurde sicher gespeichert.',
    'Poneva can read and change rows in the selected tables. Apps also follow their approved data scope.':
      'Poneva kann Zeilen in den ausgewählten Tabellen lesen und ändern. Apps halten sich ebenfalls an ihren genehmigten Datenumfang.',
    'Poneva can read the selected tables. Apps also follow their approved data scope.':
      'Poneva kann die ausgewählten Tabellen lesen. Apps halten sich ebenfalls an ihren genehmigten Datenumfang.',
    'Reads are paused until permission is enabled.':
      'Lesevorgänge sind pausiert, bis die Berechtigung aktiviert wurde.',
    'Retrying…': 'Wird erneut versucht…',
    'Retry permission': 'Berechtigung erneut versuchen',
    'Try it in Chat': 'Im Chat ausprobieren',
    Done: 'Fertig',
    'Disconnect database': 'Datenbank trennen',
    '{value1} TLS verified ·{value2} {value3}': '{value1} TLS überprüft ·{value2} {value3}',
    'Search schemas and tables': 'Schemata und Tabellen durchsuchen',
    'Search tables': 'Tabellen durchsuchen',
    '{value1} of {value2} tables selected': '{value1} von {value2} Tabellen ausgewählt',
    'Select matching tables': 'Passende Tabellen auswählen',
    'Select all tables': 'Alle Tabellen auswählen',
    Clear: 'Leeren',
    'Select a whole schema or individual tables. New tables need a fresh selection.':
      'Wählen Sie ein gesamtes Schema oder einzelne Tabellen aus. Neue Tabellen müssen erneut ausgewählt werden.',
    'No tables match this search.': 'Keine Tabellen entsprechen dieser Suche.',
    'All tables in {value1}': 'Alle Tabellen in {value1}',
    '{value1} / {value2} tables': '{value1} / {value2} Tabellen',
    'Read & write available': 'Lesen und Schreiben verfügbar',
    'Read only': 'Nur Lesen',
    Ctrl: 'Strg',
    'This suggested knowledge update could not be shown.':
      'Dieses vorgeschlagene Wissensupdate konnte nicht angezeigt werden.',
    'Suggested knowledge update': 'Vorgeschlagenes Wissensupdate',
    'Archived. Its history is kept.': 'Archiviert. Der Verlauf bleibt erhalten.',
    'Choose the page it goes under. Links to it keep working.':
      'Wählen Sie die übergeordnete Seite aus. Links dorthin funktionieren weiterhin.',
    'Its text, its history and any open suggestions are removed for good, and links to it from other pages stop working. This cannot be undone.':
      'Der Text, der Verlauf und alle offenen Vorschläge werden dauerhaft gelöscht, und Links von anderen Seiten funktionieren nicht mehr. Dies kann nicht rückgängig gemacht werden.',
    'An archived page no longer informs answers. Its history is kept, and a publisher can restore it or delete it permanently.':
      'Eine archivierte Seite wird nicht mehr für Antworten verwendet. Der Verlauf bleibt erhalten, und ein Veröffentlicher kann sie wiederherstellen oder dauerhaft löschen.',
    Under: 'Übergeordnet unter',
    Change: 'Ändern',
    'Move under': 'Verschieben unter',
    'Search pages': 'Seiten durchsuchen',
    'Why?': 'Warum?',
    'Delete permanently': 'Dauerhaft löschen',
    'Move page': 'Seite verschieben',
    'Archive page': 'Seite archivieren',
    'Suggestion {value1}: show its card': 'Vorschlag {value1}: Karte anzeigen',
    'Removed:': 'Entfernt:',
    'Added:': 'Hinzugefügt:',
    'New page “{value1}”{value2}': 'Neue Seite „{value1}“{value2}',
    'No pages match “{value1}”.': 'Keine Seiten entsprechen „{value1}“.',
    'Where this page is': 'Wo sich diese Seite befindet',
    'Describe your company': 'Beschreiben Sie Ihr Unternehmen',
    'Empty page': 'Leere Seite',
    'Describe {value1}': '{value1} beschreiben',
    'This page has no text yet.': 'Diese Seite enthält noch keinen Text.',
    'Poneva reads this page before every answer. Start with who you are, what you sell and how you work; details go on the pages under it.':
      'Poneva liest diese Seite vor jeder Antwort. Beginnen Sie damit, wer Sie sind, was Sie verkaufen und wie Sie arbeiten; Einzelheiten gehören auf die untergeordneten Seiten.',
    'Write it, or ask Poneva in chat to draft it for you.':
      'Schreiben Sie den Text oder bitten Sie Poneva im Chat, einen Entwurf für Sie zu erstellen.',
    'Suggest a first version, and a publisher decides whether it becomes the page.':
      'Schlagen Sie eine erste Version vor. Ein Veröffentlicher entscheidet, ob daraus die Seite wird.',
    'Start writing': 'Schreiben beginnen',
    'Suggest a first version': 'Erste Version vorschlagen',
    'Accepted. The page is archived.': 'Angenommen. Die Seite ist archiviert.',
    'Accepted. The page is now revision {value1}.':
      'Angenommen. Die Seite ist jetzt Revision {value1}.',
    'Accepted.': 'Angenommen.',
    'Suggestion rejected. The page stays as it is.':
      'Vorschlag abgelehnt. Die Seite bleibt unverändert.',
    'Your suggestion is withdrawn.': 'Ihr Vorschlag wurde zurückgezogen.',
    'Restored. The page informs answers again.':
      'Wiederhergestellt. Die Seite wird wieder für Antworten verwendet.',
    'Your suggestion is sent. A publisher decides whether it becomes the page.':
      'Ihr Vorschlag wurde gesendet. Ein Veröffentlicher entscheidet, ob daraus die Seite wird.',
    'Saved. The page is now revision {value1}.':
      'Gespeichert. Die Seite ist jetzt Revision {value1}.',
    'Nothing changed.': 'Keine Änderungen.',
    'This page is not available.': 'Diese Seite ist nicht verfügbar.',
    'It may have been deleted, archived or moved out of reach, or you may no longer be in this company.':
      'Sie wurde möglicherweise gelöscht, archiviert oder verschoben, oder Sie gehören möglicherweise nicht mehr zu diesem Unternehmen.',
    'Page actions': 'Seitenaktionen',
    shown: 'angezeigt',
    hidden: 'ausgeblendet',
    '{value1} History': 'Verlauf von {value1}',
    '{value1} Ask in chat': '{value1} Im Chat fragen',
    'Suggest edits': 'Änderungen vorschlagen',
    'More actions for {value1}': 'Weitere Aktionen für {value1}',
    '{value1} Poneva reads this page in every chat':
      '{value1} Poneva liest diese Seite in jedem Chat',
    'This page is archived. It no longer informs answers; its history is kept. {value1}':
      'Diese Seite ist archiviert. Sie wird nicht mehr für Antworten verwendet; der Verlauf bleibt erhalten. {value1}',
    'Restore page': 'Seite wiederherstellen',
    'This link points to an earlier revision. You are reading the current text.':
      'Dieser Link verweist auf eine frühere Revision. Sie lesen den aktuellen Text.',
    'Show it in History': 'Im Verlauf anzeigen',
    Pages: 'Seiten',
    'Pages under {value1}': 'Seiten unter {value1}',
    'Linked from': 'Verlinkt von',
    Suggestions: 'Vorschläge',
    'Suggestions are hidden. You are reading the page as everyone else sees it.':
      'Vorschläge sind ausgeblendet. Sie sehen die Seite so, wie sie alle anderen sehen.',
    'Loading suggestions…': 'Vorschläge werden geladen…',
    'Nothing is waiting for review.': 'Nichts wartet auf Überprüfung.',
    'When someone, Poneva in a chat or a connected agent suggests a change to a page, it shows here and on the page. Nothing changes until a publisher accepts it.':
      'Wenn jemand, Poneva im Chat oder ein verbundener Agent eine Änderung an einer Seite vorschlägt, wird sie hier und auf der Seite angezeigt. Nichts ändert sich, bis ein Veröffentlicher sie annimmt.',
    '{value1} Review knowledge in chat': '{value1} Wissen im Chat überprüfen',
    'Suggestions for review': 'Zu überprüfende Vorschläge',
    'Suggested changes from chats, meetings, colleagues and connected agents. Nothing changes until a publisher accepts it on the page.':
      'Vorgeschlagene Änderungen aus Chats, Besprechungen, von Kollegen und verbundenen Agenten. Nichts ändert sich, bis ein Veröffentlicher sie auf der Seite annimmt.',
    'Your suggestions wait here until a publisher decides. The pages stay as they are until then.':
      'Ihre Vorschläge warten hier, bis ein Veröffentlicher entscheidet. Bis dahin bleiben die Seiten unverändert.',
    'Review page': 'Seite überprüfen',
    'Review on page': 'Auf der Seite überprüfen',
    'Open the meeting': 'Besprechung öffnen',
    'Open the chat': 'Chat öffnen',
    'Accept and restore': 'Annehmen und wiederherstellen',
    Accept: 'Annehmen',
    Reject: 'Ablehnen',
    'Your suggestion · waiting for a publisher': 'Ihr Vorschlag · wartet auf einen Veröffentlicher',
    Withdraw: 'Zurückziehen',
    'Waiting for a publisher': 'Wartet auf einen Veröffentlicher',
    'Suggestion {value1}': 'Vorschlag {value1}',
    'Suggestion {value1} from {value2}{value3}': 'Vorschlag {value1} von {value2}{value3}',
    'Read the suggested page': 'Vorgeschlagene Seite lesen',
    'Outdated: the text it changes was edited after it was suggested. It can be rejected or withdrawn; a new suggestion can be made against the current text.':
      'Veraltet: Der zu ändernde Text wurde nach dem Vorschlag bearbeitet. Der Vorschlag kann abgelehnt oder zurückgezogen werden; für den aktuellen Text kann ein neuer Vorschlag erstellt werden.',
    'Restore this page first to accept this suggestion.':
      'Stellen Sie diese Seite zuerst wieder her, um den Vorschlag anzunehmen.',
    'Previous suggestion': 'Vorheriger Vorschlag',
    'Suggestion {value1} of {value2}': 'Vorschlag {value1} von {value2}',
    'Next suggestion': 'Nächster Vorschlag',
    'Fold the suggestions away': 'Vorschläge einklappen',
    'Show the suggestions': 'Vorschläge anzeigen',
    '1 suggestion': '1 Vorschlag',
    '{value1} suggestions': '{value1} Vorschläge',
    '{value1} the pages under {value2}': '{value1} die Seiten unter {value2}',
    px: 'px',
    '{value1} chart of {value2} across {value3}': '{value1}-Diagramm zu {value2} über {value3}',
    'We could not build the file.': 'Die Datei konnte nicht erstellt werden.',
    '{value1} Present': '{value1} anwesend',
    'Building…': 'Wird erstellt…',
    'Download PowerPoint': 'PowerPoint herunterladen',
    'Slide {value1} of {value2}': 'Folie {value1} von {value2}',
    Slides: 'Folien',
    'Slide {value1}': 'Folie {value1}',
    'Speaker notes': 'Sprechernotizen',
    'Source: {value1}': 'Quelle: {value1}',
    'Add a name and a web address.': 'Fügen Sie einen Namen und eine Webadresse hinzu.',
    'Enter a valid web address.': 'Geben Sie eine gültige Webadresse ein.',
    'Use a web address that starts with https://.':
      'Verwenden Sie eine Webadresse, die mit https:// beginnt.',
    'Add a custom connection': 'Benutzerdefinierte Verbindung hinzufügen',
    'Connect a tool server you trust. Poneva checks the address works and saves only the connection details needed to use it.':
      'Verbinden Sie einen vertrauenswürdigen Toolserver. Poneva prüft, ob die Adresse funktioniert, und speichert nur die für die Nutzung erforderlichen Verbindungsdaten.',
    'Web address': 'Webadresse',
    'https://tools.example.com': 'https://tools.example.com',
    'Starts with https://, from your provider': 'Beginnt mit https://, von Ihrem Anbieter',
    'Sign-in': 'Anmeldung',
    'Advanced sign-in': 'Erweiterte Anmeldung',
    'Access key {value1}': 'Zugriffsschlüssel {value1}',
    'Request headers': 'Anforderungsheader',
    'Add header': 'Header hinzufügen',
    'Header {value1} name': 'Name von Header {value1}',
    'Header name': 'Headername',
    'Header {value1} value': 'Wert von Header {value1}',
    'Header value': 'Headerwert',
    'Remove header': 'Header entfernen',
    Advanced: 'Erweitert',
    Transport: 'Transport',
    'Auto-detect': 'Automatisch erkennen',
    'Streamable HTTP': 'Streamable HTTP',
    'Legacy SSE': 'Legacy-SSE',
    "From your provider's app settings. Leave empty unless they gave you these.":
      'Aus den App-Einstellungen Ihres Anbieters. Lassen Sie die Felder leer, sofern Sie diese Angaben nicht erhalten haben.',
    "Authorization server issuer": "Aussteller des Autorisierungsservers",
    "Enter the authorization server issuer when using a client ID.": "Geben Sie bei Verwendung einer Client-ID den Aussteller des Autorisierungsservers an.",
    'Client ID {value1}': 'Client-ID {value1}',
    'Client secret {value1}': 'Client-Secret {value1}',
    'Connecting…': 'Verbindung wird hergestellt…',
    'Test and connect': 'Testen und verbinden',
    'Add the store, the client ID and the client secret.':
      'Fügen Sie den Shop, die Client-ID und das Client-Secret hinzu.',
    'Connect your Shopify Developer App': 'Shopify-Entwickler-App verbinden',
    'Poneva can use exactly the access your store gave the app, and nothing more. It talks to Shopify directly and keeps the client secret encrypted.':
      'Poneva kann genau auf die von Ihrem Shop für die App freigegebenen Daten zugreifen, auf keine weiteren. Die Kommunikation mit Shopify erfolgt direkt, und das Client-Secret wird verschlüsselt gespeichert.',
    'How to create the app in Shopify': 'App in Shopify erstellen',
    'Open{value1} {value2}{value3} with the account that owns the store, and create an app.':
      'Öffnen Sie{value1} {value2}{value3} mit dem Konto, dem der Shop gehört, und erstellen Sie eine App.',
    'Create a version and select the access scopes Poneva may use, for example read_products and read_orders. Add write_ scopes only for data Poneva may change. Then release the version.':
      'Erstellen Sie eine Version und wählen Sie die Zugriffsumfänge aus, die Poneva verwenden darf, zum Beispiel read_products und read_orders. Fügen Sie write_-Umfänge nur für Daten hinzu, die Poneva ändern darf. Veröffentlichen Sie anschließend die Version.',
    'For orders and customers, also select protected customer data in the app’s settings. Shopify allows this without review for an app made for your own store.':
      'Wählen Sie für Bestellungen und Kunden in den App-Einstellungen außerdem „geschützte Kundendaten“ aus. Shopify erlaubt dies ohne Prüfung für eine App, die für Ihren eigenen Shop erstellt wurde.',
    'Install the app on your store.': 'Installieren Sie die App in Ihrem Shop.',
    'Copy the client ID and client secret from the app’s settings.':
      'Kopieren Sie die Client-ID und das Client-Secret aus den App-Einstellungen.',
    'To change the access later, release a new version, approve it on the store and use Test connection here.':
      'Um den Zugriff später zu ändern, veröffentlichen Sie eine neue Version, genehmigen Sie sie im Shop und verwenden Sie hier „Verbindung testen“.',
    Store: 'Shop',
    'your-store.myshopify.com': 'your-store.myshopify.com',
    'Your store’s .myshopify.com address (Shopify admin → Settings → Domains), or paste the address of your Shopify admin page':
      'Die .myshopify.com-Adresse Ihres Shops (Shopify-Admin → Einstellungen → Domains) oder die Adresse Ihrer Shopify-Adminseite',
    'Client ID {value1} {value2}': 'Client-ID {value1} {value2}',
    'Client secret {value1} {value2}': 'Client-Secret {value1} {value2}',
    Person: 'Person',
    Everyone: 'Alle',
    Connection: 'Verbindung',
    'All connections': 'Alle Verbindungen',
    'App {value1}': 'App {value1}',
    'From {value1}': 'Von {value1}',
    'Until {value1}': 'Bis {value1}',
    Result: 'Ergebnis',
    'All results': 'Alle Ergebnisse',
    Succeeded: 'Erfolgreich',
    Denied: 'Abgelehnt',
    Failed: 'Fehlgeschlagen',
    Unknown: 'Unbekannt',
    Filter: 'Filter',
    'Loading activity…': 'Aktivitäten werden geladen…',
    'Could not load activity. Try again.':
      'Aktivitäten konnten nicht geladen werden. Versuchen Sie es erneut.',
    'Removed connection': 'Verbindung entfernt',
    'App: {value1}': 'App: {value1}',
    'Older activity': 'Ältere Aktivitäten',
    Download: 'Herunterladen',
    CSV: 'CSV',
    'Evidence for {value1}': 'Nachweis für {value1}',
    Measure: 'Messgröße',
    'Show rows →': 'Zeilen anzeigen →',
    'Ask about this number': 'Zu dieser Zahl fragen',
    'There are no numeric values available to chart. View the table for the original data.':
      'Es sind keine numerischen Werte für ein Diagramm verfügbar. In der Tabelle können Sie die Originaldaten ansehen.',
    'Chart value': 'Diagrammwert',
    '{value1} of {value2} shown': '{value1} von {value2} angezeigt',
    '{value1} by {value2}; {value3} rows. View Table for exact values.':
      '{value1} nach {value2}; {value3} Zeilen. Für genaue Werte die Tabelle anzeigen.',
    'Values come directly from the source data. Missing values are not estimates.':
      'Die Werte stammen direkt aus den Quelldaten. Fehlende Werte sind keine Schätzungen.',
    'Loading library…': 'Bibliothek wird geladen…',
    'We couldn’t load what happened in this App. Try again in a moment.':
      'Die Ereignisse in dieser App konnten nicht geladen werden. Versuchen Sie es gleich noch einmal.',
    'This App could not be opened.': 'Diese App konnte nicht geöffnet werden.',
    'Opening App…': 'App wird geöffnet…',
    'Open the saved App to run this function.':
      'Öffnen Sie die gespeicherte App, um diese Funktion auszuführen.',
    'Save this App before running its function.':
      'Speichern Sie diese App, bevor Sie ihre Funktion ausführen.',
    'Open saved App': 'Gespeicherte App öffnen',
    'Open Apps': 'Apps öffnen',
    'The App could not be opened. Try again.':
      'Die App konnte nicht geöffnet werden. Versuchen Sie es erneut.',
    Owner: 'Besitzer',
    '{value1} · admins': '{value1} · Administratoren',
    'Owner · always edits': 'Besitzer · kann immer bearbeiten',
    'Admins manage it': 'Administratoren verwalten es',
    Editors: 'Bearbeiter',
    'A colleague': 'Ein Kollege',
    'Can edit drafts and publish versions':
      'Kann Entwürfe bearbeiten und Versionen veröffentlichen',
    Remove: 'Entfernen',
    'No editors yet.': 'Noch keine Bearbeiter.',
    'Admins can always edit company agents.':
      'Administratoren können Unternehmensagenten immer bearbeiten.',
    'Asking for edit access': 'Bearbeitungszugriff wird angefragt',
    'Asked {value1} · also in your Inbox': 'Angefragt am {value1} · auch in Ihrem Posteingang',
    Grant: 'Gewähren',
    Admin: 'Administrator',
    'Make personal': 'Persönlich machen',
    'Switch off': 'Deaktivieren',
    Archive: 'Archivieren',
    'Archive this agent': 'Diesen Agenten archivieren',
    'Loading agent…': 'Agent wird geladen…',
    '{value1} Edit in chat': '{value1} Im Chat bearbeiten',
    Agent: 'Agent',
    'This agent has not been created yet. It can run once its owner creates it.':
      'Dieser Agent wurde noch nicht erstellt. Er kann ausgeführt werden, sobald sein Besitzer ihn erstellt.',
    'New agent · Draft': 'Neuer Agent · Entwurf',
    'Untitled agent': 'Agent ohne Titel',
    'Test run': 'Testlauf',
    'This draft does not run automatically.': 'Dieser Entwurf wird nicht automatisch ausgeführt.',
    'Describe the agent in the chat. Its draft appears here.':
      'Beschreiben Sie den Agenten im Chat. Sein Entwurf wird hier angezeigt.',
    '{value1} Test run': '{value1} Testlauf',
    'Describe the agent in the chat first.': 'Beschreiben Sie den Agenten zuerst im Chat.',
    'Create and turn on': 'Erstellen und aktivieren',
    'Connection write setup': 'Einrichtung des Schreibzugriffs für die Verbindung',
    'Account for connected changes': 'Konto für Änderungen an der Verbindung',
    'Choose a connection': 'Verbindung auswählen',
    'No published Skills available. You can add them later.':
      'Keine veröffentlichten Fähigkeiten verfügbar. Sie können sie später hinzufügen.',
    '{value1} · not published. Review the changes. Testing is optional.':
      '{value1} · nicht veröffentlicht. Überprüfen Sie die Änderungen. Ein Test ist optional.',
    '{value1} Test draft': '{value1} Entwurf testen',
    'Apply changes…': 'Änderungen anwenden…',
    'Apply this draft as a new version': 'Diesen Entwurf als neue Version anwenden',
    'This draft cannot be applied.': 'Dieser Entwurf kann nicht angewendet werden.',
    'What changed?': 'Was hat sich geändert?',
    'Apply version {value1}': 'Version {value1} anwenden',
    Create: 'Erstellen',
    'Edit access requested': 'Bearbeitungszugriff angefragt',
    '{value1} Request edit access': '{value1} Bearbeitungszugriff anfragen',
    '{value1} Copy agent': '{value1} Agent kopieren',
    Pause: 'Pausieren',
    'Open agent: {value1}': 'Agent öffnen: {value1}',
    '· you can edit': '· Sie können bearbeiten',
    '{value1} is switched off.': '{value1} ist deaktiviert.',
    '{value1} is archived.': '{value1} ist archiviert.',
    'Loading agents…': 'Agenten werden geladen…',
    Agents: 'Agenten',
    'Agents do work for you on a schedule or when you ask. They follow your company’s Skills.':
      'Agenten erledigen Aufgaben nach Zeitplan oder auf Ihre Anfrage. Sie folgen den Fähigkeiten Ihres Unternehmens.',
    'No agent matches. Try a Skill name or what the agent should do.':
      'Kein passender Agent gefunden. Versuchen Sie es mit dem Namen einer Fähigkeit oder einer Beschreibung der Aufgabe des Agenten.',
    'Nothing of your own yet': 'Noch nichts Eigenes',
    'Tell Chat what an agent should do, or copy one of the company’s agents below.{value1}':
      'Teilen Sie Chat mit, was ein Agent tun soll, oder kopieren Sie unten einen der Unternehmensagenten.{value1}',
    'Your agents': 'Ihre Agenten',
    'Run on demand': 'Auf Abruf ausführen',
    'Run is always available. A schedule is optional and lives separately from the agent’s instructions.':
      'Die Ausführung ist immer verfügbar. Ein Zeitplan ist optional und wird getrennt von den Anweisungen des Agenten verwaltet.',
    'What changed in version {value1}': 'Was hat sich in Version {value1} geändert?',
    'Every publish is a version you can restore.':
      'Jede Veröffentlichung ist eine Version, die Sie wiederherstellen können.',
    Authorization: 'Autorisierung',
    '{value1} {value2} · {value3} will see it.': '{value1} {value2} · {value3} werden es sehen.',
    '{value1} {value2} you': '{value1} {value2} Sie',
    '· Revised': '· Überarbeitet',
    'This chat used your {value1}.': 'Dieser Chat hat {value1} verwendet.',
    'This chat has results from {value1}.': 'Dieser Chat enthält Ergebnisse aus {value1}.',
    'db.example.com': 'db.example.com',
    'e.g. Product analytics': 'z. B. Produktanalysen',
    'Paste access key': 'Zugriffsschlüssel einfügen',
    'Shopify’s Dev Dashboard': 'Shopify’s Dev Dashboard',
    'App reference': 'App-Referenz',
    'Draft · revision {value1}': 'Entwurf · Überarbeitung {value1}',
    'its Result': 'sein Ergebnis',
    '· its first run makes it': '· sein erster Lauf macht es',
    '{value1}’s chat ·': 'Chat von {value1} ·',
    '{value1} ad {value2} available.': '{value1} und {value2} verfügbar.',
    '{value1} rows ·': '{value1} Zeilen ·',
    'It starts private. Sharing it wider shares every refresh, which can carry your private data.':
      'Zunächst ist es privat. Wenn Sie es weitergeben, wird jede Aktualisierung geteilt, wodurch Ihre privaten Daten übertragen werden können.',
    'Enable this schedule when approved': 'Diesen Zeitplan nach der Genehmigung aktivieren',
    Schedule: 'Zeitplan',
    'Kept off until you create the agent from its canvas.':
      'Bleibt deaktiviert, bis Sie den Agenten über sein Canvas erstellen.',
    'Will be enabled when you approve.': 'Wird aktiviert, sobald Sie ihn genehmigen.',
    'Will be saved paused. You can enable it later.':
      'Wird pausiert gespeichert. Sie können ihn später aktivieren.',
    'Only runs when you ask.': 'Wird nur auf Anfrage ausgeführt.',
    'Draft · approving saves it, and nothing runs. Test it and create it from its canvas.':
      'Entwurf · Durch die Genehmigung wird er gespeichert, aber nichts ausgeführt. Testen Sie ihn und erstellen Sie ihn über sein Canvas.',
    'Draft · nothing is scheduled until you approve. Connected actions require their own approval at run time.':
      'Entwurf · Bis zur Genehmigung ist nichts geplant. Verbundene Aktionen benötigen zur Ausführungszeit eine eigene Genehmigung.',
    Name: 'Name',
    'Agent name': 'Agentenname',
    'Who can use it': 'Wer ihn verwenden kann',
    'Company agent · company resources only': 'Unternehmensagent · nur Unternehmensressourcen',
    'Personal agent · runs with your access':
      'Persönlicher Agent · wird mit Ihrem Zugriff ausgeführt',
    'Approving saves it as a draft. It does not run automatically.':
      'Durch die Genehmigung wird er als Entwurf gespeichert. Er wird nicht automatisch ausgeführt.',
    'Open the agent’s runs': 'Ausführungen des Agenten öffnen',
    'Run the published version once': 'Veröffentlichte Version einmal ausführen',
    'Stopping…': 'Wird beendet …',
    'Stop run': 'Ausführung beenden',
    'Could not stop this run. Please try again.':
      'Diese Ausführung konnte nicht beendet werden. Bitte versuchen Sie es erneut.',
    'Run in progress': 'Ausführung läuft',
    'This run is still answering. You can ask follow-ups when it finishes.':
      'Diese Ausführung erstellt noch eine Antwort. Sie können nach Abschluss Folgefragen stellen.',
    'Open run details': 'Ausführungsdetails öffnen',
    Runs: 'Ausführungen',
    'Open the run chat': 'Chat der Ausführung öffnen',
    Watch: 'Ansehen',
    Goal: 'Ziel',
    'Change the goal': 'Ziel ändern',
    'What it does': 'Aufgabe',
    'What should this agent achieve?': 'Was soll dieser Agent erreichen?',
    'Not set yet.': 'Noch nicht festgelegt.',
    'When it runs': 'Ausführungszeitpunkt',
    'Change when it runs': 'Ausführungszeitpunkt ändern',
    'Off means it runs only when someone runs it. Changing when it runs never changes its instructions.':
      'Deaktiviert bedeutet, dass er nur ausgeführt wird, wenn ihn jemand startet. Eine Änderung des Ausführungszeitpunkts ändert niemals seine Anweisungen.',
    Instructions: 'Anweisungen',
    'Change the instructions': 'Anweisungen ändern',
    'How the agent should approach the work and make decisions.':
      'Wie der Agent die Aufgabe angehen und Entscheidungen treffen soll.',
    Boundaries: 'Grenzen',
    'What to do or avoid. Every connected action still follows its approval.':
      'Was zu tun oder zu vermeiden ist. Jede verbundene Aktion unterliegt weiterhin ihrer Genehmigung.',
    'No instructions of its own. It follows its Skills.':
      'Keine eigenen Anweisungen. Befolgt seine Fähigkeiten.',
    'Pin a Skill': 'Eine Fähigkeit anheften',
    'Finds the Skills that fit each run, the same way a chat does.':
      'Findet für jede Ausführung passende Fähigkeiten, genauso wie ein Chat.',
    'Skills it always follows': 'Fähigkeiten, die immer befolgt werden',
    'A Skill that is not published': 'Eine nicht veröffentlichte Fähigkeit',
    'Always follows · Version {value1}': 'Wird immer befolgt · Version {value1}',
    'Not published': 'Nicht veröffentlicht',
    Uses: 'Verwendet',
    'Change in chat': 'Im Chat ändern',
    'Change in chat: Uses': 'Im Chat ändern: Verwendet',
    'Company knowledge and the tools each run is allowed to use.':
      'Unternehmenswissen und die Tools, die jede Ausführung verwenden darf.',
    'People see the Result refresh; they change the agent, not the page.':
      'Nutzer sehen die Aktualisierung des Ergebnisses; sie ändern den Agenten, nicht die Seite.',
    'The first run after it is created makes the Result; later runs add a version to it.':
      'Die erste Ausführung nach der Erstellung erzeugt das Ergebnis; spätere Ausführungen fügen ihm eine Version hinzu.',
    'Emails whoever the run is for':
      'Sendet eine E-Mail an die Person, für die die Ausführung bestimmt ist',
    'Email each run': 'Jede Ausführung per E-Mail senden',
    Delivers: 'Liefert',
    'Change what it delivers': 'Lieferumfang ändern',
    'Expected result': 'Erwartetes Ergebnis',
    'What a successful run should deliver.': 'Was eine erfolgreiche Ausführung liefern sollte.',
    'What each run delivers': 'Was jede Ausführung liefert',
    'Keeps one Result up to date {value1}': 'Hält ein Ergebnis auf dem neuesten Stand {value1}',
    'Saves a new Result each run': 'Speichert bei jeder Ausführung ein neues Ergebnis',
    'You can run this company agent as yourself.{value1} {value2}':
      'Sie können diesen Unternehmensagenten als Sie selbst ausführen.{value1} {value2}',
    'Changes since version': 'Änderungen seit Version',
    'are not live yet.': 'sind noch nicht aktiv.',
    'Review them in Versions': 'In den Versionen überprüfen',
    Skill: 'Fähigkeit',
    'The agent always uses the Skill’s published version.':
      'Der Agent verwendet immer die veröffentlichte Version der Fähigkeit.',
    Day: 'Tag',
    Time: 'Uhrzeit',
    'Cron expression': 'Cron-Ausdruck',
    'Editors and access': 'Bearbeiter und Zugriff',
    Company: 'Unternehmen',
    Personal: 'Persönlich',
    'No changes.': 'Keine Änderungen.',
    'Instructions changes': 'Änderungen an den Anweisungen',
    'Loading versions…': 'Versionen werden geladen …',
    'What the draft changes': 'Änderungen des Entwurfs',
    'No published version yet. Try the draft, then publish it.':
      'Noch keine veröffentlichte Version. Testen Sie den Entwurf und veröffentlichen Sie ihn anschließend.',
    'Published versions': 'Veröffentlichte Versionen',
    'Former member': 'Ehemaliges Mitglied',
    Live: 'Aktiv',
    'All rows': 'Alle Zeilen',
    'Close row detail': 'Zeilendetails schließen',
    'Ask about this row': 'Zu dieser Zeile fragen',
    'Add note': 'Notiz hinzufügen',
    Note: 'Notiz',
    Saved: 'Gespeichert',
    Total: 'Gesamt',
    ascending: 'aufsteigend',
    descending: 'absteigend',
    'Scroll to see all columns': 'Scrollen, um alle Spalten zu sehen',
    '{value1} for {value2}': '{value1} für {value2}',
    Suggested: 'Vorgeschlagen',
    'Opening your conversation…': 'Ihre Unterhaltung wird geöffnet …',
    'This conversation isn’t available': 'Diese Unterhaltung ist nicht verfügbar',
    'It may have been deleted, belong to another account, or be temporarily unavailable.':
      'Sie wurde möglicherweise gelöscht, gehört zu einem anderen Konto oder ist vorübergehend nicht verfügbar.',
    '{count} more line — shown in the complete revision':
      '{count} weitere Zeile — in der vollständigen Revision angezeigt',
    '{count} more lines — shown in the complete revision':
      '{count} weitere Zeilen — in der vollständigen Revision angezeigt',
    '{count} more line removed': '{count} weitere Zeile entfernt',
    '{count} more lines removed': '{count} weitere Zeilen entfernt',
    '{count} unchanged line': '{count} unveränderte Zeile',
    '{count} unchanged lines': '{count} unveränderte Zeilen',
    '{count} more lines not shown, {added} added and {removed} removed. Check them in the complete revision.':
      '{count} weitere Zeilen werden nicht angezeigt, {added} hinzugefügt und {removed} entfernt. Überprüfen Sie sie in der vollständigen Revision.',
    'Saved result': 'Gespeichertes Ergebnis',
    'Made with a Skill': 'Mit einer Fähigkeit erstellt',
    'Preview of {name}': 'Vorschau von {name}',
    'Made with {name}': 'Mit {name} erstellt',
    'Ad-hoc result': 'Ad-hoc-Ergebnis',
    'A Skill that is not available in this workspace':
      'Eine Fähigkeit, die in diesem Workspace nicht verfügbar ist',
    '{name} · Revision {version}': '{name} · Revision {version}',
    '{name} · Version {version}': '{name} · Version {version}',
    'Return to conversation {value1}': 'Zur Unterhaltung {value1} zurückkehren',
    '{value1} Working with {value2}': '{value1} arbeitet mit {value2}',
    'View context {value1}': 'Kontext {value1} anzeigen',
    'A way of working, made yours.': 'Eine Arbeitsweise, die zu Ihrer wird.',
    'Work that runs itself.': 'Arbeit, die sich selbst erledigt.',
    'One place for one piece of work.': 'Ein Ort für eine Aufgabe.',
    'Let’s move your work forward{value1}.': 'Lassen Sie uns Ihre Arbeit voranbringen{value1}.',
    'Describe the work. Your Skill takes shape beside the conversation.':
      'Beschreiben Sie die Arbeit. Ihre Fähigkeit nimmt neben der Unterhaltung Gestalt an.',
    'Describe what it should do and when. Your agent takes shape beside the conversation. The draft does not run automatically.':
      'Beschreiben Sie, was es tun soll und wann. Ihr Agent nimmt neben der Unterhaltung Gestalt an. Der Entwurf wird nicht automatisch ausgeführt.',
    'Say what the work is. Poneva drafts the project beside the conversation and brings in what you have already done. Nothing is created until you say so.':
      'Beschreiben Sie, worum es bei der Arbeit geht. Poneva entwirft das Projekt neben der Unterhaltung und übernimmt, was Sie bereits erledigt haben. Es wird nichts erstellt, bis Sie dies bestätigen.',
    'Start with an idea below. Poneva will take it from there.':
      'Beginnen Sie unten mit einer Idee. Poneva übernimmt den Rest.',
    Triggers: 'Auslöser',
    'Review the agent and its trigger. Approval applies exactly what is shown.':
      'Überprüfen Sie den Agenten und seinen Auslöser. Mit der Genehmigung wird genau das Angezeigte angewendet.',
    '{source} · read {date}': '{source} · gelesen am {date}',
    'Evidence is being recorded · read {date}': 'Nachweis wird aufgezeichnet · gelesen am {date}',
    'Evidence expired on {date} under the retention policy':
      'Der Nachweis ist am {date} gemäß der Aufbewahrungsrichtlinie abgelaufen',
    'Entered by {person}': 'Eingegeben von {person}',
    'No retained evidence for this value': 'Für diesen Wert ist kein Nachweis gespeichert',
    'Covers {shown} of {total} rows': 'Umfasst {shown} von {total} Zeilen',
    'Search rows': 'Zeilen durchsuchen',
    'Clear filters': 'Filter löschen',
    Sort: 'Sortieren',
    'Sort: {column}': 'Sortieren: {column}',
    '{shown} of {total} rows': '{shown} von {total} Zeilen',
    More: 'Mehr',
    Density: 'Dichte',
    Comfortable: 'Komfortabel',
    Compact: 'Kompakt',
    Columns: 'Spalten',
    'No rows match. Clear the search or filters to see them again.':
      'Keine Zeilen gefunden. Löschen Sie die Suche oder die Filter, um sie wieder anzuzeigen.',
    'Not available': 'Nicht verfügbar',
    App: 'App',
    Artifact: 'Artefakt',
    'New project': 'Neues Projekt',
    'Review request': 'Überprüfungsanfrage',
    Activity: 'Aktivität',
    'Voice preview': 'Sprachvorschau',
    Source: 'Quelle',
    File: 'Datei',
    Meeting: 'Besprechung',
    'Knowledge page': 'Wissensseite',
    'Could not preview this CSV.': 'Diese CSV-Datei konnte nicht in der Vorschau angezeigt werden.',
    'File content is unavailable.': 'Der Dateiinhalt ist nicht verfügbar.',
    'You have five open suggestions here. {value1} will see them.':
      'Hier sind fünf offene Vorschläge. {value1} wird sie sehen.',
    'We could not send your suggestion. Please try again.':
      'Ihr Vorschlag konnte nicht gesendet werden. Bitte versuchen Sie es erneut.',
    'The agent': 'Der Agent',
    'Selected colleagues': 'Ausgewählte Kollegen',
    'The owner': 'Der Besitzer',
    'Forked. This copy is yours and runs with your own connections.':
      'Abgezweigt. Diese Kopie gehört Ihnen und läuft mit Ihren eigenen Verbindungen.',
    'This chat is too long to fork.': 'Dieser Chat ist zu lang zum Abzweigen.',
    'We could not fork this chat. Please try again.':
      'Dieser Chat konnte nicht abgezweigt werden. Bitte versuchen Sie es erneut.',
    'Anyone who forked it keeps their copy: forks stay with the people who made them.':
      'Alle, die ihn abgezweigt haben, behalten ihre Kopie: Abzweigungen bleiben bei den Personen, die sie erstellt haben.',
    'Nobody has forked this chat.': 'Niemand hat diesen Chat abgezweigt.',
    '1 person forked this chat. Their copy stays theirs.':
      '1 Person hat diesen Chat abgezweigt. Ihre Kopie bleibt in ihrem Besitz.',
    '{value1} people forked this chat. Their copies stay theirs.':
      '{value1} Personen haben diesen Chat abgezweigt. Ihre Kopien bleiben in ihrem Besitz.',
    'Personal. Nobody else sees it.': 'Persönlich. Niemand sonst kann es sehen.',
    'People you pick. They get it in their Inbox.':
      'Von Ihnen ausgewählte Personen. Sie erhalten es in ihrem Posteingang.',
    'Everyone in the company can follow it and fork it.':
      'Alle im Unternehmen können ihm folgen und ihn abzweigen.',
    'a chat you can no longer open': 'ein Chat, den Sie nicht mehr öffnen können',
    'shared the Result': 'hat das Ergebnis geteilt',
    'updated the Result': 'hat das Ergebnis aktualisiert',
    'published the Skill': 'hat die Fähigkeit veröffentlicht',
    'approved the fact': 'hat die Tatsache genehmigt',
    'added the fact': 'hat die Tatsache hinzugefügt',
    'added the meeting': 'hat das Meeting hinzugefügt',
    'published the page': 'hat die Seite veröffentlicht',
    'updated the page': 'hat die Seite aktualisiert',
    'shared the chat': 'hat den Chat geteilt',
    'published a version of': 'hat eine Version von veröffentlicht',
    ran: 'hat ausgeführt',
    Knowledge: 'Wissen',
    Meetings: 'Besprechungen',
    Chat: 'Chat',
    Use: 'Verwenden',
    Open: 'Öffnen',
    You: 'Sie',
    Someone: 'Jemand',
    'published version {version} of': 'hat Version {version} von veröffentlicht',
    'thing needs': 'Element benötigt',
    'things need': 'Elemente benötigen',
    'Published Skill': 'Veröffentlichte Fähigkeit',
    'Included with Skill': 'In der Fähigkeit enthalten',
    'Person added': 'Person hinzugefügt',
    'Person removed': 'Person entfernt',
    'Access changed': 'Zugriff geändert',
    'Access turned off': 'Zugriff deaktiviert',
    'Connection removed': 'Verbindung entfernt',
    'Query time limit changed': 'Zeitlimit für Abfragen geändert',
    '{count} row': '{count} Zeile',
    '{count} rows': '{count} Zeilen',
    'This source is no longer available. Company knowledge now lives in Knowledge pages, and files stay in the Library.':
      'Diese Quelle ist nicht mehr verfügbar. Unternehmenswissen befindet sich jetzt in Wissensseiten, und Dateien bleiben in der Bibliothek.',
    'Already attached': 'Bereits angehängt',
    'Also available in company knowledge': 'Auch im Unternehmenswissen verfügbar',
    'Company file': 'Unternehmensdatei',
    'Account identity unavailable': 'Kontoidentität nicht verfügbar',
    'Access expired or was revoked. Reconnect to continue.':
      'Der Zugriff ist abgelaufen oder wurde entzogen. Stellen Sie die Verbindung wieder her, um fortzufahren.',
    'Account authorized · tools unavailable': 'Konto autorisiert · Tools nicht verfügbar',
    'Not available in this workspace yet.': 'In diesem Workspace noch nicht verfügbar.',
    'Everyone in the company': 'Alle im Unternehmen',
    'Audience: only you.': 'Zielgruppe: nur Sie.',
    'Audience: everyone in the company.': 'Zielgruppe: alle im Unternehmen.',
    'tool is': 'Tool ist',
    'tools are': 'Tools sind',
    'account is': 'Konto ist',
    'accounts are': 'Konten sind',
    'We could not upload this file.': 'Wir konnten diese Datei nicht hochladen.',
    'file was': 'Datei wurde',
    'files were': 'Dateien wurden',
    'Your company': 'Ihr Unternehmen',
    'Create an agent': 'Agent erstellen',
    'Give recurring work a helping hand': 'Wiederkehrende Aufgaben leichter erledigen',
    'Create a Skill': 'Fähigkeit erstellen',
    'Save a reusable way of working': 'Eine wiederverwendbare Arbeitsweise speichern',
    'Take meeting notes': 'Besprechungsnotizen erstellen',
    'Capture decisions and next steps': 'Entscheidungen und nächste Schritte festhalten',
    'Work with a file': 'Mit einer Datei arbeiten',
    'Start from a document or image': 'Mit einem Dokument oder Bild beginnen',
    'Browse agents': 'Agenten durchsuchen',
    'Open your agents and company agents': 'Ihre Agenten und Unternehmensagenten öffnen',
    'Review results': 'Ergebnisse prüfen',
    'Return to work saved in your Library':
      'Zur in Ihrer Bibliothek gespeicherten Arbeit zurückkehren',
    'For review': 'Zur Prüfung',
    'An agent': 'Ein Agent',
    Assistant: 'Assistent',
    'Kept up to date by {value1}{value2}': 'Wird von {value1}{value2} aktuell gehalten',
    ', {value1}': ', {value1}',
    'Version {value1}{value2}{value3}': 'Version {value1}{value2}{value3}',
    'Refreshed by its agent': 'Von seinem Agenten aktualisiert',
    'Saved from a chat': 'Aus einem Chat gespeichert',
    'Saved from {value1}': 'Aus {value1} gespeichert',
    Edited: 'Bearbeitet',
    'private account': 'privates Konto',
    '{value1} ({value2})': '{value1} ({value2})',
    '{value1}’s {value2}': '{value2} von {value1}',
    'Made private. The person who added it and the owner of its recording have been told in their Inbox.':
      'Privat gemacht. Die Person, die es hinzugefügt hat, und der Eigentümer der Aufzeichnung wurden in ihrem Posteingang benachrichtigt.',
    'Made private. The person who added it has been told in their Inbox.':
      'Privat gemacht. Die Person, die es hinzugefügt hat, wurde in ihrem Posteingang benachrichtigt.',
    'Made private. The owner of its recording has been told in their Inbox.':
      'Privat gemacht. Der Eigentümer der Aufzeichnung wurde in seinem Posteingang benachrichtigt.',
    'Selected passage': 'Ausgewählte Passage',
    '{value1} {value2}': '{value1} {value2}',
    'Upload a file': 'Datei hochladen',
    'Help me create a useful report from our company knowledge and available sources.':
      'Helfen Sie mir, aus unserem Unternehmenswissen und den verfügbaren Quellen einen nützlichen Bericht zu erstellen.',
    'This saved work couldn’t be opened. Open it again to retry.':
      'Diese gespeicherte Arbeit konnte nicht geöffnet werden. Öffnen Sie sie erneut, um es noch einmal zu versuchen.',
    '{value1}’s': 'von {value1}',
    '{value1} chat “{value2}”': 'Chat „{value2}“ von {value1}',
    '{value1}{value2}': '{value1}{value2}',
    'Skill: {value1}{value2}': 'Fähigkeit: {value1}{value2}',
    'Result “{value1}”': 'Ergebnis „{value1}“',
    'Meeting “{value1}”': 'Besprechung „{value1}“',
    'Used in {value1} {value2} this week': 'Diese Woche in {value1} {value2} verwendet',
    '{value1} {value2} · used in {value3} {value4}':
      '{value1} {value2} · in {value3} {value4} verwendet',
    'The draft is not published yet, so no one else follows it.':
      'Der Entwurf ist noch nicht veröffentlicht, daher folgt ihm niemand sonst.',
    'Use it in a chat for current data, or refine the Skill first.':
      'Verwenden Sie es in einem Chat für aktuelle Daten oder verfeinern Sie zuerst die Fähigkeit.',
    'An agent keeps this up to date. Continue the work in chat.':
      'Ein Agent hält dies aktuell. Setzen Sie die Arbeit im Chat fort.',
    'Edit it here, or continue the work in chat.':
      'Bearbeiten Sie es hier oder setzen Sie die Arbeit im Chat fort.',
    'Duplicate it to your Library, or continue the work in chat.':
      'Duplizieren Sie es in Ihre Bibliothek oder setzen Sie die Arbeit im Chat fort.',
    'Download Markdown': 'Markdown herunterladen',
    'Download CSV': 'CSV herunterladen',
    'an agent': 'ein Agent',
    'Publish a Skill version': 'Fähigkeitsversion veröffentlichen',
    'Share with {value1}': 'Mit {value1} teilen',
    'Update company content': 'Unternehmensinhalte aktualisieren',
    Approved: 'Genehmigt',
    Declined: 'Abgelehnt',
    Pending: 'Ausstehend',
    'View decision': 'Entscheidung anzeigen',
    'No data': 'Keine Daten',
    'No change': 'Keine Änderung',
    'Connection created': 'Verbindung erstellt',
    'Sharing changed': 'Freigabe geändert',
    '· {value1} by {value2}': '· {value1} von {value2}',
    '· version {value1}': '· Version {value1}',
    '{message} {count} earlier file was saved and attached.':
      '{message} {count} frühere Datei wurde gespeichert und angehängt.',
    '{message} {count} earlier files were saved and attached.':
      '{message} {count} frühere Dateien wurden gespeichert und angehängt.',
    '{message} {count} earlier file was saved.':
      '{message} {count} frühere Datei wurde gespeichert.',
    '{message} {count} earlier files were saved.':
      '{message} {count} frühere Dateien wurden gespeichert.',
    'refreshed {time}': 'aktualisiert {time}',
    'a colleague': 'eine Kollegin/ein Kollege',
    'Your chat “{title}”': 'Ihr Chat „{title}“',
    '{name}’s chat “{title}”': 'Chat „{title}“ von {name}',
    'Kept up to date by {name}{version}': 'Von {name}{version} aktuell gehalten',
    'Skill: {name}{version}': 'Fähigkeit: {name}{version}',
    'Result “{title}”': 'Ergebnis „{title}“',
    'Meeting “{title}”': 'Besprechung „{title}“',
    'Used in {count} answer this week': 'Diese Woche in {count} Antwort verwendet',
    'Used in {count} answers this week': 'Diese Woche in {count} Antworten verwendet',
    '{count} source': '{count} Quelle',
    '{count} sources': '{count} Quellen',
    'used in {count} place': 'an {count} Stelle verwendet',
    'used in {count} places': 'an {count} Stellen verwendet',
    '{company} workspace': '{company} Arbeitsbereich',
    '{count} page': '{count} Seite',
    '{count} pages': '{count} Seiten',
    '{needs} · reviews and approvals': '{needs} · Prüfungen und Genehmigungen',
    '{count} thing needs you': '{count} Element benötigt Ihre Aufmerksamkeit',
    '{count} things need you': '{count} Elemente benötigen Ihre Aufmerksamkeit',
    'Included with Skill · {files} · {sources} {icon}':
      'In Skill enthalten · {files} · {sources} {icon}',
    '{count} file': '{count} Datei',
    '{count} files': '{count} Dateien',
    Today: 'Heute',
    'Earlier this week': 'Anfang dieser Woche',
    '{count} slide': '{count} Folie',
    '{count} slides': '{count} Folien',
    Early: 'Früh',
    'TLS verified': 'TLS verifiziert',
    'Made personal and switched off. Switch it on when you are ready.':
      'Als persönlich festgelegt und deaktiviert. Aktivieren Sie es, wenn Sie bereit sind.',
    'Made personal and switched off. Its owner is told which version is live.':
      'Als persönlich festgelegt und deaktiviert. Der Eigentümer wird darüber informiert, welche Version aktiv ist.',
    'Switched off.': 'Deaktiviert.',
    'Applied version {revision}.': 'Version {revision} angewendet.',
    'The draft is running in a chat only you can read.':
      'Der Entwurf läuft in einem Chat, den nur Sie lesen können.',
    'Publish a version first.': 'Veröffentlichen Sie zuerst eine Version.',
    'Another Agent action is in progress.': 'Eine andere Agent-Aktion läuft bereits.',
    'Knowledge & connections': 'Wissen & Verbindungen',
    'Pinned Skills': 'Angeheftete Fähigkeiten',
    None: 'Keine',
    'A new Result each run': 'Bei jedem Durchlauf ein neues Ergebnis',
    'One Result kept up to date': 'Ein Ergebnis, das aktuell gehalten wird',
    Email: 'E-Mail',
    On: 'Ein',
    Off: 'Aus',
    'Waiting for review': 'Wartet auf Überprüfung',
    Outdated: 'Veraltet',
    Accepted: 'Akzeptiert',
    Rejected: 'Abgelehnt',
    Withdrawn: 'Zurückgezogen',
    Replaced: 'Ersetzt',
    'Suggested edit': 'Vorgeschlagene Bearbeitung',
    'Suggested new page': 'Vorgeschlagene neue Seite',
    'Suggested move': 'Vorgeschlagene Verschiebung',
    'Suggested archive': 'Vorgeschlagene Archivierung',
    'Checking status…': 'Status wird geprüft…',
    'Status unavailable': 'Status nicht verfügbar',
    'Bulleted list': 'Aufzählungsliste',
    'Numbered list': 'Nummerierte Liste',
    'Web link': 'Weblink',
    Read: 'Lesen',
    Write: 'Schreiben',
    'shared with you': 'mit Ihnen geteilt',
    'Getting an answer': 'Antwort wird erstellt',
    '{name} is getting an answer': '{name} erstellt gerade eine Antwort',
    'We could not save. Please try again.':
      'Wir konnten nicht speichern. Bitte versuchen Sie es erneut.',
    'The new page could not be created.': 'Die neue Seite konnte nicht erstellt werden.',
    'We could not load this revision.': 'Diese Revision konnte nicht geladen werden.',
    'We could not restore this revision. Please try again.':
      'Diese Revision konnte nicht wiederhergestellt werden. Bitte versuchen Sie es erneut.',
    'We could not export this revision.': 'Diese Revision konnte nicht exportiert werden.',
    'We could not open this suggestion.': 'Dieser Vorschlag konnte nicht geöffnet werden.',
    'We could not do that. Please try again.':
      'Das war nicht möglich. Bitte versuchen Sie es erneut.',
    'We could not save your decision. Please try again.':
      'Ihre Entscheidung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
    'We could not restore this page. Please try again.':
      'Diese Seite konnte nicht wiederhergestellt werden. Bitte versuchen Sie es erneut.',
    'We could not export this page.': 'Diese Seite konnte nicht exportiert werden.',
    '{count} missed time merged.': '{count} versäumte Zeit zusammengeführt.',
    '{count} missed times merged.': '{count} versäumte Zeiten zusammengeführt.',
    'About this project': 'Über dieses Projekt',
  },
  el: {
    context: 'πλαίσιο',
    skills: 'δεξιότητες',
    'Choose company context': 'Επιλέξτε εταιρικό πλαίσιο',
    'Skills for this conversation': 'Δεξιότητες για αυτήν τη συνομιλία',
    'Bring context into the conversation': 'Προσθήκη πλαισίου στη συνομιλία',
    'Close context picker': 'Κλείσιμο επιλογέα πλαισίου',
    'Filter company context': 'Φιλτράρισμα εταιρικού πλαισίου',
    'Find a Skill…': 'Βρείτε μια δεξιότητα…',
    'Find a file…': 'Βρείτε ένα αρχείο…',
    'Available company context': 'Διαθέσιμο εταιρικό πλαίσιο',
    'No matching published Skills.': 'Δεν βρέθηκαν αντίστοιχες δημοσιευμένες δεξιότητες.',
    'No matching files.': 'Δεν βρέθηκαν αντίστοιχα αρχεία.',
    'Searching company work…': 'Αναζήτηση στην εταιρική εργασία…',
    'Try search again': 'Δοκιμάστε ξανά την αναζήτηση',
    'Meaning search is temporarily limited. Showing available text matches.':
      'Η αναζήτηση βάσει νοήματος είναι προσωρινά περιορισμένη. Εμφανίζονται οι διαθέσιμες αντιστοιχίσεις κειμένου.',
    'Load more matches': 'Φόρτωση περισσότερων αντιστοιχίσεων',
    '{value1} files attached. Remove an attachment to add another. Saved Skill references are included separately.':
      'Έχουν επισυναφθεί {value1} αρχεία. Αφαιρέστε ένα συνημμένο για να προσθέσετε άλλο. Οι αποθηκευμένες αναφορές δεξιοτήτων περιλαμβάνονται ξεχωριστά.',
    'Create a Skill in chat': 'Δημιουργία δεξιότητας στη συνομιλία',
    'Upload a company file': 'Μεταφόρτωση εταιρικού αρχείου',
    'Company knowledge is always available to Poneva.':
      'Η εταιρική γνώση είναι πάντα διαθέσιμη στην Poneva.',
    '{value1} was not connected': 'Το {value1} δεν συνδέθηκε',
    Dismiss: 'Παράβλεψη',
    'Try connecting again': 'Δοκιμάστε να συνδεθείτε ξανά',
    Waiting: 'Αναμονή',
    Connected: 'Συνδεδεμένο',
    'Needs reconnecting': 'Απαιτείται επανασύνδεση',
    Connect: 'Σύνδεση',
    '{value1}{value2} The provider’s account permissions still apply.':
      '{value1}{value2} Εξακολουθούν να ισχύουν τα δικαιώματα του λογαριασμού στον πάροχο.',
    'Last error: {value1}': 'Τελευταίο σφάλμα: {value1}',
    '{value1} {value2} ready.': '{value1} {value2} έτοιμο.',
    'Continue with my Meta app': 'Συνέχεια με την εφαρμογή Meta μου',
    Reconnect: 'Επανασύνδεση',
    Disconnect: 'Αποσύνδεση',
    'Remove attachment: {value1}': 'Αφαίρεση συνημμένου: {value1}',
    'Saved in this Skill. Edit the Skill to change its references.':
      'Αποθηκεύτηκε σε αυτήν τη δεξιότητα. Επεξεργαστείτε τη δεξιότητα για να αλλάξετε τις αναφορές της.',
    'Remove Skill context': 'Αφαίρεση πλαισίου δεξιότητας',
    Refining: 'Βελτίωση',
    Previewing: 'Προεπισκόπηση',
    Using: 'Χρήση',
    'Skill revision {value1}': 'Έκδοση δεξιότητας {value1}',
    'a new Skill': 'μια νέα δεξιότητα',
    '{value1} Making a new agent {value2}': '{value1} Δημιουργία νέου πράκτορα {value2}',
    'Stop making a new agent in this chat':
      'Διακοπή δημιουργίας νέου πράκτορα σε αυτήν τη συνομιλία',
    'Saved Skill references': 'Αποθηκευμένες αναφορές δεξιοτήτων',
    'Included with Skill · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}':
      'Περιλαμβάνεται με τη δεξιότητα · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}',
    'Selected Skill revision is unavailable. Select the Skill again to view its saved references.':
      'Η επιλεγμένη έκδοση της δεξιότητας δεν είναι διαθέσιμη. Επιλέξτε ξανά τη δεξιότητα για να δείτε τις αποθηκευμένες αναφορές της.',
    'Conversation attachments': 'Συνημμένα συνομιλίας',
    'Added for this conversation': 'Προστέθηκε για αυτήν τη συνομιλία',
    'Selected passage {value1}': 'Επιλεγμένο απόσπασμα {value1}',
    'We could not load your workspace.': 'Δεν ήταν δυνατή η φόρτωση του χώρου εργασίας σας.',
    'The selected Skill is unavailable. Check its access or choose it again.':
      'Η επιλεγμένη δεξιότητα δεν είναι διαθέσιμη. Ελέγξτε την πρόσβασή σας ή επιλέξτε την ξανά.',
    'Source saved privately and included in your knowledge search.':
      'Η πηγή αποθηκεύτηκε ιδιωτικά και συμπεριλήφθηκε στην αναζήτηση γνώσης σας.',
    'File saved privately to your library and attached to this message.':
      'Το αρχείο αποθηκεύτηκε ιδιωτικά στη βιβλιοθήκη σας και επισυνάφθηκε σε αυτό το μήνυμα.',
    'File saved privately to your library.': 'Το αρχείο αποθηκεύτηκε ιδιωτικά στη βιβλιοθήκη σας.',
    '{value1} {value2} earlier {value3} saved{value4}.':
      '{value1} {value2} πριν από {value3} αποθηκεύτηκε{value4}.',
    'Extracted text for Poneva to read. Download the original for its layout, charts and images. Spreadsheet formulas show their saved results and are not recalculated.':
      'Εξαγόμενο κείμενο για ανάγνωση από την Poneva. Κατεβάστε το πρωτότυπο για τη διάταξη, τα γραφήματα και τις εικόνες του. Οι τύποι του υπολογιστικού φύλλου εμφανίζουν τα αποθηκευμένα αποτελέσματά τους και δεν υπολογίζονται ξανά.',
    Esc: 'Esc',
    'Start something': 'Ξεκινήστε κάτι',
    'Choose a file to work with': 'Επιλέξτε ένα αρχείο για εργασία',
    'Skills worth adding': 'Δεξιότητες που αξίζει να προσθέσετε',
    'Picked for you': 'Επιλεγμένα για εσάς',
    'Reusable work grounded in your company knowledge.':
      'Επαναχρησιμοποιήσιμη εργασία βασισμένη στην εταιρική σας γνώση.',
    'Ideas from your company context and recent work. Pick one to start.':
      'Ιδέες από το εταιρικό σας πλαίσιο και την πρόσφατη εργασία σας. Επιλέξτε μία για να ξεκινήσετε.',
    'Refresh suggested tasks': 'Ανανέωση προτεινόμενων εργασιών',
    'Check for new company context.': 'Έλεγχος για νέο εταιρικό πλαίσιο.',
    'Check for new context. Ideas also refresh daily.':
      'Έλεγχος για νέο πλαίσιο. Οι ιδέες ανανεώνονται επίσης καθημερινά.',
    Refresh: 'Ανανέωση',
    'Finding useful starting points…': 'Εύρεση χρήσιμων σημείων εκκίνησης…',
    'Suggestions aren’t available right now. Try Refresh, or describe the work you want to do.':
      'Οι προτάσεις δεν είναι διαθέσιμες αυτήν τη στιγμή. Δοκιμάστε την επιλογή «Ανανέωση» ή περιγράψτε την εργασία που θέλετε να κάνετε.',
    'Loading the knowledge pages…': 'Φόρτωση των σελίδων γνώσης…',
    '{value1} All pages': '{value1} Όλες οι σελίδες',
    'The page is created.': 'Η σελίδα δημιουργήθηκε.',
    'Your new page is suggested. A publisher decides whether it is added.':
      'Η νέα σας σελίδα προτάθηκε. Ένας εκδότης αποφασίζει αν θα προστεθεί.',
    'Company knowledge': 'Εταιρική γνώση',
    'What Poneva knows about your company, page by page. Every change is kept.':
      'Όσα γνωρίζει η Poneva για την εταιρεία σας, σελίδα προς σελίδα. Κάθε αλλαγή διατηρείται.',
    'Loading company knowledge…': 'Φόρτωση εταιρικής γνώσης…',
    'Knowledge pages are not enabled in this workspace.':
      'Οι σελίδες γνώσης δεν είναι ενεργοποιημένες σε αυτόν τον χώρο εργασίας.',
    'Ask your Poneva contact to switch them on for your company.':
      'Ζητήστε από την επαφή σας στην Poneva να τις ενεργοποιήσει για την εταιρεία σας.',
    '{value1} Change the agent': '{value1} Αλλαγή πράκτορα',
    '{value1} Continue in chat': '{value1} Συνέχεια στη συνομιλία',
    'We could not load this item.': 'Δεν ήταν δυνατή η φόρτωση αυτού του στοιχείου.',
    '{value1} canvas': '{value1} καμβάς',
    'Loading {value1}…': 'Φόρτωση του {value1}…',
    '{value1} · Original retained': '{value1} · Διατηρήθηκε το πρωτότυπο',
    '{value1} {value2}{value3} · Added {value4}': '{value1} {value2}{value3} · Προστέθηκε {value4}',
    '{value1} Use in chat': '{value1} Χρήση στη συνομιλία',
    '{value1} Download': '{value1} Λήψη',
    Table: 'Πίνακας',
    Chart: 'Γράφημα',
    Original: 'Πρωτότυπο',
    'Text extracted from the PDF, marked by page. Download the original for its layout and images.':
      'Κείμενο που εξήχθη από το PDF, επισημασμένο ανά σελίδα. Κατεβάστε το πρωτότυπο για τη διάταξη και τις εικόνες του.',
    'This preview shows the beginning of the file. Poneva reads the whole file; download the original to see all of it.':
      'Αυτή η προεπισκόπηση εμφανίζει την αρχή του αρχείου. Η Poneva διαβάζει ολόκληρο το αρχείο· κατεβάστε το πρωτότυπο για να το δείτε ολόκληρο.',
    'Preview of the first {value1} complete rows. Filtering and charts use only this preview. Download the original for the full file.':
      'Προεπισκόπηση των πρώτων {value1} πλήρων γραμμών. Τα φίλτρα και τα γραφήματα χρησιμοποιούν μόνο αυτή την προεπισκόπηση. Κατεβάστε το πρωτότυπο για ολόκληρο το αρχείο.',
    'This source link cannot be opened.': 'Αυτός ο σύνδεσμος πηγής δεν μπορεί να ανοίξει.',
    'Read-only chat': 'Συνομιλία μόνο για ανάγνωση',
    'Only {value1} writes in this chat. Fork it to continue with your own connections. {value2}':
      'Μόνο ο χρήστης {value1} γράφει σε αυτή τη συνομιλία. Δημιουργήστε αντίγραφο για να συνεχίσετε με τις δικές σας συνδέσεις. {value2}',
    'Suggest a follow-up…': 'Προτείνετε μια συνέχεια…',
    'Suggest a follow-up': 'Πρόταση συνέχειας',
    'Sending…': 'Αποστολή…',
    Send: 'Αποστολή',
    'We could not dismiss that suggestion. Please try again.':
      'Δεν ήταν δυνατή η απόρριψη αυτής της πρότασης. Δοκιμάστε ξανά.',
    'Suggested follow-ups': 'Προτεινόμενες συνέχειες',
    '{value1} suggests': 'Ο/Η {value1} προτείνει',
    Ask: 'Ερώτηση',
    'Dismiss {value1}’s suggestion': 'Απόρριψη της πρότασης του/της {value1}',
    'Suggested by': 'Προτάθηκε από',
    '· edit it or send it': '· επεξεργαστείτε την ή στείλτε την',
    'Remove the suggestion tag': 'Αφαίρεση ετικέτας πρότασης',
    '{value1} {value2} is getting an answer': 'Ο/Η {value1} {value2} λαμβάνει απάντηση',
    '{value1} {value2} stopped the answer': 'Ο/Η {value1} {value2} διέκοψε την απάντηση',
    '{value1} Fork from here': '{value1} Δημιουργία αντιγράφου από εδώ',
    '{value1} From {value2}’s {value3}': '{value1} Από το {value3} του/της {value2}',
    'Only {value1} can use this account':
      'Μόνο ο χρήστης {value1} μπορεί να χρησιμοποιήσει αυτόν τον λογαριασμό',
    '{value1} Suggested by {value2}': '{value1} Προτάθηκε από τον/την {value2}',
    'Fork this chat': 'Δημιουργία αντιγράφου αυτής της συνομιλίας',
    'Forking…': 'Δημιουργία αντιγράφου…',
    Fork: 'Δημιουργία αντιγράφου',
    'Could not make this private.': 'Δεν ήταν δυνατή η μετατροπή σε ιδιωτική.',
    'Make this chat private?': 'Να γίνει ιδιωτική αυτή η συνομιλία;',
    Close: 'Κλείσιμο',
    '{value1} will see “{value2}”. Everyone else loses access right away {value3} .{value4}':
      'Ο/Η {value1} θα βλέπει το «{value2}». Όλοι οι υπόλοιποι χάνουν αμέσως την πρόσβαση {value3} .{value4}',
    Cancel: 'Ακύρωση',
    'Saving…': 'Αποθήκευση…',
    'Make private': 'Μετατροπή σε ιδιωτική',
    'This chat is private again. Forks others made stay theirs.':
      'Αυτή η συνομιλία είναι και πάλι ιδιωτική. Τα αντίγραφα που δημιούργησαν άλλοι παραμένουν δικά τους.',
    'Who can read this chat: {value1}': 'Ποιος μπορεί να διαβάσει αυτή τη συνομιλία: {value1}',
    'Move this chat': 'Μετακίνηση αυτής της συνομιλίας',
    'Only you write here. Others follow live and fork.':
      'Μόνο εσείς γράφετε εδώ. Οι άλλοι παρακολουθούν ζωντανά και δημιουργούν αντίγραφα.',
    'Made private. {value1} has been told in their Inbox.':
      'Έγινε ιδιωτική. Ο/Η {value1} ενημερώθηκε στα Εισερχόμενά του/της.',
    'Chat access': 'Πρόσβαση στη συνομιλία',
    '{value1}’s chat. As an admin you can make it private.':
      'Συνομιλία του/της {value1}. Ως διαχειριστής μπορείτε να την κάνετε ιδιωτική.',
    'Only {value1} will see it. {value2} is told.':
      'Μόνο ο χρήστης {value1} θα τη βλέπει. Ο/Η {value2} ενημερώνεται.',
    '{value1} {value2} following': '{value1} {value2} παρακολουθούν',
    'Forked from{value1} {value2} . The history is copied. From here, tools run with your own access.':
      'Δημιουργήθηκε αντίγραφο από{value1} {value2} . Το ιστορικό αντιγράφηκε. Από εδώ και πέρα, τα εργαλεία εκτελούνται με τη δική σας πρόσβαση.',
    '{value1} made this chat private': 'Ο/Η {value1} έκανε αυτή τη συνομιλία ιδιωτική',
    'You can no longer open it. Any fork you made stays yours.':
      'Δεν μπορείτε πλέον να την ανοίξετε. Οποιοδήποτε αντίγραφο δημιουργήσατε παραμένει δικό σας.',
    'Start a new chat': 'Έναρξη νέας συνομιλίας',
    'Back to Recent chats': 'Επιστροφή στις πρόσφατες συνομιλίες',
    'More chat actions': 'Περισσότερες ενέργειες συνομιλίας',
    'Close conversation sharing': 'Κλείσιμο κοινής χρήσης συνομιλίας',
    'Review the text before saving a private copy to Library. Then choose its audience. Your original conversation and future messages stay private.':
      'Ελέγξτε το κείμενο πριν αποθηκεύσετε ένα ιδιωτικό αντίγραφο στη Βιβλιοθήκη. Στη συνέχεια επιλέξτε το κοινό του. Η αρχική συνομιλία και τα μελλοντικά μηνύματά σας παραμένουν ιδιωτικά.',
    'Preparing the conversation…': 'Προετοιμασία της συνομιλίας…',
    'Refresh preview': 'Ανανέωση προεπισκόπησης',
    'The copy is saved in Library. Use Share to choose who can access it.':
      'Το αντίγραφο αποθηκεύτηκε στη Βιβλιοθήκη. Χρησιμοποιήστε την επιλογή Κοινή χρήση για να επιλέξετε ποιος θα έχει πρόσβαση.',
    'Save this copy': 'Αποθήκευση αυτού του αντιγράφου',
    'That Skill could not be opened.': 'Δεν ήταν δυνατό το άνοιγμα αυτής της Δεξιότητας.',
    '{value1}{value2} · reviews and approvals': '{value1}{value2} · έλεγχοι και εγκρίσεις',
    'Open Inbox': 'Άνοιγμα Εισερχομένων',
    'New at {value1} this week': 'Νέα στο {value1} αυτή την εβδομάδα',
    'Nothing new this week. Shared work, published Skills and approved knowledge show up here.':
      'Δεν υπάρχει κάτι νέο αυτή την εβδομάδα. Η κοινόχρηστη εργασία, οι δημοσιευμένες Δεξιότητες και η εγκεκριμένη γνώση εμφανίζονται εδώ.',
    'New at {value1}': 'Νέα στο {value1}',
    'This Skill is unavailable. Try again.':
      'Αυτή η Δεξιότητα δεν είναι διαθέσιμη. Δοκιμάστε ξανά.',
    'You can attach up to {value1} files. Remove an attachment to add another.':
      'Μπορείτε να επισυνάψετε έως και {value1} αρχεία. Αφαιρέστε ένα συνημμένο για να προσθέσετε άλλο.',
    'Add company context': 'Προσθήκη εταιρικού πλαισίου',
    'Add company context · @': 'Προσθήκη εταιρικού πλαισίου · @',
    'Choose a Skill': 'Επιλογή Δεξιότητας',
    'Choose a Skill · /': 'Επιλογή Δεξιότητας · /',
    Edit: 'Επεξεργασία',
    '{value1} Edit with chat': '{value1} Επεξεργασία με συνομιλία',
    '{value1} Duplicate to my Library': '{value1} Δημιουργία αντιγράφου στη Βιβλιοθήκη μου',
    'Duplicated to your Library. Only you can see the copy.':
      'Το αντίγραφο προστέθηκε στη Βιβλιοθήκη σας. Μόνο εσείς μπορείτε να το δείτε.',
    'Could not duplicate this Result. Try again.':
      'Δεν ήταν δυνατή η δημιουργία αντιγράφου αυτού του Αποτελέσματος. Δοκιμάστε ξανά.',
    'Saved version {value1}.': 'Η έκδοση {value1} αποθηκεύτηκε.',
    'A newer version was saved. Reload the Result before saving.':
      'Αποθηκεύτηκε νεότερη έκδοση. Φορτώστε ξανά το Αποτέλεσμα πριν από την αποθήκευση.',
    'Could not save this version. Try again.':
      'Δεν ήταν δυνατή η αποθήκευση αυτής της έκδοσης. Δοκιμάστε ξανά.',
    '{value1} saved a newer version. Review it before saving.':
      'Ο χρήστης {value1} αποθήκευσε νεότερη έκδοση. Ελέγξτε την πριν από την αποθήκευση.',
    'Hide their version': 'Απόκρυψη της έκδοσής τους',
    'Show their version': 'Εμφάνιση της έκδοσής τους',
    'Start from their version': 'Έναρξη από την έκδοσή τους',
    Markdown: 'Markdown',
    'Result text': 'Κείμενο αποτελέσματος',
    Preview: 'Προεπισκόπηση',
    'What changed': 'Τι άλλαξε',
    'What changed? (optional)': 'Τι άλλαξε; (προαιρετικό)',
    'Save version {value1}': 'Αποθήκευση έκδοσης {value1}',
    'Open chat': 'Άνοιγμα συνομιλίας',
    Current: 'Τρέχουσα',
    Restore: 'Επαναφορά',
    'Could not load the history.': 'Δεν ήταν δυνατή η φόρτωση του ιστορικού.',
    'Restored version {value1} as version {value2}.':
      'Η έκδοση {value1} επαναφέρθηκε ως έκδοση {value2}.',
    'Someone saved a newer version. Review it before restoring.':
      'Κάποιος αποθήκευσε νεότερη έκδοση. Ελέγξτε την πριν από την επαναφορά.',
    'Could not restore that version.': 'Δεν ήταν δυνατή η επαναφορά εκείνης της έκδοσης.',
    'Loading history…': 'Φόρτωση ιστορικού…',
    'Restoring keeps what is there now as a version too, so nothing is lost.':
      'Με την επαναφορά, ό,τι υπάρχει τώρα διατηρείται επίσης ως έκδοση, ώστε να μη χαθεί τίποτα.',
    'This Result was made with your own {value1}.':
      'Αυτό το Αποτέλεσμα δημιουργήθηκε με το δικό σας {value1}.',
    'It also used': 'Χρησιμοποιήθηκαν επίσης',
    'This Result was made with': 'Αυτό το Αποτέλεσμα δημιουργήθηκε με',
    'Colleagues can read what came from them, but can never use them.':
      'Οι συνάδελφοι μπορούν να διαβάσουν ό,τι προήλθε από αυτά, αλλά δεν μπορούν ποτέ να τα χρησιμοποιήσουν.',
    'Your personal agent {value1} keeps it up to date with your own access, so every refresh can carry your private data.':
      'Ο προσωπικός σας agent {value1} το διατηρεί ενημερωμένο με τη δική σας πρόσβαση, ώστε κάθε ανανέωση να μπορεί να περιλαμβάνει τα ιδιωτικά σας δεδομένα.',
    'A colleague’s personal agent keeps it up to date with their own access, so every refresh can carry their private data.':
      'Ο προσωπικός agent ενός συναδέλφου το διατηρεί ενημερωμένο με τη δική του πρόσβαση, ώστε κάθε ανανέωση να μπορεί να περιλαμβάνει τα ιδιωτικά του δεδομένα.',
    'Made private. Only you can see this meeting.':
      'Έγινε ιδιωτική. Μόνο εσείς μπορείτε να δείτε αυτήν τη σύσκεψη.',
    'Could not make this meeting private.':
      'Δεν ήταν δυνατή η μετατροπή αυτής της σύσκεψης σε ιδιωτική.',
    'Meeting · {value1} {value2} · Original retained':
      'Σύσκεψη · {value1} {value2} · Το πρωτότυπο διατηρήθηκε',
    'The recording could not be opened.': 'Δεν ήταν δυνατό το άνοιγμα της καταγραφής.',
    'Ask about this suggestion': 'Ρωτήστε σχετικά με αυτήν την πρόταση',
    meeting_processing_failed: 'Η επεξεργασία της σύσκεψης απέτυχε',
    'Who can see this': 'Ποιοι μπορούν να το δουν',
    'Everyone at {value1}': 'Όλοι στο {value1}',
    'Only me': 'Μόνο εγώ',
    'Everyone at {value1} can find it and ask about it.':
      'Όλοι στο {value1} μπορούν να το βρουν και να ρωτήσουν σχετικά με αυτό.',
    'Only you can open and search this meeting. You can share it later.':
      'Μόνο εσείς μπορείτε να ανοίξετε και να αναζητήσετε σε αυτήν τη σύσκεψη. Μπορείτε να την κοινοποιήσετε αργότερα.',
    'Added. Only you can see it. Transcription is running in the background.':
      'Προστέθηκε. Μόνο εσείς μπορείτε να το δείτε. Η απομαγνητοφώνηση εκτελείται στο παρασκήνιο.',
    'Visible to everyone at {value1}': 'Ορατό σε όλους στο {value1}',
    'Could not make it private.': 'Δεν ήταν δυνατή η μετατροπή του σε ιδιωτικό.',
    'Show more meetings': 'Εμφάνιση περισσότερων συσκέψεων',
    'Attached to this message': 'Επισυνάπτεται σε αυτό το μήνυμα',
    'Connect securely, choose the tables to share, then decide whether Poneva can read or make changes.':
      'Συνδεθείτε με ασφάλεια, επιλέξτε τους πίνακες που θέλετε να κοινοποιήσετε και, στη συνέχεια, αποφασίστε αν το Poneva μπορεί να διαβάζει ή να κάνει αλλαγές.',
    'Review the tables this connection can access. Select at least one table.':
      'Ελέγξτε τους πίνακες στους οποίους μπορεί να έχει πρόσβαση αυτή η σύνδεση. Επιλέξτε τουλάχιστον έναν πίνακα.',
    'Select at least one table. Nothing is selected by default.':
      'Επιλέξτε τουλάχιστον έναν πίνακα. Από προεπιλογή δεν έχει επιλεγεί τίποτα.',
    'Choose who can use this connection and what Poneva can do.':
      'Επιλέξτε ποιοι μπορούν να χρησιμοποιούν αυτήν τη σύνδεση και τι μπορεί να κάνει το Poneva.',
    'Your chosen access is enabled for the selected tables.':
      'Η επιλεγμένη πρόσβαση ενεργοποιήθηκε για τους επιλεγμένους πίνακες.',
    'Your connection is saved with reading paused until permission is confirmed.':
      'Η σύνδεσή σας αποθηκεύτηκε με την ανάγνωση σε παύση έως ότου επιβεβαιωθεί η άδεια.',
    'Confirm database disconnect': 'Επιβεβαίωση αποσύνδεσης βάσης δεδομένων',
    'Disconnect this database?': 'Να αποσυνδεθεί αυτή η βάση δεδομένων;',
    'Access will stop for everyone using this connection.':
      'Η πρόσβαση θα διακοπεί για όλους όσοι χρησιμοποιούν αυτήν τη σύνδεση.',
    'Keep connection': 'Διατήρηση σύνδεσης',
    'What it can reach · {value1}{value2} {value3}':
      'Τι μπορεί να προσπελάσει · {value1}{value2} {value3}',
    Back: 'Πίσω',
    Continue: 'Συνέχεια',
    'Uploading…': 'Μεταφόρτωση…',
    Library: 'Βιβλιοθήκη',
    'Source material for your work. Available whenever you need it.':
      'Υλικό πηγών για την εργασία σας. Διαθέσιμο όποτε το χρειάζεστε.',
    'The work you want to keep, with its sources and conversation attached.':
      'Η εργασία που θέλετε να κρατήσετε, μαζί με τις πηγές και τη συνομιλία της.',
    Results: 'Αποτελέσματα',
    Files: 'Αρχεία',
    Artifacts: 'Παραδοτέα',
    'Search library': 'Αναζήτηση στη βιβλιοθήκη',
    'Find files by meaning…': 'Βρείτε αρχεία βάσει νοήματος…',
    'Find saved work by meaning…': 'Βρείτε αποθηκευμένη εργασία βάσει νοήματος…',
    'Search coverage is limited while indexing or meaning-based search is unavailable. You can retry or browse recent items.':
      'Η κάλυψη της αναζήτησης είναι περιορισμένη όσο η ευρετηρίαση ή η αναζήτηση βάσει νοήματος δεν είναι διαθέσιμη. Μπορείτε να δοκιμάσετε ξανά ή να περιηγηθείτε στα πρόσφατα στοιχεία.',
    'No matching work found.': 'Δεν βρέθηκε εργασία που να ταιριάζει.',
    'A starting point for your next question.': 'Ένα σημείο εκκίνησης για την επόμενη ερώτησή σας.',
    'Good work is worth keeping.': 'Η καλή δουλειά αξίζει να διατηρείται.',
    'Try a different description or clear the search to browse.':
      'Δοκιμάστε διαφορετική περιγραφή ή διαγράψτε την αναζήτηση για να περιηγηθείτε.',
    'Upload source material once and use it in conversations and Skills. Your original stays in the library.':
      'Μεταφορτώστε το υλικό πηγών μία φορά και χρησιμοποιήστε το σε συνομιλίες και Δεξιότητες. Το πρωτότυπό σας παραμένει στη βιβλιοθήκη.',
    'Ask Poneva to save an answer, table or chart. Results stay connected to the conversation and their sources.':
      'Ζητήστε από το Poneva να αποθηκεύσει μια απάντηση, έναν πίνακα ή ένα γράφημα. Τα αποτελέσματα παραμένουν συνδεδεμένα με τη συνομιλία και τις πηγές τους.',
    'Start in chat {value1}': 'Έναρξη στη συνομιλία {value1}',
    'Open result: {value1}': 'Άνοιγμα αποτελέσματος: {value1}',
    'Loading more library items…': 'Φόρτωση περισσότερων στοιχείων βιβλιοθήκης…',
    'Load more': 'Φόρτωση περισσότερων',
    'Documents, transcripts, audio and video · Up to 500 MB per file. New files are private. Choose their audience with Share and which processable files become searchable company knowledge.':
      'Έγγραφα, απομαγνητοφωνήσεις, ήχος και βίντεο · Έως 500 MB ανά αρχείο. Τα νέα αρχεία είναι ιδιωτικά. Επιλέξτε το κοινό τους μέσω της επιλογής «Κοινή χρήση» και ποια αρχεία που μπορούν να υποβληθούν σε επεξεργασία θα γίνουν αναζητήσιμη εταιρική γνώση.',
    Skills: 'Δεξιότητες',
    'Create in chat': 'Δημιουργία στη συνομιλία',
    'Search Skills': 'Αναζήτηση δεξιοτήτων',
    'Search finds published Skills. Clear the search to browse your drafts too.':
      'Η αναζήτηση βρίσκει δημοσιευμένες δεξιότητες. Εκκαθαρίστε την αναζήτηση για να περιηγηθείτε και στα πρόχειρά σας.',
    'Search coverage is limited while indexing or meaning-based search is unavailable.':
      'Η κάλυψη της αναζήτησης είναι περιορισμένη όσο η ευρετηρίαση ή η αναζήτηση βάσει νοήματος δεν είναι διαθέσιμη.',
    'Searching Skills…': 'Αναζήτηση δεξιοτήτων…',
    'No matching published Skills found. Try a different description.':
      'Δεν βρέθηκαν δημοσιευμένες δεξιότητες που να ταιριάζουν. Δοκιμάστε διαφορετική περιγραφή.',
    'Load more Skills': 'Φόρτωση περισσότερων δεξιοτήτων',
    'View Skill: {value1}': 'Προβολή δεξιότητας: {value1}',
    'Company workspace': 'Εταιρικός χώρος εργασίας',
    'View {value1}': 'Προβολή {value1}',
    'Loading Skills…': 'Φόρτωση δεξιοτήτων…',
    'Try again {value1}': 'Δοκιμάστε ξανά {value1}',
    'Try again': 'Δοκιμάστε ξανά',
    'Nothing yet.': 'Τίποτα ακόμη.',
    'Made from · Used by': 'Δημιουργήθηκε από · Χρησιμοποιείται από',
    'Could not load links': 'Δεν ήταν δυνατή η φόρτωση των συνδέσμων',
    'Made from': 'Δημιουργήθηκε από',
    'Used by': 'Χρησιμοποιείται από',
    'About this chat {value1}': 'Σχετικά με αυτήν τη συνομιλία {value1}',
    'About this chat': 'Σχετικά με αυτήν τη συνομιλία',
    'Keep the work moving.': 'Συνεχίστε την εργασία.',
    'Ask a follow-up with this result in view, or turn a useful approach into a company Skill.':
      'Κάντε μια επακόλουθη ερώτηση έχοντας αυτό το αποτέλεσμα υπόψη ή μετατρέψτε μια χρήσιμη προσέγγιση σε εταιρική δεξιότητα.',
    'Save approach as a Skill': 'Αποθήκευση προσέγγισης ως δεξιότητας',
    'Preview of': 'Προεπισκόπηση του',
    'Made with': 'Δημιουργήθηκε με',
    'Open the draft': 'Άνοιγμα του πρόχειρου',
    'Open Skill': 'Άνοιγμα δεξιότητας',
    'Use in chat': 'Χρήση στη συνομιλία',
    'Finish the draft': 'Ολοκλήρωση του πρόχειρου',
    'Refine this Skill': 'Βελτίωση αυτής της δεξιότητας',
    'Made with a Skill.': 'Δημιουργήθηκε με μια δεξιότητα.',
    'This workspace could not be loaded just now, so that Skill cannot be opened yet. The result itself is unchanged.':
      'Δεν ήταν δυνατή η φόρτωση αυτού του χώρου εργασίας αυτήν τη στιγμή, επομένως η συγκεκριμένη δεξιότητα δεν μπορεί ακόμη να ανοίξει. Το ίδιο το αποτέλεσμα δεν έχει αλλάξει.',
    'That Skill is not available in this workspace, so it cannot be opened or used again. The result itself is unchanged.':
      'Η συγκεκριμένη δεξιότητα δεν είναι διαθέσιμη σε αυτόν τον χώρο εργασίας, επομένως δεν μπορεί να ανοίξει ή να χρησιμοποιηθεί ξανά. Το ίδιο το αποτέλεσμα δεν έχει αλλάξει.',
    'Result · {value1} {value2}': 'Αποτέλεσμα · {value1} {value2}',
    '{value1} Copy link': '{value1} Αντιγραφή συνδέσμου',
    'Result link copied.': 'Ο σύνδεσμος του αποτελέσματος αντιγράφηκε.',
    'Could not copy the link. Use your browser address bar.':
      'Δεν ήταν δυνατή η αντιγραφή του συνδέσμου. Χρησιμοποιήστε τη γραμμή διευθύνσεων του προγράμματος περιήγησης.',
    'No preview is available for this result.':
      'Δεν υπάρχει διαθέσιμη προεπισκόπηση για αυτό το αποτέλεσμα.',
    '{value1} rows are retained in this snapshot. Open Table to inspect the values.':
      'Σε αυτό το στιγμιότυπο διατηρούνται {value1} γραμμές. Ανοίξτε τον Πίνακα για να ελέγξετε τις τιμές.',
    'People can’t edit a Result an agent keeps up to date; the next refresh would replace their edit. Change the agent’s instructions instead.':
      'Οι χρήστες δεν μπορούν να επεξεργαστούν ένα αποτέλεσμα που ενημερώνεται από έναν πράκτορα· η επόμενη ανανέωση θα αντικαταστήσει την αλλαγή τους. Αλλάξτε αντί γι’ αυτό τις οδηγίες του πράκτορα.',
    'Linked sources': 'Συνδεδεμένες πηγές',
    'Saved source': 'Αποθηκευμένη πηγή',
    'No source documents are linked to this result. Company knowledge and other references may be cited in the answer.':
      'Δεν υπάρχουν έγγραφα-πηγές συνδεδεμένα με αυτό το αποτέλεσμα. Η εταιρική γνώση και άλλες αναφορές ενδέχεται να παρατίθενται στην απάντηση.',
    'Run details': 'Λεπτομέρειες εκτέλεσης',
    Created: 'Δημιουργήθηκε',
    ', revised {value1}': ', αναθεωρήθηκε {value1}',
    Conversation: 'Συνομιλία',
    'Not recorded': 'Δεν καταγράφηκε',
    'Open conversation': 'Άνοιγμα συνομιλίας',
    Run: 'Εκτέλεση',
    Updates: 'Ενημερώσεις',
    'Kept up to date by {value1}': 'Διατηρείται ενημερωμένο από {value1}',
    'Version {value1}': 'Έκδοση {value1}',
    'Could not open this request.': 'Δεν ήταν δυνατό το άνοιγμα αυτού του αιτήματος.',
    'Approved version published.': 'Η εγκεκριμένη έκδοση δημοσιεύτηκε.',
    'Request rejected. The item stays unchanged.':
      'Το αίτημα απορρίφθηκε. Το στοιχείο παραμένει αμετάβλητο.',
    'Could not save the decision.': 'Δεν ήταν δυνατή η αποθήκευση της απόφασης.',
    'Proposed company change': 'Προτεινόμενη εταιρική αλλαγή',
    'Opening…': 'Άνοιγμα…',
    'Approve this version': 'Έγκριση αυτής της έκδοσης',
    Decline: 'Απόρριψη',
    'Review the submitted version below. Changes made since submission will need a new request.':
      'Ελέγξτε παρακάτω την υποβληθείσα έκδοση. Οι αλλαγές που έγιναν μετά την υποβολή θα χρειαστούν νέο αίτημα.',
    'The version submitted with this request.': 'Η έκδοση που υποβλήθηκε με αυτό το αίτημα.',
    'Version and proposed change': 'Έκδοση και προτεινόμενη αλλαγή',
    'Could not read the pinned content.':
      'Δεν ήταν δυνατή η ανάγνωση του καρφιτσωμένου περιεχομένου.',
    'Showing a page of {value1} characters.': 'Εμφανίζεται μία σελίδα με {value1} χαρακτήρες.',
    'Beginning of the submitted content. Open the full text to review every page.':
      'Αρχή του υποβληθέντος περιεχομένου. Ανοίξτε το πλήρες κείμενο για να ελέγξετε κάθε σελίδα.',
    'Read full submitted text': 'Ανάγνωση πλήρους υποβληθέντος κειμένου',
    'Previous page': 'Προηγούμενη σελίδα',
    'Next page': 'Επόμενη σελίδα',
    'Made private. Its creator has been told in their Inbox.':
      'Έγινε ιδιωτικό. Ο δημιουργός του ενημερώθηκε στα Εισερχόμενά του.',
    'Made private. Its creator could not be notified.':
      'Έγινε ιδιωτικό. Δεν ήταν δυνατή η ειδοποίηση του δημιουργού του.',
    'Make this {value1} private?': 'Να γίνει ιδιωτικό αυτό το {value1};',
    'Only the person who created it will see it. Everyone else loses access right away, and its creator gets an Inbox update if they are still a company member. If they have left, nobody in the company will be able to access this item.':
      'Μόνο το άτομο που το δημιούργησε θα μπορεί να το δει. Όλοι οι υπόλοιποι χάνουν αμέσως την πρόσβαση και ο δημιουργός του λαμβάνει ενημέρωση στα Εισερχόμενά του, αν εξακολουθεί να είναι μέλος της εταιρείας. Αν έχει αποχωρήσει, κανείς στην εταιρεία δεν θα μπορεί να αποκτήσει πρόσβαση σε αυτό το στοιχείο.',
    'Sent for review. The current audience stays unchanged until approval.':
      'Στάλθηκε για έλεγχο. Το τρέχον κοινό παραμένει αμετάβλητο μέχρι την έγκριση.',
    'Could not update sharing.': 'Δεν ήταν δυνατή η ενημέρωση της κοινής χρήσης.',
    'They can follow new answers live and fork it to continue with their own connections. Only you write here. You can make it private again at any time.':
      'Μπορούν να παρακολουθούν ζωντανά τις νέες απαντήσεις και να δημιουργήσουν διακλάδωση, ώστε να συνεχίσουν με τις δικές τους συνδέσεις. Μόνο εσείς γράφετε εδώ. Μπορείτε να το κάνετε ξανά ιδιωτικό ανά πάσα στιγμή.',
    'They see the project, its brief and the work in it they can already open. Nothing in it opens for anyone because of the project; each item keeps its own access.':
      'Βλέπουν το έργο, την περιγραφή του και την εργασία που περιέχει και μπορούν ήδη να ανοίξουν. Τίποτα μέσα σε αυτό δεν γίνεται προσβάσιμο σε κανέναν λόγω του έργου· κάθε στοιχείο διατηρεί τη δική του πρόσβαση.',
    'Check the content for private information before sharing. Sharing an item does not grant access to its original chat or private connections.':
      'Ελέγξτε το περιεχόμενο για ιδιωτικές πληροφορίες πριν από την κοινή χρήση. Η κοινή χρήση ενός στοιχείου δεν παρέχει πρόσβαση στην αρχική συνομιλία ή στις ιδιωτικές συνδέσεις του.',
    '{value1} Everyone you share with can read it, including what the assistant or an App in it found in your {value2}. They can’t use your {value3}. Nothing changes for you: the chat keeps working with all your accounts.':
      '{value1} Όλοι όσοι έχουν πρόσβαση μπορούν να το διαβάσουν, συμπεριλαμβανομένων όσων βρήκε ο βοηθός ή μια App σε αυτό στο {value2}. Δεν μπορούν να χρησιμοποιήσουν το {value3} σας. Για εσάς δεν αλλάζει τίποτα: η συνομιλία συνεχίζει να λειτουργεί με όλους τους λογαριασμούς σας.',
    '{value1} Everyone you share with can read them, but nobody can use {value2} through this chat.':
      '{value1} Όλοι όσοι έχουν πρόσβαση μπορούν να τα διαβάσουν, αλλά κανείς δεν μπορεί να χρησιμοποιήσει το {value2} μέσω αυτής της συνομιλίας.',
    'This controls access to the working draft. Any published company version stays available until you explicitly unpublish it. To publish a new version, complete its preview and use Save Skill. Run results stay private.':
      'Αυτό ελέγχει την πρόσβαση στο προσχέδιο εργασίας. Κάθε δημοσιευμένη έκδοση της εταιρείας παραμένει διαθέσιμη μέχρι να αναιρέσετε ρητά τη δημοσίευσή της. Για να δημοσιεύσετε μια νέα έκδοση, ολοκληρώστε την προεπισκόπησή της και χρησιμοποιήστε την επιλογή Save Skill. Τα αποτελέσματα εκτέλεσης παραμένουν ιδιωτικά.',
    'Skill deleted. You can restore it from the Skills archive for 30 days.':
      'Το Skill διαγράφηκε. Μπορείτε να το επαναφέρετε από το αρχείο Skills για 30 ημέρες.',
    'Could not delete this Skill.': 'Δεν ήταν δυνατή η διαγραφή αυτού του Skill.',
    'More actions': 'Περισσότερες ενέργειες',
    'Delete “{value1}”? It will disappear from Skills and search, and cannot be used by agents. You can restore it for 30 days. Existing chats and results stay available.':
      'Διαγραφή του «{value1}»; Θα εξαφανιστεί από τα Skills και την αναζήτηση και δεν θα μπορεί να χρησιμοποιηθεί από agents. Μπορείτε να το επαναφέρετε για 30 ημέρες. Οι υπάρχουσες συνομιλίες και τα αποτελέσματα παραμένουν διαθέσιμα.',
    'Deleting…': 'Διαγραφή…',
    'Confirm delete': 'Επιβεβαίωση διαγραφής',
    'Delete Skill': 'Διαγραφή Skill',
    'Skill restored as an unpublished draft. Its author can review and publish it again.':
      'Το Skill επαναφέρθηκε ως μη δημοσιευμένο προσχέδιο. Ο συντάκτης του μπορεί να το ελέγξει και να το δημοσιεύσει ξανά.',
    'Could not restore this Skill.': 'Δεν ήταν δυνατή η επαναφορά αυτού του Skill.',
    'Archived Skills': 'Αρχειοθετημένα Skills',
    'Deleted Skills can be restored for 30 days. Restoring leaves them unpublished.':
      'Τα διαγραμμένα Skills μπορούν να επαναφερθούν για 30 ημέρες. Η επαναφορά τους τα αφήνει μη δημοσιευμένα.',
    'Restore until {value1}': 'Επαναφορά έως {value1}',
    'Loading…': 'Φόρτωση…',
    'No archived Skills.': 'Δεν υπάρχουν αρχειοθετημένα Skills.',
    'Load more archived Skills': 'Φόρτωση περισσότερων αρχειοθετημένων Skills',
    'Show more of the original': 'Εμφάνιση περισσότερου αρχικού περιεχομένου',
    'Filter result rows': 'Φιλτράρισμα γραμμών αποτελεσμάτων',
    'Find a product or value…': 'Βρείτε ένα προϊόν ή μια τιμή…',
    '{value1} of {value2}': '{value1} από {value2}',
    'Result table': 'Πίνακας αποτελεσμάτων',
    'No matching rows.': 'Δεν υπάρχουν αντίστοιχες γραμμές.',
    'Showing the first 1,000 matching rows. Download the CSV for every row.':
      'Εμφανίζονται οι πρώτες 1.000 αντίστοιχες γραμμές. Κατεβάστε το CSV για όλες τις γραμμές.',
    'Agent ·': 'Πράκτορας ·',
    'Only you': 'Μόνο εσείς',
    'Stopped before it finished.': 'Διακόπηκε πριν ολοκληρωθεί.',
    'Drafting the project…': 'Σύνταξη του έργου…',
    'Checking where this chat belongs…': 'Έλεγχος του πού ανήκει αυτή η συνομιλία…',
    'Moving the chat…': 'Μετακίνηση της συνομιλίας…',
    'Taking it out of the project…': 'Αφαίρεση από το έργο…',
    'Adding it to the project…': 'Προσθήκη στο έργο…',
    'No matching connections are available right now.':
      'Δεν υπάρχουν διαθέσιμες αντίστοιχες συνδέσεις αυτήν τη στιγμή.',
    'Company knowledge suggestion': 'Πρόταση εταιρικής γνώσης',
    'Company knowledge now lives on pages. Open Knowledge to see them.':
      'Η εταιρική γνώση βρίσκεται πλέον σε σελίδες. Ανοίξτε το Knowledge για να τις δείτε.',
    '{value1} · Open beside this conversation': '{value1} · Άνοιγμα δίπλα σε αυτήν τη συνομιλία',
    'Name {value1}': 'Όνομα {value1}',
    'Host {value1}': 'Κεντρικός υπολογιστής {value1}',
    'Port {value1}': 'Θύρα {value1}',
    'Database {value1}': 'Βάση δεδομένων {value1}',
    'Username {value1}': 'Όνομα χρήστη {value1}',
    'Password {value1}': 'Κωδικός πρόσβασης {value1}',
    'Advanced TLS': 'Προηγμένες ρυθμίσεις TLS',
    '{value1} Poneva verifies the server certificate. Add a CA or server DNS name for IP hosts when your certificate requires it.':
      '{value1} Η Poneva επαληθεύει το πιστοποιητικό του διακομιστή. Προσθέστε μια CA ή ένα όνομα DNS διακομιστή για κεντρικούς υπολογιστές IP, όταν το απαιτεί το πιστοποιητικό σας.',
    'CA certificate {value1}': 'Πιστοποιητικό CA {value1}',
    'Certificate server DNS name {value1}': 'Όνομα DNS διακομιστή πιστοποιητικού {value1}',
    '{value1} Your password is encrypted in secure storage. Poneva verifies the connection before saving it.':
      '{value1} Ο κωδικός πρόσβασής σας είναι κρυπτογραφημένος σε ασφαλή αποθήκευση. Η Poneva επαληθεύει τη σύνδεση πριν την αποθηκεύσει.',
    'Testing…': 'Δοκιμή…',
    'Test connection': 'Δοκιμή σύνδεσης',
    'PostgreSQL is connected.': 'Το PostgreSQL συνδέθηκε.',
    'PostgreSQL was saved safely.': 'Το PostgreSQL αποθηκεύτηκε με ασφάλεια.',
    'Poneva can read and change rows in the selected tables. Apps also follow their approved data scope.':
      'Η Poneva μπορεί να διαβάζει και να αλλάζει γραμμές στους επιλεγμένους πίνακες. Οι Apps ακολουθούν επίσης το εγκεκριμένο πεδίο δεδομένων τους.',
    'Poneva can read the selected tables. Apps also follow their approved data scope.':
      'Η Poneva μπορεί να διαβάζει τους επιλεγμένους πίνακες. Οι Apps ακολουθούν επίσης το εγκεκριμένο πεδίο δεδομένων τους.',
    'Reads are paused until permission is enabled.':
      'Οι αναγνώσεις έχουν暂停σει μέχρι να ενεργοποιηθεί η άδεια.',
    'Retrying…': 'Νέα προσπάθεια…',
    'Retry permission': 'Νέα προσπάθεια εξουσιοδότησης',
    'Try it in Chat': 'Δοκιμή στο Chat',
    Done: 'Ολοκληρώθηκε',
    'Disconnect database': 'Αποσύνδεση βάσης δεδομένων',
    '{value1} TLS verified ·{value2} {value3}': '{value1} Το TLS επαληθεύτηκε ·{value2} {value3}',
    'Search schemas and tables': 'Αναζήτηση σχημάτων και πινάκων',
    'Search tables': 'Αναζήτηση πινάκων',
    '{value1} of {value2} tables selected': 'Επιλέχθηκαν {value1} από {value2} πίνακες',
    'Select matching tables': 'Επιλογή αντίστοιχων πινάκων',
    'Select all tables': 'Επιλογή όλων των πινάκων',
    Clear: 'Εκκαθάριση',
    'Select a whole schema or individual tables. New tables need a fresh selection.':
      'Επιλέξτε ένα ολόκληρο σχήμα ή μεμονωμένους πίνακες. Για τους νέους πίνακες απαιτείται νέα επιλογή.',
    'No tables match this search.':
      'Δεν υπάρχουν πίνακες που να αντιστοιχούν σε αυτήν την αναζήτηση.',
    'All tables in {value1}': 'Όλοι οι πίνακες στο {value1}',
    '{value1} / {value2} tables': '{value1} / {value2} πίνακες',
    'Read & write available': 'Διαθέσιμη ανάγνωση και εγγραφή',
    'Read only': 'Μόνο ανάγνωση',
    Ctrl: 'Ctrl',
    'This suggested knowledge update could not be shown.':
      'Δεν ήταν δυνατή η εμφάνιση αυτής της προτεινόμενης ενημέρωσης γνώσης.',
    'Suggested knowledge update': 'Προτεινόμενη ενημέρωση γνώσης',
    'This suggestion is no longer available to you.':
      'Αυτή η πρόταση δεν είναι πλέον διαθέσιμη για εσάς.',
    'We could not check where this suggestion stands.':
      'Δεν ήταν δυνατός ο έλεγχος της κατάστασης αυτής της πρότασης.',
    'Check again': 'Έλεγχος ξανά',
    'Show on page': 'Εμφάνιση στη σελίδα',
    'The editor could not be loaded. Poneva may have been updated since you opened this page. Reload to get the latest version; nothing on this page has changed.':
      'Δεν ήταν δυνατή η φόρτωση του προγράμματος επεξεργασίας. Το Poneva μπορεί να έχει ενημερωθεί από τότε που ανοίξατε αυτή τη σελίδα. Κάντε επαναφόρτωση για να λάβετε την πιο πρόσφατη έκδοση· τίποτα σε αυτή τη σελίδα δεν έχει αλλάξει.',
    'Reload Poneva': 'Επαναφόρτωση του Poneva',
    Formatting: 'Μορφοποίηση',
    'Text style': 'Στυλ κειμένου',
    Text: 'Κείμενο',
    Heading: 'Επικεφαλίδα',
    Subheading: 'Υποεπικεφαλίδα',
    'Link a page': 'Σύνδεση σε σελίδα',
    'A page needs a title.': 'Η σελίδα χρειάζεται τίτλο.',
    'Nothing has changed yet.': 'Δεν έχει αλλάξει τίποτα ακόμη.',
    'A page needs some text. To remove a page, archive it instead.':
      'Η σελίδα χρειάζεται κείμενο. Για να καταργήσετε μια σελίδα, αρχειοθετήστε την.',
    'A suggested new page needs some text.': 'Μια προτεινόμενη νέα σελίδα χρειάζεται κείμενο.',
    'This page is larger than 256 KB. Split it into smaller pages.':
      'Αυτή η σελίδα είναι μεγαλύτερη από 256 KB. Χωρίστε την σε μικρότερες σελίδες.',
    'Say in a few words why this change is right.':
      'Εξηγήστε με λίγα λόγια γιατί αυτή η αλλαγή είναι σωστή.',
    'This page changed while you were editing. Your text is still here: copy it, then open the latest version and make your change again.':
      'Αυτή η σελίδα άλλαξε ενώ την επεξεργαζόσασταν. Το κείμενό σας είναι ακόμη εδώ: αντιγράψτε το, ανοίξτε την πιο πρόσφατη έκδοση και κάντε ξανά την αλλαγή σας.',
    'Your text is copied.': 'Το κείμενό σας αντιγράφηκε.',
    'Your text could not be copied. Select it in the editor and copy it.':
      'Δεν ήταν δυνατή η αντιγραφή του κειμένου σας. Επιλέξτε το στο πρόγραμμα επεξεργασίας και αντιγράψτε το.',
    'The page “{value1}” is created.': 'Η σελίδα «{value1}» δημιουργήθηκε.',
    'New page': 'Νέα σελίδα',
    'Editing {value1}': 'Επεξεργασία του {value1}',
    Editing: 'Επεξεργασία',
    'Creating publishes the page under {value1} for everyone':
      'Η δημιουργία δημοσιεύει τη σελίδα στην ενότητα {value1} για όλους',
    'Saving publishes the new version for everyone':
      'Η αποθήκευση δημοσιεύει τη νέα έκδοση για όλους',
    'Your changes are sent as a suggestion for a publisher':
      'Οι αλλαγές σας αποστέλλονται ως πρόταση σε έναν υπεύθυνο δημοσίευσης',
    'Create page': 'Δημιουργία σελίδας',
    Save: 'Αποθήκευση',
    'Send suggestion': 'Αποστολή πρότασης',
    '{value1} Copy my text': '{value1} Αντιγραφή του κειμένου μου',
    'Open the latest version': 'Άνοιγμα της πιο πρόσφατης έκδοσης',
    'Page title': 'Τίτλος σελίδας',
    'Loading the editor…': 'Φόρτωση του προγράμματος επεξεργασίας…',
    'New page text': 'Κείμενο νέας σελίδας',
    'Text of {value1}': 'Κείμενο του {value1}',
    'Write the page. Type [[ to link another page.':
      'Γράψτε τη σελίδα. Πληκτρολογήστε [[ για να συνδέσετε μια άλλη σελίδα.',
    'Type [[ to link another page.': 'Πληκτρολογήστε [[ για να συνδέσετε μια άλλη σελίδα.',
    'Link to a page': 'Σύνδεση σε σελίδα',
    'What changed, in a few words': 'Τι άλλαξε, με λίγα λόγια',
    'Where this comes from, in a few words': 'Από πού προέρχεται, με λίγα λόγια',
    'Shown in the page history.': 'Εμφανίζεται στο ιστορικό της σελίδας.',
    'A publisher sees this next to your change.':
      'Ένας υπεύθυνος δημοσίευσης το βλέπει δίπλα στην αλλαγή σας.',
    '1 suggestion is open on this page': '1 πρόταση είναι ανοιχτή σε αυτή τη σελίδα',
    '{value1} suggestions are open on this page':
      '{value1} προτάσεις είναι ανοιχτές σε αυτή τη σελίδα',
    'They stay open while you edit. After you save, they show against your new text; one whose words you changed is marked outdated.':
      'Παραμένουν ανοιχτές όσο επεξεργάζεστε. Μετά την αποθήκευση, εμφανίζονται σε αντιπαραβολή με το νέο σας κείμενο· όποια πρόταση αφορά λέξεις που αλλάξατε επισημαίνεται ως παρωχημένη.',
    'Type [[ to link another page. Links keep working when a page is renamed or moved.':
      'Πληκτρολογήστε [[ για να συνδέσετε μια άλλη σελίδα. Οι σύνδεσμοι συνεχίζουν να λειτουργούν όταν μια σελίδα μετονομάζεται ή μετακινείται.',
    'Loading the history…': 'Φόρτωση του ιστορικού…',
    'This page has no saved text yet.': 'Αυτή η σελίδα δεν έχει ακόμη αποθηκευμένο κείμενο.',
    'Say in a few words why this revision should come back.':
      'Εξηγήστε με λίγα λόγια γιατί θα πρέπει να επανέλθει αυτή η αναθεώρηση.',
    'Revision {value1} is suggested for a publisher to accept.':
      'Προτείνεται στον υπεύθυνο δημοσίευσης να αποδεχτεί την αναθεώρηση {value1}.',
    'The page already reads like this revision.':
      'Η σελίδα έχει ήδη το περιεχόμενο αυτής της αναθεώρησης.',
    'Revision {value1} is restored as revision {value2}.':
      'Η αναθεώρηση {value1} επαναφέρθηκε ως αναθεώρηση {value2}.',
    'Revision history': 'Ιστορικό αναθεωρήσεων',
    Revisions: 'Αναθεωρήσεις',
    'Every saved revision is kept.': 'Κάθε αποθηκευμένη αναθεώρηση διατηρείται.',
    'Revision {value1} {value2}': 'Αναθεώρηση {value1} {value2}',
    'Revision {value1} compared with revision {value2}':
      'Αναθεώρηση {value1} σε σύγκριση με την αναθεώρηση {value2}',
    'Revision {value1}, the first text of this page':
      'Αναθεώρηση {value1}, το πρώτο κείμενο αυτής της σελίδας',
    'Green was added, struck through was removed.':
      'Το πράσινο προστέθηκε, ενώ το διαγραμμένο αφαιρέθηκε.',
    '{value1} Export Markdown': '{value1} Εξαγωγή Markdown',
    'Restore this revision': 'Επαναφορά αυτής της αναθεώρησης',
    'Suggest restoring it': 'Πρόταση επαναφοράς',
    'Why should this revision come back?': 'Γιατί θα πρέπει να επανέλθει αυτή η αναθεώρηση;',
    'Loading this revision…': 'Φόρτωση αυτής της αναθεώρησης…',
    'Only the title changed, from “{value1}” to “{value2}”.':
      'Άλλαξε μόνο ο τίτλος, από «{value1}» σε «{value2}».',
    'The text did not change in this revision.': 'Το κείμενο δεν άλλαξε σε αυτή την αναθεώρηση.',
    'Changes in revision {value1}': 'Αλλαγές στην αναθεώρηση {value1}',
    'Loading page…': 'Φόρτωση σελίδας…',
    'Loading suggestion…': 'Φόρτωση πρότασης…',
    'This suggestion is not available.': 'Αυτή η πρόταση δεν είναι διαθέσιμη.',
    'It may have been decided, or it is not one you can see.':
      'Μπορεί να έχει ήδη διευθετηθεί ή να μην είναι ορατή σε εσάς.',
    'Open Knowledge': 'Άνοιγμα της Γνώσης',
    'Opening the suggestion…': 'Άνοιγμα της πρότασης…',
    'Choose where the page goes.': 'Επιλέξτε πού θα τοποθετηθεί η σελίδα.',
    'Say in a few words why.': 'Εξηγήστε με λίγα λόγια γιατί.',
    'Your suggestion is sent. A publisher decides.':
      'Η πρότασή σας στάλθηκε. Ένας υπεύθυνος δημοσίευσης θα αποφασίσει.',
    'Moved under {value1}.': 'Μετακινήθηκε κάτω από το {value1}.',
    'Deleted “{value1}”.': 'Το «{value1}» διαγράφηκε.',
    'Suggestion {value1} of {value2}': 'Πρόταση {value1} από {value2}',
    'Next suggestion': 'Επόμενη πρόταση',
    'Fold the suggestions away': 'Απόκρυψη προτάσεων',
    'Show the suggestions': 'Εμφάνιση προτάσεων',
    '1 suggestion': '1 πρόταση',
    '{value1} suggestions': '{value1} προτάσεις',
    '{value1} the pages under {value2}': '{value1} τις σελίδες κάτω από το {value2}',
    px: 'px',
    '{value1} chart of {value2} across {value3}':
      'Γράφημα {value1} του {value2} σε όλο το {value3}',
    'We could not build the file.': 'Δεν ήταν δυνατή η δημιουργία του αρχείου.',
    '{value1} Present': '{value1} Παρουσίαση',
    'Building…': 'Δημιουργία…',
    'Download PowerPoint': 'Λήψη PowerPoint',
    'Slide {value1} of {value2}': 'Διαφάνεια {value1} από {value2}',
    Slides: 'Διαφάνειες',
    'Slide {value1}': 'Διαφάνεια {value1}',
    'Speaker notes': 'Σημειώσεις ομιλητή',
    'Source: {value1}': 'Πηγή: {value1}',
    'Add a name and a web address.': 'Προσθέστε ένα όνομα και μια διεύθυνση ιστού.',
    'Enter a valid web address.': 'Εισαγάγετε μια έγκυρη διεύθυνση ιστού.',
    'Use a web address that starts with https://.':
      'Χρησιμοποιήστε μια διεύθυνση ιστού που ξεκινά με https://.',
    'Add a custom connection': 'Προσθήκη προσαρμοσμένης σύνδεσης',
    'Connect a tool server you trust. Poneva checks the address works and saves only the connection details needed to use it.':
      'Συνδέστε έναν διακομιστή εργαλείων που εμπιστεύεστε. Το Poneva ελέγχει ότι η διεύθυνση λειτουργεί και αποθηκεύει μόνο τα στοιχεία σύνδεσης που χρειάζονται για τη χρήση του.',
    'Web address': 'Διεύθυνση ιστού',
    'https://tools.example.com': 'https://tools.example.com',
    'Starts with https://, from your provider': 'Ξεκινά με https://, από τον πάροχό σας',
    'Sign-in': 'Σύνδεση',
    'Advanced sign-in': 'Σύνδεση για προχωρημένους',
    'Access key {value1}': 'Κλειδί πρόσβασης {value1}',
    'Request headers': 'Κεφαλίδες αιτήματος',
    'Add header': 'Προσθήκη κεφαλίδας',
    'Header {value1} name': 'Όνομα κεφαλίδας {value1}',
    'Header name': 'Όνομα κεφαλίδας',
    'Header {value1} value': 'Τιμή κεφαλίδας {value1}',
    'Header value': 'Τιμή κεφαλίδας',
    'Remove header': 'Αφαίρεση κεφαλίδας',
    Advanced: 'Για προχωρημένους',
    Transport: 'Μεταφορά',
    'Auto-detect': 'Αυτόματος εντοπισμός',
    'Streamable HTTP': 'HTTP με ροή',
    'Legacy SSE': 'Παλαιού τύπου SSE',
    "From your provider's app settings. Leave empty unless they gave you these.":
      'Από τις ρυθμίσεις εφαρμογής του παρόχου σας. Αφήστε τα κενά, εκτός αν σας τα έχει δώσει.',
    "Authorization server issuer": "Εκδότης διακομιστή εξουσιοδότησης",
    "Enter the authorization server issuer when using a client ID.": "Εισαγάγετε τον εκδότη του διακομιστή εξουσιοδότησης όταν χρησιμοποιείτε αναγνωριστικό πελάτη.",
    'Client ID {value1}': 'Αναγνωριστικό πελάτη {value1}',
    'Client secret {value1}': 'Μυστικό πελάτη {value1}',
    'Connecting…': 'Σύνδεση…',
    'Test and connect': 'Δοκιμή και σύνδεση',
    'Add the store, the client ID and the client secret.':
      'Προσθέστε το κατάστημα, το αναγνωριστικό πελάτη και το μυστικό πελάτη.',
    'Connect your Shopify Developer App': 'Συνδέστε την εφαρμογή προγραμματιστή Shopify',
    'Poneva can use exactly the access your store gave the app, and nothing more. It talks to Shopify directly and keeps the client secret encrypted.':
      'Το Poneva μπορεί να χρησιμοποιεί ακριβώς την πρόσβαση που παραχώρησε το κατάστημά σας στην εφαρμογή και τίποτα περισσότερο. Επικοινωνεί απευθείας με το Shopify και διατηρεί το μυστικό πελάτη κρυπτογραφημένο.',
    'How to create the app in Shopify': 'Πώς να δημιουργήσετε την εφαρμογή στο Shopify',
    'Open{value1} {value2}{value3} with the account that owns the store, and create an app.':
      'Ανοίξτε{value1} {value2}{value3} με τον λογαριασμό που έχει στην ιδιοκτησία του το κατάστημα και δημιουργήστε μια εφαρμογή.',
    'Create a version and select the access scopes Poneva may use, for example read_products and read_orders. Add write_ scopes only for data Poneva may change. Then release the version.':
      'Δημιουργήστε μια έκδοση και επιλέξτε τα πεδία πρόσβασης που μπορεί να χρησιμοποιεί το Poneva, για παράδειγμα read_products και read_orders. Προσθέστε πεδία write_ μόνο για δεδομένα που μπορεί να αλλάζει το Poneva. Στη συνέχεια, κυκλοφορήστε την έκδοση.',
    'For orders and customers, also select protected customer data in the app’s settings. Shopify allows this without review for an app made for your own store.':
      'Για παραγγελίες και πελάτες, επιλέξτε επίσης τα προστατευμένα δεδομένα πελατών στις ρυθμίσεις της εφαρμογής. Το Shopify το επιτρέπει χωρίς έλεγχο για μια εφαρμογή που έχει δημιουργηθεί για το δικό σας κατάστημα.',
    'Install the app on your store.': 'Εγκαταστήστε την εφαρμογή στο κατάστημά σας.',
    'Copy the client ID and client secret from the app’s settings.':
      'Αντιγράψτε το αναγνωριστικό πελάτη και το μυστικό πελάτη από τις ρυθμίσεις της εφαρμογής.',
    'To change the access later, release a new version, approve it on the store and use Test connection here.':
      'Για να αλλάξετε την πρόσβαση αργότερα, κυκλοφορήστε μια νέα έκδοση, εγκρίνετέ την στο κατάστημα και χρησιμοποιήστε εδώ τη «Δοκιμή και σύνδεση».',
    Store: 'Κατάστημα',
    'your-store.myshopify.com': 'your-store.myshopify.com',
    'Your store’s .myshopify.com address (Shopify admin → Settings → Domains), or paste the address of your Shopify admin page':
      'Η διεύθυνση .myshopify.com του καταστήματός σας (διαχειριστής Shopify → Settings → Domains) ή επικολλήστε τη διεύθυνση της σελίδας διαχειριστή Shopify',
    'Client ID {value1} {value2}': 'Αναγνωριστικό πελάτη {value1} {value2}',
    'Client secret {value1} {value2}': 'Μυστικό πελάτη {value1} {value2}',
    Person: 'Άτομο',
    Everyone: 'Όλοι',
    Connection: 'Σύνδεση',
    'All connections': 'Όλες οι συνδέσεις',
    'App {value1}': 'Εφαρμογή {value1}',
    'From {value1}': 'Από {value1}',
    'Until {value1}': 'Έως {value1}',
    Result: 'Αποτέλεσμα',
    'All results': 'Όλα τα αποτελέσματα',
    Succeeded: 'Επιτυχής',
    Denied: 'Απορρίφθηκε',
    Failed: 'Απέτυχε',
    Unknown: 'Άγνωστο',
    Filter: 'Φίλτρο',
    'Loading activity…': 'Φόρτωση δραστηριότητας…',
    'Could not load activity. Try again.':
      'Δεν ήταν δυνατή η φόρτωση της δραστηριότητας. Δοκιμάστε ξανά.',
    'Removed connection': 'Η σύνδεση καταργήθηκε',
    'App: {value1}': 'Εφαρμογή: {value1}',
    'Older activity': 'Παλαιότερη δραστηριότητα',
    'Archived. Its history is kept.': 'Αρχειοθετήθηκε. Το ιστορικό του διατηρείται.',
    'Choose the page it goes under. Links to it keep working.':
      'Επιλέξτε τη σελίδα κάτω από την οποία θα τοποθετηθεί. Οι σύνδεσμοι προς αυτήν θα συνεχίσουν να λειτουργούν.',
    'Its text, its history and any open suggestions are removed for good, and links to it from other pages stop working. This cannot be undone.':
      'Το κείμενο, το ιστορικό και τυχόν ανοιχτές προτάσεις του διαγράφονται οριστικά, ενώ οι σύνδεσμοι προς αυτό από άλλες σελίδες παύουν να λειτουργούν. Αυτή η ενέργεια δεν αναιρείται.',
    'An archived page no longer informs answers. Its history is kept, and a publisher can restore it or delete it permanently.':
      'Μια αρχειοθετημένη σελίδα δεν χρησιμοποιείται πλέον για τη διαμόρφωση απαντήσεων. Το ιστορικό της διατηρείται και ένας εκδότης μπορεί να την επαναφέρει ή να τη διαγράψει οριστικά.',
    Under: 'Κάτω από',
    Change: 'Αλλαγή',
    'Move under': 'Μετακίνηση κάτω από',
    'Search pages': 'Αναζήτηση σελίδων',
    'Why?': 'Γιατί;',
    'Delete permanently': 'Οριστική διαγραφή',
    'Move page': 'Μετακίνηση σελίδας',
    'Archive page': 'Αρχειοθέτηση σελίδας',
    'Suggestion {value1}: show its card': 'Πρόταση {value1}: εμφάνιση της κάρτας της',
    'Removed:': 'Αφαιρέθηκε:',
    'Added:': 'Προστέθηκε:',
    'New page “{value1}”{value2}': 'Νέα σελίδα «{value1}»{value2}',
    'No pages match “{value1}”.': 'Δεν βρέθηκαν σελίδες που να ταιριάζουν με «{value1}».',
    'Where this page is': 'Πού βρίσκεται αυτή η σελίδα',
    'Describe your company': 'Περιγράψτε την εταιρεία σας',
    'Empty page': 'Κενή σελίδα',
    'Describe {value1}': 'Περιγράψτε το {value1}',
    'This page has no text yet.': 'Αυτή η σελίδα δεν έχει ακόμη κείμενο.',
    'Poneva reads this page before every answer. Start with who you are, what you sell and how you work; details go on the pages under it.':
      'Η Poneva διαβάζει αυτή τη σελίδα πριν από κάθε απάντηση. Ξεκινήστε με το ποιοι είστε, τι πουλάτε και πώς εργάζεστε· οι λεπτομέρειες μπαίνουν στις σελίδες κάτω από αυτήν.',
    'Write it, or ask Poneva in chat to draft it for you.':
      'Γράψτε το ή ζητήστε από την Poneva στη συνομιλία να το συντάξει για εσάς.',
    'Suggest a first version, and a publisher decides whether it becomes the page.':
      'Προτείνετε μια πρώτη έκδοση και ένας εκδότης αποφασίζει αν θα γίνει η σελίδα.',
    'Start writing': 'Ξεκινήστε να γράφετε',
    'Suggest a first version': 'Προτείνετε μια πρώτη έκδοση',
    'Accepted. The page is archived.': 'Εγκρίθηκε. Η σελίδα αρχειοθετήθηκε.',
    'Accepted. The page is now revision {value1}.':
      'Εγκρίθηκε. Η σελίδα είναι πλέον στην αναθεώρηση {value1}.',
    'Accepted.': 'Εγκρίθηκε.',
    'Suggestion rejected. The page stays as it is.':
      'Η πρόταση απορρίφθηκε. Η σελίδα παραμένει ως έχει.',
    'Your suggestion is withdrawn.': 'Η πρότασή σας αποσύρθηκε.',
    'Restored. The page informs answers again.':
      'Επαναφέρθηκε. Η σελίδα χρησιμοποιείται ξανά για τη διαμόρφωση απαντήσεων.',
    'Your suggestion is sent. A publisher decides whether it becomes the page.':
      'Η πρότασή σας στάλθηκε. Ένας εκδότης αποφασίζει αν θα γίνει η σελίδα.',
    'Saved. The page is now revision {value1}.':
      'Αποθηκεύτηκε. Η σελίδα είναι πλέον στην αναθεώρηση {value1}.',
    'Nothing changed.': 'Δεν άλλαξε τίποτα.',
    'This page is not available.': 'Αυτή η σελίδα δεν είναι διαθέσιμη.',
    'It may have been deleted, archived or moved out of reach, or you may no longer be in this company.':
      'Μπορεί να έχει διαγραφεί, αρχειοθετηθεί ή μετακινηθεί εκτός πρόσβασης ή μπορεί να μην ανήκετε πλέον σε αυτή την εταιρεία.',
    'Page actions': 'Ενέργειες σελίδας',
    shown: 'εμφανίζονται',
    hidden: 'είναι κρυφές',
    '{value1} History': 'Ιστορικό {value1}',
    '{value1} Ask in chat': '{value1} Ρωτήστε στη συνομιλία',
    'Suggest edits': 'Προτείνετε αλλαγές',
    'More actions for {value1}': 'Περισσότερες ενέργειες για {value1}',
    '{value1} Poneva reads this page in every chat':
      '{value1} Η Poneva διαβάζει αυτή τη σελίδα σε κάθε συνομιλία',
    'This page is archived. It no longer informs answers; its history is kept. {value1}':
      'Αυτή η σελίδα είναι αρχειοθετημένη. Δεν χρησιμοποιείται πλέον για τη διαμόρφωση απαντήσεων· το ιστορικό της διατηρείται. {value1}',
    'Restore page': 'Επαναφορά σελίδας',
    'This link points to an earlier revision. You are reading the current text.':
      'Αυτός ο σύνδεσμος οδηγεί σε παλαιότερη αναθεώρηση. Διαβάζετε το τρέχον κείμενο.',
    'Show it in History': 'Εμφάνιση στο Ιστορικό',
    Pages: 'Σελίδες',
    'Pages under {value1}': 'Σελίδες κάτω από {value1}',
    'Linked from': 'Σύνδεση από',
    Suggestions: 'Προτάσεις',
    'Suggestions are hidden. You are reading the page as everyone else sees it.':
      'Οι προτάσεις είναι κρυφές. Διαβάζετε τη σελίδα όπως τη βλέπουν όλοι οι άλλοι.',
    'Loading suggestions…': 'Φόρτωση προτάσεων…',
    'Nothing is waiting for review.': 'Δεν υπάρχει κάτι σε αναμονή για έλεγχο.',
    'When someone, Poneva in a chat or a connected agent suggests a change to a page, it shows here and on the page. Nothing changes until a publisher accepts it.':
      'Όταν κάποιος, η Poneva σε μια συνομιλία ή ένας συνδεδεμένος agent προτείνει αλλαγή σε μια σελίδα, αυτή εμφανίζεται εδώ και στη σελίδα. Τίποτα δεν αλλάζει μέχρι να την εγκρίνει ένας εκδότης.',
    '{value1} Review knowledge in chat': '{value1} Ελέγξτε τις γνώσεις στη συνομιλία',
    'Suggestions for review': 'Προτάσεις για έλεγχο',
    'Suggested changes from chats, meetings, colleagues and connected agents. Nothing changes until a publisher accepts it on the page.':
      'Προτεινόμενες αλλαγές από συνομιλίες, συσκέψεις, συναδέλφους και συνδεδεμένους agents. Τίποτα δεν αλλάζει μέχρι να τις εγκρίνει ένας εκδότης στη σελίδα.',
    'Your suggestions wait here until a publisher decides. The pages stay as they are until then.':
      'Οι προτάσεις σας παραμένουν εδώ μέχρι να αποφασίσει ένας εκδότης. Μέχρι τότε, οι σελίδες παραμένουν ως έχουν.',
    'Review page': 'Έλεγχος σελίδας',
    'Review on page': 'Έλεγχος στη σελίδα',
    'Open the meeting': 'Άνοιγμα σύσκεψης',
    'Open the chat': 'Άνοιγμα συνομιλίας',
    'Accept and restore': 'Αποδοχή και επαναφορά',
    Accept: 'Αποδοχή',
    Reject: 'Απόρριψη',
    'Your suggestion · waiting for a publisher': 'Η πρότασή σας · σε αναμονή εκδότη',
    Withdraw: 'Απόσυρση',
    'Waiting for a publisher': 'Σε αναμονή εκδότη',
    'Suggestion {value1}': 'Πρόταση {value1}',
    'Suggestion {value1} from {value2}{value3}': 'Πρόταση {value1} από {value2}{value3}',
    'Read the suggested page': 'Ανάγνωση της προτεινόμενης σελίδας',
    'Outdated: the text it changes was edited after it was suggested. It can be rejected or withdrawn; a new suggestion can be made against the current text.':
      'Παρωχημένη: το κείμενο που αλλάζει επεξεργάστηκε μετά την υποβολή της πρότασης. Μπορεί να απορριφθεί ή να αποσυρθεί· μπορεί να υποβληθεί νέα πρόταση για το τρέχον κείμενο.',
    'Restore this page first to accept this suggestion.':
      'Επαναφέρετε πρώτα αυτή τη σελίδα για να αποδεχτείτε την πρόταση.',
    'Previous suggestion': 'Προηγούμενη πρόταση',
    Download: 'Λήψη',
    CSV: 'CSV',
    'Evidence for {value1}': 'Τεκμήρια για {value1}',
    Measure: 'Μέτρο',
    'Show rows →': 'Εμφάνιση γραμμών →',
    'Ask about this number': 'Ρωτήστε για αυτόν τον αριθμό',
    'There are no numeric values available to chart. View the table for the original data.':
      'Δεν υπάρχουν διαθέσιμες αριθμητικές τιμές για το γράφημα. Δείτε τον πίνακα για τα αρχικά δεδομένα.',
    'Chart value': 'Τιμή γραφήματος',
    '{value1} of {value2} shown': 'Εμφανίζονται {value1} από {value2}',
    '{value1} by {value2}; {value3} rows. View Table for exact values.':
      '{value1} επί {value2}· {value3} γραμμές. Δείτε τον Πίνακα για ακριβείς τιμές.',
    'Values come directly from the source data. Missing values are not estimates.':
      'Οι τιμές προέρχονται απευθείας από τα δεδομένα προέλευσης. Οι τιμές που λείπουν δεν είναι εκτιμήσεις.',
    'Loading library…': 'Φόρτωση βιβλιοθήκης…',
    'We couldn’t load what happened in this App. Try again in a moment.':
      'Δεν ήταν δυνατή η φόρτωση του ιστορικού σε αυτήν την εφαρμογή. Δοκιμάστε ξανά σε λίγο.',
    'This App could not be opened.': 'Δεν ήταν δυνατό το άνοιγμα αυτής της εφαρμογής.',
    'Opening App…': 'Άνοιγμα εφαρμογής…',
    'Open the saved App to run this function.':
      'Ανοίξτε την αποθηκευμένη εφαρμογή για να εκτελέσετε αυτήν τη λειτουργία.',
    'Save this App before running its function.':
      'Αποθηκεύστε αυτήν την εφαρμογή πριν εκτελέσετε τη λειτουργία της.',
    'Open saved App': 'Άνοιγμα αποθηκευμένης εφαρμογής',
    'Open Apps': 'Άνοιγμα εφαρμογών',
    'The App could not be opened. Try again.':
      'Δεν ήταν δυνατό το άνοιγμα της εφαρμογής. Δοκιμάστε ξανά.',
    Owner: 'Κάτοχος',
    '{value1} · admins': '{value1} · διαχειριστές',
    'Owner · always edits': 'Κάτοχος · επεξεργάζεται πάντα',
    'Admins manage it': 'Οι διαχειριστές τη διαχειρίζονται',
    Editors: 'Συντάκτες',
    'A colleague': 'Ένας συνάδελφος',
    'Can edit drafts and publish versions':
      'Μπορεί να επεξεργάζεται προσχέδια και να δημοσιεύει εκδόσεις',
    Remove: 'Αφαίρεση',
    'No editors yet.': 'Δεν υπάρχουν ακόμη συντάκτες.',
    'Admins can always edit company agents.':
      'Οι διαχειριστές μπορούν πάντα να επεξεργάζονται τους εταιρικούς πράκτορες.',
    'Asking for edit access': 'Αίτημα πρόσβασης για επεξεργασία',
    'Asked {value1} · also in your Inbox': 'Ζητήθηκε {value1} · βρίσκεται και στα Εισερχόμενά σας',
    Grant: 'Παραχώρηση',
    Admin: 'Διαχειριστής',
    'Make personal': 'Μετατροπή σε προσωπικό',
    'Switch off': 'Απενεργοποίηση',
    Archive: 'Αρχειοθέτηση',
    'Archive this agent': 'Αρχειοθέτηση αυτού του πράκτορα',
    'Loading agent…': 'Φόρτωση πράκτορα…',
    '{value1} Edit in chat': '{value1} Επεξεργασία στη συνομιλία',
    Agent: 'Πράκτορας',
    'This agent has not been created yet. It can run once its owner creates it.':
      'Αυτός ο πράκτορας δεν έχει δημιουργηθεί ακόμη. Μπορεί να εκτελεστεί μόλις τον δημιουργήσει ο κάτοχός του.',
    'New agent · Draft': 'Νέος πράκτορας · Προσχέδιο',
    'Untitled agent': 'Πράκτορας χωρίς τίτλο',
    'Test run': 'Δοκιμαστική εκτέλεση',
    'This draft does not run automatically.': 'Αυτό το προσχέδιο δεν εκτελείται αυτόματα.',
    'Describe the agent in the chat. Its draft appears here.':
      'Περιγράψτε τον πράκτορα στη συνομιλία. Το προσχέδιό του θα εμφανιστεί εδώ.',
    '{value1} Test run': '{value1} Δοκιμαστική εκτέλεση',
    'Describe the agent in the chat first.': 'Περιγράψτε πρώτα τον πράκτορα στη συνομιλία.',
    'Create and turn on': 'Δημιουργία και ενεργοποίηση',
    'Connection write setup': 'Ρύθμιση εγγραφής σύνδεσης',
    'Account for connected changes': 'Λογαριασμός για συνδεδεμένες αλλαγές',
    'Choose a connection': 'Επιλέξτε μια σύνδεση',
    'No published Skills available. You can add them later.':
      'Δεν υπάρχουν διαθέσιμες δημοσιευμένες Δεξιότητες. Μπορείτε να τις προσθέσετε αργότερα.',
    '{value1} · not published. Review the changes. Testing is optional.':
      '{value1} · δεν έχει δημοσιευτεί. Ελέγξτε τις αλλαγές. Η δοκιμή είναι προαιρετική.',
    '{value1} Test draft': '{value1} Δοκιμή προσχεδίου',
    'Apply changes…': 'Εφαρμογή αλλαγών…',
    'Apply this draft as a new version': 'Εφαρμογή αυτού του προσχεδίου ως νέας έκδοσης',
    'This draft cannot be applied.': 'Δεν είναι δυνατή η εφαρμογή αυτού του προσχεδίου.',
    'What changed?': 'Τι άλλαξε;',
    'Apply version {value1}': 'Εφαρμογή έκδοσης {value1}',
    Create: 'Δημιουργία',
    'Edit access requested': 'Ζητήθηκε πρόσβαση για επεξεργασία',
    '{value1} Request edit access': '{value1} Αίτημα πρόσβασης για επεξεργασία',
    '{value1} Copy agent': '{value1} Αντιγραφή πράκτορα',
    Pause: 'Παύση',
    'Open agent: {value1}': 'Άνοιγμα πράκτορα: {value1}',
    '· you can edit': '· μπορείτε να επεξεργαστείτε',
    '{value1} is switched off.': 'Ο/Η {value1} είναι απενεργοποιημένος/-η.',
    '{value1} is archived.': 'Ο/Η {value1} έχει αρχειοθετηθεί.',
    'Loading agents…': 'Φόρτωση πρακτόρων…',
    Agents: 'Πράκτορες',
    'Agents do work for you on a schedule or when you ask. They follow your company’s Skills.':
      'Οι πράκτορες εργάζονται για εσάς βάσει προγράμματος ή όταν τους το ζητάτε. Ακολουθούν τις Δεξιότητες της εταιρείας σας.',
    'No agent matches. Try a Skill name or what the agent should do.':
      'Δεν βρέθηκε πράκτορας. Δοκιμάστε το όνομα μιας Δεξιότητας ή περιγράψτε τι πρέπει να κάνει ο πράκτορας.',
    'Nothing of your own yet': 'Δεν έχετε δημιουργήσει ακόμη κάτι δικό σας',
    'Tell Chat what an agent should do, or copy one of the company’s agents below.{value1}':
      'Πείτε στο Chat τι πρέπει να κάνει ένας πράκτορας ή αντιγράψτε παρακάτω έναν από τους εταιρικούς πράκτορες.{value1}',
    'Your agents': 'Οι πράκτορές σας',
    'Run on demand': 'Εκτέλεση κατ’ απαίτηση',
    'Run is always available. A schedule is optional and lives separately from the agent’s instructions.':
      'Η εκτέλεση είναι πάντα διαθέσιμη. Το πρόγραμμα είναι προαιρετικό και ορίζεται ξεχωριστά από τις οδηγίες του πράκτορα.',
    'What changed in version {value1}': 'Τι άλλαξε στην έκδοση {value1}',
    'Every publish is a version you can restore.':
      'Κάθε δημοσίευση είναι μια έκδοση που μπορείτε να επαναφέρετε.',
    Authorization: 'Εξουσιοδότηση',
    '{value1} {value2} · {value3} will see it.': '{value1} {value2} · {value3} θα το βλέπουν.',
    '{value1} {value2} you': '{value1} {value2} εσένα',
    '· Revised': '· Αναθεωρήθηκε',
    'This chat used your {value1}.': 'Αυτή η συνομιλία χρησιμοποίησε το {value1} σας.',
    'This chat has results from {value1}.':
      'Αυτή η συνομιλία περιέχει αποτελέσματα από το {value1}.',
    'db.example.com': 'db.example.com',
    'e.g. Product analytics': 'π.χ. Αναλύσεις προϊόντος',
    'Paste access key': 'Επικολλήστε το κλειδί πρόσβασης',
    'Shopify’s Dev Dashboard': 'Shopify’s Dev Dashboard',
    'App reference': 'Αναφορά εφαρμογής',
    'Draft · revision {value1}': 'Πρόχειρο · αναθεώρηση {value1}',
    'its Result': 'το αποτέλεσμά του',
    '· its first run makes it': '· η πρώτη εκτέλεσή του το κάνει',
    '{value1}’s chat ·': 'Η συνομιλία του {value1} ·',
    '{value1} ad {value2} available.': 'Τα {value1} και {value2} είναι διαθέσιμα.',
    '{value1} rows ·': '{value1} σειρές ·',
    'It starts private. Sharing it wider shares every refresh, which can carry your private data.':
      'Ξεκινά ως ιδιωτικό. Η ευρύτερη κοινοποίησή του κοινοποιεί κάθε ανανέωση, η οποία μπορεί να περιέχει τα ιδιωτικά σας δεδομένα.',
    'Enable this schedule when approved': 'Ενεργοποίηση αυτού του προγράμματος μετά την έγκριση',
    Schedule: 'Πρόγραμμα',
    'Kept off until you create the agent from its canvas.':
      'Παραμένει απενεργοποιημένο μέχρι να δημιουργήσετε τον πράκτορα από τον καμβά του.',
    'Will be enabled when you approve.': 'Θα ενεργοποιηθεί όταν το εγκρίνετε.',
    'Will be saved paused. You can enable it later.':
      'Θα αποθηκευτεί σε παύση. Μπορείτε να το ενεργοποιήσετε αργότερα.',
    'Only runs when you ask.': 'Εκτελείται μόνο όταν το ζητάτε.',
    'Draft · approving saves it, and nothing runs. Test it and create it from its canvas.':
      'Πρόχειρο · η έγκριση το αποθηκεύει και δεν εκτελείται τίποτα. Δοκιμάστε το και δημιουργήστε το από τον καμβά του.',
    'Draft · nothing is scheduled until you approve. Connected actions require their own approval at run time.':
      'Πρόχειρο · δεν προγραμματίζεται τίποτα μέχρι να το εγκρίνετε. Οι συνδεδεμένες ενέργειες απαιτούν ξεχωριστή έγκριση κατά την εκτέλεση.',
    Name: 'Όνομα',
    'Agent name': 'Όνομα πράκτορα',
    'Who can use it': 'Ποιος μπορεί να το χρησιμοποιεί',
    'Company agent · company resources only': 'Εταιρικός πράκτορας · μόνο εταιρικοί πόροι',
    'Personal agent · runs with your access':
      'Προσωπικός πράκτορας · εκτελείται με τη δική σας πρόσβαση',
    'Approving saves it as a draft. It does not run automatically.':
      'Η έγκριση το αποθηκεύει ως πρόχειρο. Δεν εκτελείται αυτόματα.',
    'Open the agent’s runs': 'Άνοιγμα των εκτελέσεων του πράκτορα',
    'Run the published version once': 'Εκτέλεση της δημοσιευμένης έκδοσης μία φορά',
    'Stopping…': 'Διακοπή…',
    'Stop run': 'Διακοπή εκτέλεσης',
    'Could not stop this run. Please try again.':
      'Δεν ήταν δυνατή η διακοπή αυτής της εκτέλεσης. Δοκιμάστε ξανά.',
    'Run in progress': 'Η εκτέλεση βρίσκεται σε εξέλιξη',
    'This run is still answering. You can ask follow-ups when it finishes.':
      'Αυτή η εκτέλεση εξακολουθεί να απαντά. Μπορείτε να κάνετε συμπληρωματικές ερωτήσεις όταν ολοκληρωθεί.',
    'Open run details': 'Άνοιγμα λεπτομερειών εκτέλεσης',
    Runs: 'Εκτελέσεις',
    'Open the run chat': 'Άνοιγμα της συνομιλίας εκτέλεσης',
    Watch: 'Παρακολούθηση',
    Goal: 'Στόχος',
    'Change the goal': 'Αλλαγή στόχου',
    'What it does': 'Τι κάνει',
    'What should this agent achieve?': 'Τι πρέπει να επιτύχει αυτός ο πράκτορας;',
    'Not set yet.': 'Δεν έχει οριστεί ακόμη.',
    'When it runs': 'Πότε εκτελείται',
    'Change when it runs': 'Αλλαγή χρόνου εκτέλεσης',
    'Off means it runs only when someone runs it. Changing when it runs never changes its instructions.':
      'Η απενεργοποίηση σημαίνει ότι εκτελείται μόνο όταν κάποιος το εκτελεί. Η αλλαγή του χρόνου εκτέλεσης δεν αλλάζει ποτέ τις οδηγίες του.',
    Instructions: 'Οδηγίες',
    'Change the instructions': 'Αλλαγή οδηγιών',
    'How the agent should approach the work and make decisions.':
      'Πώς πρέπει ο πράκτορας να προσεγγίζει την εργασία και να λαμβάνει αποφάσεις.',
    Boundaries: 'Όρια',
    'What to do or avoid. Every connected action still follows its approval.':
      'Τι να κάνει ή να αποφεύγει. Κάθε συνδεδεμένη ενέργεια εξακολουθεί να απαιτεί την έγκρισή της.',
    'No instructions of its own. It follows its Skills.':
      'Δεν έχει δικές του οδηγίες. Ακολουθεί τις Δεξιότητές του.',
    'Pin a Skill': 'Καρφίτσωμα Δεξιότητας',
    'Finds the Skills that fit each run, the same way a chat does.':
      'Εντοπίζει τις Δεξιότητες που ταιριάζουν σε κάθε εκτέλεση, όπως κάνει μια συνομιλία.',
    'Skills it always follows': 'Δεξιότητες που ακολουθεί πάντα',
    'A Skill that is not published': 'Μια Δεξιότητα που δεν έχει δημοσιευτεί',
    'Always follows · Version {value1}': 'Ακολουθεί πάντα · Έκδοση {value1}',
    'Not published': 'Δεν έχει δημοσιευτεί',
    Uses: 'Χρησιμοποιεί',
    'Change in chat': 'Αλλαγή στη συνομιλία',
    'Change in chat: Uses': 'Αλλαγή στη συνομιλία: Χρησιμοποιεί',
    'Company knowledge and the tools each run is allowed to use.':
      'Εταιρική γνώση και εργαλεία που επιτρέπεται να χρησιμοποιεί κάθε εκτέλεση.',
    'People see the Result refresh; they change the agent, not the page.':
      'Οι χρήστες βλέπουν την ανανέωση του Αποτελέσματος· αλλάζουν τον πράκτορα, όχι τη σελίδα.',
    'The first run after it is created makes the Result; later runs add a version to it.':
      'Η πρώτη εκτέλεση μετά τη δημιουργία του δημιουργεί το Αποτέλεσμα· οι επόμενες εκτελέσεις προσθέτουν μια έκδοση σε αυτό.',
    'Emails whoever the run is for': 'Στέλνει email στο άτομο για το οποίο προορίζεται η εκτέλεση',
    'Email each run': 'Αποστολή email για κάθε εκτέλεση',
    Delivers: 'Παραδίδει',
    'Change what it delivers': 'Αλλαγή του περιεχομένου που παραδίδει',
    'Expected result': 'Αναμενόμενο αποτέλεσμα',
    'What a successful run should deliver.': 'Τι πρέπει να παραδίδει μια επιτυχημένη εκτέλεση.',
    'What each run delivers': 'Τι παραδίδει κάθε εκτέλεση',
    'Keeps one Result up to date {value1}': 'Διατηρεί ένα Αποτέλεσμα ενημερωμένο {value1}',
    'Saves a new Result each run': 'Αποθηκεύει ένα νέο Αποτέλεσμα σε κάθε εκτέλεση',
    'You can run this company agent as yourself.{value1} {value2}':
      'Μπορείτε να εκτελέσετε αυτόν τον εταιρικό πράκτορα ως εσείς.{value1} {value2}',
    'Changes since version': 'Αλλαγές από την έκδοση',
    'are not live yet.': 'δεν έχουν ενεργοποιηθεί ακόμη.',
    'Review them in Versions': 'Ελέγξτε τις στην ενότητα Εκδόσεις',
    Skill: 'Δεξιότητα',
    'The agent always uses the Skill’s published version.':
      'Ο πράκτορας χρησιμοποιεί πάντα τη δημοσιευμένη έκδοση της Δεξιότητας.',
    Day: 'Ημέρα',
    Time: 'Ώρα',
    'Cron expression': 'Έκφραση Cron',
    'Editors and access': 'Συντάκτες και πρόσβαση',
    Company: 'Εταιρικό',
    Personal: 'Προσωπικό',
    'No changes.': 'Δεν υπάρχουν αλλαγές.',
    'Instructions changes': 'Αλλαγές οδηγιών',
    'Loading versions…': 'Φόρτωση εκδόσεων…',
    'What the draft changes': 'Τι αλλάζει το πρόχειρο',
    'No published version yet. Try the draft, then publish it.':
      'Δεν υπάρχει ακόμη δημοσιευμένη έκδοση. Δοκιμάστε το πρόχειρο και, στη συνέχεια, δημοσιεύστε το.',
    'Published versions': 'Δημοσιευμένες εκδόσεις',
    'Former member': 'Πρώην μέλος',
    Live: 'Ενεργό',
    '{value1} for {value2}': '{value1} για {value2}',
    Suggested: 'Προτεινόμενο',
    'Opening your conversation…': 'Άνοιγμα της συνομιλίας σας…',
    'This conversation isn’t available': 'Αυτή η συνομιλία δεν είναι διαθέσιμη',
    'It may have been deleted, belong to another account, or be temporarily unavailable.':
      'Μπορεί να έχει διαγραφεί, να ανήκει σε άλλον λογαριασμό ή να μην είναι προσωρινά διαθέσιμη.',
    '{count} more line — shown in the complete revision':
      '{count} ακόμη γραμμή — εμφανίζεται στην πλήρη αναθεώρηση',
    '{count} more lines — shown in the complete revision':
      '{count} ακόμη γραμμές — εμφανίζονται στην πλήρη αναθεώρηση',
    '{count} more line removed': 'Αφαιρέθηκε {count} ακόμη γραμμή',
    '{count} more lines removed': 'Αφαιρέθηκαν {count} ακόμη γραμμές',
    '{count} unchanged line': '{count} γραμμή χωρίς αλλαγές',
    '{count} unchanged lines': '{count} γραμμές χωρίς αλλαγές',
    '{count} more lines not shown, {added} added and {removed} removed. Check them in the complete revision.':
      'Δεν εμφανίζονται {count} ακόμη γραμμές: προστέθηκαν {added} και αφαιρέθηκαν {removed}. Ελέγξτε τις στην πλήρη αναθεώρηση.',
    'Saved result': 'Αποθηκευμένο αποτέλεσμα',
    'Made with a Skill': 'Δημιουργήθηκε με μια Δεξιότητα',
    'Preview of {name}': 'Προεπισκόπηση του {name}',
    'Made with {name}': 'Δημιουργήθηκε με το {name}',
    'Ad-hoc result': 'Έκτακτο αποτέλεσμα',
    'A Skill that is not available in this workspace':
      'Μια Δεξιότητα που δεν είναι διαθέσιμη σε αυτόν τον χώρο εργασίας',
    '{name} · Revision {version}': '{name} · Αναθεώρηση {version}',
    '{name} · Version {version}': '{name} · Έκδοση {version}',
    'Return to conversation {value1}': 'Επιστροφή στη συνομιλία {value1}',
    '{value1} Working with {value2}': '{value1} Εργάζεται με το {value2}',
    'View context {value1}': 'Προβολή πλαισίου {value1}',
    'A way of working, made yours.': 'Ένας τρόπος εργασίας, στα μέτρα σας.',
    'Work that runs itself.': 'Εργασία που εκτελείται αυτόματα.',
    'One place for one piece of work.': 'Ένα μέρος για κάθε εργασία.',
    'Let’s move your work forward{value1}.': 'Ας προχωρήσουμε την εργασία σας{value1}.',
    'Describe the work. Your Skill takes shape beside the conversation.':
      'Περιγράψτε την εργασία. Η Δεξιότητά σας διαμορφώνεται δίπλα στη συνομιλία.',
    'Describe what it should do and when. Your agent takes shape beside the conversation. The draft does not run automatically.':
      'Περιγράψτε τι πρέπει να κάνει και πότε. Ο πράκτοράς σας διαμορφώνεται δίπλα στη συνομιλία. Το προσχέδιο δεν εκτελείται αυτόματα.',
    'Say what the work is. Poneva drafts the project beside the conversation and brings in what you have already done. Nothing is created until you say so.':
      'Πείτε ποια είναι η εργασία. Η Poneva δημιουργεί το προσχέδιο του έργου δίπλα στη συνομιλία και προσθέτει όσα έχετε ήδη κάνει. Δεν δημιουργείται τίποτα μέχρι να το ζητήσετε.',
    'Start with an idea below. Poneva will take it from there.':
      'Ξεκινήστε με μια ιδέα παρακάτω. Η Poneva θα αναλάβει τα υπόλοιπα.',
    Triggers: 'Εναύσματα',
    'Review the agent and its trigger. Approval applies exactly what is shown.':
      'Ελέγξτε τον πράκτορα και το έναυσμά του. Η έγκριση εφαρμόζει ακριβώς ό,τι εμφανίζεται.',
    '{source} · read {date}': '{source} · ανάγνωση {date}',
    'Evidence is being recorded · read {date}': 'Η τεκμηρίωση καταγράφεται · ανάγνωση {date}',
    'Evidence expired on {date} under the retention policy':
      'Η τεκμηρίωση έληξε στις {date} σύμφωνα με την πολιτική διατήρησης',
    'Entered by {person}': 'Καταχωρίστηκε από {person}',
    'No retained evidence for this value': 'Δεν υπάρχει διατηρημένη τεκμηρίωση για αυτήν την τιμή',
    'Covers {shown} of {total} rows': 'Καλύπτει {shown} από {total} γραμμές',
    'Search rows': 'Αναζήτηση γραμμών',
    'Clear filters': 'Εκκαθάριση φίλτρων',
    Sort: 'Ταξινόμηση',
    'Sort: {column}': 'Ταξινόμηση: {column}',
    '{shown} of {total} rows': '{shown} από {total} γραμμές',
    More: 'Περισσότερα',
    Density: 'Πυκνότητα',
    Comfortable: 'Άνετη',
    Compact: 'Συμπαγής',
    Columns: 'Στήλες',
    'No rows match. Clear the search or filters to see them again.':
      'Δεν βρέθηκαν γραμμές που να ταιριάζουν. Εκκαθαρίστε την αναζήτηση ή τα φίλτρα για να τις δείτε ξανά.',
    'Not available': 'Δεν είναι διαθέσιμο',
    'All rows': 'Όλες οι γραμμές',
    'Close row detail': 'Κλείσιμο λεπτομερειών γραμμής',
    'Ask about this row': 'Ρωτήστε για αυτήν τη γραμμή',
    'Add note': 'Προσθήκη σημείωσης',
    Note: 'Σημείωση',
    Saved: 'Αποθηκεύτηκε',
    Total: 'Σύνολο',
    ascending: 'αύξουσα',
    descending: 'φθίνουσα',
    'Scroll to see all columns': 'Κάντε κύλιση για να δείτε όλες τις στήλες',
    App: 'Εφαρμογή',
    Artifact: 'Τεχνούργημα',
    'New project': 'Νέο έργο',
    'Review request': 'Αίτημα ελέγχου',
    Activity: 'Δραστηριότητα',
    'Voice preview': 'Προεπισκόπηση φωνής',
    Source: 'Πηγή',
    File: 'Αρχείο',
    Meeting: 'Συνάντηση',
    'Knowledge page': 'Σελίδα γνώσης',
    'Could not preview this CSV.': 'Δεν ήταν δυνατή η προεπισκόπηση αυτού του CSV.',
    'File content is unavailable.': 'Το περιεχόμενο του αρχείου δεν είναι διαθέσιμο.',
    'You have five open suggestions here. {value1} will see them.':
      'Έχετε πέντε ανοιχτές προτάσεις εδώ. Ο/Η {value1} θα τις δει.',
    'We could not send your suggestion. Please try again.':
      'Δεν ήταν δυνατή η αποστολή της πρότασής σας. Δοκιμάστε ξανά.',
    'The agent': 'Ο agent',
    'Selected colleagues': 'Επιλεγμένοι συνάδελφοι',
    'The owner': 'Ο κάτοχος',
    'Forked. This copy is yours and runs with your own connections.':
      'Δημιουργήθηκε διακλάδωση. Αυτό το αντίγραφο είναι δικό σας και εκτελείται με τις δικές σας συνδέσεις.',
    'This chat is too long to fork.': 'Αυτή η συνομιλία είναι πολύ μεγάλη για διακλάδωση.',
    'We could not fork this chat. Please try again.':
      'Δεν ήταν δυνατή η διακλάδωση αυτής της συνομιλίας. Δοκιμάστε ξανά.',
    'Anyone who forked it keeps their copy: forks stay with the people who made them.':
      'Όποιος δημιούργησε διακλάδωση διατηρεί το αντίγραφό του: οι διακλαδώσεις παραμένουν στα άτομα που τις δημιούργησαν.',
    'Nobody has forked this chat.': 'Κανείς δεν έχει δημιουργήσει διακλάδωση αυτής της συνομιλίας.',
    '1 person forked this chat. Their copy stays theirs.':
      '1 άτομο δημιούργησε διακλάδωση αυτής της συνομιλίας. Το αντίγραφό του παραμένει δικό του.',
    '{value1} people forked this chat. Their copies stay theirs.':
      '{value1} άτομα δημιούργησαν διακλάδωση αυτής της συνομιλίας. Τα αντίγραφά τους παραμένουν δικά τους.',
    'Personal. Nobody else sees it.': 'Προσωπικό. Κανείς άλλος δεν το βλέπει.',
    'People you pick. They get it in their Inbox.':
      'Τα άτομα που επιλέγετε. Θα το λάβουν στα Εισερχόμενά τους.',
    'Everyone in the company can follow it and fork it.':
      'Όλοι στην εταιρεία μπορούν να το ακολουθήσουν και να δημιουργήσουν διακλάδωση.',
    'a chat you can no longer open': 'μια συνομιλία που δεν μπορείτε πλέον να ανοίξετε',
    'shared the Result': 'μοιράστηκε το Αποτέλεσμα',
    'updated the Result': 'ενημέρωσε το Αποτέλεσμα',
    'published the Skill': 'δημοσίευσε τη Δεξιότητα',
    'approved the fact': 'ενέκρινε το γεγονός',
    'added the fact': 'πρόσθεσε το γεγονός',
    'added the meeting': 'πρόσθεσε τη συνάντηση',
    'published the page': 'δημοσίευσε τη σελίδα',
    'updated the page': 'ενημέρωσε τη σελίδα',
    'shared the chat': 'μοιράστηκε τη συνομιλία',
    'published a version of': 'δημοσίευσε μια έκδοση του',
    ran: 'εκτέλεσε',
    Knowledge: 'Γνώση',
    Meetings: 'Συναντήσεις',
    Chat: 'Συνομιλία',
    Use: 'Χρήση',
    Open: 'Άνοιγμα',
    You: 'Εσείς',
    Someone: 'Κάποιος',
    'published version {version} of': 'δημοσίευσε την έκδοση {version} του',
    'thing needs': 'στοιχείο χρειάζεται',
    'things need': 'στοιχεία χρειάζονται',
    'Published Skill': 'Δημοσιευμένη Δεξιότητα',
    'Included with Skill': 'Περιλαμβάνεται με τη Δεξιότητα',
    'Already attached': 'Έχει ήδη επισυναφθεί',
    'Also available in company knowledge': 'Διαθέσιμο επίσης στη γνώση της εταιρείας',
    'Company file': 'Αρχείο εταιρείας',
    'Account identity unavailable': 'Η ταυτότητα του λογαριασμού δεν είναι διαθέσιμη',
    'Access expired or was revoked. Reconnect to continue.':
      'Η πρόσβαση έληξε ή ανακλήθηκε. Συνδεθείτε ξανά για να συνεχίσετε.',
    'Account authorized · tools unavailable':
      'Ο λογαριασμός εξουσιοδοτήθηκε · τα εργαλεία δεν είναι διαθέσιμα',
    'Not available in this workspace yet.': 'Δεν είναι ακόμη διαθέσιμο σε αυτόν τον χώρο εργασίας.',
    'Everyone in the company': 'Όλοι στην εταιρεία',
    'Audience: only you.': 'Κοινό: μόνο εσείς.',
    'Audience: everyone in the company.': 'Κοινό: όλοι στην εταιρεία.',
    'tool is': 'το εργαλείο είναι',
    'tools are': 'τα εργαλεία είναι',
    'account is': 'ο λογαριασμός είναι',
    'accounts are': 'οι λογαριασμοί είναι',
    'We could not upload this file.': 'Δεν ήταν δυνατή η μεταφόρτωση αυτού του αρχείου.',
    'file was': 'το αρχείο ήταν',
    'files were': 'τα αρχεία ήταν',
    'Your company': 'Η εταιρεία σας',
    'Create an agent': 'Δημιουργία agent',
    'Give recurring work a helping hand': 'Δώστε ένα χέρι στις επαναλαμβανόμενες εργασίες',
    'Create a Skill': 'Δημιουργία δεξιότητας',
    'Save a reusable way of working': 'Αποθηκεύστε έναν επαναχρησιμοποιήσιμο τρόπο εργασίας',
    'Take meeting notes': 'Κρατήστε σημειώσεις σύσκεψης',
    'Capture decisions and next steps': 'Καταγράψτε αποφάσεις και επόμενα βήματα',
    'Work with a file': 'Εργασία με αρχείο',
    'Start from a document or image': 'Ξεκινήστε από έγγραφο ή εικόνα',
    'Browse agents': 'Περιήγηση στους agent',
    'Open your agents and company agents': 'Ανοίξτε τους agent σας και τους agent της εταιρείας',
    'Review results': 'Έλεγχος αποτελεσμάτων',
    'Return to work saved in your Library':
      'Επιστροφή στην εργασία που είναι αποθηκευμένη στη Βιβλιοθήκη σας',
    'For review': 'Για έλεγχο',
    'An agent': 'Ένας agent',
    Assistant: 'Βοηθός',
    'Kept up to date by {value1}{value2}': 'Ενημερώνεται διαρκώς από {value1}{value2}',
    ', {value1}': ', {value1}',
    'Version {value1}{value2}{value3}': 'Έκδοση {value1}{value2}{value3}',
    'Refreshed by its agent': 'Ενημερώθηκε από τον agent του',
    'Saved from a chat': 'Αποθηκεύτηκε από συνομιλία',
    'Saved from {value1}': 'Αποθηκεύτηκε από την εφαρμογή {value1}',
    Edited: 'Υποβλήθηκε σε επεξεργασία',
    'private account': 'ιδιωτικός λογαριασμός',
    '{value1} ({value2})': '{value1} ({value2})',
    '{value1}’s {value2}': '{value2} του/της {value1}',
    'Made private. The person who added it and the owner of its recording have been told in their Inbox.':
      'Έγινε ιδιωτικό. Το άτομο που το πρόσθεσε και ο κάτοχος της καταγραφής του ενημερώθηκαν στα Εισερχόμενά τους.',
    'Made private. The person who added it has been told in their Inbox.':
      'Έγινε ιδιωτικό. Το άτομο που το πρόσθεσε ενημερώθηκε στα Εισερχόμενά του.',
    'Made private. The owner of its recording has been told in their Inbox.':
      'Έγινε ιδιωτικό. Ο κάτοχος της καταγραφής του ενημερώθηκε στα Εισερχόμενά του.',
    'Selected passage': 'Επιλεγμένο απόσπασμα',
    '{value1} {value2}': '{value1} {value2}',
    'Upload a file': 'Μεταφόρτωση αρχείου',
    'Help me create a useful report from our company knowledge and available sources.':
      'Βοηθήστε με να δημιουργήσω μια χρήσιμη αναφορά από τη γνώση της εταιρείας μας και τις διαθέσιμες πηγές.',
    'This saved work couldn’t be opened. Open it again to retry.':
      'Δεν ήταν δυνατό το άνοιγμα της αποθηκευμένης εργασίας. Ανοίξτε την ξανά για να δοκιμάσετε πάλι.',
    '{value1}’s': 'του/της {value1}',
    '{value1} chat “{value2}”': 'συνομιλία του/της {value1} «{value2}»',
    '{value1}{value2}': '{value1}{value2}',
    'Skill: {value1}{value2}': 'Δεξιότητα: {value1}{value2}',
    'Result “{value1}”': 'Αποτέλεσμα «{value1}»',
    'Meeting “{value1}”': 'Σύσκεψη «{value1}»',
    'Used in {value1} {value2} this week': 'Χρησιμοποιήθηκε σε {value1} {value2} αυτή την εβδομάδα',
    '{value1} {value2} · used in {value3} {value4}':
      '{value1} {value2} · χρησιμοποιήθηκε σε {value3} {value4}',
    'The draft is not published yet, so no one else follows it.':
      'Το προσχέδιο δεν έχει δημοσιευτεί ακόμη, επομένως κανείς άλλος δεν το ακολουθεί.',
    'Use it in a chat for current data, or refine the Skill first.':
      'Χρησιμοποιήστε το σε συνομιλία για τρέχοντα δεδομένα ή βελτιώστε πρώτα τη δεξιότητα.',
    'An agent keeps this up to date. Continue the work in chat.':
      'Ένας agent το διατηρεί ενημερωμένο. Συνεχίστε την εργασία σε συνομιλία.',
    'Edit it here, or continue the work in chat.':
      'Επεξεργαστείτε το εδώ ή συνεχίστε την εργασία σε συνομιλία.',
    'Duplicate it to your Library, or continue the work in chat.':
      'Δημιουργήστε ένα αντίγραφο στη Βιβλιοθήκη σας ή συνεχίστε την εργασία σε συνομιλία.',
    'Download Markdown': 'Λήψη Markdown',
    'Download CSV': 'Λήψη CSV',
    'an agent': 'έναν agent',
    'Publish a Skill version': 'Δημοσίευση έκδοσης δεξιότητας',
    'Share with {value1}': 'Κοινοποίηση σε {value1}',
    'Update company content': 'Ενημέρωση περιεχομένου εταιρείας',
    Approved: 'Εγκρίθηκε',
    Declined: 'Απορρίφθηκε',
    Pending: 'Σε αναμονή',
    'View decision': 'Προβολή απόφασης',
    'No data': 'Δεν υπάρχουν δεδομένα',
    'No change': 'Καμία αλλαγή',
    'Connection created': 'Η σύνδεση δημιουργήθηκε',
    'Sharing changed': 'Η κοινοποίηση άλλαξε',
    'Person added': 'Το άτομο προστέθηκε',
    'Person removed': 'Το άτομο αφαιρέθηκε',
    'Access changed': 'Η πρόσβαση άλλαξε',
    'Access turned off': 'Η πρόσβαση απενεργοποιήθηκε',
    'Connection removed': 'Η σύνδεση καταργήθηκε',
    'Query time limit changed': 'Το χρονικό όριο ερωτήματος άλλαξε',
    '{count} row': '{count} γραμμή',
    '{count} rows': '{count} γραμμές',
    'This source is no longer available. Company knowledge now lives in Knowledge pages, and files stay in the Library.':
      'Αυτή η πηγή δεν είναι πλέον διαθέσιμη. Η γνώση της εταιρείας βρίσκεται πλέον στις Σελίδες γνώσης και τα αρχεία παραμένουν στη Βιβλιοθήκη.',
    '· {value1} by {value2}': '· {value1} από {value2}',
    '· version {value1}': '· έκδοση {value1}',
    '{message} {count} earlier file was saved and attached.':
      '{message} Το {count} προηγούμενο αρχείο αποθηκεύτηκε και επισυνάφθηκε.',
    '{message} {count} earlier files were saved and attached.':
      '{message} Τα {count} προηγούμενα αρχεία αποθηκεύτηκαν και επισυνάφθηκαν.',
    '{message} {count} earlier file was saved.':
      '{message} Αποθηκεύτηκε {count} προηγούμενο αρχείο.',
    '{message} {count} earlier files were saved.':
      '{message} Αποθηκεύτηκαν {count} προηγούμενα αρχεία.',
    'refreshed {time}': 'ανανεώθηκε {time}',
    'a colleague': 'ένας συνάδελφος',
    'Your chat “{title}”': 'Η συνομιλία σας «{title}»',
    '{name}’s chat “{title}”': 'Η συνομιλία του/της {name} «{title}»',
    'Kept up to date by {name}{version}': 'Διατηρείται ενημερωμένο από {name}{version}',
    'Skill: {name}{version}': 'Δεξιότητα: {name}{version}',
    'Result “{title}”': 'Αποτέλεσμα «{title}»',
    'Meeting “{title}”': 'Συνάντηση «{title}»',
    'Used in {count} answer this week': 'Χρησιμοποιήθηκε σε {count} απάντηση αυτή την εβδομάδα',
    'Used in {count} answers this week': 'Χρησιμοποιήθηκε σε {count} απαντήσεις αυτή την εβδομάδα',
    '{count} source': '{count} πηγή',
    '{count} sources': '{count} πηγές',
    'used in {count} place': 'χρησιμοποιήθηκε σε {count} σημείο',
    'used in {count} places': 'χρησιμοποιήθηκε σε {count} σημεία',
    '{company} workspace': '{company} χώρος εργασίας',
    '{count} page': '{count} σελίδα',
    '{count} pages': '{count} σελίδες',
    '{needs} · reviews and approvals': '{needs} · έλεγχοι και εγκρίσεις',
    '{count} thing needs you': '{count} αντικείμενο χρειάζεται την ενέργειά σας',
    '{count} things need you': '{count} αντικείμενα χρειάζονται την ενέργειά σας',
    'Included with Skill · {files} · {sources} {icon}':
      'Περιλαμβάνεται στη Δεξιότητα · {files} · {sources} {icon}',
    '{count} file': '{count} αρχείο',
    '{count} files': '{count} αρχεία',
    Today: 'Σήμερα',
    'Earlier this week': 'Νωρίτερα αυτή την εβδομάδα',
    '{count} slide': '{count} διαφάνεια',
    '{count} slides': '{count} διαφάνειες',
    Early: 'Πρώιμο',
    'TLS verified': 'Επαληθευμένο TLS',
    'Made personal and switched off. Switch it on when you are ready.':
      'Ορίστηκε ως προσωπικό και απενεργοποιήθηκε. Ενεργοποιήστε το όταν είστε έτοιμοι.',
    'Made personal and switched off. Its owner is told which version is live.':
      'Ορίστηκε ως προσωπικό και απενεργοποιήθηκε. Ο κάτοχός του ενημερώνεται για το ποια έκδοση είναι ενεργή.',
    'Switched off.': 'Απενεργοποιήθηκε.',
    'Applied version {revision}.': 'Εφαρμόστηκε η έκδοση {revision}.',
    'The draft is running in a chat only you can read.':
      'Το προσχέδιο εκτελείται σε μια συνομιλία που μόνο εσείς μπορείτε να διαβάσετε.',
    'Publish a version first.': 'Δημοσιεύστε πρώτα μια έκδοση.',
    'Another Agent action is in progress.': 'Μια άλλη ενέργεια του Agent βρίσκεται σε εξέλιξη.',
    'Knowledge & connections': 'Γνώση και συνδέσεις',
    'Pinned Skills': 'Καρφιτσωμένες δεξιότητες',
    None: 'Κανένα',
    'A new Result each run': 'Νέο αποτέλεσμα σε κάθε εκτέλεση',
    'One Result kept up to date': 'Ένα αποτέλεσμα που διατηρείται ενημερωμένο',
    Email: 'Ηλεκτρονικό ταχυδρομείο',
    On: 'Ενεργό',
    Off: 'Ανενεργό',
    'Waiting for review': 'Αναμονή για έλεγχο',
    Outdated: 'Παρωχημένο',
    Accepted: 'Έγινε αποδεκτό',
    Rejected: 'Απορρίφθηκε',
    Withdrawn: 'Αποσύρθηκε',
    Replaced: 'Αντικαταστάθηκε',
    'Suggested edit': 'Προτεινόμενη επεξεργασία',
    'Suggested new page': 'Προτεινόμενη νέα σελίδα',
    'Suggested move': 'Προτεινόμενη μετακίνηση',
    'Suggested archive': 'Προτεινόμενη αρχειοθέτηση',
    'Checking status…': 'Έλεγχος κατάστασης…',
    'Status unavailable': 'Η κατάσταση δεν είναι διαθέσιμη',
    'Bulleted list': 'Λίστα με κουκκίδες',
    'Numbered list': 'Αριθμημένη λίστα',
    'Web link': 'Σύνδεσμος ιστού',
    Read: 'Ανάγνωση',
    Write: 'Εγγραφή',
    'shared with you': 'σε κοινή χρήση μαζί σας',
    'Getting an answer': 'Λήψη απάντησης',
    '{name} is getting an answer': 'Ο/Η {name} λαμβάνει απάντηση',
    'We could not save. Please try again.': 'Δεν ήταν δυνατή η αποθήκευση. Δοκιμάστε ξανά.',
    'The new page could not be created.': 'Δεν ήταν δυνατή η δημιουργία της νέας σελίδας.',
    'We could not load this revision.': 'Δεν ήταν δυνατή η φόρτωση αυτής της αναθεώρησης.',
    'We could not restore this revision. Please try again.':
      'Δεν ήταν δυνατή η επαναφορά αυτής της αναθεώρησης. Δοκιμάστε ξανά.',
    'We could not export this revision.': 'Δεν ήταν δυνατή η εξαγωγή αυτής της αναθεώρησης.',
    'We could not open this suggestion.': 'Δεν ήταν δυνατό το άνοιγμα αυτής της πρότασης.',
    'We could not do that. Please try again.': 'Δεν ήταν δυνατή η εκτέλεση. Δοκιμάστε ξανά.',
    'We could not save your decision. Please try again.':
      'Δεν ήταν δυνατή η αποθήκευση της απόφασής σας. Δοκιμάστε ξανά.',
    'We could not restore this page. Please try again.':
      'Δεν ήταν δυνατή η επαναφορά αυτής της σελίδας. Δοκιμάστε ξανά.',
    'We could not export this page.': 'Δεν ήταν δυνατή η εξαγωγή αυτής της σελίδας.',
    '{count} missed time merged.': 'Συγχωνεύτηκε {count} χαμένη καταχώριση χρόνου.',
    '{count} missed times merged.': 'Συγχωνεύτηκαν {count} χαμένες καταχωρίσεις χρόνου.',
    'About this project': 'Σχετικά με αυτό το έργο',
  },
  hu: {
    'We could not load this item.': 'Nem sikerült betölteni ezt az elemet.',
    '{value1} canvas': '{value1} vászon',
    'Loading {value1}…': '{value1} betöltése…',
    '{value1} · Original retained': '{value1} · Az eredeti megőrizve',
    '{value1} {value2}{value3} · Added {value4}': '{value1} {value2}{value3} · Hozzáadva: {value4}',
    '{value1} Use in chat': '{value1} Használat a csevegésben',
    '{value1} Download': '{value1} Letöltés',
    Table: 'Táblázat',
    Chart: 'Diagram',
    Original: 'Eredeti',
    'Text extracted from the PDF, marked by page. Download the original for its layout and images.':
      'A PDF-ből oldalanként kinyert szöveg. A tördelés és a képek megtekintéséhez töltse le az eredetit.',
    'This preview shows the beginning of the file. Poneva reads the whole file; download the original to see all of it.':
      'Ez az előnézet a fájl elejét mutatja. A Poneva a teljes fájlt beolvassa; a teljes tartalom megtekintéséhez töltse le az eredetit.',
    'Preview of the first {value1} complete rows. Filtering and charts use only this preview. Download the original for the full file.':
      'Az első {value1} teljes sor előnézete. A szűrés és a diagramok csak ezt az előnézetet használják. A teljes fájlhoz töltse le az eredetit.',
    'This source link cannot be opened.': 'Ez a forráshivatkozás nem nyitható meg.',
    'Read-only chat': 'Csak olvasható csevegés',
    'Only {value1} writes in this chat. Fork it to continue with your own connections. {value2}':
      'Ebben a csevegésben csak {value1} írhat. Forkolja a folytatáshoz a saját kapcsolataival. {value2}',
    'Suggest a follow-up…': 'Javasoljon folytatást…',
    'Suggest a follow-up': 'Javasoljon folytatást',
    'Sending…': 'Küldés…',
    Send: 'Küldés',
    'We could not dismiss that suggestion. Please try again.':
      'Nem sikerült elvetni a javaslatot. Próbálja újra.',
    'Suggested follow-ups': 'Javasolt folytatások',
    '{value1} suggests': '{value1} javaslata',
    Ask: 'Kérdezés',
    'Dismiss {value1}’s suggestion': '{value1} javaslatának elvetése',
    'Suggested by': 'Javasolta:',
    '· edit it or send it': '· szerkessze vagy küldje el',
    'Remove the suggestion tag': 'Javaslatcímke eltávolítása',
    '{value1} {value2} is getting an answer': '{value1} {value2} választ kap',
    '{value1} {value2} stopped the answer': '{value1} {value2} leállította a választ',
    '{value1} Fork from here': '{value1} Forkolás innen',
    '{value1} From {value2}’s {value3}': '{value1} {value2} {value3} eleméből',
    'Only {value1} can use this account': 'Ezt a fiókot csak {value1} használhatja',
    '{value1} Suggested by {value2}': '{value1} Javasolta: {value2}',
    'Fork this chat': 'Csevegés fork­olása',
    'Forking…': 'Forkolás…',
    Fork: 'Forkolás',
    'Could not make this private.': 'Nem sikerült priváttá tenni.',
    'Make this chat private?': 'Priváttá teszi ezt a csevegést?',
    Close: 'Bezárás',
    '{value1} will see “{value2}”. Everyone else loses access right away {value3} .{value4}':
      '{value1} látni fogja: „{value2}”. Mindenki más azonnal elveszíti a hozzáférést {value3} .{value4}',
    Cancel: 'Mégse',
    'Saving…': 'Mentés…',
    'Make private': 'Priváttá tétel',
    'This chat is private again. Forks others made stay theirs.':
      'Ez a csevegés ismét privát. A mások által készített forkok az övék maradnak.',
    'Who can read this chat: {value1}': 'Ki olvashatja ezt a csevegést: {value1}',
    'Move this chat': 'Csevegés áthelyezése',
    'Only you write here. Others follow live and fork.':
      'Itt csak Ön írhat. Mások élőben követhetik és fork­olhatják.',
    'Made private. {value1} has been told in their Inbox.':
      'Priváttá téve. {value1} értesítést kapott a Beérkező levelek között.',
    'Chat access': 'Csevegés-hozzáférés',
    '{value1}’s chat. As an admin you can make it private.':
      '{value1} csevegése. Rendszergazdaként priváttá teheti.',
    'Only {value1} will see it. {value2} is told.':
      'Csak {value1} fogja látni. {value2} értesítést kapott.',
    '{value1} {value2} following': '{value1} {value2} követi',
    'Forked from{value1} {value2} . The history is copied. From here, tools run with your own access.':
      'Forkolva innen: {value1} {value2} . Az előzmények másolva lettek. Ettől kezdve az eszközök az Ön hozzáférésével futnak.',
    '{value1} made this chat private': '{value1} priváttá tette ezt a csevegést',
    'You can no longer open it. Any fork you made stays yours.':
      'Többé nem nyithatja meg. Az Ön által készített forkok az Önéi maradnak.',
    'Start a new chat': 'Új csevegés indítása',
    'Back to Recent chats': 'Vissza a Legutóbbi csevegésekhez',
    'More chat actions': 'További csevegési műveletek',
    'Close conversation sharing': 'Beszélgetésmegosztás bezárása',
    'Review the text before saving a private copy to Library. Then choose its audience. Your original conversation and future messages stay private.':
      'Tekintse át a szöveget, mielőtt privát másolatként menti a Könyvtárba. Ezután válassza ki a célközönségét. Az eredeti beszélgetés és a jövőbeli üzenetek privátak maradnak.',
    'Preparing the conversation…': 'Beszélgetés előkészítése…',
    'Refresh preview': 'Előnézet frissítése',
    'The copy is saved in Library. Use Share to choose who can access it.':
      'A másolat a Könyvtárba lett mentve. A Megosztás funkcióval válassza ki, ki férhet hozzá.',
    'Save this copy': 'Másolat mentése',
    'That Skill could not be opened.': 'Nem sikerült megnyitni ezt a készséget.',
    '{value1}{value2} · reviews and approvals':
      '{value1}{value2} · felülvizsgálatok és jóváhagyások',
    'Open Inbox': 'Beérkező levelek megnyitása',
    'New at {value1} this week': 'Új itt: {value1} ezen a héten',
    'Nothing new this week. Shared work, published Skills and approved knowledge show up here.':
      'Ezen a héten nincs új elem. Itt jelennek meg a megosztott munkák, a közzétett készségek és a jóváhagyott tudásanyagok.',
    'New at {value1}': 'Új itt: {value1}',
    'This Skill is unavailable. Try again.': 'Ez a készség nem érhető el. Próbálja újra.',
    'You can attach up to {value1} files. Remove an attachment to add another.':
      'Legfeljebb {value1} fájlt csatolhat. Újabb hozzáadásához távolítson el egy csatolmányt.',
    'Add company context': 'Vállalati kontextus hozzáadása',
    'Add company context · @': 'Vállalati kontextus hozzáadása · @',
    'Choose a Skill': 'Készség kiválasztása',
    'Choose a Skill · /': 'Készség kiválasztása · /',
    context: 'kontextus',
    skills: 'készségek',
    'Choose company context': 'Vállalati kontextus kiválasztása',
    'Skills for this conversation': 'A beszélgetés készségei',
    'Bring context into the conversation': 'Kontextus hozzáadása a beszélgetéshez',
    'Close context picker': 'Kontextusválasztó bezárása',
    'Filter company context': 'Vállalati kontextus szűrése',
    'Find a Skill…': 'Készség keresése…',
    'Find a file…': 'Fájl keresése…',
    'Available company context': 'Elérhető vállalati kontextus',
    'No matching published Skills.': 'Nincs egyező közzétett készség.',
    'No matching files.': 'Nincs egyező fájl.',
    'Searching company work…': 'Vállalati munkák keresése…',
    'Try search again': 'Próbáld újra a keresést',
    'Meaning search is temporarily limited. Showing available text matches.':
      'A szemantikus keresés átmenetileg korlátozott. Az elérhető szöveges találatok jelennek meg.',
    'Load more matches': 'További találatok betöltése',
    '{value1} files attached. Remove an attachment to add another. Saved Skill references are included separately.':
      '{value1} fájl csatolva. Egy újabb fájl hozzáadásához távolíts el egy csatolmányt. A mentett készséghivatkozások külön kerülnek bele.',
    'Create a Skill in chat': 'Készség létrehozása a csevegésben',
    'Upload a company file': 'Vállalati fájl feltöltése',
    'Company knowledge is always available to Poneva.':
      'A vállalati tudás mindig elérhető a Poneva számára.',
    '{value1} was not connected': '{value1} nem csatlakozott',
    Dismiss: 'Bezárás',
    'Try connecting again': 'Próbáld újra a csatlakozást',
    Waiting: 'Várakozás',
    Connected: 'Csatlakoztatva',
    'Needs reconnecting': 'Újracsatlakozás szükséges',
    Connect: 'Csatlakozás',
    '{value1}{value2} The provider’s account permissions still apply.':
      '{value1}{value2} A szolgáltatói fiók jogosultságai továbbra is érvényesek.',
    'Last error: {value1}': 'Utolsó hiba: {value1}',
    '{value1} {value2} ready.': '{value1} {value2} készen áll.',
    'Continue with my Meta app': 'Folytatás a Meta-alkalmazásommal',
    Reconnect: 'Újracsatlakozás',
    Disconnect: 'Kapcsolat bontása',
    'Remove attachment: {value1}': 'Csatolmány eltávolítása: {value1}',
    'Saved in this Skill. Edit the Skill to change its references.':
      'Ebben a készségben mentve. A hivatkozások módosításához szerkeszd a készséget.',
    'Remove Skill context': 'Készségkontextus eltávolítása',
    Refining: 'Finomítás',
    Previewing: 'Előnézet',
    Using: 'Használat',
    'Skill revision {value1}': 'Készség verziója: {value1}',
    'a new Skill': 'egy új készség',
    '{value1} Making a new agent {value2}': '{value1} Új ügynök létrehozása {value2}',
    'Stop making a new agent in this chat':
      'Új ügynök létrehozásának leállítása ebben a csevegésben',
    'Saved Skill references': 'Mentett készséghivatkozások',
    'Included with Skill · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}':
      'A készséggel együtt · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}',
    'Selected Skill revision is unavailable. Select the Skill again to view its saved references.':
      'A kiválasztott készségverzió nem érhető el. A mentett hivatkozások megtekintéséhez válaszd ki újra a készséget.',
    'Conversation attachments': 'A beszélgetés csatolmányai',
    'Added for this conversation': 'A beszélgetéshez hozzáadva',
    'Selected passage {value1}': 'Kiválasztott részlet: {value1}',
    'We could not load your workspace.': 'Nem sikerült betölteni a munkaterületedet.',
    'The selected Skill is unavailable. Check its access or choose it again.':
      'A kiválasztott készség nem érhető el. Ellenőrizd a hozzáférését, vagy válaszd ki újra.',
    'Source saved privately and included in your knowledge search.':
      'A forrás privátként lett mentve, és bekerült a tudáskeresésbe.',
    'File saved privately to your library and attached to this message.':
      'A fájl privátként lett mentve a könyvtáradba, és csatolva lett ehhez az üzenethez.',
    'File saved privately to your library.': 'A fájl privátként lett mentve a könyvtáradba.',
    '{value1} {value2} earlier {value3} saved{value4}.':
      '{value1} {value2} korábban {value3} mentve{value4}.',
    'Extracted text for Poneva to read. Download the original for its layout, charts and images. Spreadsheet formulas show their saved results and are not recalculated.':
      'A Poneva által olvasható szöveg kinyerve. Az elrendezés, diagramok és képek megőrzéséhez töltsd le az eredetit. A táblázatképletek a mentett eredményeiket jelenítik meg, és nem kerülnek újraszámításra.',
    Esc: 'Esc',
    'Start something': 'Kezdj valamibe',
    'Choose a file to work with': 'Válassz egy fájlt a munkához',
    'Skills worth adding': 'Érdemes hozzáadni ezeket a készségeket',
    'Picked for you': 'Neked válogatva',
    'Reusable work grounded in your company knowledge.':
      'Újra felhasználható munka a vállalati tudásodra alapozva.',
    'Ideas from your company context and recent work. Pick one to start.':
      'Ötletek a vállalati kontextusod és legutóbbi munkáid alapján. Válassz egyet a kezdéshez.',
    'Refresh suggested tasks': 'Javasolt feladatok frissítése',
    'Check for new company context.': 'Új vállalati kontextus keresése.',
    'Check for new context. Ideas also refresh daily.':
      'Új kontextus keresése. Az ötletek naponta is frissülnek.',
    Refresh: 'Frissítés',
    'Finding useful starting points…': 'Hasznos kiindulópontok keresése…',
    'Suggestions aren’t available right now. Try Refresh, or describe the work you want to do.':
      'A javaslatok jelenleg nem érhetők el. Próbáld meg a Frissítést, vagy írd le, mit szeretnél elvégezni.',
    'Loading the knowledge pages…': 'Tudásoldalak betöltése…',
    '{value1} All pages': '{value1} Összes oldal',
    'The page is created.': 'Az oldal létrejött.',
    'Your new page is suggested. A publisher decides whether it is added.':
      'Az új oldalad javaslatként létrejött. A közzétevő dönt arról, hogy hozzáadják-e.',
    'Company knowledge': 'Vállalati tudás',
    'What Poneva knows about your company, page by page. Every change is kept.':
      'Amit a Poneva tud a vállalatodról, oldalról oldalra. Minden módosítás megmarad.',
    'Loading company knowledge…': 'Vállalati tudás betöltése…',
    'Knowledge pages are not enabled in this workspace.':
      'A tudásoldalak nincsenek engedélyezve ebben a munkaterületben.',
    'Ask your Poneva contact to switch them on for your company.':
      'Kérd meg a Poneva-kapcsolattartódat, hogy engedélyezze őket a vállalatod számára.',
    '{value1} Change the agent': '{value1} Ügynök módosítása',
    '{value1} Continue in chat': '{value1} Folytatás a csevegésben',
    Edit: 'Szerkesztés',
    '{value1} Edit with chat': '{value1} Szerkesztés chattel',
    '{value1} Duplicate to my Library': '{value1} Másolat a könyvtáramba',
    'Duplicated to your Library. Only you can see the copy.':
      'Létrejött a másolat a könyvtáradban. Csak te láthatod.',
    'Could not duplicate this Result. Try again.':
      'Nem sikerült lemásolni ezt az eredményt. Próbáld újra.',
    'Saved version {value1}.': 'A(z) {value1}. verzió mentve.',
    'A newer version was saved. Reload the Result before saving.':
      'Újabb verzió lett mentve. Mentés előtt töltsd újra az eredményt.',
    'Could not save this version. Try again.': 'Nem sikerült menteni ezt a verziót. Próbáld újra.',
    '{value1} saved a newer version. Review it before saving.':
      '{value1} újabb verziót mentett. Mentés előtt tekintsd át.',
    'Hide their version': 'Az ő verziójuk elrejtése',
    'Show their version': 'Az ő verziójuk megjelenítése',
    'Start from their version': 'Kezdés az ő verziójukból',
    Markdown: 'Markdown',
    'Result text': 'Eredményszöveg',
    Preview: 'Előnézet',
    'What changed': 'Mi változott',
    'What changed? (optional)': 'Mi változott? (nem kötelező)',
    'Save version {value1}': '{value1}. verzió mentése',
    'Open chat': 'Csevegés megnyitása',
    Current: 'Jelenlegi',
    Restore: 'Visszaállítás',
    'Could not load the history.': 'Nem sikerült betölteni az előzményeket.',
    'Restored version {value1} as version {value2}.':
      'A(z) {value1}. verzió visszaállítva {value2}. verzióként.',
    'Someone saved a newer version. Review it before restoring.':
      'Valaki újabb verziót mentett. Visszaállítás előtt tekintsd át.',
    'Could not restore that version.': 'Nem sikerült visszaállítani azt a verziót.',
    'Loading history…': 'Előzmények betöltése…',
    'Restoring keeps what is there now as a version too, so nothing is lost.':
      'A visszaállítás a jelenlegi állapotot is verzióként menti, így semmi sem vész el.',
    'This Result was made with your own {value1}.':
      'Ez az eredmény a saját {value1} használatával készült.',
    'It also used': 'Ezt is használta:',
    'This Result was made with': 'Ez az eredmény ezzel készült:',
    'Colleagues can read what came from them, but can never use them.':
      'A munkatársak elolvashatják a tőlük származó tartalmakat, de soha nem használhatják őket.',
    'Your personal agent {value1} keeps it up to date with your own access, so every refresh can carry your private data.':
      'A személyes ügynököd, {value1}, a saját hozzáféréseddel tartja naprakészen, így minden frissítés tartalmazhatja a személyes adataidat.',
    'A colleague’s personal agent keeps it up to date with their own access, so every refresh can carry their private data.':
      'Egy munkatárs személyes ügynöke a saját hozzáférésével tartja naprakészen, így minden frissítés tartalmazhatja a munkatárs személyes adatait.',
    'Made private. Only you can see this meeting.':
      'Priváttá téve. Csak te láthatod ezt a megbeszélést.',
    'Could not make this meeting private.': 'Nem sikerült priváttá tenni ezt a megbeszélést.',
    'Meeting · {value1} {value2} · Original retained':
      'Megbeszélés · {value1} {value2} · Az eredeti megőrizve',
    'The recording could not be opened.': 'Nem sikerült megnyitni a felvételt.',
    'Ask about this suggestion': 'Kérdezz erről a javaslatról',
    meeting_processing_failed: 'megbeszélés_feldolgozása_sikertelen',
    'Who can see this': 'Ki láthatja ezt',
    'Everyone at {value1}': 'A(z) {value1} minden tagja',
    'Only me': 'Csak én',
    'Everyone at {value1} can find it and ask about it.':
      'A(z) {value1} minden tagja megtalálhatja és kérdezhet róla.',
    'Only you can open and search this meeting. You can share it later.':
      'Csak te nyithatod meg és kereshetsz ebben a megbeszélésben. Később megoszthatod.',
    'Added. Only you can see it. Transcription is running in the background.':
      'Hozzáadva. Csak te láthatod. A leirat készítése a háttérben folyamatban van.',
    'Visible to everyone at {value1}': 'A(z) {value1} minden tagja számára látható',
    'Could not make it private.': 'Nem sikerült priváttá tenni.',
    'Show more meetings': 'További megbeszélések megjelenítése',
    'Attached to this message': 'Ehhez az üzenethez csatolva',
    'Connect securely, choose the tables to share, then decide whether Poneva can read or make changes.':
      'Csatlakozz biztonságosan, válaszd ki a megosztandó táblákat, majd döntsd el, hogy a Poneva olvashatja-e vagy módosíthatja-e őket.',
    'Review the tables this connection can access. Select at least one table.':
      'Tekintsd át, mely táblákhoz férhet hozzá ez a kapcsolat. Válassz ki legalább egy táblát.',
    'Select at least one table. Nothing is selected by default.':
      'Válassz ki legalább egy táblát. Alapértelmezés szerint nincs kiválasztva semmi.',
    'Choose who can use this connection and what Poneva can do.':
      'Válaszd ki, ki használhatja ezt a kapcsolatot, és mit tehet a Poneva.',
    'Your chosen access is enabled for the selected tables.':
      'A kiválasztott hozzáférés engedélyezve van a kijelölt táblákhoz.',
    'Your connection is saved with reading paused until permission is confirmed.':
      'A kapcsolat mentve, az olvasás szünetel az engedély megerősítéséig.',
    'Confirm database disconnect': 'Adatbázis leválasztásának megerősítése',
    'Disconnect this database?': 'Leválasztod ezt az adatbázist?',
    'Access will stop for everyone using this connection.':
      'A hozzáférés megszűnik mindenkinél, aki ezt a kapcsolatot használja.',
    'Keep connection': 'Kapcsolat megtartása',
    'What it can reach · {value1}{value2} {value3}':
      'Mihez férhet hozzá · {value1}{value2} {value3}',
    Back: 'Vissza',
    Continue: 'Folytatás',
    'Uploading…': 'Feltöltés…',
    Library: 'Könyvtár',
    'Source material for your work. Available whenever you need it.':
      'A munkád forrásanyagai. Bármikor elérhetők, amikor szükséged van rájuk.',
    'The work you want to keep, with its sources and conversation attached.':
      'A megőrizni kívánt munka a hozzá csatolt forrásokkal és beszélgetéssel.',
    Results: 'Eredmények',
    Files: 'Fájlok',
    Artifacts: 'Munkadarabok',
    'Search library': 'Keresés a könyvtárban',
    'Find files by meaning…': 'Fájlok keresése jelentés alapján…',
    'Find saved work by meaning…': 'Mentett munkák keresése jelentés alapján…',
    'Search coverage is limited while indexing or meaning-based search is unavailable. You can retry or browse recent items.':
      'A keresés hatóköre korlátozott, amíg az indexelés vagy a jelentésalapú keresés nem érhető el. Újra próbálkozhatsz, vagy böngészheted a legutóbbi elemeket.',
    'No matching work found.': 'Nem található egyező munka.',
    'A starting point for your next question.': 'Kiindulópont a következő kérdésedhez.',
    'Good work is worth keeping.': 'A jó munkát érdemes megőrizni.',
    'Try a different description or clear the search to browse.':
      'Próbálj más leírást, vagy töröld a keresést a böngészéshez.',
    'Upload source material once and use it in conversations and Skills. Your original stays in the library.':
      'Töltsd fel egyszer a forrásanyagot, és használd beszélgetésekben és készségekben. Az eredeti a könyvtárban marad.',
    'Ask Poneva to save an answer, table or chart. Results stay connected to the conversation and their sources.':
      'Kérd meg a Ponevát, hogy mentsen el egy választ, táblázatot vagy diagramot. Az eredmények kapcsolatban maradnak a beszélgetéssel és a forrásaikkal.',
    'Start in chat {value1}': 'Kezdés a(z) {value1} csevegésben',
    'Open result: {value1}': 'Eredmény megnyitása: {value1}',
    'Loading more library items…': 'További könyvtári elemek betöltése…',
    'Load more': 'Továbbiak betöltése',
    'Documents, transcripts, audio and video · Up to 500 MB per file. New files are private. Choose their audience with Share and which processable files become searchable company knowledge.':
      'Dokumentumok, átiratok, hang- és videófájlok · Fájlonként legfeljebb 500 MB. Az új fájlok privátak. A Megosztás funkcióval válaszd ki a közönségüket, és azt, hogy mely feldolgozható fájlok váljanak kereshető vállalati tudássá.',
    Skills: 'Készségek',
    'Create in chat': 'Létrehozás a csevegésben',
    'Search Skills': 'Készségek keresése',
    'Search finds published Skills. Clear the search to browse your drafts too.':
      'A keresés a közzétett készségek között keres. Töröld a keresést, hogy a piszkozatokat is böngészhesd.',
    'Search coverage is limited while indexing or meaning-based search is unavailable.':
      'A keresés lefedettsége korlátozott, amíg az indexelés vagy a jelentésalapú keresés nem érhető el.',
    'Searching Skills…': 'Készségek keresése…',
    'No matching published Skills found. Try a different description.':
      'Nem találhatók a leírásnak megfelelő közzétett készségek. Próbálj másik leírást.',
    'Load more Skills': 'További készségek betöltése',
    'View Skill: {value1}': 'Készség megtekintése: {value1}',
    'Company workspace': 'Vállalati munkaterület',
    'View {value1}': '{value1} megtekintése',
    'Loading Skills…': 'Készségek betöltése…',
    'Try again {value1}': 'Próbáld újra: {value1}',
    'Try again': 'Próbáld újra',
    'Nothing yet.': 'Még nincs itt semmi.',
    'Made from · Used by': 'Alapja · Használja',
    'Could not load links': 'A hivatkozások nem tölthetők be',
    'Made from': 'Alapja',
    'Used by': 'Használja',
    'About this chat {value1}': 'A csevegésről: {value1}',
    'About this chat': 'A csevegésről',
    'Keep the work moving.': 'Haladj tovább a munkával.',
    'Ask a follow-up with this result in view, or turn a useful approach into a company Skill.':
      'Tegyél fel egy további kérdést ennek az eredménynek a felhasználásával, vagy alakíts egy hasznos megközelítést vállalati készséggé.',
    'Save approach as a Skill': 'Megközelítés mentése készségként',
    'Preview of': 'Előnézet:',
    'Made with': 'Ezzel készült:',
    'Open the draft': 'Piszkozat megnyitása',
    'Open Skill': 'Készség megnyitása',
    'Use in chat': 'Használat a csevegésben',
    'Finish the draft': 'Piszkozat befejezése',
    'Refine this Skill': 'Készség finomítása',
    'Made with a Skill.': 'Készséggel készült.',
    'This workspace could not be loaded just now, so that Skill cannot be opened yet. The result itself is unchanged.':
      'Ezt a munkaterületet most nem sikerült betölteni, ezért a készség még nem nyitható meg. Maga az eredmény változatlan.',
    'That Skill is not available in this workspace, so it cannot be opened or used again. The result itself is unchanged.':
      'Ez a készség nem érhető el ebben a munkaterületben, ezért nem nyitható meg és nem használható újra. Maga az eredmény változatlan.',
    'Result · {value1} {value2}': 'Eredmény · {value1} {value2}',
    '{value1} Copy link': '{value1} Hivatkozás másolása',
    'Result link copied.': 'Az eredmény hivatkozása másolva.',
    'Could not copy the link. Use your browser address bar.':
      'A hivatkozás nem másolható. Használd a böngésző címsorát.',
    'No preview is available for this result.': 'Ehhez az eredményhez nem érhető el előnézet.',
    '{value1} rows are retained in this snapshot. Open Table to inspect the values.':
      'Ebben a pillanatképben {value1} sor maradt meg. Az értékek megtekintéséhez nyisd meg a Táblázatot.',
    'People can’t edit a Result an agent keeps up to date; the next refresh would replace their edit. Change the agent’s instructions instead.':
      'Az emberek nem szerkeszthetik az ügynök által naprakészen tartott eredményt; a következő frissítés felülírná a módosításukat. Inkább módosítsd az ügynök utasításait.',
    'Linked sources': 'Hivatkozott források',
    'Saved source': 'Mentett forrás',
    'No source documents are linked to this result. Company knowledge and other references may be cited in the answer.':
      'Ehhez az eredményhez nincsenek forrásdokumentumok csatolva. A válaszban vállalati tudás és más hivatkozások is szerepelhetnek.',
    'Run details': 'Futtatás részletei',
    Created: 'Létrehozva',
    ', revised {value1}': ', módosítva: {value1}',
    Conversation: 'Beszélgetés',
    'Not recorded': 'Nincs rögzítve',
    'Open conversation': 'Beszélgetés megnyitása',
    Run: 'Futtatás',
    Updates: 'Frissítések',
    'Kept up to date by {value1}': 'Naprakészen tartja: {value1}',
    'Version {value1}': '{value1}. verzió',
    'Could not open this request.': 'A kérés nem nyitható meg.',
    'Approved version published.': 'A jóváhagyott verzió közzétéve.',
    'Request rejected. The item stays unchanged.': 'A kérés elutasítva. Az elem változatlan marad.',
    'Could not save the decision.': 'A döntés nem menthető.',
    'Proposed company change': 'Javasolt vállalati módosítás',
    'Opening…': 'Megnyitás…',
    'Approve this version': 'Verzió jóváhagyása',
    Decline: 'Elutasítás',
    'Review the submitted version below. Changes made since submission will need a new request.':
      'Tekintsd át alább a beküldött verziót. A beküldés óta végzett módosításokhoz új kérelem szükséges.',
    'The version submitted with this request.': 'A kérelemmel beküldött verzió.',
    'Version and proposed change': 'Verzió és javasolt módosítás',
    'Could not read the pinned content.': 'A rögzített tartalom nem olvasható.',
    'Showing a page of {value1} characters.': 'Egy {value1} karakterből álló oldal megjelenítése.',
    'Beginning of the submitted content. Open the full text to review every page.':
      'A beküldött tartalom eleje. Nyisd meg a teljes szöveget az összes oldal áttekintéséhez.',
    'Read full submitted text': 'Teljes beküldött szöveg elolvasása',
    'Previous page': 'Előző oldal',
    'Next page': 'Következő oldal',
    'Made private. Its creator has been told in their Inbox.':
      'Priváttá téve. A létrehozó értesítést kapott a Beérkező üzenetek között.',
    'Made private. Its creator could not be notified.':
      'Priváttá téve. A létrehozót nem sikerült értesíteni.',
    'Make this {value1} private?': 'Priváttá teszed ezt: {value1}?',
    'Only the person who created it will see it. Everyone else loses access right away, and its creator gets an Inbox update if they are still a company member. If they have left, nobody in the company will be able to access this item.':
      'Csak a létrehozója fogja látni. Mindenki más azonnal elveszíti a hozzáférést, és a létrehozó értesítést kap a Beérkező üzenetek között, ha továbbra is a vállalat tagja. Ha kilépett, a vállalatból senki sem férhet hozzá ehhez az elemhez.',
    'Sent for review. The current audience stays unchanged until approval.':
      'Ellenőrzésre elküldve. A jelenlegi közönség a jóváhagyásig változatlan marad.',
    'Could not update sharing.': 'Nem sikerült frissíteni a megosztást.',
    'They can follow new answers live and fork it to continue with their own connections. Only you write here. You can make it private again at any time.':
      'Élőben követhetik az új válaszokat, és elágaztathatják, hogy saját kapcsolataikkal folytassák. Csak Ön írhat ide. Bármikor újra priváttá teheti.',
    'They see the project, its brief and the work in it they can already open. Nothing in it opens for anyone because of the project; each item keeps its own access.':
      'Látják a projektet, annak összefoglalóját és a benne lévő, számukra már megnyitható munkát. A projekt miatt semmi nem válik mindenki számára elérhetővé; minden elem megőrzi a saját hozzáférési beállításait.',
    'Check the content for private information before sharing. Sharing an item does not grant access to its original chat or private connections.':
      'Megosztás előtt ellenőrizze a tartalmat bizalmas információk szempontjából. Egy elem megosztása nem biztosít hozzáférést az eredeti csevegéséhez vagy a privát kapcsolataihoz.',
    '{value1} Everyone you share with can read it, including what the assistant or an App in it found in your {value2}. They can’t use your {value3}. Nothing changes for you: the chat keeps working with all your accounts.':
      '{value1} Mindenki, akivel megosztja, elolvashatja, beleértve azt is, amit a benne lévő asszisztens vagy App talált az Ön {value2} elemében. Nem használhatják az Ön {value3} elemét. Az Ön számára semmi sem változik: a csevegés továbbra is minden fiókjával működik.',
    '{value1} Everyone you share with can read them, but nobody can use {value2} through this chat.':
      '{value1} Mindenki, akivel megosztja, elolvashatja őket, de senki sem használhatja a(z) {value2} elemet ezen a csevegésen keresztül.',
    'This controls access to the working draft. Any published company version stays available until you explicitly unpublish it. To publish a new version, complete its preview and use Save Skill. Run results stay private.':
      'Ez szabályozza a munkapéldányhoz való hozzáférést. A közzétett vállalati verzió mindaddig elérhető marad, amíg kifejezetten vissza nem vonja a közzétételét. Új verzió közzétételéhez fejezze be az előnézetét, majd használja a Skill mentése lehetőséget. A futtatási eredmények privátak maradnak.',
    'Skill deleted. You can restore it from the Skills archive for 30 days.':
      'A Skill törölve. A Skills archívumából 30 napig visszaállíthatja.',
    'Could not delete this Skill.': 'Nem sikerült törölni ezt a Skillt.',
    'More actions': 'További műveletek',
    'Delete “{value1}”? It will disappear from Skills and search, and cannot be used by agents. You can restore it for 30 days. Existing chats and results stay available.':
      'Törli a(z) „{value1}” elemet? Eltűnik a Skills közül és a keresésből, és az ügynökök nem használhatják. 30 napig visszaállíthatja. A meglévő csevegések és eredmények továbbra is elérhetők maradnak.',
    'Deleting…': 'Törlés…',
    'Confirm delete': 'Törlés megerősítése',
    'Delete Skill': 'Skill törlése',
    'Skill restored as an unpublished draft. Its author can review and publish it again.':
      'A Skill visszaállítva közzé nem tett munkapéldányként. A szerzője átnézheti és újra közzéteheti.',
    'Could not restore this Skill.': 'Nem sikerült visszaállítani ezt a Skillt.',
    'Archived Skills': 'Archivált Skills',
    'Deleted Skills can be restored for 30 days. Restoring leaves them unpublished.':
      'A törölt Skillök 30 napig visszaállíthatók. A visszaállítás után közzé nem tett állapotban maradnak.',
    'Restore until {value1}': 'Visszaállítás eddig: {value1}',
    'Loading…': 'Betöltés…',
    'No archived Skills.': 'Nincsenek archivált Skills elemek.',
    'Load more archived Skills': 'További archivált Skills betöltése',
    'Show more of the original': 'Több megjelenítése az eredetiből',
    'Filter result rows': 'Eredménysorok szűrése',
    'Find a product or value…': 'Termék vagy érték keresése…',
    '{value1} of {value2}': '{value1} / {value2}',
    'Result table': 'Eredménytábla',
    'No matching rows.': 'Nincs egyező sor.',
    'Showing the first 1,000 matching rows. Download the CSV for every row.':
      'Az első 1000 egyező sor jelenik meg. Töltse le a CSV-fájlt az összes sorhoz.',
    'Agent ·': 'Ügynök ·',
    'Only you': 'Csak Ön',
    'Stopped before it finished.': 'A befejezés előtt leállt.',
    'Drafting the project…': 'A projekt vázlatának létrehozása…',
    'Checking where this chat belongs…': 'A csevegés helyének ellenőrzése…',
    'Moving the chat…': 'A csevegés áthelyezése…',
    'Taking it out of the project…': 'A csevegés eltávolítása a projektből…',
    'Adding it to the project…': 'Hozzáadás a projekthez…',
    'No matching connections are available right now.':
      'Jelenleg nem érhetők el egyező kapcsolatok.',
    'Company knowledge suggestion': 'Vállalati tudásjavaslat',
    'Company knowledge now lives on pages. Open Knowledge to see them.':
      'A vállalati tudás mostantól oldalakon található. Nyissa meg a Knowledge nézetet a megtekintésükhöz.',
    '{value1} · Open beside this conversation': '{value1} · Megnyitás a beszélgetés mellett',
    'Name {value1}': 'Név: {value1}',
    'Host {value1}': 'Gazdagép: {value1}',
    'Port {value1}': 'Port: {value1}',
    'Database {value1}': 'Adatbázis: {value1}',
    'Username {value1}': 'Felhasználónév: {value1}',
    'Password {value1}': 'Jelszó: {value1}',
    'Advanced TLS': 'Speciális TLS',
    '{value1} Poneva verifies the server certificate. Add a CA or server DNS name for IP hosts when your certificate requires it.':
      '{value1} A Poneva ellenőrzi a kiszolgáló tanúsítványát. IP-cím alapú gazdagép esetén adjon meg CA-t vagy a kiszolgáló DNS-nevét, ha a tanúsítványa ezt megköveteli.',
    'CA certificate {value1}': 'CA-tanúsítvány: {value1}',
    'Certificate server DNS name {value1}': 'A tanúsítvány kiszolgálói DNS-neve: {value1}',
    '{value1} Your password is encrypted in secure storage. Poneva verifies the connection before saving it.':
      '{value1} A jelszava titkosítva, biztonságos tárhelyen kerül tárolásra. A Poneva mentés előtt ellenőrzi a kapcsolatot.',
    'Testing…': 'Tesztelés…',
    'Test connection': 'Kapcsolat tesztelése',
    'PostgreSQL is connected.': 'A PostgreSQL csatlakoztatva.',
    'PostgreSQL was saved safely.': 'A PostgreSQL biztonságosan mentve.',
    'Poneva can read and change rows in the selected tables. Apps also follow their approved data scope.':
      'A Poneva olvashatja és módosíthatja a kijelölt táblák sorait. Az Appok szintén a jóváhagyott adathatókörüket követik.',
    'Poneva can read the selected tables. Apps also follow their approved data scope.':
      'A Poneva olvashatja a kijelölt táblákat. Az Appok szintén a jóváhagyott adathatókörüket követik.',
    'Reads are paused until permission is enabled.':
      'Az olvasás szünetel, amíg a jogosultságot engedélyezik.',
    'Retrying…': 'Újrapróbálkozás…',
    'Retry permission': 'Jogosultság újbóli kérése',
    'Try it in Chat': 'Kipróbálás a Chatben',
    Done: 'Kész',
    'Disconnect database': 'Adatbázis leválasztása',
    '{value1} TLS verified ·{value2} {value3}': '{value1} TLS ellenőrizve ·{value2} {value3}',
    'Search schemas and tables': 'Sémák és táblák keresése',
    'Search tables': 'Táblák keresése',
    '{value1} of {value2} tables selected': '{value1} / {value2} tábla kijelölve',
    'Select matching tables': 'Egyező táblák kijelölése',
    'Select all tables': 'Összes tábla kijelölése',
    Clear: 'Törlés',
    'Select a whole schema or individual tables. New tables need a fresh selection.':
      'Jelöljön ki egy teljes sémát vagy egyes táblákat. Az új táblákat ismét ki kell jelölni.',
    'No tables match this search.': 'Nincs a keresésnek megfelelő tábla.',
    'All tables in {value1}': 'A(z) {value1} összes táblája',
    '{value1} / {value2} tables': '{value1} / {value2} tábla',
    'Read & write available': 'Olvasás és írás engedélyezve',
    'Read only': 'Csak olvasás',
    Ctrl: 'Ctrl',
    'This suggested knowledge update could not be shown.':
      'Ez a javasolt tudásfrissítés nem jeleníthető meg.',
    'Suggested knowledge update': 'Javasolt tudásfrissítés',
    'This suggestion is no longer available to you.':
      'Ez a javaslat már nem érhető el az Ön számára.',
    'We could not check where this suggestion stands.':
      'Nem sikerült ellenőrizni, hogy mi a javaslat állapota.',
    'Check again': 'Újraellenőrzés',
    'Show on page': 'Megjelenítés az oldalon',
    'The editor could not be loaded. Poneva may have been updated since you opened this page. Reload to get the latest version; nothing on this page has changed.':
      'Nem sikerült betölteni a szerkesztőt. Lehet, hogy a Poneva frissült az oldal megnyitása óta. Töltse újra az oldalt a legújabb verzióért; ezen az oldalon semmi sem változott.',
    'Reload Poneva': 'Poneva újratöltése',
    Formatting: 'Formázás',
    'Text style': 'Szövegstílus',
    Text: 'Szöveg',
    Heading: 'Címsor',
    Subheading: 'Alcím',
    'Link a page': 'Oldalhivatkozás',
    'A page needs a title.': 'Az oldalnak címmel kell rendelkeznie.',
    'Nothing has changed yet.': 'Még semmi sem változott.',
    'A page needs some text. To remove a page, archive it instead.':
      'Az oldalnak tartalmaznia kell szöveget. Oldal eltávolításához archiválja azt.',
    'A suggested new page needs some text.': 'A javasolt új oldalnak tartalmaznia kell szöveget.',
    'This page is larger than 256 KB. Split it into smaller pages.':
      'Ez az oldal nagyobb 256 KB-nál. Ossza fel kisebb oldalakra.',
    'Say in a few words why this change is right.':
      'Néhány szóban írja le, miért helyes ez a módosítás.',
    'This page changed while you were editing. Your text is still here: copy it, then open the latest version and make your change again.':
      'Az oldal szerkesztés közben megváltozott. A szövege továbbra is itt van: másolja ki, majd nyissa meg a legújabb verziót, és hajtsa végre újra a módosítást.',
    'Your text is copied.': 'A szöveg másolása megtörtént.',
    'Your text could not be copied. Select it in the editor and copy it.':
      'Nem sikerült másolni a szöveget. Jelölje ki a szerkesztőben, majd másolja ki.',
    'The page “{value1}” is created.': 'A(z) „{value1}” oldal létrejött.',
    'New page': 'Új oldal',
    'Editing {value1}': '{value1} szerkesztése',
    Editing: 'Szerkesztés',
    'Creating publishes the page under {value1} for everyone':
      'A létrehozás mindenki számára közzéteszi az oldalt a(z) {value1} alatt',
    'Saving publishes the new version for everyone':
      'A mentés mindenki számára közzéteszi az új verziót',
    'Your changes are sent as a suggestion for a publisher':
      'A módosításait javaslatként elküldjük egy közzétevőnek',
    'Create page': 'Oldal létrehozása',
    Save: 'Mentés',
    'Send suggestion': 'Javaslat küldése',
    '{value1} Copy my text': '{value1} Szövegem másolása',
    'Open the latest version': 'Legújabb verzió megnyitása',
    'Page title': 'Oldal címe',
    'Loading the editor…': 'Szerkesztő betöltése…',
    'New page text': 'Új oldal szövege',
    'Text of {value1}': '{value1} szövege',
    'Write the page. Type [[ to link another page.':
      'Írja meg az oldalt. Másik oldal hivatkozásához írja be ezt: [[',
    'Type [[ to link another page.': 'Másik oldal hivatkozásához írja be ezt: [[',
    'Link to a page': 'Hivatkozás egy oldalra',
    'What changed, in a few words': 'Mi változott, néhány szóban',
    'Where this comes from, in a few words': 'Honnan származik, néhány szóban',
    'Shown in the page history.': 'Az oldalelőzményekben jelenik meg.',
    'A publisher sees this next to your change.': 'A közzétevő ezt a módosítása mellett látja.',
    '1 suggestion is open on this page': '1 nyitott javaslat van ezen az oldalon',
    '{value1} suggestions are open on this page': '{value1} nyitott javaslat van ezen az oldalon',
    'They stay open while you edit. After you save, they show against your new text; one whose words you changed is marked outdated.':
      'Szerkesztés közben nyitva maradnak. Mentés után az új szöveggel jelennek meg; az elavultként lesz megjelölve, amelynek a szavait módosította.',
    'Type [[ to link another page. Links keep working when a page is renamed or moved.':
      'Másik oldal hivatkozásához írja be ezt: [[. A hivatkozások akkor is működnek, ha egy oldalt átneveznek vagy áthelyeznek.',
    'Loading the history…': 'Előzmények betöltése…',
    'This page has no saved text yet.': 'Ehhez az oldalhoz még nincs mentett szöveg.',
    'Say in a few words why this revision should come back.':
      'Néhány szóban írja le, miért kellene visszaállítani ezt a verziót.',
    'Revision {value1} is suggested for a publisher to accept.':
      'A(z) {value1} verziót elfogadásra javasoltuk egy közzétevőnek.',
    'The page already reads like this revision.':
      'Az oldal már ennek a verziónak a szövegét tartalmazza.',
    'Revision {value1} is restored as revision {value2}.':
      'A(z) {value1} verzió visszaállítása megtörtént {value2} verzióként.',
    'Revision history': 'Verzióelőzmények',
    Revisions: 'Verziók',
    'Every saved revision is kept.': 'Minden mentett verzió megmarad.',
    'Revision {value1} {value2}': '{value1}. verzió, {value2}',
    'Revision {value1} compared with revision {value2}':
      '{value1}. verzió összehasonlítva a(z) {value2} verzióval',
    'Revision {value1}, the first text of this page': '{value1}. verzió, az oldal első szövege',
    'Green was added, struck through was removed.':
      'A zölddel jelölt részeket hozzáadtuk, az áthúzott részeket eltávolítottuk.',
    '{value1} Export Markdown': '{value1} Markdown exportálása',
    'Restore this revision': 'Verzió visszaállítása',
    'Suggest restoring it': 'Visszaállítás javaslata',
    'Why should this revision come back?': 'Miért kellene visszaállítani ezt a verziót?',
    'Loading this revision…': 'Verzió betöltése…',
    'Only the title changed, from “{value1}” to “{value2}”.':
      'Csak a cím változott „{value1}” címről erre: „{value2}”.',
    'The text did not change in this revision.': 'A szöveg nem változott ebben a verzióban.',
    'Changes in revision {value1}': 'A(z) {value1} verzió módosításai',
    'Loading page…': 'Oldal betöltése…',
    'Loading suggestion…': 'Javaslat betöltése…',
    'This suggestion is not available.': 'Ez a javaslat nem érhető el.',
    'It may have been decided, or it is not one you can see.':
      'Lehet, hogy már döntés született róla, vagy nem tekintheti meg.',
    'Open Knowledge': 'Tudás megnyitása',
    'Opening the suggestion…': 'Javaslat megnyitása…',
    'Choose where the page goes.': 'Válassza ki, hová kerüljön az oldal.',
    'Say in a few words why.': 'Néhány szóban írja le, miért.',
    'Your suggestion is sent. A publisher decides.':
      'A javaslatát elküldtük. Egy közzétevő dönt róla.',
    'Moved under {value1}.': 'Áthelyezve a(z) {value1} alá.',
    'Deleted “{value1}”.': '„{value1}” törölve.',
    'Archived. Its history is kept.': 'Archiválva. Az előzményei megmaradnak.',
    'Choose the page it goes under. Links to it keep working.':
      'Válaszd ki, melyik oldal alá kerüljön. A rá mutató hivatkozások továbbra is működnek.',
    'Its text, its history and any open suggestions are removed for good, and links to it from other pages stop working. This cannot be undone.':
      'A szövege, az előzményei és a nyitott javaslatok végleg törlődnek, a más oldalakról rá mutató hivatkozások pedig nem működnek többé. Ez nem vonható vissza.',
    'An archived page no longer informs answers. Its history is kept, and a publisher can restore it or delete it permanently.':
      'Az archivált oldal többé nem járul hozzá a válaszokhoz. Az előzményei megmaradnak, és egy közzétevő visszaállíthatja vagy végleg törölheti.',
    Under: 'Alatta',
    Change: 'Módosítás',
    'Move under': 'Áthelyezés ide:',
    'Search pages': 'Oldalak keresése',
    'Why?': 'Miért?',
    'Delete permanently': 'Végleges törlés',
    'Move page': 'Oldal áthelyezése',
    'Archive page': 'Oldal archiválása',
    'Suggestion {value1}: show its card': '{value1}. javaslat: kártya megjelenítése',
    'Removed:': 'Eltávolítva:',
    'Added:': 'Hozzáadva:',
    'New page “{value1}”{value2}': 'Új oldal: „{value1}”{value2}',
    'No pages match “{value1}”.': 'Nincs „{value1}” egyezésű oldal.',
    'Where this page is': 'Az oldal helye',
    'Describe your company': 'Mutasd be a cégedet',
    'Empty page': 'Üres oldal',
    'Describe {value1}': '{value1} bemutatása',
    'This page has no text yet.': 'Ezen az oldalon még nincs szöveg.',
    'Poneva reads this page before every answer. Start with who you are, what you sell and how you work; details go on the pages under it.':
      'A Poneva minden válasz előtt elolvassa ezt az oldalt. Kezdd annak bemutatásával, hogy kik vagytok, mit értékesítetek és hogyan dolgoztok; a részletek az alatta lévő oldalakra kerülnek.',
    'Write it, or ask Poneva in chat to draft it for you.':
      'Írd meg, vagy kérd meg a Ponevát a csevegésben, hogy készítsen róla első változatot.',
    'Suggest a first version, and a publisher decides whether it becomes the page.':
      'Javasolj egy első változatot, és egy közzétevő eldönti, hogy az oldal végleges tartalma legyen-e.',
    'Start writing': 'Írás megkezdése',
    'Suggest a first version': 'Első változat javaslata',
    'Accepted. The page is archived.': 'Elfogadva. Az oldal archiválva.',
    'Accepted. The page is now revision {value1}.':
      'Elfogadva. Az oldal most a(z) {value1}. verzió.',
    'Accepted.': 'Elfogadva.',
    'Suggestion rejected. The page stays as it is.':
      'A javaslat elutasítva. Az oldal változatlan marad.',
    'Your suggestion is withdrawn.': 'A javaslatodat visszavontad.',
    'Restored. The page informs answers again.':
      'Visszaállítva. Az oldal ismét hozzájárul a válaszokhoz.',
    'Your suggestion is sent. A publisher decides whether it becomes the page.':
      'A javaslatodat elküldtük. Egy közzétevő eldönti, hogy az oldal tartalma legyen-e.',
    'Saved. The page is now revision {value1}.': 'Mentve. Az oldal most a(z) {value1}. verzió.',
    'Nothing changed.': 'Nem történt változás.',
    'This page is not available.': 'Ez az oldal nem érhető el.',
    'It may have been deleted, archived or moved out of reach, or you may no longer be in this company.':
      'Lehet, hogy törölték, archiválták vagy olyan helyre helyezték át, amelyhez nincs hozzáférésed, illetve az is lehet, hogy már nem vagy ennél a cégnél.',
    'Page actions': 'Oldalműveletek',
    shown: 'megjelenítve',
    hidden: 'rejtve',
    '{value1} History': '{value1} előzményei',
    '{value1} Ask in chat': '{value1} Kérdezés a csevegésben',
    'Suggest edits': 'Módosítások javaslata',
    'More actions for {value1}': 'További műveletek ehhez: {value1}',
    '{value1} Poneva reads this page in every chat':
      '{value1} A Poneva minden csevegésben elolvassa ezt az oldalt',
    'This page is archived. It no longer informs answers; its history is kept. {value1}':
      'Ez az oldal archiválva van. Többé nem járul hozzá a válaszokhoz, az előzményei azonban megmaradnak. {value1}',
    'Restore page': 'Oldal visszaállítása',
    'This link points to an earlier revision. You are reading the current text.':
      'Ez a hivatkozás egy korábbi verzióra mutat. Jelenleg az aktuális szöveget olvasod.',
    'Show it in History': 'Megjelenítés az előzményekben',
    Pages: 'Oldalak',
    'Pages under {value1}': '{value1} alatti oldalak',
    'Linked from': 'Hivatkozások innen',
    Suggestions: 'Javaslatok',
    'Suggestions are hidden. You are reading the page as everyone else sees it.':
      'A javaslatok rejtve vannak. Az oldalt úgy olvasod, ahogyan mindenki más látja.',
    'Loading suggestions…': 'Javaslatok betöltése…',
    'Nothing is waiting for review.': 'Nincs ellenőrzésre váró elem.',
    'When someone, Poneva in a chat or a connected agent suggests a change to a page, it shows here and on the page. Nothing changes until a publisher accepts it.':
      'Ha valaki, a Poneva egy csevegésben vagy egy csatlakoztatott ügynök módosítást javasol egy oldalon, az itt és az oldalon is megjelenik. Semmi sem változik, amíg egy közzétevő el nem fogadja.',
    '{value1} Review knowledge in chat': '{value1} Tudás áttekintése a csevegésben',
    'Suggestions for review': 'Ellenőrzésre váró javaslatok',
    'Suggested changes from chats, meetings, colleagues and connected agents. Nothing changes until a publisher accepts it on the page.':
      'Csevegésekből, megbeszélésekből, kollégáktól és csatlakoztatott ügynököktől származó módosítási javaslatok. Semmi sem változik, amíg egy közzétevő el nem fogadja őket az oldalon.',
    'Your suggestions wait here until a publisher decides. The pages stay as they are until then.':
      'A javaslataid itt várakoznak, amíg egy közzétevő döntést nem hoz róluk. Addig az oldalak változatlanok maradnak.',
    'Review page': 'Oldal áttekintése',
    'Review on page': 'Áttekintés az oldalon',
    'Open the meeting': 'Megbeszélés megnyitása',
    'Open the chat': 'Csevegés megnyitása',
    'Accept and restore': 'Elfogadás és visszaállítás',
    Accept: 'Elfogadás',
    Reject: 'Elutasítás',
    'Your suggestion · waiting for a publisher': 'A javaslatod · közzétevőre vár',
    Withdraw: 'Visszavonás',
    'Waiting for a publisher': 'Közzétevőre vár',
    'Suggestion {value1}': '{value1}. javaslat',
    'Suggestion {value1} from {value2}{value3}': '{value1}. javaslat innen: {value2}{value3}',
    'Read the suggested page': 'Javasolt oldal elolvasása',
    'Outdated: the text it changes was edited after it was suggested. It can be rejected or withdrawn; a new suggestion can be made against the current text.':
      'Elavult: a módosítani kívánt szöveget a javaslat létrehozása után szerkesztették. Elutasíthatod vagy visszavonhatod; az aktuális szöveghez új javaslat készíthető.',
    'Restore this page first to accept this suggestion.':
      'A javaslat elfogadásához előbb állítsd vissza ezt az oldalt.',
    'Previous suggestion': 'Előző javaslat',
    'Suggestion {value1} of {value2}': '{value1}. javaslat / {value2}',
    'Next suggestion': 'Következő javaslat',
    'Fold the suggestions away': 'Javaslatok összecsukása',
    'Show the suggestions': 'Javaslatok megjelenítése',
    '1 suggestion': '1 javaslat',
    '{value1} suggestions': '{value1} javaslat',
    '{value1} the pages under {value2}': '{value1} a(z) {value2} alatti oldalt',
    px: 'px',
    '{value1} chart of {value2} across {value3}':
      '{value1} diagram a(z) {value2} adatairól {value3} szerint',
    'We could not build the file.': 'Nem sikerült létrehozni a fájlt.',
    '{value1} Present': '{value1} jelen van',
    'Building…': 'Létrehozás…',
    'Download PowerPoint': 'PowerPoint letöltése',
    'Slide {value1} of {value2}': '{value1}. dia / {value2}',
    Slides: 'Diák',
    'Slide {value1}': '{value1}. dia',
    'Speaker notes': 'Előadói jegyzetek',
    'Source: {value1}': 'Forrás: {value1}',
    'Add a name and a web address.': 'Adjon meg egy nevet és egy webcímet.',
    'Enter a valid web address.': 'Adjon meg érvényes webcímet.',
    'Use a web address that starts with https://.':
      'https:// előtaggal kezdődő webcímet használjon.',
    'Add a custom connection': 'Egyéni kapcsolat hozzáadása',
    'Connect a tool server you trust. Poneva checks the address works and saves only the connection details needed to use it.':
      'Csatlakoztasson egy megbízható eszközszervert. A Poneva ellenőrzi, hogy a cím működik-e, és csak a használatához szükséges kapcsolati adatokat menti.',
    'Web address': 'Webcím',
    'https://tools.example.com': 'https://tools.example.com',
    'Starts with https://, from your provider':
      'A szolgáltatótól kapott, https:// előtaggal kezdődő cím',
    'Sign-in': 'Bejelentkezés',
    'Advanced sign-in': 'Speciális bejelentkezés',
    'Access key {value1}': 'Hozzáférési kulcs: {value1}',
    'Request headers': 'Kérésfejlécek',
    'Add header': 'Fejléc hozzáadása',
    'Header {value1} name': 'A(z) {value1}. fejléc neve',
    'Header name': 'Fejléc neve',
    'Header {value1} value': 'A(z) {value1}. fejléc értéke',
    'Header value': 'Fejléc értéke',
    'Remove header': 'Fejléc eltávolítása',
    Advanced: 'Speciális',
    Transport: 'Átvitel',
    'Auto-detect': 'Automatikus felismerés',
    'Streamable HTTP': 'Streamable HTTP',
    'Legacy SSE': 'Régi SSE',
    "From your provider's app settings. Leave empty unless they gave you these.":
      'A szolgáltató alkalmazásbeállításaiból. Hagyja üresen, hacsak nem kapta meg ezeket az adatokat.',
    "Authorization server issuer": "Engedélyezési kiszolgáló kibocsátója",
    "Enter the authorization server issuer when using a client ID.": "Ügyfélazonosító használatakor adja meg az engedélyezési kiszolgáló kibocsátóját.",
    'Client ID {value1}': 'Ügyfél-azonosító: {value1}',
    'Client secret {value1}': 'Ügyféltitok: {value1}',
    'Connecting…': 'Kapcsolódás…',
    'Test and connect': 'Tesztelés és kapcsolódás',
    'Add the store, the client ID and the client secret.':
      'Adja meg az áruházat, az ügyfél-azonosítót és az ügyféltitkot.',
    'Connect your Shopify Developer App': 'Shopify fejlesztői alkalmazás csatlakoztatása',
    'Poneva can use exactly the access your store gave the app, and nothing more. It talks to Shopify directly and keeps the client secret encrypted.':
      'A Poneva pontosan az alkalmazásnak megadott áruházi hozzáférést használhatja, semmi többet. Közvetlenül kommunikál a Shopifyjal, és titkosítva tárolja az ügyféltitkot.',
    'How to create the app in Shopify': 'Az alkalmazás létrehozása a Shopifyban',
    'Open{value1} {value2}{value3} with the account that owns the store, and create an app.':
      'Nyissa meg{value1} a(z) {value2}{value3} elemet az áruház tulajdonosi fiókjával, majd hozzon létre egy alkalmazást.',
    'Create a version and select the access scopes Poneva may use, for example read_products and read_orders. Add write_ scopes only for data Poneva may change. Then release the version.':
      'Hozzon létre egy verziót, és válassza ki a Poneva által használható hozzáférési hatóköröket, például a read_products és read_orders hatókört. Csak azokhoz az adatokhoz adjon hozzá write_ hatóköröket, amelyeket a Poneva módosíthat. Ezután tegye közzé a verziót.',
    'For orders and customers, also select protected customer data in the app’s settings. Shopify allows this without review for an app made for your own store.':
      'A rendelésekhez és ügyfelekhez az alkalmazás beállításaiban válassza ki a védett ügyféladatokat is. A Shopify ezt felülvizsgálat nélkül engedélyezi a saját áruházához készült alkalmazásoknál.',
    'Install the app on your store.': 'Telepítse az alkalmazást az áruházába.',
    'Copy the client ID and client secret from the app’s settings.':
      'Másolja ki az ügyfél-azonosítót és az ügyféltitkot az alkalmazás beállításaiból.',
    'To change the access later, release a new version, approve it on the store and use Test connection here.':
      'A hozzáférés későbbi módosításához tegyen közzé egy új verziót, hagyja jóvá az áruházban, majd használja itt a Kapcsolat tesztelése lehetőséget.',
    Store: 'Áruház',
    'your-store.myshopify.com': 'your-store.myshopify.com',
    'Your store’s .myshopify.com address (Shopify admin → Settings → Domains), or paste the address of your Shopify admin page':
      'Az áruház .myshopify.com címe (Shopify adminisztráció → Beállítások → Domainek), vagy illessze be a Shopify adminisztrációs oldalának címét',
    'Client ID {value1} {value2}': 'Ügyfél-azonosító: {value1} {value2}',
    'Client secret {value1} {value2}': 'Ügyféltitok: {value1} {value2}',
    Person: 'Személy',
    Everyone: 'Mindenki',
    Connection: 'Kapcsolat',
    'All connections': 'Minden kapcsolat',
    'App {value1}': 'Alkalmazás: {value1}',
    'From {value1}': 'Ettől: {value1}',
    'Until {value1}': 'Eddig: {value1}',
    Result: 'Eredmény',
    'All results': 'Minden eredmény',
    Succeeded: 'Sikeres',
    Denied: 'Elutasítva',
    Failed: 'Sikertelen',
    Unknown: 'Ismeretlen',
    Filter: 'Szűrő',
    'Loading activity…': 'Tevékenység betöltése…',
    'Could not load activity. Try again.': 'Nem sikerült betölteni a tevékenységet. Próbálja újra.',
    'Removed connection': 'Eltávolított kapcsolat',
    'App: {value1}': 'Alkalmazás: {value1}',
    'Older activity': 'Régebbi tevékenység',
    Download: 'Letöltés',
    CSV: 'CSV',
    'Evidence for {value1}': '{value1} bizonyítékai',
    Measure: 'Mérőszám',
    'Show rows →': 'Sorok megjelenítése →',
    'Ask about this number': 'Kérdezz erről a számról',
    'There are no numeric values available to chart. View the table for the original data.':
      'Nincsenek diagramhoz használható numerikus értékek. Az eredeti adatokért tekintsd meg a táblázatot.',
    'Chart value': 'Diagramérték',
    '{value1} of {value2} shown': '{value1} / {value2} megjelenítve',
    '{value1} by {value2}; {value3} rows. View Table for exact values.':
      '{value1} × {value2}; {value3} sor. A pontos értékekért tekintsd meg a táblázatot.',
    'Values come directly from the source data. Missing values are not estimates.':
      'Az értékek közvetlenül a forrásadatokból származnak. A hiányzó értékek nem becslések.',
    'Loading library…': 'Könyvtár betöltése…',
    'We couldn’t load what happened in this App. Try again in a moment.':
      'Nem sikerült betölteni, mi történt ebben az alkalmazásban. Próbáld újra egy kis idő múlva.',
    'This App could not be opened.': 'Az alkalmazást nem sikerült megnyitni.',
    'Opening App…': 'Alkalmazás megnyitása…',
    'Open the saved App to run this function.':
      'A funkció futtatásához nyisd meg a mentett alkalmazást.',
    'Save this App before running its function.':
      'A funkció futtatása előtt mentsd az alkalmazást.',
    'Open saved App': 'Mentett alkalmazás megnyitása',
    'Open Apps': 'Alkalmazások megnyitása',
    'The App could not be opened. Try again.':
      'Az alkalmazást nem sikerült megnyitni. Próbáld újra.',
    Owner: 'Tulajdonos',
    '{value1} · admins': '{value1} · rendszergazda',
    'Owner · always edits': 'Tulajdonos · mindig szerkeszthet',
    'Admins manage it': 'A rendszergazdák kezelik',
    Editors: 'Szerkesztők',
    'A colleague': 'Egy munkatárs',
    'Can edit drafts and publish versions':
      'Szerkesztheti a piszkozatokat és közzéteheti a verziókat',
    Remove: 'Eltávolítás',
    'No editors yet.': 'Még nincsenek szerkesztők.',
    'Admins can always edit company agents.':
      'A rendszergazdák mindig szerkeszthetik a vállalati ügynököket.',
    'Asking for edit access': 'Szerkesztési hozzáférés kérése',
    'Asked {value1} · also in your Inbox': 'Kérve: {value1} · a Beérkezett üzenetek között is',
    Grant: 'Engedélyezés',
    Admin: 'Rendszergazda',
    'Make personal': 'Személyessé tétel',
    'Switch off': 'Kikapcsolás',
    Archive: 'Archiválás',
    'Archive this agent': 'Ügynök archiválása',
    'Loading agent…': 'Ügynök betöltése…',
    '{value1} Edit in chat': '{value1} Szerkesztés csevegésben',
    Agent: 'Ügynök',
    'This agent has not been created yet. It can run once its owner creates it.':
      'Ez az ügynök még nem lett létrehozva. Akkor futtatható, ha a tulajdonosa létrehozza.',
    'New agent · Draft': 'Új ügynök · Piszkozat',
    'Untitled agent': 'Névtelen ügynök',
    'Test run': 'Tesztfuttatás',
    'This draft does not run automatically.': 'Ez a piszkozat nem fut automatikusan.',
    'Describe the agent in the chat. Its draft appears here.':
      'Írd le az ügynököt a csevegésben. A piszkozata itt jelenik meg.',
    '{value1} Test run': '{value1} Tesztfuttatás',
    'Describe the agent in the chat first.': 'Először írd le az ügynököt a csevegésben.',
    'Create and turn on': 'Létrehozás és bekapcsolás',
    'Connection write setup': 'Kapcsolat írási beállítása',
    'Account for connected changes': 'Fiók a kapcsolódó módosításokhoz',
    'Choose a connection': 'Válassz kapcsolatot',
    'No published Skills available. You can add them later.':
      'Nincsenek közzétett készségek. Később hozzáadhatod őket.',
    '{value1} · not published. Review the changes. Testing is optional.':
      '{value1} · nincs közzétéve. Tekintsd át a módosításokat. A tesztelés nem kötelező.',
    '{value1} Test draft': '{value1} Piszkozat tesztelése',
    'Apply changes…': 'Módosítások alkalmazása…',
    'Apply this draft as a new version': 'Piszkozat alkalmazása új verzióként',
    'This draft cannot be applied.': 'Ez a piszkozat nem alkalmazható.',
    'What changed?': 'Mi változott?',
    'Apply version {value1}': '{value1}. verzió alkalmazása',
    Create: 'Létrehozás',
    'Edit access requested': 'Szerkesztési hozzáférés kérve',
    '{value1} Request edit access': '{value1} Szerkesztési hozzáférés kérése',
    '{value1} Copy agent': '{value1} Ügynök másolása',
    Pause: 'Szüneteltetés',
    'Open agent: {value1}': 'Ügynök megnyitása: {value1}',
    '· you can edit': '· szerkesztheted',
    '{value1} is switched off.': '{value1} ki van kapcsolva.',
    '{value1} is archived.': '{value1} archiválva van.',
    'Loading agents…': 'Ügynökök betöltése…',
    Agents: 'Ügynökök',
    'Agents do work for you on a schedule or when you ask. They follow your company’s Skills.':
      'Az ügynökök ütemezés szerint vagy kérésre dolgoznak neked. A vállalatod készségeit követik.',
    'No agent matches. Try a Skill name or what the agent should do.':
      'Nincs egyező ügynök. Próbálkozz egy készség nevével vagy annak leírásával, hogy mit kell tennie az ügynöknek.',
    'Nothing of your own yet': 'Még nincs saját tartalmad',
    'Tell Chat what an agent should do, or copy one of the company’s agents below.{value1}':
      'Mondd el a Chatnek, mit kell tennie egy ügynöknek, vagy másold le alább a vállalat egyik ügynökét.{value1}',
    'Your agents': 'Ügynökeid',
    'Run on demand': 'Igény szerinti futtatás',
    'Run is always available. A schedule is optional and lives separately from the agent’s instructions.':
      'A futtatás mindig elérhető. Az ütemezés nem kötelező, és az ügynök utasításaitól különállóan működik.',
    'What changed in version {value1}': 'Mi változott a(z) {value1} verzióban',
    'Every publish is a version you can restore.': 'Minden közzététel egy visszaállítható verzió.',
    Authorization: 'Engedélyezés',
    '{value1} {value2} · {value3} will see it.': '{value1} {value2} · {value3} látni fogja.',
    '{value1} {value2} you': '{value1} {value2} Ön',
    '· Revised': '· Módosítva',
    'This chat used your {value1}.': 'Ez a csevegés az Ön {value1} elemét használta.',
    'This chat has results from {value1}.': 'Ez a csevegés a(z) {value1} eredményeit tartalmazza.',
    'db.example.com': 'db.example.com',
    'e.g. Product analytics': 'pl. Termékelemzés',
    'Paste access key': 'Illessze be a hozzáférési kulcsot',
    'Shopify’s Dev Dashboard': 'A Shopify fejlesztői irányítópultja',
    'App reference': 'Alkalmazáshivatkozás',
    'Draft · revision {value1}': 'Piszkozat · {value1}. módosítás',
    'its Result': 'az eredménye',
    '· its first run makes it': '· az első futtatása ezt eredményezi',
    '{value1}’s chat ·': '{value1} csevegése ·',
    '{value1} ad {value2} available.': '{value1} és {value2} elérhető.',
    '{value1} rows ·': '{value1} sor ·',
    'It starts private. Sharing it wider shares every refresh, which can carry your private data.':
      'Kezdetben privát. Szélesebb körű megosztás esetén minden frissítés megosztásra kerülhet, beleértve a privát adatait is.',
    'Enable this schedule when approved': 'Jóváhagyás után engedélyezi ezt az ütemezést',
    Schedule: 'Ütemezés',
    'Kept off until you create the agent from its canvas.':
      'Kikapcsolva marad, amíg létre nem hozza az ügynököt a vásznáról.',
    'Will be enabled when you approve.': 'Jóváhagyáskor engedélyezve lesz.',
    'Will be saved paused. You can enable it later.':
      'Szüneteltetve lesz mentve. Később engedélyezheti.',
    'Only runs when you ask.': 'Csak kérésre fut.',
    'Draft · approving saves it, and nothing runs. Test it and create it from its canvas.':
      'Piszkozat · a jóváhagyás menti, és semmi sem fut le. Tesztelje, majd hozza létre a vásznáról.',
    'Draft · nothing is scheduled until you approve. Connected actions require their own approval at run time.':
      'Piszkozat · jóváhagyásig semmi sincs ütemezve. A csatlakoztatott műveletek futtatáskor külön jóváhagyást igényelnek.',
    Name: 'Név',
    'Agent name': 'Ügynök neve',
    'Who can use it': 'Ki használhatja',
    'Company agent · company resources only': 'Vállalati ügynök · csak vállalati erőforrások',
    'Personal agent · runs with your access': 'Személyes ügynök · az Ön hozzáférésével fut',
    'Approving saves it as a draft. It does not run automatically.':
      'A jóváhagyás piszkozatként menti. Nem fut automatikusan.',
    'Open the agent’s runs': 'Ügynök futtatásainak megnyitása',
    'Run the published version once': 'A közzétett verzió egyszeri futtatása',
    'Stopping…': 'Leállítás…',
    'Stop run': 'Futtatás leállítása',
    'Could not stop this run. Please try again.':
      'Nem sikerült leállítani ezt a futtatást. Próbálja újra.',
    'Run in progress': 'Futtatás folyamatban',
    'This run is still answering. You can ask follow-ups when it finishes.':
      'Ez a futtatás még választ ad. Ha befejeződött, további kérdéseket tehet fel.',
    'Open run details': 'Futtatás részleteinek megnyitása',
    Runs: 'Futtatások',
    'Open the run chat': 'Futtatási csevegés megnyitása',
    Watch: 'Megtekintés',
    Goal: 'Cél',
    'Change the goal': 'Cél módosítása',
    'What it does': 'Mit csinál',
    'What should this agent achieve?': 'Mit kell elérnie ennek az ügynöknek?',
    'Not set yet.': 'Még nincs beállítva.',
    'When it runs': 'Mikor fut',
    'Change when it runs': 'Futtatási időpont módosítása',
    'Off means it runs only when someone runs it. Changing when it runs never changes its instructions.':
      'A kikapcsolt állapot azt jelenti, hogy csak akkor fut, amikor valaki elindítja. A futtatási időpont módosítása soha nem változtatja meg az utasításait.',
    Instructions: 'Utasítások',
    'Change the instructions': 'Utasítások módosítása',
    'How the agent should approach the work and make decisions.':
      'Hogyan közelítse meg az ügynök a feladatot, és hogyan hozzon döntéseket.',
    Boundaries: 'Korlátok',
    'What to do or avoid. Every connected action still follows its approval.':
      'Mit tegyen vagy kerüljön el. Minden csatlakoztatott művelet továbbra is a saját jóváhagyását követi.',
    'No instructions of its own. It follows its Skills.':
      'Nincsenek saját utasításai. A Képességeit követi.',
    'Pin a Skill': 'Képesség rögzítése',
    'Finds the Skills that fit each run, the same way a chat does.':
      'Minden futtatáshoz megtalálja a megfelelő Képességeket, ugyanúgy, mint egy csevegés.',
    'Skills it always follows': 'Mindig követett Képességek',
    'A Skill that is not published': 'Nem közzétett Képesség',
    'Always follows · Version {value1}': 'Mindig követi · {value1}. verzió',
    'Not published': 'Nincs közzétéve',
    Uses: 'Használja',
    'Change in chat': 'Módosítás csevegésben',
    'Change in chat: Uses': 'Módosítás csevegésben: Használja',
    'Company knowledge and the tools each run is allowed to use.':
      'A vállalati tudás és a futtatások által használható eszközök.',
    'People see the Result refresh; they change the agent, not the page.':
      'A felhasználók az Eredmény frissülését látják; az ügynököt módosítják, nem az oldalt.',
    'The first run after it is created makes the Result; later runs add a version to it.':
      'A létrehozás utáni első futtatás létrehozza az Eredményt; a későbbi futtatások új verziót adnak hozzá.',
    'Emails whoever the run is for': 'E-mailt küld a futtatás címzettjének',
    'Email each run': 'E-mail küldése minden futtatásról',
    Delivers: 'Ezt adja át',
    'Change what it delivers': 'Átadott tartalom módosítása',
    'Expected result': 'Várt eredmény',
    'What a successful run should deliver.': 'Amit egy sikeres futtatásnak át kell adnia.',
    'What each run delivers': 'Amit az egyes futtatások átadnak',
    'Keeps one Result up to date {value1}': 'Egy Eredményt naprakészen tart {value1}',
    'Saves a new Result each run': 'Minden futtatáskor új Eredményt ment',
    'You can run this company agent as yourself.{value1} {value2}':
      'Ezt a vállalati ügynököt saját nevében futtathatja.{value1} {value2}',
    'Changes since version': 'Változások a verzió óta',
    'are not live yet.': 'még nem élesek.',
    'Review them in Versions': 'Tekintse át őket a Verziók között',
    Skill: 'Képesség',
    'The agent always uses the Skill’s published version.':
      'Az ügynök mindig a Képesség közzétett verzióját használja.',
    Day: 'Nap',
    Time: 'Időpont',
    'Cron expression': 'Cron-kifejezés',
    'Editors and access': 'Szerkesztők és hozzáférés',
    Company: 'Vállalati',
    Personal: 'Személyes',
    'No changes.': 'Nincsenek változások.',
    'Instructions changes': 'Utasítások változásai',
    'Loading versions…': 'Verziók betöltése…',
    'What the draft changes': 'A piszkozat változásai',
    'No published version yet. Try the draft, then publish it.':
      'Még nincs közzétett verzió. Próbálja ki a piszkozatot, majd tegye közzé.',
    'Published versions': 'Közzétett verziók',
    'Former member': 'Korábbi tag',
    Live: 'Élő',
    '{value1} for {value2}': '{value1} ehhez: {value2}',
    Suggested: 'Javasolt',
    'Opening your conversation…': 'Beszélgetés megnyitása…',
    'This conversation isn’t available': 'Ez a beszélgetés nem érhető el',
    'It may have been deleted, belong to another account, or be temporarily unavailable.':
      'Lehet, hogy törölték, egy másik fiókhoz tartozik, vagy átmenetileg nem érhető el.',
    '{count} more line — shown in the complete revision':
      'Még {count} sor — a teljes verzióban látható',
    '{count} more lines — shown in the complete revision':
      'Még {count} sor — a teljes verzióban látható',
    '{count} more line removed': 'Még {count} sor eltávolítva',
    '{count} more lines removed': 'Még {count} sor eltávolítva',
    '{count} unchanged line': '{count} változatlan sor',
    '{count} unchanged lines': '{count} változatlan sor',
    '{count} more lines not shown, {added} added and {removed} removed. Check them in the complete revision.':
      'Még {count} sor nem látható, {added} hozzáadva és {removed} eltávolítva. Ellenőrizd őket a teljes verzióban.',
    'Saved result': 'Mentett eredmény',
    'Made with a Skill': 'Készséggel készült',
    'Preview of {name}': '{name} előnézete',
    'Made with {name}': '{name} segítségével készült',
    'Ad-hoc result': 'Eseti eredmény',
    'A Skill that is not available in this workspace':
      'Ebben a munkaterületen nem elérhető készség',
    '{name} · Revision {version}': '{name} · {version}. verzió',
    '{name} · Version {version}': '{name} · {version}. verzió',
    'Return to conversation {value1}': 'Vissza a beszélgetéshez: {value1}',
    '{value1} Working with {value2}': '{value1} dolgozik ezen: {value2}',
    'View context {value1}': 'Környezet megtekintése: {value1}',
    'A way of working, made yours.': 'Egy munkamódszer, amelyet a sajátodra formálhatsz.',
    'Work that runs itself.': 'Munka, amely magától elvégzi önmagát.',
    'One place for one piece of work.': 'Egy hely minden feladathoz.',
    'Let’s move your work forward{value1}.': 'Vigyük előre a munkádat{value1}.',
    'Describe the work. Your Skill takes shape beside the conversation.':
      'Írd le a munkát. A készséged a beszélgetés mellett formálódik.',
    'Describe what it should do and when. Your agent takes shape beside the conversation. The draft does not run automatically.':
      'Írd le, mit és mikor kell tennie. Az ügynököd a beszélgetés mellett formálódik. A piszkozat nem fut le automatikusan.',
    'Say what the work is. Poneva drafts the project beside the conversation and brings in what you have already done. Nothing is created until you say so.':
      'Mondd el, miről szól a munka. A Poneva a beszélgetés mellett elkészíti a projekt vázlatát, és hozzáadja, amit már elvégeztél. Semmi sem jön létre, amíg nem hagyod jóvá.',
    'Start with an idea below. Poneva will take it from there.':
      'Kezdj egy alábbi ötlettel. A Poneva innen átveszi a munkát.',
    Triggers: 'Aktiválók',
    'Review the agent and its trigger. Approval applies exactly what is shown.':
      'Ellenőrizd az ügynököt és az aktiválóját. A jóváhagyás pontosan a megjelenítetteket alkalmazza.',
    '{source} · read {date}': '{source} · olvasva: {date}',
    'Evidence is being recorded · read {date}':
      'Bizonyíték rögzítése folyamatban · olvasva: {date}',
    'Evidence expired on {date} under the retention policy':
      'A bizonyíték a megőrzési szabályzat alapján ekkor lejárt: {date}',
    'Entered by {person}': 'Rögzítette: {person}',
    'No retained evidence for this value': 'Ehhez az értékhez nincs megőrzött bizonyíték',
    'Covers {shown} of {total} rows': '{total} sorból {shown} lefedve',
    'Search rows': 'Sorok keresése',
    'Clear filters': 'Szűrők törlése',
    Sort: 'Rendezés',
    'Sort: {column}': 'Rendezés: {column}',
    '{shown} of {total} rows': '{total} sorból {shown}',
    More: 'Továbbiak',
    Density: 'Sűrűség',
    Comfortable: 'Kényelmes',
    Compact: 'Kompakt',
    Columns: 'Oszlopok',
    'No rows match. Clear the search or filters to see them again.':
      'Nincs egyező sor. Töröld a keresést vagy a szűrőket a sorok újbóli megjelenítéséhez.',
    'Not available': 'Nem érhető el',
    'All rows': 'Minden sor',
    'Close row detail': 'Sorrészletek bezárása',
    'Ask about this row': 'Kérdezz erről a sorról',
    'Add note': 'Jegyzet hozzáadása',
    Note: 'Jegyzet',
    Saved: 'Mentve',
    Total: 'Összesen',
    ascending: 'növekvő',
    descending: 'csökkenő',
    'Scroll to see all columns': 'Görgess az összes oszlop megtekintéséhez',
    App: 'Alkalmazás',
    Artifact: 'Artefaktum',
    'New project': 'Új projekt',
    'Review request': 'Felülvizsgálati kérelem',
    Activity: 'Tevékenység',
    'Voice preview': 'Hang-előnézet',
    Source: 'Forrás',
    File: 'Fájl',
    Meeting: 'Megbeszélés',
    'Knowledge page': 'Tudásoldal',
    'Could not preview this CSV.': 'A CSV előnézete nem jeleníthető meg.',
    'File content is unavailable.': 'A fájl tartalma nem érhető el.',
    'You have five open suggestions here. {value1} will see them.':
      'Öt nyitott javaslatod van itt. {value1} látni fogja őket.',
    'We could not send your suggestion. Please try again.':
      'Nem sikerült elküldeni a javaslatodat. Próbáld újra.',
    'The agent': 'Az ügynök',
    'Selected colleagues': 'Kiválasztott kollégák',
    'The owner': 'A tulajdonos',
    'Forked. This copy is yours and runs with your own connections.':
      'Elágaztatva. Ez a példány a tiéd, és a saját kapcsolataiddal fut.',
    'This chat is too long to fork.': 'Ez a csevegés túl hosszú az elágaztatáshoz.',
    'We could not fork this chat. Please try again.':
      'Nem sikerült elágaztatni ezt a csevegést. Próbáld újra.',
    'Anyone who forked it keeps their copy: forks stay with the people who made them.':
      'Mindenki, aki elágaztatta, megtartja a saját példányát: az elágazások annál maradnak, aki létrehozta őket.',
    'Nobody has forked this chat.': 'Senki sem ágaztatta el ezt a csevegést.',
    '1 person forked this chat. Their copy stays theirs.':
      '1 személy elágaztatta ezt a csevegést. A példány az övé marad.',
    '{value1} people forked this chat. Their copies stay theirs.':
      '{value1} személy elágaztatta ezt a csevegést. A példányaik az övék maradnak.',
    'Personal. Nobody else sees it.': 'Személyes. Senki más nem látja.',
    'People you pick. They get it in their Inbox.':
      'Az általad kiválasztott személyek. Megkapják a Beérkezett üzenetek között.',
    'Everyone in the company can follow it and fork it.':
      'A vállalat minden tagja követheti és elágaztathatja.',
    'a chat you can no longer open': 'egy csevegés, amelyet már nem tudsz megnyitni',
    'shared the Result': 'megosztotta az eredményt',
    'updated the Result': 'frissítette az eredményt',
    'published the Skill': 'közzétette a készséget',
    'approved the fact': 'jóváhagyta a tényt',
    'added the fact': 'hozzáadta a tényt',
    'added the meeting': 'hozzáadta a megbeszélést',
    'published the page': 'közzétette az oldalt',
    'updated the page': 'frissítette az oldalt',
    'shared the chat': 'megosztotta a csevegést',
    'published a version of': 'közzétette ennek egy verzióját',
    ran: 'futtatta',
    Knowledge: 'Tudás',
    Meetings: 'Megbeszélések',
    Chat: 'Csevegés',
    Use: 'Használat',
    Open: 'Megnyitás',
    You: 'Te',
    Someone: 'Valaki',
    'published version {version} of': 'közzétette ennek a(z) {version}. verzióját',
    'thing needs': 'elemnek szüksége van',
    'things need': 'elemeknek szükségük van',
    'Published Skill': 'Közzétett készség',
    'Included with Skill': 'A készség része',
    'Already attached': 'Már csatolva',
    'Also available in company knowledge': 'A vállalati tudásban is elérhető',
    'Company file': 'Vállalati fájl',
    'Account identity unavailable': 'A fiókazonosság nem érhető el',
    'Access expired or was revoked. Reconnect to continue.':
      'A hozzáférés lejárt vagy visszavonták. A folytatáshoz csatlakoztasd újra.',
    'Account authorized · tools unavailable': 'Fiók engedélyezve · az eszközök nem érhetők el',
    'Not available in this workspace yet.': 'Ebben a munkaterületen még nem érhető el.',
    'Everyone in the company': 'A vállalat minden tagja',
    'Audience: only you.': 'Célközönség: csak te.',
    'Audience: everyone in the company.': 'Célközönség: a vállalat minden tagja.',
    'tool is': 'eszköz van',
    'tools are': 'eszköz van',
    'account is': 'fiók van',
    'accounts are': 'fiók van',
    'We could not upload this file.': 'Nem sikerült feltölteni ezt a fájlt.',
    'file was': 'fájl volt',
    'files were': 'fájl volt',
    'Your company': 'A vállalatod',
    'Create an agent': 'Ügynök létrehozása',
    'Give recurring work a helping hand': 'Segítség az ismétlődő munkához',
    'Create a Skill': 'Készség létrehozása',
    'Save a reusable way of working': 'Újrafelhasználható munkamódszer mentése',
    'Take meeting notes': 'Jegyzetelj a megbeszélésen',
    'Capture decisions and next steps': 'Rögzítsd a döntéseket és a következő lépéseket',
    'Work with a file': 'Munka fájllal',
    'Start from a document or image': 'Kezdés dokumentumból vagy képből',
    'Browse agents': 'Ügynökök böngészése',
    'Open your agents and company agents': 'Saját és vállalati ügynökök megnyitása',
    'Review results': 'Eredmények áttekintése',
    'Return to work saved in your Library': 'Visszatérés a Könyvtárba mentett munkához',
    'For review': 'Áttekintendő',
    'An agent': 'Egy ügynök',
    Assistant: 'Asszisztens',
    'Kept up to date by {value1}{value2}': 'Naprakészen tartja: {value1}{value2}',
    ', {value1}': ', {value1}',
    'Version {value1}{value2}{value3}': '{value1}{value2}{value3} verzió',
    'Refreshed by its agent': 'Az ügynöke frissítette',
    'Saved from a chat': 'Csevegésből mentve',
    'Saved from {value1}': 'Mentve a(z) {value1} alkalmazásból',
    Edited: 'Szerkesztve',
    'private account': 'személyes fiók',
    '{value1} ({value2})': '{value1} ({value2})',
    '{value1}’s {value2}': '{value1} – {value2}',
    'Made private. The person who added it and the owner of its recording have been told in their Inbox.':
      'Priváttá téve. A hozzáadót és a felvétel tulajdonosát értesítettük a Beérkezett üzenetek között.',
    'Made private. The person who added it has been told in their Inbox.':
      'Priváttá téve. A hozzáadót értesítettük a Beérkezett üzenetek között.',
    'Made private. The owner of its recording has been told in their Inbox.':
      'Priváttá téve. A felvétel tulajdonosát értesítettük a Beérkezett üzenetek között.',
    'Selected passage': 'Kijelölt részlet',
    '{value1} {value2}': '{value1} {value2}',
    'Upload a file': 'Fájl feltöltése',
    'Help me create a useful report from our company knowledge and available sources.':
      'Segíts hasznos jelentést készíteni a vállalati tudásból és az elérhető forrásokból.',
    'This saved work couldn’t be opened. Open it again to retry.':
      'A mentett munka nem nyitható meg. Nyisd meg újra az újrapróbálkozáshoz.',
    '{value1}’s': '{value1} –',
    '{value1} chat “{value2}”': '{value1} „{value2}” csevegése',
    '{value1}{value2}': '{value1}{value2}',
    'Skill: {value1}{value2}': 'Készség: {value1}{value2}',
    'Result “{value1}”': '„{value1}” eredménye',
    'Meeting “{value1}”': '„{value1}” megbeszélés',
    'Used in {value1} {value2} this week': 'Ezen a héten használva: {value1} {value2}',
    '{value1} {value2} · used in {value3} {value4}':
      '{value1} {value2} · {value3} {value4} használatban',
    'The draft is not published yet, so no one else follows it.':
      'A piszkozat még nincs közzétéve, ezért senki más nem követi.',
    'Use it in a chat for current data, or refine the Skill first.':
      'Használd csevegésben az aktuális adatokhoz, vagy előbb finomítsd a készséget.',
    'An agent keeps this up to date. Continue the work in chat.':
      'Egy ügynök tartja naprakészen. Folytasd a munkát csevegésben.',
    'Edit it here, or continue the work in chat.':
      'Szerkeszd itt, vagy folytasd a munkát csevegésben.',
    'Duplicate it to your Library, or continue the work in chat.':
      'Másold a Könyvtárba, vagy folytasd a munkát csevegésben.',
    'Download Markdown': 'Markdown letöltése',
    'Download CSV': 'CSV letöltése',
    'an agent': 'egy ügynök',
    'Publish a Skill version': 'Készségverzió közzététele',
    'Share with {value1}': 'Megosztás vele: {value1}',
    'Update company content': 'Vállalati tartalom frissítése',
    Approved: 'Jóváhagyva',
    Declined: 'Elutasítva',
    Pending: 'Függőben',
    'View decision': 'Döntés megtekintése',
    'No data': 'Nincs adat',
    'No change': 'Nincs változás',
    'Connection created': 'Kapcsolat létrehozva',
    'Sharing changed': 'Megosztási beállítás módosítva',
    'Person added': 'Személy hozzáadva',
    'Person removed': 'Személy eltávolítva',
    'Access changed': 'Hozzáférés módosítva',
    'Access turned off': 'Hozzáférés kikapcsolva',
    'Connection removed': 'Kapcsolat eltávolítva',
    'Query time limit changed': 'Lekérdezési időkorlát módosítva',
    '{count} row': '{count} sor',
    '{count} rows': '{count} sor',
    'This source is no longer available. Company knowledge now lives in Knowledge pages, and files stay in the Library.':
      'Ez a forrás már nem érhető el. A vállalati tudás mostantól a Tudásoldalakon található, a fájlok pedig a Könyvtárban maradnak.',
    '· {value1} by {value2}': '· {value1}, készítette: {value2}',
    '· version {value1}': '· {value1} verzió',
    '{message} {count} earlier file was saved and attached.':
      '{message} {count} korábbi fájl mentve és csatolva.',
    '{message} {count} earlier files were saved and attached.':
      '{message} {count} korábbi fájl mentve és csatolva.',
    '{message} {count} earlier file was saved.': '{message} {count} korábbi fájl mentve.',
    '{message} {count} earlier files were saved.': '{message} {count} korábbi fájl mentve.',
    'refreshed {time}': 'frissítve {time}',
    'a colleague': 'egy munkatárs',
    'Your chat “{title}”': 'A te csevegésed: „{title}”',
    '{name}’s chat “{title}”': '{name} csevegése: „{title}”',
    'Kept up to date by {name}{version}': 'Naprakészen tartja: {name}{version}',
    'Skill: {name}{version}': 'Készség: {name}{version}',
    'Result “{title}”': 'Eredmény: „{title}”',
    'Meeting “{title}”': 'Megbeszélés: „{title}”',
    'Used in {count} answer this week': 'Ezen a héten {count} válaszban használva',
    'Used in {count} answers this week': 'Ezen a héten {count} válaszban használva',
    '{count} source': '{count} forrás',
    '{count} sources': '{count} forrás',
    'used in {count} place': '{count} helyen használva',
    'used in {count} places': '{count} helyen használva',
    '{company} workspace': '{company} munkaterülete',
    '{count} page': '{count} oldal',
    '{count} pages': '{count} oldal',
    '{needs} · reviews and approvals': '{needs} · felülvizsgálatok és jóváhagyások',
    '{count} thing needs you': '{count} teendő igényli a közreműködésedet',
    '{count} things need you': '{count} teendő igényli a közreműködésedet',
    'Included with Skill · {files} · {sources} {icon}':
      'A készség része · {files} · {sources} {icon}',
    '{count} file': '{count} fájl',
    '{count} files': '{count} fájl',
    Today: 'Ma',
    'Earlier this week': 'Ezen a héten korábban',
    '{count} slide': '{count} dia',
    '{count} slides': '{count} dia',
    Early: 'Korai',
    'TLS verified': 'TLS ellenőrizve',
    'Made personal and switched off. Switch it on when you are ready.':
      'Személyre szabva és kikapcsolva. Kapcsold be, amikor készen állsz.',
    'Made personal and switched off. Its owner is told which version is live.':
      'Személyre szabva és kikapcsolva. A tulajdonosa értesítést kap arról, melyik verzió van élesben.',
    'Switched off.': 'Kikapcsolva.',
    'Applied version {revision}.': 'Alkalmazott verzió: {revision}.',
    'The draft is running in a chat only you can read.':
      'A piszkozat egy csak általad olvasható csevegésben fut.',
    'Publish a version first.': 'Először tegyél közzé egy verziót.',
    'Another Agent action is in progress.': 'Egy másik ügynökművelet folyamatban van.',
    'Knowledge & connections': 'Tudás és kapcsolatok',
    'Pinned Skills': 'Rögzített készségek',
    None: 'Nincs',
    'A new Result each run': 'Minden futtatáskor új eredmény',
    'One Result kept up to date': 'Egy naprakészen tartott eredmény',
    Email: 'E-mail',
    On: 'Be',
    Off: 'Ki',
    'Waiting for review': 'Felülvizsgálatra vár',
    Outdated: 'Elavult',
    Accepted: 'Elfogadva',
    Rejected: 'Elutasítva',
    Withdrawn: 'Visszavonva',
    Replaced: 'Lecserélve',
    'Suggested edit': 'Javasolt szerkesztés',
    'Suggested new page': 'Új oldal javaslata',
    'Suggested move': 'Áthelyezés javaslata',
    'Suggested archive': 'Archiválás javaslata',
    'Checking status…': 'Állapot ellenőrzése…',
    'Status unavailable': 'Az állapot nem érhető el',
    'Bulleted list': 'Felsorolás',
    'Numbered list': 'Számozott lista',
    'Web link': 'Webes hivatkozás',
    Read: 'Olvasás',
    Write: 'Írás',
    'shared with you': 'megosztva veled',
    'Getting an answer': 'Válasz keresése',
    '{name} is getting an answer': '{name} választ keres',
    'We could not save. Please try again.': 'Nem sikerült menteni. Próbáld újra.',
    'The new page could not be created.': 'Nem sikerült létrehozni az új oldalt.',
    'We could not load this revision.': 'Nem sikerült betölteni ezt a verziót.',
    'We could not restore this revision. Please try again.':
      'Nem sikerült visszaállítani ezt a verziót. Próbáld újra.',
    'We could not export this revision.': 'Nem sikerült exportálni ezt a verziót.',
    'We could not open this suggestion.': 'Nem sikerült megnyitni ezt a javaslatot.',
    'We could not do that. Please try again.':
      'Nem sikerült végrehajtani a műveletet. Próbáld újra.',
    'We could not save your decision. Please try again.':
      'Nem sikerült menteni a döntésedet. Próbáld újra.',
    'We could not restore this page. Please try again.':
      'Nem sikerült visszaállítani ezt az oldalt. Próbáld újra.',
    'We could not export this page.': 'Nem sikerült exportálni ezt az oldalt.',
    '{count} missed time merged.': '{count} kihagyott időpont összevonva.',
    '{count} missed times merged.': '{count} kihagyott időpont összevonva.',
    'About this project': 'A projektről',
  },
  ga: {
    context: 'comhthéacs',
    skills: 'scileanna',
    'Choose company context': 'Roghnaigh comhthéacs na cuideachta',
    'Skills for this conversation': 'Scileanna don chomhrá seo',
    'Bring context into the conversation': 'Cuir comhthéacs sa chomhrá',
    'Close context picker': 'Dún roghnóir an chomhthéacs',
    'Filter company context': 'Scag comhthéacs na cuideachta',
    'Find a Skill…': 'Aimsigh scil…',
    'Find a file…': 'Aimsigh comhad…',
    'Available company context': 'Comhthéacs cuideachta atá ar fáil',
    'No matching published Skills.': 'Níl aon scileanna foilsithe comhoiriúnacha ann.',
    'No matching files.': 'Níl aon chomhaid chomhoiriúnacha ann.',
    'Searching company work…': 'Ag cuardach obair na cuideachta…',
    'Try search again': 'Bain triail eile as an gcuardach',
    'Meaning search is temporarily limited. Showing available text matches.':
      'Tá cuardach de réir brí teoranta go sealadach. Taispeántar na meaitseálacha téacs atá ar fáil.',
    'Load more matches': 'Lódáil tuilleadh meaitseálacha',
    '{value1} files attached. Remove an attachment to add another. Saved Skill references are included separately.':
      'Tá {value1} comhad ceangailte. Bain ceangaltán chun ceann eile a chur leis. Cuirtear tagairtí sábháilte scileanna san áireamh ar leithligh.',
    'Create a Skill in chat': 'Cruthaigh scil sa chomhrá',
    'Upload a company file': 'Uaslódáil comhad cuideachta',
    'Company knowledge is always available to Poneva.':
      'Bíonn eolas na cuideachta ar fáil do Poneva i gcónaí.',
    '{value1} was not connected': 'Níor ceanglaíodh {value1}',
    Dismiss: 'Dún',
    'Try connecting again': 'Bain triail eile as an nascadh',
    Waiting: 'Ag fanacht',
    Connected: 'Ceangailte',
    'Needs reconnecting': 'Ní mór athcheangal',
    Connect: 'Ceangail',
    '{value1}{value2} The provider’s account permissions still apply.':
      '{value1}{value2} Tá ceadanna chuntas an tsoláthraí fós i bhfeidhm.',
    'Last error: {value1}': 'Earráid dheireanach: {value1}',
    '{value1} {value2} ready.': 'Tá {value1} {value2} réidh.',
    'Continue with my Meta app': "Lean ar aghaidh le m'aip Meta",
    Reconnect: 'Athcheangail',
    Disconnect: 'Dícheangail',
    'Remove attachment: {value1}': 'Bain ceangaltán: {value1}',
    'Saved in this Skill. Edit the Skill to change its references.':
      'Sábháilte sa scil seo. Cuir an scil in eagar chun a tagairtí a athrú.',
    'Remove Skill context': 'Bain comhthéacs na scile',
    Refining: 'Ag mionchoigeartú',
    Previewing: 'Ag réamhamharc',
    Using: 'In úsáid',
    'Skill revision {value1}': 'Leagan na scile {value1}',
    'a new Skill': 'scil nua',
    '{value1} Making a new agent {value2}': '{value1} Ag cruthú gníomhaire nua {value2}',
    'Stop making a new agent in this chat': 'Stop ag cruthú gníomhaire nua sa chomhrá seo',
    'Saved Skill references': 'Tagairtí sábháilte scileanna',
    'Included with Skill · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}':
      'San áireamh leis an scil · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}',
    'Selected Skill revision is unavailable. Select the Skill again to view its saved references.':
      'Níl an leagan roghnaithe den scil ar fáil. Roghnaigh an scil arís chun a tagairtí sábháilte a fheiceáil.',
    'Conversation attachments': 'Ceangaltáin an chomhrá',
    'Added for this conversation': 'Curtha leis don chomhrá seo',
    'Selected passage {value1}': 'Sliocht roghnaithe {value1}',
    'We could not load your workspace.': 'Níorbh fhéidir linn do spás oibre a lódáil.',
    'The selected Skill is unavailable. Check its access or choose it again.':
      'Níl an scil roghnaithe ar fáil. Seiceáil do rochtain uirthi nó roghnaigh arís í.',
    'Source saved privately and included in your knowledge search.':
      'Sábháladh an fhoinse go príobháideach agus cuireadh san áireamh í i do chuardach eolais.',
    'File saved privately to your library and attached to this message.':
      'Sábháladh an comhad go príobháideach i do leabharlann agus ceanglaíodh leis an teachtaireacht seo é.',
    'File saved privately to your library.':
      'Sábháladh an comhad go príobháideach i do leabharlann.',
    '{value1} {value2} earlier {value3} saved{value4}.':
      'Sábháladh {value1} {value2} níos luaithe {value3}{value4}.',
    'Extracted text for Poneva to read. Download the original for its layout, charts and images. Spreadsheet formulas show their saved results and are not recalculated.':
      'Téacs bainte amach le léamh ag Poneva. Íoslódáil an bunleagan chun a leagan amach, a chairteacha agus a íomhánna a fheiceáil. Taispeánann foirmlí na scarbhileoige a dtorthaí sábháilte agus ní dhéantar iad a athríomh.',
    Esc: 'Esc',
    'Start something': 'Tosaigh rud éigin',
    'Choose a file to work with': 'Roghnaigh comhad le hoibriú leis',
    'Skills worth adding': 'Scileanna ar fiú iad a chur leis',
    'Picked for you': 'Roghnaithe duit',
    'Reusable work grounded in your company knowledge.':
      'Obair in-athúsáidte atá bunaithe ar eolas do chuideachta.',
    'Ideas from your company context and recent work. Pick one to start.':
      'Smaointe ó chomhthéacs do chuideachta agus ó do chuid oibre le déanaí. Roghnaigh ceann le tosú.',
    'Refresh suggested tasks': 'Athnuaigh tascanna molta',
    'Check for new company context.': 'Seiceáil an bhfuil comhthéacs cuideachta nua ann.',
    'Check for new context. Ideas also refresh daily.':
      'Seiceáil an bhfuil comhthéacs nua ann. Déantar na smaointe a athnuachan gach lá freisin.',
    Refresh: 'Athnuaigh',
    'Finding useful starting points…': 'Ag aimsiú pointí úsáideacha le tosú…',
    'Suggestions aren’t available right now. Try Refresh, or describe the work you want to do.':
      'Níl moltaí ar fáil faoi láthair. Bain triail as Athnuaigh, nó déan cur síos ar an obair is mian leat a dhéanamh.',
    'Loading the knowledge pages…': 'Ag lódáil na leathanach eolais…',
    '{value1} All pages': '{value1} Gach leathanach',
    'The page is created.': 'Cruthaíodh an leathanach.',
    'Your new page is suggested. A publisher decides whether it is added.':
      'Moladh do leathanach nua. Cinneann foilsitheoir an gcuirfear leis é.',
    'Company knowledge': 'Eolas na cuideachta',
    'What Poneva knows about your company, page by page. Every change is kept.':
      'An méid atá ar eolas ag Poneva faoi do chuideachta, leathanach ar leathanach. Coinnítear gach athrú.',
    'Loading company knowledge…': 'Ag lódáil eolas na cuideachta…',
    'Knowledge pages are not enabled in this workspace.':
      'Níl leathanaigh eolais cumasaithe sa spás oibre seo.',
    'Ask your Poneva contact to switch them on for your company.':
      'Iarr ar do theagmhálaí Poneva iad a chur ar siúl do do chuideachta.',
    '{value1} Change the agent': '{value1} Athraigh an gníomhaire',
    '{value1} Continue in chat': '{value1} Lean ar aghaidh sa chomhrá',
    'We could not load this item.': 'Níorbh fhéidir linn an mhír seo a luchtú.',
    '{value1} canvas': 'canbhás {value1}',
    'Loading {value1}…': '{value1} á luchtú…',
    '{value1} · Original retained': '{value1} · An bunleagan coinnithe',
    '{value1} {value2}{value3} · Added {value4}':
      '{value1} {value2}{value3} · Curtha leis {value4}',
    '{value1} Use in chat': '{value1} Úsáid sa chomhrá',
    '{value1} Download': '{value1} Íoslódáil',
    Table: 'Tábla',
    Chart: 'Cairt',
    Original: 'Bunleagan',
    'Text extracted from the PDF, marked by page. Download the original for its layout and images.':
      'Téacs bainte as an PDF, marcáilte de réir leathanaigh. Íoslódáil an bunleagan chun a leagan amach agus a íomhánna a fheiceáil.',
    'This preview shows the beginning of the file. Poneva reads the whole file; download the original to see all of it.':
      'Taispeánann an réamhamharc seo tús an chomhaid. Léann Poneva an comhad iomlán; íoslódáil an bunleagan chun é go léir a fheiceáil.',
    'Preview of the first {value1} complete rows. Filtering and charts use only this preview. Download the original for the full file.':
      'Réamhamharc ar na chéad {value1} ró iomlána. Ní úsáideann scagadh ná cairteacha ach an réamhamharc seo. Íoslódáil an bunleagan don chomhad iomlán.',
    'This source link cannot be opened.': 'Ní féidir an nasc foinseach seo a oscailt.',
    'Read-only chat': 'Comhrá inléite amháin',
    'Only {value1} writes in this chat. Fork it to continue with your own connections. {value2}':
      'Ní scríobhann ach {value1} sa chomhrá seo. Déan brainse de chun leanúint ar aghaidh le do naisc féin. {value2}',
    'Suggest a follow-up…': 'Mol obair leantach…',
    'Suggest a follow-up': 'Mol obair leantach',
    'Sending…': 'Á sheoladh…',
    Send: 'Seol',
    'We could not dismiss that suggestion. Please try again.':
      'Níorbh fhéidir linn an moladh sin a dhíbhe. Bain triail eile as.',
    'Suggested follow-ups': 'Obair leantach mholta',
    '{value1} suggests': 'Molann {value1}',
    Ask: 'Fiafraigh',
    'Dismiss {value1}’s suggestion': 'Díbhe moladh {value1}',
    'Suggested by': 'Molta ag',
    '· edit it or send it': '· cuir in eagar é nó seol é',
    'Remove the suggestion tag': 'Bain an chlib mholta',
    '{value1} {value2} is getting an answer': 'Tá freagra á fháil ag {value1} {value2}',
    '{value1} {value2} stopped the answer': 'Stop {value1} {value2} an freagra',
    '{value1} Fork from here': '{value1} Déan brainse as seo',
    '{value1} From {value2}’s {value3}': '{value1} Ó {value3} le {value2}',
    'Only {value1} can use this account': 'Ní féidir ach le {value1} an cuntas seo a úsáid',
    '{value1} Suggested by {value2}': '{value1} Molta ag {value2}',
    'Fork this chat': 'Déan brainse den chomhrá seo',
    'Forking…': 'Brainse á dhéanamh…',
    Fork: 'Déan brainse',
    'Could not make this private.': 'Níorbh fhéidir é seo a dhéanamh príobháideach.',
    'Make this chat private?': 'An bhfuil fonn ort an comhrá seo a dhéanamh príobháideach?',
    Close: 'Dún',
    '{value1} will see “{value2}”. Everyone else loses access right away {value3} .{value4}':
      'Feicfidh {value1} “{value2}”. Caillfidh gach duine eile rochtain láithreach {value3} .{value4}',
    Cancel: 'Cealaigh',
    'Saving…': 'Á shábháil…',
    'Make private': 'Déan príobháideach',
    'This chat is private again. Forks others made stay theirs.':
      'Tá an comhrá seo príobháideach arís. Fanann na brainsí a rinne daoine eile leo.',
    'Who can read this chat: {value1}': 'Cé atá in ann an comhrá seo a léamh: {value1}',
    'Move this chat': 'Bog an comhrá seo',
    'Only you write here. Others follow live and fork.':
      'Is tusa amháin a scríobhann anseo. Leanann daoine eile é beo agus déanann siad brainsí de.',
    'Made private. {value1} has been told in their Inbox.':
      'Rinneadh príobháideach é. Cuireadh é sin in iúl do {value1} ina Bhosca Isteach.',
    'Chat access': 'Rochtain ar an gcomhrá',
    '{value1}’s chat. As an admin you can make it private.':
      'Comhrá {value1}. Mar riarthóir, is féidir leat é a dhéanamh príobháideach.',
    'Only {value1} will see it. {value2} is told.':
      'Ní fheicfidh ach {value1} é. Cuireadh é sin in iúl do {value2}.',
    '{value1} {value2} following': '{value1} {value2} ag leanúint',
    'Forked from{value1} {value2} . The history is copied. From here, tools run with your own access.':
      'Rinneadh brainse de ó{value1} {value2} . Cóipeáladh an stair. As seo amach, ritheann uirlisí le do rochtain féin.',
    '{value1} made this chat private': 'Rinne {value1} an comhrá seo príobháideach',
    'You can no longer open it. Any fork you made stays yours.':
      'Ní féidir leat é a oscailt a thuilleadh. Fanann aon bhrainse a rinne tú leatsa.',
    'Start a new chat': 'Tosaigh comhrá nua',
    'Back to Recent chats': 'Fill ar na comhráite is déanaí',
    'More chat actions': 'Tuilleadh gníomhartha comhrá',
    'Close conversation sharing': 'Dún comhroinnt an chomhrá',
    'Review the text before saving a private copy to Library. Then choose its audience. Your original conversation and future messages stay private.':
      'Déan athbhreithniú ar an téacs sula sábhálfaidh tú cóip phríobháideach sa Leabharlann. Ansin roghnaigh a lucht féachana. Fanann do chomhrá bunaidh agus do theachtaireachtaí amach anseo príobháideach.',
    'Preparing the conversation…': 'An comhrá á ullmhú…',
    'Refresh preview': 'Athnuaigh an réamhamharc',
    'The copy is saved in Library. Use Share to choose who can access it.':
      'Sábháladh an chóip sa Leabharlann. Úsáid Comhroinn chun a roghnú cé atá in ann rochtain a fháil uirthi.',
    'Save this copy': 'Sábháil an chóip seo',
    'That Skill could not be opened.': 'Níorbh fhéidir an Scil sin a oscailt.',
    '{value1}{value2} · reviews and approvals': '{value1}{value2} · athbhreithnithe agus ceaduithe',
    'Open Inbox': 'Oscail an Bosca Isteach',
    'New at {value1} this week': 'Nua ag {value1} an tseachtain seo',
    'Nothing new this week. Shared work, published Skills and approved knowledge show up here.':
      'Níl aon rud nua an tseachtain seo. Taispeántar obair chomhroinnte, Scileanna foilsithe agus eolas ceadaithe anseo.',
    'New at {value1}': 'Nua ag {value1}',
    'This Skill is unavailable. Try again.': 'Níl an Scil seo ar fáil. Bain triail eile as.',
    'You can attach up to {value1} files. Remove an attachment to add another.':
      'Is féidir suas le {value1} comhad a cheangal. Bain ceangaltán chun ceann eile a chur leis.',
    'Add company context': 'Cuir comhthéacs na cuideachta leis',
    'Add company context · @': 'Cuir comhthéacs na cuideachta leis · @',
    'Choose a Skill': 'Roghnaigh Scil',
    'Choose a Skill · /': 'Roghnaigh Scil · /',
    Edit: 'Cuir in eagar',
    '{value1} Edit with chat': '{value1} Cuir in eagar le comhrá',
    '{value1} Duplicate to my Library': '{value1} Cóipeáil chuig mo Leabharlann',
    'Duplicated to your Library. Only you can see the copy.':
      'Cóipeáladh chuig do Leabharlann é. Is tusa amháin atá in ann an chóip a fheiceáil.',
    'Could not duplicate this Result. Try again.':
      'Níorbh fhéidir an Toradh seo a chóipeáil. Bain triail eile as.',
    'Saved version {value1}.': 'Sábháladh leagan {value1}.',
    'A newer version was saved. Reload the Result before saving.':
      'Sábháladh leagan níos nuaí. Athlódáil an Toradh sula sábhálfaidh tú é.',
    'Could not save this version. Try again.':
      'Níorbh fhéidir an leagan seo a shábháil. Bain triail eile as.',
    '{value1} saved a newer version. Review it before saving.':
      'Shábháil {value1} leagan níos nuaí. Déan athbhreithniú air sula sábhálfaidh tú é.',
    'Hide their version': 'Folaigh a leagan',
    'Show their version': 'Taispeáin a leagan',
    'Start from their version': 'Tosaigh óna leagan',
    Markdown: 'Markdown',
    'Result text': 'Téacs an toraidh',
    Preview: 'Réamhamharc',
    'What changed': 'Cad a d’athraigh',
    'What changed? (optional)': 'Cad a d’athraigh? (roghnach)',
    'Save version {value1}': 'Sábháil leagan {value1}',
    'Open chat': 'Oscail an comhrá',
    Current: 'Reatha',
    Restore: 'Athchóirigh',
    'Could not load the history.': 'Níorbh fhéidir an stair a luchtú.',
    'Restored version {value1} as version {value2}.':
      'Athchóiríodh leagan {value1} mar leagan {value2}.',
    'Someone saved a newer version. Review it before restoring.':
      'Shábháil duine éigin leagan níos nuaí. Déan athbhreithniú air sula n-athchóiríonn tú é.',
    'Could not restore that version.': 'Níorbh fhéidir an leagan sin a athchóiriú.',
    'Loading history…': 'Stair á luchtú…',
    'Restoring keeps what is there now as a version too, so nothing is lost.':
      'Coinnítear an méid atá ann anois mar leagan chomh maith agus an t-athchóiriú á dhéanamh, ionas nach gcailltear tada.',
    'This Result was made with your own {value1}.': 'Rinneadh an Toradh seo le do {value1} féin.',
    'It also used': 'Úsáideadh é seo chomh maith',
    'This Result was made with': 'Rinneadh an Toradh seo le',
    'Colleagues can read what came from them, but can never use them.':
      'Is féidir le comhghleacaithe an méid a tháinig uathu a léamh, ach ní féidir leo iad a úsáid choíche.',
    'Your personal agent {value1} keeps it up to date with your own access, so every refresh can carry your private data.':
      'Coinníonn do ghníomhaire pearsanta {value1} cothrom le dáta é trí do rochtain féin, agus mar sin is féidir do shonraí príobháideacha a bheith i ngach athnuachan.',
    'A colleague’s personal agent keeps it up to date with their own access, so every refresh can carry their private data.':
      'Coinníonn gníomhaire pearsanta comhghleacaí cothrom le dáta é trína rochtain féin, agus mar sin is féidir a shonraí príobháideacha a bheith i ngach athnuachan.',
    'Made private. Only you can see this meeting.':
      'Rinneadh príobháideach é. Is tusa amháin atá in ann an cruinniú seo a fheiceáil.',
    'Could not make this meeting private.':
      'Níorbh fhéidir an cruinniú seo a dhéanamh príobháideach.',
    'Meeting · {value1} {value2} · Original retained':
      'Cruinniú · {value1} {value2} · Coinníodh an bhunleagan',
    'The recording could not be opened.': 'Níorbh fhéidir an taifeadadh a oscailt.',
    'Ask about this suggestion': 'Cuir ceist faoin moladh seo',
    meeting_processing_failed: 'theip ar phróiseáil an chruinnithe',
    'Who can see this': 'Cé atá in ann é seo a fheiceáil',
    'Everyone at {value1}': 'Gach duine ag {value1}',
    'Only me': 'Mise amháin',
    'Everyone at {value1} can find it and ask about it.':
      'Is féidir le gach duine ag {value1} é a aimsiú agus ceist a chur faoi.',
    'Only you can open and search this meeting. You can share it later.':
      'Is tusa amháin atá in ann an cruinniú seo a oscailt agus a chuardach. Is féidir leat é a roinnt níos déanaí.',
    'Added. Only you can see it. Transcription is running in the background.':
      'Cuireadh leis. Is tusa amháin atá in ann é a fheiceáil. Tá tras-scríobh ar siúl sa chúlra.',
    'Visible to everyone at {value1}': 'Infheicthe ag gach duine ag {value1}',
    'Could not make it private.': 'Níorbh fhéidir é a dhéanamh príobháideach.',
    'Show more meetings': 'Taispeáin tuilleadh cruinnithe',
    'Attached to this message': 'Ceangailte leis an teachtaireacht seo',
    'Connect securely, choose the tables to share, then decide whether Poneva can read or make changes.':
      'Ceangail go slán, roghnaigh na táblaí le roinnt, ansin déan cinneadh an féidir le Poneva iad a léamh nó athruithe a dhéanamh.',
    'Review the tables this connection can access. Select at least one table.':
      'Déan athbhreithniú ar na táblaí ar féidir leis an nasc seo rochtain a fháil orthu. Roghnaigh tábla amháin ar a laghad.',
    'Select at least one table. Nothing is selected by default.':
      'Roghnaigh tábla amháin ar a laghad. Ní roghnaítear tada de réir réamhshocraithe.',
    'Choose who can use this connection and what Poneva can do.':
      'Roghnaigh cé atá in ann an nasc seo a úsáid agus cad is féidir le Poneva a dhéanamh.',
    'Your chosen access is enabled for the selected tables.':
      'Tá an rochtain a roghnaigh tú cumasaithe do na táblaí roghnaithe.',
    'Your connection is saved with reading paused until permission is confirmed.':
      'Sábháiltear do nasc agus an léamh curtha ar sos go dtí go ndeimhnítear an cead.',
    'Confirm database disconnect': 'Deimhnigh dícheangal an bhunachair sonraí',
    'Disconnect this database?': 'An ndínascfar an bunachar sonraí seo?',
    'Access will stop for everyone using this connection.':
      'Cuirfear deireadh le rochtain do gach duine atá ag úsáid an naisc seo.',
    'Keep connection': 'Coinnigh an nasc',
    'What it can reach · {value1}{value2} {value3}':
      'An méid ar féidir leis rochtain a fháil air · {value1}{value2} {value3}',
    Back: 'Siar',
    Continue: 'Lean ar aghaidh',
    'Uploading…': 'Á uaslódáil…',
    Library: 'Leabharlann',
    'Source material for your work. Available whenever you need it.':
      'Ábhar foinseach do do chuid oibre. Ar fáil aon uair a theastaíonn sé uait.',
    'The work you want to keep, with its sources and conversation attached.':
      'An obair is mian leat a choinneáil, lena foinsí agus lena comhrá ceangailte.',
    Results: 'Torthaí',
    Files: 'Comhaid',
    Artifacts: 'Déantáin',
    'Search library': 'Cuardaigh sa leabharlann',
    'Find files by meaning…': 'Aimsigh comhaid de réir brí…',
    'Find saved work by meaning…': 'Aimsigh obair shábháilte de réir brí…',
    'Search coverage is limited while indexing or meaning-based search is unavailable. You can retry or browse recent items.':
      'Tá cumhdach an chuardaigh teoranta agus innéacsú ar siúl nó cuardach bunaithe ar bhrí gan a bheith ar fáil. Is féidir leat triail eile a bhaint as nó na míreanna is déanaí a bhrabhsáil.',
    'No matching work found.': 'Níor aimsíodh aon obair mheaitseála.',
    'A starting point for your next question.': 'Pointe tosaigh do do chéad cheist eile.',
    'Good work is worth keeping.': 'Is fiú dea-obair a choinneáil.',
    'Try a different description or clear the search to browse.':
      'Bain triail as cur síos eile nó glan an cuardach chun brabhsáil.',
    'Upload source material once and use it in conversations and Skills. Your original stays in the library.':
      'Uaslódáil ábhar foinseach uair amháin agus bain úsáid as i gcomhráite agus i Scileanna. Fanann do bhunleagan sa leabharlann.',
    'Ask Poneva to save an answer, table or chart. Results stay connected to the conversation and their sources.':
      'Iarr ar Poneva freagra, tábla nó cairt a shábháil. Fanann na Torthaí nasctha leis an gcomhrá agus lena bhfoinsí.',
    'Start in chat {value1}': 'Tosaigh i gcomhrá {value1}',
    'Open result: {value1}': 'Oscail an toradh: {value1}',
    'Loading more library items…': 'Tuilleadh míreanna leabharlainne á lódáil…',
    'Load more': 'Lódáil tuilleadh',
    'Documents, transcripts, audio and video · Up to 500 MB per file. New files are private. Choose their audience with Share and which processable files become searchable company knowledge.':
      'Doiciméid, tras-scríbhinní, fuaim agus físeán · Suas le 500 MB in aghaidh an chomhaid. Tá comhaid nua príobháideach. Roghnaigh a lucht féachana le Comhroinn agus cé na comhaid is féidir a phróiseáil a bheidh ina n-eolas inchuardaithe cuideachta.',
    Skills: 'Scileanna',
    'Create in chat': 'Cruthaigh sa chomhrá',
    'Search Skills': 'Cuardaigh scileanna',
    'Search finds published Skills. Clear the search to browse your drafts too.':
      'Aimsíonn an cuardach scileanna foilsithe. Glan an cuardach chun do dhréachtaí a bhrabhsáil freisin.',
    'Search coverage is limited while indexing or meaning-based search is unavailable.':
      'Tá clúdach an chuardaigh teoranta fad nach bhfuil innéacsú ná cuardach bunaithe ar bhrí ar fáil.',
    'Searching Skills…': 'Scileanna á gcuardach…',
    'No matching published Skills found. Try a different description.':
      'Níor aimsíodh aon scil fhoilsithe mheaitseála. Bain triail as cur síos eile.',
    'Load more Skills': 'Lódáil tuilleadh scileanna',
    'View Skill: {value1}': 'Féach ar an scil: {value1}',
    'Company workspace': 'Spás oibre na cuideachta',
    'View {value1}': 'Féach ar {value1}',
    'Loading Skills…': 'Scileanna á lódáil…',
    'Try again {value1}': 'Bain triail eile as {value1}',
    'Try again': 'Bain triail eile as',
    'Nothing yet.': 'Níl aon rud ann fós.',
    'Made from · Used by': 'Déanta as · Úsáidte ag',
    'Could not load links': 'Níorbh fhéidir na naisc a lódáil',
    'Made from': 'Déanta as',
    'Used by': 'Úsáidte ag',
    'About this chat {value1}': 'Maidir leis an gcomhrá seo {value1}',
    'About this chat': 'Maidir leis an gcomhrá seo',
    'Keep the work moving.': 'Coinnigh an obair ag imeacht.',
    'Ask a follow-up with this result in view, or turn a useful approach into a company Skill.':
      'Cuir ceist leantach agus an toradh seo le feiceáil, nó déan scil cuideachta den chur chuige úsáideach seo.',
    'Save approach as a Skill': 'Sábháil an cur chuige mar scil',
    'Preview of': 'Réamhamharc ar',
    'Made with': 'Déanta le',
    'Open the draft': 'Oscail an dréacht',
    'Open Skill': 'Oscail an scil',
    'Use in chat': 'Úsáid sa chomhrá',
    'Finish the draft': 'Críochnaigh an dréacht',
    'Refine this Skill': 'Feabhsaigh an scil seo',
    'Made with a Skill.': 'Déanta le scil.',
    'This workspace could not be loaded just now, so that Skill cannot be opened yet. The result itself is unchanged.':
      'Níorbh fhéidir an spás oibre seo a lódáil faoi láthair, mar sin ní féidir an scil sin a oscailt fós. Níl aon athrú ar an toradh féin.',
    'That Skill is not available in this workspace, so it cannot be opened or used again. The result itself is unchanged.':
      'Níl an scil sin ar fáil sa spás oibre seo, mar sin ní féidir í a oscailt ná a úsáid arís. Níl aon athrú ar an toradh féin.',
    'Result · {value1} {value2}': 'Toradh · {value1} {value2}',
    '{value1} Copy link': '{value1} Cóipeáil an nasc',
    'Result link copied.': 'Cóipeáladh nasc an toraidh.',
    'Could not copy the link. Use your browser address bar.':
      'Níorbh fhéidir an nasc a chóipeáil. Úsáid barra seoltaí do bhrabhsálaí.',
    'No preview is available for this result.': 'Níl réamhamharc ar fáil don toradh seo.',
    '{value1} rows are retained in this snapshot. Open Table to inspect the values.':
      'Coinnítear {value1} ró sa seat seo. Oscail an Tábla chun na luachanna a iniúchadh.',
    'People can’t edit a Result an agent keeps up to date; the next refresh would replace their edit. Change the agent’s instructions instead.':
      'Ní féidir le daoine Toradh a chur in eagar atá á choinneáil cothrom le dáta ag gníomhaire; chuirfeadh an chéad athnuachan eile a n-eagar ina áit. Athraigh treoracha an ghníomhaire ina ionad sin.',
    'Linked sources': 'Foinsí nasctha',
    'Saved source': 'Foinse shábháilte',
    'No source documents are linked to this result. Company knowledge and other references may be cited in the answer.':
      'Níl aon doiciméid fhoinseacha nasctha leis an toradh seo. D’fhéadfaí eolas cuideachta agus tagairtí eile a lua sa fhreagra.',
    'Run details': 'Sonraí na rithte',
    Created: 'Cruthaithe',
    ', revised {value1}': ', leasaithe {value1}',
    Conversation: 'Comhrá',
    'Not recorded': 'Gan taifead',
    'Open conversation': 'Oscail an comhrá',
    Run: 'Rith',
    Updates: 'Nuashonruithe',
    'Kept up to date by {value1}': 'Á choinneáil cothrom le dáta ag {value1}',
    'Version {value1}': 'Leagan {value1}',
    'Could not open this request.': 'Níorbh fhéidir an t-iarratas seo a oscailt.',
    'Approved version published.': 'Foilsíodh an leagan ceadaithe.',
    'Request rejected. The item stays unchanged.':
      'Diúltaíodh don iarratas. Fanann an mhír gan athrú.',
    'Could not save the decision.': 'Níorbh fhéidir an cinneadh a shábháil.',
    'Proposed company change': 'Athrú molta ar an gcuideachta',
    'Opening…': 'Á oscailt…',
    'Approve this version': 'Ceadaigh an leagan seo',
    Decline: 'Diúltaigh',
    'Review the submitted version below. Changes made since submission will need a new request.':
      'Déan athbhreithniú ar an leagan curtha isteach thíos. Beidh iarratas nua ag teastáil le haghaidh athruithe a rinneadh ó cuireadh isteach é.',
    'The version submitted with this request.':
      'An leagan a cuireadh isteach leis an iarratas seo.',
    'Version and proposed change': 'Leagan agus athrú molta',
    'Could not read the pinned content.': 'Níorbh fhéidir an t-ábhar pionáilte a léamh.',
    'Showing a page of {value1} characters.': 'Leathanach de {value1} carachtar á thaispeáint.',
    'Beginning of the submitted content. Open the full text to review every page.':
      'Tús an ábhair a cuireadh isteach. Oscail an téacs iomlán chun athbhreithniú a dhéanamh ar gach leathanach.',
    'Read full submitted text': 'Léigh an téacs iomlán a cuireadh isteach',
    'Previous page': 'Leathanach roimhe seo',
    'Next page': 'An chéad leathanach eile',
    'Made private. Its creator has been told in their Inbox.':
      'Rinneadh príobháideach é. Cuireadh a chruthaitheoir ar an eolas ina Bhosca Isteach.',
    'Made private. Its creator could not be notified.':
      'Rinneadh príobháideach é. Níorbh fhéidir fógra a thabhairt dá chruthaitheoir.',
    'Make this {value1} private?': 'An bhfuil fonn ort {value1} a dhéanamh príobháideach?',
    'Only the person who created it will see it. Everyone else loses access right away, and its creator gets an Inbox update if they are still a company member. If they have left, nobody in the company will be able to access this item.':
      'Is é an duine a chruthaigh é amháin a fheicfidh é. Caillfidh gach duine eile rochtain láithreach, agus gheobhaidh a chruthaitheoir nuashonrú sa Bhosca Isteach má tá sé fós ina chomhalta den chuideachta. Má d’fhág sé an chuideachta, ní bheidh aon duine inti in ann rochtain a fháil ar an mír seo.',
    'Sent for review. The current audience stays unchanged until approval.':
      'Seoladh lena athbhreithniú. Fanann an lucht féachana reatha gan athrú go dtí go gceadófar é.',
    'This suggestion is no longer available to you.': 'Níl an moladh seo ar fáil duit níos mó.',
    'We could not check where this suggestion stands.':
      'Níorbh fhéidir linn stádas an mholta seo a sheiceáil.',
    'Check again': 'Seiceáil arís',
    'Show on page': 'Taispeáin ar an leathanach',
    'The editor could not be loaded. Poneva may have been updated since you opened this page. Reload to get the latest version; nothing on this page has changed.':
      'Níorbh fhéidir an t-eagarthóir a luchtú. Seans gur nuashonraíodh Poneva ó d’oscail tú an leathanach seo. Athluchtaigh chun an leagan is déanaí a fháil; níl aon rud ar an leathanach seo athraithe.',
    'Reload Poneva': 'Athluchtaigh Poneva',
    Formatting: 'Formáidiú',
    'Text style': 'Stíl téacs',
    Text: 'Téacs',
    Heading: 'Ceannteideal',
    Subheading: 'Fo-cheannteideal',
    'Link a page': 'Nasc le leathanach',
    'A page needs a title.': 'Tá teideal de dhíth ar leathanach.',
    'Nothing has changed yet.': 'Níl aon rud athraithe fós.',
    'A page needs some text. To remove a page, archive it instead.':
      'Tá téacs de dhíth ar leathanach. Chun leathanach a bhaint, cartlannaigh é ina áit.',
    'A suggested new page needs some text.': 'Tá téacs de dhíth ar leathanach nua molta.',
    'This page is larger than 256 KB. Split it into smaller pages.':
      'Tá an leathanach seo níos mó ná 256 KB. Roinn ina leathanaigh níos lú é.',
    'Say in a few words why this change is right.':
      'Mínigh i gcúpla focal cén fáth a bhfuil an t-athrú seo ceart.',
    'This page changed while you were editing. Your text is still here: copy it, then open the latest version and make your change again.':
      'D’athraigh an leathanach seo agus tú á chur in eagar. Tá do théacs fós anseo: cóipeáil é, ansin oscail an leagan is déanaí agus déan d’athrú arís.',
    'Your text is copied.': 'Cóipeáladh do théacs.',
    'Your text could not be copied. Select it in the editor and copy it.':
      'Níorbh fhéidir do théacs a chóipeáil. Roghnaigh san eagarthóir é agus cóipeáil é.',
    'The page “{value1}” is created.': 'Cruthaíodh an leathanach “{value1}”.',
    'New page': 'Leathanach nua',
    'Editing {value1}': '{value1} á chur in eagar',
    Editing: 'Á chur in eagar',
    'Creating publishes the page under {value1} for everyone':
      'Foilsíonn cruthú an leathanach faoi {value1} do chách',
    'Saving publishes the new version for everyone': 'Foilsíonn sábháil an leagan nua do chách',
    'Your changes are sent as a suggestion for a publisher':
      'Seoltar do chuid athruithe mar mholadh chuig foilsitheoir',
    'Create page': 'Cruthaigh leathanach',
    Save: 'Sábháil',
    'Send suggestion': 'Seol moladh',
    '{value1} Copy my text': '{value1} Cóipeáil mo théacs',
    'Open the latest version': 'Oscail an leagan is déanaí',
    'Page title': 'Teideal an leathanaigh',
    'Loading the editor…': 'Eagarthóir á luchtú…',
    'New page text': 'Téacs an leathanaigh nua',
    'Text of {value1}': 'Téacs {value1}',
    'Write the page. Type [[ to link another page.':
      'Scríobh an leathanach. Clóscríobh [[ chun nascadh le leathanach eile.',
    'Type [[ to link another page.': 'Clóscríobh [[ chun nascadh le leathanach eile.',
    'Link to a page': 'Nasc le leathanach',
    'What changed, in a few words': 'Cad a d’athraigh, i gcúpla focal',
    'Where this comes from, in a few words': 'Cá as a dtagann sé, i gcúpla focal',
    'Shown in the page history.': 'Taispeántar i stair an leathanaigh é.',
    'A publisher sees this next to your change.': 'Feiceann foilsitheoir é seo in aice le d’athrú.',
    '1 suggestion is open on this page': 'Tá 1 mholadh oscailte ar an leathanach seo',
    '{value1} suggestions are open on this page':
      'Tá {value1} moladh oscailte ar an leathanach seo',
    'They stay open while you edit. After you save, they show against your new text; one whose words you changed is marked outdated.':
      'Fanann siad oscailte agus tú á gcur in eagar. Tar éis duit sábháil, taispeántar iad i gcoinne do théacs nua; marcáiltear mar as dáta aon cheann ar athraigh tú a fhocail.',
    'Type [[ to link another page. Links keep working when a page is renamed or moved.':
      'Clóscríobh [[ chun nascadh le leathanach eile. Leanann na naisc ag obair nuair a athainmnítear nó a bhogtar leathanach.',
    'Loading the history…': 'Stair á luchtú…',
    'This page has no saved text yet.': 'Níl aon téacs sábháilte ar an leathanach seo fós.',
    'Say in a few words why this revision should come back.':
      'Mínigh i gcúpla focal cén fáth ar cheart don athbhreithniú seo filleadh.',
    'Revision {value1} is suggested for a publisher to accept.':
      'Moltar athbhreithniú {value1} lena ghlacadh ag foilsitheoir.',
    'The page already reads like this revision.':
      'Tá an leathanach díreach mar atá san athbhreithniú seo cheana.',
    'Revision {value1} is restored as revision {value2}.':
      'Athchóiríodh athbhreithniú {value1} mar athbhreithniú {value2}.',
    'Revision history': 'Stair na n-athbhreithnithe',
    Revisions: 'Athbhreithnithe',
    'Every saved revision is kept.': 'Coinnítear gach athbhreithniú sábháilte.',
    'Revision {value1} {value2}': 'Athbhreithniú {value1} {value2}',
    'Revision {value1} compared with revision {value2}':
      'Athbhreithniú {value1} i gcomparáid le hathbhreithniú {value2}',
    'Revision {value1}, the first text of this page':
      'Athbhreithniú {value1}, an chéad téacs ar an leathanach seo',
    'Green was added, struck through was removed.':
      'Cuireadh an glas leis; baineadh an téacs a bhfuil líne tríd.',
    '{value1} Export Markdown': '{value1} Easpórtáil Markdown',
    'Restore this revision': 'Athchóirigh an t-athbhreithniú seo',
    'Suggest restoring it': 'Mol é a athchóiriú',
    'Why should this revision come back?': 'Cén fáth ar cheart don athbhreithniú seo filleadh?',
    'Loading this revision…': 'An t-athbhreithniú seo á luchtú…',
    'Only the title changed, from “{value1}” to “{value2}”.':
      'Níor athraigh ach an teideal, ó “{value1}” go “{value2}”.',
    'The text did not change in this revision.': 'Níor athraigh an téacs san athbhreithniú seo.',
    'Changes in revision {value1}': 'Athruithe in athbhreithniú {value1}',
    'Loading page…': 'Leathanach á luchtú…',
    'Loading suggestion…': 'Moladh á luchtú…',
    'This suggestion is not available.': 'Níl an moladh seo ar fáil.',
    'It may have been decided, or it is not one you can see.':
      'Seans go ndearnadh cinneadh air, nó nach bhfuil cead agat é a fheiceáil.',
    'Open Knowledge': 'Oscail Knowledge',
    'Opening the suggestion…': 'An moladh á oscailt…',
    'Choose where the page goes.': 'Roghnaigh cá rachaidh an leathanach.',
    'Say in a few words why.': 'Mínigh i gcúpla focal cén fáth.',
    'Your suggestion is sent. A publisher decides.':
      'Seoladh do mholadh. Déanann foilsitheoir an cinneadh.',
    'Moved under {value1}.': 'Bogtha faoi {value1}.',
    'Deleted “{value1}”.': 'Scriosadh “{value1}”.',
    'Could not update sharing.': 'Níorbh fhéidir comhroinnt a nuashonrú.',
    'They can follow new answers live and fork it to continue with their own connections. Only you write here. You can make it private again at any time.':
      'Is féidir leo freagraí nua a leanúint beo agus cóip a dhéanamh de chun leanúint ar aghaidh lena naisc féin. Is tusa amháin a scríobhann anseo. Is féidir leat é a dhéanamh príobháideach arís tráth ar bith.',
    'They see the project, its brief and the work in it they can already open. Nothing in it opens for anyone because of the project; each item keeps its own access.':
      'Feiceann siad an tionscadal, a achoimre agus an obair ann ar féidir leo a oscailt cheana féin. Ní osclaítear aon rud ann do dhuine ar bith de bharr an tionscadail; coinníonn gach mír a rochtain féin.',
    'Check the content for private information before sharing. Sharing an item does not grant access to its original chat or private connections.':
      'Seiceáil an t-ábhar le haghaidh faisnéise príobháidí sula gcomhroinneann tú é. Ní thugann comhroinnt míre rochtain ar a comhrá bunaidh ná ar a naisc phríobháideacha.',
    '{value1} Everyone you share with can read it, including what the assistant or an App in it found in your {value2}. They can’t use your {value3}. Nothing changes for you: the chat keeps working with all your accounts.':
      '{value1} Is féidir le gach duine a gcomhroinneann tú leis é a léamh, lena n-áirítear an méid a d’aimsigh an cúntóir nó Aip ann i do {value2}. Ní féidir leo do {value3} a úsáid. Ní athraíonn tada duitse: leanann an comhrá ag obair le do chuntais uile.',
    '{value1} Everyone you share with can read them, but nobody can use {value2} through this chat.':
      '{value1} Is féidir le gach duine a gcomhroinneann tú leo iad a léamh, ach ní féidir le duine ar bith {value2} a úsáid tríd an gcomhrá seo.',
    'This controls access to the working draft. Any published company version stays available until you explicitly unpublish it. To publish a new version, complete its preview and use Save Skill. Run results stay private.':
      'Rialaíonn sé seo rochtain ar an dréacht oibre. Fanann aon leagan cuideachta foilsithe ar fáil go dtí go ndí-fhoilsíonn tú é go sainráite. Chun leagan nua a fhoilsiú, críochnaigh a réamhamharc agus úsáid Sábháil Scil. Fanann torthaí na rith príobháideach.',
    'Skill deleted. You can restore it from the Skills archive for 30 days.':
      'Scriosadh an Scil. Is féidir leat é a athchóiriú ó chartlann na Scileanna ar feadh 30 lá.',
    'Could not delete this Skill.': 'Níorbh fhéidir an Scil seo a scriosadh.',
    'More actions': 'Tuilleadh gníomhartha',
    'Delete “{value1}”? It will disappear from Skills and search, and cannot be used by agents. You can restore it for 30 days. Existing chats and results stay available.':
      'Scrios “{value1}”? Imeoidh sé ó na Scileanna agus ón gcuardach, agus ní féidir le gníomhairí é a úsáid. Is féidir leat é a athchóiriú ar feadh 30 lá. Fanann comhráite agus torthaí atá ann cheana ar fáil.',
    'Deleting…': 'Á scriosadh…',
    'Confirm delete': 'Deimhnigh an scriosadh',
    'Delete Skill': 'Scrios Scil',
    'Skill restored as an unpublished draft. Its author can review and publish it again.':
      'Athchóiríodh an Scil mar dhréacht neamhfhoilsithe. Is féidir lena údar athbhreithniú a dhéanamh air agus é a fhoilsiú arís.',
    'Could not restore this Skill.': 'Níorbh fhéidir an Scil seo a athchóiriú.',
    'Archived Skills': 'Scileanna cartlainne',
    'Deleted Skills can be restored for 30 days. Restoring leaves them unpublished.':
      'Is féidir Scileanna scriosta a athchóiriú ar feadh 30 lá. Fágann an t-athchóiriú iad neamhfhoilsithe.',
    'Restore until {value1}': 'Athchóirigh go dtí {value1}',
    'Loading…': 'Ag luchtú…',
    'No archived Skills.': 'Níl aon Scileanna cartlainne ann.',
    'Load more archived Skills': 'Luchtaigh tuilleadh Scileanna cartlainne',
    'Show more of the original': 'Taispeáin níos mó den bhunleagan',
    'Filter result rows': 'Scag sraitheanna na dtorthaí',
    'Find a product or value…': 'Aimsigh táirge nó luach…',
    '{value1} of {value2}': '{value1} as {value2}',
    'Result table': 'Tábla torthaí',
    'No matching rows.': 'Níl aon sraitheanna comhoiriúnacha ann.',
    'Showing the first 1,000 matching rows. Download the CSV for every row.':
      'Taispeántar na chéad 1,000 sraith chomhoiriúnacha. Íoslódáil an CSV do gach sraith.',
    'Agent ·': 'Gníomhaire ·',
    'Only you': 'Tusa amháin',
    'Stopped before it finished.': 'Stopadh é sular chríochnaigh sé.',
    'Drafting the project…': 'Tionscadal á dhréachtú…',
    'Checking where this chat belongs…': 'Ag seiceáil cá mbaineann an comhrá seo…',
    'Moving the chat…': 'An comhrá á bhogadh…',
    'Taking it out of the project…': 'Á bhaint den tionscadal…',
    'Adding it to the project…': 'Á chur leis an tionscadal…',
    'No matching connections are available right now.':
      'Níl aon naisc chomhoiriúnacha ar fáil faoi láthair.',
    'Company knowledge suggestion': 'Moladh d’eolas na cuideachta',
    'Company knowledge now lives on pages. Open Knowledge to see them.':
      'Tá eolas na cuideachta ina chónaí ar leathanaigh anois. Oscail Eolas chun iad a fheiceáil.',
    '{value1} · Open beside this conversation': '{value1} · Oscail taobh leis an gcomhrá seo',
    'Name {value1}': 'Ainm {value1}',
    'Host {value1}': 'Óstríomhaire {value1}',
    'Port {value1}': 'Calafort {value1}',
    'Database {value1}': 'Bunachar sonraí {value1}',
    'Username {value1}': 'Ainm úsáideora {value1}',
    'Password {value1}': 'Focal faire {value1}',
    'Advanced TLS': 'TLS casta',
    '{value1} Poneva verifies the server certificate. Add a CA or server DNS name for IP hosts when your certificate requires it.':
      '{value1} Fíoraíonn Poneva teastas an fhreastalaí. Cuir CA nó ainm DNS an fhreastalaí leis d’óstach IP nuair a éilíonn do theastas é.',
    'CA certificate {value1}': 'Teastas CA {value1}',
    'Certificate server DNS name {value1}': 'Ainm DNS fhreastalaí an teastais {value1}',
    '{value1} Your password is encrypted in secure storage. Poneva verifies the connection before saving it.':
      '{value1} Criptítear do fhocal faire i stóráil shlán. Fíoraíonn Poneva an nasc sula sábhálann sé é.',
    'Testing…': 'Á thástáil…',
    'Test connection': 'Tástáil an nasc',
    'PostgreSQL is connected.': 'Tá PostgreSQL ceangailte.',
    'PostgreSQL was saved safely.': 'Sábháladh PostgreSQL go sábháilte.',
    'Poneva can read and change rows in the selected tables. Apps also follow their approved data scope.':
      'Is féidir le Poneva sraitheanna sna táblaí roghnaithe a léamh agus a athrú. Leanann Aipeanna a raon sonraí ceadaithe freisin.',
    'Poneva can read the selected tables. Apps also follow their approved data scope.':
      'Is féidir le Poneva na táblaí roghnaithe a léamh. Leanann Aipeanna a raon sonraí ceadaithe freisin.',
    'Reads are paused until permission is enabled.':
      'Cuirtear léamh ar sos go dtí go gcumasaítear cead.',
    'Retrying…': 'Á athiarracht…',
    'Retry permission': 'Bain triail eile as an gcead',
    'Try it in Chat': 'Bain triail as sa Chomhrá',
    Done: 'Déanta',
    'Disconnect database': 'Dínasc an bunachar sonraí',
    '{value1} TLS verified ·{value2} {value3}': '{value1} TLS fíoraithe ·{value2} {value3}',
    'Search schemas and tables': 'Cuardaigh scéimeanna agus táblaí',
    'Search tables': 'Cuardaigh táblaí',
    '{value1} of {value2} tables selected': 'Roghnaíodh {value1} as {value2} tábla',
    'Select matching tables': 'Roghnaigh táblaí comhoiriúnacha',
    'Select all tables': 'Roghnaigh na táblaí uile',
    Clear: 'Glan',
    'Select a whole schema or individual tables. New tables need a fresh selection.':
      'Roghnaigh scéim iomlán nó táblaí aonair. Ní mór táblaí nua a roghnú arís.',
    'No tables match this search.': 'Ní mheaitseálann aon tábla leis an gcuardach seo.',
    'All tables in {value1}': 'Na táblaí uile in {value1}',
    '{value1} / {value2} tables': '{value1} / {value2} tábla',
    'Read & write available': 'Léamh agus scríobh ar fáil',
    'Read only': 'Léamh amháin',
    Ctrl: 'Ctrl',
    'This suggested knowledge update could not be shown.':
      'Níorbh fhéidir an nuashonrú eolais molta seo a thaispeáint.',
    'Suggested knowledge update': 'Nuashonrú eolais molta',
    'Archived. Its history is kept.': 'Cartlannaíodh é. Coinnítear a stair.',
    'Choose the page it goes under. Links to it keep working.':
      'Roghnaigh an leathanach faoina rachaidh sé. Leanfaidh na naisc chuige ag obair.',
    'Its text, its history and any open suggestions are removed for good, and links to it from other pages stop working. This cannot be undone.':
      'Baintear a théacs, a stair agus aon mholtaí oscailte go buan, agus stopann naisc chuige ó leathanaigh eile ag obair. Ní féidir é seo a chealú.',
    'An archived page no longer informs answers. Its history is kept, and a publisher can restore it or delete it permanently.':
      'Ní chuireann leathanach cartlannaithe eolas ar fáil do fhreagraí a thuilleadh. Coinnítear a stair, agus is féidir le foilsitheoir é a athchóiriú nó a scriosadh go buan.',
    Under: 'Faoi',
    Change: 'Athraigh',
    'Move under': 'Bog faoi',
    'Search pages': 'Cuardaigh leathanaigh',
    'Why?': 'Cén fáth?',
    'Delete permanently': 'Scrios go buan',
    'Move page': 'Bog leathanach',
    'Archive page': 'Cartlannaigh leathanach',
    'Suggestion {value1}: show its card': 'Moladh {value1}: taispeáin a chárta',
    'Removed:': 'Bainte:',
    'Added:': 'Curtha leis:',
    'New page “{value1}”{value2}': 'Leathanach nua “{value1}”{value2}',
    'No pages match “{value1}”.': 'Níl aon leathanach comhoiriúnach le “{value1}”.',
    'Where this page is': 'Cá bhfuil an leathanach seo',
    'Describe your company': 'Déan cur síos ar do chuideachta',
    'Empty page': 'Leathanach folamh',
    'Describe {value1}': 'Déan cur síos ar {value1}',
    'This page has no text yet.': 'Níl aon téacs ar an leathanach seo fós.',
    'Poneva reads this page before every answer. Start with who you are, what you sell and how you work; details go on the pages under it.':
      'Léann Poneva an leathanach seo roimh gach freagra. Tosaigh le cé thú féin, cad a dhíolann tú agus conas a oibríonn tú; cuir na sonraí ar na leathanaigh faoina bhun.',
    'Write it, or ask Poneva in chat to draft it for you.':
      'Scríobh é, nó iarr ar Poneva sa chomhrá dréacht a dhéanamh duit.',
    'Suggest a first version, and a publisher decides whether it becomes the page.':
      'Mol an chéad leagan, agus cinnfidh foilsitheoir an mbeidh sé ina leathanach.',
    'Start writing': 'Tosaigh ag scríobh',
    'Suggest a first version': 'Mol an chéad leagan',
    'Accepted. The page is archived.': 'Glacadh leis. Tá an leathanach cartlannaithe.',
    'Accepted. The page is now revision {value1}.':
      'Glacadh leis. Tá an leathanach anois ina leasú {value1}.',
    'Accepted.': 'Glacadh leis.',
    'Suggestion rejected. The page stays as it is.':
      'Diúltaíodh don mholadh. Fanann an leathanach mar atá.',
    'Your suggestion is withdrawn.': 'Tarraingíodh siar do mholadh.',
    'Restored. The page informs answers again.':
      'Athchóiríodh é. Cuireann an leathanach eolas ar fáil do fhreagraí arís.',
    'Your suggestion is sent. A publisher decides whether it becomes the page.':
      'Seoladh do mholadh. Cinnfidh foilsitheoir an mbeidh sé ina leathanach.',
    'Saved. The page is now revision {value1}.':
      'Sábháladh é. Tá an leathanach anois ina leasú {value1}.',
    'Nothing changed.': 'Níor athraíodh dada.',
    'This page is not available.': 'Níl an leathanach seo ar fáil.',
    'It may have been deleted, archived or moved out of reach, or you may no longer be in this company.':
      'B’fhéidir gur scriosadh, gur cartlannaíodh nó gur bogadh as do rochtain é, nó b’fhéidir nach bhfuil tú sa chuideachta seo a thuilleadh.',
    'Page actions': 'Gníomhartha leathanaigh',
    shown: 'léirithe',
    hidden: 'i bhfolach',
    '{value1} History': 'Stair {value1}',
    '{value1} Ask in chat': '{value1} Fiafraigh sa chomhrá',
    'Suggest edits': 'Mol eagarthóireacht',
    'More actions for {value1}': 'Tuilleadh gníomhartha le haghaidh {value1}',
    '{value1} Poneva reads this page in every chat':
      '{value1} Léann Poneva an leathanach seo i ngach comhrá',
    'This page is archived. It no longer informs answers; its history is kept. {value1}':
      'Tá an leathanach seo cartlannaithe. Ní chuireann sé eolas ar fáil do fhreagraí a thuilleadh; coinnítear a stair. {value1}',
    'Restore page': 'Athchóirigh leathanach',
    'This link points to an earlier revision. You are reading the current text.':
      'Díríonn an nasc seo ar leasú níos luaithe. Tá an téacs reatha á léamh agat.',
    'Show it in History': 'Taispeáin sa Stair é',
    Pages: 'Leathanaigh',
    'Pages under {value1}': 'Leathanaigh faoi {value1}',
    'Linked from': 'Naisc uaidh',
    Suggestions: 'Moltaí',
    'Suggestions are hidden. You are reading the page as everyone else sees it.':
      'Tá na moltaí i bhfolach. Tá an leathanach á léamh agat mar a fheiceann gach duine eile é.',
    'Loading suggestions…': 'Moltaí á lódáil…',
    'Nothing is waiting for review.': 'Níl aon rud ag fanacht le hathbhreithniú.',
    'When someone, Poneva in a chat or a connected agent suggests a change to a page, it shows here and on the page. Nothing changes until a publisher accepts it.':
      'Nuair a mholann duine, Poneva i gcomhrá nó gníomhaire nasctha athrú ar leathanach, taispeántar anseo agus ar an leathanach é. Ní athraítear dada go nglacann foilsitheoir leis.',
    '{value1} Review knowledge in chat': '{value1} Déan athbhreithniú ar an eolas sa chomhrá',
    'Suggestions for review': 'Moltaí le hathbhreithniú',
    'Suggested changes from chats, meetings, colleagues and connected agents. Nothing changes until a publisher accepts it on the page.':
      'Athruithe molta ó chomhráite, cruinnithe, comhghleacaithe agus gníomhairí nasctha. Ní athraítear dada go nglacann foilsitheoir leo ar an leathanach.',
    'Your suggestions wait here until a publisher decides. The pages stay as they are until then.':
      'Fanann do mholtaí anseo go dtí go gcinnfidh foilsitheoir. Fanann na leathanaigh mar atá go dtí sin.',
    'Review page': 'Déan athbhreithniú ar an leathanach',
    'Review on page': 'Déan athbhreithniú ar an leathanach',
    'Open the meeting': 'Oscail an cruinniú',
    'Open the chat': 'Oscail an comhrá',
    'Accept and restore': 'Glac leis agus athchóirigh',
    Accept: 'Glac leis',
    Reject: 'Diúltaigh',
    'Your suggestion · waiting for a publisher': 'Do mholadh · ag fanacht le foilsitheoir',
    Withdraw: 'Tarraing siar',
    'Waiting for a publisher': 'Ag fanacht le foilsitheoir',
    'Suggestion {value1}': 'Moladh {value1}',
    'Suggestion {value1} from {value2}{value3}': 'Moladh {value1} ó {value2}{value3}',
    'Read the suggested page': 'Léigh an leathanach molta',
    'Outdated: the text it changes was edited after it was suggested. It can be rejected or withdrawn; a new suggestion can be made against the current text.':
      'As dáta: rinneadh eagarthóireacht ar an téacs a athraíonn sé tar éis an moladh a dhéanamh. Is féidir é a dhiúltú nó a tharraingt siar; is féidir moladh nua a dhéanamh bunaithe ar an téacs reatha.',
    'Restore this page first to accept this suggestion.':
      'Athchóirigh an leathanach seo ar dtús chun glacadh leis an moladh seo.',
    'Previous suggestion': 'Moladh roimhe seo',
    'Suggestion {value1} of {value2}': 'Moladh {value1} as {value2}',
    'Next suggestion': 'An chéad mholadh eile',
    'Fold the suggestions away': 'Folaigh na moltaí',
    'Show the suggestions': 'Taispeáin na moltaí',
    '1 suggestion': '1 mholadh',
    '{value1} suggestions': '{value1} mholadh',
    '{value1} the pages under {value2}': '{value1} na leathanaigh faoi {value2}',
    px: 'px',
    '{value1} chart of {value2} across {value3}': 'Cairt {value1} de {value2} thar {value3}',
    'We could not build the file.': 'Níorbh fhéidir linn an comhad a chruthú.',
    '{value1} Present': 'Láithreoireacht {value1}',
    'Building…': 'Á chruthú…',
    'Download PowerPoint': 'Íoslódáil PowerPoint',
    'Slide {value1} of {value2}': 'Sleamhnán {value1} as {value2}',
    Slides: 'Sleamhnáin',
    'Slide {value1}': 'Sleamhnán {value1}',
    'Speaker notes': 'Nótaí an chainteora',
    'Source: {value1}': 'Foinse: {value1}',
    'Add a name and a web address.': 'Cuir ainm agus seoladh gréasáin leis.',
    'Enter a valid web address.': 'Cuir isteach seoladh gréasáin bailí.',
    'Use a web address that starts with https://.':
      'Úsáid seoladh gréasáin a thosaíonn le https://.',
    'Add a custom connection': 'Cuir nasc saincheaptha leis',
    'Connect a tool server you trust. Poneva checks the address works and saves only the connection details needed to use it.':
      'Ceangail le freastalaí uirlisí a bhfuil muinín agat as. Seiceálann Poneva go n-oibríonn an seoladh agus ní shábhálann sé ach na sonraí nasctha atá riachtanach chun é a úsáid.',
    'Web address': 'Seoladh gréasáin',
    'https://tools.example.com': 'https://tools.example.com',
    'Starts with https://, from your provider': 'Tosaíonn le https://, ó do sholáthraí',
    'Sign-in': 'Logáil isteach',
    'Advanced sign-in': 'Ardlogáil isteach',
    'Access key {value1}': 'Eochair rochtana {value1}',
    'Request headers': 'Ceanntásca iarratais',
    'Add header': 'Cuir ceanntásc leis',
    'Header {value1} name': 'Ainm cheanntásc {value1}',
    'Header name': 'Ainm an cheanntáisc',
    'Header {value1} value': 'Luach cheanntásc {value1}',
    'Header value': 'Luach an cheanntáisc',
    'Remove header': 'Bain an ceanntásc',
    Advanced: 'Ardsocruithe',
    Transport: 'Iompar',
    'Auto-detect': 'Braith go huathoibríoch',
    'Streamable HTTP': 'Streamable HTTP',
    'Legacy SSE': 'Legacy SSE',
    "From your provider's app settings. Leave empty unless they gave you these.":
      'Ó shocruithe aip do sholáthraí. Fág folamh é mura dtug siad na sonraí seo duit.',
    "Authorization server issuer": "Eisitheoir an fhreastalaí údaraithe",
    "Enter the authorization server issuer when using a client ID.": "Cuir isteach eisitheoir an fhreastalaí údaraithe nuair a úsáideann tú aitheantas cliaint.",
    'Client ID {value1}': 'Aitheantas cliaint {value1}',
    'Client secret {value1}': 'Rún cliaint {value1}',
    'Connecting…': 'Ag nascadh…',
    'Test and connect': 'Tástáil agus ceangail',
    'Add the store, the client ID and the client secret.':
      'Cuir an siopa, aitheantas an chliaint agus rún an chliaint leis.',
    'Connect your Shopify Developer App': 'Ceangail d’Aip Forbróra Shopify',
    'Poneva can use exactly the access your store gave the app, and nothing more. It talks to Shopify directly and keeps the client secret encrypted.':
      'Ní féidir le Poneva ach an rochtain a thug do shiopa don aip a úsáid, agus faic eile. Déanann sé cumarsáid dhíreach le Shopify agus coimeádann sé rún an chliaint criptithe.',
    'How to create the app in Shopify': 'Conas an aip a chruthú in Shopify',
    'Open{value1} {value2}{value3} with the account that owns the store, and create an app.':
      'Oscail{value1} {value2}{value3} leis an gcuntas ar leis an siopa, agus cruthaigh aip.',
    'Create a version and select the access scopes Poneva may use, for example read_products and read_orders. Add write_ scopes only for data Poneva may change. Then release the version.':
      'Cruthaigh leagan agus roghnaigh na scóipeanna rochtana a bhféadfaidh Poneva iad a úsáid, mar shampla read_products agus read_orders. Ná cuir scóipeanna write_ leis ach amháin le haghaidh sonraí a bhféadfaidh Poneva iad a athrú. Ansin eisigh an leagan.',
    'For orders and customers, also select protected customer data in the app’s settings. Shopify allows this without review for an app made for your own store.':
      'Maidir le horduithe agus custaiméirí, roghnaigh sonraí custaiméirí cosanta i socruithe na haipe freisin. Ceadaíonn Shopify é seo gan athbhreithniú d’aip a rinneadh do do shiopa féin.',
    'Install the app on your store.': 'Suiteáil an aip ar do shiopa.',
    'Copy the client ID and client secret from the app’s settings.':
      'Cóipeáil aitheantas agus rún an chliaint ó shocruithe na haipe.',
    'To change the access later, release a new version, approve it on the store and use Test connection here.':
      'Chun an rochtain a athrú níos déanaí, eisigh leagan nua, ceadaigh é ar an siopa agus úsáid Tástáil an naisc anseo.',
    Store: 'Siopa',
    'your-store.myshopify.com': 'your-store.myshopify.com',
    'Your store’s .myshopify.com address (Shopify admin → Settings → Domains), or paste the address of your Shopify admin page':
      'Seoladh .myshopify.com do shiopa (riarthóir Shopify → Settings → Domains), nó greamaigh seoladh do leathanaigh riarthóra Shopify',
    'Client ID {value1} {value2}': 'Aitheantas cliaint {value1} {value2}',
    'Client secret {value1} {value2}': 'Rún cliaint {value1} {value2}',
    Person: 'Duine',
    Everyone: 'Gach duine',
    Connection: 'Nasc',
    'All connections': 'Gach nasc',
    'App {value1}': 'Aip {value1}',
    'From {value1}': 'Ó {value1}',
    'Until {value1}': 'Go dtí {value1}',
    Result: 'Toradh',
    'All results': 'Gach toradh',
    Succeeded: 'D’éirigh leis',
    Denied: 'Diúltaíodh dó',
    Failed: 'Theip air',
    Unknown: 'Anaithnid',
    Filter: 'Scagaire',
    'Loading activity…': 'Gníomhaíocht á luchtú…',
    'Could not load activity. Try again.':
      'Níorbh fhéidir an ghníomhaíocht a luchtú. Bain triail eile as.',
    'Removed connection': 'Nasc bainte',
    'App: {value1}': 'Aip: {value1}',
    'Older activity': 'Gníomhaíocht níos sine',
    Download: 'Íoslódáil',
    CSV: 'CSV',
    'Evidence for {value1}': 'Fianaise ar {value1}',
    Measure: 'Tomhas',
    'Show rows →': 'Taispeáin sraitheanna →',
    'Ask about this number': 'Cuir ceist faoin uimhir seo',
    'There are no numeric values available to chart. View the table for the original data.':
      'Níl aon luachanna uimhriúla ar fáil le cur i gcairt. Féach ar an tábla chun na sonraí bunaidh a fheiceáil.',
    'Chart value': 'Luach na cairte',
    '{value1} of {value2} shown': 'Taispeántar {value1} as {value2}',
    '{value1} by {value2}; {value3} rows. View Table for exact values.':
      '{value1} faoi {value2}; {value3} sraith. Féach ar an Tábla chun na luachanna beachta a fheiceáil.',
    'Values come directly from the source data. Missing values are not estimates.':
      'Tagann na luachanna go díreach ó na sonraí foinse. Ní meastacháin iad luachanna atá ar iarraidh.',
    'Loading library…': 'Leabharlann á luchtú…',
    'We couldn’t load what happened in this App. Try again in a moment.':
      'Níorbh fhéidir linn an méid a tharla san Aip seo a luchtú. Bain triail eile as ar ball.',
    'This App could not be opened.': 'Níorbh fhéidir an Aip seo a oscailt.',
    'Opening App…': 'Aip á hoscailt…',
    'Open the saved App to run this function.':
      'Oscail an Aip shábháilte chun an fheidhm seo a rith.',
    'Save this App before running its function.': 'Sábháil an Aip seo sula ritheann tú a feidhm.',
    'Open saved App': 'Oscail an Aip shábháilte',
    'Open Apps': 'Oscail Aipeanna',
    'The App could not be opened. Try again.':
      'Níorbh fhéidir an Aip a oscailt. Bain triail eile as.',
    Owner: 'Úinéir',
    '{value1} · admins': '{value1} · riarthóirí',
    'Owner · always edits': 'Úinéir · déanann sé eagarthóireacht i gcónaí',
    'Admins manage it': 'Bainistíonn riarthóirí é',
    Editors: 'Eagarthóirí',
    'A colleague': 'Comhghleacaí',
    'Can edit drafts and publish versions':
      'Is féidir dréachtaí a chur in eagar agus leaganacha a fhoilsiú',
    Remove: 'Bain',
    'No editors yet.': 'Níl aon eagarthóirí ann fós.',
    'Admins can always edit company agents.':
      'Is féidir le riarthóirí eagarthóireacht a dhéanamh i gcónaí ar ghníomhairí na cuideachta.',
    'Asking for edit access': 'Rochtain eagarthóireachta á hiarraidh',
    'Asked {value1} · also in your Inbox': 'Iarrtha {value1} · i do Bhosca Isteach freisin',
    Grant: 'Deonaigh',
    Admin: 'Riarthóir',
    'Make personal': 'Déan pearsanta',
    'Switch off': 'Múch',
    Archive: 'Cuir sa chartlann',
    'Archive this agent': 'Cuir an gníomhaire seo sa chartlann',
    'Loading agent…': 'Gníomhaire á luchtú…',
    '{value1} Edit in chat': '{value1} Cuir in eagar sa chomhrá',
    Agent: 'Gníomhaire',
    'This agent has not been created yet. It can run once its owner creates it.':
      'Níl an gníomhaire seo cruthaithe fós. Is féidir é a rith nuair a chruthaíonn a úinéir é.',
    'New agent · Draft': 'Gníomhaire nua · Dréacht',
    'Untitled agent': 'Gníomhaire gan teideal',
    'Test run': 'Rith tástála',
    'This draft does not run automatically.': 'Ní ritheann an dréacht seo go huathoibríoch.',
    'Describe the agent in the chat. Its draft appears here.':
      'Déan cur síos ar an ngníomhaire sa chomhrá. Beidh a dhréacht le feiceáil anseo.',
    '{value1} Test run': '{value1} Rith tástála',
    'Describe the agent in the chat first.': 'Déan cur síos ar an ngníomhaire sa chomhrá ar dtús.',
    'Create and turn on': 'Cruthaigh agus cuir ar siúl',
    'Connection write setup': 'Socrú scríbhneoireachta naisc',
    'Account for connected changes': 'Cuntas le haghaidh athruithe nasctha',
    'Choose a connection': 'Roghnaigh nasc',
    'No published Skills available. You can add them later.':
      'Níl aon Scileanna foilsithe ar fáil. Is féidir leat iad a chur leis níos déanaí.',
    '{value1} · not published. Review the changes. Testing is optional.':
      '{value1} · gan foilsiú. Déan athbhreithniú ar na hathruithe. Tá tástáil roghnach.',
    '{value1} Test draft': '{value1} Dréacht tástála',
    'Apply changes…': 'Cuir athruithe i bhfeidhm…',
    'Apply this draft as a new version': 'Cuir an dréacht seo i bhfeidhm mar leagan nua',
    'This draft cannot be applied.': 'Ní féidir an dréacht seo a chur i bhfeidhm.',
    'What changed?': 'Cad a d’athraigh?',
    'Apply version {value1}': 'Cuir leagan {value1} i bhfeidhm',
    Create: 'Cruthaigh',
    'Edit access requested': 'Rochtain eagarthóireachta iarrtha',
    '{value1} Request edit access': '{value1} Iarr rochtain eagarthóireachta',
    '{value1} Copy agent': '{value1} Cóipeáil gníomhaire',
    Pause: 'Sos',
    'Open agent: {value1}': 'Oscail gníomhaire: {value1}',
    '· you can edit': '· is féidir leat eagarthóireacht a dhéanamh',
    '{value1} is switched off.': 'Tá {value1} múchta.',
    '{value1} is archived.': 'Tá {value1} sa chartlann.',
    'Loading agents…': 'Gníomhairí á luchtú…',
    Agents: 'Gníomhairí',
    'Agents do work for you on a schedule or when you ask. They follow your company’s Skills.':
      'Déanann gníomhairí obair duit de réir sceidil nó nuair a iarrann tú orthu. Leanann siad Scileanna do chuideachta.',
    'No agent matches. Try a Skill name or what the agent should do.':
      'Ní mheaitseálann aon ghníomhaire. Bain triail as ainm Scile nó as cur síos ar an méid ba cheart don ghníomhaire a dhéanamh.',
    'Nothing of your own yet': 'Níl aon cheann de do chuid féin ann fós',
    'Tell Chat what an agent should do, or copy one of the company’s agents below.{value1}':
      'Inis do Chat cad ba cheart do ghníomhaire a dhéanamh, nó cóipeáil ceann de ghníomhairí na cuideachta thíos.{value1}',
    'Your agents': 'Do ghníomhairí',
    'Run on demand': 'Rith ar éileamh',
    'Run is always available. A schedule is optional and lives separately from the agent’s instructions.':
      'Bíonn rith ar fáil i gcónaí. Tá sceideal roghnach agus coinnítear é ar leithligh ó threoracha an ghníomhaire.',
    'What changed in version {value1}': "Cad a d'athraigh i leagan {value1}",
    'Every publish is a version you can restore.':
      'Is leagan é gach foilsiú ar féidir leat a athchóiriú.',
    Authorization: 'Údarú',
    '{value1} {value2} · {value3} will see it.': 'Feicfidh {value1} {value2} · {value3} é.',
    '{value1} {value2} you': '{value1} {value2} tú',
    '· Revised': '· Athbhreithnithe',
    'This chat used your {value1}.': 'Bhain an comhrá seo úsáid as do {value1}.',
    'This chat has results from {value1}.': 'Tá torthaí ó {value1} sa chomhrá seo.',
    'db.example.com': 'db.example.com',
    'e.g. Product analytics': 'm.sh. Anailísíocht táirge',
    'Paste access key': 'Greamaigh an eochair rochtana',
    'Shopify’s Dev Dashboard': 'Painéal Forbróra Shopify',
    'App reference': 'Tagairt aip',
    'Draft · revision {value1}': 'Dréacht · leasú {value1}',
    'its Result': 'a Thoradh',
    '· its first run makes it': '· déanann a chéad rith é',
    '{value1}’s chat ·': 'comhrá {value1} ·',
    '{value1} ad {value2} available.': 'Tá {value1} agus {value2} ar fáil.',
    '{value1} rows ·': '{value1} sraith ·',
    'It starts private. Sharing it wider shares every refresh, which can carry your private data.':
      'Tosaíonn sé príobháideach. Má roinneann tú é ar bhonn níos leithne, roinneann tú gach athnuachan, agus d’fhéadfadh do shonraí príobháideacha a bheith inti.',
    'Enable this schedule when approved': 'Cuir an sceideal seo ar siúl nuair a cheadaítear é',
    Schedule: 'Sceideal',
    'Kept off until you create the agent from its canvas.':
      'Coinneofar múchta é go dtí go gcruthóidh tú an gníomhaire óna chanbhás.',
    'Will be enabled when you approve.': 'Cuirfear ar siúl é nuair a cheadaíonn tú é.',
    'Will be saved paused. You can enable it later.':
      'Sábhálfar ar sos é. Is féidir leat é a chur ar siúl níos déanaí.',
    'Only runs when you ask.': 'Ní ritheann sé ach nuair a iarrann tú é.',
    'Draft · approving saves it, and nothing runs. Test it and create it from its canvas.':
      'Dréacht · sábhálann an ceadú é, agus ní ritheann aon rud. Déan tástáil air agus cruthaigh é óna chanbhás.',
    'Draft · nothing is scheduled until you approve. Connected actions require their own approval at run time.':
      'Dréacht · ní sceidealaítear aon rud go dtí go gceadaíonn tú é. Teastaíonn ceadú ar leith ó ghníomhartha ceangailte ag am an rite.',
    Name: 'Ainm',
    'Agent name': 'Ainm an ghníomhaire',
    'Who can use it': 'Cé atá in ann é a úsáid',
    'Company agent · company resources only':
      'Gníomhaire cuideachta · acmhainní na cuideachta amháin',
    'Personal agent · runs with your access': 'Gníomhaire pearsanta · ritheann sé le do rochtain',
    'Approving saves it as a draft. It does not run automatically.':
      'Trí é a cheadú, sábháiltear mar dhréacht é. Ní ritheann sé go huathoibríoch.',
    'Open the agent’s runs': 'Oscail ritheanna an ghníomhaire',
    'Run the published version once': 'Rith an leagan foilsithe uair amháin',
    'Stopping…': 'Ag stopadh…',
    'Stop run': 'Stop an rith',
    'Could not stop this run. Please try again.':
      'Níorbh fhéidir an rith seo a stopadh. Bain triail eile as le do thoil.',
    'Run in progress': 'Rith ar bun',
    'This run is still answering. You can ask follow-ups when it finishes.':
      'Tá an rith seo fós ag tabhairt freagra. Is féidir leat ceisteanna leantacha a chur nuair a chríochnaíonn sé.',
    'Open run details': 'Oscail sonraí an rite',
    Runs: 'Ritheanna',
    'Open the run chat': 'Oscail comhrá an rite',
    Watch: 'Féach',
    Goal: 'Aidhm',
    'Change the goal': 'Athraigh an aidhm',
    'What it does': 'A fheidhm',
    'What should this agent achieve?': 'Cad ba cheart don ghníomhaire seo a bhaint amach?',
    'Not set yet.': 'Níl sé socraithe fós.',
    'When it runs': 'Cathain a ritheann sé',
    'Change when it runs': 'Athraigh cathain a ritheann sé',
    'Off means it runs only when someone runs it. Changing when it runs never changes its instructions.':
      'Ciallaíonn múchta nach ritheann sé ach nuair a ritheann duine é. Ní athraíonn athrú an ama a ritheann sé a threoracha riamh.',
    Instructions: 'Treoracha',
    'Change the instructions': 'Athraigh na treoracha',
    'How the agent should approach the work and make decisions.':
      'An chaoi ar cheart don ghníomhaire tabhairt faoin obair agus cinntí a dhéanamh.',
    Boundaries: 'Teorainneacha',
    'What to do or avoid. Every connected action still follows its approval.':
      'Cad atá le déanamh nó le seachaint. Leanann gach gníomh ceangailte a cheadú fós.',
    'No instructions of its own. It follows its Skills.':
      'Níl aon treoracha dá chuid féin aige. Leanann sé a Scileanna.',
    'Pin a Skill': 'Pinn scil',
    'Finds the Skills that fit each run, the same way a chat does.':
      'Aimsíonn sé na Scileanna a oireann do gach rith, ar an mbealach céanna le comhrá.',
    'Skills it always follows': 'Scileanna a leanann sé i gcónaí',
    'A Skill that is not published': 'Scil nach bhfuil foilsithe',
    'Always follows · Version {value1}': 'Leanann sé i gcónaí · Leagan {value1}',
    'Not published': 'Gan foilsiú',
    Uses: 'Úsáideann',
    'Change in chat': 'Athraigh sa chomhrá',
    'Change in chat: Uses': 'Athraigh sa chomhrá: Úsáideann',
    'Company knowledge and the tools each run is allowed to use.':
      'Eolas na cuideachta agus na huirlisí a bhfuil cead ag gach rith iad a úsáid.',
    'People see the Result refresh; they change the agent, not the page.':
      'Feiceann daoine an Toradh á athnuachan; athraíonn siad an gníomhaire, ní an leathanach.',
    'The first run after it is created makes the Result; later runs add a version to it.':
      'Cruthaíonn an chéad rith tar éis é a chruthú an Toradh; cuireann ritheanna níos déanaí leagan leis.',
    'Emails whoever the run is for':
      'Seolann sé ríomhphost chuig an duine dá bhfuil an rith beartaithe',
    'Email each run': 'Seol ríomhphost faoi gach rith',
    Delivers: 'Seachadann',
    'Change what it delivers': 'Athraigh an méid a sheachadann sé',
    'Expected result': 'Toradh a bhfuiltear ag súil leis',
    'What a successful run should deliver.': 'An méid ba cheart do rith rathúil a sheachadadh.',
    'What each run delivers': 'An méid a sheachadann gach rith',
    'Keeps one Result up to date {value1}': 'Coinníonn sé Toradh amháin cothrom le dáta {value1}',
    'Saves a new Result each run': 'Sábhálann sé Toradh nua le gach rith',
    'You can run this company agent as yourself.{value1} {value2}':
      'Is féidir leat an gníomhaire cuideachta seo a rith mar tú féin.{value1} {value2}',
    'Changes since version': 'Athruithe ón leagan',
    'are not live yet.': 'níl siad beo fós.',
    'Review them in Versions': 'Déan athbhreithniú orthu i Leaganacha',
    Skill: 'Scil',
    'The agent always uses the Skill’s published version.':
      'Úsáideann an gníomhaire leagan foilsithe na Scile i gcónaí.',
    Day: 'Lá',
    Time: 'Am',
    'Cron expression': 'Slonn Cron',
    'Editors and access': 'Eagarthóirí agus rochtain',
    Company: 'Cuideachta',
    Personal: 'Pearsanta',
    'No changes.': 'Gan aon athruithe.',
    'Instructions changes': 'Athruithe ar na treoracha',
    'Loading versions…': 'Leaganacha á lódáil…',
    'What the draft changes': 'Na hathruithe sa dréacht',
    'No published version yet. Try the draft, then publish it.':
      'Níl aon leagan foilsithe ann fós. Bain triail as an dréacht, ansin foilsigh é.',
    'Published versions': 'Leaganacha foilsithe',
    'Former member': 'Iarbhall',
    Live: 'Beo',
    '{value1} for {value2}': '{value1} do {value2}',
    Suggested: 'Molta',
    'Opening your conversation…': 'Ag oscailt do chomhrá…',
    'This conversation isn’t available': 'Níl an comhrá seo ar fáil',
    'It may have been deleted, belong to another account, or be temporarily unavailable.':
      'Seans gur scriosadh é, gur le cuntas eile é, nó nach bhfuil sé ar fáil go sealadach.',
    '{count} more line — shown in the complete revision':
      '{count} líne bhreise — taispeántar sa leasú iomlán',
    '{count} more lines — shown in the complete revision':
      '{count} líne bhreise — taispeántar sa leasú iomlán',
    '{count} more line removed': 'Baineadh {count} líne bhreise',
    '{count} more lines removed': 'Baineadh {count} líne bhreise',
    '{count} unchanged line': '{count} líne gan athrú',
    '{count} unchanged lines': '{count} líne gan athrú',
    '{count} more lines not shown, {added} added and {removed} removed. Check them in the complete revision.':
      'Ní thaispeántar {count} líne bhreise; cuireadh {added} leis agus baineadh {removed}. Seiceáil iad sa leasú iomlán.',
    'Saved result': 'Toradh sábháilte',
    'Made with a Skill': 'Déanta le Scil',
    'Preview of {name}': 'Réamhamharc ar {name}',
    'Made with {name}': 'Déanta le {name}',
    'Ad-hoc result': 'Toradh ad hoc',
    'A Skill that is not available in this workspace': 'Scil nach bhfuil ar fáil sa spás oibre seo',
    '{name} · Revision {version}': '{name} · Leasú {version}',
    '{name} · Version {version}': '{name} · Leagan {version}',
    'Return to conversation {value1}': 'Fill ar ais chuig an gcomhrá {value1}',
    '{value1} Working with {value2}': '{value1} Ag obair le {value2}',
    'View context {value1}': 'Féach ar chomhthéacs {value1}',
    'A way of working, made yours.': 'Bealach oibre, déanta duitse.',
    'Work that runs itself.': 'Obair a ritheann léi féin.',
    'One place for one piece of work.': 'Áit amháin do phíosa oibre amháin.',
    'Let’s move your work forward{value1}.': 'Cuirimis do chuid oibre chun cinn{value1}.',
    'Describe the work. Your Skill takes shape beside the conversation.':
      'Déan cur síos ar an obair. Tagann cruth ar do Scil taobh leis an gcomhrá.',
    'Describe what it should do and when. Your agent takes shape beside the conversation. The draft does not run automatically.':
      'Déan cur síos ar a bhfuil le déanamh aige agus cathain. Tagann cruth ar do ghníomhaire taobh leis an gcomhrá. Ní ritheann an dréacht go huathoibríoch.',
    'Say what the work is. Poneva drafts the project beside the conversation and brings in what you have already done. Nothing is created until you say so.':
      'Abair cén obair atá i gceist. Déanann Poneva dréacht den tionscadal taobh leis an gcomhrá agus tugann sé isteach an méid atá déanta agat cheana. Ní chruthaítear aon rud go dtí go ndeir tú amhlaidh.',
    'Start with an idea below. Poneva will take it from there.':
      'Tosaigh le smaoineamh thíos. Tabharfaidh Poneva faoin gcuid eile.',
    Triggers: 'Truicearáin',
    'Review the agent and its trigger. Approval applies exactly what is shown.':
      'Déan athbhreithniú ar an ngníomhaire agus ar a thruicear. Cuireann an ceadú i bhfeidhm go díreach an rud a thaispeántar.',
    '{source} · read {date}': '{source} · léite {date}',
    'Evidence is being recorded · read {date}': 'Tá fianaise á taifeadadh · léite {date}',
    'Evidence expired on {date} under the retention policy':
      'Chuaigh an fhianaise in éag an {date} faoin mbeartas coinneála',
    'Entered by {person}': 'Curtha isteach ag {person}',
    'No retained evidence for this value': 'Níl aon fhianaise choinnithe ann don luach seo',
    'Covers {shown} of {total} rows': 'Clúdaíonn sé {shown} de {total} sraitheanna',
    'Search rows': 'Cuardaigh sraitheanna',
    'Clear filters': 'Glan na scagairí',
    Sort: 'Sórtáil',
    'Sort: {column}': 'Sórtáil: {column}',
    '{shown} of {total} rows': '{shown} as {total} sraitheanna',
    More: 'Tuilleadh',
    Density: 'Dlús',
    Comfortable: 'Compordach',
    Compact: 'Dlúth',
    Columns: 'Colúin',
    'No rows match. Clear the search or filters to see them again.':
      'Ní mheaitseálann aon ró. Glan an cuardach nó na scagairí chun iad a fheiceáil arís.',
    'Not available': 'Níl ar fáil',
    'All rows': 'Gach ró',
    'Close row detail': 'Dún sonraí na ró',
    'Ask about this row': 'Fiafraigh faoin ró seo',
    'Add note': 'Cuir nóta leis',
    Note: 'Nóta',
    Saved: 'Sábháilte',
    Total: 'Iomlán',
    ascending: 'ardaitheach',
    descending: 'islitheach',
    'Scroll to see all columns': 'Scrollaigh chun na colúin go léir a fheiceáil',
    App: 'Aip',
    Artifact: 'Déantán',
    'New project': 'Tionscadal nua',
    'Review request': 'Iarratas athbhreithnithe',
    Activity: 'Gníomhaíocht',
    'Voice preview': 'Réamhamharc gutha',
    Source: 'Foinse',
    File: 'Comhad',
    Meeting: 'Cruinniú',
    'Knowledge page': 'Leathanach eolais',
    'Could not preview this CSV.': 'Níorbh fhéidir réamhamharc a dhéanamh ar an CSV seo.',
    'File content is unavailable.': 'Níl inneachar an chomhaid ar fáil.',
    'You have five open suggestions here. {value1} will see them.':
      'Tá cúig mholadh oscailte agat anseo. Feicfidh {value1} iad.',
    'We could not send your suggestion. Please try again.':
      'Níorbh fhéidir linn do mholadh a sheoladh. Bain triail eile as le do thoil.',
    'The agent': 'An gníomhaire',
    'Selected colleagues': 'Comhghleacaithe roghnaithe',
    'The owner': 'An t-úinéir',
    'Forked. This copy is yours and runs with your own connections.':
      'Cruthaíodh cóip. Is leatsa an chóip seo agus ritheann sí le do naisc féin.',
    'This chat is too long to fork.': 'Tá an comhrá seo rómhór le cóipeáil.',
    'We could not fork this chat. Please try again.':
      'Níorbh fhéidir linn an comhrá seo a chóipeáil. Bain triail eile as le do thoil.',
    'Anyone who forked it keeps their copy: forks stay with the people who made them.':
      'Coinníonn aon duine a rinne cóip de a chóip féin: fanann na cóipeanna leo siúd a rinne iad.',
    'Nobody has forked this chat.': 'Ní dhearna aon duine cóip den chomhrá seo.',
    '1 person forked this chat. Their copy stays theirs.':
      'Rinne duine amháin cóip den chomhrá seo. Fanann an chóip leo.',
    '{value1} people forked this chat. Their copies stay theirs.':
      'Rinne {value1} duine cóipeanna den chomhrá seo. Fanann na cóipeanna leo.',
    'Personal. Nobody else sees it.': 'Pearsanta. Ní fheiceann aon duine eile é.',
    'People you pick. They get it in their Inbox.':
      'Na daoine a roghnaíonn tú. Gheobhaidh siad é ina mBosca Isteach.',
    'Everyone in the company can follow it and fork it.':
      'Is féidir le gach duine sa chuideachta é a leanúint agus cóip a dhéanamh de.',
    'a chat you can no longer open': 'comhrá nach féidir leat a oscailt a thuilleadh',
    'shared the Result': 'roinn an Toradh',
    'updated the Result': 'nuashonraigh an Toradh',
    'published the Skill': "d'fhoilsigh an Scil",
    'approved the fact': 'cheadaigh an fhíric',
    'added the fact': 'chuir an fhíric leis',
    'added the meeting': 'chuir an cruinniú leis',
    'published the page': "d'fhoilsigh an leathanach",
    'updated the page': 'nuashonraigh an leathanach',
    'shared the chat': 'roinn an comhrá',
    'published a version of': "d'fhoilsigh leagan de",
    ran: 'rith',
    Knowledge: 'Eolas',
    Meetings: 'Cruinnithe',
    Chat: 'Comhrá',
    Use: 'Úsáid',
    Open: 'Oscail',
    You: 'Tú',
    Someone: 'Duine éigin',
    'published version {version} of': "d'fhoilsigh leagan {version} de",
    'thing needs': 'rud de dhíth',
    'things need': 'rudaí de dhíth',
    'Published Skill': 'Scil fhoilsithe',
    'Included with Skill': 'San áireamh leis an Scil',
    'Already attached': 'Ceangailte cheana',
    'Also available in company knowledge': 'Ar fáil freisin in eolas na cuideachta',
    'Company file': 'Comhad cuideachta',
    'Account identity unavailable': 'Céannacht an chuntais ar fáil',
    'Access expired or was revoked. Reconnect to continue.':
      'Chuaigh an rochtain in éag nó cúlghaireadh í. Athcheangail chun leanúint ar aghaidh.',
    'Account authorized · tools unavailable': 'Cuntas údaraithe · uirlisí nach bhfuil ar fáil',
    'Not available in this workspace yet.': 'Níl sé ar fáil sa spás oibre seo fós.',
    'Everyone in the company': 'Gach duine sa chuideachta',
    'Audience: only you.': 'Lucht féachana: tusa amháin.',
    'Audience: everyone in the company.': 'Lucht féachana: gach duine sa chuideachta.',
    'tool is': 'is uirlis',
    'tools are': 'is uirlisí',
    'account is': 'is cuntas',
    'accounts are': 'is cuntais',
    'We could not upload this file.': 'Níorbh fhéidir linn an comhad seo a uaslódáil.',
    'file was': 'comhad',
    'files were': 'comhaid a bhí',
    'Your company': 'Do chuideachta',
    'Create an agent': 'Cruthaigh gníomhaire',
    'Give recurring work a helping hand': 'Tabhair cúnamh d’obair athfhillteach',
    'Create a Skill': 'Cruthaigh Scil',
    'Save a reusable way of working': 'Sábháil bealach oibre in-athúsáidte',
    'Take meeting notes': 'Glac nótaí cruinnithe',
    'Capture decisions and next steps': 'Taifead cinntí agus na chéad chéimeanna eile',
    'Work with a file': 'Oibrigh le comhad',
    'Start from a document or image': 'Tosaigh le doiciméad nó íomhá',
    'Browse agents': 'Brabhsáil gníomhairí',
    'Open your agents and company agents': 'Oscail do ghníomhairí agus gníomhairí na cuideachta',
    'Review results': 'Déan athbhreithniú ar thorthaí',
    'Return to work saved in your Library': 'Fill ar an obair atá sábháilte i do Leabharlann',
    'For review': 'Le haghaidh athbhreithnithe',
    'An agent': 'Gníomhaire',
    Assistant: 'Cúntóir',
    'Kept up to date by {value1}{value2}': 'Coinnithe cothrom le dáta ag {value1}{value2}',
    ', {value1}': ', {value1}',
    'Version {value1}{value2}{value3}': 'Leagan {value1}{value2}{value3}',
    'Refreshed by its agent': 'Athnuaite ag a ghníomhaire',
    'Saved from a chat': 'Sábháilte ó chomhrá',
    'Saved from {value1}': 'Sábháilte ón aip {value1}',
    Edited: 'Curtha in eagar',
    'private account': 'cuntas príobháideach',
    '{value1} ({value2})': '{value1} ({value2})',
    '{value1}’s {value2}': '{value2} de chuid {value1}',
    'Made private. The person who added it and the owner of its recording have been told in their Inbox.':
      'Socraíodh mar phríobháideach é. Cuireadh an duine a chuir leis agus úinéir a thaifeadta ar an eolas ina mBosca Isteach.',
    'Made private. The person who added it has been told in their Inbox.':
      'Socraíodh mar phríobháideach é. Cuireadh an duine a chuir leis ar an eolas ina Bhosca Isteach.',
    'Made private. The owner of its recording has been told in their Inbox.':
      'Socraíodh mar phríobháideach é. Cuireadh úinéir a thaifeadta ar an eolas ina Bhosca Isteach.',
    'Selected passage': 'Sliocht roghnaithe',
    '{value1} {value2}': '{value1} {value2}',
    'Upload a file': 'Uaslódáil comhad',
    'Help me create a useful report from our company knowledge and available sources.':
      'Cabhraigh liom tuarascáil úsáideach a chruthú ó eolas ár gcuideachta agus ó na foinsí atá ar fáil.',
    'This saved work couldn’t be opened. Open it again to retry.':
      'Níorbh fhéidir an obair shábháilte seo a oscailt. Oscail arís í chun triail eile a bhaint aisti.',
    '{value1}’s': 'de chuid {value1}',
    '{value1} chat “{value2}”': 'comhrá {value2} de chuid {value1}',
    '{value1}{value2}': '{value1}{value2}',
    'Skill: {value1}{value2}': 'Scil: {value1}{value2}',
    'Result “{value1}”': 'Toradh “{value1}”',
    'Meeting “{value1}”': 'Cruinniú “{value1}”',
    'Used in {value1} {value2} this week': 'Úsáidte in {value1} {value2} an tseachtain seo',
    '{value1} {value2} · used in {value3} {value4}':
      '{value1} {value2} · úsáidte in {value3} {value4}',
    'The draft is not published yet, so no one else follows it.':
      'Níl an dréacht foilsithe fós, mar sin ní leanann aon duine eile é.',
    'Use it in a chat for current data, or refine the Skill first.':
      'Úsáid é i gcomhrá le haghaidh sonraí reatha, nó feabhsaigh an Scil ar dtús.',
    'An agent keeps this up to date. Continue the work in chat.':
      'Coinníonn gníomhaire cothrom le dáta é seo. Lean leis an obair sa chomhrá.',
    'Edit it here, or continue the work in chat.':
      'Cuir in eagar anseo é, nó lean leis an obair sa chomhrá.',
    'Duplicate it to your Library, or continue the work in chat.':
      'Déan dúblach de i do Leabharlann, nó lean leis an obair sa chomhrá.',
    'Download Markdown': 'Íoslódáil Markdown',
    'Download CSV': 'Íoslódáil CSV',
    'an agent': 'an gníomhaire',
    'Publish a Skill version': 'Foilsigh leagan de Scil',
    'Share with {value1}': 'Comhroinn le {value1}',
    'Update company content': 'Nuashonraigh ábhar na cuideachta',
    Approved: 'Formheasta',
    Declined: 'Diúltaithe',
    Pending: 'Ar feitheamh',
    'View decision': 'Féach ar an gcinneadh',
    'No data': 'Gan sonraí',
    'No change': 'Gan athrú',
    'Connection created': 'Cruthaíodh nasc',
    'Sharing changed': 'Athraíodh an chomhroinnt',
    'Person added': 'Cuireadh duine leis',
    'Person removed': 'Baineadh duine',
    'Access changed': 'Athraíodh an rochtain',
    'Access turned off': 'Múchadh an rochtain',
    'Connection removed': 'Baineadh an nasc',
    'Query time limit changed': 'Athraíodh teorainn ama na ceiste',
    '{count} row': '{count} ró',
    '{count} rows': '{count} ró',
    'This source is no longer available. Company knowledge now lives in Knowledge pages, and files stay in the Library.':
      'Níl an fhoinse seo ar fáil níos mó. Tá eolas na cuideachta anois ar leathanaigh Eolais, agus fanann comhaid sa Leabharlann.',
    '· {value1} by {value2}': '· {value1} ag {value2}',
    '· version {value1}': '· leagan {value1}',
    '{message} {count} earlier file was saved and attached.':
      'Sábháladh agus ceanglaíodh {count} chomhad roimhe seo le {message}.',
    '{message} {count} earlier files were saved and attached.':
      'Sábháladh agus ceanglaíodh {count} chomhad roimhe seo le {message}.',
    '{message} {count} earlier file was saved.':
      'Sábháladh {count} chomhad roimhe seo le {message}.',
    '{message} {count} earlier files were saved.':
      'Sábháladh {count} chomhad roimhe seo le {message}.',
    'refreshed {time}': 'athnuachan déanta {time}',
    'a colleague': 'comhghleacaí',
    'Your chat “{title}”': 'Do chomhrá “{title}”',
    '{name}’s chat “{title}”': 'Comhrá “{title}” de chuid {name}',
    'Kept up to date by {name}{version}': 'Coinníonn {name}{version} cothrom le dáta é',
    'Skill: {name}{version}': 'Scil: {name}{version}',
    'Result “{title}”': 'Toradh “{title}”',
    'Meeting “{title}”': 'Cruinniú “{title}”',
    'Used in {count} answer this week': 'Úsáideadh i {count} fhreagra an tseachtain seo',
    'Used in {count} answers this week': 'Úsáideadh i {count} fhreagra an tseachtain seo',
    '{count} source': '{count} fhoinse',
    '{count} sources': '{count} fhoinse',
    'used in {count} place': 'úsáidte in {count} áit',
    'used in {count} places': 'úsáidte in {count} áiteanna',
    '{company} workspace': 'Spás oibre {company}',
    '{count} page': '{count} leathanach',
    '{count} pages': '{count} leathanaigh',
    '{needs} · reviews and approvals': '{needs} · athbhreithnithe agus formheasanna',
    '{count} thing needs you': 'Tá {count} rud ag fanacht leat',
    '{count} things need you': 'Tá {count} rud ag fanacht leat',
    'Included with Skill · {files} · {sources} {icon}':
      'San áireamh le Scil · {files} · {sources} {icon}',
    '{count} file': '{count} comhad',
    '{count} files': '{count} comhaid',
    Today: 'Inniu',
    'Earlier this week': 'Níos luaithe an tseachtain seo',
    '{count} slide': '{count} sleamhnán',
    '{count} slides': '{count} sleamhnáin',
    Early: 'Luath',
    'TLS verified': 'Fíoraithe le TLS',
    'Made personal and switched off. Switch it on when you are ready.':
      'Rinneadh pearsanta de agus múchadh é. Cuir ar siúl é nuair a bheidh tú réidh.',
    'Made personal and switched off. Its owner is told which version is live.':
      'Rinneadh pearsanta de agus múchadh é. Cuirtear in iúl dá úinéir cén leagan atá beo.',
    'Switched off.': 'Múchta.',
    'Applied version {revision}.': 'Leagan {revision} curtha i bhfeidhm.',
    'The draft is running in a chat only you can read.':
      'Tá an dréacht ar siúl i gcomhrá nach féidir ach leatsa é a léamh.',
    'Publish a version first.': 'Foilsigh leagan ar dtús.',
    'Another Agent action is in progress.': 'Tá gníomh Gníomhaire eile ar siúl.',
    'Knowledge & connections': 'Eolas agus naisc',
    'Pinned Skills': 'Scileanna pinnáilte',
    None: 'Níl aon cheann',
    'A new Result each run': 'Toradh nua gach rith',
    'One Result kept up to date': 'Toradh amháin coinnithe cothrom le dáta',
    Email: 'Ríomhphost',
    On: 'Ar siúl',
    Off: 'Múchta',
    'Waiting for review': 'Ag fanacht le hathbhreithniú',
    Outdated: 'As dáta',
    Accepted: 'Glactha',
    Rejected: 'Diúltaithe',
    Withdrawn: 'Aistarraingthe',
    Replaced: 'Curtha ina áit',
    'Suggested edit': 'Eagar molta',
    'Suggested new page': 'Leathanach nua molta',
    'Suggested move': 'Bogadh molta',
    'Suggested archive': 'Cartlannú molta',
    'Checking status…': 'Stádas á sheiceáil…',
    'Status unavailable': 'Níl an stádas ar fáil',
    'Bulleted list': 'Liosta le hurchair',
    'Numbered list': 'Liosta uimhrithe',
    'Web link': 'Nasc gréasáin',
    Read: 'Léigh',
    Write: 'Scríobh',
    'shared with you': 'roinnte leat',
    'Getting an answer': 'Ag fáil freagra',
    '{name} is getting an answer': 'Tá {name} ag fáil freagra',
    'We could not save. Please try again.':
      'Níorbh fhéidir linn é a shábháil. Bain triail eile as, le do thoil.',
    'The new page could not be created.': 'Níorbh fhéidir an leathanach nua a chruthú.',
    'We could not load this revision.': 'Níorbh fhéidir linn an leagan seo a luchtú.',
    'We could not restore this revision. Please try again.':
      'Níorbh fhéidir linn an leagan seo a athchóiriú. Bain triail eile as, le do thoil.',
    'We could not export this revision.': 'Níorbh fhéidir linn an leagan seo a easpórtáil.',
    'We could not open this suggestion.': 'Níorbh fhéidir linn an moladh seo a oscailt.',
    'We could not do that. Please try again.':
      'Níorbh fhéidir linn é sin a dhéanamh. Bain triail eile as, le do thoil.',
    'We could not save your decision. Please try again.':
      'Níorbh fhéidir linn do chinneadh a shábháil. Bain triail eile as, le do thoil.',
    'We could not restore this page. Please try again.':
      'Níorbh fhéidir linn an leathanach seo a athchóiriú. Bain triail eile as, le do thoil.',
    'We could not export this page.': 'Níorbh fhéidir linn an leathanach seo a easpórtáil.',
    '{count} missed time merged.': 'Cumascadh {count} iontráil ama a bhí in easnamh.',
    '{count} missed times merged.': 'Cumascadh {count} iontráil ama a bhí in easnamh.',
    'About this project': 'Maidir leis an tionscadal seo',
  },
  it: {
    'We could not load this item.': 'Non è stato possibile caricare questo elemento.',
    '{value1} canvas': 'Canvas {value1}',
    'Loading {value1}…': 'Caricamento di {value1}…',
    '{value1} · Original retained': '{value1} · Originale conservato',
    '{value1} {value2}{value3} · Added {value4}': '{value1} {value2}{value3} · Aggiunto {value4}',
    '{value1} Use in chat': '{value1} Usa nella chat',
    '{value1} Download': '{value1} Scarica',
    Table: 'Tabella',
    Chart: 'Grafico',
    Original: 'Originale',
    'Text extracted from the PDF, marked by page. Download the original for its layout and images.':
      'Testo estratto dal PDF, suddiviso per pagina. Scarica l’originale per visualizzarne il layout e le immagini.',
    'This preview shows the beginning of the file. Poneva reads the whole file; download the original to see all of it.':
      'Questa anteprima mostra l’inizio del file. Poneva legge l’intero file; scarica l’originale per visualizzarlo tutto.',
    'Preview of the first {value1} complete rows. Filtering and charts use only this preview. Download the original for the full file.':
      'Anteprima delle prime {value1} righe complete. I filtri e i grafici usano solo questa anteprima. Scarica l’originale per il file completo.',
    'This source link cannot be opened.': 'Non è possibile aprire questo link alla fonte.',
    'Read-only chat': 'Chat di sola lettura',
    'Only {value1} writes in this chat. Fork it to continue with your own connections. {value2}':
      'Solo {value1} può scrivere in questa chat. Crea un fork per continuare con le tue connessioni. {value2}',
    'Suggest a follow-up…': 'Suggerisci un seguito…',
    'Suggest a follow-up': 'Suggerisci un seguito',
    'Sending…': 'Invio…',
    Send: 'Invia',
    'We could not dismiss that suggestion. Please try again.':
      'Non è stato possibile ignorare il suggerimento. Riprova.',
    'Suggested follow-ups': 'Seguiti suggeriti',
    '{value1} suggests': '{value1} suggerisce',
    Ask: 'Chiedi',
    'Dismiss {value1}’s suggestion': 'Ignora il suggerimento di {value1}',
    'Suggested by': 'Suggerito da',
    '· edit it or send it': '· modificalo o invialo',
    'Remove the suggestion tag': 'Rimuovi il tag del suggerimento',
    '{value1} {value2} is getting an answer': '{value1} {value2} sta ricevendo una risposta',
    '{value1} {value2} stopped the answer': '{value1} {value2} ha interrotto la risposta',
    '{value1} Fork from here': '{value1} Crea un fork da qui',
    '{value1} From {value2}’s {value3}': '{value1} Da {value3} di {value2}',
    'Only {value1} can use this account': 'Solo {value1} può usare questo account',
    '{value1} Suggested by {value2}': '{value1} Suggerito da {value2}',
    'Fork this chat': 'Crea un fork di questa chat',
    'Forking…': 'Creazione del fork…',
    Fork: 'Crea fork',
    'Could not make this private.': 'Non è stato possibile renderla privata.',
    'Make this chat private?': 'Vuoi rendere privata questa chat?',
    Close: 'Chiudi',
    '{value1} will see “{value2}”. Everyone else loses access right away {value3} .{value4}':
      '{value1} vedrà “{value2}”. Tutti gli altri perderanno immediatamente l’accesso {value3} .{value4}',
    Cancel: 'Annulla',
    'Saving…': 'Salvataggio…',
    'Make private': 'Rendi privata',
    'This chat is private again. Forks others made stay theirs.':
      'Questa chat è di nuovo privata. I fork creati dagli altri resteranno di loro proprietà.',
    'Who can read this chat: {value1}': 'Chi può leggere questa chat: {value1}',
    'Move this chat': 'Sposta questa chat',
    'Only you write here. Others follow live and fork.':
      'Qui puoi scrivere solo tu. Gli altri seguono in tempo reale e possono creare fork.',
    'Made private. {value1} has been told in their Inbox.':
      'Resa privata. {value1} ha ricevuto una notifica nella Posta in arrivo.',
    'Chat access': 'Accesso alla chat',
    '{value1}’s chat. As an admin you can make it private.':
      'Chat di {value1}. In qualità di amministratore puoi renderla privata.',
    'Only {value1} will see it. {value2} is told.':
      'La vedrà solo {value1}. {value2} ha ricevuto una notifica.',
    '{value1} {value2} following': '{value1} {value2} seguono',
    'Forked from{value1} {value2} . The history is copied. From here, tools run with your own access.':
      'Fork creato da{value1} {value2} . La cronologia è stata copiata. Da qui, gli strumenti vengono eseguiti con il tuo accesso.',
    '{value1} made this chat private': '{value1} ha reso privata questa chat',
    'You can no longer open it. Any fork you made stays yours.':
      'Non puoi più aprirla. Qualsiasi fork creato da te resterà tuo.',
    'Start a new chat': 'Avvia una nuova chat',
    'Back to Recent chats': 'Torna alle chat recenti',
    'More chat actions': 'Altre azioni della chat',
    'Close conversation sharing': 'Chiudi la condivisione della conversazione',
    'Review the text before saving a private copy to Library. Then choose its audience. Your original conversation and future messages stay private.':
      'Controlla il testo prima di salvare una copia privata nella Libreria. Poi scegli il pubblico. La conversazione originale e i messaggi futuri resteranno privati.',
    'Preparing the conversation…': 'Preparazione della conversazione…',
    'Refresh preview': 'Aggiorna anteprima',
    'The copy is saved in Library. Use Share to choose who can access it.':
      'La copia è stata salvata nella Libreria. Usa Condividi per scegliere chi può accedervi.',
    'Save this copy': 'Salva questa copia',
    'That Skill could not be opened.': 'Non è stato possibile aprire quella competenza.',
    '{value1}{value2} · reviews and approvals': '{value1}{value2} · revisioni e approvazioni',
    'Open Inbox': 'Apri la Posta in arrivo',
    'New at {value1} this week': 'Novità in {value1} questa settimana',
    'Nothing new this week. Shared work, published Skills and approved knowledge show up here.':
      'Nessuna novità questa settimana. Qui vengono mostrati i lavori condivisi, le competenze pubblicate e le conoscenze approvate.',
    'New at {value1}': 'Novità in {value1}',
    'This Skill is unavailable. Try again.': 'Questa competenza non è disponibile. Riprova.',
    'You can attach up to {value1} files. Remove an attachment to add another.':
      'Puoi allegare fino a {value1} file. Rimuovi un allegato per aggiungerne un altro.',
    'Add company context': 'Aggiungi il contesto aziendale',
    'Add company context · @': 'Aggiungi il contesto aziendale · @',
    'Choose a Skill': 'Scegli una competenza',
    'Choose a Skill · /': 'Scegli una competenza · /',
    context: 'contesto',
    skills: 'competenze',
    'Choose company context': 'Scegli il contesto aziendale',
    'Skills for this conversation': 'Competenze per questa conversazione',
    'Bring context into the conversation': 'Porta il contesto nella conversazione',
    'Close context picker': 'Chiudi il selettore del contesto',
    'Filter company context': 'Filtra il contesto aziendale',
    'Find a Skill…': 'Trova una competenza…',
    'Find a file…': 'Trova un file…',
    'Available company context': 'Contesto aziendale disponibile',
    'No matching published Skills.': 'Nessuna competenza pubblicata corrispondente.',
    'No matching files.': 'Nessun file corrispondente.',
    'Searching company work…': 'Ricerca nel lavoro aziendale…',
    'Try search again': 'Prova a cercare di nuovo',
    'Meaning search is temporarily limited. Showing available text matches.':
      'La ricerca semantica è temporaneamente limitata. Sono mostrati i risultati testuali disponibili.',
    'Load more matches': 'Carica altri risultati',
    '{value1} files attached. Remove an attachment to add another. Saved Skill references are included separately.':
      '{value1} file allegati. Rimuovi un allegato per aggiungerne un altro. I riferimenti alle competenze salvati sono inclusi separatamente.',
    'Create a Skill in chat': 'Crea una competenza nella chat',
    'Upload a company file': 'Carica un file aziendale',
    'Company knowledge is always available to Poneva.':
      'La conoscenza aziendale è sempre disponibile per Poneva.',
    '{value1} was not connected': '{value1} non è stato collegato',
    Dismiss: 'Ignora',
    'Try connecting again': 'Prova a collegarti di nuovo',
    Waiting: 'In attesa',
    Connected: 'Connesso',
    'Needs reconnecting': 'Richiede una nuova connessione',
    Connect: 'Connetti',
    '{value1}{value2} The provider’s account permissions still apply.':
      "{value1}{value2} Le autorizzazioni dell'account del provider restano applicabili.",
    'Last error: {value1}': 'Ultimo errore: {value1}',
    '{value1} {value2} ready.': '{value1} {value2} pronto.',
    'Continue with my Meta app': 'Continua con la mia app Meta',
    Reconnect: 'Riconnetti',
    Disconnect: 'Disconnetti',
    'Remove attachment: {value1}': 'Rimuovi allegato: {value1}',
    'Saved in this Skill. Edit the Skill to change its references.':
      'Salvato in questa competenza. Modifica la competenza per cambiare i relativi riferimenti.',
    'Remove Skill context': 'Rimuovi il contesto della competenza',
    Refining: 'Perfezionamento',
    Previewing: 'Anteprima',
    Using: 'In uso',
    'Skill revision {value1}': 'Revisione della competenza {value1}',
    'a new Skill': 'una nuova competenza',
    '{value1} Making a new agent {value2}': '{value1} Creazione di un nuovo agente {value2}',
    'Stop making a new agent in this chat':
      'Interrompi la creazione di un nuovo agente in questa chat',
    'Saved Skill references': 'Riferimenti alle competenze salvati',
    'Included with Skill · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}':
      'Incluso con la competenza · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}',
    'Selected Skill revision is unavailable. Select the Skill again to view its saved references.':
      'La revisione selezionata della competenza non è disponibile. Seleziona di nuovo la competenza per visualizzare i riferimenti salvati.',
    'Conversation attachments': 'Allegati della conversazione',
    'Added for this conversation': 'Aggiunto per questa conversazione',
    'Selected passage {value1}': 'Passaggio selezionato {value1}',
    'We could not load your workspace.': 'Non è stato possibile caricare il tuo spazio di lavoro.',
    'The selected Skill is unavailable. Check its access or choose it again.':
      'La competenza selezionata non è disponibile. Verifica il tuo accesso o scegli di nuovo la competenza.',
    'Source saved privately and included in your knowledge search.':
      'Fonte salvata privatamente e inclusa nella ricerca nella tua conoscenza.',
    'File saved privately to your library and attached to this message.':
      'File salvato privatamente nella tua raccolta e allegato a questo messaggio.',
    'File saved privately to your library.': 'File salvato privatamente nella tua raccolta.',
    '{value1} {value2} earlier {value3} saved{value4}.':
      '{value1} {value2} {value3} precedente salvato{value4}.',
    'Extracted text for Poneva to read. Download the original for its layout, charts and images. Spreadsheet formulas show their saved results and are not recalculated.':
      "Testo estratto che Poneva può leggere. Scarica l'originale per conservarne layout, grafici e immagini. Le formule del foglio di calcolo mostrano i risultati salvati e non vengono ricalcolate.",
    Esc: 'Esc',
    'Start something': 'Inizia qualcosa',
    'Choose a file to work with': 'Scegli un file su cui lavorare',
    'Skills worth adding': 'Competenze da aggiungere',
    'Picked for you': 'Scelte per te',
    'Reusable work grounded in your company knowledge.':
      'Attività riutilizzabili basate sulla conoscenza della tua azienda.',
    'Ideas from your company context and recent work. Pick one to start.':
      'Idee dal contesto aziendale e dal lavoro recente. Scegline una per iniziare.',
    'Refresh suggested tasks': 'Aggiorna le attività suggerite',
    'Check for new company context.': 'Cerca nuovo contesto aziendale.',
    'Check for new context. Ideas also refresh daily.':
      'Cerca nuovo contesto. Le idee si aggiornano ogni giorno.',
    Refresh: 'Aggiorna',
    'Finding useful starting points…': 'Ricerca di punti di partenza utili…',
    'Suggestions aren’t available right now. Try Refresh, or describe the work you want to do.':
      "I suggerimenti non sono disponibili al momento. Prova ad aggiornare o descrivi l'attività che vuoi svolgere.",
    'Loading the knowledge pages…': 'Caricamento delle pagine della conoscenza…',
    '{value1} All pages': '{value1} Tutte le pagine',
    'The page is created.': 'La pagina è stata creata.',
    'Your new page is suggested. A publisher decides whether it is added.':
      'La tua nuova pagina è stata proposta. Un publisher decide se aggiungerla.',
    'Company knowledge': 'Conoscenza aziendale',
    'What Poneva knows about your company, page by page. Every change is kept.':
      'Ciò che Poneva sa della tua azienda, pagina per pagina. Ogni modifica viene conservata.',
    'Loading company knowledge…': 'Caricamento della conoscenza aziendale…',
    'Knowledge pages are not enabled in this workspace.':
      'Le pagine della conoscenza non sono abilitate in questo spazio di lavoro.',
    'Ask your Poneva contact to switch them on for your company.':
      'Chiedi al tuo contatto Poneva di attivarle per la tua azienda.',
    '{value1} Change the agent': '{value1} Cambia agente',
    '{value1} Continue in chat': '{value1} Continua nella chat',
    'Open result: {value1}': 'Apri risultato: {value1}',
    'Loading more library items…': 'Caricamento di altri elementi della raccolta…',
    'Load more': 'Carica altro',
    'Documents, transcripts, audio and video · Up to 500 MB per file. New files are private. Choose their audience with Share and which processable files become searchable company knowledge.':
      'Documenti, trascrizioni, audio e video · Fino a 500 MB per file. I nuovi file sono privati. Scegli il pubblico con Condividi e quali file elaborabili diventano conoscenza aziendale ricercabile.',
    Skills: 'Skill',
    'Create in chat': 'Crea nella chat',
    'Search Skills': 'Cerca nelle Skill',
    'Search finds published Skills. Clear the search to browse your drafts too.':
      'La ricerca trova le Skill pubblicate. Cancella la ricerca per visualizzare anche le tue bozze.',
    'Search coverage is limited while indexing or meaning-based search is unavailable.':
      "La copertura della ricerca è limitata mentre l'indicizzazione o la ricerca basata sul significato non è disponibile.",
    'Searching Skills…': 'Ricerca nelle Skill…',
    'No matching published Skills found. Try a different description.':
      'Nessuna Skill pubblicata corrispondente. Prova con una descrizione diversa.',
    'Load more Skills': 'Carica altre Skill',
    'View Skill: {value1}': 'Visualizza Skill: {value1}',
    'Company workspace': 'Workspace aziendale',
    'View {value1}': 'Visualizza {value1}',
    'Loading Skills…': 'Caricamento delle Skill…',
    'Try again {value1}': 'Riprova {value1}',
    'Try again': 'Riprova',
    'Nothing yet.': 'Ancora nulla.',
    'Made from · Used by': 'Deriva da · Utilizzata da',
    'Could not load links': 'Impossibile caricare i collegamenti',
    'Made from': 'Deriva da',
    'Used by': 'Utilizzata da',
    'About this chat {value1}': 'Informazioni su questa chat {value1}',
    'About this chat': 'Informazioni su questa chat',
    'Keep the work moving.': 'Fai avanzare il lavoro.',
    'Ask a follow-up with this result in view, or turn a useful approach into a company Skill.':
      'Fai una domanda di approfondimento mantenendo visibile questo risultato, oppure trasforma un approccio utile in una Skill aziendale.',
    'Save approach as a Skill': "Salva l'approccio come Skill",
    'Preview of': 'Anteprima di',
    'Made with': 'Creato con',
    'Open the draft': 'Apri la bozza',
    'Open Skill': 'Apri Skill',
    'Use in chat': 'Usa nella chat',
    'Finish the draft': 'Completa la bozza',
    'Refine this Skill': 'Perfeziona questa Skill',
    'Made with a Skill.': 'Creato con una Skill.',
    'This workspace could not be loaded just now, so that Skill cannot be opened yet. The result itself is unchanged.':
      'Non è stato possibile caricare questo workspace, quindi non puoi ancora aprire la Skill. Il risultato non è cambiato.',
    'That Skill is not available in this workspace, so it cannot be opened or used again. The result itself is unchanged.':
      'Quella Skill non è disponibile in questo workspace, quindi non può essere aperta o utilizzata di nuovo. Il risultato non è cambiato.',
    'Result · {value1} {value2}': 'Risultato · {value1} {value2}',
    '{value1} Copy link': '{value1} Copia link',
    'Result link copied.': 'Link del risultato copiato.',
    'Could not copy the link. Use your browser address bar.':
      'Impossibile copiare il link. Usa la barra degli indirizzi del browser.',
    'No preview is available for this result.':
      'Non è disponibile alcuna anteprima per questo risultato.',
    '{value1} rows are retained in this snapshot. Open Table to inspect the values.':
      'In questo snapshot sono conservate {value1} righe. Apri Tabella per esaminare i valori.',
    'People can’t edit a Result an agent keeps up to date; the next refresh would replace their edit. Change the agent’s instructions instead.':
      "Non è possibile modificare un risultato che un agente mantiene aggiornato: il prossimo aggiornamento sostituirebbe la modifica. Cambia invece le istruzioni dell'agente.",
    'Linked sources': 'Fonti collegate',
    'Saved source': 'Fonte salvata',
    'No source documents are linked to this result. Company knowledge and other references may be cited in the answer.':
      'Nessun documento di origine è collegato a questo risultato. Nella risposta potrebbero essere citate la conoscenza aziendale e altre fonti.',
    'Run details': "Dettagli dell'esecuzione",
    Created: 'Creato',
    ', revised {value1}': ', modificato {value1}',
    Conversation: 'Conversazione',
    'Not recorded': 'Non registrato',
    'Open conversation': 'Apri conversazione',
    Run: 'Esegui',
    Updates: 'Aggiornamenti',
    'Kept up to date by {value1}': 'Mantenuto aggiornato da {value1}',
    'Version {value1}': 'Versione {value1}',
    'Could not open this request.': 'Impossibile aprire questa richiesta.',
    'Approved version published.': 'Versione approvata pubblicata.',
    'Request rejected. The item stays unchanged.':
      "Richiesta rifiutata. L'elemento resta invariato.",
    'Could not save the decision.': 'Impossibile salvare la decisione.',
    'Proposed company change': 'Modifica aziendale proposta',
    'Opening…': 'Apertura…',
    'Approve this version': 'Approva questa versione',
    Decline: 'Rifiuta',
    'Review the submitted version below. Changes made since submission will need a new request.':
      "Esamina la versione inviata qui sotto. Le modifiche apportate dopo l'invio richiederanno una nuova richiesta.",
    'The version submitted with this request.': 'La versione inviata con questa richiesta.',
    'Version and proposed change': 'Versione e modifica proposta',
    'Could not read the pinned content.': 'Impossibile leggere il contenuto fissato.',
    'Showing a page of {value1} characters.':
      'Visualizzazione di una pagina di {value1} caratteri.',
    'Beginning of the submitted content. Open the full text to review every page.':
      'Inizio del contenuto inviato. Apri il testo completo per esaminare ogni pagina.',
    'Read full submitted text': 'Leggi tutto il testo inviato',
    'Previous page': 'Pagina precedente',
    'Next page': 'Pagina successiva',
    'Made private. Its creator has been told in their Inbox.':
      'Reso privato. Il suo autore è stato informato nella Posta in arrivo.',
    'Made private. Its creator could not be notified.':
      'Reso privato. Non è stato possibile informare il suo autore.',
    'Make this {value1} private?': 'Rendere privato questo elemento {value1}?',
    'Only the person who created it will see it. Everyone else loses access right away, and its creator gets an Inbox update if they are still a company member. If they have left, nobody in the company will be able to access this item.':
      "Lo vedrà solo la persona che l'ha creato. Tutti gli altri perderanno subito l'accesso e il suo autore riceverà un aggiornamento nella Posta in arrivo se è ancora membro dell'azienda. Se ha lasciato l'azienda, nessuno al suo interno potrà accedere a questo elemento.",
    'Sent for review. The current audience stays unchanged until approval.':
      "Inviato per la revisione. Il pubblico attuale resta invariato fino all'approvazione.",
    Edit: 'Modifica',
    '{value1} Edit with chat': '{value1} Modifica con la chat',
    '{value1} Duplicate to my Library': '{value1} Duplica nella mia Libreria',
    'Duplicated to your Library. Only you can see the copy.':
      'Duplicato nella tua Libreria. Solo tu puoi vedere la copia.',
    'Could not duplicate this Result. Try again.':
      'Impossibile duplicare questo Risultato. Riprova.',
    'Saved version {value1}.': 'Versione {value1} salvata.',
    'A newer version was saved. Reload the Result before saving.':
      'È stata salvata una versione più recente. Ricarica il Risultato prima di salvare.',
    'Could not save this version. Try again.': 'Impossibile salvare questa versione. Riprova.',
    '{value1} saved a newer version. Review it before saving.':
      '{value1} ha salvato una versione più recente. Esaminala prima di salvare.',
    'Hide their version': 'Nascondi la loro versione',
    'Show their version': 'Mostra la loro versione',
    'Start from their version': 'Inizia dalla loro versione',
    Markdown: 'Markdown',
    'Result text': 'Testo del Risultato',
    Preview: 'Anteprima',
    'What changed': 'Cosa è cambiato',
    'What changed? (optional)': 'Cosa è cambiato? (facoltativo)',
    'Save version {value1}': 'Salva versione {value1}',
    'Open chat': 'Apri la chat',
    Current: 'Attuale',
    Restore: 'Ripristina',
    'Could not load the history.': 'Impossibile caricare la cronologia.',
    'Restored version {value1} as version {value2}.':
      'La versione {value1} è stata ripristinata come versione {value2}.',
    'Someone saved a newer version. Review it before restoring.':
      'Qualcuno ha salvato una versione più recente. Esaminala prima di ripristinare.',
    'Could not restore that version.': 'Impossibile ripristinare quella versione.',
    'Loading history…': 'Caricamento della cronologia…',
    'Restoring keeps what is there now as a version too, so nothing is lost.':
      'Il ripristino conserva anche lo stato attuale come versione, così non perderai nulla.',
    'This Result was made with your own {value1}.':
      'Questo Risultato è stato creato con il tuo {value1}.',
    'It also used': 'Ha usato anche',
    'This Result was made with': 'Questo Risultato è stato creato con',
    'Colleagues can read what came from them, but can never use them.':
      'I colleghi possono leggere ciò che proviene da loro, ma non possono mai utilizzarlo.',
    'Your personal agent {value1} keeps it up to date with your own access, so every refresh can carry your private data.':
      'Il tuo agente personale {value1} lo mantiene aggiornato con i tuoi accessi, quindi ogni aggiornamento può includere i tuoi dati privati.',
    'A colleague’s personal agent keeps it up to date with their own access, so every refresh can carry their private data.':
      'L’agente personale di un collega lo mantiene aggiornato con i suoi accessi, quindi ogni aggiornamento può includere i suoi dati privati.',
    'Made private. Only you can see this meeting.':
      'Resa privata. Solo tu puoi vedere questa riunione.',
    'Could not make this meeting private.': 'Impossibile rendere privata questa riunione.',
    'Meeting · {value1} {value2} · Original retained':
      'Riunione · {value1} {value2} · Originale conservato',
    'The recording could not be opened.': 'Impossibile aprire la registrazione.',
    'Ask about this suggestion': 'Fai una domanda su questo suggerimento',
    meeting_processing_failed: 'Elaborazione della riunione non riuscita',
    'Who can see this': 'Chi può vedere questo',
    'Everyone at {value1}': 'Tutti in {value1}',
    'Only me': 'Solo io',
    'Everyone at {value1} can find it and ask about it.':
      'Tutti in {value1} possono trovarlo e farci domande.',
    'Only you can open and search this meeting. You can share it later.':
      'Solo tu puoi aprire e cercare questa riunione. Potrai condividerla in seguito.',
    'Added. Only you can see it. Transcription is running in the background.':
      'Aggiunta. Solo tu puoi vederla. La trascrizione è in esecuzione in background.',
    'Visible to everyone at {value1}': 'Visibile a tutti in {value1}',
    'Could not make it private.': 'Impossibile renderla privata.',
    'Show more meetings': 'Mostra altre riunioni',
    'Attached to this message': 'Allegato a questo messaggio',
    'Connect securely, choose the tables to share, then decide whether Poneva can read or make changes.':
      'Connettiti in modo sicuro, scegli le tabelle da condividere, quindi decidi se Poneva può leggere o apportare modifiche.',
    'Review the tables this connection can access. Select at least one table.':
      'Esamina le tabelle a cui questa connessione può accedere. Seleziona almeno una tabella.',
    'Select at least one table. Nothing is selected by default.':
      'Seleziona almeno una tabella. Per impostazione predefinita non è selezionato nulla.',
    'Choose who can use this connection and what Poneva can do.':
      'Scegli chi può usare questa connessione e cosa può fare Poneva.',
    'Your chosen access is enabled for the selected tables.':
      'L’accesso scelto è abilitato per le tabelle selezionate.',
    'Your connection is saved with reading paused until permission is confirmed.':
      'La connessione è stata salvata con la lettura sospesa finché l’autorizzazione non sarà confermata.',
    'Confirm database disconnect': 'Conferma disconnessione del database',
    'Disconnect this database?': 'Disconnettere questo database?',
    'Access will stop for everyone using this connection.':
      'L’accesso verrà interrotto per tutti coloro che usano questa connessione.',
    'Keep connection': 'Mantieni connessione',
    'What it can reach · {value1}{value2} {value3}':
      'A cosa può accedere · {value1}{value2} {value3}',
    Back: 'Indietro',
    Continue: 'Continua',
    'Uploading…': 'Caricamento…',
    Library: 'Libreria',
    'Source material for your work. Available whenever you need it.':
      'Materiale di riferimento per il tuo lavoro. Disponibile quando ne hai bisogno.',
    'The work you want to keep, with its sources and conversation attached.':
      'Il lavoro che vuoi conservare, con le relative fonti e conversazione allegate.',
    Results: 'Risultati',
    Files: 'File',
    Artifacts: 'Artefatti',
    'Search library': 'Cerca nella Libreria',
    'Find files by meaning…': 'Trova file per significato…',
    'Find saved work by meaning…': 'Trova lavori salvati per significato…',
    'Search coverage is limited while indexing or meaning-based search is unavailable. You can retry or browse recent items.':
      'La ricerca è limitata durante l’indicizzazione o quando la ricerca per significato non è disponibile. Puoi riprovare o consultare gli elementi recenti.',
    'No matching work found.': 'Nessun lavoro corrispondente trovato.',
    'A starting point for your next question.': 'Un punto di partenza per la tua prossima domanda.',
    'Good work is worth keeping.': 'Un buon lavoro merita di essere conservato.',
    'Try a different description or clear the search to browse.':
      'Prova una descrizione diversa o cancella la ricerca per esplorare i contenuti.',
    'Upload source material once and use it in conversations and Skills. Your original stays in the library.':
      'Carica il materiale di riferimento una volta e usalo nelle conversazioni e nelle Competenze. L’originale rimane nella Libreria.',
    'Ask Poneva to save an answer, table or chart. Results stay connected to the conversation and their sources.':
      'Chiedi a Poneva di salvare una risposta, una tabella o un grafico. I Risultati restano collegati alla conversazione e alle relative fonti.',
    'Start in chat {value1}': 'Inizia nella chat {value1}',
    'Could not update sharing.': 'Impossibile aggiornare la condivisione.',
    'They can follow new answers live and fork it to continue with their own connections. Only you write here. You can make it private again at any time.':
      'Possono seguire in tempo reale le nuove risposte e crearne una copia per continuare con le proprie connessioni. Solo tu puoi scrivere qui. Puoi renderlo di nuovo privato in qualsiasi momento.',
    'They see the project, its brief and the work in it they can already open. Nothing in it opens for anyone because of the project; each item keeps its own access.':
      'Vedono il progetto, il relativo brief e il lavoro che contiene e che possono già aprire. Nulla al suo interno diventa accessibile a qualcuno a causa del progetto; ogni elemento mantiene il proprio accesso.',
    'Check the content for private information before sharing. Sharing an item does not grant access to its original chat or private connections.':
      'Controlla che il contenuto non contenga informazioni private prima di condividerlo. La condivisione di un elemento non dà accesso alla chat originale o alle connessioni private.',
    '{value1} Everyone you share with can read it, including what the assistant or an App in it found in your {value2}. They can’t use your {value3}. Nothing changes for you: the chat keeps working with all your accounts.':
      "{value1} Chiunque condivida con te può leggerlo, compreso ciò che l'assistente o un'App al suo interno ha trovato nel tuo {value2}. Non può usare il tuo {value3}. Per te non cambia nulla: la chat continua a funzionare con tutti i tuoi account.",
    '{value1} Everyone you share with can read them, but nobody can use {value2} through this chat.':
      '{value1} Chiunque condivida con te può leggerli, ma nessuno può usare {value2} tramite questa chat.',
    'This controls access to the working draft. Any published company version stays available until you explicitly unpublish it. To publish a new version, complete its preview and use Save Skill. Run results stay private.':
      "Questo controlla l'accesso alla bozza di lavoro. Qualsiasi versione aziendale pubblicata resta disponibile finché non annulli esplicitamente la pubblicazione. Per pubblicare una nuova versione, completa l'anteprima e usa Save Skill. I risultati delle esecuzioni restano privati.",
    'Skill deleted. You can restore it from the Skills archive for 30 days.':
      "Skill eliminata. Puoi ripristinarla dall'archivio delle Skills entro 30 giorni.",
    'Could not delete this Skill.': 'Impossibile eliminare questa Skill.',
    'More actions': 'Altre azioni',
    'Delete “{value1}”? It will disappear from Skills and search, and cannot be used by agents. You can restore it for 30 days. Existing chats and results stay available.':
      'Eliminare “{value1}”? Scomparirà dalle Skills e dalla ricerca e non potrà essere usata dagli agenti. Puoi ripristinarla entro 30 giorni. Le chat e i risultati esistenti resteranno disponibili.',
    'Deleting…': 'Eliminazione…',
    'Confirm delete': 'Conferma eliminazione',
    'Delete Skill': 'Elimina Skill',
    'Skill restored as an unpublished draft. Its author can review and publish it again.':
      'Skill ripristinata come bozza non pubblicata. Il suo autore può esaminarla e pubblicarla di nuovo.',
    'Could not restore this Skill.': 'Impossibile ripristinare questa Skill.',
    'Archived Skills': 'Skills archiviate',
    'Deleted Skills can be restored for 30 days. Restoring leaves them unpublished.':
      'Le Skills eliminate possono essere ripristinate entro 30 giorni. Il ripristino le lascia non pubblicate.',
    'Restore until {value1}': 'Ripristina fino al {value1}',
    'Loading…': 'Caricamento…',
    'No archived Skills.': 'Nessuna Skill archiviata.',
    'Load more archived Skills': 'Carica altre Skills archiviate',
    'Show more of the original': "Mostra altro dell'originale",
    'Filter result rows': 'Filtra le righe dei risultati',
    'Find a product or value…': 'Trova un prodotto o un valore…',
    '{value1} of {value2}': '{value1} di {value2}',
    'Result table': 'Tabella dei risultati',
    'No matching rows.': 'Nessuna riga corrispondente.',
    'Showing the first 1,000 matching rows. Download the CSV for every row.':
      'Sono mostrate le prime 1.000 righe corrispondenti. Scarica il CSV per visualizzare tutte le righe.',
    'Agent ·': 'Agente ·',
    'Only you': 'Solo tu',
    'Stopped before it finished.': 'Interrotto prima del completamento.',
    'Drafting the project…': 'Creazione della bozza del progetto…',
    'Checking where this chat belongs…': 'Verifica della destinazione di questa chat…',
    'Moving the chat…': 'Spostamento della chat…',
    'Taking it out of the project…': 'Rimozione dal progetto…',
    'Adding it to the project…': 'Aggiunta al progetto…',
    'No matching connections are available right now.':
      'Al momento non sono disponibili connessioni corrispondenti.',
    'Company knowledge suggestion': 'Suggerimento sulla conoscenza aziendale',
    'Company knowledge now lives on pages. Open Knowledge to see them.':
      'La conoscenza aziendale ora si trova nelle pagine. Apri Knowledge per visualizzarle.',
    '{value1} · Open beside this conversation': '{value1} · Apri accanto a questa conversazione',
    'Name {value1}': 'Nome {value1}',
    'Host {value1}': 'Host {value1}',
    'Port {value1}': 'Porta {value1}',
    'Database {value1}': 'Database {value1}',
    'Username {value1}': 'Nome utente {value1}',
    'Password {value1}': 'Password {value1}',
    'Advanced TLS': 'TLS avanzato',
    '{value1} Poneva verifies the server certificate. Add a CA or server DNS name for IP hosts when your certificate requires it.':
      '{value1} Poneva verifica il certificato del server. Aggiungi una CA o il nome DNS del server per gli host IP quando il certificato lo richiede.',
    'CA certificate {value1}': 'Certificato CA {value1}',
    'Certificate server DNS name {value1}': 'Nome DNS del server del certificato {value1}',
    '{value1} Your password is encrypted in secure storage. Poneva verifies the connection before saving it.':
      "{value1} La tua password è crittografata nell'archiviazione sicura. Poneva verifica la connessione prima di salvarla.",
    'Testing…': 'Test in corso…',
    'Test connection': 'Testa connessione',
    'PostgreSQL is connected.': 'PostgreSQL è connesso.',
    'PostgreSQL was saved safely.': 'PostgreSQL è stato salvato in modo sicuro.',
    'Poneva can read and change rows in the selected tables. Apps also follow their approved data scope.':
      'Poneva può leggere e modificare le righe nelle tabelle selezionate. Le App seguono inoltre il proprio ambito dati approvato.',
    'Poneva can read the selected tables. Apps also follow their approved data scope.':
      'Poneva può leggere le tabelle selezionate. Le App seguono inoltre il proprio ambito dati approvato.',
    'Reads are paused until permission is enabled.':
      "Le letture sono sospese finché non viene abilitata l'autorizzazione.",
    'Retrying…': 'Nuovo tentativo…',
    'Retry permission': 'Riprova autorizzazione',
    'Try it in Chat': 'Provalo nella Chat',
    Done: 'Fine',
    'Disconnect database': 'Disconnetti database',
    '{value1} TLS verified ·{value2} {value3}': '{value1} TLS verificato ·{value2} {value3}',
    'Search schemas and tables': 'Cerca schemi e tabelle',
    'Search tables': 'Cerca tabelle',
    '{value1} of {value2} tables selected': '{value1} di {value2} tabelle selezionate',
    'Select matching tables': 'Seleziona le tabelle corrispondenti',
    'Select all tables': 'Seleziona tutte le tabelle',
    Clear: 'Cancella',
    'Select a whole schema or individual tables. New tables need a fresh selection.':
      'Seleziona uno schema completo o singole tabelle. Le nuove tabelle richiedono una nuova selezione.',
    'No tables match this search.': 'Nessuna tabella corrisponde a questa ricerca.',
    'All tables in {value1}': 'Tutte le tabelle in {value1}',
    '{value1} / {value2} tables': '{value1} / {value2} tabelle',
    'Read & write available': 'Lettura e scrittura disponibili',
    'Read only': 'Sola lettura',
    Ctrl: 'Ctrl',
    'This suggested knowledge update could not be shown.':
      'Impossibile mostrare questo aggiornamento suggerito della conoscenza.',
    'Suggested knowledge update': 'Aggiornamento suggerito della conoscenza',
    'This suggestion is no longer available to you.':
      'Questo suggerimento non è più disponibile per te.',
    'We could not check where this suggestion stands.':
      'Non è stato possibile verificare lo stato di questo suggerimento.',
    'Check again': 'Controlla di nuovo',
    'Show on page': 'Mostra nella pagina',
    'The editor could not be loaded. Poneva may have been updated since you opened this page. Reload to get the latest version; nothing on this page has changed.':
      "Non è stato possibile caricare l'editor. Poneva potrebbe essere stato aggiornato da quando hai aperto questa pagina. Ricarica per ottenere la versione più recente; nulla in questa pagina è cambiato.",
    'Reload Poneva': 'Ricarica Poneva',
    Formatting: 'Formattazione',
    'Text style': 'Stile del testo',
    Text: 'Testo',
    Heading: 'Titolo',
    Subheading: 'Sottotitolo',
    'Link a page': 'Collega una pagina',
    'A page needs a title.': 'Una pagina deve avere un titolo.',
    'Nothing has changed yet.': 'Non è ancora cambiato nulla.',
    'A page needs some text. To remove a page, archive it instead.':
      'Una pagina deve contenere del testo. Per rimuoverla, archiviala.',
    'A suggested new page needs some text.': 'Una nuova pagina suggerita deve contenere del testo.',
    'This page is larger than 256 KB. Split it into smaller pages.':
      'Questa pagina supera i 256 KB. Dividila in pagine più piccole.',
    'Say in a few words why this change is right.':
      'Spiega in poche parole perché questa modifica è corretta.',
    'This page changed while you were editing. Your text is still here: copy it, then open the latest version and make your change again.':
      'Questa pagina è cambiata mentre la modificavi. Il tuo testo è ancora qui: copialo, poi apri la versione più recente e apporta di nuovo la modifica.',
    'Your text is copied.': 'Il tuo testo è stato copiato.',
    'Your text could not be copied. Select it in the editor and copy it.':
      "Non è stato possibile copiare il testo. Selezionalo nell'editor e copialo.",
    'The page “{value1}” is created.': 'La pagina “{value1}” è stata creata.',
    'New page': 'Nuova pagina',
    'Editing {value1}': 'Modifica di {value1}',
    Editing: 'Modifica',
    'Creating publishes the page under {value1} for everyone':
      'La creazione pubblica la pagina sotto {value1} per tutti',
    'Saving publishes the new version for everyone':
      'Il salvataggio pubblica la nuova versione per tutti',
    'Your changes are sent as a suggestion for a publisher':
      'Le tue modifiche vengono inviate come suggerimento a un pubblicatore',
    'Create page': 'Crea pagina',
    Save: 'Salva',
    'Send suggestion': 'Invia suggerimento',
    '{value1} Copy my text': '{value1} Copia il mio testo',
    'Open the latest version': 'Apri la versione più recente',
    'Page title': 'Titolo della pagina',
    'Loading the editor…': "Caricamento dell'editor…",
    'New page text': 'Testo della nuova pagina',
    'Text of {value1}': 'Testo di {value1}',
    'Write the page. Type [[ to link another page.':
      "Scrivi la pagina. Digita [[ per collegare un'altra pagina.",
    'Type [[ to link another page.': "Digita [[ per collegare un'altra pagina.",
    'Link to a page': 'Collega a una pagina',
    'What changed, in a few words': 'Cosa è cambiato, in poche parole',
    'Where this comes from, in a few words': 'Da dove proviene, in poche parole',
    'Shown in the page history.': 'Viene mostrato nella cronologia della pagina.',
    'A publisher sees this next to your change.':
      'Un pubblicatore lo vede accanto alla tua modifica.',
    '1 suggestion is open on this page': '1 suggerimento è aperto su questa pagina',
    '{value1} suggestions are open on this page':
      '{value1} suggerimenti sono aperti su questa pagina',
    'They stay open while you edit. After you save, they show against your new text; one whose words you changed is marked outdated.':
      'Restano aperti mentre modifichi. Dopo il salvataggio, vengono mostrati sul nuovo testo; quello le cui parole hai modificato viene contrassegnato come obsoleto.',
    'Type [[ to link another page. Links keep working when a page is renamed or moved.':
      "Digita [[ per collegare un'altra pagina. I collegamenti continuano a funzionare quando una pagina viene rinominata o spostata.",
    'Loading the history…': 'Caricamento della cronologia…',
    'This page has no saved text yet.': 'Questa pagina non contiene ancora testo salvato.',
    'Say in a few words why this revision should come back.':
      'Spiega in poche parole perché questa revisione dovrebbe essere ripristinata.',
    'Revision {value1} is suggested for a publisher to accept.':
      "La revisione {value1} è stata suggerita a un pubblicatore per l'accettazione.",
    'The page already reads like this revision.': 'La pagina ha già il testo di questa revisione.',
    'Revision {value1} is restored as revision {value2}.':
      'La revisione {value1} è stata ripristinata come revisione {value2}.',
    'Revision history': 'Cronologia delle revisioni',
    Revisions: 'Revisioni',
    'Every saved revision is kept.': 'Ogni revisione salvata viene conservata.',
    'Revision {value1} {value2}': 'Revisione {value1} {value2}',
    'Revision {value1} compared with revision {value2}':
      'Revisione {value1} confrontata con la revisione {value2}',
    'Revision {value1}, the first text of this page':
      'Revisione {value1}, il primo testo di questa pagina',
    'Green was added, struck through was removed.':
      'Il verde indica le aggiunte, il testo barrato le rimozioni.',
    '{value1} Export Markdown': '{value1} Esporta Markdown',
    'Restore this revision': 'Ripristina questa revisione',
    'Suggest restoring it': 'Suggerisci di ripristinarla',
    'Why should this revision come back?': 'Perché questa revisione dovrebbe essere ripristinata?',
    'Loading this revision…': 'Caricamento di questa revisione…',
    'Only the title changed, from “{value1}” to “{value2}”.':
      'È cambiato solo il titolo, da “{value1}” a “{value2}”.',
    'The text did not change in this revision.': 'Il testo non è cambiato in questa revisione.',
    'Changes in revision {value1}': 'Modifiche nella revisione {value1}',
    'Loading page…': 'Caricamento della pagina…',
    'Loading suggestion…': 'Caricamento del suggerimento…',
    'This suggestion is not available.': 'Questo suggerimento non è disponibile.',
    'It may have been decided, or it is not one you can see.':
      'Potrebbe essere già stato deciso, oppure non hai accesso per visualizzarlo.',
    'Open Knowledge': 'Apri Conoscenza',
    'Opening the suggestion…': 'Apertura del suggerimento…',
    'Choose where the page goes.': 'Scegli dove collocare la pagina.',
    'Say in a few words why.': 'Spiega in poche parole perché.',
    'Your suggestion is sent. A publisher decides.':
      'Il tuo suggerimento è stato inviato. Decide un pubblicatore.',
    'Moved under {value1}.': 'Spostata sotto {value1}.',
    'Deleted “{value1}”.': 'Eliminata “{value1}”.',
    'Archived. Its history is kept.': 'Archiviata. La cronologia viene conservata.',
    'Choose the page it goes under. Links to it keep working.':
      'Scegli la pagina sotto cui collocarla. I collegamenti continuano a funzionare.',
    'Its text, its history and any open suggestions are removed for good, and links to it from other pages stop working. This cannot be undone.':
      'Il testo, la cronologia e tutti i suggerimenti aperti vengono eliminati definitivamente, e i collegamenti da altre pagine smettono di funzionare. Questa operazione non può essere annullata.',
    'An archived page no longer informs answers. Its history is kept, and a publisher can restore it or delete it permanently.':
      'Una pagina archiviata non contribuisce più alle risposte. La cronologia viene conservata e un editore può ripristinarla o eliminarla definitivamente.',
    Under: 'Sotto',
    Change: 'Modifica',
    'Move under': 'Sposta sotto',
    'Search pages': 'Cerca pagine',
    'Why?': 'Perché?',
    'Delete permanently': 'Elimina definitivamente',
    'Move page': 'Sposta pagina',
    'Archive page': 'Archivia pagina',
    'Suggestion {value1}: show its card': 'Suggerimento {value1}: mostra la relativa scheda',
    'Removed:': 'Rimosso:',
    'Added:': 'Aggiunto:',
    'New page “{value1}”{value2}': 'Nuova pagina “{value1}”{value2}',
    'No pages match “{value1}”.': 'Nessuna pagina corrisponde a “{value1}”.',
    'Where this page is': 'Dove si trova questa pagina',
    'Describe your company': 'Descrivi la tua azienda',
    'Empty page': 'Pagina vuota',
    'Describe {value1}': 'Descrivi {value1}',
    'This page has no text yet.': 'Questa pagina non contiene ancora testo.',
    'Poneva reads this page before every answer. Start with who you are, what you sell and how you work; details go on the pages under it.':
      'Poneva legge questa pagina prima di ogni risposta. Inizia spiegando chi siete, cosa vendete e come lavorate; i dettagli vanno nelle pagine sotto questa.',
    'Write it, or ask Poneva in chat to draft it for you.':
      'Scrivilo oppure chiedi a Poneva in chat di preparare una bozza per te.',
    'Suggest a first version, and a publisher decides whether it becomes the page.':
      'Suggerisci una prima versione: un editore deciderà se diventerà la pagina.',
    'Start writing': 'Inizia a scrivere',
    'Suggest a first version': 'Suggerisci una prima versione',
    'Accepted. The page is archived.': 'Accettato. La pagina è archiviata.',
    'Accepted. The page is now revision {value1}.':
      'Accettato. La pagina è ora alla revisione {value1}.',
    'Accepted.': 'Accettato.',
    'Suggestion rejected. The page stays as it is.':
      'Suggerimento rifiutato. La pagina resta invariata.',
    'Your suggestion is withdrawn.': 'Il tuo suggerimento è stato ritirato.',
    'Restored. The page informs answers again.':
      'Ripristinata. La pagina contribuisce nuovamente alle risposte.',
    'Your suggestion is sent. A publisher decides whether it becomes the page.':
      'Il tuo suggerimento è stato inviato. Un editore deciderà se diventerà la pagina.',
    'Saved. The page is now revision {value1}.':
      'Salvato. La pagina è ora alla revisione {value1}.',
    'Nothing changed.': 'Non è cambiato nulla.',
    'This page is not available.': 'Questa pagina non è disponibile.',
    'It may have been deleted, archived or moved out of reach, or you may no longer be in this company.':
      "Potrebbe essere stata eliminata, archiviata o spostata in un'area a cui non hai accesso, oppure potresti non appartenere più a questa azienda.",
    'Page actions': 'Azioni sulla pagina',
    shown: 'mostrati',
    hidden: 'nascosti',
    '{value1} History': 'Cronologia di {value1}',
    '{value1} Ask in chat': 'Chiedi di {value1} in chat',
    'Suggest edits': 'Suggerisci modifiche',
    'More actions for {value1}': 'Altre azioni per {value1}',
    '{value1} Poneva reads this page in every chat':
      '{value1} Poneva legge questa pagina in ogni chat',
    'This page is archived. It no longer informs answers; its history is kept. {value1}':
      'Questa pagina è archiviata. Non contribuisce più alle risposte; la cronologia viene conservata. {value1}',
    'Restore page': 'Ripristina pagina',
    'This link points to an earlier revision. You are reading the current text.':
      'Questo collegamento rimanda a una revisione precedente. Stai leggendo il testo attuale.',
    'Show it in History': 'Mostra nella cronologia',
    Pages: 'Pagine',
    'Pages under {value1}': 'Pagine sotto {value1}',
    'Linked from': 'Collegata da',
    Suggestions: 'Suggerimenti',
    'Suggestions are hidden. You are reading the page as everyone else sees it.':
      'I suggerimenti sono nascosti. Stai leggendo la pagina così come la vedono gli altri.',
    'Loading suggestions…': 'Caricamento dei suggerimenti…',
    'Nothing is waiting for review.': 'Non ci sono elementi in attesa di revisione.',
    'When someone, Poneva in a chat or a connected agent suggests a change to a page, it shows here and on the page. Nothing changes until a publisher accepts it.':
      'Quando qualcuno, Poneva in una chat o un agente connesso suggerisce una modifica a una pagina, questa viene mostrata qui e sulla pagina. Nulla cambia finché un editore non la accetta.',
    '{value1} Review knowledge in chat': '{value1} Esamina le conoscenze in chat',
    'Suggestions for review': 'Suggerimenti da esaminare',
    'Suggested changes from chats, meetings, colleagues and connected agents. Nothing changes until a publisher accepts it on the page.':
      'Modifiche suggerite da chat, riunioni, colleghi e agenti connessi. Nulla cambia finché un editore non le accetta sulla pagina.',
    'Your suggestions wait here until a publisher decides. The pages stay as they are until then.':
      'I tuoi suggerimenti restano qui finché un editore non decide. Fino ad allora, le pagine rimangono invariate.',
    'Review page': 'Esamina pagina',
    'Review on page': 'Esamina sulla pagina',
    'Open the meeting': 'Apri la riunione',
    'Open the chat': 'Apri la chat',
    'Accept and restore': 'Accetta e ripristina',
    Accept: 'Accetta',
    Reject: 'Rifiuta',
    'Your suggestion · waiting for a publisher': 'Il tuo suggerimento · in attesa di un editore',
    Withdraw: 'Ritira',
    'Waiting for a publisher': 'In attesa di un editore',
    'Suggestion {value1}': 'Suggerimento {value1}',
    'Suggestion {value1} from {value2}{value3}': 'Suggerimento {value1} da {value2}{value3}',
    'Read the suggested page': 'Leggi la pagina suggerita',
    'Outdated: the text it changes was edited after it was suggested. It can be rejected or withdrawn; a new suggestion can be made against the current text.':
      "Obsoleto: il testo che modifica è stato modificato dopo l'invio del suggerimento. Può essere rifiutato o ritirato; è possibile creare un nuovo suggerimento sul testo attuale.",
    'Restore this page first to accept this suggestion.':
      'Ripristina prima questa pagina per accettare il suggerimento.',
    'Previous suggestion': 'Suggerimento precedente',
    'Suggestion {value1} of {value2}': 'Suggerimento {value1} di {value2}',
    'Next suggestion': 'Suggerimento successivo',
    'Fold the suggestions away': 'Comprimi i suggerimenti',
    'Show the suggestions': 'Mostra i suggerimenti',
    '1 suggestion': '1 suggerimento',
    '{value1} suggestions': '{value1} suggerimenti',
    '{value1} the pages under {value2}': '{value1} le pagine sotto {value2}',
    px: 'px',
    '{value1} chart of {value2} across {value3}': '{value1} grafico di {value2} in {value3}',
    'We could not build the file.': 'Non è stato possibile creare il file.',
    '{value1} Present': '{value1} presenti',
    'Building…': 'Creazione in corso…',
    'Download PowerPoint': 'Scarica PowerPoint',
    'Slide {value1} of {value2}': 'Diapositiva {value1} di {value2}',
    Slides: 'Diapositive',
    'Slide {value1}': 'Diapositiva {value1}',
    'Speaker notes': 'Note del relatore',
    'Source: {value1}': 'Fonte: {value1}',
    'Add a name and a web address.': 'Aggiungi un nome e un indirizzo web.',
    'Enter a valid web address.': 'Inserisci un indirizzo web valido.',
    'Use a web address that starts with https://.': 'Usa un indirizzo web che inizi con https://.',
    'Add a custom connection': 'Aggiungi una connessione personalizzata',
    'Connect a tool server you trust. Poneva checks the address works and saves only the connection details needed to use it.':
      "Connetti un server di strumenti affidabile. Poneva verifica che l'indirizzo funzioni e salva solo i dettagli di connessione necessari per utilizzarlo.",
    'Web address': 'Indirizzo web',
    'https://tools.example.com': 'https://tools.example.com',
    'Starts with https://, from your provider': 'Inizia con https://, fornito dal tuo provider',
    'Sign-in': 'Accesso',
    'Advanced sign-in': 'Accesso avanzato',
    'Access key {value1}': 'Chiave di accesso {value1}',
    'Request headers': 'Intestazioni della richiesta',
    'Add header': 'Aggiungi intestazione',
    'Header {value1} name': "Nome dell'intestazione {value1}",
    'Header name': "Nome dell'intestazione",
    'Header {value1} value': "Valore dell'intestazione {value1}",
    'Header value': "Valore dell'intestazione",
    'Remove header': 'Rimuovi intestazione',
    Advanced: 'Avanzate',
    Transport: 'Trasporto',
    'Auto-detect': 'Rilevamento automatico',
    'Streamable HTTP': 'HTTP in streaming',
    'Legacy SSE': 'SSE legacy',
    "From your provider's app settings. Leave empty unless they gave you these.":
      "Nelle impostazioni dell'app del provider. Lascia vuoto se non ti sono stati forniti.",
    "Authorization server issuer": "Emittente del server di autorizzazione",
    "Enter the authorization server issuer when using a client ID.": "Inserisci l’emittente del server di autorizzazione quando usi un ID client.",
    'Client ID {value1}': 'ID client {value1}',
    'Client secret {value1}': 'Segreto client {value1}',
    'Connecting…': 'Connessione…',
    'Test and connect': 'Verifica e connetti',
    'Add the store, the client ID and the client secret.':
      "Aggiungi il negozio, l'ID client e il segreto client.",
    'Connect your Shopify Developer App': 'Connetti la tua app per sviluppatori Shopify',
    'Poneva can use exactly the access your store gave the app, and nothing more. It talks to Shopify directly and keeps the client secret encrypted.':
      "Poneva può usare esattamente gli accessi concessi dal tuo negozio all'app, e nulla di più. Comunica direttamente con Shopify e conserva il segreto client in forma crittografata.",
    'How to create the app in Shopify': "Come creare l'app in Shopify",
    'Open{value1} {value2}{value3} with the account that owns the store, and create an app.':
      "Apri{value1} {value2}{value3} con l'account proprietario del negozio e crea un'app.",
    'Create a version and select the access scopes Poneva may use, for example read_products and read_orders. Add write_ scopes only for data Poneva may change. Then release the version.':
      'Crea una versione e seleziona gli ambiti di accesso che Poneva può usare, ad esempio read_products e read_orders. Aggiungi gli ambiti write_ solo per i dati che Poneva può modificare. Poi rilascia la versione.',
    'For orders and customers, also select protected customer data in the app’s settings. Shopify allows this without review for an app made for your own store.':
      "Per gli ordini e i clienti, seleziona anche i dati dei clienti protetti nelle impostazioni dell'app. Shopify lo consente senza revisione per un'app creata per il tuo negozio.",
    'Install the app on your store.': "Installa l'app nel tuo negozio.",
    'Copy the client ID and client secret from the app’s settings.':
      "Copia l'ID client e il segreto client dalle impostazioni dell'app.",
    'To change the access later, release a new version, approve it on the store and use Test connection here.':
      'Per modificare gli accessi in seguito, rilascia una nuova versione, approvala nel negozio e usa Verifica connessione qui.',
    Store: 'Negozio',
    'your-store.myshopify.com': 'your-store.myshopify.com',
    'Your store’s .myshopify.com address (Shopify admin → Settings → Domains), or paste the address of your Shopify admin page':
      "L'indirizzo .myshopify.com del tuo negozio (amministrazione Shopify → Settings → Domains) oppure incolla l'indirizzo della pagina di amministrazione Shopify",
    'Client ID {value1} {value2}': 'ID client {value1} {value2}',
    'Client secret {value1} {value2}': 'Segreto client {value1} {value2}',
    Person: 'Persona',
    Everyone: 'Tutti',
    Connection: 'Connessione',
    'All connections': 'Tutte le connessioni',
    'App {value1}': 'Applicazione {value1}',
    'From {value1}': 'Da {value1}',
    'Until {value1}': 'Fino a {value1}',
    Result: 'Risultato',
    'All results': 'Tutti i risultati',
    Succeeded: 'Riuscito',
    Denied: 'Negato',
    Failed: 'Non riuscito',
    Unknown: 'Sconosciuto',
    Filter: 'Filtro',
    'Loading activity…': 'Caricamento attività…',
    'Could not load activity. Try again.': "Impossibile caricare l'attività. Riprova.",
    'Removed connection': 'Connessione rimossa',
    'App: {value1}': 'Applicazione: {value1}',
    'Older activity': 'Attività meno recenti',
    Download: 'Scarica',
    CSV: 'CSV',
    'Evidence for {value1}': 'Evidenza per {value1}',
    Measure: 'Misura',
    'Show rows →': 'Mostra righe →',
    'Ask about this number': 'Chiedi informazioni su questo numero',
    'There are no numeric values available to chart. View the table for the original data.':
      'Non sono disponibili valori numerici da rappresentare nel grafico. Visualizza la tabella per i dati originali.',
    'Chart value': 'Valore del grafico',
    '{value1} of {value2} shown': '{value1} di {value2} mostrati',
    '{value1} by {value2}; {value3} rows. View Table for exact values.':
      '{value1} per {value2}; {value3} righe. Visualizza la tabella per i valori esatti.',
    'Values come directly from the source data. Missing values are not estimates.':
      'I valori provengono direttamente dai dati di origine. I valori mancanti non sono stime.',
    'Loading library…': 'Caricamento della libreria…',
    'We couldn’t load what happened in this App. Try again in a moment.':
      'Non è stato possibile caricare ciò che è successo in questa app. Riprova tra poco.',
    'This App could not be opened.': 'Non è stato possibile aprire questa app.',
    'Opening App…': 'Apertura dell’app…',
    'Open the saved App to run this function.': 'Apri l’app salvata per eseguire questa funzione.',
    'Save this App before running its function.': 'Salva questa app prima di eseguire la funzione.',
    'Open saved App': 'Apri app salvata',
    'Open Apps': 'Apri app',
    'The App could not be opened. Try again.': 'Non è stato possibile aprire l’app. Riprova.',
    Owner: 'Proprietario',
    '{value1} · admins': '{value1} · amministratori',
    'Owner · always edits': 'Proprietario · modifica sempre',
    'Admins manage it': 'Gli amministratori la gestiscono',
    Editors: 'Editor',
    'A colleague': 'Un collega',
    'Can edit drafts and publish versions': 'Può modificare le bozze e pubblicare le versioni',
    Remove: 'Rimuovi',
    'No editors yet.': 'Non ci sono ancora editor.',
    'Admins can always edit company agents.':
      'Gli amministratori possono sempre modificare gli agenti aziendali.',
    'Asking for edit access': 'Richiesta di accesso alla modifica',
    'Asked {value1} · also in your Inbox': 'Richiesto {value1} · anche nella tua Posta in arrivo',
    Grant: 'Concedi',
    Admin: 'Amministratore',
    'Make personal': 'Rendi personale',
    'Switch off': 'Disattiva',
    Archive: 'Archivia',
    'Archive this agent': 'Archivia questo agente',
    'Loading agent…': 'Caricamento dell’agente…',
    '{value1} Edit in chat': '{value1} Modifica nella chat',
    Agent: 'Agente',
    'This agent has not been created yet. It can run once its owner creates it.':
      'Questo agente non è ancora stato creato. Potrà essere eseguito quando il proprietario lo creerà.',
    'New agent · Draft': 'Nuovo agente · Bozza',
    'Untitled agent': 'Agente senza titolo',
    'Test run': 'Esecuzione di prova',
    'This draft does not run automatically.': 'Questa bozza non viene eseguita automaticamente.',
    'Describe the agent in the chat. Its draft appears here.':
      'Descrivi l’agente nella chat. La sua bozza apparirà qui.',
    '{value1} Test run': '{value1} Esecuzione di prova',
    'Describe the agent in the chat first.': 'Descrivi prima l’agente nella chat.',
    'Create and turn on': 'Crea e attiva',
    'Connection write setup': 'Configurazione della scrittura della connessione',
    'Account for connected changes': 'Account per le modifiche connesse',
    'Choose a connection': 'Scegli una connessione',
    'No published Skills available. You can add them later.':
      'Non sono disponibili Competenze pubblicate. Puoi aggiungerle in seguito.',
    '{value1} · not published. Review the changes. Testing is optional.':
      '{value1} · non pubblicato. Esamina le modifiche. Il test è facoltativo.',
    '{value1} Test draft': '{value1} Testa bozza',
    'Apply changes…': 'Applica modifiche…',
    'Apply this draft as a new version': 'Applica questa bozza come nuova versione',
    'This draft cannot be applied.': 'Questa bozza non può essere applicata.',
    'What changed?': 'Che cosa è cambiato?',
    'Apply version {value1}': 'Applica versione {value1}',
    Create: 'Crea',
    'Edit access requested': 'Accesso alla modifica richiesto',
    '{value1} Request edit access': '{value1} Richiedi accesso alla modifica',
    '{value1} Copy agent': '{value1} Copia agente',
    Pause: 'Metti in pausa',
    'Open agent: {value1}': 'Apri agente: {value1}',
    '· you can edit': '· puoi modificare',
    '{value1} is switched off.': '{value1} è disattivato.',
    '{value1} is archived.': '{value1} è archiviato.',
    'Loading agents…': 'Caricamento degli agenti…',
    Agents: 'Agenti',
    'Agents do work for you on a schedule or when you ask. They follow your company’s Skills.':
      'Gli agenti lavorano per te secondo una pianificazione o quando lo chiedi. Seguono le Competenze della tua azienda.',
    'No agent matches. Try a Skill name or what the agent should do.':
      'Nessun agente corrisponde. Prova con il nome di una Competenza o con ciò che dovrebbe fare l’agente.',
    'Nothing of your own yet': 'Non hai ancora nulla di tuo',
    'Tell Chat what an agent should do, or copy one of the company’s agents below.{value1}':
      'Dì a Chat cosa dovrebbe fare un agente oppure copia uno degli agenti aziendali qui sotto.{value1}',
    'Your agents': 'I tuoi agenti',
    'Run on demand': 'Esegui su richiesta',
    'Run is always available. A schedule is optional and lives separately from the agent’s instructions.':
      'L’esecuzione è sempre disponibile. La pianificazione è facoltativa e viene gestita separatamente dalle istruzioni dell’agente.',
    'Enable this schedule when approved': 'Abilita questa pianificazione quando viene approvata',
    Schedule: 'Pianificazione',
    'Kept off until you create the agent from its canvas.':
      'Rimane disabilitata finché non crei l’agente dal relativo canvas.',
    'Will be enabled when you approve.': 'Verrà abilitata quando la approverai.',
    'Will be saved paused. You can enable it later.':
      'Verrà salvata in pausa. Potrai abilitarla in seguito.',
    'Only runs when you ask.': 'Viene eseguita solo quando lo chiedi.',
    'Draft · approving saves it, and nothing runs. Test it and create it from its canvas.':
      'Bozza · approvarla la salva e non viene eseguito nulla. Testala e creala dal relativo canvas.',
    'Draft · nothing is scheduled until you approve. Connected actions require their own approval at run time.':
      'Bozza · non viene pianificato nulla finché non approvi. Le azioni connesse richiedono una propria approvazione al momento dell’esecuzione.',
    Name: 'Nome',
    'Agent name': 'Nome dell’agente',
    'Who can use it': 'Chi può usarlo',
    'Company agent · company resources only': 'Agente aziendale · solo risorse aziendali',
    'Personal agent · runs with your access':
      'Agente personale · viene eseguito con il tuo accesso',
    'Approving saves it as a draft. It does not run automatically.':
      'Approvarlo lo salva come bozza. Non viene eseguito automaticamente.',
    'Open the agent’s runs': 'Apri le esecuzioni dell’agente',
    'Run the published version once': 'Esegui una volta la versione pubblicata',
    'Stopping…': 'Arresto in corso…',
    'Stop run': 'Interrompi esecuzione',
    'Could not stop this run. Please try again.':
      'Non è stato possibile interrompere questa esecuzione. Riprova.',
    'Run in progress': 'Esecuzione in corso',
    'This run is still answering. You can ask follow-ups when it finishes.':
      'Questa esecuzione sta ancora rispondendo. Puoi fare domande successive al termine.',
    'Open run details': 'Apri i dettagli dell’esecuzione',
    Runs: 'Esecuzioni',
    'Open the run chat': 'Apri la chat dell’esecuzione',
    Watch: 'Guarda',
    Goal: 'Obiettivo',
    'Change the goal': 'Modifica l’obiettivo',
    'What it does': 'Cosa fa',
    'What should this agent achieve?': 'Cosa dovrebbe ottenere questo agente?',
    'Not set yet.': 'Non ancora impostato.',
    'When it runs': 'Quando viene eseguito',
    'Change when it runs': 'Modifica quando viene eseguito',
    'Off means it runs only when someone runs it. Changing when it runs never changes its instructions.':
      'Disattivato significa che viene eseguito solo quando qualcuno lo avvia. Modificare quando viene eseguito non cambia mai le sue istruzioni.',
    Instructions: 'Istruzioni',
    'Change the instructions': 'Modifica le istruzioni',
    'How the agent should approach the work and make decisions.':
      'Come l’agente dovrebbe affrontare il lavoro e prendere decisioni.',
    Boundaries: 'Limiti',
    'What to do or avoid. Every connected action still follows its approval.':
      'Cosa fare o evitare. Ogni azione connessa segue comunque la propria approvazione.',
    'No instructions of its own. It follows its Skills.':
      'Non ha istruzioni proprie. Segue le sue competenze.',
    'Pin a Skill': 'Fissa una competenza',
    'Finds the Skills that fit each run, the same way a chat does.':
      'Trova le competenze adatte a ogni esecuzione, proprio come una chat.',
    'Skills it always follows': 'Competenze che segue sempre',
    'A Skill that is not published': 'Una competenza non pubblicata',
    'Always follows · Version {value1}': 'Segue sempre · Versione {value1}',
    'Not published': 'Non pubblicata',
    Uses: 'Utilizza',
    'Change in chat': 'Modifica nella chat',
    'Change in chat: Uses': 'Modifica nella chat: utilizza',
    'Company knowledge and the tools each run is allowed to use.':
      'Conoscenze aziendali e strumenti che ogni esecuzione può utilizzare.',
    'People see the Result refresh; they change the agent, not the page.':
      'Le persone vedono il Risultato aggiornarsi; modificano l’agente, non la pagina.',
    'The first run after it is created makes the Result; later runs add a version to it.':
      'La prima esecuzione dopo la creazione genera il Risultato; le esecuzioni successive vi aggiungono una versione.',
    'Emails whoever the run is for': 'Invia un’e-mail alla persona destinataria dell’esecuzione',
    'Email each run': 'Invia un’e-mail per ogni esecuzione',
    Delivers: 'Consegna',
    'Change what it delivers': 'Modifica cosa consegna',
    'Expected result': 'Risultato previsto',
    'What a successful run should deliver.':
      'Cosa dovrebbe consegnare un’esecuzione completata correttamente.',
    'What each run delivers': 'Cosa consegna ogni esecuzione',
    'Keeps one Result up to date {value1}': 'Mantiene aggiornato un Risultato {value1}',
    'Saves a new Result each run': 'Salva un nuovo Risultato a ogni esecuzione',
    'You can run this company agent as yourself.{value1} {value2}':
      'Puoi eseguire questo agente aziendale come te stesso.{value1} {value2}',
    'Changes since version': 'Modifiche dalla versione',
    'are not live yet.': 'non sono ancora attive.',
    'Review them in Versions': 'Esaminale in Versioni',
    Skill: 'Competenza',
    'The agent always uses the Skill’s published version.':
      'L’agente utilizza sempre la versione pubblicata della competenza.',
    Day: 'Giorno',
    Time: 'Ora',
    'Cron expression': 'Espressione cron',
    'Editors and access': 'Editor e accesso',
    Company: 'Aziendale',
    Personal: 'Personale',
    'No changes.': 'Nessuna modifica.',
    'Instructions changes': 'Modifiche alle istruzioni',
    'Loading versions…': 'Caricamento delle versioni…',
    'What the draft changes': 'Cosa modifica la bozza',
    'No published version yet. Try the draft, then publish it.':
      'Non esiste ancora una versione pubblicata. Prova la bozza, poi pubblicala.',
    'Published versions': 'Versioni pubblicate',
    'Former member': 'Ex membro',
    Live: 'Attiva',
    'What changed in version {value1}': 'Cosa è cambiato nella versione {value1}',
    'Every publish is a version you can restore.':
      'Ogni pubblicazione è una versione che puoi ripristinare.',
    Authorization: 'Autorizzazione',
    '{value1} {value2} · {value3} will see it.': '{value1} {value2} · {value3} lo vedrà.',
    '{value1} {value2} you': '{value1} {value2} tu',
    '· Revised': '· Modificato',
    'This chat used your {value1}.': 'Questa chat ha usato {value1}.',
    'This chat has results from {value1}.': 'Questa chat contiene risultati da {value1}.',
    'db.example.com': 'db.example.com',
    'e.g. Product analytics': 'ad es. Analisi del prodotto',
    'Paste access key': 'Incolla la chiave di accesso',
    'Shopify’s Dev Dashboard': 'Shopify’s Dev Dashboard',
    'App reference': "Riferimento dell'app",
    'Draft · revision {value1}': 'Bozza · revisione {value1}',
    'its Result': 'il suo risultato',
    '· its first run makes it': '· la sua prima esecuzione lo rende',
    '{value1}’s chat ·': 'Chat di {value1} ·',
    '{value1} ad {value2} available.': '{value1} e {value2} disponibili.',
    '{value1} rows ·': '{value1} righe ·',
    'It starts private. Sharing it wider shares every refresh, which can carry your private data.':
      'Inizia come privato. Condividerlo più ampiamente condivide ogni aggiornamento, che può contenere i tuoi dati privati.',
    '{value1} for {value2}': '{value1} per {value2}',
    Suggested: 'Suggerito',
    'Opening your conversation…': 'Apertura della conversazione…',
    'This conversation isn’t available': 'Questa conversazione non è disponibile',
    'It may have been deleted, belong to another account, or be temporarily unavailable.':
      'Potrebbe essere stata eliminata, appartenere a un altro account o essere temporaneamente non disponibile.',
    '{count} more line — shown in the complete revision':
      '{count} riga in più — mostrata nella revisione completa',
    '{count} more lines — shown in the complete revision':
      '{count} righe in più — mostrate nella revisione completa',
    '{count} more line removed': "Rimossa un'altra riga: {count}",
    '{count} more lines removed': 'Rimosse altre {count} righe',
    '{count} unchanged line': '{count} riga invariata',
    '{count} unchanged lines': '{count} righe invariate',
    '{count} more lines not shown, {added} added and {removed} removed. Check them in the complete revision.':
      'Altre {count} righe non visualizzate, {added} aggiunte e {removed} rimosse. Verificale nella revisione completa.',
    'Saved result': 'Risultato salvato',
    'Made with a Skill': 'Creato con una competenza',
    'Preview of {name}': 'Anteprima di {name}',
    'Made with {name}': 'Creato con {name}',
    'Ad-hoc result': 'Risultato ad hoc',
    'A Skill that is not available in this workspace':
      'Una competenza non disponibile in questo spazio di lavoro',
    '{name} · Revision {version}': '{name} · Revisione {version}',
    '{name} · Version {version}': '{name} · Versione {version}',
    'Return to conversation {value1}': 'Torna alla conversazione {value1}',
    '{value1} Working with {value2}': '{value1} Al lavoro con {value2}',
    'View context {value1}': 'Visualizza il contesto {value1}',
    'A way of working, made yours.': 'Un modo di lavorare, fatto su misura per te.',
    'Work that runs itself.': 'Lavoro che si svolge da solo.',
    'One place for one piece of work.': 'Un unico posto per ogni attività.',
    'Let’s move your work forward{value1}.': 'Portiamo avanti il tuo lavoro{value1}.',
    'Describe the work. Your Skill takes shape beside the conversation.':
      'Descrivi il lavoro. La tua competenza prende forma accanto alla conversazione.',
    'Describe what it should do and when. Your agent takes shape beside the conversation. The draft does not run automatically.':
      'Descrivi cosa deve fare e quando. Il tuo agente prende forma accanto alla conversazione. La bozza non viene eseguita automaticamente.',
    'Say what the work is. Poneva drafts the project beside the conversation and brings in what you have already done. Nothing is created until you say so.':
      'Spiega in cosa consiste il lavoro. Poneva prepara il progetto accanto alla conversazione e importa ciò che hai già fatto. Non viene creato nulla finché non lo confermi.',
    'Start with an idea below. Poneva will take it from there.':
      "Inizia con un'idea qui sotto. Poneva penserà al resto.",
    Triggers: 'Attivatori',
    'Review the agent and its trigger. Approval applies exactly what is shown.':
      "Esamina l'agente e il suo attivatore. L'approvazione applica esattamente ciò che viene mostrato.",
    '{source} · read {date}': '{source} · letto il {date}',
    'Evidence is being recorded · read {date}':
      'La prova è in fase di registrazione · letta il {date}',
    'Evidence expired on {date} under the retention policy':
      'La prova è scaduta il {date} in base alla politica di conservazione',
    'Entered by {person}': 'Inserito da {person}',
    'No retained evidence for this value': 'Nessuna prova conservata per questo valore',
    'Covers {shown} of {total} rows': 'Copre {shown} righe su {total}',
    'Search rows': 'Cerca righe',
    'Clear filters': 'Cancella filtri',
    Sort: 'Ordina',
    'Sort: {column}': 'Ordina: {column}',
    '{shown} of {total} rows': '{shown} righe su {total}',
    More: 'Altro',
    Density: 'Densità',
    Comfortable: 'Confortevole',
    Compact: 'Compatta',
    Columns: 'Colonne',
    'No rows match. Clear the search or filters to see them again.':
      'Nessuna riga corrisponde. Cancella la ricerca o i filtri per visualizzarle di nuovo.',
    'Not available': 'Non disponibile',
    'All rows': 'Tutte le righe',
    'Close row detail': 'Chiudi dettagli riga',
    'Ask about this row': 'Chiedi informazioni su questa riga',
    'Add note': 'Aggiungi nota',
    Note: 'Nota',
    Saved: 'Salvato',
    Total: 'Totale',
    ascending: 'crescente',
    descending: 'decrescente',
    'Scroll to see all columns': 'Scorri per vedere tutte le colonne',
    App: 'Applicazione',
    Artifact: 'Artefatto',
    'New project': 'Nuovo progetto',
    'Review request': 'Richiesta di revisione',
    Activity: 'Attività',
    'Voice preview': 'Anteprima vocale',
    Source: 'Fonte',
    File: 'File',
    Meeting: 'Riunione',
    'Knowledge page': 'Pagina della knowledge base',
    'Could not preview this CSV.': 'Non è stato possibile visualizzare l’anteprima di questo CSV.',
    'File content is unavailable.': 'Il contenuto del file non è disponibile.',
    'You have five open suggestions here. {value1} will see them.':
      'Hai cinque suggerimenti aperti qui. {value1} li vedrà.',
    'We could not send your suggestion. Please try again.':
      'Non è stato possibile inviare il suggerimento. Riprova.',
    'The agent': 'L’agente',
    'Selected colleagues': 'Colleghi selezionati',
    'The owner': 'Il proprietario',
    'Forked. This copy is yours and runs with your own connections.':
      'Biforcazione completata. Questa copia è tua e viene eseguita con le tue connessioni.',
    'This chat is too long to fork.': 'Questa chat è troppo lunga per essere biforcata.',
    'We could not fork this chat. Please try again.':
      'Non è stato possibile biforcare questa chat. Riprova.',
    'Anyone who forked it keeps their copy: forks stay with the people who made them.':
      'Chiunque l’abbia biforcata conserva la propria copia: le biforcazioni restano alle persone che le hanno create.',
    'Nobody has forked this chat.': 'Nessuno ha biforcato questa chat.',
    '1 person forked this chat. Their copy stays theirs.':
      '1 persona ha biforcato questa chat. La sua copia rimane sua.',
    '{value1} people forked this chat. Their copies stay theirs.':
      '{value1} persone hanno biforcato questa chat. Le loro copie rimangono loro.',
    'Personal. Nobody else sees it.': 'Personale. Nessun altro può vederlo.',
    'People you pick. They get it in their Inbox.':
      'Le persone che scegli. Lo ricevono nella Posta in arrivo.',
    'Everyone in the company can follow it and fork it.':
      'Tutti i membri dell’azienda possono seguirlo e biforcarlo.',
    'a chat you can no longer open': 'una chat che non puoi più aprire',
    'shared the Result': 'ha condiviso il Risultato',
    'updated the Result': 'ha aggiornato il Risultato',
    'published the Skill': 'ha pubblicato la competenza',
    'approved the fact': 'ha approvato il fatto',
    'added the fact': 'ha aggiunto il fatto',
    'added the meeting': 'ha aggiunto la riunione',
    'published the page': 'ha pubblicato la pagina',
    'updated the page': 'ha aggiornato la pagina',
    'shared the chat': 'ha condiviso la chat',
    'published a version of': 'ha pubblicato una versione di',
    ran: 'ha eseguito',
    Knowledge: 'Conoscenza',
    Meetings: 'Riunioni',
    Chat: 'Chat',
    Use: 'Usa',
    Open: 'Apri',
    You: 'Tu',
    Someone: 'Qualcuno',
    'published version {version} of': 'ha pubblicato la versione {version} di',
    'thing needs': 'elemento richiede',
    'things need': 'elementi richiedono',
    'Published Skill': 'Competenza pubblicata',
    'Included with Skill': 'Incluso nella competenza',
    'Already attached': 'Già allegato',
    'Also available in company knowledge': 'Disponibile anche nella knowledge base aziendale',
    'Company file': 'File aziendale',
    'Account identity unavailable': 'Identità dell’account non disponibile',
    'Access expired or was revoked. Reconnect to continue.':
      'L’accesso è scaduto o è stato revocato. Riconnettiti per continuare.',
    'Account authorized · tools unavailable': 'Account autorizzato · strumenti non disponibili',
    'Not available in this workspace yet.': 'Non ancora disponibile in questo workspace.',
    'Everyone in the company': 'Tutti i membri dell’azienda',
    'Audience: only you.': 'Destinatari: solo tu.',
    'Audience: everyone in the company.': 'Destinatari: tutti i membri dell’azienda.',
    'tool is': 'lo strumento è',
    'tools are': 'gli strumenti sono',
    'account is': 'l’account è',
    'accounts are': 'gli account sono',
    'We could not upload this file.': 'Non è stato possibile caricare questo file.',
    'file was': 'file era',
    'files were': 'file erano',
    'Your company': 'La tua azienda',
    'Create an agent': 'Crea un agente',
    'Give recurring work a helping hand': 'Dai una mano al lavoro ricorrente',
    'Create a Skill': 'Crea una competenza',
    'Save a reusable way of working': 'Salva un modo di lavorare riutilizzabile',
    'Take meeting notes': 'Prendi appunti durante la riunione',
    'Capture decisions and next steps': 'Registra decisioni e prossimi passi',
    'Work with a file': 'Lavora con un file',
    'Start from a document or image': "Inizia da un documento o un'immagine",
    'Browse agents': 'Esplora gli agenti',
    'Open your agents and company agents': "Apri i tuoi agenti e quelli dell'azienda",
    'Review results': 'Esamina i risultati',
    'Return to work saved in your Library': 'Torna al lavoro salvato nella tua Libreria',
    'For review': 'Da esaminare',
    'An agent': 'Un agente',
    Assistant: 'Assistente',
    'Kept up to date by {value1}{value2}': 'Mantenuto aggiornato da {value1}{value2}',
    ', {value1}': ', {value1}',
    'Version {value1}{value2}{value3}': 'Versione {value1}{value2}{value3}',
    'Refreshed by its agent': 'Aggiornato dal relativo agente',
    'Saved from a chat': 'Salvato da una chat',
    'Saved from {value1}': 'Salvato da {value1}',
    Edited: 'Modificato',
    'private account': 'account privato',
    '{value1} ({value2})': '{value1} ({value2})',
    '{value1}’s {value2}': '{value2} di {value1}',
    'Made private. The person who added it and the owner of its recording have been told in their Inbox.':
      'Reso privato. La persona che lo ha aggiunto e il proprietario della relativa registrazione hanno ricevuto una notifica nella Posta in arrivo.',
    'Made private. The person who added it has been told in their Inbox.':
      'Reso privato. La persona che lo ha aggiunto ha ricevuto una notifica nella Posta in arrivo.',
    'Made private. The owner of its recording has been told in their Inbox.':
      'Reso privato. Il proprietario della relativa registrazione ha ricevuto una notifica nella Posta in arrivo.',
    'Selected passage': 'Passaggio selezionato',
    '{value1} {value2}': '{value1} {value2}',
    'Upload a file': 'Carica un file',
    'Help me create a useful report from our company knowledge and available sources.':
      "Aiutami a creare un report utile a partire dalle conoscenze dell'azienda e dalle fonti disponibili.",
    'This saved work couldn’t be opened. Open it again to retry.':
      'Non è stato possibile aprire questo lavoro salvato. Aprilo di nuovo per riprovare.',
    '{value1}’s': 'Di {value1}',
    '{value1} chat “{value2}”': 'Chat “{value2}” di {value1}',
    '{value1}{value2}': '{value1}{value2}',
    'Skill: {value1}{value2}': 'Competenza: {value1}{value2}',
    'Result “{value1}”': 'Risultato “{value1}”',
    'Meeting “{value1}”': 'Riunione “{value1}”',
    'Used in {value1} {value2} this week': 'Utilizzato in {value1} {value2} questa settimana',
    '{value1} {value2} · used in {value3} {value4}':
      '{value1} {value2} · utilizzato in {value3} {value4}',
    'The draft is not published yet, so no one else follows it.':
      'La bozza non è ancora pubblicata, quindi nessun altro la segue.',
    'Use it in a chat for current data, or refine the Skill first.':
      'Usala in una chat per dati aggiornati oppure perfeziona prima la competenza.',
    'An agent keeps this up to date. Continue the work in chat.':
      'Un agente la mantiene aggiornata. Continua il lavoro in chat.',
    'Edit it here, or continue the work in chat.':
      'Modificala qui oppure continua il lavoro in chat.',
    'Duplicate it to your Library, or continue the work in chat.':
      'Duplicala nella tua Libreria oppure continua il lavoro in chat.',
    'Download Markdown': 'Scarica Markdown',
    'Download CSV': 'Scarica CSV',
    'an agent': 'un agente',
    'Publish a Skill version': 'Pubblica una versione della competenza',
    'Share with {value1}': 'Condividi con {value1}',
    'Update company content': "Aggiorna i contenuti dell'azienda",
    Approved: 'Approvato',
    Declined: 'Rifiutato',
    Pending: 'In attesa',
    'View decision': 'Visualizza la decisione',
    'No data': 'Nessun dato',
    'No change': 'Nessuna modifica',
    'Connection created': 'Connessione creata',
    'Sharing changed': 'Condivisione modificata',
    'Person added': 'Persona aggiunta',
    'Person removed': 'Persona rimossa',
    'Access changed': 'Accesso modificato',
    'Access turned off': 'Accesso disattivato',
    'Connection removed': 'Connessione rimossa',
    'Query time limit changed': 'Limite di tempo della query modificato',
    '{count} row': '{count} riga',
    '{count} rows': '{count} righe',
    'This source is no longer available. Company knowledge now lives in Knowledge pages, and files stay in the Library.':
      "Questa fonte non è più disponibile. Le conoscenze dell'azienda si trovano ora nelle pagine Knowledge e i file restano nella Libreria.",
    '· {value1} by {value2}': '· {value1} di {value2}',
    '· version {value1}': '· versione {value1}',
    '{message} {count} earlier file was saved and attached.':
      '{message} {count} file precedente è stato salvato e allegato.',
    '{message} {count} earlier files were saved and attached.':
      '{message} {count} file precedenti sono stati salvati e allegati.',
    '{message} {count} earlier file was saved.':
      '{message} {count} file precedente è stato salvato.',
    '{message} {count} earlier files were saved.':
      '{message} {count} file precedenti sono stati salvati.',
    'refreshed {time}': 'aggiornato {time}',
    'a colleague': 'un collega',
    'Your chat “{title}”': 'La tua chat “{title}”',
    '{name}’s chat “{title}”': 'La chat di {name} “{title}”',
    'Kept up to date by {name}{version}': 'Aggiornato da {name}{version}',
    'Skill: {name}{version}': 'Competenza: {name}{version}',
    'Result “{title}”': 'Risultato “{title}”',
    'Meeting “{title}”': 'Riunione “{title}”',
    'Used in {count} answer this week': 'Utilizzato in {count} risposta questa settimana',
    'Used in {count} answers this week': 'Utilizzato in {count} risposte questa settimana',
    '{count} source': '{count} fonte',
    '{count} sources': '{count} fonti',
    'used in {count} place': 'utilizzato in {count} punto',
    'used in {count} places': 'utilizzato in {count} punti',
    '{company} workspace': 'spazio di lavoro {company}',
    '{count} page': '{count} pagina',
    '{count} pages': '{count} pagine',
    '{needs} · reviews and approvals': '{needs} · revisioni e approvazioni',
    '{count} thing needs you': '{count} elemento richiede la tua attenzione',
    '{count} things need you': '{count} elementi richiedono la tua attenzione',
    'Included with Skill · {files} · {sources} {icon}':
      'Incluso con la competenza · {files} · {sources} {icon}',
    '{count} file': '{count} file',
    '{count} files': '{count} file',
    Today: 'Oggi',
    'Earlier this week': 'In precedenza questa settimana',
    '{count} slide': '{count} diapositiva',
    '{count} slides': '{count} diapositive',
    Early: 'In anticipo',
    'TLS verified': 'TLS verificato',
    'Made personal and switched off. Switch it on when you are ready.':
      'Reso personale e disattivato. Riattivalo quando sei pronto.',
    'Made personal and switched off. Its owner is told which version is live.':
      'Reso personale e disattivato. Il proprietario viene informato della versione attiva.',
    'Switched off.': 'Disattivato.',
    'Applied version {revision}.': 'Versione {revision} applicata.',
    'The draft is running in a chat only you can read.':
      'La bozza è in esecuzione in una chat visibile solo a te.',
    'Publish a version first.': 'Pubblica prima una versione.',
    'Another Agent action is in progress.': 'È in corso un’altra azione dell’agente.',
    'Knowledge & connections': 'Conoscenze e connessioni',
    'Pinned Skills': 'Competenze fissate',
    None: 'Nessuno',
    'A new Result each run': 'Un nuovo risultato a ogni esecuzione',
    'One Result kept up to date': 'Un risultato sempre aggiornato',
    Email: 'Email',
    On: 'Attivo',
    Off: 'Disattivato',
    'Waiting for review': 'In attesa di revisione',
    Outdated: 'Obsoleto',
    Accepted: 'Accettato',
    Rejected: 'Rifiutato',
    Withdrawn: 'Ritirato',
    Replaced: 'Sostituito',
    'Suggested edit': 'Modifica suggerita',
    'Suggested new page': 'Nuova pagina suggerita',
    'Suggested move': 'Spostamento suggerito',
    'Suggested archive': 'Archiviazione suggerita',
    'Checking status…': 'Verifica dello stato…',
    'Status unavailable': 'Stato non disponibile',
    'Bulleted list': 'Elenco puntato',
    'Numbered list': 'Elenco numerato',
    'Web link': 'Link web',
    Read: 'Lettura',
    Write: 'Scrittura',
    'shared with you': 'condiviso con te',
    'Getting an answer': 'Attesa di una risposta',
    '{name} is getting an answer': '{name} sta ricevendo una risposta',
    'We could not save. Please try again.': 'Non è stato possibile salvare. Riprova.',
    'The new page could not be created.': 'Non è stato possibile creare la nuova pagina.',
    'We could not load this revision.': 'Non è stato possibile caricare questa revisione.',
    'We could not restore this revision. Please try again.':
      'Non è stato possibile ripristinare questa revisione. Riprova.',
    'We could not export this revision.': 'Non è stato possibile esportare questa revisione.',
    'We could not open this suggestion.': 'Non è stato possibile aprire questo suggerimento.',
    'We could not do that. Please try again.':
      'Non è stato possibile eseguire l’operazione. Riprova.',
    'We could not save your decision. Please try again.':
      'Non è stato possibile salvare la tua decisione. Riprova.',
    'We could not restore this page. Please try again.':
      'Non è stato possibile ripristinare questa pagina. Riprova.',
    'We could not export this page.': 'Non è stato possibile esportare questa pagina.',
    '{count} missed time merged.': 'È stato unito {count} tempo mancante.',
    '{count} missed times merged.': 'Sono stati uniti {count} tempi mancanti.',
    'About this project': 'Informazioni su questo progetto',
  },
  lv: {
    context: 'konteksts',
    skills: 'prasmes',
    'Choose company context': 'Izvēlieties uzņēmuma kontekstu',
    'Skills for this conversation': 'Šīs sarunas prasmes',
    'Bring context into the conversation': 'Pievienot sarunai kontekstu',
    'Close context picker': 'Aizvērt konteksta atlasi',
    'Filter company context': 'Filtrēt uzņēmuma kontekstu',
    'Find a Skill…': 'Atrast prasmi…',
    'Find a file…': 'Atrast failu…',
    'Available company context': 'Pieejamais uzņēmuma konteksts',
    'No matching published Skills.': 'Nav atbilstošu publicētu prasmju.',
    'No matching files.': 'Nav atbilstošu failu.',
    'Searching company work…': 'Meklēšana uzņēmuma darbā…',
    'Try search again': 'Mēģināt meklēt vēlreiz',
    'Meaning search is temporarily limited. Showing available text matches.':
      'Nozīmes meklēšana īslaicīgi ir ierobežota. Tiek rādītas pieejamās teksta atbilstības.',
    'Load more matches': 'Ielādēt vairāk atbilstību',
    '{value1} files attached. Remove an attachment to add another. Saved Skill references are included separately.':
      'Pievienoti {value1} faili. Lai pievienotu vēl vienu, noņemiet kādu pielikumu. Saglabātās prasmju atsauces tiek iekļautas atsevišķi.',
    'Create a Skill in chat': 'Izveidot prasmi tērzētavā',
    'Upload a company file': 'Augšupielādēt uzņēmuma failu',
    'Company knowledge is always available to Poneva.':
      'Uzņēmuma zināšanas vienmēr ir pieejamas Poneva.',
    '{value1} was not connected': '{value1} netika savienots',
    Dismiss: 'Noraidīt',
    'Try connecting again': 'Mēģināt savienot vēlreiz',
    Waiting: 'Gaida',
    Connected: 'Savienots',
    'Needs reconnecting': 'Nepieciešams atkārtoti savienot',
    Connect: 'Savienot',
    '{value1}{value2} The provider’s account permissions still apply.':
      '{value1}{value2} Joprojām ir spēkā pakalpojumu sniedzēja konta atļaujas.',
    'Last error: {value1}': 'Pēdējā kļūda: {value1}',
    '{value1} {value2} ready.': '{value1} {value2} ir gatavs.',
    'Continue with my Meta app': 'Turpināt ar manu Meta lietotni',
    Reconnect: 'Atkārtoti savienot',
    Disconnect: 'Atvienot',
    'Remove attachment: {value1}': 'Noņemt pielikumu: {value1}',
    'Saved in this Skill. Edit the Skill to change its references.':
      'Saglabāts šajā prasmē. Rediģējiet prasmi, lai mainītu tās atsauces.',
    'Remove Skill context': 'Noņemt prasmes kontekstu',
    Refining: 'Precizē',
    Previewing: 'Priekšskatīšana',
    Using: 'Izmanto',
    'Skill revision {value1}': 'Prasmes versija {value1}',
    'a new Skill': 'jauna prasme',
    '{value1} Making a new agent {value2}': '{value1} Tiek veidots jauns aģents {value2}',
    'Stop making a new agent in this chat': 'Pārtraukt jauna aģenta veidošanu šajā tērzētavā',
    'Saved Skill references': 'Saglabātās prasmju atsauces',
    'Included with Skill · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}':
      'Iekļauts kopā ar prasmi · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}',
    'Selected Skill revision is unavailable. Select the Skill again to view its saved references.':
      'Atlasītā prasmes versija nav pieejama. Atlasiet prasmi vēlreiz, lai skatītu tās saglabātās atsauces.',
    'Conversation attachments': 'Sarunas pielikumi',
    'Added for this conversation': 'Pievienots šai sarunai',
    'Selected passage {value1}': 'Atlasītais fragments {value1}',
    'We could not load your workspace.': 'Neizdevās ielādēt jūsu darbvietu.',
    'The selected Skill is unavailable. Check its access or choose it again.':
      'Atlasītā prasme nav pieejama. Pārbaudiet piekļuvi tai vai atlasiet to vēlreiz.',
    'Source saved privately and included in your knowledge search.':
      'Avots saglabāts privāti un iekļauts jūsu zināšanu meklēšanā.',
    'File saved privately to your library and attached to this message.':
      'Fails saglabāts privāti jūsu bibliotēkā un pievienots šim ziņojumam.',
    'File saved privately to your library.': 'Fails saglabāts privāti jūsu bibliotēkā.',
    '{value1} {value2} earlier {value3} saved{value4}.':
      '{value1} {value2} iepriekš {value3} saglabāts{value4}.',
    'Extracted text for Poneva to read. Download the original for its layout, charts and images. Spreadsheet formulas show their saved results and are not recalculated.':
      'Izvilkts teksts, ko Poneva var lasīt. Lejupielādējiet oriģinālu, lai skatītu tā izkārtojumu, diagrammas un attēlus. Izklājlapu formulas rāda saglabātos rezultātus un netiek pārrēķinātas.',
    Esc: 'Esc',
    'Start something': 'Sākt kaut ko',
    'Choose a file to work with': 'Izvēlieties failu, ar ko strādāt',
    'Skills worth adding': 'Prasmes, ko vērts pievienot',
    'Picked for you': 'Atlasīts jums',
    'Reusable work grounded in your company knowledge.':
      'Atkārtoti izmantojams darbs, kas balstīts jūsu uzņēmuma zināšanās.',
    'Ideas from your company context and recent work. Pick one to start.':
      'Idejas no jūsu uzņēmuma konteksta un nesenā darba. Izvēlieties vienu, lai sāktu.',
    'Refresh suggested tasks': 'Atjaunināt ieteiktos uzdevumus',
    'Check for new company context.': 'Pārbaudīt, vai nav jauna uzņēmuma konteksta.',
    'Check for new context. Ideas also refresh daily.':
      'Pārbaudīt, vai nav jauna konteksta. Idejas tiek atjauninātas arī katru dienu.',
    Refresh: 'Atjaunināt',
    'Finding useful starting points…': 'Tiek meklēti noderīgi sākumpunkti…',
    'Suggestions aren’t available right now. Try Refresh, or describe the work you want to do.':
      'Ieteikumi pašlaik nav pieejami. Mēģiniet atjaunināt vai aprakstiet darbu, ko vēlaties veikt.',
    'Loading the knowledge pages…': 'Notiek zināšanu lapu ielāde…',
    '{value1} All pages': '{value1} Visas lapas',
    'The page is created.': 'Lapa ir izveidota.',
    'Your new page is suggested. A publisher decides whether it is added.':
      'Jūsu jaunā lapa ir ieteikta. Publicētājs izlems, vai to pievienot.',
    'Company knowledge': 'Uzņēmuma zināšanas',
    'What Poneva knows about your company, page by page. Every change is kept.':
      'Ko Poneva zina par jūsu uzņēmumu — lapa pēc lapas. Katra izmaiņa tiek saglabāta.',
    'Loading company knowledge…': 'Notiek uzņēmuma zināšanu ielāde…',
    'Knowledge pages are not enabled in this workspace.':
      'Šajā darbvietā zināšanu lapas nav iespējotas.',
    'Ask your Poneva contact to switch them on for your company.':
      'Lūdziet savai Poneva kontaktpersonai tās ieslēgt jūsu uzņēmumam.',
    '{value1} Change the agent': '{value1} Mainīt aģentu',
    '{value1} Continue in chat': '{value1} Turpināt tērzētavā',
    Edit: 'Rediģēt',
    '{value1} Edit with chat': '{value1} Rediģēt, izmantojot tērzēšanu',
    '{value1} Duplicate to my Library': '{value1} Dublēt manā bibliotēkā',
    'Duplicated to your Library. Only you can see the copy.':
      'Dublēts jūsu bibliotēkā. Kopiju varat redzēt tikai jūs.',
    'Could not duplicate this Result. Try again.':
      'Neizdevās dublēt šo rezultātu. Mēģiniet vēlreiz.',
    'Saved version {value1}.': 'Saglabāta versija {value1}.',
    'A newer version was saved. Reload the Result before saving.':
      'Ir saglabāta jaunāka versija. Pirms saglabāšanas atkārtoti ielādējiet rezultātu.',
    'Could not save this version. Try again.': 'Neizdevās saglabāt šo versiju. Mēģiniet vēlreiz.',
    '{value1} saved a newer version. Review it before saving.':
      '{value1} saglabāja jaunāku versiju. Pārskatiet to pirms saglabāšanas.',
    'Hide their version': 'Paslēpt viņu versiju',
    'Show their version': 'Rādīt viņu versiju',
    'Start from their version': 'Sākt ar viņu versiju',
    Markdown: 'Markdown',
    'Result text': 'Rezultāta teksts',
    Preview: 'Priekšskatījums',
    'What changed': 'Kas mainījās',
    'What changed? (optional)': 'Kas mainījās? (neobligāti)',
    'Save version {value1}': 'Saglabāt versiju {value1}',
    'Open chat': 'Atvērt tērzēšanu',
    Current: 'Pašreizējā',
    Restore: 'Atjaunot',
    'Could not load the history.': 'Neizdevās ielādēt vēsturi.',
    'Restored version {value1} as version {value2}.':
      'Versija {value1} atjaunota kā versija {value2}.',
    'Someone saved a newer version. Review it before restoring.':
      'Kāds saglabāja jaunāku versiju. Pārskatiet to pirms atjaunošanas.',
    'Could not restore that version.': 'Neizdevās atjaunot šo versiju.',
    'Loading history…': 'Ielādē vēsturi…',
    'Restoring keeps what is there now as a version too, so nothing is lost.':
      'Atjaunošanas laikā pašreizējais saturs tiek saglabāts arī kā versija, tāpēc nekas netiek zaudēts.',
    'This Result was made with your own {value1}.':
      'Šis rezultāts izveidots, izmantojot jūsu {value1}.',
    'It also used': 'Tajā tika izmantots arī',
    'This Result was made with': 'Šis rezultāts izveidots, izmantojot',
    'Colleagues can read what came from them, but can never use them.':
      'Kolēģi var lasīt no tiem iegūto informāciju, bet nekad nevar tos izmantot.',
    'Your personal agent {value1} keeps it up to date with your own access, so every refresh can carry your private data.':
      'Jūsu personīgais aģents {value1} to atjaunina, izmantojot jūsu piekļuves tiesības, tāpēc katrā atsvaidzināšanas reizē var tikt iekļauti jūsu privātie dati.',
    'A colleague’s personal agent keeps it up to date with their own access, so every refresh can carry their private data.':
      'Kolēģa personīgais aģents to atjaunina, izmantojot kolēģa piekļuves tiesības, tāpēc katrā atsvaidzināšanas reizē var tikt iekļauti kolēģa privātie dati.',
    'Made private. Only you can see this meeting.':
      'Padarīta privāta. Šo sapulci varat redzēt tikai jūs.',
    'Could not make this meeting private.': 'Neizdevās padarīt šo sapulci privātu.',
    'Meeting · {value1} {value2} · Original retained':
      'Sapulce · {value1} {value2} · Sākotnējais ieraksts saglabāts',
    'The recording could not be opened.': 'Neizdevās atvērt ierakstu.',
    'Ask about this suggestion': 'Uzdot jautājumu par šo ieteikumu',
    meeting_processing_failed: 'sapulces_apstrāde_neizdevās',
    'Who can see this': 'Kas to var redzēt',
    'Everyone at {value1}': 'Ikviens organizācijā {value1}',
    'Only me': 'Tikai es',
    'Everyone at {value1} can find it and ask about it.':
      'Ikviens organizācijā {value1} to var atrast un uzdot par to jautājumus.',
    'Only you can open and search this meeting. You can share it later.':
      'Šo sapulci varat atvērt un meklēt tajā tikai jūs. Vēlāk varat to kopīgot.',
    'Added. Only you can see it. Transcription is running in the background.':
      'Pievienots. To varat redzēt tikai jūs. Fonā notiek transkripcija.',
    'Visible to everyone at {value1}': 'Redzams ikvienam organizācijā {value1}',
    'Could not make it private.': 'Neizdevās padarīt to privātu.',
    'Show more meetings': 'Rādīt vairāk sapulču',
    'Attached to this message': 'Pievienots šim ziņojumam',
    'Connect securely, choose the tables to share, then decide whether Poneva can read or make changes.':
      'Droši izveidojiet savienojumu, izvēlieties kopīgojamās tabulas un pēc tam nosakiet, vai Poneva drīkst tās lasīt vai veikt izmaiņas.',
    'Review the tables this connection can access. Select at least one table.':
      'Pārskatiet tabulas, kurām šis savienojums var piekļūt. Atlasiet vismaz vienu tabulu.',
    'Select at least one table. Nothing is selected by default.':
      'Atlasiet vismaz vienu tabulu. Pēc noklusējuma nekas nav atlasīts.',
    'Choose who can use this connection and what Poneva can do.':
      'Izvēlieties, kas drīkst izmantot šo savienojumu un ko Poneva drīkst darīt.',
    'Your chosen access is enabled for the selected tables.':
      'Jūsu izvēlētā piekļuve ir iespējota atlasītajām tabulām.',
    'Your connection is saved with reading paused until permission is confirmed.':
      'Jūsu savienojums ir saglabāts, un lasīšana apturēta, līdz tiek apstiprināta atļauja.',
    'Confirm database disconnect': 'Apstiprināt datubāzes atvienošanu',
    'Disconnect this database?': 'Vai atvienot šo datubāzi?',
    'Access will stop for everyone using this connection.':
      'Piekļuve tiks pārtraukta visiem, kas izmanto šo savienojumu.',
    'Keep connection': 'Saglabāt savienojumu',
    'What it can reach · {value1}{value2} {value3}': 'Kam var piekļūt · {value1}{value2} {value3}',
    Back: 'Atpakaļ',
    Continue: 'Turpināt',
    'Uploading…': 'Notiek augšupielāde…',
    Library: 'Bibliotēka',
    'Source material for your work. Available whenever you need it.':
      'Materiāli jūsu darbam. Pieejami jebkurā laikā, kad tie nepieciešami.',
    'The work you want to keep, with its sources and conversation attached.':
      'Darbs, ko vēlaties saglabāt, kopā ar pievienotajiem avotiem un sarunu.',
    Results: 'Rezultāti',
    Files: 'Faili',
    Artifacts: 'Artefakti',
    'Search library': 'Meklēt bibliotēkā',
    'Find files by meaning…': 'Atrast failus pēc nozīmes…',
    'Find saved work by meaning…': 'Atrast saglabāto darbu pēc nozīmes…',
    'Search coverage is limited while indexing or meaning-based search is unavailable. You can retry or browse recent items.':
      'Meklēšanas tvērums ir ierobežots, kamēr notiek indeksēšana vai nav pieejama meklēšana pēc nozīmes. Varat mēģināt vēlreiz vai pārlūkot nesenos vienumus.',
    'No matching work found.': 'Atbilstošs darbs nav atrasts.',
    'A starting point for your next question.': 'Sākumpunkts nākamajam jautājumam.',
    'Good work is worth keeping.': 'Labs darbs ir saglabāšanas vērts.',
    'Try a different description or clear the search to browse.':
      'Izmēģiniet citu aprakstu vai notīriet meklēšanu, lai pārlūkotu saturu.',
    'Upload source material once and use it in conversations and Skills. Your original stays in the library.':
      'Augšupielādējiet avota materiālus vienreiz un izmantojiet tos sarunās un prasmēs. Sākotnējais fails paliek bibliotēkā.',
    'Ask Poneva to save an answer, table or chart. Results stay connected to the conversation and their sources.':
      'Lūdziet Poneva saglabāt atbildi, tabulu vai diagrammu. Rezultāti paliek saistīti ar sarunu un tās avotiem.',
    'Start in chat {value1}': 'Sākt tērzēšanā {value1}',
    'We could not load this item.': 'Neizdevās ielādēt šo vienumu.',
    '{value1} canvas': '{value1} kanva',
    'Loading {value1}…': 'Notiek {value1} ielāde…',
    '{value1} · Original retained': '{value1} · Oriģināls saglabāts',
    '{value1} {value2}{value3} · Added {value4}': '{value1} {value2}{value3} · Pievienots {value4}',
    '{value1} Use in chat': '{value1} Izmantot čatā',
    '{value1} Download': '{value1} Lejupielādēt',
    Table: 'Tabula',
    Chart: 'Diagramma',
    Original: 'Oriģināls',
    'Text extracted from the PDF, marked by page. Download the original for its layout and images.':
      'Teksts izvilkts no PDF un atzīmēts pēc lapām. Lejupielādējiet oriģinālu, lai skatītu tā izkārtojumu un attēlus.',
    'This preview shows the beginning of the file. Poneva reads the whole file; download the original to see all of it.':
      'Šajā priekšskatījumā redzams faila sākums. Poneva nolasa visu failu; lejupielādējiet oriģinālu, lai skatītu to pilnībā.',
    'Preview of the first {value1} complete rows. Filtering and charts use only this preview. Download the original for the full file.':
      'Pirmo {value1} pilno rindu priekšskatījums. Filtrēšana un diagrammas izmanto tikai šo priekšskatījumu. Lejupielādējiet oriģinālu, lai skatītu visu failu.',
    'This source link cannot be opened.': 'Šo avota saiti nevar atvērt.',
    'Read-only chat': 'Tikai lasāms čats',
    'Only {value1} writes in this chat. Fork it to continue with your own connections. {value2}':
      'Šajā čatā raksta tikai {value1}. Izveidojiet tā atzaru, lai turpinātu ar saviem savienojumiem. {value2}',
    'Suggest a follow-up…': 'Ieteikt turpinājumu…',
    'Suggest a follow-up': 'Ieteikt turpinājumu',
    'Sending…': 'Notiek sūtīšana…',
    Send: 'Sūtīt',
    'We could not dismiss that suggestion. Please try again.':
      'Neizdevās noraidīt šo ieteikumu. Lūdzu, mēģiniet vēlreiz.',
    'Suggested follow-ups': 'Ieteiktie turpinājumi',
    '{value1} suggests': '{value1} iesaka',
    Ask: 'Jautāt',
    'Dismiss {value1}’s suggestion': 'Noraidīt {value1} ieteikumu',
    'Suggested by': 'Ieteica',
    '· edit it or send it': '· rediģējiet vai nosūtiet',
    'Remove the suggestion tag': 'Noņemt ieteikuma atzīmi',
    '{value1} {value2} is getting an answer': '{value1} {value2} saņem atbildi',
    '{value1} {value2} stopped the answer': '{value1} {value2} apturēja atbildi',
    '{value1} Fork from here': '{value1} Izveidot atzaru no šīs vietas',
    '{value1} From {value2}’s {value3}': '{value1} No {value2} {value3}',
    'Only {value1} can use this account': 'Šo kontu var izmantot tikai {value1}',
    '{value1} Suggested by {value2}': '{value1} Ieteica {value2}',
    'Fork this chat': 'Izveidot šī čata atzaru',
    'Forking…': 'Notiek atzarošana…',
    Fork: 'Atzarot',
    'Could not make this private.': 'Neizdevās padarīt privātu.',
    'Make this chat private?': 'Vai padarīt šo čatu privātu?',
    Close: 'Aizvērt',
    '{value1} will see “{value2}”. Everyone else loses access right away {value3} .{value4}':
      '{value1} redzēs “{value2}”. Visi pārējie nekavējoties zaudēs piekļuvi {value3} .{value4}',
    Cancel: 'Atcelt',
    'Saving…': 'Notiek saglabāšana…',
    'Make private': 'Padarīt privātu',
    'This chat is private again. Forks others made stay theirs.':
      'Šis čats atkal ir privāts. Citu izveidotie atzari paliek viņiem.',
    'Who can read this chat: {value1}': 'Kas var lasīt šo čatu: {value1}',
    'Move this chat': 'Pārvietot šo čatu',
    'Only you write here. Others follow live and fork.':
      'Šeit rakstāt tikai jūs. Citi seko tiešraidē un veido atzarus.',
    'Made private. {value1} has been told in their Inbox.':
      'Padarīts privāts. {value1} par to paziņots viņa iesūtnē.',
    'Chat access': 'Piekļuve čatam',
    '{value1}’s chat. As an admin you can make it private.':
      '{value1} čats. Kā administrators varat padarīt to privātu.',
    'Only {value1} will see it. {value2} is told.':
      'To redzēs tikai {value1}. {value2} par to paziņots.',
    '{value1} {value2} following': '{value1} {value2} seko',
    'Forked from{value1} {value2} . The history is copied. From here, tools run with your own access.':
      'Atzarots no{value1} {value2} . Vēsture ir nokopēta. No šīs vietas rīki darbojas ar jūsu piekļuvi.',
    '{value1} made this chat private': '{value1} padarīja šo čatu privātu',
    'You can no longer open it. Any fork you made stays yours.':
      'Jūs to vairs nevarat atvērt. Jebkurš jūsu izveidotais atzars paliek jums.',
    'Start a new chat': 'Sākt jaunu čatu',
    'Back to Recent chats': 'Atgriezties pie nesenajiem čatiem',
    'More chat actions': 'Citas čata darbības',
    'Close conversation sharing': 'Aizvērt sarunas kopīgošanu',
    'Review the text before saving a private copy to Library. Then choose its audience. Your original conversation and future messages stay private.':
      'Pirms privātas kopijas saglabāšanas bibliotēkā pārskatiet tekstu. Pēc tam izvēlieties tās auditoriju. Jūsu sākotnējā saruna un turpmākie ziņojumi paliek privāti.',
    'Preparing the conversation…': 'Notiek sarunas sagatavošana…',
    'Refresh preview': 'Atjaunināt priekšskatījumu',
    'The copy is saved in Library. Use Share to choose who can access it.':
      'Kopija ir saglabāta bibliotēkā. Izmantojiet “Kopīgot”, lai izvēlētos, kam tai būs piekļuve.',
    'Save this copy': 'Saglabāt šo kopiju',
    'That Skill could not be opened.': 'Neizdevās atvērt šo prasmi.',
    '{value1}{value2} · reviews and approvals': '{value1}{value2} · pārskatīšana un apstiprinājumi',
    'Open Inbox': 'Atvērt iesūtni',
    'New at {value1} this week': 'Jaunumi sadaļā {value1} šonedēļ',
    'Nothing new this week. Shared work, published Skills and approved knowledge show up here.':
      'Šonedēļ nekā jauna nav. Šeit tiek rādīts koplietotais darbs, publicētās prasmes un apstiprinātās zināšanas.',
    'New at {value1}': 'Jaunumi sadaļā {value1}',
    'This Skill is unavailable. Try again.': 'Šī prasme nav pieejama. Mēģiniet vēlreiz.',
    'You can attach up to {value1} files. Remove an attachment to add another.':
      'Varat pievienot ne vairāk kā {value1} failus. Noņemiet pielikumu, lai pievienotu citu.',
    'Add company context': 'Pievienot uzņēmuma kontekstu',
    'Add company context · @': 'Pievienot uzņēmuma kontekstu · @',
    'Choose a Skill': 'Izvēlēties prasmi',
    'Choose a Skill · /': 'Izvēlēties prasmi · /',
    'Open result: {value1}': 'Atvērt rezultātu: {value1}',
    'Loading more library items…': 'Ielādē vēl bibliotēkas vienumus…',
    'Load more': 'Ielādēt vēl',
    'Documents, transcripts, audio and video · Up to 500 MB per file. New files are private. Choose their audience with Share and which processable files become searchable company knowledge.':
      'Dokumenti, atšifrējumi, audio un video · Līdz 500 MB vienam failam. Jaunie faili ir privāti. Izvēlieties to auditoriju, izmantojot funkciju Kopīgot, un to, kuri apstrādājamie faili kļūs par meklējamu uzņēmuma zināšanu avotu.',
    Skills: 'Prasmes',
    'Create in chat': 'Izveidot tērzētavā',
    'Search Skills': 'Meklēt prasmes',
    'Search finds published Skills. Clear the search to browse your drafts too.':
      'Meklēšana atrod publicētās prasmes. Notīriet meklēšanu, lai pārlūkotu arī melnrakstus.',
    'Search coverage is limited while indexing or meaning-based search is unavailable.':
      'Meklēšanas tvērums ir ierobežots, kamēr indeksēšana vai uz nozīmi balstīta meklēšana nav pieejama.',
    'Searching Skills…': 'Meklē prasmes…',
    'No matching published Skills found. Try a different description.':
      'Atbilstošas publicētas prasmes nav atrastas. Izmēģiniet citu aprakstu.',
    'Load more Skills': 'Ielādēt vēl prasmes',
    'View Skill: {value1}': 'Skatīt prasmi: {value1}',
    'Company workspace': 'Uzņēmuma darbvieta',
    'View {value1}': 'Skatīt {value1}',
    'Loading Skills…': 'Ielādē prasmes…',
    'Try again {value1}': 'Mēģināt vēlreiz {value1}',
    'Try again': 'Mēģināt vēlreiz',
    'Nothing yet.': 'Pagaidām nekā nav.',
    'Made from · Used by': 'Izveidots no · Izmanto',
    'Could not load links': 'Neizdevās ielādēt saites',
    'Made from': 'Izveidots no',
    'Used by': 'Izmanto',
    'About this chat {value1}': 'Par šo tērzēšanu {value1}',
    'About this chat': 'Par šo tērzēšanu',
    'Keep the work moving.': 'Turpiniet darbu.',
    'Ask a follow-up with this result in view, or turn a useful approach into a company Skill.':
      'Uzdodiet papildjautājumu, apskatot šo rezultātu, vai pārvērtiet noderīgu pieeju par uzņēmuma prasmi.',
    'Save approach as a Skill': 'Saglabāt pieeju kā prasmi',
    'Preview of': 'Priekšskatījums:',
    'Made with': 'Izveidots ar',
    'Open the draft': 'Atvērt melnrakstu',
    'Open Skill': 'Atvērt prasmi',
    'Use in chat': 'Izmantot tērzētavā',
    'Finish the draft': 'Pabeigt melnrakstu',
    'Refine this Skill': 'Uzlabot šo prasmi',
    'Made with a Skill.': 'Izveidots, izmantojot prasmi.',
    'This workspace could not be loaded just now, so that Skill cannot be opened yet. The result itself is unchanged.':
      'Šo darbvietu pašlaik neizdevās ielādēt, tāpēc šo prasmi vēl nevar atvērt. Pats rezultāts nav mainīts.',
    'That Skill is not available in this workspace, so it cannot be opened or used again. The result itself is unchanged.':
      'Šī prasme šajā darbvietā nav pieejama, tāpēc to nevar atvērt vai izmantot atkārtoti. Pats rezultāts nav mainīts.',
    'Result · {value1} {value2}': 'Rezultāts · {value1} {value2}',
    '{value1} Copy link': '{value1} Kopēt saiti',
    'Result link copied.': 'Rezultāta saite nokopēta.',
    'Could not copy the link. Use your browser address bar.':
      'Neizdevās nokopēt saiti. Izmantojiet pārlūkprogrammas adreses joslu.',
    'No preview is available for this result.': 'Šim rezultātam priekšskatījums nav pieejams.',
    '{value1} rows are retained in this snapshot. Open Table to inspect the values.':
      'Šajā momentuzņēmumā ir saglabātas {value1} rindas. Atveriet tabulu, lai pārbaudītu vērtības.',
    'People can’t edit a Result an agent keeps up to date; the next refresh would replace their edit. Change the agent’s instructions instead.':
      'Lietotāji nevar rediģēt rezultātu, ko aģents uztur aktuālu; nākamajā atsvaidzināšanas reizē viņu labojums tiktu aizstāts. Tā vietā mainiet aģenta norādes.',
    'Linked sources': 'Saistītie avoti',
    'Saved source': 'Saglabātais avots',
    'No source documents are linked to this result. Company knowledge and other references may be cited in the answer.':
      'Šim rezultātam nav saistītu avota dokumentu. Atbildē var tikt citētas uzņēmuma zināšanas un citas atsauces.',
    'Run details': 'Izpildes informācija',
    Created: 'Izveidots',
    ', revised {value1}': ', pārskatīts {value1}',
    Conversation: 'Saruna',
    'Not recorded': 'Nav ierakstīts',
    'Open conversation': 'Atvērt sarunu',
    Run: 'Izpildīt',
    Updates: 'Atjauninājumi',
    'Kept up to date by {value1}': 'Aktuālu uztur {value1}',
    'Version {value1}': 'Versija {value1}',
    'Could not open this request.': 'Neizdevās atvērt šo pieprasījumu.',
    'Approved version published.': 'Apstiprinātā versija ir publicēta.',
    'Request rejected. The item stays unchanged.':
      'Pieprasījums noraidīts. Vienums paliek nemainīts.',
    'Could not save the decision.': 'Neizdevās saglabāt lēmumu.',
    'Proposed company change': 'Ierosinātās izmaiņas uzņēmumā',
    'Opening…': 'Atver…',
    'Approve this version': 'Apstiprināt šo versiju',
    Decline: 'Noraidīt',
    'Review the submitted version below. Changes made since submission will need a new request.':
      'Pārskatiet zemāk iesniegto versiju. Kopš iesniegšanas veiktajām izmaiņām būs nepieciešams jauns pieprasījums.',
    'The version submitted with this request.': 'Versija, kas iesniegta kopā ar šo pieprasījumu.',
    'Version and proposed change': 'Versija un ierosinātās izmaiņas',
    'Could not read the pinned content.': 'Neizdevās nolasīt piesprausto saturu.',
    'Showing a page of {value1} characters.': 'Tiek rādīta lapa ar {value1} rakstzīmēm.',
    'Beginning of the submitted content. Open the full text to review every page.':
      'Iesniegtā satura sākums. Atveriet pilno tekstu, lai pārskatītu visas lapas.',
    'Read full submitted text': 'Lasīt visu iesniegto tekstu',
    'Previous page': 'Iepriekšējā lapa',
    'Next page': 'Nākamā lapa',
    'Made private. Its creator has been told in their Inbox.':
      'Padarīts privāts. Tā izveidotājs par to ir informēts savā iesūtnē.',
    'Made private. Its creator could not be notified.':
      'Padarīts privāts. Tā izveidotāju neizdevās informēt.',
    'Make this {value1} private?': 'Padarīt šo {value1} privātu?',
    'Only the person who created it will see it. Everyone else loses access right away, and its creator gets an Inbox update if they are still a company member. If they have left, nobody in the company will be able to access this item.':
      'To redzēs tikai persona, kas to izveidoja. Visi pārējie tūlīt zaudēs piekļuvi, un tā izveidotājs saņems iesūtnes atjauninājumu, ja joprojām ir uzņēmuma dalībnieks. Ja viņš ir aizgājis, neviens uzņēmumā nevarēs piekļūt šim vienumam.',
    'Sent for review. The current audience stays unchanged until approval.':
      'Nosūtīts pārskatīšanai. Pašreizējā auditorija paliks nemainīga līdz apstiprināšanai.',
    'Could not update sharing.': 'Neizdevās atjaunināt kopīgošanu.',
    'They can follow new answers live and fork it to continue with their own connections. Only you write here. You can make it private again at any time.':
      'Viņi var sekot jaunajām atbildēm reāllaikā un izveidot no tā atzaru, lai turpinātu ar saviem savienojumiem. Šeit rakstāt tikai jūs. Jebkurā laikā varat atkal iestatīt to kā privātu.',
    'They see the project, its brief and the work in it they can already open. Nothing in it opens for anyone because of the project; each item keeps its own access.':
      'Viņi redz projektu, tā aprakstu un tajā esošo darbu, ko jau var atvērt. Projekts nevienam neatver piekļuvi tā saturam; katram vienumam tiek saglabātas savas piekļuves tiesības.',
    'Check the content for private information before sharing. Sharing an item does not grant access to its original chat or private connections.':
      'Pirms kopīgošanas pārbaudiet, vai saturs nesatur privātu informāciju. Vienuma kopīgošana nepiešķir piekļuvi tā sākotnējai tērzēšanai vai privātajiem savienojumiem.',
    '{value1} Everyone you share with can read it, including what the assistant or an App in it found in your {value2}. They can’t use your {value3}. Nothing changes for you: the chat keeps working with all your accounts.':
      '{value1} Ikviens, ar ko to kopīgojat, var to izlasīt, tostarp to, ko asistents vai tajā esošā lietotne atrada jūsu {value2}. Viņi nevar izmantot jūsu {value3}. Jums nekas nemainās: tērzēšana turpina darboties ar visiem jūsu kontiem.',
    '{value1} Everyone you share with can read them, but nobody can use {value2} through this chat.':
      '{value1} Ikviens, ar ko tos kopīgojat, var tos izlasīt, taču neviens nevar izmantot {value2}, izmantojot šo tērzēšanu.',
    'This controls access to the working draft. Any published company version stays available until you explicitly unpublish it. To publish a new version, complete its preview and use Save Skill. Run results stay private.':
      'Tas kontrolē piekļuvi darba melnrakstam. Jebkura publicētā uzņēmuma versija paliek pieejama, līdz to nepulicējat. Lai publicētu jaunu versiju, pabeidziet tās priekšskatījumu un izmantojiet “Saglabāt prasmi”. Izpildes rezultāti paliek privāti.',
    'Skill deleted. You can restore it from the Skills archive for 30 days.':
      'Prasme izdzēsta. Varat to 30 dienu laikā atjaunot prasmju arhīvā.',
    'Could not delete this Skill.': 'Neizdevās izdzēst šo prasmi.',
    'More actions': 'Vairāk darbību',
    'Delete “{value1}”? It will disappear from Skills and search, and cannot be used by agents. You can restore it for 30 days. Existing chats and results stay available.':
      'Vai dzēst “{value1}”? Tā pazudīs no prasmēm un meklēšanas rezultātiem, un aģenti to vairs nevarēs izmantot. Varat to atjaunot 30 dienu laikā. Esošās tērzēšanas un rezultāti paliks pieejami.',
    'Deleting…': 'Dzēšana…',
    'Confirm delete': 'Apstiprināt dzēšanu',
    'Delete Skill': 'Dzēst prasmi',
    'Skill restored as an unpublished draft. Its author can review and publish it again.':
      'Prasme atjaunota kā nepublicēts melnraksts. Tās autors var to pārskatīt un publicēt vēlreiz.',
    'Could not restore this Skill.': 'Neizdevās atjaunot šo prasmi.',
    'Archived Skills': 'Arhivētās prasmes',
    'Deleted Skills can be restored for 30 days. Restoring leaves them unpublished.':
      'Izdzēstās prasmes var atjaunot 30 dienu laikā. Pēc atjaunošanas tās paliek nepublicētas.',
    'Restore until {value1}': 'Atjaunot līdz {value1}',
    'Loading…': 'Notiek ielāde…',
    'No archived Skills.': 'Nav arhivētu prasmju.',
    'Load more archived Skills': 'Ielādēt vairāk arhivētu prasmju',
    'Show more of the original': 'Rādīt vairāk sākotnējā satura',
    'Filter result rows': 'Filtrēt rezultātu rindas',
    'Find a product or value…': 'Meklēt produktu vai vērtību…',
    '{value1} of {value2}': '{value1} no {value2}',
    'Result table': 'Rezultātu tabula',
    'No matching rows.': 'Atbilstošu rindu nav.',
    'Showing the first 1,000 matching rows. Download the CSV for every row.':
      'Tiek rādītas pirmās 1 000 atbilstošās rindas. Lejupielādējiet CSV failu, lai skatītu visas rindas.',
    'Agent ·': 'Aģents ·',
    'Only you': 'Tikai jūs',
    'Stopped before it finished.': 'Apturēts, pirms tika pabeigts.',
    'Drafting the project…': 'Projekta melnraksta izveide…',
    'Checking where this chat belongs…': 'Tiek pārbaudīts, kur šī tērzēšana pieder…',
    'Moving the chat…': 'Tērzēšanas pārvietošana…',
    'Taking it out of the project…': 'Tērzēšanas izņemšana no projekta…',
    'Adding it to the project…': 'Tērzēšanas pievienošana projektam…',
    'No matching connections are available right now.':
      'Pašlaik nav pieejamu atbilstošu savienojumu.',
    'Company knowledge suggestion': 'Uzņēmuma zināšanu ieteikums',
    'Company knowledge now lives on pages. Open Knowledge to see them.':
      'Uzņēmuma zināšanas tagad atrodas lapās. Atveriet “Zināšanas”, lai tās skatītu.',
    '{value1} · Open beside this conversation': '{value1} · Atvērt blakus šai sarunai',
    'Name {value1}': 'Nosaukums {value1}',
    'Host {value1}': 'Resursdators {value1}',
    'Port {value1}': 'Ports {value1}',
    'Database {value1}': 'Datu bāze {value1}',
    'Username {value1}': 'Lietotājvārds {value1}',
    'Password {value1}': 'Parole {value1}',
    'Advanced TLS': 'Papildu TLS iestatījumi',
    '{value1} Poneva verifies the server certificate. Add a CA or server DNS name for IP hosts when your certificate requires it.':
      '{value1} Poneva pārbauda servera sertifikātu. Ja sertifikāts to pieprasa, IP resursdatoriem pievienojiet sertificēšanas iestādes sertifikātu vai servera DNS nosaukumu.',
    'CA certificate {value1}': 'Sertificēšanas iestādes sertifikāts {value1}',
    'Certificate server DNS name {value1}': 'Sertifikāta servera DNS nosaukums {value1}',
    '{value1} Your password is encrypted in secure storage. Poneva verifies the connection before saving it.':
      '{value1} Jūsu parole tiek šifrēta drošā krātuvē. Poneva pārbauda savienojumu, pirms to saglabā.',
    'Testing…': 'Notiek pārbaude…',
    'Test connection': 'Pārbaudīt savienojumu',
    'PostgreSQL is connected.': 'PostgreSQL ir savienots.',
    'PostgreSQL was saved safely.': 'PostgreSQL tika droši saglabāts.',
    'Poneva can read and change rows in the selected tables. Apps also follow their approved data scope.':
      'Poneva var lasīt un mainīt rindas atlasītajās tabulās. Lietotnes arī ievēro tām apstiprināto datu tvērumu.',
    'Poneva can read the selected tables. Apps also follow their approved data scope.':
      'Poneva var lasīt atlasītās tabulas. Lietotnes arī ievēro tām apstiprināto datu tvērumu.',
    'Reads are paused until permission is enabled.':
      'Lasīšana ir apturēta, līdz tiek iespējota atļauja.',
    'Retrying…': 'Notiek atkārtots mēģinājums…',
    'Retry permission': 'Atkārtoti mēģināt piešķirt atļauju',
    'Try it in Chat': 'Izmēģināt tērzēšanā',
    Done: 'Gatavs',
    'Disconnect database': 'Atvienot datu bāzi',
    '{value1} TLS verified ·{value2} {value3}': '{value1} TLS pārbaudīts ·{value2} {value3}',
    'Search schemas and tables': 'Meklēt shēmās un tabulās',
    'Search tables': 'Meklēt tabulās',
    '{value1} of {value2} tables selected': 'Atlasītas {value1} no {value2} tabulām',
    'Select matching tables': 'Atlasīt atbilstošās tabulas',
    'Select all tables': 'Atlasīt visas tabulas',
    Clear: 'Notīrīt',
    'Select a whole schema or individual tables. New tables need a fresh selection.':
      'Atlasiet visu shēmu vai atsevišķas tabulas. Jaunām tabulām nepieciešama atkārtota atlase.',
    'No tables match this search.': 'Neviena tabula neatbilst šai meklēšanai.',
    'All tables in {value1}': 'Visas tabulas shēmā {value1}',
    '{value1} / {value2} tables': '{value1} / {value2} tabulas',
    'Read & write available': 'Pieejama lasīšana un rakstīšana',
    'Read only': 'Tikai lasāms',
    Ctrl: 'Ctrl',
    'This suggested knowledge update could not be shown.':
      'Šo ieteikto zināšanu atjauninājumu neizdevās parādīt.',
    'Suggested knowledge update': 'Ieteiktais zināšanu atjauninājums',
    'This suggestion is no longer available to you.': 'Šis ieteikums jums vairs nav pieejams.',
    'We could not check where this suggestion stands.': 'Neizdevās pārbaudīt šī ieteikuma statusu.',
    'Check again': 'Pārbaudīt vēlreiz',
    'Show on page': 'Rādīt lapā',
    'The editor could not be loaded. Poneva may have been updated since you opened this page. Reload to get the latest version; nothing on this page has changed.':
      'Neizdevās ielādēt redaktoru. Iespējams, kopš šīs lapas atvēršanas Poneva ir atjaunināts. Ielādējiet vēlreiz, lai iegūtu jaunāko versiju; šajā lapā nekas nav mainījies.',
    'Reload Poneva': 'Ielādēt Poneva vēlreiz',
    Formatting: 'Formatēšana',
    'Text style': 'Teksta stils',
    Text: 'Teksts',
    Heading: 'Virsraksts',
    Subheading: 'Apakšvirsraksts',
    'Link a page': 'Izveidot saiti uz lapu',
    'A page needs a title.': 'Lapai ir nepieciešams virsraksts.',
    'Nothing has changed yet.': 'Pagaidām nekas nav mainījies.',
    'A page needs some text. To remove a page, archive it instead.':
      'Lapā ir jābūt tekstam. Lai noņemtu lapu, arhivējiet to.',
    'A suggested new page needs some text.': 'Ieteiktajā jaunajā lapā ir jābūt tekstam.',
    'This page is larger than 256 KB. Split it into smaller pages.':
      'Šī lapa ir lielāka par 256 KB. Sadaliet to mazākās lapās.',
    'Say in a few words why this change is right.':
      'Dažos vārdos paskaidrojiet, kāpēc šīs izmaiņas ir pamatotas.',
    'This page changed while you were editing. Your text is still here: copy it, then open the latest version and make your change again.':
      'Šī lapa mainījās, kamēr to rediģējāt. Jūsu teksts joprojām ir šeit: nokopējiet to, pēc tam atveriet jaunāko versiju un veiciet izmaiņas vēlreiz.',
    'Your text is copied.': 'Jūsu teksts ir nokopēts.',
    'Your text could not be copied. Select it in the editor and copy it.':
      'Neizdevās nokopēt jūsu tekstu. Atlasiet to redaktorā un nokopējiet.',
    'The page “{value1}” is created.': 'Lapa “{value1}” ir izveidota.',
    'New page': 'Jauna lapa',
    'Editing {value1}': 'Rediģē: {value1}',
    Editing: 'Rediģēšana',
    'Creating publishes the page under {value1} for everyone':
      'Izveidojot lapu, tā tiks publicēta zem {value1} visiem lietotājiem',
    'Saving publishes the new version for everyone':
      'Saglabājot jauno versiju, tā tiks publicēta visiem lietotājiem',
    'Your changes are sent as a suggestion for a publisher':
      'Jūsu izmaiņas tiek nosūtītas kā ieteikums publicētājam',
    'Create page': 'Izveidot lapu',
    Save: 'Saglabāt',
    'Send suggestion': 'Nosūtīt ieteikumu',
    '{value1} Copy my text': '{value1} Kopēt manu tekstu',
    'Open the latest version': 'Atvērt jaunāko versiju',
    'Page title': 'Lapas virsraksts',
    'Loading the editor…': 'Notiek redaktora ielāde…',
    'New page text': 'Jaunās lapas teksts',
    'Text of {value1}': '{value1} teksts',
    'Write the page. Type [[ to link another page.':
      'Rakstiet lapas tekstu. Ierakstiet [[, lai izveidotu saiti uz citu lapu.',
    'Type [[ to link another page.': 'Ierakstiet [[, lai izveidotu saiti uz citu lapu.',
    'Link to a page': 'Saite uz lapu',
    'What changed, in a few words': 'Kas mainījās — dažos vārdos',
    'Where this comes from, in a few words': 'No kurienes tas nāk — dažos vārdos',
    'Shown in the page history.': 'Tiek rādīts lapas vēsturē.',
    'A publisher sees this next to your change.': 'Publicētājs to redz blakus jūsu izmaiņām.',
    '1 suggestion is open on this page': 'Šajā lapā ir 1 atvērts ieteikums',
    '{value1} suggestions are open on this page': 'Šajā lapā ir atvērti {value1} ieteikumi',
    'They stay open while you edit. After you save, they show against your new text; one whose words you changed is marked outdated.':
      'Tie paliek atvērti, kamēr rediģējat. Pēc saglabāšanas tie tiks rādīti kopā ar jūsu jauno tekstu; ieteikums, kura vārdus mainījāt, tiks atzīmēts kā novecojis.',
    'Type [[ to link another page. Links keep working when a page is renamed or moved.':
      'Ierakstiet [[, lai izveidotu saiti uz citu lapu. Saites turpina darboties arī tad, ja lapa tiek pārdēvēta vai pārvietota.',
    'Loading the history…': 'Notiek vēstures ielāde…',
    'This page has no saved text yet.': 'Šai lapai vēl nav saglabāta teksta.',
    'Say in a few words why this revision should come back.':
      'Dažos vārdos paskaidrojiet, kāpēc šī redakcija būtu jāatjauno.',
    'Revision {value1} is suggested for a publisher to accept.':
      'Redakcija {value1} tiek ieteikta publicētājam apstiprināšanai.',
    'The page already reads like this revision.': 'Lapas teksts jau atbilst šai redakcijai.',
    'Revision {value1} is restored as revision {value2}.':
      'Redakcija {value1} ir atjaunota kā redakcija {value2}.',
    'Revision history': 'Redakciju vēsture',
    Revisions: 'Redakcijas',
    'Every saved revision is kept.': 'Tiek saglabāta katra redakcija.',
    'Revision {value1} {value2}': 'Redakcija {value1} {value2}',
    'Revision {value1} compared with revision {value2}':
      'Redakcijas {value1} salīdzinājums ar redakciju {value2}',
    'Revision {value1}, the first text of this page':
      'Redakcija {value1}, šīs lapas pirmais teksts',
    'Green was added, struck through was removed.':
      'Ar zaļu krāsu ir atzīmēts pievienotais, pārsvītrotais — noņemtais.',
    '{value1} Export Markdown': '{value1} Eksportēt Markdown',
    'Restore this revision': 'Atjaunot šo redakciju',
    'Suggest restoring it': 'Ieteikt to atjaunot',
    'Why should this revision come back?': 'Kāpēc šī redakcija būtu jāatjauno?',
    'Loading this revision…': 'Notiek šīs redakcijas ielāde…',
    'Only the title changed, from “{value1}” to “{value2}”.':
      'Mainījās tikai virsraksts — no “{value1}” uz “{value2}”.',
    'The text did not change in this revision.': 'Šajā redakcijā teksts nemainījās.',
    'Changes in revision {value1}': 'Izmaiņas redakcijā {value1}',
    'Loading page…': 'Notiek lapas ielāde…',
    'Loading suggestion…': 'Notiek ieteikuma ielāde…',
    'This suggestion is not available.': 'Šis ieteikums nav pieejams.',
    'It may have been decided, or it is not one you can see.':
      'Iespējams, lēmums par to jau ir pieņemts vai arī jūs to nevarat skatīt.',
    'Open Knowledge': 'Atvērt Knowledge',
    'Opening the suggestion…': 'Notiek ieteikuma atvēršana…',
    'Choose where the page goes.': 'Izvēlieties, kur lapa tiks ievietota.',
    'Say in a few words why.': 'Dažos vārdos paskaidrojiet, kāpēc.',
    'Your suggestion is sent. A publisher decides.':
      'Jūsu ieteikums ir nosūtīts. Lēmumu pieņem publicētājs.',
    'Moved under {value1}.': 'Pārvietots zem {value1}.',
    'Deleted “{value1}”.': 'Izdzēsts “{value1}”.',
    'Archived. Its history is kept.': 'Arhivēts. Tā vēsture tiek saglabāta.',
    'Choose the page it goes under. Links to it keep working.':
      'Izvēlieties lapu, zem kuras to ievietot. Saites uz to turpinās darboties.',
    'Its text, its history and any open suggestions are removed for good, and links to it from other pages stop working. This cannot be undone.':
      'Tās teksts, vēsture un visi atvērtie ieteikumi tiks neatgriezeniski dzēsti, un saites uz to no citām lapām vairs nedarbosies. Šo darbību nevar atsaukt.',
    'An archived page no longer informs answers. Its history is kept, and a publisher can restore it or delete it permanently.':
      'Arhivēta lapa vairs neietekmē atbildes. Tās vēsture tiek saglabāta, un publicētājs var to atjaunot vai neatgriezeniski dzēst.',
    Under: 'Zem',
    Change: 'Mainīt',
    'Move under': 'Pārvietot zem',
    'Search pages': 'Meklēt lapās',
    'Why?': 'Kāpēc?',
    'Delete permanently': 'Neatgriezeniski dzēst',
    'Move page': 'Pārvietot lapu',
    'Archive page': 'Arhivēt lapu',
    'Suggestion {value1}: show its card': 'Ieteikums {value1}: rādīt tā kartīti',
    'Removed:': 'Noņemts:',
    'Added:': 'Pievienots:',
    'New page “{value1}”{value2}': 'Jauna lapa “{value1}”{value2}',
    'No pages match “{value1}”.': 'Neviena lapa neatbilst “{value1}”.',
    'Where this page is': 'Kur atrodas šī lapa',
    'Describe your company': 'Aprakstiet savu uzņēmumu',
    'Empty page': 'Tukša lapa',
    'Describe {value1}': 'Aprakstiet {value1}',
    'This page has no text yet.': 'Šajā lapā vēl nav teksta.',
    'Poneva reads this page before every answer. Start with who you are, what you sell and how you work; details go on the pages under it.':
      'Poneva izlasa šo lapu pirms katras atbildes. Sāciet ar to, kas jūs esat, ko pārdodat un kā strādājat; detalizētāka informācija pievienojama lapās zem tās.',
    'Write it, or ask Poneva in chat to draft it for you.':
      'Uzrakstiet to vai palūdziet Poneva tērzētavā sagatavot melnrakstu jūsu vietā.',
    'Suggest a first version, and a publisher decides whether it becomes the page.':
      'Iesakiet pirmo versiju, un publicētājs izlems, vai tā kļūs par lapu.',
    'Start writing': 'Sākt rakstīt',
    'Suggest a first version': 'Ieteikt pirmo versiju',
    'Accepted. The page is archived.': 'Pieņemts. Lapa ir arhivēta.',
    'Accepted. The page is now revision {value1}.': 'Pieņemts. Lapa tagad ir {value1}. redakcijā.',
    'Accepted.': 'Pieņemts.',
    'Suggestion rejected. The page stays as it is.': 'Ieteikums noraidīts. Lapa paliek nemainīta.',
    'Your suggestion is withdrawn.': 'Jūsu ieteikums ir atsaukts.',
    'Restored. The page informs answers again.': 'Atjaunots. Lapa atkal ietekmē atbildes.',
    'Your suggestion is sent. A publisher decides whether it becomes the page.':
      'Jūsu ieteikums ir nosūtīts. Publicētājs izlems, vai tas kļūs par lapu.',
    'Saved. The page is now revision {value1}.': 'Saglabāts. Lapa tagad ir {value1}. redakcijā.',
    'Nothing changed.': 'Nekas nav mainījies.',
    'This page is not available.': 'Šī lapa nav pieejama.',
    'It may have been deleted, archived or moved out of reach, or you may no longer be in this company.':
      'Iespējams, tā ir dzēsta, arhivēta vai pārvietota uz vietu, kurai jums nav piekļuves, vai arī jūs vairs neesat šajā uzņēmumā.',
    'Page actions': 'Lapas darbības',
    shown: 'redzams',
    hidden: 'paslēpts',
    '{value1} History': '{value1} vēsture',
    '{value1} Ask in chat': '{value1} Jautāt tērzētavā',
    'Suggest edits': 'Ieteikt labojumus',
    'More actions for {value1}': 'Vairāk darbību: {value1}',
    '{value1} Poneva reads this page in every chat':
      '{value1} Poneva izlasa šo lapu katrā tērzētavā',
    'This page is archived. It no longer informs answers; its history is kept. {value1}':
      'Šī lapa ir arhivēta. Tā vairs neietekmē atbildes; tās vēsture tiek saglabāta. {value1}',
    'Restore page': 'Atjaunot lapu',
    'This link points to an earlier revision. You are reading the current text.':
      'Šī saite ved uz agrāku redakciju. Jūs lasāt pašreizējo tekstu.',
    'Show it in History': 'Rādīt vēsturē',
    Pages: 'Lapas',
    'Pages under {value1}': 'Lapas zem {value1}',
    'Linked from': 'Saites no',
    Suggestions: 'Ieteikumi',
    'Suggestions are hidden. You are reading the page as everyone else sees it.':
      'Ieteikumi ir paslēpti. Jūs lasāt lapu tā, kā to redz visi pārējie.',
    'Loading suggestions…': 'Notiek ieteikumu ielāde…',
    'Nothing is waiting for review.': 'Nekas negaida pārskatīšanu.',
    'When someone, Poneva in a chat or a connected agent suggests a change to a page, it shows here and on the page. Nothing changes until a publisher accepts it.':
      'Kad kāds, Poneva tērzētavā vai pievienots aģents ierosina izmaiņas lapā, tās tiek parādītas šeit un pašā lapā. Nekas nemainās, kamēr publicētājs tās nepieņem.',
    '{value1} Review knowledge in chat': '{value1} Pārskatīt zināšanas tērzētavā',
    'Suggestions for review': 'Ieteikumi pārskatīšanai',
    'Suggested changes from chats, meetings, colleagues and connected agents. Nothing changes until a publisher accepts it on the page.':
      'Ieteiktās izmaiņas no tērzētavām, sapulcēm, kolēģiem un pievienotajiem aģentiem. Nekas nemainās, kamēr publicētājs tās nepieņem lapā.',
    'Your suggestions wait here until a publisher decides. The pages stay as they are until then.':
      'Jūsu ieteikumi šeit gaida, līdz lēmumu pieņem publicētājs. Lapas līdz tam paliek nemainītas.',
    'Review page': 'Pārskatīt lapu',
    'Review on page': 'Pārskatīt lapā',
    'Open the meeting': 'Atvērt sapulci',
    'Open the chat': 'Atvērt tērzētavu',
    'Accept and restore': 'Pieņemt un atjaunot',
    Accept: 'Pieņemt',
    Reject: 'Noraidīt',
    'Your suggestion · waiting for a publisher': 'Jūsu ieteikums · gaida publicētāja lēmumu',
    Withdraw: 'Atsaukt',
    'Waiting for a publisher': 'Gaida publicētāja lēmumu',
    'Suggestion {value1}': 'Ieteikums {value1}',
    'Suggestion {value1} from {value2}{value3}': 'Ieteikums {value1} no {value2}{value3}',
    'Read the suggested page': 'Lasīt ieteikto lapu',
    'Outdated: the text it changes was edited after it was suggested. It can be rejected or withdrawn; a new suggestion can be made against the current text.':
      'Novecojis: teksts, ko tas maina, pēc ieteikuma iesniegšanas ir rediģēts. To var noraidīt vai atsaukt; jaunu ieteikumu var iesniegt, balstoties uz pašreizējo tekstu.',
    'Restore this page first to accept this suggestion.':
      'Lai pieņemtu šo ieteikumu, vispirms atjaunojiet šo lapu.',
    'Previous suggestion': 'Iepriekšējais ieteikums',
    'Suggestion {value1} of {value2}': 'Ieteikums {value1} no {value2}',
    'Next suggestion': 'Nākamais ieteikums',
    'Fold the suggestions away': 'Sakļaut ieteikumus',
    'Show the suggestions': 'Rādīt ieteikumus',
    '1 suggestion': '1 ieteikums',
    '{value1} suggestions': '{value1} ieteikumi',
    '{value1} the pages under {value2}': '{value1} lapas sadaļā {value2}',
    px: 'px',
    '{value1} chart of {value2} across {value3}':
      '{value1} diagramma par {value2} griezumā {value3}',
    'We could not build the file.': 'Neizdevās izveidot failu.',
    '{value1} Present': '{value1} prezentācija',
    'Building…': 'Notiek izveide…',
    'Download PowerPoint': 'Lejupielādēt PowerPoint',
    'Slide {value1} of {value2}': 'Slaids {value1} no {value2}',
    Slides: 'Slaidi',
    'Slide {value1}': 'Slaids {value1}',
    'Speaker notes': 'Runātāja piezīmes',
    'Source: {value1}': 'Avots: {value1}',
    'Add a name and a web address.': 'Pievienojiet nosaukumu un tīmekļa adresi.',
    'Enter a valid web address.': 'Ievadiet derīgu tīmekļa adresi.',
    'Use a web address that starts with https://.':
      'Izmantojiet tīmekļa adresi, kas sākas ar https://.',
    'Add a custom connection': 'Pievienot pielāgotu savienojumu',
    'Connect a tool server you trust. Poneva checks the address works and saves only the connection details needed to use it.':
      'Savienojiet uzticamu rīku serveri. Poneva pārbauda, vai adrese darbojas, un saglabā tikai tā lietošanai nepieciešamo savienojuma informāciju.',
    'Web address': 'Tīmekļa adrese',
    'https://tools.example.com': 'https://tools.example.com',
    'Starts with https://, from your provider': 'Sākas ar https://, no jūsu pakalpojumu sniedzēja',
    'Sign-in': 'Pieteikšanās',
    'Advanced sign-in': 'Papildu pieteikšanās',
    'Access key {value1}': 'Piekļuves atslēga {value1}',
    'Request headers': 'Pieprasījuma galvenes',
    'Add header': 'Pievienot galveni',
    'Header {value1} name': 'Galvenes {value1} nosaukums',
    'Header name': 'Galvenes nosaukums',
    'Header {value1} value': 'Galvenes {value1} vērtība',
    'Header value': 'Galvenes vērtība',
    'Remove header': 'Noņemt galveni',
    Advanced: 'Papildu',
    Transport: 'Transports',
    'Auto-detect': 'Noteikt automātiski',
    'Streamable HTTP': 'Straumējams HTTP',
    'Legacy SSE': 'Mantotais SSE',
    "From your provider's app settings. Leave empty unless they gave you these.":
      'Atrodas jūsu pakalpojumu sniedzēja lietotnes iestatījumos. Atstājiet tukšu, ja vien pakalpojumu sniedzējs tos jums nav izsniedzis.',
    "Authorization server issuer": "Autorizācijas servera izdevējs",
    "Enter the authorization server issuer when using a client ID.": "Izmantojot klienta ID, ievadiet autorizācijas servera izdevēju.",
    'Client ID {value1}': 'Klienta ID {value1}',
    'Client secret {value1}': 'Klienta slepenā atslēga {value1}',
    'Connecting…': 'Notiek savienošana…',
    'Test and connect': 'Pārbaudīt un savienot',
    'Add the store, the client ID and the client secret.':
      'Pievienojiet veikalu, klienta ID un klienta slepeno atslēgu.',
    'Connect your Shopify Developer App': 'Savienojiet savu Shopify izstrādātāja lietotni',
    'Poneva can use exactly the access your store gave the app, and nothing more. It talks to Shopify directly and keeps the client secret encrypted.':
      'Poneva var izmantot tieši to piekļuvi, ko jūsu veikals piešķīris lietotnei, un neko vairāk. Tā sazinās tieši ar Shopify un glabā klienta slepeno atslēgu šifrētā veidā.',
    'How to create the app in Shopify': 'Kā izveidot lietotni Shopify',
    'Open{value1} {value2}{value3} with the account that owns the store, and create an app.':
      'Atveriet{value1} {value2}{value3} ar kontu, kuram pieder veikals, un izveidojiet lietotni.',
    'Create a version and select the access scopes Poneva may use, for example read_products and read_orders. Add write_ scopes only for data Poneva may change. Then release the version.':
      'Izveidojiet versiju un atlasiet piekļuves tvērumus, ko Poneva drīkst izmantot, piemēram, read_products un read_orders. Pievienojiet write_ tvērumus tikai tiem datiem, kurus Poneva drīkst mainīt. Pēc tam publicējiet versiju.',
    'For orders and customers, also select protected customer data in the app’s settings. Shopify allows this without review for an app made for your own store.':
      'Pasūtījumiem un klientiem lietotnes iestatījumos atlasiet arī aizsargātos klientu datus. Shopify to atļauj bez pārbaudes lietotnei, kas izveidota jūsu veikalam.',
    'Install the app on your store.': 'Instalējiet lietotni savā veikalā.',
    'Copy the client ID and client secret from the app’s settings.':
      'Nokopējiet klienta ID un klienta slepeno atslēgu no lietotnes iestatījumiem.',
    'To change the access later, release a new version, approve it on the store and use Test connection here.':
      'Lai vēlāk mainītu piekļuvi, publicējiet jaunu versiju, apstipriniet to veikalā un šeit izmantojiet funkciju “Pārbaudīt savienojumu”.',
    Store: 'Veikals',
    'your-store.myshopify.com': 'your-store.myshopify.com',
    'Your store’s .myshopify.com address (Shopify admin → Settings → Domains), or paste the address of your Shopify admin page':
      'Jūsu veikala .myshopify.com adrese (Shopify administrēšana → Settings → Domains) vai ielīmējiet Shopify administrēšanas lapas adresi',
    'Client ID {value1} {value2}': 'Klienta ID {value1} {value2}',
    'Client secret {value1} {value2}': 'Klienta slepenā atslēga {value1} {value2}',
    Person: 'Persona',
    Everyone: 'Visi',
    Connection: 'Savienojums',
    'All connections': 'Visi savienojumi',
    'App {value1}': 'Lietotne {value1}',
    'From {value1}': 'No {value1}',
    'Until {value1}': 'Līdz {value1}',
    Result: 'Rezultāts',
    'All results': 'Visi rezultāti',
    Succeeded: 'Izdevās',
    Denied: 'Noraidīts',
    Failed: 'Neizdevās',
    Unknown: 'Nezināms',
    Filter: 'Filtrs',
    'Loading activity…': 'Notiek aktivitāšu ielāde…',
    'Could not load activity. Try again.': 'Neizdevās ielādēt aktivitātes. Mēģiniet vēlreiz.',
    'Removed connection': 'Savienojums noņemts',
    'App: {value1}': 'Lietotne: {value1}',
    'Older activity': 'Vecākas aktivitātes',
    Download: 'Lejupielādēt',
    CSV: 'CSV',
    'Evidence for {value1}': 'Pierādījumi par {value1}',
    Measure: 'Mērījums',
    'Show rows →': 'Rādīt rindas →',
    'Ask about this number': 'Uzdot jautājumu par šo skaitli',
    'There are no numeric values available to chart. View the table for the original data.':
      'Diagrammai nav pieejamu skaitlisku vērtību. Sākotnējos datus skatiet tabulā.',
    'Chart value': 'Diagrammas vērtība',
    '{value1} of {value2} shown': 'Parādīti {value1} no {value2}',
    '{value1} by {value2}; {value3} rows. View Table for exact values.':
      '{value1} pēc {value2}; {value3} rindas. Precīzas vērtības skatiet tabulā.',
    'Values come directly from the source data. Missing values are not estimates.':
      'Vērtības iegūtas tieši no avota datiem. Trūkstošās vērtības nav aplēses.',
    'Loading library…': 'Notiek bibliotēkas ielāde…',
    'We couldn’t load what happened in this App. Try again in a moment.':
      'Neizdevās ielādēt informāciju par to, kas notika šajā lietotnē. Pēc brīža mēģiniet vēlreiz.',
    'This App could not be opened.': 'Šo lietotni neizdevās atvērt.',
    'Opening App…': 'Notiek lietotnes atvēršana…',
    'Open the saved App to run this function.':
      'Lai palaistu šo funkciju, atveriet saglabāto lietotni.',
    'Save this App before running its function.':
      'Pirms funkcijas palaišanas saglabājiet šo lietotni.',
    'Open saved App': 'Atvērt saglabāto lietotni',
    'Open Apps': 'Atvērt lietotnes',
    'The App could not be opened. Try again.': 'Lietotni neizdevās atvērt. Mēģiniet vēlreiz.',
    Owner: 'Īpašnieks',
    '{value1} · admins': '{value1} · administratori',
    'Owner · always edits': 'Īpašnieks · vienmēr var rediģēt',
    'Admins manage it': 'Administratori to pārvalda',
    Editors: 'Redaktori',
    'A colleague': 'Kolēģis',
    'Can edit drafts and publish versions': 'Var rediģēt melnrakstus un publicēt versijas',
    Remove: 'Noņemt',
    'No editors yet.': 'Pagaidām nav redaktoru.',
    'Admins can always edit company agents.':
      'Administratori vienmēr var rediģēt uzņēmuma aģentus.',
    'Asking for edit access': 'Tiek pieprasīta rediģēšanas piekļuve',
    'Asked {value1} · also in your Inbox': 'Pieprasīts {value1} · arī jūsu iesūtnē',
    Grant: 'Piešķirt',
    Admin: 'Administrators',
    'Make personal': 'Padarīt personīgu',
    'Switch off': 'Izslēgt',
    Archive: 'Arhivēt',
    'Archive this agent': 'Arhivēt šo aģentu',
    'Loading agent…': 'Notiek aģenta ielāde…',
    '{value1} Edit in chat': '{value1} Rediģēt tērzēšanā',
    Agent: 'Aģents',
    'This agent has not been created yet. It can run once its owner creates it.':
      'Šis aģents vēl nav izveidots. To varēs palaist, kad to izveidos tā īpašnieks.',
    'New agent · Draft': 'Jauns aģents · Melnraksts',
    'Untitled agent': 'Aģents bez nosaukuma',
    'Test run': 'Testa izpilde',
    'This draft does not run automatically.': 'Šis melnraksts netiek palaists automātiski.',
    'Describe the agent in the chat. Its draft appears here.':
      'Aprakstiet aģentu tērzēšanā. Tā melnraksts tiks parādīts šeit.',
    '{value1} Test run': '{value1} Testa izpilde',
    'Describe the agent in the chat first.': 'Vispirms aprakstiet aģentu tērzēšanā.',
    'Create and turn on': 'Izveidot un ieslēgt',
    'Connection write setup': 'Savienojuma rakstīšanas iestatīšana',
    'Account for connected changes': 'Konts savienojuma izmaiņām',
    'Choose a connection': 'Izvēlieties savienojumu',
    'No published Skills available. You can add them later.':
      'Nav pieejamu publicētu prasmju. Varat tās pievienot vēlāk.',
    '{value1} · not published. Review the changes. Testing is optional.':
      '{value1} · nav publicēts. Pārskatiet izmaiņas. Testēšana nav obligāta.',
    '{value1} Test draft': '{value1} Testēt melnrakstu',
    'Apply changes…': 'Lietot izmaiņas…',
    'Apply this draft as a new version': 'Lietot šo melnrakstu kā jaunu versiju',
    'This draft cannot be applied.': 'Šo melnrakstu nevar lietot.',
    'What changed?': 'Kas mainījās?',
    'Apply version {value1}': 'Lietot versiju {value1}',
    Create: 'Izveidot',
    'Edit access requested': 'Pieprasīta rediģēšanas piekļuve',
    '{value1} Request edit access': '{value1} Pieprasīt rediģēšanas piekļuvi',
    '{value1} Copy agent': '{value1} Kopēt aģentu',
    Pause: 'Apturēt',
    'Open agent: {value1}': 'Atvērt aģentu: {value1}',
    '· you can edit': '· varat rediģēt',
    '{value1} is switched off.': '{value1} ir izslēgts.',
    '{value1} is archived.': '{value1} ir arhivēts.',
    'Loading agents…': 'Notiek aģentu ielāde…',
    Agents: 'Aģenti',
    'Agents do work for you on a schedule or when you ask. They follow your company’s Skills.':
      'Aģenti paveic darbu jūsu vietā pēc grafika vai tad, kad tos lūdzat. Tie izmanto jūsu uzņēmuma prasmes.',
    'No agent matches. Try a Skill name or what the agent should do.':
      'Nav atbilstošu aģentu. Izmēģiniet prasmes nosaukumu vai aprakstiet, kas aģentam jādara.',
    'Nothing of your own yet': 'Pagaidām nekā sava',
    'Tell Chat what an agent should do, or copy one of the company’s agents below.{value1}':
      'Pastāstiet Chat, kas aģentam jādara, vai nokopējiet kādu no tālāk norādītajiem uzņēmuma aģentiem.{value1}',
    'Your agents': 'Jūsu aģenti',
    'Run on demand': 'Izpildīt pēc pieprasījuma',
    'Run is always available. A schedule is optional and lives separately from the agent’s instructions.':
      'Izpilde vienmēr ir pieejama. Grafiks nav obligāts un tiek pārvaldīts atsevišķi no aģenta norādēm.',
    'What changed in version {value1}': 'Kas mainījās versijā {value1}',
    'Every publish is a version you can restore.':
      'Katra publicēšana ir versija, kuru varat atjaunot.',
    Authorization: 'Autorizācija',
    '{value1} {value2} · {value3} will see it.': '{value1} {value2} · {value3} to redzēs.',
    '{value1} {value2} you': '{value1} {value2} jūs',
    '· Revised': '· Pārskatīts',
    'This chat used your {value1}.': 'Šajā tērzēšanā tika izmantots jūsu {value1}.',
    'This chat has results from {value1}.': 'Šajā tērzēšanā ir {value1} rezultāti.',
    'db.example.com': 'db.example.com',
    'e.g. Product analytics': 'piem., produktu analītika',
    'Paste access key': 'Ielīmējiet piekļuves atslēgu',
    'Shopify’s Dev Dashboard': 'Shopify’s Dev Dashboard',
    'App reference': 'Lietotnes atsauce',
    'Draft · revision {value1}': 'Melnraksts · redakcija {value1}',
    'its Result': 'tā rezultāts',
    '· its first run makes it': '· tā pirmā izpilde padara to',
    '{value1}’s chat ·': '{value1} tērzēšana ·',
    '{value1} ad {value2} available.': '{value1} un {value2} ir pieejami.',
    '{value1} rows ·': '{value1} rindas ·',
    'It starts private. Sharing it wider shares every refresh, which can carry your private data.':
      'Sākotnēji tas ir privāts. Plašāka kopīgošana kopīgos katru atsvaidzinājumu, kurā var būt jūsu privātie dati.',
    'Enable this schedule when approved': 'Iespējot šo grafiku pēc apstiprināšanas',
    Schedule: 'Grafiks',
    'Kept off until you create the agent from its canvas.':
      'Tas paliek izslēgts, līdz izveidosiet aģentu no tā kanvas.',
    'Will be enabled when you approve.': 'Tas tiks iespējots pēc apstiprināšanas.',
    'Will be saved paused. You can enable it later.':
      'Tas tiks saglabāts apturētā stāvoklī. Vēlāk varēsiet to iespējot.',
    'Only runs when you ask.': 'Darbojas tikai pēc jūsu pieprasījuma.',
    'Draft · approving saves it, and nothing runs. Test it and create it from its canvas.':
      'Melnraksts · apstiprinot tas tiks saglabāts, un nekas nedarbosies. Pārbaudiet to un izveidojiet no tā kanvas.',
    'Draft · nothing is scheduled until you approve. Connected actions require their own approval at run time.':
      'Melnraksts · nekas netiks ieplānots, kamēr to neapstiprināsiet. Savienotajām darbībām izpildes laikā nepieciešams atsevišķs apstiprinājums.',
    Name: 'Nosaukums',
    'Agent name': 'Aģenta nosaukums',
    'Who can use it': 'Kas to var izmantot',
    'Company agent · company resources only': 'Uzņēmuma aģents · tikai uzņēmuma resursi',
    'Personal agent · runs with your access': 'Personīgais aģents · darbojas ar jūsu piekļuvi',
    'Approving saves it as a draft. It does not run automatically.':
      'Apstiprinot tas tiks saglabāts kā melnraksts. Tas nedarbosies automātiski.',
    'Open the agent’s runs': 'Atvērt aģenta izpildes',
    'Run the published version once': 'Vienreiz izpildīt publicēto versiju',
    'Stopping…': 'Aptur…',
    'Stop run': 'Apturēt izpildi',
    'Could not stop this run. Please try again.':
      'Neizdevās apturēt šo izpildi. Lūdzu, mēģiniet vēlreiz.',
    'Run in progress': 'Notiek izpilde',
    'This run is still answering. You can ask follow-ups when it finishes.':
      'Šī izpilde joprojām ģenerē atbildi. Kad tā būs pabeigta, varēsiet uzdot papildu jautājumus.',
    'Open run details': 'Atvērt izpildes informāciju',
    Runs: 'Izpildes',
    'Open the run chat': 'Atvērt izpildes tērzēšanu',
    Watch: 'Skatīties',
    Goal: 'Mērķis',
    'Change the goal': 'Mainīt mērķi',
    'What it does': 'Ko tas dara',
    'What should this agent achieve?': 'Ko šim aģentam vajadzētu sasniegt?',
    'Not set yet.': 'Vēl nav iestatīts.',
    'When it runs': 'Kad tas darbojas',
    'Change when it runs': 'Mainīt darbības laiku',
    'Off means it runs only when someone runs it. Changing when it runs never changes its instructions.':
      'Izslēgts nozīmē, ka tas darbojas tikai tad, kad kāds to palaiž. Darbības laika maiņa nekad nemaina tā norādījumus.',
    Instructions: 'Norādījumi',
    'Change the instructions': 'Mainīt norādījumus',
    'How the agent should approach the work and make decisions.':
      'Kā aģentam jāveic darbs un jāpieņem lēmumi.',
    Boundaries: 'Ierobežojumi',
    'What to do or avoid. Every connected action still follows its approval.':
      'Ko darīt vai no kā izvairīties. Katrai savienotajai darbībai joprojām nepieciešams apstiprinājums.',
    'No instructions of its own. It follows its Skills.':
      'Tam nav savu norādījumu. Tas seko savām prasmēm.',
    'Pin a Skill': 'Piespraust prasmi',
    'Finds the Skills that fit each run, the same way a chat does.':
      'Atrod katrai izpildei piemērotās prasmes tāpat kā tērzēšana.',
    'Skills it always follows': 'Prasmes, kurām tas vienmēr seko',
    'A Skill that is not published': 'Prasme, kas nav publicēta',
    'Always follows · Version {value1}': 'Vienmēr seko · Versija {value1}',
    'Not published': 'Nav publicēts',
    Uses: 'Izmanto',
    'Change in chat': 'Mainīt tērzēšanā',
    'Change in chat: Uses': 'Mainīt tērzēšanā: izmanto',
    'Company knowledge and the tools each run is allowed to use.':
      'Uzņēmuma zināšanas un rīki, kurus atļauts izmantot katrā izpildē.',
    'People see the Result refresh; they change the agent, not the page.':
      'Lietotāji redz Rezultāta atjauninājumu; viņi maina aģentu, nevis lapu.',
    'The first run after it is created makes the Result; later runs add a version to it.':
      'Pirmā izpilde pēc tā izveides izveido Rezultātu; vēlākās izpildes tam pievieno versiju.',
    'Emails whoever the run is for': 'Nosūta e-pastu izpildes adresātam',
    'Email each run': 'Nosūtīt e-pastu par katru izpildi',
    Delivers: 'Nodrošina',
    'Change what it delivers': 'Mainīt nodrošināto rezultātu',
    'Expected result': 'Gaidāmais rezultāts',
    'What a successful run should deliver.': 'Kas jānodrošina veiksmīgai izpildei.',
    'What each run delivers': 'Ko nodrošina katra izpilde',
    'Keeps one Result up to date {value1}': 'Uztur vienu Rezultātu atjauninātu {value1}',
    'Saves a new Result each run': 'Saglabā jaunu Rezultātu katrā izpildē',
    'You can run this company agent as yourself.{value1} {value2}':
      'Šo uzņēmuma aģentu varat palaist savā vārdā.{value1} {value2}',
    'Changes since version': 'Izmaiņas kopš versijas',
    'are not live yet.': 'vēl nav aktīvas.',
    'Review them in Versions': 'Pārskatiet tās sadaļā Versijas',
    Skill: 'Prasme',
    'The agent always uses the Skill’s published version.':
      'Aģents vienmēr izmanto prasmes publicēto versiju.',
    Day: 'Diena',
    Time: 'Laiks',
    'Cron expression': 'Cron izteiksme',
    'Editors and access': 'Redaktori un piekļuve',
    Company: 'Uzņēmums',
    Personal: 'Personīgais',
    'No changes.': 'Izmaiņu nav.',
    'Instructions changes': 'Norādījumu izmaiņas',
    'Loading versions…': 'Notiek versiju ielāde…',
    'What the draft changes': 'Ko maina melnraksts',
    'No published version yet. Try the draft, then publish it.':
      'Vēl nav publicētas versijas. Izmēģiniet melnrakstu un pēc tam publicējiet to.',
    'Published versions': 'Publicētās versijas',
    'Former member': 'Bijušais dalībnieks',
    Live: 'Aktīvs',
    '{value1} for {value2}': '{value1} par {value2}',
    Suggested: 'Ieteiktais',
    'Opening your conversation…': 'Notiek jūsu sarunas atvēršana…',
    'This conversation isn’t available': 'Šī saruna nav pieejama',
    'It may have been deleted, belong to another account, or be temporarily unavailable.':
      'Iespējams, tā ir dzēsta, pieder citam kontam vai īslaicīgi nav pieejama.',
    '{count} more line — shown in the complete revision':
      'Vēl {count} rinda — redzama pilnajā pārskatījumā',
    '{count} more lines — shown in the complete revision':
      'Vēl {count} rindas — redzamas pilnajā pārskatījumā',
    '{count} more line removed': 'Noņemta vēl {count} rinda',
    '{count} more lines removed': 'Noņemtas vēl {count} rindas',
    '{count} unchanged line': '{count} nemainīta rinda',
    '{count} unchanged lines': '{count} nemainītas rindas',
    '{count} more lines not shown, {added} added and {removed} removed. Check them in the complete revision.':
      'Vēl {count} rindas nav parādītas; pievienotas: {added}, noņemtas: {removed}. Skatiet tās pilnajā pārskatījumā.',
    'Saved result': 'Saglabātais rezultāts',
    'Made with a Skill': 'Izveidots, izmantojot prasmi',
    'Preview of {name}': '{name} priekšskatījums',
    'Made with {name}': 'Izveidots, izmantojot {name}',
    'Ad-hoc result': 'Vienreizējs rezultāts',
    'A Skill that is not available in this workspace': 'Prasme, kas šajā darbvietā nav pieejama',
    '{name} · Revision {version}': '{name} · Pārskatījums {version}',
    '{name} · Version {version}': '{name} · Versija {version}',
    'Return to conversation {value1}': 'Atgriezties sarunā {value1}',
    '{value1} Working with {value2}': '{value1} strādā ar {value2}',
    'View context {value1}': 'Skatīt kontekstu {value1}',
    'A way of working, made yours.': 'Darba veids, kas pielāgots jums.',
    'Work that runs itself.': 'Darbs, kas darbojas pats.',
    'One place for one piece of work.': 'Viena vieta vienam darba uzdevumam.',
    'Let’s move your work forward{value1}.': 'Virzīsim jūsu darbu uz priekšu{value1}.',
    'Describe the work. Your Skill takes shape beside the conversation.':
      'Aprakstiet darbu. Jūsu prasme veidojas līdzās sarunai.',
    'Describe what it should do and when. Your agent takes shape beside the conversation. The draft does not run automatically.':
      'Aprakstiet, kas tai jādara un kad. Jūsu aģents veidojas līdzās sarunai. Melnraksts netiek palaists automātiski.',
    'Say what the work is. Poneva drafts the project beside the conversation and brings in what you have already done. Nothing is created until you say so.':
      'Pastāstiet, kas ir jādara. Poneva izveido projekta melnrakstu līdzās sarunai un iekļauj jau paveikto. Nekas netiek izveidots, kamēr jūs to neapstiprināt.',
    'Start with an idea below. Poneva will take it from there.':
      'Sāciet ar ideju tālāk. Poneva parūpēsies par pārējo.',
    Triggers: 'Aktivizētāji',
    'Review the agent and its trigger. Approval applies exactly what is shown.':
      'Pārskatiet aģentu un tā aktivizētāju. Apstiprināšana piemēro tieši to, kas parādīts.',
    '{source} · read {date}': '{source} · lasīts {date}',
    'Evidence is being recorded · read {date}': 'Pierādījumi tiek reģistrēti · lasīts {date}',
    'Evidence expired on {date} under the retention policy':
      'Pierādījumu glabāšanas termiņš saskaņā ar saglabāšanas politiku beidzās {date}',
    'Entered by {person}': 'Ievadīja: {person}',
    'No retained evidence for this value': 'Šai vērtībai nav saglabātu pierādījumu',
    'Covers {shown} of {total} rows': 'Aptver {shown} no {total} rindām',
    'Search rows': 'Meklēt rindās',
    'Clear filters': 'Notīrīt filtrus',
    Sort: 'Kārtot',
    'Sort: {column}': 'Kārtot: {column}',
    '{shown} of {total} rows': '{shown} no {total} rindām',
    More: 'Vairāk',
    Density: 'Blīvums',
    Comfortable: 'Ērts',
    Compact: 'Kompakts',
    Columns: 'Kolonnas',
    'No rows match. Clear the search or filters to see them again.':
      'Neviena rinda neatbilst. Notīriet meklēšanu vai filtrus, lai tās atkal redzētu.',
    'Not available': 'Nav pieejams',
    'All rows': 'Visas rindas',
    'Close row detail': 'Aizvērt rindas detalizēto skatu',
    'Ask about this row': 'Uzdot jautājumu par šo rindu',
    'Add note': 'Pievienot piezīmi',
    Note: 'Piezīme',
    Saved: 'Saglabāts',
    Total: 'Kopā',
    ascending: 'augošā secībā',
    descending: 'dilstošā secībā',
    'Scroll to see all columns': 'Ritiniet, lai redzētu visas kolonnas',
    App: 'Lietotne',
    Artifact: 'Artefakts',
    'New project': 'Jauns projekts',
    'Review request': 'Pārskatīšanas pieprasījums',
    Activity: 'Aktivitāte',
    'Voice preview': 'Balss priekšskatījums',
    Source: 'Avots',
    File: 'Fails',
    Meeting: 'Sapulce',
    'Knowledge page': 'Zināšanu lapa',
    'Could not preview this CSV.': 'Neizdevās priekšskatīt šo CSV.',
    'File content is unavailable.': 'Faila saturs nav pieejams.',
    'You have five open suggestions here. {value1} will see them.':
      'Šeit ir pieci neizskatīti ieteikumi. Tos redzēs {value1}.',
    'We could not send your suggestion. Please try again.':
      'Neizdevās nosūtīt jūsu ieteikumu. Lūdzu, mēģiniet vēlreiz.',
    'The agent': 'Aģents',
    'Selected colleagues': 'Atlasītie kolēģi',
    'The owner': 'Īpašnieks',
    'Forked. This copy is yours and runs with your own connections.':
      'Izveidots atzarojums. Šī kopija pieder jums un darbojas ar jūsu savienojumiem.',
    'This chat is too long to fork.': 'Šī tērzēšana ir pārāk gara, lai izveidotu atzarojumu.',
    'We could not fork this chat. Please try again.':
      'Neizdevās izveidot šīs tērzēšanas atzarojumu. Lūdzu, mēģiniet vēlreiz.',
    'Anyone who forked it keeps their copy: forks stay with the people who made them.':
      'Ikviens, kurš izveidoja atzarojumu, saglabā savu kopiju: atzarojumi paliek pie to veidotājiem.',
    'Nobody has forked this chat.': 'Neviens nav izveidojis šīs tērzēšanas atzarojumu.',
    '1 person forked this chat. Their copy stays theirs.':
      '1 persona izveidoja šīs tērzēšanas atzarojumu. Viņu kopija paliek pie viņiem.',
    '{value1} people forked this chat. Their copies stay theirs.':
      '{value1} personas izveidoja šīs tērzēšanas atzarojumu. Viņu kopijas paliek pie viņiem.',
    'Personal. Nobody else sees it.': 'Personisks. Neviens cits to neredz.',
    'People you pick. They get it in their Inbox.':
      'Jūsu izvēlētie cilvēki. Viņi to saņems savā iesūtnē.',
    'Everyone in the company can follow it and fork it.':
      'Ikviens uzņēmumā var tam sekot un izveidot tā atzarojumu.',
    'a chat you can no longer open': 'tērzēšana, ko vairs nevarat atvērt',
    'shared the Result': 'kopīgoja rezultātu',
    'updated the Result': 'atjaunināja rezultātu',
    'published the Skill': 'publicēja prasmi',
    'approved the fact': 'apstiprināja faktu',
    'added the fact': 'pievienoja faktu',
    'added the meeting': 'pievienoja sapulci',
    'published the page': 'publicēja lapu',
    'updated the page': 'atjaunināja lapu',
    'shared the chat': 'kopīgoja tērzēšanu',
    'published a version of': 'publicēja versiju no',
    ran: 'palaida',
    Knowledge: 'Zināšanas',
    Meetings: 'Sapulces',
    Chat: 'Tērzēšana',
    Use: 'Izmantot',
    Open: 'Atvērt',
    You: 'Jūs',
    Someone: 'Kāds',
    'published version {version} of': 'publicēja versiju {version} no',
    'thing needs': 'vienumam nepieciešams',
    'things need': 'vienumiem nepieciešams',
    'Published Skill': 'Publicēta prasme',
    'Included with Skill': 'Iekļauts prasmē',
    'Already attached': 'Jau pievienots',
    'Also available in company knowledge': 'Pieejams arī uzņēmuma zināšanās',
    'Company file': 'Uzņēmuma fails',
    'Account identity unavailable': 'Konta identitāte nav pieejama',
    'Access expired or was revoked. Reconnect to continue.':
      'Piekļuve ir beigusies vai atsaukta. Lai turpinātu, izveidojiet savienojumu atkārtoti.',
    'Account authorized · tools unavailable': 'Konts autorizēts · rīki nav pieejami',
    'Not available in this workspace yet.': 'Šajā darbvietā vēl nav pieejams.',
    'Everyone in the company': 'Ikviens uzņēmumā',
    'Audience: only you.': 'Mērķauditorija: tikai jūs.',
    'Audience: everyone in the company.': 'Mērķauditorija: ikviens uzņēmumā.',
    'tool is': 'rīks ir',
    'tools are': 'rīki ir',
    'account is': 'konts ir',
    'accounts are': 'konti ir',
    'We could not upload this file.': 'Neizdevās augšupielādēt šo failu.',
    'file was': 'fails tika',
    'files were': 'faili tika',
    'Your company': 'Jūsu uzņēmums',
    'Create an agent': 'Izveidot aģentu',
    'Give recurring work a helping hand': 'Atvieglot atkārtotu darbu',
    'Create a Skill': 'Izveidot prasmi',
    'Save a reusable way of working': 'Saglabāt atkārtoti izmantojamu darba veidu',
    'Take meeting notes': 'Veikt sapulces piezīmes',
    'Capture decisions and next steps': 'Fiksēt lēmumus un nākamās darbības',
    'Work with a file': 'Strādāt ar failu',
    'Start from a document or image': 'Sākt ar dokumentu vai attēlu',
    'Browse agents': 'Pārlūkot aģentus',
    'Open your agents and company agents': 'Atvērt savus un uzņēmuma aģentus',
    'Review results': 'Pārskatīt rezultātus',
    'Return to work saved in your Library': 'Atgriezties pie bibliotēkā saglabātā darba',
    'For review': 'Pārskatīšanai',
    'An agent': 'Aģents',
    Assistant: 'Asistents',
    'Kept up to date by {value1}{value2}': 'Aktualizē {value1}{value2}',
    ', {value1}': ', {value1}',
    'Version {value1}{value2}{value3}': 'Versija {value1}{value2}{value3}',
    'Refreshed by its agent': 'To aktualizē tā aģents',
    'Saved from a chat': 'Saglabāts no tērzēšanas',
    'Saved from {value1}': 'Saglabāts no lietotnes {value1}',
    Edited: 'Rediģēts',
    'private account': 'privāts konts',
    '{value1} ({value2})': '{value1} ({value2})',
    '{value1}’s {value2}': '{value1} {value2}',
    'Made private. The person who added it and the owner of its recording have been told in their Inbox.':
      'Padarīts privāts. Persona, kas to pievienoja, un tā ieraksta īpašnieks par to ir informēti savā iesūtnē.',
    'Made private. The person who added it has been told in their Inbox.':
      'Padarīts privāts. Persona, kas to pievienoja, par to ir informēta savā iesūtnē.',
    'Made private. The owner of its recording has been told in their Inbox.':
      'Padarīts privāts. Tā ieraksta īpašnieks par to ir informēts savā iesūtnē.',
    'Selected passage': 'Atlasītais fragments',
    '{value1} {value2}': '{value1} {value2}',
    'Upload a file': 'Augšupielādēt failu',
    'Help me create a useful report from our company knowledge and available sources.':
      'Palīdziet man izveidot noderīgu pārskatu, izmantojot mūsu uzņēmuma zināšanas un pieejamos avotus.',
    'This saved work couldn’t be opened. Open it again to retry.':
      'Šo saglabāto darbu nevarēja atvērt. Atveriet to vēlreiz, lai mēģinātu atkārtoti.',
    '{value1}’s': '{value1}',
    '{value1} chat “{value2}”': '{value1} tērzēšana “{value2}”',
    '{value1}{value2}': '{value1}{value2}',
    'Skill: {value1}{value2}': 'Prasme: {value1}{value2}',
    'Result “{value1}”': 'Rezultāts “{value1}”',
    'Meeting “{value1}”': 'Sapulce “{value1}”',
    'Used in {value1} {value2} this week': 'Šonedēļ izmantots {value1} {value2}',
    '{value1} {value2} · used in {value3} {value4}':
      '{value1} {value2} · izmantots {value3} {value4}',
    'The draft is not published yet, so no one else follows it.':
      'Melnraksts vēl nav publicēts, tāpēc neviens cits tam neseko.',
    'Use it in a chat for current data, or refine the Skill first.':
      'Izmantojiet to tērzēšanā aktuālu datu iegūšanai vai vispirms uzlabojiet prasmi.',
    'An agent keeps this up to date. Continue the work in chat.':
      'Aģents uztur šo informāciju aktuālu. Turpiniet darbu tērzēšanā.',
    'Edit it here, or continue the work in chat.':
      'Rediģējiet to šeit vai turpiniet darbu tērzēšanā.',
    'Duplicate it to your Library, or continue the work in chat.':
      'Dublējiet to savā bibliotēkā vai turpiniet darbu tērzēšanā.',
    'Download Markdown': 'Lejupielādēt Markdown',
    'Download CSV': 'Lejupielādēt CSV',
    'an agent': 'aģents',
    'Publish a Skill version': 'Publicēt prasmes versiju',
    'Share with {value1}': 'Kopīgot ar {value1}',
    'Update company content': 'Atjaunināt uzņēmuma saturu',
    Approved: 'Apstiprināts',
    Declined: 'Noraidīts',
    Pending: 'Gaida',
    'View decision': 'Skatīt lēmumu',
    'No data': 'Nav datu',
    'No change': 'Izmaiņu nav',
    'Connection created': 'Savienojums izveidots',
    'Sharing changed': 'Kopīgošana mainīta',
    'Person added': 'Persona pievienota',
    'Person removed': 'Persona noņemta',
    'Access changed': 'Piekļuve mainīta',
    'Access turned off': 'Piekļuve izslēgta',
    'Connection removed': 'Savienojums noņemts',
    'Query time limit changed': 'Mainīts vaicājuma laika ierobežojums',
    '{count} row': '{count} rinda',
    '{count} rows': '{count} rindas',
    'This source is no longer available. Company knowledge now lives in Knowledge pages, and files stay in the Library.':
      'Šis avots vairs nav pieejams. Uzņēmuma zināšanas tagad atrodas zināšanu lapās, bet faili paliek bibliotēkā.',
    '· {value1} by {value2}': '· {value1} — {value2}',
    '· version {value1}': '· versija {value1}',
    '{message} {count} earlier file was saved and attached.':
      '{message} {count} iepriekšējais fails tika saglabāts un pievienots.',
    '{message} {count} earlier files were saved and attached.':
      '{message} {count} iepriekšējie faili tika saglabāti un pievienoti.',
    '{message} {count} earlier file was saved.':
      '{message} {count} iepriekšējais fails tika saglabāts.',
    '{message} {count} earlier files were saved.':
      '{message} {count} iepriekšējie faili tika saglabāti.',
    'refreshed {time}': 'atjaunināts {time}',
    'a colleague': 'kolēģis',
    'Your chat “{title}”': 'Jūsu tērzēšana “{title}”',
    '{name}’s chat “{title}”': '{name} tērzēšana “{title}”',
    'Kept up to date by {name}{version}': 'Atjaunina {name}{version}',
    'Skill: {name}{version}': 'Prasme: {name}{version}',
    'Result “{title}”': 'Rezultāts “{title}”',
    'Meeting “{title}”': 'Sapulce “{title}”',
    'Used in {count} answer this week': 'Šonedēļ izmantots {count} atbildē',
    'Used in {count} answers this week': 'Šonedēļ izmantots {count} atbildēs',
    '{count} source': '{count} avots',
    '{count} sources': '{count} avoti',
    'used in {count} place': 'izmantots {count} vietā',
    'used in {count} places': 'izmantots {count} vietās',
    '{company} workspace': '{company} darbvieta',
    '{count} page': '{count} lapa',
    '{count} pages': '{count} lapas',
    '{needs} · reviews and approvals': '{needs} · pārskatīšanas un apstiprināšanas',
    '{count} thing needs you': '{count} vienums gaida jūsu rīcību',
    '{count} things need you': '{count} vienumi gaida jūsu rīcību',
    'Included with Skill · {files} · {sources} {icon}':
      'Iekļauts prasmē · {files} · {sources} {icon}',
    '{count} file': '{count} fails',
    '{count} files': '{count} faili',
    Today: 'Šodien',
    'Earlier this week': 'Šīs nedēļas sākumā',
    '{count} slide': '{count} slaids',
    '{count} slides': '{count} slaidi',
    Early: 'Agri',
    'TLS verified': 'TLS pārbaudīts',
    'Made personal and switched off. Switch it on when you are ready.':
      'Padarīts privāts un izslēgts. Ieslēdziet to, kad esat gatavs.',
    'Made personal and switched off. Its owner is told which version is live.':
      'Padarīts privāts un izslēgts. Tā īpašniekam tiek paziņots, kura versija ir aktīva.',
    'Switched off.': 'Izslēgts.',
    'Applied version {revision}.': 'Lietota versija {revision}.',
    'The draft is running in a chat only you can read.':
      'Melnraksts darbojas tērzēšanā, ko varat lasīt tikai jūs.',
    'Publish a version first.': 'Vispirms publicējiet versiju.',
    'Another Agent action is in progress.': 'Notiek cita aģenta darbība.',
    'Knowledge & connections': 'Zināšanas un savienojumi',
    'Pinned Skills': 'Piespraustās prasmes',
    None: 'Nav',
    'A new Result each run': 'Jauns rezultāts katrā izpildē',
    'One Result kept up to date': 'Viens atjaunināts rezultāts',
    Email: 'E-pasts',
    On: 'Ieslēgts',
    Off: 'Izslēgts',
    'Waiting for review': 'Gaida pārskatīšanu',
    Outdated: 'Novecojis',
    Accepted: 'Pieņemts',
    Rejected: 'Noraidīts',
    Withdrawn: 'Atsaukts',
    Replaced: 'Aizstāts',
    'Suggested edit': 'Ieteiktais labojums',
    'Suggested new page': 'Ieteiktā jauna lapa',
    'Suggested move': 'Ieteiktā pārvietošana',
    'Suggested archive': 'Ieteiktā arhivēšana',
    'Checking status…': 'Tiek pārbaudīts statuss…',
    'Status unavailable': 'Statuss nav pieejams',
    'Bulleted list': 'Saraksts ar aizzīmēm',
    'Numbered list': 'Numurēts saraksts',
    'Web link': 'Tīmekļa saite',
    Read: 'Lasīt',
    Write: 'Rakstīt',
    'shared with you': 'kopīgots ar jums',
    'Getting an answer': 'Saņem atbildi',
    '{name} is getting an answer': '{name} saņem atbildi',
    'We could not save. Please try again.': 'Neizdevās saglabāt. Lūdzu, mēģiniet vēlreiz.',
    'The new page could not be created.': 'Neizdevās izveidot jauno lapu.',
    'We could not load this revision.': 'Neizdevās ielādēt šo versiju.',
    'We could not restore this revision. Please try again.':
      'Neizdevās atjaunot šo versiju. Lūdzu, mēģiniet vēlreiz.',
    'We could not export this revision.': 'Neizdevās eksportēt šo versiju.',
    'We could not open this suggestion.': 'Neizdevās atvērt šo ieteikumu.',
    'We could not do that. Please try again.': 'Neizdevās to izdarīt. Lūdzu, mēģiniet vēlreiz.',
    'We could not save your decision. Please try again.':
      'Neizdevās saglabāt jūsu lēmumu. Lūdzu, mēģiniet vēlreiz.',
    'We could not restore this page. Please try again.':
      'Neizdevās atjaunot šo lapu. Lūdzu, mēģiniet vēlreiz.',
    'We could not export this page.': 'Neizdevās eksportēt šo lapu.',
    '{count} missed time merged.': 'Apvienots {count} nokavētais laiks.',
    '{count} missed times merged.': 'Apvienoti {count} nokavētie laiki.',
    'About this project': 'Par šo projektu',
  },
  lt: {
    'We could not load this item.': 'Nepavyko įkelti šio elemento.',
    '{value1} canvas': '{value1} drobė',
    'Loading {value1}…': 'Įkeliama {value1}…',
    '{value1} · Original retained': '{value1} · Originalas išsaugotas',
    '{value1} {value2}{value3} · Added {value4}': '{value1} {value2}{value3} · Pridėta {value4}',
    '{value1} Use in chat': '{value1} Naudoti pokalbyje',
    '{value1} Download': '{value1} Atsisiųsti',
    Table: 'Lentelė',
    Chart: 'Diagrama',
    Original: 'Originalas',
    'Text extracted from the PDF, marked by page. Download the original for its layout and images.':
      'Iš PDF ištrauktas tekstas, pažymėtas pagal puslapius. Atsisiųskite originalą, kad matytumėte jo išdėstymą ir vaizdus.',
    'This preview shows the beginning of the file. Poneva reads the whole file; download the original to see all of it.':
      'Šioje peržiūroje rodoma failo pradžia. Poneva perskaito visą failą; atsisiųskite originalą, kad matytumėte visą jo turinį.',
    'Preview of the first {value1} complete rows. Filtering and charts use only this preview. Download the original for the full file.':
      'Pirmųjų {value1} užbaigtų eilučių peržiūra. Filtravimui ir diagramoms naudojama tik ši peržiūra. Atsisiųskite originalą, kad matytumėte visą failą.',
    'This source link cannot be opened.': 'Šios šaltinio nuorodos nepavyksta atidaryti.',
    'Read-only chat': 'Tik skaitymo pokalbis',
    'Only {value1} writes in this chat. Fork it to continue with your own connections. {value2}':
      'Šiame pokalbyje rašo tik {value1}. Sukurkite jo atšaką, kad galėtumėte tęsti naudodami savo ryšius. {value2}',
    'Suggest a follow-up…': 'Pasiūlyti tęsinį…',
    'Suggest a follow-up': 'Pasiūlyti tęsinį',
    'Sending…': 'Siunčiama…',
    Send: 'Siųsti',
    'We could not dismiss that suggestion. Please try again.':
      'Nepavyko atmesti šio pasiūlymo. Bandykite dar kartą.',
    'Suggested follow-ups': 'Siūlomi tęsiniai',
    '{value1} suggests': '{value1} siūlo',
    Ask: 'Paklausti',
    'Dismiss {value1}’s suggestion': 'Atmesti {value1} pasiūlymą',
    'Suggested by': 'Pasiūlė',
    '· edit it or send it': '· redaguokite arba išsiųskite',
    'Remove the suggestion tag': 'Pašalinti pasiūlymo žymą',
    '{value1} {value2} is getting an answer': '{value1} {value2} gauna atsakymą',
    '{value1} {value2} stopped the answer': '{value1} {value2} sustabdė atsakymą',
    '{value1} Fork from here': '{value1} Sukurti atšaką nuo čia',
    '{value1} From {value2}’s {value3}': '{value1} Iš {value2} {value3}',
    'Only {value1} can use this account': 'Šią paskyrą gali naudoti tik {value1}',
    '{value1} Suggested by {value2}': '{value1} Pasiūlė {value2}',
    'Fork this chat': 'Sukurti šio pokalbio atšaką',
    'Forking…': 'Kuriama atšaka…',
    Fork: 'Atšakoti',
    'Could not make this private.': 'Nepavyko padaryti privataus.',
    'Make this chat private?': 'Padaryti šį pokalbį privatų?',
    Close: 'Uždaryti',
    '{value1} will see “{value2}”. Everyone else loses access right away {value3} .{value4}':
      '{value1} matys „{value2}“. Visi kiti iškart praras prieigą {value3} .{value4}',
    Cancel: 'Atšaukti',
    'Saving…': 'Išsaugoma…',
    'Make private': 'Padaryti privatų',
    'This chat is private again. Forks others made stay theirs.':
      'Šis pokalbis vėl privatus. Kitų sukurtos atšakos lieka jiems.',
    'Who can read this chat: {value1}': 'Kas gali skaityti šį pokalbį: {value1}',
    'Move this chat': 'Perkelti šį pokalbį',
    'Only you write here. Others follow live and fork.':
      'Čia rašote tik jūs. Kiti stebi pokalbį tiesiogiai ir kuria atšakas.',
    'Made private. {value1} has been told in their Inbox.':
      'Pokalbis tapo privatus. {value1} apie tai informuotas skiltyje „Gautieji“.',
    'Chat access': 'Pokalbio prieiga',
    '{value1}’s chat. As an admin you can make it private.':
      '{value1} pokalbis. Kaip administratorius galite padaryti jį privatų.',
    'Only {value1} will see it. {value2} is told.': 'Jį matys tik {value1}. {value2} informuotas.',
    '{value1} {value2} following': '{value1} {value2} stebi',
    'Forked from{value1} {value2} . The history is copied. From here, tools run with your own access.':
      'Atšaka sukurta nuo{value1} {value2} . Istorija nukopijuota. Nuo čia įrankiai veikia naudojant jūsų prieigą.',
    '{value1} made this chat private': '{value1} padarė šį pokalbį privatų',
    'You can no longer open it. Any fork you made stays yours.':
      'Daugiau nebegalite jo atidaryti. Bet kuri jūsų sukurta atšaka lieka jums.',
    'Start a new chat': 'Pradėti naują pokalbį',
    'Back to Recent chats': 'Grįžti į naujausius pokalbius',
    'More chat actions': 'Daugiau pokalbio veiksmų',
    'Close conversation sharing': 'Uždaryti pokalbio bendrinimą',
    'Review the text before saving a private copy to Library. Then choose its audience. Your original conversation and future messages stay private.':
      'Peržiūrėkite tekstą prieš išsaugodami privačią kopiją bibliotekoje. Tada pasirinkite jos auditoriją. Jūsų pradinis pokalbis ir būsimos žinutės lieka privatūs.',
    'Preparing the conversation…': 'Ruošiamas pokalbis…',
    'Refresh preview': 'Atnaujinti peržiūrą',
    'The copy is saved in Library. Use Share to choose who can access it.':
      'Kopija išsaugota bibliotekoje. Naudokite funkciją „Bendrinti“, kad pasirinktumėte, kas gali ją pasiekti.',
    'Save this copy': 'Išsaugoti šią kopiją',
    'That Skill could not be opened.': 'Nepavyko atidaryti šio įgūdžio.',
    '{value1}{value2} · reviews and approvals': '{value1}{value2} · peržiūros ir patvirtinimai',
    'Open Inbox': 'Atidaryti gautuosius',
    'New at {value1} this week': 'Šią savaitę nauja skiltyje „{value1}“',
    'Nothing new this week. Shared work, published Skills and approved knowledge show up here.':
      'Šią savaitę nieko naujo. Čia rodomi bendrinami darbai, paskelbti įgūdžiai ir patvirtintos žinios.',
    'New at {value1}': 'Nauja skiltyje „{value1}“',
    'This Skill is unavailable. Try again.': 'Šis įgūdis nepasiekiamas. Bandykite dar kartą.',
    'You can attach up to {value1} files. Remove an attachment to add another.':
      'Galite pridėti ne daugiau kaip {value1} failų. Pašalinkite priedą, kad pridėtumėte kitą.',
    'Add company context': 'Pridėti įmonės kontekstą',
    'Add company context · @': 'Pridėti įmonės kontekstą · @',
    'Choose a Skill': 'Pasirinkite įgūdį',
    'Choose a Skill · /': 'Pasirinkite įgūdį · /',
    context: 'kontekstas',
    skills: 'įgūdžiai',
    'Choose company context': 'Pasirinkite įmonės kontekstą',
    'Skills for this conversation': 'Šio pokalbio įgūdžiai',
    'Bring context into the conversation': 'Įtraukti kontekstą į pokalbį',
    'Close context picker': 'Uždaryti konteksto pasirinkimą',
    'Filter company context': 'Filtruoti įmonės kontekstą',
    'Find a Skill…': 'Rasti įgūdį…',
    'Find a file…': 'Rasti failą…',
    'Available company context': 'Galimas įmonės kontekstas',
    'No matching published Skills.': 'Atitinkančių paskelbtų įgūdžių nerasta.',
    'No matching files.': 'Atitinkančių failų nerasta.',
    'Searching company work…': 'Ieškoma įmonės darbuose…',
    'Try search again': 'Pabandykite ieškoti dar kartą',
    'Meaning search is temporarily limited. Showing available text matches.':
      'Semantinė paieška laikinai apribota. Rodomi galimi teksto atitikmenys.',
    'Load more matches': 'Įkelti daugiau atitikmenų',
    '{value1} files attached. Remove an attachment to add another. Saved Skill references are included separately.':
      'Pridėta failų: {value1}. Pašalinkite priedą, kad galėtumėte pridėti kitą. Išsaugotos įgūdžių nuorodos įtraukiamos atskirai.',
    'Create a Skill in chat': 'Sukurti įgūdį pokalbyje',
    'Upload a company file': 'Įkelti įmonės failą',
    'Company knowledge is always available to Poneva.': 'Įmonės žinios visada prieinamos Poneva.',
    '{value1} was not connected': '{value1} neprijungtas',
    Dismiss: 'Atmesti',
    'Try connecting again': 'Pabandykite prisijungti dar kartą',
    Waiting: 'Laukiama',
    Connected: 'Prijungta',
    'Needs reconnecting': 'Reikia prisijungti iš naujo',
    Connect: 'Prisijungti',
    '{value1}{value2} The provider’s account permissions still apply.':
      '{value1}{value2} Teikėjo paskyros leidimai vis dar taikomi.',
    'Last error: {value1}': 'Paskutinė klaida: {value1}',
    '{value1} {value2} ready.': '{value1} {value2} paruošta.',
    'Continue with my Meta app': 'Tęsti naudojant mano Meta programėlę',
    Reconnect: 'Prisijungti iš naujo',
    Disconnect: 'Atsijungti',
    'Remove attachment: {value1}': 'Pašalinti priedą: {value1}',
    'Saved in this Skill. Edit the Skill to change its references.':
      'Išsaugota šiame įgūdyje. Redaguokite įgūdį, kad pakeistumėte jo nuorodas.',
    'Remove Skill context': 'Pašalinti įgūdžio kontekstą',
    Refining: 'Tikslinama',
    Previewing: 'Peržiūrima',
    Using: 'Naudojama',
    'Skill revision {value1}': 'Įgūdžio versija {value1}',
    'a new Skill': 'naują įgūdį',
    '{value1} Making a new agent {value2}': '{value1} Kuriamas naujas agentas {value2}',
    'Stop making a new agent in this chat': 'Sustabdyti naujo agento kūrimą šiame pokalbyje',
    'Saved Skill references': 'Išsaugotos įgūdžių nuorodos',
    'Included with Skill · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}':
      'Įtraukta su įgūdžiu · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}',
    'Selected Skill revision is unavailable. Select the Skill again to view its saved references.':
      'Pasirinkta įgūdžio versija nepasiekiama. Pasirinkite įgūdį dar kartą, kad peržiūrėtumėte jo išsaugotas nuorodas.',
    'Conversation attachments': 'Pokalbio priedai',
    'Added for this conversation': 'Pridėta šiam pokalbiui',
    'Selected passage {value1}': 'Pasirinkta ištrauka {value1}',
    'We could not load your workspace.': 'Nepavyko įkelti jūsų darbo srities.',
    'The selected Skill is unavailable. Check its access or choose it again.':
      'Pasirinktas įgūdis nepasiekiamas. Patikrinkite prieigą arba pasirinkite jį dar kartą.',
    'Source saved privately and included in your knowledge search.':
      'Šaltinis išsaugotas privačiai ir įtrauktas į jūsų žinių paiešką.',
    'File saved privately to your library and attached to this message.':
      'Failas privačiai išsaugotas jūsų bibliotekoje ir pridėtas prie šio pranešimo.',
    'File saved privately to your library.': 'Failas privačiai išsaugotas jūsų bibliotekoje.',
    '{value1} {value2} earlier {value3} saved{value4}.':
      '{value1} {value2} anksčiau {value3} išsaugota{value4}.',
    'Extracted text for Poneva to read. Download the original for its layout, charts and images. Spreadsheet formulas show their saved results and are not recalculated.':
      'Išskleistas tekstas, kurį gali perskaityti Poneva. Atsisiųskite originalą, jei reikia jo išdėstymo, diagramų ir vaizdų. Skaičiuoklės formulėse rodomi išsaugoti rezultatai, jos neperskaičiuojamos.',
    Esc: 'Esc',
    'Start something': 'Pradėkite ką nors',
    'Choose a file to work with': 'Pasirinkite failą, su kuriuo norite dirbti',
    'Skills worth adding': 'Verta pridėti įgūdžių',
    'Picked for you': 'Parinkta jums',
    'Reusable work grounded in your company knowledge.':
      'Pakartotinai naudojamas darbas, paremtas jūsų įmonės žiniomis.',
    'Ideas from your company context and recent work. Pick one to start.':
      'Idėjos iš jūsų įmonės konteksto ir naujausio darbo. Pasirinkite vieną, kad pradėtumėte.',
    'Refresh suggested tasks': 'Atnaujinti siūlomas užduotis',
    'Check for new company context.': 'Patikrinti, ar yra naujo įmonės konteksto.',
    'Check for new context. Ideas also refresh daily.':
      'Patikrinkite, ar yra naujo konteksto. Idėjos taip pat atnaujinamos kasdien.',
    Refresh: 'Atnaujinti',
    'Finding useful starting points…': 'Ieškoma naudingų pradžios taškų…',
    'Suggestions aren’t available right now. Try Refresh, or describe the work you want to do.':
      'Pasiūlymai šiuo metu nepasiekiami. Pabandykite atnaujinti arba aprašykite, ką norite atlikti.',
    'Loading the knowledge pages…': 'Įkeliami žinių puslapiai…',
    '{value1} All pages': '{value1} Visi puslapiai',
    'The page is created.': 'Puslapis sukurtas.',
    'Your new page is suggested. A publisher decides whether it is added.':
      'Jūsų naujas puslapis pasiūlytas. Leidėjas nuspręs, ar jį pridėti.',
    'Company knowledge': 'Įmonės žinios',
    'What Poneva knows about your company, page by page. Every change is kept.':
      'Tai, ką Poneva žino apie jūsų įmonę, puslapis po puslapio. Visi pakeitimai išsaugomi.',
    'Loading company knowledge…': 'Įkeliamos įmonės žinios…',
    'Knowledge pages are not enabled in this workspace.':
      'Šioje darbo srityje žinių puslapiai neįjungti.',
    'Ask your Poneva contact to switch them on for your company.':
      'Paprašykite savo Poneva kontaktinio asmens įjungti juos jūsų įmonei.',
    '{value1} Change the agent': '{value1} Pakeisti agentą',
    '{value1} Continue in chat': '{value1} Tęsti pokalbyje',
    Edit: 'Redaguoti',
    '{value1} Edit with chat': '{value1} Redaguoti pokalbyje',
    '{value1} Duplicate to my Library': '{value1} Dubliuoti į mano biblioteką',
    'Duplicated to your Library. Only you can see the copy.':
      'Nukopijuota į jūsų biblioteką. Kopiją matote tik jūs.',
    'Could not duplicate this Result. Try again.':
      'Nepavyko nukopijuoti šio rezultato. Bandykite dar kartą.',
    'Saved version {value1}.': 'Išsaugota {value1} versija.',
    'A newer version was saved. Reload the Result before saving.':
      'Išsaugota naujesnė versija. Prieš išsaugodami iš naujo įkelkite rezultatą.',
    'Could not save this version. Try again.':
      'Nepavyko išsaugoti šios versijos. Bandykite dar kartą.',
    '{value1} saved a newer version. Review it before saving.':
      '{value1} išsaugojo naujesnę versiją. Prieš išsaugodami ją peržiūrėkite.',
    'Hide their version': 'Slėpti jų versiją',
    'Show their version': 'Rodyti jų versiją',
    'Start from their version': 'Pradėti nuo jų versijos',
    Markdown: 'Markdown',
    'Result text': 'Rezultato tekstas',
    Preview: 'Peržiūra',
    'What changed': 'Kas pasikeitė',
    'What changed? (optional)': 'Kas pasikeitė? (nebūtina)',
    'Save version {value1}': 'Išsaugoti {value1} versiją',
    'Open chat': 'Atidaryti pokalbį',
    Current: 'Dabartinė',
    Restore: 'Atkurti',
    'Could not load the history.': 'Nepavyko įkelti istorijos.',
    'Restored version {value1} as version {value2}.':
      'Versija {value1} atkurta kaip {value2} versija.',
    'Someone saved a newer version. Review it before restoring.':
      'Kažkas išsaugojo naujesnę versiją. Prieš atkurdami ją peržiūrėkite.',
    'Could not restore that version.': 'Nepavyko atkurti tos versijos.',
    'Loading history…': 'Įkeliama istorija…',
    'Restoring keeps what is there now as a version too, so nothing is lost.':
      'Atkuriant dabartinė būsena taip pat išsaugoma kaip versija, todėl niekas neprarandama.',
    'This Result was made with your own {value1}.':
      'Šis rezultatas sukurtas naudojant jūsų {value1}.',
    'It also used': 'Taip pat naudota',
    'This Result was made with': 'Šis rezultatas sukurtas naudojant',
    'Colleagues can read what came from them, but can never use them.':
      'Kolegos gali skaityti iš jų gautą informaciją, bet niekada negali jos naudoti.',
    'Your personal agent {value1} keeps it up to date with your own access, so every refresh can carry your private data.':
      'Jūsų asmeninis agentas {value1} atnaujina informaciją naudodamasis jūsų prieiga, todėl kiekvienas atnaujinimas gali apimti jūsų privačius duomenis.',
    'A colleague’s personal agent keeps it up to date with their own access, so every refresh can carry their private data.':
      'Kolegos asmeninis agentas atnaujina informaciją naudodamasis jo prieiga, todėl kiekvienas atnaujinimas gali apimti jo privačius duomenis.',
    'Made private. Only you can see this meeting.':
      'Padaryta privačia. Šį susitikimą matote tik jūs.',
    'Could not make this meeting private.': 'Nepavyko padaryti šio susitikimo privataus.',
    'Meeting · {value1} {value2} · Original retained':
      'Susitikimas · {value1} {value2} · Originalas išsaugotas',
    'The recording could not be opened.': 'Nepavyko atidaryti įrašo.',
    'Ask about this suggestion': 'Klausti apie šį pasiūlymą',
    meeting_processing_failed: 'Nepavyko apdoroti susitikimo',
    'Who can see this': 'Kas gali tai matyti',
    'Everyone at {value1}': 'Visi organizacijoje {value1}',
    'Only me': 'Tik aš',
    'Everyone at {value1} can find it and ask about it.':
      'Visi organizacijoje {value1} gali tai rasti ir apie tai klausti.',
    'Only you can open and search this meeting. You can share it later.':
      'Šį susitikimą atidaryti ir jame ieškoti galite tik jūs. Vėliau galite juo pasidalyti.',
    'Added. Only you can see it. Transcription is running in the background.':
      'Pridėta. Matote tik jūs. Transkribavimas vykdomas fone.',
    'Visible to everyone at {value1}': 'Matoma visiems organizacijoje {value1}',
    'Could not make it private.': 'Nepavyko padaryti to privataus.',
    'Show more meetings': 'Rodyti daugiau susitikimų',
    'Attached to this message': 'Pridėta prie šio pranešimo',
    'Connect securely, choose the tables to share, then decide whether Poneva can read or make changes.':
      'Saugiai prisijunkite, pasirinkite bendrintinas lenteles, tada nuspręskite, ar Poneva gali jas skaityti arba keisti.',
    'Review the tables this connection can access. Select at least one table.':
      'Peržiūrėkite lenteles, kurias gali pasiekti šis ryšys. Pasirinkite bent vieną lentelę.',
    'Select at least one table. Nothing is selected by default.':
      'Pasirinkite bent vieną lentelę. Pagal numatytuosius nustatymus niekas nepasirinkta.',
    'Choose who can use this connection and what Poneva can do.':
      'Pasirinkite, kas gali naudoti šį ryšį ir ką gali atlikti Poneva.',
    'Your chosen access is enabled for the selected tables.':
      'Pasirinkta prieiga įjungta pasirinktoms lentelėms.',
    'Your connection is saved with reading paused until permission is confirmed.':
      'Jūsų ryšys išsaugotas, o skaitymas pristabdytas, kol bus patvirtintas leidimas.',
    'Confirm database disconnect': 'Patvirtinti duomenų bazės atjungimą',
    'Disconnect this database?': 'Atjungti šią duomenų bazę?',
    'Access will stop for everyone using this connection.':
      'Prieiga bus sustabdyta visiems, naudojantiems šį ryšį.',
    'Keep connection': 'Palikti ryšį',
    'What it can reach · {value1}{value2} {value3}':
      'Ką jis gali pasiekti · {value1}{value2} {value3}',
    Back: 'Atgal',
    Continue: 'Tęsti',
    'Uploading…': 'Įkeliama…',
    Library: 'Biblioteka',
    'Source material for your work. Available whenever you need it.':
      'Jūsų darbo šaltinio medžiaga. Prieinama, kai tik jos prireikia.',
    'The work you want to keep, with its sources and conversation attached.':
      'Darbas, kurį norite išsaugoti, su pridėtais šaltiniais ir pokalbiu.',
    Results: 'Rezultatai',
    Files: 'Failai',
    Artifacts: 'Artefaktai',
    'Search library': 'Ieškoti bibliotekoje',
    'Find files by meaning…': 'Rasti failus pagal prasmę…',
    'Find saved work by meaning…': 'Rasti išsaugotą darbą pagal prasmę…',
    'Search coverage is limited while indexing or meaning-based search is unavailable. You can retry or browse recent items.':
      'Kol vykdomas indeksavimas arba nepasiekiama paieška pagal prasmę, paieškos aprėptis yra ribota. Galite bandyti dar kartą arba naršyti naujausius elementus.',
    'No matching work found.': 'Atitinkančio darbo nerasta.',
    'A starting point for your next question.': 'Pradinis taškas kitam jūsų klausimui.',
    'Good work is worth keeping.': 'Geras darbas vertas išsaugojimo.',
    'Try a different description or clear the search to browse.':
      'Pabandykite kitą aprašą arba išvalykite paiešką, kad galėtumėte naršyti.',
    'Upload source material once and use it in conversations and Skills. Your original stays in the library.':
      'Įkelkite šaltinio medžiagą vieną kartą ir naudokite ją pokalbiuose bei įgūdžiuose. Originalas lieka bibliotekoje.',
    'Ask Poneva to save an answer, table or chart. Results stay connected to the conversation and their sources.':
      'Paprašykite Poneva išsaugoti atsakymą, lentelę ar diagramą. Rezultatai lieka susieti su pokalbiu ir jo šaltiniais.',
    'Start in chat {value1}': 'Pradėti pokalbyje {value1}',
    'Could not update sharing.': 'Nepavyko atnaujinti bendrinimo.',
    'They can follow new answers live and fork it to continue with their own connections. Only you write here. You can make it private again at any time.':
      'Jie gali tiesiogiai sekti naujus atsakymus ir sukurti jo kopiją, kad tęstų darbą naudodami savo ryšius. Čia rašote tik jūs. Bet kada galite vėl padaryti jį privatų.',
    'They see the project, its brief and the work in it they can already open. Nothing in it opens for anyone because of the project; each item keeps its own access.':
      'Jie mato projektą, jo aprašą ir jame esantį darbą, kurį jau gali atidaryti. Vien dėl projekto niekas jame netampa prieinama kitiems; kiekvienas elementas išlaiko savo prieigos teises.',
    'Check the content for private information before sharing. Sharing an item does not grant access to its original chat or private connections.':
      'Prieš bendrindami patikrinkite, ar turinyje nėra privačios informacijos. Bendrinant elementą nesuteikiama prieiga prie pradinio pokalbio ar privačių ryšių.',
    '{value1} Everyone you share with can read it, including what the assistant or an App in it found in your {value2}. They can’t use your {value3}. Nothing changes for you: the chat keeps working with all your accounts.':
      '{value1} Visi, su kuriais bendrinate, gali tai skaityti, įskaitant tai, ką asistentas ar jame esanti programėlė rado jūsų {value2}. Jie negali naudoti jūsų {value3}. Jums niekas nesikeičia: pokalbis ir toliau veikia su visomis jūsų paskyromis.',
    '{value1} Everyone you share with can read them, but nobody can use {value2} through this chat.':
      '{value1} Visi, su kuriais bendrinate, gali juos skaityti, bet niekas negali naudoti {value2} per šį pokalbį.',
    'This controls access to the working draft. Any published company version stays available until you explicitly unpublish it. To publish a new version, complete its preview and use Save Skill. Run results stay private.':
      'Tai valdo prieigą prie darbinio juodraščio. Bet kuri paskelbta įmonės versija lieka prieinama, kol aiškiai jos neatsiunpublikuojate. Norėdami paskelbti naują versiją, peržiūrėkite ją ir pasirinkite „Išsaugoti įgūdį“. Paleidimo rezultatai lieka privatūs.',
    'Skill deleted. You can restore it from the Skills archive for 30 days.':
      'Įgūdis ištrintas. 30 dienų galite jį atkurti iš įgūdžių archyvo.',
    'Could not delete this Skill.': 'Nepavyko ištrinti šio įgūdžio.',
    'More actions': 'Daugiau veiksmų',
    'Delete “{value1}”? It will disappear from Skills and search, and cannot be used by agents. You can restore it for 30 days. Existing chats and results stay available.':
      'Ištrinti „{value1}“? Jis dings iš įgūdžių ir paieškos bei negalės būti naudojamas agentų. 30 dienų galėsite jį atkurti. Esami pokalbiai ir rezultatai liks prieinami.',
    'Deleting…': 'Trinama…',
    'Confirm delete': 'Patvirtinti ištrynimą',
    'Delete Skill': 'Ištrinti įgūdį',
    'Skill restored as an unpublished draft. Its author can review and publish it again.':
      'Įgūdis atkurtas kaip nepaskelbtas juodraštis. Jo autorius gali jį peržiūrėti ir vėl paskelbti.',
    'Could not restore this Skill.': 'Nepavyko atkurti šio įgūdžio.',
    'Archived Skills': 'Archyvuoti įgūdžiai',
    'Deleted Skills can be restored for 30 days. Restoring leaves them unpublished.':
      'Ištrintus įgūdžius galima atkurti per 30 dienų. Atkurti jie lieka nepaskelbti.',
    'Restore until {value1}': 'Atkurti iki {value1}',
    'Loading…': 'Įkeliama…',
    'No archived Skills.': 'Archyvuotų įgūdžių nėra.',
    'Load more archived Skills': 'Įkelti daugiau archyvuotų įgūdžių',
    'Show more of the original': 'Rodyti daugiau originalo',
    'Filter result rows': 'Filtruoti rezultatų eilutes',
    'Find a product or value…': 'Rasti produktą arba reikšmę…',
    '{value1} of {value2}': '{value1} iš {value2}',
    'Result table': 'Rezultatų lentelė',
    'No matching rows.': 'Atitinkančių eilučių nėra.',
    'Showing the first 1,000 matching rows. Download the CSV for every row.':
      'Rodomos pirmosios 1 000 atitinkančių eilučių. Atsisiųskite CSV failą, kad matytumėte visas eilutes.',
    'Agent ·': 'Agentas ·',
    'Only you': 'Tik jūs',
    'Stopped before it finished.': 'Sustabdyta nebaigus.',
    'Drafting the project…': 'Kuriamas projekto juodraštis…',
    'Checking where this chat belongs…': 'Tikrinama, kur priklauso šis pokalbis…',
    'Moving the chat…': 'Pokalbis perkeliamas…',
    'Taking it out of the project…': 'Pokalbis pašalinamas iš projekto…',
    'Adding it to the project…': 'Pokalbis pridedamas prie projekto…',
    'No matching connections are available right now.': 'Šiuo metu nėra atitinkančių ryšių.',
    'Company knowledge suggestion': 'Įmonės žinių pasiūlymas',
    'Company knowledge now lives on pages. Open Knowledge to see them.':
      'Įmonės žinios dabar pateikiamos puslapiuose. Atidarykite „Žinios“, kad jas pamatytumėte.',
    '{value1} · Open beside this conversation': '{value1} · Atidaryti šalia šio pokalbio',
    'Name {value1}': 'Pavadinimas {value1}',
    'Host {value1}': 'Pagrindinis kompiuteris {value1}',
    'Port {value1}': 'Prievadas {value1}',
    'Database {value1}': 'Duomenų bazė {value1}',
    'Username {value1}': 'Naudotojo vardas {value1}',
    'Password {value1}': 'Slaptažodis {value1}',
    'Advanced TLS': 'Išplėstiniai TLS nustatymai',
    '{value1} Poneva verifies the server certificate. Add a CA or server DNS name for IP hosts when your certificate requires it.':
      '{value1} Poneva patikrina serverio sertifikatą. Jei to reikalauja jūsų sertifikatas, pridėkite CA arba serverio DNS vardą IP pagrindiniams kompiuteriams.',
    'CA certificate {value1}': 'CA sertifikatas {value1}',
    'Certificate server DNS name {value1}': 'Sertifikato serverio DNS vardas {value1}',
    '{value1} Your password is encrypted in secure storage. Poneva verifies the connection before saving it.':
      '{value1} Jūsų slaptažodis užšifruojamas saugioje saugykloje. Prieš išsaugodama Poneva patikrina ryšį.',
    'Testing…': 'Tikrinama…',
    'Test connection': 'Tikrinti ryšį',
    'PostgreSQL is connected.': 'PostgreSQL prijungta.',
    'PostgreSQL was saved safely.': 'PostgreSQL saugiai išsaugota.',
    'Poneva can read and change rows in the selected tables. Apps also follow their approved data scope.':
      'Poneva gali skaityti ir keisti eilučių duomenis pasirinktose lentelėse. Programėlės taip pat laikosi patvirtintos duomenų aprėpties.',
    'Poneva can read the selected tables. Apps also follow their approved data scope.':
      'Poneva gali skaityti pasirinktas lenteles. Programėlės taip pat laikosi patvirtintos duomenų aprėpties.',
    'Reads are paused until permission is enabled.':
      'Skaitymas pristabdytas, kol bus įjungtas leidimas.',
    'Retrying…': 'Bandoma dar kartą…',
    'Retry permission': 'Bandyti leidimą dar kartą',
    'Try it in Chat': 'Išbandyti pokalbyje',
    Done: 'Atlikta',
    'Disconnect database': 'Atjungti duomenų bazę',
    '{value1} TLS verified ·{value2} {value3}': '{value1} TLS patvirtintas ·{value2} {value3}',
    'Search schemas and tables': 'Ieškoti schemų ir lentelių',
    'Search tables': 'Ieškoti lentelių',
    '{value1} of {value2} tables selected': 'Pasirinkta lentelių: {value1} iš {value2}',
    'Select matching tables': 'Pasirinkti atitinkančias lenteles',
    'Select all tables': 'Pasirinkti visas lenteles',
    Clear: 'Išvalyti',
    'Select a whole schema or individual tables. New tables need a fresh selection.':
      'Pasirinkite visą schemą arba atskiras lenteles. Naujas lenteles reikia pasirinkti iš naujo.',
    'No tables match this search.': 'Šios paieškos neatitinkančių lentelių nėra.',
    'All tables in {value1}': 'Visos schemos {value1} lentelės',
    '{value1} / {value2} tables': '{value1} / {value2} lentelių',
    'Read & write available': 'Galima skaityti ir rašyti',
    'Read only': 'Tik skaitymas',
    Ctrl: 'Ctrl',
    'This suggested knowledge update could not be shown.':
      'Nepavyko parodyti šio siūlomo žinių atnaujinimo.',
    'Suggested knowledge update': 'Siūlomas žinių atnaujinimas',
    'This suggestion is no longer available to you.': 'Šis pasiūlymas jums nebepasiekiamas.',
    'We could not check where this suggestion stands.':
      'Nepavyko patikrinti, kokia šio pasiūlymo būsena.',
    'Check again': 'Patikrinti dar kartą',
    'Show on page': 'Rodyti puslapyje',
    'The editor could not be loaded. Poneva may have been updated since you opened this page. Reload to get the latest version; nothing on this page has changed.':
      'Nepavyko įkelti rengyklės. Nuo tada, kai atidarėte šį puslapį, Poneva galėjo būti atnaujinta. Įkelkite iš naujo, kad gautumėte naujausią versiją; šiame puslapyje niekas nepasikeitė.',
    'Reload Poneva': 'Įkelti Poneva iš naujo',
    Formatting: 'Formatavimas',
    'Text style': 'Teksto stilius',
    Text: 'Tekstas',
    Heading: 'Antraštė',
    Subheading: 'Paantraštė',
    'Link a page': 'Susieti puslapį',
    'A page needs a title.': 'Puslapiui reikia pavadinimo.',
    'Nothing has changed yet.': 'Kol kas niekas nepasikeitė.',
    'A page needs some text. To remove a page, archive it instead.':
      'Puslapyje turi būti teksto. Norėdami pašalinti puslapį, suarchyvuokite jį.',
    'A suggested new page needs some text.': 'Siūlomame naujame puslapyje turi būti teksto.',
    'This page is larger than 256 KB. Split it into smaller pages.':
      'Šis puslapis didesnis nei 256 KB. Padalykite jį į mažesnius puslapius.',
    'Say in a few words why this change is right.':
      'Keliais žodžiais paaiškinkite, kodėl šis pakeitimas tinkamas.',
    'This page changed while you were editing. Your text is still here: copy it, then open the latest version and make your change again.':
      'Redaguojant šis puslapis pasikeitė. Jūsų tekstas vis dar čia: nukopijuokite jį, tada atidarykite naujausią versiją ir atlikite pakeitimą dar kartą.',
    'Your text is copied.': 'Jūsų tekstas nukopijuotas.',
    'Your text could not be copied. Select it in the editor and copy it.':
      'Nepavyko nukopijuoti jūsų teksto. Pažymėkite jį rengyklėje ir nukopijuokite.',
    'The page “{value1}” is created.': 'Puslapis „{value1}“ sukurtas.',
    'New page': 'Naujas puslapis',
    'Editing {value1}': 'Redaguojama „{value1}“',
    Editing: 'Redaguojama',
    'Creating publishes the page under {value1} for everyone':
      'Sukūrus puslapį, jis bus paskelbtas skiltyje „{value1}“ visiems',
    'Saving publishes the new version for everyone':
      'Išsaugojus nauja versija bus paskelbta visiems',
    'Your changes are sent as a suggestion for a publisher':
      'Jūsų pakeitimai išsiunčiami kaip pasiūlymas publikuotojui',
    'Create page': 'Sukurti puslapį',
    Save: 'Išsaugoti',
    'Send suggestion': 'Siųsti pasiūlymą',
    '{value1} Copy my text': '{value1} Kopijuoti mano tekstą',
    'Open the latest version': 'Atidaryti naujausią versiją',
    'Page title': 'Puslapio pavadinimas',
    'Loading the editor…': 'Įkeliama rengyklė…',
    'New page text': 'Naujo puslapio tekstas',
    'Text of {value1}': '„{value1}“ tekstas',
    'Write the page. Type [[ to link another page.':
      'Rašykite puslapį. Įveskite [[, kad susietumėte kitą puslapį.',
    'Type [[ to link another page.': 'Įveskite [[, kad susietumėte kitą puslapį.',
    'Link to a page': 'Nuoroda į puslapį',
    'What changed, in a few words': 'Kas pasikeitė, keliais žodžiais',
    'Where this comes from, in a few words': 'Iš kur tai paimta, keliais žodžiais',
    'Shown in the page history.': 'Rodoma puslapio istorijoje.',
    'A publisher sees this next to your change.': 'Publikuotojas tai matys šalia jūsų pakeitimo.',
    '1 suggestion is open on this page': 'Šiame puslapyje pateiktas 1 nebaigtas pasiūlymas',
    '{value1} suggestions are open on this page':
      'Šiame puslapyje pateikta nebaigtų pasiūlymų: {value1}',
    'They stay open while you edit. After you save, they show against your new text; one whose words you changed is marked outdated.':
      'Jie lieka nebaigti, kol redaguojate. Išsaugojus jie bus rodomi su jūsų nauju tekstu; pasiūlymas, kurio žodžius pakeitėte, bus pažymėtas kaip pasenęs.',
    'Type [[ to link another page. Links keep working when a page is renamed or moved.':
      'Įveskite [[, kad susietumėte kitą puslapį. Nuorodos veikia ir pervadinus ar perkėlus puslapį.',
    'Loading the history…': 'Įkeliama istorija…',
    'This page has no saved text yet.': 'Šiame puslapyje dar nėra išsaugoto teksto.',
    'Say in a few words why this revision should come back.':
      'Keliais žodžiais paaiškinkite, kodėl ši peržiūra turėtų būti grąžinta.',
    'Revision {value1} is suggested for a publisher to accept.':
      'Publikuotojui siūloma priimti peržiūrą {value1}.',
    'The page already reads like this revision.': 'Puslapis jau atrodo taip, kaip ši peržiūra.',
    'Revision {value1} is restored as revision {value2}.':
      'Peržiūra {value1} atkurta kaip peržiūra {value2}.',
    'Revision history': 'Peržiūrų istorija',
    Revisions: 'Peržiūros',
    'Every saved revision is kept.': 'Išsaugomos visos peržiūros.',
    'Revision {value1} {value2}': 'Peržiūra {value1} {value2}',
    'Revision {value1} compared with revision {value2}':
      'Peržiūros {value1} palyginimas su peržiūra {value2}',
    'Revision {value1}, the first text of this page':
      'Peržiūra {value1}, pirmasis šio puslapio tekstas',
    'Green was added, struck through was removed.':
      'Žalia spalva pažymėta tai, kas pridėta, perbraukta – tai, kas pašalinta.',
    '{value1} Export Markdown': '{value1} Eksportuoti Markdown',
    'Restore this revision': 'Atkurti šią peržiūrą',
    'Suggest restoring it': 'Siūlyti ją atkurti',
    'Why should this revision come back?': 'Kodėl ši peržiūra turėtų būti grąžinta?',
    'Loading this revision…': 'Įkeliama ši peržiūra…',
    'Only the title changed, from “{value1}” to “{value2}”.':
      'Pasikeitė tik pavadinimas: iš „{value1}“ į „{value2}“.',
    'The text did not change in this revision.': 'Šioje peržiūroje tekstas nepasikeitė.',
    'Changes in revision {value1}': 'Peržiūros {value1} pakeitimai',
    'Loading page…': 'Įkeliamas puslapis…',
    'Loading suggestion…': 'Įkeliamas pasiūlymas…',
    'This suggestion is not available.': 'Šis pasiūlymas nepasiekiamas.',
    'It may have been decided, or it is not one you can see.':
      'Jis galėjo būti išnagrinėtas arba jūs neturite teisės jo matyti.',
    'Open Knowledge': 'Atverti žinyną',
    'Opening the suggestion…': 'Atidaromas pasiūlymas…',
    'Choose where the page goes.': 'Pasirinkite, kur bus perkeltas puslapis.',
    'Say in a few words why.': 'Keliais žodžiais paaiškinkite, kodėl.',
    'Your suggestion is sent. A publisher decides.':
      'Jūsų pasiūlymas išsiųstas. Sprendimą priima publikuotojas.',
    'Moved under {value1}.': 'Perkelta į „{value1}“.',
    'Deleted “{value1}”.': 'Ištrinta „{value1}“.',
    'Open result: {value1}': 'Atidaryti rezultatą: {value1}',
    'Loading more library items…': 'Įkeliama daugiau bibliotekos elementų…',
    'Load more': 'Įkelti daugiau',
    'Documents, transcripts, audio and video · Up to 500 MB per file. New files are private. Choose their audience with Share and which processable files become searchable company knowledge.':
      'Dokumentai, stenogramos, garso ir vaizdo įrašai · Vienas failas gali būti iki 500 MB. Nauji failai yra privatūs. Pasirinkite jų auditoriją naudodami „Bendrinti“ ir nurodykite, kurie apdorojami failai taps įmonės žinių paieškos šaltiniais.',
    Skills: 'Įgūdžiai',
    'Create in chat': 'Kurti pokalbyje',
    'Search Skills': 'Ieškoti įgūdžių',
    'Search finds published Skills. Clear the search to browse your drafts too.':
      'Paieška randa paskelbtus įgūdžius. Išvalykite paiešką, kad galėtumėte naršyti ir juodraščius.',
    'Search coverage is limited while indexing or meaning-based search is unavailable.':
      'Kol indeksavimas arba paieška pagal prasmę nepasiekiama, paieškos aprėptis yra ribota.',
    'Searching Skills…': 'Ieškoma įgūdžių…',
    'No matching published Skills found. Try a different description.':
      'Atitinkančių paskelbtų įgūdžių nerasta. Pabandykite kitą aprašą.',
    'Load more Skills': 'Įkelti daugiau įgūdžių',
    'View Skill: {value1}': 'Peržiūrėti įgūdį: {value1}',
    'Company workspace': 'Įmonės darbo sritis',
    'View {value1}': 'Peržiūrėti {value1}',
    'Loading Skills…': 'Įkeliami įgūdžiai…',
    'Try again {value1}': 'Bandyti dar kartą {value1}',
    'Try again': 'Bandyti dar kartą',
    'Nothing yet.': 'Kol kas nieko nėra.',
    'Made from · Used by': 'Sukurta iš · Naudoja',
    'Could not load links': 'Nepavyko įkelti nuorodų',
    'Made from': 'Sukurta iš',
    'Used by': 'Naudoja',
    'About this chat {value1}': 'Apie šį pokalbį {value1}',
    'About this chat': 'Apie šį pokalbį',
    'Keep the work moving.': 'Tęskite darbą.',
    'Ask a follow-up with this result in view, or turn a useful approach into a company Skill.':
      'Užduokite papildomą klausimą matydami šį rezultatą arba paverskite naudingą metodą įmonės įgūdžiu.',
    'Save approach as a Skill': 'Išsaugoti metodą kaip įgūdį',
    'Preview of': 'Peržiūra:',
    'Made with': 'Sukurta naudojant',
    'Open the draft': 'Atidaryti juodraštį',
    'Open Skill': 'Atidaryti įgūdį',
    'Use in chat': 'Naudoti pokalbyje',
    'Finish the draft': 'Užbaigti juodraštį',
    'Refine this Skill': 'Patobulinti šį įgūdį',
    'Made with a Skill.': 'Sukurta naudojant įgūdį.',
    'This workspace could not be loaded just now, so that Skill cannot be opened yet. The result itself is unchanged.':
      'Šiuo metu nepavyko įkelti šios darbo srities, todėl įgūdžio dar negalima atidaryti. Pats rezultatas nepasikeitė.',
    'That Skill is not available in this workspace, so it cannot be opened or used again. The result itself is unchanged.':
      'Šis įgūdis šioje darbo srityje nepasiekiamas, todėl jo negalima atidaryti ar vėl naudoti. Pats rezultatas nepasikeitė.',
    'Result · {value1} {value2}': 'Rezultatas · {value1} {value2}',
    '{value1} Copy link': '{value1} Kopijuoti nuorodą',
    'Result link copied.': 'Rezultato nuoroda nukopijuota.',
    'Could not copy the link. Use your browser address bar.':
      'Nepavyko nukopijuoti nuorodos. Naudokite naršyklės adreso juostą.',
    'No preview is available for this result.': 'Šio rezultato peržiūra nepasiekiama.',
    '{value1} rows are retained in this snapshot. Open Table to inspect the values.':
      'Šioje momentinėje kopijoje išsaugota eilučių: {value1}. Atidarykite lentelę, kad peržiūrėtumėte reikšmes.',
    'People can’t edit a Result an agent keeps up to date; the next refresh would replace their edit. Change the agent’s instructions instead.':
      'Žmonės negali redaguoti rezultato, kurį agentas nuolat atnaujina, nes kitas atnaujinimas pakeistų jų redagavimus. Vietoj to pakeiskite agento instrukcijas.',
    'Linked sources': 'Susieti šaltiniai',
    'Saved source': 'Išsaugotas šaltinis',
    'No source documents are linked to this result. Company knowledge and other references may be cited in the answer.':
      'Su šiuo rezultatu nesusieta jokių šaltinio dokumentų. Atsakyme gali būti cituojamos įmonės žinios ir kitos nuorodos.',
    'Run details': 'Vykdymo informacija',
    Created: 'Sukurta',
    ', revised {value1}': ', pakeista {value1}',
    Conversation: 'Pokalbis',
    'Not recorded': 'Neįrašyta',
    'Open conversation': 'Atidaryti pokalbį',
    Run: 'Vykdyti',
    Updates: 'Atnaujinimai',
    'Kept up to date by {value1}': 'Atnaujina {value1}',
    'Version {value1}': 'Versija {value1}',
    'Could not open this request.': 'Nepavyko atidaryti šios užklausos.',
    'Approved version published.': 'Patvirtinta versija paskelbta.',
    'Request rejected. The item stays unchanged.': 'Užklausa atmesta. Elementas nepasikeitė.',
    'Could not save the decision.': 'Nepavyko išsaugoti sprendimo.',
    'Proposed company change': 'Siūlomas įmonės pakeitimas',
    'Opening…': 'Atidaroma…',
    'Approve this version': 'Patvirtinti šią versiją',
    Decline: 'Atmesti',
    'Review the submitted version below. Changes made since submission will need a new request.':
      'Peržiūrėkite toliau pateiktą pateiktą versiją. Po pateikimo atliktiems pakeitimams reikės naujos užklausos.',
    'The version submitted with this request.': 'Su šia užklausa pateikta versija.',
    'Version and proposed change': 'Versija ir siūlomas pakeitimas',
    'Could not read the pinned content.': 'Nepavyko perskaityti prisegto turinio.',
    'Showing a page of {value1} characters.': 'Rodomas puslapis, kuriame yra {value1} simbolių.',
    'Beginning of the submitted content. Open the full text to review every page.':
      'Pateikto turinio pradžia. Atidarykite visą tekstą, kad peržiūrėtumėte kiekvieną puslapį.',
    'Read full submitted text': 'Perskaityti visą pateiktą tekstą',
    'Previous page': 'Ankstesnis puslapis',
    'Next page': 'Kitas puslapis',
    'Made private. Its creator has been told in their Inbox.':
      'Padaryta privačia. Kūrėjui apie tai pranešta gautuosiuose.',
    'Made private. Its creator could not be notified.':
      'Padaryta privačia. Nepavyko apie tai pranešti kūrėjui.',
    'Make this {value1} private?': 'Padaryti šį elementą privačiu: {value1}?',
    'Only the person who created it will see it. Everyone else loses access right away, and its creator gets an Inbox update if they are still a company member. If they have left, nobody in the company will be able to access this item.':
      'Jį matys tik sukūręs asmuo. Visi kiti iškart praras prieigą, o kūrėjas gaus pranešimą gautuosiuose, jei vis dar bus įmonės narys. Jei jis išėjo, niekas įmonėje nebegalės pasiekti šio elemento.',
    'Sent for review. The current audience stays unchanged until approval.':
      'Išsiųsta peržiūrėti. Dabartinė auditorija nesikeis, kol nebus patvirtinta.',
    'Suggestion {value1} of {value2}': 'Pasiūlymas {value1} iš {value2}',
    'Next suggestion': 'Kitas pasiūlymas',
    'Fold the suggestions away': 'Suskleisti pasiūlymus',
    'Show the suggestions': 'Rodyti pasiūlymus',
    '1 suggestion': '1 pasiūlymas',
    '{value1} suggestions': '{value1} pasiūlymų',
    '{value1} the pages under {value2}': '{value1} puslapių skiltyje {value2}',
    px: 'px',
    '{value1} chart of {value2} across {value3}':
      '{value1} diagrama, rodanti {value2} per {value3}',
    'We could not build the file.': 'Nepavyko sukurti failo.',
    '{value1} Present': '{value1} pateikta',
    'Building…': 'Kuriama…',
    'Download PowerPoint': 'Atsisiųsti „PowerPoint“',
    'Slide {value1} of {value2}': 'Skaidrė {value1} iš {value2}',
    Slides: 'Skaidrės',
    'Slide {value1}': 'Skaidrė {value1}',
    'Speaker notes': 'Pranešėjo pastabos',
    'Source: {value1}': 'Šaltinis: {value1}',
    'Add a name and a web address.': 'Įveskite pavadinimą ir interneto adresą.',
    'Enter a valid web address.': 'Įveskite galiojantį interneto adresą.',
    'Use a web address that starts with https://.':
      'Naudokite interneto adresą, prasidedantį https://.',
    'Add a custom connection': 'Pridėti tinkintą ryšį',
    'Connect a tool server you trust. Poneva checks the address works and saves only the connection details needed to use it.':
      'Prisijunkite prie patikimo įrankių serverio. „Poneva“ patikrina, ar adresas veikia, ir išsaugo tik ryšiui naudoti reikalingą informaciją.',
    'Web address': 'Interneto adresas',
    'https://tools.example.com': 'https://tools.example.com',
    'Starts with https://, from your provider': 'Prasideda https://, pateiktas jūsų teikėjo',
    'Sign-in': 'Prisijungimas',
    'Advanced sign-in': 'Išplėstinis prisijungimas',
    'Access key {value1}': 'Prieigos raktas {value1}',
    'Request headers': 'Užklausos antraštės',
    'Add header': 'Pridėti antraštę',
    'Header {value1} name': 'Antraštės {value1} pavadinimas',
    'Header name': 'Antraštės pavadinimas',
    'Header {value1} value': 'Antraštės {value1} reikšmė',
    'Header value': 'Antraštės reikšmė',
    'Remove header': 'Pašalinti antraštę',
    Advanced: 'Išplėstiniai',
    Transport: 'Transportas',
    'Auto-detect': 'Aptikti automatiškai',
    'Streamable HTTP': 'Srautinis HTTP',
    'Legacy SSE': 'Senasis SSE',
    "From your provider's app settings. Leave empty unless they gave you these.":
      'Iš jūsų teikėjo programėlės nustatymų. Palikite tuščią, nebent teikėjas juos pateikė.',
    "Authorization server issuer": "Autorizavimo serverio išdavėjas",
    "Enter the authorization server issuer when using a client ID.": "Naudodami kliento ID, įveskite autorizavimo serverio išdavėją.",
    'Client ID {value1}': 'Kliento ID {value1}',
    'Client secret {value1}': 'Kliento paslaptis {value1}',
    'Connecting…': 'Jungiamasi…',
    'Test and connect': 'Išbandyti ir prisijungti',
    'Add the store, the client ID and the client secret.':
      'Įveskite parduotuvę, kliento ID ir kliento paslaptį.',
    'Connect your Shopify Developer App': 'Prijunkite savo „Shopify“ kūrėjo programėlę',
    'Poneva can use exactly the access your store gave the app, and nothing more. It talks to Shopify directly and keeps the client secret encrypted.':
      '„Poneva“ gali naudoti tiksliai tą prieigą, kurią jūsų parduotuvė suteikė programėlei, ir nieko daugiau. Ji tiesiogiai susisiekia su „Shopify“ ir saugo kliento paslaptį užšifruotą.',
    'How to create the app in Shopify': 'Kaip sukurti programėlę „Shopify“',
    'Open{value1} {value2}{value3} with the account that owns the store, and create an app.':
      'Atidarykite{value1} {value2}{value3} naudodami parduotuvės savininko paskyrą ir sukurkite programėlę.',
    'Create a version and select the access scopes Poneva may use, for example read_products and read_orders. Add write_ scopes only for data Poneva may change. Then release the version.':
      'Sukurkite versiją ir pasirinkite prieigos sritis, kurias gali naudoti „Poneva“, pavyzdžiui, read_products ir read_orders. write_ sritis pridėkite tik tiems duomenims, kuriuos „Poneva“ gali keisti. Tada išleiskite versiją.',
    'For orders and customers, also select protected customer data in the app’s settings. Shopify allows this without review for an app made for your own store.':
      'Užsakymams ir klientams programėlės nustatymuose taip pat pasirinkite protected customer data. „Shopify“ leidžia tai padaryti be peržiūros, jei programėlė sukurta jūsų parduotuvei.',
    'Install the app on your store.': 'Įdiekite programėlę savo parduotuvėje.',
    'Copy the client ID and client secret from the app’s settings.':
      'Nukopijuokite kliento ID ir kliento paslaptį iš programėlės nustatymų.',
    'To change the access later, release a new version, approve it on the store and use Test connection here.':
      'Norėdami vėliau pakeisti prieigą, išleiskite naują versiją, patvirtinkite ją parduotuvėje ir čia pasirinkite „Išbandyti ryšį“.',
    Store: 'Parduotuvė',
    'your-store.myshopify.com': 'your-store.myshopify.com',
    'Your store’s .myshopify.com address (Shopify admin → Settings → Domains), or paste the address of your Shopify admin page':
      'Jūsų parduotuvės .myshopify.com adresas („Shopify“ administravimo skydas → Settings → Domains) arba įklijuokite „Shopify“ administravimo puslapio adresą',
    'Client ID {value1} {value2}': 'Kliento ID {value1} {value2}',
    'Client secret {value1} {value2}': 'Kliento paslaptis {value1} {value2}',
    Person: 'Asmuo',
    Everyone: 'Visi',
    Connection: 'Ryšys',
    'All connections': 'Visi ryšiai',
    'App {value1}': 'Programėlė {value1}',
    'From {value1}': 'Nuo {value1}',
    'Until {value1}': 'Iki {value1}',
    Result: 'Rezultatas',
    'All results': 'Visi rezultatai',
    Succeeded: 'Pavyko',
    Denied: 'Atmesta',
    Failed: 'Nepavyko',
    Unknown: 'Nežinoma',
    Filter: 'Filtruoti',
    'Loading activity…': 'Įkeliama veikla…',
    'Could not load activity. Try again.': 'Nepavyko įkelti veiklos. Bandykite dar kartą.',
    'Removed connection': 'Ryšys pašalintas',
    'App: {value1}': 'Programėlė: {value1}',
    'Older activity': 'Senesnė veikla',
    'Archived. Its history is kept.': 'Suarchyvuota. Jos istorija išsaugota.',
    'Choose the page it goes under. Links to it keep working.':
      'Pasirinkite puslapį, po kuriuo ji bus. Nuorodos į ją ir toliau veiks.',
    'Its text, its history and any open suggestions are removed for good, and links to it from other pages stop working. This cannot be undone.':
      'Jos tekstas, istorija ir visi neįvykdyti pasiūlymai bus negrįžtamai pašalinti, o nuorodos į ją iš kitų puslapių nustos veikti. Šio veiksmo atšaukti negalima.',
    'An archived page no longer informs answers. Its history is kept, and a publisher can restore it or delete it permanently.':
      'Suarchyvuotas puslapis nebenaudojamas atsakymams. Jo istorija išsaugota, o leidėjas gali jį atkurti arba visam laikui ištrinti.',
    Under: 'Po',
    Change: 'Keisti',
    'Move under': 'Perkelti po',
    'Search pages': 'Ieškoti puslapių',
    'Why?': 'Kodėl?',
    'Delete permanently': 'Ištrinti visam laikui',
    'Move page': 'Perkelti puslapį',
    'Archive page': 'Archyvuoti puslapį',
    'Suggestion {value1}: show its card': 'Pasiūlymas {value1}: rodyti jo kortelę',
    'Removed:': 'Pašalinta:',
    'Added:': 'Pridėta:',
    'New page “{value1}”{value2}': 'Naujas puslapis „{value1}“{value2}',
    'No pages match “{value1}”.': 'Nerasta puslapių pagal „{value1}“.',
    'Where this page is': 'Kur yra šis puslapis',
    'Describe your company': 'Aprašykite savo įmonę',
    'Empty page': 'Tuščias puslapis',
    'Describe {value1}': 'Aprašykite {value1}',
    'This page has no text yet.': 'Šiame puslapyje dar nėra teksto.',
    'Poneva reads this page before every answer. Start with who you are, what you sell and how you work; details go on the pages under it.':
      'Poneva perskaito šį puslapį prieš kiekvieną atsakymą. Pradėkite nuo to, kas esate, ką parduodate ir kaip dirbate; išsamią informaciją pateikite po juo esančiuose puslapiuose.',
    'Write it, or ask Poneva in chat to draft it for you.':
      'Parašykite patys arba paprašykite Poneva pokalbyje parengti juodraštį.',
    'Suggest a first version, and a publisher decides whether it becomes the page.':
      'Pasiūlykite pirmąją versiją, o leidėjas nuspręs, ar ji taps puslapiu.',
    'Start writing': 'Pradėti rašyti',
    'Suggest a first version': 'Pasiūlyti pirmąją versiją',
    'Accepted. The page is archived.': 'Priimta. Puslapis suarchyvuotas.',
    'Accepted. The page is now revision {value1}.':
      'Priimta. Dabar puslapis yra {value1} redakcijos.',
    'Accepted.': 'Priimta.',
    'Suggestion rejected. The page stays as it is.':
      'Pasiūlymas atmestas. Puslapis lieka nepakitęs.',
    'Your suggestion is withdrawn.': 'Jūsų pasiūlymas atšauktas.',
    'Restored. The page informs answers again.': 'Atkurta. Puslapis vėl naudojamas atsakymams.',
    'Your suggestion is sent. A publisher decides whether it becomes the page.':
      'Jūsų pasiūlymas išsiųstas. Leidėjas nuspręs, ar jis taps puslapiu.',
    'Saved. The page is now revision {value1}.':
      'Išsaugota. Dabar puslapis yra {value1} redakcijos.',
    'Nothing changed.': 'Nieko nepakeista.',
    'This page is not available.': 'Šis puslapis nepasiekiamas.',
    'It may have been deleted, archived or moved out of reach, or you may no longer be in this company.':
      'Jis galėjo būti ištrintas, suarchyvuotas, perkeltas į nepasiekiamą vietą arba jūs nebesate šios įmonės narys.',
    'Page actions': 'Puslapio veiksmai',
    shown: 'rodoma',
    hidden: 'paslėpta',
    '{value1} History': '{value1} istorija',
    '{value1} Ask in chat': '{value1} klausti pokalbyje',
    'Suggest edits': 'Siūlyti pakeitimus',
    'More actions for {value1}': 'Daugiau veiksmų su {value1}',
    '{value1} Poneva reads this page in every chat':
      '{value1} Poneva perskaito šį puslapį kiekviename pokalbyje',
    'This page is archived. It no longer informs answers; its history is kept. {value1}':
      'Šis puslapis suarchyvuotas. Jis nebenaudojamas atsakymams, o jo istorija išsaugota. {value1}',
    'Restore page': 'Atkurti puslapį',
    'This link points to an earlier revision. You are reading the current text.':
      'Ši nuoroda veda į ankstesnę redakciją. Skaitote dabartinį tekstą.',
    'Show it in History': 'Rodyti istorijoje',
    Pages: 'Puslapiai',
    'Pages under {value1}': 'Puslapiai po {value1}',
    'Linked from': 'Nuorodos iš',
    Suggestions: 'Pasiūlymai',
    'Suggestions are hidden. You are reading the page as everyone else sees it.':
      'Pasiūlymai paslėpti. Puslapį matote taip, kaip jį mato visi kiti.',
    'Loading suggestions…': 'Įkeliami pasiūlymai…',
    'Nothing is waiting for review.': 'Nieko nelaukia peržiūros.',
    'When someone, Poneva in a chat or a connected agent suggests a change to a page, it shows here and on the page. Nothing changes until a publisher accepts it.':
      'Kai kas nors, Poneva pokalbyje arba prijungtas agentas pasiūlo puslapio pakeitimą, jis rodomas čia ir puslapyje. Nieko nekeičiama, kol leidėjas jo nepriima.',
    '{value1} Review knowledge in chat': '{value1} peržiūrėti žinias pokalbyje',
    'Suggestions for review': 'Peržiūrėtini pasiūlymai',
    'Suggested changes from chats, meetings, colleagues and connected agents. Nothing changes until a publisher accepts it on the page.':
      'Siūlomi pakeitimai iš pokalbių, susitikimų, kolegų ir prijungtų agentų. Nieko nekeičiama, kol leidėjas jų nepriima puslapyje.',
    'Your suggestions wait here until a publisher decides. The pages stay as they are until then.':
      'Jūsų pasiūlymai čia laukia leidėjo sprendimo. Iki tol puslapiai lieka nepakitę.',
    'Review page': 'Peržiūrėti puslapį',
    'Review on page': 'Peržiūrėti puslapyje',
    'Open the meeting': 'Atidaryti susitikimą',
    'Open the chat': 'Atidaryti pokalbį',
    'Accept and restore': 'Priimti ir atkurti',
    Accept: 'Priimti',
    Reject: 'Atmesti',
    'Your suggestion · waiting for a publisher': 'Jūsų pasiūlymas · laukiama leidėjo sprendimo',
    Withdraw: 'Atšaukti',
    'Waiting for a publisher': 'Laukiama leidėjo sprendimo',
    'Suggestion {value1}': 'Pasiūlymas {value1}',
    'Suggestion {value1} from {value2}{value3}': 'Pasiūlymas {value1} nuo {value2}{value3}',
    'Read the suggested page': 'Skaityti siūlomą puslapį',
    'Outdated: the text it changes was edited after it was suggested. It can be rejected or withdrawn; a new suggestion can be made against the current text.':
      'Pasenęs: keičiamas tekstas buvo redaguotas po pasiūlymo pateikimo. Pasiūlymą galima atmesti arba atšaukti; naują pasiūlymą galima pateikti pagal dabartinį tekstą.',
    'Restore this page first to accept this suggestion.':
      'Pirmiausia atkurkite šį puslapį, kad galėtumėte priimti šį pasiūlymą.',
    'Previous suggestion': 'Ankstesnis pasiūlymas',
    Download: 'Atsisiųsti',
    CSV: 'CSV',
    'Evidence for {value1}': 'Pagrindimas: {value1}',
    Measure: 'Metrika',
    'Show rows →': 'Rodyti eilutes →',
    'Ask about this number': 'Paklausti apie šį skaičių',
    'There are no numeric values available to chart. View the table for the original data.':
      'Diagramai nėra skaitinių reikšmių. Peržiūrėkite lentelę, kurioje pateikti pradiniai duomenys.',
    'Chart value': 'Diagramos reikšmė',
    '{value1} of {value2} shown': 'Rodoma {value1} iš {value2}',
    '{value1} by {value2}; {value3} rows. View Table for exact values.':
      '{value1} pagal {value2}; {value3} eilučių. Tikslias reikšmes peržiūrėkite lentelėje.',
    'Values come directly from the source data. Missing values are not estimates.':
      'Reikšmės paimtos tiesiogiai iš šaltinio duomenų. Trūkstamos reikšmės nėra įverčiai.',
    'Loading library…': 'Įkeliama biblioteka…',
    'We couldn’t load what happened in this App. Try again in a moment.':
      'Nepavyko įkelti, kas įvyko šioje programėlėje. Po akimirkos bandykite dar kartą.',
    'This App could not be opened.': 'Šios programėlės nepavyko atidaryti.',
    'Opening App…': 'Atidaroma programėlė…',
    'Open the saved App to run this function.':
      'Norėdami paleisti šią funkciją, atidarykite išsaugotą programėlę.',
    'Save this App before running its function.':
      'Prieš paleisdami jos funkciją išsaugokite šią programėlę.',
    'Open saved App': 'Atidaryti išsaugotą programėlę',
    'Open Apps': 'Atidaryti programėles',
    'The App could not be opened. Try again.':
      'Programėlės nepavyko atidaryti. Bandykite dar kartą.',
    Owner: 'Savininkas',
    '{value1} · admins': '{value1} · administratoriai',
    'Owner · always edits': 'Savininkas · visada gali redaguoti',
    'Admins manage it': 'Administratoriai ją tvarko',
    Editors: 'Redaktoriai',
    'A colleague': 'Kolega',
    'Can edit drafts and publish versions': 'Gali redaguoti juodraščius ir skelbti versijas',
    Remove: 'Pašalinti',
    'No editors yet.': 'Redaktorių dar nėra.',
    'Admins can always edit company agents.':
      'Administratoriai visada gali redaguoti įmonės agentus.',
    'Asking for edit access': 'Prašoma redagavimo prieigos',
    'Asked {value1} · also in your Inbox': 'Paprašyta {value1} · taip pat jūsų gautuosiuose',
    Grant: 'Suteikti',
    Admin: 'Administratorius',
    'Make personal': 'Padaryti asmeninį',
    'Switch off': 'Išjungti',
    Archive: 'Archyvuoti',
    'Archive this agent': 'Archyvuoti šį agentą',
    'Loading agent…': 'Įkeliamas agentas…',
    '{value1} Edit in chat': '{value1} Redaguoti pokalbyje',
    Agent: 'Agentas',
    'This agent has not been created yet. It can run once its owner creates it.':
      'Šis agentas dar nesukurtas. Jis galės veikti, kai jį sukurs savininkas.',
    'New agent · Draft': 'Naujas agentas · Juodraštis',
    'Untitled agent': 'Agentas be pavadinimo',
    'Test run': 'Bandomasis paleidimas',
    'This draft does not run automatically.': 'Šis juodraštis nepaleidžiamas automatiškai.',
    'Describe the agent in the chat. Its draft appears here.':
      'Aprašykite agentą pokalbyje. Jo juodraštis bus rodomas čia.',
    '{value1} Test run': '{value1} Bandomasis paleidimas',
    'Describe the agent in the chat first.': 'Pirmiausia aprašykite agentą pokalbyje.',
    'Create and turn on': 'Sukurti ir įjungti',
    'Connection write setup': 'Ryšio rašymo sąranka',
    'Account for connected changes': 'Paskyra prijungtiems pakeitimams',
    'Choose a connection': 'Pasirinkite ryšį',
    'No published Skills available. You can add them later.':
      'Paskelbtų įgūdžių nėra. Galėsite juos pridėti vėliau.',
    '{value1} · not published. Review the changes. Testing is optional.':
      '{value1} · nepaskelbta. Peržiūrėkite pakeitimus. Testavimas neprivalomas.',
    '{value1} Test draft': '{value1} Testuoti juodraštį',
    'Apply changes…': 'Taikyti pakeitimus…',
    'Apply this draft as a new version': 'Pritaikyti šį juodraštį kaip naują versiją',
    'This draft cannot be applied.': 'Šio juodraščio pritaikyti negalima.',
    'What changed?': 'Kas pasikeitė?',
    'Apply version {value1}': 'Pritaikyti {value1} versiją',
    Create: 'Sukurti',
    'Edit access requested': 'Paprašyta redagavimo prieigos',
    '{value1} Request edit access': '{value1} Prašyti redagavimo prieigos',
    '{value1} Copy agent': '{value1} Kopijuoti agentą',
    Pause: 'Pristabdyti',
    'Open agent: {value1}': 'Atidaryti agentą: {value1}',
    '· you can edit': '· galite redaguoti',
    '{value1} is switched off.': '{value1} yra išjungtas.',
    '{value1} is archived.': '{value1} suarchyvuotas.',
    'Loading agents…': 'Įkeliami agentai…',
    Agents: 'Agentai',
    'Agents do work for you on a schedule or when you ask. They follow your company’s Skills.':
      'Agentai atlieka darbus pagal tvarkaraštį arba jums paprašius. Jie vadovaujasi jūsų įmonės įgūdžiais.',
    'No agent matches. Try a Skill name or what the agent should do.':
      'Atitinkančių agentų nėra. Pabandykite įvesti įgūdžio pavadinimą arba tai, ką agentas turėtų daryti.',
    'Nothing of your own yet': 'Jūsų turinio dar nėra',
    'Tell Chat what an agent should do, or copy one of the company’s agents below.{value1}':
      'Nurodykite pokalbyje, ką turėtų daryti agentas, arba nukopijuokite vieną iš toliau pateiktų įmonės agentų.{value1}',
    'Your agents': 'Jūsų agentai',
    'Run on demand': 'Paleisti pagal poreikį',
    'Run is always available. A schedule is optional and lives separately from the agent’s instructions.':
      'Paleidimas visada galimas. Tvarkaraštis neprivalomas ir saugomas atskirai nuo agento instrukcijų.',
    'What changed in version {value1}': 'Kas pasikeitė {value1} versijoje',
    'Every publish is a version you can restore.':
      'Kiekvienas paskelbimas yra versija, kurią galite atkurti.',
    Authorization: 'Autorizacija',
    '{value1} {value2} · {value3} will see it.': '{value1} {value2} · tai matys {value3}.',
    '{value1} {value2} you': '{value1} {value2} jūs',
    '· Revised': '· Pataisyta',
    'This chat used your {value1}.': 'Šiame pokalbyje naudotas jūsų {value1}.',
    'This chat has results from {value1}.': 'Šiame pokalbyje yra rezultatų iš {value1}.',
    'db.example.com': 'db.example.com',
    'e.g. Product analytics': 'pvz., produktų analizė',
    'Paste access key': 'Įklijuokite prieigos raktą',
    'Shopify’s Dev Dashboard': 'Shopify’s Dev Dashboard',
    'App reference': 'Programėlės identifikatorius',
    'Draft · revision {value1}': 'Juodraštis · redakcija {value1}',
    'its Result': 'jo rezultatas',
    '· its first run makes it': '· pirmasis jo paleidimas padaro jį',
    '{value1}’s chat ·': '{value1} pokalbis ·',
    '{value1} ad {value2} available.': '{value1} ir {value2} pasiekiami.',
    '{value1} rows ·': '{value1} eilučių ·',
    'It starts private. Sharing it wider shares every refresh, which can carry your private data.':
      'Iš pradžių jis yra privatus. Dalijantis juo plačiau, dalijamasi ir kiekvienu atnaujinimu, kuriame gali būti jūsų privačių duomenų.',
    'Enable this schedule when approved': 'Įjungti šį tvarkaraštį jį patvirtinus',
    Schedule: 'Tvarkaraštis',
    'Kept off until you create the agent from its canvas.':
      'Išjungtas, kol sukursite agentą jo drobėje.',
    'Will be enabled when you approve.': 'Bus įjungtas, kai patvirtinsite.',
    'Will be saved paused. You can enable it later.':
      'Bus išsaugotas pristabdytas. Galėsite jį įjungti vėliau.',
    'Only runs when you ask.': 'Paleidžiamas tik jums paprašius.',
    'Draft · approving saves it, and nothing runs. Test it and create it from its canvas.':
      'Juodraštis · patvirtinus jis bus išsaugotas ir niekas nebus paleista. Išbandykite jį ir sukurkite iš jo drobės.',
    'Draft · nothing is scheduled until you approve. Connected actions require their own approval at run time.':
      'Juodraštis · kol nepatvirtinsite, niekas nebus suplanuota. Prijungtiems veiksmams paleidimo metu reikės atskiro patvirtinimo.',
    Name: 'Pavadinimas',
    'Agent name': 'Agento pavadinimas',
    'Who can use it': 'Kas gali jį naudoti',
    'Company agent · company resources only': 'Įmonės agentas · tik įmonės ištekliai',
    'Personal agent · runs with your access': 'Asmeninis agentas · veikia su jūsų prieiga',
    'Approving saves it as a draft. It does not run automatically.':
      'Patvirtinus jis išsaugomas kaip juodraštis. Jis nepaleidžiamas automatiškai.',
    'Open the agent’s runs': 'Atidaryti agento paleidimus',
    'Run the published version once': 'Paleisti paskelbtą versiją vieną kartą',
    'Stopping…': 'Stabdoma…',
    'Stop run': 'Stabdyti paleidimą',
    'Could not stop this run. Please try again.':
      'Nepavyko sustabdyti šio paleidimo. Bandykite dar kartą.',
    'Run in progress': 'Paleidimas vykdomas',
    'This run is still answering. You can ask follow-ups when it finishes.':
      'Šis paleidimas vis dar rengia atsakymą. Jam pasibaigus galėsite užduoti papildomų klausimų.',
    'Open run details': 'Atidaryti paleidimo informaciją',
    Runs: 'Paleidimai',
    'Open the run chat': 'Atidaryti paleidimo pokalbį',
    Watch: 'Stebėti',
    Goal: 'Tikslas',
    'Change the goal': 'Keisti tikslą',
    'What it does': 'Ką jis daro',
    'What should this agent achieve?': 'Ką turėtų pasiekti šis agentas?',
    'Not set yet.': 'Dar nenustatyta.',
    'When it runs': 'Kada paleidžiamas',
    'Change when it runs': 'Keisti paleidimo laiką',
    'Off means it runs only when someone runs it. Changing when it runs never changes its instructions.':
      'Išjungta reiškia, kad jis paleidžiamas tik kam nors jį paleidus. Pakeitus paleidimo laiką jo instrukcijos niekada nepasikeičia.',
    Instructions: 'Instrukcijos',
    'Change the instructions': 'Keisti instrukcijas',
    'How the agent should approach the work and make decisions.':
      'Kaip agentas turėtų atlikti darbą ir priimti sprendimus.',
    Boundaries: 'Ribos',
    'What to do or avoid. Every connected action still follows its approval.':
      'Ką daryti arba ko vengti. Kiekvienam prijungtam veiksmui vis tiek reikalingas jo patvirtinimas.',
    'No instructions of its own. It follows its Skills.':
      'Savo instrukcijų nėra. Jis vadovaujasi savo įgūdžiais.',
    'Pin a Skill': 'Prisegti įgūdį',
    'Finds the Skills that fit each run, the same way a chat does.':
      'Kiekvienam paleidimui randa tinkamus įgūdžius taip pat, kaip pokalbis.',
    'Skills it always follows': 'Įgūdžiai, kuriais visada vadovaujasi',
    'A Skill that is not published': 'Nepaskelbtas įgūdis',
    'Always follows · Version {value1}': 'Visada vadovaujasi · versija {value1}',
    'Not published': 'Nepaskelbta',
    Uses: 'Naudoja',
    'Change in chat': 'Keisti pokalbyje',
    'Change in chat: Uses': 'Keisti pokalbyje: naudoja',
    'Company knowledge and the tools each run is allowed to use.':
      'Įmonės žinios ir įrankiai, kuriuos leidžiama naudoti kiekvienam paleidimui.',
    'People see the Result refresh; they change the agent, not the page.':
      'Žmonės mato atnaujintą rezultatą; jie keičia agentą, o ne puslapį.',
    'The first run after it is created makes the Result; later runs add a version to it.':
      'Pirmasis paleidimas po sukūrimo sukuria rezultatą, o vėlesni paleidimai prideda jo versiją.',
    'Emails whoever the run is for': 'Išsiunčia el. laišką paleidimo gavėjui',
    'Email each run': 'Siųsti el. laišką po kiekvieno paleidimo',
    Delivers: 'Pateikia',
    'Change what it delivers': 'Keisti, ką jis pateikia',
    'Expected result': 'Tikėtinas rezultatas',
    'What a successful run should deliver.': 'Ką turėtų pateikti sėkmingas paleidimas.',
    'What each run delivers': 'Ką pateikia kiekvienas paleidimas',
    'Keeps one Result up to date {value1}': 'Atnaujina vieną rezultatą {value1}',
    'Saves a new Result each run': 'Kiekvieno paleidimo metu išsaugo naują rezultatą',
    'You can run this company agent as yourself.{value1} {value2}':
      'Šį įmonės agentą galite paleisti kaip jūs.{value1} {value2}',
    'Changes since version': 'Pakeitimai nuo versijos',
    'are not live yet.': 'dar nepaskelbti.',
    'Review them in Versions': 'Peržiūrėkite juos skiltyje „Versijos“',
    Skill: 'Įgūdis',
    'The agent always uses the Skill’s published version.':
      'Agentas visada naudoja paskelbtą įgūdžio versiją.',
    Day: 'Diena',
    Time: 'Laikas',
    'Cron expression': 'Cron išraiška',
    'Editors and access': 'Redaktoriai ir prieiga',
    Company: 'Įmonė',
    Personal: 'Asmeninis',
    'No changes.': 'Pakeitimų nėra.',
    'Instructions changes': 'Instrukcijų pakeitimai',
    'Loading versions…': 'Įkeliamos versijos…',
    'What the draft changes': 'Ką keičia juodraštis',
    'No published version yet. Try the draft, then publish it.':
      'Paskelbtos versijos dar nėra. Išbandykite juodraštį ir paskelbkite jį.',
    'Published versions': 'Paskelbtos versijos',
    'Former member': 'Buvęs narys',
    Live: 'Aktyvi',
    '{value1} for {value2}': '{value1} skirta {value2}',
    Suggested: 'Siūloma',
    'Opening your conversation…': 'Atidaromas jūsų pokalbis…',
    'This conversation isn’t available': 'Šis pokalbis nepasiekiamas',
    'It may have been deleted, belong to another account, or be temporarily unavailable.':
      'Jis galėjo būti ištrintas, priklausyti kitai paskyrai arba laikinai nepasiekiamas.',
    '{count} more line — shown in the complete revision':
      'Dar viena eilutė ({count}) — rodoma visoje pataisoje',
    '{count} more lines — shown in the complete revision':
      'Dar {count} eilutės — rodomos visoje pataisoje',
    '{count} more line removed': 'Pašalinta dar viena eilutė ({count})',
    '{count} more lines removed': 'Pašalinta dar {count} eilučių',
    '{count} unchanged line': 'Nepakeista viena eilutė ({count})',
    '{count} unchanged lines': 'Nepakeistos {count} eilutės',
    '{count} more lines not shown, {added} added and {removed} removed. Check them in the complete revision.':
      'Dar {count} eilučių nerodoma: pridėta {added}, pašalinta {removed}. Peržiūrėkite jas visoje pataisoje.',
    'Saved result': 'Išsaugotas rezultatas',
    'Made with a Skill': 'Sukurta naudojant įgūdį',
    'Preview of {name}': '{name} peržiūra',
    'Made with {name}': 'Sukurta naudojant {name}',
    'Ad-hoc result': 'Vienkartinis rezultatas',
    'A Skill that is not available in this workspace': 'Įgūdis, nepasiekiamas šioje darbo srityje',
    '{name} · Revision {version}': '{name} · pataisa {version}',
    '{name} · Version {version}': '{name} · versija {version}',
    'Return to conversation {value1}': 'Grįžti į pokalbį {value1}',
    '{value1} Working with {value2}': '{value1} dirba su {value2}',
    'View context {value1}': 'Peržiūrėti kontekstą {value1}',
    'A way of working, made yours.': 'Darbo būdas, pritaikytas jums.',
    'Work that runs itself.': 'Darbas, kuris vyksta savaime.',
    'One place for one piece of work.': 'Viena vieta vienam darbui.',
    'Let’s move your work forward{value1}.': 'Pajudinkime jūsų darbą į priekį{value1}.',
    'Describe the work. Your Skill takes shape beside the conversation.':
      'Apibūdinkite darbą. Jūsų įgūdis formuojamas šalia pokalbio.',
    'Describe what it should do and when. Your agent takes shape beside the conversation. The draft does not run automatically.':
      'Apibūdinkite, ką jis turėtų daryti ir kada. Jūsų agentas formuojamas šalia pokalbio. Juodraštis nevykdomas automatiškai.',
    'Say what the work is. Poneva drafts the project beside the conversation and brings in what you have already done. Nothing is created until you say so.':
      'Nurodykite, koks tai darbas. „Poneva“ parengia projekto juodraštį šalia pokalbio ir įtraukia tai, ką jau atlikote. Nieko nesukuriama, kol to nepatvirtinate.',
    'Start with an idea below. Poneva will take it from there.':
      'Pradėkite nuo toliau pateiktos idėjos. „Poneva“ pasirūpins visa kita.',
    Triggers: 'Aktyvikliai',
    'Review the agent and its trigger. Approval applies exactly what is shown.':
      'Peržiūrėkite agentą ir jo aktyviklį. Patvirtinus taikoma tiksliai tai, kas rodoma.',
    '{source} · read {date}': '{source} · skaityta {date}',
    'Evidence is being recorded · read {date}': 'Pagrindžiantys duomenys įrašomi · skaityta {date}',
    'Evidence expired on {date} under the retention policy':
      'Pagrindžiančių duomenų galiojimas baigėsi {date} pagal saugojimo politiką',
    'Entered by {person}': 'Įvedė {person}',
    'No retained evidence for this value': 'Šiai reikšmei nėra išsaugotų pagrindžiančių duomenų',
    'Covers {shown} of {total} rows': 'Apima {shown} iš {total} eilučių',
    'Search rows': 'Ieškoti eilučių',
    'Clear filters': 'Išvalyti filtrus',
    Sort: 'Rikiuoti',
    'Sort: {column}': 'Rikiuoti: {column}',
    '{shown} of {total} rows': '{shown} iš {total} eilučių',
    More: 'Daugiau',
    Density: 'Tankis',
    Comfortable: 'Patogus',
    Compact: 'Kompaktiškas',
    Columns: 'Stulpeliai',
    'No rows match. Clear the search or filters to see them again.':
      'Atitinkančių eilučių nėra. Išvalykite paiešką arba filtrus, kad jas vėl matytumėte.',
    'Not available': 'Nepasiekiama',
    'All rows': 'Visos eilutės',
    'Close row detail': 'Uždaryti eilutės informaciją',
    'Ask about this row': 'Klausti apie šią eilutę',
    'Add note': 'Pridėti pastabą',
    Note: 'Pastaba',
    Saved: 'Išsaugota',
    Total: 'Iš viso',
    ascending: 'didėjančiai',
    descending: 'mažėjančiai',
    'Scroll to see all columns': 'Slinkite, kad pamatytumėte visus stulpelius',
    App: 'Programa',
    Artifact: 'Artefaktas',
    'New project': 'Naujas projektas',
    'Review request': 'Peržiūrėti užklausą',
    Activity: 'Veikla',
    'Voice preview': 'Balso peržiūra',
    Source: 'Šaltinis',
    File: 'Failas',
    Meeting: 'Susitikimas',
    'Knowledge page': 'Žinių puslapis',
    'Could not preview this CSV.': 'Nepavyko peržiūrėti šio CSV.',
    'File content is unavailable.': 'Failo turinys nepasiekiamas.',
    'You have five open suggestions here. {value1} will see them.':
      'Čia yra penki neįvykdyti pasiūlymai. Juos matys {value1}.',
    'We could not send your suggestion. Please try again.':
      'Nepavyko išsiųsti jūsų pasiūlymo. Bandykite dar kartą.',
    'The agent': 'Agentas',
    'Selected colleagues': 'Pasirinkti kolegos',
    'The owner': 'Savininkas',
    'Forked. This copy is yours and runs with your own connections.':
      'Sukurta kopija. Ji priklauso jums ir veikia su jūsų ryšiais.',
    'This chat is too long to fork.': 'Šis pokalbis per ilgas, kad būtų galima sukurti jo kopiją.',
    'We could not fork this chat. Please try again.':
      'Nepavyko sukurti šio pokalbio kopijos. Bandykite dar kartą.',
    'Anyone who forked it keeps their copy: forks stay with the people who made them.':
      'Kiekvienas, sukūręs kopiją, ją pasilieka: kopijos lieka jas sukūrusiems žmonėms.',
    'Nobody has forked this chat.': 'Niekas nesukūrė šio pokalbio kopijos.',
    '1 person forked this chat. Their copy stays theirs.':
      '1 žmogus sukūrė šio pokalbio kopiją. Ji lieka jam.',
    '{value1} people forked this chat. Their copies stay theirs.':
      '{value1} žmonės sukūrė šio pokalbio kopijas. Jos lieka jiems.',
    'Personal. Nobody else sees it.': 'Asmeniška. Niekas kitas to nemato.',
    'People you pick. They get it in their Inbox.':
      'Jūsų pasirinkti žmonės. Jie tai gaus gautuosiuose.',
    'Everyone in the company can follow it and fork it.':
      'Visi įmonės darbuotojai gali tai sekti ir sukurti kopiją.',
    'a chat you can no longer open': 'pokalbį, kurio nebegalite atidaryti',
    'shared the Result': 'bendrino Rezultatą',
    'updated the Result': 'atnaujino Rezultatą',
    'published the Skill': 'paskelbė Įgūdį',
    'approved the fact': 'patvirtino faktą',
    'added the fact': 'pridėjo faktą',
    'added the meeting': 'pridėjo susitikimą',
    'published the page': 'paskelbė puslapį',
    'updated the page': 'atnaujino puslapį',
    'shared the chat': 'bendrino pokalbį',
    'published a version of': 'paskelbė versiją elemento',
    ran: 'paleido',
    Knowledge: 'Žinios',
    Meetings: 'Susitikimai',
    Chat: 'Pokalbis',
    Use: 'Naudoti',
    Open: 'Atidaryti',
    You: 'Jūs',
    Someone: 'Kažkas',
    'published version {version} of': 'paskelbė elemento {version} versiją',
    'thing needs': 'elementą reikia',
    'things need': 'elementus reikia',
    'Published Skill': 'Paskelbtas įgūdis',
    'Included with Skill': 'Įtraukta į įgūdį',
    'Already attached': 'Jau pridėta',
    'Also available in company knowledge': 'Taip pat pasiekiama įmonės žiniose',
    'Company file': 'Įmonės failas',
    'Account identity unavailable': 'Paskyros tapatybė nepasiekiama',
    'Access expired or was revoked. Reconnect to continue.':
      'Prieiga baigė galioti arba buvo atšaukta. Norėdami tęsti, prisijunkite iš naujo.',
    'Account authorized · tools unavailable': 'Paskyra autorizuota · įrankiai nepasiekiami',
    'Not available in this workspace yet.': 'Šioje darbo srityje dar nepasiekiama.',
    'Everyone in the company': 'Visi įmonės darbuotojai',
    'Audience: only you.': 'Auditorija: tik jūs.',
    'Audience: everyone in the company.': 'Auditorija: visi įmonės darbuotojai.',
    'tool is': 'įrankis yra',
    'tools are': 'įrankiai yra',
    'account is': 'paskyra yra',
    'accounts are': 'paskyros yra',
    'We could not upload this file.': 'Nepavyko įkelti šio failo.',
    'file was': 'failas buvo',
    'files were': 'failai buvo',
    'Your company': 'Jūsų įmonė',
    'Create an agent': 'Sukurti agentą',
    'Give recurring work a helping hand': 'Palengvinkite pasikartojantį darbą',
    'Create a Skill': 'Sukurti įgūdį',
    'Save a reusable way of working': 'Išsaugokite pakartotinai naudojamą darbo būdą',
    'Take meeting notes': 'Rašyti susitikimo užrašus',
    'Capture decisions and next steps': 'Užfiksuoti sprendimus ir tolesnius veiksmus',
    'Work with a file': 'Dirbti su failu',
    'Start from a document or image': 'Pradėti nuo dokumento arba vaizdo',
    'Browse agents': 'Peržiūrėti agentus',
    'Open your agents and company agents': 'Atidaryti savo ir įmonės agentus',
    'Review results': 'Peržiūrėti rezultatus',
    'Return to work saved in your Library': 'Grįžti prie Bibliotekoje išsaugoto darbo',
    'For review': 'Peržiūrai',
    'An agent': 'Agentas',
    Assistant: 'Asistentas',
    'Kept up to date by {value1}{value2}': 'Nuolat atnaujina {value1}{value2}',
    ', {value1}': ', {value1}',
    'Version {value1}{value2}{value3}': 'Versija {value1}{value2}{value3}',
    'Refreshed by its agent': 'Atnaujino jo agentas',
    'Saved from a chat': 'Išsaugota iš pokalbio',
    'Saved from {value1}': 'Išsaugota iš programos {value1}',
    Edited: 'Redaguota',
    'private account': 'privati paskyra',
    '{value1} ({value2})': '{value1} ({value2})',
    '{value1}’s {value2}': '{value2} – {value1}',
    'Made private. The person who added it and the owner of its recording have been told in their Inbox.':
      'Padaryta privačia. Asmuo, kuris ją pridėjo, ir jos įrašo savininkas apie tai informuoti gautuosiuose.',
    'Made private. The person who added it has been told in their Inbox.':
      'Padaryta privačia. Asmuo, kuris ją pridėjo, apie tai informuotas gautuosiuose.',
    'Made private. The owner of its recording has been told in their Inbox.':
      'Padaryta privačia. Jos įrašo savininkas apie tai informuotas gautuosiuose.',
    'Selected passage': 'Pasirinkta ištrauka',
    '{value1} {value2}': '{value1} {value2}',
    'Upload a file': 'Įkelti failą',
    'Help me create a useful report from our company knowledge and available sources.':
      'Padėkite man sukurti naudingą ataskaitą iš mūsų įmonės žinių ir prieinamų šaltinių.',
    'This saved work couldn’t be opened. Open it again to retry.':
      'Šio išsaugoto darbo nepavyko atidaryti. Atidarykite jį dar kartą ir bandykite iš naujo.',
    '{value1}’s': '{value1}',
    '{value1} chat “{value2}”': '{value1} pokalbis „{value2}“',
    '{value1}{value2}': '{value1}{value2}',
    'Skill: {value1}{value2}': 'Įgūdis: {value1}{value2}',
    'Result “{value1}”': 'Rezultatas „{value1}“',
    'Meeting “{value1}”': 'Susitikimas „{value1}“',
    'Used in {value1} {value2} this week': 'Šią savaitę naudota {value1} {value2}',
    '{value1} {value2} · used in {value3} {value4}':
      '{value1} {value2} · naudota {value3} {value4}',
    'The draft is not published yet, so no one else follows it.':
      'Juodraštis dar nepaskelbtas, todėl niekas kitas jo neseka.',
    'Use it in a chat for current data, or refine the Skill first.':
      'Naudokite jį pokalbyje su aktualiais duomenimis arba pirmiausia patobulinkite įgūdį.',
    'An agent keeps this up to date. Continue the work in chat.':
      'Agentas nuolat tai atnaujina. Tęskite darbą pokalbyje.',
    'Edit it here, or continue the work in chat.': 'Redaguokite čia arba tęskite darbą pokalbyje.',
    'Duplicate it to your Library, or continue the work in chat.':
      'Dubliuokite į Biblioteką arba tęskite darbą pokalbyje.',
    'Download Markdown': 'Atsisiųsti Markdown',
    'Download CSV': 'Atsisiųsti CSV',
    'an agent': 'agentas',
    'Publish a Skill version': 'Paskelbti įgūdžio versiją',
    'Share with {value1}': 'Bendrinti su {value1}',
    'Update company content': 'Atnaujinti įmonės turinį',
    Approved: 'Patvirtinta',
    Declined: 'Atmesta',
    Pending: 'Laukiama',
    'View decision': 'Peržiūrėti sprendimą',
    'No data': 'Nėra duomenų',
    'No change': 'Pakeitimų nėra',
    'Connection created': 'Ryšys sukurtas',
    'Sharing changed': 'Bendrinimas pakeistas',
    'Person added': 'Asmuo pridėtas',
    'Person removed': 'Asmuo pašalintas',
    'Access changed': 'Prieiga pakeista',
    'Access turned off': 'Prieiga išjungta',
    'Connection removed': 'Ryšys pašalintas',
    'Query time limit changed': 'Užklausos laiko limitas pakeistas',
    '{count} row': '{count} eilutė',
    '{count} rows': '{count} eilučių',
    'This source is no longer available. Company knowledge now lives in Knowledge pages, and files stay in the Library.':
      'Šis šaltinis nebepasiekiamas. Įmonės žinios dabar saugomos žinių puslapiuose, o failai lieka Bibliotekoje.',
    '· {value1} by {value2}': '· {value1}, autorius – {value2}',
    '· version {value1}': '· versija {value1}',
    '{message} {count} earlier file was saved and attached.':
      '{message} Išsaugotas ir pridėtas {count} ankstesnis failas.',
    '{message} {count} earlier files were saved and attached.':
      '{message} Išsaugoti ir pridėti {count} ankstesni failai.',
    '{message} {count} earlier file was saved.': '{message} Išsaugotas {count} ankstesnis failas.',
    '{message} {count} earlier files were saved.': '{message} Išsaugoti {count} ankstesni failai.',
    'refreshed {time}': 'atnaujinta {time}',
    'a colleague': 'kolega',
    'Your chat “{title}”': 'Jūsų pokalbis „{title}“',
    '{name}’s chat “{title}”': '{name} pokalbis „{title}“',
    'Kept up to date by {name}{version}': 'Atnaujina {name}{version}',
    'Skill: {name}{version}': 'Įgūdis: {name}{version}',
    'Result “{title}”': 'Rezultatas „{title}“',
    'Meeting “{title}”': 'Susitikimas „{title}“',
    'Used in {count} answer this week': 'Šią savaitę panaudota {count} atsakyme',
    'Used in {count} answers this week': 'Šią savaitę panaudota {count} atsakymuose',
    '{count} source': '{count} šaltinis',
    '{count} sources': '{count} šaltiniai',
    'used in {count} place': 'panaudota {count} vietoje',
    'used in {count} places': 'panaudota {count} vietose',
    '{company} workspace': '{company} darbo sritis',
    '{count} page': '{count} puslapis',
    '{count} pages': '{count} puslapiai',
    '{needs} · reviews and approvals': '{needs} · peržiūros ir patvirtinimai',
    '{count} thing needs you': '{count} elementui reikia jūsų dėmesio',
    '{count} things need you': '{count} elementams reikia jūsų dėmesio',
    'Included with Skill · {files} · {sources} {icon}':
      'Įtraukta į įgūdį · {files} · {sources} {icon}',
    '{count} file': '{count} failas',
    '{count} files': '{count} failai',
    Today: 'Šiandien',
    'Earlier this week': 'Anksčiau šią savaitę',
    '{count} slide': '{count} skaidrė',
    '{count} slides': '{count} skaidrės',
    Early: 'Anksti',
    'TLS verified': 'TLS patvirtinta',
    'Made personal and switched off. Switch it on when you are ready.':
      'Paversta asmenine ir išjungta. Įjunkite, kai būsite pasiruošę.',
    'Made personal and switched off. Its owner is told which version is live.':
      'Paversta asmenine ir išjungta. Jos savininkui pranešama, kuri versija yra aktyvi.',
    'Switched off.': 'Išjungta.',
    'Applied version {revision}.': 'Pritaikyta versija {revision}.',
    'The draft is running in a chat only you can read.':
      'Juodraštis vykdomas pokalbyje, kurį galite perskaityti tik jūs.',
    'Publish a version first.': 'Pirmiausia paskelbkite versiją.',
    'Another Agent action is in progress.': 'Vykdomas kitas agento veiksmas.',
    'Knowledge & connections': 'Žinios ir ryšiai',
    'Pinned Skills': 'Prisegti įgūdžiai',
    None: 'Nėra',
    'A new Result each run': 'Naujas rezultatas per kiekvieną vykdymą',
    'One Result kept up to date': 'Vienas nuolat atnaujinamas rezultatas',
    Email: 'El. paštas',
    On: 'Įjungta',
    Off: 'Išjungta',
    'Waiting for review': 'Laukiama peržiūros',
    Outdated: 'Pasenę',
    Accepted: 'Priimta',
    Rejected: 'Atmesta',
    Withdrawn: 'Atšaukta',
    Replaced: 'Pakeista',
    'Suggested edit': 'Siūlomas pakeitimas',
    'Suggested new page': 'Siūlomas naujas puslapis',
    'Suggested move': 'Siūlomas perkėlimas',
    'Suggested archive': 'Siūlomas archyvavimas',
    'Checking status…': 'Tikrinama būsena…',
    'Status unavailable': 'Būsena nepasiekiama',
    'Bulleted list': 'Sąrašas su ženkleliais',
    'Numbered list': 'Numeruotas sąrašas',
    'Web link': 'Žiniatinklio nuoroda',
    Read: 'Skaityti',
    Write: 'Rašyti',
    'shared with you': 'bendrinama su jumis',
    'Getting an answer': 'Rengiamas atsakymas',
    '{name} is getting an answer': '{name} rengia atsakymą',
    'We could not save. Please try again.': 'Nepavyko išsaugoti. Bandykite dar kartą.',
    'The new page could not be created.': 'Nepavyko sukurti naujo puslapio.',
    'We could not load this revision.': 'Nepavyko įkelti šios versijos.',
    'We could not restore this revision. Please try again.':
      'Nepavyko atkurti šios versijos. Bandykite dar kartą.',
    'We could not export this revision.': 'Nepavyko eksportuoti šios versijos.',
    'We could not open this suggestion.': 'Nepavyko atidaryti šio pasiūlymo.',
    'We could not do that. Please try again.': 'Nepavyko to atlikti. Bandykite dar kartą.',
    'We could not save your decision. Please try again.':
      'Nepavyko išsaugoti jūsų sprendimo. Bandykite dar kartą.',
    'We could not restore this page. Please try again.':
      'Nepavyko atkurti šio puslapio. Bandykite dar kartą.',
    'We could not export this page.': 'Nepavyko eksportuoti šio puslapio.',
    '{count} missed time merged.': 'Sujungtas {count} praleistas laiko įrašas.',
    '{count} missed times merged.': 'Sujungti {count} praleisti laiko įrašai.',
    'About this project': 'Apie šį projektą',
  },
  mt: {
    context: 'kuntest',
    skills: 'ħiliet',
    'Choose company context': 'Agħżel il-kuntest tal-kumpanija',
    'Skills for this conversation': 'Ħiliet għal din il-konverżazzjoni',
    'Bring context into the conversation': 'Żid il-kuntest fil-konverżazzjoni',
    'Close context picker': 'Agħlaq l-għażla tal-kuntest',
    'Filter company context': 'Iffiltra l-kuntest tal-kumpanija',
    'Find a Skill…': 'Sib ħila…',
    'Find a file…': 'Sib fajl…',
    'Available company context': 'Kuntest tal-kumpanija disponibbli',
    'No matching published Skills.': 'Ma nstabu l-ebda ħiliet ippubblikati li jaqblu.',
    'No matching files.': 'Ma nstab l-ebda fajl li jaqbel.',
    'Searching company work…': 'Qed infittxu fix-xogħol tal-kumpanija…',
    'Try search again': 'Erġa’ pprova tfittex',
    'Meaning search is temporarily limited. Showing available text matches.':
      'It-tfittxija skont it-tifsira hija limitata temporanjament. Qed nuru r-riżultati disponibbli skont it-test.',
    'Load more matches': 'Tagħbija aktar riżultati',
    '{value1} files attached. Remove an attachment to add another. Saved Skill references are included separately.':
      '{value1} fajl mehmuż. Neħħi mehmuż biex iżżid ieħor. Ir-referenzi tal-ħila ssejvjati huma inklużi separatament.',
    'Create a Skill in chat': 'Oħloq ħila fiċ-chat',
    'Upload a company file': 'Ittella’ fajl tal-kumpanija',
    'Company knowledge is always available to Poneva.':
      'L-għarfien tal-kumpanija huwa dejjem disponibbli għal Poneva.',
    '{value1} was not connected': '{value1} ma ġiex ikkonnettjat',
    Dismiss: 'Agħlaq',
    'Try connecting again': 'Erġa’ pprova tikkonnettja',
    Waiting: 'Qed tistenna',
    Connected: 'Konness',
    'Needs reconnecting': 'Jeħtieġ jerġa’ jiġi kkonnettjat',
    Connect: 'Ikkonnettja',
    '{value1}{value2} The provider’s account permissions still apply.':
      '{value1}{value2} Il-permessi tal-kont tal-fornitur għadhom japplikaw.',
    'Last error: {value1}': 'L-aħħar żball: {value1}',
    '{value1} {value2} ready.': '{value1} {value2} lest.',
    'Continue with my Meta app': 'Kompli bl-app Meta tiegħi',
    Reconnect: 'Erġa’ kkonnettja',
    Disconnect: 'Skonnettja',
    'Remove attachment: {value1}': 'Neħħi l-mehmuż: {value1}',
    'Saved in this Skill. Edit the Skill to change its references.':
      'Ssejvjat f’din il-ħila. Editja l-ħila biex tibdel ir-referenzi tagħha.',
    'Remove Skill context': 'Neħħi l-kuntest tal-ħila',
    Refining: 'Qed nirfinaw',
    Previewing: 'Qed nuru preview',
    Using: 'Qed nużaw',
    'Skill revision {value1}': 'Reviżjoni tal-ħila {value1}',
    'a new Skill': 'ħila ġdida',
    '{value1} Making a new agent {value2}': '{value1} Qed noħolqu aġent ġdid {value2}',
    'Stop making a new agent in this chat': 'Waqqaf il-ħolqien ta’ aġent ġdid f’dan iċ-chat',
    'Saved Skill references': 'Referenzi tal-ħila ssejvjati',
    'Included with Skill · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}':
      'Inkluż mal-ħila · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}',
    'Selected Skill revision is unavailable. Select the Skill again to view its saved references.':
      'Ir-reviżjoni tal-ħila magħżula mhijiex disponibbli. Agħżel il-ħila mill-ġdid biex tara r-referenzi ssejvjati tagħha.',
    'Conversation attachments': 'Mehmużin tal-konverżazzjoni',
    'Added for this conversation': 'Miżjud għal din il-konverżazzjoni',
    'Selected passage {value1}': 'Silta magħżula {value1}',
    'We could not load your workspace.': 'Ma stajniex intellgħu l-ispazju tax-xogħol tiegħek.',
    'The selected Skill is unavailable. Check its access or choose it again.':
      'Il-ħila magħżula mhijiex disponibbli. Iċċekkja l-aċċess għaliha jew agħżelha mill-ġdid.',
    'Source saved privately and included in your knowledge search.':
      'Is-sors ġie ssejvjat privatament u inkluż fit-tfittxija tal-għarfien tiegħek.',
    'File saved privately to your library and attached to this message.':
      'Il-fajl ġie ssejvjat privatament fil-librerija tiegħek u mehmuż ma’ dan il-messaġġ.',
    'File saved privately to your library.':
      'Il-fajl ġie ssejvjat privatament fil-librerija tiegħek.',
    '{value1} {value2} earlier {value3} saved{value4}.':
      '{value1} {value2} aktar kmieni {value3} ssejvjat{value4}.',
    'Extracted text for Poneva to read. Download the original for its layout, charts and images. Spreadsheet formulas show their saved results and are not recalculated.':
      'Test estratt biex jaqrah Poneva. Niżżel l-oriġinal biex iżżomm it-tqassim, il-graffs u l-immaġini tiegħu. Il-formuli tal-ispreadsheet juru r-riżultati ssejvjati tagħhom u ma jiġux ikkalkulati mill-ġdid.',
    Esc: 'Esc',
    'Start something': 'Ibda xi ħaġa',
    'Choose a file to work with': 'Agħżel fajl biex taħdem fuqu',
    'Skills worth adding': 'Ħiliet li ta’ min iżżid',
    'Picked for you': 'Magħżula għalik',
    'Reusable work grounded in your company knowledge.':
      'Xogħol li jista’ jerġa’ jintuża u bbażat fuq l-għarfien tal-kumpanija tiegħek.',
    'Ideas from your company context and recent work. Pick one to start.':
      'Ideat mill-kuntest tal-kumpanija tiegħek u mix-xogħol riċenti. Agħżel waħda biex tibda.',
    'Refresh suggested tasks': 'Aġġorna l-kompiti ssuġġeriti',
    'Check for new company context.': 'Iċċekkja għal kuntest ġdid tal-kumpanija.',
    'Check for new context. Ideas also refresh daily.':
      'Iċċekkja għal kuntest ġdid. L-ideat jiġu aġġornati wkoll kuljum.',
    Refresh: 'Aġġorna',
    'Finding useful starting points…': 'Qed infittxu punti utli minn fejn tibda…',
    'Suggestions aren’t available right now. Try Refresh, or describe the work you want to do.':
      'Is-suġġerimenti mhumiex disponibbli bħalissa. Ipprova Aġġorna, jew iddeskrivi x-xogħol li trid tagħmel.',
    'Loading the knowledge pages…': 'Qed intellgħu l-paġni tal-għarfien…',
    '{value1} All pages': '{value1} Il-paġni kollha',
    'The page is created.': 'Il-paġna nħolqot.',
    'Your new page is suggested. A publisher decides whether it is added.':
      'Il-paġna l-ġdida tiegħek ġiet issuġġerita. Pubblikatur jiddeċiedi jekk tiżdiedx.',
    'Company knowledge': 'Għarfien tal-kumpanija',
    'What Poneva knows about your company, page by page. Every change is kept.':
      'Dak li jaf Poneva dwar il-kumpanija tiegħek, paġna paġna. Kull bidla tinżamm.',
    'Loading company knowledge…': 'Qed intellgħu l-għarfien tal-kumpanija…',
    'Knowledge pages are not enabled in this workspace.':
      'Il-paġni tal-għarfien mhumiex attivati f’dan l-ispazju tax-xogħol.',
    'Ask your Poneva contact to switch them on for your company.':
      'Itlob lill-kuntatt tiegħek f’Poneva biex jattivahom għall-kumpanija tiegħek.',
    '{value1} Change the agent': '{value1} Ibdel l-aġent',
    '{value1} Continue in chat': '{value1} Kompli fiċ-chat',
    'We could not load this item.': 'Ma stajniex intellgħu dan l-oġġett.',
    '{value1} canvas': "Kanvas ta' {value1}",
    'Loading {value1}…': 'Qed jitgħabba {value1}…',
    '{value1} · Original retained': '{value1} · Oriġinal miżmum',
    '{value1} {value2}{value3} · Added {value4}': '{value1} {value2}{value3} · Miżjud {value4}',
    '{value1} Use in chat': '{value1} Uża fiċ-chat',
    '{value1} Download': '{value1} Niżżel',
    Table: 'Tabella',
    Chart: 'Grafika',
    Original: 'Oriġinali',
    'Text extracted from the PDF, marked by page. Download the original for its layout and images.':
      'Test estratt mill-PDF, immarkat skont il-paġna. Niżżel l-oriġinali biex tara t-tqassim u l-immaġnijiet tiegħu.',
    'This preview shows the beginning of the file. Poneva reads the whole file; download the original to see all of it.':
      'Din il-previżjoni turi l-bidu tal-fajl. Poneva jaqra l-fajl kollu; niżżel l-oriġinali biex tara l-fajl kollu.',
    'Preview of the first {value1} complete rows. Filtering and charts use only this preview. Download the original for the full file.':
      'Previżjoni tal-ewwel {value1} ringiela kompluta. Il-filtrazzjoni u l-graffiċi jużaw din il-previżjoni biss. Niżżel l-oriġinali għall-fajl sħiħ.',
    'This source link cannot be opened.': 'Din il-link tas-sors ma tistax tinfetaħ.',
    'Read-only chat': "Chat ta' qari biss",
    'Only {value1} writes in this chat. Fork it to continue with your own connections. {value2}':
      "{value1} biss jista' jikteb f'dan iċ-chat. Oħloq fergħa minnu biex tkompli bil-konnessjonijiet tiegħek. {value2}",
    'Suggest a follow-up…': 'Issuġġerixxi segwitu…',
    'Suggest a follow-up': 'Issuġġerixxi segwitu',
    'Sending…': 'Qed jintbagħat…',
    Send: 'Ibgħat',
    'We could not dismiss that suggestion. Please try again.':
      "Ma stajniex inneħħu dik is-suġġeriment. Erġa' pprova.",
    'Suggested follow-ups': 'Segwiti ssuġġeriti',
    '{value1} suggests': '{value1} jissuġġerixxi',
    Ask: 'Staqsi',
    'Dismiss {value1}’s suggestion': "Neħħi s-suġġeriment ta' {value1}",
    'Suggested by': 'Issuġġerit minn',
    '· edit it or send it': '· editjah jew ibagħtu',
    'Remove the suggestion tag': 'Neħħi t-tikketta tas-suġġeriment',
    '{value1} {value2} is getting an answer': '{value1} {value2} qed jirċievi tweġiba',
    '{value1} {value2} stopped the answer': '{value1} {value2} waqqaf it-tweġiba',
    '{value1} Fork from here': '{value1} Oħloq fergħa minn hawn',
    '{value1} From {value2}’s {value3}': "{value1} Minn {value3} ta' {value2}",
    'Only {value1} can use this account': "{value1} biss jista' juża dan il-kont",
    '{value1} Suggested by {value2}': '{value1} Issuġġerit minn {value2}',
    'Fork this chat': 'Oħloq fergħa minn dan iċ-chat',
    'Forking…': 'Qed tinħoloq fergħa…',
    Fork: 'Oħloq fergħa',
    'Could not make this private.': 'Ma stajniex nagħmluha privata.',
    'Make this chat private?': 'Tagħmel dan iċ-chat privat?',
    Close: 'Agħlaq',
    '{value1} will see “{value2}”. Everyone else loses access right away {value3} .{value4}':
      '{value1} se jara “{value2}”. Kulħadd iktar jitlef l-aċċess minnufih {value3} .{value4}',
    Cancel: 'Ikkanċella',
    'Saving…': 'Qed jiġi ssejvjat…',
    'Make private': 'Agħmlu privat',
    'This chat is private again. Forks others made stay theirs.':
      "Dan iċ-chat reġa' sar privat. Il-friegħi li ħolqu oħrajn jibqgħu tagħhom.",
    'Who can read this chat: {value1}': "Min jista' jaqra dan iċ-chat: {value1}",
    'Move this chat': 'Mexxi dan iċ-chat',
    'Only you write here. Others follow live and fork.':
      'Int biss tikteb hawn. Oħrajn isegwu live u joħolqu fergħa.',
    'Made private. {value1} has been told in their Inbox.':
      'Sar privat. {value1} ġie nnotifikat fl-Inbox tiegħu.',
    'Chat access': 'Aċċess għaċ-chat',
    '{value1}’s chat. As an admin you can make it private.':
      "Iċ-chat ta' {value1}. Bħala amministratur tista' tagħmlu privat.",
    'Only {value1} will see it. {value2} is told.':
      '{value1} biss se jarah. {value2} ġie nnotifikat.',
    '{value1} {value2} following': '{value1} {value2} qed isegwu',
    'Forked from{value1} {value2} . The history is copied. From here, tools run with your own access.':
      "Inħolqot fergħa minn{value1} {value2} . L-istorja ġiet ikkupjata. Minn hawn 'il quddiem, l-għodod jaħdmu bl-aċċess tiegħek.",
    '{value1} made this chat private': '{value1} għamel dan iċ-chat privat',
    'You can no longer open it. Any fork you made stays yours.':
      "Ma tistax tibqa' tiftaħu. Kwalunkwe fergħa li ħloqt tibqa' tiegħek.",
    'Start a new chat': 'Ibda chat ġdid',
    'Back to Recent chats': 'Lura għaċ-chats riċenti',
    'More chat actions': 'Aktar azzjonijiet taċ-chat',
    'Close conversation sharing': 'Agħlaq il-qsim tal-konversazzjoni',
    'Review the text before saving a private copy to Library. Then choose its audience. Your original conversation and future messages stay private.':
      'Irrevedi t-test qabel issalva kopja privata fil-Librerija. Imbagħad agħżel l-udjenza tagħha. Il-konversazzjoni oriġinali tiegħek u l-messaġġi futuri jibqgħu privati.',
    'Preparing the conversation…': 'Qed titħejja l-konversazzjoni…',
    'Refresh preview': 'Aġġorna l-previżjoni',
    'The copy is saved in Library. Use Share to choose who can access it.':
      "Il-kopja ġiet issejvjata fil-Librerija. Uża Aqsam biex tagħżel min jista' jaċċessaha.",
    'Save this copy': 'Issejvja din il-kopja',
    'That Skill could not be opened.': 'Dik il-Ħila ma setgħetx tinfetaħ.',
    '{value1}{value2} · reviews and approvals':
      '{value1}{value2} · reviżjonijiet u approvazzjonijiet',
    'Open Inbox': 'Iftaħ l-Inbox',
    'New at {value1} this week': "Ġdid f'{value1} din il-ġimgħa",
    'Nothing new this week. Shared work, published Skills and approved knowledge show up here.':
      'Xejn ġdid din il-ġimgħa. Ix-xogħol maqsum, il-Ħiliet ippubblikati u l-għarfien approvat jidhru hawn.',
    'New at {value1}': "Ġdid f'{value1}",
    'This Skill is unavailable. Try again.': "Din il-Ħila mhijiex disponibbli. Erġa' pprova.",
    'You can attach up to {value1} files. Remove an attachment to add another.':
      "Tista' tehmeż sa {value1} fajl. Neħħi sekwestru biex iżżid ieħor.",
    'Add company context': 'Żid il-kuntest tal-kumpanija',
    'Add company context · @': 'Żid il-kuntest tal-kumpanija · @',
    'Choose a Skill': 'Agħżel Ħila',
    'Choose a Skill · /': 'Agħżel Ħila · /',
    Edit: 'Editja',
    '{value1} Edit with chat': '{value1} Editja biċ-chat',
    '{value1} Duplicate to my Library': '{value1} Idduplika fil-Librerija tiegħi',
    'Duplicated to your Library. Only you can see the copy.':
      'Idduplikat fil-Librerija tiegħek. Int biss tista’ tara l-kopja.',
    'Could not duplicate this Result. Try again.':
      'Ma setax jiġi duplikat dan ir-Riżultat. Erġa’ pprova.',
    'Saved version {value1}.': 'Il-verżjoni {value1} ġiet salvata.',
    'A newer version was saved. Reload the Result before saving.':
      'Ġiet salvata verżjoni aktar ġdida. Erġa’ agħbbet ir-Riżultat qabel issalvah.',
    'Could not save this version. Try again.':
      'Ma setgħetx tiġi salvata din il-verżjoni. Erġa’ pprova.',
    '{value1} saved a newer version. Review it before saving.':
      '{value1} salva verżjoni aktar ġdida. Irrevediha qabel issalva.',
    'Hide their version': 'Aħbi l-verżjoni tagħhom',
    'Show their version': 'Uri l-verżjoni tagħhom',
    'Start from their version': 'Ibda mill-verżjoni tagħhom',
    Markdown: 'Markdown',
    'Result text': 'Test tar-Riżultat',
    Preview: 'Previżjoni',
    'What changed': 'X’inbidel',
    'What changed? (optional)': 'X’inbidel? (mhux obbligatorju)',
    'Save version {value1}': 'Issejvja l-verżjoni {value1}',
    'Open chat': 'Iftaħ iċ-chat',
    Current: 'Kurrenti',
    Restore: 'Irrestawra',
    'Could not load the history.': 'Ma setgħetx titgħabba l-istorja.',
    'Restored version {value1} as version {value2}.':
      'Il-verżjoni {value1} ġiet irrestawrata bħala verżjoni {value2}.',
    'Someone saved a newer version. Review it before restoring.':
      'Xi ħadd salva verżjoni aktar ġdida. Irrevediha qabel tirrestawra.',
    'Could not restore that version.': 'Ma setgħetx tiġi rrestawrata dik il-verżjoni.',
    'Loading history…': 'Qed titgħabba l-istorja…',
    'Restoring keeps what is there now as a version too, so nothing is lost.':
      'Ir-restawr iżomm ukoll dak li hemm bħalissa bħala verżjoni, u għalhekk ma jintilef xejn.',
    'This Result was made with your own {value1}.':
      'Dan ir-Riżultat inħoloq bl-{value1} tiegħek stess.',
    'It also used': 'Uża wkoll',
    'This Result was made with': 'Dan ir-Riżultat inħoloq bi',
    'Colleagues can read what came from them, but can never use them.':
      'Il-kollegi jistgħu jaqraw dak li ġie mingħandhom, iżda qatt ma jistgħu jużawh.',
    'Your personal agent {value1} keeps it up to date with your own access, so every refresh can carry your private data.':
      'L-aġent personali tiegħek {value1} iżommu aġġornat bl-aċċess tiegħek, sabiex kull aġġornament ikun jista’ jinkludi d-dejta privata tiegħek.',
    'A colleague’s personal agent keeps it up to date with their own access, so every refresh can carry their private data.':
      'L-aġent personali ta’ kollega jżommu aġġornat bl-aċċess tiegħu, sabiex kull aġġornament ikun jista’ jinkludi d-dejta privata tiegħu.',
    'Made private. Only you can see this meeting.':
      'Sar privat. Int biss tista’ tara din il-laqgħa.',
    'Could not make this meeting private.': 'Din il-laqgħa ma setgħetx issir privata.',
    'Meeting · {value1} {value2} · Original retained':
      'Laqgħa · {value1} {value2} · L-oriġinal inżamm',
    'The recording could not be opened.': 'Ir-reġistrazzjoni ma setgħetx tinfetaħ.',
    'Ask about this suggestion': 'Staqsi dwar din is-suġġeriment',
    meeting_processing_failed: 'falliment fl-ipproċessar tal-laqgħa',
    'Who can see this': 'Min jista’ jara dan',
    'Everyone at {value1}': 'Kulħadd fuq {value1}',
    'Only me': 'Jien biss',
    'Everyone at {value1} can find it and ask about it.':
      'Kulħadd fuq {value1} jista’ jsibu u jistaqsi dwaru.',
    'Only you can open and search this meeting. You can share it later.':
      'Int biss tista’ tiftaħ u tfittex f’din il-laqgħa. Tista’ taqsamha aktar tard.',
    'Added. Only you can see it. Transcription is running in the background.':
      'Miżjud. Int biss tista’ tarah. It-traskrizzjoni għaddejja fl-isfond.',
    'Visible to everyone at {value1}': 'Viżibbli għal kulħadd fuq {value1}',
    'Could not make it private.': 'Ma setax isir privat.',
    'Show more meetings': 'Uri aktar laqgħat',
    'Attached to this message': 'Imwaħħal ma’ dan il-messaġġ',
    'Connect securely, choose the tables to share, then decide whether Poneva can read or make changes.':
      'Ikkonnettja b’mod sigur, agħżel it-tabelli li trid taqsam, imbagħad iddeċiedi jekk Poneva jistax jaqra jew jagħmel bidliet.',
    'Review the tables this connection can access. Select at least one table.':
      'Irrevedi t-tabelli li tista’ taċċessa din il-konnessjoni. Agħżel mill-inqas tabella waħda.',
    'Select at least one table. Nothing is selected by default.':
      'Agħżel mill-inqas tabella waħda. Xejn mhu magħżul awtomatikament.',
    'Choose who can use this connection and what Poneva can do.':
      'Agħżel min jista’ juża din il-konnessjoni u x’jista’ jagħmel Poneva.',
    'Your chosen access is enabled for the selected tables.':
      'L-aċċess li għażilt huwa attivat għat-tabelli magħżula.',
    'Your connection is saved with reading paused until permission is confirmed.':
      'Il-konnessjoni tiegħek ġiet salvata bil-qari mwaqqaf sakemm jiġi kkonfermat il-permess.',
    'Confirm database disconnect': 'Ikkonferma d-diżkonnessjoni tad-database',
    'Disconnect this database?': 'Tiskonnettja din id-database?',
    'Access will stop for everyone using this connection.':
      'L-aċċess se jieqaf għal kull min juża din il-konnessjoni.',
    'Keep connection': 'Żomm il-konnessjoni',
    'What it can reach · {value1}{value2} {value3}':
      'X’jista’ jaċċessa · {value1}{value2} {value3}',
    Back: 'Lura',
    Continue: 'Kompli',
    'Uploading…': 'Qed tittella’…',
    Library: 'Librerija',
    'Source material for your work. Available whenever you need it.':
      'Materjal ta’ sors għax-xogħol tiegħek. Disponibbli kull meta jkollok bżonnu.',
    'The work you want to keep, with its sources and conversation attached.':
      'Ix-xogħol li trid iżżomm, bis-sorsi u l-konversazzjoni tiegħu mehmużin.',
    Results: 'Riżultati',
    Files: 'Fajls',
    Artifacts: 'Artifatti',
    'Search library': 'Fittex fil-librerija',
    'Find files by meaning…': 'Sib fajls skont it-tifsira…',
    'Find saved work by meaning…': 'Sib xogħol salvat skont it-tifsira…',
    'Search coverage is limited while indexing or meaning-based search is unavailable. You can retry or browse recent items.':
      'It-tfittxija hija limitata waqt l-indiċjar jew meta t-tfittxija skont it-tifsira ma tkunx disponibbli. Tista’ terġa’ tipprova jew tfittex fl-oġġetti riċenti.',
    'No matching work found.': 'Ma nstab l-ebda xogħol li jaqbel.',
    'A starting point for your next question.': 'Punt tat-tluq għall-mistoqsija li jmiss tiegħek.',
    'Good work is worth keeping.': 'Xogħol tajjeb ta’ min iżommu.',
    'Try a different description or clear the search to browse.':
      'Ipprova deskrizzjoni differenti jew neħħi t-tfittxija biex tfittex.',
    'Upload source material once and use it in conversations and Skills. Your original stays in the library.':
      'Tella’ l-materjal tas-sors darba u użah fil-konversazzjonijiet u fil-Ħiliet. L-oriġinal tiegħek jibqa’ fil-librerija.',
    'Ask Poneva to save an answer, table or chart. Results stay connected to the conversation and their sources.':
      'Staqsi lil Poneva biex isalva tweġiba, tabella jew grafika. Ir-riżultati jibqgħu konnessi mal-konversazzjoni u mas-sorsi tagħhom.',
    'Start in chat {value1}': 'Ibda fiċ-chat {value1}',
    'Open result: {value1}': 'Iftaħ ir-riżultat: {value1}',
    'Loading more library items…': 'Qed jitgħabbew aktar oġġetti tal-librerija…',
    'Load more': 'Tagħbija aktar',
    'Documents, transcripts, audio and video · Up to 500 MB per file. New files are private. Choose their audience with Share and which processable files become searchable company knowledge.':
      'Dokumenti, traskrizzjonijiet, awdjo u vidjo · Sa 500 MB għal kull fajl. Fajls ġodda huma privati. Agħżel l-udjenza tagħhom permezz ta’ Aqsam u liema fajls li jistgħu jiġu pproċessati jsiru għarfien tal-kumpanija li jista’ jiġi mfittxija.',
    Skills: 'Ħiliet',
    'Create in chat': 'Oħloq fiċ-chat',
    'Search Skills': 'Fittex fil-Ħiliet',
    'Search finds published Skills. Clear the search to browse your drafts too.':
      'It-tfittxija ssib Ħiliet ippubblikati. Ħassar it-tfittxija biex tfittex ukoll fl-abbozzi tiegħek.',
    'Search coverage is limited while indexing or meaning-based search is unavailable.':
      'Il-kopertura tat-tfittxija hija limitata waqt li l-indiċizzazzjoni jew it-tfittxija bbażata fuq it-tifsira ma tkunx disponibbli.',
    'Searching Skills…': 'Qed jitfittxu l-Ħiliet…',
    'No matching published Skills found. Try a different description.':
      'Ma nstabu l-ebda Ħiliet ippubblikati li jaqblu. Ipprova deskrizzjoni differenti.',
    'Load more Skills': 'Tagħbija aktar Ħiliet',
    'View Skill: {value1}': 'Ara l-Ħila: {value1}',
    'Company workspace': 'Spazju tax-xogħol tal-kumpanija',
    'View {value1}': 'Ara {value1}',
    'Loading Skills…': 'Qed jitgħabbew il-Ħiliet…',
    'Try again {value1}': 'Erġa’ pprova {value1}',
    'Try again': 'Erġa’ pprova',
    'Nothing yet.': 'Għadu m’hemm xejn.',
    'Made from · Used by': 'Iffurmat minn · Użat minn',
    'Could not load links': 'Ma setgħux jitgħabbew il-links',
    'Made from': 'Iffurmat minn',
    'Used by': 'Użat minn',
    'About this chat {value1}': 'Dwar dan iċ-chat {value1}',
    'About this chat': 'Dwar dan iċ-chat',
    'Keep the work moving.': 'Kompli mexxi x-xogħol.',
    'Ask a follow-up with this result in view, or turn a useful approach into a company Skill.':
      'Staqsi mistoqsija ta’ segwitu b’dan ir-riżultat quddiemek, jew ibdel approċċ utli f’Ħila tal-kumpanija.',
    'Save approach as a Skill': 'Issejvja l-approċċ bħala Ħila',
    'Preview of': 'Previżjoni ta’',
    'Made with': 'Magħmul b’',
    'Open the draft': 'Iftaħ l-abbozz',
    'Open Skill': 'Iftaħ il-Ħila',
    'Use in chat': 'Uża fiċ-chat',
    'Finish the draft': 'Imlesta l-abbozz',
    'Refine this Skill': 'Irfina din il-Ħila',
    'Made with a Skill.': 'Magħmul b’Ħila.',
    'This workspace could not be loaded just now, so that Skill cannot be opened yet. The result itself is unchanged.':
      'Dan l-ispazju tax-xogħol ma setax jitgħabba bħalissa, għalhekk dik il-Ħila għadha ma tistax tinfetaħ. Ir-riżultat innifsu ma nbidilx.',
    'That Skill is not available in this workspace, so it cannot be opened or used again. The result itself is unchanged.':
      'Dik il-Ħila mhijiex disponibbli f’dan l-ispazju tax-xogħol, għalhekk ma tistax tinfetaħ jew terġa’ tintuża. Ir-riżultat innifsu ma nbidilx.',
    'Result · {value1} {value2}': 'Riżultat · {value1} {value2}',
    '{value1} Copy link': '{value1} Ikkopja l-link',
    'Result link copied.': 'Il-link tar-riżultat ġiet ikkupjata.',
    'Could not copy the link. Use your browser address bar.':
      'Ma setgħetx tiġi kkupjata l-link. Uża l-bar tal-indirizz tal-browser tiegħek.',
    'No preview is available for this result.':
      'M’hemm l-ebda previżjoni disponibbli għal dan ir-riżultat.',
    '{value1} rows are retained in this snapshot. Open Table to inspect the values.':
      '{value1} ringiela huma miżmuma f’dan l-istampa. Iftaħ it-Tabella biex tispezzjona l-valuri.',
    'People can’t edit a Result an agent keeps up to date; the next refresh would replace their edit. Change the agent’s instructions instead.':
      'In-nies ma jistgħux jeditjaw Riżultat li aġent iżomm aġġornat; l-aġġornament li jmiss jissostitwixxi l-editjar tagħhom. Minflok, ibdel l-istruzzjonijiet tal-aġent.',
    'Linked sources': 'Sorsi marbuta',
    'Saved source': 'Sors issejvjat',
    'No source documents are linked to this result. Company knowledge and other references may be cited in the answer.':
      'L-ebda dokument sors mhu marbut ma’ dan ir-riżultat. Fit-tweġiba jistgħu jiġu ċċitati l-għarfien tal-kumpanija u referenzi oħra.',
    'Run details': 'Dettalji tal-eżekuzzjoni',
    Created: 'Maħluq',
    ', revised {value1}': ', rivedut {value1}',
    Conversation: 'Konverżazzjoni',
    'Not recorded': 'Mhux irreġistrat',
    'Open conversation': 'Iftaħ il-konverżazzjoni',
    Run: 'Eżegwixxi',
    Updates: 'Aġġornamenti',
    'Kept up to date by {value1}': 'Miżmum aġġornat minn {value1}',
    'Version {value1}': 'Verżjoni {value1}',
    'Could not open this request.': 'Din it-talba ma setgħetx tinfetaħ.',
    'Approved version published.': 'Il-verżjoni approvata ġiet ippubblikata.',
    'Request rejected. The item stays unchanged.':
      'It-talba ġiet irrifjutata. L-oġġett jibqa’ mhux mibdul.',
    'Could not save the decision.': 'Id-deċiżjoni ma setgħetx tiġi ssejvjata.',
    'Proposed company change': 'Bidla proposta għall-kumpanija',
    'Opening…': 'Qed tinfetaħ…',
    'Approve this version': 'Approva din il-verżjoni',
    Decline: 'Irrifjuta',
    'Review the submitted version below. Changes made since submission will need a new request.':
      'Irrevedi l-verżjoni sottomessa hawn taħt. Bidliet li jsiru wara s-sottomissjoni jkunu jeħtieġu talba ġdida.',
    'The version submitted with this request.': 'Il-verżjoni sottomessa ma’ din it-talba.',
    'Version and proposed change': 'Verżjoni u bidla proposta',
    'Could not read the pinned content.': 'Il-kontenut ippinjat ma setax jinqara.',
    'Showing a page of {value1} characters.': 'Qed tintwera paġna b’{value1} karattru.',
    'Beginning of the submitted content. Open the full text to review every page.':
      'Il-bidu tal-kontenut sottomess. Iftaħ it-test sħiħ biex tirrevedi kull paġna.',
    'Read full submitted text': 'Aqra t-test sħiħ sottomess',
    'Previous page': 'Paġna preċedenti',
    'Next page': 'Paġna li jmiss',
    'Made private. Its creator has been told in their Inbox.':
      'Sar privat. Il-kreatur tiegħu ġie nnotifikat fl-Inbox tiegħu.',
    'Made private. Its creator could not be notified.':
      'Sar privat. Il-kreatur tiegħu ma setax jiġi nnotifikat.',
    'Make this {value1} private?': 'Tagħmel dan {value1} privat?',
    'Only the person who created it will see it. Everyone else loses access right away, and its creator gets an Inbox update if they are still a company member. If they have left, nobody in the company will be able to access this item.':
      'Se jarah biss il-persuna li ħolqitu. Kulħadd jitlef l-aċċess minnufih, u l-kreatur tiegħu jirċievi aġġornament fl-Inbox jekk għadu membru tal-kumpanija. Jekk telaq, ħadd fil-kumpanija ma jkun jista’ jaċċessa dan l-oġġett.',
    'Sent for review. The current audience stays unchanged until approval.':
      'Intbagħat għar-reviżjoni. L-udjenza attwali tibqa’ l-istess sakemm jiġi approvat.',
    'This suggestion is no longer available to you.':
      'Din is-suġġeriment m’għadux disponibbli għalik.',
    'We could not check where this suggestion stands.':
      'Ma stajniex niċċekkjaw f’liema stat jinsab dan is-suġġeriment.',
    'Check again': 'Erġa’ ċċekkja',
    'Show on page': 'Uri fuq il-paġna',
    'The editor could not be loaded. Poneva may have been updated since you opened this page. Reload to get the latest version; nothing on this page has changed.':
      'L-editur ma setax jitgħabba. Poneva jista’ jkun ġie aġġornat minn meta ftaħt din il-paġna. Erġa’ agħbbiha biex tikseb l-aħħar verżjoni; xejn fuq din il-paġna ma nbidel.',
    'Reload Poneva': 'Erġa’ agħbi Poneva',
    Formatting: 'Ifformattjar',
    'Text style': 'Stil tat-test',
    Text: 'Test',
    Heading: 'Titlu',
    Subheading: 'Sottotitlu',
    'Link a page': 'Agħmel link għal paġna',
    'A page needs a title.': 'Paġna teħtieġ titlu.',
    'Nothing has changed yet.': 'Għadu ma nbidel xejn.',
    'A page needs some text. To remove a page, archive it instead.':
      'Paġna teħtieġ xi test. Biex tneħħi paġna, arkivjaha minflok.',
    'A suggested new page needs some text.': 'Paġna ġdida ssuġġerita teħtieġ xi test.',
    'This page is larger than 256 KB. Split it into smaller pages.':
      'Din il-paġna hija akbar minn 256 KB. Aqsamha f’paġni iżgħar.',
    'Say in a few words why this change is right.':
      'Għid fi ftit kliem għaliex din il-bidla hija xierqa.',
    'This page changed while you were editing. Your text is still here: copy it, then open the latest version and make your change again.':
      'Din il-paġna nbidlet waqt li kont qed teditja. It-test tiegħek għadu hawn: ikkopjah, imbagħad iftaħ l-aħħar verżjoni u erġa’ għamel il-bidla tiegħek.',
    'Your text is copied.': 'It-test tiegħek ġie kkupjat.',
    'Your text could not be copied. Select it in the editor and copy it.':
      'It-test tiegħek ma setax jiġi kkupjat. Agħżlu fl-editur u kkopjah.',
    'The page “{value1}” is created.': 'Inħolqot il-paġna “{value1}”.',
    'New page': 'Paġna ġdida',
    'Editing {value1}': 'Qed teditja {value1}',
    Editing: 'Qed teditja',
    'Creating publishes the page under {value1} for everyone':
      'Il-ħolqien jippubblika l-paġna taħt {value1} għal kulħadd',
    'Saving publishes the new version for everyone':
      'Is-salvataġġ jippubblika l-verżjoni l-ġdida għal kulħadd',
    'Your changes are sent as a suggestion for a publisher':
      'Il-bidliet tiegħek jintbagħtu bħala suġġeriment lil pubblikatur',
    'Create page': 'Oħloq paġna',
    Save: 'Issejvja',
    'Send suggestion': 'Ibgħat suġġeriment',
    '{value1} Copy my text': '{value1} Ikkopja t-test tiegħi',
    'Open the latest version': 'Iftaħ l-aħħar verżjoni',
    'Page title': 'Titlu tal-paġna',
    'Loading the editor…': 'Qed jitgħabba l-editur…',
    'New page text': 'Test tal-paġna l-ġdida',
    'Text of {value1}': 'Test ta’ {value1}',
    'Write the page. Type [[ to link another page.':
      'Ikteb il-paġna. Ittajpja [[ biex tagħmel link għal paġna oħra.',
    'Type [[ to link another page.': 'Ittajpja [[ biex tagħmel link għal paġna oħra.',
    'Link to a page': 'Link għal paġna',
    'What changed, in a few words': 'X’inbidel, fi ftit kliem',
    'Where this comes from, in a few words': 'Minn fejn ġej dan, fi ftit kliem',
    'Shown in the page history.': 'Jintwera fl-istorja tal-paġna.',
    'A publisher sees this next to your change.': 'Pubblikatur jarah dan ħdejn il-bidla tiegħek.',
    '1 suggestion is open on this page': 'Suġġeriment wieħed huwa miftuħ fuq din il-paġna',
    '{value1} suggestions are open on this page':
      '{value1} suġġerimenti huma miftuħa fuq din il-paġna',
    'They stay open while you edit. After you save, they show against your new text; one whose words you changed is marked outdated.':
      'Jibqgħu miftuħa waqt li teditja. Wara li tissejvja, jintwerew kontra t-test il-ġdid tiegħek; dak li fih bdilt il-kliem jiġi mmarkat bħala skadut.',
    'Type [[ to link another page. Links keep working when a page is renamed or moved.':
      'Ittajpja [[ biex tagħmel link għal paġna oħra. Il-links jibqgħu jaħdmu meta paġna tibdel isimha jew tiġi mċaqilqa.',
    'Loading the history…': 'Qed titgħabba l-istorja…',
    'This page has no saved text yet.': 'Din il-paġna għad m’għandhiex test issejvjat.',
    'Say in a few words why this revision should come back.':
      'Għid fi ftit kliem għaliex għandha terġa’ tidħol din ir-reviżjoni.',
    'Revision {value1} is suggested for a publisher to accept.':
      'Ir-reviżjoni {value1} hija ssuġġerita biex pubblikatur jaċċettaha.',
    'The page already reads like this revision.':
      'Il-paġna diġà għandha l-istess test bħal din ir-reviżjoni.',
    'Revision {value1} is restored as revision {value2}.':
      'Ir-reviżjoni {value1} ġiet restawrata bħala reviżjoni {value2}.',
    'Revision history': 'Storja tar-reviżjonijiet',
    Revisions: 'Reviżjonijiet',
    'Every saved revision is kept.': 'Kull reviżjoni ssejvjata tinżamm.',
    'Revision {value1} {value2}': 'Reviżjoni {value1} {value2}',
    'Revision {value1} compared with revision {value2}':
      'Reviżjoni {value1} mqabbla mar-reviżjoni {value2}',
    'Revision {value1}, the first text of this page':
      'Reviżjoni {value1}, l-ewwel test ta’ din il-paġna',
    'Green was added, struck through was removed.':
      'L-aħdar ġie miżjud, u t-test maqsum ġie mneħħi.',
    '{value1} Export Markdown': '{value1} Esporta Markdown',
    'Restore this revision': 'Irrestawra din ir-reviżjoni',
    'Suggest restoring it': 'Issuġġerixxi li tiġi restawrata',
    'Why should this revision come back?': 'Għaliex għandha terġa’ tidħol din ir-reviżjoni?',
    'Loading this revision…': 'Qed titgħabba din ir-reviżjoni…',
    'Only the title changed, from “{value1}” to “{value2}”.':
      'Inbidel biss it-titlu, minn “{value1}” għal “{value2}”.',
    'The text did not change in this revision.': 'It-test ma nbidilx f’din ir-reviżjoni.',
    'Changes in revision {value1}': 'Bidliet fir-reviżjoni {value1}',
    'Loading page…': 'Qed titgħabba l-paġna…',
    'Loading suggestion…': 'Qed jitgħabba s-suġġeriment…',
    'This suggestion is not available.': 'Dan is-suġġeriment mhuwiex disponibbli.',
    'It may have been decided, or it is not one you can see.':
      'Jista’ jkun li ttieħed deċiżjoni dwaru, jew mhuwiex wieħed li tista’ tara.',
    'Open Knowledge': 'Iftaħ l-Għarfien',
    'Opening the suggestion…': 'Qed jinfetaħ is-suġġeriment…',
    'Choose where the page goes.': 'Agħżel fejn tmur il-paġna.',
    'Say in a few words why.': 'Għid fi ftit kliem għaliex.',
    'Your suggestion is sent. A publisher decides.':
      'Is-suġġeriment tiegħek intbagħat. Pubblikatur jieħu d-deċiżjoni.',
    'Moved under {value1}.': 'Ġiet imċaqilqa taħt {value1}.',
    'Deleted “{value1}”.': 'Tħassret “{value1}”.',
    'Could not update sharing.': 'Ma setax jiġi aġġornat il-qsim.',
    'They can follow new answers live and fork it to continue with their own connections. Only you write here. You can make it private again at any time.':
      'Jistgħu jsegwu t-tweġibiet il-ġodda b’mod dirett u jagħmlu fergħa minnu biex ikomplu bil-konnessjonijiet tagħhom. Hija int biss li tikteb hawn. Tista’ terġa’ tagħmlu privat fi kwalunkwe ħin.',
    'They see the project, its brief and the work in it they can already open. Nothing in it opens for anyone because of the project; each item keeps its own access.':
      'Jaraw il-proġett, il-qosor tiegħu u x-xogħol fih li diġà jistgħu jiftħu. Xejn fih ma jinfetaħ għal ħadd minħabba l-proġett; kull oġġett iżomm l-aċċess tiegħu.',
    'Check the content for private information before sharing. Sharing an item does not grant access to its original chat or private connections.':
      'Iċċekkja l-kontenut għal informazzjoni privata qabel taqsmu. Il-qsim ta’ oġġett ma jagħtix aċċess għaċ-chat oriġinali tiegħu jew għall-konnessjonijiet privati.',
    '{value1} Everyone you share with can read it, including what the assistant or an App in it found in your {value2}. They can’t use your {value3}. Nothing changes for you: the chat keeps working with all your accounts.':
      '{value1} Kull min taqsam miegħu jista’ jaqrah, inkluż dak li sab l-assistent jew Applikazzjoni fih fil-{value2} tiegħek. Ma jistgħux jużaw il-{value3} tiegħek. Għalik ma jinbidel xejn: iċ-chat jibqa’ jaħdem bil-kontijiet kollha tiegħek.',
    '{value1} Everyone you share with can read them, but nobody can use {value2} through this chat.':
      '{value1} Kull min taqsam magħhom jista’ jaqrahom, iżda ħadd ma jista’ juża {value2} permezz ta’ din iċ-chat.',
    'This controls access to the working draft. Any published company version stays available until you explicitly unpublish it. To publish a new version, complete its preview and use Save Skill. Run results stay private.':
      'Dan jikkontrolla l-aċċess għall-abbozz tax-xogħol. Kwalunkwe verżjoni tal-kumpanija ppubblikata tibqa’ disponibbli sakemm tneħħiha espliċitament mill-pubblikazzjoni. Biex tippubblika verżjoni ġdida, lesti l-previżjoni tagħha u uża Issejvja l-Ħila. Ir-riżultati tal-eżekuzzjoni jibqgħu privati.',
    'Skill deleted. You can restore it from the Skills archive for 30 days.':
      'Il-Ħila tħassret. Tista’ tirrestawraha mill-arkivju tal-Ħiliet għal 30 jum.',
    'Could not delete this Skill.': 'Din il-Ħila ma setgħetx titħassar.',
    'More actions': 'Aktar azzjonijiet',
    'Delete “{value1}”? It will disappear from Skills and search, and cannot be used by agents. You can restore it for 30 days. Existing chats and results stay available.':
      'Tħassar “{value1}”? Se tisparixxi mill-Ħiliet u mit-tfittxija, u ma tkunx tista’ tintuża mill-aġenti. Tista’ tirrestawraha għal 30 jum. Iċ-chats u r-riżultati eżistenti jibqgħu disponibbli.',
    'Deleting…': 'Qed jitħassar…',
    'Confirm delete': 'Ikkonferma t-tħassir',
    'Delete Skill': 'Ħassar il-Ħila',
    'Skill restored as an unpublished draft. Its author can review and publish it again.':
      'Il-Ħila ġiet restawrata bħala abbozz mhux ippubblikat. L-awtur tagħha jista’ jirrevediha u jippubblikaha mill-ġdid.',
    'Could not restore this Skill.': 'Din il-Ħila ma setgħetx tiġi rrestawrata.',
    'Archived Skills': 'Ħiliet arkivjati',
    'Deleted Skills can be restored for 30 days. Restoring leaves them unpublished.':
      'Il-Ħiliet imħassra jistgħu jiġu rrestawrati għal 30 jum. Ir-restawr iħallihom mhux ippubblikati.',
    'Restore until {value1}': 'Irrestawra sa {value1}',
    'Loading…': 'Qed jitgħabba…',
    'No archived Skills.': 'M’hemmx Ħiliet arkivjati.',
    'Load more archived Skills': 'Għabbi aktar Ħiliet arkivjati',
    'Show more of the original': 'Uri aktar mill-oriġinali',
    'Filter result rows': 'Iffiltra r-ringieli tar-riżultati',
    'Find a product or value…': 'Sib prodott jew valur…',
    '{value1} of {value2}': '{value1} minn {value2}',
    'Result table': 'Tabella tar-riżultati',
    'No matching rows.': 'M’hemmx ringieli li jaqblu.',
    'Showing the first 1,000 matching rows. Download the CSV for every row.':
      'Qed jintwerew l-ewwel 1,000 ringiela li jaqblu. Niżżel is-CSV għar-ringieli kollha.',
    'Agent ·': 'Aġent ·',
    'Only you': 'Int biss',
    'Stopped before it finished.': 'Waqqaf qabel ma lesta.',
    'Drafting the project…': 'Qed jitfassal il-proġett…',
    'Checking where this chat belongs…': 'Qed jiġi ċċekkjat fejn tappartjeni din iċ-chat…',
    'Moving the chat…': 'Qed tiġi mċaqalqa ċ-chat…',
    'Taking it out of the project…': 'Qed titneħħa mill-proġett…',
    'Adding it to the project…': 'Qed tiżdied mal-proġett…',
    'No matching connections are available right now.':
      'Bħalissa m’hemmx konnessjonijiet li jaqblu disponibbli.',
    'Company knowledge suggestion': 'Suġġeriment għall-għarfien tal-kumpanija',
    'Company knowledge now lives on pages. Open Knowledge to see them.':
      'L-għarfien tal-kumpanija issa jinsab fuq il-paġni. Iftaħ l-Għarfien biex tarahom.',
    '{value1} · Open beside this conversation': '{value1} · Iftaħ ħdejn din il-konverżazzjoni',
    'Name {value1}': 'Isem {value1}',
    'Host {value1}': 'Ospitanti {value1}',
    'Port {value1}': 'Port {value1}',
    'Database {value1}': 'Bażi tad-dejta {value1}',
    'Username {value1}': 'Isem tal-utent {value1}',
    'Password {value1}': 'Il-password {value1}',
    'Advanced TLS': 'TLS avvanzat',
    '{value1} Poneva verifies the server certificate. Add a CA or server DNS name for IP hosts when your certificate requires it.':
      '{value1} Poneva tivverifika ċ-ċertifikat tas-server. Żid CA jew isem DNS tas-server għall-hosts IP meta ċ-ċertifikat tiegħek jeħtieġ dan.',
    'CA certificate {value1}': 'Ċertifikat CA {value1}',
    'Certificate server DNS name {value1}': 'Isem DNS tas-server taċ-ċertifikat {value1}',
    '{value1} Your password is encrypted in secure storage. Poneva verifies the connection before saving it.':
      '{value1} Il-password tiegħek hija kriptata f’ħażna sigura. Poneva tivverifika l-konnessjoni qabel issalvaha.',
    'Testing…': 'Qed jiġi ttestjat…',
    'Test connection': 'Ittestja l-konnessjoni',
    'PostgreSQL is connected.': 'PostgreSQL huwa konness.',
    'PostgreSQL was saved safely.': 'PostgreSQL ġie ssejvjat b’mod sigur.',
    'Poneva can read and change rows in the selected tables. Apps also follow their approved data scope.':
      'Poneva tista’ taqra u tibdel ringieli fit-tabelli magħżula. L-Applikazzjonijiet isegwu wkoll l-ambitu tad-dejta approvat tagħhom.',
    'Poneva can read the selected tables. Apps also follow their approved data scope.':
      'Poneva tista’ taqra t-tabelli magħżula. L-Applikazzjonijiet isegwu wkoll l-ambitu tad-dejta approvat tagħhom.',
    'Reads are paused until permission is enabled.':
      'Il-qari waqaf sakemm jiġi attivat il-permess.',
    'Retrying…': 'Qed jerġa’ jipprova…',
    'Retry permission': 'Erġa’ pprova l-permess',
    'Try it in Chat': 'Ipprovaha fiċ-Chat',
    Done: 'Lest',
    'Disconnect database': 'Skonnettja l-bażi tad-dejta',
    '{value1} TLS verified ·{value2} {value3}': '{value1} TLS ivverifikat ·{value2} {value3}',
    'Search schemas and tables': 'Fittex fl-iskemi u t-tabelli',
    'Search tables': 'Fittex fit-tabelli',
    '{value1} of {value2} tables selected': '{value1} minn {value2} tabella magħżula',
    'Select matching tables': 'Agħżel it-tabelli li jaqblu',
    'Select all tables': 'Agħżel it-tabelli kollha',
    Clear: 'Neħħi',
    'Select a whole schema or individual tables. New tables need a fresh selection.':
      'Agħżel skema sħiħa jew tabelli individwali. Tabelli ġodda jeħtieġu għażla ġdida.',
    'No tables match this search.': 'L-ebda tabella ma taqbel ma’ din it-tfittxija.',
    'All tables in {value1}': 'It-tabelli kollha f’{value1}',
    '{value1} / {value2} tables': '{value1} / {value2} tabelli',
    'Read & write available': 'Qari u kitba disponibbli',
    'Read only': 'Qari biss',
    Ctrl: 'Ctrl',
    'This suggested knowledge update could not be shown.':
      'Dan l-aġġornament issuġġerit tal-għarfien ma setax jintwera.',
    'Suggested knowledge update': 'Aġġornament issuġġerit tal-għarfien',
    'Suggestion {value1} of {value2}': 'Suġġeriment {value1} minn {value2}',
    'Next suggestion': 'Suġġeriment li jmiss',
    'Fold the suggestions away': 'Aħbi s-suġġerimenti',
    'Show the suggestions': 'Uri s-suġġerimenti',
    '1 suggestion': 'Suġġeriment 1',
    '{value1} suggestions': '{value1} suġġerimenti',
    '{value1} the pages under {value2}': '{value1} il-paġni taħt {value2}',
    px: 'px',
    '{value1} chart of {value2} across {value3}': 'Grafika {value1} ta’ {value2} fuq {value3}',
    'We could not build the file.': 'Ma stajniex nibnu l-fajl.',
    '{value1} Present': '{value1} preżenti',
    'Building…': 'Qed jinbena…',
    'Download PowerPoint': 'Niżżel PowerPoint',
    'Slide {value1} of {value2}': 'Slajd {value1} minn {value2}',
    Slides: 'Slajds',
    'Slide {value1}': 'Slajd {value1}',
    'Speaker notes': 'Noti tal-kelliem',
    'Source: {value1}': 'Sors: {value1}',
    'Add a name and a web address.': 'Żid isem u indirizz tal-web.',
    'Enter a valid web address.': 'Daħħal indirizz tal-web validu.',
    'Use a web address that starts with https://.': 'Uża indirizz tal-web li jibda b’https://.',
    'Add a custom connection': 'Żid konnessjoni personalizzata',
    'Connect a tool server you trust. Poneva checks the address works and saves only the connection details needed to use it.':
      'Qabbad server tal-għodod li tafda. Poneva jivverifika li l-indirizz jaħdem u jissejvja biss id-dettalji tal-konnessjoni meħtieġa biex tużah.',
    'Web address': 'Indirizz tal-web',
    'https://tools.example.com': 'https://tools.example.com',
    'Starts with https://, from your provider': 'Jibda b’https://, mingħand il-fornitur tiegħek',
    'Sign-in': 'Aċċess',
    'Advanced sign-in': 'Aċċess avvanzat',
    'Access key {value1}': 'Ċavetta tal-aċċess {value1}',
    'Request headers': 'Headers tat-talba',
    'Add header': 'Żid header',
    'Header {value1} name': 'Isem tal-header {value1}',
    'Header name': 'Isem tal-header',
    'Header {value1} value': 'Valur tal-header {value1}',
    'Header value': 'Valur tal-header',
    'Remove header': 'Neħħi l-header',
    Advanced: 'Avvanzat',
    Transport: 'Trasport',
    'Auto-detect': 'Sejbien awtomatiku',
    'Streamable HTTP': 'HTTP li jista’ jintuża għall-istrimjar',
    'Legacy SSE': 'SSE legat',
    "From your provider's app settings. Leave empty unless they gave you these.":
      'Mis-settings tal-app tal-fornitur tiegħek. Ħallihom vojta sakemm ma jkunux tawhielek.',
    "Authorization server issuer": "Emittent tas-server tal-awtorizzazzjoni",
    "Enter the authorization server issuer when using a client ID.": "Daħħal l-emittent tas-server tal-awtorizzazzjoni meta tuża ID tal-klijent.",
    'Client ID {value1}': 'ID tal-klijent {value1}',
    'Client secret {value1}': 'Sigriet tal-klijent {value1}',
    'Connecting…': 'Qed tikkonnettja…',
    'Test and connect': 'Ittestja u qabbad',
    'Add the store, the client ID and the client secret.':
      'Żid il-ħanut, l-ID tal-klijent u s-sigriet tal-klijent.',
    'Connect your Shopify Developer App': 'Qabbad l-App tal-Iżviluppatur ta’ Shopify tiegħek',
    'Poneva can use exactly the access your store gave the app, and nothing more. It talks to Shopify directly and keeps the client secret encrypted.':
      'Poneva jista’ juża eżattament l-aċċess li l-ħanut tiegħek ta lill-app, u xejn aktar. Jikkonnettja ma’ Shopify direttament u jżomm is-sigriet tal-klijent kriptat.',
    'How to create the app in Shopify': 'Kif toħloq l-app fi Shopify',
    'Open{value1} {value2}{value3} with the account that owns the store, and create an app.':
      'Iftaħ{value1} {value2}{value3} bil-kont li għandu l-ħanut, u oħloq app.',
    'Create a version and select the access scopes Poneva may use, for example read_products and read_orders. Add write_ scopes only for data Poneva may change. Then release the version.':
      'Oħloq verżjoni u agħżel l-iskopijiet tal-aċċess li Poneva jista’ juża, pereżempju read_products u read_orders. Żid l-iskopijiet write_ biss għad-dejta li Poneva jista’ jibdel. Imbagħad ippubblika l-verżjoni.',
    'For orders and customers, also select protected customer data in the app’s settings. Shopify allows this without review for an app made for your own store.':
      'Għall-ordnijiet u l-klijenti, agħżel ukoll id-dejta protetta tal-klijenti fis-settings tal-app. Shopify jippermetti dan mingħajr reviżjoni għal app magħmula għall-ħanut tiegħek stess.',
    'Install the app on your store.': 'Installa l-app fil-ħanut tiegħek.',
    'Copy the client ID and client secret from the app’s settings.':
      'Ikkopja l-ID tal-klijent u s-sigriet tal-klijent mis-settings tal-app.',
    'To change the access later, release a new version, approve it on the store and use Test connection here.':
      'Biex tibdel l-aċċess aktar tard, ippubblika verżjoni ġdida, approvaha fil-ħanut u uża “Ittestja l-konnessjoni” hawnhekk.',
    Store: 'Ħanut',
    'your-store.myshopify.com': 'your-store.myshopify.com',
    'Your store’s .myshopify.com address (Shopify admin → Settings → Domains), or paste the address of your Shopify admin page':
      'L-indirizz .myshopify.com tal-ħanut tiegħek (l-amministrazzjoni ta’ Shopify → Settings → Domains), jew waħħal l-indirizz tal-paġna tal-amministrazzjoni ta’ Shopify tiegħek',
    'Client ID {value1} {value2}': 'ID tal-klijent {value1} {value2}',
    'Client secret {value1} {value2}': 'Sigriet tal-klijent {value1} {value2}',
    Person: 'Persuna',
    Everyone: 'Kulħadd',
    Connection: 'Konnessjoni',
    'All connections': 'Il-konnessjonijiet kollha',
    'App {value1}': 'Applikazzjoni {value1}',
    'From {value1}': 'Minn {value1}',
    'Until {value1}': 'Sa {value1}',
    Result: 'Riżultat',
    'All results': 'Ir-riżultati kollha',
    Succeeded: 'Irnexxa',
    Denied: 'Miċħud',
    Failed: 'Falla',
    Unknown: 'Mhux magħruf',
    Filter: 'Iffiltra',
    'Loading activity…': 'Qed titgħabba l-attività…',
    'Could not load activity. Try again.': 'Ma setgħetx titgħabba l-attività. Erġa’ pprova.',
    'Removed connection': 'Konnessjoni mneħħija',
    'App: {value1}': 'Applikazzjoni: {value1}',
    'Older activity': 'Attività aktar antika',
    'Archived. Its history is kept.': 'Arkivjata. L-istorja tagħha tinżamm.',
    'Choose the page it goes under. Links to it keep working.':
      'Agħżel il-paġna li taħtha se titqiegħed. Il-links għaliha jibqgħu jaħdmu.',
    'Its text, its history and any open suggestions are removed for good, and links to it from other pages stop working. This cannot be undone.':
      'It-test, l-istorja u kwalunkwe suġġeriment miftuħ jitneħħew għal dejjem, u l-links għaliha minn paġni oħra ma jibqgħux jaħdmu. Din l-azzjoni ma tistax titneħħa.',
    'An archived page no longer informs answers. Its history is kept, and a publisher can restore it or delete it permanently.':
      'Paġna arkivjata ma tibqax tintuża fit-tweġibiet. L-istorja tagħha tinżamm, u pubblikatur jista’ jirrestawraha jew iħassarha għal dejjem.',
    Under: 'Taħt',
    Change: 'Ibdel',
    'Move under': 'Mexxi taħt',
    'Search pages': 'Fittex fil-paġni',
    'Why?': 'Għaliex?',
    'Delete permanently': 'Ħassar għal dejjem',
    'Move page': 'Mexxi l-paġna',
    'Archive page': 'Arkivja l-paġna',
    'Suggestion {value1}: show its card': 'Suġġeriment {value1}: uri l-kard tiegħu',
    'Removed:': 'Imneħħija:',
    'Added:': 'Miżjuda:',
    'New page “{value1}”{value2}': 'Paġna ġdida “{value1}”{value2}',
    'No pages match “{value1}”.': 'L-ebda paġna ma taqbel ma’ “{value1}”.',
    'Where this page is': 'Fejn tinsab din il-paġna',
    'Describe your company': 'Iddeskrivi l-kumpanija tiegħek',
    'Empty page': 'Paġna vojta',
    'Describe {value1}': 'Iddeskrivi {value1}',
    'This page has no text yet.': 'Din il-paġna għad m’għandhiex test.',
    'Poneva reads this page before every answer. Start with who you are, what you sell and how you work; details go on the pages under it.':
      'Poneva taqra din il-paġna qabel kull tweġiba. Ibda b’min int, x’tbigħ u kif taħdem; id-dettalji jitpoġġew fil-paġni ta’ taħtha.',
    'Write it, or ask Poneva in chat to draft it for you.':
      'Iktibha, jew staqsi lil Poneva fiċ-chat biex tfassalha għalik.',
    'Suggest a first version, and a publisher decides whether it becomes the page.':
      'Issuġġerixxi l-ewwel verżjoni, u pubblikatur jiddeċiedi jekk issirx il-paġna.',
    'Start writing': 'Ibda ikteb',
    'Suggest a first version': 'Issuġġerixxi l-ewwel verżjoni',
    'Accepted. The page is archived.': 'Aċċettata. Il-paġna ġiet arkivjata.',
    'Accepted. The page is now revision {value1}.':
      'Aċċettata. Il-paġna issa tinsab fir-reviżjoni {value1}.',
    'Accepted.': 'Aċċettata.',
    'Suggestion rejected. The page stays as it is.':
      'Is-suġġeriment ġie rrifjutat. Il-paġna tibqa’ kif inhi.',
    'Your suggestion is withdrawn.': 'Is-suġġeriment tiegħek ġie rtirat.',
    'Restored. The page informs answers again.':
      'Ġiet irrestawrata. Il-paġna terġa’ tintuża fit-tweġibiet.',
    'Your suggestion is sent. A publisher decides whether it becomes the page.':
      'Is-suġġeriment tiegħek intbagħat. Pubblikatur jiddeċiedi jekk isirx il-paġna.',
    'Saved. The page is now revision {value1}.':
      'Ġiet salvata. Il-paġna issa tinsab fir-reviżjoni {value1}.',
    'Nothing changed.': 'Ma nbidel xejn.',
    'This page is not available.': 'Din il-paġna mhijiex disponibbli.',
    'It may have been deleted, archived or moved out of reach, or you may no longer be in this company.':
      'Jista’ jkun li tħassret, ġiet arkivjata jew tmexxiet ’il barra mill-aċċess tiegħek, jew li m’għadekx f’din il-kumpanija.',
    'Page actions': 'Azzjonijiet tal-paġna',
    shown: 'murija',
    hidden: 'moħbija',
    '{value1} History': 'L-istorja ta’ {value1}',
    '{value1} Ask in chat': 'Staqsi dwar {value1} fiċ-chat',
    'Suggest edits': 'Issuġġerixxi bidliet',
    'More actions for {value1}': 'Aktar azzjonijiet għal {value1}',
    '{value1} Poneva reads this page in every chat':
      '{value1} Poneva taqra din il-paġna f’kull chat',
    'This page is archived. It no longer informs answers; its history is kept. {value1}':
      'Din il-paġna hija arkivjata. Ma tibqax tintuża fit-tweġibiet; l-istorja tagħha tinżamm. {value1}',
    'Restore page': 'Irrestawra l-paġna',
    'This link points to an earlier revision. You are reading the current text.':
      'Dan il-link jindika reviżjoni preċedenti. Qed taqra t-test attwali.',
    'Show it in History': 'Uriha fl-Istorja',
    Pages: 'Paġni',
    'Pages under {value1}': 'Paġni taħt {value1}',
    'Linked from': 'Linked minn',
    Suggestions: 'Suġġerimenti',
    'Suggestions are hidden. You are reading the page as everyone else sees it.':
      'Is-suġġerimenti huma moħbija. Qed taqra l-paġna kif jarawha l-oħrajn.',
    'Loading suggestions…': 'Qed jitgħabbew is-suġġerimenti…',
    'Nothing is waiting for review.': 'M’hemm xejn jistenna reviżjoni.',
    'When someone, Poneva in a chat or a connected agent suggests a change to a page, it shows here and on the page. Nothing changes until a publisher accepts it.':
      'Meta xi ħadd, Poneva fi chat jew aġent konness jissuġġerixxi bidla f’paġna, din tidher hawn u fuq il-paġna. Ma jinbidel xejn sakemm pubblikatur ma jaċċettahiex.',
    '{value1} Review knowledge in chat': '{value1} Irrevedi l-għarfien fiċ-chat',
    'Suggestions for review': 'Suġġerimenti għal reviżjoni',
    'Suggested changes from chats, meetings, colleagues and connected agents. Nothing changes until a publisher accepts it on the page.':
      'Bidliet issuġġeriti minn chats, laqgħat, kollegi u aġenti konnessi. Ma jinbidel xejn sakemm pubblikatur ma jaċċettahomx fuq il-paġna.',
    'Your suggestions wait here until a publisher decides. The pages stay as they are until then.':
      'Is-suġġerimenti tiegħek jibqgħu hawn sakemm jiddeċiedi pubblikatur. Sa dak iż-żmien, il-paġni jibqgħu kif inhuma.',
    'Review page': 'Irrevedi l-paġna',
    'Review on page': 'Irrevedi fuq il-paġna',
    'Open the meeting': 'Iftaħ il-laqgħa',
    'Open the chat': 'Iftaħ iċ-chat',
    'Accept and restore': 'Aċċetta u rrestawra',
    Accept: 'Aċċetta',
    Reject: 'Irrifjuta',
    'Your suggestion · waiting for a publisher':
      'Is-suġġeriment tiegħek · qed jistenna pubblikatur',
    Withdraw: 'Irtira',
    'Waiting for a publisher': 'Qed jistenna pubblikatur',
    'Suggestion {value1}': 'Suġġeriment {value1}',
    'Suggestion {value1} from {value2}{value3}': 'Suġġeriment {value1} mingħand {value2}{value3}',
    'Read the suggested page': 'Aqra l-paġna ssuġġerita',
    'Outdated: the text it changes was edited after it was suggested. It can be rejected or withdrawn; a new suggestion can be made against the current text.':
      'Skadut: it-test li jbiddel ġie editjat wara li ġie ssuġġerit. Jista’ jiġi rrifjutat jew irtirat; jista’ jsir suġġeriment ġdid abbażi tat-test attwali.',
    'Restore this page first to accept this suggestion.':
      'L-ewwel irrestawra din il-paġna biex taċċetta dan is-suġġeriment.',
    'Previous suggestion': 'Suġġeriment preċedenti',
    Download: 'Niżżel',
    CSV: 'CSV',
    'Evidence for {value1}': 'Evidenza għal {value1}',
    Measure: 'Kejl',
    'Show rows →': 'Uri r-ringieli →',
    'Ask about this number': 'Staqsi dwar dan in-numru',
    'There are no numeric values available to chart. View the table for the original data.':
      "M'hemmx valuri numeriċi disponibbli għall-grafika. Ara t-tabella għad-dejta oriġinali.",
    'Chart value': 'Valur tal-grafika',
    '{value1} of {value2} shown': '{value1} minn {value2} murija',
    '{value1} by {value2}; {value3} rows. View Table for exact values.':
      "{value1} b'{value2}; {value3} ringieli. Ara t-Tabella għall-valuri eżatti.",
    'Values come directly from the source data. Missing values are not estimates.':
      'Il-valuri ġejjin direttament mid-dejta tas-sors. Il-valuri neqsin mhumiex stimi.',
    'Loading library…': 'Qed titgħabba l-librerija…',
    'We couldn’t load what happened in this App. Try again in a moment.':
      "Ma stajniex nitgħabbew dak li ġara f'din l-App. Erġa' pprova wara ftit.",
    'This App could not be opened.': 'Din l-App ma setgħetx tinfetaħ.',
    'Opening App…': 'Qed tinfetaħ l-App…',
    'Open the saved App to run this function.': 'Iftaħ l-App salvata biex tħaddem din il-funzjoni.',
    'Save this App before running its function.':
      'Issejvja din l-App qabel ma tħaddem il-funzjoni tagħha.',
    'Open saved App': 'Iftaħ l-App salvata',
    'Open Apps': 'Iftaħ l-Apps',
    'The App could not be opened. Try again.': "L-App ma setgħetx tinfetaħ. Erġa' pprova.",
    Owner: 'Sid',
    '{value1} · admins': '{value1} · amministraturi',
    'Owner · always edits': "Sid · dejjem jista' jeditja",
    'Admins manage it': 'L-amministraturi jimmaniġġjawha',
    Editors: 'Edituri',
    'A colleague': 'Kollega',
    'Can edit drafts and publish versions': "Jista' jeditja l-abbozzi u jippubblika l-verżjonijiet",
    Remove: 'Neħħi',
    'No editors yet.': "Għad m'hemmx edituri.",
    'Admins can always edit company agents.':
      'L-amministraturi jistgħu dejjem jeditjaw l-aġenti tal-kumpanija.',
    'Asking for edit access': 'Qed tintalab aċċess għall-editjar',
    'Asked {value1} · also in your Inbox': 'Mitlub {value1} · ukoll fl-Inbox tiegħek',
    Grant: 'Agħti aċċess',
    Admin: 'Amministratur',
    'Make personal': 'Agħmilha personali',
    'Switch off': 'Itfi',
    Archive: 'Arkivja',
    'Archive this agent': 'Arkivja dan l-aġent',
    'Loading agent…': 'Qed jitgħabba l-aġent…',
    '{value1} Edit in chat': '{value1} Editja fiċ-chat',
    Agent: 'Aġent',
    'This agent has not been created yet. It can run once its owner creates it.':
      "Dan l-aġent għadu ma nħoloqx. Jista' jitħaddem meta s-sid tiegħu joħolqu.",
    'New agent · Draft': 'Aġent ġdid · Abbozz',
    'Untitled agent': 'Aġent mingħajr titlu',
    'Test run': "Ħaddim ta' prova",
    'This draft does not run automatically.': 'Dan l-abbozz ma jitħaddimx awtomatikament.',
    'Describe the agent in the chat. Its draft appears here.':
      'Iddeskrivi l-aġent fiċ-chat. L-abbozz tiegħu jidher hawn.',
    '{value1} Test run': "{value1} Ħaddim ta' prova",
    'Describe the agent in the chat first.': 'L-ewwel iddeskrivi l-aġent fiċ-chat.',
    'Create and turn on': 'Oħloq u ixgħel',
    'Connection write setup': 'Konfigurazzjoni tal-kitba tal-konnessjoni',
    'Account for connected changes': 'Kont għall-bidliet permezz tal-konnessjoni',
    'Choose a connection': 'Agħżel konnessjoni',
    'No published Skills available. You can add them later.':
      "M'hemmx Ħiliet ippubblikati disponibbli. Tista' żżidhom aktar tard.",
    '{value1} · not published. Review the changes. Testing is optional.':
      '{value1} · mhux ippubblikat. Irrevedi l-bidliet. L-ittestjar mhux obbligatorju.',
    '{value1} Test draft': '{value1} Ittestja l-abbozz',
    'Apply changes…': 'Applika l-bidliet…',
    'Apply this draft as a new version': 'Applika dan l-abbozz bħala verżjoni ġdida',
    'This draft cannot be applied.': 'Dan l-abbozz ma jistax jiġi applikat.',
    'What changed?': "X'inbidel?",
    'Apply version {value1}': 'Applika l-verżjoni {value1}',
    Create: 'Oħloq',
    'Edit access requested': 'Intalab aċċess għall-editjar',
    '{value1} Request edit access': '{value1} Itlob aċċess għall-editjar',
    '{value1} Copy agent': '{value1} Ikkopja l-aġent',
    Pause: 'Issospendi',
    'Open agent: {value1}': 'Iftaħ l-aġent: {value1}',
    '· you can edit': "· tista' teditja",
    '{value1} is switched off.': '{value1} huwa mitfi.',
    '{value1} is archived.': '{value1} huwa arkivjat.',
    'Loading agents…': 'Qed jitgħabbew l-aġenti…',
    Agents: 'Aġenti',
    'Agents do work for you on a schedule or when you ask. They follow your company’s Skills.':
      'L-aġenti jaħdmu għalik skont skeda jew meta titlobhom. Huma jsegwu l-Ħiliet tal-kumpanija tiegħek.',
    'No agent matches. Try a Skill name or what the agent should do.':
      "L-ebda aġent ma jaqbel. Ipprova isem ta' Ħila jew iddeskrivi x'għandu jagħmel l-aġent.",
    'Nothing of your own yet': "Għad m'għandek xejn tiegħek",
    'Tell Chat what an agent should do, or copy one of the company’s agents below.{value1}':
      "Għid lil Chat x'għandu jagħmel aġent, jew ikkopja wieħed mill-aġenti tal-kumpanija hawn taħt.{value1}",
    'Your agents': 'L-aġenti tiegħek',
    'Run on demand': 'Ħaddem meta mitlub',
    'Run is always available. A schedule is optional and lives separately from the agent’s instructions.':
      'It-tħaddim huwa dejjem disponibbli. Skeda mhijiex obbligatorja u tinżamm separatament mill-istruzzjonijiet tal-aġent.',
    'Enable this schedule when approved': 'Ippermetti din l-iskeda meta tiġi approvata',
    Schedule: 'Skeda',
    'Kept off until you create the agent from its canvas.':
      "Se tibqa' mitfija sakemm toħloq l-aġent mill-kanvas tiegħu.",
    'Will be enabled when you approve.': 'Se tiġi attivata meta tapprovaha.',
    'Will be saved paused. You can enable it later.':
      "Se tiġi ssejvjata waqfa. Tista' tattivaha aktar tard.",
    'Only runs when you ask.': 'Titħaddem biss meta titlobha.',
    'Draft · approving saves it, and nothing runs. Test it and create it from its canvas.':
      'Abbozz · l-approvazzjoni tissejvjah, u ma jitħaddem xejn. Ittestjah u oħloq l-aġent mill-kanvas tiegħu.',
    'Draft · nothing is scheduled until you approve. Connected actions require their own approval at run time.':
      'Abbozz · ma tiġi skedata xejn sakemm tapprova. L-azzjonijiet konnessi jeħtieġu l-approvazzjoni tagħhom meta jitħaddmu.',
    Name: 'Isem',
    'Agent name': 'Isem tal-aġent',
    'Who can use it': "Min jista' jużah",
    'Company agent · company resources only': 'Aġent tal-kumpanija · riżorsi tal-kumpanija biss',
    'Personal agent · runs with your access': 'Aġent personali · jitħaddem bl-aċċess tiegħek',
    'Approving saves it as a draft. It does not run automatically.':
      'L-approvazzjoni tissejvjah bħala abbozz. Ma jitħaddemx awtomatikament.',
    'Open the agent’s runs': 'Iftaħ l-eżekuzzjonijiet tal-aġent',
    'Run the published version once': 'Ħaddem il-verżjoni ppubblikata darba',
    'Stopping…': 'Qed jitwaqqaf…',
    'Stop run': 'Waqqaf l-eżekuzzjoni',
    'Could not stop this run. Please try again.':
      "Ma setgħetx titwaqqaf din l-eżekuzzjoni. Erġa' pprova.",
    'Run in progress': 'Eżekuzzjoni għaddejja',
    'This run is still answering. You can ask follow-ups when it finishes.':
      "Din l-eżekuzzjoni għadha qed twieġeb. Tista' tistaqsi mistoqsijiet ta' segwitu meta tispiċċa.",
    'Open run details': 'Iftaħ id-dettalji tal-eżekuzzjoni',
    Runs: 'Eżekuzzjonijiet',
    'Open the run chat': 'Iftaħ iċ-chat tal-eżekuzzjoni',
    Watch: 'Ara',
    Goal: 'Għan',
    'Change the goal': 'Ibdel l-għan',
    'What it does': "X'jagħmel",
    'What should this agent achieve?': "X'għandu jikseb dan l-aġent?",
    'Not set yet.': 'Għadu mhux issettjat.',
    'When it runs': 'Meta jitħaddem',
    'Change when it runs': 'Ibdel meta jitħaddem',
    'Off means it runs only when someone runs it. Changing when it runs never changes its instructions.':
      'Mitfi jfisser li jitħaddem biss meta xi ħadd iħaddmu. Li tibdel meta jitħaddem qatt ma jbiddel l-istruzzjonijiet tiegħu.',
    Instructions: 'Istruzzjonijiet',
    'Change the instructions': 'Ibdel l-istruzzjonijiet',
    'How the agent should approach the work and make decisions.':
      'Kif l-aġent għandu javviċina x-xogħol u jieħu d-deċiżjonijiet.',
    Boundaries: 'Limiti',
    'What to do or avoid. Every connected action still follows its approval.':
      "X'għandu jagħmel jew jevita. Kull azzjoni konnessa xorta ssegwi l-approvazzjoni tagħha.",
    'No instructions of its own. It follows its Skills.':
      "M'għandux istruzzjonijiet tiegħu. Issegwi l-Ħiliet tiegħu.",
    'Pin a Skill': 'Pin Ħila',
    'Finds the Skills that fit each run, the same way a chat does.':
      "Isib il-Ħiliet li jaqblu ma' kull eżekuzzjoni, bl-istess mod bħal chat.",
    'Skills it always follows': 'Ħiliet li dejjem isegwi',
    'A Skill that is not published': 'Ħila li mhix ippubblikata',
    'Always follows · Version {value1}': 'Dejjem isegwi · Verżjoni {value1}',
    'Not published': 'Mhix ippubblikata',
    Uses: 'Juża',
    'Change in chat': 'Ibdel fiċ-chat',
    'Change in chat: Uses': 'Ibdel fiċ-chat: Juża',
    'Company knowledge and the tools each run is allowed to use.':
      'L-għarfien tal-kumpanija u l-għodod li kull eżekuzzjoni għandha permess tuża.',
    'People see the Result refresh; they change the agent, not the page.':
      'In-nies jaraw ir-Riżultat jiġġedded; jibdlu l-aġent, mhux il-paġna.',
    'The first run after it is created makes the Result; later runs add a version to it.':
      "L-ewwel eżekuzzjoni wara li jinħoloq toħloq ir-Riżultat; l-eżekuzzjonijiet ta' wara jżidu verżjoni miegħu.",
    'Emails whoever the run is for': 'Jibgħat email lil min hi maħsuba għalih l-eżekuzzjoni',
    'Email each run': 'Ibgħat email għal kull eżekuzzjoni',
    Delivers: 'Iwassal',
    'Change what it delivers': 'Ibdel dak li jwassal',
    'Expected result': 'Riżultat mistenni',
    'What a successful run should deliver.': 'Dak li għandha twassal eżekuzzjoni li tirnexxi.',
    'What each run delivers': 'Dak li twassal kull eżekuzzjoni',
    'Keeps one Result up to date {value1}': 'Iżomm Riżultat wieħed aġġornat {value1}',
    'Saves a new Result each run': "Jissejvja Riżultat ġdid f'kull eżekuzzjoni",
    'You can run this company agent as yourself.{value1} {value2}':
      "Tista' tħaddem dan l-aġent tal-kumpanija bħala lilek innifsek.{value1} {value2}",
    'Changes since version': 'Bidliet mill-verżjoni',
    'are not live yet.': 'għadhomx attivi.',
    'Review them in Versions': 'Irrevedihom fil-Verżjonijiet',
    Skill: 'Ħila',
    'The agent always uses the Skill’s published version.':
      'L-aġent dejjem juża l-verżjoni ppubblikata tal-Ħila.',
    Day: 'Jum',
    Time: 'Ħin',
    'Cron expression': 'Espressjoni Cron',
    'Editors and access': 'Edituri u aċċess',
    Company: 'Kumpanija',
    Personal: 'Personali',
    'No changes.': 'L-ebda bidla.',
    'Instructions changes': 'Bidliet fl-istruzzjonijiet',
    'Loading versions…': 'Qed jitgħabbew il-verżjonijiet…',
    'What the draft changes': "X'jibdel l-abbozz",
    'No published version yet. Try the draft, then publish it.':
      "Għad m'hemmx verżjoni ppubblikata. Ipprova l-abbozz, imbagħad ippubblikah.",
    'Published versions': 'Verżjonijiet ippubblikati',
    'Former member': 'Eks-membru',
    Live: 'Attiv',
    'What changed in version {value1}': 'X’inbidel fil-verżjoni {value1}?',
    'Every publish is a version you can restore.':
      'Kull pubblikazzjoni hija verżjoni li tista’ tirrestawra.',
    Authorization: 'Awtorizzazzjoni',
    '{value1} {value2} · {value3} will see it.': '{value1} {value2} · {value3} se jarawha.',
    '{value1} {value2} you': '{value1} {value2} lilek',
    '· Revised': '· Rivedut',
    'This chat used your {value1}.': 'Din il-konversazzjoni użat {value1} tiegħek.',
    'This chat has results from {value1}.':
      'Din il-konversazzjoni għandha riżultati minn {value1}.',
    'db.example.com': 'db.example.com',
    'e.g. Product analytics': 'eż. Analitika tal-prodott',
    'Paste access key': 'Waħħal iċ-ċavetta tal-aċċess',
    'Shopify’s Dev Dashboard': 'Shopify’s Dev Dashboard',
    'App reference': 'Referenza tal-app',
    'Draft · revision {value1}': 'Abbozz · reviżjoni {value1}',
    'its Result': 'Ir-Riżultat tiegħu',
    '· its first run makes it': '· l-ewwel tħaddim tiegħu jagħmlu',
    '{value1}’s chat ·': 'Iċ-chat ta’ {value1} ·',
    '{value1} ad {value2} available.': '{value1} u {value2} disponibbli.',
    '{value1} rows ·': '{value1} ringieli ·',
    'It starts private. Sharing it wider shares every refresh, which can carry your private data.':
      'Jibda privat. Il-qsim tiegħu ma’ udjenza usa’ jaqsam kull aġġornament, li jista’ jinkludi d-dejta privata tiegħek.',
    '{value1} for {value2}': '{value1} għal {value2}',
    Suggested: 'Suġġerit',
    'Opening your conversation…': 'Qed niftħu l-konversazzjoni tiegħek…',
    'This conversation isn’t available': 'Din il-konversazzjoni mhijiex disponibbli',
    'It may have been deleted, belong to another account, or be temporarily unavailable.':
      'Jista’ jkun li tħassret, tappartjeni għal kont ieħor, jew mhijiex disponibbli temporanjament.',
    '{count} more line — shown in the complete revision':
      'Linja oħra {count} — murija fir-reviżjoni sħiħa',
    '{count} more lines — shown in the complete revision':
      '{count} linji oħra — murija fir-reviżjoni sħiħa',
    '{count} more line removed': 'Tneħħiet linja oħra {count}',
    '{count} more lines removed': 'Tneħħew {count} linji oħra',
    '{count} unchanged line': '{count} linja ma nbidlitx',
    '{count} unchanged lines': '{count} linji ma nbidlux',
    '{count} more lines not shown, {added} added and {removed} removed. Check them in the complete revision.':
      '{count} linja oħra mhumiex murija, {added} miżjuda u {removed} imneħħija. Iċċekkjahom fir-reviżjoni sħiħa.',
    'Saved result': 'Riżultat salvat',
    'Made with a Skill': 'Magħmul b’Ħila',
    'Preview of {name}': 'Previżjoni ta’ {name}',
    'Made with {name}': 'Magħmul b’{name}',
    'Ad-hoc result': 'Riżultat ad hoc',
    'A Skill that is not available in this workspace':
      'Ħila li mhijiex disponibbli f’dan l-ispazju tax-xogħol',
    '{name} · Revision {version}': '{name} · Reviżjoni {version}',
    '{name} · Version {version}': '{name} · Verżjoni {version}',
    'Return to conversation {value1}': 'Erġa’ lura għall-konversazzjoni {value1}',
    '{value1} Working with {value2}': '{value1} Qed naħdem ma’ {value2}',
    'View context {value1}': 'Ara l-kuntest {value1}',
    'A way of working, made yours.': 'Mod kif taħdem, magħmul għalik.',
    'Work that runs itself.': 'Xogħol li jmexxi lilu nnifsu.',
    'One place for one piece of work.': 'Post wieħed għal biċċa xogħol waħda.',
    'Let’s move your work forward{value1}.': 'Ejja navvanzaw ix-xogħol tiegħek{value1}.',
    'Describe the work. Your Skill takes shape beside the conversation.':
      'Iddeskrivi x-xogħol. Il-Ħila tiegħek tieħu forma ħdejn il-konversazzjoni.',
    'Describe what it should do and when. Your agent takes shape beside the conversation. The draft does not run automatically.':
      'Iddeskrivi x’għandha tagħmel u meta. L-aġent tiegħek jieħu forma ħdejn il-konversazzjoni. L-abbozz ma jitħaddimx awtomatikament.',
    'Say what the work is. Poneva drafts the project beside the conversation and brings in what you have already done. Nothing is created until you say so.':
      'Għid x’inhu x-xogħol. Poneva jabbozza l-proġett ħdejn il-konversazzjoni u jdaħħal dak li diġà għamilt. Ma jinħoloq xejn sakemm ma tgħidx hekk.',
    'Start with an idea below. Poneva will take it from there.':
      'Ibda b’idea hawn taħt. Poneva jieħu ħsieb il-bqija.',
    Triggers: 'Attivaturi',
    'Review the agent and its trigger. Approval applies exactly what is shown.':
      'Irrevedi l-aġent u l-attivatur tiegħu. L-approvazzjoni tapplika eżattament dak li jidher.',
    '{source} · read {date}': '{source} · inqara {date}',
    'Evidence is being recorded · read {date}': 'L-evidenza qed tiġi rreġistrata · inqara {date}',
    'Evidence expired on {date} under the retention policy':
      'L-evidenza skadiet fi {date} skont il-politika taż-żamma',
    'Entered by {person}': 'Imdaħħla minn {person}',
    'No retained evidence for this value': 'M’hemmx evidenza miżmuma għal dan il-valur',
    'Covers {shown} of {total} rows': 'Ikopri {shown} minn {total} ringiela',
    'Search rows': 'Fittex fir-ringieli',
    'Clear filters': 'Neħħi l-filtri',
    Sort: 'Issortja',
    'Sort: {column}': 'Issortja: {column}',
    '{shown} of {total} rows': '{shown} minn {total} ringiela',
    More: 'Aktar',
    Density: 'Densità',
    Comfortable: 'Komda',
    Compact: 'Kompatti',
    Columns: 'Kolonni',
    'No rows match. Clear the search or filters to see them again.':
      'L-ebda ringiela ma taqbel. Neħħi t-tfittxija jew il-filtri biex terġa’ tarahom.',
    'Not available': 'Mhux disponibbli',
    'All rows': 'Ir-ringieli kollha',
    'Close row detail': 'Agħlaq id-dettalji tar-ringiela',
    'Ask about this row': 'Staqsi dwar din ir-ringiela',
    'Add note': 'Żid nota',
    Note: 'Nota',
    Saved: 'Salvat',
    Total: 'Totali',
    ascending: 'tiela’',
    descending: 'nieżel',
    'Scroll to see all columns': 'Skrollja biex tara l-kolonni kollha',
    App: 'Applikazzjoni',
    Artifact: 'Artefatt',
    'New project': 'Proġett ġdid',
    'Review request': 'Talba għal reviżjoni',
    Activity: 'Attività',
    'Voice preview': 'Previżjoni tal-vuċi',
    Source: 'Sors',
    File: 'Fajl',
    Meeting: 'Laqgħa',
    'Knowledge page': 'Paġna tal-għarfien',
    'Could not preview this CSV.': 'Ma stajniex nipprevedu dan is-CSV.',
    'File content is unavailable.': 'Il-kontenut tal-fajl mhuwiex disponibbli.',
    'You have five open suggestions here. {value1} will see them.':
      'Għandek ħames suġġerimenti miftuħa hawn. {value1} se jarahom.',
    'We could not send your suggestion. Please try again.':
      'Ma stajniex nibagħtu s-suġġeriment tiegħek. Erġa’ pprova.',
    'The agent': 'L-aġent',
    'Selected colleagues': 'Kollegi magħżula',
    'The owner': 'Is-sid',
    'Forked. This copy is yours and runs with your own connections.':
      'Inħolqot kopja. Din il-kopja hija tiegħek u taħdem bil-konnessjonijiet tiegħek.',
    'This chat is too long to fork.': 'Din iċ-chat hija twila wisq biex tinħoloq kopja tagħha.',
    'We could not fork this chat. Please try again.':
      'Ma stajniex noħolqu kopja ta’ din iċ-chat. Erġa’ pprova.',
    'Anyone who forked it keeps their copy: forks stay with the people who made them.':
      'Kull min ħoloq kopja tagħha jżomm il-kopja tiegħu: il-kopji jibqgħu għand in-nies li ħolquhom.',
    'Nobody has forked this chat.': 'Ħadd ma ħoloq kopja ta’ din iċ-chat.',
    '1 person forked this chat. Their copy stays theirs.':
      'Persuna waħda ħolqot kopja ta’ din iċ-chat. Il-kopja tibqa’ tagħha.',
    '{value1} people forked this chat. Their copies stay theirs.':
      '{value1} persuni ħolqu kopja ta’ din iċ-chat. Il-kopji jibqgħu tagħhom.',
    'Personal. Nobody else sees it.': 'Personali. Ħaddieħor ma jaraha.',
    'People you pick. They get it in their Inbox.':
      'In-nies li tagħżel. Jirċevuha fil-kaxxa tal-inbox tagħhom.',
    'Everyone in the company can follow it and fork it.':
      'Kulħadd fil-kumpanija jista’ jsegwiha u joħloq kopja tagħha.',
    'a chat you can no longer open': 'chat li ma tistax tiftaħ aktar',
    'shared the Result': 'qasam ir-Riżultat',
    'updated the Result': 'aġġorna r-Riżultat',
    'published the Skill': 'ippubblika l-Ħila',
    'approved the fact': 'approva l-fatt',
    'added the fact': 'żied il-fatt',
    'added the meeting': 'żied il-laqgħa',
    'published the page': 'ippubblika l-paġna',
    'updated the page': 'aġġorna l-paġna',
    'shared the chat': 'qasam iċ-chat',
    'published a version of': 'ippubblika verżjoni ta’',
    ran: 'ħaddem',
    Knowledge: 'Għarfien',
    Meetings: 'Laqgħat',
    Chat: 'Chat',
    Use: 'Uża',
    Open: 'Iftaħ',
    You: 'Int',
    Someone: 'Xi ħadd',
    'published version {version} of': 'ippubblika l-verżjoni {version} ta’',
    'thing needs': 'ħaġa teħtieġ',
    'things need': 'affarijiet jeħtieġu',
    'Published Skill': 'Ħila ppubblikata',
    'Included with Skill': 'Inkluż mal-Ħila',
    'Already attached': 'Diġà mehmuż',
    'Also available in company knowledge': 'Disponibbli wkoll fl-għarfien tal-kumpanija',
    'Company file': 'Fajl tal-kumpanija',
    'Account identity unavailable': 'L-identità tal-kont mhijiex disponibbli',
    'Access expired or was revoked. Reconnect to continue.':
      'L-aċċess skada jew ġie revokat. Erġa’ qabbad biex tkompli.',
    'Account authorized · tools unavailable':
      'Il-kont ġie awtorizzat · l-għodod mhumiex disponibbli',
    'Not available in this workspace yet.': 'Għadu mhux disponibbli f’dan il-workspace.',
    'Everyone in the company': 'Kulħadd fil-kumpanija',
    'Audience: only you.': 'Udjenza: int biss.',
    'Audience: everyone in the company.': 'Udjenza: kulħadd fil-kumpanija.',
    'tool is': 'l-għodda hija',
    'tools are': 'l-għodod huma',
    'account is': 'il-kont huwa',
    'accounts are': 'il-kontijiet huma',
    'We could not upload this file.': 'Ma stajniex intellgħu dan il-fajl.',
    'file was': 'il-fajl kien',
    'files were': 'il-fajls kienu',
    'Your company': 'Il-kumpanija tiegħek',
    'Create an agent': 'Oħloq aġent',
    'Give recurring work a helping hand': 'Agħti daqqa t’id lix-xogħol rikorrenti',
    'Create a Skill': 'Oħloq Ħila',
    'Save a reusable way of working': 'Issejvja mod ta’ xogħol li jista’ jerġa’ jintuża',
    'Take meeting notes': 'Ħu noti tal-laqgħa',
    'Capture decisions and next steps': 'Irreġistra d-deċiżjonijiet u l-passi li jmiss',
    'Work with a file': 'Aħdem b’fajl',
    'Start from a document or image': 'Ibda minn dokument jew immaġni',
    'Browse agents': 'Fittex fost l-aġenti',
    'Open your agents and company agents': 'Iftaħ l-aġenti tiegħek u tal-kumpanija',
    'Review results': 'Irrevedi r-riżultati',
    'Return to work saved in your Library': 'Erġa’ lura għax-xogħol salvat fil-Librerija tiegħek',
    'For review': 'Għar-reviżjoni',
    'An agent': 'Aġent',
    Assistant: 'Assistent',
    'Kept up to date by {value1}{value2}': 'Jinżamm aġġornat minn {value1}{value2}',
    ', {value1}': ', {value1}',
    'Version {value1}{value2}{value3}': 'Verżjoni {value1}{value2}{value3}',
    'Refreshed by its agent': 'Aġġornat mill-aġent tiegħu',
    'Saved from a chat': 'Issejvjat minn chat',
    'Saved from {value1}': 'Issejvjat minn {value1}',
    Edited: 'Editjat',
    'private account': 'kont privat',
    '{value1} ({value2})': '{value1} ({value2})',
    '{value1}’s {value2}': '{value2} ta’ {value1}',
    'Made private. The person who added it and the owner of its recording have been told in their Inbox.':
      'Sar privat. Il-persuna li żieditu u s-sid tar-reġistrazzjoni tiegħu ġew infurmati fl-Inbox tagħhom.',
    'Made private. The person who added it has been told in their Inbox.':
      'Sar privat. Il-persuna li żieditu ġiet infurmata fl-Inbox tagħha.',
    'Made private. The owner of its recording has been told in their Inbox.':
      'Sar privat. Is-sid tar-reġistrazzjoni tiegħu ġie infurmat fl-Inbox tiegħu.',
    'Selected passage': 'Silta magħżula',
    '{value1} {value2}': '{value1} {value2}',
    'Upload a file': 'Ittella’ fajl',
    'Help me create a useful report from our company knowledge and available sources.':
      'Għinni noħloq rapport utli mill-għarfien tal-kumpanija tagħna u mis-sorsi disponibbli.',
    'This saved work couldn’t be opened. Open it again to retry.':
      'Dan ix-xogħol salvat ma setax jinfetaħ. Iftaħ mill-ġdid biex terġa’ tipprova.',
    '{value1}’s': 'ta’ {value1}',
    '{value1} chat “{value2}”': 'Chat “{value2}” ta’ {value1}',
    '{value1}{value2}': '{value1}{value2}',
    'Skill: {value1}{value2}': 'Ħila: {value1}{value2}',
    'Result “{value1}”': 'Riżultat “{value1}”',
    'Meeting “{value1}”': 'Laqgħa “{value1}”',
    'Used in {value1} {value2} this week': 'Użat f’{value1} {value2} din il-ġimgħa',
    '{value1} {value2} · used in {value3} {value4}': '{value1} {value2} · użat f’{value3} {value4}',
    'The draft is not published yet, so no one else follows it.':
      'L-abbozz għadu ma ġiex ippubblikat, għalhekk ħaddieħor ma jsegwih.',
    'Use it in a chat for current data, or refine the Skill first.':
      'Użah f’chat għal dejta kurrenti, jew irfina l-Ħila l-ewwel.',
    'An agent keeps this up to date. Continue the work in chat.':
      'Aġent iżomm dan aġġornat. Kompli x-xogħol fiċ-chat.',
    'Edit it here, or continue the work in chat.': 'Editjah hawn, jew kompli x-xogħol fiċ-chat.',
    'Duplicate it to your Library, or continue the work in chat.':
      'Idduplikah fil-Librerija tiegħek, jew kompli x-xogħol fiċ-chat.',
    'Download Markdown': 'Niżżel Markdown',
    'Download CSV': 'Niżżel CSV',
    'an agent': 'aġent',
    'Publish a Skill version': 'Ippubblika verżjoni ta’ Ħila',
    'Share with {value1}': 'Aqsam ma’ {value1}',
    'Update company content': 'Aġġorna l-kontenut tal-kumpanija',
    Approved: 'Approvat',
    Declined: 'Miċħud',
    Pending: 'Pendenti',
    'View decision': 'Ara d-deċiżjoni',
    'No data': 'Ebda dejta',
    'No change': 'Ebda bidla',
    'Connection created': 'Inħolqot il-konnessjoni',
    'Sharing changed': 'Inbidlu s-settings tal-kondiviżjoni',
    'Person added': 'Żdiedet persuna',
    'Person removed': 'Tneħħiet persuna',
    'Access changed': 'Inbidel l-aċċess',
    'Access turned off': 'L-aċċess ġie diżattivat',
    'Connection removed': 'Tneħħiet il-konnessjoni',
    'Query time limit changed': 'Inbidel il-limitu taż-żmien tal-mistoqsija',
    '{count} row': '{count} ringiela',
    '{count} rows': '{count} ringieli',
    'This source is no longer available. Company knowledge now lives in Knowledge pages, and files stay in the Library.':
      'Dan is-sors m’għadux disponibbli. L-għarfien tal-kumpanija issa jinsab fil-paġni tal-Għarfien, u l-fajls jibqgħu fil-Librerija.',
    '· {value1} by {value2}': '· {value1} minn {value2}',
    '· version {value1}': '· verżjoni {value1}',
    '{message} {count} earlier file was saved and attached.':
      '{message} {count} fajl preċedenti ġie ssejvjat u mehmuż.',
    '{message} {count} earlier files were saved and attached.':
      '{message} {count} fajls preċedenti ġew ssejvjati u mehmuża.',
    '{message} {count} earlier file was saved.': '{message} {count} fajl preċedenti ġie ssejvjat.',
    '{message} {count} earlier files were saved.':
      '{message} {count} fajls preċedenti ġew ssejvjati.',
    'refreshed {time}': 'aġġornat {time}',
    'a colleague': 'kollega',
    'Your chat “{title}”': 'Iċ-chat tiegħek “{title}”',
    '{name}’s chat “{title}”': 'Iċ-chat ta’ {name} “{title}”',
    'Kept up to date by {name}{version}': 'Jinżamm aġġornat minn {name}{version}',
    'Skill: {name}{version}': 'Ħila: {name}{version}',
    'Result “{title}”': 'Riżultat “{title}”',
    'Meeting “{title}”': 'Laqgħa “{title}”',
    'Used in {count} answer this week': 'Intuża f’{count} tweġiba din il-ġimgħa',
    'Used in {count} answers this week': 'Intuża f’{count} tweġibiet din il-ġimgħa',
    '{count} source': '{count} sors',
    '{count} sources': '{count} sorsi',
    'used in {count} place': 'intuża f’{count} post',
    'used in {count} places': 'intuża f’{count} postijiet',
    '{company} workspace': 'Spazju tax-xogħol ta’ {company}',
    '{count} page': '{count} paġna',
    '{count} pages': '{count} paġni',
    '{needs} · reviews and approvals': '{needs} · reviżjonijiet u approvazzjonijiet',
    '{count} thing needs you': '{count} oġġett jeħtieġ l-attenzjoni tiegħek',
    '{count} things need you': '{count} oġġetti jeħtieġu l-attenzjoni tiegħek',
    'Included with Skill · {files} · {sources} {icon}':
      'Inkluż ma’ Ħila · {files} · {sources} {icon}',
    '{count} file': '{count} fajl',
    '{count} files': '{count} fajls',
    Today: 'Illum',
    'Earlier this week': 'Aktar kmieni din il-ġimgħa',
    '{count} slide': '{count} slajd',
    '{count} slides': '{count} slajds',
    Early: 'Kmieni',
    'TLS verified': 'TLS ivverifikat',
    'Made personal and switched off. Switch it on when you are ready.':
      'Sar personali u ġie mitfi. Ixgħelu meta tkun lest.',
    'Made personal and switched off. Its owner is told which version is live.':
      'Sar personali u ġie mitfi. Is-sid tiegħu jiġi infurmat liema verżjoni hija attiva.',
    'Switched off.': 'Mitfi.',
    'Applied version {revision}.': 'Ġiet applikata l-verżjoni {revision}.',
    'The draft is running in a chat only you can read.':
      "L-abbozz qed jaħdem f'chat li tista' taqra int biss.",
    'Publish a version first.': 'Ippubblika verżjoni l-ewwel.',
    'Another Agent action is in progress.': 'Għaddejja azzjoni oħra tal-Aġent.',
    'Knowledge & connections': 'Għarfien u konnessjonijiet',
    'Pinned Skills': 'Ħiliet ippinjati',
    None: 'Xejn',
    'A new Result each run': "Riżultat ġdid ma' kull tħaddim",
    'One Result kept up to date': 'Riżultat wieħed jinżamm aġġornat',
    Email: 'Email',
    On: 'Mixgħul',
    Off: 'Mitfi',
    'Waiting for review': 'Jistenna reviżjoni',
    Outdated: 'Skadut',
    Accepted: 'Aċċettat',
    Rejected: 'Miċħud',
    Withdrawn: 'Irtirat',
    Replaced: 'Mibdul',
    'Suggested edit': 'Editjar issuġġerit',
    'Suggested new page': 'Paġna ġdida issuġġerita',
    'Suggested move': 'Ċaqliq issuġġerit',
    'Suggested archive': 'Arkivjar issuġġerit',
    'Checking status…': 'Qed jiġi kkontrollat l-istatus…',
    'Status unavailable': 'L-istatus mhux disponibbli',
    'Bulleted list': "Lista b'punti",
    'Numbered list': 'Lista numerata',
    'Web link': 'Link tal-web',
    Read: 'Qari',
    Write: 'Kitba',
    'shared with you': 'kondiviż miegħek',
    'Getting an answer': 'Qed tinkiseb tweġiba',
    '{name} is getting an answer': '{name} qed jikseb tweġiba',
    'We could not save. Please try again.': 'Ma stajniex insalvaw. Jekk jogħġbok erġa’ pprova.',
    'The new page could not be created.': 'Il-paġna l-ġdida ma setgħetx tinħoloq.',
    'We could not load this revision.': 'Ma stajniex intellgħu din ir-reviżjoni.',
    'We could not restore this revision. Please try again.':
      'Ma stajniex nirrestawraw din ir-reviżjoni. Jekk jogħġbok erġa’ pprova.',
    'We could not export this revision.': 'Ma stajniex nesportaw din ir-reviżjoni.',
    'We could not open this suggestion.': 'Ma stajniex niftħu din is-suġġeriment.',
    'We could not do that. Please try again.':
      'Ma stajniex nagħmlu dan. Jekk jogħġbok erġa’ pprova.',
    'We could not save your decision. Please try again.':
      'Ma stajniex insalvaw id-deċiżjoni tiegħek. Jekk jogħġbok erġa’ pprova.',
    'We could not restore this page. Please try again.':
      'Ma stajniex nirrestawraw din il-paġna. Jekk jogħġbok erġa’ pprova.',
    'We could not export this page.': 'Ma stajniex nesportaw din il-paġna.',
    '{count} missed time merged.': '{count} entrata ta’ ħin mitluf ingħaqdet.',
    '{count} missed times merged.': '{count} entrati ta’ ħin mitluf ingħaqdu.',
    'About this project': 'Dwar dan il-proġett',
  },
  pl: {
    'We could not load this item.': 'Nie udało się wczytać tego elementu.',
    '{value1} canvas': 'Płótno {value1}',
    'Loading {value1}…': 'Wczytywanie {value1}…',
    '{value1} · Original retained': '{value1} · Zachowano oryginał',
    '{value1} {value2}{value3} · Added {value4}': '{value1} {value2}{value3} · Dodano {value4}',
    '{value1} Use in chat': '{value1} Użyj na czacie',
    '{value1} Download': '{value1} Pobierz',
    Table: 'Tabela',
    Chart: 'Wykres',
    Original: 'Oryginał',
    'Text extracted from the PDF, marked by page. Download the original for its layout and images.':
      'Tekst wyodrębniony z pliku PDF, oznaczony według stron. Pobierz oryginał, aby zachować jego układ i obrazy.',
    'This preview shows the beginning of the file. Poneva reads the whole file; download the original to see all of it.':
      'Ten podgląd pokazuje początek pliku. Poneva odczytuje cały plik; pobierz oryginał, aby zobaczyć całość.',
    'Preview of the first {value1} complete rows. Filtering and charts use only this preview. Download the original for the full file.':
      'Podgląd pierwszych {value1} pełnych wierszy. Filtrowanie i wykresy korzystają tylko z tego podglądu. Pobierz oryginał, aby zobaczyć cały plik.',
    'This source link cannot be opened.': 'Nie można otworzyć tego linku źródłowego.',
    'Read-only chat': 'Czat tylko do odczytu',
    'Only {value1} writes in this chat. Fork it to continue with your own connections. {value2}':
      'Na tym czacie tylko {value1} może pisać. Utwórz jego kopię, aby kontynuować z własnymi połączeniami. {value2}',
    'Suggest a follow-up…': 'Zaproponuj dalszą wiadomość…',
    'Suggest a follow-up': 'Zaproponuj dalszą wiadomość',
    'Sending…': 'Wysyłanie…',
    Send: 'Wyślij',
    'We could not dismiss that suggestion. Please try again.':
      'Nie udało się odrzucić tej sugestii. Spróbuj ponownie.',
    'Suggested follow-ups': 'Proponowane dalsze wiadomości',
    '{value1} suggests': '{value1} sugeruje',
    Ask: 'Zapytaj',
    'Dismiss {value1}’s suggestion': 'Odrzuć sugestię użytkownika {value1}',
    'Suggested by': 'Zasugerował(a)',
    '· edit it or send it': '· edytuj ją lub wyślij',
    'Remove the suggestion tag': 'Usuń oznaczenie sugestii',
    '{value1} {value2} is getting an answer': '{value1} {value2} otrzymuje odpowiedź',
    '{value1} {value2} stopped the answer': '{value1} {value2} zatrzymał(a) odpowiedź',
    '{value1} Fork from here': '{value1} Utwórz kopię od tego miejsca',
    '{value1} From {value2}’s {value3}': '{value1} Z {value3} użytkownika {value2}',
    'Only {value1} can use this account': 'Tylko {value1} może korzystać z tego konta',
    '{value1} Suggested by {value2}': '{value1} Zasugerowane przez {value2}',
    'Fork this chat': 'Utwórz kopię tego czatu',
    'Forking…': 'Tworzenie kopii…',
    Fork: 'Utwórz kopię',
    'Could not make this private.': 'Nie udało się ustawić tego jako prywatne.',
    'Make this chat private?': 'Ustawić ten czat jako prywatny?',
    Close: 'Zamknij',
    '{value1} will see “{value2}”. Everyone else loses access right away {value3} .{value4}':
      'Użytkownik {value1} zobaczy „{value2}”. Wszyscy pozostali natychmiast stracą dostęp {value3} .{value4}',
    Cancel: 'Anuluj',
    'Saving…': 'Zapisywanie…',
    'Make private': 'Ustaw jako prywatne',
    'This chat is private again. Forks others made stay theirs.':
      'Ten czat znów jest prywatny. Kopie utworzone przez innych pozostają ich własnością.',
    'Who can read this chat: {value1}': 'Kto może czytać ten czat: {value1}',
    'Move this chat': 'Przenieś ten czat',
    'Only you write here. Others follow live and fork.':
      'Tylko Ty możesz tu pisać. Inni obserwują czat na żywo i mogą tworzyć jego kopie.',
    'Made private. {value1} has been told in their Inbox.':
      'Ustawiono jako prywatne. Użytkownik {value1} został o tym powiadomiony w swojej skrzynce odbiorczej.',
    'Chat access': 'Dostęp do czatu',
    '{value1}’s chat. As an admin you can make it private.':
      'Czat użytkownika {value1}. Jako administrator możesz ustawić go jako prywatny.',
    'Only {value1} will see it. {value2} is told.':
      'Zobaczy go tylko {value1}. Użytkownik {value2} został o tym powiadomiony.',
    '{value1} {value2} following': '{value1} {value2} obserwuje',
    'Forked from{value1} {value2} . The history is copied. From here, tools run with your own access.':
      'Utworzono kopię z{value1} {value2} . Historia została skopiowana. Od tego miejsca narzędzia działają z Twoimi uprawnieniami.',
    '{value1} made this chat private': 'Użytkownik {value1} ustawił ten czat jako prywatny',
    'You can no longer open it. Any fork you made stays yours.':
      'Nie możesz już go otworzyć. Każda utworzona przez Ciebie kopia pozostaje Twoją własnością.',
    'Start a new chat': 'Rozpocznij nowy czat',
    'Back to Recent chats': 'Wróć do ostatnich czatów',
    'More chat actions': 'Więcej działań na czacie',
    'Close conversation sharing': 'Zamknij udostępnianie rozmowy',
    'Review the text before saving a private copy to Library. Then choose its audience. Your original conversation and future messages stay private.':
      'Przejrzyj tekst przed zapisaniem prywatnej kopii w Bibliotece. Następnie wybierz jej odbiorców. Twoja oryginalna rozmowa i przyszłe wiadomości pozostaną prywatne.',
    'Preparing the conversation…': 'Przygotowywanie rozmowy…',
    'Refresh preview': 'Odśwież podgląd',
    'The copy is saved in Library. Use Share to choose who can access it.':
      'Kopia została zapisana w Bibliotece. Użyj opcji Udostępnij, aby wybrać, kto może uzyskać do niej dostęp.',
    'Save this copy': 'Zapisz tę kopię',
    'That Skill could not be opened.': 'Nie udało się otworzyć tej umiejętności.',
    '{value1}{value2} · reviews and approvals': '{value1}{value2} · przeglądy i zatwierdzenia',
    'Open Inbox': 'Otwórz skrzynkę odbiorczą',
    'New at {value1} this week': 'Nowe w {value1} w tym tygodniu',
    'Nothing new this week. Shared work, published Skills and approved knowledge show up here.':
      'W tym tygodniu nie ma nic nowego. Udostępnione materiały, opublikowane umiejętności i zatwierdzona wiedza pojawią się tutaj.',
    'New at {value1}': 'Nowe w {value1}',
    'This Skill is unavailable. Try again.': 'Ta umiejętność jest niedostępna. Spróbuj ponownie.',
    'You can attach up to {value1} files. Remove an attachment to add another.':
      'Możesz załączyć maksymalnie {value1} plików. Usuń załącznik, aby dodać kolejny.',
    'Add company context': 'Dodaj kontekst firmy',
    'Add company context · @': 'Dodaj kontekst firmy · @',
    'Choose a Skill': 'Wybierz umiejętność',
    'Choose a Skill · /': 'Wybierz umiejętność · /',
    context: 'kontekst',
    skills: 'umiejętności',
    'Choose company context': 'Wybierz kontekst firmy',
    'Skills for this conversation': 'Umiejętności na potrzeby tej rozmowy',
    'Bring context into the conversation': 'Dodaj kontekst do rozmowy',
    'Close context picker': 'Zamknij wybór kontekstu',
    'Filter company context': 'Filtruj kontekst firmy',
    'Find a Skill…': 'Znajdź umiejętność…',
    'Find a file…': 'Znajdź plik…',
    'Available company context': 'Dostępny kontekst firmy',
    'No matching published Skills.': 'Brak pasujących opublikowanych umiejętności.',
    'No matching files.': 'Brak pasujących plików.',
    'Searching company work…': 'Wyszukiwanie danych firmowych…',
    'Try search again': 'Spróbuj wyszukać ponownie',
    'Meaning search is temporarily limited. Showing available text matches.':
      'Wyszukiwanie według znaczenia jest tymczasowo ograniczone. Wyświetlam dostępne wyniki wyszukiwania tekstowego.',
    'Load more matches': 'Załaduj więcej wyników',
    '{value1} files attached. Remove an attachment to add another. Saved Skill references are included separately.':
      'Dołączono pliki: {value1}. Usuń załącznik, aby dodać kolejny. Zapisane odwołania do umiejętności są uwzględniane osobno.',
    'Create a Skill in chat': 'Utwórz umiejętność na czacie',
    'Upload a company file': 'Prześlij plik firmowy',
    'Company knowledge is always available to Poneva.':
      'Wiedza firmowa jest zawsze dostępna dla Poneva.',
    '{value1} was not connected': 'Nie udało się połączyć z {value1}',
    Dismiss: 'Odrzuć',
    'Try connecting again': 'Spróbuj połączyć ponownie',
    Waiting: 'Oczekiwanie',
    Connected: 'Połączono',
    'Needs reconnecting': 'Wymaga ponownego połączenia',
    Connect: 'Połącz',
    '{value1}{value2} The provider’s account permissions still apply.':
      '{value1}{value2} Nadal obowiązują uprawnienia do konta nadane przez dostawcę.',
    'Last error: {value1}': 'Ostatni błąd: {value1}',
    '{value1} {value2} ready.': '{value1} {value2} gotowe.',
    'Continue with my Meta app': 'Kontynuuj za pomocą mojej aplikacji Meta',
    Reconnect: 'Połącz ponownie',
    Disconnect: 'Rozłącz',
    'Remove attachment: {value1}': 'Usuń załącznik: {value1}',
    'Saved in this Skill. Edit the Skill to change its references.':
      'Zapisano w tej umiejętności. Edytuj umiejętność, aby zmienić jej odwołania.',
    'Remove Skill context': 'Usuń kontekst umiejętności',
    Refining: 'Dopracowywanie',
    Previewing: 'Podgląd',
    Using: 'Używanie',
    'Skill revision {value1}': 'Wersja umiejętności {value1}',
    'a new Skill': 'nowa umiejętność',
    '{value1} Making a new agent {value2}': '{value1} Tworzenie nowego agenta {value2}',
    'Stop making a new agent in this chat': 'Przerwij tworzenie nowego agenta na tym czacie',
    'Saved Skill references': 'Zapisane odwołania do umiejętności',
    'Included with Skill · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}':
      'Dołączono z umiejętnością · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}',
    'Selected Skill revision is unavailable. Select the Skill again to view its saved references.':
      'Wybrana wersja umiejętności jest niedostępna. Wybierz umiejętność ponownie, aby wyświetlić zapisane odwołania.',
    'Conversation attachments': 'Załączniki rozmowy',
    'Added for this conversation': 'Dodano na potrzeby tej rozmowy',
    'Selected passage {value1}': 'Wybrany fragment {value1}',
    'We could not load your workspace.': 'Nie udało się załadować Twojego obszaru roboczego.',
    'The selected Skill is unavailable. Check its access or choose it again.':
      'Wybrana umiejętność jest niedostępna. Sprawdź dostęp do niej lub wybierz ją ponownie.',
    'Source saved privately and included in your knowledge search.':
      'Źródło zapisano prywatnie i uwzględniono w wyszukiwaniu wiedzy.',
    'File saved privately to your library and attached to this message.':
      'Plik zapisano prywatnie w Twojej bibliotece i dołączono do tej wiadomości.',
    'File saved privately to your library.': 'Plik zapisano prywatnie w Twojej bibliotece.',
    '{value1} {value2} earlier {value3} saved{value4}.':
      '{value1} {value2} wcześniej {value3} zapisano{value4}.',
    'Extracted text for Poneva to read. Download the original for its layout, charts and images. Spreadsheet formulas show their saved results and are not recalculated.':
      'Wyodrębniony tekst do odczytu przez Poneva. Pobierz oryginał, aby zachować jego układ, wykresy i obrazy. Formuły arkusza kalkulacyjnego pokazują zapisane wyniki i nie są ponownie obliczane.',
    Esc: 'Esc',
    'Start something': 'Zacznij coś',
    'Choose a file to work with': 'Wybierz plik, na którym chcesz pracować',
    'Skills worth adding': 'Warto dodać te umiejętności',
    'Picked for you': 'Wybrane dla Ciebie',
    'Reusable work grounded in your company knowledge.':
      'Gotowe do ponownego użycia działania oparte na wiedzy firmowej.',
    'Ideas from your company context and recent work. Pick one to start.':
      'Pomysły na podstawie kontekstu firmy i ostatnich działań. Wybierz jeden, aby rozpocząć.',
    'Refresh suggested tasks': 'Odśwież sugerowane zadania',
    'Check for new company context.': 'Sprawdź nowy kontekst firmy.',
    'Check for new context. Ideas also refresh daily.':
      'Sprawdź nowy kontekst. Pomysły są również odświeżane codziennie.',
    Refresh: 'Odśwież',
    'Finding useful starting points…': 'Wyszukiwanie przydatnych punktów wyjścia…',
    'Suggestions aren’t available right now. Try Refresh, or describe the work you want to do.':
      'Sugestie są teraz niedostępne. Kliknij „Odśwież” lub opisz zadanie, które chcesz wykonać.',
    'Loading the knowledge pages…': 'Ładowanie stron wiedzy…',
    '{value1} All pages': '{value1} Wszystkie strony',
    'The page is created.': 'Strona została utworzona.',
    'Your new page is suggested. A publisher decides whether it is added.':
      'Twoja nowa strona została zaproponowana. Wydawca decyduje, czy zostanie dodana.',
    'Company knowledge': 'Wiedza firmowa',
    'What Poneva knows about your company, page by page. Every change is kept.':
      'To, co Poneva wie o Twojej firmie — strona po stronie. Każda zmiana jest zachowywana.',
    'Loading company knowledge…': 'Ładowanie wiedzy firmowej…',
    'Knowledge pages are not enabled in this workspace.':
      'Strony wiedzy nie są włączone w tym obszarze roboczym.',
    'Ask your Poneva contact to switch them on for your company.':
      'Poproś osobę kontaktową w Poneva o włączenie ich dla Twojej firmy.',
    '{value1} Change the agent': '{value1} Zmień agenta',
    '{value1} Continue in chat': '{value1} Kontynuuj na czacie',
    Edit: 'Edytuj',
    '{value1} Edit with chat': '{value1} Edytuj na czacie',
    '{value1} Duplicate to my Library': '{value1} Zduplikuj w mojej bibliotece',
    'Duplicated to your Library. Only you can see the copy.':
      'Zduplikowano w Twojej bibliotece. Tylko Ty możesz zobaczyć kopię.',
    'Could not duplicate this Result. Try again.':
      'Nie udało się zduplikować tego wyniku. Spróbuj ponownie.',
    'Saved version {value1}.': 'Zapisano wersję {value1}.',
    'A newer version was saved. Reload the Result before saving.':
      'Zapisano nowszą wersję. Wczytaj ponownie wynik przed zapisaniem.',
    'Could not save this version. Try again.':
      'Nie udało się zapisać tej wersji. Spróbuj ponownie.',
    '{value1} saved a newer version. Review it before saving.':
      '{value1} zapisał(a) nowszą wersję. Sprawdź ją przed zapisaniem.',
    'Hide their version': 'Ukryj ich wersję',
    'Show their version': 'Pokaż ich wersję',
    'Start from their version': 'Zacznij od ich wersji',
    Markdown: 'Markdown',
    'Result text': 'Treść wyniku',
    Preview: 'Podgląd',
    'What changed': 'Co się zmieniło',
    'What changed? (optional)': 'Co się zmieniło? (opcjonalnie)',
    'Save version {value1}': 'Zapisz wersję {value1}',
    'Open chat': 'Otwórz czat',
    Current: 'Bieżąca',
    Restore: 'Przywróć',
    'Could not load the history.': 'Nie udało się wczytać historii.',
    'Restored version {value1} as version {value2}.':
      'Przywrócono wersję {value1} jako wersję {value2}.',
    'Someone saved a newer version. Review it before restoring.':
      'Ktoś zapisał nowszą wersję. Sprawdź ją przed przywróceniem.',
    'Could not restore that version.': 'Nie udało się przywrócić tej wersji.',
    'Loading history…': 'Wczytywanie historii…',
    'Restoring keeps what is there now as a version too, so nothing is lost.':
      'Przywrócenie zapisze również bieżący stan jako wersję, więc nic nie zostanie utracone.',
    'This Result was made with your own {value1}.':
      'Ten wynik został utworzony przy użyciu Twojego {value1}.',
    'It also used': 'Wykorzystano również',
    'This Result was made with': 'Ten wynik został utworzony przy użyciu',
    'Colleagues can read what came from them, but can never use them.':
      'Współpracownicy mogą czytać dane pochodzące z tych źródeł, ale nigdy nie mogą ich używać.',
    'Your personal agent {value1} keeps it up to date with your own access, so every refresh can carry your private data.':
      'Twój osobisty agent {value1} aktualizuje je, korzystając z Twoich uprawnień, więc każde odświeżenie może zawierać Twoje prywatne dane.',
    'A colleague’s personal agent keeps it up to date with their own access, so every refresh can carry their private data.':
      'Osobisty agent współpracownika aktualizuje je, korzystając z jego uprawnień, więc każde odświeżenie może zawierać jego prywatne dane.',
    'Made private. Only you can see this meeting.':
      'Ustawiono jako prywatne. Tylko Ty możesz zobaczyć to spotkanie.',
    'Could not make this meeting private.': 'Nie udało się ustawić tego spotkania jako prywatnego.',
    'Meeting · {value1} {value2} · Original retained':
      'Spotkanie · {value1} {value2} · Zachowano oryginał',
    'The recording could not be opened.': 'Nie udało się otworzyć nagrania.',
    'Ask about this suggestion': 'Zapytaj o tę sugestię',
    meeting_processing_failed: 'Nie udało się przetworzyć spotkania',
    'Who can see this': 'Kto może to zobaczyć',
    'Everyone at {value1}': 'Wszyscy w {value1}',
    'Only me': 'Tylko ja',
    'Everyone at {value1} can find it and ask about it.':
      'Wszyscy w {value1} mogą to znaleźć i zadawać o to pytania.',
    'Only you can open and search this meeting. You can share it later.':
      'Tylko Ty możesz otwierać i przeszukiwać to spotkanie. Możesz udostępnić je później.',
    'Added. Only you can see it. Transcription is running in the background.':
      'Dodano. Tylko Ty możesz to zobaczyć. Transkrypcja trwa w tle.',
    'Visible to everyone at {value1}': 'Widoczne dla wszystkich w {value1}',
    'Could not make it private.': 'Nie udało się ustawić jako prywatne.',
    'Show more meetings': 'Pokaż więcej spotkań',
    'Attached to this message': 'Dołączono do tej wiadomości',
    'Connect securely, choose the tables to share, then decide whether Poneva can read or make changes.':
      'Połącz się bezpiecznie, wybierz tabele do udostępnienia, a następnie zdecyduj, czy Poneva może je odczytywać lub modyfikować.',
    'Review the tables this connection can access. Select at least one table.':
      'Sprawdź tabele, do których to połączenie ma dostęp. Wybierz co najmniej jedną tabelę.',
    'Select at least one table. Nothing is selected by default.':
      'Wybierz co najmniej jedną tabelę. Domyślnie nie wybrano żadnej.',
    'Choose who can use this connection and what Poneva can do.':
      'Wybierz, kto może korzystać z tego połączenia i jakie działania może wykonywać Poneva.',
    'Your chosen access is enabled for the selected tables.':
      'Wybrany przez Ciebie dostęp jest włączony dla wybranych tabel.',
    'Your connection is saved with reading paused until permission is confirmed.':
      'Połączenie zapisano z wstrzymanym odczytem do czasu potwierdzenia uprawnień.',
    'Confirm database disconnect': 'Potwierdź odłączenie bazy danych',
    'Disconnect this database?': 'Odłączyć tę bazę danych?',
    'Access will stop for everyone using this connection.':
      'Dostęp zostanie wstrzymany dla wszystkich korzystających z tego połączenia.',
    'Keep connection': 'Zachowaj połączenie',
    'What it can reach · {value1}{value2} {value3}': 'Zakres dostępu · {value1}{value2} {value3}',
    Back: 'Wstecz',
    Continue: 'Dalej',
    'Uploading…': 'Przesyłanie…',
    Library: 'Biblioteka',
    'Source material for your work. Available whenever you need it.':
      'Materiały źródłowe do Twojej pracy. Dostępne zawsze, gdy ich potrzebujesz.',
    'The work you want to keep, with its sources and conversation attached.':
      'Praca, którą chcesz zachować, wraz z dołączonymi źródłami i rozmową.',
    Results: 'Wyniki',
    Files: 'Pliki',
    Artifacts: 'Artefakty',
    'Search library': 'Przeszukaj bibliotekę',
    'Find files by meaning…': 'Znajdź pliki według znaczenia…',
    'Find saved work by meaning…': 'Znajdź zapisane materiały według znaczenia…',
    'Search coverage is limited while indexing or meaning-based search is unavailable. You can retry or browse recent items.':
      'Zakres wyszukiwania jest ograniczony podczas indeksowania lub gdy wyszukiwanie według znaczenia jest niedostępne. Możesz spróbować ponownie albo przeglądać ostatnie elementy.',
    'No matching work found.': 'Nie znaleziono pasujących materiałów.',
    'A starting point for your next question.': 'Punkt wyjścia do Twojego następnego pytania.',
    'Good work is worth keeping.': 'Dobra praca zasługuje na zachowanie.',
    'Try a different description or clear the search to browse.':
      'Spróbuj użyć innego opisu albo wyczyść wyszukiwanie, aby przeglądać zawartość.',
    'Upload source material once and use it in conversations and Skills. Your original stays in the library.':
      'Prześlij materiały źródłowe raz i używaj ich w rozmowach oraz umiejętnościach. Oryginał pozostanie w bibliotece.',
    'Ask Poneva to save an answer, table or chart. Results stay connected to the conversation and their sources.':
      'Poproś Ponevę o zapisanie odpowiedzi, tabeli lub wykresu. Wyniki pozostają połączone z rozmową i ich źródłami.',
    'Start in chat {value1}': 'Rozpocznij na czacie {value1}',
    'Open result: {value1}': 'Otwórz wynik: {value1}',
    'Loading more library items…': 'Ładowanie kolejnych elementów biblioteki…',
    'Load more': 'Załaduj więcej',
    'Documents, transcripts, audio and video · Up to 500 MB per file. New files are private. Choose their audience with Share and which processable files become searchable company knowledge.':
      'Dokumenty, transkrypcje, pliki audio i wideo · Do 500 MB na plik. Nowe pliki są prywatne. Wybierz ich odbiorców za pomocą opcji Udostępnij oraz określ, które pliki możliwe do przetworzenia staną się przeszukiwalną wiedzą firmową.',
    Skills: 'Umiejętności',
    'Create in chat': 'Utwórz na czacie',
    'Search Skills': 'Wyszukaj umiejętności',
    'Search finds published Skills. Clear the search to browse your drafts too.':
      'Wyszukiwanie obejmuje opublikowane umiejętności. Wyczyść wyszukiwanie, aby przeglądać także wersje robocze.',
    'Search coverage is limited while indexing or meaning-based search is unavailable.':
      'Zakres wyszukiwania jest ograniczony, gdy indeksowanie lub wyszukiwanie oparte na znaczeniu jest niedostępne.',
    'Searching Skills…': 'Wyszukiwanie umiejętności…',
    'No matching published Skills found. Try a different description.':
      'Nie znaleziono pasujących opublikowanych umiejętności. Spróbuj użyć innego opisu.',
    'Load more Skills': 'Załaduj więcej umiejętności',
    'View Skill: {value1}': 'Wyświetl umiejętność: {value1}',
    'Company workspace': 'Obszar roboczy firmy',
    'View {value1}': 'Wyświetl {value1}',
    'Loading Skills…': 'Ładowanie umiejętności…',
    'Try again {value1}': 'Spróbuj ponownie {value1}',
    'Try again': 'Spróbuj ponownie',
    'Nothing yet.': 'Na razie nic tu nie ma.',
    'Made from · Used by': 'Utworzone na podstawie · Używane przez',
    'Could not load links': 'Nie udało się załadować powiązań',
    'Made from': 'Utworzone na podstawie',
    'Used by': 'Używane przez',
    'About this chat {value1}': 'Informacje o tym czacie {value1}',
    'About this chat': 'Informacje o tym czacie',
    'Keep the work moving.': 'Posuwaj pracę naprzód.',
    'Ask a follow-up with this result in view, or turn a useful approach into a company Skill.':
      'Zadaj pytanie uzupełniające, mając ten wynik na uwadze, albo przekształć przydatne podejście w umiejętność firmową.',
    'Save approach as a Skill': 'Zapisz podejście jako umiejętność',
    'Preview of': 'Podgląd',
    'Made with': 'Utworzone za pomocą',
    'Open the draft': 'Otwórz wersję roboczą',
    'Open Skill': 'Otwórz umiejętność',
    'Use in chat': 'Użyj na czacie',
    'Finish the draft': 'Dokończ wersję roboczą',
    'Refine this Skill': 'Udoskonal tę umiejętność',
    'Made with a Skill.': 'Utworzone za pomocą umiejętności.',
    'This workspace could not be loaded just now, so that Skill cannot be opened yet. The result itself is unchanged.':
      'Nie udało się teraz załadować tego obszaru roboczego, więc nie można jeszcze otworzyć tej umiejętności. Sam wynik pozostaje bez zmian.',
    'That Skill is not available in this workspace, so it cannot be opened or used again. The result itself is unchanged.':
      'Ta umiejętność nie jest dostępna w tym obszarze roboczym, więc nie można jej ponownie otworzyć ani użyć. Sam wynik pozostaje bez zmian.',
    'Result · {value1} {value2}': 'Wynik · {value1} {value2}',
    '{value1} Copy link': '{value1} Kopiuj link',
    'Result link copied.': 'Skopiowano link do wyniku.',
    'Could not copy the link. Use your browser address bar.':
      'Nie udało się skopiować linku. Użyj paska adresu przeglądarki.',
    'No preview is available for this result.': 'Podgląd tego wyniku jest niedostępny.',
    '{value1} rows are retained in this snapshot. Open Table to inspect the values.':
      'W tym zrzucie zachowano wiersze: {value1}. Otwórz tabelę, aby sprawdzić wartości.',
    'People can’t edit a Result an agent keeps up to date; the next refresh would replace their edit. Change the agent’s instructions instead.':
      'Nie można edytować wyniku, który agent aktualizuje; przy następnym odświeżeniu wprowadzone zmiany zostaną zastąpione. Zamiast tego zmień instrukcje agenta.',
    'Linked sources': 'Połączone źródła',
    'Saved source': 'Zapisane źródło',
    'No source documents are linked to this result. Company knowledge and other references may be cited in the answer.':
      'Do tego wyniku nie są połączone żadne dokumenty źródłowe. W odpowiedzi mogą zostać przywołane zasoby wiedzy firmowej i inne materiały.',
    'Run details': 'Szczegóły uruchomienia',
    Created: 'Utworzono',
    ', revised {value1}': ', zmodyfikowano {value1}',
    Conversation: 'Rozmowa',
    'Not recorded': 'Nie zarejestrowano',
    'Open conversation': 'Otwórz rozmowę',
    Run: 'Uruchomienie',
    Updates: 'Aktualizacje',
    'Kept up to date by {value1}': 'Aktualizowane przez {value1}',
    'Version {value1}': 'Wersja {value1}',
    'Could not open this request.': 'Nie udało się otworzyć tego wniosku.',
    'Approved version published.': 'Zatwierdzona wersja została opublikowana.',
    'Request rejected. The item stays unchanged.':
      'Wniosek odrzucono. Element pozostaje bez zmian.',
    'Could not save the decision.': 'Nie udało się zapisać decyzji.',
    'Proposed company change': 'Proponowana zmiana firmowa',
    'Opening…': 'Otwieranie…',
    'Approve this version': 'Zatwierdź tę wersję',
    Decline: 'Odrzuć',
    'Review the submitted version below. Changes made since submission will need a new request.':
      'Sprawdź poniżej przesłaną wersję. Zmiany wprowadzone po przesłaniu będą wymagać nowego wniosku.',
    'The version submitted with this request.': 'Wersja przesłana wraz z tym wnioskiem.',
    'Version and proposed change': 'Wersja i proponowana zmiana',
    'Could not read the pinned content.': 'Nie udało się odczytać przypiętej treści.',
    'Showing a page of {value1} characters.': 'Wyświetlanie strony zawierającej {value1} znaków.',
    'Beginning of the submitted content. Open the full text to review every page.':
      'Początek przesłanej treści. Otwórz pełny tekst, aby przejrzeć każdą stronę.',
    'Read full submitted text': 'Przeczytaj pełną przesłaną treść',
    'Previous page': 'Poprzednia strona',
    'Next page': 'Następna strona',
    'Made private. Its creator has been told in their Inbox.':
      'Ustawiono jako prywatne. Twórca otrzymał powiadomienie w swojej skrzynce odbiorczej.',
    'Made private. Its creator could not be notified.':
      'Ustawiono jako prywatne. Nie udało się powiadomić twórcy.',
    'Make this {value1} private?': 'Ustawić {value1} jako prywatne?',
    'Only the person who created it will see it. Everyone else loses access right away, and its creator gets an Inbox update if they are still a company member. If they have left, nobody in the company will be able to access this item.':
      'Zobaczy to tylko osoba, która utworzyła ten element. Wszyscy inni natychmiast stracą dostęp, a twórca otrzyma aktualizację w skrzynce odbiorczej, jeśli nadal jest członkiem firmy. Jeśli twórca odszedł, nikt w firmie nie będzie mieć dostępu do tego elementu.',
    'Sent for review. The current audience stays unchanged until approval.':
      'Przesłano do sprawdzenia. Obecni odbiorcy pozostaną bez zmian do czasu zatwierdzenia.',
    'This suggestion is no longer available to you.':
      'Ta sugestia nie jest już dla Ciebie dostępna.',
    'We could not check where this suggestion stands.':
      'Nie udało się sprawdzić stanu tej sugestii.',
    'Check again': 'Sprawdź ponownie',
    'Show on page': 'Pokaż na stronie',
    'The editor could not be loaded. Poneva may have been updated since you opened this page. Reload to get the latest version; nothing on this page has changed.':
      'Nie udało się załadować edytora. Poneva mogła zostać zaktualizowana od czasu otwarcia tej strony. Odśwież stronę, aby pobrać najnowszą wersję. Nic na tej stronie się nie zmieniło.',
    'Reload Poneva': 'Odśwież Poneva',
    Formatting: 'Formatowanie',
    'Text style': 'Styl tekstu',
    Text: 'Tekst',
    Heading: 'Nagłówek',
    Subheading: 'Podnagłówek',
    'Link a page': 'Połącz ze stroną',
    'A page needs a title.': 'Strona musi mieć tytuł.',
    'Nothing has changed yet.': 'Nic się jeszcze nie zmieniło.',
    'A page needs some text. To remove a page, archive it instead.':
      'Strona musi zawierać tekst. Aby ją usunąć, zarchiwizuj ją.',
    'A suggested new page needs some text.': 'Sugerowana nowa strona musi zawierać tekst.',
    'This page is larger than 256 KB. Split it into smaller pages.':
      'Ta strona jest większa niż 256 KB. Podziel ją na mniejsze strony.',
    'Say in a few words why this change is right.':
      'Napisz w kilku słowach, dlaczego ta zmiana jest właściwa.',
    'This page changed while you were editing. Your text is still here: copy it, then open the latest version and make your change again.':
      'Ta strona zmieniła się podczas edycji. Twój tekst nadal tu jest: skopiuj go, otwórz najnowszą wersję i wprowadź zmianę ponownie.',
    'Your text is copied.': 'Twój tekst został skopiowany.',
    'Your text could not be copied. Select it in the editor and copy it.':
      'Nie udało się skopiować tekstu. Zaznacz go w edytorze i skopiuj.',
    'The page “{value1}” is created.': 'Strona „{value1}” została utworzona.',
    'New page': 'Nowa strona',
    'Editing {value1}': 'Edycja {value1}',
    Editing: 'Edycja',
    'Creating publishes the page under {value1} for everyone':
      'Utworzenie strony opublikuje ją w sekcji {value1} dla wszystkich',
    'Saving publishes the new version for everyone':
      'Zapisanie opublikuje nową wersję dla wszystkich',
    'Your changes are sent as a suggestion for a publisher':
      'Twoje zmiany zostaną wysłane jako sugestia do wydawcy',
    'Create page': 'Utwórz stronę',
    Save: 'Zapisz',
    'Send suggestion': 'Wyślij sugestię',
    '{value1} Copy my text': '{value1} Skopiuj mój tekst',
    'Open the latest version': 'Otwórz najnowszą wersję',
    'Page title': 'Tytuł strony',
    'Loading the editor…': 'Ładowanie edytora…',
    'New page text': 'Tekst nowej strony',
    'Text of {value1}': 'Tekst: {value1}',
    'Write the page. Type [[ to link another page.':
      'Napisz treść strony. Wpisz [[, aby połączyć z inną stroną.',
    'Type [[ to link another page.': 'Wpisz [[, aby połączyć z inną stroną.',
    'Link to a page': 'Połącz ze stroną',
    'What changed, in a few words': 'Co się zmieniło — w kilku słowach',
    'Where this comes from, in a few words': 'Skąd to pochodzi — w kilku słowach',
    'Shown in the page history.': 'Wyświetlane w historii strony.',
    'A publisher sees this next to your change.': 'Wydawca zobaczy to obok Twojej zmiany.',
    '1 suggestion is open on this page': 'Na tej stronie jest otwarta 1 sugestia',
    '{value1} suggestions are open on this page':
      'Na tej stronie jest otwartych sugestii: {value1}',
    'They stay open while you edit. After you save, they show against your new text; one whose words you changed is marked outdated.':
      'Pozostają otwarte podczas edycji. Po zapisaniu są wyświetlane przy nowym tekście; sugestia, której treść została zmieniona, jest oznaczana jako nieaktualna.',
    'Type [[ to link another page. Links keep working when a page is renamed or moved.':
      'Wpisz [[, aby połączyć z inną stroną. Linki nadal działają po zmianie nazwy lub przeniesieniu strony.',
    'Loading the history…': 'Ładowanie historii…',
    'This page has no saved text yet.': 'Ta strona nie ma jeszcze zapisanego tekstu.',
    'Say in a few words why this revision should come back.':
      'Napisz w kilku słowach, dlaczego ta wersja powinna zostać przywrócona.',
    'Revision {value1} is suggested for a publisher to accept.':
      'Wersja {value1} została zaproponowana wydawcy do zaakceptowania.',
    'The page already reads like this revision.': 'Strona już ma treść tej wersji.',
    'Revision {value1} is restored as revision {value2}.':
      'Wersja {value1} została przywrócona jako wersja {value2}.',
    'Revision history': 'Historia wersji',
    Revisions: 'Wersje',
    'Every saved revision is kept.': 'Każda zapisana wersja jest zachowywana.',
    'Revision {value1} {value2}': 'Wersja {value1} {value2}',
    'Revision {value1} compared with revision {value2}':
      'Porównanie wersji {value1} z wersją {value2}',
    'Revision {value1}, the first text of this page': 'Wersja {value1}, pierwszy tekst tej strony',
    'Green was added, struck through was removed.':
      'Zielony tekst został dodany, a przekreślony usunięty.',
    '{value1} Export Markdown': '{value1} Eksportuj Markdown',
    'Restore this revision': 'Przywróć tę wersję',
    'Suggest restoring it': 'Zaproponuj jej przywrócenie',
    'Why should this revision come back?': 'Dlaczego ta wersja powinna zostać przywrócona?',
    'Loading this revision…': 'Ładowanie tej wersji…',
    'Only the title changed, from “{value1}” to “{value2}”.':
      'Zmienił się tylko tytuł — z „{value1}” na „{value2}”.',
    'The text did not change in this revision.': 'Tekst nie zmienił się w tej wersji.',
    'Changes in revision {value1}': 'Zmiany w wersji {value1}',
    'Loading page…': 'Ładowanie strony…',
    'Loading suggestion…': 'Ładowanie sugestii…',
    'This suggestion is not available.': 'Ta sugestia jest niedostępna.',
    'It may have been decided, or it is not one you can see.':
      'Być może została już rozpatrzona albo nie masz do niej dostępu.',
    'Open Knowledge': 'Otwórz bazę wiedzy',
    'Opening the suggestion…': 'Otwieranie sugestii…',
    'Choose where the page goes.': 'Wybierz, gdzie ma trafić strona.',
    'Say in a few words why.': 'Napisz w kilku słowach, dlaczego.',
    'Your suggestion is sent. A publisher decides.':
      'Twoja sugestia została wysłana. Decyzję podejmuje wydawca.',
    'Moved under {value1}.': 'Przeniesiono pod {value1}.',
    'Deleted “{value1}”.': 'Usunięto „{value1}”.',
    'Could not update sharing.': 'Nie udało się zaktualizować udostępniania.',
    'They can follow new answers live and fork it to continue with their own connections. Only you write here. You can make it private again at any time.':
      'Mogą na bieżąco śledzić nowe odpowiedzi i utworzyć kopię, aby kontynuować pracę z własnymi połączeniami. Tylko Ty możesz tu pisać. W każdej chwili możesz ponownie ustawić to jako prywatne.',
    'They see the project, its brief and the work in it they can already open. Nothing in it opens for anyone because of the project; each item keeps its own access.':
      'Widzą projekt, jego opis oraz zawartą w nim pracę, do której już mają dostęp. Projekt nie otwiera nikomu dostępu do żadnych elementów — każdy z nich zachowuje własne ustawienia dostępu.',
    'Check the content for private information before sharing. Sharing an item does not grant access to its original chat or private connections.':
      'Przed udostępnieniem sprawdź, czy treść nie zawiera prywatnych informacji. Udostępnienie elementu nie zapewnia dostępu do jego oryginalnego czatu ani prywatnych połączeń.',
    '{value1} Everyone you share with can read it, including what the assistant or an App in it found in your {value2}. They can’t use your {value3}. Nothing changes for you: the chat keeps working with all your accounts.':
      '{value1} Każdy, komu to udostępnisz, może to przeczytać, w tym informacje znalezione przez asystenta lub aplikację w Twoim {value2}. Nie mogą korzystać z Twojego {value3}. Dla Ciebie nic się nie zmienia: czat nadal działa ze wszystkimi Twoimi kontami.',
    '{value1} Everyone you share with can read them, but nobody can use {value2} through this chat.':
      '{value1} Każdy, komu je udostępnisz, może je przeczytać, ale nikt nie może używać {value2} za pośrednictwem tego czatu.',
    'This controls access to the working draft. Any published company version stays available until you explicitly unpublish it. To publish a new version, complete its preview and use Save Skill. Run results stay private.':
      'To ustawienie kontroluje dostęp do roboczego szkicu. Każda opublikowana wersja firmowa pozostaje dostępna, dopóki jej wyraźnie nie wycofasz. Aby opublikować nową wersję, ukończ jej podgląd i wybierz Zapisz umiejętność. Wyniki uruchomień pozostają prywatne.',
    'Skill deleted. You can restore it from the Skills archive for 30 days.':
      'Umiejętność usunięto. Możesz ją przywrócić z archiwum umiejętności w ciągu 30 dni.',
    'Could not delete this Skill.': 'Nie udało się usunąć tej umiejętności.',
    'More actions': 'Więcej działań',
    'Delete “{value1}”? It will disappear from Skills and search, and cannot be used by agents. You can restore it for 30 days. Existing chats and results stay available.':
      'Usunąć „{value1}”? Zniknie z umiejętności i wyników wyszukiwania, a agenci nie będą mogli jej używać. Możesz ją przywrócić w ciągu 30 dni. Istniejące czaty i wyniki pozostaną dostępne.',
    'Deleting…': 'Usuwanie…',
    'Confirm delete': 'Potwierdź usunięcie',
    'Delete Skill': 'Usuń umiejętność',
    'Skill restored as an unpublished draft. Its author can review and publish it again.':
      'Umiejętność przywrócono jako nieopublikowany szkic. Jej autor może ją sprawdzić i ponownie opublikować.',
    'Could not restore this Skill.': 'Nie udało się przywrócić tej umiejętności.',
    'Archived Skills': 'Zarchiwizowane umiejętności',
    'Deleted Skills can be restored for 30 days. Restoring leaves them unpublished.':
      'Usunięte umiejętności można przywrócić w ciągu 30 dni. Przywrócenie pozostawia je nieopublikowane.',
    'Restore until {value1}': 'Przywróć do {value1}',
    'Loading…': 'Ładowanie…',
    'No archived Skills.': 'Brak zarchiwizowanych umiejętności.',
    'Load more archived Skills': 'Załaduj więcej zarchiwizowanych umiejętności',
    'Show more of the original': 'Pokaż więcej oryginalnej treści',
    'Filter result rows': 'Filtruj wiersze wyników',
    'Find a product or value…': 'Znajdź produkt lub wartość…',
    '{value1} of {value2}': '{value1} z {value2}',
    'Result table': 'Tabela wyników',
    'No matching rows.': 'Brak pasujących wierszy.',
    'Showing the first 1,000 matching rows. Download the CSV for every row.':
      'Wyświetlamy pierwszych 1000 pasujących wierszy. Pobierz plik CSV, aby zobaczyć wszystkie wiersze.',
    'Agent ·': 'Agent ·',
    'Only you': 'Tylko Ty',
    'Stopped before it finished.': 'Zatrzymano przed ukończeniem.',
    'Drafting the project…': 'Tworzenie szkicu projektu…',
    'Checking where this chat belongs…': 'Sprawdzanie, do którego miejsca należy ten czat…',
    'Moving the chat…': 'Przenoszenie czatu…',
    'Taking it out of the project…': 'Usuwanie czatu z projektu…',
    'Adding it to the project…': 'Dodawanie czatu do projektu…',
    'No matching connections are available right now.': 'Brak dostępnych pasujących połączeń.',
    'Company knowledge suggestion': 'Sugestia dotycząca wiedzy firmowej',
    'Company knowledge now lives on pages. Open Knowledge to see them.':
      'Wiedza firmowa znajduje się teraz na stronach. Otwórz sekcję Wiedza, aby je zobaczyć.',
    '{value1} · Open beside this conversation': '{value1} · Otwórz obok tej rozmowy',
    'Name {value1}': 'Nazwa {value1}',
    'Host {value1}': 'Host {value1}',
    'Port {value1}': 'Port {value1}',
    'Database {value1}': 'Baza danych {value1}',
    'Username {value1}': 'Nazwa użytkownika {value1}',
    'Password {value1}': 'Hasło {value1}',
    'Advanced TLS': 'Zaawansowane ustawienia TLS',
    '{value1} Poneva verifies the server certificate. Add a CA or server DNS name for IP hosts when your certificate requires it.':
      '{value1} Poneva weryfikuje certyfikat serwera. W przypadku hostów IP dodaj urząd certyfikacji (CA) lub nazwę DNS serwera, jeśli wymaga tego Twój certyfikat.',
    'CA certificate {value1}': 'Certyfikat CA {value1}',
    'Certificate server DNS name {value1}': 'Nazwa DNS serwera certyfikatu {value1}',
    '{value1} Your password is encrypted in secure storage. Poneva verifies the connection before saving it.':
      '{value1} Twoje hasło jest szyfrowane w bezpiecznej pamięci. Poneva weryfikuje połączenie przed jego zapisaniem.',
    'Testing…': 'Testowanie…',
    'Test connection': 'Testuj połączenie',
    'PostgreSQL is connected.': 'Połączono z PostgreSQL.',
    'PostgreSQL was saved safely.': 'PostgreSQL zapisano bezpiecznie.',
    'Poneva can read and change rows in the selected tables. Apps also follow their approved data scope.':
      'Poneva może odczytywać i zmieniać wiersze w wybranych tabelach. Aplikacje również przestrzegają zatwierdzonego zakresu danych.',
    'Poneva can read the selected tables. Apps also follow their approved data scope.':
      'Poneva może odczytywać wybrane tabele. Aplikacje również przestrzegają zatwierdzonego zakresu danych.',
    'Reads are paused until permission is enabled.':
      'Odczyty są wstrzymane do czasu włączenia uprawnienia.',
    'Retrying…': 'Ponawianie próby…',
    'Retry permission': 'Ponów próbę uzyskania uprawnienia',
    'Try it in Chat': 'Wypróbuj w czacie',
    Done: 'Gotowe',
    'Disconnect database': 'Odłącz bazę danych',
    '{value1} TLS verified ·{value2} {value3}': '{value1} TLS zweryfikowano ·{value2} {value3}',
    'Search schemas and tables': 'Szukaj schematów i tabel',
    'Search tables': 'Szukaj tabel',
    '{value1} of {value2} tables selected': 'Wybrano {value1} z {value2} tabel',
    'Select matching tables': 'Wybierz pasujące tabele',
    'Select all tables': 'Wybierz wszystkie tabele',
    Clear: 'Wyczyść',
    'Select a whole schema or individual tables. New tables need a fresh selection.':
      'Wybierz cały schemat lub poszczególne tabele. Nowe tabele wymagają ponownego wyboru.',
    'No tables match this search.': 'Żadne tabele nie pasują do tego wyszukiwania.',
    'All tables in {value1}': 'Wszystkie tabele w {value1}',
    '{value1} / {value2} tables': '{value1} / {value2} tabel',
    'Read & write available': 'Dostępny odczyt i zapis',
    'Read only': 'Tylko odczyt',
    Ctrl: 'Ctrl',
    'This suggested knowledge update could not be shown.':
      'Nie udało się wyświetlić tej sugerowanej aktualizacji wiedzy.',
    'Suggested knowledge update': 'Sugerowana aktualizacja wiedzy',
    'Archived. Its history is kept.': 'Zarchiwizowano. Historia została zachowana.',
    'Choose the page it goes under. Links to it keep working.':
      'Wybierz stronę nadrzędną. Odnośniki do niej nadal będą działać.',
    'Its text, its history and any open suggestions are removed for good, and links to it from other pages stop working. This cannot be undone.':
      'Jej treść, historia i wszystkie otwarte sugestie zostaną trwale usunięte, a odnośniki do niej z innych stron przestaną działać. Tej czynności nie można cofnąć.',
    'An archived page no longer informs answers. Its history is kept, and a publisher can restore it or delete it permanently.':
      'Zarchiwizowana strona nie wpływa już na odpowiedzi. Jej historia zostaje zachowana, a osoba publikująca może ją przywrócić lub trwale usunąć.',
    Under: 'Nadrzędna strona',
    Change: 'Zmień',
    'Move under': 'Przenieś pod',
    'Search pages': 'Szukaj stron',
    'Why?': 'Dlaczego?',
    'Delete permanently': 'Usuń trwale',
    'Move page': 'Przenieś stronę',
    'Archive page': 'Zarchiwizuj stronę',
    'Suggestion {value1}: show its card': 'Sugestia {value1}: pokaż jej kartę',
    'Removed:': 'Usunięto:',
    'Added:': 'Dodano:',
    'New page “{value1}”{value2}': 'Nowa strona „{value1}”{value2}',
    'No pages match “{value1}”.': 'Brak stron pasujących do „{value1}”.',
    'Where this page is': 'Położenie tej strony',
    'Describe your company': 'Opisz swoją firmę',
    'Empty page': 'Pusta strona',
    'Describe {value1}': 'Opisz {value1}',
    'This page has no text yet.': 'Ta strona nie ma jeszcze treści.',
    'Poneva reads this page before every answer. Start with who you are, what you sell and how you work; details go on the pages under it.':
      'Poneva czyta tę stronę przed każdą odpowiedzią. Zacznij od tego, kim jesteś, co sprzedajesz i jak pracujesz; szczegóły umieść na stronach podrzędnych.',
    'Write it, or ask Poneva in chat to draft it for you.':
      'Napisz ją lub poproś Ponevę na czacie o przygotowanie wersji roboczej.',
    'Suggest a first version, and a publisher decides whether it becomes the page.':
      'Zaproponuj pierwszą wersję, a osoba publikująca zdecyduje, czy stanie się ona stroną.',
    'Start writing': 'Zacznij pisać',
    'Suggest a first version': 'Zaproponuj pierwszą wersję',
    'Accepted. The page is archived.': 'Zaakceptowano. Strona została zarchiwizowana.',
    'Accepted. The page is now revision {value1}.':
      'Zaakceptowano. Strona ma teraz wersję {value1}.',
    'Accepted.': 'Zaakceptowano.',
    'Suggestion rejected. The page stays as it is.':
      'Sugestia odrzucona. Strona pozostaje bez zmian.',
    'Your suggestion is withdrawn.': 'Twoja sugestia została wycofana.',
    'Restored. The page informs answers again.': 'Przywrócono. Strona znów wpływa na odpowiedzi.',
    'Your suggestion is sent. A publisher decides whether it becomes the page.':
      'Twoja sugestia została wysłana. Osoba publikująca zdecyduje, czy stanie się ona stroną.',
    'Saved. The page is now revision {value1}.': 'Zapisano. Strona ma teraz wersję {value1}.',
    'Nothing changed.': 'Nic się nie zmieniło.',
    'This page is not available.': 'Ta strona jest niedostępna.',
    'It may have been deleted, archived or moved out of reach, or you may no longer be in this company.':
      'Mogła zostać usunięta, zarchiwizowana lub przeniesiona poza Twój dostęp albo możesz już nie należeć do tej firmy.',
    'Page actions': 'Działania na stronie',
    shown: 'pokazane',
    hidden: 'ukryte',
    '{value1} History': 'Historia: {value1}',
    '{value1} Ask in chat': '{value1} Zapytaj na czacie',
    'Suggest edits': 'Zaproponuj zmiany',
    'More actions for {value1}': 'Więcej działań dla {value1}',
    '{value1} Poneva reads this page in every chat':
      '{value1} Poneva czyta tę stronę na każdym czacie',
    'This page is archived. It no longer informs answers; its history is kept. {value1}':
      'Ta strona jest zarchiwizowana. Nie wpływa już na odpowiedzi, ale jej historia została zachowana. {value1}',
    'Restore page': 'Przywróć stronę',
    'This link points to an earlier revision. You are reading the current text.':
      'Ten odnośnik prowadzi do wcześniejszej wersji. Czytasz bieżącą treść.',
    'Show it in History': 'Pokaż w historii',
    Pages: 'Strony',
    'Pages under {value1}': 'Strony pod: {value1}',
    'Linked from': 'Odnośniki z',
    Suggestions: 'Sugestie',
    'Suggestions are hidden. You are reading the page as everyone else sees it.':
      'Sugestie są ukryte. Czytasz stronę tak, jak widzą ją inni.',
    'Loading suggestions…': 'Wczytywanie sugestii…',
    'Nothing is waiting for review.': 'Nic nie czeka na sprawdzenie.',
    'When someone, Poneva in a chat or a connected agent suggests a change to a page, it shows here and on the page. Nothing changes until a publisher accepts it.':
      'Gdy ktoś, Poneva na czacie lub połączony agent zaproponuje zmianę na stronie, pojawi się ona tutaj i na stronie. Nic się nie zmieni, dopóki osoba publikująca jej nie zaakceptuje.',
    '{value1} Review knowledge in chat': '{value1} Sprawdź wiedzę na czacie',
    'Suggestions for review': 'Sugestie do sprawdzenia',
    'Suggested changes from chats, meetings, colleagues and connected agents. Nothing changes until a publisher accepts it on the page.':
      'Proponowane zmiany z czatów, spotkań, od współpracowników i połączonych agentów. Nic się nie zmieni, dopóki osoba publikująca nie zaakceptuje ich na stronie.',
    'Your suggestions wait here until a publisher decides. The pages stay as they are until then.':
      'Twoje sugestie czekają tutaj na decyzję osoby publikującej. Do tego czasu strony pozostają bez zmian.',
    'Review page': 'Sprawdź stronę',
    'Review on page': 'Sprawdź na stronie',
    'Open the meeting': 'Otwórz spotkanie',
    'Open the chat': 'Otwórz czat',
    'Accept and restore': 'Zaakceptuj i przywróć',
    Accept: 'Zaakceptuj',
    Reject: 'Odrzuć',
    'Your suggestion · waiting for a publisher':
      'Twoja sugestia · oczekuje na decyzję osoby publikującej',
    Withdraw: 'Wycofaj',
    'Waiting for a publisher': 'Oczekiwanie na decyzję osoby publikującej',
    'Suggestion {value1}': 'Sugestia {value1}',
    'Suggestion {value1} from {value2}{value3}': 'Sugestia {value1} od {value2}{value3}',
    'Read the suggested page': 'Przeczytaj proponowaną stronę',
    'Outdated: the text it changes was edited after it was suggested. It can be rejected or withdrawn; a new suggestion can be made against the current text.':
      'Nieaktualne: tekst, który zmienia ta sugestia, został edytowany po jej zaproponowaniu. Można ją odrzucić lub wycofać; nową sugestię można oprzeć na bieżącej treści.',
    'Restore this page first to accept this suggestion.':
      'Najpierw przywróć tę stronę, aby zaakceptować tę sugestię.',
    'Previous suggestion': 'Poprzednia sugestia',
    'Suggestion {value1} of {value2}': 'Sugestia {value1} z {value2}',
    'Next suggestion': 'Następna sugestia',
    'Fold the suggestions away': 'Zwiń sugestie',
    'Show the suggestions': 'Pokaż sugestie',
    '1 suggestion': '1 sugestia',
    '{value1} suggestions': '{value1} sugestii',
    '{value1} the pages under {value2}': '{value1} strony pod {value2}',
    px: 'px',
    '{value1} chart of {value2} across {value3}':
      'Wykres {value1} przedstawiający {value2} w zakresie {value3}',
    'We could not build the file.': 'Nie udało się utworzyć pliku.',
    '{value1} Present': '{value1} obecnych',
    'Building…': 'Tworzenie…',
    'Download PowerPoint': 'Pobierz plik PowerPoint',
    'Slide {value1} of {value2}': 'Slajd {value1} z {value2}',
    Slides: 'Slajdy',
    'Slide {value1}': 'Slajd {value1}',
    'Speaker notes': 'Notatki prelegenta',
    'Source: {value1}': 'Źródło: {value1}',
    'Add a name and a web address.': 'Dodaj nazwę i adres internetowy.',
    'Enter a valid web address.': 'Wprowadź prawidłowy adres internetowy.',
    'Use a web address that starts with https://.':
      'Użyj adresu internetowego zaczynającego się od https://.',
    'Add a custom connection': 'Dodaj niestandardowe połączenie',
    'Connect a tool server you trust. Poneva checks the address works and saves only the connection details needed to use it.':
      'Połącz z zaufanym serwerem narzędzi. Poneva sprawdzi, czy adres działa, i zapisze tylko dane połączenia potrzebne do korzystania z niego.',
    'Web address': 'Adres internetowy',
    'https://tools.example.com': 'https://tools.example.com',
    'Starts with https://, from your provider': 'Zaczyna się od https://, od dostawcy',
    'Sign-in': 'Logowanie',
    'Advanced sign-in': 'Zaawansowane logowanie',
    'Access key {value1}': 'Klucz dostępu {value1}',
    'Request headers': 'Nagłówki żądań',
    'Add header': 'Dodaj nagłówek',
    'Header {value1} name': 'Nazwa nagłówka {value1}',
    'Header name': 'Nazwa nagłówka',
    'Header {value1} value': 'Wartość nagłówka {value1}',
    'Header value': 'Wartość nagłówka',
    'Remove header': 'Usuń nagłówek',
    Advanced: 'Zaawansowane',
    Transport: 'Transport',
    'Auto-detect': 'Wykryj automatycznie',
    'Streamable HTTP': 'Strumieniowy HTTP',
    'Legacy SSE': 'Starszy SSE',
    "From your provider's app settings. Leave empty unless they gave you these.":
      'Z ustawień aplikacji dostawcy. Pozostaw puste, chyba że dostawca przekazał Ci te dane.',
    "Authorization server issuer": "Wystawca serwera autoryzacji",
    "Enter the authorization server issuer when using a client ID.": "Jeśli używasz identyfikatora klienta, podaj wystawcę serwera autoryzacji.",
    'Client ID {value1}': 'Identyfikator klienta {value1}',
    'Client secret {value1}': 'Sekret klienta {value1}',
    'Connecting…': 'Łączenie…',
    'Test and connect': 'Przetestuj i połącz',
    'Add the store, the client ID and the client secret.':
      'Dodaj sklep, identyfikator klienta i sekret klienta.',
    'Connect your Shopify Developer App': 'Połącz aplikację deweloperską Shopify',
    'Poneva can use exactly the access your store gave the app, and nothing more. It talks to Shopify directly and keeps the client secret encrypted.':
      'Poneva może korzystać dokładnie z uprawnień przyznanych aplikacji przez Twój sklep i z niczego więcej. Łączy się bezpośrednio z Shopify i przechowuje sekret klienta w postaci zaszyfrowanej.',
    'How to create the app in Shopify': 'Jak utworzyć aplikację w Shopify',
    'Open{value1} {value2}{value3} with the account that owns the store, and create an app.':
      'Otwórz{value1} {value2}{value3} za pomocą konta właściciela sklepu i utwórz aplikację.',
    'Create a version and select the access scopes Poneva may use, for example read_products and read_orders. Add write_ scopes only for data Poneva may change. Then release the version.':
      'Utwórz wersję i wybierz zakresy dostępu, z których Poneva może korzystać, na przykład read_products i read_orders. Dodaj zakresy write_ tylko dla danych, które Poneva może zmieniać. Następnie opublikuj wersję.',
    'For orders and customers, also select protected customer data in the app’s settings. Shopify allows this without review for an app made for your own store.':
      'W przypadku zamówień i klientów wybierz także chronione dane klientów w ustawieniach aplikacji. Shopify pozwala na to bez weryfikacji w przypadku aplikacji utworzonej na potrzeby własnego sklepu.',
    'Install the app on your store.': 'Zainstaluj aplikację w swoim sklepie.',
    'Copy the client ID and client secret from the app’s settings.':
      'Skopiuj identyfikator klienta i sekret klienta z ustawień aplikacji.',
    'To change the access later, release a new version, approve it on the store and use Test connection here.':
      'Aby później zmienić uprawnienia, opublikuj nową wersję, zatwierdź ją w sklepie i użyj tutaj opcji Przetestuj połączenie.',
    Store: 'Sklep',
    'your-store.myshopify.com': 'your-store.myshopify.com',
    'Your store’s .myshopify.com address (Shopify admin → Settings → Domains), or paste the address of your Shopify admin page':
      'Adres sklepu w domenie .myshopify.com (panel administracyjny Shopify → Settings → Domains) albo adres strony panelu administracyjnego Shopify',
    'Client ID {value1} {value2}': 'Identyfikator klienta {value1} {value2}',
    'Client secret {value1} {value2}': 'Sekret klienta {value1} {value2}',
    Person: 'Osoba',
    Everyone: 'Wszyscy',
    Connection: 'Połączenie',
    'All connections': 'Wszystkie połączenia',
    'App {value1}': 'Aplikacja {value1}',
    'From {value1}': 'Od {value1}',
    'Until {value1}': 'Do {value1}',
    Result: 'Wynik',
    'All results': 'Wszystkie wyniki',
    Succeeded: 'Powodzenie',
    Denied: 'Odrzucono',
    Failed: 'Niepowodzenie',
    Unknown: 'Nieznany',
    Filter: 'Filtr',
    'Loading activity…': 'Ładowanie aktywności…',
    'Could not load activity. Try again.': 'Nie udało się wczytać aktywności. Spróbuj ponownie.',
    'Removed connection': 'Usunięto połączenie',
    'App: {value1}': 'Aplikacja: {value1}',
    'Older activity': 'Starsza aktywność',
    'What changed in version {value1}': 'Co zmieniło się w wersji {value1}',
    'Every publish is a version you can restore.':
      'Każda publikacja to wersja, którą możesz przywrócić.',
    Authorization: 'Autoryzacja',
    '{value1} {value2} · {value3} will see it.': '{value1} {value2} · {value3} zobaczą to.',
    '{value1} {value2} you': '{value1} {value2} Ty',
    '· Revised': '· Zmieniono',
    'This chat used your {value1}.': 'Ten czat użył Twojego {value1}.',
    'This chat has results from {value1}.': 'Ten czat zawiera wyniki z {value1}.',
    'db.example.com': 'db.example.com',
    'e.g. Product analytics': 'np. analityka produktu',
    'Paste access key': 'Wklej klucz dostępu',
    'Shopify’s Dev Dashboard': 'Panel deweloperski Shopify',
    'App reference': 'Odwołanie do aplikacji',
    'Draft · revision {value1}': 'Wersja robocza · rewizja {value1}',
    'its Result': 'jego wynik',
    '· its first run makes it': '· jego pierwsze uruchomienie sprawia, że',
    '{value1}’s chat ·': 'Czat {value1} ·',
    '{value1} ad {value2} available.': '{value1} i {value2} dostępne.',
    '{value1} rows ·': '{value1} wierszy ·',
    'It starts private. Sharing it wider shares every refresh, which can carry your private data.':
      'Początkowo jest prywatne. Udostępnienie go szerszemu gronu udostępnia każde odświeżenie, które może zawierać Twoje prywatne dane.',
    'Enable this schedule when approved': 'Włącz ten harmonogram po zatwierdzeniu',
    Schedule: 'Harmonogram',
    'Kept off until you create the agent from its canvas.':
      'Pozostanie wyłączony do czasu utworzenia agenta na jego kanwie.',
    'Will be enabled when you approve.': 'Zostanie włączony po zatwierdzeniu.',
    'Will be saved paused. You can enable it later.':
      'Zostanie zapisany jako wstrzymany. Możesz włączyć go później.',
    'Only runs when you ask.': 'Uruchamia się tylko na żądanie.',
    'Draft · approving saves it, and nothing runs. Test it and create it from its canvas.':
      'Wersja robocza · zatwierdzenie zapisze ją, ale nic się nie uruchomi. Przetestuj ją i utwórz na jej kanwie.',
    'Draft · nothing is scheduled until you approve. Connected actions require their own approval at run time.':
      'Wersja robocza · nic nie zostanie zaplanowane do czasu zatwierdzenia. Połączone działania wymagają osobnego zatwierdzenia w momencie uruchomienia.',
    Name: 'Nazwa',
    'Agent name': 'Nazwa agenta',
    'Who can use it': 'Kto może go używać',
    'Company agent · company resources only': 'Agent firmowy · tylko zasoby firmowe',
    'Personal agent · runs with your access': 'Agent osobisty · działa z Twoimi uprawnieniami',
    'Approving saves it as a draft. It does not run automatically.':
      'Zatwierdzenie zapisuje go jako wersję roboczą. Nie uruchamia się automatycznie.',
    'Open the agent’s runs': 'Otwórz uruchomienia agenta',
    'Run the published version once': 'Uruchom opublikowaną wersję raz',
    'Stopping…': 'Zatrzymywanie…',
    'Stop run': 'Zatrzymaj uruchomienie',
    'Could not stop this run. Please try again.':
      'Nie udało się zatrzymać tego uruchomienia. Spróbuj ponownie.',
    'Run in progress': 'Uruchomienie w toku',
    'This run is still answering. You can ask follow-ups when it finishes.':
      'To uruchomienie nadal generuje odpowiedź. Po jego zakończeniu możesz zadać dodatkowe pytania.',
    'Open run details': 'Otwórz szczegóły uruchomienia',
    Runs: 'Uruchomienia',
    'Open the run chat': 'Otwórz czat uruchomienia',
    Watch: 'Obserwuj',
    Goal: 'Cel',
    'Change the goal': 'Zmień cel',
    'What it does': 'Co robi',
    'What should this agent achieve?': 'Co powinien osiągnąć ten agent?',
    'Not set yet.': 'Jeszcze nie ustawiono.',
    'When it runs': 'Kiedy się uruchamia',
    'Change when it runs': 'Zmień czas uruchamiania',
    'Off means it runs only when someone runs it. Changing when it runs never changes its instructions.':
      'Wyłączenie oznacza, że agent uruchamia się tylko wtedy, gdy ktoś go uruchomi. Zmiana czasu uruchamiania nigdy nie zmienia jego instrukcji.',
    Instructions: 'Instrukcje',
    'Change the instructions': 'Zmień instrukcje',
    'How the agent should approach the work and make decisions.':
      'Jak agent powinien wykonywać zadania i podejmować decyzje.',
    Boundaries: 'Granice',
    'What to do or avoid. Every connected action still follows its approval.':
      'Co robić lub czego unikać. Każde połączone działanie nadal wymaga zatwierdzenia.',
    'No instructions of its own. It follows its Skills.':
      'Nie ma własnych instrukcji. Postępuje zgodnie ze swoimi Umiejętnościami.',
    'Pin a Skill': 'Przypnij Umiejętność',
    'Finds the Skills that fit each run, the same way a chat does.':
      'Wyszukuje Umiejętności odpowiednie dla każdego uruchomienia, tak samo jak czat.',
    'Skills it always follows': 'Umiejętności, których zawsze przestrzega',
    'A Skill that is not published': 'Nieopublikowana Umiejętność',
    'Always follows · Version {value1}': 'Zawsze przestrzega · Wersja {value1}',
    'Not published': 'Nieopublikowana',
    Uses: 'Wykorzystuje',
    'Change in chat': 'Zmień na czacie',
    'Change in chat: Uses': 'Zmień na czacie: Wykorzystuje',
    'Company knowledge and the tools each run is allowed to use.':
      'Wiedza firmowa i narzędzia, z których każde uruchomienie może korzystać.',
    'People see the Result refresh; they change the agent, not the page.':
      'Użytkownicy widzą odświeżenie Wyniku; zmieniają agenta, a nie stronę.',
    'The first run after it is created makes the Result; later runs add a version to it.':
      'Pierwsze uruchomienie po utworzeniu generuje Wynik; kolejne uruchomienia dodają do niego wersję.',
    'Emails whoever the run is for': 'Wysyła e-mail do osoby, której dotyczy uruchomienie',
    'Email each run': 'Wysyłaj e-mail przy każdym uruchomieniu',
    Delivers: 'Dostarcza',
    'Change what it delivers': 'Zmień to, co dostarcza',
    'Expected result': 'Oczekiwany wynik',
    'What a successful run should deliver.':
      'Co powinno zostać dostarczone po pomyślnym uruchomieniu.',
    'What each run delivers': 'Co dostarcza każde uruchomienie',
    'Keeps one Result up to date {value1}': 'Aktualizuje jeden Wynik {value1}',
    'Saves a new Result each run': 'Zapisuje nowy Wynik przy każdym uruchomieniu',
    'You can run this company agent as yourself.{value1} {value2}':
      'Możesz uruchomić tego agenta firmowego jako siebie.{value1} {value2}',
    'Changes since version': 'Zmiany od wersji',
    'are not live yet.': 'nie są jeszcze aktywne.',
    'Review them in Versions': 'Przejrzyj je w Wersjach',
    Skill: 'Umiejętność',
    'The agent always uses the Skill’s published version.':
      'Agent zawsze korzysta z opublikowanej wersji Umiejętności.',
    Day: 'Dzień',
    Time: 'Godzina',
    'Cron expression': 'Wyrażenie cron',
    'Editors and access': 'Edytorzy i dostęp',
    Company: 'Firmowy',
    Personal: 'Osobisty',
    'No changes.': 'Brak zmian.',
    'Instructions changes': 'Zmiany instrukcji',
    'Loading versions…': 'Ładowanie wersji…',
    'What the draft changes': 'Co zmienia wersja robocza',
    'No published version yet. Try the draft, then publish it.':
      'Nie ma jeszcze opublikowanej wersji. Wypróbuj wersję roboczą, a następnie ją opublikuj.',
    'Published versions': 'Opublikowane wersje',
    'Former member': 'Były członek',
    Live: 'Aktywna',
    Download: 'Pobierz',
    CSV: 'CSV',
    'Evidence for {value1}': 'Dane źródłowe dla {value1}',
    Measure: 'Miara',
    'Show rows →': 'Pokaż wiersze →',
    'Ask about this number': 'Zapytaj o tę liczbę',
    'There are no numeric values available to chart. View the table for the original data.':
      'Brak wartości liczbowych dostępnych do utworzenia wykresu. Wyświetl tabelę, aby zobaczyć oryginalne dane.',
    'Chart value': 'Wartość na wykresie',
    '{value1} of {value2} shown': 'Wyświetlono {value1} z {value2}',
    '{value1} by {value2}; {value3} rows. View Table for exact values.':
      '{value1} według {value2}; {value3} wierszy. Wyświetl tabelę, aby zobaczyć dokładne wartości.',
    'Values come directly from the source data. Missing values are not estimates.':
      'Wartości pochodzą bezpośrednio z danych źródłowych. Brakujące wartości nie są szacunkowe.',
    'Loading library…': 'Ładowanie biblioteki…',
    'We couldn’t load what happened in this App. Try again in a moment.':
      'Nie udało się wczytać informacji o tym, co wydarzyło się w tej aplikacji. Spróbuj ponownie za chwilę.',
    'This App could not be opened.': 'Nie udało się otworzyć tej aplikacji.',
    'Opening App…': 'Otwieranie aplikacji…',
    'Open the saved App to run this function.':
      'Otwórz zapisaną aplikację, aby uruchomić tę funkcję.',
    'Save this App before running its function.':
      'Zapisz tę aplikację przed uruchomieniem jej funkcji.',
    'Open saved App': 'Otwórz zapisaną aplikację',
    'Open Apps': 'Otwórz aplikacje',
    'The App could not be opened. Try again.':
      'Nie udało się otworzyć aplikacji. Spróbuj ponownie.',
    Owner: 'Właściciel',
    '{value1} · admins': '{value1} · administratorzy',
    'Owner · always edits': 'Właściciel · zawsze może edytować',
    'Admins manage it': 'Administratorzy zarządzają',
    Editors: 'Edytorzy',
    'A colleague': 'Współpracownik',
    'Can edit drafts and publish versions': 'Może edytować wersje robocze i publikować wersje',
    Remove: 'Usuń',
    'No editors yet.': 'Nie ma jeszcze edytorów.',
    'Admins can always edit company agents.':
      'Administratorzy zawsze mogą edytować agentów firmowych.',
    'Asking for edit access': 'Prośba o dostęp do edycji',
    'Asked {value1} · also in your Inbox':
      'Poproszono {value1} · także w Twojej skrzynce odbiorczej',
    Grant: 'Przyznaj',
    Admin: 'Administrator',
    'Make personal': 'Ustaw jako osobiste',
    'Switch off': 'Wyłącz',
    Archive: 'Archiwizuj',
    'Archive this agent': 'Zarchiwizuj tego agenta',
    'Loading agent…': 'Ładowanie agenta…',
    '{value1} Edit in chat': '{value1} Edytuj na czacie',
    Agent: 'Agent',
    'This agent has not been created yet. It can run once its owner creates it.':
      'Ten agent nie został jeszcze utworzony. Będzie można go uruchomić, gdy utworzy go właściciel.',
    'New agent · Draft': 'Nowy agent · Wersja robocza',
    'Untitled agent': 'Agent bez nazwy',
    'Test run': 'Uruchomienie testowe',
    'This draft does not run automatically.': 'Ta wersja robocza nie uruchamia się automatycznie.',
    'Describe the agent in the chat. Its draft appears here.':
      'Opisz agenta na czacie. Jego wersja robocza pojawi się tutaj.',
    '{value1} Test run': '{value1} Uruchomienie testowe',
    'Describe the agent in the chat first.': 'Najpierw opisz agenta na czacie.',
    'Create and turn on': 'Utwórz i włącz',
    'Connection write setup': 'Konfiguracja zapisu połączenia',
    'Account for connected changes': 'Konto dla zmian w połączonym systemie',
    'Choose a connection': 'Wybierz połączenie',
    'No published Skills available. You can add them later.':
      'Brak opublikowanych umiejętności. Możesz dodać je później.',
    '{value1} · not published. Review the changes. Testing is optional.':
      '{value1} · nieopublikowane. Przejrzyj zmiany. Testowanie jest opcjonalne.',
    '{value1} Test draft': '{value1} Testuj wersję roboczą',
    'Apply changes…': 'Zastosuj zmiany…',
    'Apply this draft as a new version': 'Zastosuj tę wersję roboczą jako nową wersję',
    'This draft cannot be applied.': 'Nie można zastosować tej wersji roboczej.',
    'What changed?': 'Co się zmieniło?',
    'Apply version {value1}': 'Zastosuj wersję {value1}',
    Create: 'Utwórz',
    'Edit access requested': 'Poproszono o dostęp do edycji',
    '{value1} Request edit access': '{value1} Poproś o dostęp do edycji',
    '{value1} Copy agent': '{value1} Kopiuj agenta',
    Pause: 'Wstrzymaj',
    'Open agent: {value1}': 'Otwórz agenta: {value1}',
    '· you can edit': '· możesz edytować',
    '{value1} is switched off.': '{value1} jest wyłączony.',
    '{value1} is archived.': '{value1} jest zarchiwizowany.',
    'Loading agents…': 'Ładowanie agentów…',
    Agents: 'Agenci',
    'Agents do work for you on a schedule or when you ask. They follow your company’s Skills.':
      'Agenci wykonują za Ciebie zadania zgodnie z harmonogramem lub na Twoje żądanie. Korzystają z umiejętności Twojej firmy.',
    'No agent matches. Try a Skill name or what the agent should do.':
      'Nie znaleziono pasującego agenta. Spróbuj podać nazwę umiejętności lub opisać, co agent powinien robić.',
    'Nothing of your own yet': 'Nie masz jeszcze nic własnego',
    'Tell Chat what an agent should do, or copy one of the company’s agents below.{value1}':
      'Powiedz Chatowi, co powinien robić agent, albo skopiuj poniżej jednego z agentów firmowych.{value1}',
    'Your agents': 'Twoi agenci',
    'Run on demand': 'Uruchamiaj na żądanie',
    'Run is always available. A schedule is optional and lives separately from the agent’s instructions.':
      'Uruchomienie jest zawsze dostępne. Harmonogram jest opcjonalny i działa niezależnie od instrukcji agenta.',
    '{value1} for {value2}': '{value1} dla {value2}',
    Suggested: 'Sugerowane',
    'Opening your conversation…': 'Otwieranie rozmowy…',
    'This conversation isn’t available': 'Ta rozmowa jest niedostępna',
    'It may have been deleted, belong to another account, or be temporarily unavailable.':
      'Mogła zostać usunięta, należeć do innego konta lub być tymczasowo niedostępna.',
    '{count} more line — shown in the complete revision':
      'Jeszcze {count} wiersz — widoczny w pełnej wersji',
    '{count} more lines — shown in the complete revision':
      'Jeszcze {count} wierszy — widocznych w pełnej wersji',
    '{count} more line removed': 'Usunięto jeszcze {count} wiersz',
    '{count} more lines removed': 'Usunięto jeszcze {count} wierszy',
    '{count} unchanged line': '{count} niezmieniony wiersz',
    '{count} unchanged lines': '{count} niezmienionych wierszy',
    '{count} more lines not shown, {added} added and {removed} removed. Check them in the complete revision.':
      'Nie pokazano jeszcze {count} wierszy; dodano {added}, a usunięto {removed}. Sprawdź je w pełnej wersji.',
    'Saved result': 'Zapisany wynik',
    'Made with a Skill': 'Utworzono za pomocą umiejętności',
    'Preview of {name}': 'Podgląd: {name}',
    'Made with {name}': 'Utworzono za pomocą {name}',
    'Ad-hoc result': 'Wynik doraźny',
    'A Skill that is not available in this workspace':
      'Umiejętność niedostępna w tym obszarze roboczym',
    '{name} · Revision {version}': '{name} · Wersja {version}',
    '{name} · Version {version}': '{name} · Wersja {version}',
    'Return to conversation {value1}': 'Wróć do rozmowy {value1}',
    '{value1} Working with {value2}': '{value1} Praca z {value2}',
    'View context {value1}': 'Wyświetl kontekst {value1}',
    'A way of working, made yours.': 'Sposób pracy dopasowany do Ciebie.',
    'Work that runs itself.': 'Praca, która wykonuje się sama.',
    'One place for one piece of work.': 'Jedno miejsce na jedno zadanie.',
    'Let’s move your work forward{value1}.': 'Posuńmy Twoją pracę do przodu{value1}.',
    'Describe the work. Your Skill takes shape beside the conversation.':
      'Opisz pracę. Twoja umiejętność nabiera kształtu obok rozmowy.',
    'Describe what it should do and when. Your agent takes shape beside the conversation. The draft does not run automatically.':
      'Opisz, co ma robić i kiedy. Twój agent nabiera kształtu obok rozmowy. Szkic nie uruchamia się automatycznie.',
    'Say what the work is. Poneva drafts the project beside the conversation and brings in what you have already done. Nothing is created until you say so.':
      'Powiedz, na czym polega praca. Poneva przygotuje szkic projektu obok rozmowy i doda to, co zostało już wykonane. Nic nie zostanie utworzone, dopóki nie wyrazisz zgody.',
    'Start with an idea below. Poneva will take it from there.':
      'Zacznij od pomysłu poniżej. Poneva zajmie się resztą.',
    Triggers: 'Wyzwalacze',
    'Review the agent and its trigger. Approval applies exactly what is shown.':
      'Sprawdź agenta i jego wyzwalacz. Zatwierdzenie zastosuje dokładnie to, co pokazano.',
    '{source} · read {date}': '{source} · odczytano {date}',
    'Evidence is being recorded · read {date}':
      'Rejestrowanie danych potwierdzających · odczytano {date}',
    'Evidence expired on {date} under the retention policy':
      'Dane potwierdzające wygasły {date} zgodnie z zasadami przechowywania',
    'Entered by {person}': 'Wprowadzone przez {person}',
    'No retained evidence for this value':
      'Brak przechowywanych danych potwierdzających dla tej wartości',
    'Covers {shown} of {total} rows': 'Obejmuje {shown} z {total} wierszy',
    'Search rows': 'Szukaj wierszy',
    'Clear filters': 'Wyczyść filtry',
    Sort: 'Sortuj',
    'Sort: {column}': 'Sortuj: {column}',
    '{shown} of {total} rows': '{shown} z {total} wierszy',
    More: 'Więcej',
    Density: 'Gęstość',
    Comfortable: 'Wygodny',
    Compact: 'Kompaktowy',
    Columns: 'Kolumny',
    'No rows match. Clear the search or filters to see them again.':
      'Brak pasujących wierszy. Wyczyść wyszukiwanie lub filtry, aby zobaczyć je ponownie.',
    'Not available': 'Niedostępne',
    'All rows': 'Wszystkie wiersze',
    'Close row detail': 'Zamknij szczegóły wiersza',
    'Ask about this row': 'Zapytaj o ten wiersz',
    'Add note': 'Dodaj notatkę',
    Note: 'Notatka',
    Saved: 'Zapisano',
    Total: 'Łącznie',
    ascending: 'rosnąco',
    descending: 'malejąco',
    'Scroll to see all columns': 'Przewiń, aby zobaczyć wszystkie kolumny',
    App: 'Aplikacja',
    Artifact: 'Artefakt',
    'New project': 'Nowy projekt',
    'Review request': 'Prośba o weryfikację',
    Activity: 'Aktywność',
    'Voice preview': 'Podgląd głosu',
    Source: 'Źródło',
    File: 'Plik',
    Meeting: 'Spotkanie',
    'Knowledge page': 'Strona wiedzy',
    'Could not preview this CSV.': 'Nie udało się wyświetlić podglądu tego pliku CSV.',
    'File content is unavailable.': 'Zawartość pliku jest niedostępna.',
    'You have five open suggestions here. {value1} will see them.':
      'Masz tutaj pięć otwartych sugestii. {value1} je zobaczy.',
    'We could not send your suggestion. Please try again.':
      'Nie udało się wysłać sugestii. Spróbuj ponownie.',
    'The agent': 'Agent',
    'Selected colleagues': 'Wybrani współpracownicy',
    'The owner': 'Właściciel',
    'Forked. This copy is yours and runs with your own connections.':
      'Utworzono kopię. Ta kopia należy do Ciebie i działa z Twoimi połączeniami.',
    'This chat is too long to fork.': 'Ten czat jest zbyt długi, aby utworzyć jego kopię.',
    'We could not fork this chat. Please try again.':
      'Nie udało się utworzyć kopii tego czatu. Spróbuj ponownie.',
    'Anyone who forked it keeps their copy: forks stay with the people who made them.':
      'Każdy, kto utworzył kopię, zachowuje ją: kopie pozostają u osób, które je utworzyły.',
    'Nobody has forked this chat.': 'Nikt nie utworzył kopii tego czatu.',
    '1 person forked this chat. Their copy stays theirs.':
      '1 osoba utworzyła kopię tego czatu. Kopia pozostaje jej własnością.',
    '{value1} people forked this chat. Their copies stay theirs.':
      '{value1} osób utworzyło kopię tego czatu. Kopie pozostają ich własnością.',
    'Personal. Nobody else sees it.': 'Osobiste. Nikt inny tego nie widzi.',
    'People you pick. They get it in their Inbox.':
      'Wybrane przez Ciebie osoby. Otrzymają to w swojej skrzynce odbiorczej.',
    'Everyone in the company can follow it and fork it.':
      'Każdy w firmie może to obserwować i utworzyć tego kopię.',
    'a chat you can no longer open': 'czat, którego nie możesz już otworzyć',
    'shared the Result': 'udostępnił wynik',
    'updated the Result': 'zaktualizował wynik',
    'published the Skill': 'opublikował umiejętność',
    'approved the fact': 'zatwierdził fakt',
    'added the fact': 'dodał fakt',
    'added the meeting': 'dodał spotkanie',
    'published the page': 'opublikował stronę',
    'updated the page': 'zaktualizował stronę',
    'shared the chat': 'udostępnił czat',
    'published a version of': 'opublikował wersję elementu',
    ran: 'uruchomił',
    Knowledge: 'Wiedza',
    Meetings: 'Spotkania',
    Chat: 'Czat',
    Use: 'Użyj',
    Open: 'Otwórz',
    You: 'Ty',
    Someone: 'Ktoś',
    'published version {version} of': 'opublikował wersję {version} elementu',
    'thing needs': 'element wymaga',
    'things need': 'elementy wymagają',
    'Published Skill': 'Opublikowana umiejętność',
    'Included with Skill': 'Dołączone do umiejętności',
    'Already attached': 'Już dołączone',
    'Also available in company knowledge': 'Dostępne również w zasobach wiedzy firmy',
    'Company file': 'Plik firmowy',
    'Account identity unavailable': 'Tożsamość konta niedostępna',
    'Access expired or was revoked. Reconnect to continue.':
      'Dostęp wygasł lub został cofnięty. Połącz ponownie, aby kontynuować.',
    'Account authorized · tools unavailable': 'Konto autoryzowane · narzędzia niedostępne',
    'Not available in this workspace yet.': 'Jeszcze niedostępne w tym obszarze roboczym.',
    'Everyone in the company': 'Wszyscy w firmie',
    'Audience: only you.': 'Odbiorcy: tylko Ty.',
    'Audience: everyone in the company.': 'Odbiorcy: wszyscy w firmie.',
    'tool is': 'narzędzie to',
    'tools are': 'narzędzia to',
    'account is': 'konto to',
    'accounts are': 'konta to',
    'We could not upload this file.': 'Nie udało się przesłać tego pliku.',
    'file was': 'plik został',
    'files were': 'pliki zostały',
    'Your company': 'Twoja firma',
    'Create an agent': 'Utwórz agenta',
    'Give recurring work a helping hand': 'Ułatw sobie cykliczną pracę',
    'Create a Skill': 'Utwórz umiejętność',
    'Save a reusable way of working': 'Zapisz wielokrotnego użytku sposób pracy',
    'Take meeting notes': 'Rób notatki ze spotkań',
    'Capture decisions and next steps': 'Zapisuj decyzje i kolejne kroki',
    'Work with a file': 'Pracuj z plikiem',
    'Start from a document or image': 'Zacznij od dokumentu lub obrazu',
    'Browse agents': 'Przeglądaj agentów',
    'Open your agents and company agents': 'Otwórz swoich agentów i agentów firmowych',
    'Review results': 'Przejrzyj wyniki',
    'Return to work saved in your Library': 'Wróć do pracy zapisanej w Bibliotece',
    'For review': 'Do sprawdzenia',
    'An agent': 'Agent',
    Assistant: 'Asystent',
    'Kept up to date by {value1}{value2}': 'Aktualizowane przez {value1}{value2}',
    ', {value1}': ', {value1}',
    'Version {value1}{value2}{value3}': 'Wersja {value1}{value2}{value3}',
    'Refreshed by its agent': 'Zaktualizowane przez agenta',
    'Saved from a chat': 'Zapisane z czatu',
    'Saved from {value1}': 'Zapisane z aplikacji {value1}',
    Edited: 'Edytowane',
    'private account': 'konto prywatne',
    '{value1} ({value2})': '{value1} ({value2})',
    '{value1}’s {value2}': '{value2} użytkownika {value1}',
    'Made private. The person who added it and the owner of its recording have been told in their Inbox.':
      'Ustawiono jako prywatne. Osoba, która je dodała, oraz właściciel jego nagrania otrzymali wiadomość w skrzynce odbiorczej.',
    'Made private. The person who added it has been told in their Inbox.':
      'Ustawiono jako prywatne. Osoba, która je dodała, otrzymała wiadomość w skrzynce odbiorczej.',
    'Made private. The owner of its recording has been told in their Inbox.':
      'Ustawiono jako prywatne. Właściciel jego nagrania otrzymał wiadomość w skrzynce odbiorczej.',
    'Selected passage': 'Wybrany fragment',
    '{value1} {value2}': '{value1} {value2}',
    'Upload a file': 'Prześlij plik',
    'Help me create a useful report from our company knowledge and available sources.':
      'Pomóż mi utworzyć przydatny raport na podstawie wiedzy firmowej i dostępnych źródeł.',
    'This saved work couldn’t be opened. Open it again to retry.':
      'Nie można otworzyć tej zapisanej pracy. Otwórz ją ponownie, aby spróbować jeszcze raz.',
    '{value1}’s': 'Użytkownika {value1}',
    '{value1} chat “{value2}”': 'Czat użytkownika {value1} „{value2}”',
    '{value1}{value2}': '{value1}{value2}',
    'Skill: {value1}{value2}': 'Umiejętność: {value1}{value2}',
    'Result “{value1}”': 'Wynik „{value1}”',
    'Meeting “{value1}”': 'Spotkanie „{value1}”',
    'Used in {value1} {value2} this week': 'Użyto w tym tygodniu: {value1} {value2}',
    '{value1} {value2} · used in {value3} {value4}':
      '{value1} {value2} · użyto w: {value3} {value4}',
    'The draft is not published yet, so no one else follows it.':
      'Wersja robocza nie została jeszcze opublikowana, więc nikt inny jej nie obserwuje.',
    'Use it in a chat for current data, or refine the Skill first.':
      'Użyj jej na czacie, aby uzyskać aktualne dane, lub najpierw udoskonal umiejętność.',
    'An agent keeps this up to date. Continue the work in chat.':
      'Agent aktualizuje te informacje. Kontynuuj pracę na czacie.',
    'Edit it here, or continue the work in chat.': 'Edytuj tutaj lub kontynuuj pracę na czacie.',
    'Duplicate it to your Library, or continue the work in chat.':
      'Utwórz duplikat w Bibliotece lub kontynuuj pracę na czacie.',
    'Download Markdown': 'Pobierz Markdown',
    'Download CSV': 'Pobierz CSV',
    'an agent': 'agent',
    'Publish a Skill version': 'Opublikuj wersję umiejętności',
    'Share with {value1}': 'Udostępnij użytkownikowi {value1}',
    'Update company content': 'Aktualizuj treści firmowe',
    Approved: 'Zatwierdzono',
    Declined: 'Odrzucono',
    Pending: 'Oczekuje na decyzję',
    'View decision': 'Wyświetl decyzję',
    'No data': 'Brak danych',
    'No change': 'Bez zmian',
    'Connection created': 'Utworzono połączenie',
    'Sharing changed': 'Zmieniono udostępnianie',
    'Person added': 'Dodano osobę',
    'Person removed': 'Usunięto osobę',
    'Access changed': 'Zmieniono dostęp',
    'Access turned off': 'Wyłączono dostęp',
    'Connection removed': 'Usunięto połączenie',
    'Query time limit changed': 'Zmieniono limit czasu zapytania',
    '{count} row': '{count} wiersz',
    '{count} rows': '{count} wierszy',
    'This source is no longer available. Company knowledge now lives in Knowledge pages, and files stay in the Library.':
      'To źródło nie jest już dostępne. Wiedza firmowa znajduje się teraz na stronach wiedzy, a pliki pozostają w Bibliotece.',
    '· {value1} by {value2}': '· {value1} przez {value2}',
    '· version {value1}': '· wersja {value1}',
    '{message} {count} earlier file was saved and attached.':
      'Wcześniej zapisano i załączono plik {message} {count}.',
    '{message} {count} earlier files were saved and attached.':
      'Wcześniej zapisano i załączono pliki {message} {count}.',
    '{message} {count} earlier file was saved.': 'Wcześniej zapisano plik {message} {count}.',
    '{message} {count} earlier files were saved.': 'Wcześniej zapisano pliki {message} {count}.',
    'refreshed {time}': 'odświeżono {time}',
    'a colleague': 'współpracownik',
    'Your chat “{title}”': 'Twój czat „{title}”',
    '{name}’s chat “{title}”': 'Czat użytkownika {name}: „{title}”',
    'Kept up to date by {name}{version}': 'Aktualizowane przez {name}{version}',
    'Skill: {name}{version}': 'Umiejętność: {name}{version}',
    'Result “{title}”': 'Wynik „{title}”',
    'Meeting “{title}”': 'Spotkanie „{title}”',
    'Used in {count} answer this week': 'Użyto w {count} odpowiedzi w tym tygodniu',
    'Used in {count} answers this week': 'Użyto w {count} odpowiedziach w tym tygodniu',
    '{count} source': '{count} źródło',
    '{count} sources': '{count} źródeł',
    'used in {count} place': 'użyto w {count} miejscu',
    'used in {count} places': 'użyto w {count} miejscach',
    '{company} workspace': 'Przestrzeń robocza {company}',
    '{count} page': '{count} strona',
    '{count} pages': '{count} stron',
    '{needs} · reviews and approvals': '{needs} · weryfikacje i zatwierdzenia',
    '{count} thing needs you': '{count} element wymaga Twojej uwagi',
    '{count} things need you': '{count} elementy wymagają Twojej uwagi',
    'Included with Skill · {files} · {sources} {icon}':
      'W zestawie z umiejętnością · {files} · {sources} {icon}',
    '{count} file': '{count} plik',
    '{count} files': '{count} plików',
    Today: 'Dziś',
    'Earlier this week': 'Wcześniej w tym tygodniu',
    '{count} slide': '{count} slajd',
    '{count} slides': '{count} slajdów',
    Early: 'Wczesne',
    'TLS verified': 'Zweryfikowano TLS',
    'Made personal and switched off. Switch it on when you are ready.':
      'Ustawiono jako osobiste i wyłączono. Włącz je, gdy będziesz gotowy.',
    'Made personal and switched off. Its owner is told which version is live.':
      'Ustawiono jako osobiste i wyłączono. Właściciel otrzyma informację, która wersja jest aktywna.',
    'Switched off.': 'Wyłączono.',
    'Applied version {revision}.': 'Zastosowano wersję {revision}.',
    'The draft is running in a chat only you can read.':
      'Wersja robocza działa w czacie, który możesz odczytać tylko Ty.',
    'Publish a version first.': 'Najpierw opublikuj wersję.',
    'Another Agent action is in progress.': 'Trwa inne działanie agenta.',
    'Knowledge & connections': 'Wiedza i połączenia',
    'Pinned Skills': 'Przypięte umiejętności',
    None: 'Brak',
    'A new Result each run': 'Nowy wynik przy każdym uruchomieniu',
    'One Result kept up to date': 'Jeden wynik aktualizowany na bieżąco',
    Email: 'E-mail',
    On: 'Włączone',
    Off: 'Wyłączone',
    'Waiting for review': 'Oczekuje na sprawdzenie',
    Outdated: 'Nieaktualne',
    Accepted: 'Zaakceptowane',
    Rejected: 'Odrzucone',
    Withdrawn: 'Wycofane',
    Replaced: 'Zastąpione',
    'Suggested edit': 'Sugerowana edycja',
    'Suggested new page': 'Sugerowana nowa strona',
    'Suggested move': 'Sugerowane przeniesienie',
    'Suggested archive': 'Sugerowane zarchiwizowanie',
    'Checking status…': 'Sprawdzanie stanu…',
    'Status unavailable': 'Stan niedostępny',
    'Bulleted list': 'Lista punktowana',
    'Numbered list': 'Lista numerowana',
    'Web link': 'Link internetowy',
    Read: 'Odczyt',
    Write: 'Zapis',
    'shared with you': 'udostępniono Ci',
    'Getting an answer': 'Przygotowywanie odpowiedzi',
    '{name} is getting an answer': '{name} przygotowuje odpowiedź',
    'We could not save. Please try again.': 'Nie udało się zapisać. Spróbuj ponownie.',
    'The new page could not be created.': 'Nie udało się utworzyć nowej strony.',
    'We could not load this revision.': 'Nie udało się wczytać tej wersji.',
    'We could not restore this revision. Please try again.':
      'Nie udało się przywrócić tej wersji. Spróbuj ponownie.',
    'We could not export this revision.': 'Nie udało się wyeksportować tej wersji.',
    'We could not open this suggestion.': 'Nie udało się otworzyć tej sugestii.',
    'We could not do that. Please try again.':
      'Nie udało się wykonać tej czynności. Spróbuj ponownie.',
    'We could not save your decision. Please try again.':
      'Nie udało się zapisać Twojej decyzji. Spróbuj ponownie.',
    'We could not restore this page. Please try again.':
      'Nie udało się przywrócić tej strony. Spróbuj ponownie.',
    'We could not export this page.': 'Nie udało się wyeksportować tej strony.',
    '{count} missed time merged.': 'Scalono {count} pominięty wpis czasu.',
    '{count} missed times merged.': 'Scalono {count} pominięte wpisy czasu.',
    'About this project': 'O tym projekcie',
  },
  pt: {
    context: 'contexto',
    skills: 'habilidades',
    'Choose company context': 'Escolha o contexto da empresa',
    'Skills for this conversation': 'Habilidades para esta conversa',
    'Bring context into the conversation': 'Adicionar contexto à conversa',
    'Close context picker': 'Fechar seletor de contexto',
    'Filter company context': 'Filtrar contexto da empresa',
    'Find a Skill…': 'Encontrar uma habilidade…',
    'Find a file…': 'Encontrar um arquivo…',
    'Available company context': 'Contexto disponível da empresa',
    'No matching published Skills.': 'Nenhuma habilidade publicada correspondente.',
    'No matching files.': 'Nenhum arquivo correspondente.',
    'Searching company work…': 'Pesquisando no trabalho da empresa…',
    'Try search again': 'Tentar pesquisar novamente',
    'Meaning search is temporarily limited. Showing available text matches.':
      'A pesquisa semântica está temporariamente limitada. Mostrando correspondências de texto disponíveis.',
    'Load more matches': 'Carregar mais correspondências',
    '{value1} files attached. Remove an attachment to add another. Saved Skill references are included separately.':
      '{value1} arquivos anexados. Remova um anexo para adicionar outro. As referências de habilidades salvas são incluídas separadamente.',
    'Create a Skill in chat': 'Criar uma habilidade no chat',
    'Upload a company file': 'Enviar um arquivo da empresa',
    'Company knowledge is always available to Poneva.':
      'O conhecimento da empresa está sempre disponível para a Poneva.',
    '{value1} was not connected': '{value1} não foi conectado',
    Dismiss: 'Dispensar',
    'Try connecting again': 'Tentar conectar novamente',
    Waiting: 'Aguardando',
    Connected: 'Conectado',
    'Needs reconnecting': 'Precisa ser reconectado',
    Connect: 'Conectar',
    '{value1}{value2} The provider’s account permissions still apply.':
      '{value1}{value2} As permissões da conta do provedor continuam valendo.',
    'Last error: {value1}': 'Último erro: {value1}',
    '{value1} {value2} ready.': '{value1} {value2} pronto.',
    'Continue with my Meta app': 'Continuar com meu aplicativo da Meta',
    Reconnect: 'Reconectar',
    Disconnect: 'Desconectar',
    'Remove attachment: {value1}': 'Remover anexo: {value1}',
    'Saved in this Skill. Edit the Skill to change its references.':
      'Salvo nesta habilidade. Edite a habilidade para alterar suas referências.',
    'Remove Skill context': 'Remover contexto da habilidade',
    Refining: 'Aprimorando',
    Previewing: 'Visualizando',
    Using: 'Usando',
    'Skill revision {value1}': 'Revisão da habilidade {value1}',
    'a new Skill': 'uma nova habilidade',
    '{value1} Making a new agent {value2}': '{value1} Criando um novo agente {value2}',
    'Stop making a new agent in this chat': 'Parar de criar um novo agente neste chat',
    'Saved Skill references': 'Referências de habilidades salvas',
    'Included with Skill · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}':
      'Incluído com a habilidade · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}',
    'Selected Skill revision is unavailable. Select the Skill again to view its saved references.':
      'A revisão selecionada da habilidade não está disponível. Selecione a habilidade novamente para ver suas referências salvas.',
    'Conversation attachments': 'Anexos da conversa',
    'Added for this conversation': 'Adicionado para esta conversa',
    'Selected passage {value1}': 'Trecho selecionado {value1}',
    'We could not load your workspace.': 'Não foi possível carregar seu espaço de trabalho.',
    'The selected Skill is unavailable. Check its access or choose it again.':
      'A habilidade selecionada não está disponível. Verifique o acesso ou escolha-a novamente.',
    'Source saved privately and included in your knowledge search.':
      'Fonte salva de forma privada e incluída na sua pesquisa de conhecimento.',
    'File saved privately to your library and attached to this message.':
      'Arquivo salvo de forma privada na sua biblioteca e anexado a esta mensagem.',
    'File saved privately to your library.': 'Arquivo salvo de forma privada na sua biblioteca.',
    '{value1} {value2} earlier {value3} saved{value4}.':
      '{value1} {value2} anteriormente {value3} salvo{value4}.',
    'Extracted text for Poneva to read. Download the original for its layout, charts and images. Spreadsheet formulas show their saved results and are not recalculated.':
      'Texto extraído para leitura pela Poneva. Baixe o original para preservar seu layout, gráficos e imagens. As fórmulas da planilha mostram os resultados salvos e não são recalculadas.',
    Esc: 'Esc',
    'Start something': 'Começar algo',
    'Choose a file to work with': 'Escolha um arquivo para trabalhar',
    'Skills worth adding': 'Habilidades que vale a pena adicionar',
    'Picked for you': 'Escolhido para você',
    'Reusable work grounded in your company knowledge.':
      'Trabalho reutilizável baseado no conhecimento da sua empresa.',
    'Ideas from your company context and recent work. Pick one to start.':
      'Ideias baseadas no contexto da sua empresa e no trabalho recente. Escolha uma para começar.',
    'Refresh suggested tasks': 'Atualizar tarefas sugeridas',
    'Check for new company context.': 'Verificar novo contexto da empresa.',
    'Check for new context. Ideas also refresh daily.':
      'Verificar novo contexto. As ideias também são atualizadas diariamente.',
    Refresh: 'Atualizar',
    'Finding useful starting points…': 'Encontrando pontos de partida úteis…',
    'Suggestions aren’t available right now. Try Refresh, or describe the work you want to do.':
      'As sugestões não estão disponíveis no momento. Tente Atualizar ou descreva o trabalho que deseja fazer.',
    'Loading the knowledge pages…': 'Carregando as páginas de conhecimento…',
    '{value1} All pages': '{value1} Todas as páginas',
    'The page is created.': 'A página foi criada.',
    'Your new page is suggested. A publisher decides whether it is added.':
      'Sua nova página foi sugerida. Um publicador decide se ela será adicionada.',
    'Company knowledge': 'Conhecimento da empresa',
    'What Poneva knows about your company, page by page. Every change is kept.':
      'O que a Poneva sabe sobre sua empresa, página por página. Todas as alterações são mantidas.',
    'Loading company knowledge…': 'Carregando o conhecimento da empresa…',
    'Knowledge pages are not enabled in this workspace.':
      'As páginas de conhecimento não estão habilitadas neste espaço de trabalho.',
    'Ask your Poneva contact to switch them on for your company.':
      'Peça ao seu contato na Poneva para ativá-las para sua empresa.',
    '{value1} Change the agent': '{value1} Alterar o agente',
    '{value1} Continue in chat': '{value1} Continuar no chat',
    'We could not load this item.': 'Não foi possível carregar este item.',
    '{value1} canvas': 'Tela {value1}',
    'Loading {value1}…': 'Carregando {value1}…',
    '{value1} · Original retained': '{value1} · Original mantido',
    '{value1} {value2}{value3} · Added {value4}':
      '{value1} {value2}{value3} · Adicionado em {value4}',
    '{value1} Use in chat': '{value1} Usar no chat',
    '{value1} Download': '{value1} Baixar',
    Table: 'Tabela',
    Chart: 'Gráfico',
    Original: 'Original',
    'Text extracted from the PDF, marked by page. Download the original for its layout and images.':
      'Texto extraído do PDF, marcado por página. Baixe o original para ver o layout e as imagens.',
    'This preview shows the beginning of the file. Poneva reads the whole file; download the original to see all of it.':
      'Esta prévia mostra o início do arquivo. O Poneva lê o arquivo inteiro; baixe o original para vê-lo completo.',
    'Preview of the first {value1} complete rows. Filtering and charts use only this preview. Download the original for the full file.':
      'Prévia das primeiras {value1} linhas completas. A filtragem e os gráficos usam apenas esta prévia. Baixe o original para ver o arquivo completo.',
    'This source link cannot be opened.': 'Não é possível abrir este link da fonte.',
    'Read-only chat': 'Chat somente leitura',
    'Only {value1} writes in this chat. Fork it to continue with your own connections. {value2}':
      'Somente {value1} pode escrever neste chat. Crie uma ramificação para continuar com suas próprias conexões. {value2}',
    'Suggest a follow-up…': 'Sugerir uma continuação…',
    'Suggest a follow-up': 'Sugerir uma continuação',
    'Sending…': 'Enviando…',
    Send: 'Enviar',
    'We could not dismiss that suggestion. Please try again.':
      'Não foi possível dispensar essa sugestão. Tente novamente.',
    'Suggested follow-ups': 'Continuações sugeridas',
    '{value1} suggests': '{value1} sugere',
    Ask: 'Perguntar',
    'Dismiss {value1}’s suggestion': 'Dispensar a sugestão de {value1}',
    'Suggested by': 'Sugerido por',
    '· edit it or send it': '· edite ou envie',
    'Remove the suggestion tag': 'Remover a etiqueta de sugestão',
    '{value1} {value2} is getting an answer': '{value1} {value2} está recebendo uma resposta',
    '{value1} {value2} stopped the answer': '{value1} {value2} interrompeu a resposta',
    '{value1} Fork from here': '{value1} Criar uma ramificação a partir daqui',
    '{value1} From {value2}’s {value3}': '{value1} De {value3} de {value2}',
    'Only {value1} can use this account': 'Somente {value1} pode usar esta conta',
    '{value1} Suggested by {value2}': '{value1} Sugerido por {value2}',
    'Fork this chat': 'Criar uma ramificação deste chat',
    'Forking…': 'Criando ramificação…',
    Fork: 'Criar ramificação',
    'Could not make this private.': 'Não foi possível tornar isto privado.',
    'Make this chat private?': 'Tornar este chat privado?',
    Close: 'Fechar',
    '{value1} will see “{value2}”. Everyone else loses access right away {value3} .{value4}':
      '{value1} verá “{value2}”. Todas as outras pessoas perderão o acesso imediatamente {value3} .{value4}',
    Cancel: 'Cancelar',
    'Saving…': 'Salvando…',
    'Make private': 'Tornar privado',
    'This chat is private again. Forks others made stay theirs.':
      'Este chat voltou a ser privado. As ramificações criadas por outras pessoas continuam sendo delas.',
    'Who can read this chat: {value1}': 'Quem pode ler este chat: {value1}',
    'Move this chat': 'Mover este chat',
    'Only you write here. Others follow live and fork.':
      'Somente você escreve aqui. As outras pessoas acompanham ao vivo e criam ramificações.',
    'Made private. {value1} has been told in their Inbox.':
      'Tornado privado. {value1} foi informado na Caixa de entrada.',
    'Chat access': 'Acesso ao chat',
    '{value1}’s chat. As an admin you can make it private.':
      'Chat de {value1}. Como administrador, você pode torná-lo privado.',
    'Only {value1} will see it. {value2} is told.':
      'Somente {value1} poderá vê-lo. {value2} foi informado.',
    '{value1} {value2} following': '{value1} {value2} acompanhando',
    'Forked from{value1} {value2} . The history is copied. From here, tools run with your own access.':
      'Ramificação criada a partir de{value1} {value2} . O histórico foi copiado. A partir daqui, as ferramentas usam seu próprio acesso.',
    '{value1} made this chat private': '{value1} tornou este chat privado',
    'You can no longer open it. Any fork you made stays yours.':
      'Você não pode mais abri-lo. Qualquer ramificação que você criou continua sendo sua.',
    'Start a new chat': 'Iniciar um novo chat',
    'Back to Recent chats': 'Voltar aos chats recentes',
    'More chat actions': 'Mais ações do chat',
    'Close conversation sharing': 'Fechar compartilhamento da conversa',
    'Review the text before saving a private copy to Library. Then choose its audience. Your original conversation and future messages stay private.':
      'Revise o texto antes de salvar uma cópia privada na Biblioteca. Em seguida, escolha o público. Sua conversa original e as mensagens futuras continuarão privadas.',
    'Preparing the conversation…': 'Preparando a conversa…',
    'Refresh preview': 'Atualizar prévia',
    'The copy is saved in Library. Use Share to choose who can access it.':
      'A cópia foi salva na Biblioteca. Use Compartilhar para escolher quem pode acessá-la.',
    'Save this copy': 'Salvar esta cópia',
    'That Skill could not be opened.': 'Não foi possível abrir essa habilidade.',
    '{value1}{value2} · reviews and approvals': '{value1}{value2} · revisões e aprovações',
    'Open Inbox': 'Abrir Caixa de entrada',
    'New at {value1} this week': 'Novidades em {value1} nesta semana',
    'Nothing new this week. Shared work, published Skills and approved knowledge show up here.':
      'Nada de novo nesta semana. Trabalhos compartilhados, habilidades publicadas e conhecimentos aprovados aparecem aqui.',
    'New at {value1}': 'Novidades em {value1}',
    'This Skill is unavailable. Try again.': 'Esta habilidade está indisponível. Tente novamente.',
    'You can attach up to {value1} files. Remove an attachment to add another.':
      'Você pode anexar até {value1} arquivos. Remova um anexo para adicionar outro.',
    'Add company context': 'Adicionar contexto da empresa',
    'Add company context · @': 'Adicionar contexto da empresa · @',
    'Choose a Skill': 'Escolher uma habilidade',
    'Choose a Skill · /': 'Escolher uma habilidade · /',
    Edit: 'Editar',
    '{value1} Edit with chat': '{value1} Editar com chat',
    '{value1} Duplicate to my Library': '{value1} Duplicar para minha Biblioteca',
    'Duplicated to your Library. Only you can see the copy.':
      'Duplicado para sua Biblioteca. Só você pode ver a cópia.',
    'Could not duplicate this Result. Try again.':
      'Não foi possível duplicar este Resultado. Tente novamente.',
    'Saved version {value1}.': 'Versão {value1} salva.',
    'A newer version was saved. Reload the Result before saving.':
      'Uma versão mais recente foi salva. Recarregue o Resultado antes de salvar.',
    'Could not save this version. Try again.':
      'Não foi possível salvar esta versão. Tente novamente.',
    '{value1} saved a newer version. Review it before saving.':
      '{value1} salvou uma versão mais recente. Revise-a antes de salvar.',
    'Hide their version': 'Ocultar a versão deles',
    'Show their version': 'Mostrar a versão deles',
    'Start from their version': 'Começar pela versão deles',
    Markdown: 'Markdown',
    'Result text': 'Texto do Resultado',
    Preview: 'Prévia',
    'What changed': 'O que mudou',
    'What changed? (optional)': 'O que mudou? (opcional)',
    'Save version {value1}': 'Salvar versão {value1}',
    'Open chat': 'Abrir chat',
    Current: 'Atual',
    Restore: 'Restaurar',
    'Could not load the history.': 'Não foi possível carregar o histórico.',
    'Restored version {value1} as version {value2}.':
      'A versão {value1} foi restaurada como versão {value2}.',
    'Someone saved a newer version. Review it before restoring.':
      'Alguém salvou uma versão mais recente. Revise-a antes de restaurar.',
    'Could not restore that version.': 'Não foi possível restaurar essa versão.',
    'Loading history…': 'Carregando histórico…',
    'Restoring keeps what is there now as a version too, so nothing is lost.':
      'A restauração também mantém o estado atual como uma versão, para que nada seja perdido.',
    'This Result was made with your own {value1}.':
      'Este Resultado foi criado com seu próprio {value1}.',
    'It also used': 'Também usou',
    'This Result was made with': 'Este Resultado foi criado com',
    'Colleagues can read what came from them, but can never use them.':
      'Os colegas podem ler o que veio deles, mas nunca podem usá-los.',
    'Your personal agent {value1} keeps it up to date with your own access, so every refresh can carry your private data.':
      'Seu agente pessoal {value1} mantém tudo atualizado com seu próprio acesso, para que cada atualização possa incluir seus dados privados.',
    'A colleague’s personal agent keeps it up to date with their own access, so every refresh can carry their private data.':
      'O agente pessoal de um colega mantém tudo atualizado com o próprio acesso, para que cada atualização possa incluir os dados privados dele.',
    'Made private. Only you can see this meeting.':
      'Tornada privada. Só você pode ver esta reunião.',
    'Could not make this meeting private.': 'Não foi possível tornar esta reunião privada.',
    'Meeting · {value1} {value2} · Original retained':
      'Reunião · {value1} {value2} · Original mantido',
    'The recording could not be opened.': 'Não foi possível abrir a gravação.',
    'Ask about this suggestion': 'Perguntar sobre esta sugestão',
    meeting_processing_failed: 'Falha ao processar a reunião',
    'Who can see this': 'Quem pode ver isto',
    'Everyone at {value1}': 'Todos em {value1}',
    'Only me': 'Somente eu',
    'Everyone at {value1} can find it and ask about it.':
      'Todos em {value1} podem encontrar isto e fazer perguntas sobre o assunto.',
    'Only you can open and search this meeting. You can share it later.':
      'Só você pode abrir e pesquisar esta reunião. Você pode compartilhá-la mais tarde.',
    'Added. Only you can see it. Transcription is running in the background.':
      'Adicionado. Só você pode ver isto. A transcrição está sendo executada em segundo plano.',
    'Visible to everyone at {value1}': 'Visível para todos em {value1}',
    'Could not make it private.': 'Não foi possível torná-lo privado.',
    'Show more meetings': 'Mostrar mais reuniões',
    'Attached to this message': 'Anexado a esta mensagem',
    'Connect securely, choose the tables to share, then decide whether Poneva can read or make changes.':
      'Conecte-se com segurança, escolha as tabelas que deseja compartilhar e decida se a Poneva pode ler ou fazer alterações.',
    'Review the tables this connection can access. Select at least one table.':
      'Revise as tabelas que esta conexão pode acessar. Selecione pelo menos uma tabela.',
    'Select at least one table. Nothing is selected by default.':
      'Selecione pelo menos uma tabela. Nada é selecionado por padrão.',
    'Choose who can use this connection and what Poneva can do.':
      'Escolha quem pode usar esta conexão e o que a Poneva pode fazer.',
    'Your chosen access is enabled for the selected tables.':
      'O acesso escolhido foi ativado para as tabelas selecionadas.',
    'Your connection is saved with reading paused until permission is confirmed.':
      'Sua conexão foi salva com a leitura pausada até que a permissão seja confirmada.',
    'Confirm database disconnect': 'Confirmar desconexão do banco de dados',
    'Disconnect this database?': 'Desconectar este banco de dados?',
    'Access will stop for everyone using this connection.':
      'O acesso será interrompido para todos que usam esta conexão.',
    'Keep connection': 'Manter conexão',
    'What it can reach · {value1}{value2} {value3}':
      'O que pode acessar · {value1}{value2} {value3}',
    Back: 'Voltar',
    Continue: 'Continuar',
    'Uploading…': 'Enviando…',
    Library: 'Biblioteca',
    'Source material for your work. Available whenever you need it.':
      'Material de referência para seu trabalho. Disponível sempre que você precisar.',
    'The work you want to keep, with its sources and conversation attached.':
      'O trabalho que você quer guardar, com suas fontes e conversa anexadas.',
    Results: 'Resultados',
    Files: 'Arquivos',
    Artifacts: 'Artefatos',
    'Search library': 'Pesquisar na biblioteca',
    'Find files by meaning…': 'Encontrar arquivos por significado…',
    'Find saved work by meaning…': 'Encontrar trabalhos salvos por significado…',
    'Search coverage is limited while indexing or meaning-based search is unavailable. You can retry or browse recent items.':
      'A cobertura da pesquisa é limitada enquanto a indexação ou a pesquisa por significado estiver indisponível. Você pode tentar novamente ou navegar pelos itens recentes.',
    'No matching work found.': 'Nenhum trabalho correspondente foi encontrado.',
    'A starting point for your next question.': 'Um ponto de partida para sua próxima pergunta.',
    'Good work is worth keeping.': 'Um bom trabalho merece ser guardado.',
    'Try a different description or clear the search to browse.':
      'Tente uma descrição diferente ou limpe a pesquisa para navegar.',
    'Upload source material once and use it in conversations and Skills. Your original stays in the library.':
      'Envie o material de referência uma vez e use-o em conversas e Habilidades. O original permanece na biblioteca.',
    'Ask Poneva to save an answer, table or chart. Results stay connected to the conversation and their sources.':
      'Peça à Poneva para salvar uma resposta, tabela ou gráfico. Os Resultados permanecem conectados à conversa e às suas fontes.',
    'Start in chat {value1}': 'Começar no chat {value1}',
    'This suggestion is no longer available to you.':
      'Esta sugestão não está mais disponível para você.',
    'We could not check where this suggestion stands.':
      'Não foi possível verificar o status desta sugestão.',
    'Check again': 'Verificar novamente',
    'Show on page': 'Mostrar na página',
    'The editor could not be loaded. Poneva may have been updated since you opened this page. Reload to get the latest version; nothing on this page has changed.':
      'Não foi possível carregar o editor. O Poneva pode ter sido atualizado desde que você abriu esta página. Recarregue para obter a versão mais recente; nada nesta página foi alterado.',
    'Reload Poneva': 'Recarregar o Poneva',
    Formatting: 'Formatação',
    'Text style': 'Estilo do texto',
    Text: 'Texto',
    Heading: 'Título',
    Subheading: 'Subtítulo',
    'Link a page': 'Vincular uma página',
    'A page needs a title.': 'Uma página precisa de um título.',
    'Nothing has changed yet.': 'Nada mudou ainda.',
    'A page needs some text. To remove a page, archive it instead.':
      'Uma página precisa de algum texto. Para removê-la, arquive-a.',
    'A suggested new page needs some text.': 'Uma nova página sugerida precisa de algum texto.',
    'This page is larger than 256 KB. Split it into smaller pages.':
      'Esta página tem mais de 256 KB. Divida-a em páginas menores.',
    'Say in a few words why this change is right.':
      'Diga em poucas palavras por que esta alteração está correta.',
    'This page changed while you were editing. Your text is still here: copy it, then open the latest version and make your change again.':
      'Esta página mudou enquanto você a editava. Seu texto ainda está aqui: copie-o, abra a versão mais recente e faça sua alteração novamente.',
    'Your text is copied.': 'Seu texto foi copiado.',
    'Your text could not be copied. Select it in the editor and copy it.':
      'Não foi possível copiar seu texto. Selecione-o no editor e copie-o.',
    'The page “{value1}” is created.': 'A página “{value1}” foi criada.',
    'New page': 'Nova página',
    'Editing {value1}': 'Editando {value1}',
    Editing: 'Editando',
    'Creating publishes the page under {value1} for everyone':
      'Ao criar, a página será publicada em {value1} para todos',
    'Saving publishes the new version for everyone':
      'Ao salvar, a nova versão será publicada para todos',
    'Your changes are sent as a suggestion for a publisher':
      'Suas alterações são enviadas como sugestão para um publicador',
    'Create page': 'Criar página',
    Save: 'Salvar',
    'Send suggestion': 'Enviar sugestão',
    '{value1} Copy my text': '{value1} Copiar meu texto',
    'Open the latest version': 'Abrir a versão mais recente',
    'Page title': 'Título da página',
    'Loading the editor…': 'Carregando o editor…',
    'New page text': 'Texto da nova página',
    'Text of {value1}': 'Texto de {value1}',
    'Write the page. Type [[ to link another page.':
      'Escreva a página. Digite [[ para vincular outra página.',
    'Type [[ to link another page.': 'Digite [[ para vincular outra página.',
    'Link to a page': 'Vincular a uma página',
    'What changed, in a few words': 'O que mudou, em poucas palavras',
    'Where this comes from, in a few words': 'De onde isso vem, em poucas palavras',
    'Shown in the page history.': 'Exibido no histórico da página.',
    'A publisher sees this next to your change.':
      'Um publicador verá isso ao lado da sua alteração.',
    '1 suggestion is open on this page': '1 sugestão está aberta nesta página',
    '{value1} suggestions are open on this page': '{value1} sugestões estão abertas nesta página',
    'They stay open while you edit. After you save, they show against your new text; one whose words you changed is marked outdated.':
      'Elas permanecem abertas enquanto você edita. Depois que você salvar, serão exibidas em relação ao seu novo texto; aquela cujas palavras você alterou será marcada como desatualizada.',
    'Type [[ to link another page. Links keep working when a page is renamed or moved.':
      'Digite [[ para vincular outra página. Os links continuam funcionando quando uma página é renomeada ou movida.',
    'Loading the history…': 'Carregando o histórico…',
    'This page has no saved text yet.': 'Esta página ainda não tem texto salvo.',
    'Say in a few words why this revision should come back.':
      'Diga em poucas palavras por que esta revisão deve ser restaurada.',
    'Revision {value1} is suggested for a publisher to accept.':
      'A revisão {value1} foi sugerida para aceitação por um publicador.',
    'The page already reads like this revision.': 'A página já está igual a esta revisão.',
    'Revision {value1} is restored as revision {value2}.':
      'A revisão {value1} foi restaurada como revisão {value2}.',
    'Revision history': 'Histórico de revisões',
    Revisions: 'Revisões',
    'Every saved revision is kept.': 'Todas as revisões salvas são mantidas.',
    'Revision {value1} {value2}': 'Revisão {value1} {value2}',
    'Revision {value1} compared with revision {value2}':
      'Revisão {value1} comparada com a revisão {value2}',
    'Revision {value1}, the first text of this page':
      'Revisão {value1}, o primeiro texto desta página',
    'Green was added, struck through was removed.':
      'O texto em verde foi adicionado; o texto tachado foi removido.',
    '{value1} Export Markdown': '{value1} Exportar Markdown',
    'Restore this revision': 'Restaurar esta revisão',
    'Suggest restoring it': 'Sugerir a restauração',
    'Why should this revision come back?': 'Por que esta revisão deve ser restaurada?',
    'Loading this revision…': 'Carregando esta revisão…',
    'Only the title changed, from “{value1}” to “{value2}”.':
      'Apenas o título mudou, de “{value1}” para “{value2}”.',
    'The text did not change in this revision.': 'O texto não mudou nesta revisão.',
    'Changes in revision {value1}': 'Alterações na revisão {value1}',
    'Loading page…': 'Carregando a página…',
    'Loading suggestion…': 'Carregando a sugestão…',
    'This suggestion is not available.': 'Esta sugestão não está disponível.',
    'It may have been decided, or it is not one you can see.':
      'Ela pode já ter sido decidida ou pode não ser uma sugestão que você possa ver.',
    'Open Knowledge': 'Abrir o Conhecimento',
    'Opening the suggestion…': 'Abrindo a sugestão…',
    'Choose where the page goes.': 'Escolha onde a página ficará.',
    'Say in a few words why.': 'Diga em poucas palavras por quê.',
    'Your suggestion is sent. A publisher decides.':
      'Sua sugestão foi enviada. Um publicador decide.',
    'Moved under {value1}.': 'Movida para baixo de {value1}.',
    'Deleted “{value1}”.': '“{value1}” foi excluída.',
    'Could not update sharing.': 'Não foi possível atualizar o compartilhamento.',
    'They can follow new answers live and fork it to continue with their own connections. Only you write here. You can make it private again at any time.':
      'Eles podem acompanhar novas respostas em tempo real e criar uma ramificação para continuar com as próprias conexões. Somente você escreve aqui. Você pode torná-lo privado novamente a qualquer momento.',
    'They see the project, its brief and the work in it they can already open. Nothing in it opens for anyone because of the project; each item keeps its own access.':
      'Eles veem o projeto, seu resumo e o trabalho que já podem abrir. Nada nele é aberto para outras pessoas por causa do projeto; cada item mantém seu próprio acesso.',
    'Check the content for private information before sharing. Sharing an item does not grant access to its original chat or private connections.':
      'Verifique se há informações privadas no conteúdo antes de compartilhá-lo. Compartilhar um item não concede acesso ao chat original nem às conexões privadas.',
    '{value1} Everyone you share with can read it, including what the assistant or an App in it found in your {value2}. They can’t use your {value3}. Nothing changes for you: the chat keeps working with all your accounts.':
      '{value1} Todos com quem você compartilhar poderão ler o conteúdo, incluindo o que o assistente ou um aplicativo nele encontrou em seu {value2}. Eles não poderão usar seu {value3}. Nada muda para você: o chat continua funcionando com todas as suas contas.',
    '{value1} Everyone you share with can read them, but nobody can use {value2} through this chat.':
      '{value1} Todos com quem você compartilhar poderão lê-los, mas ninguém poderá usar {value2} por meio deste chat.',
    'This controls access to the working draft. Any published company version stays available until you explicitly unpublish it. To publish a new version, complete its preview and use Save Skill. Run results stay private.':
      'Isso controla o acesso ao rascunho em andamento. Qualquer versão da empresa publicada continuará disponível até que você a retire explicitamente da publicação. Para publicar uma nova versão, conclua a visualização e use Salvar habilidade. Os resultados das execuções permanecem privados.',
    'Skill deleted. You can restore it from the Skills archive for 30 days.':
      'Habilidade excluída. Você pode restaurá-la do arquivo de habilidades por 30 dias.',
    'Could not delete this Skill.': 'Não foi possível excluir esta habilidade.',
    'More actions': 'Mais ações',
    'Delete “{value1}”? It will disappear from Skills and search, and cannot be used by agents. You can restore it for 30 days. Existing chats and results stay available.':
      'Excluir “{value1}”? Ela desaparecerá das habilidades e da pesquisa e não poderá ser usada por agentes. Você pode restaurá-la por 30 dias. Os chats e resultados existentes continuarão disponíveis.',
    'Deleting…': 'Excluindo…',
    'Confirm delete': 'Confirmar exclusão',
    'Delete Skill': 'Excluir habilidade',
    'Skill restored as an unpublished draft. Its author can review and publish it again.':
      'Habilidade restaurada como rascunho não publicado. O autor pode revisá-la e publicá-la novamente.',
    'Could not restore this Skill.': 'Não foi possível restaurar esta habilidade.',
    'Archived Skills': 'Habilidades arquivadas',
    'Deleted Skills can be restored for 30 days. Restoring leaves them unpublished.':
      'As habilidades excluídas podem ser restauradas por 30 dias. A restauração mantém essas habilidades não publicadas.',
    'Restore until {value1}': 'Restaurar até {value1}',
    'Loading…': 'Carregando…',
    'No archived Skills.': 'Nenhuma habilidade arquivada.',
    'Load more archived Skills': 'Carregar mais habilidades arquivadas',
    'Show more of the original': 'Mostrar mais do original',
    'Filter result rows': 'Filtrar linhas de resultados',
    'Find a product or value…': 'Encontrar um produto ou valor…',
    '{value1} of {value2}': '{value1} de {value2}',
    'Result table': 'Tabela de resultados',
    'No matching rows.': 'Nenhuma linha correspondente.',
    'Showing the first 1,000 matching rows. Download the CSV for every row.':
      'Exibindo as primeiras 1.000 linhas correspondentes. Baixe o CSV para ver todas as linhas.',
    'Agent ·': 'Agente ·',
    'Only you': 'Somente você',
    'Stopped before it finished.': 'Interrompido antes de terminar.',
    'Drafting the project…': 'Criando o rascunho do projeto…',
    'Checking where this chat belongs…': 'Verificando onde este chat deve ficar…',
    'Moving the chat…': 'Movendo o chat…',
    'Taking it out of the project…': 'Removendo-o do projeto…',
    'Adding it to the project…': 'Adicionando-o ao projeto…',
    'No matching connections are available right now.':
      'Nenhuma conexão correspondente está disponível no momento.',
    'Company knowledge suggestion': 'Sugestão de conhecimento da empresa',
    'Company knowledge now lives on pages. Open Knowledge to see them.':
      'O conhecimento da empresa agora fica nas páginas. Abra Conhecimento para vê-las.',
    '{value1} · Open beside this conversation': '{value1} · Abrir ao lado desta conversa',
    'Name {value1}': 'Nome {value1}',
    'Host {value1}': 'Host {value1}',
    'Port {value1}': 'Porta {value1}',
    'Database {value1}': 'Banco de dados {value1}',
    'Username {value1}': 'Nome de usuário {value1}',
    'Password {value1}': 'Senha {value1}',
    'Advanced TLS': 'TLS avançado',
    '{value1} Poneva verifies the server certificate. Add a CA or server DNS name for IP hosts when your certificate requires it.':
      '{value1} A Poneva verifica o certificado do servidor. Adicione uma CA ou um nome DNS do servidor para hosts IP quando o certificado exigir isso.',
    'CA certificate {value1}': 'Certificado da CA {value1}',
    'Certificate server DNS name {value1}': 'Nome DNS do servidor do certificado {value1}',
    '{value1} Your password is encrypted in secure storage. Poneva verifies the connection before saving it.':
      '{value1} Sua senha é criptografada no armazenamento seguro. A Poneva verifica a conexão antes de salvá-la.',
    'Testing…': 'Testando…',
    'Test connection': 'Testar conexão',
    'PostgreSQL is connected.': 'O PostgreSQL está conectado.',
    'PostgreSQL was saved safely.': 'O PostgreSQL foi salvo com segurança.',
    'Poneva can read and change rows in the selected tables. Apps also follow their approved data scope.':
      'A Poneva pode ler e alterar linhas nas tabelas selecionadas. Os aplicativos também seguem o escopo de dados aprovado para eles.',
    'Poneva can read the selected tables. Apps also follow their approved data scope.':
      'A Poneva pode ler as tabelas selecionadas. Os aplicativos também seguem o escopo de dados aprovado para eles.',
    'Reads are paused until permission is enabled.':
      'As leituras estão pausadas até que a permissão seja ativada.',
    'Retrying…': 'Tentando novamente…',
    'Retry permission': 'Tentar novamente a permissão',
    'Try it in Chat': 'Experimentar no chat',
    Done: 'Concluído',
    'Disconnect database': 'Desconectar banco de dados',
    '{value1} TLS verified ·{value2} {value3}': '{value1} TLS verificado ·{value2} {value3}',
    'Search schemas and tables': 'Pesquisar esquemas e tabelas',
    'Search tables': 'Pesquisar tabelas',
    '{value1} of {value2} tables selected': '{value1} de {value2} tabelas selecionadas',
    'Select matching tables': 'Selecionar tabelas correspondentes',
    'Select all tables': 'Selecionar todas as tabelas',
    Clear: 'Limpar',
    'Select a whole schema or individual tables. New tables need a fresh selection.':
      'Selecione um esquema inteiro ou tabelas individuais. Tabelas novas exigem uma nova seleção.',
    'No tables match this search.': 'Nenhuma tabela corresponde a esta pesquisa.',
    'All tables in {value1}': 'Todas as tabelas em {value1}',
    '{value1} / {value2} tables': '{value1} / {value2} tabelas',
    'Read & write available': 'Leitura e gravação disponíveis',
    'Read only': 'Somente leitura',
    Ctrl: 'Ctrl',
    'This suggested knowledge update could not be shown.':
      'Não foi possível exibir esta atualização sugerida do conhecimento.',
    'Suggested knowledge update': 'Atualização sugerida do conhecimento',
    'Open result: {value1}': 'Abrir resultado: {value1}',
    'Loading more library items…': 'Carregando mais itens da biblioteca…',
    'Load more': 'Carregar mais',
    'Documents, transcripts, audio and video · Up to 500 MB per file. New files are private. Choose their audience with Share and which processable files become searchable company knowledge.':
      'Documentos, transcrições, áudio e vídeo · Até 500 MB por arquivo. Arquivos novos são privados. Escolha o público com Compartilhar e quais arquivos processáveis se tornam conhecimento pesquisável da empresa.',
    Skills: 'Competências',
    'Create in chat': 'Criar no chat',
    'Search Skills': 'Pesquisar competências',
    'Search finds published Skills. Clear the search to browse your drafts too.':
      'A pesquisa encontra competências publicadas. Limpe a pesquisa para também navegar pelos seus rascunhos.',
    'Search coverage is limited while indexing or meaning-based search is unavailable.':
      'A cobertura da pesquisa é limitada enquanto a indexação ou a pesquisa baseada em significado estiver indisponível.',
    'Searching Skills…': 'Pesquisando competências…',
    'No matching published Skills found. Try a different description.':
      'Nenhuma competência publicada correspondente foi encontrada. Tente uma descrição diferente.',
    'Load more Skills': 'Carregar mais competências',
    'View Skill: {value1}': 'Ver competência: {value1}',
    'Company workspace': 'Espaço de trabalho da empresa',
    'View {value1}': 'Ver {value1}',
    'Loading Skills…': 'Carregando competências…',
    'Try again {value1}': 'Tentar novamente {value1}',
    'Try again': 'Tentar novamente',
    'Nothing yet.': 'Nada por enquanto.',
    'Made from · Used by': 'Criado a partir de · Usado por',
    'Could not load links': 'Não foi possível carregar os links',
    'Made from': 'Criado a partir de',
    'Used by': 'Usado por',
    'About this chat {value1}': 'Sobre este chat {value1}',
    'About this chat': 'Sobre este chat',
    'Keep the work moving.': 'Mantenha o trabalho avançando.',
    'Ask a follow-up with this result in view, or turn a useful approach into a company Skill.':
      'Faça uma pergunta de acompanhamento com este resultado em destaque ou transforme uma abordagem útil em uma competência da empresa.',
    'Save approach as a Skill': 'Salvar abordagem como competência',
    'Preview of': 'Prévia de',
    'Made with': 'Criado com',
    'Open the draft': 'Abrir o rascunho',
    'Open Skill': 'Abrir competência',
    'Use in chat': 'Usar no chat',
    'Finish the draft': 'Concluir o rascunho',
    'Refine this Skill': 'Aprimorar esta competência',
    'Made with a Skill.': 'Criado com uma competência.',
    'This workspace could not be loaded just now, so that Skill cannot be opened yet. The result itself is unchanged.':
      'Não foi possível carregar este espaço de trabalho agora, então essa competência ainda não pode ser aberta. O resultado em si não foi alterado.',
    'That Skill is not available in this workspace, so it cannot be opened or used again. The result itself is unchanged.':
      'Essa competência não está disponível neste espaço de trabalho, então não pode ser aberta nem usada novamente. O resultado em si não foi alterado.',
    'Result · {value1} {value2}': 'Resultado · {value1} {value2}',
    '{value1} Copy link': '{value1} Copiar link',
    'Result link copied.': 'Link do resultado copiado.',
    'Could not copy the link. Use your browser address bar.':
      'Não foi possível copiar o link. Use a barra de endereço do navegador.',
    'No preview is available for this result.': 'Não há prévia disponível para este resultado.',
    '{value1} rows are retained in this snapshot. Open Table to inspect the values.':
      '{value1} linhas foram mantidas neste instantâneo. Abra Tabela para inspecionar os valores.',
    'People can’t edit a Result an agent keeps up to date; the next refresh would replace their edit. Change the agent’s instructions instead.':
      'As pessoas não podem editar um resultado que um agente mantém atualizado; a próxima atualização substituiria a edição. Altere as instruções do agente.',
    'Linked sources': 'Fontes vinculadas',
    'Saved source': 'Fonte salva',
    'No source documents are linked to this result. Company knowledge and other references may be cited in the answer.':
      'Nenhum documento de origem está vinculado a este resultado. O conhecimento da empresa e outras referências podem ser citados na resposta.',
    'Run details': 'Detalhes da execução',
    Created: 'Criado',
    Conversation: 'Conversa',
    'Not recorded': 'Não registrado',
    'Open conversation': 'Abrir conversa',
    Run: 'Execução',
    Updates: 'Atualizações',
    'Kept up to date by {value1}': 'Mantido atualizado por {value1}',
    'Version {value1}': 'Versão {value1}',
    'Could not open this request.': 'Não foi possível abrir esta solicitação.',
    'Approved version published.': 'Versão aprovada publicada.',
    'Request rejected. The item stays unchanged.':
      'Solicitação rejeitada. O item permanece inalterado.',
    'Could not save the decision.': 'Não foi possível salvar a decisão.',
    'Proposed company change': 'Alteração proposta para a empresa',
    'Opening…': 'Abrindo…',
    'Approve this version': 'Aprovar esta versão',
    Decline: 'Recusar',
    'Review the submitted version below. Changes made since submission will need a new request.':
      'Revise abaixo a versão enviada. Alterações feitas desde o envio exigirão uma nova solicitação.',
    'The version submitted with this request.': 'A versão enviada com esta solicitação.',
    'Version and proposed change': 'Versão e alteração proposta',
    'Could not read the pinned content.': 'Não foi possível ler o conteúdo fixado.',
    'Showing a page of {value1} characters.': 'Exibindo uma página com {value1} caracteres.',
    'Beginning of the submitted content. Open the full text to review every page.':
      'Início do conteúdo enviado. Abra o texto completo para revisar todas as páginas.',
    'Read full submitted text': 'Ler texto completo enviado',
    'Previous page': 'Página anterior',
    'Next page': 'Próxima página',
    'Made private. Its creator has been told in their Inbox.':
      'Tornado privado. O criador foi informado na caixa de entrada.',
    'Made private. Its creator could not be notified.':
      'Tornado privado. Não foi possível notificar o criador.',
    'Make this {value1} private?': 'Tornar {value1} privado?',
    'Only the person who created it will see it. Everyone else loses access right away, and its creator gets an Inbox update if they are still a company member. If they have left, nobody in the company will be able to access this item.':
      'Somente a pessoa que o criou poderá vê-lo. Todas as outras pessoas perderão o acesso imediatamente, e o criador receberá uma atualização na caixa de entrada se ainda for membro da empresa. Se tiver saído, ninguém na empresa poderá acessar este item.',
    'Sent for review. The current audience stays unchanged until approval.':
      'Enviado para revisão. O público atual permanece inalterado até a aprovação.',
    ', revised {value1}': ', revisado {value1}',
    Download: 'Baixar',
    CSV: 'CSV',
    'Evidence for {value1}': 'Evidências para {value1}',
    Measure: 'Medida',
    'Show rows →': 'Mostrar linhas →',
    'Ask about this number': 'Perguntar sobre este número',
    'There are no numeric values available to chart. View the table for the original data.':
      'Não há valores numéricos disponíveis para criar o gráfico. Consulte a tabela para ver os dados originais.',
    'Chart value': 'Valor do gráfico',
    '{value1} of {value2} shown': '{value1} de {value2} exibidos',
    '{value1} by {value2}; {value3} rows. View Table for exact values.':
      '{value1} por {value2}; {value3} linhas. Consulte a tabela para ver os valores exatos.',
    'Values come directly from the source data. Missing values are not estimates.':
      'Os valores vêm diretamente dos dados de origem. Valores ausentes não são estimativas.',
    'Loading library…': 'Carregando biblioteca…',
    'We couldn’t load what happened in this App. Try again in a moment.':
      'Não foi possível carregar o que aconteceu neste aplicativo. Tente novamente em instantes.',
    'This App could not be opened.': 'Não foi possível abrir este aplicativo.',
    'Opening App…': 'Abrindo aplicativo…',
    'Open the saved App to run this function.':
      'Abra o aplicativo salvo para executar esta função.',
    'Save this App before running its function.':
      'Salve este aplicativo antes de executar sua função.',
    'Open saved App': 'Abrir aplicativo salvo',
    'Open Apps': 'Abrir aplicativos',
    'The App could not be opened. Try again.':
      'Não foi possível abrir o aplicativo. Tente novamente.',
    Owner: 'Proprietário',
    '{value1} · admins': '{value1} · administradores',
    'Owner · always edits': 'Proprietário · sempre pode editar',
    'Admins manage it': 'Os administradores gerenciam este item',
    Editors: 'Editores',
    'A colleague': 'Um colega',
    'Can edit drafts and publish versions': 'Pode editar rascunhos e publicar versões',
    Remove: 'Remover',
    'No editors yet.': 'Ainda não há editores.',
    'Admins can always edit company agents.':
      'Os administradores sempre podem editar os agentes da empresa.',
    'Asking for edit access': 'Solicitando acesso para editar',
    'Asked {value1} · also in your Inbox':
      'Solicitado em {value1} · também está na sua Caixa de entrada',
    Grant: 'Conceder',
    Admin: 'Administrador',
    'Make personal': 'Tornar pessoal',
    'Switch off': 'Desativar',
    Archive: 'Arquivar',
    'Archive this agent': 'Arquivar este agente',
    'Loading agent…': 'Carregando agente…',
    '{value1} Edit in chat': '{value1} Editar no chat',
    Agent: 'Agente',
    'This agent has not been created yet. It can run once its owner creates it.':
      'Este agente ainda não foi criado. Ele poderá ser executado quando o proprietário o criar.',
    'New agent · Draft': 'Novo agente · Rascunho',
    'Untitled agent': 'Agente sem título',
    'Test run': 'Execução de teste',
    'This draft does not run automatically.': 'Este rascunho não é executado automaticamente.',
    'Describe the agent in the chat. Its draft appears here.':
      'Descreva o agente no chat. O rascunho dele aparecerá aqui.',
    '{value1} Test run': '{value1} Execução de teste',
    'Describe the agent in the chat first.': 'Primeiro, descreva o agente no chat.',
    'Create and turn on': 'Criar e ativar',
    'Connection write setup': 'Configuração de gravação da conexão',
    'Account for connected changes': 'Conta para alterações conectadas',
    'Choose a connection': 'Escolha uma conexão',
    'No published Skills available. You can add them later.':
      'Nenhuma competência publicada disponível. Você poderá adicioná-las mais tarde.',
    '{value1} · not published. Review the changes. Testing is optional.':
      '{value1} · não publicado. Revise as alterações. O teste é opcional.',
    '{value1} Test draft': '{value1} Testar rascunho',
    'Apply changes…': 'Aplicar alterações…',
    'Apply this draft as a new version': 'Aplicar este rascunho como uma nova versão',
    'This draft cannot be applied.': 'Não é possível aplicar este rascunho.',
    'What changed?': 'O que mudou?',
    'Apply version {value1}': 'Aplicar versão {value1}',
    Create: 'Criar',
    'Edit access requested': 'Acesso para editar solicitado',
    '{value1} Request edit access': '{value1} Solicitar acesso para editar',
    '{value1} Copy agent': '{value1} Copiar agente',
    Pause: 'Pausar',
    'Open agent: {value1}': 'Abrir agente: {value1}',
    '· you can edit': '· você pode editar',
    '{value1} is switched off.': '{value1} está desativado.',
    '{value1} is archived.': '{value1} está arquivado.',
    'Loading agents…': 'Carregando agentes…',
    Agents: 'Agentes',
    'Agents do work for you on a schedule or when you ask. They follow your company’s Skills.':
      'Os agentes trabalham para você conforme uma programação ou quando você solicita. Eles seguem as competências da sua empresa.',
    'No agent matches. Try a Skill name or what the agent should do.':
      'Nenhum agente corresponde. Tente usar o nome de uma competência ou descrever o que o agente deve fazer.',
    'Nothing of your own yet': 'Você ainda não tem nada próprio',
    'Tell Chat what an agent should do, or copy one of the company’s agents below.{value1}':
      'Diga ao Chat o que um agente deve fazer ou copie um dos agentes da empresa abaixo.{value1}',
    'Your agents': 'Seus agentes',
    'Run on demand': 'Executar sob demanda',
    'Run is always available. A schedule is optional and lives separately from the agent’s instructions.':
      'A execução está sempre disponível. A programação é opcional e fica separada das instruções do agente.',
    'Archived. Its history is kept.': 'Arquivado. O histórico é mantido.',
    'Choose the page it goes under. Links to it keep working.':
      'Escolha a página sob a qual ele ficará. Os links para ele continuam funcionando.',
    'Its text, its history and any open suggestions are removed for good, and links to it from other pages stop working. This cannot be undone.':
      'O texto, o histórico e todas as sugestões abertas são removidos permanentemente, e os links para ele em outras páginas deixam de funcionar. Não é possível desfazer esta ação.',
    'An archived page no longer informs answers. Its history is kept, and a publisher can restore it or delete it permanently.':
      'Uma página arquivada não contribui mais para as respostas. O histórico é mantido, e um publicador pode restaurá-la ou excluí-la permanentemente.',
    Under: 'Sob',
    Change: 'Alterar',
    'Move under': 'Mover para sob',
    'Search pages': 'Pesquisar páginas',
    'Why?': 'Por quê?',
    'Delete permanently': 'Excluir permanentemente',
    'Move page': 'Mover página',
    'Archive page': 'Arquivar página',
    'Suggestion {value1}: show its card': 'Sugestão {value1}: mostrar o cartão',
    'Removed:': 'Removido:',
    'Added:': 'Adicionado:',
    'New page “{value1}”{value2}': 'Nova página “{value1}”{value2}',
    'No pages match “{value1}”.': 'Nenhuma página corresponde a “{value1}”.',
    'Where this page is': 'Onde esta página está',
    'Describe your company': 'Descreva sua empresa',
    'Empty page': 'Página vazia',
    'Describe {value1}': 'Descreva {value1}',
    'This page has no text yet.': 'Esta página ainda não tem texto.',
    'Poneva reads this page before every answer. Start with who you are, what you sell and how you work; details go on the pages under it.':
      'A Poneva lê esta página antes de cada resposta. Comece dizendo quem vocês são, o que vendem e como trabalham; os detalhes ficam nas páginas sob ela.',
    'Write it, or ask Poneva in chat to draft it for you.':
      'Escreva ou peça à Poneva, no chat, para criar um rascunho para você.',
    'Suggest a first version, and a publisher decides whether it becomes the page.':
      'Sugira uma primeira versão, e um publicador decidirá se ela se tornará a página.',
    'Start writing': 'Começar a escrever',
    'Suggest a first version': 'Sugerir uma primeira versão',
    'Accepted. The page is archived.': 'Aceita. A página foi arquivada.',
    'Accepted. The page is now revision {value1}.':
      'Aceita. A página agora está na revisão {value1}.',
    'Accepted.': 'Aceita.',
    'Suggestion rejected. The page stays as it is.':
      'Sugestão rejeitada. A página permanece como está.',
    'Your suggestion is withdrawn.': 'Sua sugestão foi retirada.',
    'Restored. The page informs answers again.':
      'Restaurada. A página voltou a contribuir para as respostas.',
    'Your suggestion is sent. A publisher decides whether it becomes the page.':
      'Sua sugestão foi enviada. Um publicador decidirá se ela se tornará a página.',
    'Saved. The page is now revision {value1}.': 'Salvo. A página agora está na revisão {value1}.',
    'Nothing changed.': 'Nada mudou.',
    'This page is not available.': 'Esta página não está disponível.',
    'It may have been deleted, archived or moved out of reach, or you may no longer be in this company.':
      'Ela pode ter sido excluída, arquivada ou movida para um local ao qual você não tem acesso, ou talvez você não faça mais parte desta empresa.',
    'Page actions': 'Ações da página',
    shown: 'mostradas',
    hidden: 'ocultas',
    '{value1} History': 'Histórico de {value1}',
    '{value1} Ask in chat': 'Perguntar sobre {value1} no chat',
    'Suggest edits': 'Sugerir edições',
    'More actions for {value1}': 'Mais ações para {value1}',
    '{value1} Poneva reads this page in every chat':
      '{value1} A Poneva lê esta página em todos os chats',
    'This page is archived. It no longer informs answers; its history is kept. {value1}':
      'Esta página está arquivada. Ela não contribui mais para as respostas; o histórico é mantido. {value1}',
    'Restore page': 'Restaurar página',
    'This link points to an earlier revision. You are reading the current text.':
      'Este link aponta para uma revisão anterior. Você está lendo o texto atual.',
    'Show it in History': 'Mostrar no histórico',
    Pages: 'Páginas',
    'Pages under {value1}': 'Páginas sob {value1}',
    'Linked from': 'Links de',
    Suggestions: 'Sugestões',
    'Suggestions are hidden. You are reading the page as everyone else sees it.':
      'As sugestões estão ocultas. Você está lendo a página como todos os outros a veem.',
    'Loading suggestions…': 'Carregando sugestões…',
    'Nothing is waiting for review.': 'Não há nada aguardando revisão.',
    'When someone, Poneva in a chat or a connected agent suggests a change to a page, it shows here and on the page. Nothing changes until a publisher accepts it.':
      'Quando alguém, a Poneva em um chat ou um agente conectado sugere uma alteração em uma página, ela aparece aqui e na página. Nada muda até que um publicador a aceite.',
    '{value1} Review knowledge in chat': '{value1} Revisar conhecimento no chat',
    'Suggestions for review': 'Sugestões para revisão',
    'Suggested changes from chats, meetings, colleagues and connected agents. Nothing changes until a publisher accepts it on the page.':
      'Alterações sugeridas em chats, reuniões, por colegas e por agentes conectados. Nada muda até que um publicador as aceite na página.',
    'Your suggestions wait here until a publisher decides. The pages stay as they are until then.':
      'Suas sugestões ficam aqui até que um publicador decida. Até lá, as páginas permanecem como estão.',
    'Review page': 'Revisar página',
    'Review on page': 'Revisar na página',
    'Open the meeting': 'Abrir a reunião',
    'Open the chat': 'Abrir o chat',
    'Accept and restore': 'Aceitar e restaurar',
    Accept: 'Aceitar',
    Reject: 'Rejeitar',
    'Your suggestion · waiting for a publisher': 'Sua sugestão · aguardando um publicador',
    Withdraw: 'Retirar',
    'Waiting for a publisher': 'Aguardando um publicador',
    'Suggestion {value1}': 'Sugestão {value1}',
    'Suggestion {value1} from {value2}{value3}': 'Sugestão {value1} de {value2}{value3}',
    'Read the suggested page': 'Ler a página sugerida',
    'Outdated: the text it changes was edited after it was suggested. It can be rejected or withdrawn; a new suggestion can be made against the current text.':
      'Desatualizada: o texto que ela altera foi editado depois que a sugestão foi feita. Ela pode ser rejeitada ou retirada; uma nova sugestão pode ser feita com base no texto atual.',
    'Restore this page first to accept this suggestion.':
      'Restaure esta página primeiro para aceitar esta sugestão.',
    'Previous suggestion': 'Sugestão anterior',
    'Suggestion {value1} of {value2}': 'Sugestão {value1} de {value2}',
    'Next suggestion': 'Próxima sugestão',
    'Fold the suggestions away': 'Recolher sugestões',
    'Show the suggestions': 'Mostrar sugestões',
    '1 suggestion': '1 sugestão',
    '{value1} suggestions': '{value1} sugestões',
    '{value1} the pages under {value2}': '{value1} as páginas em {value2}',
    px: 'px',
    '{value1} chart of {value2} across {value3}':
      'Gráfico {value1} de {value2} ao longo de {value3}',
    'We could not build the file.': 'Não foi possível criar o arquivo.',
    '{value1} Present': '{value1} Apresentação',
    'Building…': 'Criando…',
    'Download PowerPoint': 'Baixar PowerPoint',
    'Slide {value1} of {value2}': 'Slide {value1} de {value2}',
    Slides: 'Apresentações',
    'Slide {value1}': 'Diapositivo {value1}',
    'Speaker notes': 'Notas do apresentador',
    'Source: {value1}': 'Fonte: {value1}',
    'Add a name and a web address.': 'Adicione um nome e um endereço da Web.',
    'Enter a valid web address.': 'Insira um endereço da Web válido.',
    'Use a web address that starts with https://.':
      'Use um endereço da Web que comece com https://.',
    'Add a custom connection': 'Adicionar uma conexão personalizada',
    'Connect a tool server you trust. Poneva checks the address works and saves only the connection details needed to use it.':
      'Conecte um servidor de ferramentas confiável. O Poneva verifica se o endereço funciona e salva apenas os detalhes de conexão necessários para usá-lo.',
    'Web address': 'Endereço da Web',
    'https://tools.example.com': 'https://tools.example.com',
    'Starts with https://, from your provider': 'Começa com https://, fornecido pelo seu provedor',
    'Sign-in': 'Login',
    'Advanced sign-in': 'Login avançado',
    'Access key {value1}': 'Chave de acesso {value1}',
    'Request headers': 'Cabeçalhos da solicitação',
    'Add header': 'Adicionar cabeçalho',
    'Header {value1} name': 'Nome do cabeçalho {value1}',
    'Header name': 'Nome do cabeçalho',
    'Header {value1} value': 'Valor do cabeçalho {value1}',
    'Header value': 'Valor do cabeçalho',
    'Remove header': 'Remover cabeçalho',
    Advanced: 'Avançado',
    Transport: 'Transporte',
    'Auto-detect': 'Detectar automaticamente',
    'Streamable HTTP': 'HTTP com streaming',
    'Legacy SSE': 'SSE legado',
    "From your provider's app settings. Leave empty unless they gave you these.":
      'Nas configurações do aplicativo do seu provedor. Deixe em branco, a menos que ele tenha fornecido esses dados.',
    "Authorization server issuer": "Emissor do servidor de autorização",
    "Enter the authorization server issuer when using a client ID.": "Introduza o emissor do servidor de autorização quando utilizar um ID de cliente.",
    'Client ID {value1}': 'ID do cliente {value1}',
    'Client secret {value1}': 'Segredo do cliente {value1}',
    'Connecting…': 'Conectando…',
    'Test and connect': 'Testar e conectar',
    'Add the store, the client ID and the client secret.':
      'Adicione a loja, o ID do cliente e o segredo do cliente.',
    'Connect your Shopify Developer App': 'Conecte seu aplicativo de desenvolvedor da Shopify',
    'Poneva can use exactly the access your store gave the app, and nothing more. It talks to Shopify directly and keeps the client secret encrypted.':
      'O Poneva pode usar exatamente o acesso que sua loja concedeu ao aplicativo, e nada além disso. Ele se comunica diretamente com a Shopify e mantém o segredo do cliente criptografado.',
    'How to create the app in Shopify': 'Como criar o aplicativo na Shopify',
    'Open{value1} {value2}{value3} with the account that owns the store, and create an app.':
      'Abra{value1} {value2}{value3} com a conta que é proprietária da loja e crie um aplicativo.',
    'Create a version and select the access scopes Poneva may use, for example read_products and read_orders. Add write_ scopes only for data Poneva may change. Then release the version.':
      'Crie uma versão e selecione os escopos de acesso que o Poneva pode usar, por exemplo, read_products e read_orders. Adicione escopos write_ somente para dados que o Poneva pode alterar. Em seguida, lance a versão.',
    'For orders and customers, also select protected customer data in the app’s settings. Shopify allows this without review for an app made for your own store.':
      'Para pedidos e clientes, selecione também os dados protegidos de clientes nas configurações do aplicativo. A Shopify permite isso sem análise para um aplicativo criado para sua própria loja.',
    'Install the app on your store.': 'Instale o aplicativo na sua loja.',
    'Copy the client ID and client secret from the app’s settings.':
      'Copie o ID do cliente e o segredo do cliente nas configurações do aplicativo.',
    'To change the access later, release a new version, approve it on the store and use Test connection here.':
      'Para alterar o acesso depois, lance uma nova versão, aprove-a na loja e use Testar conexão aqui.',
    Store: 'Loja',
    'your-store.myshopify.com': 'your-store.myshopify.com',
    'Your store’s .myshopify.com address (Shopify admin → Settings → Domains), or paste the address of your Shopify admin page':
      'O endereço .myshopify.com da sua loja (admin da Shopify → Settings → Domains) ou cole o endereço da página de administração da Shopify',
    'Client ID {value1} {value2}': 'ID do cliente {value1} {value2}',
    'Client secret {value1} {value2}': 'Segredo do cliente {value1} {value2}',
    Person: 'Pessoa',
    Everyone: 'Todos',
    Connection: 'Conexão',
    'All connections': 'Todas as conexões',
    'App {value1}': 'Aplicativo {value1}',
    'From {value1}': 'De {value1}',
    'Until {value1}': 'Até {value1}',
    Result: 'Resultado',
    'All results': 'Todos os resultados',
    Succeeded: 'Concluído',
    Denied: 'Negado',
    Failed: 'Falhou',
    Unknown: 'Desconhecido',
    Filter: 'Filtrar',
    'Loading activity…': 'Carregando atividade…',
    'Could not load activity. Try again.':
      'Não foi possível carregar a atividade. Tente novamente.',
    'Removed connection': 'Conexão removida',
    'App: {value1}': 'Aplicativo: {value1}',
    'Older activity': 'Atividade mais antiga',
    'What changed in version {value1}': 'O que mudou na versão {value1}',
    'Every publish is a version you can restore.':
      'Cada publicação é uma versão que você pode restaurar.',
    Authorization: 'Autorização',
    '{value1} {value2} · {value3} will see it.': '{value1} {value2} · {value3} poderão vê-lo.',
    '{value1} {value2} you': '{value1} {value2} você',
    '· Revised': '· Revisado',
    'This chat used your {value1}.': 'Este chat usou seu {value1}.',
    'This chat has results from {value1}.': 'Este chat tem resultados de {value1}.',
    'db.example.com': 'db.example.com',
    'e.g. Product analytics': 'ex.: Análise de produto',
    'Paste access key': 'Cole a chave de acesso',
    'Shopify’s Dev Dashboard': 'Painel de desenvolvimento da Shopify',
    'App reference': 'Referência do app',
    'Draft · revision {value1}': 'Rascunho · revisão {value1}',
    'its Result': 'seu resultado',
    '· its first run makes it': '· sua primeira execução o torna',
    '{value1}’s chat ·': 'Chat de {value1} ·',
    '{value1} ad {value2} available.': '{value1} e {value2} disponíveis.',
    '{value1} rows ·': '{value1} linhas ·',
    'It starts private. Sharing it wider shares every refresh, which can carry your private data.':
      'Ele começa privado. Compartilhá-lo com mais pessoas compartilha todas as atualizações, que podem conter seus dados privados.',
    'Enable this schedule when approved': 'Ative esta programação quando aprovada',
    Schedule: 'Programação',
    'Kept off until you create the agent from its canvas.':
      'Permanece desativada até você criar o agente a partir do canvas.',
    'Will be enabled when you approve.': 'Será ativada quando você aprovar.',
    'Will be saved paused. You can enable it later.':
      'Será salva pausada. Você poderá ativá-la depois.',
    'Only runs when you ask.': 'Só é executada quando você solicitar.',
    'Draft · approving saves it, and nothing runs. Test it and create it from its canvas.':
      'Rascunho · aprovar salva o rascunho, e nada é executado. Teste-o e crie-o a partir do canvas.',
    'Draft · nothing is scheduled until you approve. Connected actions require their own approval at run time.':
      'Rascunho · nada é programado até você aprovar. As ações conectadas exigem aprovação própria no momento da execução.',
    Name: 'Nome',
    'Agent name': 'Nome do agente',
    'Who can use it': 'Quem pode usá-lo',
    'Company agent · company resources only': 'Agente da empresa · apenas recursos da empresa',
    'Personal agent · runs with your access': 'Agente pessoal · executado com seu acesso',
    'Approving saves it as a draft. It does not run automatically.':
      'A aprovação salva como rascunho. Ele não é executado automaticamente.',
    'Open the agent’s runs': 'Abrir as execuções do agente',
    'Run the published version once': 'Executar a versão publicada uma vez',
    'Stopping…': 'Parando…',
    'Stop run': 'Parar execução',
    'Could not stop this run. Please try again.':
      'Não foi possível parar esta execução. Tente novamente.',
    'Run in progress': 'Execução em andamento',
    'This run is still answering. You can ask follow-ups when it finishes.':
      'Esta execução ainda está respondendo. Você poderá fazer perguntas de acompanhamento quando ela terminar.',
    'Open run details': 'Abrir detalhes da execução',
    Runs: 'Execuções',
    'Open the run chat': 'Abrir o chat da execução',
    Watch: 'Acompanhar',
    Goal: 'Objetivo',
    'Change the goal': 'Alterar o objetivo',
    'What it does': 'O que ele faz',
    'What should this agent achieve?': 'O que este agente deve alcançar?',
    'Not set yet.': 'Ainda não definido.',
    'When it runs': 'Quando é executado',
    'Change when it runs': 'Alterar quando é executado',
    'Off means it runs only when someone runs it. Changing when it runs never changes its instructions.':
      'Desativado significa que ele só é executado quando alguém o executa. Alterar quando ele é executado nunca altera suas instruções.',
    Instructions: 'Instruções',
    'Change the instructions': 'Alterar as instruções',
    'How the agent should approach the work and make decisions.':
      'Como o agente deve realizar o trabalho e tomar decisões.',
    Boundaries: 'Limites',
    'What to do or avoid. Every connected action still follows its approval.':
      'O que fazer ou evitar. Cada ação conectada continua sujeita à aprovação.',
    'No instructions of its own. It follows its Skills.':
      'Não tem instruções próprias. Segue suas Skills.',
    'Pin a Skill': 'Fixar uma Skill',
    'Finds the Skills that fit each run, the same way a chat does.':
      'Encontra as Skills adequadas para cada execução, da mesma forma que um chat.',
    'Skills it always follows': 'Skills que ele sempre segue',
    'A Skill that is not published': 'Uma Skill que não foi publicada',
    'Always follows · Version {value1}': 'Sempre segue · Versão {value1}',
    'Not published': 'Não publicada',
    Uses: 'Usa',
    'Change in chat': 'Alterar no chat',
    'Change in chat: Uses': 'Alterar no chat: Usa',
    'Company knowledge and the tools each run is allowed to use.':
      'Conhecimento da empresa e as ferramentas que cada execução pode usar.',
    'People see the Result refresh; they change the agent, not the page.':
      'As pessoas veem o Resultado atualizado; elas alteram o agente, não a página.',
    'The first run after it is created makes the Result; later runs add a version to it.':
      'A primeira execução após sua criação gera o Resultado; as execuções seguintes adicionam uma versão a ele.',
    'Emails whoever the run is for': 'Envia um e-mail para a pessoa a quem a execução se destina',
    'Email each run': 'Enviar um e-mail a cada execução',
    Delivers: 'Entrega',
    'Change what it delivers': 'Alterar o que ele entrega',
    'Expected result': 'Resultado esperado',
    'What a successful run should deliver.': 'O que uma execução bem-sucedida deve entregar.',
    'What each run delivers': 'O que cada execução entrega',
    'Keeps one Result up to date {value1}': 'Mantém um Resultado atualizado {value1}',
    'Saves a new Result each run': 'Salva um novo Resultado a cada execução',
    'You can run this company agent as yourself.{value1} {value2}':
      'Você pode executar este agente da empresa como você mesmo.{value1} {value2}',
    'Changes since version': 'Alterações desde a versão',
    'are not live yet.': 'ainda não estão ativas.',
    'Review them in Versions': 'Revise-as em Versões',
    Skill: 'Habilidade',
    'The agent always uses the Skill’s published version.':
      'O agente sempre usa a versão publicada da Skill.',
    Day: 'Dia',
    Time: 'Hora',
    'Cron expression': 'Expressão cron',
    'Editors and access': 'Editores e acesso',
    Company: 'Empresa',
    Personal: 'Pessoal',
    'No changes.': 'Nenhuma alteração.',
    'Instructions changes': 'Alterações nas instruções',
    'Loading versions…': 'Carregando versões…',
    'What the draft changes': 'O que o rascunho altera',
    'No published version yet. Try the draft, then publish it.':
      'Ainda não há uma versão publicada. Teste o rascunho e publique-o.',
    'Published versions': 'Versões publicadas',
    'Former member': 'Ex-membro',
    Live: 'Ativa',
    '{value1} for {value2}': '{value1} para {value2}',
    Suggested: 'Sugerido',
    'Opening your conversation…': 'Abrindo sua conversa…',
    'This conversation isn’t available': 'Esta conversa não está disponível',
    'It may have been deleted, belong to another account, or be temporarily unavailable.':
      'Ela pode ter sido excluída, pertencer a outra conta ou estar temporariamente indisponível.',
    '{count} more line — shown in the complete revision':
      'Mais {count} linha — exibida na revisão completa',
    '{count} more lines — shown in the complete revision':
      'Mais {count} linhas — exibidas na revisão completa',
    '{count} more line removed': 'Mais {count} linha removida',
    '{count} more lines removed': 'Mais {count} linhas removidas',
    '{count} unchanged line': '{count} linha inalterada',
    '{count} unchanged lines': '{count} linhas inalteradas',
    '{count} more lines not shown, {added} added and {removed} removed. Check them in the complete revision.':
      'Mais {count} linhas não exibidas, {added} adicionadas e {removed} removidas. Confira-as na revisão completa.',
    'Saved result': 'Resultado salvo',
    'Made with a Skill': 'Feito com uma habilidade',
    'Preview of {name}': 'Prévia de {name}',
    'Made with {name}': 'Feito com {name}',
    'Ad-hoc result': 'Resultado ad hoc',
    'A Skill that is not available in this workspace':
      'Uma habilidade que não está disponível neste espaço de trabalho',
    '{name} · Revision {version}': '{name} · Revisão {version}',
    '{name} · Version {version}': '{name} · Versão {version}',
    'Return to conversation {value1}': 'Voltar à conversa {value1}',
    '{value1} Working with {value2}': '{value1} trabalhando com {value2}',
    'View context {value1}': 'Ver contexto {value1}',
    'A way of working, made yours.': 'Uma forma de trabalhar, do seu jeito.',
    'Work that runs itself.': 'Trabalho que se executa sozinho.',
    'One place for one piece of work.': 'Um só lugar para cada trabalho.',
    'Let’s move your work forward{value1}.': 'Vamos avançar com seu trabalho{value1}.',
    'Describe the work. Your Skill takes shape beside the conversation.':
      'Descreva o trabalho. Sua habilidade ganha forma ao lado da conversa.',
    'Describe what it should do and when. Your agent takes shape beside the conversation. The draft does not run automatically.':
      'Descreva o que ele deve fazer e quando. Seu agente ganha forma ao lado da conversa. O rascunho não é executado automaticamente.',
    'Say what the work is. Poneva drafts the project beside the conversation and brings in what you have already done. Nothing is created until you say so.':
      'Diga qual é o trabalho. A Poneva cria um rascunho do projeto ao lado da conversa e inclui o que você já fez. Nada é criado até você autorizar.',
    'Start with an idea below. Poneva will take it from there.':
      'Comece com uma ideia abaixo. A Poneva cuidará do resto.',
    Triggers: 'Gatilhos',
    'Review the agent and its trigger. Approval applies exactly what is shown.':
      'Revise o agente e seu gatilho. A aprovação aplica exatamente o que é exibido.',
    '{source} · read {date}': '{source} · lido em {date}',
    'Evidence is being recorded · read {date}':
      'As evidências estão sendo registradas · lido em {date}',
    'Evidence expired on {date} under the retention policy':
      'A evidência expirou em {date} conforme a política de retenção',
    'Entered by {person}': 'Inserido por {person}',
    'No retained evidence for this value': 'Nenhuma evidência retida para este valor',
    'Covers {shown} of {total} rows': 'Abrange {shown} de {total} linhas',
    'Search rows': 'Pesquisar linhas',
    'Clear filters': 'Limpar filtros',
    Sort: 'Ordenar',
    'Sort: {column}': 'Ordenar: {column}',
    '{shown} of {total} rows': '{shown} de {total} linhas',
    More: 'Mais',
    Density: 'Densidade',
    Comfortable: 'Confortável',
    Compact: 'Compacta',
    Columns: 'Colunas',
    'No rows match. Clear the search or filters to see them again.':
      'Nenhuma linha corresponde. Limpe a pesquisa ou os filtros para vê-las novamente.',
    'Not available': 'Não disponível',
    'All rows': 'Todas as linhas',
    'Close row detail': 'Fechar detalhes da linha',
    'Ask about this row': 'Perguntar sobre esta linha',
    'Add note': 'Adicionar nota',
    Note: 'Nota',
    Saved: 'Salvo',
    Total: 'Total',
    ascending: 'crescente',
    descending: 'decrescente',
    'Scroll to see all columns': 'Role para ver todas as colunas',
    App: 'Aplicativo',
    Artifact: 'Artefato',
    'New project': 'Novo projeto',
    'Review request': 'Solicitação de revisão',
    Activity: 'Atividade',
    'Voice preview': 'Prévia de voz',
    Source: 'Fonte',
    File: 'Arquivo',
    Meeting: 'Reunião',
    'Knowledge page': 'Página de conhecimento',
    'Could not preview this CSV.': 'Não foi possível visualizar este CSV.',
    'File content is unavailable.': 'O conteúdo do arquivo não está disponível.',
    'You have five open suggestions here. {value1} will see them.':
      'Você tem cinco sugestões abertas aqui. {value1} poderá vê-las.',
    'We could not send your suggestion. Please try again.':
      'Não foi possível enviar sua sugestão. Tente novamente.',
    'The agent': 'O agente',
    'Selected colleagues': 'Colegas selecionados',
    'The owner': 'O proprietário',
    'Forked. This copy is yours and runs with your own connections.':
      'Cópia criada. Esta cópia é sua e funciona com suas próprias conexões.',
    'This chat is too long to fork.': 'Esta conversa é longa demais para criar uma cópia.',
    'We could not fork this chat. Please try again.':
      'Não foi possível criar uma cópia desta conversa. Tente novamente.',
    'Anyone who forked it keeps their copy: forks stay with the people who made them.':
      'Quem criou uma cópia fica com ela: as cópias permanecem com as pessoas que as criaram.',
    'Nobody has forked this chat.': 'Ninguém criou uma cópia desta conversa.',
    '1 person forked this chat. Their copy stays theirs.':
      '1 pessoa criou uma cópia desta conversa. A cópia permanece com ela.',
    '{value1} people forked this chat. Their copies stay theirs.':
      '{value1} pessoas criaram cópias desta conversa. As cópias permanecem com elas.',
    'Personal. Nobody else sees it.': 'Pessoal. Ninguém mais pode vê-lo.',
    'People you pick. They get it in their Inbox.':
      'As pessoas que você escolher. Elas receberão na Caixa de entrada.',
    'Everyone in the company can follow it and fork it.':
      'Todos na empresa podem acompanhá-lo e criar uma cópia.',
    'a chat you can no longer open': 'uma conversa que você não pode mais abrir',
    'shared the Result': 'compartilhou o Resultado',
    'updated the Result': 'atualizou o Resultado',
    'published the Skill': 'publicou a Habilidade',
    'approved the fact': 'aprovou o fato',
    'added the fact': 'adicionou o fato',
    'added the meeting': 'adicionou a reunião',
    'published the page': 'publicou a página',
    'updated the page': 'atualizou a página',
    'shared the chat': 'compartilhou a conversa',
    'published a version of': 'publicou uma versão de',
    ran: 'executou',
    Knowledge: 'Conhecimento',
    Meetings: 'Reuniões',
    Chat: 'Conversa',
    Use: 'Usar',
    Open: 'Abrir',
    You: 'Você',
    Someone: 'Alguém',
    'published version {version} of': 'publicou a versão {version} de',
    'thing needs': 'item precisa',
    'things need': 'itens precisam',
    'Published Skill': 'Habilidade publicada',
    'Included with Skill': 'Incluído com a Habilidade',
    'Already attached': 'Já anexado',
    'Also available in company knowledge': 'Também disponível no conhecimento da empresa',
    'Company file': 'Arquivo da empresa',
    'Account identity unavailable': 'Identidade da conta indisponível',
    'Access expired or was revoked. Reconnect to continue.':
      'O acesso expirou ou foi revogado. Reconecte-se para continuar.',
    'Account authorized · tools unavailable': 'Conta autorizada · ferramentas indisponíveis',
    'Not available in this workspace yet.': 'Ainda não disponível neste espaço de trabalho.',
    'Everyone in the company': 'Todos na empresa',
    'Audience: only you.': 'Público: somente você.',
    'Audience: everyone in the company.': 'Público: todos na empresa.',
    'tool is': 'ferramenta é',
    'tools are': 'ferramentas são',
    'account is': 'conta é',
    'accounts are': 'contas são',
    'We could not upload this file.': 'Não foi possível enviar este arquivo.',
    'file was': 'o arquivo era',
    'files were': 'os arquivos eram',
    'Your company': 'Sua empresa',
    'Create an agent': 'Criar um agente',
    'Give recurring work a helping hand': 'Dê uma mãozinha ao trabalho recorrente',
    'Create a Skill': 'Criar uma habilidade',
    'Save a reusable way of working': 'Salve uma forma reutilizável de trabalhar',
    'Take meeting notes': 'Fazer anotações de reunião',
    'Capture decisions and next steps': 'Registrar decisões e próximos passos',
    'Work with a file': 'Trabalhar com um arquivo',
    'Start from a document or image': 'Começar com um documento ou imagem',
    'Browse agents': 'Explorar agentes',
    'Open your agents and company agents': 'Abrir seus agentes e os agentes da empresa',
    'Review results': 'Revisar resultados',
    'Return to work saved in your Library': 'Voltar ao trabalho salvo na sua Biblioteca',
    'For review': 'Para revisão',
    'An agent': 'Um agente',
    Assistant: 'Assistente',
    'Kept up to date by {value1}{value2}': 'Mantido atualizado por {value1}{value2}',
    ', {value1}': ', {value1}',
    'Version {value1}{value2}{value3}': 'Versão {value1}{value2}{value3}',
    'Refreshed by its agent': 'Atualizado pelo próprio agente',
    'Saved from a chat': 'Salvo de um chat',
    'Saved from {value1}': 'Salvo de {value1}',
    Edited: 'Editado',
    'private account': 'conta privada',
    '{value1} ({value2})': '{value1} ({value2})',
    '{value1}’s {value2}': '{value2} de {value1}',
    'Made private. The person who added it and the owner of its recording have been told in their Inbox.':
      'Tornado privado. A pessoa que o adicionou e o proprietário da gravação foram avisados na Caixa de entrada.',
    'Made private. The person who added it has been told in their Inbox.':
      'Tornado privado. A pessoa que o adicionou foi avisada na Caixa de entrada.',
    'Made private. The owner of its recording has been told in their Inbox.':
      'Tornado privado. O proprietário da gravação foi avisado na Caixa de entrada.',
    'Selected passage': 'Trecho selecionado',
    '{value1} {value2}': '{value1} {value2}',
    'Upload a file': 'Enviar um arquivo',
    'Help me create a useful report from our company knowledge and available sources.':
      'Ajude-me a criar um relatório útil com base no conhecimento da nossa empresa e nas fontes disponíveis.',
    'This saved work couldn’t be opened. Open it again to retry.':
      'Não foi possível abrir este trabalho salvo. Abra-o novamente para tentar de novo.',
    '{value1}’s': 'de {value1}',
    '{value1} chat “{value2}”': 'chat de {value1} “{value2}”',
    '{value1}{value2}': '{value1}{value2}',
    'Skill: {value1}{value2}': 'Habilidade: {value1}{value2}',
    'Result “{value1}”': 'Resultado “{value1}”',
    'Meeting “{value1}”': 'Reunião “{value1}”',
    'Used in {value1} {value2} this week': 'Usado em {value1} {value2} esta semana',
    '{value1} {value2} · used in {value3} {value4}':
      '{value1} {value2} · usado em {value3} {value4}',
    'The draft is not published yet, so no one else follows it.':
      'O rascunho ainda não foi publicado, então ninguém mais o acompanha.',
    'Use it in a chat for current data, or refine the Skill first.':
      'Use-a em um chat para obter dados atuais ou refine a habilidade primeiro.',
    'An agent keeps this up to date. Continue the work in chat.':
      'Um agente mantém isso atualizado. Continue o trabalho no chat.',
    'Edit it here, or continue the work in chat.': 'Edite aqui ou continue o trabalho no chat.',
    'Duplicate it to your Library, or continue the work in chat.':
      'Duplique-o para sua Biblioteca ou continue o trabalho no chat.',
    'Download Markdown': 'Baixar Markdown',
    'Download CSV': 'Baixar CSV',
    'an agent': 'um agente',
    'Publish a Skill version': 'Publicar uma versão da habilidade',
    'Share with {value1}': 'Compartilhar com {value1}',
    'Update company content': 'Atualizar o conteúdo da empresa',
    Approved: 'Aprovado',
    Declined: 'Recusado',
    Pending: 'Pendente',
    'View decision': 'Ver decisão',
    'No data': 'Sem dados',
    'No change': 'Nenhuma alteração',
    'Connection created': 'Conexão criada',
    'Sharing changed': 'Compartilhamento alterado',
    'Person added': 'Pessoa adicionada',
    'Person removed': 'Pessoa removida',
    'Access changed': 'Acesso alterado',
    'Access turned off': 'Acesso desativado',
    'Connection removed': 'Conexão removida',
    'Query time limit changed': 'Limite de tempo da consulta alterado',
    '{count} row': '{count} linha',
    '{count} rows': '{count} linhas',
    'This source is no longer available. Company knowledge now lives in Knowledge pages, and files stay in the Library.':
      'Esta fonte não está mais disponível. O conhecimento da empresa agora fica nas páginas de Conhecimento, e os arquivos permanecem na Biblioteca.',
    '· {value1} by {value2}': '· {value1} por {value2}',
    '· version {value1}': '· versão {value1}',
    '{message} {count} earlier file was saved and attached.':
      '{message} {count} arquivo anterior foi salvo e anexado.',
    '{message} {count} earlier files were saved and attached.':
      '{message} {count} arquivos anteriores foram salvos e anexados.',
    '{message} {count} earlier file was saved.': '{message} {count} arquivo anterior foi salvo.',
    '{message} {count} earlier files were saved.':
      '{message} {count} arquivos anteriores foram salvos.',
    'refreshed {time}': 'atualizado {time}',
    'a colleague': 'um colega',
    'Your chat “{title}”': 'Seu chat “{title}”',
    '{name}’s chat “{title}”': 'Chat de {name}: “{title}”',
    'Kept up to date by {name}{version}': 'Mantido atualizado por {name}{version}',
    'Skill: {name}{version}': 'Habilidade: {name}{version}',
    'Result “{title}”': 'Resultado “{title}”',
    'Meeting “{title}”': 'Reunião “{title}”',
    'Used in {count} answer this week': 'Usado em {count} resposta esta semana',
    'Used in {count} answers this week': 'Usado em {count} respostas esta semana',
    '{count} source': '{count} fonte',
    '{count} sources': '{count} fontes',
    'used in {count} place': 'usado em {count} local',
    'used in {count} places': 'usado em {count} locais',
    '{company} workspace': '{company} espaço de trabalho',
    '{count} page': '{count} página',
    '{count} pages': '{count} páginas',
    '{needs} · reviews and approvals': '{needs} · revisões e aprovações',
    '{count} thing needs you': '{count} item precisa de você',
    '{count} things need you': '{count} itens precisam de você',
    'Included with Skill · {files} · {sources} {icon}':
      'Incluído com a habilidade · {files} · {sources} {icon}',
    '{count} file': '{count} arquivo',
    '{count} files': '{count} arquivos',
    Today: 'Hoje',
    'Earlier this week': 'Mais cedo nesta semana',
    '{count} slide': '{count} diapositivo',
    '{count} slides': '{count} diapositivos',
    Early: 'Cedo',
    'TLS verified': 'TLS verificado',
    'Made personal and switched off. Switch it on when you are ready.':
      'Tornado pessoal e desativado. Ative-o quando estiver pronto.',
    'Made personal and switched off. Its owner is told which version is live.':
      'Tornado pessoal e desativado. O proprietário é informado sobre qual versão está ativa.',
    'Switched off.': 'Desativado.',
    'Applied version {revision}.': 'Versão {revision} aplicada.',
    'The draft is running in a chat only you can read.':
      'O rascunho está sendo executado em um chat que só você pode ler.',
    'Publish a version first.': 'Publique uma versão primeiro.',
    'Another Agent action is in progress.': 'Outra ação do Agente está em andamento.',
    'Knowledge & connections': 'Conhecimento e conexões',
    'Pinned Skills': 'Habilidades fixadas',
    None: 'Nenhum',
    'A new Result each run': 'Um novo Resultado a cada execução',
    'One Result kept up to date': 'Um Resultado mantido atualizado',
    Email: 'E-mail',
    On: 'Ativado',
    Off: 'Desativado',
    'Waiting for review': 'Aguardando revisão',
    Outdated: 'Desatualizado',
    Accepted: 'Aceito',
    Rejected: 'Rejeitado',
    Withdrawn: 'Retirado',
    Replaced: 'Substituído',
    'Suggested edit': 'Edição sugerida',
    'Suggested new page': 'Nova página sugerida',
    'Suggested move': 'Movimentação sugerida',
    'Suggested archive': 'Arquivamento sugerido',
    'Checking status…': 'Verificando status…',
    'Status unavailable': 'Status indisponível',
    'Bulleted list': 'Lista com marcadores',
    'Numbered list': 'Lista numerada',
    'Web link': 'Link da web',
    Read: 'Ler',
    Write: 'Escrever',
    'shared with you': 'partilhado consigo',
    'Getting an answer': 'A obter uma resposta',
    '{name} is getting an answer': '{name} está a obter uma resposta',
    'We could not save. Please try again.': 'Não foi possível salvar. Tente novamente.',
    'The new page could not be created.': 'Não foi possível criar a nova página.',
    'We could not load this revision.': 'Não foi possível carregar esta revisão.',
    'We could not restore this revision. Please try again.':
      'Não foi possível restaurar esta revisão. Tente novamente.',
    'We could not export this revision.': 'Não foi possível exportar esta revisão.',
    'We could not open this suggestion.': 'Não foi possível abrir esta sugestão.',
    'We could not do that. Please try again.': 'Não foi possível fazer isso. Tente novamente.',
    'We could not save your decision. Please try again.':
      'Não foi possível salvar sua decisão. Tente novamente.',
    'We could not restore this page. Please try again.':
      'Não foi possível restaurar esta página. Tente novamente.',
    'We could not export this page.': 'Não foi possível exportar esta página.',
    '{count} missed time merged.': '{count} intervalo perdido mesclado.',
    '{count} missed times merged.': '{count} intervalos perdidos mesclados.',
    'About this project': 'Sobre este projeto',
  },
  ro: {
    'We could not load this item.': 'Nu am putut încărca acest element.',
    '{value1} canvas': '{value1} pânză',
    'Loading {value1}…': 'Se încarcă {value1}…',
    '{value1} · Original retained': '{value1} · Original păstrat',
    '{value1} {value2}{value3} · Added {value4}': '{value1} {value2}{value3} · Adăugat {value4}',
    '{value1} Use in chat': '{value1} Folosește în chat',
    '{value1} Download': '{value1} Descarcă',
    Table: 'Tabel',
    Chart: 'Grafic',
    Original: 'Original',
    'Text extracted from the PDF, marked by page. Download the original for its layout and images.':
      'Text extras din PDF, marcat pe pagini. Descarcă originalul pentru aspectul și imaginile sale.',
    'This preview shows the beginning of the file. Poneva reads the whole file; download the original to see all of it.':
      'Această previzualizare arată începutul fișierului. Poneva citește întregul fișier; descarcă originalul pentru a-l vedea complet.',
    'Preview of the first {value1} complete rows. Filtering and charts use only this preview. Download the original for the full file.':
      'Previzualizarea primelor {value1} rânduri complete. Filtrarea și graficele folosesc doar această previzualizare. Descarcă originalul pentru fișierul complet.',
    'This source link cannot be opened.': 'Acest link sursă nu poate fi deschis.',
    'Read-only chat': 'Chat cu acces doar pentru citire',
    'Only {value1} writes in this chat. Fork it to continue with your own connections. {value2}':
      'Doar {value1} poate scrie în acest chat. Creează o copie pentru a continua cu propriile conexiuni. {value2}',
    'Suggest a follow-up…': 'Sugerează o continuare…',
    'Suggest a follow-up': 'Sugerează o continuare',
    'Sending…': 'Se trimite…',
    Send: 'Trimite',
    'We could not dismiss that suggestion. Please try again.':
      'Nu am putut închide acea sugestie. Încearcă din nou.',
    'Suggested follow-ups': 'Continuări sugerate',
    '{value1} suggests': '{value1} sugerează',
    Ask: 'Întreabă',
    'Dismiss {value1}’s suggestion': 'Închide sugestia lui {value1}',
    'Suggested by': 'Sugerată de',
    '· edit it or send it': '· editeaz-o sau trimite-o',
    'Remove the suggestion tag': 'Elimină eticheta sugestiei',
    '{value1} {value2} is getting an answer': '{value1} {value2} primește un răspuns',
    '{value1} {value2} stopped the answer': '{value1} {value2} a oprit răspunsul',
    '{value1} Fork from here': '{value1} Creează o copie de aici',
    '{value1} From {value2}’s {value3}': '{value1} Din {value3} al lui {value2}',
    'Only {value1} can use this account': 'Doar {value1} poate folosi acest cont',
    '{value1} Suggested by {value2}': '{value1} Sugerată de {value2}',
    'Fork this chat': 'Creează o copie a acestui chat',
    'Forking…': 'Se creează copia…',
    Fork: 'Creează o copie',
    'Could not make this private.': 'Nu s-a putut face privat.',
    'Make this chat private?': 'Faci acest chat privat?',
    Close: 'Închide',
    '{value1} will see “{value2}”. Everyone else loses access right away {value3} .{value4}':
      '{value1} va vedea „{value2}”. Toți ceilalți își pierd imediat accesul {value3} .{value4}',
    Cancel: 'Anulează',
    'Saving…': 'Se salvează…',
    'Make private': 'Fă privat',
    'This chat is private again. Forks others made stay theirs.':
      'Acest chat este din nou privat. Copiile create de ceilalți rămân ale lor.',
    'Who can read this chat: {value1}': 'Cine poate citi acest chat: {value1}',
    'Move this chat': 'Mută acest chat',
    'Only you write here. Others follow live and fork.':
      'Doar tu scrii aici. Ceilalți urmăresc în timp real și pot crea copii.',
    'Made private. {value1} has been told in their Inbox.':
      'A fost făcut privat. {value1} a fost informat(ă) în Mesaje primite.',
    'Chat access': 'Acces la chat',
    '{value1}’s chat. As an admin you can make it private.':
      'Chatul lui {value1}. În calitate de administrator, îl poți face privat.',
    'Only {value1} will see it. {value2} is told.':
      'Doar {value1} îl va vedea. {value2} este informat(ă).',
    '{value1} {value2} following': '{value1} {value2} urmăresc',
    'Forked from{value1} {value2} . The history is copied. From here, tools run with your own access.':
      'Copie creată din{value1} {value2} . Istoricul este copiat. De aici, instrumentele rulează cu propriul tău acces.',
    '{value1} made this chat private': '{value1} a făcut acest chat privat',
    'You can no longer open it. Any fork you made stays yours.':
      'Nu îl mai poți deschide. Orice copie ai creat rămâne a ta.',
    'Start a new chat': 'Începe un chat nou',
    'Back to Recent chats': 'Înapoi la chat-urile recente',
    'More chat actions': 'Mai multe acțiuni pentru chat',
    'Close conversation sharing': 'Închide distribuirea conversației',
    'Review the text before saving a private copy to Library. Then choose its audience. Your original conversation and future messages stay private.':
      'Verifică textul înainte de a salva o copie privată în Bibliotecă. Apoi alege publicul acesteia. Conversația originală și mesajele viitoare rămân private.',
    'Preparing the conversation…': 'Se pregătește conversația…',
    'Refresh preview': 'Reîmprospătează previzualizarea',
    'The copy is saved in Library. Use Share to choose who can access it.':
      'Copia este salvată în Bibliotecă. Folosește Distribuie pentru a alege cine o poate accesa.',
    'Save this copy': 'Salvează această copie',
    'That Skill could not be opened.': 'Abilitatea respectivă nu a putut fi deschisă.',
    '{value1}{value2} · reviews and approvals': '{value1}{value2} · recenzii și aprobări',
    'Open Inbox': 'Deschide Mesaje primite',
    'New at {value1} this week': 'Noutăți la {value1} în această săptămână',
    'Nothing new this week. Shared work, published Skills and approved knowledge show up here.':
      'Nimic nou în această săptămână. Aici apar lucrările distribuite, abilitățile publicate și cunoștințele aprobate.',
    'New at {value1}': 'Noutăți la {value1}',
    'This Skill is unavailable. Try again.':
      'Această abilitate nu este disponibilă. Încearcă din nou.',
    'You can attach up to {value1} files. Remove an attachment to add another.':
      'Poți atașa până la {value1} fișiere. Elimină un atașament pentru a adăuga altul.',
    'Add company context': 'Adaugă contextul companiei',
    'Add company context · @': 'Adaugă contextul companiei · @',
    'Choose a Skill': 'Alege o abilitate',
    'Choose a Skill · /': 'Alege o abilitate · /',
    context: 'context',
    skills: 'competențe',
    'Choose company context': 'Alege contextul companiei',
    'Skills for this conversation': 'Competențe pentru această conversație',
    'Bring context into the conversation': 'Adaugă context în conversație',
    'Close context picker': 'Închide selectorul de context',
    'Filter company context': 'Filtrează contextul companiei',
    'Find a Skill…': 'Găsește o competență…',
    'Find a file…': 'Găsește un fișier…',
    'Available company context': 'Context disponibil al companiei',
    'No matching published Skills.': 'Nu există competențe publicate corespunzătoare.',
    'No matching files.': 'Nu există fișiere corespunzătoare.',
    'Searching company work…': 'Se caută în activitatea companiei…',
    'Try search again': 'Încearcă din nou căutarea',
    'Meaning search is temporarily limited. Showing available text matches.':
      'Căutarea semantică este temporar limitată. Se afișează potrivirile text disponibile.',
    'Load more matches': 'Încarcă mai multe potriviri',
    '{value1} files attached. Remove an attachment to add another. Saved Skill references are included separately.':
      'Sunt atașate {value1} fișiere. Elimină un atașament pentru a adăuga altul. Referințele salvate ale competenței sunt incluse separat.',
    'Create a Skill in chat': 'Creează o competență în chat',
    'Upload a company file': 'Încarcă un fișier al companiei',
    'Company knowledge is always available to Poneva.':
      'Cunoștințele companiei sunt întotdeauna disponibile pentru Poneva.',
    '{value1} was not connected': '{value1} nu a fost conectat',
    Dismiss: 'Închide',
    'Try connecting again': 'Încearcă să te conectezi din nou',
    Waiting: 'Se așteaptă',
    Connected: 'Conectat',
    'Needs reconnecting': 'Necesită reconectare',
    Connect: 'Conectează',
    '{value1}{value2} The provider’s account permissions still apply.':
      '{value1}{value2} Se aplică în continuare permisiunile contului furnizorului.',
    'Last error: {value1}': 'Ultima eroare: {value1}',
    '{value1} {value2} ready.': '{value1} {value2} este gata.',
    'Continue with my Meta app': 'Continuă cu aplicația mea Meta',
    Reconnect: 'Reconectează',
    Disconnect: 'Deconectează',
    'Remove attachment: {value1}': 'Elimină atașamentul: {value1}',
    'Saved in this Skill. Edit the Skill to change its references.':
      'Salvat în această competență. Editează competența pentru a-i modifica referințele.',
    'Remove Skill context': 'Elimină contextul competenței',
    Refining: 'Se rafinează',
    Previewing: 'Se previzualizează',
    Using: 'Se utilizează',
    'Skill revision {value1}': 'Versiunea competenței {value1}',
    'a new Skill': 'o competență nouă',
    '{value1} Making a new agent {value2}': '{value1} Se creează un agent nou {value2}',
    'Stop making a new agent in this chat': 'Oprește crearea unui agent nou în acest chat',
    'Saved Skill references': 'Referințe salvate ale competenței',
    'Included with Skill · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}':
      'Inclus cu competența · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}',
    'Selected Skill revision is unavailable. Select the Skill again to view its saved references.':
      'Versiunea selectată a competenței nu este disponibilă. Selectează din nou competența pentru a-i vedea referințele salvate.',
    'Conversation attachments': 'Atașamentele conversației',
    'Added for this conversation': 'Adăugat pentru această conversație',
    'Selected passage {value1}': 'Fragment selectat {value1}',
    'We could not load your workspace.': 'Nu am putut încărca spațiul tău de lucru.',
    'The selected Skill is unavailable. Check its access or choose it again.':
      'Competența selectată nu este disponibilă. Verifică accesul la aceasta sau selecteaz-o din nou.',
    'Source saved privately and included in your knowledge search.':
      'Sursa a fost salvată privat și inclusă în căutarea cunoștințelor tale.',
    'File saved privately to your library and attached to this message.':
      'Fișierul a fost salvat privat în biblioteca ta și atașat la acest mesaj.',
    'File saved privately to your library.': 'Fișierul a fost salvat privat în biblioteca ta.',
    '{value1} {value2} earlier {value3} saved{value4}.':
      '{value1} {value2} anterior {value3} salvat{value4}.',
    'Extracted text for Poneva to read. Download the original for its layout, charts and images. Spreadsheet formulas show their saved results and are not recalculated.':
      'Text extras pentru a fi citit de Poneva. Descarcă originalul pentru aspectul, graficele și imaginile sale. Formulele din foaia de calcul afișează rezultatele salvate și nu sunt recalculare.',
    Esc: 'Esc',
    'Start something': 'Începe ceva',
    'Choose a file to work with': 'Alege un fișier cu care să lucrezi',
    'Skills worth adding': 'Competențe care merită adăugate',
    'Picked for you': 'Selectate pentru tine',
    'Reusable work grounded in your company knowledge.':
      'Activitate reutilizabilă bazată pe cunoștințele companiei tale.',
    'Ideas from your company context and recent work. Pick one to start.':
      'Idei din contextul companiei și activitatea ta recentă. Alege una pentru a începe.',
    'Refresh suggested tasks': 'Reîmprospătează sarcinile sugerate',
    'Check for new company context.': 'Verifică dacă există context nou al companiei.',
    'Check for new context. Ideas also refresh daily.':
      'Verifică dacă există context nou. Ideile se reîmprospătează zilnic.',
    Refresh: 'Reîmprospătează',
    'Finding useful starting points…': 'Se caută puncte de pornire utile…',
    'Suggestions aren’t available right now. Try Refresh, or describe the work you want to do.':
      'Sugestiile nu sunt disponibile momentan. Încearcă „Reîmprospătează” sau descrie activitatea pe care vrei să o faci.',
    'Loading the knowledge pages…': 'Se încarcă paginile de cunoștințe…',
    '{value1} All pages': '{value1} Toate paginile',
    'The page is created.': 'Pagina a fost creată.',
    'Your new page is suggested. A publisher decides whether it is added.':
      'Pagina ta nouă este propusă. Un editor decide dacă este adăugată.',
    'Company knowledge': 'Cunoștințele companiei',
    'What Poneva knows about your company, page by page. Every change is kept.':
      'Ce știe Poneva despre compania ta, pagină cu pagină. Fiecare modificare este păstrată.',
    'Loading company knowledge…': 'Se încarcă cunoștințele companiei…',
    'Knowledge pages are not enabled in this workspace.':
      'Paginile de cunoștințe nu sunt activate în acest spațiu de lucru.',
    'Ask your Poneva contact to switch them on for your company.':
      'Cere persoanei tale de contact de la Poneva să le activeze pentru compania ta.',
    '{value1} Change the agent': '{value1} Schimbă agentul',
    '{value1} Continue in chat': '{value1} Continuă în chat',
    Edit: 'Editează',
    '{value1} Edit with chat': '{value1} Editează în chat',
    '{value1} Duplicate to my Library': '{value1} Duplică în biblioteca mea',
    'Duplicated to your Library. Only you can see the copy.':
      'S-a creat o copie în biblioteca ta. Doar tu poți vedea copia.',
    'Could not duplicate this Result. Try again.':
      'Rezultatul nu a putut fi duplicat. Încearcă din nou.',
    'Saved version {value1}.': 'Versiunea {value1} a fost salvată.',
    'A newer version was saved. Reload the Result before saving.':
      'A fost salvată o versiune mai nouă. Reîncarcă rezultatul înainte de a salva.',
    'Could not save this version. Try again.':
      'Această versiune nu a putut fi salvată. Încearcă din nou.',
    '{value1} saved a newer version. Review it before saving.':
      '{value1} a salvat o versiune mai nouă. Verific-o înainte de a salva.',
    'Hide their version': 'Ascunde versiunea lor',
    'Show their version': 'Afișează versiunea lor',
    'Start from their version': 'Începe de la versiunea lor',
    Markdown: 'Markdown',
    'Result text': 'Textul rezultatului',
    Preview: 'Previzualizare',
    'What changed': 'Ce s-a schimbat',
    'What changed? (optional)': 'Ce s-a schimbat? (opțional)',
    'Save version {value1}': 'Salvează versiunea {value1}',
    'Open chat': 'Deschide chatul',
    Current: 'Actuală',
    Restore: 'Restaurează',
    'Could not load the history.': 'Istoricul nu a putut fi încărcat.',
    'Restored version {value1} as version {value2}.':
      'Versiunea {value1} a fost restaurată ca versiunea {value2}.',
    'Someone saved a newer version. Review it before restoring.':
      'Cineva a salvat o versiune mai nouă. Verific-o înainte de restaurare.',
    'Could not restore that version.': 'Versiunea respectivă nu a putut fi restaurată.',
    'Loading history…': 'Se încarcă istoricul…',
    'Restoring keeps what is there now as a version too, so nothing is lost.':
      'Restaurarea păstrează și starea actuală ca versiune, astfel încât nimic nu se pierde.',
    'This Result was made with your own {value1}.':
      'Acest rezultat a fost creat cu propriul tău {value1}.',
    'It also used': 'A folosit și',
    'This Result was made with': 'Acest rezultat a fost creat cu',
    'Colleagues can read what came from them, but can never use them.':
      'Colegii pot citi ceea ce provine de la ei, dar nu le pot folosi niciodată.',
    'Your personal agent {value1} keeps it up to date with your own access, so every refresh can carry your private data.':
      'Agentul tău personal {value1} îl menține actualizat folosind propriul tău acces, astfel încât fiecare reîmprospătare poate include datele tale private.',
    'A colleague’s personal agent keeps it up to date with their own access, so every refresh can carry their private data.':
      'Agentul personal al unui coleg îl menține actualizat folosind propriul acces, astfel încât fiecare reîmprospătare poate include datele private ale acestuia.',
    'Made private. Only you can see this meeting.':
      'A fost setată ca privată. Doar tu poți vedea această întâlnire.',
    'Could not make this meeting private.': 'Această întâlnire nu a putut fi setată ca privată.',
    'Meeting · {value1} {value2} · Original retained':
      'Întâlnire · {value1} {value2} · Originalul a fost păstrat',
    'The recording could not be opened.': 'Înregistrarea nu a putut fi deschisă.',
    'Ask about this suggestion': 'Întreabă despre această sugestie',
    meeting_processing_failed: 'Procesarea întâlnirii a eșuat',
    'Who can see this': 'Cine poate vedea acest lucru',
    'Everyone at {value1}': 'Toți cei din {value1}',
    'Only me': 'Doar eu',
    'Everyone at {value1} can find it and ask about it.':
      'Toți cei din {value1} îl pot găsi și pot pune întrebări despre el.',
    'Only you can open and search this meeting. You can share it later.':
      'Doar tu poți deschide și căuta în această întâlnire. O poți distribui mai târziu.',
    'Added. Only you can see it. Transcription is running in the background.':
      'Adăugat. Doar tu îl poți vedea. Transcrierea se execută în fundal.',
    'Visible to everyone at {value1}': 'Vizibil pentru toți cei din {value1}',
    'Could not make it private.': 'Nu a putut fi setat ca privat.',
    'Show more meetings': 'Afișează mai multe întâlniri',
    'Attached to this message': 'Atașat la acest mesaj',
    'Connect securely, choose the tables to share, then decide whether Poneva can read or make changes.':
      'Conectează-te în siguranță, alege tabelele de distribuit, apoi decide dacă Poneva le poate citi sau modifica.',
    'Review the tables this connection can access. Select at least one table.':
      'Verifică tabelele la care poate avea acces această conexiune. Selectează cel puțin un tabel.',
    'Select at least one table. Nothing is selected by default.':
      'Selectează cel puțin un tabel. În mod implicit, nu este selectat nimic.',
    'Choose who can use this connection and what Poneva can do.':
      'Alege cine poate folosi această conexiune și ce poate face Poneva.',
    'Your chosen access is enabled for the selected tables.':
      'Accesul ales de tine este activat pentru tabelele selectate.',
    'Your connection is saved with reading paused until permission is confirmed.':
      'Conexiunea ta este salvată cu citirea suspendată până la confirmarea permisiunii.',
    'Confirm database disconnect': 'Confirmă deconectarea bazei de date',
    'Disconnect this database?': 'Deconectezi această bază de date?',
    'Access will stop for everyone using this connection.':
      'Accesul va fi oprit pentru toți cei care folosesc această conexiune.',
    'Keep connection': 'Păstrează conexiunea',
    'What it can reach · {value1}{value2} {value3}':
      'La ce poate avea acces · {value1}{value2} {value3}',
    Back: 'Înapoi',
    Continue: 'Continuă',
    'Uploading…': 'Se încarcă…',
    Library: 'Bibliotecă',
    'Source material for your work. Available whenever you need it.':
      'Materiale-sursă pentru munca ta. Disponibile ori de câte ori ai nevoie de ele.',
    'The work you want to keep, with its sources and conversation attached.':
      'Lucrările pe care vrei să le păstrezi, cu sursele și conversația atașate.',
    Results: 'Rezultate',
    Files: 'Fișiere',
    Artifacts: 'Artefacte',
    'Search library': 'Caută în bibliotecă',
    'Find files by meaning…': 'Găsește fișiere după semnificație…',
    'Find saved work by meaning…': 'Găsește lucrări salvate după semnificație…',
    'Search coverage is limited while indexing or meaning-based search is unavailable. You can retry or browse recent items.':
      'Căutarea este limitată cât timp se realizează indexarea sau căutarea după semnificație nu este disponibilă. Poți încerca din nou sau poți răsfoi elementele recente.',
    'No matching work found.': 'Nu s-au găsit lucrări corespunzătoare.',
    'A starting point for your next question.':
      'Un punct de pornire pentru următoarea ta întrebare.',
    'Good work is worth keeping.': 'Lucrările bune merită păstrate.',
    'Try a different description or clear the search to browse.':
      'Încearcă o descriere diferită sau șterge căutarea pentru a răsfoi.',
    'Upload source material once and use it in conversations and Skills. Your original stays in the library.':
      'Încarcă materialul-sursă o singură dată și folosește-l în conversații și Skills. Originalul rămâne în bibliotecă.',
    'Ask Poneva to save an answer, table or chart. Results stay connected to the conversation and their sources.':
      'Cere-i lui Poneva să salveze un răspuns, un tabel sau o diagramă. Rezultatele rămân conectate la conversație și la sursele lor.',
    'Start in chat {value1}': 'Începe în chatul {value1}',
    'Open result: {value1}': 'Deschide rezultatul: {value1}',
    'Loading more library items…': 'Se încarcă mai multe elemente din bibliotecă…',
    'Load more': 'Încarcă mai multe',
    'Documents, transcripts, audio and video · Up to 500 MB per file. New files are private. Choose their audience with Share and which processable files become searchable company knowledge.':
      'Documente, transcrieri, fișiere audio și video · Până la 500 MB per fișier. Fișierele noi sunt private. Alege cui îi sunt destinate cu Partajare și care fișiere procesabile devin informații ale companiei care pot fi căutate.',
    Skills: 'Competențe',
    'Create in chat': 'Creează în chat',
    'Search Skills': 'Caută competențe',
    'Search finds published Skills. Clear the search to browse your drafts too.':
      'Căutarea găsește competențele publicate. Șterge căutarea pentru a vedea și schițele tale.',
    'Search coverage is limited while indexing or meaning-based search is unavailable.':
      'Rezultatele căutării sunt limitate cât timp indexarea sau căutarea bazată pe sens nu este disponibilă.',
    'Searching Skills…': 'Se caută competențe…',
    'No matching published Skills found. Try a different description.':
      'Nu au fost găsite competențe publicate corespunzătoare. Încearcă o altă descriere.',
    'Load more Skills': 'Încarcă mai multe competențe',
    'View Skill: {value1}': 'Vezi competența: {value1}',
    'Company workspace': 'Spațiul de lucru al companiei',
    'View {value1}': 'Vezi {value1}',
    'Loading Skills…': 'Se încarcă competențele…',
    'Try again {value1}': 'Încearcă din nou {value1}',
    'Try again': 'Încearcă din nou',
    'Nothing yet.': 'Nimic deocamdată.',
    'Made from · Used by': 'Creat din · Folosit de',
    'Could not load links': 'Linkurile nu au putut fi încărcate',
    'Made from': 'Creat din',
    'Used by': 'Folosit de',
    'About this chat {value1}': 'Despre acest chat {value1}',
    'About this chat': 'Despre acest chat',
    'Keep the work moving.': 'Continuă treaba.',
    'Ask a follow-up with this result in view, or turn a useful approach into a company Skill.':
      'Pune o întrebare suplimentară având acest rezultat la vedere sau transformă o abordare utilă într-o competență a companiei.',
    'Save approach as a Skill': 'Salvează abordarea ca competență',
    'Preview of': 'Previzualizare pentru',
    'Made with': 'Creat cu',
    'Open the draft': 'Deschide schița',
    'Open Skill': 'Deschide competența',
    'Use in chat': 'Folosește în chat',
    'Finish the draft': 'Finalizează schița',
    'Refine this Skill': 'Îmbunătățește această competență',
    'Made with a Skill.': 'Creat cu o competență.',
    'This workspace could not be loaded just now, so that Skill cannot be opened yet. The result itself is unchanged.':
      'Acest spațiu de lucru nu a putut fi încărcat momentan, astfel că această competență nu poate fi deschisă încă. Rezultatul în sine nu s-a modificat.',
    'That Skill is not available in this workspace, so it cannot be opened or used again. The result itself is unchanged.':
      'Acea competență nu este disponibilă în acest spațiu de lucru, astfel că nu poate fi deschisă sau folosită din nou. Rezultatul în sine nu s-a modificat.',
    'Result · {value1} {value2}': 'Rezultat · {value1} {value2}',
    '{value1} Copy link': '{value1} Copiază linkul',
    'Result link copied.': 'Linkul rezultatului a fost copiat.',
    'Could not copy the link. Use your browser address bar.':
      'Linkul nu a putut fi copiat. Folosește bara de adrese a browserului.',
    'No preview is available for this result.':
      'Nu este disponibilă nicio previzualizare pentru acest rezultat.',
    '{value1} rows are retained in this snapshot. Open Table to inspect the values.':
      'În acest instantaneu sunt păstrate {value1} rânduri. Deschide Tabel pentru a inspecta valorile.',
    'People can’t edit a Result an agent keeps up to date; the next refresh would replace their edit. Change the agent’s instructions instead.':
      'Utilizatorii nu pot edita un rezultat pe care un agent îl menține actualizat; următoarea reîmprospătare le-ar înlocui modificările. Schimbă în schimb instrucțiunile agentului.',
    'Linked sources': 'Surse asociate',
    'Saved source': 'Sursă salvată',
    'No source documents are linked to this result. Company knowledge and other references may be cited in the answer.':
      'Niciun document-sursă nu este asociat acestui rezultat. În răspuns pot fi citate informațiile companiei și alte referințe.',
    'Run details': 'Detalii despre rulare',
    Created: 'Creat',
    Conversation: 'Conversație',
    'Not recorded': 'Nu este înregistrat',
    'Open conversation': 'Deschide conversația',
    Run: 'Rulează',
    Updates: 'Actualizări',
    'Kept up to date by {value1}': 'Menținut la zi de {value1}',
    'Version {value1}': 'Versiunea {value1}',
    'Could not open this request.': 'Această solicitare nu a putut fi deschisă.',
    'Approved version published.': 'Versiunea aprobată a fost publicată.',
    'Request rejected. The item stays unchanged.':
      'Solicitarea a fost respinsă. Elementul rămâne neschimbat.',
    'Could not save the decision.': 'Decizia nu a putut fi salvată.',
    'Proposed company change': 'Modificare propusă pentru companie',
    'Opening…': 'Se deschide…',
    'Approve this version': 'Aprobă această versiune',
    Decline: 'Respinge',
    'Review the submitted version below. Changes made since submission will need a new request.':
      'Examinează mai jos versiunea trimisă. Modificările făcute după trimitere vor necesita o solicitare nouă.',
    'The version submitted with this request.': 'Versiunea trimisă împreună cu această solicitare.',
    'Version and proposed change': 'Versiunea și modificarea propusă',
    'Could not read the pinned content.': 'Conținutul fixat nu a putut fi citit.',
    'Showing a page of {value1} characters.': 'Se afișează o pagină de {value1} caractere.',
    'Beginning of the submitted content. Open the full text to review every page.':
      'Începutul conținutului trimis. Deschide textul complet pentru a examina fiecare pagină.',
    'Read full submitted text': 'Citește întregul text trimis',
    'Previous page': 'Pagina anterioară',
    'Next page': 'Pagina următoare',
    'Made private. Its creator has been told in their Inbox.':
      'A fost făcut privat. Creatorul a fost informat în Mesaje primite.',
    'Made private. Its creator could not be notified.':
      'A fost făcut privat. Creatorul nu a putut fi notificat.',
    'Make this {value1} private?': 'Fă acest {value1} privat?',
    'Only the person who created it will see it. Everyone else loses access right away, and its creator gets an Inbox update if they are still a company member. If they have left, nobody in the company will be able to access this item.':
      'Doar persoana care l-a creat îl va putea vedea. Toți ceilalți își pierd imediat accesul, iar creatorul primește o actualizare în Mesaje primite dacă este încă membru al companiei. Dacă a plecat, nimeni din companie nu va mai putea accesa acest element.',
    'Sent for review. The current audience stays unchanged until approval.':
      'Trimis pentru examinare. Publicul actual rămâne neschimbat până la aprobare.',
    ', revised {value1}': ', revizuit {value1}',
    'Could not update sharing.': 'Partajarea nu a putut fi actualizată.',
    'They can follow new answers live and fork it to continue with their own connections. Only you write here. You can make it private again at any time.':
      'Pot urmări răspunsurile noi în timp real și pot crea o copie pentru a continua cu propriile conexiuni. Doar tu poți scrie aici. Poți face acest spațiu privat din nou oricând.',
    'They see the project, its brief and the work in it they can already open. Nothing in it opens for anyone because of the project; each item keeps its own access.':
      'Vor vedea proiectul, descrierea acestuia și elementele pe care le pot deschide deja. Nimic din proiect nu devine accesibil altora datorită proiectului; fiecare element își păstrează propriile permisiuni de acces.',
    'Check the content for private information before sharing. Sharing an item does not grant access to its original chat or private connections.':
      'Verifică dacă există informații private înainte de a partaja. Partajarea unui element nu oferă acces la chatul său original sau la conexiunile private.',
    '{value1} Everyone you share with can read it, including what the assistant or an App in it found in your {value2}. They can’t use your {value3}. Nothing changes for you: the chat keeps working with all your accounts.':
      '{value1} Toate persoanele cu care îl partajezi îl pot citi, inclusiv ceea ce a găsit asistentul sau o aplicație din acesta în {value2}. Nu pot folosi {value3}. Pentru tine nu se schimbă nimic: chatul continuă să funcționeze cu toate conturile tale.',
    '{value1} Everyone you share with can read them, but nobody can use {value2} through this chat.':
      '{value1} Toate persoanele cu care le partajezi le pot citi, dar nimeni nu poate folosi {value2} prin acest chat.',
    'This controls access to the working draft. Any published company version stays available until you explicitly unpublish it. To publish a new version, complete its preview and use Save Skill. Run results stay private.':
      'Aceasta controlează accesul la versiunea de lucru. Orice versiune a companiei deja publicată rămâne disponibilă până când alegi explicit să o retragi. Pentru a publica o versiune nouă, finalizează previzualizarea și folosește Salvează Skill. Rezultatele rulării rămân private.',
    'Skill deleted. You can restore it from the Skills archive for 30 days.':
      'Skill șters. Îl poți restaura din arhiva Skills timp de 30 de zile.',
    'Could not delete this Skill.': 'Acest Skill nu a putut fi șters.',
    'More actions': 'Mai multe acțiuni',
    'Delete “{value1}”? It will disappear from Skills and search, and cannot be used by agents. You can restore it for 30 days. Existing chats and results stay available.':
      'Ștergi „{value1}”? Va dispărea din Skills și din rezultatele căutării și nu va mai putea fi folosit de agenți. Îl poți restaura timp de 30 de zile. Chat-urile și rezultatele existente rămân disponibile.',
    'Deleting…': 'Se șterge…',
    'Confirm delete': 'Confirmă ștergerea',
    'Delete Skill': 'Șterge Skill',
    'Skill restored as an unpublished draft. Its author can review and publish it again.':
      'Skill restaurat ca schiță nepublicată. Autorul îl poate verifica și publica din nou.',
    'Could not restore this Skill.': 'Acest Skill nu a putut fi restaurat.',
    'Archived Skills': 'Skills arhivate',
    'Deleted Skills can be restored for 30 days. Restoring leaves them unpublished.':
      'Skill-urile șterse pot fi restaurate timp de 30 de zile. Restaurarea le lasă nepublicate.',
    'Restore until {value1}': 'Restaurează până la {value1}',
    'Loading…': 'Se încarcă…',
    'No archived Skills.': 'Nu există Skills arhivate.',
    'Load more archived Skills': 'Încarcă mai multe Skills arhivate',
    'Show more of the original': 'Afișează mai mult din original',
    'Filter result rows': 'Filtrează rândurile de rezultate',
    'Find a product or value…': 'Găsește un produs sau o valoare…',
    '{value1} of {value2}': '{value1} din {value2}',
    'Result table': 'Tabel de rezultate',
    'No matching rows.': 'Nu există rânduri corespunzătoare.',
    'Showing the first 1,000 matching rows. Download the CSV for every row.':
      'Se afișează primele 1.000 de rânduri corespunzătoare. Descarcă fișierul CSV pentru toate rândurile.',
    'Agent ·': 'Agent ·',
    'Only you': 'Doar tu',
    'Stopped before it finished.': 'S-a oprit înainte de finalizare.',
    'Drafting the project…': 'Se redactează proiectul…',
    'Checking where this chat belongs…': 'Se verifică unde aparține acest chat…',
    'Moving the chat…': 'Se mută chatul…',
    'Taking it out of the project…': 'Se elimină din proiect…',
    'Adding it to the project…': 'Se adaugă la proiect…',
    'No matching connections are available right now.':
      'Momentan nu există conexiuni corespunzătoare disponibile.',
    'Company knowledge suggestion': 'Sugestie de cunoștințe ale companiei',
    'Company knowledge now lives on pages. Open Knowledge to see them.':
      'Cunoștințele companiei se află acum în pagini. Deschide Knowledge pentru a le vedea.',
    '{value1} · Open beside this conversation': '{value1} · Deschide lângă această conversație',
    'Name {value1}': 'Nume {value1}',
    'Host {value1}': 'Gazdă {value1}',
    'Port {value1}': 'Portul {value1}',
    'Database {value1}': 'Bază de date {value1}',
    'Username {value1}': 'Nume de utilizator {value1}',
    'Password {value1}': 'Parolă {value1}',
    'Advanced TLS': 'TLS avansat',
    '{value1} Poneva verifies the server certificate. Add a CA or server DNS name for IP hosts when your certificate requires it.':
      '{value1} Poneva verifică certificatul serverului. Adaugă o CA sau un nume DNS al serverului pentru gazdele IP, dacă certificatul tău necesită acest lucru.',
    'CA certificate {value1}': 'Certificat CA {value1}',
    'Certificate server DNS name {value1}': 'Nume DNS al serverului certificatului {value1}',
    '{value1} Your password is encrypted in secure storage. Poneva verifies the connection before saving it.':
      '{value1} Parola ta este criptată în stocare securizată. Poneva verifică conexiunea înainte de a o salva.',
    'Testing…': 'Se testează…',
    'Test connection': 'Testează conexiunea',
    'PostgreSQL is connected.': 'PostgreSQL este conectat.',
    'PostgreSQL was saved safely.': 'PostgreSQL a fost salvat în siguranță.',
    'Poneva can read and change rows in the selected tables. Apps also follow their approved data scope.':
      'Poneva poate citi și modifica rândurile din tabelele selectate. Aplicațiile respectă, de asemenea, domeniul de date aprobat.',
    'Poneva can read the selected tables. Apps also follow their approved data scope.':
      'Poneva poate citi tabelele selectate. Aplicațiile respectă, de asemenea, domeniul de date aprobat.',
    'Reads are paused until permission is enabled.':
      'Citirea este suspendată până la activarea permisiunii.',
    'Retrying…': 'Se reîncearcă…',
    'Retry permission': 'Reîncearcă acordarea permisiunii',
    'Try it in Chat': 'Încearcă în Chat',
    Done: 'Gata',
    'Disconnect database': 'Deconectează baza de date',
    '{value1} TLS verified ·{value2} {value3}': '{value1} TLS verificat ·{value2} {value3}',
    'Search schemas and tables': 'Caută scheme și tabele',
    'Search tables': 'Caută tabele',
    '{value1} of {value2} tables selected': '{value1} din {value2} tabele selectate',
    'Select matching tables': 'Selectează tabelele corespunzătoare',
    'Select all tables': 'Selectează toate tabelele',
    Clear: 'Șterge selecția',
    'Select a whole schema or individual tables. New tables need a fresh selection.':
      'Selectează o schemă întreagă sau tabele individuale. Pentru tabelele noi este necesară o selecție nouă.',
    'No tables match this search.': 'Niciun tabel nu corespunde acestei căutări.',
    'All tables in {value1}': 'Toate tabelele din {value1}',
    '{value1} / {value2} tables': '{value1} / {value2} tabele',
    'Read & write available': 'Citire și scriere disponibile',
    'Read only': 'Doar citire',
    Ctrl: 'Ctrl',
    'This suggested knowledge update could not be shown.':
      'Această actualizare sugerată a cunoștințelor nu a putut fi afișată.',
    'Suggested knowledge update': 'Actualizare sugerată a cunoștințelor',
    'This suggestion is no longer available to you.':
      'Această sugestie nu mai este disponibilă pentru tine.',
    'We could not check where this suggestion stands.':
      'Nu am putut verifica stadiul acestei sugestii.',
    'Check again': 'Verifică din nou',
    'Show on page': 'Afișează pe pagină',
    'The editor could not be loaded. Poneva may have been updated since you opened this page. Reload to get the latest version; nothing on this page has changed.':
      'Editorul nu a putut fi încărcat. Este posibil ca Poneva să fi fost actualizat de când ai deschis această pagină. Reîncarcă pentru a obține cea mai recentă versiune; nimic de pe această pagină nu s-a schimbat.',
    'Reload Poneva': 'Reîncarcă Poneva',
    Formatting: 'Formatare',
    'Text style': 'Stilul textului',
    Text: 'Text',
    Heading: 'Titlu',
    Subheading: 'Subtitlu',
    'Link a page': 'Leagă o pagină',
    'A page needs a title.': 'O pagină trebuie să aibă un titlu.',
    'Nothing has changed yet.': 'Nu s-a schimbat nimic încă.',
    'A page needs some text. To remove a page, archive it instead.':
      'O pagină trebuie să conțină text. Pentru a elimina o pagină, arhiveaz-o.',
    'A suggested new page needs some text.': 'O pagină nouă sugerată trebuie să conțină text.',
    'This page is larger than 256 KB. Split it into smaller pages.':
      'Această pagină este mai mare de 256 KB. Împarte-o în pagini mai mici.',
    'Say in a few words why this change is right.':
      'Spune în câteva cuvinte de ce este potrivită această modificare.',
    'This page changed while you were editing. Your text is still here: copy it, then open the latest version and make your change again.':
      'Această pagină s-a schimbat în timp ce o editai. Textul tău este în continuare aici: copiază-l, apoi deschide cea mai recentă versiune și efectuează din nou modificarea.',
    'Your text is copied.': 'Textul tău a fost copiat.',
    'Your text could not be copied. Select it in the editor and copy it.':
      'Textul tău nu a putut fi copiat. Selectează-l în editor și copiază-l.',
    'The page “{value1}” is created.': 'Pagina „{value1}” a fost creată.',
    'New page': 'Pagină nouă',
    'Editing {value1}': 'Se editează {value1}',
    Editing: 'Editare',
    'Creating publishes the page under {value1} for everyone':
      'Crearea publică pagina în {value1} pentru toată lumea',
    'Saving publishes the new version for everyone':
      'Salvarea publică noua versiune pentru toată lumea',
    'Your changes are sent as a suggestion for a publisher':
      'Modificările tale sunt trimise ca sugestie unui editor',
    'Create page': 'Creează pagina',
    Save: 'Salvează',
    'Send suggestion': 'Trimite sugestia',
    '{value1} Copy my text': '{value1} Copiază textul meu',
    'Open the latest version': 'Deschide cea mai recentă versiune',
    'Page title': 'Titlul paginii',
    'Loading the editor…': 'Se încarcă editorul…',
    'New page text': 'Textul paginii noi',
    'Text of {value1}': 'Textul pentru {value1}',
    'Write the page. Type [[ to link another page.':
      'Scrie pagina. Tastează [[ pentru a crea un link către o altă pagină.',
    'Type [[ to link another page.': 'Tastează [[ pentru a crea un link către o altă pagină.',
    'Link to a page': 'Link către o pagină',
    'What changed, in a few words': 'Ce s-a schimbat, în câteva cuvinte',
    'Where this comes from, in a few words': 'De unde provine, în câteva cuvinte',
    'Shown in the page history.': 'Apare în istoricul paginii.',
    'A publisher sees this next to your change.': 'Un editor vede acest text lângă modificarea ta.',
    '1 suggestion is open on this page': '1 sugestie este deschisă pe această pagină',
    '{value1} suggestions are open on this page':
      '{value1} sugestii sunt deschise pe această pagină',
    'They stay open while you edit. After you save, they show against your new text; one whose words you changed is marked outdated.':
      'Rămân deschise cât timp editezi. După salvare, sunt afișate alături de noul tău text; cea ale cărei cuvinte le-ai modificat este marcată ca învechită.',
    'Type [[ to link another page. Links keep working when a page is renamed or moved.':
      'Tastează [[ pentru a crea un link către o altă pagină. Linkurile continuă să funcționeze când o pagină este redenumită sau mutată.',
    'Loading the history…': 'Se încarcă istoricul…',
    'This page has no saved text yet.': 'Această pagină nu are încă text salvat.',
    'Say in a few words why this revision should come back.':
      'Spune în câteva cuvinte de ce ar trebui restaurată această revizie.',
    'Revision {value1} is suggested for a publisher to accept.':
      'Revizia {value1} este propusă spre acceptare de către un editor.',
    'The page already reads like this revision.': 'Pagina are deja conținutul acestei revizii.',
    'Revision {value1} is restored as revision {value2}.':
      'Revizia {value1} a fost restaurată ca revizia {value2}.',
    'Revision history': 'Istoricul reviziilor',
    Revisions: 'Revizii',
    'Every saved revision is kept.': 'Fiecare revizie salvată este păstrată.',
    'Revision {value1} {value2}': 'Revizia {value1} {value2}',
    'Revision {value1} compared with revision {value2}':
      'Revizia {value1} comparată cu revizia {value2}',
    'Revision {value1}, the first text of this page':
      'Revizia {value1}, primul text al acestei pagini',
    'Green was added, struck through was removed.':
      'Textul verde a fost adăugat, iar textul tăiat a fost eliminat.',
    '{value1} Export Markdown': '{value1} Exportă Markdown',
    'Restore this revision': 'Restaurează această revizie',
    'Suggest restoring it': 'Sugerează restaurarea',
    'Why should this revision come back?': 'De ce ar trebui restaurată această revizie?',
    'Loading this revision…': 'Se încarcă această revizie…',
    'Only the title changed, from “{value1}” to “{value2}”.':
      'S-a schimbat doar titlul, din „{value1}” în „{value2}”.',
    'The text did not change in this revision.': 'Textul nu s-a schimbat în această revizie.',
    'Changes in revision {value1}': 'Modificările din revizia {value1}',
    'Loading page…': 'Se încarcă pagina…',
    'Loading suggestion…': 'Se încarcă sugestia…',
    'This suggestion is not available.': 'Această sugestie nu este disponibilă.',
    'It may have been decided, or it is not one you can see.':
      'Este posibil să fi fost soluționată sau să nu fie vizibilă pentru tine.',
    'Open Knowledge': 'Deschide Knowledge',
    'Opening the suggestion…': 'Se deschide sugestia…',
    'Choose where the page goes.': 'Alege unde va fi plasată pagina.',
    'Say in a few words why.': 'Spune în câteva cuvinte de ce.',
    'Your suggestion is sent. A publisher decides.':
      'Sugestia ta a fost trimisă. Un editor va decide.',
    'Moved under {value1}.': 'Mutată sub {value1}.',
    'Deleted “{value1}”.': '„{value1}” a fost ștearsă.',
    'Archived. Its history is kept.': 'Arhivată. Istoricul este păstrat.',
    'Choose the page it goes under. Links to it keep working.':
      'Alege pagina sub care va fi mutată. Linkurile către ea vor continua să funcționeze.',
    'Its text, its history and any open suggestions are removed for good, and links to it from other pages stop working. This cannot be undone.':
      'Textul, istoricul și orice sugestii deschise sunt șterse definitiv, iar linkurile către ea din alte pagini nu mai funcționează. Această acțiune nu poate fi anulată.',
    'An archived page no longer informs answers. Its history is kept, and a publisher can restore it or delete it permanently.':
      'O pagină arhivată nu mai contribuie la răspunsuri. Istoricul este păstrat, iar un editor o poate restaura sau șterge definitiv.',
    Under: 'Sub',
    Change: 'Schimbă',
    'Move under': 'Mută sub',
    'Search pages': 'Caută pagini',
    'Why?': 'De ce?',
    'Delete permanently': 'Șterge definitiv',
    'Move page': 'Mută pagina',
    'Archive page': 'Arhivează pagina',
    'Suggestion {value1}: show its card': 'Sugestia {value1}: afișează cardul',
    'Removed:': 'Eliminat:',
    'Added:': 'Adăugat:',
    'New page “{value1}”{value2}': 'Pagină nouă „{value1}”{value2}',
    'No pages match “{value1}”.': 'Nicio pagină nu corespunde căutării „{value1}”.',
    'Where this page is': 'Unde se află această pagină',
    'Describe your company': 'Descrie compania ta',
    'Empty page': 'Pagină goală',
    'Describe {value1}': 'Descrie {value1}',
    'This page has no text yet.': 'Această pagină nu are încă niciun text.',
    'Poneva reads this page before every answer. Start with who you are, what you sell and how you work; details go on the pages under it.':
      'Poneva citește această pagină înainte de fiecare răspuns. Începe cu cine sunteți, ce vindeți și cum lucrați; detaliile se adaugă pe paginile de sub ea.',
    'Write it, or ask Poneva in chat to draft it for you.':
      'Scrie tu sau cere-i lui Poneva, în chat, să redacteze un prim draft pentru tine.',
    'Suggest a first version, and a publisher decides whether it becomes the page.':
      'Propune o primă versiune, iar un editor decide dacă aceasta devine pagina.',
    'Start writing': 'Începe să scrii',
    'Suggest a first version': 'Propune o primă versiune',
    'Accepted. The page is archived.': 'Acceptată. Pagina este arhivată.',
    'Accepted. The page is now revision {value1}.':
      'Acceptată. Pagina este acum la revizia {value1}.',
    'Accepted.': 'Acceptată.',
    'Suggestion rejected. The page stays as it is.':
      'Sugestia a fost respinsă. Pagina rămâne neschimbată.',
    'Your suggestion is withdrawn.': 'Sugestia ta a fost retrasă.',
    'Restored. The page informs answers again.':
      'Restaurată. Pagina contribuie din nou la răspunsuri.',
    'Your suggestion is sent. A publisher decides whether it becomes the page.':
      'Sugestia ta a fost trimisă. Un editor decide dacă aceasta devine pagina.',
    'Saved. The page is now revision {value1}.': 'Salvată. Pagina este acum la revizia {value1}.',
    'Nothing changed.': 'Nu s-a schimbat nimic.',
    'This page is not available.': 'Această pagină nu este disponibilă.',
    'It may have been deleted, archived or moved out of reach, or you may no longer be in this company.':
      'Este posibil să fi fost ștearsă, arhivată sau mutată într-un loc la care nu ai acces ori este posibil să nu mai faci parte din această companie.',
    'Page actions': 'Acțiuni pentru pagină',
    shown: 'afișate',
    hidden: 'ascunse',
    '{value1} History': 'Istoricul {value1}',
    '{value1} Ask in chat': '{value1} Întreabă în chat',
    'Suggest edits': 'Propune modificări',
    'More actions for {value1}': 'Mai multe acțiuni pentru {value1}',
    '{value1} Poneva reads this page in every chat':
      '{value1} Poneva citește această pagină în fiecare chat',
    'This page is archived. It no longer informs answers; its history is kept. {value1}':
      'Această pagină este arhivată. Nu mai contribuie la răspunsuri; istoricul este păstrat. {value1}',
    'Restore page': 'Restaurează pagina',
    'This link points to an earlier revision. You are reading the current text.':
      'Acest link duce la o revizie anterioară. Citești textul actual.',
    'Show it in History': 'Afișeaz-o în Istoric',
    Pages: 'Pagini',
    'Pages under {value1}': 'Pagini sub {value1}',
    'Linked from': 'Linkuri din',
    Suggestions: 'Sugestii',
    'Suggestions are hidden. You are reading the page as everyone else sees it.':
      'Sugestiile sunt ascunse. Citești pagina așa cum o văd ceilalți.',
    'Loading suggestions…': 'Se încarcă sugestiile…',
    'Nothing is waiting for review.': 'Nu există nimic în așteptarea verificării.',
    'When someone, Poneva in a chat or a connected agent suggests a change to a page, it shows here and on the page. Nothing changes until a publisher accepts it.':
      'Când cineva, Poneva într-un chat sau un agent conectat propune o modificare pentru o pagină, aceasta apare aici și pe pagină. Nimic nu se schimbă până când un editor nu o acceptă.',
    '{value1} Review knowledge in chat': '{value1} Verifică baza de cunoștințe în chat',
    'Suggestions for review': 'Sugestii de verificat',
    'Suggested changes from chats, meetings, colleagues and connected agents. Nothing changes until a publisher accepts it on the page.':
      'Modificări sugerate din chat-uri, întâlniri, de colegi și agenți conectați. Nimic nu se schimbă până când un editor nu le acceptă pe pagină.',
    'Your suggestions wait here until a publisher decides. The pages stay as they are until then.':
      'Sugestiile tale așteaptă aici până când un editor decide. Paginile rămân neschimbate până atunci.',
    'Review page': 'Verifică pagina',
    'Review on page': 'Verifică pe pagină',
    'Open the meeting': 'Deschide întâlnirea',
    'Open the chat': 'Deschide chatul',
    'Accept and restore': 'Acceptă și restaurează',
    Accept: 'Acceptă',
    Reject: 'Respinge',
    'Your suggestion · waiting for a publisher': 'Sugestia ta · în așteptarea unui editor',
    Withdraw: 'Retrage',
    'Waiting for a publisher': 'În așteptarea unui editor',
    'Suggestion {value1}': 'Sugestia {value1}',
    'Suggestion {value1} from {value2}{value3}': 'Sugestia {value1} de la {value2}{value3}',
    'Read the suggested page': 'Citește pagina sugerată',
    'Outdated: the text it changes was edited after it was suggested. It can be rejected or withdrawn; a new suggestion can be made against the current text.':
      'Depășită: textul pe care îl modifică a fost editat după trimiterea sugestiei. Sugestia poate fi respinsă sau retrasă; se poate face o sugestie nouă pentru textul actual.',
    'Restore this page first to accept this suggestion.':
      'Restaurează mai întâi această pagină pentru a accepta sugestia.',
    'Previous suggestion': 'Sugestia anterioară',
    'Suggestion {value1} of {value2}': 'Sugestia {value1} din {value2}',
    'Next suggestion': 'Sugestia următoare',
    'Fold the suggestions away': 'Ascunde sugestiile',
    'Show the suggestions': 'Afișează sugestiile',
    '1 suggestion': '1 sugestie',
    '{value1} suggestions': '{value1} sugestii',
    '{value1} the pages under {value2}': '{value1} paginile din {value2}',
    px: 'px',
    '{value1} chart of {value2} across {value3}': 'Grafic {value1} pentru {value2} în {value3}',
    'We could not build the file.': 'Nu am putut genera fișierul.',
    '{value1} Present': '{value1} prezent',
    'Building…': 'Se generează…',
    'Download PowerPoint': 'Descarcă PowerPoint',
    'Slide {value1} of {value2}': 'Diapozitivul {value1} din {value2}',
    Slides: 'Diapozitive',
    'Slide {value1}': 'Diapozitivul {value1}',
    'Speaker notes': 'Notele prezentatorului',
    'Source: {value1}': 'Sursă: {value1}',
    'Add a name and a web address.': 'Adaugă un nume și o adresă web.',
    'Enter a valid web address.': 'Introdu o adresă web validă.',
    'Use a web address that starts with https://.':
      'Folosește o adresă web care începe cu https://.',
    'Add a custom connection': 'Adaugă o conexiune personalizată',
    'Connect a tool server you trust. Poneva checks the address works and saves only the connection details needed to use it.':
      'Conectează un server de instrumente în care ai încredere. Poneva verifică dacă adresa funcționează și salvează doar detaliile de conexiune necesare pentru utilizarea acestuia.',
    'Web address': 'Adresă web',
    'https://tools.example.com': 'https://tools.example.com',
    'Starts with https://, from your provider': 'Începe cu https://, de la furnizorul tău',
    'Sign-in': 'Autentificare',
    'Advanced sign-in': 'Autentificare avansată',
    'Access key {value1}': 'Cheie de acces {value1}',
    'Request headers': 'Antete de solicitare',
    'Add header': 'Adaugă un antet',
    'Header {value1} name': 'Numele antetului {value1}',
    'Header name': 'Numele antetului',
    'Header {value1} value': 'Valoarea antetului {value1}',
    'Header value': 'Valoarea antetului',
    'Remove header': 'Elimină antetul',
    Advanced: 'Avansat',
    Transport: 'Transport',
    'Auto-detect': 'Detectare automată',
    'Streamable HTTP': 'Streamable HTTP',
    'Legacy SSE': 'SSE moștenit',
    "From your provider's app settings. Leave empty unless they gave you these.":
      'Din setările aplicației furnizorului tău. Lasă necompletat dacă nu ți le-a furnizat.',
    "Authorization server issuer": "Emitentul serverului de autorizare",
    "Enter the authorization server issuer when using a client ID.": "Introduceți emitentul serverului de autorizare când folosiți un ID de client.",
    'Client ID {value1}': 'ID client {value1}',
    'Client secret {value1}': 'Secret client {value1}',
    'Connecting…': 'Se conectează…',
    'Test and connect': 'Testează și conectează',
    'Add the store, the client ID and the client secret.':
      'Adaugă magazinul, ID-ul clientului și secretul clientului.',
    'Connect your Shopify Developer App': 'Conectează aplicația ta de dezvoltare Shopify',
    'Poneva can use exactly the access your store gave the app, and nothing more. It talks to Shopify directly and keeps the client secret encrypted.':
      'Poneva poate folosi exact accesul acordat aplicației de magazinul tău și nimic mai mult. Comunică direct cu Shopify și păstrează secretul clientului criptat.',
    'How to create the app in Shopify': 'Cum să creezi aplicația în Shopify',
    'Open{value1} {value2}{value3} with the account that owns the store, and create an app.':
      'Deschide{value1} {value2}{value3} cu contul care deține magazinul și creează o aplicație.',
    'Create a version and select the access scopes Poneva may use, for example read_products and read_orders. Add write_ scopes only for data Poneva may change. Then release the version.':
      'Creează o versiune și selectează domeniile de acces pe care le poate folosi Poneva, de exemplu read_products și read_orders. Adaugă domenii write_ doar pentru datele pe care Poneva le poate modifica. Apoi publică versiunea.',
    'For orders and customers, also select protected customer data in the app’s settings. Shopify allows this without review for an app made for your own store.':
      'Pentru comenzi și clienți, selectează și datele protejate ale clienților din setările aplicației. Shopify permite acest lucru fără verificare pentru o aplicație creată pentru propriul magazin.',
    'Install the app on your store.': 'Instalează aplicația în magazinul tău.',
    'Copy the client ID and client secret from the app’s settings.':
      'Copiază ID-ul clientului și secretul clientului din setările aplicației.',
    'To change the access later, release a new version, approve it on the store and use Test connection here.':
      'Pentru a modifica ulterior accesul, publică o versiune nouă, aprob-o în magazin și folosește aici „Testează conexiunea”.',
    Store: 'Magazin',
    'your-store.myshopify.com': 'your-store.myshopify.com',
    'Your store’s .myshopify.com address (Shopify admin → Settings → Domains), or paste the address of your Shopify admin page':
      'Adresa .myshopify.com a magazinului tău (administratorul Shopify → Settings → Domains) sau lipește adresa paginii de administrare Shopify',
    'Client ID {value1} {value2}': 'ID client {value1} {value2}',
    'Client secret {value1} {value2}': 'Secret client {value1} {value2}',
    Person: 'Persoană',
    Everyone: 'Toți',
    Connection: 'Conexiune',
    'All connections': 'Toate conexiunile',
    'App {value1}': 'Aplicația {value1}',
    'From {value1}': 'De la {value1}',
    'Until {value1}': 'Până la {value1}',
    Result: 'Rezultat',
    'All results': 'Toate rezultatele',
    Succeeded: 'Reușit',
    Denied: 'Respins',
    Failed: 'Eșuat',
    Unknown: 'Necunoscut',
    Filter: 'Filtru',
    'Loading activity…': 'Se încarcă activitatea…',
    'Could not load activity. Try again.': 'Activitatea nu a putut fi încărcată. Încearcă din nou.',
    'Removed connection': 'Conexiune eliminată',
    'App: {value1}': 'Aplicație: {value1}',
    'Older activity': 'Activitate mai veche',
    Download: 'Descarcă',
    CSV: 'CSV',
    'Evidence for {value1}': 'Dovezi pentru {value1}',
    Measure: 'Măsură',
    'Show rows →': 'Afișează rândurile →',
    'Ask about this number': 'Întreabă despre acest număr',
    'There are no numeric values available to chart. View the table for the original data.':
      'Nu există valori numerice disponibile pentru diagramă. Consultă tabelul pentru datele originale.',
    'Chart value': 'Valoare în diagramă',
    '{value1} of {value2} shown': '{value1} din {value2} afișate',
    '{value1} by {value2}; {value3} rows. View Table for exact values.':
      '{value1} după {value2}; {value3} rânduri. Consultă tabelul pentru valorile exacte.',
    'Values come directly from the source data. Missing values are not estimates.':
      'Valorile provin direct din datele sursă. Valorile lipsă nu sunt estimări.',
    'Loading library…': 'Se încarcă biblioteca…',
    'We couldn’t load what happened in this App. Try again in a moment.':
      'Nu am putut încărca ce s-a întâmplat în această aplicație. Încearcă din nou peste puțin timp.',
    'This App could not be opened.': 'Această aplicație nu a putut fi deschisă.',
    'Opening App…': 'Se deschide aplicația…',
    'Open the saved App to run this function.':
      'Deschide aplicația salvată pentru a rula această funcție.',
    'Save this App before running its function.':
      'Salvează această aplicație înainte de a-i rula funcția.',
    'Open saved App': 'Deschide aplicația salvată',
    'Open Apps': 'Deschide aplicații',
    'The App could not be opened. Try again.':
      'Aplicația nu a putut fi deschisă. Încearcă din nou.',
    Owner: 'Proprietar',
    '{value1} · admins': '{value1} · administratori',
    'Owner · always edits': 'Proprietar · editează întotdeauna',
    'Admins manage it': 'Administratorii o gestionează',
    Editors: 'Editori',
    'A colleague': 'Un coleg',
    'Can edit drafts and publish versions': 'Poate edita schițe și publica versiuni',
    Remove: 'Elimină',
    'No editors yet.': 'Încă nu există editori.',
    'Admins can always edit company agents.':
      'Administratorii pot edita oricând agenții companiei.',
    'Asking for edit access': 'Se solicită acces de editare',
    'Asked {value1} · also in your Inbox': 'Solicitat {value1} · se află și în Inbox',
    Grant: 'Acordă',
    Admin: 'Administrator',
    'Make personal': 'Fă-l personal',
    'Switch off': 'Dezactivează',
    Archive: 'Arhivează',
    'Archive this agent': 'Arhivează acest agent',
    'Loading agent…': 'Se încarcă agentul…',
    '{value1} Edit in chat': '{value1} Editează în chat',
    Agent: 'Agent',
    'This agent has not been created yet. It can run once its owner creates it.':
      'Acest agent nu a fost încă creat. Poate rula după ce proprietarul îl creează.',
    'New agent · Draft': 'Agent nou · Schiță',
    'Untitled agent': 'Agent fără titlu',
    'Test run': 'Rulează testul',
    'This draft does not run automatically.': 'Această schiță nu rulează automat.',
    'Describe the agent in the chat. Its draft appears here.':
      'Descrie agentul în chat. Schița sa va apărea aici.',
    '{value1} Test run': '{value1} Rulează testul',
    'Describe the agent in the chat first.': 'Mai întâi descrie agentul în chat.',
    'Create and turn on': 'Creează și activează',
    'Connection write setup': 'Configurarea scrierii conexiunii',
    'Account for connected changes': 'Cont pentru modificările conexiunii',
    'Choose a connection': 'Alege o conexiune',
    'No published Skills available. You can add them later.':
      'Nu există competențe publicate. Le poți adăuga mai târziu.',
    '{value1} · not published. Review the changes. Testing is optional.':
      '{value1} · nepublicat. Verifică modificările. Testarea este opțională.',
    '{value1} Test draft': '{value1} Testează schița',
    'Apply changes…': 'Aplică modificările…',
    'Apply this draft as a new version': 'Aplică această schiță ca versiune nouă',
    'This draft cannot be applied.': 'Această schiță nu poate fi aplicată.',
    'What changed?': 'Ce s-a schimbat?',
    'Apply version {value1}': 'Aplică versiunea {value1}',
    Create: 'Creează',
    'Edit access requested': 'Acces de editare solicitat',
    '{value1} Request edit access': '{value1} Solicită acces de editare',
    '{value1} Copy agent': '{value1} Copiază agentul',
    Pause: 'Pune pe pauză',
    'Open agent: {value1}': 'Deschide agentul: {value1}',
    '· you can edit': '· poți edita',
    '{value1} is switched off.': '{value1} este dezactivat.',
    '{value1} is archived.': '{value1} este arhivat.',
    'Loading agents…': 'Se încarcă agenții…',
    Agents: 'Agenți',
    'Agents do work for you on a schedule or when you ask. They follow your company’s Skills.':
      'Agenții lucrează pentru tine conform unui program sau la cererea ta. Ei urmează competențele companiei.',
    'No agent matches. Try a Skill name or what the agent should do.':
      'Niciun agent nu corespunde. Încearcă numele unei competențe sau descrie ce ar trebui să facă agentul.',
    'Nothing of your own yet': 'Încă nu ai nimic propriu',
    'Tell Chat what an agent should do, or copy one of the company’s agents below.{value1}':
      'Spune-i lui Chat ce ar trebui să facă un agent sau copiază unul dintre agenții companiei de mai jos.{value1}',
    'Your agents': 'Agenții tăi',
    'Run on demand': 'Rulează la cerere',
    'Run is always available. A schedule is optional and lives separately from the agent’s instructions.':
      'Rularea este întotdeauna disponibilă. Programarea este opțională și există separat de instrucțiunile agentului.',
    'Enable this schedule when approved': 'Activează această programare după aprobare',
    Schedule: 'Programare',
    'Kept off until you create the agent from its canvas.':
      'Rămâne dezactivată până când creezi agentul din pânza sa.',
    'Will be enabled when you approve.': 'Va fi activată când o aprobi.',
    'Will be saved paused. You can enable it later.':
      'Va fi salvată ca întreruptă. O poți activa mai târziu.',
    'Only runs when you ask.': 'Rulează doar când îi ceri.',
    'Draft · approving saves it, and nothing runs. Test it and create it from its canvas.':
      'Ciornă · aprobarea o salvează, iar nimic nu rulează. Testeaz-o și creează agentul din pânza sa.',
    'Draft · nothing is scheduled until you approve. Connected actions require their own approval at run time.':
      'Ciornă · nimic nu este programat până când nu aprobi. Acțiunile conectate necesită propria aprobare la momentul rulării.',
    Name: 'Nume',
    'Agent name': 'Numele agentului',
    'Who can use it': 'Cine îl poate folosi',
    'Company agent · company resources only': 'Agent al companiei · doar resursele companiei',
    'Personal agent · runs with your access': 'Agent personal · rulează cu accesul tău',
    'Approving saves it as a draft. It does not run automatically.':
      'Aprobarea îl salvează ca ciornă. Nu rulează automat.',
    'Open the agent’s runs': 'Deschide rulările agentului',
    'Run the published version once': 'Rulează o dată versiunea publicată',
    'Stopping…': 'Se oprește…',
    'Stop run': 'Oprește rularea',
    'Could not stop this run. Please try again.': 'Rularea nu a putut fi oprită. Încearcă din nou.',
    'Run in progress': 'Rulare în curs',
    'This run is still answering. You can ask follow-ups when it finishes.':
      'Această rulare încă formulează un răspuns. Poți adresa întrebări suplimentare când se încheie.',
    'Open run details': 'Deschide detaliile rulării',
    Runs: 'Rulări',
    'Open the run chat': 'Deschide chatul rulării',
    Watch: 'Urmărește',
    Goal: 'Obiectiv',
    'Change the goal': 'Schimbă obiectivul',
    'What it does': 'Ce face',
    'What should this agent achieve?': 'Ce ar trebui să realizeze acest agent?',
    'Not set yet.': 'Încă nu este setat.',
    'When it runs': 'Când rulează',
    'Change when it runs': 'Schimbă momentul rulării',
    'Off means it runs only when someone runs it. Changing when it runs never changes its instructions.':
      'Dezactivat înseamnă că rulează doar când cineva îl pornește. Schimbarea momentului rulării nu îi modifică niciodată instrucțiunile.',
    Instructions: 'Instrucțiuni',
    'Change the instructions': 'Schimbă instrucțiunile',
    'How the agent should approach the work and make decisions.':
      'Modul în care agentul ar trebui să abordeze activitatea și să ia decizii.',
    Boundaries: 'Limite',
    'What to do or avoid. Every connected action still follows its approval.':
      'Ce să facă sau să evite. Fiecare acțiune conectată respectă în continuare aprobarea sa.',
    'No instructions of its own. It follows its Skills.':
      'Nu are instrucțiuni proprii. Urmează Competențele sale.',
    'Pin a Skill': 'Fixează o competență',
    'Finds the Skills that fit each run, the same way a chat does.':
      'Găsește Competențele potrivite pentru fiecare rulare, la fel ca un chat.',
    'Skills it always follows': 'Competențe pe care le urmează mereu',
    'A Skill that is not published': 'O competență care nu este publicată',
    'Always follows · Version {value1}': 'Urmează mereu · Versiunea {value1}',
    'Not published': 'Nepublicată',
    Uses: 'Folosește',
    'Change in chat': 'Schimbă în chat',
    'Change in chat: Uses': 'Schimbă în chat: Folosește',
    'Company knowledge and the tools each run is allowed to use.':
      'Cunoștințele companiei și instrumentele pe care fiecare rulare le poate folosi.',
    'People see the Result refresh; they change the agent, not the page.':
      'Oamenii văd actualizarea Rezultatului; ei modifică agentul, nu pagina.',
    'The first run after it is created makes the Result; later runs add a version to it.':
      'Prima rulare după creare generează Rezultatul; rulările ulterioare adaugă o versiune la acesta.',
    'Emails whoever the run is for': 'Trimite e-mail persoanei pentru care este rularea',
    'Email each run': 'Trimite un e-mail pentru fiecare rulare',
    Delivers: 'Livrează',
    'Change what it delivers': 'Schimbă ce livrează',
    'Expected result': 'Rezultat așteptat',
    'What a successful run should deliver.': 'Ce ar trebui să livreze o rulare reușită.',
    'What each run delivers': 'Ce livrează fiecare rulare',
    'Keeps one Result up to date {value1}': 'Menține un singur Rezultat actualizat {value1}',
    'Saves a new Result each run': 'Salvează un Rezultat nou la fiecare rulare',
    'You can run this company agent as yourself.{value1} {value2}':
      'Poți rula acest agent al companiei ca tine.{value1} {value2}',
    'Changes since version': 'Modificări de la versiunea',
    'are not live yet.': 'nu sunt încă active.',
    'Review them in Versions': 'Examinează-le în Versiuni',
    Skill: 'Competență',
    'The agent always uses the Skill’s published version.':
      'Agentul folosește întotdeauna versiunea publicată a Competenței.',
    Day: 'Zi',
    Time: 'Oră',
    'Cron expression': 'Expresie Cron',
    'Editors and access': 'Editori și acces',
    Company: 'Companie',
    Personal: 'Personal',
    'No changes.': 'Nicio modificare.',
    'Instructions changes': 'Modificări ale instrucțiunilor',
    'Loading versions…': 'Se încarcă versiunile…',
    'What the draft changes': 'Ce modifică ciorna',
    'No published version yet. Try the draft, then publish it.':
      'Nu există încă nicio versiune publicată. Încearcă ciorna, apoi public-o.',
    'Published versions': 'Versiuni publicate',
    'Former member': 'Fost membru',
    Live: 'Activ',
    'What changed in version {value1}': 'Ce s-a schimbat în versiunea {value1}',
    'Every publish is a version you can restore.':
      'Fiecare publicare este o versiune pe care o poți restaura.',
    Authorization: 'Autorizare',
    '{value1} {value2} · {value3} will see it.': '{value1} {value2} · {value3} îl vor vedea.',
    '{value1} {value2} you': '{value1} {value2} tu',
    '· Revised': '· Revizuit',
    'This chat used your {value1}.': 'Acest chat a folosit {value1}.',
    'This chat has results from {value1}.': 'Acest chat are rezultate de la {value1}.',
    'db.example.com': 'db.example.com',
    'e.g. Product analytics': 'de ex. Analiza produsului',
    'Paste access key': 'Lipește cheia de acces',
    'Shopify’s Dev Dashboard': 'Panoul pentru dezvoltatori Shopify',
    'App reference': 'Referință aplicație',
    'Draft · revision {value1}': 'Ciornă · revizia {value1}',
    'its Result': 'Rezultatul său',
    '· its first run makes it': '· prima sa rulare îl face',
    '{value1}’s chat ·': 'Chatul lui {value1} ·',
    '{value1} ad {value2} available.': '{value1} și {value2} sunt disponibile.',
    '{value1} rows ·': '{value1} rânduri ·',
    'It starts private. Sharing it wider shares every refresh, which can carry your private data.':
      'Începe ca element privat. Partajarea lui cu mai multe persoane partajează fiecare reîmprospătare, care poate include datele tale private.',
    descending: 'descrescător',
    'Scroll to see all columns': 'Derulați pentru a vedea toate coloanele',
    '{value1} for {value2}': '{value1} pentru {value2}',
    Suggested: 'Sugerat',
    'Opening your conversation…': 'Se deschide conversația…',
    'This conversation isn’t available': 'Această conversație nu este disponibilă',
    'It may have been deleted, belong to another account, or be temporarily unavailable.':
      'Este posibil să fi fost ștearsă, să aparțină altui cont sau să fie temporar indisponibilă.',
    '{count} more line — shown in the complete revision':
      'încă {count} rând — afișat în revizia completă',
    '{count} more lines — shown in the complete revision':
      'încă {count} rânduri — afișate în revizia completă',
    '{count} more line removed': 'încă {count} rând eliminat',
    '{count} more lines removed': 'încă {count} rânduri eliminate',
    '{count} unchanged line': '{count} rând neschimbat',
    '{count} unchanged lines': '{count} rânduri neschimbate',
    '{count} more lines not shown, {added} added and {removed} removed. Check them in the complete revision.':
      'încă {count} rânduri neafișate, {added} adăugate și {removed} eliminate. Verifică-le în revizia completă.',
    'Saved result': 'Rezultat salvat',
    'Made with a Skill': 'Creat cu o abilitate',
    'Preview of {name}': 'Previzualizare pentru {name}',
    'Made with {name}': 'Creat cu {name}',
    'Ad-hoc result': 'Rezultat ad-hoc',
    'A Skill that is not available in this workspace':
      'O abilitate care nu este disponibilă în acest spațiu de lucru',
    '{name} · Revision {version}': '{name} · Revizia {version}',
    '{name} · Version {version}': '{name} · Versiunea {version}',
    'Return to conversation {value1}': 'Revino la conversația {value1}',
    '{value1} Working with {value2}': '{value1} lucrează cu {value2}',
    'View context {value1}': 'Vezi contextul {value1}',
    'A way of working, made yours.': 'Un mod de lucru, făcut pentru tine.',
    'Work that runs itself.': 'Muncă ce se desfășoară singură.',
    'One place for one piece of work.': 'Un singur loc pentru fiecare proiect.',
    'Let’s move your work forward{value1}.': 'Hai să-ți ducem munca mai departe{value1}.',
    'Describe the work. Your Skill takes shape beside the conversation.':
      'Descrie munca. Abilitatea ta prinde contur lângă conversație.',
    'Describe what it should do and when. Your agent takes shape beside the conversation. The draft does not run automatically.':
      'Descrie ce ar trebui să facă și când. Agentul tău prinde contur lângă conversație. Schița nu rulează automat.',
    'Say what the work is. Poneva drafts the project beside the conversation and brings in what you have already done. Nothing is created until you say so.':
      'Spune în ce constă munca. Poneva schițează proiectul lângă conversație și aduce ceea ce ai făcut deja. Nimic nu este creat până nu confirmi.',
    'Start with an idea below. Poneva will take it from there.':
      'Începe cu o idee mai jos. Poneva se ocupă de restul.',
    Triggers: 'Declanșatori',
    'Review the agent and its trigger. Approval applies exactly what is shown.':
      'Verifică agentul și declanșatorul acestuia. Aprobarea aplică exact ceea ce este afișat.',
    '{source} · read {date}': '{source} · citit la {date}',
    'Evidence is being recorded · read {date}': 'Dovezile sunt înregistrate · citite la {date}',
    'Evidence expired on {date} under the retention policy':
      'Dovezile au expirat la {date} conform politicii de păstrare',
    'Entered by {person}': 'Introduse de {person}',
    'No retained evidence for this value': 'Nu există dovezi păstrate pentru această valoare',
    'Covers {shown} of {total} rows': 'Acoperă {shown} din {total} rânduri',
    'Search rows': 'Caută în rânduri',
    'Clear filters': 'Șterge filtrele',
    Sort: 'Sortează',
    'Sort: {column}': 'Sortează: {column}',
    '{shown} of {total} rows': '{shown} din {total} rânduri',
    More: 'Mai multe',
    Density: 'Densitate',
    Comfortable: 'Confortabil',
    Compact: 'Compact',
    Columns: 'Coloane',
    'No rows match. Clear the search or filters to see them again.':
      'Niciun rând nu corespunde. Șterge căutarea sau filtrele pentru a le vedea din nou.',
    'Not available': 'Indisponibil',
    'All rows': 'Toate rândurile',
    'Close row detail': 'Închide detaliile rândului',
    'Ask about this row': 'Întreabă despre acest rând',
    'Add note': 'Adaugă o notă',
    Note: 'Notă',
    Saved: 'Salvat',
    Total: 'Total',
    ascending: 'crescător',
    App: 'Aplicație',
    Artifact: 'Artefact',
    'New project': 'Proiect nou',
    'Review request': 'Solicitare de revizuire',
    Activity: 'Activitate',
    'Voice preview': 'Previzualizare vocală',
    Source: 'Sursă',
    File: 'Fișier',
    Meeting: 'Întâlnire',
    'Knowledge page': 'Pagină de cunoștințe',
    'Could not preview this CSV.': 'Nu s-a putut previzualiza acest CSV.',
    'File content is unavailable.': 'Conținutul fișierului nu este disponibil.',
    'You have five open suggestions here. {value1} will see them.':
      'Aveți cinci sugestii deschise aici. {value1} le va vedea.',
    'We could not send your suggestion. Please try again.':
      'Nu am putut trimite sugestia dvs. Încercați din nou.',
    'The agent': 'Agentul',
    'Selected colleagues': 'Colegii selectați',
    'The owner': 'Proprietarul',
    'Forked. This copy is yours and runs with your own connections.':
      'S-a creat o copie. Această copie vă aparține și rulează cu propriile conexiuni.',
    'This chat is too long to fork.': 'Acest chat este prea lung pentru a crea o copie.',
    'We could not fork this chat. Please try again.':
      'Nu am putut crea o copie a acestui chat. Încercați din nou.',
    'Anyone who forked it keeps their copy: forks stay with the people who made them.':
      'Oricine a creat o copie o păstrează: copiile rămân la persoanele care le-au creat.',
    'Nobody has forked this chat.': 'Nimeni nu a creat o copie a acestui chat.',
    '1 person forked this chat. Their copy stays theirs.':
      'O persoană a creat o copie a acestui chat. Copia îi aparține în continuare.',
    '{value1} people forked this chat. Their copies stay theirs.':
      '{value1} persoane au creat copii ale acestui chat. Copiile le aparțin în continuare.',
    'Personal. Nobody else sees it.': 'Personal. Nimeni altcineva nu îl vede.',
    'People you pick. They get it in their Inbox.':
      'Persoanele alese de dvs. Îl primesc în Mesaje primite.',
    'Everyone in the company can follow it and fork it.':
      'Toți cei din companie îl pot urmări și pot crea o copie.',
    'a chat you can no longer open': 'un chat pe care nu îl mai puteți deschide',
    'shared the Result': 'a distribuit Rezultatul',
    'updated the Result': 'a actualizat Rezultatul',
    'published the Skill': 'a publicat abilitatea',
    'approved the fact': 'a aprobat informația',
    'added the fact': 'a adăugat informația',
    'added the meeting': 'a adăugat întâlnirea',
    'published the page': 'a publicat pagina',
    'updated the page': 'a actualizat pagina',
    'shared the chat': 'a distribuit chatul',
    'published a version of': 'a publicat o versiune a',
    ran: 'a rulat',
    Knowledge: 'Cunoștințe',
    Meetings: 'Întâlniri',
    Chat: 'Chat',
    Use: 'Folosește',
    Open: 'Deschide',
    You: 'Tu',
    Someone: 'Cineva',
    'published version {version} of': 'a publicat versiunea {version} a',
    'thing needs': 'element necesită',
    'things need': 'elemente necesită',
    'Published Skill': 'Abilitate publicată',
    'Included with Skill': 'Inclusă în abilitate',
    'Already attached': 'Deja atașat',
    'Also available in company knowledge': 'Disponibilă și în baza de cunoștințe a companiei',
    'Company file': 'Fișier al companiei',
    'Account identity unavailable': 'Identitatea contului nu este disponibilă',
    'Access expired or was revoked. Reconnect to continue.':
      'Accesul a expirat sau a fost revocat. Reconectați-vă pentru a continua.',
    'Account authorized · tools unavailable': 'Cont autorizat · instrumente indisponibile',
    'Not available in this workspace yet.': 'Încă nu este disponibil în acest spațiu de lucru.',
    'Everyone in the company': 'Toți cei din companie',
    'Audience: only you.': 'Public: doar dvs.',
    'Audience: everyone in the company.': 'Public: toți cei din companie.',
    'tool is': 'instrumentul este',
    'tools are': 'instrumentele sunt',
    'account is': 'contul este',
    'accounts are': 'conturile sunt',
    'We could not upload this file.': 'Nu am putut încărca acest fișier.',
    'file was': 'fișierul a fost',
    'files were': 'fișierele au fost',
    'Your company': 'Compania ta',
    'Create an agent': 'Creează un agent',
    'Give recurring work a helping hand': 'Oferă ajutor pentru munca recurentă',
    'Create a Skill': 'Creează o abilitate',
    'Save a reusable way of working': 'Salvează un mod de lucru reutilizabil',
    'Take meeting notes': 'Ia notițe în ședință',
    'Capture decisions and next steps': 'Notează deciziile și pașii următori',
    'Work with a file': 'Lucrează cu un fișier',
    'Start from a document or image': 'Pornește de la un document sau o imagine',
    'Browse agents': 'Răsfoiește agenții',
    'Open your agents and company agents': 'Deschide agenții tăi și agenții companiei',
    'Review results': 'Examinează rezultatele',
    'Return to work saved in your Library': 'Revino la lucrările salvate în Biblioteca ta',
    'For review': 'De examinat',
    'An agent': 'Un agent',
    Assistant: 'Asistent',
    'Kept up to date by {value1}{value2}': 'Actualizat permanent de {value1}{value2}',
    ', {value1}': ', {value1}',
    'Version {value1}{value2}{value3}': 'Versiunea {value1}{value2}{value3}',
    'Refreshed by its agent': 'Actualizat de agentul său',
    'Saved from a chat': 'Salvat dintr-o conversație',
    'Saved from {value1}': 'Salvat din {value1}',
    Edited: 'Editat',
    'private account': 'cont privat',
    '{value1} ({value2})': '{value1} ({value2})',
    '{value1}’s {value2}': '{value2} al lui {value1}',
    'Made private. The person who added it and the owner of its recording have been told in their Inbox.':
      'A fost făcut privat. Persoana care l-a adăugat și proprietarul înregistrării au fost informați în Mesaje primite.',
    'Made private. The person who added it has been told in their Inbox.':
      'A fost făcut privat. Persoana care l-a adăugat a fost informată în Mesaje primite.',
    'Made private. The owner of its recording has been told in their Inbox.':
      'A fost făcut privat. Proprietarul înregistrării a fost informat în Mesaje primite.',
    'Selected passage': 'Fragment selectat',
    '{value1} {value2}': '{value1} {value2}',
    'Upload a file': 'Încarcă un fișier',
    'Help me create a useful report from our company knowledge and available sources.':
      'Ajută-mă să creez un raport util pe baza cunoștințelor companiei și a surselor disponibile.',
    'This saved work couldn’t be opened. Open it again to retry.':
      'Această lucrare salvată nu a putut fi deschisă. Deschide-o din nou pentru a reîncerca.',
    '{value1}’s': 'al lui {value1}',
    '{value1} chat “{value2}”': 'Conversația „{value2}” a lui {value1}',
    '{value1}{value2}': '{value1}{value2}',
    'Skill: {value1}{value2}': 'Abilitate: {value1}{value2}',
    'Result “{value1}”': 'Rezultatul „{value1}”',
    'Meeting “{value1}”': 'Ședința „{value1}”',
    'Used in {value1} {value2} this week': 'Folosit în {value1} {value2} săptămâna aceasta',
    '{value1} {value2} · used in {value3} {value4}':
      '{value1} {value2} · folosit în {value3} {value4}',
    'The draft is not published yet, so no one else follows it.':
      'Ciorna nu este încă publicată, așa că nimeni altcineva nu o urmărește.',
    'Use it in a chat for current data, or refine the Skill first.':
      'Folosește-o într-o conversație pentru date actuale sau îmbunătățește mai întâi abilitatea.',
    'An agent keeps this up to date. Continue the work in chat.':
      'Un agent menține aceste informații actualizate. Continuă lucrul în conversație.',
    'Edit it here, or continue the work in chat.':
      'Editează aici sau continuă lucrul în conversație.',
    'Duplicate it to your Library, or continue the work in chat.':
      'Duplică în Biblioteca ta sau continuă lucrul în conversație.',
    'Download Markdown': 'Descarcă Markdown',
    'Download CSV': 'Descarcă CSV',
    'an agent': 'un agent',
    'Publish a Skill version': 'Publică o versiune a abilității',
    'Share with {value1}': 'Partajează cu {value1}',
    'Update company content': 'Actualizează conținutul companiei',
    Approved: 'Aprobat',
    Declined: 'Respins',
    Pending: 'În așteptare',
    'View decision': 'Vezi decizia',
    'No data': 'Nu există date',
    'No change': 'Nicio modificare',
    'Connection created': 'Conexiune creată',
    'Sharing changed': 'Partajare modificată',
    'Person added': 'Persoană adăugată',
    'Person removed': 'Persoană eliminată',
    'Access changed': 'Acces modificat',
    'Access turned off': 'Acces dezactivat',
    'Connection removed': 'Conexiune eliminată',
    'Query time limit changed': 'Limită de timp pentru interogare modificată',
    '{count} row': '{count} rând',
    '{count} rows': '{count} rânduri',
    'This source is no longer available. Company knowledge now lives in Knowledge pages, and files stay in the Library.':
      'Această sursă nu mai este disponibilă. Cunoștințele companiei se află acum în paginile de cunoștințe, iar fișierele rămân în Bibliotecă.',
    '· {value1} by {value2}': '· {value1} de {value2}',
    '· version {value1}': '· versiunea {value1}',
    '{message} {count} earlier file was saved and attached.':
      '{message} {count} fișier anterior a fost salvat și atașat.',
    '{message} {count} earlier files were saved and attached.':
      '{message} {count} fișiere anterioare au fost salvate și atașate.',
    '{message} {count} earlier file was saved.': '{message} {count} fișier anterior a fost salvat.',
    '{message} {count} earlier files were saved.':
      '{message} {count} fișiere anterioare au fost salvate.',
    'refreshed {time}': 'actualizat {time}',
    'a colleague': 'un coleg',
    'Your chat “{title}”': 'Chatul tău „{title}”',
    '{name}’s chat “{title}”': 'Chatul „{title}” al lui {name}',
    'Kept up to date by {name}{version}': 'Menținut la zi de {name}{version}',
    'Skill: {name}{version}': 'Abilitate: {name}{version}',
    'Result “{title}”': 'Rezultatul „{title}”',
    'Meeting “{title}”': 'Întâlnirea „{title}”',
    'Used in {count} answer this week': 'Folosit în {count} răspuns săptămâna aceasta',
    'Used in {count} answers this week': 'Folosit în {count} răspunsuri săptămâna aceasta',
    '{count} source': '{count} sursă',
    '{count} sources': '{count} surse',
    'used in {count} place': 'folosit în {count} loc',
    'used in {count} places': 'folosit în {count} locuri',
    '{company} workspace': 'spațiul de lucru {company}',
    '{count} page': '{count} pagină',
    '{count} pages': '{count} pagini',
    '{needs} · reviews and approvals': '{needs} · verificări și aprobări',
    '{count} thing needs you': '{count} element are nevoie de tine',
    '{count} things need you': '{count} elemente au nevoie de tine',
    'Included with Skill · {files} · {sources} {icon}':
      'Inclusă cu abilitatea · {files} · {sources} {icon}',
    '{count} file': '{count} fișier',
    '{count} files': '{count} fișiere',
    Today: 'Astăzi',
    'Earlier this week': 'La începutul acestei săptămâni',
    '{count} slide': '{count} diapozitiv',
    '{count} slides': '{count} diapozitive',
    Early: 'Devreme',
    'TLS verified': 'TLS verificat',
    'Made personal and switched off. Switch it on when you are ready.':
      'Setat ca personal și dezactivat. Activează-l când ești gata.',
    'Made personal and switched off. Its owner is told which version is live.':
      'Setat ca personal și dezactivat. Proprietarul este informat ce versiune este activă.',
    'Switched off.': 'Dezactivat.',
    'Applied version {revision}.': 'Versiunea {revision} a fost aplicată.',
    'The draft is running in a chat only you can read.':
      'Schița rulează într-un chat pe care doar tu îl poți citi.',
    'Publish a version first.': 'Publică mai întâi o versiune.',
    'Another Agent action is in progress.': 'O altă acțiune a agentului este în curs.',
    'Knowledge & connections': 'Cunoștințe și conexiuni',
    'Pinned Skills': 'Abilități fixate',
    None: 'Niciuna',
    'A new Result each run': 'Un rezultat nou la fiecare rulare',
    'One Result kept up to date': 'Un rezultat menținut la zi',
    Email: 'E-mail',
    On: 'Activat',
    Off: 'Dezactivat',
    'Waiting for review': 'În așteptarea examinării',
    Outdated: 'Învechit',
    Accepted: 'Acceptat',
    Rejected: 'Respins',
    Withdrawn: 'Retras',
    Replaced: 'Înlocuit',
    'Suggested edit': 'Editare sugerată',
    'Suggested new page': 'Pagină nouă sugerată',
    'Suggested move': 'Mutare sugerată',
    'Suggested archive': 'Arhivare sugerată',
    'Checking status…': 'Se verifică starea…',
    'Status unavailable': 'Starea nu este disponibilă',
    'Bulleted list': 'Listă cu marcatori',
    'Numbered list': 'Listă numerotată',
    'Web link': 'Link web',
    Read: 'Citire',
    Write: 'Scriere',
    'shared with you': 'partajat cu tine',
    'Getting an answer': 'Primește un răspuns',
    '{name} is getting an answer': '{name} primește un răspuns',
    'We could not save. Please try again.': 'Nu am putut salva. Încearcă din nou.',
    'The new page could not be created.': 'Noua pagină nu a putut fi creată.',
    'We could not load this revision.': 'Nu am putut încărca această revizie.',
    'We could not restore this revision. Please try again.':
      'Nu am putut restaura această revizie. Încearcă din nou.',
    'We could not export this revision.': 'Nu am putut exporta această revizie.',
    'We could not open this suggestion.': 'Nu am putut deschide această sugestie.',
    'We could not do that. Please try again.': 'Nu am putut face acest lucru. Încearcă din nou.',
    'We could not save your decision. Please try again.':
      'Nu am putut salva decizia ta. Încearcă din nou.',
    'We could not restore this page. Please try again.':
      'Nu am putut restaura această pagină. Încearcă din nou.',
    'We could not export this page.': 'Nu am putut exporta această pagină.',
    '{count} missed time merged.': 'A fost îmbinată {count} înregistrare de timp omisă.',
    '{count} missed times merged.': 'Au fost îmbinate {count} înregistrări de timp omise.',
    'About this project': 'Despre acest proiect',
  },
  sk: {
    'We could not load this item.': 'Túto položku sa nepodarilo načítať.',
    '{value1} canvas': '{value1} plátno',
    'Loading {value1}…': 'Načítava sa {value1}…',
    '{value1} · Original retained': '{value1} · Pôvodný súbor zachovaný',
    '{value1} {value2}{value3} · Added {value4}': '{value1} {value2}{value3} · Pridané {value4}',
    '{value1} Use in chat': '{value1} Použiť v chate',
    '{value1} Download': '{value1} Stiahnuť',
    Table: 'Tabuľka',
    Chart: 'Graf',
    Original: 'Pôvodný súbor',
    'Text extracted from the PDF, marked by page. Download the original for its layout and images.':
      'Text extrahovaný z PDF a označený podľa strán. Stiahnite si pôvodný súbor, aby ste zachovali jeho rozloženie a obrázky.',
    'This preview shows the beginning of the file. Poneva reads the whole file; download the original to see all of it.':
      'Táto ukážka zobrazuje začiatok súboru. Poneva číta celý súbor; stiahnite si pôvodný súbor, aby ste videli jeho celý obsah.',
    'Preview of the first {value1} complete rows. Filtering and charts use only this preview. Download the original for the full file.':
      'Ukážka prvých {value1} úplných riadkov. Filtrovanie a grafy používajú iba túto ukážku. Stiahnite si pôvodný súbor, aby ste videli celý súbor.',
    'This source link cannot be opened.': 'Tento odkaz na zdroj sa nedá otvoriť.',
    'Read-only chat': 'Chat iba na čítanie',
    'Only {value1} writes in this chat. Fork it to continue with your own connections. {value2}':
      'V tomto chate môže písať iba {value1}. Vytvorte odbočku a pokračujte s vlastnými pripojeniami. {value2}',
    'Suggest a follow-up…': 'Navrhnúť pokračovanie…',
    'Suggest a follow-up': 'Navrhnúť pokračovanie',
    'Sending…': 'Odosiela sa…',
    Send: 'Odoslať',
    'We could not dismiss that suggestion. Please try again.':
      'Tento návrh sa nepodarilo skryť. Skúste to znova.',
    'Suggested follow-ups': 'Navrhované pokračovania',
    '{value1} suggests': '{value1} navrhuje',
    Ask: 'Opýtať sa',
    'Dismiss {value1}’s suggestion': 'Skryť návrh od {value1}',
    'Suggested by': 'Navrhol/-a',
    '· edit it or send it': '· upravte ho alebo odošlite',
    'Remove the suggestion tag': 'Odstrániť štítok návrhu',
    '{value1} {value2} is getting an answer': '{value1} {value2} dostáva odpoveď',
    '{value1} {value2} stopped the answer': '{value1} {value2} zastavil/-a odpoveď',
    '{value1} Fork from here': '{value1} Vytvoriť odbočku odtiaľto',
    '{value1} From {value2}’s {value3}': '{value1} Z {value3} používateľa {value2}',
    'Only {value1} can use this account': 'Tento účet môže používať iba {value1}',
    '{value1} Suggested by {value2}': '{value1} Navrhol/-a {value2}',
    'Fork this chat': 'Vytvoriť odbočku z tohto chatu',
    'Forking…': 'Vytvára sa odbočka…',
    Fork: 'Vytvoriť odbočku',
    'Could not make this private.': 'Tento chat sa nepodarilo nastaviť ako súkromný.',
    'Make this chat private?': 'Nastaviť tento chat ako súkromný?',
    Close: 'Zavrieť',
    '{value1} will see “{value2}”. Everyone else loses access right away {value3} .{value4}':
      '{value1} uvidí „{value2}“. Všetci ostatní okamžite stratia prístup {value3} .{value4}',
    Cancel: 'Zrušiť',
    'Saving…': 'Ukladá sa…',
    'Make private': 'Nastaviť ako súkromné',
    'This chat is private again. Forks others made stay theirs.':
      'Tento chat je opäť súkromný. Odbočky vytvorené ostatnými zostávajú ich vlastníctvom.',
    'Who can read this chat: {value1}': 'Kto môže čítať tento chat: {value1}',
    'Move this chat': 'Presunúť tento chat',
    'Only you write here. Others follow live and fork.':
      'Písať tu môžete iba vy. Ostatní vás sledujú naživo a môžu vytvoriť odbočku.',
    'Made private. {value1} has been told in their Inbox.':
      'Nastavené ako súkromné. {value1} dostal/-a oznámenie do doručenej pošty.',
    'Chat access': 'Prístup k chatu',
    '{value1}’s chat. As an admin you can make it private.':
      'Chat používateľa {value1}. Ako správca ho môžete nastaviť ako súkromný.',
    'Only {value1} will see it. {value2} is told.':
      'Uvidí ho iba {value1}. {value2} dostane oznámenie.',
    '{value1} {value2} following': '{value1} {value2} sleduje',
    'Forked from{value1} {value2} . The history is copied. From here, tools run with your own access.':
      'Odbočka z{value1} {value2} . História je skopírovaná. Od tohto miesta sa nástroje spúšťajú s vaším vlastným prístupom.',
    '{value1} made this chat private': '{value1} nastavil/-a tento chat ako súkromný',
    'You can no longer open it. Any fork you made stays yours.':
      'Už ho nemôžete otvoriť. Každá odbočka, ktorú ste vytvorili, zostáva vaša.',
    'Start a new chat': 'Začať nový chat',
    'Back to Recent chats': 'Späť na posledné chaty',
    'More chat actions': 'Ďalšie akcie chatu',
    'Close conversation sharing': 'Zavrieť zdieľanie konverzácie',
    'Review the text before saving a private copy to Library. Then choose its audience. Your original conversation and future messages stay private.':
      'Pred uložením súkromnej kópie do knižnice skontrolujte text. Potom vyberte jej publikum. Vaša pôvodná konverzácia a budúce správy zostanú súkromné.',
    'Preparing the conversation…': 'Pripravuje sa konverzácia…',
    'Refresh preview': 'Obnoviť ukážku',
    'The copy is saved in Library. Use Share to choose who can access it.':
      'Kópia je uložená v knižnici. Pomocou možnosti Zdieľať vyberte, kto k nej môže mať prístup.',
    'Save this copy': 'Uložiť túto kópiu',
    'That Skill could not be opened.': 'Túto zručnosť sa nepodarilo otvoriť.',
    '{value1}{value2} · reviews and approvals': '{value1}{value2} · kontroly a schválenia',
    'Open Inbox': 'Otvoriť doručenú poštu',
    'New at {value1} this week': 'Nové v {value1} tento týždeň',
    'Nothing new this week. Shared work, published Skills and approved knowledge show up here.':
      'Tento týždeň nič nové. Zdieľaná práca, publikované zručnosti a schválené znalosti sa zobrazia tu.',
    'New at {value1}': 'Nové v {value1}',
    'This Skill is unavailable. Try again.': 'Táto zručnosť nie je k dispozícii. Skúste to znova.',
    'You can attach up to {value1} files. Remove an attachment to add another.':
      'Môžete priložiť najviac {value1} súborov. Ak chcete pridať ďalší, odstráňte prílohu.',
    'Add company context': 'Pridať kontext spoločnosti',
    'Add company context · @': 'Pridať kontext spoločnosti · @',
    'Choose a Skill': 'Vybrať zručnosť',
    'Choose a Skill · /': 'Vybrať zručnosť · /',
    context: 'kontext',
    skills: 'zručnosti',
    'Choose company context': 'Vyberte kontext spoločnosti',
    'Skills for this conversation': 'Zručnosti pre túto konverzáciu',
    'Bring context into the conversation': 'Pridať kontext do konverzácie',
    'Close context picker': 'Zavrieť výber kontextu',
    'Filter company context': 'Filtrovať kontext spoločnosti',
    'Find a Skill…': 'Nájsť zručnosť…',
    'Find a file…': 'Nájsť súbor…',
    'Available company context': 'Dostupný kontext spoločnosti',
    'No matching published Skills.': 'Žiadne zodpovedajúce publikované zručnosti.',
    'No matching files.': 'Žiadne zodpovedajúce súbory.',
    'Searching company work…': 'Vyhľadáva sa v práci spoločnosti…',
    'Try search again': 'Skúsiť vyhľadávanie znova',
    'Meaning search is temporarily limited. Showing available text matches.':
      'Vyhľadávanie podľa významu je dočasne obmedzené. Zobrazujú sa dostupné textové zhody.',
    'Load more matches': 'Načítať ďalšie zhody',
    '{value1} files attached. Remove an attachment to add another. Saved Skill references are included separately.':
      'Priložené súbory: {value1}. Ak chcete pridať ďalší, odstráňte prílohu. Odkazy na uložené zručnosti sú zahrnuté samostatne.',
    'Create a Skill in chat': 'Vytvoriť zručnosť v chate',
    'Upload a company file': 'Nahrať súbor spoločnosti',
    'Company knowledge is always available to Poneva.':
      'Znalosti spoločnosti sú pre Ponevu vždy dostupné.',
    '{value1} was not connected': '{value1} nebolo pripojené',
    Dismiss: 'Skryť',
    'Try connecting again': 'Skúsiť pripojenie znova',
    Waiting: 'Čaká sa',
    Connected: 'Pripojené',
    'Needs reconnecting': 'Vyžaduje opätovné pripojenie',
    Connect: 'Pripojiť',
    '{value1}{value2} The provider’s account permissions still apply.':
      '{value1}{value2} Naďalej platia povolenia účtu poskytovateľa.',
    'Last error: {value1}': 'Posledná chyba: {value1}',
    '{value1} {value2} ready.': '{value1} {value2} pripravené.',
    'Continue with my Meta app': 'Pokračovať s mojou aplikáciou Meta',
    Reconnect: 'Znova pripojiť',
    Disconnect: 'Odpojiť',
    'Remove attachment: {value1}': 'Odstrániť prílohu: {value1}',
    'Saved in this Skill. Edit the Skill to change its references.':
      'Uložené v tejto zručnosti. Ak chcete zmeniť odkazy, upravte zručnosť.',
    'Remove Skill context': 'Odstrániť kontext zručnosti',
    Refining: 'Spresňuje sa',
    Previewing: 'Zobrazuje sa ukážka',
    Using: 'Používa sa',
    'Skill revision {value1}': 'Revízia zručnosti {value1}',
    'a new Skill': 'nová zručnosť',
    '{value1} Making a new agent {value2}': '{value1} Vytvára sa nový agent {value2}',
    'Stop making a new agent in this chat': 'Zastaviť vytváranie nového agenta v tomto chate',
    'Saved Skill references': 'Uložené odkazy na zručnosti',
    'Included with Skill · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}':
      'Zahrnuté so zručnosťou · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}',
    'Selected Skill revision is unavailable. Select the Skill again to view its saved references.':
      'Vybraná revízia zručnosti nie je dostupná. Ak chcete zobraziť jej uložené odkazy, vyberte zručnosť znova.',
    'Conversation attachments': 'Prílohy konverzácie',
    'Added for this conversation': 'Pridané pre túto konverzáciu',
    'Selected passage {value1}': 'Vybraná pasáž {value1}',
    'We could not load your workspace.': 'Váš pracovný priestor sa nepodarilo načítať.',
    'The selected Skill is unavailable. Check its access or choose it again.':
      'Vybraná zručnosť nie je dostupná. Skontrolujte k nej prístup alebo ju vyberte znova.',
    'Source saved privately and included in your knowledge search.':
      'Zdroj bol uložený súkromne a zahrnutý do vyhľadávania v znalostiach.',
    'File saved privately to your library and attached to this message.':
      'Súbor bol uložený súkromne do vašej knižnice a priložený k tejto správe.',
    'File saved privately to your library.': 'Súbor bol uložený súkromne do vašej knižnice.',
    '{value1} {value2} earlier {value3} saved{value4}.':
      '{value1} {value2} predtým {value3} uložené{value4}.',
    'Extracted text for Poneva to read. Download the original for its layout, charts and images. Spreadsheet formulas show their saved results and are not recalculated.':
      'Extrahovaný text na čítanie pre Ponevu. Pôvodný súbor si stiahnite, ak chcete zachovať jeho rozloženie, grafy a obrázky. Vzorce v tabuľke zobrazujú uložené výsledky a neprepočítavajú sa.',
    Esc: 'Esc',
    'Start something': 'Začať',
    'Choose a file to work with': 'Vyberte súbor, s ktorým chcete pracovať',
    'Skills worth adding': 'Zručnosti, ktoré sa oplatí pridať',
    'Picked for you': 'Vybrané pre vás',
    'Reusable work grounded in your company knowledge.':
      'Opakovane použiteľná práca založená na znalostiach vašej spoločnosti.',
    'Ideas from your company context and recent work. Pick one to start.':
      'Nápady z kontextu vašej spoločnosti a nedávnej práce. Vyberte jeden a začnite.',
    'Refresh suggested tasks': 'Obnoviť navrhované úlohy',
    'Check for new company context.': 'Skontrolovať nový kontext spoločnosti.',
    'Check for new context. Ideas also refresh daily.':
      'Skontrolujte nový kontext. Nápady sa tiež obnovujú denne.',
    Refresh: 'Obnoviť',
    'Finding useful starting points…': 'Hľadajú sa užitočné východiská…',
    'Suggestions aren’t available right now. Try Refresh, or describe the work you want to do.':
      'Návrhy momentálne nie sú dostupné. Skúste Obnoviť alebo opíšte prácu, ktorú chcete vykonať.',
    'Loading the knowledge pages…': 'Načítavajú sa stránky znalostí…',
    '{value1} All pages': '{value1} Všetky stránky',
    'The page is created.': 'Stránka je vytvorená.',
    'Your new page is suggested. A publisher decides whether it is added.':
      'Vaša nová stránka bola navrhnutá. O jej pridaní rozhodne vydavateľ.',
    'Company knowledge': 'Znalosti spoločnosti',
    'What Poneva knows about your company, page by page. Every change is kept.':
      'Čo Poneva vie o vašej spoločnosti, stránku po stránke. Každá zmena sa uchováva.',
    'Loading company knowledge…': 'Načítavajú sa znalosti spoločnosti…',
    'Knowledge pages are not enabled in this workspace.':
      'Stránky znalostí nie sú v tomto pracovnom priestore povolené.',
    'Ask your Poneva contact to switch them on for your company.':
      'Požiadajte svojho kontaktu v Poneve, aby ich pre vašu spoločnosť zapol.',
    '{value1} Change the agent': '{value1} Zmeniť agenta',
    '{value1} Continue in chat': '{value1} Pokračovať v chate',
    Edit: 'Upraviť',
    '{value1} Edit with chat': '{value1} Upraviť v chate',
    '{value1} Duplicate to my Library': '{value1} Duplikovať do mojej knižnice',
    'Duplicated to your Library. Only you can see the copy.':
      'Duplikát bol pridaný do vašej knižnice. Kópiu vidíte iba vy.',
    'Could not duplicate this Result. Try again.':
      'Tento výsledok sa nepodarilo duplikovať. Skúste to znova.',
    'Saved version {value1}.': 'Verzia {value1} bola uložená.',
    'A newer version was saved. Reload the Result before saving.':
      'Bola uložená novšia verzia. Pred uložením znova načítajte výsledok.',
    'Could not save this version. Try again.': 'Túto verziu sa nepodarilo uložiť. Skúste to znova.',
    '{value1} saved a newer version. Review it before saving.':
      '{value1} uložil(a) novšiu verziu. Pred uložením si ju skontrolujte.',
    'Hide their version': 'Skryť ich verziu',
    'Show their version': 'Zobraziť ich verziu',
    'Start from their version': 'Začať od ich verzie',
    Markdown: 'Markdown',
    'Result text': 'Text výsledku',
    Preview: 'Ukážka',
    'What changed': 'Čo sa zmenilo',
    'What changed? (optional)': 'Čo sa zmenilo? (voliteľné)',
    'Save version {value1}': 'Uložiť verziu {value1}',
    'Open chat': 'Otvoriť chat',
    Current: 'Aktuálna',
    Restore: 'Obnoviť',
    'Could not load the history.': 'Históriu sa nepodarilo načítať.',
    'Restored version {value1} as version {value2}.':
      'Verzia {value1} bola obnovená ako verzia {value2}.',
    'Someone saved a newer version. Review it before restoring.':
      'Niekto uložil novšiu verziu. Pred obnovením si ju skontrolujte.',
    'Could not restore that version.': 'Túto verziu sa nepodarilo obnoviť.',
    'Loading history…': 'Načítava sa história…',
    'Restoring keeps what is there now as a version too, so nothing is lost.':
      'Obnovením sa aktuálny stav tiež uloží ako verzia, takže sa nič nestratí.',
    'This Result was made with your own {value1}.':
      'Tento výsledok bol vytvorený pomocou vášho vlastného prvku {value1}.',
    'It also used': 'Použil aj',
    'This Result was made with': 'Tento výsledok bol vytvorený pomocou',
    'Colleagues can read what came from them, but can never use them.':
      'Kolegovia si môžu prečítať obsah, ktorý z nich pochádza, ale nikdy ich nemôžu používať.',
    'Your personal agent {value1} keeps it up to date with your own access, so every refresh can carry your private data.':
      'Váš osobný agent {value1} ho aktualizuje pomocou vášho prístupu, takže každé obnovenie môže obsahovať vaše súkromné údaje.',
    'A colleague’s personal agent keeps it up to date with their own access, so every refresh can carry their private data.':
      'Osobný agent kolegu ho aktualizuje pomocou jeho prístupu, takže každé obnovenie môže obsahovať jeho súkromné údaje.',
    'Made private. Only you can see this meeting.':
      'Nastavené ako súkromné. Toto stretnutie vidíte iba vy.',
    'Could not make this meeting private.': 'Toto stretnutie sa nepodarilo nastaviť ako súkromné.',
    'Meeting · {value1} {value2} · Original retained':
      'Stretnutie · {value1} {value2} · Originál zachovaný',
    'The recording could not be opened.': 'Nahrávku sa nepodarilo otvoriť.',
    'Ask about this suggestion': 'Opýtať sa na tento návrh',
    meeting_processing_failed: 'spracovanie_stretnutia_zlyhalo',
    'Who can see this': 'Kto to môže vidieť',
    'Everyone at {value1}': 'Všetci v {value1}',
    'Only me': 'Iba ja',
    'Everyone at {value1} can find it and ask about it.':
      'Všetci v {value1} to môžu nájsť a pýtať sa na to.',
    'Only you can open and search this meeting. You can share it later.':
      'Toto stretnutie môžete otvoriť a prehľadávať iba vy. Neskôr ho môžete zdieľať.',
    'Added. Only you can see it. Transcription is running in the background.':
      'Pridané. Vidíte to iba vy. Prepis sa vytvára na pozadí.',
    'Visible to everyone at {value1}': 'Viditeľné pre všetkých v {value1}',
    'Could not make it private.': 'Nepodarilo sa to nastaviť ako súkromné.',
    'Show more meetings': 'Zobraziť ďalšie stretnutia',
    'Attached to this message': 'Priložené k tejto správe',
    'Connect securely, choose the tables to share, then decide whether Poneva can read or make changes.':
      'Bezpečne sa pripojte, vyberte tabuľky na zdieľanie a potom určte, či z nich Poneva môže čítať alebo vykonávať zmeny.',
    'Review the tables this connection can access. Select at least one table.':
      'Skontrolujte tabuľky, ku ktorým má toto pripojenie prístup. Vyberte aspoň jednu tabuľku.',
    'Select at least one table. Nothing is selected by default.':
      'Vyberte aspoň jednu tabuľku. Predvolene nie je vybratá žiadna.',
    'Choose who can use this connection and what Poneva can do.':
      'Vyberte, kto môže toto pripojenie používať a čo môže Poneva robiť.',
    'Your chosen access is enabled for the selected tables.':
      'Zvolený prístup je povolený pre vybrané tabuľky.',
    'Your connection is saved with reading paused until permission is confirmed.':
      'Vaše pripojenie je uložené s pozastaveným čítaním, kým sa nepotvrdí povolenie.',
    'Confirm database disconnect': 'Potvrdiť odpojenie databázy',
    'Disconnect this database?': 'Odpojiť túto databázu?',
    'Access will stop for everyone using this connection.':
      'Prístup sa zastaví pre všetkých, ktorí používajú toto pripojenie.',
    'Keep connection': 'Ponechať pripojenie',
    'What it can reach · {value1}{value2} {value3}':
      'K čomu má prístup · {value1}{value2} {value3}',
    Back: 'Späť',
    Continue: 'Pokračovať',
    'Uploading…': 'Nahráva sa…',
    Library: 'Knižnica',
    'Source material for your work. Available whenever you need it.':
      'Zdrojové materiály pre vašu prácu. K dispozícii vždy, keď ich potrebujete.',
    'The work you want to keep, with its sources and conversation attached.':
      'Práca, ktorú si chcete ponechať, s pripojenými zdrojmi a konverzáciou.',
    Results: 'Výsledky',
    Files: 'Súbory',
    Artifacts: 'Artefakty',
    'Search library': 'Prehľadávať knižnicu',
    'Find files by meaning…': 'Nájsť súbory podľa významu…',
    'Find saved work by meaning…': 'Nájsť uloženú prácu podľa významu…',
    'Search coverage is limited while indexing or meaning-based search is unavailable. You can retry or browse recent items.':
      'Rozsah vyhľadávania je obmedzený, kým prebieha indexovanie alebo nie je dostupné vyhľadávanie podľa významu. Môžete to skúsiť znova alebo prehľadávať najnovšie položky.',
    'No matching work found.': 'Nenašla sa žiadna zodpovedajúca práca.',
    'A starting point for your next question.': 'Východisko pre vašu ďalšiu otázku.',
    'Good work is worth keeping.': 'Dobrá práca stojí za to, aby ste si ju ponechali.',
    'Try a different description or clear the search to browse.':
      'Skúste iný opis alebo vymažte vyhľadávanie a prehľadajte obsah.',
    'Upload source material once and use it in conversations and Skills. Your original stays in the library.':
      'Nahrajte zdrojový materiál raz a používajte ho v konverzáciách a zručnostiach. Originál zostane v knižnici.',
    'Ask Poneva to save an answer, table or chart. Results stay connected to the conversation and their sources.':
      'Požiadajte Ponevu, aby uložila odpoveď, tabuľku alebo graf. Výsledky zostanú prepojené s konverzáciou a jej zdrojmi.',
    'Start in chat {value1}': 'Začať v chate {value1}',
    'Open result: {value1}': 'Otvoriť výsledok: {value1}',
    'Loading more library items…': 'Načítavajú sa ďalšie položky knižnice…',
    'Load more': 'Načítať ďalšie',
    'Documents, transcripts, audio and video · Up to 500 MB per file. New files are private. Choose their audience with Share and which processable files become searchable company knowledge.':
      'Dokumenty, prepisy, zvukové a video súbory · Maximálne 500 MB na súbor. Nové súbory sú súkromné. Pomocou možnosti Zdieľať vyberte ich publikum a určte, ktoré spracovateľné súbory sa stanú prehľadávateľnou firemnou databázou znalostí.',
    Skills: 'Zručnosti',
    'Create in chat': 'Vytvoriť v chate',
    'Search Skills': 'Vyhľadať zručnosti',
    'Search finds published Skills. Clear the search to browse your drafts too.':
      'Vyhľadávanie nájde publikované zručnosti. Vymažte vyhľadávanie a prehliadajte aj svoje koncepty.',
    'Search coverage is limited while indexing or meaning-based search is unavailable.':
      'Rozsah vyhľadávania je obmedzený, kým nie je k dispozícii indexovanie alebo vyhľadávanie podľa významu.',
    'Searching Skills…': 'Vyhľadávajú sa zručnosti…',
    'No matching published Skills found. Try a different description.':
      'Nenašli sa žiadne zodpovedajúce publikované zručnosti. Skúste iný opis.',
    'Load more Skills': 'Načítať ďalšie zručnosti',
    'View Skill: {value1}': 'Zobraziť zručnosť: {value1}',
    'Company workspace': 'Firemný pracovný priestor',
    'View {value1}': 'Zobraziť {value1}',
    'Loading Skills…': 'Načítavajú sa zručnosti…',
    'Try again {value1}': 'Skúsiť znova {value1}',
    'Try again': 'Skúsiť znova',
    'Nothing yet.': 'Zatiaľ nič.',
    'Made from · Used by': 'Vytvorené z · Používané v',
    'Could not load links': 'Odkazy sa nepodarilo načítať',
    'Made from': 'Vytvorené z',
    'Used by': 'Používané v',
    'About this chat {value1}': 'O tomto chate {value1}',
    'About this chat': 'O tomto chate',
    'Keep the work moving.': 'Pokračujte v práci.',
    'Ask a follow-up with this result in view, or turn a useful approach into a company Skill.':
      'Položte doplňujúcu otázku s týmto výsledkom na obrazovke alebo premeňte užitočný postup na firemnú zručnosť.',
    'Save approach as a Skill': 'Uložiť postup ako zručnosť',
    'Preview of': 'Ukážka',
    'Made with': 'Vytvorené pomocou',
    'Open the draft': 'Otvoriť koncept',
    'Open Skill': 'Otvoriť zručnosť',
    'Use in chat': 'Použiť v chate',
    'Finish the draft': 'Dokončiť koncept',
    'Refine this Skill': 'Vylepšiť túto zručnosť',
    'Made with a Skill.': 'Vytvorené pomocou zručnosti.',
    'This workspace could not be loaded just now, so that Skill cannot be opened yet. The result itself is unchanged.':
      'Tento pracovný priestor sa teraz nepodarilo načítať, preto túto zručnosť zatiaľ nemožno otvoriť. Samotný výsledok sa nezmenil.',
    'That Skill is not available in this workspace, so it cannot be opened or used again. The result itself is unchanged.':
      'Táto zručnosť nie je v tomto pracovnom priestore dostupná, preto ju nemožno znova otvoriť ani použiť. Samotný výsledok sa nezmenil.',
    'Result · {value1} {value2}': 'Výsledok · {value1} {value2}',
    '{value1} Copy link': '{value1} Kopírovať odkaz',
    'Result link copied.': 'Odkaz na výsledok bol skopírovaný.',
    'Could not copy the link. Use your browser address bar.':
      'Odkaz sa nepodarilo skopírovať. Použite adresný riadok prehliadača.',
    'No preview is available for this result.': 'Pre tento výsledok nie je k dispozícii ukážka.',
    '{value1} rows are retained in this snapshot. Open Table to inspect the values.':
      'V tejto snímke je zachovaných {value1} riadkov. Otvorte Tabuľku a skontrolujte hodnoty.',
    'People can’t edit a Result an agent keeps up to date; the next refresh would replace their edit. Change the agent’s instructions instead.':
      'Používatelia nemôžu upravovať výsledok, ktorý agent udržiava aktuálny; pri ďalšej aktualizácii by sa ich úpravy prepísali. Namiesto toho zmeňte pokyny agenta.',
    'Linked sources': 'Prepojené zdroje',
    'Saved source': 'Uložený zdroj',
    'No source documents are linked to this result. Company knowledge and other references may be cited in the answer.':
      'K tomuto výsledku nie sú prepojené žiadne zdrojové dokumenty. V odpovedi môžu byť citované firemné znalosti a iné referencie.',
    'Run details': 'Podrobnosti spustenia',
    Created: 'Vytvorené',
    ', revised {value1}': ', upravené {value1}',
    Conversation: 'Konverzácia',
    'Not recorded': 'Nezaznamenané',
    'Open conversation': 'Otvoriť konverzáciu',
    Run: 'Spustenie',
    Updates: 'Aktualizácie',
    'Kept up to date by {value1}': 'Aktualizuje {value1}',
    'Version {value1}': 'Verzia {value1}',
    'Could not open this request.': 'Túto žiadosť sa nepodarilo otvoriť.',
    'Approved version published.': 'Schválená verzia bola publikovaná.',
    'Request rejected. The item stays unchanged.':
      'Žiadosť bola zamietnutá. Položka zostáva nezmenená.',
    'Could not save the decision.': 'Rozhodnutie sa nepodarilo uložiť.',
    'Proposed company change': 'Navrhovaná firemná zmena',
    'Opening…': 'Otvára sa…',
    'Approve this version': 'Schváliť túto verziu',
    Decline: 'Zamietnuť',
    'Review the submitted version below. Changes made since submission will need a new request.':
      'Nižšie skontrolujte odoslanú verziu. Zmeny vykonané po odoslaní si vyžiadajú novú žiadosť.',
    'The version submitted with this request.': 'Verzia odoslaná s touto žiadosťou.',
    'Version and proposed change': 'Verzia a navrhovaná zmena',
    'Could not read the pinned content.': 'Pripnutý obsah sa nepodarilo načítať.',
    'Showing a page of {value1} characters.': 'Zobrazuje sa strana s {value1} znakmi.',
    'Beginning of the submitted content. Open the full text to review every page.':
      'Začiatok odoslaného obsahu. Otvorte celý text a skontrolujte každú stranu.',
    'Read full submitted text': 'Prečítať celý odoslaný text',
    'Previous page': 'Predchádzajúca strana',
    'Next page': 'Ďalšia strana',
    'Made private. Its creator has been told in their Inbox.':
      'Nastavené ako súkromné. Autor bol o tom informovaný v doručenej pošte.',
    'Made private. Its creator could not be notified.':
      'Nastavené ako súkromné. Autora sa nepodarilo upozorniť.',
    'Make this {value1} private?': 'Nastaviť {value1} ako súkromné?',
    'Only the person who created it will see it. Everyone else loses access right away, and its creator gets an Inbox update if they are still a company member. If they have left, nobody in the company will be able to access this item.':
      'Uvidí ho iba osoba, ktorá ho vytvorila. Všetci ostatní okamžite stratia prístup a jeho autor dostane aktualizáciu v doručenej pošte, ak je stále členom spoločnosti. Ak zo spoločnosti odišiel, k tejto položke nebude mať prístup nikto v spoločnosti.',
    'Sent for review. The current audience stays unchanged until approval.':
      'Odoslané na kontrolu. Aktuálne publikum zostane nezmenené až do schválenia.',
    'This suggestion is no longer available to you.': 'Tento návrh už pre vás nie je k dispozícii.',
    'We could not check where this suggestion stands.': 'Nepodarilo sa overiť stav tohto návrhu.',
    'Check again': 'Skontrolovať znova',
    'Show on page': 'Zobraziť na stránke',
    'The editor could not be loaded. Poneva may have been updated since you opened this page. Reload to get the latest version; nothing on this page has changed.':
      'Editor sa nepodarilo načítať. Poneva mohla byť aktualizovaná od otvorenia tejto stránky. Načítajte stránku znova, aby ste získali najnovšiu verziu; na tejto stránke sa nič nezmenilo.',
    'Reload Poneva': 'Načítať Poneva znova',
    Formatting: 'Formátovanie',
    'Text style': 'Štýl textu',
    Text: 'Text',
    Heading: 'Nadpis',
    Subheading: 'Podnadpis',
    'Link a page': 'Prepojiť stránku',
    'A page needs a title.': 'Stránka musí mať názov.',
    'Nothing has changed yet.': 'Zatiaľ sa nič nezmenilo.',
    'A page needs some text. To remove a page, archive it instead.':
      'Stránka musí obsahovať nejaký text. Ak ju chcete odstrániť, archivujte ju.',
    'A suggested new page needs some text.': 'Navrhovaná nová stránka musí obsahovať nejaký text.',
    'This page is larger than 256 KB. Split it into smaller pages.':
      'Táto stránka je väčšia ako 256 KB. Rozdeľte ju na menšie stránky.',
    'Say in a few words why this change is right.':
      'Stručne vysvetlite, prečo je táto zmena správna.',
    'This page changed while you were editing. Your text is still here: copy it, then open the latest version and make your change again.':
      'Táto stránka sa počas úprav zmenila. Váš text je stále tu: skopírujte ho, potom otvorte najnovšiu verziu a vykonajte zmenu znova.',
    'Your text is copied.': 'Text bol skopírovaný.',
    'Your text could not be copied. Select it in the editor and copy it.':
      'Text sa nepodarilo skopírovať. Vyberte ho v editore a skopírujte.',
    'The page “{value1}” is created.': 'Stránka „{value1}“ bola vytvorená.',
    'New page': 'Nová stránka',
    'Editing {value1}': 'Úprava {value1}',
    Editing: 'Úprava',
    'Creating publishes the page under {value1} for everyone':
      'Vytvorením stránku zverejníte pod {value1} pre všetkých',
    'Saving publishes the new version for everyone': 'Uložením zverejníte novú verziu pre všetkých',
    'Your changes are sent as a suggestion for a publisher':
      'Vaše zmeny sa odošlú ako návrh schvaľovateľovi',
    'Create page': 'Vytvoriť stránku',
    Save: 'Uložiť',
    'Send suggestion': 'Odoslať návrh',
    '{value1} Copy my text': '{value1} Skopírovať môj text',
    'Open the latest version': 'Otvoriť najnovšiu verziu',
    'Page title': 'Názov stránky',
    'Loading the editor…': 'Editor sa načítava…',
    'New page text': 'Text novej stránky',
    'Text of {value1}': 'Text stránky {value1}',
    'Write the page. Type [[ to link another page.':
      'Napíšte obsah stránky. Zadaním [[ prepojíte inú stránku.',
    'Type [[ to link another page.': 'Zadaním [[ prepojíte inú stránku.',
    'Link to a page': 'Prepojiť so stránkou',
    'What changed, in a few words': 'Čo sa zmenilo, stručne',
    'Where this comes from, in a few words': 'Odkiaľ to pochádza, stručne',
    'Shown in the page history.': 'Zobrazuje sa v histórii stránky.',
    'A publisher sees this next to your change.': 'Schvaľovateľ to uvidí vedľa vašej zmeny.',
    '1 suggestion is open on this page': 'Na tejto stránke je otvorený 1 návrh',
    '{value1} suggestions are open on this page': 'Na tejto stránke je otvorených {value1} návrhov',
    'They stay open while you edit. After you save, they show against your new text; one whose words you changed is marked outdated.':
      'Počas úprav zostávajú otvorené. Po uložení sa zobrazia pri vašom novom texte; návrh, ktorého slová ste zmenili, bude označený ako neaktuálny.',
    'Type [[ to link another page. Links keep working when a page is renamed or moved.':
      'Zadaním [[ prepojíte inú stránku. Odkazy budú fungovať aj po premenovaní alebo presunutí stránky.',
    'Loading the history…': 'História sa načítava…',
    'This page has no saved text yet.': 'Táto stránka zatiaľ nemá uložený text.',
    'Say in a few words why this revision should come back.':
      'Stručne vysvetlite, prečo by sa mala táto revízia obnoviť.',
    'Revision {value1} is suggested for a publisher to accept.':
      'Revízia {value1} bola navrhnutá schvaľovateľovi na prijatie.',
    'The page already reads like this revision.': 'Stránka už vyzerá ako táto revízia.',
    'Revision {value1} is restored as revision {value2}.':
      'Revízia {value1} bola obnovená ako revízia {value2}.',
    'Revision history': 'História revízií',
    Revisions: 'Revízie',
    'Every saved revision is kept.': 'Každá uložená revízia sa uchováva.',
    'Revision {value1} {value2}': 'Revízia {value1} {value2}',
    'Revision {value1} compared with revision {value2}':
      'Porovnanie revízie {value1} s revíziou {value2}',
    'Revision {value1}, the first text of this page': 'Revízia {value1}, prvý text tejto stránky',
    'Green was added, struck through was removed.':
      'Zelené bolo pridané, prečiarknuté bolo odstránené.',
    '{value1} Export Markdown': '{value1} Exportovať Markdown',
    'Restore this revision': 'Obnoviť túto revíziu',
    'Suggest restoring it': 'Navrhnúť jej obnovenie',
    'Why should this revision come back?': 'Prečo by sa mala táto revízia obnoviť?',
    'Loading this revision…': 'Táto revízia sa načítava…',
    'Only the title changed, from “{value1}” to “{value2}”.':
      'Zmenil sa iba názov z „{value1}“ na „{value2}“.',
    'The text did not change in this revision.': 'Text sa v tejto revízii nezmenil.',
    'Changes in revision {value1}': 'Zmeny v revízii {value1}',
    'Loading page…': 'Stránka sa načítava…',
    'Loading suggestion…': 'Návrh sa načítava…',
    'This suggestion is not available.': 'Tento návrh nie je k dispozícii.',
    'It may have been decided, or it is not one you can see.':
      'Možno už bolo o ňom rozhodnuté alebo ho nemáte oprávnenie zobraziť.',
    'Open Knowledge': 'Otvoriť Knowledge',
    'Opening the suggestion…': 'Návrh sa otvára…',
    'Choose where the page goes.': 'Vyberte, kam sa stránka umiestni.',
    'Say in a few words why.': 'Stručne vysvetlite prečo.',
    'Your suggestion is sent. A publisher decides.':
      'Váš návrh bol odoslaný. Rozhodne o ňom schvaľovateľ.',
    'Moved under {value1}.': 'Presunuté pod {value1}.',
    'Deleted “{value1}”.': 'Odstránené „{value1}“.',
    'Could not update sharing.': 'Zdieľanie sa nepodarilo aktualizovať.',
    'They can follow new answers live and fork it to continue with their own connections. Only you write here. You can make it private again at any time.':
      'Môžu sledovať nové odpovede naživo a vytvoriť z toho vlastnú verziu s vlastnými pripojeniami. Píšete sem iba vy. Kedykoľvek to môžete znova nastaviť ako súkromné.',
    'They see the project, its brief and the work in it they can already open. Nothing in it opens for anyone because of the project; each item keeps its own access.':
      'Uvidia projekt, jeho zadanie a prácu v ňom, ku ktorej už majú prístup. Vďaka projektu sa nikomu neotvorí nič ďalšie; každá položka si zachová vlastné prístupové práva.',
    'Check the content for private information before sharing. Sharing an item does not grant access to its original chat or private connections.':
      'Pred zdieľaním skontrolujte obsah, či neobsahuje súkromné informácie. Zdieľanie položky neposkytuje prístup k pôvodnému chatu ani k súkromným pripojeniam.',
    '{value1} Everyone you share with can read it, including what the assistant or an App in it found in your {value2}. They can’t use your {value3}. Nothing changes for you: the chat keeps working with all your accounts.':
      '{value1} Každý, s kým ju zdieľate, si ju môže prečítať vrátane toho, čo v nej asistent alebo aplikácia našli vo vašom {value2}. Nemôžu používať vaše {value3}. Pre vás sa nič nemení: chat naďalej funguje so všetkými vašimi účtami.',
    '{value1} Everyone you share with can read them, but nobody can use {value2} through this chat.':
      '{value1} Každý, s kým ich zdieľate, si ich môže prečítať, ale nikto nemôže používať {value2} prostredníctvom tohto chatu.',
    'This controls access to the working draft. Any published company version stays available until you explicitly unpublish it. To publish a new version, complete its preview and use Save Skill. Run results stay private.':
      'Toto určuje prístup k pracovnej verzii. Každá zverejnená firemná verzia zostane dostupná, kým ju výslovne nezrušíte. Ak chcete zverejniť novú verziu, dokončite jej náhľad a použite možnosť Uložiť zručnosť. Výsledky spustenia zostávajú súkromné.',
    'Skill deleted. You can restore it from the Skills archive for 30 days.':
      'Zručnosť bola odstránená. Z archívu zručností ju môžete obnoviť do 30 dní.',
    'Could not delete this Skill.': 'Túto zručnosť sa nepodarilo odstrániť.',
    'More actions': 'Ďalšie akcie',
    'Delete “{value1}”? It will disappear from Skills and search, and cannot be used by agents. You can restore it for 30 days. Existing chats and results stay available.':
      'Odstrániť „{value1}“? Zmizne zo zručností a vyhľadávania a agenti ju nebudú môcť používať. Do 30 dní ju môžete obnoviť. Existujúce chaty a výsledky zostanú dostupné.',
    'Deleting…': 'Odstraňuje sa…',
    'Confirm delete': 'Potvrdiť odstránenie',
    'Delete Skill': 'Odstrániť zručnosť',
    'Skill restored as an unpublished draft. Its author can review and publish it again.':
      'Zručnosť bola obnovená ako nezverejnený koncept. Jej autor ju môže skontrolovať a znova zverejniť.',
    'Could not restore this Skill.': 'Túto zručnosť sa nepodarilo obnoviť.',
    'Archived Skills': 'Archivované zručnosti',
    'Deleted Skills can be restored for 30 days. Restoring leaves them unpublished.':
      'Odstránené zručnosti možno obnoviť do 30 dní. Po obnovení zostanú nezverejnené.',
    'Restore until {value1}': 'Obnoviť do {value1}',
    'Loading…': 'Načítava sa…',
    'No archived Skills.': 'Žiadne archivované zručnosti.',
    'Load more archived Skills': 'Načítať ďalšie archivované zručnosti',
    'Show more of the original': 'Zobraziť viac z originálu',
    'Filter result rows': 'Filtrovať riadky výsledkov',
    'Find a product or value…': 'Nájsť produkt alebo hodnotu…',
    '{value1} of {value2}': '{value1} z {value2}',
    'Result table': 'Tabuľka výsledkov',
    'No matching rows.': 'Žiadne zodpovedajúce riadky.',
    'Showing the first 1,000 matching rows. Download the CSV for every row.':
      'Zobrazuje sa prvých 1 000 zodpovedajúcich riadkov. Stiahnite si CSV so všetkými riadkami.',
    'Agent ·': 'Agent ·',
    'Only you': 'Iba vy',
    'Stopped before it finished.': 'Zastavené pred dokončením.',
    'Drafting the project…': 'Pripravuje sa návrh projektu…',
    'Checking where this chat belongs…': 'Kontroluje sa, kam tento chat patrí…',
    'Moving the chat…': 'Chat sa presúva…',
    'Taking it out of the project…': 'Chat sa vyberá z projektu…',
    'Adding it to the project…': 'Chat sa pridáva do projektu…',
    'No matching connections are available right now.':
      'Momentálne nie sú k dispozícii žiadne zodpovedajúce pripojenia.',
    'Company knowledge suggestion': 'Návrh firemných znalostí',
    'Company knowledge now lives on pages. Open Knowledge to see them.':
      'Firemné znalosti sa teraz nachádzajú na stránkach. Otvorte Znalosti a zobrazte si ich.',
    '{value1} · Open beside this conversation': '{value1} · Otvoriť vedľa tejto konverzácie',
    'Name {value1}': 'Názov {value1}',
    'Host {value1}': 'Hostiteľ {value1}',
    'Port {value1}': 'Port {value1}',
    'Database {value1}': 'Databáza {value1}',
    'Username {value1}': 'Používateľské meno {value1}',
    'Password {value1}': 'Heslo {value1}',
    'Advanced TLS': 'Rozšírené TLS',
    '{value1} Poneva verifies the server certificate. Add a CA or server DNS name for IP hosts when your certificate requires it.':
      '{value1} Poneva overuje certifikát servera. Ak to váš certifikát vyžaduje, pre hostiteľov s IP adresou pridajte certifikačnú autoritu CA alebo DNS názov servera.',
    'CA certificate {value1}': 'Certifikát CA {value1}',
    'Certificate server DNS name {value1}': 'DNS názov servera certifikátu {value1}',
    '{value1} Your password is encrypted in secure storage. Poneva verifies the connection before saving it.':
      '{value1} Vaše heslo je zašifrované v zabezpečenom úložisku. Poneva pred uložením overí pripojenie.',
    'Testing…': 'Testuje sa…',
    'Test connection': 'Otestovať pripojenie',
    'PostgreSQL is connected.': 'PostgreSQL je pripojené.',
    'PostgreSQL was saved safely.': 'PostgreSQL bolo bezpečne uložené.',
    'Poneva can read and change rows in the selected tables. Apps also follow their approved data scope.':
      'Poneva môže čítať a meniť riadky vo vybraných tabuľkách. Aplikácie sa tiež riadia schváleným rozsahom údajov.',
    'Poneva can read the selected tables. Apps also follow their approved data scope.':
      'Poneva môže čítať vybrané tabuľky. Aplikácie sa tiež riadia schváleným rozsahom údajov.',
    'Reads are paused until permission is enabled.':
      'Čítanie je pozastavené, kým nepovolíte prístup.',
    'Retrying…': 'Skúša sa znova…',
    'Retry permission': 'Znova požiadať o povolenie',
    'Try it in Chat': 'Vyskúšať v chate',
    Done: 'Hotovo',
    'Disconnect database': 'Odpojiť databázu',
    '{value1} TLS verified ·{value2} {value3}': '{value1} TLS overené ·{value2} {value3}',
    'Search schemas and tables': 'Hľadať schémy a tabuľky',
    'Search tables': 'Hľadať tabuľky',
    '{value1} of {value2} tables selected': 'Vybraté tabuľky: {value1} z {value2}',
    'Select matching tables': 'Vybrať zodpovedajúce tabuľky',
    'Select all tables': 'Vybrať všetky tabuľky',
    Clear: 'Vymazať',
    'Select a whole schema or individual tables. New tables need a fresh selection.':
      'Vyberte celú schému alebo jednotlivé tabuľky. Nové tabuľky vyžadujú nový výber.',
    'No tables match this search.': 'Tomuto vyhľadávaniu nezodpovedajú žiadne tabuľky.',
    'All tables in {value1}': 'Všetky tabuľky v {value1}',
    '{value1} / {value2} tables': '{value1} / {value2} tabuliek',
    'Read & write available': 'Čítanie a zápis sú k dispozícii',
    'Read only': 'Iba na čítanie',
    Ctrl: 'Ctrl',
    'This suggested knowledge update could not be shown.':
      'Tento navrhovaný update znalostí sa nepodarilo zobraziť.',
    'Suggested knowledge update': 'Navrhovaný update znalostí',
    'Suggestion {value1} of {value2}': 'Návrh {value1} z {value2}',
    'Next suggestion': 'Ďalší návrh',
    'Fold the suggestions away': 'Skryť návrhy',
    'Show the suggestions': 'Zobraziť návrhy',
    '1 suggestion': '1 návrh',
    '{value1} suggestions': '{value1} návrhov',
    '{value1} the pages under {value2}': '{value1} stránky pod {value2}',
    px: 'px',
    '{value1} chart of {value2} across {value3}': '{value1} graf {value2} naprieč {value3}',
    'We could not build the file.': 'Súbor sa nepodarilo vytvoriť.',
    '{value1} Present': '{value1} prezentácia',
    'Building…': 'Vytvára sa…',
    'Download PowerPoint': 'Stiahnuť PowerPoint',
    'Slide {value1} of {value2}': 'Snímka {value1} z {value2}',
    Slides: 'Snímky',
    'Slide {value1}': 'Snímka {value1}',
    'Speaker notes': 'Poznámky pre rečníka',
    'Source: {value1}': 'Zdroj: {value1}',
    'Add a name and a web address.': 'Pridajte názov a webovú adresu.',
    'Enter a valid web address.': 'Zadajte platnú webovú adresu.',
    'Use a web address that starts with https://.':
      'Použite webovú adresu začínajúcu reťazcom https://.',
    'Add a custom connection': 'Pridať vlastné pripojenie',
    'Connect a tool server you trust. Poneva checks the address works and saves only the connection details needed to use it.':
      'Pripojte server nástrojov, ktorému dôverujete. Poneva overí, či adresa funguje, a uloží iba údaje o pripojení potrebné na jeho používanie.',
    'Web address': 'Webová adresa',
    'https://tools.example.com': 'https://tools.example.com',
    'Starts with https://, from your provider': 'Začína reťazcom https://, od vášho poskytovateľa',
    'Sign-in': 'Prihlásenie',
    'Advanced sign-in': 'Rozšírené prihlásenie',
    'Access key {value1}': 'Prístupový kľúč {value1}',
    'Request headers': 'Hlavičky požiadavky',
    'Add header': 'Pridať hlavičku',
    'Header {value1} name': 'Názov hlavičky {value1}',
    'Header name': 'Názov hlavičky',
    'Header {value1} value': 'Hodnota hlavičky {value1}',
    'Header value': 'Hodnota hlavičky',
    'Remove header': 'Odstrániť hlavičku',
    Advanced: 'Rozšírené',
    Transport: 'Prenos',
    'Auto-detect': 'Automaticky rozpoznať',
    'Streamable HTTP': 'Streamable HTTP',
    'Legacy SSE': 'Staršie SSE',
    "From your provider's app settings. Leave empty unless they gave you these.":
      'Nájdete v nastaveniach aplikácie poskytovateľa. Ponechajte prázdne, ak vám ich neposkytol.',
    "Authorization server issuer": "Vydavateľ autorizačného servera",
    "Enter the authorization server issuer when using a client ID.": "Pri použití ID klienta zadajte vydavateľa autorizačného servera.",
    'Client ID {value1}': 'ID klienta {value1}',
    'Client secret {value1}': 'Tajný kľúč klienta {value1}',
    'Connecting…': 'Pripája sa…',
    'Test and connect': 'Otestovať a pripojiť',
    'Add the store, the client ID and the client secret.':
      'Pridajte obchod, ID klienta a tajný kľúč klienta.',
    'Connect your Shopify Developer App': 'Pripojte svoju vývojársku aplikáciu Shopify',
    'Poneva can use exactly the access your store gave the app, and nothing more. It talks to Shopify directly and keeps the client secret encrypted.':
      'Poneva môže používať presne tie prístupy, ktoré váš obchod udelil aplikácii, a nič viac. Komunikuje priamo so Shopify a tajný kľúč klienta uchováva zašifrovaný.',
    'How to create the app in Shopify': 'Ako vytvoriť aplikáciu v Shopify',
    'Open{value1} {value2}{value3} with the account that owns the store, and create an app.':
      'Otvorte{value1} {value2}{value3} pomocou účtu, ktorý vlastní obchod, a vytvorte aplikáciu.',
    'Create a version and select the access scopes Poneva may use, for example read_products and read_orders. Add write_ scopes only for data Poneva may change. Then release the version.':
      'Vytvorte verziu a vyberte rozsahy prístupu, ktoré môže Poneva používať, napríklad read_products a read_orders. Rozsahy write_ pridajte iba pre údaje, ktoré môže Poneva meniť. Potom verziu zverejnite.',
    'For orders and customers, also select protected customer data in the app’s settings. Shopify allows this without review for an app made for your own store.':
      'Pri objednávkach a zákazníkoch v nastaveniach aplikácie vyberte aj chránené údaje zákazníkov. Shopify to pri aplikácii vytvorenej pre váš vlastný obchod povoľuje bez kontroly.',
    'Install the app on your store.': 'Nainštalujte aplikáciu vo svojom obchode.',
    'Copy the client ID and client secret from the app’s settings.':
      'Skopírujte ID klienta a tajný kľúč klienta z nastavení aplikácie.',
    'To change the access later, release a new version, approve it on the store and use Test connection here.':
      'Ak chcete neskôr zmeniť prístup, zverejnite novú verziu, schváľte ju v obchode a tu použite funkciu Otestovať pripojenie.',
    Store: 'Obchod',
    'your-store.myshopify.com': 'your-store.myshopify.com',
    'Your store’s .myshopify.com address (Shopify admin → Settings → Domains), or paste the address of your Shopify admin page':
      'Adresa vášho obchodu .myshopify.com (Shopify admin → Settings → Domains) alebo vložte adresu stránky Shopify admin',
    'Client ID {value1} {value2}': 'ID klienta {value1} {value2}',
    'Client secret {value1} {value2}': 'Tajný kľúč klienta {value1} {value2}',
    Person: 'Osoba',
    Everyone: 'Všetci',
    Connection: 'Pripojenie',
    'All connections': 'Všetky pripojenia',
    'App {value1}': 'Aplikácia {value1}',
    'From {value1}': 'Od {value1}',
    'Until {value1}': 'Do {value1}',
    Result: 'Výsledok',
    'All results': 'Všetky výsledky',
    Succeeded: 'Úspešné',
    Denied: 'Zamietnuté',
    Failed: 'Zlyhané',
    Unknown: 'Neznáme',
    Filter: 'Filter',
    'Loading activity…': 'Načítava sa aktivita…',
    'Could not load activity. Try again.': 'Aktivitu sa nepodarilo načítať. Skúste to znova.',
    'Removed connection': 'Odstránené pripojenie',
    'App: {value1}': 'Aplikácia: {value1}',
    'Older activity': 'Staršia aktivita',
    'Archived. Its history is kept.': 'Archivované. História sa zachová.',
    'Choose the page it goes under. Links to it keep working.':
      'Vyberte stránku, pod ktorú patrí. Odkazy na ňu budú naďalej fungovať.',
    'Its text, its history and any open suggestions are removed for good, and links to it from other pages stop working. This cannot be undone.':
      'Jej text, história a všetky otvorené návrhy sa natrvalo odstránia a odkazy na ňu z iných stránok prestanú fungovať. Túto akciu nemožno vrátiť späť.',
    'An archived page no longer informs answers. Its history is kept, and a publisher can restore it or delete it permanently.':
      'Archivovaná stránka už neovplyvňuje odpovede. Jej história sa zachová a vydavateľ ju môže obnoviť alebo natrvalo odstrániť.',
    Under: 'Pod',
    Change: 'Zmeniť',
    'Move under': 'Presunúť pod',
    'Search pages': 'Vyhľadať stránky',
    'Why?': 'Prečo?',
    'Delete permanently': 'Natrvalo odstrániť',
    'Move page': 'Presunúť stránku',
    'Archive page': 'Archivovať stránku',
    'Suggestion {value1}: show its card': 'Návrh {value1}: zobraziť jeho kartu',
    'Removed:': 'Odstránené:',
    'Added:': 'Pridané:',
    'New page “{value1}”{value2}': 'Nová stránka „{value1}“{value2}',
    'No pages match “{value1}”.': 'Žiadne stránky nezodpovedajú výrazu „{value1}“.',
    'Where this page is': 'Kde sa táto stránka nachádza',
    'Describe your company': 'Opíšte svoju spoločnosť',
    'Empty page': 'Prázdna stránka',
    'Describe {value1}': 'Opíšte {value1}',
    'This page has no text yet.': 'Táto stránka zatiaľ nemá žiadny text.',
    'Poneva reads this page before every answer. Start with who you are, what you sell and how you work; details go on the pages under it.':
      'Poneva si túto stránku prečíta pred každou odpoveďou. Začnite tým, kto ste, čo predávate a ako pracujete; podrobnosti patria na stránky pod ňou.',
    'Write it, or ask Poneva in chat to draft it for you.':
      'Napíšte ho alebo požiadajte Ponevu v chate, aby ho pripravila za vás.',
    'Suggest a first version, and a publisher decides whether it becomes the page.':
      'Navrhnite prvú verziu a vydavateľ rozhodne, či sa z nej stane stránka.',
    'Start writing': 'Začať písať',
    'Suggest a first version': 'Navrhnúť prvú verziu',
    'Accepted. The page is archived.': 'Prijaté. Stránka je archivovaná.',
    'Accepted. The page is now revision {value1}.': 'Prijaté. Stránka je teraz vo verzii {value1}.',
    'Accepted.': 'Prijaté.',
    'Suggestion rejected. The page stays as it is.':
      'Návrh bol zamietnutý. Stránka zostáva nezmenená.',
    'Your suggestion is withdrawn.': 'Váš návrh bol stiahnutý.',
    'Restored. The page informs answers again.': 'Obnovené. Stránka opäť ovplyvňuje odpovede.',
    'Your suggestion is sent. A publisher decides whether it becomes the page.':
      'Váš návrh bol odoslaný. Vydavateľ rozhodne, či sa z neho stane stránka.',
    'Saved. The page is now revision {value1}.': 'Uložené. Stránka je teraz vo verzii {value1}.',
    'Nothing changed.': 'Nič sa nezmenilo.',
    'This page is not available.': 'Táto stránka nie je k dispozícii.',
    'It may have been deleted, archived or moved out of reach, or you may no longer be in this company.':
      'Možno bola odstránená, archivovaná alebo presunutá mimo vášho dosahu, prípadne už nie ste v tejto spoločnosti.',
    'Page actions': 'Akcie stránky',
    shown: 'zobrazené',
    hidden: 'skryté',
    '{value1} History': 'História: {value1}',
    '{value1} Ask in chat': 'Opýtať sa v chate: {value1}',
    'Suggest edits': 'Navrhnúť úpravy',
    'More actions for {value1}': 'Ďalšie akcie pre {value1}',
    '{value1} Poneva reads this page in every chat':
      '{value1} Poneva si túto stránku prečíta v každom chate',
    'This page is archived. It no longer informs answers; its history is kept. {value1}':
      'Táto stránka je archivovaná. Už neovplyvňuje odpovede, jej história sa však zachováva. {value1}',
    'Restore page': 'Obnoviť stránku',
    'This link points to an earlier revision. You are reading the current text.':
      'Tento odkaz vedie na staršiu verziu. Čítate aktuálny text.',
    'Show it in History': 'Zobraziť v histórii',
    Pages: 'Stránky',
    'Pages under {value1}': 'Stránky pod {value1}',
    'Linked from': 'Odkazy z',
    Suggestions: 'Návrhy',
    'Suggestions are hidden. You are reading the page as everyone else sees it.':
      'Návrhy sú skryté. Čítate stránku tak, ako ju vidia ostatní.',
    'Loading suggestions…': 'Načítavajú sa návrhy…',
    'Nothing is waiting for review.': 'Na kontrolu nič nečaká.',
    'When someone, Poneva in a chat or a connected agent suggests a change to a page, it shows here and on the page. Nothing changes until a publisher accepts it.':
      'Keď niekto, Poneva v chate alebo pripojený agent navrhne zmenu stránky, zobrazí sa tu aj na stránke. Nič sa nezmení, kým ju vydavateľ neprijme.',
    '{value1} Review knowledge in chat': '{value1} Skontrolovať znalosti v chate',
    'Suggestions for review': 'Návrhy na kontrolu',
    'Suggested changes from chats, meetings, colleagues and connected agents. Nothing changes until a publisher accepts it on the page.':
      'Navrhované zmeny z chatov, stretnutí, od kolegov a pripojených agentov. Nič sa nezmení, kým ich vydavateľ neprijme na stránke.',
    'Your suggestions wait here until a publisher decides. The pages stay as they are until then.':
      'Vaše návrhy tu čakajú, kým vydavateľ nerozhodne. Dovtedy zostávajú stránky nezmenené.',
    'Review page': 'Skontrolovať stránku',
    'Review on page': 'Skontrolovať na stránke',
    'Open the meeting': 'Otvoriť stretnutie',
    'Open the chat': 'Otvoriť chat',
    'Accept and restore': 'Prijať a obnoviť',
    Accept: 'Prijať',
    Reject: 'Zamietnuť',
    'Your suggestion · waiting for a publisher': 'Váš návrh · čaká na vydavateľa',
    Withdraw: 'Stiahnuť',
    'Waiting for a publisher': 'Čaká na vydavateľa',
    'Suggestion {value1}': 'Návrh {value1}',
    'Suggestion {value1} from {value2}{value3}': 'Návrh {value1} od {value2}{value3}',
    'Read the suggested page': 'Prečítať navrhovanú stránku',
    'Outdated: the text it changes was edited after it was suggested. It can be rejected or withdrawn; a new suggestion can be made against the current text.':
      'Neaktuálne: text, ktorý návrh mení, bol po jeho odoslaní upravený. Návrh možno zamietnuť alebo stiahnuť; k aktuálnemu textu možno vytvoriť nový návrh.',
    'Restore this page first to accept this suggestion.':
      'Ak chcete tento návrh prijať, najprv obnovte stránku.',
    'Previous suggestion': 'Predchádzajúci návrh',
    Download: 'Stiahnuť',
    CSV: 'CSV',
    'Evidence for {value1}': 'Dôkaz pre {value1}',
    Measure: 'Metrika',
    'Show rows →': 'Zobraziť riadky →',
    'Ask about this number': 'Opýtať sa na toto číslo',
    'There are no numeric values available to chart. View the table for the original data.':
      'Na vytvorenie grafu nie sú k dispozícii žiadne číselné hodnoty. Pôvodné údaje zobrazíte v tabuľke.',
    'Chart value': 'Hodnota v grafe',
    '{value1} of {value2} shown': 'Zobrazené: {value1} z {value2}',
    '{value1} by {value2}; {value3} rows. View Table for exact values.':
      '{value1} podľa {value2}; {value3} riadkov. Presné hodnoty zobrazíte v tabuľke.',
    'Values come directly from the source data. Missing values are not estimates.':
      'Hodnoty pochádzajú priamo zo zdrojových údajov. Chýbajúce hodnoty nie sú odhady.',
    'Loading library…': 'Načítava sa knižnica…',
    'We couldn’t load what happened in this App. Try again in a moment.':
      'Nepodarilo sa načítať, čo sa v tejto aplikácii stalo. Skúste to znova o chvíľu.',
    'This App could not be opened.': 'Túto aplikáciu sa nepodarilo otvoriť.',
    'Opening App…': 'Otvára sa aplikácia…',
    'Open the saved App to run this function.':
      'Ak chcete spustiť túto funkciu, otvorte uloženú aplikáciu.',
    'Save this App before running its function.': 'Pred spustením funkcie túto aplikáciu uložte.',
    'Open saved App': 'Otvoriť uloženú aplikáciu',
    'Open Apps': 'Otvoriť aplikácie',
    'The App could not be opened. Try again.': 'Aplikáciu sa nepodarilo otvoriť. Skúste to znova.',
    Owner: 'Vlastník',
    '{value1} · admins': '{value1} · správcovia',
    'Owner · always edits': 'Vlastník · vždy môže upravovať',
    'Admins manage it': 'Spravujú ju správcovia',
    Editors: 'Redaktori',
    'A colleague': 'Kolega',
    'Can edit drafts and publish versions': 'Môže upravovať koncepty a publikovať verzie',
    Remove: 'Odstrániť',
    'No editors yet.': 'Zatiaľ žiadni redaktori.',
    'Admins can always edit company agents.': 'Správcovia môžu vždy upravovať firemných agentov.',
    'Asking for edit access': 'Žiadosť o prístup na úpravy',
    'Asked {value1} · also in your Inbox': 'Požiadané {value1} · aj vo vašej doručenej pošte',
    Grant: 'Udeliť',
    Admin: 'Správca',
    'Make personal': 'Nastaviť ako osobné',
    'Switch off': 'Vypnúť',
    Archive: 'Archivovať',
    'Archive this agent': 'Archivovať tohto agenta',
    'Loading agent…': 'Načítava sa agent…',
    '{value1} Edit in chat': '{value1} Upraviť v chate',
    Agent: 'Agent',
    'This agent has not been created yet. It can run once its owner creates it.':
      'Tento agent ešte nebol vytvorený. Spustiť ho možno po jeho vytvorení vlastníkom.',
    'New agent · Draft': 'Nový agent · Koncept',
    'Untitled agent': 'Agent bez názvu',
    'Test run': 'Testovacie spustenie',
    'This draft does not run automatically.': 'Tento koncept sa nespúšťa automaticky.',
    'Describe the agent in the chat. Its draft appears here.':
      'Opíšte agenta v chate. Jeho koncept sa zobrazí tu.',
    '{value1} Test run': '{value1} Testovacie spustenie',
    'Describe the agent in the chat first.': 'Najprv opíšte agenta v chate.',
    'Create and turn on': 'Vytvoriť a zapnúť',
    'Connection write setup': 'Nastavenie zápisu pripojenia',
    'Account for connected changes': 'Účet pre zmeny v pripojených službách',
    'Choose a connection': 'Vyberte pripojenie',
    'No published Skills available. You can add them later.':
      'Nie sú k dispozícii žiadne publikované zručnosti. Môžete ich pridať neskôr.',
    '{value1} · not published. Review the changes. Testing is optional.':
      '{value1} · nepublikované. Skontrolujte zmeny. Testovanie je voliteľné.',
    '{value1} Test draft': '{value1} Testovať koncept',
    'Apply changes…': 'Použiť zmeny…',
    'Apply this draft as a new version': 'Použiť tento koncept ako novú verziu',
    'This draft cannot be applied.': 'Tento koncept nemožno použiť.',
    'What changed?': 'Čo sa zmenilo?',
    'Apply version {value1}': 'Použiť verziu {value1}',
    Create: 'Vytvoriť',
    'Edit access requested': 'Požiadané o povolenie na úpravy',
    '{value1} Request edit access': '{value1} Požiadať o povolenie na úpravy',
    '{value1} Copy agent': '{value1} Kopírovať agenta',
    Pause: 'Pozastaviť',
    'Open agent: {value1}': 'Otvoriť agenta: {value1}',
    '· you can edit': '· môžete upravovať',
    '{value1} is switched off.': '{value1} je vypnutý.',
    '{value1} is archived.': '{value1} je archivovaný.',
    'Loading agents…': 'Načítavajú sa agenti…',
    Agents: 'Agenti',
    'Agents do work for you on a schedule or when you ask. They follow your company’s Skills.':
      'Agenti za vás pracujú podľa plánu alebo na požiadanie. Riadia sa zručnosťami vašej spoločnosti.',
    'No agent matches. Try a Skill name or what the agent should do.':
      'Nenašiel sa žiadny zodpovedajúci agent. Skúste názov zručnosti alebo opíšte, čo má agent robiť.',
    'Nothing of your own yet': 'Zatiaľ nemáte nič vlastné',
    'Tell Chat what an agent should do, or copy one of the company’s agents below.{value1}':
      'Povedzte chatu, čo má agent robiť, alebo skopírujte niektorého z firemných agentov nižšie.{value1}',
    'Your agents': 'Vaši agenti',
    'Run on demand': 'Spustiť na požiadanie',
    'Run is always available. A schedule is optional and lives separately from the agent’s instructions.':
      'Spustenie je vždy k dispozícii. Plán je voliteľný a existuje oddelene od pokynov pre agenta.',
    'What changed in version {value1}': 'Čo sa zmenilo vo verzii {value1}',
    'Every publish is a version you can restore.':
      'Každé zverejnenie je verzia, ktorú môžete obnoviť.',
    Authorization: 'Autorizácia',
    '{value1} {value2} · {value3} will see it.': '{value1} {value2} · uvidia to {value3}.',
    '{value1} {value2} you': '{value1} {value2} vám',
    '· Revised': '· Upravené',
    'This chat used your {value1}.': 'Tento chat použil váš {value1}.',
    'This chat has results from {value1}.': 'Tento chat obsahuje výsledky z {value1}.',
    'db.example.com': 'db.example.com',
    'e.g. Product analytics': 'napr. Analýza produktov',
    'Paste access key': 'Vložte prístupový kľúč',
    'Shopify’s Dev Dashboard': 'Vývojársky panel Shopify',
    'App reference': 'Referencia aplikácie',
    'Draft · revision {value1}': 'Koncept · revízia {value1}',
    'its Result': 'jeho výsledok',
    '· its first run makes it': '· jeho prvé spustenie ho',
    '{value1}’s chat ·': 'Chat používateľa {value1} ·',
    '{value1} ad {value2} available.': '{value1} a {value2} sú k dispozícii.',
    '{value1} rows ·': '{value1} riadkov ·',
    'It starts private. Sharing it wider shares every refresh, which can carry your private data.':
      'Na začiatku je súkromné. Jeho širšie zdieľanie sprístupní každé obnovenie, ktoré môže obsahovať vaše súkromné údaje.',
    'Enable this schedule when approved': 'Povoliť tento harmonogram po schválení',
    Schedule: 'Harmonogram',
    'Kept off until you create the agent from its canvas.':
      'Zostane vypnutý, kým nevytvoríte agenta z jeho plátna.',
    'Will be enabled when you approve.': 'Povolí sa po vašom schválení.',
    'Will be saved paused. You can enable it later.':
      'Uloží sa pozastavený. Neskôr ho môžete povoliť.',
    'Only runs when you ask.': 'Spustí sa iba na požiadanie.',
    'Draft · approving saves it, and nothing runs. Test it and create it from its canvas.':
      'Koncept · schválením ho uložíte a nič sa nespustí. Otestujte ho a vytvorte z jeho plátna.',
    'Draft · nothing is scheduled until you approve. Connected actions require their own approval at run time.':
      'Koncept · kým ho neschválite, nič nebude naplánované. Pripojené akcie si pri spustení vyžadujú vlastné schválenie.',
    Name: 'Názov',
    'Agent name': 'Názov agenta',
    'Who can use it': 'Kto ho môže používať',
    'Company agent · company resources only': 'Firemný agent · iba firemné zdroje',
    'Personal agent · runs with your access': 'Osobný agent · spúšťa sa s vaším prístupom',
    'Approving saves it as a draft. It does not run automatically.':
      'Schválením ho uložíte ako koncept. Nespustí sa automaticky.',
    'Open the agent’s runs': 'Otvoriť spustenia agenta',
    'Run the published version once': 'Spustiť publikovanú verziu raz',
    'Stopping…': 'Zastavuje sa…',
    'Stop run': 'Zastaviť spustenie',
    'Could not stop this run. Please try again.':
      'Toto spustenie sa nepodarilo zastaviť. Skúste to znova.',
    'Run in progress': 'Spustenie prebieha',
    'This run is still answering. You can ask follow-ups when it finishes.':
      'Toto spustenie stále odpovedá. Po jeho dokončení môžete položiť doplňujúce otázky.',
    'Open run details': 'Otvoriť podrobnosti spustenia',
    Runs: 'Spustenia',
    'Open the run chat': 'Otvoriť chat spustenia',
    Watch: 'Sledovať',
    Goal: 'Cieľ',
    'Change the goal': 'Zmeniť cieľ',
    'What it does': 'Čo robí',
    'What should this agent achieve?': 'Čo má tento agent dosiahnuť?',
    'Not set yet.': 'Zatiaľ nenastavené.',
    'When it runs': 'Kedy sa spúšťa',
    'Change when it runs': 'Zmeniť čas spúšťania',
    'Off means it runs only when someone runs it. Changing when it runs never changes its instructions.':
      'Vypnuté znamená, že sa spustí iba vtedy, keď ho niekto spustí. Zmena času spúšťania nikdy nemení jeho pokyny.',
    Instructions: 'Pokyny',
    'Change the instructions': 'Zmeniť pokyny',
    'How the agent should approach the work and make decisions.':
      'Ako má agent pristupovať k práci a rozhodovať sa.',
    Boundaries: 'Hranice',
    'What to do or avoid. Every connected action still follows its approval.':
      'Čo má robiť alebo čomu sa má vyhýbať. Každá pripojená akcia sa naďalej riadi vlastným schválením.',
    'No instructions of its own. It follows its Skills.':
      'Nemá vlastné pokyny. Riadi sa svojimi zručnosťami.',
    'Pin a Skill': 'Pripnúť zručnosť',
    'Finds the Skills that fit each run, the same way a chat does.':
      'Pre každé spustenie nájde vhodné zručnosti rovnakým spôsobom ako chat.',
    'Skills it always follows': 'Zručnosti, ktorými sa vždy riadi',
    'A Skill that is not published': 'Zručnosť, ktorá nie je publikovaná',
    'Always follows · Version {value1}': 'Vždy sa riadi · Verzia {value1}',
    'Not published': 'Nepublikované',
    Uses: 'Používa',
    'Change in chat': 'Zmeniť v chate',
    'Change in chat: Uses': 'Zmeniť v chate: Používa',
    'Company knowledge and the tools each run is allowed to use.':
      'Firemné znalosti a nástroje, ktoré môže každé spustenie používať.',
    'People see the Result refresh; they change the agent, not the page.':
      'Ľudia uvidia aktualizáciu Výsledku; zmenia agenta, nie stránku.',
    'The first run after it is created makes the Result; later runs add a version to it.':
      'Prvé spustenie po vytvorení vytvorí Výsledok; neskoršie spustenia doň pridajú verziu.',
    'Emails whoever the run is for': 'Pošle e-mail osobe, pre ktorú je spustenie určené',
    'Email each run': 'Poslať e-mail pri každom spustení',
    Delivers: 'Dodáva',
    'Change what it delivers': 'Zmeniť, čo dodáva',
    'Expected result': 'Očakávaný výsledok',
    'What a successful run should deliver.': 'Čo má úspešné spustenie dodať.',
    'What each run delivers': 'Čo dodáva každé spustenie',
    'Keeps one Result up to date {value1}': 'Udržiava jeden Výsledok aktuálny {value1}',
    'Saves a new Result each run': 'Pri každom spustení uloží nový Výsledok',
    'You can run this company agent as yourself.{value1} {value2}':
      'Tohto firemného agenta môžete spustiť ako vy.{value1} {value2}',
    'Changes since version': 'Zmeny od verzie',
    'are not live yet.': 'ešte nie sú aktívne.',
    'Review them in Versions': 'Skontrolovať ich vo Verziách',
    Skill: 'Zručnosť',
    'The agent always uses the Skill’s published version.':
      'Agent vždy používa publikovanú verziu zručnosti.',
    Day: 'Deň',
    Time: 'Čas',
    'Cron expression': 'Výraz Cron',
    'Editors and access': 'Editori a prístup',
    Company: 'Firemné',
    Personal: 'Osobné',
    'No changes.': 'Žiadne zmeny.',
    'Instructions changes': 'Zmeny pokynov',
    'Loading versions…': 'Načítavajú sa verzie…',
    'What the draft changes': 'Čo mení koncept',
    'No published version yet. Try the draft, then publish it.':
      'Zatiaľ nemá publikovanú verziu. Vyskúšajte koncept a potom ho publikujte.',
    'Published versions': 'Publikované verzie',
    'Former member': 'Bývalý člen',
    Live: 'Aktívne',
    '{value1} for {value2}': '{value1} pre {value2}',
    Suggested: 'Navrhované',
    'Opening your conversation…': 'Otváranie vašej konverzácie…',
    'This conversation isn’t available': 'Táto konverzácia nie je dostupná',
    'It may have been deleted, belong to another account, or be temporarily unavailable.':
      'Možno bola odstránená, patrí inému účtu alebo je dočasne nedostupná.',
    '{count} more line — shown in the complete revision':
      '{count} ďalší riadok — zobrazený v kompletnej revízii',
    '{count} more lines — shown in the complete revision':
      '{count} ďalšie riadky — zobrazené v kompletnej revízii',
    '{count} more line removed': 'Odstránený {count} ďalší riadok',
    '{count} more lines removed': 'Odstránených {count} ďalších riadkov',
    '{count} unchanged line': '{count} nezmenený riadok',
    '{count} unchanged lines': '{count} nezmenené riadky',
    '{count} more lines not shown, {added} added and {removed} removed. Check them in the complete revision.':
      'Ďalších {count} riadkov nie je zobrazených, {added} pridaných a {removed} odstránených. Skontrolujte ich v kompletnej revízii.',
    'Saved result': 'Uložený výsledok',
    'Made with a Skill': 'Vytvorené pomocou zručnosti',
    'Preview of {name}': 'Ukážka {name}',
    'Made with {name}': 'Vytvorené pomocou {name}',
    'Ad-hoc result': 'Výsledok ad hoc',
    'A Skill that is not available in this workspace':
      'Zručnosť, ktorá nie je dostupná v tomto pracovnom priestore',
    '{name} · Revision {version}': '{name} · Revízia {version}',
    '{name} · Version {version}': '{name} · Verzia {version}',
    'Return to conversation {value1}': 'Späť do konverzácie {value1}',
    '{value1} Working with {value2}': '{value1} pracuje s {value2}',
    'View context {value1}': 'Zobraziť kontext {value1}',
    'A way of working, made yours.': 'Spôsob práce prispôsobený vám.',
    'Work that runs itself.': 'Práca, ktorá sa vykonáva sama.',
    'One place for one piece of work.': 'Jedno miesto pre jednu pracovnú úlohu.',
    'Let’s move your work forward{value1}.': 'Posuňme vašu prácu vpred{value1}.',
    'Describe the work. Your Skill takes shape beside the conversation.':
      'Opíšte prácu. Vaša zručnosť sa vytvorí vedľa konverzácie.',
    'Describe what it should do and when. Your agent takes shape beside the conversation. The draft does not run automatically.':
      'Opíšte, čo má robiť a kedy. Váš agent sa vytvorí vedľa konverzácie. Koncept sa nespustí automaticky.',
    'Say what the work is. Poneva drafts the project beside the conversation and brings in what you have already done. Nothing is created until you say so.':
      'Povedzte, o akú prácu ide. Poneva pripraví návrh projektu vedľa konverzácie a pridá to, čo ste už urobili. Nič sa nevytvorí, kým to nepotvrdíte.',
    'Start with an idea below. Poneva will take it from there.':
      'Začnite nápadom nižšie. Poneva sa postará o zvyšok.',
    Triggers: 'Spúšťače',
    'Review the agent and its trigger. Approval applies exactly what is shown.':
      'Skontrolujte agenta a jeho spúšťač. Schválenie použije presne to, čo je zobrazené.',
    '{source} · read {date}': '{source} · prečítané {date}',
    'Evidence is being recorded · read {date}': 'Dôkaz sa zaznamenáva · prečítané {date}',
    'Evidence expired on {date} under the retention policy':
      'Platnosť dôkazu skončila {date} podľa pravidiel uchovávania',
    'Entered by {person}': 'Zadal(a) {person}',
    'No retained evidence for this value': 'Pre túto hodnotu nie je k dispozícii uchovaný dôkaz',
    'Covers {shown} of {total} rows': 'Pokrýva {shown} z {total} riadkov',
    'Search rows': 'Hľadať v riadkoch',
    'Clear filters': 'Vymazať filtre',
    Sort: 'Zoradiť',
    'Sort: {column}': 'Zoradiť: {column}',
    '{shown} of {total} rows': '{shown} z {total} riadkov',
    More: 'Viac',
    Density: 'Hustota',
    Comfortable: 'Pohodlné',
    Compact: 'Kompaktné',
    Columns: 'Stĺpce',
    'No rows match. Clear the search or filters to see them again.':
      'Žiadne riadky sa nezhodujú. Vymažte vyhľadávanie alebo filtre a znova ich zobrazte.',
    'Not available': 'Nedostupné',
    'All rows': 'Všetky riadky',
    'Close row detail': 'Zavrieť podrobnosti riadka',
    'Ask about this row': 'Opýtať sa na tento riadok',
    'Add note': 'Pridať poznámku',
    Note: 'Poznámka',
    Saved: 'Uložené',
    Total: 'Celkom',
    ascending: 'vzostupne',
    descending: 'zostupne',
    'Scroll to see all columns': 'Posuňte sa, aby ste videli všetky stĺpce',
    App: 'Aplikácia',
    Artifact: 'Artefakt',
    'New project': 'Nový projekt',
    'Review request': 'Žiadosť o kontrolu',
    Activity: 'Aktivita',
    'Voice preview': 'Ukážka hlasu',
    Source: 'Zdroj',
    File: 'Súbor',
    Meeting: 'Stretnutie',
    'Knowledge page': 'Stránka znalostí',
    'Could not preview this CSV.': 'Náhľad tohto CSV sa nepodarilo zobraziť.',
    'File content is unavailable.': 'Obsah súboru nie je k dispozícii.',
    'You have five open suggestions here. {value1} will see them.':
      'Máte tu päť otvorených návrhov. Uvidí ich {value1}.',
    'We could not send your suggestion. Please try again.':
      'Návrh sa nepodarilo odoslať. Skúste to znova.',
    'The agent': 'Agent',
    'Selected colleagues': 'Vybraní kolegovia',
    'The owner': 'Vlastník',
    'Forked. This copy is yours and runs with your own connections.':
      'Vytvorená kópia. Táto kópia je vaša a funguje s vašimi vlastnými pripojeniami.',
    'This chat is too long to fork.': 'Tento chat je príliš dlhý na vytvorenie kópie.',
    'We could not fork this chat. Please try again.':
      'Kópiu tohto chatu sa nepodarilo vytvoriť. Skúste to znova.',
    'Anyone who forked it keeps their copy: forks stay with the people who made them.':
      'Každý, kto vytvoril kópiu, si ju ponechá: kópie zostávajú ľuďom, ktorí ich vytvorili.',
    'Nobody has forked this chat.': 'Nikto nevytvoril kópiu tohto chatu.',
    '1 person forked this chat. Their copy stays theirs.':
      '1 osoba vytvorila kópiu tohto chatu. Táto kópia zostáva jej.',
    '{value1} people forked this chat. Their copies stay theirs.':
      'Kópiu tohto chatu vytvorilo {value1} ľudí. Ich kópie zostávajú im.',
    'Personal. Nobody else sees it.': 'Osobné. Nikto iný to neuvidí.',
    'People you pick. They get it in their Inbox.':
      'Ľudia, ktorých vyberiete. Dostanú to do doručenej pošty.',
    'Everyone in the company can follow it and fork it.':
      'Všetci v spoločnosti to môžu sledovať a vytvoriť si kópiu.',
    'a chat you can no longer open': 'chat, ktorý už nemôžete otvoriť',
    'shared the Result': 'zdieľal výsledok',
    'updated the Result': 'aktualizoval výsledok',
    'published the Skill': 'zverejnil zručnosť',
    'approved the fact': 'schválil fakt',
    'added the fact': 'pridal fakt',
    'added the meeting': 'pridal stretnutie',
    'published the page': 'zverejnil stránku',
    'updated the page': 'aktualizoval stránku',
    'shared the chat': 'zdieľal chat',
    'published a version of': 'zverejnil verziu',
    ran: 'spustil',
    Knowledge: 'Znalosti',
    Meetings: 'Stretnutia',
    Chat: 'Chat',
    Use: 'Použiť',
    Open: 'Otvoriť',
    You: 'Vy',
    Someone: 'Niekto',
    'published version {version} of': 'zverejnil verziu {version}',
    'thing needs': 'položka potrebuje',
    'things need': 'položky potrebujú',
    'Published Skill': 'Zverejnená zručnosť',
    'Included with Skill': 'Súčasť zručnosti',
    'Already attached': 'Už pripojené',
    'Also available in company knowledge': 'Dostupné aj v znalostiach spoločnosti',
    'Company file': 'Firemný súbor',
    'Account identity unavailable': 'Identita účtu nie je k dispozícii',
    'Access expired or was revoked. Reconnect to continue.':
      'Platnosť prístupu vypršala alebo bol odvolaný. Ak chcete pokračovať, znova sa pripojte.',
    'Account authorized · tools unavailable': 'Účet autorizovaný · nástroje nie sú k dispozícii',
    'Not available in this workspace yet.':
      'V tomto pracovnom priestore zatiaľ nie je k dispozícii.',
    'Everyone in the company': 'Všetci v spoločnosti',
    'Audience: only you.': 'Publikum: iba vy.',
    'Audience: everyone in the company.': 'Publikum: všetci v spoločnosti.',
    'tool is': 'nástroj je',
    'tools are': 'nástroje sú',
    'account is': 'účet je',
    'accounts are': 'účty sú',
    'We could not upload this file.': 'Tento súbor sa nepodarilo nahrať.',
    'file was': 'súbor bol',
    'files were': 'súbory boli',
    'Your company': 'Vaša spoločnosť',
    'Create an agent': 'Vytvoriť agenta',
    'Give recurring work a helping hand': 'Uľahčite si opakovanú prácu',
    'Create a Skill': 'Vytvoriť zručnosť',
    'Save a reusable way of working': 'Uložte si opakovateľný spôsob práce',
    'Take meeting notes': 'Robiť poznámky zo stretnutia',
    'Capture decisions and next steps': 'Zachytiť rozhodnutia a ďalšie kroky',
    'Work with a file': 'Pracovať so súborom',
    'Start from a document or image': 'Začať dokumentom alebo obrázkom',
    'Browse agents': 'Prehľadávať agentov',
    'Open your agents and company agents': 'Otvoriť svojich agentov a firemných agentov',
    'Review results': 'Skontrolovať výsledky',
    'Return to work saved in your Library': 'Vrátiť sa k práci uloženej v knižnici',
    'For review': 'Na kontrolu',
    'An agent': 'Agent',
    Assistant: 'Asistent',
    'Kept up to date by {value1}{value2}': 'Aktualizuje ho {value1}{value2}',
    ', {value1}': ', {value1}',
    'Version {value1}{value2}{value3}': 'Verzia {value1}{value2}{value3}',
    'Refreshed by its agent': 'Aktualizované jeho agentom',
    'Saved from a chat': 'Uložené z chatu',
    'Saved from {value1}': 'Uložené z aplikácie {value1}',
    Edited: 'Upravené',
    'private account': 'súkromný účet',
    '{value1} ({value2})': '{value1} ({value2})',
    '{value1}’s {value2}': '{value2} používateľa {value1}',
    'Made private. The person who added it and the owner of its recording have been told in their Inbox.':
      'Nastavené ako súkromné. Osoba, ktorá ho pridala, a vlastník jeho záznamu boli o tom informovaní v doručenej pošte.',
    'Made private. The person who added it has been told in their Inbox.':
      'Nastavené ako súkromné. Osoba, ktorá ho pridala, bola o tom informovaná v doručenej pošte.',
    'Made private. The owner of its recording has been told in their Inbox.':
      'Nastavené ako súkromné. Vlastník jeho záznamu bol o tom informovaný v doručenej pošte.',
    'Selected passage': 'Vybraná pasáž',
    '{value1} {value2}': '{value1} {value2}',
    'Upload a file': 'Nahrať súbor',
    'Help me create a useful report from our company knowledge and available sources.':
      'Pomôžte mi vytvoriť užitočnú správu z firemných znalostí a dostupných zdrojov.',
    'This saved work couldn’t be opened. Open it again to retry.':
      'Túto uloženú prácu sa nepodarilo otvoriť. Otvorte ju znova a skúste to znova.',
    '{value1}’s': 'používateľa {value1}',
    '{value1} chat “{value2}”': 'Chat používateľa {value1} „{value2}“',
    '{value1}{value2}': '{value1}{value2}',
    'Skill: {value1}{value2}': 'Zručnosť: {value1}{value2}',
    'Result “{value1}”': 'Výsledok „{value1}“',
    'Meeting “{value1}”': 'Stretnutie „{value1}“',
    'Used in {value1} {value2} this week': 'Tento týždeň použité v {value1} {value2}',
    '{value1} {value2} · used in {value3} {value4}':
      '{value1} {value2} · použité v {value3} {value4}',
    'The draft is not published yet, so no one else follows it.':
      'Koncept ešte nie je zverejnený, takže ho nikto ďalší nesleduje.',
    'Use it in a chat for current data, or refine the Skill first.':
      'Použite ho v chate s aktuálnymi údajmi alebo najprv vylepšite zručnosť.',
    'An agent keeps this up to date. Continue the work in chat.':
      'Agent to udržiava aktuálne. Pokračujte v práci v chate.',
    'Edit it here, or continue the work in chat.':
      'Upravte ho tu alebo pokračujte v práci v chate.',
    'Duplicate it to your Library, or continue the work in chat.':
      'Vytvorte jeho kópiu v knižnici alebo pokračujte v práci v chate.',
    'Download Markdown': 'Stiahnuť Markdown',
    'Download CSV': 'Stiahnuť CSV',
    'an agent': 'agent',
    'Publish a Skill version': 'Zverejniť verziu zručnosti',
    'Share with {value1}': 'Zdieľať s {value1}',
    'Update company content': 'Aktualizovať firemný obsah',
    Approved: 'Schválené',
    Declined: 'Zamietnuté',
    Pending: 'Čaká na spracovanie',
    'View decision': 'Zobraziť rozhodnutie',
    'No data': 'Žiadne údaje',
    'No change': 'Žiadna zmena',
    'Connection created': 'Pripojenie vytvorené',
    'Sharing changed': 'Zdieľanie zmenené',
    'Person added': 'Osoba pridaná',
    'Person removed': 'Osoba odstránená',
    'Access changed': 'Prístup zmenený',
    'Access turned off': 'Prístup vypnutý',
    'Connection removed': 'Pripojenie odstránené',
    'Query time limit changed': 'Časový limit dopytu zmenený',
    '{count} row': '{count} riadok',
    '{count} rows': '{count} riadkov',
    'This source is no longer available. Company knowledge now lives in Knowledge pages, and files stay in the Library.':
      'Tento zdroj už nie je k dispozícii. Firemné znalosti sa teraz nachádzajú na stránkach znalostí a súbory zostávajú v knižnici.',
    '· {value1} by {value2}': '· {value1} od {value2}',
    '· version {value1}': '· verzia {value1}',
    '{message} {count} earlier file was saved and attached.':
      '{message} {count} predchádzajúci súbor bol uložený a priložený.',
    '{message} {count} earlier files were saved and attached.':
      '{message} {count} predchádzajúce súbory boli uložené a priložené.',
    '{message} {count} earlier file was saved.':
      '{message} {count} predchádzajúci súbor bol uložený.',
    '{message} {count} earlier files were saved.':
      '{message} {count} predchádzajúce súbory boli uložené.',
    'refreshed {time}': 'obnovené {time}',
    'a colleague': 'kolega',
    'Your chat “{title}”': 'Váš chat „{title}“',
    '{name}’s chat “{title}”': 'Chat používateľa {name} „{title}“',
    'Kept up to date by {name}{version}': 'Udržiava {name}{version}',
    'Skill: {name}{version}': 'Zručnosť: {name}{version}',
    'Result “{title}”': 'Výsledok „{title}“',
    'Meeting “{title}”': 'Stretnutie „{title}“',
    'Used in {count} answer this week': 'Použité v {count} odpovedi tento týždeň',
    'Used in {count} answers this week': 'Použité v {count} odpovediach tento týždeň',
    '{count} source': '{count} zdroj',
    '{count} sources': '{count} zdroje',
    'used in {count} place': 'použité na {count} mieste',
    'used in {count} places': 'použité na {count} miestach',
    '{company} workspace': '{company} pracovný priestor',
    '{count} page': '{count} strana',
    '{count} pages': '{count} strán',
    '{needs} · reviews and approvals': '{needs} · kontroly a schválenia',
    '{count} thing needs you': '{count} položka vyžaduje vašu pozornosť',
    '{count} things need you': '{count} položky vyžadujú vašu pozornosť',
    'Included with Skill · {files} · {sources} {icon}':
      'Súčasť zručnosti · {files} · {sources} {icon}',
    '{count} file': '{count} súbor',
    '{count} files': '{count} súborov',
    Today: 'Dnes',
    'Earlier this week': 'Skôr tento týždeň',
    '{count} slide': '{count} snímka',
    '{count} slides': '{count} snímok',
    Early: 'Skoro',
    'TLS verified': 'TLS overené',
    'Made personal and switched off. Switch it on when you are ready.':
      'Nastavené ako osobné a vypnuté. Zapnite ho, keď budete pripravení.',
    'Made personal and switched off. Its owner is told which version is live.':
      'Nastavené ako osobné a vypnuté. Jeho vlastník je informovaný, ktorá verzia je aktívna.',
    'Switched off.': 'Vypnuté.',
    'Applied version {revision}.': 'Použitá verzia {revision}.',
    'The draft is running in a chat only you can read.':
      'Koncept beží v chate, ktorý môžete čítať iba vy.',
    'Publish a version first.': 'Najprv zverejnite verziu.',
    'Another Agent action is in progress.': 'Prebieha iná akcia agenta.',
    'Knowledge & connections': 'Znalosti a pripojenia',
    'Pinned Skills': 'Pripnuté zručnosti',
    None: 'Žiadne',
    'A new Result each run': 'Nový výsledok pri každom spustení',
    'One Result kept up to date': 'Jeden výsledok udržiavaný v aktuálnom stave',
    Email: 'E-mail',
    On: 'Zapnuté',
    Off: 'Vypnuté',
    'Waiting for review': 'Čaká na kontrolu',
    Outdated: 'Zastarané',
    Accepted: 'Prijaté',
    Rejected: 'Odmietnuté',
    Withdrawn: 'Stiahnuté',
    Replaced: 'Nahradené',
    'Suggested edit': 'Navrhovaná úprava',
    'Suggested new page': 'Navrhovaná nová stránka',
    'Suggested move': 'Navrhované presunutie',
    'Suggested archive': 'Navrhovaná archivácia',
    'Checking status…': 'Kontroluje sa stav…',
    'Status unavailable': 'Stav nie je k dispozícii',
    'Bulleted list': 'Zoznam s odrážkami',
    'Numbered list': 'Číslovaný zoznam',
    'Web link': 'Webový odkaz',
    Read: 'Čítať',
    Write: 'Zapisovať',
    'shared with you': 'zdieľané s vami',
    'Getting an answer': 'Získava odpoveď',
    '{name} is getting an answer': '{name} získava odpoveď',
    'We could not save. Please try again.': 'Nepodarilo sa uložiť. Skúste to znova.',
    'The new page could not be created.': 'Novú stránku sa nepodarilo vytvoriť.',
    'We could not load this revision.': 'Túto revíziu sa nepodarilo načítať.',
    'We could not restore this revision. Please try again.':
      'Túto revíziu sa nepodarilo obnoviť. Skúste to znova.',
    'We could not export this revision.': 'Túto revíziu sa nepodarilo exportovať.',
    'We could not open this suggestion.': 'Tento návrh sa nepodarilo otvoriť.',
    'We could not do that. Please try again.': 'Túto akciu sa nepodarilo vykonať. Skúste to znova.',
    'We could not save your decision. Please try again.':
      'Vaše rozhodnutie sa nepodarilo uložiť. Skúste to znova.',
    'We could not restore this page. Please try again.':
      'Túto stránku sa nepodarilo obnoviť. Skúste to znova.',
    'We could not export this page.': 'Túto stránku sa nepodarilo exportovať.',
    '{count} missed time merged.': '{count} vynechaný čas bol zlúčený.',
    '{count} missed times merged.': '{count} vynechaných časov bolo zlúčených.',
    'About this project': 'O tomto projekte',
  },
  sl: {
    'We could not load this item.': 'Tega elementa ni bilo mogoče naložiti.',
    '{value1} canvas': '{value1} platno',
    'Loading {value1}…': 'Nalaganje: {value1} …',
    '{value1} · Original retained': '{value1} · Izvirnik ohranjen',
    '{value1} {value2}{value3} · Added {value4}': '{value1} {value2}{value3} · Dodano {value4}',
    '{value1} Use in chat': '{value1} Uporabi v klepetu',
    '{value1} Download': '{value1} Prenesi',
    Table: 'Tabela',
    Chart: 'Graf',
    Original: 'Izvirnik',
    'Text extracted from the PDF, marked by page. Download the original for its layout and images.':
      'Besedilo, izvlečeno iz PDF-ja in označeno po straneh. Prenesite izvirnik, da ohranite njegovo postavitev in slike.',
    'This preview shows the beginning of the file. Poneva reads the whole file; download the original to see all of it.':
      'Ta predogled prikazuje začetek datoteke. Poneva prebere celotno datoteko; prenesite izvirnik, da si ogledate vsebino v celoti.',
    'Preview of the first {value1} complete rows. Filtering and charts use only this preview. Download the original for the full file.':
      'Predogled prvih {value1} celotnih vrstic. Filtriranje in grafikoni uporabljajo samo ta predogled. Za celotno datoteko prenesite izvirnik.',
    'This source link cannot be opened.': 'Te povezave do vira ni mogoče odpreti.',
    'Read-only chat': 'Klepet samo za branje',
    'Only {value1} writes in this chat. Fork it to continue with your own connections. {value2}':
      'V tem klepetu lahko piše samo {value1}. Razvejite ga, da nadaljujete z lastnimi povezavami. {value2}',
    'Suggest a follow-up…': 'Predlagaj nadaljevanje …',
    'Suggest a follow-up': 'Predlagaj nadaljevanje',
    'Sending…': 'Pošiljanje …',
    Send: 'Pošlji',
    'We could not dismiss that suggestion. Please try again.':
      'Tega predloga ni bilo mogoče opustiti. Poskusite znova.',
    'Suggested follow-ups': 'Predlagana nadaljevanja',
    '{value1} suggests': '{value1} predlaga',
    Ask: 'Vprašaj',
    'Dismiss {value1}’s suggestion': 'Opusti predlog uporabnika {value1}',
    'Suggested by': 'Predlagal/-a',
    '· edit it or send it': '· uredite ali pošljite',
    'Remove the suggestion tag': 'Odstrani oznako predloga',
    '{value1} {value2} is getting an answer': '{value1} {value2} dobiva odgovor',
    '{value1} {value2} stopped the answer': '{value1} {value2} je ustavil/-a odgovor',
    '{value1} Fork from here': '{value1} Razveji od tu',
    '{value1} From {value2}’s {value3}': '{value1} Iz {value3} uporabnika {value2}',
    'Only {value1} can use this account': 'Ta račun lahko uporablja samo {value1}',
    '{value1} Suggested by {value2}': '{value1} Predlagal/-a {value2}',
    'Fork this chat': 'Razveji ta klepet',
    'Forking…': 'Razvejanje …',
    Fork: 'Razveji',
    'Could not make this private.': 'Zasebnosti ni bilo mogoče nastaviti.',
    'Make this chat private?': 'Želite ta klepet nastaviti kot zaseben?',
    Close: 'Zapri',
    '{value1} will see “{value2}”. Everyone else loses access right away {value3} .{value4}':
      '{value1} bo videl/-a »{value2}«. Vsi drugi bodo takoj izgubili dostop {value3} .{value4}',
    Cancel: 'Prekliči',
    'Saving…': 'Shranjevanje …',
    'Make private': 'Nastavi kot zasebno',
    'This chat is private again. Forks others made stay theirs.':
      'Ta klepet je znova zaseben. Razvejanja drugih ostanejo njihova.',
    'Who can read this chat: {value1}': 'Kdo lahko bere ta klepet: {value1}',
    'Move this chat': 'Premakni ta klepet',
    'Only you write here. Others follow live and fork.':
      'Tukaj lahko pišete samo vi. Drugi spremljajo v živo in razvejajo klepet.',
    'Made private. {value1} has been told in their Inbox.':
      'Nastavljeno kot zasebno. {value1} je bil/-a obveščen/-a v mapi Prejeto.',
    'Chat access': 'Dostop do klepeta',
    '{value1}’s chat. As an admin you can make it private.':
      'Klepet uporabnika {value1}. Kot skrbnik ga lahko nastavite kot zasebnega.',
    'Only {value1} will see it. {value2} is told.':
      'Videli ga bodo samo uporabniki: {value1}. {value2} je obveščen/-a.',
    '{value1} {value2} following': '{value1} {value2} spremlja',
    'Forked from{value1} {value2} . The history is copied. From here, tools run with your own access.':
      'Razvejano iz{value1} {value2} . Zgodovina je kopirana. Od tu naprej se orodja izvajajo z vašim dostopom.',
    '{value1} made this chat private': '{value1} je ta klepet nastavil/-a kot zaseben',
    'You can no longer open it. Any fork you made stays yours.':
      'Ne morete ga več odpreti. Vsako razvejanje, ki ste ga ustvarili, ostane vaše.',
    'Start a new chat': 'Začni nov klepet',
    'Back to Recent chats': 'Nazaj na nedavne klepete',
    'More chat actions': 'Več dejanj klepeta',
    'Close conversation sharing': 'Zapri skupno rabo pogovora',
    'Review the text before saving a private copy to Library. Then choose its audience. Your original conversation and future messages stay private.':
      'Pred shranjevanjem zasebne kopije v Knjižnico preglejte besedilo. Nato izberite njeno občinstvo. Vaš izvirni pogovor in prihodnja sporočila ostanejo zasebni.',
    'Preparing the conversation…': 'Priprava pogovora …',
    'Refresh preview': 'Osveži predogled',
    'The copy is saved in Library. Use Share to choose who can access it.':
      'Kopija je shranjena v Knjižnici. Z možnostjo Deli izberite, kdo lahko dostopa do nje.',
    'Save this copy': 'Shrani to kopijo',
    'That Skill could not be opened.': 'Te veščine ni bilo mogoče odpreti.',
    '{value1}{value2} · reviews and approvals': '{value1}{value2} · pregledi in odobritve',
    'Open Inbox': 'Odpri mapo Prejeto',
    'New at {value1} this week': 'Novo pri {value1} ta teden',
    'Nothing new this week. Shared work, published Skills and approved knowledge show up here.':
      'Ta teden ni nič novega. Tukaj so prikazani delo v skupni rabi, objavljene veščine in odobreno znanje.',
    'New at {value1}': 'Novo pri {value1}',
    'This Skill is unavailable. Try again.': 'Ta veščina ni na voljo. Poskusite znova.',
    'You can attach up to {value1} files. Remove an attachment to add another.':
      'Priložite lahko največ {value1} datotek. Odstranite prilogo, da dodate drugo.',
    'Add company context': 'Dodaj kontekst podjetja',
    'Add company context · @': 'Dodaj kontekst podjetja · @',
    'Choose a Skill': 'Izberite veščino',
    'Choose a Skill · /': 'Izberite veščino · /',
    context: 'kontekst',
    skills: 'veščine',
    'Choose company context': 'Izberite kontekst podjetja',
    'Skills for this conversation': 'Veščine za ta pogovor',
    'Bring context into the conversation': 'Dodajte kontekst v pogovor',
    'Close context picker': 'Zaprite izbirnik konteksta',
    'Filter company context': 'Filtrirajte kontekst podjetja',
    'Find a Skill…': 'Poiščite veščino …',
    'Find a file…': 'Poiščite datoteko …',
    'Available company context': 'Razpoložljivi kontekst podjetja',
    'No matching published Skills.': 'Ni ustreznih objavljenih veščin.',
    'No matching files.': 'Ni ustreznih datotek.',
    'Searching company work…': 'Iskanje po delu podjetja …',
    'Try search again': 'Poskusite znova iskati',
    'Meaning search is temporarily limited. Showing available text matches.':
      'Pomensko iskanje je začasno omejeno. Prikazani so razpoložljivi rezultati besedilnega iskanja.',
    'Load more matches': 'Naloži več rezultatov',
    '{value1} files attached. Remove an attachment to add another. Saved Skill references are included separately.':
      'Priloženih datotek: {value1}. Odstranite prilogo, da dodate drugo. Shranjene reference na veščine so vključene ločeno.',
    'Create a Skill in chat': 'Ustvari veščino v klepetu',
    'Upload a company file': 'Naloži datoteko podjetja',
    'Company knowledge is always available to Poneva.': 'Znanje podjetja je Ponevi vedno na voljo.',
    '{value1} was not connected': '{value1} ni bil povezan',
    Dismiss: 'Opusti',
    'Try connecting again': 'Poskusite znova vzpostaviti povezavo',
    Waiting: 'Čakanje',
    Connected: 'Povezano',
    'Needs reconnecting': 'Potrebna je ponovna vzpostavitev povezave',
    Connect: 'Poveži',
    '{value1}{value2} The provider’s account permissions still apply.':
      '{value1}{value2} Dovoljenja računa ponudnika še vedno veljajo.',
    'Last error: {value1}': 'Zadnja napaka: {value1}',
    '{value1} {value2} ready.': '{value1} {value2} je pripravljen.',
    'Continue with my Meta app': 'Nadaljuj z mojo aplikacijo Meta',
    Reconnect: 'Znova poveži',
    Disconnect: 'Prekini povezavo',
    'Remove attachment: {value1}': 'Odstrani prilogo: {value1}',
    'Saved in this Skill. Edit the Skill to change its references.':
      'Shranjeno v tej veščini. Uredite veščino, da spremenite njene reference.',
    'Remove Skill context': 'Odstrani kontekst veščine',
    Refining: 'Izpopolnjevanje',
    Previewing: 'Predogled',
    Using: 'Uporaba',
    'Skill revision {value1}': 'Različica veščine {value1}',
    'a new Skill': 'nova veščina',
    '{value1} Making a new agent {value2}': '{value1} Ustvarjanje novega agenta {value2}',
    'Stop making a new agent in this chat': 'Ustavi ustvarjanje novega agenta v tem klepetu',
    'Saved Skill references': 'Shranjene reference na veščine',
    'Included with Skill · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}':
      'Vključeno z veščino · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}',
    'Selected Skill revision is unavailable. Select the Skill again to view its saved references.':
      'Izbrana različica veščine ni na voljo. Znova izberite veščino, da si ogledate njene shranjene reference.',
    'Conversation attachments': 'Priloge pogovora',
    'Added for this conversation': 'Dodano za ta pogovor',
    'Selected passage {value1}': 'Izbrani odlomek {value1}',
    'We could not load your workspace.': 'Vašega delovnega prostora ni bilo mogoče naložiti.',
    'The selected Skill is unavailable. Check its access or choose it again.':
      'Izbrana veščina ni na voljo. Preverite dostop do nje ali jo znova izberite.',
    'Source saved privately and included in your knowledge search.':
      'Vir je zasebno shranjen in vključen v vaše iskanje po znanju.',
    'File saved privately to your library and attached to this message.':
      'Datoteka je zasebno shranjena v vaši knjižnici in priložena temu sporočilu.',
    'File saved privately to your library.': 'Datoteka je zasebno shranjena v vaši knjižnici.',
    '{value1} {value2} earlier {value3} saved{value4}.':
      '{value1} {value2} prej {value3} shranjeno{value4}.',
    'Extracted text for Poneva to read. Download the original for its layout, charts and images. Spreadsheet formulas show their saved results and are not recalculated.':
      'Izvlečeno besedilo, ki ga lahko Poneva prebere. Prenesite izvirnik za ogled postavitve, grafikonov in slik. Formule v preglednici prikazujejo shranjene rezultate in se ne preračunajo.',
    Esc: 'Esc',
    'Start something': 'Začnite nekaj',
    'Choose a file to work with': 'Izberite datoteko za delo',
    'Skills worth adding': 'Vredno je dodati te veščine',
    'Picked for you': 'Izbrano za vas',
    'Reusable work grounded in your company knowledge.':
      'Ponovno uporabno delo, ki temelji na znanju vašega podjetja.',
    'Ideas from your company context and recent work. Pick one to start.':
      'Ideje iz konteksta vašega podjetja in nedavnega dela. Izberite eno za začetek.',
    'Refresh suggested tasks': 'Osveži predlagana opravila',
    'Check for new company context.': 'Preverite, ali je na voljo nov kontekst podjetja.',
    'Check for new context. Ideas also refresh daily.':
      'Preverite, ali je na voljo nov kontekst. Ideje se osvežijo tudi vsak dan.',
    Refresh: 'Osveži',
    'Finding useful starting points…': 'Iskanje uporabnih izhodišč …',
    'Suggestions aren’t available right now. Try Refresh, or describe the work you want to do.':
      'Predlogi trenutno niso na voljo. Poskusite z možnostjo »Osveži« ali opišite delo, ki ga želite opraviti.',
    'Loading the knowledge pages…': 'Nalaganje strani z znanjem …',
    '{value1} All pages': '{value1} Vse strani',
    'The page is created.': 'Stran je ustvarjena.',
    'Your new page is suggested. A publisher decides whether it is added.':
      'Vaša nova stran je predlagana. Izdajatelj odloči, ali bo dodana.',
    'Company knowledge': 'Znanje podjetja',
    'What Poneva knows about your company, page by page. Every change is kept.':
      'Kaj Poneva ve o vašem podjetju, stran za stranjo. Vsaka sprememba se ohrani.',
    'Loading company knowledge…': 'Nalaganje znanja podjetja …',
    'Knowledge pages are not enabled in this workspace.':
      'Strani z znanjem v tem delovnem prostoru niso omogočene.',
    'Ask your Poneva contact to switch them on for your company.':
      'Prosite svojo kontaktno osebo pri Ponevi, naj jih omogoči za vaše podjetje.',
    '{value1} Change the agent': '{value1} Spremeni agenta',
    '{value1} Continue in chat': '{value1} Nadaljuj v klepetu',
    Edit: 'Uredi',
    '{value1} Edit with chat': '{value1} Uredi s klepetom',
    '{value1} Duplicate to my Library': '{value1} Podvoji v mojo knjižnico',
    'Duplicated to your Library. Only you can see the copy.':
      'Podvojeno v vaši knjižnici. Kopijo lahko vidite samo vi.',
    'Could not duplicate this Result. Try again.':
      'Tega rezultata ni bilo mogoče podvojiti. Poskusite znova.',
    'Saved version {value1}.': 'Različica {value1} je shranjena.',
    'A newer version was saved. Reload the Result before saving.':
      'Shranjena je bila novejša različica. Pred shranjevanjem znova naložite rezultat.',
    'Could not save this version. Try again.':
      'Te različice ni bilo mogoče shraniti. Poskusite znova.',
    '{value1} saved a newer version. Review it before saving.':
      '{value1} je shranil/-a novejšo različico. Pred shranjevanjem jo preglejte.',
    'Hide their version': 'Skrij njihovo različico',
    'Show their version': 'Prikaži njihovo različico',
    'Start from their version': 'Začni z njihovo različico',
    Markdown: 'Markdown',
    'Result text': 'Besedilo rezultata',
    Preview: 'Predogled',
    'What changed': 'Kaj se je spremenilo',
    'What changed? (optional)': 'Kaj se je spremenilo? (izbirno)',
    'Save version {value1}': 'Shrani različico {value1}',
    'Open chat': 'Odpri klepet',
    Current: 'Trenutno',
    Restore: 'Obnovi',
    'Could not load the history.': 'Zgodovine ni bilo mogoče naložiti.',
    'Restored version {value1} as version {value2}.':
      'Različica {value1} je obnovljena kot različica {value2}.',
    'Someone saved a newer version. Review it before restoring.':
      'Nekdo je shranil novejšo različico. Pred obnovitvijo jo preglejte.',
    'Could not restore that version.': 'Te različice ni bilo mogoče obnoviti.',
    'Loading history…': 'Nalaganje zgodovine …',
    'Restoring keeps what is there now as a version too, so nothing is lost.':
      'Pri obnovitvi se trenutno stanje prav tako shrani kot različica, zato se nič ne izgubi.',
    'This Result was made with your own {value1}.':
      'Ta rezultat je bil ustvarjen z vašim {value1}.',
    'It also used': 'Uporabil je tudi',
    'This Result was made with': 'Ta rezultat je bil ustvarjen z',
    'Colleagues can read what came from them, but can never use them.':
      'Sodelavci lahko preberejo vsebino, ki izhaja iz njih, vendar je nikoli ne morejo uporabiti.',
    'Your personal agent {value1} keeps it up to date with your own access, so every refresh can carry your private data.':
      'Vaš osebni agent {value1} ga posodablja z vašim dostopom, zato lahko vsaka osvežitev vsebuje vaše zasebne podatke.',
    'A colleague’s personal agent keeps it up to date with their own access, so every refresh can carry their private data.':
      'Osebni agent sodelavca ga posodablja z njegovim dostopom, zato lahko vsaka osvežitev vsebuje njegove zasebne podatke.',
    'Made private. Only you can see this meeting.':
      'Nastavljeno kot zasebno. Ta sestanek lahko vidite samo vi.',
    'Could not make this meeting private.': 'Tega sestanka ni bilo mogoče nastaviti kot zasebnega.',
    'Meeting · {value1} {value2} · Original retained':
      'Sestanek · {value1} {value2} · Izvirnik je ohranjen',
    'The recording could not be opened.': 'Posnetka ni bilo mogoče odpreti.',
    'Ask about this suggestion': 'Vprašaj o tem predlogu',
    meeting_processing_failed: 'obdelava_sestanka_ni_uspela',
    'Who can see this': 'Kdo lahko to vidi',
    'Everyone at {value1}': 'Vsi v {value1}',
    'Only me': 'Samo jaz',
    'Everyone at {value1} can find it and ask about it.':
      'Vsi v {value1} ga lahko najdejo in sprašujejo o njem.',
    'Only you can open and search this meeting. You can share it later.':
      'Ta sestanek lahko odprete in iščete po njem samo vi. Pozneje ga lahko delite.',
    'Added. Only you can see it. Transcription is running in the background.':
      'Dodano. Vidite ga lahko samo vi. Prepisovanje poteka v ozadju.',
    'Visible to everyone at {value1}': 'Vidno vsem v {value1}',
    'Could not make it private.': 'Tega ni bilo mogoče nastaviti kot zasebnega.',
    'Show more meetings': 'Prikaži več sestankov',
    'Attached to this message': 'Priloženo temu sporočilu',
    'Connect securely, choose the tables to share, then decide whether Poneva can read or make changes.':
      'Varno vzpostavite povezavo, izberite tabele za skupno rabo in nato določite, ali jih lahko Poneva bere ali spreminja.',
    'Review the tables this connection can access. Select at least one table.':
      'Preglejte tabele, do katerih lahko ta povezava dostopa. Izberite vsaj eno tabelo.',
    'Select at least one table. Nothing is selected by default.':
      'Izberite vsaj eno tabelo. Privzeto ni izbrana nobena.',
    'Choose who can use this connection and what Poneva can do.':
      'Izberite, kdo lahko uporablja to povezavo in kaj lahko Poneva počne.',
    'Your chosen access is enabled for the selected tables.':
      'Izbrani dostop je omogočen za izbrane tabele.',
    'Your connection is saved with reading paused until permission is confirmed.':
      'Vaša povezava je shranjena, branje pa je zaustavljeno, dokler dovoljenje ni potrjeno.',
    'Confirm database disconnect': 'Potrdi prekinitev povezave z zbirko podatkov',
    'Disconnect this database?': 'Želite prekiniti povezavo s to zbirko podatkov?',
    'Access will stop for everyone using this connection.':
      'Dostop bo onemogočen vsem, ki uporabljajo to povezavo.',
    'Keep connection': 'Ohrani povezavo',
    'What it can reach · {value1}{value2} {value3}':
      'Do česa lahko dostopa · {value1}{value2} {value3}',
    Back: 'Nazaj',
    Continue: 'Nadaljuj',
    'Uploading…': 'Nalaganje …',
    Library: 'Knjižnica',
    'Source material for your work. Available whenever you need it.':
      'Izvorno gradivo za vaše delo. Na voljo je, kadar ga potrebujete.',
    'The work you want to keep, with its sources and conversation attached.':
      'Delo, ki ga želite obdržati, skupaj s priloženimi viri in pogovorom.',
    Results: 'Rezultati',
    Files: 'Datoteke',
    Artifacts: 'Artefakti',
    'Search library': 'Išči po knjižnici',
    'Find files by meaning…': 'Poiščite datoteke po pomenu …',
    'Find saved work by meaning…': 'Poiščite shranjeno delo po pomenu …',
    'Search coverage is limited while indexing or meaning-based search is unavailable. You can retry or browse recent items.':
      'Obseg iskanja je omejen, dokler indeksiranje ali iskanje po pomenu ni na voljo. Poskusite znova ali prebrskajte nedavne elemente.',
    'No matching work found.': 'Ustreznega dela ni bilo mogoče najti.',
    'A starting point for your next question.': 'Izhodišče za vaše naslednje vprašanje.',
    'Good work is worth keeping.': 'Dobro delo je vredno ohraniti.',
    'Try a different description or clear the search to browse.':
      'Poskusite z drugačnim opisom ali počistite iskanje za brskanje.',
    'Upload source material once and use it in conversations and Skills. Your original stays in the library.':
      'Izvorno gradivo naložite enkrat in ga uporabljajte v pogovorih in veščinah. Izvirnik ostane v knjižnici.',
    'Ask Poneva to save an answer, table or chart. Results stay connected to the conversation and their sources.':
      'Prosite Ponevo, naj shrani odgovor, tabelo ali grafikon. Rezultati ostanejo povezani s pogovorom in njegovimi viri.',
    'Start in chat {value1}': 'Začni v klepetu {value1}',
    'Open result: {value1}': 'Odpri rezultat: {value1}',
    'Loading more library items…': 'Nalaganje dodatnih elementov knjižnice …',
    'Load more': 'Naloži več',
    'Documents, transcripts, audio and video · Up to 500 MB per file. New files are private. Choose their audience with Share and which processable files become searchable company knowledge.':
      'Dokumenti, prepisi, zvočni in videoposnetki · Do 500 MB na datoteko. Nove datoteke so zasebne. Z možnostjo Deli izberite njihovo občinstvo in določite, katere datoteke, ki jih je mogoče obdelati, postanejo del znanja podjetja, po katerem je mogoče iskati.',
    Skills: 'Veščine',
    'Create in chat': 'Ustvari v klepetu',
    'Search Skills': 'Išči veščine',
    'Search finds published Skills. Clear the search to browse your drafts too.':
      'Iskanje najde objavljene veščine. Počistite iskanje, če želite brskati tudi po svojih osnutkih.',
    'Search coverage is limited while indexing or meaning-based search is unavailable.':
      'Obseg iskanja je omejen, dokler indeksiranje ali iskanje po pomenu ni na voljo.',
    'Searching Skills…': 'Iskanje veščin …',
    'No matching published Skills found. Try a different description.':
      'Ujemajočih se objavljenih veščin ni bilo mogoče najti. Poskusite z drugačnim opisom.',
    'Load more Skills': 'Naloži več veščin',
    'View Skill: {value1}': 'Ogled veščine: {value1}',
    'Company workspace': 'Delovni prostor podjetja',
    'View {value1}': 'Ogled {value1}',
    'Loading Skills…': 'Nalaganje veščin …',
    'Try again {value1}': 'Poskusi znova {value1}',
    'Try again': 'Poskusi znova',
    'Nothing yet.': 'Za zdaj nič.',
    'Made from · Used by': 'Ustvarjeno iz · Uporabljajo',
    'Could not load links': 'Povezav ni bilo mogoče naložiti',
    'Made from': 'Ustvarjeno iz',
    'Used by': 'Uporabljajo',
    'About this chat {value1}': 'O tem klepetu {value1}',
    'About this chat': 'O tem klepetu',
    'Keep the work moving.': 'Nadaljujte z delom.',
    'Ask a follow-up with this result in view, or turn a useful approach into a company Skill.':
      'Postavite nadaljnje vprašanje, pri čemer naj bo ta rezultat viden, ali pa uporaben pristop pretvorite v veščino podjetja.',
    'Save approach as a Skill': 'Shrani pristop kot veščino',
    'Preview of': 'Predogled',
    'Made with': 'Ustvarjeno z',
    'Open the draft': 'Odpri osnutek',
    'Open Skill': 'Odpri veščino',
    'Use in chat': 'Uporabi v klepetu',
    'Finish the draft': 'Dokončaj osnutek',
    'Refine this Skill': 'Izboljšaj to veščino',
    'Made with a Skill.': 'Ustvarjeno z veščino.',
    'This workspace could not be loaded just now, so that Skill cannot be opened yet. The result itself is unchanged.':
      'Tega delovnega prostora trenutno ni bilo mogoče naložiti, zato te veščine še ni mogoče odpreti. Sam rezultat ostaja nespremenjen.',
    'That Skill is not available in this workspace, so it cannot be opened or used again. The result itself is unchanged.':
      'Ta veščina v tem delovnem prostoru ni na voljo, zato je ni mogoče odpreti ali znova uporabiti. Sam rezultat ostaja nespremenjen.',
    'Result · {value1} {value2}': 'Rezultat · {value1} {value2}',
    '{value1} Copy link': '{value1} Kopiraj povezavo',
    'Result link copied.': 'Povezava do rezultata je kopirana.',
    'Could not copy the link. Use your browser address bar.':
      'Povezave ni bilo mogoče kopirati. Uporabite naslovno vrstico brskalnika.',
    'No preview is available for this result.': 'Predogled tega rezultata ni na voljo.',
    '{value1} rows are retained in this snapshot. Open Table to inspect the values.':
      'V tem posnetku je ohranjenih {value1} vrstic. Odprite tabelo za pregled vrednosti.',
    'People can’t edit a Result an agent keeps up to date; the next refresh would replace their edit. Change the agent’s instructions instead.':
      'Rezultata, ki ga agent vzdržuje ažurnega, ni mogoče urejati; naslednja osvežitev bi nadomestila vaše spremembe. Namesto tega spremenite navodila agenta.',
    'Linked sources': 'Povezani viri',
    'Saved source': 'Shranjeni vir',
    'No source documents are linked to this result. Company knowledge and other references may be cited in the answer.':
      'S tem rezultatom ni povezan noben izvorni dokument. V odgovoru so lahko navedeni znanje podjetja in drugi viri.',
    'Run details': 'Podrobnosti izvajanja',
    Created: 'Ustvarjeno',
    ', revised {value1}': ', posodobljeno {value1}',
    Conversation: 'Pogovor',
    'Not recorded': 'Ni zabeleženo',
    'Open conversation': 'Odpri pogovor',
    Run: 'Izvajanje',
    Updates: 'Posodobitve',
    'Kept up to date by {value1}': 'Ažurno vzdržuje {value1}',
    'Version {value1}': 'Različica {value1}',
    'Could not open this request.': 'Te zahteve ni bilo mogoče odpreti.',
    'Approved version published.': 'Odobrena različica je objavljena.',
    'Request rejected. The item stays unchanged.':
      'Zahteva je zavrnjena. Element ostaja nespremenjen.',
    'Could not save the decision.': 'Odločitve ni bilo mogoče shraniti.',
    'Proposed company change': 'Predlagana sprememba podjetja',
    'Opening…': 'Odpiranje …',
    'Approve this version': 'Odobri to različico',
    Decline: 'Zavrni',
    'Review the submitted version below. Changes made since submission will need a new request.':
      'Spodaj preglejte poslano različico. Za spremembe, opravljene po pošiljanju, bo potrebna nova zahteva.',
    'The version submitted with this request.': 'Različica, poslana s to zahtevo.',
    'Version and proposed change': 'Različica in predlagana sprememba',
    'Could not read the pinned content.': 'Pripete vsebine ni bilo mogoče prebrati.',
    'Showing a page of {value1} characters.': 'Prikazana je stran z {value1} znaki.',
    'Beginning of the submitted content. Open the full text to review every page.':
      'Začetek poslane vsebine. Odprite celotno besedilo za pregled vseh strani.',
    'Read full submitted text': 'Preberi celotno poslano besedilo',
    'Previous page': 'Prejšnja stran',
    'Next page': 'Naslednja stran',
    'Made private. Its creator has been told in their Inbox.':
      'Nastavljeno kot zasebno. Ustvarjalec je bil o tem obveščen v mapi Prejeto.',
    'Made private. Its creator could not be notified.':
      'Nastavljeno kot zasebno. Ustvarjalca ni bilo mogoče obvestiti.',
    'Make this {value1} private?': 'Želite {value1} nastaviti kot zasebno?',
    'Only the person who created it will see it. Everyone else loses access right away, and its creator gets an Inbox update if they are still a company member. If they have left, nobody in the company will be able to access this item.':
      'Videla ga bo samo oseba, ki ga je ustvarila. Vsi drugi bodo takoj izgubili dostop, njegov ustvarjalec pa bo prejel obvestilo v mapi Prejeto, če je še vedno član podjetja. Če je podjetje zapustil, do tega elementa ne bo mogel dostopati nihče v podjetju.',
    'Sent for review. The current audience stays unchanged until approval.':
      'Poslano v pregled. Trenutno občinstvo ostane nespremenjeno do odobritve.',
    'Could not update sharing.': 'Skupne rabe ni bilo mogoče posodobiti.',
    'They can follow new answers live and fork it to continue with their own connections. Only you write here. You can make it private again at any time.':
      'V živo lahko spremljajo nove odgovore in ustvarijo svojo različico za nadaljevanje z lastnimi povezavami. Tukaj lahko pišete samo vi. Kadar koli lahko znova nastavite zasebnost.',
    'They see the project, its brief and the work in it they can already open. Nothing in it opens for anyone because of the project; each item keeps its own access.':
      'Vidijo projekt, njegov povzetek in delo v njem, do katerega že imajo dostop. Zaradi projekta se nikomur ne odpre nič novega; vsak element ohrani svoj dostop.',
    'Check the content for private information before sharing. Sharing an item does not grant access to its original chat or private connections.':
      'Pred skupno rabo preverite, ali vsebina vsebuje zasebne podatke. Skupna raba elementa ne omogoči dostopa do izvornega klepeta ali zasebnih povezav.',
    '{value1} Everyone you share with can read it, including what the assistant or an App in it found in your {value2}. They can’t use your {value3}. Nothing changes for you: the chat keeps working with all your accounts.':
      '{value1} Vsi, s katerimi vsebino delite, jo lahko berejo, vključno s tem, kar sta pomočnik ali aplikacija v njej našla v vašem {value2}. Vašega {value3} ne morejo uporabljati. Za vas se nič ne spremeni: klepet še naprej deluje z vsemi vašimi računi.',
    '{value1} Everyone you share with can read them, but nobody can use {value2} through this chat.':
      '{value1} Vsi, s katerimi jih delite, jih lahko berejo, vendar nihče ne more uporabljati {value2} prek tega klepeta.',
    'This controls access to the working draft. Any published company version stays available until you explicitly unpublish it. To publish a new version, complete its preview and use Save Skill. Run results stay private.':
      'To določa dostop do delovnega osnutka. Vsaka objavljena različica podjetja ostane na voljo, dokler je izrecno ne umaknete iz objave. Če želite objaviti novo različico, dokončajte njen predogled in uporabite možnost »Shrani spretnost«. Rezultati izvajanja ostanejo zasebni.',
    'Skill deleted. You can restore it from the Skills archive for 30 days.':
      'Spretnost je izbrisana. Iz arhiva spretnosti jo lahko obnovite v 30 dneh.',
    'Could not delete this Skill.': 'Te spretnosti ni bilo mogoče izbrisati.',
    'More actions': 'Več dejanj',
    'Delete “{value1}”? It will disappear from Skills and search, and cannot be used by agents. You can restore it for 30 days. Existing chats and results stay available.':
      'Želite izbrisati »{value1}«? Izginila bo iz spretnosti in iskanja ter je agenti ne bodo mogli uporabljati. Obnovite jo lahko v 30 dneh. Obstoječi klepeti in rezultati ostanejo na voljo.',
    'Deleting…': 'Brisanje …',
    'Confirm delete': 'Potrdi brisanje',
    'Delete Skill': 'Izbriši spretnost',
    'Skill restored as an unpublished draft. Its author can review and publish it again.':
      'Spretnost je obnovljena kot neobjavljen osnutek. Njen avtor jo lahko pregleda in znova objavi.',
    'Could not restore this Skill.': 'Te spretnosti ni bilo mogoče obnoviti.',
    'Archived Skills': 'Arhivirane spretnosti',
    'Deleted Skills can be restored for 30 days. Restoring leaves them unpublished.':
      'Izbrisane spretnosti lahko obnovite v 30 dneh. Obnovljene ostanejo neobjavljene.',
    'Restore until {value1}': 'Obnovi do {value1}',
    'Loading…': 'Nalaganje …',
    'No archived Skills.': 'Ni arhiviranih spretnosti.',
    'Load more archived Skills': 'Naloži več arhiviranih spretnosti',
    'Show more of the original': 'Pokaži več izvirnika',
    'Filter result rows': 'Filtriraj vrstice rezultatov',
    'Find a product or value…': 'Poiščite izdelek ali vrednost …',
    '{value1} of {value2}': '{value1} od {value2}',
    'Result table': 'Tabela rezultatov',
    'No matching rows.': 'Ni ujemajočih se vrstic.',
    'Showing the first 1,000 matching rows. Download the CSV for every row.':
      'Prikazanih je prvih 1.000 ujemajočih se vrstic. Za vse vrstice prenesite CSV.',
    'Agent ·': 'Agent ·',
    'Only you': 'Samo vi',
    'Stopped before it finished.': 'Ustavljeno pred dokončanjem.',
    'Drafting the project…': 'Priprava osnutka projekta …',
    'Checking where this chat belongs…': 'Preverjanje, kam spada ta klepet …',
    'Moving the chat…': 'Premikanje klepeta …',
    'Taking it out of the project…': 'Odstranjevanje iz projekta …',
    'Adding it to the project…': 'Dodajanje v projekt …',
    'No matching connections are available right now.':
      'Trenutno ni na voljo ujemajočih se povezav.',
    'Company knowledge suggestion': 'Predlog znanja podjetja',
    'Company knowledge now lives on pages. Open Knowledge to see them.':
      'Znanje podjetja je zdaj na straneh. Odprite Znanje, da si jih ogledate.',
    '{value1} · Open beside this conversation': '{value1} · Odpri ob tem pogovoru',
    'Name {value1}': 'Ime {value1}',
    'Host {value1}': 'Gostitelj {value1}',
    'Port {value1}': 'Vrata {value1}',
    'Database {value1}': 'Zbirka podatkov {value1}',
    'Username {value1}': 'Uporabniško ime {value1}',
    'Password {value1}': 'Geslo {value1}',
    'Advanced TLS': 'Napredni TLS',
    '{value1} Poneva verifies the server certificate. Add a CA or server DNS name for IP hosts when your certificate requires it.':
      '{value1} Poneva preveri strežniško potrdilo. Če vaše potrdilo to zahteva, za gostitelje IP dodajte overitelja CA ali ime DNS strežnika.',
    'CA certificate {value1}': 'Potrdilo CA {value1}',
    'Certificate server DNS name {value1}': 'Ime DNS strežnika potrdila {value1}',
    '{value1} Your password is encrypted in secure storage. Poneva verifies the connection before saving it.':
      '{value1} Vaše geslo je šifrirano v varni shrambi. Poneva pred shranjevanjem preveri povezavo.',
    'Testing…': 'Preizkušanje …',
    'Test connection': 'Preizkusi povezavo',
    'PostgreSQL is connected.': 'PostgreSQL je povezan.',
    'PostgreSQL was saved safely.': 'PostgreSQL je bil varno shranjen.',
    'Poneva can read and change rows in the selected tables. Apps also follow their approved data scope.':
      'Poneva lahko bere in spreminja vrstice v izbranih tabelah. Aplikacije upoštevajo tudi obseg podatkov, za katerega so odobrene.',
    'Poneva can read the selected tables. Apps also follow their approved data scope.':
      'Poneva lahko bere izbrane tabele. Aplikacije upoštevajo tudi obseg podatkov, za katerega so odobrene.',
    'Reads are paused until permission is enabled.':
      'Branje je zaustavljeno, dokler ne omogočite dovoljenja.',
    'Retrying…': 'Ponovni poskus …',
    'Retry permission': 'Znova poskusi z dovoljenjem',
    'Try it in Chat': 'Preizkusi v klepetu',
    Done: 'Končano',
    'Disconnect database': 'Prekini povezavo z zbirko podatkov',
    '{value1} TLS verified ·{value2} {value3}': '{value1} TLS preverjen ·{value2} {value3}',
    'Search schemas and tables': 'Išči sheme in tabele',
    'Search tables': 'Išči tabele',
    '{value1} of {value2} tables selected': 'Izbranih tabel: {value1} od {value2}',
    'Select matching tables': 'Izberi ujemajoče se tabele',
    'Select all tables': 'Izberi vse tabele',
    Clear: 'Počisti',
    'Select a whole schema or individual tables. New tables need a fresh selection.':
      'Izberite celotno shemo ali posamezne tabele. Za nove tabele je potrebna nova izbira.',
    'No tables match this search.': 'Nobena tabela ne ustreza temu iskanju.',
    'All tables in {value1}': 'Vse tabele v {value1}',
    '{value1} / {value2} tables': '{value1} / {value2} tabel',
    'Read & write available': 'Branje in pisanje sta na voljo',
    'Read only': 'Samo za branje',
    Ctrl: 'Ctrl',
    'This suggested knowledge update could not be shown.':
      'Predlagane posodobitve znanja ni bilo mogoče prikazati.',
    'Suggested knowledge update': 'Predlagana posodobitev znanja',
    'This suggestion is no longer available to you.': 'Ta predlog vam ni več na voljo.',
    'We could not check where this suggestion stands.':
      'Ni bilo mogoče preveriti stanja tega predloga.',
    'Check again': 'Preveri znova',
    'Show on page': 'Pokaži na strani',
    'The editor could not be loaded. Poneva may have been updated since you opened this page. Reload to get the latest version; nothing on this page has changed.':
      'Urejevalnika ni bilo mogoče naložiti. Poneva je bila morda posodobljena, odkar ste odprli to stran. Znova naložite stran, da dobite najnovejšo različico; na tej strani se ni nič spremenilo.',
    'Reload Poneva': 'Znova naloži Ponevo',
    Formatting: 'Oblikovanje',
    'Text style': 'Slog besedila',
    Text: 'Besedilo',
    Heading: 'Naslov',
    Subheading: 'Podnaslov',
    'Link a page': 'Poveži stran',
    'A page needs a title.': 'Stran mora imeti naslov.',
    'Nothing has changed yet.': 'Za zdaj se ni nič spremenilo.',
    'A page needs some text. To remove a page, archive it instead.':
      'Stran mora vsebovati nekaj besedila. Če želite stran odstraniti, jo raje arhivirajte.',
    'A suggested new page needs some text.': 'Predlagana nova stran mora vsebovati nekaj besedila.',
    'This page is larger than 256 KB. Split it into smaller pages.':
      'Ta stran je večja od 256 KB. Razdelite jo na manjše strani.',
    'Say in a few words why this change is right.':
      'Z nekaj besedami povejte, zakaj je ta sprememba ustrezna.',
    'This page changed while you were editing. Your text is still here: copy it, then open the latest version and make your change again.':
      'Ta stran se je med vašim urejanjem spremenila. Vaše besedilo je še vedno tukaj: kopirajte ga, nato odprite najnovejšo različico in znova izvedite spremembo.',
    'Your text is copied.': 'Vaše besedilo je kopirano.',
    'Your text could not be copied. Select it in the editor and copy it.':
      'Vašega besedila ni bilo mogoče kopirati. Izberite ga v urejevalniku in ga kopirajte.',
    'The page “{value1}” is created.': 'Stran »{value1}« je ustvarjena.',
    'New page': 'Nova stran',
    'Editing {value1}': 'Urejanje strani {value1}',
    Editing: 'Urejanje',
    'Creating publishes the page under {value1} for everyone':
      'Z ustvarjanjem bo stran pod {value1} objavljena za vse',
    'Saving publishes the new version for everyone':
      'S shranjevanjem bo nova različica objavljena za vse',
    'Your changes are sent as a suggestion for a publisher':
      'Vaše spremembe so poslane kot predlog objavitelju',
    'Create page': 'Ustvari stran',
    Save: 'Shrani',
    'Send suggestion': 'Pošlji predlog',
    '{value1} Copy my text': '{value1} Kopiraj moje besedilo',
    'Open the latest version': 'Odpri najnovejšo različico',
    'Page title': 'Naslov strani',
    'Loading the editor…': 'Nalaganje urejevalnika …',
    'New page text': 'Besedilo nove strani',
    'Text of {value1}': 'Besedilo strani {value1}',
    'Write the page. Type [[ to link another page.':
      'Napišite vsebino strani. Vnesite [[ za povezavo z drugo stranjo.',
    'Type [[ to link another page.': 'Vnesite [[ za povezavo z drugo stranjo.',
    'Link to a page': 'Povezava na stran',
    'What changed, in a few words': 'Kaj se je spremenilo, z nekaj besedami',
    'Where this comes from, in a few words': 'Od kod to prihaja, z nekaj besedami',
    'Shown in the page history.': 'Prikazano v zgodovini strani.',
    'A publisher sees this next to your change.': 'Objavitelj bo to videl ob vaši spremembi.',
    '1 suggestion is open on this page': 'Na tej strani je odprt 1 predlog',
    '{value1} suggestions are open on this page': 'Na tej strani je odprtih {value1} predlogov',
    'They stay open while you edit. After you save, they show against your new text; one whose words you changed is marked outdated.':
      'Med urejanjem ostanejo odprti. Ko shranite, se prikažejo ob vašem novem besedilu; predlog, katerega besede ste spremenili, je označen kot zastarel.',
    'Type [[ to link another page. Links keep working when a page is renamed or moved.':
      'Vnesite [[ za povezavo z drugo stranjo. Povezave še naprej delujejo, tudi če stran preimenujete ali premaknete.',
    'Loading the history…': 'Nalaganje zgodovine …',
    'This page has no saved text yet.': 'Ta stran še nima shranjenega besedila.',
    'Say in a few words why this revision should come back.':
      'Z nekaj besedami povejte, zakaj naj se ta revizija obnovi.',
    'Revision {value1} is suggested for a publisher to accept.':
      'Revizija {value1} je predlagana v sprejem objavitelju.',
    'The page already reads like this revision.': 'Stran je že videti kot ta revizija.',
    'Revision {value1} is restored as revision {value2}.':
      'Revizija {value1} je obnovljena kot revizija {value2}.',
    'Revision history': 'Zgodovina revizij',
    Revisions: 'Revizije',
    'Every saved revision is kept.': 'Vsaka shranjena revizija se ohrani.',
    'Revision {value1} {value2}': 'Revizija {value1} {value2}',
    'Revision {value1} compared with revision {value2}':
      'Primerjava revizije {value1} z revizijo {value2}',
    'Revision {value1}, the first text of this page': 'Revizija {value1}, prvo besedilo te strani',
    'Green was added, struck through was removed.':
      'Zeleno je bilo dodano, prečrtano je bilo odstranjeno.',
    '{value1} Export Markdown': '{value1} Izvozi Markdown',
    'Restore this revision': 'Obnovi to revizijo',
    'Suggest restoring it': 'Predlagaj obnovitev',
    'Why should this revision come back?': 'Zakaj naj se ta revizija obnovi?',
    'Loading this revision…': 'Nalaganje te revizije …',
    'Only the title changed, from “{value1}” to “{value2}”.':
      'Spremenil se je samo naslov, iz »{value1}« v »{value2}«.',
    'The text did not change in this revision.': 'Besedilo se v tej reviziji ni spremenilo.',
    'Changes in revision {value1}': 'Spremembe v reviziji {value1}',
    'Loading page…': 'Nalaganje strani …',
    'Loading suggestion…': 'Nalaganje predloga …',
    'This suggestion is not available.': 'Ta predlog ni na voljo.',
    'It may have been decided, or it is not one you can see.':
      'Morda je bilo o njem že odločeno ali pa ga ne morete videti.',
    'Open Knowledge': 'Odpri zbirko znanja',
    'Opening the suggestion…': 'Odpiranje predloga …',
    'Choose where the page goes.': 'Izberite, kam naj bo stran umeščena.',
    'Say in a few words why.': 'Z nekaj besedami povejte, zakaj.',
    'Your suggestion is sent. A publisher decides.': 'Vaš predlog je poslan. Odloči objavitelj.',
    'Moved under {value1}.': 'Premaknjeno pod {value1}.',
    'Deleted “{value1}”.': '»{value1}« je izbrisano.',
    'Archived. Its history is kept.': 'Arhivirano. Zgodovina je ohranjena.',
    'Choose the page it goes under. Links to it keep working.':
      'Izberite stran, pod katero spada. Povezave do nje še naprej delujejo.',
    'Its text, its history and any open suggestions are removed for good, and links to it from other pages stop working. This cannot be undone.':
      'Njeno besedilo, zgodovina in vsi odprti predlogi bodo trajno odstranjeni, povezave do nje z drugih strani pa bodo prenehale delovati. Tega ni mogoče razveljaviti.',
    'An archived page no longer informs answers. Its history is kept, and a publisher can restore it or delete it permanently.':
      'Arhivirana stran ne vpliva več na odgovore. Njena zgodovina je ohranjena, objavitelj pa jo lahko obnovi ali trajno izbriše.',
    Under: 'Pod',
    Change: 'Spremeni',
    'Move under': 'Premakni pod',
    'Search pages': 'Išči strani',
    'Why?': 'Zakaj?',
    'Delete permanently': 'Trajno izbriši',
    'Move page': 'Premakni stran',
    'Archive page': 'Arhiviraj stran',
    'Suggestion {value1}: show its card': 'Predlog {value1}: prikaži njegovo kartico',
    'Removed:': 'Odstranjeno:',
    'Added:': 'Dodano:',
    'New page “{value1}”{value2}': 'Nova stran »{value1}«{value2}',
    'Where this page is': 'Kje je ta stran',
    'Describe your company': 'Opišite svoje podjetje',
    'Empty page': 'Prazna stran',
    'Describe {value1}': 'Opišite {value1}',
    'This page has no text yet.': 'Ta stran še nima besedila.',
    'Poneva reads this page before every answer. Start with who you are, what you sell and how you work; details go on the pages under it.':
      'Poneva prebere to stran pred vsakim odgovorom. Začnite s tem, kdo ste, kaj prodajate in kako delate; podrobnosti dodajte na strani pod njo.',
    'Write it, or ask Poneva in chat to draft it for you.':
      'Napišite ga sami ali prosite Ponevo v klepetu, naj pripravi osnutek.',
    'Suggest a first version, and a publisher decides whether it becomes the page.':
      'Predlagajte prvo različico, objavitelj pa odloči, ali bo postala stran.',
    'Start writing': 'Začnite pisati',
    'Suggest a first version': 'Predlagajte prvo različico',
    'Accepted. The page is archived.': 'Sprejeto. Stran je arhivirana.',
    'Accepted. The page is now revision {value1}.': 'Sprejeto. Stran je zdaj različica {value1}.',
    'Accepted.': 'Sprejeto.',
    'Suggestion rejected. The page stays as it is.':
      'Predlog je zavrnjen. Stran ostane nespremenjena.',
    'Your suggestion is withdrawn.': 'Vaš predlog je umaknjen.',
    'Restored. The page informs answers again.': 'Obnovljeno. Stran znova vpliva na odgovore.',
    'Your suggestion is sent. A publisher decides whether it becomes the page.':
      'Vaš predlog je poslan. Objavitelj odloči, ali bo postal stran.',
    'Saved. The page is now revision {value1}.': 'Shranjeno. Stran je zdaj različica {value1}.',
    'Nothing changed.': 'Nič se ni spremenilo.',
    'This page is not available.': 'Ta stran ni na voljo.',
    'It may have been deleted, archived or moved out of reach, or you may no longer be in this company.':
      'Morda je bila izbrisana, arhivirana ali premaknjena izven vašega dostopa oziroma niste več v tem podjetju.',
    'Page actions': 'Dejanja strani',
    shown: 'prikazano',
    hidden: 'skrito',
    '{value1} History': 'Zgodovina: {value1}',
    '{value1} Ask in chat': 'Vprašaj v klepetu: {value1}',
    'Suggest edits': 'Predlagaj spremembe',
    'More actions for {value1}': 'Več dejanj za {value1}',
    '{value1} Poneva reads this page in every chat':
      '{value1} Poneva prebere to stran v vsakem klepetu',
    'This page is archived. It no longer informs answers; its history is kept. {value1}':
      'Ta stran je arhivirana. Ne vpliva več na odgovore; njena zgodovina je ohranjena. {value1}',
    'Restore page': 'Obnovi stran',
    'This link points to an earlier revision. You are reading the current text.':
      'Ta povezava vodi do starejše različice. Berete trenutno besedilo.',
    'Show it in History': 'Prikaži v zgodovini',
    Pages: 'Strani',
    'Pages under {value1}': 'Strani pod {value1}',
    'Linked from': 'Povezave s strani',
    Suggestions: 'Predlogi',
    'Suggestions are hidden. You are reading the page as everyone else sees it.':
      'Predlogi so skriti. Stran berete tako, kot jo vidijo vsi drugi.',
    'Loading suggestions…': 'Nalaganje predlogov …',
    'Nothing is waiting for review.': 'Nič ne čaka na pregled.',
    'When someone, Poneva in a chat or a connected agent suggests a change to a page, it shows here and on the page. Nothing changes until a publisher accepts it.':
      'Ko nekdo, Poneva v klepetu ali povezani agent predlaga spremembo strani, se ta prikaže tukaj in na strani. Nič se ne spremeni, dokler je objavitelj ne sprejme.',
    '{value1} Review knowledge in chat': '{value1} Preglej znanje v klepetu',
    'Suggestions for review': 'Predlogi za pregled',
    'Suggested changes from chats, meetings, colleagues and connected agents. Nothing changes until a publisher accepts it on the page.':
      'Predlagane spremembe iz klepetov, sestankov, od sodelavcev in povezanih agentov. Nič se ne spremeni, dokler jih objavitelj ne sprejme na strani.',
    'Your suggestions wait here until a publisher decides. The pages stay as they are until then.':
      'Vaši predlogi so tukaj, dokler objavitelj ne odloči. Strani do takrat ostanejo nespremenjene.',
    'Review page': 'Preglej stran',
    'Review on page': 'Preglej na strani',
    'Open the meeting': 'Odpri sestanek',
    'Open the chat': 'Odpri klepet',
    'Accept and restore': 'Sprejmi in obnovi',
    Accept: 'Sprejmi',
    Reject: 'Zavrni',
    'Your suggestion · waiting for a publisher': 'Vaš predlog · čaka na objavitelja',
    Withdraw: 'Umik',
    'Waiting for a publisher': 'Čaka na objavitelja',
    'Suggestion {value1}': 'Predlog {value1}',
    'Suggestion {value1} from {value2}{value3}': 'Predlog {value1} od {value2}{value3}',
    'Read the suggested page': 'Preberi predlagano stran',
    'Outdated: the text it changes was edited after it was suggested. It can be rejected or withdrawn; a new suggestion can be made against the current text.':
      'Zastarelo: besedilo, ki ga spreminja, je bilo po predlogu urejeno. Predlog lahko zavrnete ali umaknete; za trenutno besedilo lahko ustvarite nov predlog.',
    'Restore this page first to accept this suggestion.':
      'Najprej obnovite to stran, da boste lahko sprejeli ta predlog.',
    'Previous suggestion': 'Prejšnji predlog',
    'No pages match “{value1}”.': 'Nobena stran se ne ujema z »{value1}«.',
    'Suggestion {value1} of {value2}': 'Predlog {value1} od {value2}',
    'Next suggestion': 'Naslednji predlog',
    'Fold the suggestions away': 'Skrij predloge',
    'Show the suggestions': 'Prikaži predloge',
    '1 suggestion': '1 predlog',
    '{value1} suggestions': '{value1} predlogov',
    '{value1} the pages under {value2}': '{value1} strani pod {value2}',
    px: 'px',
    '{value1} chart of {value2} across {value3}': '{value1} grafikon za {value2} po {value3}',
    'We could not build the file.': 'Datoteke ni bilo mogoče ustvariti.',
    '{value1} Present': '{value1} prisotnih',
    'Building…': 'Ustvarjanje …',
    'Download PowerPoint': 'Prenesi PowerPoint',
    'Slide {value1} of {value2}': 'Prosojnica {value1} od {value2}',
    Slides: 'Prosojnice',
    'Slide {value1}': 'Prosojnica {value1}',
    'Speaker notes': 'Opombe govorca',
    'Source: {value1}': 'Vir: {value1}',
    'Add a name and a web address.': 'Dodajte ime in spletni naslov.',
    'Enter a valid web address.': 'Vnesite veljaven spletni naslov.',
    'Use a web address that starts with https://.':
      'Uporabite spletni naslov, ki se začne z https://.',
    'Add a custom connection': 'Dodaj povezavo po meri',
    'Connect a tool server you trust. Poneva checks the address works and saves only the connection details needed to use it.':
      'Povežite strežnik orodij, ki mu zaupate. Poneva preveri, ali naslov deluje, in shrani le podatke o povezavi, potrebne za njegovo uporabo.',
    'Web address': 'Spletni naslov',
    'https://tools.example.com': 'https://tools.example.com',
    'Starts with https://, from your provider': 'Začne se z https://, od vašega ponudnika',
    'Sign-in': 'Prijava',
    'Advanced sign-in': 'Napredna prijava',
    'Access key {value1}': 'Dostopni ključ {value1}',
    'Request headers': 'Glave zahtev',
    'Add header': 'Dodaj glavo',
    'Header {value1} name': 'Ime glave {value1}',
    'Header name': 'Ime glave',
    'Header {value1} value': 'Vrednost glave {value1}',
    'Header value': 'Vrednost glave',
    'Remove header': 'Odstrani glavo',
    Advanced: 'Napredno',
    Transport: 'Prenos',
    'Auto-detect': 'Samodejno zaznaj',
    'Streamable HTTP': 'HTTP s pretakanjem',
    'Legacy SSE': 'Podedovani SSE',
    "From your provider's app settings. Leave empty unless they gave you these.":
      'V nastavitvah aplikacije vašega ponudnika. Pustite prazno, razen če vam jih je posredoval.',
    "Authorization server issuer": "Izdajatelj avtorizacijskega strežnika",
    "Enter the authorization server issuer when using a client ID.": "Pri uporabi ID-ja odjemalca vnesite izdajatelja avtorizacijskega strežnika.",
    'Client ID {value1}': 'ID odjemalca {value1}',
    'Client secret {value1}': 'Skrivnost odjemalca {value1}',
    'Connecting…': 'Vzpostavljanje povezave …',
    'Test and connect': 'Preizkusi in poveži',
    'Add the store, the client ID and the client secret.':
      'Dodajte trgovino, ID odjemalca in skrivnost odjemalca.',
    'Connect your Shopify Developer App': 'Povežite svojo razvijalsko aplikacijo Shopify',
    'Poneva can use exactly the access your store gave the app, and nothing more. It talks to Shopify directly and keeps the client secret encrypted.':
      'Poneva lahko uporablja natanko tiste dostope, ki jih je vaša trgovina dodelila aplikaciji, in nič več. S Shopifyjem komunicira neposredno, skrivnost odjemalca pa hrani šifrirano.',
    'How to create the app in Shopify': 'Kako ustvariti aplikacijo v Shopifyju',
    'Open{value1} {value2}{value3} with the account that owns the store, and create an app.':
      'Odprite{value1} {value2}{value3} z računom, ki je lastnik trgovine, in ustvarite aplikacijo.',
    'Create a version and select the access scopes Poneva may use, for example read_products and read_orders. Add write_ scopes only for data Poneva may change. Then release the version.':
      'Ustvarite različico in izberite obsege dostopa, ki jih lahko uporablja Poneva, na primer read_products in read_orders. Obsege write_ dodajte samo za podatke, ki jih lahko Poneva spreminja. Nato objavite različico.',
    'For orders and customers, also select protected customer data in the app’s settings. Shopify allows this without review for an app made for your own store.':
      'Za naročila in stranke v nastavitvah aplikacije izberite tudi zaščitene podatke strank. Shopify to za aplikacijo, ustvarjeno za vašo trgovino, omogoča brez pregleda.',
    'Install the app on your store.': 'Namestite aplikacijo v svojo trgovino.',
    'Copy the client ID and client secret from the app’s settings.':
      'Kopirajte ID odjemalca in skrivnost odjemalca iz nastavitev aplikacije.',
    'To change the access later, release a new version, approve it on the store and use Test connection here.':
      'Če želite pozneje spremeniti dostop, objavite novo različico, jo odobrite v trgovini in tukaj uporabite možnost Preizkusi povezavo.',
    Store: 'Trgovina',
    'your-store.myshopify.com': 'your-store.myshopify.com',
    'Your store’s .myshopify.com address (Shopify admin → Settings → Domains), or paste the address of your Shopify admin page':
      'Naslov vaše trgovine .myshopify.com (Shopifyjev skrbnik → Settings → Domains) ali prilepite naslov strani Shopifyjevega skrbnika',
    'Client ID {value1} {value2}': 'ID odjemalca {value1} {value2}',
    'Client secret {value1} {value2}': 'Skrivnost odjemalca {value1} {value2}',
    Person: 'Oseba',
    Everyone: 'Vsi',
    Connection: 'Povezava',
    'All connections': 'Vse povezave',
    'App {value1}': 'Aplikacija {value1}',
    'From {value1}': 'Od {value1}',
    'Until {value1}': 'Do {value1}',
    Result: 'Rezultat',
    'All results': 'Vsi rezultati',
    Succeeded: 'Uspešno',
    Denied: 'Zavrnjeno',
    Failed: 'Neuspešno',
    Unknown: 'Neznano',
    Filter: 'Filter',
    'Loading activity…': 'Nalaganje dejavnosti …',
    'Could not load activity. Try again.': 'Dejavnosti ni bilo mogoče naložiti. Poskusite znova.',
    'Removed connection': 'Odstranjena povezava',
    'App: {value1}': 'Aplikacija: {value1}',
    'Older activity': 'Starejša dejavnost',
    Download: 'Prenos',
    CSV: 'CSV',
    'Evidence for {value1}': 'Dokazi za {value1}',
    Measure: 'Mera',
    'Show rows →': 'Prikaži vrstice →',
    'Ask about this number': 'Vprašaj o tej številki',
    'There are no numeric values available to chart. View the table for the original data.':
      'Na voljo ni številskih vrednosti za grafikon. Za izvirne podatke si oglejte tabelo.',
    'Chart value': 'Vrednost grafikona',
    '{value1} of {value2} shown': 'Prikazanih: {value1} od {value2}',
    '{value1} by {value2}; {value3} rows. View Table for exact values.':
      '{value1} po {value2}; {value3} vrstic. Za natančne vrednosti si oglejte tabelo.',
    'Values come directly from the source data. Missing values are not estimates.':
      'Vrednosti prihajajo neposredno iz izvornih podatkov. Manjkajoče vrednosti niso ocene.',
    'Loading library…': 'Nalaganje knjižnice…',
    'We couldn’t load what happened in this App. Try again in a moment.':
      'Dogajanja v tej aplikaciji ni bilo mogoče naložiti. Poskusite znova čez trenutek.',
    'This App could not be opened.': 'Te aplikacije ni bilo mogoče odpreti.',
    'Opening App…': 'Odpiranje aplikacije…',
    'Open the saved App to run this function.':
      'Odprite shranjeno aplikacijo, da zaženete to funkcijo.',
    'Save this App before running its function.': 'Pred zagonom funkcije shranite to aplikacijo.',
    'Open saved App': 'Odpri shranjeno aplikacijo',
    'Open Apps': 'Odpri aplikacije',
    'The App could not be opened. Try again.':
      'Aplikacije ni bilo mogoče odpreti. Poskusite znova.',
    Owner: 'Lastnik',
    '{value1} · admins': '{value1} · skrbniki',
    'Owner · always edits': 'Lastnik · vedno lahko ureja',
    'Admins manage it': 'Upravljajo skrbniki',
    Editors: 'Uredniki',
    'A colleague': 'Sodelavec',
    'Can edit drafts and publish versions': 'Lahko ureja osnutke in objavlja različice',
    Remove: 'Odstrani',
    'No editors yet.': 'Urednikov še ni.',
    'Admins can always edit company agents.': 'Skrbniki lahko vedno urejajo agente podjetja.',
    'Asking for edit access': 'Zahtevanje dostopa za urejanje',
    'Asked {value1} · also in your Inbox': 'Zahtevano {value1} · tudi v vašem nabiralniku',
    Grant: 'Odobri',
    Admin: 'Skrbnik',
    'Make personal': 'Nastavi kot osebno',
    'Switch off': 'Izklopi',
    Archive: 'Arhiviraj',
    'Archive this agent': 'Arhiviraj tega agenta',
    'Loading agent…': 'Nalaganje agenta…',
    '{value1} Edit in chat': '{value1} Uredi v klepetu',
    Agent: 'Agent',
    'This agent has not been created yet. It can run once its owner creates it.':
      'Ta agent še ni bil ustvarjen. Zažene se lahko, ko ga ustvari njegov lastnik.',
    'New agent · Draft': 'Nov agent · osnutek',
    'Untitled agent': 'Agent brez naslova',
    'Test run': 'Preizkusni zagon',
    'This draft does not run automatically.': 'Ta osnutek se ne zažene samodejno.',
    'Describe the agent in the chat. Its draft appears here.':
      'Opišite agenta v klepetu. Njegov osnutek se prikaže tukaj.',
    '{value1} Test run': '{value1} Preizkusni zagon',
    'Describe the agent in the chat first.': 'Najprej opišite agenta v klepetu.',
    'Create and turn on': 'Ustvari in vklopi',
    'Connection write setup': 'Nastavitev pisanja povezave',
    'Account for connected changes': 'Račun za spremembe v povezavi',
    'Choose a connection': 'Izberite povezavo',
    'No published Skills available. You can add them later.':
      'Objavljene veščine niso na voljo. Dodate jih lahko pozneje.',
    '{value1} · not published. Review the changes. Testing is optional.':
      '{value1} · ni objavljeno. Preglejte spremembe. Preizkušanje ni obvezno.',
    '{value1} Test draft': '{value1} Preizkusi osnutek',
    'Apply changes…': 'Uveljavljanje sprememb…',
    'Apply this draft as a new version': 'Uveljavi ta osnutek kot novo različico',
    'This draft cannot be applied.': 'Tega osnutka ni mogoče uveljaviti.',
    'What changed?': 'Kaj se je spremenilo?',
    'Apply version {value1}': 'Uveljavi različico {value1}',
    Create: 'Ustvari',
    'Edit access requested': 'Dostop za urejanje je zahtevan',
    '{value1} Request edit access': '{value1} Zahtevaj dostop za urejanje',
    '{value1} Copy agent': '{value1} Kopiraj agenta',
    Pause: 'Začasno ustavi',
    'Open agent: {value1}': 'Odpri agenta: {value1}',
    '· you can edit': '· lahko urejate',
    '{value1} is switched off.': '{value1} je izklopljen.',
    '{value1} is archived.': '{value1} je arhiviran.',
    'Loading agents…': 'Nalaganje agentov…',
    Agents: 'Agenti',
    'Agents do work for you on a schedule or when you ask. They follow your company’s Skills.':
      'Agenti delajo za vas po urniku ali na vašo zahtevo. Upoštevajo veščine vašega podjetja.',
    'No agent matches. Try a Skill name or what the agent should do.':
      'Noben agent se ne ujema. Poskusite z imenom veščine ali opišite, kaj naj agent naredi.',
    'Nothing of your own yet': 'Za zdaj še nič vašega',
    'Tell Chat what an agent should do, or copy one of the company’s agents below.{value1}':
      'Povejte Chatu, kaj naj agent naredi, ali spodaj kopirajte enega od agentov podjetja.{value1}',
    'Your agents': 'Vaši agenti',
    'Run on demand': 'Zaženi na zahtevo',
    'Run is always available. A schedule is optional and lives separately from the agent’s instructions.':
      'Zagon je vedno na voljo. Urnik je neobvezen in je ločen od navodil agenta.',
    'What changed in version {value1}': 'Kaj se je spremenilo v različici {value1}',
    'Every publish is a version you can restore.':
      'Vsaka objava je različica, ki jo lahko obnovite.',
    Authorization: 'Avtorizacija',
    '{value1} {value2} · {value3} will see it.': '{value1} {value2} · {value3} ga bodo videli.',
    '{value1} {value2} you': '{value1} {value2} vas',
    '· Revised': '· Spremenjeno',
    'This chat used your {value1}.': 'Ta klepet je uporabil vaš {value1}.',
    'This chat has results from {value1}.': 'Ta klepet vsebuje rezultate iz {value1}.',
    'db.example.com': 'db.example.com',
    'e.g. Product analytics': 'npr. analitika izdelka',
    'Paste access key': 'Prilepite dostopni ključ',
    'Shopify’s Dev Dashboard': 'Shopifyjeva nadzorna plošča za razvijalce',
    'App reference': 'Referenca aplikacije',
    'Draft · revision {value1}': 'Osnutek · revizija {value1}',
    'its Result': 'njen rezultat',
    '· its first run makes it': '· zaradi prvega zagona postane',
    '{value1}’s chat ·': 'Klepet uporabnika {value1} ·',
    '{value1} ad {value2} available.': '{value1} in {value2} sta na voljo.',
    '{value1} rows ·': '{value1} vrstic ·',
    'It starts private. Sharing it wider shares every refresh, which can carry your private data.':
      'Na začetku je zasebno. Če ga delite širše, delite vsako osvežitev, pri čemer se lahko prenesejo vaši zasebni podatki.',
    'Enable this schedule when approved': 'Omogoči ta urnik po odobritvi',
    Schedule: 'Urnik',
    'Kept off until you create the agent from its canvas.':
      'Ostane izklopljen, dokler agenta ne ustvarite na njegovem platnu.',
    'Will be enabled when you approve.': 'Omogočen bo po vaši odobritvi.',
    'Will be saved paused. You can enable it later.':
      'Shranjen bo zaustavljen. Pozneje ga lahko omogočite.',
    'Only runs when you ask.': 'Zažene se samo na vašo zahtevo.',
    'Draft · approving saves it, and nothing runs. Test it and create it from its canvas.':
      'Osnutek · z odobritvijo ga shranite in nič se ne zažene. Preizkusite ga in ustvarite na njegovem platnu.',
    'Draft · nothing is scheduled until you approve. Connected actions require their own approval at run time.':
      'Osnutek · nič ni razporejeno, dokler ne odobrite. Povezana dejanja zahtevajo lastno odobritev ob zagonu.',
    Name: 'Ime',
    'Agent name': 'Ime agenta',
    'Who can use it': 'Kdo ga lahko uporablja',
    'Company agent · company resources only': 'Podjetniški agent · samo viri podjetja',
    'Personal agent · runs with your access': 'Osebni agent · uporablja se z vašim dostopom',
    'Approving saves it as a draft. It does not run automatically.':
      'Z odobritvijo ga shranite kot osnutek. Ne zažene se samodejno.',
    'Open the agent’s runs': 'Odpri zagone agenta',
    'Run the published version once': 'Enkrat zaženi objavljeno različico',
    'Stopping…': 'Zaustavljanje …',
    'Stop run': 'Zaustavi zagon',
    'Could not stop this run. Please try again.':
      'Tega zagona ni bilo mogoče zaustaviti. Poskusite znova.',
    'Run in progress': 'Zagon v teku',
    'This run is still answering. You can ask follow-ups when it finishes.':
      'Ta zagon še vedno odgovarja. Ko se konča, lahko postavite dodatna vprašanja.',
    'Open run details': 'Odpri podrobnosti zagona',
    Runs: 'Zagoni',
    'Open the run chat': 'Odpri klepet zagona',
    Watch: 'Ogled',
    Goal: 'Cilj',
    'Change the goal': 'Spremeni cilj',
    'What it does': 'Kaj počne',
    'What should this agent achieve?': 'Kaj naj ta agent doseže?',
    'Not set yet.': 'Še ni nastavljeno.',
    'When it runs': 'Kdaj se zažene',
    'Change when it runs': 'Spremeni čas zagona',
    'Off means it runs only when someone runs it. Changing when it runs never changes its instructions.':
      'Izklop pomeni, da se zažene samo, ko ga nekdo zažene. Sprememba časa zagona nikoli ne spremeni njegovih navodil.',
    Instructions: 'Navodila',
    'Change the instructions': 'Spremeni navodila',
    'How the agent should approach the work and make decisions.':
      'Kako naj se agent loti dela in sprejema odločitve.',
    Boundaries: 'Omejitve',
    'What to do or avoid. Every connected action still follows its approval.':
      'Kaj naj naredi ali čemu naj se izogne. Vsako povezano dejanje še vedno zahteva odobritev.',
    'No instructions of its own. It follows its Skills.':
      'Nima lastnih navodil. Upošteva svoje veščine.',
    'Pin a Skill': 'Pripni veščino',
    'Finds the Skills that fit each run, the same way a chat does.':
      'Za vsak zagon poišče ustrezne veščine, tako kot klepet.',
    'Skills it always follows': 'Veščine, ki jih vedno upošteva',
    'A Skill that is not published': 'Neobjavljena veščina',
    'Always follows · Version {value1}': 'Vedno upošteva · različica {value1}',
    'Not published': 'Ni objavljeno',
    Uses: 'Uporablja',
    'Change in chat': 'Spremeni v klepetu',
    'Change in chat: Uses': 'Spremeni v klepetu: Uporablja',
    'Company knowledge and the tools each run is allowed to use.':
      'Znanje podjetja in orodja, ki jih lahko uporablja posamezen zagon.',
    'People see the Result refresh; they change the agent, not the page.':
      'Uporabniki vidijo osvežen rezultat; spremenijo agenta, ne strani.',
    'The first run after it is created makes the Result; later runs add a version to it.':
      'Prvi zagon po ustvarjanju ustvari rezultat; poznejši zagoni mu dodajo različico.',
    'Emails whoever the run is for': 'Pošlje e-pošto osebi, za katero je zagon namenjen',
    'Email each run': 'Pošlji e-pošto za vsak zagon',
    Delivers: 'Dostavlja',
    'Change what it delivers': 'Spremeni, kaj dostavlja',
    'Expected result': 'Pričakovani rezultat',
    'What a successful run should deliver.': 'Kaj naj uspešen zagon dostavi.',
    'What each run delivers': 'Kaj dostavi posamezen zagon',
    'Keeps one Result up to date {value1}': 'En rezultat ohranja ažuren {value1}',
    'Saves a new Result each run': 'Ob vsakem zagonu shrani nov rezultat',
    'You can run this company agent as yourself.{value1} {value2}':
      'Ta podjetniški agent lahko zaženete kot sami.{value1} {value2}',
    'Changes since version': 'Spremembe od različice',
    'are not live yet.': 'še niso v veljavi.',
    'Review them in Versions': 'Preglejte jih v razdelku Različice',
    Skill: 'Veščina',
    'The agent always uses the Skill’s published version.':
      'Agent vedno uporablja objavljeno različico veščine.',
    Day: 'Dan',
    Time: 'Čas',
    'Cron expression': 'Izraz Cron',
    'Editors and access': 'Uredniki in dostop',
    Company: 'Podjetje',
    Personal: 'Osebno',
    'No changes.': 'Ni sprememb.',
    'Instructions changes': 'Spremembe navodil',
    'Loading versions…': 'Nalaganje različic …',
    'What the draft changes': 'Kaj spreminja osnutek',
    'No published version yet. Try the draft, then publish it.':
      'Objavljena različica še ne obstaja. Preizkusite osnutek in ga nato objavite.',
    'Published versions': 'Objavljene različice',
    'Former member': 'Nekdanji član',
    Live: 'Aktivno',
    '{value1} for {value2}': '{value1} za {value2}',
    Suggested: 'Predlagano',
    'Opening your conversation…': 'Odpiranje pogovora …',
    'This conversation isn’t available': 'Ta pogovor ni na voljo',
    'It may have been deleted, belong to another account, or be temporarily unavailable.':
      'Morda je bil izbrisan, pripada drugemu računu ali pa začasno ni na voljo.',
    '{count} more line — shown in the complete revision':
      '{count} dodatna vrstica — prikazana v celotni reviziji',
    '{count} more lines — shown in the complete revision':
      '{count} dodatnih vrstic — prikazanih v celotni reviziji',
    '{count} more line removed': 'Odstranjena je bila še {count} vrstica',
    '{count} more lines removed': 'Odstranjenih je bilo še {count} vrstic',
    '{count} unchanged line': '{count} nespremenjena vrstica',
    '{count} unchanged lines': '{count} nespremenjenih vrstic',
    '{count} more lines not shown, {added} added and {removed} removed. Check them in the complete revision.':
      'Še {count} vrstic ni prikazanih, dodanih je {added}, odstranjenih pa {removed}. Oglejte si jih v celotni reviziji.',
    'Saved result': 'Shranjen rezultat',
    'Made with a Skill': 'Ustvarjeno z veščino',
    'Preview of {name}': 'Predogled: {name}',
    'Made with {name}': 'Ustvarjeno z {name}',
    'Ad-hoc result': 'Rezultat po meri',
    'A Skill that is not available in this workspace':
      'Veščina, ki v tem delovnem prostoru ni na voljo',
    '{name} · Revision {version}': '{name} · revizija {version}',
    '{name} · Version {version}': '{name} · različica {version}',
    'Return to conversation {value1}': 'Vrnite se v pogovor {value1}',
    '{value1} Working with {value2}': '{value1} dela z {value2}',
    'View context {value1}': 'Prikaži kontekst {value1}',
    'A way of working, made yours.': 'Način dela, prilagojen vam.',
    'Work that runs itself.': 'Delo, ki se opravi samo.',
    'One place for one piece of work.': 'Eno mesto za posamezno delo.',
    'Let’s move your work forward{value1}.': 'Nadaljujmo vaše delo{value1}.',
    'Describe the work. Your Skill takes shape beside the conversation.':
      'Opišite delo. Vaša veščina se oblikuje ob pogovoru.',
    'Describe what it should do and when. Your agent takes shape beside the conversation. The draft does not run automatically.':
      'Opišite, kaj naj naredi in kdaj. Vaš agent se oblikuje ob pogovoru. Osnutek se ne zažene samodejno.',
    'Say what the work is. Poneva drafts the project beside the conversation and brings in what you have already done. Nothing is created until you say so.':
      'Povejte, za katero delo gre. Poneva pripravi osnutek projekta ob pogovoru in vključi, kar ste že naredili. Nič se ne ustvari, dokler tega ne potrdite.',
    'Start with an idea below. Poneva will take it from there.':
      'Začnite s spodnjo zamislijo. Poneva bo nadaljevala od tam.',
    Triggers: 'Sprožilci',
    'Review the agent and its trigger. Approval applies exactly what is shown.':
      'Preglejte agenta in njegov sprožilec. Z odobritvijo se natančno uveljavi prikazano.',
    '{source} · read {date}': '{source} · prebrano {date}',
    'Evidence is being recorded · read {date}': 'Dokazila se beležijo · prebrano {date}',
    'Evidence expired on {date} under the retention policy':
      'Dokazilo je {date} poteklo v skladu s pravilnikom o hrambi',
    'Entered by {person}': 'Vnesel/-la: {person}',
    'No retained evidence for this value': 'Za to vrednost ni shranjenih dokazil',
    'Covers {shown} of {total} rows': 'Zajema {shown} od {total} vrstic',
    'Search rows': 'Iskanje vrstic',
    'Clear filters': 'Počisti filtre',
    Sort: 'Razvrsti',
    'Sort: {column}': 'Razvrsti: {column}',
    '{shown} of {total} rows': '{shown} od {total} vrstic',
    More: 'Več',
    Density: 'Gostota',
    Comfortable: 'Udobno',
    Compact: 'Strnjeno',
    Columns: 'Stolpci',
    'No rows match. Clear the search or filters to see them again.':
      'Nobena vrstica se ne ujema. Počistite iskanje ali filtre, da jih znova prikažete.',
    'Not available': 'Ni na voljo',
    'All rows': 'Vse vrstice',
    'Close row detail': 'Zapri podrobnosti vrstice',
    'Ask about this row': 'Vprašaj o tej vrstici',
    'Add note': 'Dodaj opombo',
    Note: 'Opomba',
    Saved: 'Shranjeno',
    Total: 'Skupaj',
    ascending: 'naraščajoče',
    descending: 'padajoče',
    'Scroll to see all columns': 'Pomaknite se, da si ogledate vse stolpce',
    App: 'Aplikacija',
    Artifact: 'Artefakt',
    'New project': 'Nov projekt',
    'Review request': 'Zahteva za pregled',
    Activity: 'Dejavnost',
    'Voice preview': 'Predogled glasu',
    Source: 'Vir',
    File: 'Datoteka',
    Meeting: 'Sestanek',
    'Knowledge page': 'Stran znanja',
    'Could not preview this CSV.': 'Predogleda tega CSV-ja ni bilo mogoče prikazati.',
    'File content is unavailable.': 'Vsebina datoteke ni na voljo.',
    'You have five open suggestions here. {value1} will see them.':
      'Tukaj imate pet odprtih predlogov. {value1} jih bo videl.',
    'We could not send your suggestion. Please try again.':
      'Predloga ni bilo mogoče poslati. Poskusite znova.',
    'The agent': 'Agent',
    'Selected colleagues': 'Izbrani sodelavci',
    'The owner': 'Lastnik',
    'Forked. This copy is yours and runs with your own connections.':
      'Razvejano. Ta kopija je vaša in se izvaja z vašimi povezavami.',
    'This chat is too long to fork.': 'Ta klepet je predolg za razvejanje.',
    'We could not fork this chat. Please try again.':
      'Tega klepeta ni bilo mogoče razvejati. Poskusite znova.',
    'Anyone who forked it keeps their copy: forks stay with the people who made them.':
      'Vsak, ki ga je razvejal, obdrži svojo kopijo: razvejane kopije ostanejo pri osebah, ki so jih ustvarile.',
    'Nobody has forked this chat.': 'Nihče ni razvejal tega klepeta.',
    '1 person forked this chat. Their copy stays theirs.':
      'Klepet je razvejala 1 oseba. Njena kopija ostane njena.',
    '{value1} people forked this chat. Their copies stay theirs.':
      'Klepet je razvejalo {value1} oseb. Njihove kopije ostanejo njihove.',
    'Personal. Nobody else sees it.': 'Osebno. Nihče drug tega ne vidi.',
    'People you pick. They get it in their Inbox.':
      'Osebe, ki jih izberete. Prejmejo ga v mapo Prejeto.',
    'Everyone in the company can follow it and fork it.':
      'Vsi v podjetju mu lahko sledijo in ga razvejajo.',
    'a chat you can no longer open': 'klepet, ki ga ne morete več odpreti',
    'shared the Result': 'je delil rezultat',
    'updated the Result': 'je posodobil rezultat',
    'published the Skill': 'je objavil veščino',
    'approved the fact': 'je odobril dejstvo',
    'added the fact': 'je dodal dejstvo',
    'added the meeting': 'je dodal sestanek',
    'published the page': 'je objavil stran',
    'updated the page': 'je posodobil stran',
    'shared the chat': 'je delil klepet',
    'published a version of': 'je objavil različico',
    ran: 'je zagnal',
    Knowledge: 'Znanje',
    Meetings: 'Sestanki',
    Chat: 'Klepet',
    Use: 'Uporabi',
    Open: 'Odpri',
    You: 'Vi',
    Someone: 'Nekdo',
    'published version {version} of': 'je objavil različico {version} od',
    'thing needs': 'element potrebuje',
    'things need': 'elementi potrebujejo',
    'Published Skill': 'Objavljena veščina',
    'Included with Skill': 'Vključeno z veščino',
    'Already attached': 'Že pripeto',
    'Also available in company knowledge': 'Na voljo tudi v znanju podjetja',
    'Company file': 'Datoteka podjetja',
    'Account identity unavailable': 'Identiteta računa ni na voljo',
    'Access expired or was revoked. Reconnect to continue.':
      'Dostop je potekel ali bil preklican. Za nadaljevanje se znova povežite.',
    'Account authorized · tools unavailable': 'Račun je pooblaščen · orodja niso na voljo',
    'Not available in this workspace yet.': 'V tem delovnem prostoru še ni na voljo.',
    'Everyone in the company': 'Vsi v podjetju',
    'Audience: only you.': 'Občinstvo: samo vi.',
    'Audience: everyone in the company.': 'Občinstvo: vsi v podjetju.',
    'tool is': 'orodje je',
    'tools are': 'orodja so',
    'account is': 'račun je',
    'accounts are': 'računi so',
    'We could not upload this file.': 'Te datoteke ni bilo mogoče naložiti.',
    'file was': 'datoteka je bila',
    'files were': 'datotek je bilo',
    'Your company': 'Vaše podjetje',
    'Create an agent': 'Ustvari agenta',
    'Give recurring work a helping hand': 'Olajšajte ponavljajoče se delo',
    'Create a Skill': 'Ustvari veščino',
    'Save a reusable way of working': 'Shranite ponovljiv način dela',
    'Take meeting notes': 'Zapišite zapiske s sestanka',
    'Capture decisions and next steps': 'Zabeležite odločitve in naslednje korake',
    'Work with a file': 'Delajte z datoteko',
    'Start from a document or image': 'Začnite z dokumentom ali sliko',
    'Browse agents': 'Prebrskaj agente',
    'Open your agents and company agents': 'Odprite svoje agente in agente podjetja',
    'Review results': 'Preglejte rezultate',
    'Return to work saved in your Library': 'Vrnite se k delu, shranjenemu v Knjižnici',
    'For review': 'Za pregled',
    'An agent': 'Agent',
    Assistant: 'Pomočnik',
    'Kept up to date by {value1}{value2}': 'Posodablja {value1}{value2}',
    ', {value1}': ', {value1}',
    'Version {value1}{value2}{value3}': 'Različica {value1}{value2}{value3}',
    'Refreshed by its agent': 'Posodobil ga je njegov agent',
    'Saved from a chat': 'Shranjeno iz klepeta',
    'Saved from {value1}': 'Shranjeno iz aplikacije {value1}',
    Edited: 'Urejeno',
    'private account': 'zasebni račun',
    '{value1} ({value2})': '{value1} ({value2})',
    '{value1}’s {value2}': '{value2} uporabnika {value1}',
    'Made private. The person who added it and the owner of its recording have been told in their Inbox.':
      'Nastavljeno kot zasebno. Oseba, ki ga je dodala, in lastnik njegovega posnetka sta bila o tem obveščena v mapi Prejeto.',
    'Made private. The person who added it has been told in their Inbox.':
      'Nastavljeno kot zasebno. Oseba, ki ga je dodala, je bila o tem obveščena v mapi Prejeto.',
    'Made private. The owner of its recording has been told in their Inbox.':
      'Nastavljeno kot zasebno. Lastnik njegovega posnetka je bil o tem obveščen v mapi Prejeto.',
    'Selected passage': 'Izbrani odlomek',
    '{value1} {value2}': '{value1} {value2}',
    'Upload a file': 'Naloži datoteko',
    'Help me create a useful report from our company knowledge and available sources.':
      'Pomagaj mi ustvariti uporabno poročilo iz znanja našega podjetja in razpoložljivih virov.',
    'This saved work couldn’t be opened. Open it again to retry.':
      'Tega shranjenega dela ni bilo mogoče odpreti. Znova ga odprite in poskusite.',
    '{value1}’s': 'uporabnika {value1}',
    '{value1} chat “{value2}”': 'Klepet uporabnika {value1} »{value2}«',
    '{value1}{value2}': '{value1}{value2}',
    'Skill: {value1}{value2}': 'Veščina: {value1}{value2}',
    'Result “{value1}”': 'Rezultat »{value1}«',
    'Meeting “{value1}”': 'Sestanek »{value1}«',
    'Used in {value1} {value2} this week': 'Ta teden uporabljeno v {value1} {value2}',
    '{value1} {value2} · used in {value3} {value4}':
      '{value1} {value2} · uporabljeno v {value3} {value4}',
    'The draft is not published yet, so no one else follows it.':
      'Osnutek še ni objavljen, zato mu ne sledi nihče drug.',
    'Use it in a chat for current data, or refine the Skill first.':
      'Uporabite ga v klepetu za aktualne podatke ali najprej izboljšajte veščino.',
    'An agent keeps this up to date. Continue the work in chat.':
      'Agent to posodablja. Nadaljujte delo v klepetu.',
    'Edit it here, or continue the work in chat.':
      'Uredite ga tukaj ali nadaljujte delo v klepetu.',
    'Duplicate it to your Library, or continue the work in chat.':
      'Podvojite ga v Knjižnico ali nadaljujte delo v klepetu.',
    'Download Markdown': 'Prenesi Markdown',
    'Download CSV': 'Prenesi CSV',
    'an agent': 'agent',
    'Publish a Skill version': 'Objavi različico veščine',
    'Share with {value1}': 'Deli z: {value1}',
    'Update company content': 'Posodobi vsebino podjetja',
    Approved: 'Odobreno',
    Declined: 'Zavrnjeno',
    Pending: 'Čaka na obravnavo',
    'View decision': 'Ogled odločitve',
    'No data': 'Ni podatkov',
    'No change': 'Brez sprememb',
    'Connection created': 'Povezava je ustvarjena',
    'Sharing changed': 'Nastavitve deljenja so spremenjene',
    'Person added': 'Oseba je dodana',
    'Person removed': 'Oseba je odstranjena',
    'Access changed': 'Dostop je spremenjen',
    'Access turned off': 'Dostop je izklopljen',
    'Connection removed': 'Povezava je odstranjena',
    'Query time limit changed': 'Časovna omejitev poizvedbe je spremenjena',
    '{count} row': '{count} vrstica',
    '{count} rows': '{count} vrstic',
    'This source is no longer available. Company knowledge now lives in Knowledge pages, and files stay in the Library.':
      'Ta vir ni več na voljo. Znanje podjetja je zdaj na straneh Znanja, datoteke pa ostajajo v Knjižnici.',
    '· {value1} by {value2}': '· {value1} avtor {value2}',
    '· version {value1}': '· različica {value1}',
    '{message} {count} earlier file was saved and attached.':
      '{message} Shranjena in priložena je bila {count} prejšnja datoteka.',
    '{message} {count} earlier files were saved and attached.':
      '{message} Shranjenih in priloženih je bilo {count} prejšnjih datotek.',
    '{message} {count} earlier file was saved.':
      '{message} Shranjena je bila {count} prejšnja datoteka.',
    '{message} {count} earlier files were saved.':
      '{message} Shranjenih je bilo {count} prejšnjih datotek.',
    'refreshed {time}': 'osveženo {time}',
    'a colleague': 'sodelavec',
    'Your chat “{title}”': 'Vaš klepet »{title}«',
    '{name}’s chat “{title}”': 'Klepet uporabnika {name} »{title}«',
    'Kept up to date by {name}{version}': 'Posodablja {name}{version}',
    'Skill: {name}{version}': 'Veščina: {name}{version}',
    'Result “{title}”': 'Rezultat »{title}«',
    'Meeting “{title}”': 'Sestanek »{title}«',
    'Used in {count} answer this week': 'Uporabljeno v {count} odgovoru ta teden',
    'Used in {count} answers this week': 'Uporabljeno v {count} odgovorih ta teden',
    '{count} source': '{count} vir',
    '{count} sources': '{count} virov',
    'used in {count} place': 'uporabljeno na {count} mestu',
    'used in {count} places': 'uporabljeno na {count} mestih',
    '{company} workspace': '{company} delovni prostor',
    '{count} page': '{count} stran',
    '{count} pages': '{count} strani',
    '{needs} · reviews and approvals': '{needs} · pregledi in odobritve',
    '{count} thing needs you': '{count} stvar potrebuje vašo pozornost',
    '{count} things need you': '{count} stvari potrebujejo vašo pozornost',
    'Included with Skill · {files} · {sources} {icon}':
      'Vključeno v veščino · {files} · {sources} {icon}',
    '{count} file': '{count} datoteka',
    '{count} files': '{count} datotek',
    Today: 'Danes',
    'Earlier this week': 'Prej ta teden',
    '{count} slide': '{count} diapozitiv',
    '{count} slides': '{count} diapozitivov',
    Early: 'Zgodaj',
    'TLS verified': 'TLS preverjen',
    'Made personal and switched off. Switch it on when you are ready.':
      'Prilagojeno uporabniku in izklopljeno. Vklopite, ko boste pripravljeni.',
    'Made personal and switched off. Its owner is told which version is live.':
      'Prilagojeno uporabniku in izklopljeno. Lastniku bo sporočeno, katera različica je aktivna.',
    'Switched off.': 'Izklopljeno.',
    'Applied version {revision}.': 'Uporabljena različica {revision}.',
    'The draft is running in a chat only you can read.':
      'Osnutek se izvaja v klepetu, ki ga lahko berete samo vi.',
    'Publish a version first.': 'Najprej objavite različico.',
    'Another Agent action is in progress.': 'Poteka drugo dejanje agenta.',
    'Knowledge & connections': 'Znanje in povezave',
    'Pinned Skills': 'Pripete veščine',
    None: 'Brez',
    'A new Result each run': 'Nov rezultat ob vsakem zagonu',
    'One Result kept up to date': 'En rezultat, ki se posodablja',
    Email: 'E-pošta',
    On: 'Vklopljeno',
    Off: 'Izklopljeno',
    'Waiting for review': 'Čaka na pregled',
    Outdated: 'Zastarelo',
    Accepted: 'Sprejeto',
    Rejected: 'Zavrnjeno',
    Withdrawn: 'Um अवaknjeno',
    Replaced: 'Zamenjano',
    'Suggested edit': 'Predlagano urejanje',
    'Suggested new page': 'Predlagana nova stran',
    'Suggested move': 'Predlagan premik',
    'Suggested archive': 'Predlagano arhiviranje',
    'Checking status…': 'Preverjanje stanja…',
    'Status unavailable': 'Stanje ni na voljo',
    'Bulleted list': 'Označeni seznam',
    'Numbered list': 'Oštevilčeni seznam',
    'Web link': 'Spletna povezava',
    Read: 'Branje',
    Write: 'Pisanje',
    'shared with you': 'v skupni rabi z vami',
    'Getting an answer': 'Pridobivanje odgovora',
    '{name} is getting an answer': '{name} pripravlja odgovor',
    'We could not save. Please try again.': 'Shranjevanje ni uspelo. Poskusite znova.',
    'The new page could not be created.': 'Nove strani ni bilo mogoče ustvariti.',
    'We could not load this revision.': 'Te različice ni bilo mogoče naložiti.',
    'We could not restore this revision. Please try again.':
      'Te različice ni bilo mogoče obnoviti. Poskusite znova.',
    'We could not export this revision.': 'Te različice ni bilo mogoče izvoziti.',
    'We could not open this suggestion.': 'Tega predloga ni bilo mogoče odpreti.',
    'We could not do that. Please try again.': 'Tega ni bilo mogoče izvesti. Poskusite znova.',
    'We could not save your decision. Please try again.':
      'Vaše odločitve ni bilo mogoče shraniti. Poskusite znova.',
    'We could not restore this page. Please try again.':
      'Te strani ni bilo mogoče obnoviti. Poskusite znova.',
    'We could not export this page.': 'Te strani ni bilo mogoče izvoziti.',
    '{count} missed time merged.': 'Združen je bil {count} zamujen vnos.',
    '{count} missed times merged.': 'Združenih je bilo {count} zamujenih vnosov.',
    'About this project': 'O tem projektu',
  },
  es: {
    context: 'contexto',
    skills: 'habilidades',
    'Choose company context': 'Elegir contexto de la empresa',
    'Skills for this conversation': 'Habilidades para esta conversación',
    'Bring context into the conversation': 'Añadir contexto a la conversación',
    'Close context picker': 'Cerrar selector de contexto',
    'Filter company context': 'Filtrar contexto de la empresa',
    'Find a Skill…': 'Buscar una habilidad…',
    'Find a file…': 'Buscar un archivo…',
    'Available company context': 'Contexto disponible de la empresa',
    'No matching published Skills.': 'No hay habilidades publicadas que coincidan.',
    'No matching files.': 'No hay archivos que coincidan.',
    'Searching company work…': 'Buscando en el trabajo de la empresa…',
    'Try search again': 'Intentar buscar de nuevo',
    'Meaning search is temporarily limited. Showing available text matches.':
      'La búsqueda por significado está limitada temporalmente. Se muestran las coincidencias de texto disponibles.',
    'Load more matches': 'Cargar más coincidencias',
    '{value1} files attached. Remove an attachment to add another. Saved Skill references are included separately.':
      'Hay {value1} archivos adjuntos. Quita un archivo adjunto para añadir otro. Las referencias guardadas de las habilidades se incluyen por separado.',
    'Create a Skill in chat': 'Crear una habilidad en el chat',
    'Upload a company file': 'Subir un archivo de la empresa',
    'Company knowledge is always available to Poneva.':
      'El conocimiento de la empresa siempre está disponible para Poneva.',
    '{value1} was not connected': '{value1} no se conectó',
    Dismiss: 'Descartar',
    'Try connecting again': 'Intentar conectar de nuevo',
    Waiting: 'Esperando',
    Connected: 'Conectado',
    'Needs reconnecting': 'Es necesario volver a conectar',
    Connect: 'Conectar',
    '{value1}{value2} The provider’s account permissions still apply.':
      '{value1}{value2} Los permisos de la cuenta del proveedor siguen aplicándose.',
    'Last error: {value1}': 'Último error: {value1}',
    '{value1} {value2} ready.': '{value1} {value2} listo.',
    'Continue with my Meta app': 'Continuar con mi aplicación de Meta',
    Reconnect: 'Volver a conectar',
    Disconnect: 'Desconectar',
    'Remove attachment: {value1}': 'Quitar archivo adjunto: {value1}',
    'Saved in this Skill. Edit the Skill to change its references.':
      'Guardado en esta habilidad. Edita la habilidad para cambiar sus referencias.',
    'Remove Skill context': 'Quitar contexto de la habilidad',
    Refining: 'Perfeccionando',
    Previewing: 'Generando vista previa',
    Using: 'Usando',
    'Skill revision {value1}': 'Revisión de la habilidad {value1}',
    'a new Skill': 'una nueva habilidad',
    '{value1} Making a new agent {value2}': '{value1} Creando un nuevo agente {value2}',
    'Stop making a new agent in this chat': 'Dejar de crear un nuevo agente en este chat',
    'Saved Skill references': 'Referencias guardadas de la habilidad',
    'Included with Skill · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}':
      'Incluido con la habilidad · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}',
    'Selected Skill revision is unavailable. Select the Skill again to view its saved references.':
      'La revisión seleccionada de la habilidad no está disponible. Selecciona la habilidad de nuevo para ver sus referencias guardadas.',
    'Conversation attachments': 'Archivos adjuntos de la conversación',
    'Added for this conversation': 'Añadido para esta conversación',
    'Selected passage {value1}': 'Pasaje seleccionado {value1}',
    'We could not load your workspace.': 'No hemos podido cargar tu espacio de trabajo.',
    'The selected Skill is unavailable. Check its access or choose it again.':
      'La habilidad seleccionada no está disponible. Comprueba tu acceso o selecciónala de nuevo.',
    'Source saved privately and included in your knowledge search.':
      'Fuente guardada de forma privada e incluida en tu búsqueda de conocimiento.',
    'File saved privately to your library and attached to this message.':
      'Archivo guardado de forma privada en tu biblioteca y adjuntado a este mensaje.',
    'File saved privately to your library.': 'Archivo guardado de forma privada en tu biblioteca.',
    '{value1} {value2} earlier {value3} saved{value4}.':
      '{value1} {value2} anterior {value3} guardado{value4}.',
    'Extracted text for Poneva to read. Download the original for its layout, charts and images. Spreadsheet formulas show their saved results and are not recalculated.':
      'Texto extraído para que Poneva lo lea. Descarga el original para conservar su diseño, gráficos e imágenes. Las fórmulas de la hoja de cálculo muestran los resultados guardados y no se vuelven a calcular.',
    Esc: 'Esc',
    'Start something': 'Empezar algo',
    'Choose a file to work with': 'Elegir un archivo con el que trabajar',
    'Skills worth adding': 'Habilidades que vale la pena añadir',
    'Picked for you': 'Elegido para ti',
    'Reusable work grounded in your company knowledge.':
      'Trabajo reutilizable basado en el conocimiento de tu empresa.',
    'Ideas from your company context and recent work. Pick one to start.':
      'Ideas basadas en el contexto de tu empresa y en tu trabajo reciente. Elige una para empezar.',
    'Refresh suggested tasks': 'Actualizar tareas sugeridas',
    'Check for new company context.': 'Buscar nuevo contexto de la empresa.',
    'Check for new context. Ideas also refresh daily.':
      'Buscar nuevo contexto. Las ideas también se actualizan a diario.',
    Refresh: 'Actualizar',
    'Finding useful starting points…': 'Buscando puntos de partida útiles…',
    'Suggestions aren’t available right now. Try Refresh, or describe the work you want to do.':
      'Las sugerencias no están disponibles en este momento. Prueba a actualizar o describe el trabajo que quieres hacer.',
    'Loading the knowledge pages…': 'Cargando las páginas de conocimiento…',
    '{value1} All pages': '{value1} Todas las páginas',
    'The page is created.': 'La página se ha creado.',
    'Your new page is suggested. A publisher decides whether it is added.':
      'Tu nueva página se ha propuesto. Un editor decide si se añade.',
    'Company knowledge': 'Conocimiento de la empresa',
    'What Poneva knows about your company, page by page. Every change is kept.':
      'Lo que Poneva sabe sobre tu empresa, página por página. Se conserva cada cambio.',
    'Loading company knowledge…': 'Cargando el conocimiento de la empresa…',
    'Knowledge pages are not enabled in this workspace.':
      'Las páginas de conocimiento no están habilitadas en este espacio de trabajo.',
    'Ask your Poneva contact to switch them on for your company.':
      'Pide a tu contacto de Poneva que las active para tu empresa.',
    '{value1} Change the agent': '{value1} Cambiar el agente',
    '{value1} Continue in chat': '{value1} Continuar en el chat',
    'We could not load this item.': 'No se pudo cargar este elemento.',
    '{value1} canvas': '{value1} lienzo',
    'Loading {value1}…': 'Cargando {value1}…',
    '{value1} · Original retained': '{value1} · Original conservado',
    '{value1} {value2}{value3} · Added {value4}': '{value1} {value2}{value3} · Añadido {value4}',
    '{value1} Use in chat': '{value1} Usar en el chat',
    '{value1} Download': '{value1} Descargar',
    Table: 'Tabla',
    Chart: 'Gráfico',
    Original: 'Original',
    'Text extracted from the PDF, marked by page. Download the original for its layout and images.':
      'Texto extraído del PDF y marcado por página. Descarga el original para conservar su diseño e imágenes.',
    'This preview shows the beginning of the file. Poneva reads the whole file; download the original to see all of it.':
      'Esta vista previa muestra el principio del archivo. Poneva lee el archivo completo; descarga el original para verlo entero.',
    'Preview of the first {value1} complete rows. Filtering and charts use only this preview. Download the original for the full file.':
      'Vista previa de las primeras {value1} filas completas. Los filtros y gráficos solo usan esta vista previa. Descarga el original para ver el archivo completo.',
    'This source link cannot be opened.': 'No se puede abrir este enlace de origen.',
    'Read-only chat': 'Chat de solo lectura',
    'Only {value1} writes in this chat. Fork it to continue with your own connections. {value2}':
      'Solo {value1} puede escribir en este chat. Crea una bifurcación para continuar con tus propias conexiones. {value2}',
    'Suggest a follow-up…': 'Sugerir una continuación…',
    'Suggest a follow-up': 'Sugerir una continuación',
    'Sending…': 'Enviando…',
    Send: 'Enviar',
    'We could not dismiss that suggestion. Please try again.':
      'No se pudo descartar esa sugerencia. Inténtalo de nuevo.',
    'Suggested follow-ups': 'Continuaciones sugeridas',
    '{value1} suggests': '{value1} sugiere',
    Ask: 'Preguntar',
    'Dismiss {value1}’s suggestion': 'Descartar la sugerencia de {value1}',
    'Suggested by': 'Sugerido por',
    '· edit it or send it': '· edítalo o envíalo',
    'Remove the suggestion tag': 'Quitar la etiqueta de sugerencia',
    '{value1} {value2} is getting an answer': '{value1} {value2} está recibiendo una respuesta',
    '{value1} {value2} stopped the answer': '{value1} {value2} detuvo la respuesta',
    '{value1} Fork from here': '{value1} Crear una bifurcación desde aquí',
    '{value1} From {value2}’s {value3}': '{value1} Del {value3} de {value2}',
    'Only {value1} can use this account': 'Solo {value1} puede usar esta cuenta',
    '{value1} Suggested by {value2}': '{value1} Sugerido por {value2}',
    'Fork this chat': 'Crear una bifurcación de este chat',
    'Forking…': 'Creando bifurcación…',
    Fork: 'Bifurcar',
    'Could not make this private.': 'No se pudo hacer privado.',
    'Make this chat private?': '¿Hacer privado este chat?',
    Close: 'Cerrar',
    '{value1} will see “{value2}”. Everyone else loses access right away {value3} .{value4}':
      '{value1} verá “{value2}”. Todos los demás perderán el acceso de inmediato {value3} .{value4}',
    Cancel: 'Cancelar',
    'Saving…': 'Guardando…',
    'Make private': 'Hacer privado',
    'This chat is private again. Forks others made stay theirs.':
      'Este chat vuelve a ser privado. Las bifurcaciones que hayan creado otras personas seguirán siendo suyas.',
    'Who can read this chat: {value1}': 'Quién puede leer este chat: {value1}',
    'Move this chat': 'Mover este chat',
    'Only you write here. Others follow live and fork.':
      'Solo tú escribes aquí. Las demás personas siguen la conversación en directo y pueden crear bifurcaciones.',
    'Made private. {value1} has been told in their Inbox.':
      'Se ha hecho privado. Se ha avisado a {value1} en su bandeja de entrada.',
    'Chat access': 'Acceso al chat',
    '{value1}’s chat. As an admin you can make it private.':
      'Chat de {value1}. Como administrador, puedes hacerlo privado.',
    'Only {value1} will see it. {value2} is told.':
      'Solo {value1} podrá verlo. Se ha avisado a {value2}.',
    '{value1} {value2} following': '{value1} {value2} siguiendo',
    'Forked from{value1} {value2} . The history is copied. From here, tools run with your own access.':
      'Bifurcado de{value1} {value2} . El historial se ha copiado. A partir de aquí, las herramientas se ejecutan con tu propio acceso.',
    '{value1} made this chat private': '{value1} hizo privado este chat',
    'You can no longer open it. Any fork you made stays yours.':
      'Ya no puedes abrirlo. Cualquier bifurcación que hayas creado seguirá siendo tuya.',
    'Start a new chat': 'Iniciar un chat nuevo',
    'Back to Recent chats': 'Volver a Chats recientes',
    'More chat actions': 'Más acciones del chat',
    'Close conversation sharing': 'Cerrar el uso compartido de la conversación',
    'Review the text before saving a private copy to Library. Then choose its audience. Your original conversation and future messages stay private.':
      'Revisa el texto antes de guardar una copia privada en la Biblioteca. Después, elige quién podrá verla. Tu conversación original y los mensajes futuros seguirán siendo privados.',
    'Preparing the conversation…': 'Preparando la conversación…',
    'Refresh preview': 'Actualizar vista previa',
    'The copy is saved in Library. Use Share to choose who can access it.':
      'La copia se ha guardado en la Biblioteca. Usa Compartir para elegir quién puede acceder a ella.',
    'Save this copy': 'Guardar esta copia',
    'That Skill could not be opened.': 'No se pudo abrir esa habilidad.',
    '{value1}{value2} · reviews and approvals': '{value1}{value2} · revisiones y aprobaciones',
    'Open Inbox': 'Abrir bandeja de entrada',
    'New at {value1} this week': 'Novedades en {value1} esta semana',
    'Nothing new this week. Shared work, published Skills and approved knowledge show up here.':
      'No hay novedades esta semana. Aquí aparecen el trabajo compartido, las habilidades publicadas y los conocimientos aprobados.',
    'New at {value1}': 'Novedades en {value1}',
    'This Skill is unavailable. Try again.':
      'Esta habilidad no está disponible. Inténtalo de nuevo.',
    'You can attach up to {value1} files. Remove an attachment to add another.':
      'Puedes adjuntar hasta {value1} archivos. Quita un archivo adjunto para añadir otro.',
    'Add company context': 'Añadir contexto de la empresa',
    'Add company context · @': 'Añadir contexto de la empresa · @',
    'Choose a Skill': 'Elegir una habilidad',
    'Choose a Skill · /': 'Elegir una habilidad · /',
    Edit: 'Editar',
    '{value1} Edit with chat': '{value1} Editar con chat',
    '{value1} Duplicate to my Library': '{value1} Duplicar en mi biblioteca',
    'Duplicated to your Library. Only you can see the copy.':
      'Se duplicó en tu biblioteca. Solo tú puedes ver la copia.',
    'Could not duplicate this Result. Try again.':
      'No se pudo duplicar este resultado. Inténtalo de nuevo.',
    'Saved version {value1}.': 'Se guardó la versión {value1}.',
    'A newer version was saved. Reload the Result before saving.':
      'Se guardó una versión más reciente. Recarga el resultado antes de guardarlo.',
    'Could not save this version. Try again.':
      'No se pudo guardar esta versión. Inténtalo de nuevo.',
    '{value1} saved a newer version. Review it before saving.':
      '{value1} guardó una versión más reciente. Revísala antes de guardarla.',
    'Hide their version': 'Ocultar su versión',
    'Show their version': 'Mostrar su versión',
    'Start from their version': 'Empezar desde su versión',
    Markdown: 'Markdown',
    'Result text': 'Texto del resultado',
    Preview: 'Vista previa',
    'What changed': 'Qué cambió',
    'What changed? (optional)': '¿Qué cambió? (opcional)',
    'Save version {value1}': 'Guardar versión {value1}',
    'Open chat': 'Abrir chat',
    Current: 'Actual',
    Restore: 'Restaurar',
    'Could not load the history.': 'No se pudo cargar el historial.',
    'Restored version {value1} as version {value2}.':
      'La versión {value1} se restauró como versión {value2}.',
    'Someone saved a newer version. Review it before restoring.':
      'Alguien guardó una versión más reciente. Revísala antes de restaurarla.',
    'Could not restore that version.': 'No se pudo restaurar esa versión.',
    'Loading history…': 'Cargando historial…',
    'Restoring keeps what is there now as a version too, so nothing is lost.':
      'Al restaurar, lo que hay ahora también se conserva como una versión, así que no se pierde nada.',
    'This Result was made with your own {value1}.':
      'Este resultado se creó con tu propio {value1}.',
    'It also used': 'También usó',
    'This Result was made with': 'Este resultado se creó con',
    'Colleagues can read what came from them, but can never use them.':
      'Tus colegas pueden leer lo que provino de ellos, pero nunca pueden usarlo.',
    'Your personal agent {value1} keeps it up to date with your own access, so every refresh can carry your private data.':
      'Tu agente personal {value1} lo mantiene actualizado con tus propios permisos, por lo que cada actualización puede incluir tus datos privados.',
    'A colleague’s personal agent keeps it up to date with their own access, so every refresh can carry their private data.':
      'El agente personal de un colega lo mantiene actualizado con sus propios permisos, por lo que cada actualización puede incluir sus datos privados.',
    'Made private. Only you can see this meeting.':
      'Se hizo privado. Solo tú puedes ver esta reunión.',
    'Could not make this meeting private.': 'No se pudo hacer privada esta reunión.',
    'Meeting · {value1} {value2} · Original retained':
      'Reunión · {value1} {value2} · Original conservado',
    'The recording could not be opened.': 'No se pudo abrir la grabación.',
    'Ask about this suggestion': 'Preguntar sobre esta sugerencia',
    meeting_processing_failed: 'error_al_procesar_la_reunión',
    'Who can see this': 'Quién puede ver esto',
    'Everyone at {value1}': 'Todas las personas de {value1}',
    'Only me': 'Solo yo',
    'Everyone at {value1} can find it and ask about it.':
      'Todas las personas de {value1} pueden encontrarlo y preguntar sobre ello.',
    'Only you can open and search this meeting. You can share it later.':
      'Solo tú puedes abrir y buscar en esta reunión. Puedes compartirla más adelante.',
    'Added. Only you can see it. Transcription is running in the background.':
      'Añadido. Solo tú puedes verlo. La transcripción se está ejecutando en segundo plano.',
    'Visible to everyone at {value1}': 'Visible para todas las personas de {value1}',
    'Could not make it private.': 'No se pudo hacer privado.',
    'Show more meetings': 'Mostrar más reuniones',
    'Attached to this message': 'Adjunto a este mensaje',
    'Connect securely, choose the tables to share, then decide whether Poneva can read or make changes.':
      'Conéctate de forma segura, elige las tablas que quieres compartir y decide si Poneva puede leerlas o hacer cambios.',
    'Review the tables this connection can access. Select at least one table.':
      'Revisa las tablas a las que puede acceder esta conexión. Selecciona al menos una tabla.',
    'Select at least one table. Nothing is selected by default.':
      'Selecciona al menos una tabla. De forma predeterminada, no se selecciona ninguna.',
    'Choose who can use this connection and what Poneva can do.':
      'Elige quién puede usar esta conexión y qué puede hacer Poneva.',
    'Your chosen access is enabled for the selected tables.':
      'El acceso que elegiste está habilitado para las tablas seleccionadas.',
    'Your connection is saved with reading paused until permission is confirmed.':
      'Tu conexión se guardó con la lectura pausada hasta que se confirme el permiso.',
    'Confirm database disconnect': 'Confirmar desconexión de la base de datos',
    'Disconnect this database?': '¿Desconectar esta base de datos?',
    'Access will stop for everyone using this connection.':
      'El acceso se interrumpirá para todas las personas que usen esta conexión.',
    'Keep connection': 'Conservar conexión',
    'What it can reach · {value1}{value2} {value3}':
      'Qué puede alcanzar · {value1}{value2} {value3}',
    Back: 'Atrás',
    Continue: 'Continuar',
    'Uploading…': 'Subiendo…',
    Library: 'Biblioteca',
    'Source material for your work. Available whenever you need it.':
      'Material de referencia para tu trabajo. Disponible cuando lo necesites.',
    'The work you want to keep, with its sources and conversation attached.':
      'El trabajo que quieres conservar, con sus fuentes y conversación adjuntas.',
    Results: 'Resultados',
    Files: 'Archivos',
    Artifacts: 'Artefactos',
    'Search library': 'Buscar en la biblioteca',
    'Find files by meaning…': 'Buscar archivos por significado…',
    'Find saved work by meaning…': 'Buscar trabajo guardado por significado…',
    'Search coverage is limited while indexing or meaning-based search is unavailable. You can retry or browse recent items.':
      'La cobertura de búsqueda es limitada mientras se indexa el contenido o la búsqueda por significado no está disponible. Puedes volver a intentarlo o explorar los elementos recientes.',
    'No matching work found.': 'No se encontró ningún trabajo coincidente.',
    'A starting point for your next question.': 'Un punto de partida para tu próxima pregunta.',
    'Good work is worth keeping.': 'El buen trabajo merece conservarse.',
    'Try a different description or clear the search to browse.':
      'Prueba con otra descripción o borra la búsqueda para explorar.',
    'Upload source material once and use it in conversations and Skills. Your original stays in the library.':
      'Sube el material de referencia una vez y úsalo en conversaciones y Habilidades. El original permanece en la biblioteca.',
    'Ask Poneva to save an answer, table or chart. Results stay connected to the conversation and their sources.':
      'Pide a Poneva que guarde una respuesta, tabla o gráfico. Los resultados permanecen conectados a la conversación y a sus fuentes.',
    'Start in chat {value1}': 'Empezar en el chat {value1}',
    'Open result: {value1}': 'Abrir resultado: {value1}',
    'Loading more library items…': 'Cargando más elementos de la biblioteca…',
    'Load more': 'Cargar más',
    'Documents, transcripts, audio and video · Up to 500 MB per file. New files are private. Choose their audience with Share and which processable files become searchable company knowledge.':
      'Documentos, transcripciones, audio y vídeo · Hasta 500 MB por archivo. Los archivos nuevos son privados. Elige su audiencia con Compartir y qué archivos procesables se convierten en conocimiento de la empresa consultable.',
    Skills: 'Habilidades',
    'Create in chat': 'Crear en el chat',
    'Search Skills': 'Buscar habilidades',
    'Search finds published Skills. Clear the search to browse your drafts too.':
      'La búsqueda encuentra habilidades publicadas. Borra la búsqueda para explorar también tus borradores.',
    'Search coverage is limited while indexing or meaning-based search is unavailable.':
      'La cobertura de búsqueda es limitada mientras la indexación o la búsqueda basada en significado no estén disponibles.',
    'Searching Skills…': 'Buscando habilidades…',
    'No matching published Skills found. Try a different description.':
      'No se encontraron habilidades publicadas coincidentes. Prueba con otra descripción.',
    'Load more Skills': 'Cargar más habilidades',
    'View Skill: {value1}': 'Ver habilidad: {value1}',
    'Company workspace': 'Espacio de trabajo de la empresa',
    'View {value1}': 'Ver {value1}',
    'Loading Skills…': 'Cargando habilidades…',
    'Try again {value1}': 'Intentar de nuevo {value1}',
    'Try again': 'Intentar de nuevo',
    'Nothing yet.': 'Aún no hay nada.',
    'Made from · Used by': 'Creado a partir de · Usado por',
    'Could not load links': 'No se pudieron cargar los enlaces',
    'Made from': 'Creado a partir de',
    'Used by': 'Usado por',
    'About this chat {value1}': 'Acerca de este chat {value1}',
    'About this chat': 'Acerca de este chat',
    'Keep the work moving.': 'Mantén el trabajo en marcha.',
    'Ask a follow-up with this result in view, or turn a useful approach into a company Skill.':
      'Haz una pregunta de seguimiento con este resultado a la vista o convierte un enfoque útil en una habilidad de la empresa.',
    'Save approach as a Skill': 'Guardar enfoque como habilidad',
    'Preview of': 'Vista previa de',
    'Made with': 'Creado con',
    'Open the draft': 'Abrir el borrador',
    'Open Skill': 'Abrir habilidad',
    'Use in chat': 'Usar en el chat',
    'Finish the draft': 'Terminar el borrador',
    'Refine this Skill': 'Perfeccionar esta habilidad',
    'Made with a Skill.': 'Creado con una habilidad.',
    'This workspace could not be loaded just now, so that Skill cannot be opened yet. The result itself is unchanged.':
      'No se ha podido cargar este espacio de trabajo ahora, por lo que la habilidad aún no se puede abrir. El resultado no ha cambiado.',
    'That Skill is not available in this workspace, so it cannot be opened or used again. The result itself is unchanged.':
      'Esa habilidad no está disponible en este espacio de trabajo, por lo que no se puede abrir ni volver a usar. El resultado no ha cambiado.',
    'Result · {value1} {value2}': 'Resultado · {value1} {value2}',
    '{value1} Copy link': '{value1} Copiar enlace',
    'Result link copied.': 'Enlace del resultado copiado.',
    'Could not copy the link. Use your browser address bar.':
      'No se pudo copiar el enlace. Usa la barra de direcciones del navegador.',
    'No preview is available for this result.':
      'No hay ninguna vista previa disponible para este resultado.',
    '{value1} rows are retained in this snapshot. Open Table to inspect the values.':
      'Esta instantánea conserva {value1} filas. Abre Tabla para inspeccionar los valores.',
    'People can’t edit a Result an agent keeps up to date; the next refresh would replace their edit. Change the agent’s instructions instead.':
      'No se puede editar un resultado que un agente mantiene actualizado; la próxima actualización reemplazaría los cambios. Cambia las instrucciones del agente.',
    'Linked sources': 'Fuentes vinculadas',
    'Saved source': 'Fuente guardada',
    'No source documents are linked to this result. Company knowledge and other references may be cited in the answer.':
      'No hay documentos fuente vinculados a este resultado. La respuesta puede citar conocimiento de la empresa y otras referencias.',
    'Run details': 'Detalles de la ejecución',
    Created: 'Creado',
    ', revised {value1}': ', revisado {value1}',
    Conversation: 'Conversación',
    'Not recorded': 'No registrada',
    'Open conversation': 'Abrir conversación',
    Run: 'Ejecución',
    Updates: 'Actualizaciones',
    'Kept up to date by {value1}': 'Mantenido actualizado por {value1}',
    'Version {value1}': 'Versión {value1}',
    'Could not open this request.': 'No se pudo abrir esta solicitud.',
    'Approved version published.': 'Versión aprobada publicada.',
    'Request rejected. The item stays unchanged.': 'Solicitud rechazada. El elemento no cambia.',
    'Could not save the decision.': 'No se pudo guardar la decisión.',
    'Proposed company change': 'Cambio propuesto en la empresa',
    'Opening…': 'Abriendo…',
    'Approve this version': 'Aprobar esta versión',
    Decline: 'Rechazar',
    'Review the submitted version below. Changes made since submission will need a new request.':
      'Revisa abajo la versión enviada. Los cambios realizados después del envío requerirán una nueva solicitud.',
    'The version submitted with this request.': 'La versión enviada con esta solicitud.',
    'Version and proposed change': 'Versión y cambio propuesto',
    'Could not read the pinned content.': 'No se pudo leer el contenido fijado.',
    'Showing a page of {value1} characters.': 'Se muestra una página de {value1} caracteres.',
    'Beginning of the submitted content. Open the full text to review every page.':
      'Inicio del contenido enviado. Abre el texto completo para revisar todas las páginas.',
    'Read full submitted text': 'Leer el texto completo enviado',
    'Previous page': 'Página anterior',
    'Next page': 'Página siguiente',
    'Made private. Its creator has been told in their Inbox.':
      'Se ha hecho privado. Se ha informado a su creador en su bandeja de entrada.',
    'Made private. Its creator could not be notified.':
      'Se ha hecho privado. No se pudo notificar a su creador.',
    'Make this {value1} private?': '¿Hacer privado este elemento: {value1}?',
    'Only the person who created it will see it. Everyone else loses access right away, and its creator gets an Inbox update if they are still a company member. If they have left, nobody in the company will be able to access this item.':
      'Solo lo verá la persona que lo creó. Todos los demás perderán el acceso de inmediato y su creador recibirá una actualización en la bandeja de entrada si aún es miembro de la empresa. Si se ha marchado, nadie de la empresa podrá acceder a este elemento.',
    'Sent for review. The current audience stays unchanged until approval.':
      'Enviado para revisión. La audiencia actual no cambia hasta su aprobación.',
    'This suggestion is no longer available to you.':
      'Esta sugerencia ya no está disponible para ti.',
    'We could not check where this suggestion stands.':
      'No pudimos comprobar el estado de esta sugerencia.',
    'Check again': 'Comprobar de nuevo',
    'Show on page': 'Mostrar en la página',
    'The editor could not be loaded. Poneva may have been updated since you opened this page. Reload to get the latest version; nothing on this page has changed.':
      'No se pudo cargar el editor. Es posible que Poneva se haya actualizado desde que abriste esta página. Recarga para obtener la última versión; nada de esta página ha cambiado.',
    'Reload Poneva': 'Recargar Poneva',
    Formatting: 'Formato',
    'Text style': 'Estilo de texto',
    Text: 'Texto',
    Heading: 'Encabezado',
    Subheading: 'Subencabezado',
    'Link a page': 'Vincular una página',
    'A page needs a title.': 'La página necesita un título.',
    'Nothing has changed yet.': 'Todavía no ha cambiado nada.',
    'A page needs some text. To remove a page, archive it instead.':
      'La página necesita texto. Para quitarla, archívala.',
    'A suggested new page needs some text.': 'Una página nueva sugerida necesita texto.',
    'This page is larger than 256 KB. Split it into smaller pages.':
      'Esta página supera los 256 KB. Divídela en páginas más pequeñas.',
    'Say in a few words why this change is right.':
      'Explica brevemente por qué este cambio es adecuado.',
    'This page changed while you were editing. Your text is still here: copy it, then open the latest version and make your change again.':
      'Esta página cambió mientras la editabas. Tu texto sigue aquí: cópialo, abre la última versión y vuelve a hacer el cambio.',
    'Your text is copied.': 'Tu texto se ha copiado.',
    'Your text could not be copied. Select it in the editor and copy it.':
      'No se pudo copiar tu texto. Selecciónalo en el editor y cópialo.',
    'The page “{value1}” is created.': 'Se ha creado la página “{value1}”.',
    'New page': 'Página nueva',
    'Editing {value1}': 'Editando {value1}',
    Editing: 'Editando',
    'Creating publishes the page under {value1} for everyone':
      'Al crearla, la página se publicará debajo de {value1} para todos',
    'Saving publishes the new version for everyone':
      'Al guardar, la nueva versión se publicará para todos',
    'Your changes are sent as a suggestion for a publisher':
      'Tus cambios se envían como sugerencia a la persona responsable de publicar',
    'Create page': 'Crear página',
    Save: 'Guardar',
    'Send suggestion': 'Enviar sugerencia',
    '{value1} Copy my text': '{value1} Copiar mi texto',
    'Open the latest version': 'Abrir la última versión',
    'Page title': 'Título de la página',
    'Loading the editor…': 'Cargando el editor…',
    'New page text': 'Texto de la página nueva',
    'Text of {value1}': 'Texto de {value1}',
    'Write the page. Type [[ to link another page.':
      'Escribe la página. Escribe [[ para vincular otra página.',
    'Type [[ to link another page.': 'Escribe [[ para vincular otra página.',
    'Link to a page': 'Vincular a una página',
    'What changed, in a few words': 'Qué ha cambiado, brevemente',
    'Where this comes from, in a few words': 'De dónde procede, brevemente',
    'Shown in the page history.': 'Se muestra en el historial de la página.',
    'A publisher sees this next to your change.':
      'La persona responsable de publicar lo verá junto a tu cambio.',
    '1 suggestion is open on this page': 'Hay 1 sugerencia abierta en esta página',
    '{value1} suggestions are open on this page':
      'Hay {value1} sugerencias abiertas en esta página',
    'They stay open while you edit. After you save, they show against your new text; one whose words you changed is marked outdated.':
      'Siguen abiertas mientras editas. Después de guardar, se mostrarán junto a tu nuevo texto; las que hayas modificado se marcarán como obsoletas.',
    'Type [[ to link another page. Links keep working when a page is renamed or moved.':
      'Escribe [[ para vincular otra página. Los vínculos siguen funcionando aunque se cambie el nombre o se mueva una página.',
    'Loading the history…': 'Cargando el historial…',
    'This page has no saved text yet.': 'Esta página todavía no tiene texto guardado.',
    'Say in a few words why this revision should come back.':
      'Explica brevemente por qué debería recuperarse esta revisión.',
    'Revision {value1} is suggested for a publisher to accept.':
      'Se sugiere la revisión {value1} para que la acepte la persona responsable de publicar.',
    'The page already reads like this revision.':
      'La página ya tiene el contenido de esta revisión.',
    'Revision {value1} is restored as revision {value2}.':
      'La revisión {value1} se ha restaurado como revisión {value2}.',
    'Revision history': 'Historial de revisiones',
    Revisions: 'Revisiones',
    'Every saved revision is kept.': 'Se conservan todas las revisiones guardadas.',
    'Revision {value1} {value2}': 'Revisión {value1} {value2}',
    'Revision {value1} compared with revision {value2}':
      'Revisión {value1} comparada con la revisión {value2}',
    'Revision {value1}, the first text of this page':
      'Revisión {value1}, el primer texto de esta página',
    'Green was added, struck through was removed.':
      'El texto en verde se añadió; el texto tachado se eliminó.',
    '{value1} Export Markdown': '{value1} Exportar Markdown',
    'Restore this revision': 'Restaurar esta revisión',
    'Suggest restoring it': 'Sugerir su restauración',
    'Why should this revision come back?': '¿Por qué debería recuperarse esta revisión?',
    'Loading this revision…': 'Cargando esta revisión…',
    'Only the title changed, from “{value1}” to “{value2}”.':
      'Solo cambió el título, de “{value1}” a “{value2}”.',
    'The text did not change in this revision.': 'El texto no cambió en esta revisión.',
    'Changes in revision {value1}': 'Cambios en la revisión {value1}',
    'Loading page…': 'Cargando la página…',
    'Loading suggestion…': 'Cargando la sugerencia…',
    'This suggestion is not available.': 'Esta sugerencia no está disponible.',
    'It may have been decided, or it is not one you can see.':
      'Es posible que ya se haya decidido sobre ella o que no tengas acceso para verla.',
    'Open Knowledge': 'Abrir Knowledge',
    'Opening the suggestion…': 'Abriendo la sugerencia…',
    'Choose where the page goes.': 'Elige dónde colocar la página.',
    'Say in a few words why.': 'Explica brevemente por qué.',
    'Your suggestion is sent. A publisher decides.':
      'Tu sugerencia se ha enviado. La persona responsable de publicar decidirá.',
    'Moved under {value1}.': 'Se ha movido debajo de {value1}.',
    'Deleted “{value1}”.': 'Se ha eliminado “{value1}”.',
    'Could not update sharing.': 'No se pudo actualizar el uso compartido.',
    'They can follow new answers live and fork it to continue with their own connections. Only you write here. You can make it private again at any time.':
      'Pueden seguir las nuevas respuestas en directo y bifurcarlo para continuar con sus propias conexiones. Solo tú puedes escribir aquí. Puedes volver a hacerlo privado en cualquier momento.',
    'They see the project, its brief and the work in it they can already open. Nothing in it opens for anyone because of the project; each item keeps its own access.':
      'Ven el proyecto, su descripción y el trabajo que ya pueden abrir. Nada se abre para nadie por pertenecer al proyecto; cada elemento conserva su propio acceso.',
    'Check the content for private information before sharing. Sharing an item does not grant access to its original chat or private connections.':
      'Comprueba que el contenido no incluya información privada antes de compartirlo. Compartir un elemento no concede acceso a su chat original ni a sus conexiones privadas.',
    '{value1} Everyone you share with can read it, including what the assistant or an App in it found in your {value2}. They can’t use your {value3}. Nothing changes for you: the chat keeps working with all your accounts.':
      '{value1} Todas las personas con las que lo compartas podrán leerlo, incluido lo que el asistente o una Aplicación hayan encontrado en tu {value2}. No podrán usar tu {value3}. Para ti no cambia nada: el chat seguirá funcionando con todas tus cuentas.',
    '{value1} Everyone you share with can read them, but nobody can use {value2} through this chat.':
      '{value1} Todas las personas con las que los compartas podrán leerlos, pero nadie podrá usar {value2} a través de este chat.',
    'This controls access to the working draft. Any published company version stays available until you explicitly unpublish it. To publish a new version, complete its preview and use Save Skill. Run results stay private.':
      'Esto controla el acceso al borrador de trabajo. Cualquier versión de la empresa que esté publicada seguirá disponible hasta que la retires explícitamente. Para publicar una versión nueva, completa su vista previa y usa Guardar habilidad. Los resultados de las ejecuciones siguen siendo privados.',
    'Skill deleted. You can restore it from the Skills archive for 30 days.':
      'Habilidad eliminada. Puedes restaurarla desde el archivo de Habilidades durante 30 días.',
    'Could not delete this Skill.': 'No se pudo eliminar esta habilidad.',
    'More actions': 'Más acciones',
    'Delete “{value1}”? It will disappear from Skills and search, and cannot be used by agents. You can restore it for 30 days. Existing chats and results stay available.':
      '¿Eliminar “{value1}”? Desaparecerá de Habilidades y de la búsqueda, y los agentes no podrán usarla. Puedes restaurarla durante 30 días. Los chats y resultados existentes seguirán disponibles.',
    'Deleting…': 'Eliminando…',
    'Confirm delete': 'Confirmar eliminación',
    'Delete Skill': 'Eliminar habilidad',
    'Skill restored as an unpublished draft. Its author can review and publish it again.':
      'La habilidad se restauró como borrador no publicado. Su autor puede revisarla y volver a publicarla.',
    'Could not restore this Skill.': 'No se pudo restaurar esta habilidad.',
    'Archived Skills': 'Habilidades archivadas',
    'Deleted Skills can be restored for 30 days. Restoring leaves them unpublished.':
      'Las habilidades eliminadas se pueden restaurar durante 30 días. Al restaurarlas, permanecen sin publicar.',
    'Restore until {value1}': 'Restaurar hasta {value1}',
    'Loading…': 'Cargando…',
    'No archived Skills.': 'No hay habilidades archivadas.',
    'Load more archived Skills': 'Cargar más habilidades archivadas',
    'Show more of the original': 'Mostrar más del original',
    'Filter result rows': 'Filtrar filas de resultados',
    'Find a product or value…': 'Buscar un producto o valor…',
    '{value1} of {value2}': '{value1} de {value2}',
    'Result table': 'Tabla de resultados',
    'No matching rows.': 'No hay filas coincidentes.',
    'Showing the first 1,000 matching rows. Download the CSV for every row.':
      'Se muestran las primeras 1.000 filas coincidentes. Descarga el CSV para ver todas las filas.',
    'Agent ·': 'Agente ·',
    'Only you': 'Solo tú',
    'Stopped before it finished.': 'Se detuvo antes de terminar.',
    'Drafting the project…': 'Redactando el proyecto…',
    'Checking where this chat belongs…': 'Comprobando dónde pertenece este chat…',
    'Moving the chat…': 'Moviendo el chat…',
    'Taking it out of the project…': 'Sacándolo del proyecto…',
    'Adding it to the project…': 'Añadiéndolo al proyecto…',
    'No matching connections are available right now.':
      'No hay conexiones coincidentes disponibles en este momento.',
    'Company knowledge suggestion': 'Sugerencia de conocimiento de la empresa',
    'Company knowledge now lives on pages. Open Knowledge to see them.':
      'El conocimiento de la empresa ahora está en páginas. Abre Conocimiento para verlo.',
    '{value1} · Open beside this conversation': '{value1} · Abrir junto a esta conversación',
    'Name {value1}': 'Nombre {value1}',
    'Host {value1}': 'Servidor {value1}',
    'Port {value1}': 'Puerto {value1}',
    'Database {value1}': 'Base de datos {value1}',
    'Username {value1}': 'Nombre de usuario {value1}',
    'Password {value1}': 'Contraseña {value1}',
    'Advanced TLS': 'TLS avanzado',
    '{value1} Poneva verifies the server certificate. Add a CA or server DNS name for IP hosts when your certificate requires it.':
      '{value1} Poneva verifica el certificado del servidor. Añade una CA o un nombre DNS del servidor para hosts con IP cuando el certificado lo requiera.',
    'CA certificate {value1}': 'Certificado de CA {value1}',
    'Certificate server DNS name {value1}': 'Nombre DNS del servidor del certificado {value1}',
    '{value1} Your password is encrypted in secure storage. Poneva verifies the connection before saving it.':
      '{value1} Tu contraseña está cifrada en un almacenamiento seguro. Poneva verifica la conexión antes de guardarla.',
    'Testing…': 'Probando…',
    'Test connection': 'Probar conexión',
    'PostgreSQL is connected.': 'PostgreSQL está conectado.',
    'PostgreSQL was saved safely.': 'PostgreSQL se guardó de forma segura.',
    'Poneva can read and change rows in the selected tables. Apps also follow their approved data scope.':
      'Poneva puede leer y modificar filas en las tablas seleccionadas. Las Aplicaciones también respetan el alcance de datos aprobado.',
    'Poneva can read the selected tables. Apps also follow their approved data scope.':
      'Poneva puede leer las tablas seleccionadas. Las Aplicaciones también respetan el alcance de datos aprobado.',
    'Reads are paused until permission is enabled.':
      'Las lecturas están pausadas hasta que se habilite el permiso.',
    'Retrying…': 'Reintentando…',
    'Retry permission': 'Reintentar permiso',
    'Try it in Chat': 'Probarlo en Chat',
    Done: 'Listo',
    'Disconnect database': 'Desconectar base de datos',
    '{value1} TLS verified ·{value2} {value3}': '{value1} TLS verificado ·{value2} {value3}',
    'Search schemas and tables': 'Buscar esquemas y tablas',
    'Search tables': 'Buscar tablas',
    '{value1} of {value2} tables selected': '{value1} de {value2} tablas seleccionadas',
    'Select matching tables': 'Seleccionar tablas coincidentes',
    'Select all tables': 'Seleccionar todas las tablas',
    Clear: 'Borrar',
    'Select a whole schema or individual tables. New tables need a fresh selection.':
      'Selecciona un esquema completo o tablas individuales. Las tablas nuevas requieren una selección nueva.',
    'No tables match this search.': 'Ninguna tabla coincide con esta búsqueda.',
    'All tables in {value1}': 'Todas las tablas de {value1}',
    '{value1} / {value2} tables': '{value1} / {value2} tablas',
    'Read & write available': 'Lectura y escritura disponibles',
    'Read only': 'Solo lectura',
    Ctrl: 'Ctrl',
    'This suggested knowledge update could not be shown.':
      'No se pudo mostrar esta actualización de conocimiento sugerida.',
    'Suggested knowledge update': 'Actualización de conocimiento sugerida',
    'Archived. Its history is kept.': 'Archivada. Su historial se conserva.',
    'Choose the page it goes under. Links to it keep working.':
      'Elige la página bajo la que irá. Los enlaces seguirán funcionando.',
    'Its text, its history and any open suggestions are removed for good, and links to it from other pages stop working. This cannot be undone.':
      'Su texto, su historial y cualquier sugerencia abierta se eliminan para siempre, y los enlaces a ella desde otras páginas dejan de funcionar. Esta acción no se puede deshacer.',
    'An archived page no longer informs answers. Its history is kept, and a publisher can restore it or delete it permanently.':
      'Una página archivada ya no influye en las respuestas. Su historial se conserva y un publicador puede restaurarla o eliminarla permanentemente.',
    Under: 'Bajo',
    Change: 'Cambiar',
    'Move under': 'Mover bajo',
    'Search pages': 'Buscar páginas',
    'Why?': '¿Por qué?',
    'Delete permanently': 'Eliminar permanentemente',
    'Move page': 'Mover página',
    'Archive page': 'Archivar página',
    'Suggestion {value1}: show its card': 'Sugerencia {value1}: mostrar su tarjeta',
    'Removed:': 'Eliminado:',
    'Added:': 'Añadido:',
    'New page “{value1}”{value2}': 'Nueva página “{value1}”{value2}',
    'No pages match “{value1}”.': 'Ninguna página coincide con “{value1}”.',
    'Where this page is': 'Dónde está esta página',
    'Describe your company': 'Describe tu empresa',
    'Empty page': 'Página vacía',
    'Describe {value1}': 'Describe {value1}',
    'This page has no text yet.': 'Esta página aún no tiene texto.',
    'Poneva reads this page before every answer. Start with who you are, what you sell and how you work; details go on the pages under it.':
      'Poneva lee esta página antes de cada respuesta. Empieza por quién eres, qué vendes y cómo trabajas; añade los detalles en las páginas que dependen de ella.',
    'Write it, or ask Poneva in chat to draft it for you.':
      'Escríbelo o pídele a Poneva en el chat que prepare un borrador.',
    'Suggest a first version, and a publisher decides whether it becomes the page.':
      'Sugiere una primera versión y un publicador decidirá si se convierte en la página.',
    'Start writing': 'Empezar a escribir',
    'Suggest a first version': 'Sugerir una primera versión',
    'Accepted. The page is archived.': 'Aceptado. La página está archivada.',
    'Accepted. The page is now revision {value1}.':
      'Aceptado. La página ahora es la revisión {value1}.',
    'Accepted.': 'Aceptado.',
    'Suggestion rejected. The page stays as it is.':
      'Sugerencia rechazada. La página permanece sin cambios.',
    'Your suggestion is withdrawn.': 'Tu sugerencia se ha retirado.',
    'Restored. The page informs answers again.':
      'Restaurada. La página vuelve a influir en las respuestas.',
    'Your suggestion is sent. A publisher decides whether it becomes the page.':
      'Tu sugerencia se ha enviado. Un publicador decidirá si se convierte en la página.',
    'Saved. The page is now revision {value1}.':
      'Guardado. La página ahora es la revisión {value1}.',
    'Nothing changed.': 'No ha cambiado nada.',
    'This page is not available.': 'Esta página no está disponible.',
    'It may have been deleted, archived or moved out of reach, or you may no longer be in this company.':
      'Puede que se haya eliminado, archivado o movido fuera de tu alcance, o que ya no formes parte de esta empresa.',
    'Page actions': 'Acciones de la página',
    shown: 'visible',
    hidden: 'oculto',
    '{value1} History': 'Historial de {value1}',
    '{value1} Ask in chat': '{value1} Preguntar en el chat',
    'Suggest edits': 'Sugerir cambios',
    'More actions for {value1}': 'Más acciones para {value1}',
    '{value1} Poneva reads this page in every chat': '{value1} Poneva lee esta página en cada chat',
    'This page is archived. It no longer informs answers; its history is kept. {value1}':
      'Esta página está archivada. Ya no influye en las respuestas; su historial se conserva. {value1}',
    'Restore page': 'Restaurar página',
    'This link points to an earlier revision. You are reading the current text.':
      'Este enlace apunta a una revisión anterior. Estás leyendo el texto actual.',
    'Show it in History': 'Mostrar en el historial',
    Pages: 'Páginas',
    'Pages under {value1}': 'Páginas bajo {value1}',
    'Linked from': 'Enlaces desde',
    Suggestions: 'Sugerencias',
    'Suggestions are hidden. You are reading the page as everyone else sees it.':
      'Las sugerencias están ocultas. Estás leyendo la página tal como la ven los demás.',
    'Loading suggestions…': 'Cargando sugerencias…',
    'Nothing is waiting for review.': 'No hay nada pendiente de revisión.',
    'When someone, Poneva in a chat or a connected agent suggests a change to a page, it shows here and on the page. Nothing changes until a publisher accepts it.':
      'Cuando alguien, Poneva en un chat o un agente conectado sugiere un cambio en una página, aparece aquí y en la página. Nada cambia hasta que un publicador lo acepta.',
    '{value1} Review knowledge in chat': '{value1} Revisar conocimiento en el chat',
    'Suggestions for review': 'Sugerencias para revisar',
    'Suggested changes from chats, meetings, colleagues and connected agents. Nothing changes until a publisher accepts it on the page.':
      'Cambios sugeridos desde chats, reuniones, compañeros y agentes conectados. Nada cambia hasta que un publicador los acepta en la página.',
    'Your suggestions wait here until a publisher decides. The pages stay as they are until then.':
      'Tus sugerencias esperan aquí hasta que un publicador decida. Las páginas no cambian hasta entonces.',
    'Review page': 'Revisar página',
    'Review on page': 'Revisar en la página',
    'Open the meeting': 'Abrir la reunión',
    'Open the chat': 'Abrir el chat',
    'Accept and restore': 'Aceptar y restaurar',
    Accept: 'Aceptar',
    Reject: 'Rechazar',
    'Your suggestion · waiting for a publisher': 'Tu sugerencia · a la espera de un publicador',
    Withdraw: 'Retirar',
    'Waiting for a publisher': 'A la espera de un publicador',
    'Suggestion {value1}': 'Sugerencia {value1}',
    'Suggestion {value1} from {value2}{value3}': 'Sugerencia {value1} de {value2}{value3}',
    'Read the suggested page': 'Leer la página sugerida',
    'Outdated: the text it changes was edited after it was suggested. It can be rejected or withdrawn; a new suggestion can be made against the current text.':
      'Desactualizada: el texto que modifica se editó después de realizar la sugerencia. Puedes rechazarla o retirarla; se puede hacer una nueva sugerencia sobre el texto actual.',
    'Restore this page first to accept this suggestion.':
      'Restaura primero esta página para aceptar esta sugerencia.',
    'Previous suggestion': 'Sugerencia anterior',
    Download: 'Descargar',
    CSV: 'CSV',
    'Evidence for {value1}': 'Evidencia de {value1}',
    Measure: 'Medida',
    'Show rows →': 'Mostrar filas →',
    'Ask about this number': 'Preguntar sobre este número',
    'There are no numeric values available to chart. View the table for the original data.':
      'No hay valores numéricos disponibles para crear un gráfico. Consulta la tabla para ver los datos originales.',
    'Chart value': 'Valor del gráfico',
    '{value1} of {value2} shown': 'Se muestran {value1} de {value2}',
    '{value1} by {value2}; {value3} rows. View Table for exact values.':
      '{value1} por {value2}; {value3} filas. Consulta la tabla para ver los valores exactos.',
    'Values come directly from the source data. Missing values are not estimates.':
      'Los valores proceden directamente de los datos de origen. Los valores que faltan no son estimaciones.',
    'Loading library…': 'Cargando biblioteca…',
    'We couldn’t load what happened in this App. Try again in a moment.':
      'No hemos podido cargar lo ocurrido en esta aplicación. Inténtalo de nuevo en un momento.',
    'This App could not be opened.': 'No se ha podido abrir esta aplicación.',
    'Opening App…': 'Abriendo aplicación…',
    'Open the saved App to run this function.':
      'Abre la aplicación guardada para ejecutar esta función.',
    'Save this App before running its function.':
      'Guarda esta aplicación antes de ejecutar su función.',
    'Open saved App': 'Abrir aplicación guardada',
    'Open Apps': 'Abrir aplicaciones',
    'The App could not be opened. Try again.':
      'No se ha podido abrir la aplicación. Inténtalo de nuevo.',
    Owner: 'Propietario',
    '{value1} · admins': '{value1} · administradores',
    'Owner · always edits': 'Propietario · siempre puede editar',
    'Admins manage it': 'Los administradores la gestionan',
    Editors: 'Editores',
    'A colleague': 'Un compañero',
    'Can edit drafts and publish versions': 'Puede editar borradores y publicar versiones',
    Remove: 'Eliminar',
    'No editors yet.': 'Todavía no hay editores.',
    'Admins can always edit company agents.':
      'Los administradores siempre pueden editar los agentes de la empresa.',
    'Asking for edit access': 'Solicitando acceso de edición',
    'Asked {value1} · also in your Inbox':
      'Solicitado {value1} · también está en tu bandeja de entrada',
    Grant: 'Conceder',
    Admin: 'Administrador',
    'Make personal': 'Hacer personal',
    'Switch off': 'Desactivar',
    Archive: 'Archivar',
    'Archive this agent': 'Archivar este agente',
    'Loading agent…': 'Cargando agente…',
    '{value1} Edit in chat': '{value1} Editar en el chat',
    Agent: 'Agente',
    'This agent has not been created yet. It can run once its owner creates it.':
      'Este agente todavía no se ha creado. Podrá ejecutarse cuando lo cree su propietario.',
    'New agent · Draft': 'Agente nuevo · Borrador',
    'Untitled agent': 'Agente sin título',
    'Test run': 'Ejecución de prueba',
    'This draft does not run automatically.': 'Este borrador no se ejecuta automáticamente.',
    'Describe the agent in the chat. Its draft appears here.':
      'Describe el agente en el chat. Su borrador aparecerá aquí.',
    '{value1} Test run': '{value1} Ejecución de prueba',
    'Describe the agent in the chat first.': 'Primero, describe el agente en el chat.',
    'Create and turn on': 'Crear y activar',
    'Connection write setup': 'Configuración de escritura de la conexión',
    'Account for connected changes': 'Cuenta para cambios conectados',
    'Choose a connection': 'Elegir una conexión',
    'No published Skills available. You can add them later.':
      'No hay Habilidades publicadas disponibles. Puedes añadirlas más tarde.',
    '{value1} · not published. Review the changes. Testing is optional.':
      '{value1} · no publicado. Revisa los cambios. Las pruebas son opcionales.',
    '{value1} Test draft': '{value1} Probar borrador',
    'Apply changes…': 'Aplicando cambios…',
    'Apply this draft as a new version': 'Aplicar este borrador como una nueva versión',
    'This draft cannot be applied.': 'No se puede aplicar este borrador.',
    'What changed?': '¿Qué ha cambiado?',
    'Apply version {value1}': 'Aplicar versión {value1}',
    Create: 'Crear',
    'Edit access requested': 'Acceso de edición solicitado',
    '{value1} Request edit access': '{value1} Solicitar acceso de edición',
    '{value1} Copy agent': '{value1} Copiar agente',
    Pause: 'Pausar',
    'Open agent: {value1}': 'Abrir agente: {value1}',
    '· you can edit': '· puedes editar',
    '{value1} is switched off.': '{value1} está desactivado.',
    '{value1} is archived.': '{value1} está archivado.',
    'Loading agents…': 'Cargando agentes…',
    Agents: 'Agentes',
    'Agents do work for you on a schedule or when you ask. They follow your company’s Skills.':
      'Los agentes trabajan por ti según un horario o cuando se lo pides. Siguen las Habilidades de tu empresa.',
    'No agent matches. Try a Skill name or what the agent should do.':
      'Ningún agente coincide. Prueba con el nombre de una Habilidad o describe lo que debería hacer el agente.',
    'Nothing of your own yet': 'Todavía no tienes nada propio',
    'Tell Chat what an agent should do, or copy one of the company’s agents below.{value1}':
      'Dile a Chat qué debe hacer un agente o copia uno de los agentes de la empresa que aparecen abajo.{value1}',
    'Your agents': 'Tus agentes',
    'Run on demand': 'Ejecutar bajo demanda',
    'Run is always available. A schedule is optional and lives separately from the agent’s instructions.':
      'La ejecución siempre está disponible. El horario es opcional y se configura por separado de las instrucciones del agente.',
    'Suggestion {value1} of {value2}': 'Sugerencia {value1} de {value2}',
    'Next suggestion': 'Siguiente sugerencia',
    'Fold the suggestions away': 'Ocultar las sugerencias',
    'Show the suggestions': 'Mostrar las sugerencias',
    '1 suggestion': '1 sugerencia',
    '{value1} suggestions': '{value1} sugerencias',
    '{value1} the pages under {value2}': '{value1} las páginas bajo {value2}',
    px: 'px',
    '{value1} chart of {value2} across {value3}': 'Gráfico de {value2} por {value3}: {value1}',
    'We could not build the file.': 'No se ha podido crear el archivo.',
    '{value1} Present': '{value1} Presentes',
    'Building…': 'Creando…',
    'Download PowerPoint': 'Descargar PowerPoint',
    'Slide {value1} of {value2}': 'Diapositiva {value1} de {value2}',
    Slides: 'Diapositivas',
    'Slide {value1}': 'Diapositiva {value1}',
    'Speaker notes': 'Notas del orador',
    'Source: {value1}': 'Fuente: {value1}',
    'Add a name and a web address.': 'Añade un nombre y una dirección web.',
    'Enter a valid web address.': 'Introduce una dirección web válida.',
    'Use a web address that starts with https://.':
      'Usa una dirección web que empiece por https://.',
    'Add a custom connection': 'Añadir una conexión personalizada',
    'Connect a tool server you trust. Poneva checks the address works and saves only the connection details needed to use it.':
      'Conecta un servidor de herramientas de confianza. Poneva comprueba que la dirección funciona y solo guarda los datos de conexión necesarios para usarlo.',
    'Web address': 'Dirección web',
    'https://tools.example.com': 'https://tools.example.com',
    'Starts with https://, from your provider':
      'Empieza por https://, proporcionada por tu proveedor',
    'Sign-in': 'Inicio de sesión',
    'Advanced sign-in': 'Inicio de sesión avanzado',
    'Access key {value1}': 'Clave de acceso {value1}',
    'Request headers': 'Encabezados de solicitud',
    'Add header': 'Añadir encabezado',
    'Header {value1} name': 'Nombre del encabezado {value1}',
    'Header name': 'Nombre del encabezado',
    'Header {value1} value': 'Valor del encabezado {value1}',
    'Header value': 'Valor del encabezado',
    'Remove header': 'Eliminar encabezado',
    Advanced: 'Avanzado',
    Transport: 'Transporte',
    'Auto-detect': 'Detección automática',
    'Streamable HTTP': 'HTTP con streaming',
    'Legacy SSE': 'SSE heredado',
    "From your provider's app settings. Leave empty unless they gave you these.":
      'Desde la configuración de la aplicación de tu proveedor. Déjalo vacío salvo que te hayan proporcionado estos datos.',
    "Authorization server issuer": "Emisor del servidor de autorización",
    "Enter the authorization server issuer when using a client ID.": "Introduce el emisor del servidor de autorización cuando uses un ID de cliente.",
    'Client ID {value1}': 'ID de cliente {value1}',
    'Client secret {value1}': 'Secreto de cliente {value1}',
    'Connecting…': 'Conectando…',
    'Test and connect': 'Probar y conectar',
    'Add the store, the client ID and the client secret.':
      'Añade la tienda, el ID de cliente y el secreto de cliente.',
    'Connect your Shopify Developer App': 'Conecta tu aplicación de desarrollador de Shopify',
    'Poneva can use exactly the access your store gave the app, and nothing more. It talks to Shopify directly and keeps the client secret encrypted.':
      'Poneva solo puede usar los permisos que tu tienda concedió a la aplicación. Se comunica directamente con Shopify y mantiene el secreto de cliente cifrado.',
    'How to create the app in Shopify': 'Cómo crear la aplicación en Shopify',
    'Open{value1} {value2}{value3} with the account that owns the store, and create an app.':
      'Abre{value1} {value2}{value3} con la cuenta propietaria de la tienda y crea una aplicación.',
    'Create a version and select the access scopes Poneva may use, for example read_products and read_orders. Add write_ scopes only for data Poneva may change. Then release the version.':
      'Crea una versión y selecciona los ámbitos de acceso que Poneva puede usar, por ejemplo read_products y read_orders. Añade ámbitos write_ solo para los datos que Poneva pueda modificar. Después, publica la versión.',
    'For orders and customers, also select protected customer data in the app’s settings. Shopify allows this without review for an app made for your own store.':
      'Para los pedidos y clientes, selecciona también los datos de clientes protegidos en la configuración de la aplicación. Shopify permite hacerlo sin revisión en una aplicación creada para tu propia tienda.',
    'Install the app on your store.': 'Instala la aplicación en tu tienda.',
    'Copy the client ID and client secret from the app’s settings.':
      'Copia el ID de cliente y el secreto de cliente desde la configuración de la aplicación.',
    'To change the access later, release a new version, approve it on the store and use Test connection here.':
      'Para cambiar los permisos más adelante, publica una versión nueva, apruébala en la tienda y usa Probar conexión aquí.',
    Store: 'Tienda',
    'your-store.myshopify.com': 'your-store.myshopify.com',
    'Your store’s .myshopify.com address (Shopify admin → Settings → Domains), or paste the address of your Shopify admin page':
      'La dirección .myshopify.com de tu tienda (administrador de Shopify → Settings → Domains), o pega la dirección de la página de administración de Shopify',
    'Client ID {value1} {value2}': 'ID de cliente {value1} {value2}',
    'Client secret {value1} {value2}': 'Secreto de cliente {value1} {value2}',
    Person: 'Persona',
    Everyone: 'Todos',
    Connection: 'Conexión',
    'All connections': 'Todas las conexiones',
    'App {value1}': 'Aplicación {value1}',
    'From {value1}': 'Desde {value1}',
    'Until {value1}': 'Hasta {value1}',
    Result: 'Resultado',
    'All results': 'Todos los resultados',
    Succeeded: 'Correcto',
    Denied: 'Denegado',
    Failed: 'Fallido',
    Unknown: 'Desconocido',
    Filter: 'Filtrar',
    'Loading activity…': 'Cargando actividad…',
    'Could not load activity. Try again.':
      'No se ha podido cargar la actividad. Inténtalo de nuevo.',
    'Removed connection': 'Conexión eliminada',
    'App: {value1}': 'Aplicación: {value1}',
    'Older activity': 'Actividad anterior',
    'What changed in version {value1}': 'Qué cambió en la versión {value1}',
    'Every publish is a version you can restore.':
      'Cada publicación es una versión que puedes restaurar.',
    Authorization: 'Autorización',
    '{value1} {value2} · {value3} will see it.': '{value1} {value2} · {value3} podrán verlo.',
    '{value1} {value2} you': '{value1} {value2} tú',
    '· Revised': '· Revisado',
    'This chat used your {value1}.': 'Este chat usó tu {value1}.',
    'This chat has results from {value1}.': 'Este chat tiene resultados de {value1}.',
    'db.example.com': 'db.example.com',
    'e.g. Product analytics': 'p. ej., análisis de productos',
    'Paste access key': 'Pega la clave de acceso',
    'Shopify’s Dev Dashboard': 'Panel de desarrolladores de Shopify',
    'App reference': 'Referencia de la app',
    'Draft · revision {value1}': 'Borrador · revisión {value1}',
    'its Result': 'su resultado',
    '· its first run makes it': '· su primera ejecución lo convierte en',
    '{value1}’s chat ·': 'Chat de {value1} ·',
    '{value1} ad {value2} available.': '{value1} y {value2} disponibles.',
    '{value1} rows ·': '{value1} filas ·',
    'It starts private. Sharing it wider shares every refresh, which can carry your private data.':
      'Comienza siendo privado. Compartirlo más ampliamente comparte cada actualización, que puede contener tus datos privados.',
    'Enable this schedule when approved': 'Activa esta programación al aprobarla',
    Schedule: 'Programación',
    'Kept off until you create the agent from its canvas.':
      'Se mantiene desactivada hasta que crees el agente desde su lienzo.',
    'Will be enabled when you approve.': 'Se activará cuando la apruebes.',
    'Will be saved paused. You can enable it later.':
      'Se guardará en pausa. Puedes activarla más tarde.',
    'Only runs when you ask.': 'Solo se ejecuta cuando lo solicitas.',
    'Draft · approving saves it, and nothing runs. Test it and create it from its canvas.':
      'Borrador · al aprobarlo se guardará y no se ejecutará nada. Pruébalo y créalo desde su lienzo.',
    'Draft · nothing is scheduled until you approve. Connected actions require their own approval at run time.':
      'Borrador · no se programará nada hasta que lo apruebes. Las acciones conectadas requieren su propia aprobación al ejecutarse.',
    Name: 'Nombre',
    'Agent name': 'Nombre del agente',
    'Who can use it': 'Quién puede usarlo',
    'Company agent · company resources only': 'Agente de la empresa · solo recursos de la empresa',
    'Personal agent · runs with your access': 'Agente personal · se ejecuta con tus permisos',
    'Approving saves it as a draft. It does not run automatically.':
      'Al aprobarlo, se guardará como borrador. No se ejecuta automáticamente.',
    'Open the agent’s runs': 'Abrir las ejecuciones del agente',
    'Run the published version once': 'Ejecutar una vez la versión publicada',
    'Stopping…': 'Deteniendo…',
    'Stop run': 'Detener ejecución',
    'Could not stop this run. Please try again.':
      'No se pudo detener esta ejecución. Inténtalo de nuevo.',
    'Run in progress': 'Ejecución en curso',
    'This run is still answering. You can ask follow-ups when it finishes.':
      'Esta ejecución todavía está respondiendo. Puedes hacer preguntas de seguimiento cuando termine.',
    'Open run details': 'Abrir detalles de la ejecución',
    Runs: 'Ejecuciones',
    'Open the run chat': 'Abrir el chat de la ejecución',
    Watch: 'Ver',
    Goal: 'Objetivo',
    'Change the goal': 'Cambiar el objetivo',
    'What it does': 'Qué hace',
    'What should this agent achieve?': '¿Qué debería lograr este agente?',
    'Not set yet.': 'Aún no se ha establecido.',
    'When it runs': 'Cuándo se ejecuta',
    'Change when it runs': 'Cambiar cuándo se ejecuta',
    'Off means it runs only when someone runs it. Changing when it runs never changes its instructions.':
      'Desactivado significa que solo se ejecuta cuando alguien lo inicia. Cambiar cuándo se ejecuta nunca cambia sus instrucciones.',
    Instructions: 'Instrucciones',
    'Change the instructions': 'Cambiar las instrucciones',
    'How the agent should approach the work and make decisions.':
      'Cómo debe abordar el trabajo y tomar decisiones.',
    Boundaries: 'Límites',
    'What to do or avoid. Every connected action still follows its approval.':
      'Qué hacer o evitar. Cada acción conectada sigue requiriendo su aprobación.',
    'No instructions of its own. It follows its Skills.':
      'No tiene instrucciones propias. Sigue sus habilidades.',
    'Pin a Skill': 'Fijar una habilidad',
    'Finds the Skills that fit each run, the same way a chat does.':
      'Encuentra las habilidades adecuadas para cada ejecución, igual que un chat.',
    'Skills it always follows': 'Habilidades que siempre sigue',
    'A Skill that is not published': 'Una habilidad que no está publicada',
    'Always follows · Version {value1}': 'Siempre sigue · Versión {value1}',
    'Not published': 'No publicada',
    Uses: 'Usa',
    'Change in chat': 'Cambiar en el chat',
    'Change in chat: Uses': 'Cambiar en el chat: Usa',
    'Company knowledge and the tools each run is allowed to use.':
      'Conocimiento de la empresa y herramientas que cada ejecución puede usar.',
    'People see the Result refresh; they change the agent, not the page.':
      'Las personas ven cómo se actualiza el resultado; cambian el agente, no la página.',
    'The first run after it is created makes the Result; later runs add a version to it.':
      'La primera ejecución después de crearlo genera el resultado; las ejecuciones posteriores le añaden una versión.',
    'Emails whoever the run is for': 'Envía un correo a quien corresponda la ejecución',
    'Email each run': 'Enviar un correo por cada ejecución',
    Delivers: 'Entrega',
    'Change what it delivers': 'Cambiar lo que entrega',
    'Expected result': 'Resultado esperado',
    'What a successful run should deliver.': 'Lo que debería entregar una ejecución correcta.',
    'What each run delivers': 'Lo que entrega cada ejecución',
    'Keeps one Result up to date {value1}': 'Mantiene actualizado un resultado {value1}',
    'Saves a new Result each run': 'Guarda un resultado nuevo en cada ejecución',
    'You can run this company agent as yourself.{value1} {value2}':
      'Puedes ejecutar este agente de la empresa como tú mismo.{value1} {value2}',
    'Changes since version': 'Cambios desde la versión',
    'are not live yet.': 'todavía no están activos.',
    'Review them in Versions': 'Revísalos en Versiones',
    Skill: 'Habilidad',
    'The agent always uses the Skill’s published version.':
      'El agente siempre usa la versión publicada de la habilidad.',
    Day: 'Día',
    Time: 'Hora',
    'Cron expression': 'Expresión de Cron',
    'Editors and access': 'Editores y acceso',
    Company: 'Empresa',
    Personal: 'Personal',
    'No changes.': 'No hay cambios.',
    'Instructions changes': 'Cambios en las instrucciones',
    'Loading versions…': 'Cargando versiones…',
    'What the draft changes': 'Qué cambia el borrador',
    'No published version yet. Try the draft, then publish it.':
      'Aún no hay una versión publicada. Prueba el borrador y luego publícalo.',
    'Published versions': 'Versiones publicadas',
    'Former member': 'Exmiembro',
    Live: 'Activo',
    '{value1} for {value2}': '{value1} para {value2}',
    Suggested: 'Sugerido',
    'Opening your conversation…': 'Abriendo tu conversación…',
    'This conversation isn’t available': 'Esta conversación no está disponible',
    'It may have been deleted, belong to another account, or be temporarily unavailable.':
      'Es posible que se haya eliminado, que pertenezca a otra cuenta o que no esté disponible temporalmente.',
    '{count} more line — shown in the complete revision':
      '{count} línea más — se muestra en la revisión completa',
    '{count} more lines — shown in the complete revision':
      '{count} líneas más — se muestran en la revisión completa',
    '{count} more line removed': 'Se eliminó {count} línea más',
    '{count} more lines removed': 'Se eliminaron {count} líneas más',
    '{count} unchanged line': '{count} línea sin cambios',
    '{count} unchanged lines': '{count} líneas sin cambios',
    '{count} more lines not shown, {added} added and {removed} removed. Check them in the complete revision.':
      'No se muestran {count} líneas más; se añadieron {added} y se eliminaron {removed}. Compruébalas en la revisión completa.',
    'Saved result': 'Resultado guardado',
    'Made with a Skill': 'Creado con una habilidad',
    'Preview of {name}': 'Vista previa de {name}',
    'Made with {name}': 'Creado con {name}',
    'Ad-hoc result': 'Resultado ad hoc',
    'A Skill that is not available in this workspace':
      'Una habilidad que no está disponible en este espacio de trabajo',
    '{name} · Revision {version}': '{name} · Revisión {version}',
    '{name} · Version {version}': '{name} · Versión {version}',
    'Return to conversation {value1}': 'Volver a la conversación {value1}',
    '{value1} Working with {value2}': '{value1} trabajando con {value2}',
    'View context {value1}': 'Ver contexto {value1}',
    'A way of working, made yours.': 'Una forma de trabajar, hecha a tu medida.',
    'Work that runs itself.': 'Trabajo que se ejecuta solo.',
    'One place for one piece of work.': 'Un solo lugar para cada trabajo.',
    'Let’s move your work forward{value1}.': 'Hagamos avanzar tu trabajo{value1}.',
    'Describe the work. Your Skill takes shape beside the conversation.':
      'Describe el trabajo. Tu habilidad toma forma junto a la conversación.',
    'Describe what it should do and when. Your agent takes shape beside the conversation. The draft does not run automatically.':
      'Describe qué debe hacer y cuándo. Tu agente toma forma junto a la conversación. El borrador no se ejecuta automáticamente.',
    'Say what the work is. Poneva drafts the project beside the conversation and brings in what you have already done. Nothing is created until you say so.':
      'Describe en qué consiste el trabajo. Poneva redacta el proyecto junto a la conversación e incorpora lo que ya has hecho. No se crea nada hasta que lo indiques.',
    'Start with an idea below. Poneva will take it from there.':
      'Empieza con una idea. Poneva se encargará del resto.',
    Triggers: 'Activadores',
    'Review the agent and its trigger. Approval applies exactly what is shown.':
      'Revisa el agente y su activador. La aprobación aplica exactamente lo que se muestra.',
    '{source} · read {date}': '{source} · leído el {date}',
    'Evidence is being recorded · read {date}':
      'Se está registrando la evidencia · leído el {date}',
    'Evidence expired on {date} under the retention policy':
      'La evidencia caducó el {date} según la política de conservación',
    'Entered by {person}': 'Introducido por {person}',
    'No retained evidence for this value': 'No hay evidencia conservada para este valor',
    'Covers {shown} of {total} rows': 'Cubre {shown} de {total} filas',
    'Search rows': 'Buscar filas',
    'Clear filters': 'Borrar filtros',
    Sort: 'Ordenar',
    'Sort: {column}': 'Ordenar: {column}',
    '{shown} of {total} rows': '{shown} de {total} filas',
    More: 'Más',
    Density: 'Densidad',
    Comfortable: 'Cómoda',
    Compact: 'Compacta',
    Columns: 'Columnas',
    'No rows match. Clear the search or filters to see them again.':
      'Ninguna fila coincide. Borra la búsqueda o los filtros para volver a verlas.',
    'Not available': 'No disponible',
    'All rows': 'Todas las filas',
    'Close row detail': 'Cerrar detalle de la fila',
    'Ask about this row': 'Preguntar sobre esta fila',
    'Add note': 'Añadir nota',
    Note: 'Nota',
    Saved: 'Guardado',
    Total: 'Total',
    ascending: 'ascendente',
    descending: 'descendente',
    'Scroll to see all columns': 'Desplázate para ver todas las columnas',
    App: 'Aplicación',
    Artifact: 'Artefacto',
    'New project': 'Nuevo proyecto',
    'Review request': 'Solicitud de revisión',
    Activity: 'Actividad',
    'Voice preview': 'Vista previa de voz',
    Source: 'Fuente',
    File: 'Archivo',
    Meeting: 'Reunión',
    'Knowledge page': 'Página de conocimiento',
    'Could not preview this CSV.': 'No se pudo previsualizar este CSV.',
    'File content is unavailable.': 'El contenido del archivo no está disponible.',
    'You have five open suggestions here. {value1} will see them.':
      'Tienes cinco sugerencias abiertas aquí. {value1} las verá.',
    'We could not send your suggestion. Please try again.':
      'No pudimos enviar tu sugerencia. Inténtalo de nuevo.',
    'The agent': 'El agente',
    'Selected colleagues': 'Compañeros seleccionados',
    'The owner': 'El propietario',
    'Forked. This copy is yours and runs with your own connections.':
      'Bifurcado. Esta copia es tuya y se ejecuta con tus propias conexiones.',
    'This chat is too long to fork.': 'Este chat es demasiado largo para bifurcarlo.',
    'We could not fork this chat. Please try again.':
      'No pudimos bifurcar este chat. Inténtalo de nuevo.',
    'Anyone who forked it keeps their copy: forks stay with the people who made them.':
      'Quienes lo bifurcaron conservan su copia: las bifurcaciones pertenecen a quienes las crearon.',
    'Nobody has forked this chat.': 'Nadie ha bifurcado este chat.',
    '1 person forked this chat. Their copy stays theirs.':
      '1 persona bifurcó este chat. Su copia sigue siendo suya.',
    '{value1} people forked this chat. Their copies stay theirs.':
      '{value1} personas bifurcaron este chat. Sus copias siguen siendo suyas.',
    'Personal. Nobody else sees it.': 'Personal. Nadie más puede verlo.',
    'People you pick. They get it in their Inbox.':
      'Las personas que elijas. Lo recibirán en su bandeja de entrada.',
    'Everyone in the company can follow it and fork it.':
      'Todos en la empresa pueden seguirlo y bifurcarlo.',
    'a chat you can no longer open': 'un chat que ya no puedes abrir',
    'shared the Result': 'compartió el resultado',
    'updated the Result': 'actualizó el resultado',
    'published the Skill': 'publicó la habilidad',
    'approved the fact': 'aprobó el dato',
    'added the fact': 'añadió el dato',
    'added the meeting': 'añadió la reunión',
    'published the page': 'publicó la página',
    'updated the page': 'actualizó la página',
    'shared the chat': 'compartió el chat',
    'published a version of': 'publicó una versión de',
    ran: 'ejecutó',
    Knowledge: 'Conocimiento',
    Meetings: 'Reuniones',
    Chat: 'Chat',
    Use: 'Usar',
    Open: 'Abrir',
    You: 'Tú',
    Someone: 'Alguien',
    'published version {version} of': 'publicó la versión {version} de',
    'thing needs': 'elemento necesita',
    'things need': 'elementos necesitan',
    'Published Skill': 'Habilidad publicada',
    'Included with Skill': 'Incluido con la habilidad',
    'Already attached': 'Ya adjunto',
    'Also available in company knowledge': 'También disponible en el conocimiento de la empresa',
    'Company file': 'Archivo de la empresa',
    'Account identity unavailable': 'Identidad de la cuenta no disponible',
    'Access expired or was revoked. Reconnect to continue.':
      'El acceso caducó o fue revocado. Vuelve a conectar para continuar.',
    'Account authorized · tools unavailable': 'Cuenta autorizada · herramientas no disponibles',
    'Not available in this workspace yet.': 'Aún no está disponible en este espacio de trabajo.',
    'Everyone in the company': 'Todos en la empresa',
    'Audience: only you.': 'Audiencia: solo tú.',
    'Audience: everyone in the company.': 'Audiencia: todos en la empresa.',
    'tool is': 'la herramienta es',
    'tools are': 'las herramientas son',
    'account is': 'la cuenta es',
    'accounts are': 'las cuentas son',
    'We could not upload this file.': 'No pudimos subir este archivo.',
    'file was': 'archivo fue',
    'files were': 'archivos fueron',
    'Your company': 'Tu empresa',
    'Create an agent': 'Crear un agente',
    'Give recurring work a helping hand': 'Dale una mano al trabajo recurrente',
    'Create a Skill': 'Crear una habilidad',
    'Save a reusable way of working': 'Guarda una forma de trabajo reutilizable',
    'Take meeting notes': 'Tomar notas de reuniones',
    'Capture decisions and next steps': 'Captura decisiones y próximos pasos',
    'Work with a file': 'Trabajar con un archivo',
    'Start from a document or image': 'Comenzar con un documento o una imagen',
    'Browse agents': 'Explorar agentes',
    'Open your agents and company agents': 'Abre tus agentes y los de la empresa',
    'Review results': 'Revisar resultados',
    'Return to work saved in your Library': 'Volver al trabajo guardado en tu biblioteca',
    'For review': 'Para revisar',
    'An agent': 'Un agente',
    Assistant: 'Asistente',
    'Kept up to date by {value1}{value2}': 'Actualizado por {value1}{value2}',
    ', {value1}': ', {value1}',
    'Version {value1}{value2}{value3}': 'Versión {value1}{value2}{value3}',
    'Refreshed by its agent': 'Actualizado por su agente',
    'Saved from a chat': 'Guardado desde un chat',
    'Saved from {value1}': 'Guardado desde {value1}',
    Edited: 'Editado',
    'private account': 'cuenta privada',
    '{value1} ({value2})': '{value1} ({value2})',
    '{value1}’s {value2}': '{value2} de {value1}',
    'Made private. The person who added it and the owner of its recording have been told in their Inbox.':
      'Se hizo privado. La persona que lo añadió y el propietario de su grabación han recibido una notificación en su bandeja de entrada.',
    'Made private. The person who added it has been told in their Inbox.':
      'Se hizo privado. La persona que lo añadió ha recibido una notificación en su bandeja de entrada.',
    'Made private. The owner of its recording has been told in their Inbox.':
      'Se hizo privado. El propietario de su grabación ha recibido una notificación en su bandeja de entrada.',
    'Selected passage': 'Pasaje seleccionado',
    '{value1} {value2}': '{value1} {value2}',
    'Upload a file': 'Subir un archivo',
    'Help me create a useful report from our company knowledge and available sources.':
      'Ayúdame a crear un informe útil a partir del conocimiento de nuestra empresa y las fuentes disponibles.',
    'This saved work couldn’t be opened. Open it again to retry.':
      'No se pudo abrir este trabajo guardado. Ábrelo de nuevo para volver a intentarlo.',
    '{value1}’s': 'De {value1}',
    '{value1} chat “{value2}”': 'Chat de {value1}: “{value2}”',
    '{value1}{value2}': '{value1}{value2}',
    'Skill: {value1}{value2}': 'Habilidad: {value1}{value2}',
    'Result “{value1}”': 'Resultado “{value1}”',
    'Meeting “{value1}”': 'Reunión “{value1}”',
    'Used in {value1} {value2} this week': 'Usado en {value1} {value2} esta semana',
    '{value1} {value2} · used in {value3} {value4}':
      '{value1} {value2} · usado en {value3} {value4}',
    'The draft is not published yet, so no one else follows it.':
      'El borrador aún no se ha publicado, por lo que nadie más lo sigue.',
    'Use it in a chat for current data, or refine the Skill first.':
      'Úsalo en un chat para obtener datos actuales o perfecciona primero la habilidad.',
    'An agent keeps this up to date. Continue the work in chat.':
      'Un agente mantiene esto actualizado. Continúa el trabajo en el chat.',
    'Edit it here, or continue the work in chat.': 'Edítalo aquí o continúa el trabajo en el chat.',
    'Duplicate it to your Library, or continue the work in chat.':
      'Duplícalo en tu biblioteca o continúa el trabajo en el chat.',
    'Download Markdown': 'Descargar Markdown',
    'Download CSV': 'Descargar CSV',
    'an agent': 'un agente',
    'Publish a Skill version': 'Publicar una versión de la habilidad',
    'Share with {value1}': 'Compartir con {value1}',
    'Update company content': 'Actualizar el contenido de la empresa',
    Approved: 'Aprobado',
    Declined: 'Rechazado',
    Pending: 'Pendiente',
    'View decision': 'Ver decisión',
    'No data': 'Sin datos',
    'No change': 'Sin cambios',
    'Connection created': 'Conexión creada',
    'Sharing changed': 'Uso compartido modificado',
    'Person added': 'Persona añadida',
    'Person removed': 'Persona eliminada',
    'Access changed': 'Acceso modificado',
    'Access turned off': 'Acceso desactivado',
    'Connection removed': 'Conexión eliminada',
    'Query time limit changed': 'Límite de tiempo de consulta modificado',
    '{count} row': '{count} fila',
    '{count} rows': '{count} filas',
    'This source is no longer available. Company knowledge now lives in Knowledge pages, and files stay in the Library.':
      'Esta fuente ya no está disponible. El conocimiento de la empresa ahora se encuentra en las páginas de Conocimiento y los archivos permanecen en la biblioteca.',
    '· {value1} by {value2}': '· {value1} por {value2}',
    '· version {value1}': '· versión {value1}',
    '{message} {count} earlier file was saved and attached.':
      '{message} Se guardó y adjuntó {count} archivo anterior.',
    '{message} {count} earlier files were saved and attached.':
      '{message} Se guardaron y adjuntaron {count} archivos anteriores.',
    '{message} {count} earlier file was saved.': '{message} Se guardó {count} archivo anterior.',
    '{message} {count} earlier files were saved.':
      '{message} Se guardaron {count} archivos anteriores.',
    'refreshed {time}': 'actualizado {time}',
    'a colleague': 'un colega',
    'Your chat “{title}”': 'Tu chat “{title}”',
    '{name}’s chat “{title}”': 'Chat de {name}: “{title}”',
    'Kept up to date by {name}{version}': 'Actualizado por {name}{version}',
    'Skill: {name}{version}': 'Habilidad: {name}{version}',
    'Result “{title}”': 'Resultado “{title}”',
    'Meeting “{title}”': 'Reunión “{title}”',
    'Used in {count} answer this week': 'Usado en {count} respuesta esta semana',
    'Used in {count} answers this week': 'Usado en {count} respuestas esta semana',
    '{count} source': '{count} fuente',
    '{count} sources': '{count} fuentes',
    'used in {count} place': 'usado en {count} lugar',
    'used in {count} places': 'usado en {count} lugares',
    '{company} workspace': 'Espacio de trabajo de {company}',
    '{count} page': '{count} página',
    '{count} pages': '{count} páginas',
    '{needs} · reviews and approvals': '{needs} · revisiones y aprobaciones',
    '{count} thing needs you': '{count} elemento necesita tu atención',
    '{count} things need you': '{count} elementos necesitan tu atención',
    'Included with Skill · {files} · {sources} {icon}':
      'Incluido con la habilidad · {files} · {sources} {icon}',
    '{count} file': '{count} archivo',
    '{count} files': '{count} archivos',
    Today: 'Hoy',
    'Earlier this week': 'A principios de esta semana',
    '{count} slide': '{count} diapositiva',
    '{count} slides': '{count} diapositivas',
    Early: 'Temprano',
    'TLS verified': 'TLS verificado',
    'Made personal and switched off. Switch it on when you are ready.':
      'Se ha hecho personal y se ha desactivado. Actívalo cuando estés listo.',
    'Made personal and switched off. Its owner is told which version is live.':
      'Se ha hecho personal y se ha desactivado. Se informa a su propietario de qué versión está activa.',
    'Switched off.': 'Desactivado.',
    'Applied version {revision}.': 'Se ha aplicado la versión {revision}.',
    'The draft is running in a chat only you can read.':
      'El borrador se está ejecutando en un chat que solo tú puedes leer.',
    'Publish a version first.': 'Publica primero una versión.',
    'Another Agent action is in progress.': 'Hay otra acción del agente en curso.',
    'Knowledge & connections': 'Conocimiento y conexiones',
    'Pinned Skills': 'Habilidades fijadas',
    None: 'Ninguno',
    'A new Result each run': 'Un resultado nuevo en cada ejecución',
    'One Result kept up to date': 'Un resultado actualizado',
    Email: 'Correo electrónico',
    On: 'Activado',
    Off: 'Desactivado',
    'Waiting for review': 'Esperando revisión',
    Outdated: 'Desactualizado',
    Accepted: 'Aceptado',
    Rejected: 'Rechazado',
    Withdrawn: 'Retirado',
    Replaced: 'Reemplazado',
    'Suggested edit': 'Edición sugerida',
    'Suggested new page': 'Nueva página sugerida',
    'Suggested move': 'Movimiento sugerido',
    'Suggested archive': 'Archivado sugerido',
    'Checking status…': 'Comprobando el estado…',
    'Status unavailable': 'Estado no disponible',
    'Bulleted list': 'Lista con viñetas',
    'Numbered list': 'Lista numerada',
    'Web link': 'Enlace web',
    Read: 'Leer',
    Write: 'Escribir',
    'shared with you': 'compartido contigo',
    'Getting an answer': 'Obteniendo una respuesta',
    '{name} is getting an answer': '{name} está obteniendo una respuesta',
    'We could not save. Please try again.': 'No se pudo guardar. Inténtalo de nuevo.',
    'The new page could not be created.': 'No se pudo crear la página nueva.',
    'We could not load this revision.': 'No se pudo cargar esta revisión.',
    'We could not restore this revision. Please try again.':
      'No se pudo restaurar esta revisión. Inténtalo de nuevo.',
    'We could not export this revision.': 'No se pudo exportar esta revisión.',
    'We could not open this suggestion.': 'No se pudo abrir esta sugerencia.',
    'We could not do that. Please try again.':
      'No se pudo realizar esa acción. Inténtalo de nuevo.',
    'We could not save your decision. Please try again.':
      'No se pudo guardar tu decisión. Inténtalo de nuevo.',
    'We could not restore this page. Please try again.':
      'No se pudo restaurar esta página. Inténtalo de nuevo.',
    'We could not export this page.': 'No se pudo exportar esta página.',
    '{count} missed time merged.': 'Se fusionó {count} registro de tiempo omitido.',
    '{count} missed times merged.': 'Se fusionaron {count} registros de tiempo omitidos.',
    'About this project': 'Acerca de este proyecto',
  },
  sv: {
    'We could not load this item.': 'Det gick inte att läsa in det här objektet.',
    '{value1} canvas': '{value1} arbetsyta',
    'Loading {value1}…': 'Läser in {value1}…',
    '{value1} · Original retained': '{value1} · Originalet har behållits',
    '{value1} {value2}{value3} · Added {value4}': '{value1} {value2}{value3} · Tillagd {value4}',
    '{value1} Use in chat': '{value1} Använd i chatten',
    '{value1} Download': '{value1} Ladda ned',
    Table: 'Tabell',
    Chart: 'Diagram',
    Original: 'Ursprunglig',
    'Text extracted from the PDF, marked by page. Download the original for its layout and images.':
      'Texten har extraherats från PDF-filen och markerats per sida. Ladda ned originalet för att se layout och bilder.',
    'This preview shows the beginning of the file. Poneva reads the whole file; download the original to see all of it.':
      'Den här förhandsvisningen visar början av filen. Poneva läser hela filen. Ladda ned originalet för att se allt.',
    'Preview of the first {value1} complete rows. Filtering and charts use only this preview. Download the original for the full file.':
      'Förhandsvisning av de första {value1} fullständiga raderna. Filtrering och diagram använder endast den här förhandsvisningen. Ladda ned originalet för hela filen.',
    'This source link cannot be opened.': 'Den här källänken kan inte öppnas.',
    'Read-only chat': 'Chatt med skrivskydd',
    'Only {value1} writes in this chat. Fork it to continue with your own connections. {value2}':
      'Det är bara {value1} som kan skriva i den här chatten. Skapa en förgrening för att fortsätta med dina egna anslutningar. {value2}',
    'Suggest a follow-up…': 'Föreslå en uppföljning…',
    'Suggest a follow-up': 'Föreslå en uppföljning',
    'Sending…': 'Skickar…',
    Send: 'Skicka',
    'We could not dismiss that suggestion. Please try again.':
      'Det gick inte att avfärda förslaget. Försök igen.',
    'Suggested follow-ups': 'Föreslagna uppföljningar',
    '{value1} suggests': '{value1} föreslår',
    Ask: 'Fråga',
    'Dismiss {value1}’s suggestion': 'Avfärda {value1}s förslag',
    'Suggested by': 'Föreslaget av',
    '· edit it or send it': '· redigera eller skicka det',
    'Remove the suggestion tag': 'Ta bort förslagstaggen',
    '{value1} {value2} is getting an answer': '{value1} {value2} får ett svar',
    '{value1} {value2} stopped the answer': '{value1} {value2} stoppade svaret',
    '{value1} Fork from here': '{value1} Skapa en förgrening härifrån',
    '{value1} From {value2}’s {value3}': '{value1} Från {value2}s {value3}',
    'Only {value1} can use this account': 'Det är bara {value1} som kan använda det här kontot',
    '{value1} Suggested by {value2}': '{value1} Föreslaget av {value2}',
    'Fork this chat': 'Förgrena den här chatten',
    'Forking…': 'Förgrenar…',
    Fork: 'Förgrena',
    'Could not make this private.': 'Det gick inte att göra den privat.',
    'Make this chat private?': 'Vill du göra den här chatten privat?',
    Close: 'Stäng',
    '{value1} will see “{value2}”. Everyone else loses access right away {value3} .{value4}':
      '{value1} kommer att se ”{value2}”. Alla andra förlorar åtkomsten direkt {value3} .{value4}',
    Cancel: 'Avbryt',
    'Saving…': 'Sparar…',
    'Make private': 'Gör privat',
    'This chat is private again. Forks others made stay theirs.':
      'Den här chatten är privat igen. Förgreningar som andra har skapat förblir deras.',
    'Who can read this chat: {value1}': 'Vilka kan läsa den här chatten: {value1}',
    'Move this chat': 'Flytta den här chatten',
    'Only you write here. Others follow live and fork.':
      'Det är bara du som kan skriva här. Andra följer live och skapar förgreningar.',
    'Made private. {value1} has been told in their Inbox.':
      'Gjorde privat. {value1} har meddelats i sin inkorg.',
    'Chat access': 'Chattåtkomst',
    '{value1}’s chat. As an admin you can make it private.':
      '{value1}s chatt. Som administratör kan du göra den privat.',
    'Only {value1} will see it. {value2} is told.':
      'Det är bara {value1} som kan se den. {value2} har meddelats.',
    '{value1} {value2} following': '{value1} {value2} följer',
    'Forked from{value1} {value2} . The history is copied. From here, tools run with your own access.':
      'Förgrenad från{value1} {value2} . Historiken har kopierats. Härifrån körs verktygen med din egen åtkomst.',
    '{value1} made this chat private': '{value1} gjorde den här chatten privat',
    'You can no longer open it. Any fork you made stays yours.':
      'Du kan inte längre öppna den. Alla förgreningar du har skapat förblir dina.',
    'Start a new chat': 'Starta en ny chatt',
    'Back to Recent chats': 'Tillbaka till Senaste chattarna',
    'More chat actions': 'Fler chattåtgärder',
    'Close conversation sharing': 'Stäng delning av konversation',
    'Review the text before saving a private copy to Library. Then choose its audience. Your original conversation and future messages stay private.':
      'Granska texten innan du sparar en privat kopia i Biblioteket. Välj sedan vilka som ska få tillgång. Din ursprungliga konversation och framtida meddelanden förblir privata.',
    'Preparing the conversation…': 'Förbereder konversationen…',
    'Refresh preview': 'Uppdatera förhandsvisning',
    'The copy is saved in Library. Use Share to choose who can access it.':
      'Kopian har sparats i Biblioteket. Använd Dela för att välja vilka som ska få åtkomst.',
    'Save this copy': 'Spara den här kopian',
    'That Skill could not be opened.': 'Det gick inte att öppna den färdigheten.',
    '{value1}{value2} · reviews and approvals': '{value1}{value2} · granskningar och godkännanden',
    'Open Inbox': 'Öppna inkorgen',
    'New at {value1} this week': 'Nytt hos {value1} den här veckan',
    'Nothing new this week. Shared work, published Skills and approved knowledge show up here.':
      'Inget nytt den här veckan. Delat arbete, publicerade färdigheter och godkänd kunskap visas här.',
    'New at {value1}': 'Nytt hos {value1}',
    'This Skill is unavailable. Try again.':
      'Den här färdigheten är inte tillgänglig. Försök igen.',
    'You can attach up to {value1} files. Remove an attachment to add another.':
      'Du kan bifoga upp till {value1} filer. Ta bort en bilaga för att lägga till en till.',
    'Add company context': 'Lägg till företagskontext',
    'Add company context · @': 'Lägg till företagskontext · @',
    'Choose a Skill': 'Välj en färdighet',
    'Choose a Skill · /': 'Välj en färdighet · /',
    context: 'kontext',
    skills: 'kompetenser',
    'Choose company context': 'Välj företagskontext',
    'Skills for this conversation': 'Kompetenser för den här konversationen',
    'Bring context into the conversation': 'Lägg till kontext i konversationen',
    'Close context picker': 'Stäng kontextväljaren',
    'Filter company context': 'Filtrera företagskontext',
    'Find a Skill…': 'Hitta en kompetens…',
    'Find a file…': 'Hitta en fil…',
    'Available company context': 'Tillgänglig företagskontext',
    'No matching published Skills.': 'Inga matchande publicerade kompetenser.',
    'No matching files.': 'Inga matchande filer.',
    'Searching company work…': 'Söker i företagets arbete…',
    'Try search again': 'Försök söka igen',
    'Meaning search is temporarily limited. Showing available text matches.':
      'Betydelsesökningen är tillfälligt begränsad. Visar tillgängliga textmatchningar.',
    'Load more matches': 'Ladda fler matchningar',
    '{value1} files attached. Remove an attachment to add another. Saved Skill references are included separately.':
      '{value1} filer bifogade. Ta bort en bilaga för att lägga till en till. Sparade kompetensreferenser inkluderas separat.',
    'Create a Skill in chat': 'Skapa en kompetens i chatten',
    'Upload a company file': 'Ladda upp en företagsfil',
    'Company knowledge is always available to Poneva.':
      'Företagskunskap är alltid tillgänglig för Poneva.',
    '{value1} was not connected': '{value1} anslöts inte',
    Dismiss: 'Avfärda',
    'Try connecting again': 'Försök ansluta igen',
    Waiting: 'Väntar',
    Connected: 'Ansluten',
    'Needs reconnecting': 'Behöver anslutas igen',
    Connect: 'Anslut',
    '{value1}{value2} The provider’s account permissions still apply.':
      '{value1}{value2} Leverantörens kontobehörigheter gäller fortfarande.',
    'Last error: {value1}': 'Senaste felet: {value1}',
    '{value1} {value2} ready.': '{value1} {value2} är redo.',
    'Continue with my Meta app': 'Fortsätt med min Meta-app',
    Reconnect: 'Anslut igen',
    Disconnect: 'Koppla från',
    'Remove attachment: {value1}': 'Ta bort bilagan: {value1}',
    'Saved in this Skill. Edit the Skill to change its references.':
      'Sparat i den här kompetensen. Redigera kompetensen för att ändra dess referenser.',
    'Remove Skill context': 'Ta bort kompetenskontext',
    Refining: 'Förfinar',
    Previewing: 'Förhandsgranskar',
    Using: 'Använder',
    'Skill revision {value1}': 'Kompetensversion {value1}',
    'a new Skill': 'en ny kompetens',
    '{value1} Making a new agent {value2}': '{value1} Skapar en ny agent {value2}',
    'Stop making a new agent in this chat': 'Sluta skapa en ny agent i den här chatten',
    'Saved Skill references': 'Sparade kompetensreferenser',
    'Included with Skill · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}':
      'Inkluderas med kompetensen · {value1}{value2} {value3} · {value4}{value5} {value6} {value7}',
    'Selected Skill revision is unavailable. Select the Skill again to view its saved references.':
      'Den valda kompetensversionen är inte tillgänglig. Välj kompetensen igen för att visa dess sparade referenser.',
    'Conversation attachments': 'Konversationsbilagor',
    'Added for this conversation': 'Tillagd för den här konversationen',
    'Selected passage {value1}': 'Valt avsnitt {value1}',
    'We could not load your workspace.': 'Det gick inte att läsa in din arbetsyta.',
    'The selected Skill is unavailable. Check its access or choose it again.':
      'Den valda kompetensen är inte tillgänglig. Kontrollera åtkomsten eller välj den igen.',
    'Source saved privately and included in your knowledge search.':
      'Källan sparades privat och inkluderades i din kunskapssökning.',
    'File saved privately to your library and attached to this message.':
      'Filen sparades privat i ditt bibliotek och bifogades till det här meddelandet.',
    'File saved privately to your library.': 'Filen sparades privat i ditt bibliotek.',
    '{value1} {value2} earlier {value3} saved{value4}.':
      '{value1} {value2} tidigare {value3} sparad{value4}.',
    'Extracted text for Poneva to read. Download the original for its layout, charts and images. Spreadsheet formulas show their saved results and are not recalculated.':
      'Extraherad text som Poneva kan läsa. Ladda ned originalet för layout, diagram och bilder. Kalkylbladsformler visar sina sparade resultat och beräknas inte om.',
    Esc: 'Esc',
    'Start something': 'Starta något',
    'Choose a file to work with': 'Välj en fil att arbeta med',
    'Skills worth adding': 'Kompetenser som kan vara värda att lägga till',
    'Picked for you': 'Utvalt för dig',
    'Reusable work grounded in your company knowledge.':
      'Återanvändbart arbete baserat på företagets kunskap.',
    'Ideas from your company context and recent work. Pick one to start.':
      'Idéer från företagets kontext och senaste arbete. Välj en för att komma igång.',
    'Refresh suggested tasks': 'Uppdatera föreslagna uppgifter',
    'Check for new company context.': 'Sök efter ny företagskontext.',
    'Check for new context. Ideas also refresh daily.':
      'Sök efter ny kontext. Idéer uppdateras också dagligen.',
    Refresh: 'Uppdatera',
    'Finding useful starting points…': 'Hittar användbara startpunkter…',
    'Suggestions aren’t available right now. Try Refresh, or describe the work you want to do.':
      'Förslag är inte tillgängliga just nu. Försök med Uppdatera eller beskriv arbetet du vill utföra.',
    'Loading the knowledge pages…': 'Läser in kunskapssidorna…',
    '{value1} All pages': '{value1} Alla sidor',
    'The page is created.': 'Sidan har skapats.',
    'Your new page is suggested. A publisher decides whether it is added.':
      'Din nya sida har föreslagits. En publicerare avgör om den läggs till.',
    'Company knowledge': 'Företagskunskap',
    'What Poneva knows about your company, page by page. Every change is kept.':
      'Det Poneva vet om ditt företag, sida för sida. Alla ändringar sparas.',
    'Loading company knowledge…': 'Läser in företagskunskap…',
    'Knowledge pages are not enabled in this workspace.':
      'Kunskapssidor är inte aktiverade i den här arbetsytan.',
    'Ask your Poneva contact to switch them on for your company.':
      'Be din Poneva-kontakt att aktivera dem för företaget.',
    '{value1} Change the agent': '{value1} Byt agent',
    '{value1} Continue in chat': '{value1} Fortsätt i chatten',
    Edit: 'Redigera',
    '{value1} Edit with chat': '{value1} Redigera med chatt',
    '{value1} Duplicate to my Library': '{value1} Duplicera till mitt bibliotek',
    'Duplicated to your Library. Only you can see the copy.':
      'Duplicerat till ditt bibliotek. Bara du kan se kopian.',
    'Could not duplicate this Result. Try again.':
      'Det gick inte att duplicera det här resultatet. Försök igen.',
    'Saved version {value1}.': 'Version {value1} sparad.',
    'A newer version was saved. Reload the Result before saving.':
      'En nyare version har sparats. Läs in resultatet igen innan du sparar.',
    'Could not save this version. Try again.':
      'Det gick inte att spara den här versionen. Försök igen.',
    '{value1} saved a newer version. Review it before saving.':
      '{value1} sparade en nyare version. Granska den innan du sparar.',
    'Hide their version': 'Dölj deras version',
    'Show their version': 'Visa deras version',
    'Start from their version': 'Börja med deras version',
    Markdown: 'Markdown',
    'Result text': 'Resultattext',
    Preview: 'Förhandsgranska',
    'What changed': 'Vad ändrades',
    'What changed? (optional)': 'Vad ändrades? (valfritt)',
    'Save version {value1}': 'Spara version {value1}',
    'Open chat': 'Öppna chatten',
    Current: 'Aktuell',
    Restore: 'Återställ',
    'Could not load the history.': 'Det gick inte att läsa in historiken.',
    'Restored version {value1} as version {value2}.':
      'Version {value1} återställdes som version {value2}.',
    'Someone saved a newer version. Review it before restoring.':
      'Någon har sparat en nyare version. Granska den innan du återställer.',
    'Could not restore that version.': 'Det gick inte att återställa den versionen.',
    'Loading history…': 'Läser in historik…',
    'Restoring keeps what is there now as a version too, so nothing is lost.':
      'Det som finns nu sparas också som en version när du återställer, så inget går förlorat.',
    'This Result was made with your own {value1}.':
      'Det här resultatet skapades med din egen {value1}.',
    'It also used': 'Det använde också',
    'This Result was made with': 'Det här resultatet skapades med',
    'Colleagues can read what came from them, but can never use them.':
      'Kollegor kan läsa det som kom från dem, men kan aldrig använda dem.',
    'Your personal agent {value1} keeps it up to date with your own access, so every refresh can carry your private data.':
      'Din personliga agent {value1} håller det uppdaterat med din egen åtkomst, så varje uppdatering kan innehålla dina privata data.',
    'A colleague’s personal agent keeps it up to date with their own access, so every refresh can carry their private data.':
      'En kollegas personliga agent håller det uppdaterat med sin egen åtkomst, så varje uppdatering kan innehålla deras privata data.',
    'Made private. Only you can see this meeting.': 'Gjort privat. Bara du kan se det här mötet.',
    'Could not make this meeting private.': 'Det gick inte att göra det här mötet privat.',
    'Meeting · {value1} {value2} · Original retained':
      'Möte · {value1} {value2} · Originalet har sparats',
    'The recording could not be opened.': 'Det gick inte att öppna inspelningen.',
    'Ask about this suggestion': 'Fråga om det här förslaget',
    meeting_processing_failed: 'mötesbearbetning misslyckades',
    'Who can see this': 'Vem kan se detta',
    'Everyone at {value1}': 'Alla på {value1}',
    'Only me': 'Bara jag',
    'Everyone at {value1} can find it and ask about it.':
      'Alla på {value1} kan hitta det och ställa frågor om det.',
    'Only you can open and search this meeting. You can share it later.':
      'Bara du kan öppna och söka i det här mötet. Du kan dela det senare.',
    'Added. Only you can see it. Transcription is running in the background.':
      'Tillagt. Bara du kan se det. Transkriberingen körs i bakgrunden.',
    'Visible to everyone at {value1}': 'Synligt för alla på {value1}',
    'Could not make it private.': 'Det gick inte att göra det privat.',
    'Show more meetings': 'Visa fler möten',
    'Attached to this message': 'Bifogat till det här meddelandet',
    'Connect securely, choose the tables to share, then decide whether Poneva can read or make changes.':
      'Anslut säkert, välj vilka tabeller som ska delas och bestäm sedan om Poneva får läsa eller göra ändringar.',
    'Review the tables this connection can access. Select at least one table.':
      'Granska vilka tabeller den här anslutningen kan komma åt. Välj minst en tabell.',
    'Select at least one table. Nothing is selected by default.':
      'Välj minst en tabell. Inget är valt som standard.',
    'Choose who can use this connection and what Poneva can do.':
      'Välj vem som får använda den här anslutningen och vad Poneva får göra.',
    'Your chosen access is enabled for the selected tables.':
      'Den valda åtkomsten är aktiverad för de valda tabellerna.',
    'Your connection is saved with reading paused until permission is confirmed.':
      'Din anslutning har sparats med läsning pausad tills behörigheten har bekräftats.',
    'Confirm database disconnect': 'Bekräfta frånkoppling av databasen',
    'Disconnect this database?': 'Koppla från den här databasen?',
    'Access will stop for everyone using this connection.':
      'Åtkomsten upphör för alla som använder den här anslutningen.',
    'Keep connection': 'Behåll anslutningen',
    'What it can reach · {value1}{value2} {value3}':
      'Vad den kan komma åt · {value1}{value2} {value3}',
    Back: 'Tillbaka',
    Continue: 'Fortsätt',
    'Uploading…': 'Laddar upp…',
    Library: 'Bibliotek',
    'Source material for your work. Available whenever you need it.':
      'Källmaterial för ditt arbete. Tillgängligt när du behöver det.',
    'The work you want to keep, with its sources and conversation attached.':
      'Arbetet du vill spara, med tillhörande källor och konversation.',
    Results: 'Resultat',
    Files: 'Filer',
    Artifacts: 'Artefakter',
    'Search library': 'Sök i biblioteket',
    'Find files by meaning…': 'Hitta filer efter innebörd…',
    'Find saved work by meaning…': 'Hitta sparat arbete efter innebörd…',
    'Search coverage is limited while indexing or meaning-based search is unavailable. You can retry or browse recent items.':
      'Sökningen är begränsad medan indexering pågår eller innebördssökning inte är tillgänglig. Du kan försöka igen eller bläddra bland de senaste objekten.',
    'No matching work found.': 'Inget matchande arbete hittades.',
    'A starting point for your next question.': 'En utgångspunkt för din nästa fråga.',
    'Good work is worth keeping.': 'Bra arbete är värt att spara.',
    'Try a different description or clear the search to browse.':
      'Försök med en annan beskrivning eller rensa sökningen för att bläddra.',
    'Upload source material once and use it in conversations and Skills. Your original stays in the library.':
      'Ladda upp källmaterial en gång och använd det i konversationer och färdigheter. Originalet finns kvar i biblioteket.',
    'Ask Poneva to save an answer, table or chart. Results stay connected to the conversation and their sources.':
      'Be Poneva spara ett svar, en tabell eller ett diagram. Resultaten förblir kopplade till konversationen och dess källor.',
    'Start in chat {value1}': 'Börja i chatten {value1}',
    'Open result: {value1}': 'Öppna resultat: {value1}',
    'Loading more library items…': 'Läser in fler objekt från biblioteket…',
    'Load more': 'Läs in fler',
    'Documents, transcripts, audio and video · Up to 500 MB per file. New files are private. Choose their audience with Share and which processable files become searchable company knowledge.':
      'Dokument, transkriberingar, ljud och video · Upp till 500 MB per fil. Nya filer är privata. Välj målgrupp med Dela och vilka bearbetningsbara filer som ska bli sökbara i företagets kunskap.',
    Skills: 'Färdigheter',
    'Create in chat': 'Skapa i chatten',
    'Search Skills': 'Sök efter färdigheter',
    'Search finds published Skills. Clear the search to browse your drafts too.':
      'Sökningen hittar publicerade färdigheter. Rensa sökningen om du även vill bläddra bland dina utkast.',
    'Search coverage is limited while indexing or meaning-based search is unavailable.':
      'Sökningen är begränsad medan indexering eller betydelsebaserad sökning inte är tillgänglig.',
    'Searching Skills…': 'Söker efter färdigheter…',
    'No matching published Skills found. Try a different description.':
      'Inga matchande publicerade färdigheter hittades. Försök med en annan beskrivning.',
    'Load more Skills': 'Läs in fler färdigheter',
    'View Skill: {value1}': 'Visa färdighet: {value1}',
    'Company workspace': 'Företagets arbetsyta',
    'View {value1}': 'Visa {value1}',
    'Loading Skills…': 'Läser in färdigheter…',
    'Try again {value1}': 'Försök igen {value1}',
    'Try again': 'Försök igen',
    'Nothing yet.': 'Ingenting ännu.',
    'Made from · Used by': 'Skapad från · Används av',
    'Could not load links': 'Det gick inte att läsa in länkar',
    'Made from': 'Skapad från',
    'Used by': 'Används av',
    'About this chat {value1}': 'Om den här chatten {value1}',
    'About this chat': 'Om den här chatten',
    'Keep the work moving.': 'Håll arbetet igång.',
    'Ask a follow-up with this result in view, or turn a useful approach into a company Skill.':
      'Ställ en följdfråga med det här resultatet synligt, eller omvandla ett användbart tillvägagångssätt till en företagsfärdighet.',
    'Save approach as a Skill': 'Spara tillvägagångssättet som en färdighet',
    'Preview of': 'Förhandsvisning av',
    'Made with': 'Skapad med',
    'Open the draft': 'Öppna utkastet',
    'Open Skill': 'Öppna färdighet',
    'Use in chat': 'Använd i chatten',
    'Finish the draft': 'Slutför utkastet',
    'Refine this Skill': 'Förbättra den här färdigheten',
    'Made with a Skill.': 'Skapad med en färdighet.',
    'This workspace could not be loaded just now, so that Skill cannot be opened yet. The result itself is unchanged.':
      'Den här arbetsytan kunde inte läsas in just nu, så färdigheten kan inte öppnas än. Resultatet är oförändrat.',
    'That Skill is not available in this workspace, so it cannot be opened or used again. The result itself is unchanged.':
      'Den färdigheten är inte tillgänglig i den här arbetsytan och kan därför inte öppnas eller användas igen. Resultatet är oförändrat.',
    'Result · {value1} {value2}': 'Resultat · {value1} {value2}',
    '{value1} Copy link': '{value1} Kopiera länk',
    'Result link copied.': 'Resultatlänken har kopierats.',
    'Could not copy the link. Use your browser address bar.':
      'Det gick inte att kopiera länken. Använd webbläsarens adressfält.',
    'No preview is available for this result.':
      'Ingen förhandsvisning är tillgänglig för det här resultatet.',
    '{value1} rows are retained in this snapshot. Open Table to inspect the values.':
      '{value1} rader finns kvar i den här ögonblicksbilden. Öppna Tabell för att granska värdena.',
    'People can’t edit a Result an agent keeps up to date; the next refresh would replace their edit. Change the agent’s instructions instead.':
      'Det går inte att redigera ett resultat som en agent håller uppdaterat. Nästa uppdatering skulle ersätta ändringen. Ändra agentens instruktioner i stället.',
    'Linked sources': 'Länkade källor',
    'Saved source': 'Sparad källa',
    'No source documents are linked to this result. Company knowledge and other references may be cited in the answer.':
      'Inga källdokument är länkade till det här resultatet. Företagets kunskap och andra referenser kan citeras i svaret.',
    'Run details': 'Körningsinformation',
    Created: 'Skapad',
    ', revised {value1}': ', reviderad {value1}',
    Conversation: 'Konversation',
    'Not recorded': 'Inte inspelad',
    'Open conversation': 'Öppna konversation',
    Run: 'Körning',
    Updates: 'Uppdateringar',
    'Kept up to date by {value1}': 'Hålls uppdaterad av {value1}',
    'Version {value1}': 'Version {value1}',
    'Could not open this request.': 'Det gick inte att öppna den här begäran.',
    'Approved version published.': 'Den godkända versionen har publicerats.',
    'Request rejected. The item stays unchanged.': 'Begäran avslogs. Objektet förblir oförändrat.',
    'Could not save the decision.': 'Det gick inte att spara beslutet.',
    'Proposed company change': 'Föreslagen företagsändring',
    'Opening…': 'Öppnar…',
    'Approve this version': 'Godkänn den här versionen',
    Decline: 'Avslå',
    'Review the submitted version below. Changes made since submission will need a new request.':
      'Granska den inskickade versionen nedan. Ändringar som har gjorts efter inskickningen kräver en ny begäran.',
    'The version submitted with this request.': 'Versionen som skickades in med den här begäran.',
    'Version and proposed change': 'Version och föreslagen ändring',
    'Could not read the pinned content.': 'Det gick inte att läsa det fästa innehållet.',
    'Showing a page of {value1} characters.': 'Visar en sida med {value1} tecken.',
    'Beginning of the submitted content. Open the full text to review every page.':
      'Början av det inskickade innehållet. Öppna hela texten för att granska alla sidor.',
    'Read full submitted text': 'Läs hela den inskickade texten',
    'Previous page': 'Föregående sida',
    'Next page': 'Nästa sida',
    'Made private. Its creator has been told in their Inbox.':
      'Gjort privat. Skaparen har fått information i sin inkorg.',
    'Made private. Its creator could not be notified.':
      'Gjort privat. Skaparen kunde inte meddelas.',
    'Make this {value1} private?': 'Vill du göra {value1} privat?',
    'Only the person who created it will see it. Everyone else loses access right away, and its creator gets an Inbox update if they are still a company member. If they have left, nobody in the company will be able to access this item.':
      'Det är bara personen som skapade det som kan se det. Alla andra förlorar åtkomsten direkt, och skaparen får en uppdatering i inkorgen om hen fortfarande är medlem i företaget. Om personen har lämnat företaget kan ingen där komma åt objektet.',
    'Sent for review. The current audience stays unchanged until approval.':
      'Skickad för granskning. Den nuvarande målgruppen förblir oförändrad tills den har godkänts.',
    'This suggestion is no longer available to you.':
      'Det här förslaget är inte längre tillgängligt för dig.',
    'We could not check where this suggestion stands.':
      'Vi kunde inte kontrollera statusen för det här förslaget.',
    'Check again': 'Kontrollera igen',
    'Show on page': 'Visa på sidan',
    'The editor could not be loaded. Poneva may have been updated since you opened this page. Reload to get the latest version; nothing on this page has changed.':
      'Redigeraren kunde inte läsas in. Poneva kan ha uppdaterats sedan du öppnade den här sidan. Läs in sidan igen för att hämta den senaste versionen. Ingenting på sidan har ändrats.',
    'Reload Poneva': 'Läs in Poneva igen',
    Formatting: 'Formatering',
    'Text style': 'Textstil',
    Text: 'Text',
    Heading: 'Rubrik',
    Subheading: 'Underrubrik',
    'Link a page': 'Länka en sida',
    'A page needs a title.': 'En sida måste ha en titel.',
    'Nothing has changed yet.': 'Ingenting har ändrats ännu.',
    'A page needs some text. To remove a page, archive it instead.':
      'En sida måste innehålla text. Arkivera sidan om du vill ta bort den.',
    'A suggested new page needs some text.': 'En föreslagen ny sida måste innehålla text.',
    'This page is larger than 256 KB. Split it into smaller pages.':
      'Den här sidan är större än 256 KB. Dela upp den i mindre sidor.',
    'Say in a few words why this change is right.':
      'Beskriv med några få ord varför den här ändringen är rätt.',
    'This page changed while you were editing. Your text is still here: copy it, then open the latest version and make your change again.':
      'Den här sidan ändrades medan du redigerade. Din text finns fortfarande kvar: kopiera den, öppna sedan den senaste versionen och gör ändringen igen.',
    'Your text is copied.': 'Din text har kopierats.',
    'Your text could not be copied. Select it in the editor and copy it.':
      'Din text kunde inte kopieras. Markera den i redigeraren och kopiera den.',
    'The page “{value1}” is created.': 'Sidan ”{value1}” har skapats.',
    'New page': 'Ny sida',
    'Editing {value1}': 'Redigerar {value1}',
    Editing: 'Redigerar',
    'Creating publishes the page under {value1} for everyone':
      'När du skapar sidan publiceras den under {value1} för alla',
    'Saving publishes the new version for everyone':
      'När du sparar publiceras den nya versionen för alla',
    'Your changes are sent as a suggestion for a publisher':
      'Dina ändringar skickas som ett förslag till en publicerare',
    'Create page': 'Skapa sida',
    Save: 'Spara',
    'Send suggestion': 'Skicka förslag',
    '{value1} Copy my text': '{value1} Kopiera min text',
    'Open the latest version': 'Öppna den senaste versionen',
    'Page title': 'Sidtitel',
    'Loading the editor…': 'Läser in redigeraren…',
    'New page text': 'Text på den nya sidan',
    'Text of {value1}': 'Text för {value1}',
    'Write the page. Type [[ to link another page.':
      'Skriv på sidan. Skriv [[ för att länka till en annan sida.',
    'Type [[ to link another page.': 'Skriv [[ för att länka till en annan sida.',
    'Link to a page': 'Länka till en sida',
    'What changed, in a few words': 'Vad ändrades, med några få ord',
    'Where this comes from, in a few words': 'Var detta kommer från, med några få ord',
    'Shown in the page history.': 'Visas i sidhistoriken.',
    'A publisher sees this next to your change.': 'En publicerare ser detta bredvid din ändring.',
    '1 suggestion is open on this page': '1 förslag är öppet på den här sidan',
    '{value1} suggestions are open on this page': '{value1} förslag är öppna på den här sidan',
    'They stay open while you edit. After you save, they show against your new text; one whose words you changed is marked outdated.':
      'De förblir öppna medan du redigerar. När du har sparat visas de mot din nya text. Ett förslag vars ord du har ändrat markeras som inaktuellt.',
    'Type [[ to link another page. Links keep working when a page is renamed or moved.':
      'Skriv [[ för att länka till en annan sida. Länkarna fortsätter att fungera när en sida byter namn eller flyttas.',
    'Loading the history…': 'Läser in historiken…',
    'This page has no saved text yet.': 'Den här sidan har ingen sparad text ännu.',
    'Say in a few words why this revision should come back.':
      'Beskriv med några få ord varför den här versionen bör återställas.',
    'Revision {value1} is suggested for a publisher to accept.':
      'Version {value1} har föreslagits för godkännande av en publicerare.',
    'The page already reads like this revision.': 'Sidan ser redan ut som den här versionen.',
    'Revision {value1} is restored as revision {value2}.':
      'Version {value1} har återställts som version {value2}.',
    'Revision history': 'Versionshistorik',
    Revisions: 'Versioner',
    'Every saved revision is kept.': 'Alla sparade versioner behålls.',
    'Revision {value1} {value2}': 'Version {value1} {value2}',
    'Revision {value1} compared with revision {value2}':
      'Version {value1} jämförd med version {value2}',
    'Revision {value1}, the first text of this page':
      'Version {value1}, den första texten på den här sidan',
    'Green was added, struck through was removed.':
      'Grönt lades till och överstruken text togs bort.',
    '{value1} Export Markdown': '{value1} Exportera Markdown',
    'Restore this revision': 'Återställ den här versionen',
    'Suggest restoring it': 'Föreslå att den återställs',
    'Why should this revision come back?': 'Varför bör den här versionen återställas?',
    'Loading this revision…': 'Läser in den här versionen…',
    'Only the title changed, from “{value1}” to “{value2}”.':
      'Endast titeln ändrades, från ”{value1}” till ”{value2}”.',
    'The text did not change in this revision.': 'Texten ändrades inte i den här versionen.',
    'Changes in revision {value1}': 'Ändringar i version {value1}',
    'Loading page…': 'Läser in sidan…',
    'Loading suggestion…': 'Läser in förslaget…',
    'This suggestion is not available.': 'Det här förslaget är inte tillgängligt.',
    'It may have been decided, or it is not one you can see.':
      'Det kan redan ha avgjorts, eller så har du inte åtkomst till det.',
    'Open Knowledge': 'Öppna Kunskap',
    'Opening the suggestion…': 'Öppnar förslaget…',
    'Choose where the page goes.': 'Välj var sidan ska placeras.',
    'Say in a few words why.': 'Beskriv med några få ord varför.',
    'Your suggestion is sent. A publisher decides.':
      'Ditt förslag har skickats. En publicerare fattar beslutet.',
    'Moved under {value1}.': 'Flyttad under {value1}.',
    'Deleted “{value1}”.': '”{value1}” har tagits bort.',
    'Could not update sharing.': 'Det gick inte att uppdatera delningen.',
    'They can follow new answers live and fork it to continue with their own connections. Only you write here. You can make it private again at any time.':
      'De kan följa nya svar direkt och skapa en egen kopia för att fortsätta med sina egna anslutningar. Det är bara du som kan skriva här. Du kan göra den privat igen när som helst.',
    'They see the project, its brief and the work in it they can already open. Nothing in it opens for anyone because of the project; each item keeps its own access.':
      'De ser projektet, dess beskrivning och det arbete i det som de redan kan öppna. Inget i projektet blir tillgängligt för någon på grund av projektet; varje objekt behåller sin egen åtkomst.',
    'Check the content for private information before sharing. Sharing an item does not grant access to its original chat or private connections.':
      'Kontrollera att innehållet inte innehåller privat information innan du delar det. Att dela ett objekt ger inte åtkomst till dess ursprungliga chatt eller privata anslutningar.',
    '{value1} Everyone you share with can read it, including what the assistant or an App in it found in your {value2}. They can’t use your {value3}. Nothing changes for you: the chat keeps working with all your accounts.':
      '{value1} Alla du delar med kan läsa det, inklusive det som assistenten eller en app i det hittade i din {value2}. De kan inte använda din {value3}. Ingenting ändras för dig: chatten fortsätter att fungera med alla dina konton.',
    '{value1} Everyone you share with can read them, but nobody can use {value2} through this chat.':
      '{value1} Alla du delar med kan läsa dem, men ingen kan använda {value2} via den här chatten.',
    'This controls access to the working draft. Any published company version stays available until you explicitly unpublish it. To publish a new version, complete its preview and use Save Skill. Run results stay private.':
      'Det här styr åtkomsten till arbetsutkastet. Alla publicerade företagsversioner förblir tillgängliga tills du uttryckligen avpublicerar dem. Om du vill publicera en ny version slutför du förhandsgranskningen och väljer Spara kompetens. Körningsresultat förblir privata.',
    'Skill deleted. You can restore it from the Skills archive for 30 days.':
      'Kompetensen har tagits bort. Du kan återställa den från kompetensarkivet i 30 dagar.',
    'Could not delete this Skill.': 'Det gick inte att ta bort den här kompetensen.',
    'More actions': 'Fler åtgärder',
    'Delete “{value1}”? It will disappear from Skills and search, and cannot be used by agents. You can restore it for 30 days. Existing chats and results stay available.':
      'Ta bort ”{value1}”? Den försvinner från Kompetenser och sökresultat och kan inte användas av agenter. Du kan återställa den i 30 dagar. Befintliga chattar och resultat förblir tillgängliga.',
    'Deleting…': 'Tar bort…',
    'Confirm delete': 'Bekräfta borttagning',
    'Delete Skill': 'Ta bort kompetens',
    'Skill restored as an unpublished draft. Its author can review and publish it again.':
      'Kompetensen har återställts som ett opublicerat utkast. Dess författare kan granska och publicera den igen.',
    'Could not restore this Skill.': 'Det gick inte att återställa den här kompetensen.',
    'Archived Skills': 'Arkiverade kompetenser',
    'Deleted Skills can be restored for 30 days. Restoring leaves them unpublished.':
      'Borttagna kompetenser kan återställas i 30 dagar. När de återställs förblir de opublicerade.',
    'Restore until {value1}': 'Återställ till och med {value1}',
    'Loading…': 'Laddar…',
    'No archived Skills.': 'Inga arkiverade kompetenser.',
    'Load more archived Skills': 'Ladda fler arkiverade kompetenser',
    'Show more of the original': 'Visa mer av originalet',
    'Filter result rows': 'Filtrera resultatrader',
    'Find a product or value…': 'Hitta en produkt eller ett värde…',
    '{value1} of {value2}': '{value1} av {value2}',
    'Result table': 'Resultattabell',
    'No matching rows.': 'Inga matchande rader.',
    'Showing the first 1,000 matching rows. Download the CSV for every row.':
      'Visar de första 1 000 matchande raderna. Ladda ner CSV-filen för alla rader.',
    'Agent ·': 'Agent ·',
    'Only you': 'Bara du',
    'Stopped before it finished.': 'Stoppades innan det blev klart.',
    'Drafting the project…': 'Skapar ett utkast av projektet…',
    'Checking where this chat belongs…': 'Kontrollerar var den här chatten hör hemma…',
    'Moving the chat…': 'Flyttar chatten…',
    'Taking it out of the project…': 'Tar bort den från projektet…',
    'Adding it to the project…': 'Lägger till den i projektet…',
    'No matching connections are available right now.':
      'Inga matchande anslutningar är tillgängliga just nu.',
    'Company knowledge suggestion': 'Förslag på företagskunskap',
    'Company knowledge now lives on pages. Open Knowledge to see them.':
      'Företagskunskap finns nu på sidor. Öppna Kunskap för att se dem.',
    '{value1} · Open beside this conversation': '{value1} · Öppna bredvid den här konversationen',
    'Name {value1}': 'Namn {value1}',
    'Host {value1}': 'Värd {value1}',
    'Port {value1}': 'Port {value1}',
    'Database {value1}': 'Databas {value1}',
    'Username {value1}': 'Användarnamn {value1}',
    'Password {value1}': 'Lösenord {value1}',
    'Advanced TLS': 'Avancerad TLS',
    '{value1} Poneva verifies the server certificate. Add a CA or server DNS name for IP hosts when your certificate requires it.':
      '{value1} Poneva verifierar servercertifikatet. Lägg till en CA eller serverns DNS-namn för IP-värdar när certifikatet kräver det.',
    'CA certificate {value1}': 'CA-certifikat {value1}',
    'Certificate server DNS name {value1}': 'Serverns DNS-namn för certifikatet {value1}',
    '{value1} Your password is encrypted in secure storage. Poneva verifies the connection before saving it.':
      '{value1} Ditt lösenord krypteras i säker lagring. Poneva verifierar anslutningen innan den sparas.',
    'Testing…': 'Testar…',
    'Test connection': 'Testa anslutning',
    'PostgreSQL is connected.': 'PostgreSQL är anslutet.',
    'PostgreSQL was saved safely.': 'PostgreSQL sparades säkert.',
    'Poneva can read and change rows in the selected tables. Apps also follow their approved data scope.':
      'Poneva kan läsa och ändra rader i de valda tabellerna. Appar följer också sitt godkända dataomfång.',
    'Poneva can read the selected tables. Apps also follow their approved data scope.':
      'Poneva kan läsa de valda tabellerna. Appar följer också sitt godkända dataomfång.',
    'Reads are paused until permission is enabled.':
      'Läsning är pausad tills behörigheten aktiveras.',
    'Retrying…': 'Försöker igen…',
    'Retry permission': 'Försök med behörighet igen',
    'Try it in Chat': 'Prova i Chat',
    Done: 'Klart',
    'Disconnect database': 'Koppla från databas',
    '{value1} TLS verified ·{value2} {value3}': '{value1} TLS verifierad ·{value2} {value3}',
    'Search schemas and tables': 'Sök efter scheman och tabeller',
    'Search tables': 'Sök efter tabeller',
    '{value1} of {value2} tables selected': '{value1} av {value2} tabeller valda',
    'Select matching tables': 'Välj matchande tabeller',
    'Select all tables': 'Välj alla tabeller',
    Clear: 'Rensa',
    'Select a whole schema or individual tables. New tables need a fresh selection.':
      'Välj ett helt schema eller enskilda tabeller. Nya tabeller kräver ett nytt urval.',
    'No tables match this search.': 'Inga tabeller matchar sökningen.',
    'All tables in {value1}': 'Alla tabeller i {value1}',
    '{value1} / {value2} tables': '{value1} / {value2} tabeller',
    'Read & write available': 'Läsning och skrivning tillgängliga',
    'Read only': 'Endast läsning',
    Ctrl: 'Ctrl',
    'This suggested knowledge update could not be shown.':
      'Det föreslagna kunskapsuppdateringen kunde inte visas.',
    'Suggested knowledge update': 'Föreslagen kunskapsuppdatering',
    'Suggestion {value1} of {value2}': 'Förslag {value1} av {value2}',
    'Next suggestion': 'Nästa förslag',
    'Fold the suggestions away': 'Fäll ihop förslagen',
    'Show the suggestions': 'Visa förslagen',
    '1 suggestion': '1 förslag',
    '{value1} suggestions': '{value1} förslag',
    '{value1} the pages under {value2}': '{value1} sidorna under {value2}',
    px: 'px',
    '{value1} chart of {value2} across {value3}': '{value1}-diagram över {value2} för {value3}',
    'We could not build the file.': 'Det gick inte att skapa filen.',
    '{value1} Present': '{value1} närvarande',
    'Building…': 'Skapar…',
    'Download PowerPoint': 'Ladda ner PowerPoint',
    'Slide {value1} of {value2}': 'Bild {value1} av {value2}',
    Slides: 'Bilder',
    'Slide {value1}': 'Bild {value1}',
    'Speaker notes': 'Talaranteckningar',
    'Source: {value1}': 'Källa: {value1}',
    'Add a name and a web address.': 'Lägg till ett namn och en webbadress.',
    'Enter a valid web address.': 'Ange en giltig webbadress.',
    'Use a web address that starts with https://.': 'Använd en webbadress som börjar med https://.',
    'Add a custom connection': 'Lägg till en anpassad anslutning',
    'Connect a tool server you trust. Poneva checks the address works and saves only the connection details needed to use it.':
      'Anslut till en verktygsserver du litar på. Poneva kontrollerar att adressen fungerar och sparar endast de anslutningsuppgifter som behövs för att använda den.',
    'Web address': 'Webbadress',
    'https://tools.example.com': 'https://tools.example.com',
    'Starts with https://, from your provider': 'Börjar med https://, från din leverantör',
    'Sign-in': 'Inloggning',
    'Advanced sign-in': 'Avancerad inloggning',
    'Access key {value1}': 'Åtkomstnyckel {value1}',
    'Request headers': 'Begärandehuvuden',
    'Add header': 'Lägg till huvud',
    'Header {value1} name': 'Namn på huvud {value1}',
    'Header name': 'Namn på huvud',
    'Header {value1} value': 'Värde för huvud {value1}',
    'Header value': 'Värde för huvud',
    'Remove header': 'Ta bort huvud',
    Advanced: 'Avancerat',
    Transport: 'Transport',
    'Auto-detect': 'Identifiera automatiskt',
    'Streamable HTTP': 'Streamable HTTP',
    'Legacy SSE': 'Äldre SSE',
    "From your provider's app settings. Leave empty unless they gave you these.":
      'Från appinställningarna hos din leverantör. Lämna tomt om du inte har fått dessa uppgifter.',
    "Authorization server issuer": "Auktoriseringsserverns utfärdare",
    "Enter the authorization server issuer when using a client ID.": "Ange auktoriseringsserverns utfärdare när du använder ett klient-ID.",
    'Client ID {value1}': 'Klient-ID {value1}',
    'Client secret {value1}': 'Klienthemlighet {value1}',
    'Connecting…': 'Ansluter…',
    'Test and connect': 'Testa och anslut',
    'Add the store, the client ID and the client secret.':
      'Lägg till butiken, klient-ID:t och klienthemligheten.',
    'Connect your Shopify Developer App': 'Anslut din Shopify-utvecklarapp',
    'Poneva can use exactly the access your store gave the app, and nothing more. It talks to Shopify directly and keeps the client secret encrypted.':
      'Poneva kan endast använda den åtkomst som din butik gav appen. Den kommunicerar direkt med Shopify och lagrar klienthemligheten krypterad.',
    'How to create the app in Shopify': 'Så här skapar du appen i Shopify',
    'Open{value1} {value2}{value3} with the account that owns the store, and create an app.':
      'Öppna{value1} {value2}{value3} med kontot som äger butiken och skapa en app.',
    'Create a version and select the access scopes Poneva may use, for example read_products and read_orders. Add write_ scopes only for data Poneva may change. Then release the version.':
      'Skapa en version och välj de åtkomstomfång som Poneva får använda, till exempel read_products och read_orders. Lägg endast till write_-omfång för data som Poneva får ändra. Publicera sedan versionen.',
    'For orders and customers, also select protected customer data in the app’s settings. Shopify allows this without review for an app made for your own store.':
      'För order och kunder väljer du även skyddade kunduppgifter i appens inställningar. Shopify tillåter detta utan granskning för en app som skapats för din egen butik.',
    'Install the app on your store.': 'Installera appen i din butik.',
    'Copy the client ID and client secret from the app’s settings.':
      'Kopiera klient-ID:t och klienthemligheten från appens inställningar.',
    'To change the access later, release a new version, approve it on the store and use Test connection here.':
      'Om du vill ändra åtkomsten senare publicerar du en ny version, godkänner den i butiken och använder Testa anslutning här.',
    Store: 'Butik',
    'your-store.myshopify.com': 'your-store.myshopify.com',
    'Your store’s .myshopify.com address (Shopify admin → Settings → Domains), or paste the address of your Shopify admin page':
      'Din butiks .myshopify.com-adress (Shopify-administratör → Settings → Domains), eller klistra in adressen till din Shopify-administratörssida',
    'Client ID {value1} {value2}': 'Klient-ID {value1} {value2}',
    'Client secret {value1} {value2}': 'Klienthemlighet {value1} {value2}',
    Person: 'Person',
    Everyone: 'Alla',
    Connection: 'Anslutning',
    'All connections': 'Alla anslutningar',
    'App {value1}': 'App {value1}',
    'From {value1}': 'Från {value1}',
    'Until {value1}': 'Till {value1}',
    Result: 'Resultat',
    'All results': 'Alla resultat',
    Succeeded: 'Lyckades',
    Denied: 'Nekades',
    Failed: 'Misslyckades',
    Unknown: 'Okänt',
    Filter: 'Filter',
    'Loading activity…': 'Läser in aktivitet…',
    'Could not load activity. Try again.': 'Det gick inte att läsa in aktiviteten. Försök igen.',
    'Removed connection': 'Borttagen anslutning',
    'App: {value1}': 'App: {value1}',
    'Older activity': 'Äldre aktivitet',
    'Archived. Its history is kept.': 'Arkiverad. Historiken sparas.',
    'Choose the page it goes under. Links to it keep working.':
      'Välj sidan den ska ligga under. Länkar till den fortsätter att fungera.',
    'Its text, its history and any open suggestions are removed for good, and links to it from other pages stop working. This cannot be undone.':
      'Texten, historiken och eventuella öppna förslag tas bort permanent, och länkar till den från andra sidor slutar fungera. Detta går inte att ångra.',
    'An archived page no longer informs answers. Its history is kept, and a publisher can restore it or delete it permanently.':
      'En arkiverad sida bidrar inte längre till svar. Historiken sparas, och en publicerare kan återställa den eller ta bort den permanent.',
    Under: 'Under',
    Change: 'Ändra',
    'Move under': 'Flytta under',
    'Search pages': 'Sök sidor',
    'Why?': 'Varför?',
    'Delete permanently': 'Ta bort permanent',
    'Move page': 'Flytta sida',
    'Archive page': 'Arkivera sida',
    'Suggestion {value1}: show its card': 'Förslag {value1}: visa dess kort',
    'Removed:': 'Borttagen:',
    'Added:': 'Tillagd:',
    'New page “{value1}”{value2}': 'Ny sida ”{value1}”{value2}',
    'No pages match “{value1}”.': 'Inga sidor matchar ”{value1}”.',
    'Where this page is': 'Var den här sidan finns',
    'Describe your company': 'Beskriv ditt företag',
    'Empty page': 'Tom sida',
    'Describe {value1}': 'Beskriv {value1}',
    'This page has no text yet.': 'Den här sidan har ingen text än.',
    'Poneva reads this page before every answer. Start with who you are, what you sell and how you work; details go on the pages under it.':
      'Poneva läser den här sidan före varje svar. Börja med vilka ni är, vad ni säljer och hur ni arbetar. Lägg detaljer på sidorna under den.',
    'Write it, or ask Poneva in chat to draft it for you.':
      'Skriv själv eller be Poneva skriva ett utkast åt dig i chatten.',
    'Suggest a first version, and a publisher decides whether it becomes the page.':
      'Föreslå en första version. En publicerare avgör om den ska bli sidan.',
    'Start writing': 'Börja skriva',
    'Suggest a first version': 'Föreslå en första version',
    'Accepted. The page is archived.': 'Godkänt. Sidan arkiveras.',
    'Accepted. The page is now revision {value1}.': 'Godkänt. Sidan är nu version {value1}.',
    'Accepted.': 'Godkänt.',
    'Suggestion rejected. The page stays as it is.':
      'Förslaget avvisades. Sidan förblir oförändrad.',
    'Your suggestion is withdrawn.': 'Ditt förslag har dragits tillbaka.',
    'Restored. The page informs answers again.': 'Återställd. Sidan bidrar till svar igen.',
    'Your suggestion is sent. A publisher decides whether it becomes the page.':
      'Ditt förslag har skickats. En publicerare avgör om det ska bli sidan.',
    'Saved. The page is now revision {value1}.': 'Sparat. Sidan är nu version {value1}.',
    'Nothing changed.': 'Inget ändrades.',
    'This page is not available.': 'Den här sidan är inte tillgänglig.',
    'It may have been deleted, archived or moved out of reach, or you may no longer be in this company.':
      'Den kan ha tagits bort, arkiverats eller flyttats utom räckhåll, eller så tillhör du inte längre det här företaget.',
    'Page actions': 'Sidåtgärder',
    shown: 'visas',
    hidden: 'döljs',
    '{value1} History': 'Historik för {value1}',
    '{value1} Ask in chat': '{value1} Fråga i chatten',
    'Suggest edits': 'Föreslå ändringar',
    'More actions for {value1}': 'Fler åtgärder för {value1}',
    '{value1} Poneva reads this page in every chat':
      '{value1} Poneva läser den här sidan i varje chatt',
    'This page is archived. It no longer informs answers; its history is kept. {value1}':
      'Den här sidan är arkiverad. Den bidrar inte längre till svar, men historiken sparas. {value1}',
    'Restore page': 'Återställ sida',
    'This link points to an earlier revision. You are reading the current text.':
      'Den här länken går till en tidigare version. Du läser den aktuella texten.',
    'Show it in History': 'Visa i historiken',
    Pages: 'Sidor',
    'Pages under {value1}': 'Sidor under {value1}',
    'Linked from': 'Länkad från',
    Suggestions: 'Förslag',
    'Suggestions are hidden. You are reading the page as everyone else sees it.':
      'Förslag är dolda. Du läser sidan som alla andra ser den.',
    'Loading suggestions…': 'Läser in förslag…',
    'Nothing is waiting for review.': 'Inget väntar på granskning.',
    'When someone, Poneva in a chat or a connected agent suggests a change to a page, it shows here and on the page. Nothing changes until a publisher accepts it.':
      'När någon, Poneva i en chatt eller en ansluten agent föreslår en ändring av en sida visas den här och på sidan. Inget ändras förrän en publicerare godkänner den.',
    '{value1} Review knowledge in chat': '{value1} Granska kunskap i chatten',
    'Suggestions for review': 'Förslag att granska',
    'Suggested changes from chats, meetings, colleagues and connected agents. Nothing changes until a publisher accepts it on the page.':
      'Föreslagna ändringar från chattar, möten, kollegor och anslutna agenter. Inget ändras förrän en publicerare godkänner dem på sidan.',
    'Your suggestions wait here until a publisher decides. The pages stay as they are until then.':
      'Dina förslag väntar här tills en publicerare fattar beslut. Sidorna förblir oförändrade tills dess.',
    'Review page': 'Granska sida',
    'Review on page': 'Granska på sidan',
    'Open the meeting': 'Öppna mötet',
    'Open the chat': 'Öppna chatten',
    'Accept and restore': 'Godkänn och återställ',
    Accept: 'Godkänn',
    Reject: 'Avvisa',
    'Your suggestion · waiting for a publisher': 'Ditt förslag · väntar på en publicerare',
    Withdraw: 'Dra tillbaka',
    'Waiting for a publisher': 'Väntar på en publicerare',
    'Suggestion {value1}': 'Förslag {value1}',
    'Suggestion {value1} from {value2}{value3}': 'Förslag {value1} från {value2}{value3}',
    'Read the suggested page': 'Läs den föreslagna sidan',
    'Outdated: the text it changes was edited after it was suggested. It can be rejected or withdrawn; a new suggestion can be made against the current text.':
      'Föråldrat: texten som ändras redigerades efter att förslaget skickades. Det kan avvisas eller dras tillbaka. Ett nytt förslag kan lämnas utifrån den aktuella texten.',
    'Restore this page first to accept this suggestion.':
      'Återställ sidan först för att godkänna det här förslaget.',
    'Previous suggestion': 'Föregående förslag',
    Download: 'Ladda ned',
    CSV: 'CSV',
    'Evidence for {value1}': 'Underlag för {value1}',
    Measure: 'Mått',
    'Show rows →': 'Visa rader →',
    'Ask about this number': 'Fråga om det här talet',
    'There are no numeric values available to chart. View the table for the original data.':
      'Det finns inga numeriska värden att visa i ett diagram. Visa tabellen för originaldata.',
    'Chart value': 'Diagramvärde',
    '{value1} of {value2} shown': '{value1} av {value2} visas',
    '{value1} by {value2}; {value3} rows. View Table for exact values.':
      '{value1} efter {value2}; {value3} rader. Visa tabellen för exakta värden.',
    'Values come directly from the source data. Missing values are not estimates.':
      'Värdena kommer direkt från källdata. Saknade värden är inte uppskattningar.',
    'Loading library…': 'Läser in bibliotek…',
    'We couldn’t load what happened in this App. Try again in a moment.':
      'Vi kunde inte läsa in det som hände i den här appen. Försök igen om en stund.',
    'This App could not be opened.': 'Den här appen kunde inte öppnas.',
    'Opening App…': 'Öppnar app…',
    'Open the saved App to run this function.':
      'Öppna den sparade appen för att köra den här funktionen.',
    'Save this App before running its function.': 'Spara den här appen innan du kör funktionen.',
    'Open saved App': 'Öppna sparad app',
    'Open Apps': 'Öppna appar',
    'The App could not be opened. Try again.': 'Appen kunde inte öppnas. Försök igen.',
    Owner: 'Ägare',
    '{value1} · admins': '{value1} · administratörer',
    'Owner · always edits': 'Ägare · redigerar alltid',
    'Admins manage it': 'Administratörer hanterar den',
    Editors: 'Redaktörer',
    'A colleague': 'En kollega',
    'Can edit drafts and publish versions': 'Kan redigera utkast och publicera versioner',
    Remove: 'Ta bort',
    'No editors yet.': 'Inga redaktörer ännu.',
    'Admins can always edit company agents.':
      'Administratörer kan alltid redigera företagets agenter.',
    'Asking for edit access': 'Ber om redigeringsåtkomst',
    'Asked {value1} · also in your Inbox': 'Begärde {value1} · finns även i din inkorg',
    Grant: 'Bevilja',
    Admin: 'Administratör',
    'Make personal': 'Gör personlig',
    'Switch off': 'Stäng av',
    Archive: 'Arkivera',
    'Archive this agent': 'Arkivera den här agenten',
    'Loading agent…': 'Läser in agent…',
    '{value1} Edit in chat': '{value1} Redigera i chatten',
    Agent: 'Agent',
    'This agent has not been created yet. It can run once its owner creates it.':
      'Den här agenten har inte skapats ännu. Den kan köras när ägaren har skapat den.',
    'New agent · Draft': 'Ny agent · Utkast',
    'Untitled agent': 'Namnlös agent',
    'Test run': 'Testkörning',
    'This draft does not run automatically.': 'Det här utkastet körs inte automatiskt.',
    'Describe the agent in the chat. Its draft appears here.':
      'Beskriv agenten i chatten. Utkastet visas här.',
    '{value1} Test run': '{value1} Testkörning',
    'Describe the agent in the chat first.': 'Beskriv först agenten i chatten.',
    'Create and turn on': 'Skapa och slå på',
    'Connection write setup': 'Konfiguration av skrivanslutning',
    'Account for connected changes': 'Konto för anslutna ändringar',
    'Choose a connection': 'Välj en anslutning',
    'No published Skills available. You can add them later.':
      'Inga publicerade färdigheter tillgängliga. Du kan lägga till dem senare.',
    '{value1} · not published. Review the changes. Testing is optional.':
      '{value1} · inte publicerad. Granska ändringarna. Testning är valfri.',
    '{value1} Test draft': '{value1} Testa utkast',
    'Apply changes…': 'Tillämpa ändringar…',
    'Apply this draft as a new version': 'Tillämpa det här utkastet som en ny version',
    'This draft cannot be applied.': 'Det här utkastet kan inte tillämpas.',
    'What changed?': 'Vad ändrades?',
    'Apply version {value1}': 'Tillämpa version {value1}',
    Create: 'Skapa',
    'Edit access requested': 'Redigeringsåtkomst begärd',
    '{value1} Request edit access': '{value1} Begär redigeringsåtkomst',
    '{value1} Copy agent': '{value1} Kopiera agent',
    Pause: 'Pausa',
    'Open agent: {value1}': 'Öppna agent: {value1}',
    '· you can edit': '· du kan redigera',
    '{value1} is switched off.': '{value1} är avstängd.',
    '{value1} is archived.': '{value1} är arkiverad.',
    'Loading agents…': 'Läser in agenter…',
    Agents: 'Agenter',
    'Agents do work for you on a schedule or when you ask. They follow your company’s Skills.':
      'Agenter utför arbete åt dig enligt ett schema eller när du ber dem. De följer företagets färdigheter.',
    'No agent matches. Try a Skill name or what the agent should do.':
      'Ingen agent matchar. Prova ett färdighetsnamn eller vad agenten ska göra.',
    'Nothing of your own yet': 'Inget eget ännu',
    'Tell Chat what an agent should do, or copy one of the company’s agents below.{value1}':
      'Berätta för Chat vad en agent ska göra eller kopiera en av företagets agenter nedan.{value1}',
    'Your agents': 'Dina agenter',
    'Run on demand': 'Kör vid behov',
    'Run is always available. A schedule is optional and lives separately from the agent’s instructions.':
      'Körning är alltid tillgänglig. Ett schema är valfritt och finns separat från agentens instruktioner.',
    'Enable this schedule when approved': 'Aktivera det här schemat när det har godkänts',
    Schedule: 'Schema',
    'Kept off until you create the agent from its canvas.':
      'Förblir inaktiverat tills du skapar agenten från dess arbetsyta.',
    'Will be enabled when you approve.': 'Aktiveras när du godkänner.',
    'Will be saved paused. You can enable it later.': 'Sparas pausat. Du kan aktivera det senare.',
    'Only runs when you ask.': 'Körs bara när du ber om det.',
    'Draft · approving saves it, and nothing runs. Test it and create it from its canvas.':
      'Utkast · när du godkänner sparas det, och inget körs. Testa det och skapa det från dess arbetsyta.',
    'Draft · nothing is scheduled until you approve. Connected actions require their own approval at run time.':
      'Utkast · inget schemaläggs förrän du godkänner. Anslutna åtgärder kräver eget godkännande när de körs.',
    Name: 'Namn',
    'Agent name': 'Agentnamn',
    'Who can use it': 'Vem kan använda den',
    'Company agent · company resources only': 'Företagsagent · endast företagsresurser',
    'Personal agent · runs with your access': 'Personlig agent · körs med din åtkomst',
    'Approving saves it as a draft. It does not run automatically.':
      'När du godkänner sparas den som ett utkast. Den körs inte automatiskt.',
    'Open the agent’s runs': 'Öppna agentens körningar',
    'Run the published version once': 'Kör den publicerade versionen en gång',
    'Stopping…': 'Stoppar…',
    'Stop run': 'Stoppa körning',
    'Could not stop this run. Please try again.':
      'Det gick inte att stoppa den här körningen. Försök igen.',
    'Run in progress': 'Körning pågår',
    'This run is still answering. You can ask follow-ups when it finishes.':
      'Den här körningen svarar fortfarande. Du kan ställa följdfrågor när den är klar.',
    'Open run details': 'Öppna körningsdetaljer',
    Runs: 'Körningar',
    'Open the run chat': 'Öppna körningschatten',
    Watch: 'Visa',
    Goal: 'Mål',
    'Change the goal': 'Ändra målet',
    'What it does': 'Vad den gör',
    'What should this agent achieve?': 'Vad ska den här agenten uppnå?',
    'Not set yet.': 'Inte angivet ännu.',
    'When it runs': 'När den körs',
    'Change when it runs': 'Ändra när den körs',
    'Off means it runs only when someone runs it. Changing when it runs never changes its instructions.':
      'Av innebär att den bara körs när någon kör den. Att ändra när den körs ändrar aldrig dess instruktioner.',
    Instructions: 'Instruktioner',
    'Change the instructions': 'Ändra instruktionerna',
    'How the agent should approach the work and make decisions.':
      'Hur agenten ska ta sig an arbetet och fatta beslut.',
    Boundaries: 'Begränsningar',
    'What to do or avoid. Every connected action still follows its approval.':
      'Vad den ska göra eller undvika. Alla anslutna åtgärder följer fortfarande sitt godkännande.',
    'No instructions of its own. It follows its Skills.':
      'Har inga egna instruktioner. Följer sina färdigheter.',
    'Pin a Skill': 'Fäst en färdighet',
    'Finds the Skills that fit each run, the same way a chat does.':
      'Hittar de färdigheter som passar för varje körning, på samma sätt som en chatt.',
    'Skills it always follows': 'Färdigheter den alltid följer',
    'A Skill that is not published': 'En färdighet som inte är publicerad',
    'Always follows · Version {value1}': 'Följer alltid · Version {value1}',
    'Not published': 'Inte publicerad',
    Uses: 'Använder',
    'Change in chat': 'Ändra i chatten',
    'Change in chat: Uses': 'Ändra i chatten: Använder',
    'Company knowledge and the tools each run is allowed to use.':
      'Företagskunskap och de verktyg som varje körning får använda.',
    'People see the Result refresh; they change the agent, not the page.':
      'Användarna ser Resultatet uppdateras; de ändrar agenten, inte sidan.',
    'The first run after it is created makes the Result; later runs add a version to it.':
      'Den första körningen efter att det har skapats skapar Resultatet; senare körningar lägger till en version av det.',
    'Emails whoever the run is for': 'Skickar e-post till den som körningen gäller',
    'Email each run': 'Skicka e-post för varje körning',
    Delivers: 'Levererar',
    'Change what it delivers': 'Ändra vad den levererar',
    'Expected result': 'Förväntat resultat',
    'What a successful run should deliver.': 'Vad en lyckad körning ska leverera.',
    'What each run delivers': 'Vad varje körning levererar',
    'Keeps one Result up to date {value1}': 'Håller ett Resultat uppdaterat {value1}',
    'Saves a new Result each run': 'Sparar ett nytt Resultat vid varje körning',
    'You can run this company agent as yourself.{value1} {value2}':
      'Du kan köra den här företagsagenten som dig själv.{value1} {value2}',
    'Changes since version': 'Ändringar sedan version',
    'are not live yet.': 'är inte aktiva ännu.',
    'Review them in Versions': 'Granska dem i Versioner',
    Skill: 'Färdighet',
    'The agent always uses the Skill’s published version.':
      'Agenten använder alltid färdighetens publicerade version.',
    Day: 'Dag',
    Time: 'Tid',
    'Cron expression': 'Cron-uttryck',
    'Editors and access': 'Redaktörer och åtkomst',
    Company: 'Företag',
    Personal: 'Personlig',
    'No changes.': 'Inga ändringar.',
    'Instructions changes': 'Ändringar av instruktioner',
    'Loading versions…': 'Läser in versioner…',
    'What the draft changes': 'Vad utkastet ändrar',
    'No published version yet. Try the draft, then publish it.':
      'Ingen publicerad version ännu. Testa utkastet och publicera det sedan.',
    'Published versions': 'Publicerade versioner',
    'Former member': 'Tidigare medlem',
    Live: 'Aktiv',
    'What changed in version {value1}': 'Vad ändrades i version {value1}',
    'Every publish is a version you can restore.':
      'Varje publicering är en version som du kan återställa.',
    Authorization: 'Auktorisering',
    '{value1} {value2} · {value3} will see it.': '{value1} {value2} · {value3} kommer att se det.',
    '{value1} {value2} you': '{value1} {value2} du',
    '· Revised': '· Reviderad',
    'This chat used your {value1}.': 'Den här chatten använde din {value1}.',
    'This chat has results from {value1}.': 'Den här chatten har resultat från {value1}.',
    'db.example.com': 'db.example.com',
    'e.g. Product analytics': 't.ex. Produktanalys',
    'Paste access key': 'Klistra in åtkomstnyckel',
    'Shopify’s Dev Dashboard': 'Shopify’s Dev Dashboard',
    'App reference': 'Appreferens',
    'Draft · revision {value1}': 'Utkast · version {value1}',
    'its Result': 'dess resultat',
    '· its first run makes it': '· dess första körning gör den',
    '{value1}’s chat ·': '{value1}s chatt ·',
    '{value1} ad {value2} available.': '{value1} och {value2} tillgängliga.',
    '{value1} rows ·': '{value1} rader ·',
    'It starts private. Sharing it wider shares every refresh, which can carry your private data.':
      'Den är privat från början. Om du delar den med fler delas varje uppdatering, vilket kan innebära att dina privata data delas.',
    'Add note': 'Lägg till anteckning',
    Note: 'Anteckning',
    Saved: 'Sparad',
    Total: 'Totalt',
    ascending: 'stigande',
    descending: 'fallande',
    'Scroll to see all columns': 'Rulla för att se alla kolumner',
    '{value1} for {value2}': '{value1} för {value2}',
    Suggested: 'Föreslaget',
    'Opening your conversation…': 'Öppnar din konversation…',
    'This conversation isn’t available': 'Den här konversationen är inte tillgänglig',
    'It may have been deleted, belong to another account, or be temporarily unavailable.':
      'Den kan ha tagits bort, tillhöra ett annat konto eller vara tillfälligt otillgänglig.',
    '{count} more line — shown in the complete revision':
      '{count} rad till — visas i den fullständiga revisionen',
    '{count} more lines — shown in the complete revision':
      '{count} rader till — visas i den fullständiga revisionen',
    '{count} more line removed': '{count} rad till borttagen',
    '{count} more lines removed': '{count} rader till borttagna',
    '{count} unchanged line': '{count} oförändrad rad',
    '{count} unchanged lines': '{count} oförändrade rader',
    '{count} more lines not shown, {added} added and {removed} removed. Check them in the complete revision.':
      '{count} ytterligare rader visas inte, {added} tillagda och {removed} borttagna. Kontrollera dem i den fullständiga revisionen.',
    'Saved result': 'Sparat resultat',
    'Made with a Skill': 'Skapat med en färdighet',
    'Preview of {name}': 'Förhandsvisning av {name}',
    'Made with {name}': 'Skapat med {name}',
    'Ad-hoc result': 'Ad hoc-resultat',
    'A Skill that is not available in this workspace':
      'En färdighet som inte är tillgänglig i den här arbetsytan',
    '{name} · Revision {version}': '{name} · Revidering {version}',
    '{name} · Version {version}': '{name} · Version {version}',
    'Return to conversation {value1}': 'Återgå till konversationen {value1}',
    '{value1} Working with {value2}': '{value1} arbetar med {value2}',
    'View context {value1}': 'Visa kontext {value1}',
    'A way of working, made yours.': 'Ett arbetssätt, gjort till ditt.',
    'Work that runs itself.': 'Arbete som sköter sig självt.',
    'One place for one piece of work.': 'En plats för ett arbete.',
    'Let’s move your work forward{value1}.': 'Låt oss föra ditt arbete framåt{value1}.',
    'Describe the work. Your Skill takes shape beside the conversation.':
      'Beskriv arbetet. Din färdighet tar form bredvid konversationen.',
    'Describe what it should do and when. Your agent takes shape beside the conversation. The draft does not run automatically.':
      'Beskriv vad den ska göra och när. Din agent tar form bredvid konversationen. Utkastet körs inte automatiskt.',
    'Say what the work is. Poneva drafts the project beside the conversation and brings in what you have already done. Nothing is created until you say so.':
      'Beskriv vad arbetet gäller. Poneva skapar ett utkast till projektet bredvid konversationen och tar med det du redan har gjort. Inget skapas förrän du säger till.',
    'Start with an idea below. Poneva will take it from there.':
      'Börja med en idé nedan. Poneva tar det därifrån.',
    Triggers: 'Utlösare',
    'Review the agent and its trigger. Approval applies exactly what is shown.':
      'Granska agenten och dess utlösare. Godkännandet tillämpar exakt det som visas.',
    '{source} · read {date}': '{source} · läst {date}',
    'Evidence is being recorded · read {date}': 'Underlag registreras · läst {date}',
    'Evidence expired on {date} under the retention policy':
      'Underlaget upphörde att gälla {date} enligt lagringspolicyn',
    'Entered by {person}': 'Angett av {person}',
    'No retained evidence for this value': 'Inget bevarat underlag för detta värde',
    'Covers {shown} of {total} rows': 'Omfattar {shown} av {total} rader',
    'Search rows': 'Sök rader',
    'Clear filters': 'Rensa filter',
    Sort: 'Sortera',
    'Sort: {column}': 'Sortera: {column}',
    '{shown} of {total} rows': '{shown} av {total} rader',
    More: 'Mer',
    Density: 'Täthet',
    Comfortable: 'Bekväm',
    Compact: 'Kompakt',
    Columns: 'Kolumner',
    'No rows match. Clear the search or filters to see them again.':
      'Inga rader matchar. Rensa sökningen eller filtren för att se dem igen.',
    'Not available': 'Inte tillgängligt',
    'All rows': 'Alla rader',
    'Close row detail': 'Stäng radinformation',
    'Ask about this row': 'Fråga om den här raden',
    App: 'App',
    Artifact: 'Artefakt',
    'New project': 'Nytt projekt',
    'Review request': 'Granskningsbegäran',
    Activity: 'Aktivitet',
    'Voice preview': 'Röstförhandsgranskning',
    Source: 'Källa',
    File: 'Fil',
    Meeting: 'Möte',
    'Knowledge page': 'Kunskapssida',
    'Could not preview this CSV.': 'Det gick inte att förhandsgranska den här CSV-filen.',
    'File content is unavailable.': 'Filinnehållet är inte tillgängligt.',
    'You have five open suggestions here. {value1} will see them.':
      'Du har fem öppna förslag här. {value1} kommer att se dem.',
    'We could not send your suggestion. Please try again.':
      'Det gick inte att skicka ditt förslag. Försök igen.',
    'The agent': 'Agenten',
    'Selected colleagues': 'Valda kollegor',
    'The owner': 'Ägaren',
    'Forked. This copy is yours and runs with your own connections.':
      'En kopia har skapats. Den här kopian är din och körs med dina egna anslutningar.',
    'This chat is too long to fork.': 'Den här chatten är för lång för att skapa en kopia av.',
    'We could not fork this chat. Please try again.':
      'Det gick inte att skapa en kopia av den här chatten. Försök igen.',
    'Anyone who forked it keeps their copy: forks stay with the people who made them.':
      'Alla som skapade en kopia behåller den: kopior stannar hos personerna som skapade dem.',
    'Nobody has forked this chat.': 'Ingen har skapat en kopia av den här chatten.',
    '1 person forked this chat. Their copy stays theirs.':
      '1 person har skapat en kopia av den här chatten. Kopian förblir deras.',
    '{value1} people forked this chat. Their copies stay theirs.':
      '{value1} personer har skapat kopior av den här chatten. Kopiorna förblir deras.',
    'Personal. Nobody else sees it.': 'Personligt. Ingen annan kan se det.',
    'People you pick. They get it in their Inbox.': 'Personer du väljer. De får det i sin inkorg.',
    'Everyone in the company can follow it and fork it.':
      'Alla i företaget kan följa det och skapa en kopia av det.',
    'a chat you can no longer open': 'en chatt som du inte längre kan öppna',
    'shared the Result': 'delade resultatet',
    'updated the Result': 'uppdaterade resultatet',
    'published the Skill': 'publicerade färdigheten',
    'approved the fact': 'godkände faktumet',
    'added the fact': 'lade till faktumet',
    'added the meeting': 'lade till mötet',
    'published the page': 'publicerade sidan',
    'updated the page': 'uppdaterade sidan',
    'shared the chat': 'delade chatten',
    'published a version of': 'publicerade en version av',
    ran: 'körde',
    Knowledge: 'Kunskap',
    Meetings: 'Möten',
    Chat: 'Chatt',
    Use: 'Använd',
    Open: 'Öppna',
    You: 'Du',
    Someone: 'Någon',
    'published version {version} of': 'publicerade version {version} av',
    'thing needs': 'sak behöver',
    'things need': 'saker behöver',
    'Published Skill': 'Publicerad färdighet',
    'Included with Skill': 'Ingår i färdighet',
    'Already attached': 'Redan bifogad',
    'Also available in company knowledge': 'Finns även i företagets kunskap',
    'Company file': 'Företagsfil',
    'Account identity unavailable': 'Kontots identitet är inte tillgänglig',
    'Connection removed': 'Anslutningen har tagits bort',
    'Query time limit changed': 'Tidsgränsen för frågan har ändrats',
    '{count} row': '{count} rad',
    '{count} rows': '{count} rader',
    'This source is no longer available. Company knowledge now lives in Knowledge pages, and files stay in the Library.':
      'Den här källan är inte längre tillgänglig. Företagskunskap finns nu på kunskapssidor, och filer finns kvar i biblioteket.',
    'Access expired or was revoked. Reconnect to continue.':
      'Åtkomsten har upphört eller återkallats. Anslut igen för att fortsätta.',
    'Account authorized · tools unavailable':
      'Kontot är auktoriserat · verktyg är inte tillgängliga',
    'Not available in this workspace yet.': 'Inte tillgängligt i den här arbetsytan ännu.',
    'Everyone in the company': 'Alla i företaget',
    'Audience: only you.': 'Målgrupp: bara du.',
    'Audience: everyone in the company.': 'Målgrupp: alla i företaget.',
    'tool is': 'verktyget är',
    'tools are': 'verktygen är',
    'account is': 'kontot är',
    'accounts are': 'kontona är',
    'We could not upload this file.': 'Det gick inte att ladda upp den här filen.',
    'file was': 'filen var',
    'files were': 'filerna var',
    'Your company': 'Ditt företag',
    'Create an agent': 'Skapa en agent',
    'Give recurring work a helping hand': 'Få hjälp med återkommande arbete',
    'Create a Skill': 'Skapa en färdighet',
    'Save a reusable way of working': 'Spara ett återanvändbart arbetssätt',
    'Take meeting notes': 'Anteckna mötet',
    'Capture decisions and next steps': 'Fånga beslut och nästa steg',
    'Work with a file': 'Arbeta med en fil',
    'Start from a document or image': 'Börja med ett dokument eller en bild',
    'Browse agents': 'Bläddra bland agenter',
    'Open your agents and company agents': 'Öppna dina agenter och företagets agenter',
    'Review results': 'Granska resultat',
    'Return to work saved in your Library': 'Återgå till arbete som sparats i ditt bibliotek',
    'For review': 'För granskning',
    'An agent': 'En agent',
    Assistant: 'Assistent',
    'Kept up to date by {value1}{value2}': 'Hålls uppdaterad av {value1}{value2}',
    ', {value1}': ', {value1}',
    'Version {value1}{value2}{value3}': 'Version {value1}{value2}{value3}',
    'Refreshed by its agent': 'Uppdaterad av sin agent',
    'Saved from a chat': 'Sparad från en chatt',
    'Saved from {value1}': 'Sparad från {value1}',
    Edited: 'Redigerad',
    'private account': 'privat konto',
    '{value1} ({value2})': '{value1} ({value2})',
    '{value1}’s {value2}': '{value2} som tillhör {value1}',
    'Made private. The person who added it and the owner of its recording have been told in their Inbox.':
      'Gjort privat. Personen som lade till det och ägaren till inspelningen har meddelats i sin inkorg.',
    'Made private. The person who added it has been told in their Inbox.':
      'Gjort privat. Personen som lade till det har meddelats i sin inkorg.',
    'Made private. The owner of its recording has been told in their Inbox.':
      'Gjort privat. Ägaren till inspelningen har meddelats i sin inkorg.',
    'Selected passage': 'Valt avsnitt',
    '{value1} {value2}': '{value1} {value2}',
    'Upload a file': 'Ladda upp en fil',
    'Help me create a useful report from our company knowledge and available sources.':
      'Hjälp mig att skapa en användbar rapport utifrån vår företagskunskap och tillgängliga källor.',
    'This saved work couldn’t be opened. Open it again to retry.':
      'Det sparade arbetet kunde inte öppnas. Öppna det igen för att försöka på nytt.',
    '{value1}’s': '{value1}s',
    '{value1} chat “{value2}”': '{value1}s chatt ”{value2}”',
    '{value1}{value2}': '{value1}{value2}',
    'Skill: {value1}{value2}': 'Färdighet: {value1}{value2}',
    'Result “{value1}”': 'Resultat ”{value1}”',
    'Meeting “{value1}”': 'Möte ”{value1}”',
    'Used in {value1} {value2} this week': 'Använd i {value1} {value2} den här veckan',
    '{value1} {value2} · used in {value3} {value4}':
      '{value1} {value2} · används i {value3} {value4}',
    'The draft is not published yet, so no one else follows it.':
      'Utkastet har inte publicerats än, så ingen annan följer det.',
    'Use it in a chat for current data, or refine the Skill first.':
      'Använd den i en chatt för aktuella data eller finslipa färdigheten först.',
    'An agent keeps this up to date. Continue the work in chat.':
      'En agent håller den här uppdaterad. Fortsätt arbetet i chatten.',
    'Edit it here, or continue the work in chat.':
      'Redigera den här eller fortsätt arbetet i chatten.',
    'Duplicate it to your Library, or continue the work in chat.':
      'Duplicera den till ditt bibliotek eller fortsätt arbetet i chatten.',
    'Download Markdown': 'Ladda ner Markdown',
    'Download CSV': 'Ladda ner CSV',
    'an agent': 'en agent',
    'Publish a Skill version': 'Publicera en färdighetsversion',
    'Share with {value1}': 'Dela med {value1}',
    'Update company content': 'Uppdatera företagsinnehåll',
    Approved: 'Godkänd',
    Declined: 'Avslagen',
    Pending: 'Väntar',
    'View decision': 'Visa beslut',
    'No data': 'Inga data',
    'No change': 'Ingen ändring',
    'Connection created': 'Anslutning skapad',
    'Sharing changed': 'Delning ändrad',
    'Person added': 'Person tillagd',
    'Person removed': 'Person borttagen',
    'Access changed': 'Åtkomst ändrad',
    'Access turned off': 'Åtkomst avstängd',
    '· {value1} by {value2}': '· {value1} av {value2}',
    '· version {value1}': '· version {value1}',
    '{message} {count} earlier file was saved and attached.':
      '{message} {count} tidigare fil sparades och bifogades.',
    '{message} {count} earlier files were saved and attached.':
      '{message} {count} tidigare filer sparades och bifogades.',
    '{message} {count} earlier file was saved.': '{message} {count} tidigare fil sparades.',
    '{message} {count} earlier files were saved.': '{message} {count} tidigare filer sparades.',
    'refreshed {time}': 'uppdaterad {time}',
    'a colleague': 'en kollega',
    'Your chat “{title}”': 'Din chatt ”{title}”',
    '{name}’s chat “{title}”': '{name}s chatt ”{title}”',
    'Kept up to date by {name}{version}': 'Hålls uppdaterad av {name}{version}',
    'Skill: {name}{version}': 'Färdighet: {name}{version}',
    'Result “{title}”': 'Resultat ”{title}”',
    'Meeting “{title}”': 'Möte ”{title}”',
    'Used in {count} answer this week': 'Använd i {count} svar den här veckan',
    'Used in {count} answers this week': 'Använd i {count} svar den här veckan',
    '{count} source': '{count} källa',
    '{count} sources': '{count} källor',
    'used in {count} place': 'använd i {count} ställe',
    'used in {count} places': 'använd i {count} ställen',
    '{company} workspace': '{company} arbetsyta',
    '{count} page': '{count} sida',
    '{count} pages': '{count} sidor',
    '{needs} · reviews and approvals': '{needs} · granskningar och godkännanden',
    '{count} thing needs you': '{count} sak kräver din åtgärd',
    '{count} things need you': '{count} saker kräver din åtgärd',
    'Included with Skill · {files} · {sources} {icon}':
      'Ingår i färdigheten · {files} · {sources} {icon}',
    '{count} file': '{count} fil',
    '{count} files': '{count} filer',
    Today: 'Idag',
    'Earlier this week': 'Tidigare i veckan',
    '{count} slide': '{count} bild',
    '{count} slides': '{count} bilder',
    Early: 'Tidigt',
    'TLS verified': 'TLS verifierat',
    'Made personal and switched off. Switch it on when you are ready.':
      'Gjort personlig och avstängd. Slå på den när du är redo.',
    'Made personal and switched off. Its owner is told which version is live.':
      'Gjort personlig och avstängd. Ägaren får veta vilken version som är aktiv.',
    'Switched off.': 'Avstängd.',
    'Applied version {revision}.': 'Version {revision} tillämpad.',
    'The draft is running in a chat only you can read.':
      'Utkastet körs i en chatt som bara du kan läsa.',
    'Publish a version first.': 'Publicera en version först.',
    'Another Agent action is in progress.': 'En annan agentåtgärd pågår.',
    'Knowledge & connections': 'Kunskap och anslutningar',
    'Pinned Skills': 'Fästa färdigheter',
    None: 'Inga',
    'A new Result each run': 'Ett nytt resultat vid varje körning',
    'One Result kept up to date': 'Ett resultat hålls uppdaterat',
    Email: 'E-post',
    On: 'På',
    Off: 'Av',
    'Waiting for review': 'Väntar på granskning',
    Outdated: 'Föråldrad',
    Accepted: 'Godkänd',
    Rejected: 'Avvisad',
    Withdrawn: 'Tillbakadragen',
    Replaced: 'Ersatt',
    'Suggested edit': 'Föreslagen redigering',
    'Suggested new page': 'Föreslagen ny sida',
    'Suggested move': 'Föreslagen flytt',
    'Suggested archive': 'Föreslagen arkivering',
    'Checking status…': 'Kontrollerar status…',
    'Status unavailable': 'Status inte tillgänglig',
    'Bulleted list': 'Punktlista',
    'Numbered list': 'Numrerad lista',
    'Web link': 'Webblänk',
    Read: 'Läs',
    Write: 'Skriv',
    'shared with you': 'delad med dig',
    'Getting an answer': 'Hämtar ett svar',
    '{name} is getting an answer': '{name} hämtar ett svar',
    'We could not save. Please try again.': 'Det gick inte att spara. Försök igen.',
    'The new page could not be created.': 'Den nya sidan kunde inte skapas.',
    'We could not load this revision.': 'Det gick inte att läsa in den här revisionen.',
    'We could not restore this revision. Please try again.':
      'Det gick inte att återställa den här revisionen. Försök igen.',
    'We could not export this revision.': 'Det gick inte att exportera den här revisionen.',
    'We could not open this suggestion.': 'Det gick inte att öppna det här förslaget.',
    'We could not do that. Please try again.': 'Det gick inte att göra det. Försök igen.',
    'We could not save your decision. Please try again.':
      'Det gick inte att spara ditt beslut. Försök igen.',
    'We could not restore this page. Please try again.':
      'Det gick inte att återställa den här sidan. Försök igen.',
    'We could not export this page.': 'Det gick inte att exportera den här sidan.',
    '{count} missed time merged.': '{count} missad tidsregistrering slogs samman.',
    '{count} missed times merged.': '{count} missade tidsregistreringar slogs samman.',
    'About this project': 'Om det här projektet',
  },
} satisfies NamespaceCatalog<Key>;
export default catalog;
